webpackJsonp([28],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var env = exports.env = "production";
var nonProdEnvStr = exports.nonProdEnvStr = ['development', 'testing', 'homolog'];

var resourceTable = exports.resourceTable = {
  api: {
    dev: '/api/',
    prod: '/tradelinks_cadastro/api/'
  },
  cadastro: {
    dev: '/cadastro/',
    prod: '/tradelinks_cadastro/api/'
  },
  public: {
    dev: '/public/',
    prod: '/tradelinks_cadastro/public/'
  },
  job: {
    dev: '/job/',
    prod: '/tradelinks_job/api'
  },
  negociacao: {
    dev: '/negociacao/',
    prod: '/tradelinks_verbas_estruturais/api/negociacao/'
  },
  orcamento: {
    dev: '/orcamento/',
    prod: '/tradelinks_orcamento/api/'
  },
  planejamento_acao: {
    dev: '/planejamento_acao/',
    prod: '/tradelinks_planejamento_acao/api/'
  },
  planejamento_tatico: {
    dev: '/planejamento_tatico/',
    prod: '/tradelinks_planejamento_tatico/api/'
  },
  planejamento: {
    dev: '/planejamento/',
    prod: '/tradelinks_verbas_estruturais/api/planejamento/'
  },
  usuario: {
    dev: '/usuario/',
    prod: '/tradelinks_usuario/api/'
  },
  workflow_tatico: {
    dev: '/workflow_tatico/',
    prod: '/tradelinks_workflow/api/workflow/'
  },
  workflow_estrutural: {
    dev: '/workflow_estrutural/',
    prod: '/tradelinks_verbas_estruturais/api/workflow/'
  },
  workflow: {
    dev: '/workflow/',
    prod: '/tradelinks_workflow/api/'
  },
  apuracao_acao: {
    dev: '/apuracao_acao/',
    prod: '/tradelinks_apuracao_acao/api/'
  },
  apuracao: {
    dev: '/apuracao/',
    prod: '/tradelinks_verbas_estruturais/api/apuracao/'
  },
  execucao: {
    dev: '/execucao/',
    prod: '/tradelinks_execucao/api/'
  },
  execucao_acao_tatica: {
    dev: '/execucao_tatico/',
    prod: '/tradelinks_execucao_tatico/api/'
  },
  pagamento_verbas_estruturais: {
    dev: '/pagamento_verbas_estruturais/',
    prod: '/tradelinks_verbas_estruturais/api/pagamento/'
  },
  pagamento_tatico: {
    dev: '/pagamento_tatico/',
    prod: '/tradelinks_pagamento_tatico/api/'
  },
  pagamento_gestao: {
    dev: '/pagamento/',
    prod: '/tradelinks_pagamento/api/'
  },
  relatorio: {
    dev: '/relatorio/',
    prod: '/tradelinks_relatorio/api/'
  },
  recebimento: {
    dev: '/recebimento/',
    prod: '/tradelinks_liquidacao_acao/api/recebimento/'
  },
  pagamento: {
    dev: '/pagamento/',
    prod: '/tradelinks_liquidacao_acao/api/pagamento/'
  },
  liquidacao: {
    dev: '/liquidacao/',
    prod: '/tradelinks_liquidacao_acao/api/'
  },
  arquivo_acao: {
    dev: '/arquivo_acao/',
    prod: '/tradelinks_planejamento_acao/api/'
  }
};

exports.default = function (type) {
  var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (!type) {
    throw Error('[api-resource] Error! type is not defined.');
  }

  if (!resourceTable.hasOwnProperty(type)) {
    throw Error('[api-resource] Error! type is defined BUT it was not found on resourceTable: ' + type);
  }

  var auxEnv = nonProdEnvStr.indexOf(env) !== -1 ? 'dev' : 'prod';

  return '' + resourceTable[type][auxEnv] + api;
};

/***/ }),
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAllEmpty = exports.removeEmptyProperties = exports.convertToIntegerFormat = exports.convertToNumberFormat = exports.convertToPercent = exports.convertToMoney = exports.subtractValues = exports.sumValues = exports.toColumnName = exports.prepareResponseData = exports.getNumber = exports.getPercent = exports.getMoney = exports.convertFloatToMoneyComma = exports.convertFloatToMoney = exports.convertMoneytoFloat = exports.isCpfValido = exports.formatarDocumento = exports.convertToCpf = exports.convertToCnpj = exports.convertCnpjString = exports.removeItem = exports.nestedObjectToArray = exports.getClosestThemedParent = exports.getClosestVueParent = exports.copyObject = exports.componentExpandableSize = exports.calculateMenuHeight = exports.camelCase = exports.capitalize = exports.accessObjectViaString = undefined;

var _assign = __webpack_require__(4);

var _assign2 = _interopRequireDefault(_assign);

var _keys = __webpack_require__(11);

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__(38);

var _stringify2 = _interopRequireDefault(_stringify);

var _vanillaMasker = __webpack_require__(53);

var _vanillaMasker2 = _interopRequireDefault(_vanillaMasker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var accessObjectViaString = exports.accessObjectViaString = function accessObjectViaString(object, access) {
  if (!access || access.length < 1) {
    return object;
  }
  var attribute = object;
  access.split('.').forEach(function (el) {
    var value = attribute[el];
    attribute = value || el;
  });
  if (attribute && !isNaN(attribute) || attribute && attribute.length || attribute instanceof Function) {
    return attribute;
  }
  return access;
};

var capitalize = exports.capitalize = function capitalize(str) {
  return str ? str.charAt(0).toUpperCase() + str.toLowerCase().slice(1) : '';
};

var camelCase = exports.camelCase = function camelCase(str) {
  var string = str.toLowerCase().replace(/[^A-Za-z0-9]/g, ' ').split(' ').reduce(function (result, word) {
    return result + capitalize(word.toLowerCase());
  });
  return string.charAt(0).toLowerCase() + string.slice(1);
};

var calculateMenuHeight = exports.calculateMenuHeight = function calculateMenuHeight(listSize) {
  var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 48;
  var gap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 75;
  var maxItems = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 4;
  var maxSize = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 275;

  if (listSize) {
    var size = listSize > maxItems ? maxSize : height * listSize + gap;
    return size < 120 ? 120 : size;
  }
  return 'auto';
};

var componentExpandableSize = exports.componentExpandableSize = function componentExpandableSize(listSize) {
  var size = listSize !== 'auto' ? listSize : 'auto';
  return '' + size + (isNaN(size) ? '' : 'px');
};

var copyObject = exports.copyObject = function copyObject(object) {
  return JSON.parse((0, _stringify2.default)(object));
};

var getClosestVueParent = exports.getClosestVueParent = function getClosestVueParent(parent, cssClass) {
  if (!parent || !parent.$el) {
    return false;
  }

  if (parent._uid === 0) {
    return false;
  }

  if (parent.$el.classList && parent.$el.classList.contains(cssClass)) {
    return parent;
  }

  return getClosestVueParent(parent.$parent, cssClass);
};

var getClosestThemedParent = exports.getClosestThemedParent = function getClosestThemedParent($parent) {
  if (!$parent || !$parent.$el || $parent._uid === 0) {
    return false;
  }

  if ($parent.mdTheme || $parent.mdName) {
    return $parent;
  }

  return getClosestThemedParent($parent.$parent);
};

var nestedObjectToArray = exports.nestedObjectToArray = function nestedObjectToArray(nested) {
  if (!nested) {
    return [];
  }
  return (0, _keys2.default)(nested).map(function (el) {
    return nested[el];
  });
};

var removeItem = exports.removeItem = function removeItem(array, item) {
  if (array && item && array.hasOwnProperty('length') && array.length) {
    var index = isNaN(Number(item)) ? array.indexOf(item) : item;
    if (index !== -1) {
      array.splice(index, 1);
    }
  }
  return array;
};

var convertCnpjString = exports.convertCnpjString = function convertCnpjString(cnpj) {
  return cnpj ? cnpj.replace(/[./-]/g, '').toUpperCase() : cnpj;
};

var convertToCnpj = exports.convertToCnpj = function convertToCnpj(cnpj) {
  return cnpj.replace(/^([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{2})/, '$1.$2.$3/$4-$5');
};

var convertToCpf = exports.convertToCpf = function convertToCpf(cpf) {
  return cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
};

var formatarDocumento = exports.formatarDocumento = function formatarDocumento(doc) {
  if (!doc) return doc;
  var norm = convertCnpjString(doc);
  if (norm.length === 11) return convertToCpf(norm);
  if (norm.length === 14) return convertToCnpj(norm);
  return doc;
};

var isCpfValido = exports.isCpfValido = function isCpfValido(cpf) {
  var norm = (cpf || '').replace(/[^0-9]/g, '');
  if (norm.length !== 11 || /^(\d)\1{10}$/.test(norm)) return false;

  var soma = 0;
  for (var i = 0; i < 9; i += 1) {
    soma += Number(norm.charAt(i)) * (10 - i);
  }
  var dv1 = 11 - soma % 11;
  if (dv1 >= 10) dv1 = 0;
  if (dv1 !== Number(norm.charAt(9))) return false;

  soma = 0;
  for (var _i = 0; _i < 10; _i += 1) {
    soma += Number(norm.charAt(_i)) * (11 - _i);
  }
  var dv2 = 11 - soma % 11;
  if (dv2 >= 10) dv2 = 0;
  return dv2 === Number(norm.charAt(10));
};

var convertMoneytoFloat = exports.convertMoneytoFloat = function convertMoneytoFloat(str) {
  var money = String(str).replace(/[^\d,-]/g, '').replace(',', '.');
  return Number(money.length ? money : '0');
};

var convertFloatToMoney = exports.convertFloatToMoney = function convertFloatToMoney(str) {
  var t1 = String(str).split('.');
  var t2 = '';
  if (t1[1]) {
    t2 = t1[1].length === 1 ? t1[1] + '0' : t1[1];
  } else {
    t2 = '00';
  }
  return t1[0] + '.' + t2;
};

var convertFloatToMoneyComma = exports.convertFloatToMoneyComma = function convertFloatToMoneyComma(str) {
  var t1 = String(str).split('.');
  var t2 = '';
  if (t1[1]) {
    t2 = t1[1].length === 1 ? t1[1] + '0' : t1[1];
  } else {
    t2 = '00';
  }
  return t1[0] + ',' + t2;
};

function getValueFixed(vlrModelo, vlrDefault, decimalPlaces, symbol, onRight) {
  if (vlrModelo === null || vlrModelo === undefined) {
    if (vlrDefault === undefined) return '-';
    vlrModelo = vlrDefault;
  }
  var vlrArredondado = vlrModelo.toFixed ? vlrModelo.toFixed(decimalPlaces) : vlrModelo;
  var vlrFormatado = convertFloatToMoney(vlrArredondado);
  vlrFormatado = vlrFormatado.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  var money = vlrFormatado.split('.');
  var ready = onRight ? money[0].replace(/,/g, '.') + ',' + money[1] + symbol : symbol + ' ' + money[0].replace(/,/g, '.') + ',' + money[1];
  return ready;
}

var getMoney = exports.getMoney = function getMoney(vlrModelo, vlrDefault) {
  var decimalPlaces = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
  var currency = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'R$';
  return getValueFixed(vlrModelo, vlrDefault, decimalPlaces, currency);
};

var getPercent = exports.getPercent = function getPercent(vlrModelo, vlrDefault) {
  var decimalPlaces = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
  return getValueFixed(vlrModelo, vlrDefault, decimalPlaces, '%', true);
};

var getNumber = exports.getNumber = function getNumber(vlrModelo, vlrDefault) {
  var decimalPlaces = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
  return getValueFixed(vlrModelo, vlrDefault, decimalPlaces, '');
};

var prepareResponseData = exports.prepareResponseData = function prepareResponseData(response) {
  if (response.data.hasOwnProperty('resposta')) {
    return response.data.resposta;
  }
  return response.data;
};

var toColumnName = exports.toColumnName = function toColumnName(n) {
  var ordA = 'a'.charCodeAt(0);
  var ordZ = 'z'.charCodeAt(0);
  var len = ordZ - ordA + 1;

  var s = '';
  while (n >= 0) {
    s = String.fromCharCode(n % len + ordA) + s;
    n = Math.floor(n / len) - 1;
  }
  return s;
};

var sumValues = exports.sumValues = function sumValues(a, b) {
  return (parseFloat(a) + parseFloat(b)).toFixed(2);
};

var subtractValues = exports.subtractValues = function subtractValues(a, b) {
  return (parseFloat(a) - parseFloat(b)).toFixed(2);
};

var convertToMoney = exports.convertToMoney = function convertToMoney(value) {
  if (!value) {
    return 'R$ 0,00';
  }
  var valor = convertFloatToMoney(value);
  if (value < 0) {
    return 'R$ -' + _vanillaMasker2.default.toMoney(valor);
  }
  return 'R$ ' + _vanillaMasker2.default.toMoney(valor);
};

var convertToPercent = exports.convertToPercent = function convertToPercent(value) {
  if (!value) {
    return '0,00 %';
  }
  var valor = convertFloatToMoney(value);
  if (value < 0) {
    return '-' + _vanillaMasker2.default.toMoney(valor) + ' %';
  }
  return _vanillaMasker2.default.toMoney(valor) + ' %';
};

var convertToNumberFormat = exports.convertToNumberFormat = function convertToNumberFormat(value) {
  if (!value) {
    return '0';
  }
  var valor = convertFloatToMoney(value);
  if (value < 0) {
    return '-' + _vanillaMasker2.default.toMoney(valor);
  }
  return '' + _vanillaMasker2.default.toMoney(valor);
};

var convertToIntegerFormat = exports.convertToIntegerFormat = function convertToIntegerFormat(value) {
  if (!value) {
    return '0';
  }
  return Number(value).toLocaleString();
};

function isEmpty(obj) {
  if (Array.isArray(obj) && !obj.length) {
    return true;
  }
  if (obj instanceof Object && !(0, _keys2.default)(obj).length) {
    return true;
  }
  if (obj === null || obj === undefined) {
    return true;
  }
  return false;
}

function replacer(key, value) {
  if (isEmpty(value)) {
    return undefined;
  }
  return value;
}

var removeEmptyProperties = exports.removeEmptyProperties = function removeEmptyProperties(obj) {
  if (isEmpty(obj)) {
    return obj;
  }
  var objParseado = JSON.parse((0, _stringify2.default)(obj, replacer));
  var jsonString = (0, _assign2.default)(objParseado, objParseado.extensoes);
  delete jsonString.extensoes;
  return jsonString;
};

var isAllEmpty = exports.isAllEmpty = function isAllEmpty(obj) {
  obj = removeEmptyProperties(obj);
  return isEmpty(obj);
};

/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (basePath) {
  return {
    ativar: { method: 'PUT', url: basePath + '/ativacao/{id}/true' },
    atualizar: { method: 'PUT', url: '' + basePath },
    gravar: { method: 'POST', url: '' + basePath },
    inativar: { method: 'PUT', url: basePath + '/ativacao/{id}/false' },
    listar: { method: 'GET', url: basePath + '?tamanhoPagina={size}&numeroPagina={page}' },
    listarAtivos: { method: 'GET', url: basePath + '?nome={nome}&indAtivo=true' },
    selecao: { method: 'GET', url: basePath + '/selecao' }
  };
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateComputed = undefined;

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _typeof2 = __webpack_require__(55);

var _typeof3 = _interopRequireDefault(_typeof2);

var _assign = __webpack_require__(4);

var _assign2 = _interopRequireDefault(_assign);

var _keys = __webpack_require__(11);

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty2 = __webpack_require__(73);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _vuex = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rolesComputedGeneratorList = function rolesComputedGeneratorList(entity) {
  return {
    canAccessPage: function canAccessPage() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el === entity + '_PAGINA' || el === entity + '_CRUD' || el === entity + '_AGENCIA' || el === entity + '_EMPRESA';
      }).length;
    },
    canAccessCRUD: function canAccessCRUD() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el === entity + '_CRUD';
      }).length;
    },
    canEnable: function canEnable() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el === entity + '_ATIVAR' || el === entity + '_CRUD';
      }).length;
    },
    canPost: function canPost() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el === entity + '_INSERIR' || el === entity + '_CRUD';
      }).length;
    },
    canGet: function canGet() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el === entity + '_OBTER' || el === entity + '_CRUD' || el === entity + '_PAGINA';
      }).length;
    },
    canEdit: function canEdit() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el === entity + '_ATUALIZAR' || el === entity + '_CRUD';
      }).length;
    },
    canSearch: function canSearch() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el === entity + '_PAGINA' || el === entity + '_PESQUISAR' || el === entity + '_CRUD';
      }).length;
    },
    canImport: function canImport() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el === entity + '_IMPORTAR' || el === entity + '_CRUD';
      }).length;
    },
    canExport: function canExport() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el === entity + '_EXPORTAR';
      }).length;
    },
    canHistory: function canHistory() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el === entity + '_PESQUISAR_LOG' || el === entity + '_PAGINA' || el === entity + '_CRUD';
      }).length;
    },
    canCopy: function canCopy() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el === entity + '_COPIAR' || el === entity + '_CRUD';
      }).length;
    },
    canCancel: function canCancel() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el === entity + '_CANCELAR' || el === entity + '_CRUD';
      }).length;
    },
    canStartWorkflow: function canStartWorkflow() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el === entity + '_INICIA_FLUXO' || el === entity + '_CRUD';
      }).length;
    },
    canFinish: function canFinish() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el === entity + '_FINALIZAR' || el === entity + '_CRUD';
      }).length;
    }
  };
};

var appendSuffixOnListKey = function appendSuffixOnListKey(list, key, suffix) {
  return (0, _defineProperty3.default)({}, '' + key + suffix, list[key]);
};

var compilerolesComputedGeneratorList = function compilerolesComputedGeneratorList(list, selectionList) {
  var suffix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  if (!selectionList.length) {
    return list;
  }
  return (0, _keys2.default)(list).reduce(function (acc, curr) {
    if (selectionList.indexOf(curr) !== -1) {
      return (0, _assign2.default)(appendSuffixOnListKey(list, curr, suffix), acc);
    }
    return acc;
  }, {});
};

var generateComputed = exports.generateComputed = function generateComputed() {
  for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
    params[_key] = arguments[_key];
  }

  if (!params || !params.length) {
    return {};
  }

  var entity = params[0].replace(/[' ']/g, '_').toUpperCase(),
      suffix = typeof params[1] === 'string' ? params[1] : '';

  var list = [];
  if ((0, _typeof3.default)(params[1]) === 'object') {
    list = params[1];
  } else if ((0, _typeof3.default)(params[2]) === 'object') {
    list = params[2];
  }
  return (0, _extends3.default)({}, (0, _vuex.mapGetters)('roles', ['getAllRoles']), compilerolesComputedGeneratorList(rolesComputedGeneratorList(entity), list, suffix));
};

exports.default = generateComputed;

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Confirm_vue_vue_type_template_id_fbcbea64___ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Confirm_vue_vue_type_script_lang_js___ = __webpack_require__(283);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__Confirm_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__Confirm_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Confirm_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__Confirm_vue_vue_type_template_id_fbcbea64___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Confirm_vue_vue_type_template_id_fbcbea64___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 13 */,
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var el = null;
var getLoadingElement = function getLoadingElement() {
  if (el === null) {
    el = document.getElementById('spinner-loading');
  }
  return el;
};

var skip = false;

var showLoading = exports.showLoading = function showLoading() {
  if (!skip) {
    var element = getLoadingElement();
    if (element != null && element.style.display !== 'block') {
      element.style.display = 'block';
    }
  } else {
    skip = false;
  }
};

var hideLoading = exports.hideLoading = function hideLoading() {
  setTimeout(function () {
    var element = getLoadingElement();
    if (element != null && element.style.display !== 'none') {
      element.style.display = 'none';
    }
  }, 2E2);
};

var skipLoading = exports.skipLoading = function skipLoading() {
  skip = true;
};

var showInitialLoading = exports.showInitialLoading = function showInitialLoading() {
  showLoading();
  getLoadingElement().style.opacity = 1;
};

var hideInitialLoading = exports.hideInitialLoading = function hideInitialLoading() {
  hideLoading();
  getLoadingElement().style.opacity = null;
};

/***/ }),
/* 15 */,
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mdAutocomplete_vue_vue_type_template_id_064cd0dc_lang_html___ = __webpack_require__(1010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mdAutocomplete_vue_vue_type_script_lang_js___ = __webpack_require__(304);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__mdAutocomplete_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__mdAutocomplete_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mdAutocomplete_scss_vue_type_style_index_0_lang_scss___ = __webpack_require__(1013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mdAutocomplete_vue_vue_type_style_index_1_lang_css___ = __webpack_require__(1014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);







/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_4__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__mdAutocomplete_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__mdAutocomplete_vue_vue_type_template_id_064cd0dc_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__mdAutocomplete_vue_vue_type_template_id_064cd0dc_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TabelaGenerica_vue_vue_type_script_lang_js___ = __webpack_require__(361);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__TabelaGenerica_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__TabelaGenerica_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TabelaGenerica_css_vue_type_style_index_0_lang_css___ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);
var render, staticRenderFns





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__TabelaGenerica_vue_vue_type_script_lang_js___["default"],
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(11);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    metadados: {
      type: Object,
      required: true
    },
    ignoraObrigatorios: {
      type: Boolean,
      default: false
    },
    objetoContainer: {
      type: Object,
      required: true
    },
    somenteLeitura: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    inputId: function inputId() {
      return 'MetadadosCampoDinamico-' + this.metadados.labelCampo;
    },
    campoObrigatorio: function campoObrigatorio() {
      return !this.ignoraObrigatorios && this.metadados.vlrObrigatorio;
    },
    inputLabel: function inputLabel() {
      var inputLabel = void 0;
      if (this.metadados.nomCampo) {
        inputLabel = this.metadados.nomCampo;
      } else {
        inputLabel = this.$tc('label.' + this.metadados.labelCampo, 1);
      }
      return inputLabel + (this.campoObrigatorio ? ' *' : '');
    },
    campoDesabilitado: function campoDesabilitado() {
      if (this.somenteLeitura) {
        return true;
      }

      var desAtributos = this.metadados.desAtributos;

      if (!desAtributos) {
        return false;
      }

      var desabilitado = desAtributos ? desAtributos.desabilitado : false;
      desabilitado = desabilitado || this.desabilitadoPorDependencia;

      return desabilitado;
    },
    desabilitadoPorDependencia: function desabilitadoPorDependencia() {
      var _this = this;

      var desAtributos = this.metadados.desAtributos;

      if (!desAtributos) {
        return false;
      }
      var dependencias = desAtributos.dependencias;

      if (!dependencias || !Array.isArray(dependencias)) {
        return false;
      }

      var falhas = dependencias.filter(function (dependencia) {
        var vlrDependencia = _this.objetoContainer[dependencia];
        return !vlrDependencia || vlrDependencia === '' || (0, _keys2.default)(vlrDependencia).length === 0;
      });

      return falhas.length > 0;
    }
  },
  methods: {
    emiteValorAlterado: function emiteValorAlterado(valor) {
      this.$emit('MetadadosCampoDinamico_valorAlterado', valor);
      this.$emit('input', valor);
    },
    refresh: function refresh() {
      this.$forceUpdate();
    }
  }
};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeParametrosNulos = exports.extractRequestData = exports.prepareResponseData = undefined;

var _keys = __webpack_require__(11);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prepareResponseData = exports.prepareResponseData = function prepareResponseData(response) {
  if (response.data && response.data.hasOwnProperty('resposta')) {
    return response.data.resposta;
  }
  return response.data;
};

var extractRequestData = exports.extractRequestData = function extractRequestData(request) {
  if (request.data.hasOwnProperty('data')) {
    return request.data.data;
  }
  return request.data;
};

var removeParametrosNulos = exports.removeParametrosNulos = function removeParametrosNulos(parametros) {
  (0, _keys2.default)(parametros).forEach(function (k) {
    return !parametros[k] && parametros[k] !== undefined && delete parametros[k];
  });
};

exports.default = prepareResponseData;

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CRUDGenerico_vue_vue_type_script_lang_js___ = __webpack_require__(297);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__CRUDGenerico_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__CRUDGenerico_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CRUDGenerico_css_vue_type_style_index_0_lang_css___ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);
var render, staticRenderFns





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__CRUDGenerico_vue_vue_type_script_lang_js___["default"],
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validarIntervalos = exports.formatDatePattern = exports.formatFirstDayOfTheMonth = exports.formatlastDayOfTheMonth = exports.parseDateYYYYMM = exports.parseDateYYYYMMDD = exports.formatDateMonthYYYY = exports.formatDateMMYYYY = exports.formatDateDDMMYYYY = undefined;

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_moment2.default.locale('pt-br');

var formatDateDDMMYYYY = exports.formatDateDDMMYYYY = function formatDateDDMMYYYY(date) {
  if (!date) return null;
  return (0, _moment2.default)(date, 'YYYY-MM-DD').format('DD-MM-YYYY');
};

var formatDateMMYYYY = exports.formatDateMMYYYY = function formatDateMMYYYY(date) {
  if (!date) return null;
  return (0, _moment2.default)(date, 'YYYY-MM-DD').format('MM-YYYY');
};

var formatDateMonthYYYY = exports.formatDateMonthYYYY = function formatDateMonthYYYY(date) {
  if (!date) return null;
  return (0, _moment2.default)(date, 'YYYY-MM-DD').format('MMM-YYYY');
};

var parseDateYYYYMMDD = exports.parseDateYYYYMMDD = function parseDateYYYYMMDD(date) {
  if (!date || date.length !== 10) return null;
  var retorno = (0, _moment2.default)(date, 'DD-MM-YYYY');
  if (retorno.isValid()) return retorno.format('YYYY-MM-DD');
  return null;
};

var parseDateYYYYMM = exports.parseDateYYYYMM = function parseDateYYYYMM(date) {
  if (!date || date.length !== 10) return null;
  var retorno = (0, _moment2.default)(date, 'DD-MM-YYYY');
  if (retorno.isValid()) return retorno.format('YYYYMM');
  return null;
};

var formatlastDayOfTheMonth = exports.formatlastDayOfTheMonth = function formatlastDayOfTheMonth(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD-MM-YYYY';

  if (!date) {
    return null;
  }
  return (0, _moment2.default)(date, 'MM-YYYY').endOf('month').format(format);
};

var formatFirstDayOfTheMonth = exports.formatFirstDayOfTheMonth = function formatFirstDayOfTheMonth(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD-MM-YYYY';

  if (!date) {
    return null;
  }
  return (0, _moment2.default)(date, 'MM-YYYY').startOf('month').format(format);
};

var formatDatePattern = exports.formatDatePattern = function formatDatePattern(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD/MM/YYYY';

  if (!date) {
    return null;
  }
  return (0, _moment2.default)(date, format).format('DD/MM/YYYY');
};

var validarIntervalos = exports.validarIntervalos = function validarIntervalos(dtaInicio, dtaFim, dtaInicio2, dtaFim2) {
  var momentInicio = (0, _moment2.default)(dtaInicio);
  var momentFim = (0, _moment2.default)(dtaFim);
  var momentInicio2 = (0, _moment2.default)(dtaInicio2);
  var momentFim2 = (0, _moment2.default)(dtaFim2);
  return momentInicio.isBetween(momentInicio2, momentFim2, null, '[]') || momentFim.isBetween(momentInicio2, momentFim2, null, '[]') || momentInicio.isSameOrBefore(momentInicio2) && momentFim.isSameOrAfter(momentFim2);
};

/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RegisterForm_vue_vue_type_template_id_198e55a6_scoped_true_lang_html___ = __webpack_require__(1007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RegisterForm_vue_vue_type_script_lang_js___ = __webpack_require__(301);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__RegisterForm_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__RegisterForm_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RegisterForm_css_vue_type_style_index_0_id_198e55a6_lang_css_scoped_true___ = __webpack_require__(1009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__RegisterForm_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__RegisterForm_vue_vue_type_template_id_198e55a6_scoped_true_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__RegisterForm_vue_vue_type_template_id_198e55a6_scoped_true_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  "198e55a6",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UploadFile_vue_vue_type_template_id_25e3d179_lang_html___ = __webpack_require__(1058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UploadFile_vue_vue_type_script_lang_js___ = __webpack_require__(339);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__UploadFile_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__UploadFile_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__UploadFile_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__UploadFile_vue_vue_type_template_id_25e3d179_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__UploadFile_vue_vue_type_template_id_25e3d179_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 38 */,
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'exportacao_arquivo');

exports.default = function ($http, timeout) {
  var getResponseProperty = function getResponseProperty(obj) {
    for (var _len = arguments.length, params = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      params[_key - 1] = arguments[_key];
    }

    var attribute = params.filter(function (el) {
      return obj.hasOwnProperty(el);
    })[0];
    var value = obj[attribute];
    return value[0];
  };

  var getFileName = function getFileName(response) {
    var header = getResponseProperty(response.headers.map, 'content-disposition', 'Content-Disposition');
    var temp = header.split('filename=');
    var fileName = temp[1];
    return fileName;
  };

  var onError = function onError(response) {
    console.error('TODO: falha ao exportar', response);
    throw Error('Erro ao exportar');
  };

  var onFileDownloaded = function onFileDownloaded(response) {
    if (!response || !response.data) {
      return onError(response);
    }
    var fileName = getFileName(response);
    var type = getResponseProperty(response.headers.map, 'content-type', 'Content-Type');
    var file = new window.Blob([response.data], { type: type });
    var a = document.createElement('a');
    a.download = fileName;
    a.href = window.URL.createObjectURL(file);
    document.body.appendChild(a);
    a.click();
    return a;
  };

  return {
    download: function download(nomeExportacao, parametros) {
      var resourceOptional = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var variableBasePath = resourceOptional != null ? (0, _apiResource2.default)(resourceOptional, 'exportacao_arquivo') : basePath;
      var downloadUrl = variableBasePath + '/planilha/' + nomeExportacao;
      return $http.post(downloadUrl, parametros, { responseType: 'arraybuffer', timeout: timeout }).then(onFileDownloaded).catch(onError);
    }
  };
};

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_Pagination_css_vue_type_style_index_1_lang_css___ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_Pagination_css_vue_type_style_index_1_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_Pagination_css_vue_type_style_index_1_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_Pagination_css_vue_type_style_index_1_lang_css____default.a); 

/***/ }),
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function ($http) {
  var getResponseProperty = function getResponseProperty(obj) {
    for (var _len = arguments.length, params = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      params[_key - 1] = arguments[_key];
    }

    var attribute = params.filter(function (el) {
      return obj.hasOwnProperty(el);
    })[0];
    var value = obj[attribute];
    return value[0];
  };

  var getFileName = function getFileName(response) {
    var header = getResponseProperty(response.headers.map, 'content-disposition', 'Content-Disposition');
    var temp = header.split('filename=');
    var fileName = temp[1];
    return fileName;
  };

  var onError = function onError(response) {
    console.error('TODO: falha ao fazer download', response);
    throw Error('Erro ao fazer download');
  };

  var onFileDownloaded = function onFileDownloaded(response) {
    if (!response || !response.data) {
      return onError(response);
    }
    var fileName = getFileName(response);
    var type = getResponseProperty(response.headers.map, 'content-type', 'Content-Type');
    var file = new window.Blob([response.data], { type: type });
    var a = document.createElement('a');
    a.download = fileName;
    a.href = window.URL.createObjectURL(file);
    document.body.appendChild(a);
    a.click();
    return a;
  };

  var onFileOpen = function onFileOpen(response) {
    if (!response || !response.data) {
      return onError(response);
    }
    var type = getResponseProperty(response.headers.map, 'content-type', 'Content-Type');
    var file = new window.Blob([response.data], { type: type });
    var a = document.createElement('a');
    a.href = window.URL.createObjectURL(file);
    a.target = '_blank';
    document.body.appendChild(a);
    a.click();
    return a;
  };

  return {
    download: function download(basePath, parametros) {
      var id = parametros.id;
      var url = parametros.url;
      var downloadUrl = basePath + '/' + id + '/' + url;
      return $http.post(downloadUrl, parametros, { responseType: 'arraybuffer' }).then(onFileDownloaded).catch(onError);
    },
    downloadGet: function downloadGet(basePath, parametros) {
      var param = parametros.param;
      var url = parametros.url;
      var downloadUrl = basePath + '/' + url + param;
      return $http.get(downloadUrl, { responseType: 'arraybuffer' }).then(onFileDownloaded).catch(onError);
    },
    downloadGetAba: function downloadGetAba(basePath, parametros) {
      var param = parametros.param;
      var url = parametros.url;
      var downloadUrl = basePath + '/' + url + param;
      return $http.get(downloadUrl, { responseType: 'arraybuffer' }).then(onFileOpen).catch(onError);
    }
  };
};

/***/ }),
/* 55 */,
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InputDatepicker_vue_vue_type_template_id_0b04765f_lang_html___ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InputDatepicker_vue_vue_type_script_lang_js___ = __webpack_require__(287);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__InputDatepicker_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__InputDatepicker_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__InputDatepicker_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__InputDatepicker_vue_vue_type_template_id_0b04765f_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__InputDatepicker_vue_vue_type_template_id_0b04765f_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StatusPassos_vue_vue_type_template_id_17e9e3c3_lang_html___ = __webpack_require__(1069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StatusPassos_vue_vue_type_script_lang_js___ = __webpack_require__(350);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__StatusPassos_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__StatusPassos_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StatusPassos_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(1076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__StatusPassos_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__StatusPassos_vue_vue_type_template_id_17e9e3c3_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__StatusPassos_vue_vue_type_template_id_17e9e3c3_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_TabelaGenerica_css_vue_type_style_index_0_lang_css___ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_TabelaGenerica_css_vue_type_style_index_0_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_TabelaGenerica_css_vue_type_style_index_0_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_TabelaGenerica_css_vue_type_style_index_0_lang_css____default.a); 

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mdChipsAutocomplete_vue_vue_type_template_id_31514c06_lang_html___ = __webpack_require__(1112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mdChipsAutocomplete_vue_vue_type_script_lang_js___ = __webpack_require__(383);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__mdChipsAutocomplete_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__mdChipsAutocomplete_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mdChipsAutocomplete_scss_vue_type_style_index_0_lang_scss___ = __webpack_require__(1116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mdChipsAutocomplete_vue_vue_type_style_index_1_lang_css___ = __webpack_require__(1117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);







/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_4__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__mdChipsAutocomplete_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__mdChipsAutocomplete_vue_vue_type_template_id_31514c06_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__mdChipsAutocomplete_vue_vue_type_template_id_31514c06_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

var _downloads = __webpack_require__(54);

var _downloads2 = _interopRequireDefault(_downloads);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  methods: {
    detalharAcordo: function detalharAcordo(row) {
      var rota = null;
      switch (row.codTipoAcordo) {
        case 'FIXO':
          rota = 'verDetalhesNegociacaoFixoFluxo';
          break;
        case 'TABLOIDE':
          rota = 'verDetalhesNegociacaoTabloideFluxo';
          break;
        case 'NEGOCIACAO_PRECO':
          rota = 'verDetalhesNegociacaoPrecoFluxo';
          break;
        case 'POSITIVACAO':
          rota = 'verDetalhesPositivacaoFluxo';
          break;
        case 'CRESCIMENTO':
          rota = 'verDetalhesCrescimentoFluxo';
          break;
        default:
          return;
      }
      this.$router.push({ name: rota, params: { id: row.numeroAcordo } });
    },
    imprimirContrato: function imprimirContrato(row) {
      var _this = this;

      var getBasePath = (0, _apiResource2.default)('negociacao', 'contrato');
      var resource = (0, _downloads2.default)(this.$http);

      var parametros = '?id=' + row.numeroAcordo;
      resource.downloadGet(getBasePath, {
        param: parametros,
        url: 'relatorio/negociacao'
      }).then(function () {
        _this.$toast.create(_this.$t('message.exportacao_download'), 'snack', 3E3);
      }).catch(function () {
        _this.$toast.create(_this.$t('errors.imprimir'), 'snack', 3E3);
      });
    }
  }
};

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_TabelaSizing_css_vue_type_style_index_2_lang_css___ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_TabelaSizing_css_vue_type_style_index_2_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_TabelaSizing_css_vue_type_style_index_2_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_TabelaSizing_css_vue_type_style_index_2_lang_css____default.a); 

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TooltipAjuda_vue_vue_type_template_id_2f772edf_lang_html___ = __webpack_require__(1580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TooltipAjuda_vue_vue_type_script_lang_js___ = __webpack_require__(673);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__TooltipAjuda_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__TooltipAjuda_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__TooltipAjuda_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__TooltipAjuda_vue_vue_type_template_id_2f772edf_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__TooltipAjuda_vue_vue_type_template_id_2f772edf_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InputMoneyOld_vue_vue_type_template_id_5940dc7e___ = __webpack_require__(1015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InputMoneyOld_vue_vue_type_script_lang_js___ = __webpack_require__(309);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__InputMoneyOld_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__InputMoneyOld_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__InputMoneyOld_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__InputMoneyOld_vue_vue_type_template_id_5940dc7e___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__InputMoneyOld_vue_vue_type_template_id_5940dc7e___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 80 */,
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      workspaceFiltrosResources: this.$api.workspaceFiltros(this.$resource),
      workspace: {}
    };
  },

  methods: {
    carregarWorkspace: function carregarWorkspace(entidade, cb) {
      var _this = this;

      return this.workspaceFiltrosResources.pesquisar({ entidade: entidade }).then(function (response) {
        _this.workspace = response.data || {};
        if (cb && _this.workspace && _this.workspace.filtros) {
          cb(_this.workspace.filtros);
        }
      });
    },
    salvarWorkspace: function salvarWorkspace(entidade) {
      var filtros = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var idEntidade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      if (this.workspace.id) {
        this.atualizarWorkspace(entidade, filtros, idEntidade);
      } else {
        this.inserirWorkspace(entidade, filtros, idEntidade);
      }
    },
    inserirWorkspace: function inserirWorkspace(entidade) {
      var _this2 = this;

      var filtros = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var idEntidade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      this.workspace.idEntidade = idEntidade;
      this.workspace.filtros = filtros;

      this.workspaceFiltrosResources.inserir({ entidade: entidade }, this.workspace).then(function (response) {
        _this2.workspace.id = response.data;
      });
    },
    atualizarWorkspace: function atualizarWorkspace(entidade) {
      var filtros = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var idEntidade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      this.workspace.idEntidade = idEntidade;
      this.workspace.filtros = filtros;

      this.workspaceFiltrosResources.atualizar({ entidade: entidade }, this.workspace);
    }
  }
};

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.basePath = undefined;

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePathCadastro = (0, _apiResource2.default)('cadastro');
var basePath = exports.basePath = (0, _apiResource2.default)('job');

var importacaoActions = {
  importar: { method: 'POST', url: basePath + 'importacao?tipo_importacao={tipoImportacao}&nome_arquivo={nomeArquivo}' },
  listarAndamento: { method: 'GET', url: basePathCadastro + 'importacao/andamento' },
  listarErro: { method: 'GET', url: basePathCadastro + 'importacao/erro' },
  listarFinalizado: { method: 'GET', url: basePathCadastro + 'importacao/finalizado' },
  listarTipos: { method: 'GET', url: basePathCadastro + 'tipo-importacao' },
  listarDetalhesErros: { method: 'GET', url: basePathCadastro + 'importacao/erro-detalhes?tamanhoPagina={size}&numeroPagina={page}&idErro={idErro}' },
  listarUltimasSellInSellOut: { method: 'GET', url: basePathCadastro + 'importacao/sellin-sellout' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, importacaoActions);
};

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.numberBetweenValues = exports.convertToNumberFormat = exports.convertToPercent = exports.convertToMoney = undefined;

var _vanillaMasker = __webpack_require__(53);

var _vanillaMasker2 = _interopRequireDefault(_vanillaMasker);

var _helpers = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var convertToMoney = exports.convertToMoney = function convertToMoney(value) {
  if (!value) {
    return 'R$ 0,00';
  }
  var valor = (0, _helpers.convertFloatToMoney)(value);
  if (value < 0) {
    return 'R$ -' + _vanillaMasker2.default.toMoney(valor);
  }
  return 'R$ ' + _vanillaMasker2.default.toMoney(valor);
};

var convertToPercent = exports.convertToPercent = function convertToPercent(value) {
  if (!value) {
    return '0,00 %';
  }
  var valor = (0, _helpers.convertFloatToMoney)(value);
  if (value < 0) {
    return '-' + _vanillaMasker2.default.toMoney(valor) + ' %';
  }
  return _vanillaMasker2.default.toMoney(valor) + ' %';
};

var convertToNumberFormat = exports.convertToNumberFormat = function convertToNumberFormat(value) {
  if (!value) {
    return '0';
  }
  var valor = (0, _helpers.convertFloatToMoney)(value);
  if (value < 0) {
    return '-' + _vanillaMasker2.default.toMoney(valor);
  }
  return '' + _vanillaMasker2.default.toMoney(valor);
};

var numberBetweenValues = exports.numberBetweenValues = function numberBetweenValues(n, a, b) {
  return a <= n && (!b || b >= n);
};

/***/ }),
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.basePath = undefined;

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePathCadastro = (0, _apiResource2.default)('cadastro');
var basePath = exports.basePath = (0, _apiResource2.default)('job');

var importacaoActions = {
  importar: { method: 'POST', url: basePath + 'importacao?tipo_importacao={tipoImportacao}&nome_arquivo={nomeArquivo}' },
  listarAndamento: { method: 'GET', url: basePathCadastro + 'importacao/andamento' },
  listarErro: { method: 'GET', url: basePathCadastro + 'importacao/erro' },
  listarFinalizado: { method: 'GET', url: basePathCadastro + 'importacao/finalizado' },
  listarTipos: { method: 'GET', url: basePathCadastro + 'tipo-importacao' },
  listarDetalhesErros: { method: 'GET', url: basePathCadastro + 'importacao/erro-detalhes?tamanhoPagina={size}&numeroPagina={page}&idErro={idErro}' },
  listarUltimasSellInSellOut: { method: 'GET', url: basePathCadastro + 'importacao/sellin-sellout' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, importacaoActions);
};

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var trigger = function trigger(el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
};

exports.default = trigger;

/***/ }),
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (basePath) {
  return {
    ativar: { method: 'PUT', url: basePath + '/ativacao/{id}/true' },
    atualizar: { method: 'PUT', url: '' + basePath },
    gravar: { method: 'POST', url: '' + basePath },
    inativar: { method: 'PUT', url: basePath + '/ativacao/{id}/false' },
    listar: { method: 'GET', url: basePath + '?tamanhoPagina={size}&numeroPagina={page}' },
    listarAtivos: { method: 'GET', url: basePath + '?nome={nome}&indAtivo=true' },
    selecao: { method: 'GET', url: basePath + '/selecao' }
  };
};

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.auth = undefined;

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

var _keycloakJs = __webpack_require__(956);

var _keycloakJs2 = _interopRequireDefault(_keycloakJs);

var _vue = __webpack_require__(44);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prdEnv = "production" === 'production',
    jsonPath = prdEnv ? './keycloak.json' : './static/keycloak.json',
    keycloak = new _keycloakJs2.default(jsonPath);

var getSessionData = function getSessionData(key) {
  var data = window.sessionStorage.getItem(key) === 'undefined';
  return data ? undefined : window.sessionStorage.getItem(key);
};

var setSessionData = function setSessionData(key, data) {
  window.sessionStorage.setItem(key, data);
};

var tokenItem = getSessionData('token');
var idTokenItem = getSessionData('idToken');
var refreshTokenItem = getSessionData('refreshToken');

var sessionListeners = [];

var notifySessionExpired = function notifySessionExpired() {
  if (sessionListeners.length === 0) {
    window.logout();
  } else {
    sessionListeners.forEach(function (listener) {
      return listener.onSessionExpired();
    });
  }
};

var con = console;

var _refreshToken = function _refreshToken() {
  return keycloak.updateToken(-1);
};

var onResponse = function onResponse(response) {
  if (response.status === 401) {
    con.log('Sessão expirada mediante resposta 401.');
    notifySessionExpired();
  }
  return response;
};

var isRefreshTokenExpired = function isRefreshTokenExpired() {
  var tenSeconds = 10 * 1000,
      now = new Date().getTime(),
      timeSkew = keycloak.timeSkew * 1000,
      refreshDate = new Date(keycloak.refreshTokenParsed.exp * 1000).getTime();

  var expiresIn = refreshDate;
  expiresIn += timeSkew;
  expiresIn -= now;
  expiresIn -= tenSeconds;

  return expiresIn < 0;
};

var setHeaders = function setHeaders(request) {
  request.headers.set('Authorization', 'Bearer ' + keycloak.token);
  request.headers.set('Accept', 'application/json');
  request.headers.set('Content-type', 'application/json');
};

var _isTokenExpired = function _isTokenExpired() {
  return keycloak.isTokenExpired(10);
};

var auth = exports.auth = {
  loginRequired: function loginRequired() {
    var promise = new _promise2.default(function (resolve) {
      keycloak.init({
        onLoad: 'login-required',
        timeSkew: 0,
        token: tokenItem,
        idToken: idTokenItem,
        refreshToken: refreshTokenItem,
        flow: 'standard',
        checkLoginIframe: false
      }).success(function () {
        setSessionData('token', keycloak.token);
        setSessionData('idToken', keycloak.idToken);
        setSessionData('refreshToken', keycloak.refreshToken);
        resolve();
      }).error(function (err) {
        resolve();
      });
    });
    return promise;
  },
  createInterceptors: function createInterceptors() {
    _vue2.default.http.interceptors.push(function (request, next) {
      if (!_isTokenExpired()) {
        setHeaders(request);
        next(onResponse);
      } else if (!isRefreshTokenExpired()) {
        _refreshToken().success(function () {
          setHeaders(request);
          next(onResponse);
        }).error(function (err) {
          con.log('Sessão expirada mediante erro de refresh.', err);
          notifySessionExpired();
        });
      } else {
        con.log('Sessão expirada mediante expiração do token de refresh.');
        notifySessionExpired();
      }
    });
  },
  isTokenExpired: function isTokenExpired() {
    return _isTokenExpired();
  },
  refreshToken: function refreshToken() {
    return new _promise2.default(function (resolve) {
      _refreshToken().success(resolve).error(notifySessionExpired);
    });
  },
  registerSessionListener: function registerSessionListener(listener) {
    if (listener.onSessionExpired) sessionListeners.push(listener);
  },
  doLogout: function doLogout() {
    window.logout();
  }
};

window.keycloak = keycloak;

var plugin = function plugin() {
  window.logout = function () {
    keycloak.logout(window.location.origin);
  };
  _vue2.default.prototype.$auth = keycloak;
};

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(plugin);
}

exports.default = plugin;

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PendenciaNegociacao_vue_vue_type_template_id_9dd7ca00___ = __webpack_require__(1216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PendenciaNegociacao_vue_vue_type_script_lang_js___ = __webpack_require__(449);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__PendenciaNegociacao_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__PendenciaNegociacao_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__PendenciaNegociacao_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__PendenciaNegociacao_vue_vue_type_template_id_9dd7ca00___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__PendenciaNegociacao_vue_vue_type_template_id_9dd7ca00___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(29);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(43);

var _createClass3 = _interopRequireDefault(_createClass2);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _numeric = __webpack_require__(83);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Apuracao = function () {
  function Apuracao(titulo, id, idAcordo, apuracao) {
    (0, _classCallCheck3.default)(this, Apuracao);

    _moment2.default.locale('pt-BR');
    this._titulo = titulo;
    this._id = id;
    this._idAcordo = idAcordo;
    this._idMeta = apuracao.idMeta;
    this._statusApuracao = apuracao.status;
    this._tipoAcordo = apuracao.codTipoAcordo;
    this._tipo = apuracao.descTipoAcordo;
    this._descricao = apuracao.descricao;
    this._dataInicio = apuracao.dtaInicio;
    this._dataFinal = apuracao.dtaFim;
    this._periodoDe = apuracao.periodoDe;
    this._periodoAte = apuracao.periodoAte;
    this._solicitante = apuracao.solicitante;
    this._codCliente = apuracao.codCliente;
    this._cliente = apuracao.nomCliente;
    this._contratoCliente = apuracao.contratoCliente;
    this._codClientePagador = apuracao.codClientePag;
    this._clientePagador = apuracao.nomClientePag;
    this._holding = apuracao.descFiltro;
    this._regiao = apuracao.descFiltro;
    this._filtroCliente = apuracao.nomFiltroCliente;
    this._tipoBeneficio = apuracao.codTipoBeneficio;
    this._descTipoBeneficio = apuracao.descTipoBeneficio;
    this._banco = apuracao.nomBanco;
    this._agencia = apuracao.vlrAgencia;
    this._contaCorrente = apuracao.vlrConta;
    this._evidencia = apuracao.evidencia;
    this._marca = apuracao.marca;
    this._linhaDeProduto = apuracao.linhaProduto;
    this._familia = apuracao.familia;
    this._produto = apuracao.produto;
    this._valorMeta = apuracao.vlrMeta;
    this._valorRelizado = apuracao.realizadoMeta;
    this._valorNegociado = apuracao.vlrNegociado;
    this._valorPagamento = apuracao.vlrPagamento;
    this._precoNegociado = apuracao.precoNegociacao;
    this._tipoBonificacao = apuracao.tipoBonificacao;
    this._tipoMetaBeneficio = apuracao.tipoMetaBeneficio;
    this._unidadeMedida = apuracao.unidadeMedida;
    this._baseCalculoApuracao = apuracao.baseCalculoApuracao;
    this._justificativa = apuracao.justificativa;
    this._aprovador = !!apuracao.aprovador;
    this._metas = apuracao.metas;
  }

  (0, _createClass3.default)(Apuracao, [{
    key: 'exibirMeta',
    value: function exibirMeta(valor) {
      if (this.ehValor) {
        return (0, _numeric.convertToMoney)(valor);
      }
      return (0, _numeric.convertToNumberFormat)(valor);
    }
  }, {
    key: 'id',
    get: function get() {
      return this._id;
    }
  }, {
    key: 'status',
    get: function get() {
      return this._statusApuracao;
    },
    set: function set(value) {
      this._statusApuracao = value;
    }
  }, {
    key: 'exibirAprovado',
    get: function get() {
      return this._statusApuracao === 'APROVADO' || this._statusApuracao === 'AGUARDANDO_APROVACAO';
    }
  }, {
    key: 'exibirAnalisar',
    get: function get() {
      return this._statusApuracao === 'EM_ANALISE' || this._statusApuracao === 'AGUARDANDO_APROVACAO' && this._aprovador;
    }
  }, {
    key: 'exibirReprovado',
    get: function get() {
      return this._statusApuracao === 'REPROVADO' || this._statusApuracao === 'AGUARDANDO_APROVACAO' && this._aprovador;
    }
  }, {
    key: 'naoExecutarAcoes',
    get: function get() {
      return this._statusApuracao === 'APROVADO' || this._statusApuracao === 'EM_ANALISE' || this._statusApuracao === 'REPROVADO' || !this._aprovador;
    }
  }, {
    key: 'exibirJustificativa',
    get: function get() {
      return this._justificativa && this._justificativa.length && this.naoExecutarAcoes;
    }
  }, {
    key: 'ehValor',
    get: function get() {
      return this._tipoMetaBeneficio === 'SELLOUT_VALOR' || this._tipoMetaBeneficio === 'SELLIN_VALOR';
    }
  }, {
    key: 'tipoMetaBeneficio',
    get: function get() {
      return this._tipoMetaBeneficio;
    }
  }, {
    key: 'tipoBonificacao',
    get: function get() {
      return this._tipoBonificacao;
    }
  }, {
    key: 'baseCalculoApuracao',
    get: function get() {
      return this._baseCalculoApuracao;
    }
  }, {
    key: 'unidadeMedida',
    get: function get() {
      return this._unidadeMedida;
    }
  }, {
    key: 'ehPercentual',
    get: function get() {
      return this._tipoBonificacao === 'PERCENTUAL';
    }
  }, {
    key: 'titulo',
    get: function get() {
      return this._titulo + ' ' + this._idAcordo + ' :: ' + this._tipo + ' :: ' + this._solicitante;
    }
  }, {
    key: 'descricao',
    get: function get() {
      return this._descricao;
    }
  }, {
    key: 'dataInicio',
    get: function get() {
      return (0, _moment2.default)(this._dataInicio, 'YYYY-MM-DD').format('DD-MM-YYYY');
    }
  }, {
    key: 'dataFinal',
    get: function get() {
      return (0, _moment2.default)(this._dataFinal, 'YYYY-MM-DD').format('DD-MM-YYYY');
    }
  }, {
    key: 'periodo',
    get: function get() {
      if (this._periodoAte > this._periodoDe) {
        return (0, _moment2.default)(this._periodoDe, 'YYYYMM').format('MMMM/YYYY') + ' \xE0 ' + (0, _moment2.default)(this._periodoAte, 'YYYYMM').format('MMMM/YYYY');
      }
      return (0, _moment2.default)(this._periodoDe, 'YYYYMM').format('MMMM/YYYY');
    }
  }, {
    key: 'contratoCliente',
    get: function get() {
      return this._contratoCliente;
    }
  }, {
    key: 'clientePagador',
    get: function get() {
      return this._codClientePagador + ' - ' + this._clientePagador;
    }
  }, {
    key: 'descTipoBeneficio',
    get: function get() {
      return this._descTipoBeneficio;
    }
  }, {
    key: 'ehDepositoEmConta',
    get: function get() {
      return this._tipoBeneficio === 'DEPOSITO_CONTA';
    }
  }, {
    key: 'contaCorrente',
    get: function get() {
      return this._banco + ' - ' + this._agencia + ' - ' + this._contaCorrente;
    }
  }, {
    key: 'ehMetaComContraPartida',
    get: function get() {
      return this.ehCrescimento || this.ehNegociacaoPreco || this.ehPositivacao;
    }
  }, {
    key: 'ehPositivacaoOuNegociacaoPreco',
    get: function get() {
      return this.ehPositivacao || this.ehNegociacaoPreco;
    }
  }, {
    key: 'ehCrescimentoOuNegociacaoPreco',
    get: function get() {
      return this.ehCrescimento || this.ehNegociacaoPreco;
    }
  }, {
    key: 'ehPositivacao',
    get: function get() {
      return this._tipoAcordo === 'POSITIVACAO';
    }
  }, {
    key: 'ehNegociacaoPreco',
    get: function get() {
      return this._tipoAcordo === 'NEGOCIACAO_PRECO';
    }
  }, {
    key: 'ehCrescimento',
    get: function get() {
      return this._tipoAcordo === 'CRESCIMENTO';
    }
  }, {
    key: 'ehTabloide',
    get: function get() {
      return this._tipoAcordo === 'TABLOIDE';
    }
  }, {
    key: 'cliente',
    get: function get() {
      return this._cliente;
    }
  }, {
    key: 'codCliente',
    get: function get() {
      return this._codCliente;
    }
  }, {
    key: 'ehCliente',
    get: function get() {
      return this._filtroCliente === 'id_cliente';
    }
  }, {
    key: 'holding',
    get: function get() {
      return this._holding;
    }
  }, {
    key: 'ehHolding',
    get: function get() {
      return this._filtroCliente === 'id_holding';
    }
  }, {
    key: 'ehRegiao',
    get: function get() {
      return this._filtroCliente === 'id_regiao';
    }
  }, {
    key: 'valorMeta',
    get: function get() {
      return this.exibirMeta(this._valorMeta);
    }
  }, {
    key: 'valorRelizado',
    get: function get() {
      return this.exibirMeta(this._valorRelizado);
    }
  }, {
    key: 'valorNegociado',
    get: function get() {
      return (0, _numeric.convertToMoney)(this._valorNegociado);
    }
  }, {
    key: 'valorPagamento',
    get: function get() {
      return (0, _numeric.convertToMoney)(this._valorPagamento);
    }
  }, {
    key: 'precoNegociado',
    get: function get() {
      return (0, _numeric.convertToMoney)(this._precoNegociado);
    }
  }, {
    key: 'evidencia',
    get: function get() {
      return this._evidencia;
    }
  }, {
    key: 'marca',
    get: function get() {
      return this._marca;
    }
  }, {
    key: 'linhaDeProduto',
    get: function get() {
      return this._linhaDeProduto;
    }
  }, {
    key: 'familia',
    get: function get() {
      return this._familia;
    }
  }, {
    key: 'produto',
    get: function get() {
      return this._produto;
    }
  }, {
    key: 'metasCrescimento',
    get: function get() {
      return this._metas;
    }
  }, {
    key: 'justificativa',
    get: function get() {
      return this._justificativa;
    },
    set: function set(value) {
      this._justificativa = value;
    }
  }, {
    key: 'idMeta',
    get: function get() {
      return this._idMeta;
    }
  }]);
  return Apuracao;
}();

exports.default = Apuracao;

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PendenciaApuracao_vue_vue_type_template_id_3dd482c4___ = __webpack_require__(1224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PendenciaApuracao_vue_vue_type_script_lang_js___ = __webpack_require__(455);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__PendenciaApuracao_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__PendenciaApuracao_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__PendenciaApuracao_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__PendenciaApuracao_vue_vue_type_template_id_3dd482c4___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__PendenciaApuracao_vue_vue_type_template_id_3dd482c4___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListarEvidencia_vue_vue_type_template_id_f2387790___ = __webpack_require__(1229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ListarEvidencia_vue_vue_type_script_lang_js___ = __webpack_require__(459);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__ListarEvidencia_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__ListarEvidencia_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ListarEvidencia_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__ListarEvidencia_vue_vue_type_template_id_f2387790___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ListarEvidencia_vue_vue_type_template_id_f2387790___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MetasCrescimento_vue_vue_type_template_id_6be13fe0___ = __webpack_require__(1064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MetasCrescimento_vue_vue_type_script_lang_js___ = __webpack_require__(344);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__MetasCrescimento_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__MetasCrescimento_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MetasCrescimento_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(1066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__MetasCrescimento_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__MetasCrescimento_vue_vue_type_template_id_6be13fe0___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__MetasCrescimento_vue_vue_type_template_id_6be13fe0___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _helpers = __webpack_require__(5);

exports.default = {
  data: function data() {
    return {
      indexPagina: 0
    };
  },

  props: {
    registros: {
      type: Array,
      default: []
    },
    paginas: Number,
    title: {
      type: String,
      default: ''
    },
    limitePagina: {
      type: Number,
      default: 5
    },
    carregando: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    possuiRegistros: function possuiRegistros() {
      return !!this.registros && !!this.registros.length;
    }
  },
  methods: {
    getMoney: _helpers.getMoney,
    clickHandler: function clickHandler(pagina) {
      this.indexPagina = pagina - 1;
      this.$emit('TABELA_BUSCAR_PROXIMA_PAGINA', pagina);
    },
    refazPaginacao: function refazPaginacao() {
      this.indexPagina = 0;
    },
    formatPercent: function formatPercent(val) {
      return (val || 0).toLocaleString('pt-br', { style: 'percent' });
    },
    formatDecimal: function formatDecimal(val) {
      return (val || 0).toLocaleString('pt-br', { style: 'decimal' });
    }
  }
};

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_Pagination_css_vue_type_style_index_0_lang_css___ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_Pagination_css_vue_type_style_index_0_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_Pagination_css_vue_type_style_index_0_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_Pagination_css_vue_type_style_index_0_lang_css____default.a); 

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ModalVoltar_vue_vue_type_template_id_72de9d0e_lang_html___ = __webpack_require__(1020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ModalVoltar_vue_vue_type_script_lang_js___ = __webpack_require__(311);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__ModalVoltar_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__ModalVoltar_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ModalVoltar_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__ModalVoltar_vue_vue_type_template_id_72de9d0e_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ModalVoltar_vue_vue_type_template_id_72de9d0e_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

var _genericResource = __webpack_require__(104);

var _genericResource2 = _interopRequireDefault(_genericResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'filtro-cliente');

var filtroClienteActions = (0, _extends3.default)({}, (0, _genericResource2.default)(basePath), {
  listarAtivos: { method: 'GET', url: basePath + '?tamanhoPagina=40&numeroPagina=1&indAtivo=true' }
});

exports.default = function (resource) {
  return resource('' + basePath, {}, filtroClienteActions);
};

/***/ }),
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'controlador-trade');

var controladorTradeActions = {
  listar: { method: 'GET', url: '' + basePath }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, controladorTradeActions);
};

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

var _genericResource = __webpack_require__(7);

var _genericResource2 = _interopRequireDefault(_genericResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'dicionario');

var dicionarioActions = (0, _extends3.default)({}, (0, _genericResource2.default)(basePath), {
  implantacao: { method: 'GET', url: basePath + '/implantacao' }
});

exports.default = function (resource) {
  return resource('' + basePath, {}, dicionarioActions);
};

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(11);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  buildGET: function buildGET(resource, basePath, uri, params) {
    var queryParams = '';

    var concatParam = function concatParam(key, value) {
      var concat = queryParams.length !== 0 ? '&' : '';
      queryParams = '' + queryParams + concat + key + '=' + value;
    };

    (0, _keys2.default)(params).filter(function (key) {
      return params[key] || params[key] === false;
    }).forEach(function (key) {
      var value = params[key];
      if (!Array.isArray(value)) {
        concatParam(key, value);
      } else {
        value.forEach(function (itemValue) {
          concatParam(key, itemValue);
        });
      }
    });

    var pathWithSlash = basePath.endsWith('/') ? basePath : basePath + '/';

    var actions = {
      doGet: { method: 'GET', url: '' + pathWithSlash + uri + '?' + queryParams }
    };

    return resource(basePath, {}, actions);
  },
  buildPUT: function buildPUT(resource, basePath, uri, params) {
    var queryParams = '';

    var concatParam = function concatParam(key, value) {
      var concat = queryParams.length !== 0 ? '&' : '';
      queryParams = '' + queryParams + concat + key + '=' + value;
    };

    (0, _keys2.default)(params).filter(function (key) {
      return params[key] || params[key] === false;
    }).forEach(function (key) {
      var value = params[key];
      if (!Array.isArray(value)) {
        concatParam(key, value);
      } else {
        value.forEach(function (itemValue) {
          concatParam(key, itemValue);
        });
      }
    });

    var pathWithSlash = basePath.endsWith('/') ? basePath : basePath + '/';

    var actions = {
      doPut: { method: 'PUT', url: '' + pathWithSlash + uri + '?' + queryParams }
    };

    return resource(basePath, {}, actions);
  },
  buildPOST: function buildPOST(resource, basePath, uri, params) {
    var queryParams = '';

    var concatParam = function concatParam(key, value) {
      var concat = queryParams.length !== 0 ? '&' : '';
      queryParams = '' + queryParams + concat + key + '=' + value;
    };

    (0, _keys2.default)(params).filter(function (key) {
      return params[key] || params[key] === false;
    }).forEach(function (key) {
      var value = params[key];
      if (!Array.isArray(value)) {
        concatParam(key, value);
      } else {
        value.forEach(function (itemValue) {
          concatParam(key, itemValue);
        });
      }
    });

    var pathWithSlash = basePath.endsWith('/') ? basePath : basePath + '/';

    var actions = {
      doPost: { method: 'POST', url: '' + pathWithSlash + uri + '?' + queryParams }
    };

    return resource(basePath, {}, actions);
  }
};

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

var _genericResource = __webpack_require__(7);

var _genericResource2 = _interopRequireDefault(_genericResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'termo-aceite');

var termoAceiteActions = (0, _extends3.default)({}, (0, _genericResource2.default)(basePath), {
  listarFiltrado: { method: 'GET', url: basePath + '?tamanhoPagina={tamanhoPagina}&numeroPagina={numeroPagina}&filtro={filter}' },
  buscar: { method: 'GET', url: basePath + '/{id}' },
  ativacao: { method: 'PUT', url: basePath + '/ativacao/{codigo}' },
  buscarTermosLogin: { method: 'GET', url: basePath + '/login' },
  aceitarTermos: { method: 'POST', url: basePath + '/aceito' },
  listarRealizados: { method: 'GET', url: basePath + '/realizados?tamanhoPagina={tamanhoPagina}&numeroPagina={numeroPagina}&filtro={filter}' }
});

exports.default = function (resource) {
  return resource('' + basePath, {}, termoAceiteActions);
};

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

var _genericResource = __webpack_require__(7);

var _genericResource2 = _interopRequireDefault(_genericResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('usuario', 'usuario');

var usuarioActions = (0, _extends3.default)({}, (0, _genericResource2.default)(basePath), {
  buscar: { method: 'GET', url: basePath + '/{id}' },
  ativarRepresentante: { method: 'PUT', url: basePath + '/representante/{id}/true' },
  desativarRepresentante: { method: 'PUT', url: basePath + '/representante/{id}/false' },
  listarSuperior: { method: 'GET', url: basePath + '/superior?nome={nome}&idEstruturaUsuario={idEstruturaUsuario}&colunaOrdenacao=nom_usuario' },
  listarAtivosPorEmail: { method: 'GET', url: basePath + '?email={email}&indAtivo=true&colunaOrdenacao=email' },
  listarAtivosPorEmailNaoConfigurados: { method: 'GET', url: basePath + '?filter={email}&colunaOrdenacao=email&naoConfiguradosTradelinks=true' },
  listarNaoConfigurados: { method: 'GET', url: basePath + '?filter={filter}&naoConfiguradosTradelinks=true' },
  informacao: { method: 'GET', url: basePath + '/informacao' },
  listarConfiguracao: { method: 'GET', url: basePath + '/configuracao' },
  atualizarConfiguracao: { method: 'PUT', url: basePath + '/configuracao' },
  listarRepresentante: { method: 'GET', url: basePath + '/representante' },
  redefinirSenha: { method: 'PUT', url: basePath + '/senha/redefinicao/usuario/{idUsuario}' },
  listarAtivosResumido: { method: 'GET', url: basePath + '/resumido?nome={nome}&indAtivo=true' }
});

exports.default = function (resource) {
  return resource('' + basePath, {}, usuarioActions);
};

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var app = {
  theme: {
    primary: {
      color: 'orange',
      hue: 800,
      textColor: 'white'
    },
    accent: 'brown',
    warn: {
      color: 'red',
      hue: 400
    },
    background: 'white'
  },
  title: 'Tradelinks'
};

var themeVuetify = exports.themeVuetify = {
  primary: '#EF6C00',
  secondary: '#b0bec5',
  tertiary: '#8bc34a',
  accent: '#795548',
  error: '#b71c1c',
  warning: '#EF5350'
};

exports.default = function (Vue) {
  Vue.material.registerTheme('default', app.theme);
};

var title = exports.title = app.title;

/***/ }),
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ptBr = __webpack_require__(927);

var _ptBr2 = _interopRequireDefault(_ptBr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  locale: 'pt-br',
  messages: {
    'pt-br': _ptBr2.default
  }
};

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Home_vue_vue_type_script_lang_js___ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Home_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Home_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Home_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Home_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Home_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(6);

var _Sidebar = __webpack_require__(932);

var _Sidebar2 = _interopRequireDefault(_Sidebar);

var _Toolbar = __webpack_require__(938);

var _Toolbar2 = _interopRequireDefault(_Toolbar);

var _importacoes = __webpack_require__(99);

var _importacoes2 = _interopRequireDefault(_importacoes);

var _dicionario = __webpack_require__(242);

var _dicionario2 = _interopRequireDefault(_dicionario);

var _usuario = __webpack_require__(245);

var _usuario2 = _interopRequireDefault(_usuario);

var _controladorTrade = __webpack_require__(241);

var _controladorTrade2 = _interopRequireDefault(_controladorTrade);

var _auth = __webpack_require__(105);

var _loading = __webpack_require__(14);

var _menu = __webpack_require__(957);

var _menu2 = _interopRequireDefault(_menu);

var _TermoAceiteLogin = __webpack_require__(958);

var _TermoAceiteLogin2 = _interopRequireDefault(_TermoAceiteLogin);

var _termoAceite = __webpack_require__(244);

var _termoAceite2 = _interopRequireDefault(_termoAceite);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Home',
  data: function data() {
    return {
      importacaoResources: (0, _importacoes2.default)(this.$resource),
      dicionarioResources: (0, _dicionario2.default)(this.$resource),
      usuarioResources: (0, _usuario2.default)(this.$resource),
      controladorResources: (0, _controladorTrade2.default)(this.$resource),
      termoAceiteResources: (0, _termoAceite2.default)(this.$resource),
      dicionarioCarregado: false,
      eventLoop: null,
      eventLoopTimer: 10E3,
      mensagemModalInicializacao: '',
      menuList: (0, _menu2.default)(this),
      usuarioInfo: {},
      abrirMenu: false,
      recarregar: false,
      termos: [],
      aceito: false
    };
  },

  components: {
    Sidebar: _Sidebar2.default,
    Toolbar: _Toolbar2.default,
    TermoAceiteLogin: _TermoAceiteLogin2.default
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('roles', ['getAllRoles', 'getUsuario']), (0, _vuex.mapGetters)('usuario', ['usuarioLogado']), (0, _vuex.mapGetters)('implantacao', ['implantacao', 'indModoVarejo']), (0, _vuex.mapGetters)('controlador', ['getControladoreSelecionado']), {
    canAccessPageList: function canAccessPageList() {
      if (!this.getAllRoles) {
        return [];
      }
      return this.getAllRoles.filter(function (el) {
        return el.indexOf('_PAGINA') !== -1 || el.indexOf('_CRUD') !== -1;
      });
    },
    canImport: function canImport() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el.endsWith('_IMPORTAR') || el.endsWith('_CRUD');
      }).length;
    },
    filteredMenuList: function filteredMenuList() {
      var _this = this;

      if (!this.getAllRoles || !this.getAllRoles.length) {
        return [];
      }
      var filter = [];
      var routesFiltradas = [];
      this.menuList.forEach(function (m) {
        if (m.sub) {
          var subFiltrado = _this.filtrarSubMenu(m.sub);
          if (subFiltrado.length) {
            m.sub = subFiltrado;
            filter.push(m);
          }
        } else {
          _this.getAllRoles.forEach(function (r) {
            if (_this.validarRotaPorRole(m, routesFiltradas, r)) {
              filter.push(m);
              routesFiltradas.push(m.route);
            }
          });
        }
      });
      return filter;
    },
    hideMenu: function hideMenu() {
      return !this.filteredMenuList.length;
    },
    pageName: function pageName() {
      return this.$route.name;
    },
    usuario: function usuario() {
      return this.getUsuario;
    },
    state: function state() {
      return this.$route.name;
    },
    path: function path() {
      return this.$route.path;
    }
  }),
  watch: {
    getControladoreSelecionado: function getControladoreSelecionado() {
      var _this2 = this;

      if (this.$router.currentRoute.name === 'dashboard') {
        this.recarregar = true;
        setTimeout(function () {
          _this2.recarregar = false;
        }, 1E2);
      }
    }
  },
  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('importacao', ['popularImportacoesAndamento', 'popularTiposImportacao']), (0, _vuex.mapActions)('usuario', ['carregarInformacoesUsuario']), (0, _vuex.mapActions)('controlador', ['carregarControladores']), (0, _vuex.mapActions)('implantacao', ['carregarImplantacao']), {
    filtrarSubMenu: function filtrarSubMenu(subMenu) {
      var _this3 = this;

      var filter = [];
      var routesFiltradas = [];
      subMenu.forEach(function (m) {
        _this3.getAllRoles.forEach(function (r) {
          if (_this3.validarRotaPorRole(m, routesFiltradas, r)) {
            filter.push(m);
            routesFiltradas.push(m.route);
          }
        });
      });
      return filter;
    },
    validarRotaPorRole: function validarRotaPorRole(menu, routesFiltradas, role) {
      if (!Array.isArray(menu.role)) {
        return role.startsWith(menu.role) && !routesFiltradas.includes(menu.route);
      }
      var menuRoles = menu.role;
      return menuRoles.indexOf(role) >= 0 && !routesFiltradas.includes(menu.route);
    },
    usaEstiloNovo: function usaEstiloNovo(path) {
      var novasTelas = ['/cliente', '/produto', '/centro-custo', '/usuario', '/tipo-investimento', '/estrutura-usuario', '/importacoes', '/workflow', '/alcada', '/regiao', '/tipo-orcamento', '/tipo-acao', '/unidade-medida', '/sso-grupo', '/orcamento', '/ajuste-verba', '/negociacao', '/apuracao', '/pagamento', '/margem-contribuicao', '/sellin', '/transferencia-posse', '/termo-aceite', '/gestao-aprovacao', '/administracao'];
      return novasTelas.filter(function (tela) {
        return path.indexOf(tela) >= 0;
      }).length > 0;
    },
    buscarImportacoesAndamento: function buscarImportacoesAndamento() {
      var _this4 = this;

      if (this.canImport) {
        this.popularImportacoesAndamento(this.importacaoResources.listarAndamento).then(function () {
          _this4.resetEventLoop(10E3);
        });
      }
    },
    buscarTiposImportacao: function buscarTiposImportacao() {
      if (this.canImport) {
        this.popularTiposImportacao({ resource: this.importacaoResources.listarTipos,
          roles: this.getAllRoles });
      }
    },
    resetEventLoop: function resetEventLoop(timer) {
      if (this.eventLoopTimer === timer) {
        return;
      }
      window.clearInterval(this.eventLoop);
      this.eventLoopTimer = timer;
      this.eventLoopImportacoes();
    },
    eventLoopImportacoes: function eventLoopImportacoes() {
      var _this5 = this;

      if (!this.eventLoop && this.canImport) {
        this.eventLoop = setInterval(function () {
          _this5.buscarImportacoesAndamento();
        }, this.eventLoopTimer);
      }
    },
    toggleSidenav: function toggleSidenav() {
      this.abrirMenu = !this.abrirMenu;
    },
    logoutAceito: function logoutAceito() {
      this.$refs.modalSessao.close();
      _auth.auth.doLogout();
    },
    iniciaAplicacao: function iniciaAplicacao() {
      this.dicionarioCarregado = true;
      this.buscarImportacoesAndamento();
      this.buscarTiposImportacao();
    },
    recarregarAplicacao: function recarregarAplicacao() {
      location.reload();
    },
    fecharModalErro: function fecharModalErro() {
      this.$refs.modalErroInicializacaoAplicacao.close();
    },
    carregarTermos: function carregarTermos() {
      var _this6 = this;

      return new _promise2.default(function (resolve, reject) {
        _this6.termoAceiteResources.buscarTermosLogin().then(function (response) {
          _this6.termos = response.data;
          resolve();
        }).catch(reject);
      });
    },
    termoAceito: function termoAceito() {
      this.aceito = true;
    }
  }),
  mounted: function mounted() {
    var _this7 = this;

    _auth.auth.registerSessionListener({
      onSessionExpired: this.$refs.modalSessao.open
    });

    (0, _loading.showInitialLoading)();
    _promise2.default.all([this.carregarInformacoesUsuario(this.usuarioResources.informacao), this.carregarControladores(this.controladorResources.listar), this.carregarImplantacao(this.dicionarioResources.implantacao)]).then(function () {
      _this7.carregarTermos();
      _this7.iniciaAplicacao();
      setTimeout(function () {
        return (0, _loading.hideInitialLoading)();
      }, 3000);
    }).catch(function (e) {
      if (e.status === 403) {
        _this7.mensagemModalInicializacao = _this7.$t('errors.inicializacao_sem_perfil');
      } else {
        _this7.mensagemModalInicializacao = _this7.$t('errors.inicializacao');
      }
      _this7.$refs.modalErroInicializacaoAplicacao.open();
      setTimeout(function () {
        return (0, _loading.hideInitialLoading)();
      });
      window.setTimeout(function () {
        throw e;
      });
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.clearInterval(this.eventLoop);
  }
};

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Sidebar_vue_vue_type_script_lang_js___ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Sidebar_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Sidebar_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Sidebar_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Sidebar_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Sidebar_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loading = __webpack_require__(14);

exports.default = {
  props: {
    menuList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    abrir: false,
    logo: String
  },
  data: function data() {
    return {
      abrirMenu: false
    };
  },

  watch: {
    abrir: function abrir() {
      this.abrirMenu = !this.abrirMenu;
    }
  },
  methods: {
    lockBodyScroll: function lockBodyScroll() {
      document.body.style.overflowY = 'hidden';
    },
    onItemClicked: function onItemClicked(item) {
      if (!item.sub) {
        this.goToPage(item.route);
      }
    },
    getAbsolutePath: function getAbsolutePath() {
      return window.location.hash ? window.location.hash.replace('#/', '') : '';
    },
    shouldReloadRoute: function shouldReloadRoute(route) {
      var current = this.$router.history.current;

      return current.matched.filter(function (m) {
        return m.name === route;
      }).length > 0;
    },
    goToPage: function goToPage(route) {
      var _this = this;

      this.abrirMenu = !this.abrirMenu;
      if (this.$route.name === route && this.$route.name !== 'importacoes') {
        return;
      }

      setTimeout(function () {
        if (!_this.shouldReloadRoute(route)) {
          (0, _loading.showLoading)();
          _this.$router.push({ name: route, params: { menu: true } }, null, function () {
            return (0, _loading.hideLoading)();
          });
        } else {
          _this.$router.go();
        }
      }, 500);
    },
    toggleLockBodyScroll: function toggleLockBodyScroll() {
      document.body.style.overflowY = document.body.style.overflowY === 'hidden' ? 'auto' : 'hidden';
    },
    unlockBodyScroll: function unlockBodyScroll() {
      document.body.style.overflowY = 'auto';
    },
    toggleExpand: function toggleExpand() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      $logger.log('Args', args);
    }
  },
  mounted: function mounted() {
    $logger.log('Mounting', 'Sidebar');
  }
};

/***/ }),
/* 258 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 259 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 260 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Toolbar_vue_vue_type_script_lang_js___ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Toolbar_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Toolbar_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Toolbar_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Toolbar_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Toolbar_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Badge = __webpack_require__(941);

var _Badge2 = _interopRequireDefault(_Badge);

var _UsuarioToolbar = __webpack_require__(945);

var _UsuarioToolbar2 = _interopRequireDefault(_UsuarioToolbar);

var _termoAceite = __webpack_require__(948);

var _termoAceite2 = _interopRequireDefault(_termoAceite);

var _CalendarioToolbar = __webpack_require__(949);

var _CalendarioToolbar2 = _interopRequireDefault(_CalendarioToolbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    hideMenu: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    title: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    usuario: String,
    mail: String,
    estruturaUsuario: String,
    perfil: String
  },
  data: function data() {
    return {
      termoAceiteResources: (0, _termoAceite2.default)(this.$resource),

      progress: 0,
      progressInterval: null,
      done: false,
      transition: true,
      termos: []
    };
  },

  components: {
    Badge: _Badge2.default,
    UsuarioToolbar: _UsuarioToolbar2.default,
    CalendarioToolbar: _CalendarioToolbar2.default
  },
  methods: {
    logout: function logout() {
      var auth = this.$auth || window.auth;
      auth.logout();
    },
    toggleSidenav: function toggleSidenav() {
      this.$emit('TOGGLE_SIDEBAR');
    },
    irInicio: function irInicio() {
      if (this.$router.currentRoute.name !== 'dashboard') {
        this.$router.push({ name: 'inicio' });
        this.$emit('Toolbar_rotaAlterada');
      }
    },
    goToAceitePage: function goToAceitePage() {
      this.$router.push({ name: 'termoAceiteRealizado' });
    },
    buscarAceites: function buscarAceites() {
      var _this = this;

      var params = {
        numeroPagina: 1,
        tamanhoPagina: 10,
        filter: ''
      };

      this.termoAceiteResources.listarRealizados(params).then(function (response) {
        _this.termos = response.data.resposta;
      });
    }
  },
  mounted: function mounted() {
    this.buscarAceites();
  }
};

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Badge_vue_vue_type_script_lang_js___ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Badge_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Badge_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Badge_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Badge_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Badge_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      progress: 0,
      progressInterval: null,
      done: false,
      transition: true
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('importacao', {
    importacoesAndamento: 'getImportacoesAndamento',
    tiposImportacao: 'getTiposImportacao'
  }), {
    quantidadeAndamento: function quantidadeAndamento() {
      return this.importacoesAndamento.length;
    }
  }),
  methods: {
    startProgress: function startProgress() {
      var _this = this;

      this.progressInterval = window.setInterval(function () {
        _this.progress += 3;

        if (_this.progress >= 115) {
          _this.done = true;
          window.clearInterval(_this.progressInterval);
          window.setTimeout(function () {
            _this.done = false;
          }, 3E3);
        }
      }, 1E2);
    },
    restartProgress: function restartProgress() {
      var _this2 = this;

      this.progress = 0;
      this.transition = false;
      this.done = false;

      window.clearInterval(this.progressInterval);
      window.setTimeout(function () {
        _this2.transition = true;
        _this2.startProgress();
      }, 600);
    },
    goToImportPage: function goToImportPage() {
      this.$emit('RESET_SIDEBAR');
      this.$router.push({ name: 'importacoes' });
    }
  }
};

/***/ }),
/* 265 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_UsuarioToolbar_vue_vue_type_script_lang_js___ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_UsuarioToolbar_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_UsuarioToolbar_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_UsuarioToolbar_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_UsuarioToolbar_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_UsuarioToolbar_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'UsuarioToolbar',
  props: {
    usuario: String,
    mail: String,
    estruturaUsuario: String,
    perfil: String
  },
  data: function data() {
    return {
      menu: false,
      message: false,
      hints: true
    };
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('controlador', ['getControladores', 'getControladoreSelecionado']), {
    controladores: function controladores() {
      return this.getControladores || [];
    },
    temControladores: function temControladores() {
      return !!this.controladores.length;
    },
    exibirControladores: function exibirControladores() {
      return this.temControladores && (this.controladores.length > 1 || this.controladores.length === 1 && !!this.controladores[0].idDivisaoTitular);
    }
  }),
  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('controlador', ['setControladoreSelecionado']), {
    itemSelecionado: function itemSelecionado(item) {
      return item.id === this.getControladoreSelecionado.id;
    },
    selecionar: function selecionar(item) {
      if (this.itemSelecionado(item)) return;
      this.setControladoreSelecionado(item);
      this.menu = false;
      this.$emit('UsuarioToolBar_selecionar', item);
    },
    logout: function logout() {
      this.menu = false;
      var auth = this.$auth || window.auth;
      auth.logout();
    }
  })
};

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioToolbar_vue_vue_type_script_lang_js___ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioToolbar_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioToolbar_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioToolbar_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioToolbar_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioToolbar_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(6);

var _CalendarioCard = __webpack_require__(952);

var _CalendarioCard2 = _interopRequireDefault(_CalendarioCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'CalendarioToolbar',
  components: {
    CalendarioCard: _CalendarioCard2.default
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('roles', ['getAllRoles']), {
    canAccessView: function canAccessView() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el === 'CAL_VISUALIZAR';
      }).length;
    }
  }),
  data: function data() {
    return {
      menu: false
    };
  }
};

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioCard_vue_vue_type_script_lang_js___ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioCard_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioCard_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioCard_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioCard_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioCard_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loading = __webpack_require__(14);

exports.default = {
  name: 'CalendarioCard',
  data: function data() {
    return {
      resources: this.$api.calendario(this.$resource),
      date: new Date().toJSON().substr(0, 10),
      dataAnterior: null,
      mesAnoPesquisa: null,
      datas: {},
      eventos: []
    };
  },

  computed: {
    listaEventos: function listaEventos() {
      if (this.date) {
        return this.datas[this.date] || [];
      }
      return this.eventos;
    }
  },
  watch: {
    date: function date() {
      this.dataAnterior = this.date;
    }
  },
  methods: {
    carregarMes: function carregarMes() {
      var _this = this;

      (0, _loading.skipLoading)();
      var params = {
        indAtivo: true,
        indCancelado: false,
        size: 20000,
        page: 0,
        dataInicio: this.getDataInicio(),
        dataFim: this.getDataFim(),
        asc: true,
        colunaOrdenacao: 'data_inicio'
      };

      this.resources.listar(params).then(function (response) {
        _this.converterDatas(response.data.resposta);
      }, function (err) {
        _this.$error(_this, err);
      });
    },
    formatarData: function formatarData(item) {
      var dataInicio = this.moment(item.dataInicio, 'DD/MM/YYYY HH:mm:ss');
      var dataFim = this.moment(item.dataFim, 'DD/MM/YYYY HH:mm:ss');
      if (dataFim.isSame(dataInicio)) {
        return dataInicio.format('DD/MM/YYYY');
      }
      return dataInicio.format('DD/MM/YYYY') + ' a ' + dataFim.format('DD/MM/YYYY');
    },
    obterInformacaoFechamento: function obterInformacaoFechamento(item) {
      var dataInicio = this.moment(item.dataInicio, 'DD/MM/YYYY HH:mm:ss').add(-1, 'days');
      return 'Aprova\xE7\xE3o de apura\xE7\xE3o at\xE9: ' + dataInicio.format('DD/MM/YYYY') + ' \xE0s ' + item.horarioInicio;
    },
    converterDatas: function converterDatas(eventos) {
      var _this2 = this;

      this.eventos = eventos;
      var datas = {};
      eventos.forEach(function (e) {
        var dataInicio = _this2.moment(e.dataInicio, 'DD/MM/YYYY HH:mm:ss');
        var dataFim = _this2.moment(e.dataFim, 'DD/MM/YYYY HH:mm:ss');
        while (dataInicio.isSameOrBefore(dataFim)) {
          var formatada = dataInicio.format('YYYY-MM-DD');
          if (datas[formatada]) datas[formatada].push(e);else datas[formatada] = [e];
          dataInicio.add(1, 'days');
        }
      });
      this.datas = datas;
    },
    getDataInicio: function getDataInicio() {
      if (!this.mesAnoPesquisa || !this.mesAnoPesquisa.length) return null;
      return this.moment(this.mesAnoPesquisa, 'YYYY-MM').startOf(1).format('YYYY-MM-DD');
    },
    getDataFim: function getDataFim() {
      if (!this.mesAnoPesquisa || !this.mesAnoPesquisa.length) return null;
      return this.moment(this.mesAnoPesquisa, 'YYYY-MM').endOf('month').format('YYYY-MM-DD');
    },
    ehEvento: function ehEvento(date) {
      return !!this.datas[date];
    },
    corDoEvento: function corDoEvento(date) {
      return this.datas[date][0].cor;
    },
    alterarMes: function alterarMes(mes) {
      this.mesAnoPesquisa = mes;
      this.carregarMes();
    },
    limparSelecao: function limparSelecao(data) {
      if (data === this.dataAnterior) {
        this.date = null;
      }
    }
  },
  mounted: function mounted() {
    this.mesAnoPesquisa = this.moment().format('YYYY-MM');
    this.carregarMes();
  }
};

/***/ }),
/* 272 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TermoAceiteLogin_vue_vue_type_script_lang_js___ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TermoAceiteLogin_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TermoAceiteLogin_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TermoAceiteLogin_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TermoAceiteLogin_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TermoAceiteLogin_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'TermoAceiteLogin',
  components: {},
  props: {
    termos: Array,
    title: String
  },
  data: function data() {
    return {
      termoAceiteResources: this.$api.termoAceite(this.$resource),

      termo: {},
      continuar: true,
      index: 0,
      termoAceito: false,
      timeout: true,
      sombraToolbar: false
    };
  },

  computed: {},
  methods: {
    logout: function logout() {
      var auth = this.$auth || window.auth;
      auth.logout();
    },
    proximo: function proximo() {
      if (this.continuar) {
        this.index = this.index + 1;
        this.termo = this.termos[this.index];
        if (this.index >= this.termos.length - 1) {
          this.continuar = false;
        }
        this.termoAceito = false;
        this.timeoutAceito();
      } else {
        this.finalizar();
      }
    },
    timeoutAceito: function timeoutAceito() {
      var _this = this;

      this.timeout = true;
      window.setTimeout(function () {
        _this.timeout = false;
      }, 5000);
    },
    onScroll: function onScroll(i) {
      if (i.currentTarget.scrollY) {
        this.sombraToolbar = true;
      } else {
        this.sombraToolbar = false;
      }
    },
    finalizar: function finalizar() {
      var _this2 = this;

      this.termoAceiteResources.aceitarTermos(this.termos).then(function () {
        _this2.$emit('ACEITO');
      }).catch(function (err) {
        _this2.$toast.create(err.data.error, 'snack', 3E3);
      });
    }
  },
  mounted: function mounted() {
    if (this.termos.length) {
      this.termo = this.termos[this.index];
      if (this.termos.length < 2) {
        this.continuar = false;
      }
      this.timeoutAceito();
    }
  }
};

/***/ }),
/* 275 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_NotFound_vue_vue_type_script_lang_js___ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_NotFound_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_NotFound_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_NotFound_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_NotFound_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_NotFound_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  mounted: function mounted() {
    var _this = this;

    window.setTimeout(function () {
      _this.$router.push({ name: 'dashboard' });
    }, 3000);
  }
};

/***/ }),
/* 278 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Administracao_vue_vue_type_script_lang_js___ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Administracao_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Administracao_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Administracao_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Administracao_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Administracao_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(6);

var _AgendamentoTarefa = __webpack_require__(970);

var _AgendamentoTarefa2 = _interopRequireDefault(_AgendamentoTarefa);

var _RateioAcordo = __webpack_require__(975);

var _RateioAcordo2 = _interopRequireDefault(_RateioAcordo);

var _CacheManager = __webpack_require__(993);

var _CacheManager2 = _interopRequireDefault(_CacheManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Administracao',
  data: function data() {
    return {
      tabSelecionada: null
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('roles', ['getAllRoles']), {
    canAccessPage: function canAccessPage() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el === 'ADMINISTRACAO_PAGINA';
      }).length;
    }
  }),
  components: {
    AgendamentoTarefa: _AgendamentoTarefa2.default,
    RateioAcordo: _RateioAcordo2.default,
    CacheManager: _CacheManager2.default
  },
  methods: {
    accessForbidden: function accessForbidden() {
      if (!this.canAccessPage) {
        this.$router.push({ name: 'inicio' });
        this.$toast.create('Acesso negado', 'snack', 3E3);
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (!this.canAccessPage) {
      window.setTimeout(function () {
        return _this.accessForbidden();
      }, 1E3);
    }
  }
};

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AgendamentoTarefa_vue_vue_type_script_lang_js___ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AgendamentoTarefa_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AgendamentoTarefa_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AgendamentoTarefa_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AgendamentoTarefa_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AgendamentoTarefa_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Confirm = __webpack_require__(12);

var _Confirm2 = _interopRequireDefault(_Confirm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'AgendamentoTarefa',
  components: {
    Confirm: _Confirm2.default
  },
  data: function data() {
    var _this = this;

    return {
      agendamentoResources: this.$api.agendamento(this.$resource),
      agendamentos: [],
      agendamento: {},
      dataProximaExecucao: '',
      agendamentoAberto: {},
      dialogForm: false,
      dialogReagendar: false,
      dialogLog: false,
      headers: [{ text: this.$tc('label.nome', 1), value: 'nome', sortable: false }, { text: this.$tc('label.periodo', 1), value: 'periodo', sortable: false }, { text: this.$tc('label.data_proxima_execucao', 1), value: 'dta_proxima_execucao', sortable: false }, { text: this.$tc('label.tempo', 1), value: 'coeficiente_tempo', sortable: false }, { text: this.$tc('label.unica_execucao', 1), value: 'ind_unica_execucao', sortable: false }, { text: this.$tc('label.ativo', 1), value: 'ind_ativo', sortable: false }, { text: this.$tc('label.opcao', 2), value: 'opcoes', sortable: false }],
      headersLog: [{ text: this.$tc('label.data', 1), value: 'dta_criacao' }, { text: this.$tc('label.status', 1), value: 'ind_status' }, { text: this.$tc('title.erro', 1), value: 'erro' }],
      logs: [],
      periodos: ['MINUTO', 'HORAL', 'DIARIO'],
      rules: {
        required: function required(value) {
          return !!value || _this.$t('message.campo_obrigatorio');
        },
        validDate: function validDate(value) {
          return !value || value.length === 10 && _this.moment(value, 'DD-MM-YYYY').isValid() || _this.$t('message.data_invalida');
        }
      }

    };
  },

  methods: {
    requestAgendamentos: function requestAgendamentos() {
      var _this2 = this;

      this.agendamentoResources.listar().then(function (response) {
        _this2.agendamentos = response.data;
      }).catch(function (err) {
        _this2.$error(_this2, err);
      });
    },
    edit: function edit(item) {
      this.agendamento = item;
      this.dialogForm = true;
    },
    reagendar: function reagendar(item) {
      this.agendamento = item;
      this.dataProximaExecucao = item.dta_proxima_execucao;
      this.dialogReagendar = true;
    },
    fechar: function fechar() {
      this.dialogForm = false;
      this.dialogReagendar = false;
      this.dialogLog = false;
    },
    abrirDialogSalvar: function abrirDialogSalvar() {
      if (!this.$refs.form.validate()) return;
      this.$refs.confirmDialog.open();
    },
    abrirDialogSalvarReagendar: function abrirDialogSalvarReagendar() {
      if (!this.$refs.formReagendar.validate()) return;
      this.$refs.confirmDialogReagendar.open();
    },
    salvar: function salvar() {
      var _this3 = this;

      this.agendamentoResources.atualizar(this.agendamento).then(function () {
        _this3.$toast.create(_this3.$t('message.atualizado_confira_tabela'), 'snack', '3E3');
        _this3.requestAgendamentos();
        _this3.fechar();
      }, function (err) {
        _this3.$error(_this3, err);
      });
    },
    salvarReagendar: function salvarReagendar() {
      var _this4 = this;

      this.agendamento.dta_proxima_execucao = this.dataProximaExecucao;
      this.agendamentoResources.reagendar(this.agendamento).then(function () {
        _this4.$toast.create(_this4.$t('message.atualizado_confira_tabela'), 'snack', '3E3');
        _this4.requestAgendamentos();
        _this4.fechar();
      }, function (err) {
        _this4.$error(_this4, err);
      });
    },
    requestLogs: function requestLogs(item) {
      var _this5 = this;

      this.agendamentoAberto = item;
      this.agendamentoResources.listarLogs({ id: item.id }).then(function (response) {
        _this5.logs = response.data;
        _this5.dialogLog = true;
      }).catch(function (err) {
        _this5.$error(_this5, err);
      });
    }
  },
  mounted: function mounted() {
    this.requestAgendamentos();
  }
};

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Confirm_vue_vue_type_script_lang_js___ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Confirm_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Confirm_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Confirm_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Confirm_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Confirm_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'Confirm',
  props: {
    title: String,
    message: String,
    persistent: false,
    agreeLabel: String,
    disagreeLabel: String,
    hideDisagree: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      titleDialog: '',
      messageDialog: '',

      dialog: false,
      callback: null
    };
  },

  methods: {
    open: function open() {
      this.titleDialog = this.title;
      if (!this.title || !this.title.length) {
        this.titleDialog = this.$t('title.atencao');
      }
      this.dialog = true;
    },
    openWithParams: function openWithParams(title, message, callback) {
      this.titleDialog = title;
      this.messageDialog = message;
      this.callback = callback;
      this.dialog = true;
    },
    disagree: function disagree() {
      this.close();
      this.$emit('disagree');
      if (this.callback) {
        this.callback(false);
      }
    },
    agree: function agree() {
      this.close();
      this.$emit('agree');
      if (this.callback) {
        this.callback(true);
      }
    },
    close: function close() {
      this.dialog = false;
    }
  }
};

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_RateioAcordo_vue_vue_type_script_lang_js___ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_RateioAcordo_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_RateioAcordo_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_RateioAcordo_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_RateioAcordo_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_RateioAcordo_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(710);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _InputDatepicker = __webpack_require__(56);

var _InputDatepicker2 = _interopRequireDefault(_InputDatepicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'RateioAcordo',
  data: function data() {
    return {
      acordoResources: this.$api.acordo(this.$resource),
      dataInicial: '',
      dataFinal: ''
    };
  },

  components: {
    InputDatepicker: _InputDatepicker2.default
  },
  methods: {
    dataInicialFormatadaStatusNegociacoes: function dataInicialFormatadaStatusNegociacoes(dataInicial) {
      this.dataInicial = dataInicial;
    },
    dataFinalFormatadaStatusNegociacoes: function dataFinalFormatadaStatusNegociacoes(dataFinal) {
      this.dataFinal = dataFinal;
    },
    converterData: function converterData(data) {
      if (!data) {
        return null;
      }

      var _data$split = data.split('-'),
          _data$split2 = (0, _slicedToArray3.default)(_data$split, 3),
          year = _data$split2[0],
          month = _data$split2[1],
          day = _data$split2[2];

      return year + '-' + month.padStart(2, '0') + '-' + day.padStart(2, '0');
    },
    datasValidas: function datasValidas() {
      var dataInicial = (0, _moment2.default)(this.dataInicial);
      var dataFinal = (0, _moment2.default)(this.dataFinal);

      if (this.dataInicial && !this.dataFinal || this.dataFinal && !this.dataInicial) {
        this.$toast.create(this.$t('message.data_final_e_inicial'), 'snack', 3E3);
        return false;
      }

      if (dataFinal.isBefore(dataInicial)) {
        this.$toast.create(this.$t('message.data_inicial_maior_final'), 'snack', 3E3);
        return false;
      }

      return true;
    },
    formatarData: function formatarData(data) {
      if (!data) {
        return null;
      }

      var _data$split3 = data.split('-'),
          _data$split4 = (0, _slicedToArray3.default)(_data$split3, 3),
          year = _data$split4[0],
          month = _data$split4[1],
          day = _data$split4[2];

      return day + '-' + month + '-' + year;
    },
    aplicar: function aplicar() {
      var _this = this;

      if (this.datasValidas()) {
        var filtros = { dataInicio: (0, _moment2.default)(this.dataInicial, 'DD-MM-YYYY').format('YYYY-MM-DD'),
          dataFim: (0, _moment2.default)(this.dataFinal, 'DD-MM-YYYY').format('YYYY-MM-DD') };
        this.acordoResources.ratear(filtros).then(function () {
          _this.$toast.create(_this.$t('message.atualizado_confira_tabela'), 'snack', 3E3);
        }).catch(function (err) {
          _this.$error(_this, err);
        });
      }
    }
  }
};

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_InputDatepicker_vue_vue_type_script_lang_js___ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_InputDatepicker_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_InputDatepicker_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_InputDatepicker_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_InputDatepicker_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_InputDatepicker_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Datepicker = __webpack_require__(986);

var _Datepicker2 = _interopRequireDefault(_Datepicker);

var _getInViewPosition = __webpack_require__(992);

var _getInViewPosition2 = _interopRequireDefault(_getInViewPosition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    classDesign: { type: String, default: '' },
    dataVvRules: [String, Function, Object],
    disablePassedDays: { type: Boolean, default: false },
    disablePassedMonths: { type: Boolean, default: false },
    disablePreviousDays: { type: String, default: null },
    disabledDays: { type: Array, default: function _default() {
        return [];
      }
    },
    doubled: { type: Boolean, default: false },
    format: { type: String, default: 'DD/MM/YYYY' },
    id: { type: String, default: 'vue-datepicker' },
    label: String,
    lang: { type: String, default: 'pt-br' },
    name: { type: String, default: 'datepicker' },
    orientation: { type: String, default: 'portrait' },
    timepicker: { type: Boolean, default: false },
    value: { type: String, default: '' },
    vValidate: Boolean,
    required: { type: Boolean, default: false },
    dateIsClicked: { type: Boolean, default: false },
    tabindex: { type: Number, default: 1 },
    disabled: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      date: '',
      isVisible: false,
      parentName: '' || this.name,
      dateValue: '',
      eventListener: false
    };
  },

  computed: {
    localModel: function localModel() {
      return this.dateValue ? this.dateValue : this.formattedDate;
    },
    formattedDate: function formattedDate() {
      return this.date ? this.date.format(this.format) : '';
    }
  },
  components: {
    Datepicker: _Datepicker2.default
  },
  watch: {
    formattedDate: function formattedDate() {
      if (this.formattedDate) {
        this.$emit('INPUTDATEPICKER_FORMATTED_DATE', this.formattedDate);
      }
    },
    date: function date() {
      if (this.date) {
        this.$emit('INPUTDATEPICKER_DATE', this.date);
      }
    },
    value: function value() {
      this.dateValue = this.value;
    }
  },
  methods: {
    selectDate: function selectDate(obj) {
      this.date = obj;
      this.dateValue = this.formattedDate;
      if (obj.dateIsClicked || this.dateIsClicked) {
        this.hideDatePicker();
      }
      this.validate();
    },
    getPosition: function getPosition(vertical, horizontal) {
      var menuTriggerRect = this.datepickerTrigger.getBoundingClientRect();

      var top = vertical === 'top' ? menuTriggerRect.top + (menuTriggerRect.height - this.menuContent.offsetHeight) : menuTriggerRect.top;
      var left = horizontal === 'left' ? menuTriggerRect.left - (this.menuContent.offsetWidth + menuTriggerRect.width) : menuTriggerRect.left;
      return { top: top, left: left };
    },
    calculateMenuContentPos: function calculateMenuContentPos() {
      this.isVisible = true;
      var position = void 0;
      position = this.getPosition('bottom', 'right');
      position = (0, _getInViewPosition2.default)(this.$refs.datepicker.$el, position);
      this.$refs.datepicker.$el.style.top = position.top + (window.pageYOffset + 28) + 'px';
      this.$refs.datepicker.$el.style.left = position.left + window.pageXOffset + 'px';
      this.$refs.datepicker.$el.style.zIndex = 10;
      this.$refs.datepicker.$el.style.position = 'absolute';
    },
    showDatepickerEvent: function showDatepickerEvent() {
      if (!this.isVisible) {
        this.showDatepicker();
      }
    },
    showDatepicker: function showDatepicker() {
      var _this = this;

      this.isVisible = true;
      setTimeout(function () {
        document.body.appendChild(_this.$refs.datepicker.$el);
        _this.calculateMenuContentPos();
        _this.addEventListenerHide();
      }, 1E2);
    },
    addEventListenerHide: function addEventListenerHide() {
      var _this2 = this;

      setTimeout(function () {
        if (!_this2.eventListener) {
          document.addEventListener('click', _this2.hideDatePicker);
          _this2.eventListener = true;
        }
      }, 1E2);
    },
    hideDatePicker: function hideDatePicker() {
      this.isVisible = false;
      document.body.removeChild(this.$refs.datepicker.$el);
      document.removeEventListener('click', this.hideDatePicker);
      this.eventListener = false;
    },
    cancelDateSelection: function cancelDateSelection() {
      this.hideDatePicker();
    },
    validate: function validate() {
      var _this3 = this;

      setTimeout(function () {
        _this3.$validator.validateAll();
      }, 1000);
    },
    doValidateAll: function doValidateAll() {
      return this.$validator.validateAll();
    }
  },
  mounted: function mounted() {
    this.datepickerTrigger = this.$el.querySelector('#datepicker-trigger');
    this.errors.clear();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isVisible) {
      this.hideDatePicker();
    }
  }
};

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Datepicker_vue_vue_type_script_lang_js___ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Datepicker_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Datepicker_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Datepicker_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Datepicker_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Datepicker_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _month = __webpack_require__(989);

var monthClasses = _interopRequireWildcard(_month);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    initialDate: {
      type: Object,
      default: function _default() {
        _moment2.default.locale(this.lang || 'pt-br');
        return (0, _moment2.default)();
      }
    },
    disablePassedDays: { type: Boolean, default: false },
    disablePreviousDays: { type: String, default: null },
    disablePassedMonths: { type: Boolean, default: false },
    disabledDays: { type: Array, default: function _default() {
        return [];
      }
    },
    format: { type: String, default: 'DD/MM/YYYY' },
    doubled: { type: Boolean, default: false },
    lang: { type: String, default: 'pt-br' },
    orientation: { type: String, default: 'portrait' },
    show: { type: Boolean, required: true },
    showActions: { type: Boolean, required: false, default: false },
    isDatepicker: { type: Boolean, required: false, default: false },
    noheader: { type: Boolean, default: false }
  },
  data: function data() {
    return {
      date: '',
      weekDays: monthClasses.getWeekDays(this.lang),
      months: [],
      classDirection: 'off',
      dayDirection: 'off',
      yearsVisible: false,
      years: null
    };
  },

  computed: {
    year: function year() {
      return this.date.format('YYYY');
    },
    dateFormatted: function dateFormatted() {
      if (this.orientation === 'landscape') {
        return this.lang === 'en' || this.lang === 'en-us' ? this.date.format('dddd') + ',<br>' + this.date.format('MMM DD') : this.date.format('ddd DD') + ',<br>' + this.date.format('MMMM');
      }
      if (this.doubled) {
        return this.lang === 'en' || this.lang === 'en-us' ? this.date.format('dddd') + ', ' + this.date.format('MMMM DD') : this.date.format('dddd DD MMMM');
      }

      return this.lang === 'en' || this.lang === 'en-us' ? this.date.format('dddd') + ', ' + this.date.format('MMM DD') : this.date.format('dddd DD MMM');
    },
    classOrientation: function classOrientation() {
      return this.orientation;
    },
    isDoubled: function isDoubled() {
      if (this.doubled) return 'double';
      return '';
    },
    language: function language() {
      var tmp = ['ok', 'cancel'];

      if (this.lang === 'da') {
        tmp[1] = 'afbestille';
      }
      if (this.lang === 'nl') {
        tmp[1] = 'annuleren';
      }
      if (this.lang === 'de') {
        tmp[1] = 'abbrechen';
      }
      if (this.lang === 'es' || this.lang === 'es-do') {
        tmp[1] = 'cancelar';
      }
      if (this.lang === 'fi') {
        tmp[1] = 'peruuttaa';
      }
      if (this.lang === 'fr' || this.lang === 'fr-ca' || this.lang === 'fr-ch') {
        tmp[1] = 'annuler';
      }
      if (this.lang === 'hu') {
        tmp[1] = 'megszünteti';
      }
      if (this.lang === 'it') {
        tmp[1] = 'annullare';
      }
      if (this.lang === 'lb') {
        tmp[1] = 'annuléieren';
      }
      if (this.lang === 'nb') {
        tmp[1] = 'avbryte';
      }
      if (this.lang === 'pl') {
        tmp[1] = 'anulować';
      }
      if (this.lang === 'pt' || this.lang === 'pt-br') {
        tmp[1] = 'cancelar';
      }
      if (this.lang === 'ro') {
        tmp[1] = 'anula';
      }
      if (this.lang === 'ru') {
        tmp[1] = 'отменить';
      }
      if (this.lang === 'sk') {
        tmp[1] = 'zrušiť';
      }
      if (this.lang === 'sl') {
        tmp[1] = 'preklic';
      }
      if (this.lang === 'sv') {
        tmp[1] = 'avboka';
      }
      if (this.lang === 'uk') {
        tmp[1] = 'preklic';
      }

      return tmp;
    }
  },
  watch: {
    show: function show(val) {
      if (val === false) {
        this.classDirection = 'off';
        this.dayDirection = 'off';
        return;
      }
      var newDate = (0, _moment2.default)([this.date.year(), this.date.month(), this.date.date()]);
      this.date = newDate.clone();
    },
    yearsVisible: function yearsVisible() {
      var scrollOffset = (this.date.year() - this.years[0].year()) * 40 - 130;
    }
  },
  methods: {
    classYear: function classYear(year) {
      if (year.year() === this.date.year()) {
        return 'selected';
      }
      return '';
    },
    isDisabled: function isDisabled(day) {
      if (this.disabledDays.length > 0) {
        for (var i = 0; i < this.disabledDays.length; i += 1) {
          var currDisabledDay = (0, _moment2.default)(this.disabledDays[i], 'YYYY-MM-D'),
              startDay = currDisabledDay.startOf('day').unix();
          if (startDay === day.startOf('day').unix()) {
            return true;
          }
        }
      }

      if (this.disablePreviousDays) {
        return day < (0, _moment2.default)(this.disablePreviousDays, this.format).startOf('day');
      }

      if (this.disablePassedDays) {
        return day < (0, _moment2.default)().startOf('day');
      }

      if (this.disablePassedMonths) {
        return day < (0, _moment2.default)().startOf('month');
      }
      return false;
    },
    isSelected: function isSelected(day) {
      return this.date.unix() === day.unix();
    },
    selectDate: function selectDate(newDate) {
      if (!this.isDisabled(newDate)) {
        this.classDirection = 'off';
        this.setClassDirection(newDate);
        this.date = newDate.clone();
        this.$emit('clicked-day', newDate);
      }
    },
    selectYear: function selectYear(date) {
      this.setClassDirection(date);

      var newDate = (0, _moment2.default)([date.year(), this.date.month(), this.date.date()]);
      this.date = newDate.clone();

      this.setMonths();

      var scrollOffset = (this.date.year() - this.years[0].year()) * 40 - 130;
      this.showOrHideYears();

      this.$emit('change', this.date);
    },
    setClassDirection: function setClassDirection(date) {
      this.dayDirection = 'direction-next';
      if (date.isBefore(this.date)) this.dayDirection = 'direction-prev';
    },
    setMonths: function setMonths() {
      var newMonths = [],
          firstMonth = new monthClasses.default(this.date.month(), this.date.year());
      newMonths.push(firstMonth);

      if (this.doubled) {
        var mon = this.date.month() + 1;
        var year = this.date.year();

        if (mon > 11) {
          mon = 0;
          year += 1;
        }

        var secondMonth = new monthClasses.default(mon, year);
        newMonths.push(secondMonth);
      }

      this.months = newMonths;
    },
    nextMonth: function nextMonth() {
      var tmpMonths = [],
          monthsLength = this.months.length - 1;

      for (var i = 0; i < monthsLength; i += 1) {
        tmpMonths.push(new monthClasses.default(this.months[i + 1].month, this.months[i + 1].year));
      }

      var mon = this.months[monthsLength].month + 1;
      var year = this.months[monthsLength].year;

      if (mon > 11) {
        mon = 0;
        year += 1;
      }

      var tmpMonth = new monthClasses.default(mon, year);
      tmpMonths.push(tmpMonth);

      this.classDirection = 'direction-next';
      this.months = tmpMonths;
    },
    prevMonth: function prevMonth() {
      var tmpMonths = [],
          monthsLength = this.months.length - 1;

      for (var i = monthsLength; i > 0; i -= 1) {
        tmpMonths.push(new monthClasses.default(this.months[i - 1].month, this.months[i - 1].year));
      }

      var mon = this.months[0].month - 1;
      var year = this.months[0].year;

      if (mon < 0) {
        mon = 11;
        year -= 1;
      }

      var tmpMonth = new monthClasses.default(mon, year);
      tmpMonths.unshift(tmpMonth);

      this.classDirection = 'direction-prev';
      this.months = tmpMonths;
    },
    submitDay: function submitDay() {
      this.classDirection = 'off';
      this.dayDirection = 'off';
      this.yearsVisible = false;
      this.$emit('change', this.date);
      this.$emit('hide');
    },
    cancel: function cancel() {
      this.classDirection = 'off';
      this.dayDirection = 'off';
      this.$emit('cancel');
    },
    showOrHideYears: function showOrHideYears() {
      this.yearsVisible = !this.yearsVisible;
    }
  },
  created: function created() {
    _moment2.default.locale(this.lang);
    this.date = this.initialDate.clone();
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.setMonths();
      _this.years = _this.months[0].getYears();
    });
  }
};

/***/ }),
/* 291 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CacheManager_vue_vue_type_script_lang_js___ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CacheManager_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CacheManager_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CacheManager_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CacheManager_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CacheManager_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Confirm = __webpack_require__(12);

var _Confirm2 = _interopRequireDefault(_Confirm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Confirm: _Confirm2.default
  },
  data: function data() {
    return {
      resource: this.$api.cacheManager(this.$resource)
    };
  },

  methods: {
    checkAndDrop: function checkAndDrop() {
      this.$refs.dialog.open();
    },
    dropCache: function dropCache() {
      this.resource.dropCache();
    }
  }
};

/***/ }),
/* 294 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AjusteVerbaForm_vue_vue_type_script_lang_js___ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AjusteVerbaForm_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AjusteVerbaForm_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AjusteVerbaForm_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AjusteVerbaForm_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AjusteVerbaForm_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(706);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(707);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(6);

var _CRUDGenerico = __webpack_require__(23);

var _CRUDGenerico2 = _interopRequireDefault(_CRUDGenerico);

var _RegisterForm = __webpack_require__(36);

var _RegisterForm2 = _interopRequireDefault(_RegisterForm);

var _mdAutocomplete = __webpack_require__(16);

var _mdAutocomplete2 = _interopRequireDefault(_mdAutocomplete);

var _InputMoneyOld = __webpack_require__(79);

var _InputMoneyOld2 = _interopRequireDefault(_InputMoneyOld);

var _helpers = __webpack_require__(5);

var _ModalVoltar = __webpack_require__(119);

var _ModalVoltar2 = _interopRequireDefault(_ModalVoltar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'AjusteVerbaForm',
  extends: _CRUDGenerico2.default,
  props: {
    somenteLeitura: Boolean,
    novo: Boolean,
    fluxo: Boolean
  },
  data: function data() {
    return {
      fetchOrcamentoFunction: this.$api.orcamento(this.$resource).listarAprovados,
      fetchLinhaFunction: this.$api.linhasInvestimento(this.$resource).buscarPorOrcamento,
      desdobramentoResource: this.$api.desdobramento(this.$resource),
      workflowAjusteVerbaResources: this.$api.workflowAjusteVerba(this.$resource),
      ajusteVerbaResource: this.$api.ajusteVerba(this.$resource),
      orcamentoResources: this.$api.orcamento(this.$resource),
      tipo: 'ADENDO',
      justificativaReprovacao: '',
      ajuste: {
        tipo: 'ADENDO',
        idOrcamento: null,
        descricaoOrcamento: '',
        idLinhaInvestimento: null,
        descricaoLinha: '',
        idDesdobramento: null,
        competencia: '',
        idRepresentante: null,
        representante: '',
        valor: 0,
        vlrPlanejado: 0,
        vlrDisponivel: 0,
        justificativa: ''
      },
      justificarAjuste: {
        observacao: '',
        obrigatorio: false
      },
      fluxoAjuste: {},
      podeAprovar: false,
      podeReprovar: false,
      disableButton: false,
      disableLinha: true,
      disableDesdobramento: true,
      disableRepresentante: true,
      dialog: {
        ref: 'dialog1',
        from: 'saveRegisterFromButton',
        title: this.$t('label.atencao'),
        content: '',
        action: function action() {}
      }
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('roles', ['getAllRoles']), {
    canAccessPage: function canAccessPage() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el === 'ORC_AJUSTE' || el === 'DASH_OPER_ORC';
      }).length;
    },
    canPost: function canPost() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el === 'ORC_AJUSTE';
      }).length;
    },
    canSearch: function canSearch() {
      return this.canAccessPage;
    }
  }),
  methods: {
    requestPermiteAprovar: function requestPermiteAprovar() {
      var _this = this;

      this.podeAprovar = false;
      this.podeReprovar = false;
      if (this.fluxo && this.fluxoAjuste.statusFluxo === 'AGUARDANDO_APROVACAO') {
        var idAjuste = this.$route.params.id;
        this.workflowAjusteVerbaResources.aprovador({ idAjuste: idAjuste }).then(function (response) {
          if (response.data.usuarioHabilitado) {
            _this.podeAprovar = true;
            _this.podeReprovar = true;
          }
        }).catch(function (err) {
          _this.$error(_this, err);
        });
      }
    },
    openDialogJustificativaReprovar: function openDialogJustificativaReprovar() {
      this.justificarAjuste.observacao = '';
      this.justificarAjuste.obrigatorio = true;
      this.justificarAjuste.action = this.requestReprovar;

      this.openDialog('justificarDialog');
    },
    openDialogReprovar: function openDialogReprovar(ref, from) {
      var content = this.$t('message.deseja_reprovar_ajuste_verba');
      this.setDialogContent(content, this.openDialogJustificativaReprovar, from || this.dialog.from);
      this.openDialog(ref || this.dialog.ref);
    },
    openDialogAprovar: function openDialogAprovar(ref, from) {
      if (!this.validarValor()) {
        return;
      }
      var content = this.$t('message.deseja_aprovar_ajuste_verba');
      this.setDialogContent(content, this.requestAprovar, from || this.dialog.from);
      this.openDialog(ref || this.dialog.ref);
    },
    requestAprovar: function requestAprovar() {
      var _this2 = this;

      var idAjuste = this.ajuste.id;
      this.workflowAjusteVerbaResources.aprovar({ idAjuste: idAjuste }, {}).then(function () {
        _this2.voltar();
        _this2.$toast.create(_this2.$t('message.ajuste_verba_aprovado'), 'snack', 3E3);
      }).catch(function (err) {
        _this2.$error(_this2, err);
      });
    },
    requestReprovar: function requestReprovar() {
      var _this3 = this;

      var payload = {};
      payload.observacao = this.justificarAjuste.observacao;
      var idAjuste = this.ajuste.id;
      this.workflowAjusteVerbaResources.reprovar({ idAjuste: idAjuste }, payload).then(function () {
        _this3.voltar();
        _this3.$toast.create(_this3.$t('message.ajuste_verba_reprovado'), 'snack', 3E3);
      }).catch(function (err) {
        _this3.$error(_this3, err);
      });
    },
    setOrcamento: function setOrcamento(hit) {
      if (!hit.id) {
        this.limparOrcamento();
        return;
      }
      this.disableLinha = false;
      this.ajuste.idOrcamento = hit.id;
      this.ajuste.descricaoOrcamento = hit.descricao;
      this.ajuste.descricaoLinha = '';
      this.limparLinha();
    },
    setLinha: function setLinha(hit) {
      if (!hit.id) {
        this.limparLinha();
        return;
      }
      this.disableDesdobramento = false;
      this.ajuste.idLinhaInvestimento = hit.id;
      this.ajuste.descricaoLinha = hit.descricao ? hit.descricao.trim() : '';
      this.ajuste.competencia = '';
      this.limparDesdobramento();
    },
    setDesdobramento: function setDesdobramento(hit) {
      if (!hit.id) {
        this.limparDesdobramento();
        return;
      }
      this.disableRepresentante = false;
      this.ajuste.idDesdobramento = hit.id;
      this.ajuste.competencia = hit.anoMes;
      this.ajuste.representante = '';
      this.limparRepresentante();
    },
    setRepresentante: function setRepresentante(hit) {
      if (!hit.idRepresentante) {
        this.limparRepresentante();
        return;
      }
      this.ajuste.idRepresentante = hit.idRepresentante;
      this.ajuste.idControladorDestino = hit.idControladorTrade;
      this.ajuste.representante = hit.nome;
      this.buscarValoresRepresentante();
    },
    buscarLinha: function buscarLinha(row) {
      row.codigo = this.ajuste.idOrcamento;
      return this.fetchLinhaFunction(row);
    },
    buscarDesdobramento: function buscarDesdobramento(row) {
      return this.desdobramentoResource.buscarVigentesPorLinhaInvestimento({ codigo: this.ajuste.idLinhaInvestimento, anoMes: row.anoMes });
    },
    buscarRepresentante: function buscarRepresentante(row) {
      row.codigo = this.ajuste.idDesdobramento;
      row.indAtivo = true;

      return this.desdobramentoResource.buscarRepresentantes(row);
    },
    buscarValores: function buscarValores() {
      var _this4 = this;

      return this.desdobramentoResource.buscarPlanejadoDisponivel({ codigo: this.ajuste.idDesdobramento }).then(this.preencherValores).catch(function (err) {
        _this4.$error(_this4, err);
      });
    },
    buscarValoresRepresentante: function buscarValoresRepresentante() {
      var _this5 = this;

      return this.desdobramentoResource.buscarPlanejadoDisponivelRepresentante({ codigo: this.ajuste.idDesdobramento, idRepresentante: this.ajuste.idRepresentante }).then(this.preencherValores).catch(function (err) {
        _this5.$error(_this5, err);
      });
    },
    preencherValores: function preencherValores(response) {
      this.ajuste.vlrPlanejado = response.data.vlrPlanejado;
      this.ajuste.vlrDisponivel = response.data.vlrDisponivel;
    },
    limparOrcamento: function limparOrcamento() {
      this.ajuste.idOrcamento = null;
      this.ajuste.descricaoLinha = '';
      this.disableLinha = true;
      this.limparLinha();
    },
    limparLinha: function limparLinha() {
      this.ajuste.idLinhaInvestimento = null;
      this.ajuste.competencia = '';
      this.disableDesdobramento = true;
      this.limparDesdobramento();
    },
    limparDesdobramento: function limparDesdobramento() {
      this.disableRepresentante = true;
      this.ajuste.idDesdobramento = null;
      this.ajuste.representante = '';
      this.ajuste.vlrPlanejado = 0;
      this.ajuste.vlrDisponivel = 0;
      this.ajuste.idRepresentante = null;
    },
    limparRepresentante: function limparRepresentante() {
      this.ajuste.idRepresentante = null;
      this.ajuste.idControladorDestino = null;
      if (this.ajuste.idDesdobramento) this.buscarValores();
    },
    validarValor: function validarValor() {
      if (this.ajuste.valor <= 0) {
        this.$toast.create(this.$t('errors.valor.maior_zero'), 'snack', 3E3);
        return false;
      }
      if (this.ajuste.tipo === 'REDUCAO' && this.ajuste.valor > this.ajuste.vlrDisponivel) {
        this.$toast.create(this.$t('errors.valor.disponivel.excedido'), 'snack', 3E3);
        return false;
      }
      return true;
    },
    openCancelDialog: function openCancelDialog() {
      this.$refs.voltarDialog.open();
    },
    cancel: function cancel() {
      this.voltar();
    },
    openSaveDialog: function openSaveDialog(ref, from) {
      var _this6 = this;

      if (!this.canPost) {
        return;
      }
      this.$validator.validateAll().then(function (isValid) {
        if (!_this6.validarValor() || !isValid) {
          return;
        }
        _this6.setDialogContent(_this6.$t('message.salvar_novo_ajuste_verba'), _this6.save, from || _this6.dialog.from);
        _this6.openDialog(ref || _this6.dialog.ref);
      });
    },
    openSaveDialogVoltar: function openSaveDialogVoltar() {
      var _this7 = this;

      if (!this.canPost) {
        return;
      }
      this.$validator.validateAll().then(function (isValid) {
        if (!_this7.validarValor() || !isValid) {
          return;
        }
        _this7.save();
      });
    },
    save: function save() {
      var _this8 = this;

      if (!this.canPost) {
        return;
      }
      var objeto = (0, _helpers.copyObject)(this.ajuste);
      objeto.valor = this.ajuste.valor;
      this.ajusteVerbaResource.gravar(objeto).then(this.tratarSalvoSucesso).catch(function (err) {
        if (err.status !== 500) {
          _this8.$error(_this8.$t('message.ajuste_verba_erro_azion'));
        }
        _this8.$error(_this8, err);
      });
    },
    tratarSalvoSucesso: function tratarSalvoSucesso(response) {
      this.$router.push({ name: 'orcamento' });

      if (response.data.status === 'APROVADO') {
        this.$toast.create(this.$t('message.ajuste_verba_finalizado'), 'snack', 3E3);
      } else {
        this.$toast.create(this.$t('message.ajuste_verba_enviado_aprovacao'), 'snack', 3E3);
      }
    },
    voltar: function voltar() {
      if (this.fluxo) {
        this.$router.push({ name: 'dashboard' });
      } else {
        this.$router.push({ name: 'orcamento' });
      }
    },
    closeDialog: function closeDialog(ref, cb) {
      this.$refs[ref].close();
      if (cb) {
        cb();
      }
    },
    setDialogContent: function setDialogContent(content, action, from) {
      this.dialog.content = content || this.$t('message.salvar_novo_registro');
      this.dialog.action = action || this.save;
      this.dialog.from = from || this.dialog.from;
    },
    carregarAjuste: function carregarAjuste(orcamento) {
      var _this9 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var res;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(orcamento.length === 1)) {
                  _context.next = 5;
                  break;
                }

                _this9.ajuste = orcamento[0] || {};
                _this9.disableDesdobramento = false;
                _context.next = 18;
                break;

              case 5:
                if (!(orcamento.length > 1 && typeof orcamento !== 'number')) {
                  _context.next = 12;
                  break;
                }

                _this9.disableDesdobramento = false;
                _this9.ajuste.descricaoOrcamento = orcamento[0].descricaoOrcamento;
                _this9.ajuste.idOrcamento = orcamento[0].idOrcamento;
                _this9.carregarLinha(orcamento);
                _context.next = 18;
                break;

              case 12:
                if (!(typeof orcamento === 'number')) {
                  _context.next = 18;
                  break;
                }

                _context.next = 15;
                return _this9.ajusteVerbaResource.obter({ id: orcamento });

              case 15:
                res = _context.sent;

                _this9.ajuste = res.body;
                _this9.carregarLinha([_this9.ajuste]);

              case 18:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this9);
      }))();
    },
    carregarLinha: function carregarLinha(ajuste) {
      var element = ajuste[0].idLinhaInvestimento;
      if (ajuste.filter(function (el) {
        return el.idLinhaInvestimento !== element;
      }).length) {
        this.disableLinha = false;
        this.ajuste.descricaoLinha = '';
        this.limparLinha();
      } else {
        this.ajuste.idLinhaInvestimento = ajuste[0].idLinhaInvestimento;
        this.ajuste.descricaoLinha = ajuste[0].descricaoLinha;
      }
    },
    carregarFluxo: function carregarFluxo() {
      var _this10 = this;

      if (this.fluxo || this.ajuste.status === 'REPROVADO') {
        this.fluxoAjuste.usuarioSolicitante = {};
        var idAjuste = this.$route.params.id;
        this.workflowAjusteVerbaResources.status({ idAjuste: idAjuste }, { idAjuste: idAjuste }).then(function (response) {
          _this10.fluxoAjuste = response.data;
          _this10.preencherJustificativaReprovacao();
          _this10.requestPermiteAprovar();
        }).catch(function (err) {
          _this10.$error(_this10, err);
        });
      }
    },
    preencherJustificativaReprovacao: function preencherJustificativaReprovacao() {
      if (this.fluxoAjuste && this.fluxoAjuste.passoAtual) {
        this.justificativaReprovacao = this.fluxoAjuste.passoAtual.observacao;
      }
    },
    carregarValores: function carregarValores() {
      if (this.ajuste.idRepresentante) {
        this.buscarValoresRepresentante();
        return;
      }
      this.buscarValores();
    }
  },
  beforeMount: function beforeMount() {
    if (this.$route.params.ajuste && this.$route.params.ajuste.length) {
      this.carregarAjuste(this.$route.params.ajuste);
    }
    if (this.$route.params.id) {
      this.carregarAjuste(parseInt(this.$route.params.id, 10));
    }
  },

  components: {
    RegisterForm: _RegisterForm2.default,
    mdAutocomplete: _mdAutocomplete2.default,
    InputMoney: _InputMoneyOld2.default,
    ModalVoltar: _ModalVoltar2.default
  }
};

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CRUDGenerico_vue_vue_type_script_lang_js___ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CRUDGenerico_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CRUDGenerico_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CRUDGenerico_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CRUDGenerico_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CRUDGenerico_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(9);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _assign = __webpack_require__(4);

var _assign2 = _interopRequireDefault(_assign);

var _exportacoes = __webpack_require__(39);

var _exportacoes2 = _interopRequireDefault(_exportacoes);

var _http = __webpack_require__(22);

var _helpers = __webpack_require__(5);

var _sort = __webpack_require__(1006);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  methods: {
    aplicarAcaoArray: function aplicarAcaoArray(arrayObjetos, acao) {
      if (arrayObjetos.length) {
        arrayObjetos.map(acao);
      }
    },
    ativarInativar: function ativarInativar(arrayObjetos, cb) {
      var _this = this;

      this.aplicarAcaoArray(arrayObjetos, function (row) {
        _this.requestAtivarInativar(row);
        return row;
      });
      if (cb) {
        cb();
      }
    },
    atualizar: function atualizar(row) {
      var order = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var item = this.tableRows.find(function (el) {
        return el.id === row.id;
      });
      if (item) {
        (0, _helpers.removeItem)(this.tableRows, item);
        this.tableRows.unshift(row);
        if (order) {
          this.organizarAtivos();
        }
      }
    },
    autocompleteModelAccess: function autocompleteModelAccess(campo) {
      return campo.replace('id_', '').replace('cod_', '');
    },
    cleanTableNoResult: function cleanTableNoResult(cb) {
      this.tableRows = [];
      if (cb) {
        cb();
      }
    },
    closeDialog: function closeDialog() {
      this.$refs.dialog1.close();
    },
    closeDialogSave: function closeDialogSave(item, cb) {
      this.closeDialog();
      this.requestAdicionar(item, cb);
    },
    criarHeaderMenu: function criarHeaderMenu(key, object) {
      return {
        name: object[key],
        tooltip: object[key],
        sortType: key,
        classes: []
      };
    },
    exportarFiltros: function exportarFiltros(filtros, cb, nomeExportador) {
      var _this2 = this;

      var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 500;
      var timeout = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 120000;

      var resource = (0, _exportacoes2.default)(this.$http, timeout);
      resource.download(nomeExportador, {
        limit: limit,
        parametrosConsulta: filtros
      }).then(function () {
        if (cb) {
          cb();
        }
        _this2.$toast.create(_this2.$t('message.exportacao_download'), 'snack', 3E3);
      }).catch(function () {
        if (cb) {
          cb();
        }
        _this2.$toast.create('Erro ao exportar. Tente novamente.', 'snack', 3E3);
      });
    },
    exportar: function exportar(cb, nomeExportador) {
      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 500;
      var timeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 120000;

      this.exportarFiltros({}, cb, nomeExportador, limit, timeout);
    },
    openDialog: function openDialog(ref) {
      this.$refs[ref].open();
    },
    organizar: function organizar(ordenacao) {
      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      (0, _sort.sortTableColumn)(source || this.tableRows, ordenacao);
    },
    organizarAtivos: function organizarAtivos() {
      (0, _sort.sortTruthy)(this.tableRows, 'indAtivo');
    },
    prepareFetchExtensao: function prepareFetchExtensao(idNivelExtensao) {
      var _this3 = this;

      return function () {
        var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        var params = (0, _assign2.default)({}, param, { idNivelExtensao: idNivelExtensao });
        return (_this3.extensaoResources || _this3.resourcesExtensao).listarAtivos(params);
      };
    },
    prepareFetchExtensaoManyToMany: function prepareFetchExtensaoManyToMany(idNivelExtensao, extensoes, campo) {
      var _this4 = this;

      return function () {
        var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        var params = (0, _assign2.default)({}, param, { idNivelExtensao: idNivelExtensao });
        if (extensoes) {
          params.idsNotIn = extensoes.map(function (el) {
            return el[campo];
          });
        }
        return (_this4.extensaoResources || _this4.resourcesExtensao).listarAtivos(params);
      };
    },

    prepareResponseData: _http.prepareResponseData,
    remover: function remover(arrayObjetos) {
      var _this5 = this;

      this.aplicarAcaoArray(arrayObjetos, function (row) {
        _this5.requestRemover(row);
        return row;
      });
    },
    requestAdicionarGenerico: function requestAdicionarGenerico(resource, objeto) {
      var _this6 = this;

      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      resource(objeto).then(function (docs) {
        objeto.id = docs.data.id;
        _this6.tableRows.unshift((0, _helpers.copyObject)(objeto));
        if (cb) {
          cb();
        }
        _this6.$toast.create(_this6.$t('message.adicionado_confira_tabela'), 'snack', 3E3);
      }).catch(function (err) {
        _this6.$error(_this6, err);
      });
    },
    requestAtivarInativarGenerico: function requestAtivarInativarGenerico(objeto, id, resources, cb, order) {
      var _this7 = this;

      var resource = this.validaObjeto(objeto) ? resources.inativar : resources.ativar;
      return resource({ id: id }, { id: id }).then(function () {
        return _this7.tratarRetornoSucessoAtivarInativar(objeto, cb, order);
      }).catch(function (err) {
        _this7.$error(_this7, err);
      });
    },
    tratarRetornoSucessoAtivarInativar: function tratarRetornoSucessoAtivarInativar(objeto, cb, order) {
      this.$toast.create((this.validaObjeto(objeto) ? 'Inativado' : 'Ativado') + ' com sucesso.', 'snack', 3E3);

      objeto.indAtivo = !objeto.indAtivo;
      objeto.ind_ativo = !objeto.ind_ativo;

      this.atualizar(objeto, order);
      if (cb) {
        cb();
      }
    },
    tratarRetornoSucessoAtivarInativarMassa: function tratarRetornoSucessoAtivarInativarMassa(arrayObjetos, cb) {
      var _this8 = this;

      this.$toast.create(this.$t('message.alteracao_massa_sucesso'), 'snack', 3E3);

      this.aplicarAcaoArray(arrayObjetos, function (row) {
        row.indAtivo = !row.indAtivo;
        row.ind_ativo = !row.ind_ativo;
        _this8.atualizar(row);
      });

      if (cb) {
        cb();
      }
    },
    requestAtualizarGenerico: function requestAtualizarGenerico(resource, objeto, order) {
      var _this9 = this;

      resource(objeto).then(function () {
        _this9.$toast.create(_this9.$t('message.atualizado_confira_tabela'), 'snack', 3E3);
        _this9.atualizar(objeto, order);
      }).catch(function (err) {
        _this9.$error(_this9, err);
      });
    },
    requestPopularGenerico: function requestPopularGenerico(resource) {
      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var _this10 = this;

      var source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var order = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

      var pagination = page || { size: 20, page: 1 };

      resource(pagination).then(function (response) {
        var objetos = response.data.resposta;

        if (!objetos.length) {
          if (pagination.page < 2) {
            _this10.cleanTableNoResult(cb);
          } else if (cb) {
            cb(true);
          }
          return;
        }

        if (objetos && objetos.hasOwnProperty('length') && objetos.length) {
          if (pagination.page < 2) {
            if (source) {
              var _source;

              source = [];
              (_source = source).push.apply(_source, (0, _toConsumableArray3.default)(objetos));
            } else {
              var _tableRows;

              _this10.tableRows = [];
              (_tableRows = _this10.tableRows).push.apply(_tableRows, (0, _toConsumableArray3.default)(objetos));
            }
          } else {
            var _ref;

            (_ref = source || _this10.tableRows).push.apply(_ref, (0, _toConsumableArray3.default)(objetos));
          }
        }
        if (cb) {
          cb();
        }
        if (!source && order) {
          _this10.organizarAtivos();
        }
      }).catch(function (err) {
        _this10.$error(_this10, err);
      });
    },
    requestRemoverGenerico: function requestRemoverGenerico(objeto, id, resources, cb) {
      var _this11 = this;

      return resource({ id: id }, { id: id }).then(function () {
        _this11.$toast.create((_this11.validaObjeto(objeto) ? 'Inativado' : 'Ativado') + ' com sucesso.', 'snack', 3E3);
        (0, _helpers.removeItem)(_this11.tableRows, row);
        if (cb) {
          cb();
        }
      }).catch(function (err) {
        _this11.$error(_this11, err);
      });
    },
    validaObjeto: function validaObjeto(obj) {
      return !!obj.indAtivo;
    }
  }
};

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_CRUDGenerico_css_vue_type_style_index_0_lang_css___ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_CRUDGenerico_css_vue_type_style_index_0_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_CRUDGenerico_css_vue_type_style_index_0_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_CRUDGenerico_css_vue_type_style_index_0_lang_css____default.a); 

/***/ }),
/* 300 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_RegisterForm_vue_vue_type_script_lang_js___ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_RegisterForm_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_RegisterForm_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_RegisterForm_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_RegisterForm_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_RegisterForm_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    title: String,
    elevation: {
      type: String,
      default: '0'
    },
    color: {
      type: String,
      default: undefined
    },
    subtitle: {
      type: String,
      default: function _default() {
        return this.$t('label.preencha_campos_abaixo');
      }
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    save: {
      type: Function,
      default: function _default() {
        return function () {
          return {};
        };
      }
    },
    cancel: {
      type: Function,
      default: function _default() {
        return function () {
          return {};
        };
      }
    },
    cancelLabel: {
      type: String,
      default: function _default() {
        return this.$t('label.cancelar');
      }
    },
    saveLabel: {
      type: String,
      default: function _default() {
        return this.$t('label.salvar');
      }
    },
    showButton: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    cancelAction: function cancelAction() {
      if (this.cancel) {
        this.cancel();
      }
      this.$emit('REGISTERFORM_CANCEL_ACTION');
    },
    saveAction: function saveAction() {
      if (this.save) {
        this.save();
      }
      this.$emit('REGISTERFORM_SAVE_ACTION');
    }
  }
};

/***/ }),
/* 303 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_mdAutocomplete_vue_vue_type_script_lang_js___ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_mdAutocomplete_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_mdAutocomplete_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_mdAutocomplete_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_mdAutocomplete_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_mdAutocomplete_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(73);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = __webpack_require__(4);

var _assign2 = _interopRequireDefault(_assign);

var _autocomplete = __webpack_require__(306);

var _autocomplete2 = _interopRequireDefault(_autocomplete);

var _common = __webpack_require__(1012);

var _common2 = _interopRequireDefault(_common);

var _helpers = __webpack_require__(5);

var _loading = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_common2.default, _autocomplete2.default],
  props: {
    extensao: {
      type: Boolean,
      default: false
    },
    chips: {
      type: Array,
      default: null
    },
    identifier: {
      type: String,
      default: 'id'
    },
    menuStyle: {
      type: String,
      default: 'width:330px; max-height:400px'
    },
    direction: {
      type: String,
      default: 'bottom right'
    }
  },
  data: function data() {
    return {
      items: [],
      loading: false,
      query: '',
      selected: null,
      timeout: 0,
      parentContainer: null,
      searchButton: null,
      lastPrintValue: null,
      verMais: false,
      limit: 6,
      numeroPagina: 0
    };
  },

  computed: {
    listIsEmpty: function listIsEmpty() {
      return this.list.length === 0;
    },
    inputIdComputado: function inputIdComputado() {
      this.inputId = 'md-auto-complete-input-' + Date.now();
      return this.inputId;
    }
  },
  watch: {
    list: function list(value) {
      this.items = (0, _assign2.default)([], value);
    },
    query: function query(value) {
      this.$refs.input.value = value;
      this.setParentUpdateValue(value);
      if (value === '') {
        this.emptyAction();
      }
    },
    value: function value(_value) {
      this.query = _value;
      this.setParentUpdateValue(_value);
    }
  },
  methods: {
    blurInput: function blurInput(e) {
      if (this.lastPrintValue !== null) {
        var el = document.getElementById(this.inputId);
        if (el.value === '' || this.lastPrintValue !== el.value) {
          this.$emit('selected', {}, '');
        }
      }
      if (this.onBlur) {
        this.onBlur(e);
      }
    },
    debounceUpdate: function debounceUpdate() {
      var _this = this;

      this.onInput();

      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }

      this.timeout = window.setTimeout(function () {
        if (!_this.listIsEmpty) {
          _this.renderFilteredList();
          return;
        }
        _this.update();
      }, this.debounce);
    },
    hit: function hit(item) {
      var value = this.printAttribute ? item[this.printAttribute] : this.printFunction(item);
      this.query = value;
      this.$refs.input.value = value;
      this.selected = item;
      this.lastPrintValue = value;
      this.onInput();
      this.$emit('selected', this.selected, this.$refs.input.value);
      this.numeroPagina = 0;
      this.verMais = false;
    },
    makeFetchRequestAllRegister: function makeFetchRequestAllRegister() {
      this.makeFetchRequest({});
    },
    makeFetchRequest: function makeFetchRequest(queryObject) {
      var _this2 = this;

      this.numeroPagina = this.numeroPagina + 1;
      queryObject.tamanhoPagina = this.limit;
      queryObject.numeroPagina = this.numeroPagina;
      if (this.disabled) {
        return null;
      }
      this.loading = true;
      this.toggleMenu();
      (0, _loading.skipLoading)();
      return this.fetch(queryObject).then(function (response) {
        var data = response || response.data || response.body;
        var totalPagina = data.quantidadeRegistrosPagina || data.data.quantidadeRegistrosPagina;
        data = _this2.prepareResponseData ? _this2.prepareResponseData(data) : data;
        _this2.items = _this2.limit ? data.slice(0, _this2.limit) : data;
        if (_this2.items.length < _this2.limit) {
          _this2.verMais = false;
          _this2.numeroPagina = 0;
        } else _this2.verMais = !(totalPagina && totalPagina <= _this2.limit * _this2.numeroPagina);

        if (_this2.chips) {
          var found = [];
          _this2.items.forEach(function (items, index) {
            _this2.chips.forEach(function (chip) {
              if (items[_this2.identifier] === chip[_this2.identifier]) {
                found.push(index);
              }
            });
          });
          for (var i = found.length - 1; i >= 0; i -= 1) {
            _this2.items.splice(found[i], 1);
          }
        }
        _this2.loading = false;
      });
    },
    onFocus: function onFocus() {
      if (this.parentContainer) {
        this.parentContainer.isFocused = true;
      }
      this.$refs.input.focus();
    },
    onInput: function onInput() {
      this.updateValues();
      this.$emit('change', this.$refs.input.value);
      this.$emit('input', this.$refs.input.value);
    },
    addExtension: function addExtension() {
      this.$emit('addExtension');
    },
    emptyAction: function emptyAction() {
      this.$emit('empty');
    },
    renderFilteredList: function renderFilteredList() {
      if (this.filterList) {
        this.items = this.filterList((0, _assign2.default)([], this.list), this.query);
      }
      this.toggleMenu();
    },
    reset: function reset() {
      this.items = [];
      this.query = '';
      this.loading = false;
      this.numeroPagina = 0;
      this.verMais = false;
    },
    setParentValue: function setParentValue(value) {
      var val = value || this.$refs.input.value;
      if (this.parentContainer) {
        this.parentContainer.setValue(val);
      }
    },
    setParentDisabled: function setParentDisabled() {
      if (this.parentContainer) {
        this.parentContainer.isDisabled = this.disabled;
      }
    },
    setParentRequired: function setParentRequired() {
      if (this.parentContainer) {
        this.parentContainer.isRequired = this.required;
      }
    },
    setParentPlaceholder: function setParentPlaceholder() {
      if (this.parentContainer) {
        this.parentContainer.hasPlaceholder = !!this.placeholder;
      }
    },
    setParentUpdateValue: function setParentUpdateValue(value) {
      this.setParentValue(value);
      this.updateValues(value);
    },
    setSearchButton: function setSearchButton() {
      this.searchButton = this.parentContainer.$el.querySelector('[md-autocomplete-search]');

      if (this.searchButton) {
        this.searchButton.addEventListener('click', this.searchButtonRequest);
      }
    },
    searchButtonRequest: function searchButtonRequest() {
      this.numeroPagina = 0;
      var queryObject = (0, _defineProperty3.default)({}, this.queryParam, this.query);
      this.makeFetchRequest(queryObject);
    },
    update: function update() {
      if (!this.query && !this.list.length) {
        return this.reset();
      }

      if (this.minChars && this.query.length < this.minChars) {
        return this;
      }

      this.loading = true;
      this.numeroPagina = 0;
      var queryObject = (0, _defineProperty3.default)({}, this.queryParam, this.query);
      return this.makeFetchRequest(queryObject);
    },
    updateVerMais: function updateVerMais() {
      this.loading = true;

      var queryObject = (0, _defineProperty3.default)({}, this.queryParam, this.query);
      return this.makeFetchRequest(queryObject);
    },
    toggleMenu: function toggleMenu() {
      this.$refs.menu.toggle();
    },
    updateValues: function updateValues(value) {
      var newValue = value || this.$refs.input.value || this.value;

      this.setParentValue(newValue);
      this.parentContainer.inputLength = newValue ? newValue.length : 0;
    },
    verMaisRegistros: function verMaisRegistros() {
      var _this3 = this;

      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }

      this.timeout = window.setTimeout(function () {
        if (!_this3.listIsEmpty) {
          _this3.renderFilteredList();
          return;
        }
        _this3.updateVerMais();
      }, this.debounce);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.searchButton !== undefined) {
      this.searchButton.removeEventListener('click', this.makeFetchRequest);
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    this.$nextTick(function () {
      _this4.parentContainer = (0, _helpers.getClosestVueParent)(_this4.$parent, 'md-input-container');

      if (!_this4.listIsEmpty) {
        _this4.items = (0, _assign2.default)([], _this4.list);
      }

      _this4.query = _this4.value;

      _this4.verifyProps();
      _this4.setSearchButton();

      _this4.setParentDisabled();
      _this4.setParentRequired();
      _this4.setParentPlaceholder();
      _this4.handleMaxLength();
      _this4.updateValues();
    });
  }
};

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    debounce: {
      type: Number,
      default: 1E3
    },
    disabled: Boolean,
    fetch: Function,
    filterList: Function,
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    minChars: {
      type: Number,
      default: 1
    },
    name: String,
    prepareResponseData: Function,
    printAttribute: {
      type: String,
      default: 'name'
    },
    printFunction: {
      type: Function,
      default: null
    },
    queryParam: {
      type: String,
      default: 'q'
    },
    required: Boolean
  },
  methods: {
    onFocus: function onFocus() {
      if (this.parentContainer) {
        this.parentContainer.isFocused = true;
      }
    },
    onBlur: function onBlur() {
      this.parentContainer.isFocused = false;
      this.setParentValue();
    },
    verifyProps: function verifyProps() {
      if (!this.parentContainer) {
        return this.throwErrorDestroy('You should wrap the md-input in a md-input-container');
      } else if (this.listIsEmpty && this.filterList) {
        return this.throwErrorDestroy('You should use a `filterList` function prop with the `list` prop');
      } else if (!this.fetch && this.listIsEmpty) {
        return this.throwErrorDestroy('You should use a `fetch` function prop');
      }
      return this;
    },
    throwErrorDestroy: function throwErrorDestroy(errorMessage) {
      this.$destroy();
      throw new Error(errorMessage);
    }
  }
};

/***/ }),
/* 307 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 308 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_InputMoneyOld_vue_vue_type_script_lang_js___ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_InputMoneyOld_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_InputMoneyOld_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_InputMoneyOld_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_InputMoneyOld_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_InputMoneyOld_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _awesomeMask = __webpack_require__(1017);

var _awesomeMask2 = _interopRequireDefault(_awesomeMask);

var _helpers = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'InputMoneyOld',
  props: {
    oneWayBind: Number,
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    maxlength: [Number, String],
    placeholder: String,
    inputClass: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      valor: 0.0,
      lastHit: null,
      parentContainer: null
    };
  },

  watch: {
    oneWayBind: function oneWayBind(novoValor) {
      if (this.lastHit === novoValor || novoValor === undefined) return;

      var event = new Event('keyup', { bubbles: true });
      this.$el.value = this.trataPerdaPrecisao(novoValor);
      this.$el.dispatchEvent(event);

      this.lastHit = novoValor;
    }
  },
  methods: {
    alteracao: function alteracao() {
      var valorAlterado = this.valorSemMascara();
      if (valorAlterado === this.lastHit) return;

      this.lastHit = valorAlterado;
      this.$emit('change', this.lastHit);
      this.setParentValue(valorAlterado);
    },
    consequencia: function consequencia() {
      this.$emit('blur', this.lastHit);
    },
    valorSemMascara: function valorSemMascara() {
      return typeof this.valor === 'string' ? parseInt(this.valor.replace(/[\D]+/g, ''), 10) / 100 : this.valor;
    },
    trataPerdaPrecisao: function trataPerdaPrecisao(novoValor) {
      var retorno = 0;
      var copia = novoValor * 10;
      if (novoValor - parseInt(novoValor, 10) === 0 || copia - parseInt(copia, 10) === 0) {
        retorno = novoValor * 100;
      } else {
        retorno = novoValor;
      }
      return parseFloat(retorno.toFixed(2));
    },
    setParentValue: function setParentValue(value) {
      if (value === undefined || value === null) {
        this.parentContainer.setValue(this.$refs.input.value);
      } else {
        this.parentContainer.setValue(value);
      }
    },
    setParentDisabled: function setParentDisabled() {
      this.parentContainer.isDisabled = this.disabled;
    },
    setParentRequired: function setParentRequired() {
      this.parentContainer.isRequired = this.required;
    },
    setParentPlaceholder: function setParentPlaceholder() {
      this.parentContainer.hasPlaceholder = !!this.placeholder;
    },
    setParentUpdateValue: function setParentUpdateValue(value) {
      this.setParentValue(value);
      this.updateValues(value);
    },
    updateValues: function updateValues(value) {
      var newValue = value || this.$refs.input.value || this.value;

      this.setParentValue(newValue);
      this.parentContainer.inputLength = newValue ? newValue.length : 0;
    }
  },
  directives: {
    mask: _awesomeMask2.default
  },
  beforeMount: function beforeMount() {
    this.valor = this.trataPerdaPrecisao(this.oneWayBind || 0.0);
  },
  mounted: function mounted() {
    this.parentContainer = (0, _helpers.getClosestVueParent)(this.$parent, 'md-input-container');
  }
};

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ModalVoltar_vue_vue_type_script_lang_js___ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ModalVoltar_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ModalVoltar_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ModalVoltar_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ModalVoltar_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ModalVoltar_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    actionSim: Function,
    actionNao: Function,
    mdClickOutsideToClose: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    open: function open() {
      this.$refs.voltarDialog.open();
    },
    close: function close() {
      this.$refs.voltarDialog.close();
    },
    defaultClose: function defaultClose() {
      this.close();
    },
    defaultActionSim: function defaultActionSim() {
      this.close();
      if (this.actionSim) {
        this.actionSim();
      }
    },
    defaultActionNao: function defaultActionNao() {
      this.close();
      if (this.actionNao) {
        this.actionNao();
      }
    }
  }
};

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AlcadaCadastro_vue_vue_type_script_lang_js___ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AlcadaCadastro_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AlcadaCadastro_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AlcadaCadastro_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AlcadaCadastro_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AlcadaCadastro_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _rolesComputedGenerator = __webpack_require__(8);

var _CRUDGenerico = __webpack_require__(23);

var _CRUDGenerico2 = _interopRequireDefault(_CRUDGenerico);

var _AlcadaForm = __webpack_require__(1026);

var _AlcadaForm2 = _interopRequireDefault(_AlcadaForm);

var _AlcadaTabela = __webpack_require__(1032);

var _AlcadaTabela2 = _interopRequireDefault(_AlcadaTabela);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'CadastroAlcada',
  extends: _CRUDGenerico2.default,
  data: function data() {
    return {
      alcadaResources: this.$api.alcada(this.$resource)
    };
  },

  components: {
    AlcadaForm: _AlcadaForm2.default,
    AlcadaTabela: _AlcadaTabela2.default
  },
  computed: (0, _extends3.default)({}, (0, _rolesComputedGenerator.generateComputed)('alcada', ['canAccessCRUD', 'canAccessPage']), {
    somenteLeitura: function somenteLeitura() {
      return !this.canAccessCRUD;
    }
  }),
  methods: {
    accessForbidden: function accessForbidden() {
      if (!this.canAccessPage) {
        this.$router.push({ name: 'inicio' });
        this.$toast.create(this.$t('message.acesso_negado'), 'snack', 3E3);
      }
    },
    onCancelar: function onCancelar() {
      this.$refs.alcadaTabela.filtrar();
    },
    onEditarAlcada: function onEditarAlcada(alcada) {
      this.$refs.alcadaForm.editar(alcada);
    },
    onNovoAlcada: function onNovoAlcada() {
      this.$refs.alcadaTabela.filtrar();
    },
    filtrar: function filtrar(searchQuery) {
      this.searchQuery = searchQuery;
      this.requestPopular();
    },
    requestPopular: function requestPopular() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (page && page.filter) {
        this.request(this.alcadaResources.listarFiltrado, page);
        return;
      }
      this.request(this.alcadaResources.listar, page);
    },
    requestAdicionar: function requestAdicionar(objeto) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (!this.canAccessCRUD) {
        return;
      }
      this.requestAdicionarGenerico(this.alcadaResources.gravar, objeto, cb);
    },
    requestAtivarInativar: function requestAtivarInativar(index) {
      if (!this.canAccessCRUD) {
        return null;
      }
      var row = this.tableRows[index],
          id = row.id;
      return this.requestAtivarInativarGenerico(row, id, this.alcadaResources, this.requestPopular);
    },
    requestAtualizar: function requestAtualizar(objeto) {
      var _this = this;

      if (!this.canAccessCRUD) {
        return;
      }
      if (objeto.objFluxo) {
        objeto.idWorkflowTipo = objeto.objFluxo.idWorkflowTipo;
        objeto.fluxo = objeto.objFluxo.fluxo;
        delete objeto.objFluxo;
      }
      if (objeto.objEstruturaUsuario) {
        objeto.idEstruturaUsuario = objeto.objEstruturaUsuario.idEstruturaUsuario;
        objeto.nomEstruturaUsuario = objeto.objEstruturaUsuario.nomEstruturaUsuario;
        delete objeto.objEstruturaUsuario;
      }
      var payload = this.prepareRequestObject(copyObject(objeto));

      this.alcadaResources.atualizar(payload).then(function () {
        _this.$toast.create(_this.$t('message.atualizado_confira_tabela'), 'snack', 3E3);
        _this.atualizar(objeto);
      }).catch(function (err) {
        _this.$error(_this, err);
      });
    },
    request: function request(requisicao) {
      var _this2 = this;

      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var pagination = page || { size: 10, page: 1 };
      this.carregando = true;

      requisicao(pagination).then(function (response) {
        _this2.tableRows = response.data.resposta;
        var qtdeRegistros = response.data.quantidadeRegistrosPagina;
        _this2.paginas = Math.ceil(qtdeRegistros / pagination.size);

        _this2.carregando = false;
        if (cb) {
          cb();
        }
      }).catch(function (err) {
        _this2.$error(_this2, err);
        _this2.carregando = false;
      });
    },
    prepareRequestObject: function prepareRequestObject(objeto) {
      var cleanPayload = {};
      cleanPayload.id = objeto.id;
      cleanPayload.descricao = objeto.descricao;
      cleanPayload.idEstruturaUsuario = objeto.idEstruturaUsuario;
      cleanPayload.nomEstruturaUsuario = objeto.nomEstruturaUsuario;
      cleanPayload.idWorkflowTipo = objeto.idWorkflowTipo;
      cleanPayload.indAtivo = objeto.indAtivo;
      cleanPayload.vlrLimiteFinal = objeto.vlrLimiteFinal;
      cleanPayload.vlrLimiteInicial = objeto.vlrLimiteInicial;
      cleanPayload.objFluxo = objeto.objFluxo;
      cleanPayload.objEstruturaUsuario = objeto.objEstruturaUsuario;
      return cleanPayload;
    }
  },
  beforeMount: function beforeMount() {
    var _this3 = this;

    if (!this.canAccessPage) {
      window.setTimeout(function () {
        _this3.accessForbidden();
      }, 1E3);
    } else {}
  },
  mounted: function mounted() {
    var _this4 = this;

    if (!this.canAccessPage) {
      window.setTimeout(function () {
        return _this4.accessForbidden();
      }, 1E3);
    } else {
      this.requestPopular();
    }
  }
};

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AlcadaForm_vue_vue_type_script_lang_js___ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AlcadaForm_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AlcadaForm_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AlcadaForm_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AlcadaForm_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AlcadaForm_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(4);

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _InputMoney = __webpack_require__(702);

var _InputMoney2 = _interopRequireDefault(_InputMoney);

var _Confirm = __webpack_require__(12);

var _Confirm2 = _interopRequireDefault(_Confirm);

var _Alcada = __webpack_require__(320);

var _Alcada2 = _interopRequireDefault(_Alcada);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'AlcadaForm',
  data: function data() {
    var _this = this;

    return {
      alcada: new _Alcada2.default(),
      alcadaResources: this.$api.alcada(this.$resource),
      estruturaUsuarioResources: this.$api.estruturaUsuario(this.$resource),
      listaFluxos: [],
      listaEstruturaUsuarios: [],
      layoutClass: { wrap: true },
      dialog: {
        content: ''
      },
      rules: {
        required: function required(value) {
          return !!value || _this.$t('message.campo_obrigatorio');
        },
        valorFinalMaiorInicial: function valorFinalMaiorInicial() {
          var valorFinal = _this.alcada.vlrLimiteFinal;
          return valorFinal > _this.alcada.vlrLimiteInicial || _this.$t('errors.valor_inicial_mayor_final');
        }
      }
    };
  },

  watch: {},
  components: {
    Confirm: _Confirm2.default,
    InputMoney: _InputMoney2.default
  },
  methods: {
    cancel: function cancel() {
      this.limparFormulario();
      this.$emit('FORMULARIO_CADASTRO_ALCADA_CANCELAR');
    },
    editar: function editar(alcada) {
      this.alcada = new _Alcada2.default((0, _extends3.default)({}, alcada));
    },
    limparFormulario: function limparFormulario() {
      var _this2 = this;

      this.alcada = new _Alcada2.default();
      setTimeout(function () {
        return _this2.$refs.form.reset();
      }, 1E2);
    },
    buscarTiposFluxo: function buscarTiposFluxo() {
      var _this3 = this;

      this.alcadaResources.listarTiposFluxo().then(function (response) {
        _this3.listaFluxos = response.data.resposta;
      }).catch(function (err) {
        _this3.$error(_this3, err);
      });
    },
    setarTipoFluxo: function setarTipoFluxo() {
      this.alcada.idWorkflowTipo = this.alcada.fluxo.id;
      delete this.alcada.fluxo;
    },
    buscarEstruturasDeUsuario: function buscarEstruturasDeUsuario() {
      var _this4 = this;

      this.estruturaUsuarioResources.selecao({ limit: 10000 }).then(function (resultado) {
        _this4.listaEstruturaUsuarios = resultado.data;
      }).catch(function (err) {
        _this4.$error(_this4, err);
      });
    },
    setarEstruturaUsuario: function setarEstruturaUsuario() {
      this.alcada.idEstruturaUsuario = this.alcada.estruturaUsuario.id;
      this.alcada.nomEstruturaUsuario = this.alcada.estruturaUsuario.nomEstruturaUsuario;
      delete this.alcada.estruturaUsuario;
    },
    validarCampos: function validarCampos() {
      if (!!this.alcada.vlrLimiteFinal && this.alcada.vlrLimiteFinal > 0) {
        this.$refs.form.validate();
      }
    },
    closeDialog: function closeDialog(ref, cb) {
      this.$refs[ref].close();
      this.$refs[ref].active = false;
      if (cb) {
        cb();
      }
    },
    openSaveDialog: function openSaveDialog() {
      if (!this.$refs.form.validate()) return;
      this.dialog.content = this.$t('message.salvar');
      this.$refs.confirmDialog.open();
    },
    openDialog: function openDialog(ref) {
      this.$refs[ref].open();
      this.$refs[ref].active = true;
    },
    save: function save() {
      var _this5 = this;

      var salvarOuAtualizar = void 0;
      var inclusao = true;
      this.setarTipoFluxo();
      this.setarEstruturaUsuario();
      if (this.alcada.indSemValorFim) {
        this.alcada.vlrLimiteFinal = null;
      }
      this.$emit('FORMULARIO_CADASTRO_ALCADA_SALVAR', this.alcada, this.clearForm);
      if (this.alcada.id != null) {
        inclusao = false;
        salvarOuAtualizar = this.alcadaResources.atualizar(this.alcada);
      } else {
        salvarOuAtualizar = this.alcadaResources.gravar(this.alcada);
      }

      salvarOuAtualizar.then(function () {
        return _this5.$toast.create(_this5.$t(inclusao ? 'message.adicionado_confira_tabela' : 'message.atualizado_confira_tabela'), 'snack', 3e3);
      }).then(function () {
        _this5.$emit('FORMULARIO_CADASTRO_ALCADA_SALVAR', (0, _assign2.default)({}, _this5.alcada));
      }).then(function () {
        return _this5.limparFormulario();
      }).catch(function (err) {
        _this5.$error(_this5, err);
      });
    }
  },
  computed: {
    somenteLeitura: function somenteLeitura() {
      return !this.canAccessCRUD;
    }
  },
  mounted: function mounted() {
    this.buscarTiposFluxo();
    this.buscarEstruturasDeUsuario();
  }
};

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_InputMoney_vue_vue_type_script_lang_js___ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_InputMoney_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_InputMoney_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_InputMoney_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_InputMoney_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_InputMoney_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vMoney = __webpack_require__(98);

exports.default = {
  name: 'InputMoney',
  props: {
    value: {
      type: [Number, String],
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: String,
    id: {
      type: String,
      default: function _default() {
        return 'InputMoney-' + Date.now().toString();
      }
    },
    rules: {
      type: Array
    },
    hint: {
      type: String,
      default: ''
    },
    persistentHint: {
      type: Boolean,
      default: false
    },
    alignRight: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    singleLine: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Money: _vMoney.Money
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler(alterado) {
        this.valorInterno = alterado;
      }
    }
  },
  computed: {
    hasErrors: function hasErrors() {
      if (!this.required) {
        return false;
      }

      var val = this.valorInterno,
          hasErrors = val === null || val === this.valorVazioDinheiro;
      return hasErrors;
    },
    validaCampo: function validaCampo() {
      if (this.hasErrors) {
        return this.$t('message.campo_obrigatorio');
      }
      return null;
    }
  },
  data: function data() {
    return {
      dirty: false,
      focused: false,
      valorInterno: null,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      },
      valorVazioDinheiro: 0
    };
  },

  methods: {
    valorDinheiroAlterado: function valorDinheiroAlterado(valor) {
      if (valor === this.value) return;
      this.$emit('InputMoney_valorAlterado', valor);
      this.$emit('input', valor);
    },
    refresh: function refresh() {
      this.$forceUpdate();
    }
  },
  mounted: function mounted() {
    var _this = this;

    var input = document.getElementById(this.id);

    input.addEventListener('focus', function () {
      _this.focused = true;
    }, false);

    input.addEventListener('keyup', function () {
      _this.dirty = true;
    }, false);

    input.addEventListener('blur', function () {
      _this.focused = false;
      _this.dirty = true;
    }, false);
  }
};

/***/ }),
/* 319 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(29);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(43);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Alcada = function () {
  function Alcada() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    (0, _classCallCheck3.default)(this, Alcada);

    if (data) {
      this.id = data.id;
      this.descricao = data.descricao;
      this.vlrLimiteInicial = data.vlrLimiteInicial;
      this.fluxo = data.fluxo;
      this.estruturaUsuario = data.estruturaUsuario;
      if (!data.vlrLimiteFinal) {
        this.indSemValorFim = true;
        this.vlrLimiteFinal = 0;
      } else {
        this.indSemValorFim = false;
        this.vlrLimiteFinal = data.vlrLimiteFinal;
      }
    } else {
      this.indAtivo = true;
      this.indSemValorFim = false;
    }
  }

  (0, _createClass3.default)(Alcada, [{
    key: "construirAPartirDaConsultaCompleta",
    value: function construirAPartirDaConsultaCompleta(dadosDaConsulta) {
      this.id = dadosDaConsulta.id;
      this.descricao = dadosDaConsulta.descricao;
      this.vlrLimiteInicial = dadosDaConsulta.vlrLimiteInicial;
      this.indAtivo = dadosDaConsulta.indAtivo;
      this.estruturaUsuario = {
        nomEstruturaUsuario: dadosDaConsulta.nomEstruturaUsuario,
        id: dadosDaConsulta.idEstruturaUsuario
      };
      this.fluxo = {
        nome: dadosDaConsulta.fluxo,
        id: dadosDaConsulta.idWorkflowTipo
      };
      if (!dadosDaConsulta.vlrLimiteFinal) {
        this.indSemValorFim = true;
        this.vlrLimiteFinal = 0;
      } else {
        this.indSemValorFim = false;
        this.vlrLimiteFinal = dadosDaConsulta.vlrLimiteFinal;
      }
    }
  }, {
    key: "ehEdicao",
    value: function ehEdicao() {
      return this.id;
    }
  }]);
  return Alcada;
}();

exports.default = Alcada;

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AlcadaTabela_vue_vue_type_script_lang_js___ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AlcadaTabela_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AlcadaTabela_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AlcadaTabela_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AlcadaTabela_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AlcadaTabela_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _rolesComputedGenerator = __webpack_require__(8);

var _Alcada = __webpack_require__(320);

var _Alcada2 = _interopRequireDefault(_Alcada);

var _Confirm = __webpack_require__(12);

var _Confirm2 = _interopRequireDefault(_Confirm);

var _helpers = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Confirm: _Confirm2.default
  },
  data: function data() {
    return {
      alcadaResources: this.$api.alcada(this.$resource),
      listaAlcadas: [],
      esperar: false,
      headers: [{ text: this.$tc('label.fluxo', 1), value: 'fluxo', sortable: true }, { text: this.$tc('label.descricao', 1), value: 'descricao', sortable: true }, { text: this.$tc('label.ativo', 1), value: 'ind_ativo', sortable: true }, { text: this.$tc('label.estrutura_usuario', 1), value: 'nom_estrutura_usuario', sortable: true }, { text: this.$tc('label.valor_inicial', 1), value: 'vlr_limite_inicial', sortable: true }, { text: this.$tc('label.valor_final', 1), value: 'vlr_limite_final', sortable: true }, { text: '', value: 'acoes', sortable: false }],
      pagination: {},
      totalPage: 0,
      searchQuery: '',
      registros: [],
      selected: []
    };
  },

  watch: {
    pagination: {
      handler: function handler() {
        this.filtrar();
      },

      deep: true
    },
    searchQuery: function searchQuery() {
      var _this = this;

      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      this.timeout = window.setTimeout(function () {
        _this.filtrar();
      }, 500);
    }
  },
  props: {
    title: String
  },
  computed: (0, _extends3.default)({
    filteredList: function filteredList() {
      return [];
    }
  }, (0, _rolesComputedGenerator.generateComputed)('Alcada', ['canAccessCRUD']), {
    somenteLeitura: function somenteLeitura() {
      return !this.canAccessCRUD;
    }
  }),
  methods: {
    convertToMoney: _helpers.convertToMoney,
    ativarInativarRegistros: function ativarInativarRegistros() {
      var _this2 = this;

      var parametros = [];
      this.selected.forEach(function (item) {
        parametros.push({ id: item.id, indAtivo: item.indAtivo });
      });

      this.alcadaResources.ativarInativarRegistros(parametros).then(function () {
        _this2.$toast.create(_this2.$t('message.atualizado_confira_tabela'), 'snack', 3E3);
        _this2.limparSelecionados();
        _this2.filtrar();
      }).catch(function (err) {
        _this2.$error(_this2, err);
      });
    },
    buscar: function buscar() {
      var _this3 = this;

      if (this.searchQuery) {
        this.pagination.page = 1;
      }

      var params = {
        descricao: this.searchQuery,
        page: this.pagination.page,
        size: this.pagination.itemsPerPage,
        asc: !this.pagination.sortDesc[0],
        colunaOrdenacao: this.pagination.sortBy[0]
      };

      this.alcadaResources.listar(params).then(function (response) {
        _this3.registros = response.data.resposta;
        _this3.montarObjetoAlcadas();
        _this3.totalPage = response.data.quantidadeRegistrosPagina;
        _this3.pararEsperar();
      }, function (err) {
        _this3.pararEsperar();
        _this3.$error(_this3, err);
      });
    },
    filtrar: function filtrar() {
      var _this4 = this;

      if (this.esperar) return;
      this.esperar = true;
      setTimeout(function () {
        _this4.buscar();
      }, 5E2);
    },
    getSearchQuery: function getSearchQuery() {
      return this.searchQuery;
    },
    limparSelecionados: function limparSelecionados() {
      this.selected = [];
    },
    dialogConfirmarInativacao: function dialogConfirmarInativacao() {
      this.$refs.dialogConfirmaInativacao.open();
    },
    montarObjetoAlcadas: function montarObjetoAlcadas() {
      this.listaAlcadas = this.registros.map(function (data) {
        var alcada = new _Alcada2.default();
        alcada.construirAPartirDaConsultaCompleta(data);
        return alcada;
      });
    },
    onEditarAlcada: function onEditarAlcada(alcada) {
      if (!alcada.desAtributos) {
        alcada.desAtributos = { regional: false };
      }
      this.$emit('PESQUISA_ALCADA_EDITAR', alcada);
    },
    validateConflitosValores: function validateConflitosValores(row) {
      this.valuesErro = null;
      var status = true;
      if (!this.rowEdit.indSemValorFim && row.vlrLimiteInicial > row.vlrLimiteFinal) {
        this.valuesErro = 'vlr_inicial_maior_vlr_final';
        status = false;
      }
      return status;
    },
    pararEsperar: function pararEsperar() {
      var _this5 = this;

      setTimeout(function () {
        _this5.esperar = false;
      }, 2E2);
    },
    mudarOrdenacao: function mudarOrdenacao(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    toggleAll: function toggleAll() {
      if (this.selected.length) this.selected = [];else this.selected = this.listaAlcadas.slice();
    }
  }
};

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscal_vue_vue_type_script_lang_js___ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscal_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscal_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscal_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscal_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscal_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'AnoFiscal',
  methods: {
    accessForbidden: function accessForbidden() {
      this.$router.push({ name: 'inicio' });
      this.$toast.create(this.$t('message.acesso_negado'), 'snack', 3E3);
    }
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('roles', ['getAllRoles']), {
    canAccessPage: function canAccessPage() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el === 'ANO_FISCAL';
      }).length;
    }
  }),
  beforeMount: function beforeMount() {
    var _this = this;

    if (!this.canAccessPage) {
      window.setTimeout(function () {
        return _this.accessForbidden();
      }, 1E3);
    }
  }
};

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalPesquisar_vue_vue_type_script_lang_js___ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalPesquisar_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalPesquisar_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalPesquisar_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalPesquisar_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalPesquisar_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(6);

var _AnoFiscalCard = __webpack_require__(1042);

var _AnoFiscalCard2 = _interopRequireDefault(_AnoFiscalCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'AnoFiscalPesquisar',
  components: {
    AnoFiscalCard: _AnoFiscalCard2.default
  },
  props: {
    habilitarBloqueio: {
      type: Boolean,
      default: false
    },
    habilitarFechamento: {
      type: Boolean,
      default: false
    },
    habilitarPeriodosOrcamento: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      tipos: [],
      carregouTipos: false,
      resourcesOrcamentoTipoVerba: this.$api.orcamentoTipoVerba(this.$resource)
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('roles', ['getAllRoles']), {
    canAccessPage: function canAccessPage() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el === 'ANO_FISCAL';
      }).length;
    }
  }),
  methods: {
    accessForbidden: function accessForbidden() {
      this.$router.push({ name: 'inicio' });
      this.$toast.create(this.$t('message.acesso_negado'), 'snack', 3E3);
    },
    pesquisarTipos: function pesquisarTipos() {
      var _this = this;

      this.resourcesOrcamentoTipoVerba.buscarAtivos().then(function (res) {
        _this.tipos = res.data;
        _this.carregouTipos = true;
      }, function (err) {
        _this.$error(_this, err);
      });
    }
  },
  mounted: function mounted() {
    this.pesquisarTipos();
  },
  beforeMount: function beforeMount() {
    var _this2 = this;

    if (!this.canAccessPage) {
      window.setTimeout(function () {
        _this2.accessForbidden();
      }, 1E3);
    }
  }
};

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalCard_vue_vue_type_script_lang_js___ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalCard_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalCard_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalCard_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalCard_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalCard_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(4);

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _vuex = __webpack_require__(6);

var _Confirm = __webpack_require__(12);

var _Confirm2 = _interopRequireDefault(_Confirm);

var _AnoFiscalTipoEvento = __webpack_require__(329);

var _AnoFiscalTipoEvento2 = _interopRequireDefault(_AnoFiscalTipoEvento);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'AnoFiscalCard',
  mixins: [_AnoFiscalTipoEvento2.default],
  components: {
    Confirm: _Confirm2.default
  },
  data: function data() {
    return {
      index: 1,
      message: '',
      ano: {},
      periodo: {},
      anos: [],
      acaoFechar: function acaoFechar() {},
      resourcesAnoFiscal: this.$api.anoFiscal(this.$resource),
      resourcesOrcamentoTipoVerba: this.$api.orcamentoTipoVerba(this.$resource),
      headers: [{ text: this.$t('label.descricao'), value: 'descricao', sortable: false }, { text: this.$t('label.data_inicio'), value: 'dataInicio', sortable: false }, { text: this.$t('label.data_fim'), value: 'dataFim', sortable: false }]
    };
  },

  props: {
    tipoVerba: null,
    habilitarBloqueio: {
      type: Boolean,
      default: false
    },
    habilitarFechamento: {
      type: Boolean,
      default: false
    },
    habilitarPeriodosOrcamento: {
      type: Boolean,
      default: true
    }
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('roles', ['getAllRoles']), {
    canPeriodoFiscal: function canPeriodoFiscal() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el === 'PERIODO_FISCAL';
      }).length;
    },
    headersPeriodo: function headersPeriodo() {
      var headers = (0, _assign2.default)([], this.headers);
      if (this.canPeriodoFiscal) {
        headers.push({ text: '', value: 'acoes', sortable: false });
      }
      return headers;
    },
    exibirNovo: function exibirNovo() {
      return this.index >= this.anos.length;
    },
    anoFiscal: function anoFiscal() {
      if (this.exibirNovo) return { descricao: this.$tc('label.novo', 1) };
      return this.anos[this.index];
    },
    anoFiscalBloqueado: function anoFiscalBloqueado() {
      return this.anoFiscal.status === 'VIGENTE_COM_BLOQUEIO';
    },
    anoFiscalVigente: function anoFiscalVigente() {
      return this.anoFiscal.status === 'VIGENTE_COM_BLOQUEIO' || this.anoFiscal.status === 'VIGENTE';
    },
    traduzStatus: function traduzStatus() {
      return this.$tc('label.status_ano_fiscal.' + this.anoFiscal.status, 1);
    },
    habilitarVoltar: function habilitarVoltar() {
      return this.index > 0 && !!this.anos.length;
    },
    habilitarProximo: function habilitarProximo() {
      return this.index < this.anos.length;
    },
    temProximo: function temProximo() {
      return this.index < this.anos.length - 1;
    }
  }),
  methods: {
    periodoVigente: function periodoVigente(status) {
      return status === 'VIGENTE_COM_BLOQUEIO' || status === 'VIGENTE';
    },
    periodoBloqueado: function periodoBloqueado(status) {
      return status === 'VIGENTE_COM_BLOQUEIO';
    },
    tratarStatus: function tratarStatus(status) {
      return this.$tc('label.status_ano_fiscal.' + status, 1);
    },
    voltarAno: function voltarAno() {
      this.index = this.index - 1;
    },
    proximoAno: function proximoAno() {
      this.index = this.index + 1;
    },
    formatarData: function formatarData(valor) {
      return (0, _moment2.default)(valor).format('DD/MM/YYYY');
    },
    carregarAnoFiscal: function carregarAnoFiscal() {
      var _this = this;

      if (!this.tipoVerba) return;
      this.idTipoVerba = this.tipoVerba.id;
      if (!this.naoLimparMensagem) {
        this.mensagem = '';
      }
      this.naoLimparMensagem = false;
      this.resourcesAnoFiscal.pesquisarPorTipo({ idTipoVerba: this.tipoVerba.id }).then(this.tratarRetorno).catch(function (err) {
        _this.$error(_this, err);
      });
    },
    tratarRetorno: function tratarRetorno(res) {
      var _this2 = this;

      this.anos = res.body;
      this.anos.forEach(function (a, i) {
        if (a.status === 'VIGENTE' || a.status === 'VIGENTE_COM_BLOQUEIO') _this2.index = i;
      });
    },
    fecharPeriodoAno: function fecharPeriodoAno() {
      this.fecharPeriodo(this.tipoVerba.id, this.periodo.id);
    },
    fecharPeriodoConfirmacao: function fecharPeriodoConfirmacao(item) {
      this.periodo = item;
      this.acaoFechar = this.fecharPeriodoAno;
      this.message = this.$t('message.fechamento_periodo_fiscal');
      this.$refs.confirmDialog.open();
    },
    fecharAno: function fecharAno() {
      if (this.temProximo) {
        this.fecharAnoFiscal(this.tipoVerba.id, this.ano.id);
      } else {
        this.novo('novoFecharAnoFiscal', this.ano.id);
      }
    },
    fecharConfirmacao: function fecharConfirmacao(item) {
      this.ano = item;
      this.acaoFechar = this.fecharAno;
      this.message = this.$t('message.fechamento_ano_fiscal');
      this.$refs.confirmDialog.open();
    },
    novo: function novo(rota, idAnoFechar) {
      var param = {
        name: rota,
        params: {
          tipo: this.tipoVerba.id
        }
      };
      if (idAnoFechar) {
        param.params.idAnoFechar = idAnoFechar;
      }
      this.$router.push(param);
    }
  },
  mounted: function mounted() {
    this.carregarAnoFiscal();
  }
};

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'AnoFiscalTipoEvento',
  data: function data() {
    return {
      resources: this.$api.origemVerba(this.$resource),
      idTipoVerba: null
    };
  },

  computed: {
    mensagem: {
      get: function get() {
        var anosFiscal = this.$store.state.store.anoFiscal.anoFiscal;
        if (anosFiscal[this.idTipoVerba]) return anosFiscal[this.idTipoVerba].mensagem;
        return anosFiscal.mensagem;
      },
      set: function set(valor) {
        this.alterarMensagem({ idTipoVerba: this.idTipoVerba, mensagem: valor });
      }
    },
    naoLimparMensagem: {
      get: function get() {
        var anosFiscal = this.$store.state.store.anoFiscal.anoFiscal;
        if (anosFiscal[this.idTipoVerba]) return anosFiscal[this.idTipoVerba].naoLimparMensagem;
        return anosFiscal.naoLimparMensagem;
      },
      set: function set(valor) {
        this.alterarNaoLimparMensagem({
          idTipoVerba: this.idTipoVerba,
          naoLimparMensagem: valor
        });
      }
    },
    executandoProcedimento: function executandoProcedimento() {
      return !!this.mensagem;
    }
  },
  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('anoFiscal', ['alterarMensagem', 'alterarNaoLimparMensagem']), {
    fecharAnoFiscal: function fecharAnoFiscal(id, idEntidade) {
      this.fechar({ id: id, idEntidade: idEntidade, entidade: 'ANO' });
    },
    fecharPeriodo: function fecharPeriodo(id, idEntidade) {
      this.fechar({ id: id, idEntidade: idEntidade, entidade: 'PERIODO' });
    },
    bloquearAnoFiscal: function bloquearAnoFiscal(id, idEntidade) {
      this.bloquear({ id: id, idEntidade: idEntidade, entidade: 'ANO' });
    },
    bloquearPeriodo: function bloquearPeriodo(id, idEntidade) {
      this.bloquear({ id: id, idEntidade: idEntidade, entidade: 'PERIODO' });
    },
    desbloquearAnoFiscal: function desbloquearAnoFiscal(id, idEntidade) {
      this.desbloquear({ id: id, idEntidade: idEntidade, entidade: 'ANO' });
    },
    desbloquearPeriodo: function desbloquearPeriodo(id, idEntidade) {
      this.desbloquear({ id: id, idEntidade: idEntidade, entidade: 'PERIODO' });
    },
    bloquear: function bloquear(acao) {
      acao.acao = 'BLOQUEIO';
      this.executarAcao(acao, this.$t('message.bloqueio_periodo_fiscal_enviado'));
    },
    desbloquear: function desbloquear(acao) {
      acao.acao = 'DESBLOQUEIO';
      this.executarAcao(acao, this.$t('message.desbloqueio_periodo_fiscal_enviado'));
    },
    fechar: function fechar(acao) {
      acao.acao = 'FECHAMENTO';
      this.executarAcao(acao, this.$t('message.fechamento_periodo_fiscal_enviado'));
    },
    executarAcao: function executarAcao(acao, mensagem) {
      var _this = this;

      this.resources.executarAcao(acao, acao).then(function () {
        _this.mensagem = mensagem;
        _this.naoLimparMensagem = true;
        _this.$forceUpdate();
      }, function (err) {
        _this.$error(_this, err);
      });
    }
  })
};

/***/ }),
/* 330 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalForm_vue_vue_type_script_lang_js___ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalForm_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalForm_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalForm_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalForm_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalForm_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(9);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _dateUtils = __webpack_require__(30);

var _AnoFiscalPeriodos = __webpack_require__(1049);

var _AnoFiscalPeriodos2 = _interopRequireDefault(_AnoFiscalPeriodos);

var _AnoFiscalPeriodosOrcamento = __webpack_require__(1053);

var _AnoFiscalPeriodosOrcamento2 = _interopRequireDefault(_AnoFiscalPeriodosOrcamento);

var _AnoFiscalTipoEvento = __webpack_require__(329);

var _AnoFiscalTipoEvento2 = _interopRequireDefault(_AnoFiscalTipoEvento);

var _Confirm = __webpack_require__(12);

var _Confirm2 = _interopRequireDefault(_Confirm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'AnoFiscalForm',
  mixins: [_AnoFiscalTipoEvento2.default],
  data: function data() {
    var _this = this;

    return {
      anoFiscal: {},
      periodos: [],
      periodosOrcamento: [],
      periodosSincronizados: false,
      tipo: {},
      tipoOrcamento: {},
      menuDataInicio: false,
      dataPrevistaFim: '',
      qtdDiasAddDataInicio: 0,
      dataInicio: {
        type: String,
        default: null
      },
      formato: 'YYYY-MM-DD',
      formatoSalvar: 'YYYY-MM-DD',
      rules: {
        required: function required(value) {
          return !!value || _this.$t('message.campo_obrigatorio');
        },
        validDate: function validDate(value) {
          return !value || value.length === 10 && _this.moment(value, 'DD-MM-YYYY').isValid() || _this.$t('message.data_invalida');
        }
      },
      resourcesAnoFiscal: this.$api.anoFiscal(this.$resource),
      resourcesOrcamentoTipoVerba: this.$api.orcamentoTipoVerba(this.$resource)
    };
  },

  computed: {
    dataInicioFormatada: {
      get: function get() {
        return (0, _dateUtils.formatDateDDMMYYYY)(this.dataInicio);
      },
      set: function set(newValue) {
        this.dataInicio = parseDateYYYYMMDD(newValue);
      }
    }
  },
  props: {
    somenteLeitura: {
      type: Boolean,
      default: false
    },
    fecharDepoisSalvar: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    tratarAlteracaoPeriodo: function tratarAlteracaoPeriodo(dataFim) {
      if (dataFim > this.anoFiscal.dataPrevistaFim) {
        this.anoFiscal.dataPrevistaFim = dataFim;
        this.dataPrevistaFim = (0, _dateUtils.formatDateDDMMYYYY)(this.anoFiscal.dataPrevistaFim);
        if (this.periodosSincronizados) {
          this.periodosOrcamento = [].concat((0, _toConsumableArray3.default)(this.$refs.periodos.periodos));
        }
      }
    },
    sincronizacaoPeriodos: function sincronizacaoPeriodos(sincronizarPeriodos) {
      if (sincronizarPeriodos) {
        this.periodosOrcamento = [].concat((0, _toConsumableArray3.default)(this.$refs.periodos.periodos));
      }
      this.periodosSincronizados = sincronizarPeriodos;
    },
    openSaveDialog: function openSaveDialog() {
      this.$refs.confirmDialog.open();
    },
    openDialog: function openDialog(ref) {
      this.$refs[ref].open();
    },
    validarAno: function validarAno() {
      var _this2 = this;

      this.$validator.validateAll().then(function (isValid) {
        var periodoPreenchido = _this2.$refs.periodos.getPeriodos().length > 0;
        if (!isValid || !periodoPreenchido) {
          return;
        }
        _this2.openSaveDialog();
      }).catch();
    },
    montarAno: function montarAno() {
      this.idOrigemVerba = this.$route.params.tipo;
      this.mensagem = '';
      this.anoFiscal.idTipoVerba = this.$route.params.tipo;
      this.anoFiscal.descricao = this.$tc('label.ano_fiscal') + ' ' + this.anoAtual();
      this.anoFiscal.dataInicio = this.hoje();
      this.dataInicio = this.anoFiscal.dataInicio;
      this.anoFiscal.dataPrevistaFim = '';
      this.buscarTipo();
    },
    hoje: function hoje() {
      return (0, _moment2.default)().format(this.formatoSalvar);
    },
    plusOneDay: function plusOneDay(data) {
      return this.plusNDay(data, 1);
    },
    plusNDay: function plusNDay(data, qtd) {
      return (0, _moment2.default)(data, this.formatoSalvar).add(qtd, 'day').add(1, 'hour').format(this.formatoSalvar);
    },
    anoAtual: function anoAtual() {
      return (0, _moment2.default)().format('YYYY');
    },
    cancel: function cancel() {
      this.$router.push({ name: 'ano-fiscal' });
    },
    save: function save() {
      var _this3 = this;

      this.resourcesAnoFiscal.gravar(this.prepararAnoSalvar()).then(function () {
        if (_this3.fecharDepoisSalvar) {
          _this3.fecharAnoFiscal(_this3.$route.params.tipo, _this3.$route.params.idAnoFechar);
        }
        _this3.$toast.create(_this3.$t('message.adicionado_confira_tabela'), 'snack', 5E3);
        _this3.$router.push({ name: 'ano-fiscal' });
      }).catch(function (err) {
        _this3.$error(_this3, err);
      });
    },
    alterarFormatoSalvar: function alterarFormatoSalvar(data) {
      return (0, _moment2.default)(data, this.formato).format(this.formatoSalvar);
    },
    prepararAnoSalvar: function prepararAnoSalvar() {
      var anoSalvar = {};
      anoSalvar.idTipoVerba = this.anoFiscal.idTipoVerba;
      anoSalvar.descricao = this.anoFiscal.descricao;
      anoSalvar.dataInicio = this.alterarFormatoSalvar(this.dataInicio);
      anoSalvar.dataPrevistaFim = this.alterarFormatoSalvar(this.anoFiscal.dataPrevistaFim);
      anoSalvar.periodos = [].concat((0, _toConsumableArray3.default)(this.$refs.periodos.getPeriodos()));
      anoSalvar.periodosOrcamento = [].concat((0, _toConsumableArray3.default)(this.$refs.periodosOrcamento.getPeriodos()));
      return anoSalvar;
    },
    buscarTipo: function buscarTipo() {
      var _this4 = this;

      this.resourcesOrcamentoTipoVerba.buscarTipoVerba({ id: this.anoFiscal.idTipoVerba }).then(function (res) {
        _this4.tipo = res.data;
      }, function (err) {
        _this4.$error(_this4, err);
        _this4.cancel();
      });
    },
    preencherDataInicio: function preencherDataInicio() {
      var _this5 = this;

      this.resourcesOrcamentoTipoVerba.ultimoAno({ id: this.anoFiscal.idTipoVerba }).then(function (res) {
        if (res.data && !_this5.fecharDepoisSalvar) {
          _this5.anoFiscal.dataInicio = _this5.plusOneDay(res.data.dataPrevistaFim);
        } else {
          _this5.anoFiscal.dataInicio = _this5.plusNDay(_this5.hoje());
        }
        _this5.dataInicio = _this5.anoFiscal.dataInicio;
        _this5.$forceUpdate();
      }, function (err) {
        _this5.$error(_this5, err);
        _this5.cancel();
      });
    }
  },
  components: {
    Confirm: _Confirm2.default,
    AnoFiscalPeriodos: _AnoFiscalPeriodos2.default,
    AnoFiscalPeriodosOrcamento: _AnoFiscalPeriodosOrcamento2.default
  },
  beforeMount: function beforeMount() {
    this.montarAno();
  },
  mounted: function mounted() {
    this.buscarTipo();
    this.preencherDataInicio();
  }
};

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalPeriodos_vue_vue_type_script_lang_js___ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalPeriodos_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalPeriodos_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalPeriodos_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalPeriodos_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalPeriodos_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _dateUtils = __webpack_require__(30);

var _InputDatepicker = __webpack_require__(56);

var _InputDatepicker2 = _interopRequireDefault(_InputDatepicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'AnoFiscalPeriodos',
  props: {
    periodos: {
      type: Array
    },
    somenteLeitura: {
      type: Boolean,
      default: false
    },
    dataInicio: {
      type: String,
      default: null
    }
  },
  components: {
    InputDatepicker: _InputDatepicker2.default
  },
  data: function data() {
    var _this = this;

    return {
      periodosSelecionados: [],
      menuDataInicio: false,
      menuDataFim: false,
      formatoSalvar: 'YYYY-MM-DD',
      dataInicioPeriodo: this.dataInicio,
      periodo: {
        descricao: null,
        dataInicio: '',
        dataFim: ''
      },
      headers: [{ text: this.$t('label.descricao'), value: 'descricao', sortable: false }, { text: this.$t('label.data_inicio'), value: 'dataInicio', sortable: false }, { text: this.$t('label.data_fim'), value: 'dataFim', sortable: false }],
      rules: {
        required: function required(value) {
          return !!value || _this.$t('message.campo_obrigatorio');
        },
        validDate: function validDate(value) {
          return !value || value.length === 10 && _this.moment(value, 'DD-MM-YYYY').isValid() || _this.$t('message.data_invalida');
        }
      }
    };
  },

  watch: {
    dataInicio: function dataInicio(valor) {
      this.dataInicioPeriodo = valor;
    }
  },
  methods: {
    formatDateDDMMYYYY: _dateUtils.formatDateDDMMYYYY,
    validar: function validar() {
      if (this.periodos.length === 0) {
        this.$toast.create(this.$t('errors.meta.intervalos.obrigatorios'), 'snack', 3E3);
        return false;
      }
      return true;
    },
    getPeriodos: function getPeriodos() {
      var _this2 = this;

      var periodosSalvar = [];
      this.periodos.forEach(function (el) {
        periodosSalvar.push(_this2.prepararPeriodoSalvar(el));
      });
      return periodosSalvar;
    },
    limparForm: function limparForm() {
      this.$refs.descricaoAnoPeriodo.reset();
      this.$refs.anoPeriodoDataInicio.reset();
      this.$refs.anoPeriodoDataFim.reset();
    },
    prepararPeriodoSalvar: function prepararPeriodoSalvar(periodo) {
      var periodoSalvar = {};
      periodoSalvar.descricao = periodo.descricao;
      periodoSalvar.dataFim = this.alterarFormatoSalvar(periodo.dataFim);
      periodoSalvar.dataInicio = this.alterarFormatoSalvar(periodo.dataInicio);
      periodoSalvar.tipo = 'PLANEJAMENTO_ACAO';

      return periodoSalvar;
    },
    incluirPeriodo: function incluirPeriodo() {
      var valid = this.$refs.descricaoAnoPeriodo.validate(true);
      valid = this.$refs.anoPeriodoDataFim.validate(true) && this.$refs.anoPeriodoDataInicio.validate(true) && valid;
      if (valid) {
        this.periodos.push({
          descricao: this.periodo.descricao,
          dataInicio: this.periodo.dataInicio,
          dataFim: this.periodo.dataFim
        });

        this.limparPeriodo();
        this.arrumarLista();
        this.emitirNotificacaoAlteracao();
      }
    },
    emitirNotificacaoAlteracao: function emitirNotificacaoAlteracao() {
      if (this.periodos.length) {
        this.$emit('PERIODO_INCLUIDO_OU_EXCLUIDO', this.periodos[this.periodos.length - 1].dataFim);
      } else {
        this.$emit('PERIODO_INCLUIDO_OU_EXCLUIDO', null);
      }
    },
    alterarFormatoSalvar: function alterarFormatoSalvar(data) {
      return (0, _moment2.default)(data, this.formatoSalvar).format(this.formatoSalvar);
    },
    isAfter: function isAfter(data, outra) {
      return (0, _moment2.default)(data, this.formatoSalvar).isAfter((0, _moment2.default)(outra, this.formatoSalvar));
    },
    arrumarLista: function arrumarLista() {
      var _this3 = this;

      this.periodos.sort(function (a, b) {
        return _this3.isAfter(a.dataInicio, b.dataInicio);
      });
    },
    limparPeriodo: function limparPeriodo() {
      this.periodo.descricao = '';
      this.periodo.dataInicio = '';
      this.periodo.dataFim = '';
      this.limparForm();
    },
    preencherSelecionado: function preencherSelecionado(index) {
      var periodo = this.periodos[index];
      if (periodo) {
        periodo.index = index;
        this.periodosSelecionados.push(periodo);
      }
    },
    remover: function remover() {
      var _this4 = this;

      var index = [];
      this.periodosSelecionados.forEach(function (el) {
        _this4.periodos.forEach(function (p, i) {
          if (p.dataInicio === el.dataInicio && p.dataFim === el.dataFim && p.descricao === el.descricao) {
            index.push(i);
          }
        });
      });

      index.forEach(function (el) {
        return _this4.periodos.splice(el, 1);
      });
      this.periodosSelecionados = [];
      this.arrumarLista();
      this.emitirNotificacaoAlteracao();
    }
  },
  computed: {
    dataInicioFormatada: {
      get: function get() {
        return (0, _dateUtils.formatDateDDMMYYYY)(this.periodo.dataInicio);
      },
      set: function set(newValue) {
        this.periodo.dataInicio = (0, _dateUtils.parseDateYYYYMMDD)(newValue);
      }
    },
    dataInicioPicker: {
      get: function get() {
        return this.periodo.dataInicio ? this.periodo.dataInicio : this.dataInicio;
      },
      set: function set(newValue) {
        this.periodo.dataInicio = newValue;
        if (this.isAfter(this.periodo.dataInicio, this.periodo.dataFim)) {
          this.periodo.dataFim = '';
        }
      }
    },
    dataFimFormatada: {
      get: function get() {
        return (0, _dateUtils.formatDateDDMMYYYY)(this.periodo.dataFim);
      },
      set: function set(newValue) {
        this.periodo.dataFim = (0, _dateUtils.parseDateYYYYMMDD)(newValue);
      }
    },
    dataFimPicker: {
      get: function get() {
        return this.periodo.dataFim ? this.periodo.dataFim : this.periodo.dataInicio;
      },
      set: function set(newValue) {
        this.periodo.dataFim = newValue;
      }
    },
    isContentAvailable: function isContentAvailable() {
      return this.periodos.length > 0;
    },
    hojeYYYYMMD: function hojeYYYYMMD() {
      return [(0, _moment2.default)().format('YYYY-MM-D')];
    },
    hasPeriodosSelecionados: function hasPeriodosSelecionados() {
      return this.periodosSelecionados.length;
    }
  }
};

/***/ }),
/* 335 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalPeriodosOrcamento_vue_vue_type_script_lang_js___ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalPeriodosOrcamento_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalPeriodosOrcamento_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalPeriodosOrcamento_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalPeriodosOrcamento_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalPeriodosOrcamento_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _dateUtils = __webpack_require__(30);

var _InputDatepicker = __webpack_require__(56);

var _InputDatepicker2 = _interopRequireDefault(_InputDatepicker);

var _Confirm = __webpack_require__(12);

var _Confirm2 = _interopRequireDefault(_Confirm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'AnoFiscalPeriodosOrçamento',
  props: {
    periodos: {
      type: Array
    },
    somenteLeitura: {
      type: Boolean,
      default: false
    },
    dataInicio: {
      type: String,
      default: null
    }
  },
  components: {
    InputDatepicker: _InputDatepicker2.default,
    Confirm: _Confirm2.default
  },
  data: function data() {
    var _this = this;

    return {
      periodosSelecionados: [],
      menuDataInicio: false,
      menuDataFim: false,
      formatoSalvar: 'YYYY-MM-DD',
      dataInicioPeriodo: this.dataInicio,
      periodo: {
        descricao: null,
        dataInicio: '',
        dataFim: ''
      },
      igualAoPlanejamento: false,
      dialog: {
        content: ''
      },
      headers: [{ text: this.$t('label.descricao'), value: 'descricao', sortable: false }, { text: this.$t('label.data_inicio'), value: 'dataInicio', sortable: false }, { text: this.$t('label.data_fim'), value: 'dataFim', sortable: false }],
      rules: {
        required: function required(value) {
          return !!value || _this.$t('message.campo_obrigatorio');
        },
        validDate: function validDate(value) {
          return !value || value.length === 10 && _this.moment(value, 'DD-MM-YYYY').isValid() || _this.$t('message.data_invalida');
        }
      }
    };
  },

  watch: {
    dataInicio: function dataInicio(valor) {
      this.dataInicioPeriodo = valor;
    }
  },
  methods: {
    formatDateDDMMYYYY: _dateUtils.formatDateDDMMYYYY,
    validar: function validar() {
      if (this.periodos.length === 0) {
        this.$toast.create(this.$t('errors.meta.intervalos.obrigatorios'), 'snack', 3E3);
        return false;
      }
      return true;
    },
    getPeriodos: function getPeriodos() {
      var _this2 = this;

      var periodosSalvar = [];
      this.periodos.forEach(function (el) {
        periodosSalvar.push(_this2.prepararPeriodoSalvar(el));
      });
      return periodosSalvar;
    },
    possuiPeriodos: function possuiPeriodos() {
      return this.periodos && this.periodos.length > 0;
    },
    limparForm: function limparForm() {
      this.$refs.descricaoAnoPeriodo.reset();
      this.$refs.anoPeriodoDataInicio.reset();
      this.$refs.anoPeriodoDataFim.reset();
    },
    changeIgualPlanejamento: function changeIgualPlanejamento() {
      if (this.igualAoPlanejamento) {
        this.dialog.content = this.$t('message.advertencia_periodos_iguais');
        this.$refs.confirmDialog.open();
      } else {
        this.$emit('SINCRONIZACAO_PERIODOS', false);
      }
    },
    tratarPeriodosIguais: function tratarPeriodosIguais() {
      this.$emit('SINCRONIZACAO_PERIODOS', true);
    },
    reverterOpcao: function reverterOpcao() {
      this.igualAoPlanejamento = !this.igualAoPlanejamento;
    },
    prepararPeriodoSalvar: function prepararPeriodoSalvar(periodo) {
      var periodoSalvar = {};
      periodoSalvar.descricao = periodo.descricao;
      periodoSalvar.dataFim = this.alterarFormatoSalvar(periodo.dataFim);
      periodoSalvar.dataInicio = this.alterarFormatoSalvar(periodo.dataInicio);
      periodoSalvar.tipo = 'PLANEJAMENTO_ORCAMENTARIO';

      return periodoSalvar;
    },
    incluirPeriodo: function incluirPeriodo() {
      var valid = this.$refs.descricaoAnoPeriodo.validate(true);
      valid = this.$refs.anoPeriodoDataFim.validate(true) && valid;
      if (valid) {
        if (!this.periodos.length) {
          this.periodo.dataInicio = this.dataInicio;
        }
        this.periodos.push({
          descricao: this.periodo.descricao,
          dataInicio: this.periodo.dataInicio,
          dataFim: this.periodo.dataFim
        });

        this.limparPeriodo();
        this.arrumarLista();
        this.emitirNotificacaoAlteracao();
      }
    },
    emitirNotificacaoAlteracao: function emitirNotificacaoAlteracao() {
      if (this.periodos.length) {
        this.$emit('PERIODO_INCLUIDO_OU_EXCLUIDO', this.periodos[this.periodos.length - 1].dataFim);
      } else {
        this.$emit('PERIODO_INCLUIDO_OU_EXCLUIDO', null);
      }
    },
    alterarFormatoSalvar: function alterarFormatoSalvar(data) {
      return (0, _moment2.default)(data, this.formatoSalvar).format(this.formatoSalvar);
    },
    isAfter: function isAfter(data, outra) {
      return (0, _moment2.default)(data, this.formatoSalvar).isAfter((0, _moment2.default)(outra, this.formatoSalvar));
    },
    arrumarLista: function arrumarLista() {
      var _this3 = this;

      this.periodos.sort(function (a, b) {
        return _this3.isAfter(a.dataFim, b.dataFim);
      });
    },
    limparPeriodo: function limparPeriodo() {
      this.periodo.descricao = '';
      this.periodo.dataInicio = '';
      this.periodo.dataFim = '';
      this.limparForm();
    },
    preencherSelecionado: function preencherSelecionado(index) {
      var periodo = this.periodos[index];
      if (periodo) {
        periodo.index = index;
        this.periodosSelecionados.push(periodo);
      }
    },
    remover: function remover() {
      var _this4 = this;

      var index = [];
      this.periodosSelecionados.forEach(function (el) {
        _this4.periodos.forEach(function (p, i) {
          if (p.dataInicio === el.dataInicio && p.dataFim === el.dataFim && p.descricao === el.descricao) {
            index.push(i);
          }
        });
      });

      index.forEach(function (el) {
        return _this4.periodos.splice(el, 1);
      });
      this.periodosSelecionados = [];
      this.arrumarLista();
      this.emitirNotificacaoAlteracao();
    }
  },
  computed: {
    dataInicioFormatada: {
      get: function get() {
        return (0, _dateUtils.formatDateDDMMYYYY)(this.periodo.dataInicio);
      },
      set: function set(newValue) {
        this.periodo.dataInicio = (0, _dateUtils.parseDateYYYYMMDD)(newValue);
      }
    },
    dataInicioPicker: {
      get: function get() {
        return this.periodo.dataInicio ? this.periodo.dataInicio : this.dataInicio;
      },
      set: function set(newValue) {
        this.periodo.dataInicio = newValue;
        if (this.isAfter(this.periodo.dataInicio, this.periodo.dataFim)) {
          this.periodo.dataFim = '';
        }
      }
    },
    dataFimFormatada: {
      get: function get() {
        return (0, _dateUtils.formatDateDDMMYYYY)(this.periodo.dataFim);
      },
      set: function set(newValue) {
        this.periodo.dataFim = (0, _dateUtils.parseDateYYYYMMDD)(newValue);
      }
    },
    dataFimPicker: {
      get: function get() {
        return this.periodo.dataFim ? this.periodo.dataFim : this.periodo.dataInicio;
      },
      set: function set(newValue) {
        this.periodo.dataFim = newValue;
      }
    },
    isContentAvailable: function isContentAvailable() {
      return this.periodos.length > 0;
    },
    hojeYYYYMMD: function hojeYYYYMMD() {
      return [(0, _moment2.default)().format('YYYY-MM-D')];
    },
    hasPeriodosSelecionados: function hasPeriodosSelecionados() {
      return this.periodosSelecionados.length;
    }
  }
};

/***/ }),
/* 338 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_UploadFile_vue_vue_type_script_lang_js___ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_UploadFile_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_UploadFile_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_UploadFile_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_UploadFile_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_UploadFile_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Dropzone = __webpack_require__(708);

var _Dropzone2 = _interopRequireDefault(_Dropzone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    title: String,
    subtitle: String,
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      default: 'uploadfile-component'
    },
    numMaxArquivos: {
      type: Boolean,
      default: false
    },
    url: {
      type: String,
      required: true
    },
    acceptedFileTypes: {
      type: String
    },
    maxFileSizeInMB: {
      type: Number,
      default: 50
    },
    maxNumberOfFiles: {
      type: Number,
      default: 1
    }
  },
  components: {
    Dropzone: _Dropzone2.default
  },
  methods: {
    fileAdded: function fileAdded() {
      for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
        params[_key] = arguments[_key];
      }

      this.$emit.apply(this, ['UPLOADFILE_FILE_ADDED'].concat(params));
    },
    fileRemoved: function fileRemoved() {
      for (var _len2 = arguments.length, params = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        params[_key2] = arguments[_key2];
      }

      this.$emit.apply(this, ['UPLOADFILE_FILE_REMOVED'].concat(params));
    },
    uploadSuccess: function uploadSuccess() {
      for (var _len3 = arguments.length, params = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        params[_key3] = arguments[_key3];
      }

      this.$emit.apply(this, ['UPLOADFILE_SUCCESS'].concat(params));
    },
    uploadError: function uploadError() {
      for (var _len4 = arguments.length, params = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        params[_key4] = arguments[_key4];
      }

      this.$emit.apply(this, ['UPLOADFILE_ERROR'].concat(params));
    },
    uploadSending: function uploadSending() {
      for (var _len5 = arguments.length, params = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        params[_key5] = arguments[_key5];
      }

      this.$emit.apply(this, ['UPLOADFILE_SENDING'].concat(params));
    }
  }
};

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Dropzone_vue_vue_type_script_lang_js___ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Dropzone_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Dropzone_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Dropzone_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Dropzone_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Dropzone_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dropzone = __webpack_require__(1062);

var _dropzone2 = _interopRequireDefault(_dropzone);

var _auth = __webpack_require__(105);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_dropzone2.default.autoDiscover = false;

exports.default = {
  props: {
    id: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    numMaxArquivos: {
      type: Boolean,
      default: false
    },
    clickable: {
      type: Boolean,
      default: true
    },
    acceptedFileTypes: {
      type: String
    },
    thumbnailHeight: {
      type: Number,
      default: 200
    },
    thumbnailWidth: {
      type: Number,
      default: 200
    },
    showRemoveLink: {
      type: Boolean,
      default: true
    },
    maxFileSizeInMB: {
      type: Number,
      default: 500
    },
    maxNumberOfFiles: {
      type: Number,
      default: 1
    },
    autoProcessQueue: {
      type: Boolean,
      default: true
    },
    dropzoneOptions: {
      type: Object,
      default: function _default() {
        return null;
      }
    },
    title: {
      type: String,
      default: function _default() {
        return 'Arraste o seu arquivo aqui';
      }
    }
  },
  data: function data() {
    return {
      dropzone: null
    };
  },

  computed: {
    addIcon: function addIcon() {
      return '<i class="material-icons">add</i>';
    },
    doneIcon: function doneIcon() {
      return '<i class="material-icons">done</i>';
    },
    errorIcon: function errorIcon() {
      return '<i class="material-icons">error</i>';
    }
  },
  watch: {
    url: function url() {
      this.recreateDropzone();
    },
    id: function id() {
      this.recreateDropzone();
    },
    numMaxArquivos: function numMaxArquivos() {
      this.removeAllFiles();
    }
  },
  methods: {
    removeAllFiles: function removeAllFiles() {
      this.dropzone.removeAllFiles(true);
    },
    processQueue: function processQueue() {
      this.dropzone.processQueue();
    },
    recreateDropzone: function recreateDropzone() {
      this.dropzone.destroy();
      this.dropzone = null;
      document.querySelector('#' + this.id).innerHTML = '';
      this.initDropzone();
    },
    createDropzoneElement: function createDropzoneElement() {
      var element = document.getElementById(this.id);
      if (!element) {
        element = this.$refs.entrypoint.querySelector('form');
      }
      return element;
    },
    createDropzone: function createDropzone() {
      var element = this.createDropzoneElement();
      this.dropzone = !this.dropzoneOptions ? new _dropzone2.default(element, {
        addRemoveLinks: this.showRemoveLink,
        acceptedMimeTypes: this.acceptedFileTypes,
        autoProcessQueue: this.autoProcessQueue,
        clickable: this.clickable,
        dictCancelUpload: 'Cancelar',
        dictCancelUploadConfirmation: 'Tem certeza que deseja cancelar o envio?',
        dictDefaultMessage: this.title + '<br>' + this.addIcon,
        dictFallbackMessage: 'O seu browser não suporta esta feature. Use o Google Chrome.',

        dictFileTooBig: 'O arquivo \xE9 muito grande! O m\xE1ximo suportado \xE9 ' + this.maxFileSizeInMB + 'MB',
        dictInvalidFileType: 'Este arquivo n\xE3o \xE9 suportado. Os tipos aceitos s\xE3o: ' + this.acceptedFileTypes,
        dictMaxFilesExceeded: 'O n\xFAmero m\xE1ximo de arquivos para envio \xE9: ' + this.maxNumberOfFiles + '.',
        dictResponseError: 'Erro no nosso servidor. Reenvie o arquivo.',
        dictRemoveFile: 'Remover arquivo',
        maxFiles: this.maxNumberOfFiles,
        maxFilesize: this.maxFileSizeInMB,
        accept: function accept(file, done) {
          if (_auth.auth.isTokenExpired()) {
            _auth.auth.refreshToken().then(function () {
              return done();
            });
          } else {
            done();
          }
        },
        previewTemplate: '\n              <div class="dz-preview dz-file-preview">\n                <div class="dz-image" style="width: ' + this.thumbnailWidth + 'px; height:' + this.thumbnailHeight + 'px">\n                  <img data-dz-thumbnail />\n                </div>\n                <div class="dz-details">\n                  <div class="dz-size">\n                    <span data-dz-size></span>\n                  </div>\n                  <div class="dz-filename">\n                    <span data-dz-name></span>\n                  </div>\n                </div>\n                <div class="dz-progress">\n                  <span class="dz-upload" data-dz-uploadprogress></span>\n                </div>\n                <div class="dz-error-message">\n                  <span data-dz-errormessage></span>\n                </div>\n                <div class="dz-success-mark">' + this.doneIcon + '</div>\n                <div class="dz-error-mark">' + this.errorIcon + '</div>\n              </div>',
        thumbnailWidth: this.thumbnailWidth,
        thumbnailHeight: this.thumbnailHeight
      }) : new _dropzone2.default(element, this.dropzoneOptions);
    },
    initDropzone: function initDropzone() {
      this.createDropzone();
      this.registerDropzoneEvents();
    },
    removeFile: function removeFile(file) {
      this.dropzone.removeFile(file);
    },
    registerDropzoneEvents: function registerDropzoneEvents() {
      var _this = this;

      this.dropzone.on('addedfile', function (file) {
        _this.$emit('UPLOADFILE_FILE_ADDED', file);
      });

      this.dropzone.on('maxfilesexceeded', function (file) {
        _this.dropzone.removeFile(file);
      });

      this.dropzone.on('removedfile', function (file) {
        _this.$emit('UPLOADFILE_FILE_REMOVED', file);
      });

      this.dropzone.on('success', function (file, response) {
        _this.$emit('UPLOADFILE_SUCCESS', file, response);
        setTimeout(function () {
          _this.dropzone.removeFile(file);
        }, 3E3);
      });

      this.dropzone.on('error', function (file, error, xhr) {
        _this.$emit('UPLOADFILE_ERROR', file, error, xhr);
      });

      this.dropzone.on('sending', function (file, xhr, formData) {
        if (sessionStorage && sessionStorage.token) {
          var token = _this.$auth.token || sessionStorage.token;
          xhr.setRequestHeader('Authorization', 'Bearer ' + token);
        }
        var fn = encodeURI(file.name);
        formData.append('filename', fn);
        _this.$emit('UPLOADFILE_SENDING', file, xhr, formData);
      });
    },
    startComponent: function startComponent() {
      this.initDropzone();
    }
  },
  mounted: function mounted() {
    this.startComponent();
  }
};

/***/ }),
/* 343 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetasCrescimento_vue_vue_type_script_lang_js___ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetasCrescimento_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetasCrescimento_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetasCrescimento_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetasCrescimento_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetasCrescimento_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _numeric = __webpack_require__(83);

exports.default = {
  name: 'MetasCrescimento',
  props: {
    pendencia: null,
    isActivatorInput: true
  },
  data: function data() {
    return {
      menu: false,
      item: 'attach_money',
      items: ['attach_money']
    };
  },
  methods: {
    headers: function headers() {
      return [{ text: this.$t('label.meta_de'), value: 'meta_de', sortable: false, align: 'center' }, { text: this.$t('label.meta_ate'), value: 'meta_ate', sortable: false, align: 'center' }, { text: this.$t('label.bonificacao_pagamento'), value: 'bonificacao_pagamento', sortable: false, align: 'center' }];
    },
    exibirMeta: function exibirMeta(valor) {
      if (this.pendencia.ehValor) {
        return (0, _numeric.convertToMoney)(valor);
      }
      return (0, _numeric.convertToNumberFormat)(valor);
    },
    exibirPagamento: function exibirPagamento(valor) {
      if (this.pendencia.ehPercentual) {
        return (0, _numeric.convertToPercent)(valor);
      }
      return (0, _numeric.convertToMoney)(valor);
    }
  }
};

/***/ }),
/* 346 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 347 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ExecucaoSidebar_vue_vue_type_script_lang_js___ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ExecucaoSidebar_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ExecucaoSidebar_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ExecucaoSidebar_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ExecucaoSidebar_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ExecucaoSidebar_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _UploadFile = __webpack_require__(37);

var _UploadFile2 = _interopRequireDefault(_UploadFile);

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

var _downloads = __webpack_require__(54);

var _downloads2 = _interopRequireDefault(_downloads);

var _rolesComputedGenerator = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      execucaoResources: this.$api.execucao(this.$resource),
      arquivosSuportados: 'application/pdf',
      evidencias: [],
      execucaoSelecionada: null,
      drawer: false
    };
  },

  props: {
    maxFileSizeInMB: {
      type: Number,
      default: 10
    },
    idMeta: {
      type: Number,
      default: 0
    },
    status: {
      type: String,
      default: ''
    },
    referencia: {
      type: String,
      default: ''
    },
    deletar: {
      type: Boolean,
      default: false
    },
    tela: {
      type: String,
      default: 'APURACAO'
    }
  },
  watch: {
    idMeta: function idMeta(value) {
      this.idMeta = value;
      this.listarEvidencias();
    },
    status: function status(value) {
      this.status = value;
    },
    deletar: function deletar(value) {
      this.deletar = value;
    },
    referencia: function referencia(valor) {
      this.referencia = valor;
    }
  },
  computed: (0, _extends3.default)({
    importUrlExcucaoMetas: function importUrlExcucaoMetas() {
      var urlUpload = (0, _apiResource2.default)('execucao', 'execucao');
      return urlUpload + '/upload?id_meta';
    },
    uploadFileMetaDropzoneId: function uploadFileMetaDropzoneId() {
      return 'myVueDropzone' + (Math.random() * Math.random() * 100).toString().replace('.', '');
    },
    showImport: function showImport() {
      return this.idMeta !== 0;
    },
    permiteUpload: function permiteUpload() {
      return ['AGUARDANDO_APURACAO', 'EM_CADASTRO', 'EM_ANALISE'].includes(this.status);
    },
    possuiEvidencias: function possuiEvidencias() {
      return this.evidencias && this.evidencias.length !== 0;
    },
    permiteDeletar: function permiteDeletar() {
      return this.deletar !== false && this.canAccessUpload;
    }
  }, (0, _rolesComputedGenerator.generateComputed)('EXECUCAO', ['canEdit']), {
    canAccessUpload: function canAccessUpload() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el === 'APU_UPLOAD';
      }).length;
    },
    canAccessDownload: function canAccessDownload() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el === 'APU_DOWNLOAD';
      }).length;
    }
  }),
  components: {
    UploadFile: _UploadFile2.default
  },
  methods: {
    close: function close() {
      this.$emit('EXECUCAOSIDEBAR_CLOSE');
    },
    open: function open(ref) {},
    toggle: function toggle() {
      this.drawer = !this.drawer;
    },
    closeDialog: function closeDialog(ref, cb) {
      this.$refs[ref].close();
      if (cb) {
        cb();
      }
    },
    openConfirmDialog: function openConfirmDialog(row) {
      this.execucaoSelecionada = row;
      this.$refs.confirmDialog.open();
    },
    listarEvidencias: function listarEvidencias(callback) {
      var _this = this;

      if (this.idMeta === 0 || !this.canAccessDownload) {
        return;
      }
      var id = this.idMeta;
      this.execucaoResources.listar({ id: id }, { id: id }).then(function (response) {
        _this.evidencias = response.data;
        if (!_this.evidencias.length && callback) {
          callback();
        }
      }).catch(function (err) {
        _this.$toast.create(err.data.error, 'snack', 3E3);
      });
    },
    removerEvidencia: function removerEvidencia() {
      var _this2 = this;

      var callback = function callback() {
        return _this2.$emit('ARQUIVO_REMOVIDO', _this2.referencia);
      };
      if (this.execucaoSelecionada) {
        var idExecucao = this.execucaoSelecionada.id;
        this.execucaoResources.remover({ idExecucao: idExecucao }, { idExecucao: idExecucao }).then(function () {
          _this2.$toast.create(_this2.$t('message.execucao_removida') || msg, 'snack', 5E3);
          _this2.listarEvidencias(callback);
        }).catch(function (err) {
          _this2.$toast.create(err.data.error, 'snack', 3E3);
        });
      }
    },
    uploadMetaSuccess: function uploadMetaSuccess(object, msg) {
      this.$toast.create(this.$t('message.execucao_metas') || msg, 'snack', 5E3);
      this.listarEvidencias();
      this.$emit('EXECUCAOSIDEBAR_REFRESH_APURACAO', this.referencia);
    },
    uploadError: function uploadError(file, msg) {
      var acepted = file.accepted;
      if (!acepted) {
        this.$refs.dropZoneReivindicacao.numMaxArquivos = true;
        this.$toast.create(this.$t(msg.erros[0]) || this.$t('message.erro_tente_importar_novamente'), 'snack', 5E3);
      }
      this.$toast.create(this.$t(msg.erros[0]) || this.$t('message.erro_tente_importar_novamente'), 'snack', 5E3);
    },
    visualizarArquivo: function visualizarArquivo(row) {
      var _this3 = this;

      var getBasePath = (0, _apiResource2.default)('execucao', 'execucao');
      var resource = (0, _downloads2.default)(this.$http);

      resource.downloadGetAba(getBasePath, {
        param: '',
        url: row.id + '/pdf'
      }).then(function () {}).catch(function () {
        _this3.$toast.create('Erro ao exportar. Tente novamente.', 'snack', 3E3);
      });
    }
  }
};

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_StatusPassos_vue_vue_type_script_lang_js___ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_StatusPassos_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_StatusPassos_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_StatusPassos_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_StatusPassos_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_StatusPassos_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(4);

var _assign2 = _interopRequireDefault(_assign);

var _StatusPassosItem = __webpack_require__(352);

var _StatusPassosItem2 = _interopRequireDefault(_StatusPassosItem);

var _HistoricoTransferencia = __webpack_require__(1073);

var _HistoricoTransferencia2 = _interopRequireDefault(_HistoricoTransferencia);

var _helpers = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    entidade: String,
    source: {
      type: Object,
      default: {
        cabecalhoFluxo: null,
        passos: []
      }
    }
  },
  data: function data() {
    return {
      fluxoCopiado: {
        cabecalhoFluxo: null,
        passos: []
      },
      dialog: false,
      passosTransferidos: {},
      colorPalette: ['teal accent-4', 'red lighten-1', 'orange darken-2', 'amber lighten-1', 'blue-grey lighten-2', 'blue darken-1']
    };
  },

  components: {
    HistoricoTransferencia: _HistoricoTransferencia2.default,
    StatusPassosItem: _StatusPassosItem2.default
  },
  watch: {
    source: function source(val) {
      this.passosTransferidos = {};
      val.passos.filter(this.passoTemTransferencia).forEach(this.convertePassoTransferico);
    }
  },
  computed: {
    titulo: function titulo() {
      var tituloBase = this.$t('label.acompanhamento_fluxo');
      return this.source && this.source.cabecalhoFluxo ? tituloBase + '  - ' + this.source.cabecalhoFluxo.tipoFluxo : tituloBase;
    }
  },
  methods: {
    convertePassoTransferico: function convertePassoTransferico(passo) {
      var _this = this;

      passo.usuarioTransferenciaPasso.forEach(function (u) {
        var passoTrans = (0, _assign2.default)({}, passo);
        passoTrans.statusPasso = 'TRANSFERIDO';
        passoTrans.usuarioTransferenciaPasso = u;
        _this.preencherPassosTransferidos(passoTrans);
      });
    },
    preencherPassosTransferidos: function preencherPassosTransferidos(passo) {
      if (this.passosTransferidos[passo.sequencia]) {
        this.passosTransferidos[passo.sequencia].push(passo);
      } else {
        this.passosTransferidos[passo.sequencia] = [passo];
      }
    },
    passoTemTransferencia: function passoTemTransferencia(passo) {
      return passo.usuarioTransferenciaPasso && passo.usuarioTransferenciaPasso.length;
    },
    exibePasso: function exibePasso(passo) {
      return passo.statusPasso !== 'CONDICAO_NAO_ATENDIDA' && passo.statusPasso !== 'TRANSFERIDO';
    },
    styles: function styles(status) {
      var colorIndex = 0;
      if (status === 'ENCERRADO') {
        colorIndex = 5;
      } else if (status === 'EM_CADASTRO') {
        colorIndex = 4;
      } else if (status === 'EM_FLUXO') {
        colorIndex = 4;
      } else if (status === 'CANCELADO') {
        colorIndex = 3;
      } else if (status === 'AGUARDANDO_APROVACAO') {
        colorIndex = 2;
      } else if (status === 'REPROVADO') {
        colorIndex = 1;
      } else if (status === 'AGUARDANDO_EXECUCAO_METAS') {
        colorIndex = 6;
      } else if (status === 'AGUARDANDO_APURACAO') {
        colorIndex = 5;
      } else if (status === 'AGUARDANDO_PAGAMENTO') {
        colorIndex = 5;
      } else if (status === 'APURACAO_PREVIA') {
        colorIndex = 4;
      } else if (status === 'EM_ANALISE') {
        colorIndex = 3;
      } else if (status === 'EM_REIVINDICACAO') {
        colorIndex = 2;
      } else {
        colorIndex = 0;
      }

      return this.color || this.colorPalette[colorIndex];
    },
    toDate: function toDate(data) {
      return this.moment(data, 'DD/MM/YYYY hh:mm:ss').format('DD-MM-YYYY HH:mm:ss');
    },
    open: function open() {
      var _this2 = this;

      this.dialog = true;
      setTimeout(function () {
        _this2.fluxoCopiado = (0, _helpers.copyObject)(_this2.source);
        _this2.trataPassosRejeitados();
      });

      this.onOpen();
    },
    trataPassosRejeitados: function trataPassosRejeitados() {
      var _fluxoCopiado = this.fluxoCopiado,
          cabecalhoFluxo = _fluxoCopiado.cabecalhoFluxo,
          passos = _fluxoCopiado.passos;
      var statusFluxo = cabecalhoFluxo.statusFluxo;

      if (statusFluxo !== 'REPROVADO' && statusFluxo !== 'EM_ANALISE') {
        return;
      }

      var indice = 0;
      while (indice < passos.length) {
        var passoLoop = passos[indice];
        var statusPasso = passoLoop.statusPasso;

        if (statusPasso === statusFluxo) {
          break;
        }
        indice += 1;
      }

      this.fluxoCopiado.passos = passos.slice(0, indice + 1);
    },
    defaultClose: function defaultClose() {
      this.$emit('GENERICMODAL_DEFAULT_CLOSE');
      this.close();
    },
    onOpen: function onOpen() {
      this.$emit('GENERICMODAL_OPEN');
    },
    onClose: function onClose() {
      this.$emit('GENERICMODAL_CLOSE');
    },
    close: function close() {
      this.dialog = false;
      this.onClose();
    }
  }
};

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StatusPassosItem_vue_vue_type_template_id_962171be___ = __webpack_require__(1071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StatusPassosItem_vue_vue_type_script_lang_js___ = __webpack_require__(353);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__StatusPassosItem_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__StatusPassosItem_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__StatusPassosItem_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__StatusPassosItem_vue_vue_type_template_id_962171be___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__StatusPassosItem_vue_vue_type_template_id_962171be___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_StatusPassosItem_vue_vue_type_script_lang_js___ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_StatusPassosItem_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_StatusPassosItem_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_StatusPassosItem_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_StatusPassosItem_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_StatusPassosItem_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'StatusPassosItem',
  props: {
    item: null,
    cliente: null
  },
  methods: {
    aguardandoAprovacao: function aguardandoAprovacao(passo) {
      return passo.statusPasso === 'AGUARDANDO_APROVACAO';
    },
    transferido: function transferido(passo) {
      return passo.statusPasso === 'TRANSFERIDO';
    },
    toDate: function toDate(data) {
      return this.moment(data, 'DD/MM/YYYY hh:mm:ss').format('DD-MM-YYYY HH:mm:ss');
    }
  }
};

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_HistoricoTransferencia_vue_vue_type_script_lang_js___ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_HistoricoTransferencia_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_HistoricoTransferencia_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_HistoricoTransferencia_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_HistoricoTransferencia_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_HistoricoTransferencia_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _StatusPassosItem = __webpack_require__(352);

var _StatusPassosItem2 = _interopRequireDefault(_StatusPassosItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'HistoricoTransferencia',
  props: {
    passosTransferidos: {},
    sequencia: null,
    cliente: null
  },
  data: function data() {
    return {
      menu: false,
      passosTransferidosSeguencia: []
    };
  },

  components: {
    StatusPassosItem: _StatusPassosItem2.default
  },
  computed: {
    passosTransferidosDaSequencia: function passosTransferidosDaSequencia() {
      if (this.passosTransferidos && this.passosTransferidos[this.sequencia]) {
        return this.passosTransferidos[this.sequencia];
      }
      return [];
    },
    seguenciaComPassoTransferido: function seguenciaComPassoTransferido() {
      return this.passosTransferidosDaSequencia.length;
    }
  }
};

/***/ }),
/* 357 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_GenericModal_vue_vue_type_script_lang_js___ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_GenericModal_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_GenericModal_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_GenericModal_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_GenericModal_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_GenericModal_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    title: String,
    save: Function,
    saveLabel: {
      type: String,
      default: 'salvar'
    },
    mdOpenFrom: String,
    mdCloseTo: String,
    mdEscToClose: {
      type: Boolean,
      default: true
    },
    mdClickOutsideToClose: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      dialog: false
    };
  },

  watch: {
    dialog: function dialog(val) {
      if (!val) {
        this.onClose();
      }
    }
  },
  methods: {
    open: function open() {
      this.dialog = true;
      this.onOpen();
    },
    close: function close() {
      this.dialog = false;
    },
    defaultClose: function defaultClose() {
      this.$emit('GENERICMODAL_DEFAULT_CLOSE');
      this.close();
    },
    defaultSave: function defaultSave() {
      this.$emit('GENERICMODAL_DEFAULT_SAVE');
      if (!this.save) {
        this.close();
      } else {
        this.save();
      }
    },
    onOpen: function onOpen() {
      this.$emit('GENERICMODAL_OPEN');
    },
    onClose: function onClose() {
      this.$emit('GENERICMODAL_CLOSE');
    }
  }
};

/***/ }),
/* 360 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TabelaGenerica_vue_vue_type_script_lang_js___ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TabelaGenerica_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TabelaGenerica_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TabelaGenerica_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TabelaGenerica_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TabelaGenerica_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(4);

var _assign2 = _interopRequireDefault(_assign);

var _stringify = __webpack_require__(38);

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__(55);

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = __webpack_require__(11);

var _keys2 = _interopRequireDefault(_keys);

var _vueInfiniteLoading = __webpack_require__(1081);

var _vueInfiniteLoading2 = _interopRequireDefault(_vueInfiniteLoading);

var _helpers = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    tableRows: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tableHeader: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    title: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    visibleColumns: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    numericColumns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    timestampColumns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mobileInvisibleColumns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    ignoreColumns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    lastSearchTableSize: {
      type: Number,
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      ignoredColumns: [],
      tableData: [],
      columnTypes: [],
      currentColumn: '',
      currentEditItem: null,
      editItem: null,
      edition: null,
      selected: null,
      showLoading: false,
      paginationSize: 20,
      searchQuery: '',
      dialog: {
        ref: 'dialog1',
        from: 'blockbtn',
        title: 'Atenção',
        content: 'Deseja realmente aplicar esta ação',
        action: function action() {
          return {};
        }
      },
      sortData: { name: 'dessert', type: 'desc' },
      openSearchToolbar: false,
      paginationPage: 0,
      stopRequestingPages: false,
      blockExportButton: false
    };
  },

  computed: {
    isHeaderAvailable: function isHeaderAvailable() {
      return this.tableHeader && this.tableHeader.length;
    },
    isContentAvailable: function isContentAvailable() {
      return !!this.filteredList && !!this.filteredList.length;
    },
    canRenderTable: function canRenderTable() {
      return this.isHeaderAvailable && this.isContentAvailable;
    },
    filteredList: function filteredList() {
      if (this.tableData) {
        if (this.searchQuery.length > 2) {
          return this.filterDatasource();
        }
      }
      return this.tableData;
    },
    selectedRowElements: function selectedRowElements() {
      if (this.$refs.myTable) {
        return this.filteredList.length < this.$refs.myTable.numberOfSelected ? this.filteredList.length : this.$refs.myTable.numberOfSelected;
      }
      return 0;
    }
  },
  components: {
    InfiniteLoading: _vueInfiniteLoading2.default
  },
  watch: {
    tableRows: function tableRows(newVal) {
      this.tableData = newVal ? (0, _helpers.copyObject)(newVal) : [];

      if (this.lastSearchTableSize) {
        this.closeLoading(false);
        if (this.paginationSize > this.lastSearchTableSize) {
          this.closeLoading(true);
        }
      }
    }
  },
  methods: {
    ativarInativarSelecao: function ativarInativarSelecao() {
      var selected = this.getTableSelection();
      this.selected = null;
      this.$refs.myTable.numberOfSelected = 0;
      this.currentEditItem = null;
      this.$emit('TABELAGENERICA_BLOQUEAR_SELECIONADOS', selected);
    },
    blockSelectedItems: function blockSelectedItems() {
      this.ativarInativarSelecao();
    },
    selecionadoLabel: function selecionadoLabel() {
      return this.$refs.myTable && this.$refs.myTable.numberOfSelected > 1 ? 'selecionados' : 'selecionado';
    },
    cleanEdition: function cleanEdition() {
      this.edition = '';
      this.currentColumn = '';
      this.currentEditItem = null;
      this.editItem = null;
    },
    closeDialog: function closeDialog(ref, cb) {
      this.$refs[ref].close();
      if (cb) {
        cb();
      }
    },
    closeSearchHeader: function closeSearchHeader() {
      this.searchQuery = '';
      this.openSearchToolbar = false;
    },
    closeLoading: function closeLoading() {
      var stop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (stop) {
        this.stopRequestingPages = true;
      } else {
        this.stopRequestingPages = false;
      }

      this.showLoading = false;

      if (this.$refs.infiniteLoading) {
        this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded');
      }
    },
    countSelectedItems: function countSelectedItems() {
      return this.selected ? (0, _helpers.nestedObjectToArray)(this.selected).filter(function (el) {
        return typeof el !== 'undefined';
      }).length : 0;
    },
    exportData: function exportData() {
      var _this = this;

      this.blockExportButton = true;
      this.$emit('TABELAGENERICA_EXPORTAR_DADOS', function () {
        _this.blockExportButton = false;
      });
    },
    filterDatasource: function filterDatasource(array) {
      var _this2 = this;

      var filtered = (array || this.tableData).filter(function (el) {
        var auxa = (0, _keys2.default)(el).map(function (key) {
          var entry = el[key];
          return (typeof entry === 'undefined' ? 'undefined' : (0, _typeof3.default)(entry)) === 'object' ? (0, _stringify2.default)(entry).toLowerCase() : entry.toString().toLowerCase();
        });
        var result = auxa.filter(function (elem) {
          return ~elem.indexOf(_this2.searchQuery.toLowerCase());
        });
        return result.length > 0;
      });
      return filtered;
    },
    focusSearchInput: function focusSearchInput(id) {
      this.openSearchToolbar = true;
      setTimeout(function () {
        var input = document.getElementById(id);
        input.focus();
      }, 100);
    },
    getEditDependency: function getEditDependency(column, rowAccess, dependency) {
      return (typeof column === 'undefined' ? 'undefined' : (0, _typeof3.default)(column)) === 'object' ? rowAccess[dependency] : rowAccess;
    },
    getTableSelection: function getTableSelection() {
      var mapSelectedIds = this.selected.map(function (el) {
        return el.id;
      });
      var mapped = this.tableData.map(function (el, index) {
        if (mapSelectedIds.indexOf(el.id) !== -1) {
          return index;
        }
        return undefined;
      });
      var filtered = mapped.filter(function (el) {
        return el !== undefined;
      });
      return filtered;
    },
    hideOnMedium: function hideOnMedium(columnIndex) {
      return this.mobileInvisibleColumns.indexOf(columnIndex) !== -1;
    },
    isAccepted: function isAccepted(col) {
      return !this.ignoredColumns.length || this.ignoredColumns.indexOf(col) === -1;
    },
    isColumnVisible: function isColumnVisible(column) {
      return this.visibleColumns.indexOf(column) !== -1;
    },
    isNumericField: function isNumericField(columnIndex) {
      return this.numericColumns.indexOf(columnIndex) === -1;
    },
    isTimestampField: function isTimestampField(columnIndex) {
      return this.timestampColumns.indexOf(columnIndex) === -1;
    },
    moveOnNextTableData: function moveOnNextTableData(col) {
      var row = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.editItem = row || this.editItem;
      this.currentEditItem = row || this.currentEditItem;
      this.currentColumn = col;
      this.edition = this.editItem ? this.editItem[col].toString() : '';

      this.setFocusOnInput();
    },
    onArrowDownPress: function onArrowDownPress() {
      this.previousNextRowSelector('next');
    },
    onArrowUpPress: function onArrowUpPress() {
      this.previousNextRowSelector('prev');
    },
    onCelMouseEnter: function onCelMouseEnter(row, col) {
      if (!this.currentEditItem) {
        this.editItem = row;
        this.currentColumn = col;
      }
    },
    onCelMouseLeave: function onCelMouseLeave() {
      if (!this.currentEditItem) {
        this.currentEditItem = null;
        this.editItem = null;
      }
    },
    onClickEdit: function onClickEdit(row, value) {
      var inputId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      if (this.onClickEditSpecific) {
        this.onClickEditSpecific(row);
      }
      this.currentEditItem = row;
      this.edition = value;

      this.setFocusOnInput(inputId);
    },
    onInfinite: function onInfinite() {
      if (this.stopRequestingPages) {
        return;
      }

      this.showLoading = true;
      this.paginationPage += 1;

      var pagination = {
        size: this.paginationSize,
        page: this.paginationPage,
        filter: this.searchQuery
      };
      if (this.hasOwnProperty('statusFilter') && this.statusFilter !== '') {
        pagination.indAtivo = this.statusFilter;
      }

      this.$emit('TABELAGENERICA_BUSCAR_PROXIMA_PAGINA', pagination, this.closeLoading);
    },
    onKeyCtrlAPress: function onKeyCtrlAPress() {},
    onKeyEnterPress: function onKeyEnterPress() {
      this.cleanEdition();
    },
    onKeyEscPress: function onKeyEscPress() {
      this.cleanEdition();
    },
    onOpen: function onOpen() {},
    onSelect: function onSelect(obj) {
      this.select(this.filteredList, obj, true);
    },
    setList: function setList(list, obj, param) {
      var _this3 = this;

      if (param) {
        return list.length === this.tableData.length ? (0, _keys2.default)(obj).map(function (el) {
          return _this3.tableData[el];
        }).filter(function (el) {
          return typeof el !== 'undefined';
        }) : this.filteredList;
      }
      return (0, _keys2.default)(obj).map(function (el) {
        return _this3.tableData[el];
      }).filter(function (el) {
        return typeof el !== 'undefined';
      });
    },
    clearCheckbox: function clearCheckbox() {
      this.selected = [];
      var parent = this.$refs.myTable ? this.$refs.myTable.$children : undefined;
      if (parent) {
        parent.forEach(function (row, index) {
          if (parent[index].$children[0]) {
            parent[index].checkbox = false;
            parent[index].$children[0].$children[0].checked = false;
          }
        });
        parent[0].checkbox = false;
        parent[0].$children[parent[0].$children.length - 1].$children[0].checked = false;
      }
    },
    select: function select(list, obj, param) {
      var _this4 = this;

      this.selected = this.setList(list, obj, param);

      this.$nextTick(function () {
        if (document.querySelector('.md-counter span:first-child')) {
          document.querySelector('.md-counter span:first-child').innerHTML = _this4.selected.length;
        }
      });
      var parent = this.$refs.myTable.$children;
      if (this.selected.length === this.tableData.length || this.selected.length === 0) {
        var value = parent[0].checkbox;
        parent.forEach(function (row, index) {
          if (parent[index].$children[0]) {
            parent[index].checkbox = value;
            parent[index].$children[0].$children[0].checked = value;
          }
        });
      }
      if (this.selected.length === this.tableData.length) {
        parent[0].checkbox = true;
        parent[0].$children[parent[0].$children.length - 1].$children[0].checked = true;
        if (this.tableData.length === 1) {
          parent.forEach(function (row, index) {
            if (parent[index].$children[0]) {
              parent[index].checkbox = true;
              parent[index].$children[0].$children[0].checked = true;
            }
          });
        }
      } else {
        parent[0].checkbox = false;
        parent[0].$children[parent[0].$children.length - 1].$children[0].checked = false;
      }
    },
    onSort: function onSort(obj) {
      this.sortData = obj;
      this.$emit('TABELAGENERICA_ORDENAR', this.sortData);
      this.cleanEdition();
    },
    onTabPress: function onTabPress() {
      var keys = (0, _keys2.default)(this.currentEditItem),
          colIndex = keys.indexOf(this.currentColumn),
          currentEditItemIndex = this.tableData.indexOf(this.currentEditItem),
          lastColumnIndex = keys.length - 1,
          lastTableRow = this.tableData.length - 1;

      if (colIndex === lastColumnIndex || colIndex === -1) {
        var nextRow = currentEditItemIndex === lastTableRow ? this.tableData[0] : this.tableData[currentEditItemIndex + 1];
        var nextRowKeys = (0, _keys2.default)(nextRow),
            _col = nextRowKeys[0];
        this.moveOnNextTableData(_col, nextRow);
        if (!this.isAccepted(_col)) {
          this.onTabPress();
        }
        return;
      }
      var col = keys[colIndex + 1];
      this.moveOnNextTableData(col);
      if (!this.isAccepted(col)) {
        this.onTabPress();
      }
    },
    openBlockDialog: function openBlockDialog(ref, from) {
      var content = 'Deseja ativar/inativar o(s) ' + this.selectedRowElements + ' elemento(s) selecionado(s)?';
      this.setDialogContent(content, this.blockSelectedItems, from);

      var parent = this.$refs.myTable.$children;
      parent.forEach(function (row, index) {
        if (parent[index].$children[0]) {
          parent[index].checkbox = false;
          parent[index].$children[0].$children[0].checked = false;
        }
      });
      parent[0].checkbox = false;
      parent[0].$children[parent[0].$children.length - 1].$children[0].checked = false;
      this.openDialog(ref);
    },
    openDialog: function openDialog(ref) {
      this.$refs[ref].open();
    },
    previousNextColumnSelector: function previousNextColumnSelector() {},
    previousNextRowSelector: function previousNextRowSelector(direction) {
      if (this.currentEditItem) {
        var nextRow = this.rowSelection(direction),
            column = this.currentColumn || (0, _keys2.default)(nextRow)[0];

        this.moveOnNextTableData(column, nextRow);
        return;
      }
      var index = direction === 'next' ? 0 : this.tableData.length - 1,
          row = this.tableData[index];
      this.moveOnNextTableData((0, _keys2.default)(row)[0], row);
    },
    rowSelection: function rowSelection(direction) {
      var currentIndex = this.tableData.indexOf(this.currentEditItem);
      var nextRow = null;
      if (direction === 'next') {
        nextRow = currentIndex === this.tableData.length - 1 ? this.tableData[0] : this.tableData[currentIndex + 1];
      } else {
        nextRow = currentIndex === 0 ? this.tableData[this.tableData.length - 1] : this.tableData[currentIndex - 1];
      }

      return nextRow;
    },
    setDialogContent: function setDialogContent(content, action, from) {
      this.dialog.content = content;
      this.dialog.action = action;
      this.dialog.from = from;
    },
    setFocusOnInput: function setFocusOnInput(inputId) {
      var target = null;

      if (inputId === null) {
        if (!this.$refs.currentinput || !this.$refs.currentinput.length) {
          return;
        }
        var currInput = this.$refs.currentinput[0];
        target = currInput.focus ? currInput : currInput.$el;
      } else {
        target = document.getElementById(inputId);
      }

      setTimeout(function () {
        return target.focus();
      }, 500);
    },
    startComponent: function startComponent() {
      this.tableData = (0, _helpers.copyObject)(this.tableRows);
      this.ignoredColumns = (0, _helpers.copyObject)(this.ignoreColumns);
      this.onInfinite();
    },
    updateItemDependency: function updateItemDependency(row, property, dependency) {
      var item = (0, _assign2.default)({}, row);
      item[property] = dependency;
      this.$emit('TABELAGENERICA_ATUALIZAR', item);
      this.cleanEdition();
    },
    updateItem: function updateItem(row, rowIndex, columnIndex) {
      var item = (0, _assign2.default)({}, row);
      if (this.edition !== null && this.edition !== undefined) {
        if ((0, _typeof3.default)(this.edition) !== 'object') {
          var newVal = this.edition.toString();
          if (columnIndex && item[rowIndex]) {
            item[rowIndex][columnIndex] = newVal;
          } else if (item[rowIndex]) {
            item[rowIndex] = newVal;
          }
        }
      }

      this.$emit('TABELAGENERICA_ATUALIZAR', item);
      this.cleanEdition();
    }
  },
  mounted: function mounted() {
    this.startComponent();
  }
};

/***/ }),
/* 363 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CarteiraCliente_vue_vue_type_script_lang_js___ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CarteiraCliente_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CarteiraCliente_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CarteiraCliente_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CarteiraCliente_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CarteiraCliente_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _rolesComputedGenerator = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'CarteiraCliente',
  methods: {
    accessForbidden: function accessForbidden() {
      this.$router.push({ name: 'inicio' });
      this.$toast.create('Acesso negado', 'snack', 3E3);
    }
  },
  computed: (0, _extends3.default)({}, (0, _rolesComputedGenerator.generateComputed)('Carteira', ['canAccessPage'])),
  beforeMount: function beforeMount() {
    var _this = this;

    if (!this.canAccessPage) {
      window.setTimeout(function () {
        return _this.accessForbidden();
      }, 1E3);
    }
  }
};

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Calendario_vue_vue_type_script_lang_js___ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Calendario_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Calendario_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Calendario_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Calendario_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Calendario_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _CalendarioTabela = __webpack_require__(1090);

var _CalendarioTabela2 = _interopRequireDefault(_CalendarioTabela);

var _CalendarioForm = __webpack_require__(1094);

var _CalendarioForm2 = _interopRequireDefault(_CalendarioForm);

var _CalendarioToolbar = __webpack_require__(1098);

var _CalendarioToolbar2 = _interopRequireDefault(_CalendarioToolbar);

var _rolesComputedGenerator = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Calendario',
  data: function data() {
    return {
      dialogForm: false,
      idEvento: null
    };
  },

  components: {
    CalendarioForm: _CalendarioForm2.default,
    CalendarioTabela: _CalendarioTabela2.default,
    CalendarioToolbar: _CalendarioToolbar2.default
  },
  computed: (0, _extends3.default)({}, (0, _rolesComputedGenerator.generateComputed)('Cal', ['canAccessPage', 'canAccessCRUD'])),
  methods: {
    edit: function edit(id) {
      this.idEvento = id;
      this.abrirForm();
    },
    buscar: function buscar() {
      this.fecharForm();
      this.$refs.tabela.filtrar();
    },
    abrirForm: function abrirForm() {
      this.dialogForm = true;
    },
    fecharForm: function fecharForm() {
      this.idEvento = null;
      this.dialogForm = false;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (!this.canAccessPage) {
      window.setTimeout(function () {
        _this.$router.push({ name: 'inicio' });
      }, 1E3);
    }
  }
};

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioTabela_vue_vue_type_script_lang_js___ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioTabela_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioTabela_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioTabela_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioTabela_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioTabela_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Confirm = __webpack_require__(12);

var _Confirm2 = _interopRequireDefault(_Confirm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'CalendarioTabela',
  components: {
    Confirm: _Confirm2.default
  },
  props: {
    somenteLeitura: true
  },
  data: function data() {
    var _this = this;

    return {
      search: '',
      resources: this.$api.calendario(this.$resource),
      totalPage: 0,
      mesAnoPesquisa: this.moment().format('MM-YYYY'),
      indCancelado: false,
      esperar: false,
      menuMesPesquisa: false,
      evento: {},
      pagination: {},
      headers: [{ text: this.$t('label.nome', 1), value: 'nome', sortable: false }, { text: this.$tc('label.tipo', 1), value: 'descricao', sortable: false }, { text: this.$tc('label.data_inicio', 1), value: 'dataInicio', sortable: false }, { text: this.$tc('label.data_fim', 1), value: 'dataFim', sortable: false }, { text: this.$t('label.usuario_criador'), value: 'usuarioCriacao', sortable: false }, { text: this.$t('label.usuario_alteracao'), value: 'usuarioAlteracao', sortable: false }, { text: this.$t('label.data_do_cancelamento'), value: 'dataCancelamento', sortable: false }, { text: this.$t('label.cancelar'), value: 'cancelamento', sortable: false }],
      rules: {
        validDate: function validDate(value) {
          return _this.isDataValida(value) || _this.$t('message.data_invalida');
        }
      },
      eventos: []
    };
  },

  computed: {
    mesPesquisaFormatado: {
      get: function get() {
        return this.mesAnoPesquisa;
      },
      set: function set(newValue) {
        this.mesAnoPesquisa = newValue;
      }
    },
    mesPesquisa: {
      get: function get() {
        return this.moment(this.mesAnoPesquisa, 'MM-YYYY').format('YYYY-MM');
      },
      set: function set(newValue) {
        this.mesAnoPesquisa = this.moment(newValue, 'YYYY-MM').format('MM-YYYY');
      }
    }
  },
  watch: {
    pagination: {
      handler: function handler() {
        this.filtrar();
      },

      deep: true
    },
    mesAnoPesquisa: function mesAnoPesquisa() {
      this.filtrar();
    }
  },
  methods: {
    cancelarEvento: function cancelarEvento() {
      var _this2 = this;

      var params = {
        id: this.evento.id
      };
      this.resources.cancelar({ id: this.evento.id }, params).then(function () {
        _this2.$toast.create(_this2.$t('message.atualizado_confira_tabela'), 'snack', 3E3);
        _this2.esperar = true;
        setTimeout(function () {
          _this2.buscar();
        }, 5E2);
      }, function (err) {
        _this2.cancelarAlteracaoStatus();
        _this2.$error(_this2, err);
      });
    },
    dataFimMaiorQueDataAtual: function dataFimMaiorQueDataAtual(item) {
      if (item && item.dataFim) {
        return this.moment(item.dataFim, 'DD/MM/YYYY').isAfter(this.moment(), 'day') || this.moment(item.dataFim, 'DD/MM/YYYY').isSame(this.moment(), 'day');
      }
      return false;
    },
    cancelarItem: function cancelarItem(evento) {
      this.evento = evento;
      this.$refs.cancelDialog.open();
    },
    isDataValida: function isDataValida(value) {
      return !value || value.length === 7 && this.moment(value, 'MM-YYYY').isValid();
    },
    convertDate: function convertDate(data) {
      return this.moment(data, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY');
    },
    ativarInativa: function ativarInativa(evento) {
      this.evento = evento;
      this.$refs.confirmDialog.open();
    },
    cancelarAlteracaoStatus: function cancelarAlteracaoStatus() {
      this.evento.indAtivo = !this.evento.indAtivo;
    },
    alterarStatus: function alterarStatus() {
      var _this3 = this;

      var params = {
        id: this.evento.id,
        status: this.evento.indAtivo
      };
      this.resources.ativarInativar(params, params).then(function () {
        _this3.$toast.create(_this3.$t('message.atualizado_confira_tabela'), 'snack', 3E3);
      }, function (err) {
        _this3.cancelarAlteracaoStatus();
        _this3.$error(_this3, err);
      });
    },
    filtrar: function filtrar() {
      var _this4 = this;

      if (this.esperar) return;
      if (!this.mesAnoPesquisa || !this.mesAnoPesquisa.length || this.isDataValida(this.mesAnoPesquisa)) {
        this.esperar = true;
        setTimeout(function () {
          _this4.buscar();
        }, 5E2);
      }
    },
    editItem: function editItem(item) {
      this.$emit('edit', item.id);
    },
    buscar: function buscar() {
      var _this5 = this;

      var params = {
        nome: this.search,
        page: this.pagination.page,
        size: this.pagination.itemsPerPage,
        asc: !this.pagination.descending,
        indCancelado: this.indCancelado,
        colunaOrdenacao: this.pagination.sortBy,
        dataInicio: this.getDataInicio(),
        dataFim: this.getDataFim()
      };

      this.resources.listar(params).then(function (response) {
        _this5.eventos = response.data.resposta;
        _this5.totalPage = response.data.quantidadeRegistrosPagina;
        _this5.pararEsperar();
      }, function (err) {
        _this5.pararEsperar();
        _this5.$error(_this5, err);
      });
    },
    getDataInicio: function getDataInicio() {
      if (!this.mesAnoPesquisa || !this.mesAnoPesquisa.length) return null;
      return this.moment(this.mesAnoPesquisa, 'MM-YYYY').startOf(1).format('YYYY-MM-DD');
    },
    getDataFim: function getDataFim() {
      if (!this.mesAnoPesquisa || !this.mesAnoPesquisa.length) return null;
      return this.moment(this.mesAnoPesquisa, 'MM-YYYY').endOf('month').format('YYYY-MM-DD');
    },
    pararEsperar: function pararEsperar() {
      var _this6 = this;

      setTimeout(function () {
        _this6.esperar = false;
      }, 2E2);
    }
  },
  beforeMount: function beforeMount() {
    if (!this.somenteLeitura) {
      this.headers.push({ text: '', value: 'acao', sortable: false });
    }
  },
  mounted: function mounted() {
    this.filtrar();
  }
};

/***/ }),
/* 370 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioForm_vue_vue_type_script_lang_js___ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioForm_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioForm_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioForm_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioForm_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioForm_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dateUtils = __webpack_require__(30);

var _Confirm = __webpack_require__(12);

var _Confirm2 = _interopRequireDefault(_Confirm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'CalendarioForm',
  components: {
    Confirm: _Confirm2.default
  },
  props: {
    idEvento: {
      type: Number,
      default: null
    },
    somenteLeitura: true
  },
  data: function data() {
    var _this = this;

    return {
      resources: this.$api.calendario(this.$resource),
      tipos: [],
      menuDataInicio: false,
      menuCor: false,
      menuDataFim: false,
      observacoes: null,
      eventosListados: [],
      cores: ['red darken-1', 'deep-purple darken-1', 'blue darken-1', 'light-blue darken-1', 'cyan darken-1', 'teal darken-1', 'green darken-1', 'light-green darken-1', 'lime darken-1', 'yellow darken-1', 'amber darken-1', 'orange darken-1', 'deep-orange darken-1', 'blue-grey darken-1', 'grey darken-1'],
      evento: {
        id: null,
        nome: '',
        dataInicio: null,
        dataFim: null,
        dataDiaSeguinte: null,
        idTipo: null,
        cor: 'red darken-1',
        indAtivo: true
      },
      rules: {
        required: function required(value) {
          return !!value || _this.$t('message.campo_obrigatorio');
        },
        requiredTipo: function requiredTipo() {
          return !!_this.evento.idTipo || _this.$t('message.campo_obrigatorio');
        },
        maxLength50: function maxLength50(v) {
          return v && v.length <= 50 || _this.$t('message.limite_caracteres_excedido');
        },
        validDate: function validDate(value) {
          return !value || value.length === 10 && _this.moment(value, 'DD-MM-YYYY').isValid() || _this.$t('message.data_invalida');
        },
        dataFimMaiorInicio: function dataFimMaiorInicio() {
          return !_this.isDataFimMaiorInicio() || _this.$t('message.data_inicial_maior_final');
        },
        dataInicioMenorQueDiaSeguinte: function dataInicioMenorQueDiaSeguinte() {
          return !_this.isDataInicioMenorDiaSeguinte() || _this.$t('message.data_inicial_menor_dia_seguinte');
        }
      }
    };
  },

  computed: {
    dateInicioFormatada: {
      get: function get() {
        return (0, _dateUtils.formatDateDDMMYYYY)(this.evento.dataInicio);
      },
      set: function set(newValue) {
        this.evento.dataInicio = (0, _dateUtils.parseDateYYYYMMDD)(newValue);
      }
    },
    dataInicio: {
      get: function get() {
        return this.evento.dataInicio;
      },
      set: function set(newValue) {
        this.evento.dataInicio = newValue;
      }
    },
    dateFimFormatada: {
      get: function get() {
        return (0, _dateUtils.formatDateDDMMYYYY)(this.evento.dataFim);
      },
      set: function set(newValue) {
        this.evento.dataFim = (0, _dateUtils.parseDateYYYYMMDD)(newValue);
      }
    },
    dataFim: {
      get: function get() {
        return this.evento.dataFim;
      },
      set: function set(newValue) {
        this.evento.dataFim = newValue;
      }
    },
    dataDiaSeguinte: {
      get: function get() {
        return '' + this.moment().add(1, 'd').format('YYYY-MM-DD');
      },
      set: function set(newValue) {
        this.evento.dataDiaSeguinte = (0, _dateUtils.formatDateDDMMYYYY)(newValue);
      }
    }
  },
  methods: {
    abrirDialogSalvar: function abrirDialogSalvar() {
      if (!this.$refs.form.validate()) return;
      this.$refs.confirmDialog.open();
    },
    salvar: function salvar() {
      var _this2 = this;

      if (this.idEvento) {
        this.resources.atualizar({ id: this.idEvento }, this.evento).then(function () {
          _this2.$toast.create(_this2.$t('message.atualizado_confira_tabela'), 'snack', '3E3');
          _this2.$emit('atualizarGrid');
        }, function (err) {
          _this2.$error(_this2, err);
        });
      } else {
        this.resources.gravar(this.evento).then(function () {
          _this2.$toast.create(_this2.$t('message.adicionado_confira_tabela'), 'snack', '3E3');
          _this2.$emit('atualizarGrid');
        }, function (err) {
          _this2.$error(_this2, err);
        });
      }
    },
    cancelar: function cancelar() {
      this.$refs.form.reset();
      this.$emit('cancelar');
    },
    isDataFimMaiorInicio: function isDataFimMaiorInicio() {
      var dtInicio = this.moment(this.evento.dataInicio, 'YYYY-MM-DD');
      var dtFinal = this.moment(this.evento.dataFim, 'YYYY-MM-DD');
      return dtFinal.isBefore(dtInicio);
    },
    isDataInicioMenorDiaSeguinte: function isDataInicioMenorDiaSeguinte() {
      var dtInicio = this.moment(this.evento.dataInicio, 'YYYY-MM-DD');
      var dtDiaSeguinte = this.moment().add(1, 'd').format('YYYY-MM-DD');
      return dtInicio.isBefore(dtDiaSeguinte);
    },
    buscarTipos: function buscarTipos() {
      var _this3 = this;

      this.resources.tipos().then(function (response) {
        _this3.tipos = response.data;
      }, function (err) {
        _this3.$error(_this3, err);
      });
    },
    carregar: function carregar() {
      var _this4 = this;

      var id = this.idEvento;
      this.resources.obter({ id: id }).then(function (response) {
        _this4.evento = response.data;
      }, function (err) {
        _this4.$error(_this4, err);
        _this4.cancelar();
      });
    },
    buscarEventos: function buscarEventos() {
      var _this5 = this;

      this.resources.listar().then(function (response) {
        _this5.eventosListados = response.data.resposta;
      }, function (err) {
        _this5.$error(_this5, err);
        _this5.cancelar();
      });
    },
    exibeObservacoes: function exibeObservacoes(id) {
      var obj = this.tipos.find(function (el) {
        return el.id === id;
      });
      if (obj) {
        this.observacoes = JSON.parse(obj.observacoes.value);
      }
    }
  },
  mounted: function mounted() {
    this.buscarTipos();
    if (this.idEvento) {
      this.carregar();
      this.buscarEventos();
    }
  }
};

/***/ }),
/* 373 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioToolbar_vue_vue_type_script_lang_js___ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioToolbar_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioToolbar_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioToolbar_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioToolbar_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioToolbar_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(6);

var _CalendarioCard = __webpack_require__(1101);

var _CalendarioCard2 = _interopRequireDefault(_CalendarioCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'CalendarioToolbar',
  components: {
    CalendarioCard: _CalendarioCard2.default
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('roles', ['getAllRoles']), {
    canAccessView: function canAccessView() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el === 'CAL_VISUALIZAR';
      }).length;
    }
  }),
  data: function data() {
    return {
      menu: false
    };
  }
};

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioCard_vue_vue_type_script_lang_js___ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioCard_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioCard_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioCard_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioCard_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioCard_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loading = __webpack_require__(14);

exports.default = {
  name: 'CalendarioCard',
  data: function data() {
    return {
      resources: this.$api.calendario(this.$resource),
      date: new Date().toJSON().substr(0, 10),
      dataAnterior: null,
      mesAnoPesquisa: null,
      datas: {},
      eventos: []
    };
  },

  computed: {
    listaEventos: function listaEventos() {
      if (this.date) {
        return this.datas[this.date] || [];
      }
      return this.eventos;
    }
  },
  watch: {
    date: function date() {
      this.dataAnterior = this.date;
    }
  },
  methods: {
    carregarMes: function carregarMes() {
      var _this = this;

      (0, _loading.skipLoading)();
      var params = {
        indAtivo: true,
        indCancelado: false,
        size: 20000,
        page: 0,
        dataInicio: this.getDataInicio(),
        dataFim: this.getDataFim(),
        asc: true,
        colunaOrdenacao: 'data_inicio'
      };

      this.resources.listar(params).then(function (response) {
        _this.converterDatas(response.data.resposta);
      }, function (err) {
        _this.$error(_this, err);
      });
    },
    formatarData: function formatarData(item) {
      var dataInicio = this.moment(item.dataInicio, 'DD/MM/YYYY HH:mm:ss');
      var dataFim = this.moment(item.dataFim, 'DD/MM/YYYY HH:mm:ss');
      if (dataFim.isSame(dataInicio)) {
        return dataInicio.format('DD/MM/YYYY');
      }
      return dataInicio.format('DD/MM/YYYY') + ' a ' + dataFim.format('DD/MM/YYYY');
    },
    converterDatas: function converterDatas(eventos) {
      var _this2 = this;

      this.eventos = eventos;
      var datas = {};
      eventos.forEach(function (e) {
        var dataInicio = _this2.moment(e.dataInicio, 'DD/MM/YYYY HH:mm:ss');
        var dataFim = _this2.moment(e.dataFim, 'DD/MM/YYYY HH:mm:ss');
        while (dataInicio.isSameOrBefore(dataFim)) {
          var formatada = dataInicio.format('YYYY-MM-DD');
          if (datas[formatada]) datas[formatada].push(e);else datas[formatada] = [e];
          dataInicio.add(1, 'days');
        }
      });
      this.datas = datas;
    },
    getDataInicio: function getDataInicio() {
      if (!this.mesAnoPesquisa || !this.mesAnoPesquisa.length) return null;
      return this.moment(this.mesAnoPesquisa, 'YYYY-MM').startOf(1).format('YYYY-MM-DD');
    },
    getDataFim: function getDataFim() {
      if (!this.mesAnoPesquisa || !this.mesAnoPesquisa.length) return null;
      return this.moment(this.mesAnoPesquisa, 'YYYY-MM').endOf('month').format('YYYY-MM-DD');
    },
    ehEvento: function ehEvento(date) {
      return !!this.datas[date];
    },
    corDoEvento: function corDoEvento(date) {
      return this.datas[date][0].cor;
    },
    alterarMes: function alterarMes(mes) {
      this.mesAnoPesquisa = mes;
      this.carregarMes();
    },
    limparSelecao: function limparSelecao(data) {
      if (data === this.dataAnterior) {
        this.date = null;
      }
    }
  },
  mounted: function mounted() {
    this.mesAnoPesquisa = this.moment().format('YYYY-MM');
    this.carregarMes();
  }
};

/***/ }),
/* 378 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CentroCusto_vue_vue_type_script_lang_js___ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CentroCusto_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CentroCusto_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CentroCusto_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CentroCusto_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CentroCusto_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(4);

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _CRUDGenerico = __webpack_require__(23);

var _CRUDGenerico2 = _interopRequireDefault(_CRUDGenerico);

var _SideColumn = __webpack_require__(1109);

var _SideColumn2 = _interopRequireDefault(_SideColumn);

var _CentroCustoTabela = __webpack_require__(1118);

var _CentroCustoTabela2 = _interopRequireDefault(_CentroCustoTabela);

var _helpers = __webpack_require__(5);

var _rolesComputedGenerator = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'CentroCusto',
  extends: _CRUDGenerico2.default,
  data: function data() {
    return {
      centroCustoResources: this.$api.centroCusto(this.$resource),
      extensaoResources: this.$api.extensao(this.$resource),
      tableHeader: [{
        name: this.$t('label.codigo'),
        tooltip: this.$t('label.cod_centro_custo'),
        sortType: 'idExterno',
        classes: ['md-hide-medium']
      }, {
        name: this.$t('label.nome'),
        tooltip: this.$t('label.nome'),
        sortType: 'nome',
        classes: ['md-hide-medium']
      }, {
        name: this.$tc('label.unidade_negocio', 1),
        tooltip: this.$tc('label.unidade_negocio', 1),
        sortType: 'unidadeNegocio',
        classes: ['md-hide-medium']
      }, {
        name: this.$t('label.canal'),
        tooltip: this.$t('label.canal'),
        sortType: 'canais',
        classes: ['md-hide-medium']
      }, {
        name: this.$t('label.marca'),
        tooltip: this.$t('label.marca'),
        sortType: 'marcas',
        classes: ['md-hide-medium']
      }, {
        name: this.$tc('label.cliente', 1),
        tooltip: this.$tc('label.cliente', 1),
        sortType: 'composicao',
        classes: ['md-hide-medium']
      }, {
        name: this.$tc('label.produto', 1),
        tooltip: this.$tc('label.produto', 1),
        sortType: 'composicao',
        classes: ['md-hide-medium']
      }],
      tableRows: [],
      carregando: false,
      paginas: 0,
      limitePagina: 20,
      searchQuery: '',
      statusFilter: 'true'
    };
  },

  computed: (0, _extends3.default)({}, (0, _rolesComputedGenerator.generateComputed)('Ceco', ['canAccessPage', 'canAccessCRUD'])),
  components: {
    SideColumn: _SideColumn2.default,
    CentroCustoTabela: _CentroCustoTabela2.default
  },
  methods: {
    accessForbidden: function accessForbidden() {
      if (!this.canAccessPage) {
        this.$router.push({ name: 'inicio' });
        this.$toast.create('Acesso negado', 'snack', 3E3);
      }
    },
    alterarTamanhoPagina: function alterarTamanhoPagina(valor) {
      this.limitePagina = valor;
      this.requestPopular();
    },
    filtrarPorStatus: function filtrarPorStatus(status) {
      this.statusFilter = status;
      this.requestPopular();
    },
    filtrar: function filtrar(searchQuery) {
      this.searchQuery = searchQuery;
      this.requestPopular();
    },
    requestAdicionar: function requestAdicionar(objeto) {
      var _this = this;

      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var payload = (0, _helpers.copyObject)(objeto);

      delete payload.dependencias.canais;
      delete payload.dependencias.marcas;
      delete payload.dependencias.unidadeNegocio;

      this.centroCustoResources.gravar(payload).then(function (docs) {
        objeto.id = docs.data.id;

        _this.tableRows.unshift(objeto);
        _this.$toast.create(_this.$t('message.adicionado_confira_tabela'), 'snack', 3E3);
        if (cb) {
          cb();
        }
      }).catch(function (err) {
        _this.$error(_this, err);
      });
    },
    requestAtivarInativar: function requestAtivarInativar(index) {
      var row = this.tableRows[index],
          id = row.id;
      return this.requestAtivarInativarGenerico(row, id, this.centroCustoResources);
    },
    requestAtualizar: function requestAtualizar(objeto) {
      var _this2 = this;

      var payload = (0, _assign2.default)({}, objeto);
      var idsCanal = payload.dependencias.canais.map(function (el) {
        return el.id;
      });
      var idsMarca = payload.dependencias.marcas.map(function (el) {
        return el.id;
      });
      var idUnidadeNegocio = payload.dependencias.unidadeNegocio.id;

      delete payload.dependencias;
      delete payload.canais;
      delete payload.marcas;
      delete payload.unidadenegocio;
      delete payload.codUnidadenegocio;

      payload.dependencias = {};
      payload.dependencias.idsCanal = idsCanal;
      payload.dependencias.idsMarca = idsMarca;
      payload.dependencias.idUnidadeNegocio = idUnidadeNegocio;

      this.centroCustoResources.atualizar(payload).then(function () {
        _this2.$toast.create(_this2.$t('message.atualizado_confira_tabela'), 'snack', 3E3);
        _this2.requestPopular();
      }).catch(function (err) {
        _this2.$error(_this2, err);
      });
    },
    requestExportacao: function requestExportacao(cb) {
      this.exportar(cb, 'centro_custo');
    },
    requestPopular: function requestPopular() {
      var _this3 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.$refs.centroCustoTabela.clearCheckbox();
      this.carregando = true;
      var filtro = {};
      filtro.page = page;
      filtro.size = this.limitePagina;
      filtro.nome = this.searchQuery;
      if (this.statusFilter !== '') {
        filtro.indAtivo = this.statusFilter;
      }
      this.centroCustoResources.listar(filtro).then(function (response) {
        _this3.tableRows = response.data.resposta;
        var qtdeRegistros = response.data.quantidadeRegistrosPagina;
        _this3.paginas = Math.ceil(qtdeRegistros / filtro.size);
        _this3.carregando = false;
        if (cb) {
          cb();
        }
      }).catch(function (err) {
        _this3.carregando = false;
        _this3.$toast.create(err.data.error, 'snack', 3E3);
      });
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    if (!this.canAccessPage) {
      window.setTimeout(function () {
        return _this4.accessForbidden();
      }, 1E3);
    } else {
      this.requestPopular();
    }
  }
};

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SideColumn_vue_vue_type_script_lang_js___ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SideColumn_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SideColumn_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SideColumn_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SideColumn_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SideColumn_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(4);

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _RegisterForm = __webpack_require__(36);

var _RegisterForm2 = _interopRequireDefault(_RegisterForm);

var _mdChipsAutocomplete = __webpack_require__(65);

var _mdChipsAutocomplete2 = _interopRequireDefault(_mdChipsAutocomplete);

var _mdAutocomplete = __webpack_require__(16);

var _mdAutocomplete2 = _interopRequireDefault(_mdAutocomplete);

var _helpers = __webpack_require__(5);

var _rolesComputedGenerator = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'CentroCustoSideColumn',
  props: {
    fetchExtensaoFunction: Function,
    prepareResponseData: Function
  },
  data: function data() {
    return {
      dialog: {
        ref: 'dialog1',
        from: 'saveRegisterFromButton',
        title: this.$t('label.atencao'),
        content: '',
        action: function action() {}
      },
      disableButton: false,
      centroCusto: {
        dependencias: {
          canais: [],
          idsCanal: [],
          idsMarca: [],
          idUnidadeNegocio: '',
          marcas: [],
          unidadeNegocio: {
            id: '',
            nomExtensao: ''
          }
        },
        nome: '',
        indAtivo: true,
        idExterno: '',
        indCliente: false,
        indProduto: false
      },
      source: []
    };
  },

  computed: (0, _extends3.default)({}, (0, _rolesComputedGenerator.generateComputed)('Ceco', ['canAccessCRUD'])),
  components: {
    RegisterForm: _RegisterForm2.default,
    mdChipsAutocomplete: _mdChipsAutocomplete2.default,
    mdAutocomplete: _mdAutocomplete2.default
  },
  methods: {
    addCanalChip: function addCanalChip(value) {
      this.centroCusto.dependencias.idsCanal = value.map(function (el) {
        return el.id;
      });
    },
    addMarcaChip: function addMarcaChip(value) {
      this.centroCusto.dependencias.idsMarca = value.map(function (el) {
        return el.id;
      });
    },
    cancel: function cancel() {
      this.$emit('SIDECOLUMN_CANCEL_ACTION');
      this.clearForm();
    },
    clearForm: function clearForm() {
      var _this = this;

      this.centroCusto = (0, _helpers.copyObject)(this.originalCentroCusto);
      setTimeout(function () {
        _this.fields.reset();
        _this.errors.clear();
        _this.$refs.containerIdExterno.inputLength = 0;
        _this.$refs.containerNome.inputLength = 0;
        _this.source = [];
      }, 1E2);
    },
    closeDialog: function closeDialog(ref, cb) {
      this.$refs[ref].close();
      this.$refs[ref].active = false;
      if (cb) {
        cb();
      }
    },
    openDialog: function openDialog(ref) {
      this.$refs[ref].open();
      this.$refs[ref].active = true;
    },
    openSaveDialog: function openSaveDialog(ref, from) {
      var _this2 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (!isValid) {
          return;
        }

        if (_this2.centroCusto.indCliente === false && _this2.centroCusto.indProduto === false) {
          _this2.$toast.create(_this2.$t('message.erro_salvar_centro_sem_produto_cliente'), 'snack', 5E3);
          return;
        }

        var content = _this2.$t('message.salvar_novo_centro_custo');
        _this2.setDialogContent(content, _this2.save, from || _this2.dialog.from);

        _this2.openDialog(ref || _this2.dialog.ref);
      });
    },
    save: function save(obj) {
      var objCentroCusto = (0, _assign2.default)({}, obj || this.centroCusto);
      this.$emit('SIDECOLUMN_SAVE_ACTION', objCentroCusto, this.clearForm);
    },
    setUnidadeNegocio: function setUnidadeNegocio(hit) {
      this.centroCusto.dependencias.idUnidadeNegocio = hit.id;
      this.centroCusto.dependencias.unidadeNegocio.id = hit.id;
      this.centroCusto.dependencias.unidadeNegocio.nomExtensao = hit.nomExtensao;
    },
    fetchSuperiorCanalFunction: function fetchSuperiorCanalFunction() {
      var _this3 = this;

      return function () {
        var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        var params = (0, _assign2.default)({}, param, { nome: _this3.$refs.canalAutoComplete.currentChip, idNivelExtensao: 3 });
        return _this3.fetchExtensaoFunction(params);
      };
    },
    fetchSuperiorMarcaFunction: function fetchSuperiorMarcaFunction() {
      var _this4 = this;

      return function () {
        var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        var params = (0, _assign2.default)({}, param, { nome: _this4.$refs.marcaAutoComplete.currentChip, idNivelExtensao: 2 });
        return _this4.fetchExtensaoFunction(params);
      };
    },
    fetchSuperiorUnidadeNegocioFunction: function fetchSuperiorUnidadeNegocioFunction() {
      var _this5 = this;

      return function () {
        var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        var params = (0, _assign2.default)({}, param, { nome: _this5.centroCusto.dependencias.unidadeNegocio.nomExtensao, idNivelExtensao: 1 });
        return _this5.fetchExtensaoFunction(params);
      };
    },
    setDialogContent: function setDialogContent(content, action, from) {
      this.dialog.content = content || this.$t('message.salvar_novo_registro');
      this.dialog.action = action || this.save;
      this.dialog.from = from || this.dialog.from;
    }
  },
  mounted: function mounted() {
    this.originalCentroCusto = (0, _helpers.copyObject)(this.centroCusto);
  }
};

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_mdChipsAutocomplete_vue_vue_type_script_lang_js___ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_mdChipsAutocomplete_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_mdChipsAutocomplete_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_mdChipsAutocomplete_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_mdChipsAutocomplete_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_mdChipsAutocomplete_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(4);

var _assign2 = _interopRequireDefault(_assign);

var _defineProperty2 = __webpack_require__(73);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = __webpack_require__(11);

var _keys2 = _interopRequireDefault(_keys);

var _mdAutocomplete = __webpack_require__(16);

var _mdAutocomplete2 = _interopRequireDefault(_mdAutocomplete);

var _autocomplete = __webpack_require__(306);

var _autocomplete2 = _interopRequireDefault(_autocomplete);

var _helpers = __webpack_require__(5);

var _mdTheme = __webpack_require__(1114);

var _mdTheme2 = _interopRequireDefault(_mdTheme);

var _uniqueId = __webpack_require__(1115);

var _uniqueId2 = _interopRequireDefault(_uniqueId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_mdTheme2.default, _autocomplete2.default],
  props: {
    extensao: {
      type: Boolean,
      default: false
    },
    mdInputId: String,
    mdInputName: String,
    mdInputPlaceholder: String,
    mdInputType: {
      type: String,
      default: 'text'
    },
    mdMax: {
      type: Number,
      default: Infinity
    },
    mdStatic: Boolean,
    value: Array,
    prepareResponseData: Function,
    identifier: {
      value: String,
      default: 'id'
    }
  },
  data: function data() {
    return {
      currentChip: '',
      inputId: this.mdInputId || 'chips-' + (0, _uniqueId2.default)(),
      selectedChips: this.value || []
    };
  },

  watch: {
    value: function value(val) {
      this.selectedChips = val || [];
      this.$refs.autocomplete.query = '';
    }
  },
  computed: {
    classes: function classes() {
      return {
        'md-static': this.mdStatic,
        'md-disabled': this.disabled
      };
    },
    hasReachedMaxSize: function hasReachedMaxSize() {
      return this.selectedChips && this.selectedChips.length === this.mdMax;
    },
    placeholder: function placeholder() {
      return this.selectedChips && this.selectedChips.length ? this.mdInputPlaceholder : '';
    }
  },
  components: {
    mdAutocomplete: _mdAutocomplete2.default
  },
  methods: {
    textoChip: function textoChip(chip) {
      if (this.printFunction) {
        return this.printFunction(chip);
      }
      return chip[this.printAttribute];
    },
    addChip: function addChip() {
      var selected = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (selected === null || (0, _keys2.default)(selected).length === 0) {
        return;
      }

      if (!this.hasReachedMaxSize) {
        var value = void 0;
        if (this.printFunction) {
          value = selected || (0, _defineProperty3.default)({}, this.printFunction(), this.currentChip.trim());
        } else {
          value = selected || (0, _defineProperty3.default)({}, this.printAttribute, this.currentChip.trim());
        }

        if (this.selectedChips.indexOf(value) < 0) {
          this.selectedChips.push(value);
          this.currentChip = null;
          this.$emit('input', this.selectedChips);
          this.$emit('change', this.selectedChips);
          this.applyAutocompleteFocus();
        }
      }
      this.$refs.autocomplete.query = '';
    },
    addExtension: function addExtension() {
      this.$emit('addExtension', this.currentChip);
    },
    applyAutocompleteFocus: function applyAutocompleteFocus() {
      var _this = this;

      this.$nextTick(function () {
        if (_this.$refs.autocomplete) _this.$refs.autocomplete.onFocus();
      });
    },
    cleanField: function cleanField() {
      this.$refs.autocomplete.query = '';
    },
    deleteChip: function deleteChip(chip) {
      var index = this.selectedChips.indexOf(chip);

      if (index >= 0) {
        this.selectedChips.splice(index, 1);
      }

      this.$emit('change', this.selectedChips);
      this.applyAutocompleteFocus();
    },
    deleteLastChip: function deleteLastChip() {
      if (!this.currentChip) {
        this.selectedChips.pop();
        this.$emit('change', this.selectedChips);
        this.applyAutocompleteFocus();
      }
    },
    onFocus: function onFocus() {
      if (this.parentContainer) {
        this.parentContainer.isFocused = true;
      }
      this.$refs.autocomplete.onFocus();
    },
    onInput: function onInput() {
      this.updateValues();
    },
    onBlur: function onBlur() {
      this.parentContainer.isFocused = false;
    },
    verifyProps: function verifyProps() {
      if (!this.parentContainer) {
        return this.throwErrorDestroy('You should wrap the md-input in a md-input-container');
      } else if (!this.listIsEmpty && this.filterList) {
        return this.throwErrorDestroy('You should use a `filterList` function prop with the `list` prop');
      } else if (!this.fetch) {
        return this.throwErrorDestroy('You should use a `fetch` function prop');
      }
      return this;
    },
    throwErrorDestroy: function throwErrorDestroy(errorMessage) {
      this.$destroy();
      throw new Error(errorMessage);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.parentContainer = (0, _helpers.getClosestVueParent)(_this2.$parent, 'md-input-container');

      if (!_this2.listIsEmpty) {
        _this2.items = (0, _assign2.default)([], _this2.list);
      }
    });
  }
};

/***/ }),
/* 385 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 386 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CentroCustoTabela_vue_vue_type_script_lang_js___ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CentroCustoTabela_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CentroCustoTabela_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CentroCustoTabela_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CentroCustoTabela_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CentroCustoTabela_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(4);

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuejsPaginate = __webpack_require__(27);

var _vuejsPaginate2 = _interopRequireDefault(_vuejsPaginate);

var _tabelaCommonsMixin = __webpack_require__(117);

var _tabelaCommonsMixin2 = _interopRequireDefault(_tabelaCommonsMixin);

var _TabelaGenerica = __webpack_require__(20);

var _TabelaGenerica2 = _interopRequireDefault(_TabelaGenerica);

var _mdChipsAutocomplete = __webpack_require__(65);

var _mdChipsAutocomplete2 = _interopRequireDefault(_mdChipsAutocomplete);

var _mdAutocomplete = __webpack_require__(16);

var _mdAutocomplete2 = _interopRequireDefault(_mdAutocomplete);

var _rolesComputedGenerator = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  extends: _TabelaGenerica2.default,
  mixins: [_tabelaCommonsMixin2.default],
  data: function data() {
    return {
      centroCustoResources: this.$api.centroCusto(this.$resource),
      bloquearBotaoExportacao: false,
      centroCustos: [],
      esperar: false,
      headers: [{ text: this.$tc('label.cod_centro_custo', 1), value: 'id_externo' }, { text: this.$tc('label.nome', 1), value: 'nome' }],
      pagination: {},
      totalPage: 0,
      searchQuery: '',
      selected: [],
      statusFilter: 'true'
    };
  },

  props: {
    fetchExtensaoFunction: Function,
    prepareResponseData: Function,
    statusFilter: {
      type: String,
      default: 'true'
    }
  },
  components: {
    mdChipsAutocomplete: _mdChipsAutocomplete2.default,
    mdAutocomplete: _mdAutocomplete2.default,
    Paginate: _vuejsPaginate2.default
  },
  computed: (0, _extends3.default)({}, (0, _rolesComputedGenerator.generateComputed)('Ceco', ['canAccessCRUD']), {
    centroCustoFilteredList: function centroCustoFilteredList() {
      var _this = this;

      return this.filteredList.map(function (linha) {
        var row = (0, _assign2.default)({}, linha);

        row.dependencias = _this.stringToArray(linha);

        return row;
      });
    }
  }),
  watch: {
    pagination: {
      handler: function handler() {
        this.filtrar();
      },

      deep: true
    },
    searchQuery: function searchQuery(novoValor) {
      var _this2 = this;

      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      this.timeout = window.setTimeout(function () {
        _this2.$emit('TABELA_FILTRAR_PAGINA', novoValor);
      }, 500);
    },
    paginationSize: function paginationSize(valor) {
      this.$emit('PAGINACAO_ALTERANDO_TAMANHO_PAGINA', valor);
    }
  },
  methods: {
    buscar: function buscar() {
      if (this.searchQuery) {
        this.pagination.page = 1;
      }
    },
    filtrar: function filtrar() {
      var _this3 = this;

      if (this.esperar) return;
      this.esperar = true;
      setTimeout(function () {
        _this3.buscar();
      }, 5E2);
    },
    getSearchQuery: function getSearchQuery() {
      return this.searchQuery;
    },
    extractCanaisName: function extractCanaisName(row) {
      return row.dependencias.canais.map(function (el) {
        return el.nomExtensao;
      }).join(', ');
    },
    extractMarcasName: function extractMarcasName(row) {
      return row.dependencias.marcas.map(function (el) {
        return el.nomExtensao;
      }).join(', ');
    },
    fetchSuperiorCanalFunction: function fetchSuperiorCanalFunction() {
      return this.fetchExtensaoFunction({
        nome: this.$refs.canalAutoComplete['0'].$refs.autocomplete.query,
        idNivelExtensao: 3
      });
    },
    fetchSuperiorMarcaFunction: function fetchSuperiorMarcaFunction() {
      return this.fetchExtensaoFunction({
        nome: this.$refs.marcaAutoComplete['0'].$refs.autocomplete.query,
        idNivelExtensao: 2
      });
    },
    fetchSuperiorUnidadeNegocioFunction: function fetchSuperiorUnidadeNegocioFunction() {
      return this.fetchExtensaoFunction({
        nome: this.$refs.unidadeNegocioAutoComplete['0'].query,
        idNivelExtensao: 1
      });
    },
    setUnidadeNegocio: function setUnidadeNegocio(hit, row) {
      var unidadeNegocio = {
        id: hit.id,
        nomExtensao: hit.nomExtensao
      };
      this.updateItemDependency(row, 'unidadeNegocio', unidadeNegocio);
    },
    updateItemDependency: function updateItemDependency(row, property, dependency) {
      var item = (0, _assign2.default)({}, row);
      item.dependencias[property] = dependency;
      this.$emit('TABELAGENERICA_ATUALIZAR', item);
      this.cleanEdition();
    },
    stringToArray: function stringToArray(linha) {
      if (typeof linha.canais !== 'string' && typeof linha.marcas !== 'string') {
        return linha.dependencias;
      }

      var canaisObj = !linha.canais ? [] : linha.canais.split(',').map(function (cat) {
        var canaisStr = cat.split(':');
        return {
          id: parseInt(canaisStr[0], 10),
          nomExtensao: canaisStr[1]
        };
      });

      var marcasObj = !linha.marcas ? [] : linha.marcas.split(',').map(function (cat) {
        var marcasStr = cat.split(':');
        return {
          id: parseInt(marcasStr[0], 10),
          nomExtensao: marcasStr[1]
        };
      });

      var unidadeNegocioStr = linha.unidadenegocio.split(':');
      var unidadeNegocioObj = {
        id: parseInt(unidadeNegocioStr[0], 10),
        nomExtensao: unidadeNegocioStr[1]
      };

      return {
        canais: canaisObj,
        marcas: marcasObj,
        unidadeNegocio: unidadeNegocioObj
      };
    },
    validadeUpdateItem: function validadeUpdateItem(row, rowIndex, columnIndex) {
      if (row.indCliente === false && row.indProduto === false) {
        this.$toast.create(this.$t('message.erro_salvar_centro_sem_produto_cliente'), 'snack', 5E3);
        return;
      }

      this.updateItem(row, rowIndex, columnIndex);
      this.currentEditItem = null;
    },
    handleStatusFilterChange: function handleStatusFilterChange() {
      this.paginationPage = 0;
      this.$emit('TABELA_FILTRAR_STATUS', this.statusFilter);
      this.filtrar();
    }
  },
  mounted: function mounted() {
    this.filtrar();
  }
};

/***/ }),
/* 389 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 390 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Cliente_vue_vue_type_script_lang_js___ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Cliente_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Cliente_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Cliente_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Cliente_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Cliente_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'Cliente'
};

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Configuracao_vue_vue_type_script_lang_js___ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Configuracao_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Configuracao_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Configuracao_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Configuracao_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Configuracao_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(6);

var _ConfiguracaoWorkflowAprovacao = __webpack_require__(1130);

var _ConfiguracaoWorkflowAprovacao2 = _interopRequireDefault(_ConfiguracaoWorkflowAprovacao);

var _ConfiguracaoCalendarioAprovacao = __webpack_require__(1135);

var _ConfiguracaoCalendarioAprovacao2 = _interopRequireDefault(_ConfiguracaoCalendarioAprovacao);

var _ConfiguracaoWorkflowContrato = __webpack_require__(1140);

var _ConfiguracaoWorkflowContrato2 = _interopRequireDefault(_ConfiguracaoWorkflowContrato);

var _ConfiguracaoOrcamento = __webpack_require__(1145);

var _ConfiguracaoOrcamento2 = _interopRequireDefault(_ConfiguracaoOrcamento);

var _ConfiguracaoApuracaoAcordo = __webpack_require__(1153);

var _ConfiguracaoApuracaoAcordo2 = _interopRequireDefault(_ConfiguracaoApuracaoAcordo);

var _ConfiguracaoPagamento = __webpack_require__(1158);

var _ConfiguracaoPagamento2 = _interopRequireDefault(_ConfiguracaoPagamento);

var _ConfiguracaoCadastro = __webpack_require__(1162);

var _ConfiguracaoCadastro2 = _interopRequireDefault(_ConfiguracaoCadastro);

var _ConfiguracaoNotificacaoEmail = __webpack_require__(1167);

var _ConfiguracaoNotificacaoEmail2 = _interopRequireDefault(_ConfiguracaoNotificacaoEmail);

var _configuracao = __webpack_require__(1175);

var _configuracao2 = _interopRequireDefault(_configuracao);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Configuracao',
  data: function data() {
    return {
      configuracaoResources: (0, _configuracao2.default)(this.$resource)
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('roles', ['getAllRoles']), {
    canAccessPage: function canAccessPage() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el.startsWith('CONFIG');
      }).length;
    },
    canAccessPageOrcamento: function canAccessPageOrcamento() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el === 'CONFIG_ORC';
      }).length;
    },
    canAccessPageCalendario: function canAccessPageCalendario() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el === 'CONFIG_CALENDARIO';
      }).length;
    },
    canAccessPageWorkflowAprovacao: function canAccessPageWorkflowAprovacao() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el === 'CONFIG_FLUXO';
      }).length;
    },
    canAccessPageWorkflowContrato: function canAccessPageWorkflowContrato() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el === 'CONFIG_NEG';
      }).length;
    },
    canAccessPageApuracaoAcordo: function canAccessPageApuracaoAcordo() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el === 'CONFIG_APURACAO';
      }).length;
    },
    canAccessPagePagamento: function canAccessPagePagamento() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el === 'CONFIG_PGTO';
      }).length;
    },
    canAccessPageCadastro: function canAccessPageCadastro() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el === 'CONFIG_CADASTRO';
      }).length;
    },
    canAccessPageNotificacaoEmail: function canAccessPageNotificacaoEmail() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el === 'CONFIG_EMAIL';
      }).length;
    }
  }),
  components: {
    ConfiguracaoWorkflowAprovacao: _ConfiguracaoWorkflowAprovacao2.default,
    ConfiguracaoCalendarioAprovacao: _ConfiguracaoCalendarioAprovacao2.default,
    ConfiguracaoWorkflowContrato: _ConfiguracaoWorkflowContrato2.default,
    ConfiguracaoOrcamento: _ConfiguracaoOrcamento2.default,
    ConfiguracaoApuracaoAcordo: _ConfiguracaoApuracaoAcordo2.default,
    ConfiguracaoPagamento: _ConfiguracaoPagamento2.default,
    ConfiguracaoCadastro: _ConfiguracaoCadastro2.default,
    ConfiguracaoNotificacaoEmail: _ConfiguracaoNotificacaoEmail2.default
  },
  methods: {
    accessForbidden: function accessForbidden() {
      if (!this.canAccessPage) {
        this.$router.push({ name: 'inicio' });
        this.$toast.create('Acesso negado', 'snack', 3E3);
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (!this.canAccessPage) {
      window.setTimeout(function () {
        return _this.accessForbidden();
      }, 1E3);
    }
  }
};

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoWorkflowAprovacao_vue_vue_type_script_lang_js___ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoWorkflowAprovacao_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoWorkflowAprovacao_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoWorkflowAprovacao_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoWorkflowAprovacao_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoWorkflowAprovacao_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(4);

var _assign2 = _interopRequireDefault(_assign);

var _configuracaoWorkflowAprovacao = __webpack_require__(1133);

var _configuracaoWorkflowAprovacao2 = _interopRequireDefault(_configuracaoWorkflowAprovacao);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ConfiguracaoWorkflowAprovacao',
  data: function data() {
    return {
      configuracaoWorkflowAprovacaoResources: (0, _configuracaoWorkflowAprovacao2.default)(this.$resource),
      aprovacoes: [],
      disableCheck: false
    };
  },

  components: {},
  methods: {
    requestPopular: function requestPopular() {
      var _this = this;

      this.configuracaoWorkflowAprovacaoResources.pesquisar().then(function (response) {
        var objeto = response.data;
        if (!objeto || !objeto.length) {
          return;
        }

        _this.aprovacoes = objeto.map(function (el) {
          el.valorParametro = el.valorParametro === 'true';
          return el;
        });
      });
    },
    requestAtualizar: function requestAtualizar(objeto) {
      var _this2 = this;

      if (!this.disableCheck) {
        this.disableCheck = true;
        setTimeout(function () {
          var payload = (0, _assign2.default)({}, objeto);
          delete payload.tabela;
          _this2.configuracaoWorkflowAprovacaoResources.atualizar(payload).then(function () {
            _this2.$toast.create(_this2.$t('message.atualizado_confira_tabela'), 'snack', 3E3);
            _this2.disableCheck = false;
          }).catch(function (err) {
            _this2.$error(_this2, err);
            _this2.disableCheck = false;
          });
        }, 500);
      }
    }
  },
  mounted: function mounted() {
    this.requestPopular();
  }
};

/***/ }),
/* 397 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoCalendarioAprovacao_vue_vue_type_script_lang_js___ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoCalendarioAprovacao_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoCalendarioAprovacao_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoCalendarioAprovacao_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoCalendarioAprovacao_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoCalendarioAprovacao_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(4);

var _assign2 = _interopRequireDefault(_assign);

var _configuracaoCalendarioAprovacao = __webpack_require__(1138);

var _configuracaoCalendarioAprovacao2 = _interopRequireDefault(_configuracaoCalendarioAprovacao);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ConfiguracaoCalendarioAprovacao',
  data: function data() {
    return {
      confCalendarioAprovacaoResources: (0, _configuracaoCalendarioAprovacao2.default)(this.$resource),
      aprovacoes: [],
      disableCheck: false
    };
  },

  components: {},
  methods: {
    requestPopular: function requestPopular() {
      var _this = this;

      this.confCalendarioAprovacaoResources.pesquisar().then(function (response) {
        var objeto = response.data;
        if (!objeto || !objeto.length) {
          return;
        }

        _this.aprovacoes = objeto.map(function (el) {
          el.valorParametro = el.valorParametro === 'true';
          return el;
        });
      });
    },
    requestAtualizar: function requestAtualizar(objeto) {
      var _this2 = this;

      if (!this.disableCheck) {
        this.disableCheck = true;
        setTimeout(function () {
          var payload = (0, _assign2.default)({}, objeto);
          delete payload.tabela;
          _this2.confCalendarioAprovacaoResources.atualizar(payload).then(function () {
            _this2.$toast.create(_this2.$t('message.atualizado_confira_tabela'), 'snack', 3E3);
            _this2.atualizar(objeto);
            _this2.disableCheck = false;
          }).catch(function (err) {
            _this2.$error(_this2, err);
            _this2.disableCheck = false;
          });
        }, 500);
      }
    }
  },
  mounted: function mounted() {
    this.requestPopular();
  }
};

/***/ }),
/* 400 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoWorkflowContrato_vue_vue_type_script_lang_js___ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoWorkflowContrato_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoWorkflowContrato_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoWorkflowContrato_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoWorkflowContrato_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoWorkflowContrato_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(11);

var _keys2 = _interopRequireDefault(_keys);

var _configuracaoWorkflowContrato = __webpack_require__(1143);

var _configuracaoWorkflowContrato2 = _interopRequireDefault(_configuracaoWorkflowContrato);

var _helpers = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ConfiguracaoWorkflowContrato',
  data: function data() {
    return {
      configuracaoWorkflowContratoResources: (0, _configuracaoWorkflowContrato2.default)(this.$resource),
      contratos: [],
      negociacoes: [],
      configuracoesContrato: [],
      tipoAcordo: '',
      tipoProvisao: '',
      disableCheck: false,
      tipos: [{ tipo: 'FIXO', descricao: this.$t('label.gasto_fixo') }, { tipo: 'MARGEM', descricao: this.$t('label.margem') }]
    };
  },

  computed: {
    hasConfiguracoesContrato: function hasConfiguracoesContrato() {
      return !!(this.configuracoesContrato && this.configuracoesContrato.length);
    },
    grupos: function grupos() {
      var _this = this;

      if (this.hasConfiguracoesContrato) {
        var grupos = this._.groupBy(this.configuracoesContrato, function (el) {
          return el.nomeGrupo;
        });
        (0, _keys2.default)(grupos).forEach(function (key) {
          grupos[key] = _this._.groupBy(grupos[key], function (el) {
            return el.nomeSubGrupo || 'SEM_SUB_GRUPO';
          });
        });
        return grupos;
      }
      return [];
    },
    contratosCombobox: function contratosCombobox() {
      return this.contratos.length ? this.contratos.filter(function (el) {
        return el.valor;
      }) : [];
    }
  },
  methods: {
    convertToBool: function convertToBool() {
      this.contratos.forEach(function (el) {
        el.valor = el.valor === 'true';
      });
    },
    copyObject: function copyObject(el) {
      if (el.valor === true) {
        this.contratosCombobox.push(el);
      }
    },
    requestAtualizar: function requestAtualizar(item, $event) {
      var _this2 = this;

      if (!this.disableCheck) {
        this.disableCheck = true;
        setTimeout(function () {
          var valorSelecao = $event;
          var nomeAcordo = item.nomeAcordo;
          _this2.contratosCombobox = [];
          _this2.contratos.map(_this2.copyObject);

          _this2.configuracaoWorkflowContratoResources.atualizarTipoAcordo({ valorSelecao: valorSelecao, nomeAcordo: nomeAcordo }, {}).then(function () {
            _this2.disableCheck = false;
            _this2.$toast.create(_this2.$t('message.atualizado_confira_tabela'), 'snack', 3E3);
          }).catch(function (err) {
            _this2.$error(_this2, err);
            _this2.disableCheck = false;
          });
        }, 500);
      }
    },
    requestAtualizarConfiguracao: function requestAtualizarConfiguracao(item, $event) {
      var _this3 = this;

      item.valorSelecao = $event;
      delete item.vlrSelecao;

      this.configuracaoWorkflowContratoResources.atualizarConfiguracoesContrato(item).catch(function (err) {
        _this3.$error(_this3, err);
      });
      this.$forceUpdate();
    },
    requestAtualizarSubConfiguracao: function requestAtualizarSubConfiguracao(item) {
      var _this4 = this;

      if (!this.disableCheck) {
        this.disableCheck = true;
        setTimeout(function () {
          _this4.configuracaoWorkflowContratoResources.atualizarSubConfiguracoesContrato(item).then(function () {
            _this4.disableCheck = false;
          }).catch(function (err) {
            _this4.disableCheck = false;
            _this4.$error(_this4, err);
          });
        }, 500);
      }
    },
    requestAtualizarTipoProvisao: function requestAtualizarTipoProvisao() {
      var nomeAcordo = this.tipoAcordo;
      this.configuracaoWorkflowContratoResources.atualizarTipoProvisao({ nomeAcordo: nomeAcordo }, this.tipoProvisao).then(function () {});
    },
    requestPopularTipoProvisao: function requestPopularTipoProvisao() {
      var _this5 = this;

      var nomeAcordo = this.tipoAcordo;
      this.configuracaoWorkflowContratoResources.pesquisarTipoProvisao({ nomeAcordo: nomeAcordo }).then(function (response) {
        _this5.tipoProvisao = response.bodyText;
      });
    },
    requestPopular: function requestPopular() {
      var _this6 = this;

      this.configuracaoWorkflowContratoResources.pesquisar().then(function (response) {
        var objeto = response.data;
        if (!objeto || !objeto.length) {
          return;
        }

        _this6.negociacoes = objeto.filter(function (el) {
          return el.idConfiguracao === 'NEGOCIACOES';
        }).map(function (el) {
          el.valor = el.valor === 'true';
          return el;
        });

        _this6.contratos = objeto.filter(function (el) {
          return el.idConfiguracao === 'ACORDO';
        }).map(function (el) {
          el.valor = el.valor === 'true';
          return el;
        });
        if (_this6.contratos) {
          _this6.requestPrimeiroContrato();
        }
      });
    },
    requestPopularConfiguracoesContrato: function requestPopularConfiguracoesContrato(_ref) {
      var _this7 = this;

      var nomeAcordo = _ref.nomeAcordo;

      this.requestPopularTipoProvisao();

      this.configuracoesContrato = [];
      this.configuracaoWorkflowContratoResources.pesquisarConfiguracoesContrato({ nomeAcordo: nomeAcordo }, {}).then(function (response) {
        var objeto = response.data;
        _this7.configuracoesContrato = objeto.map(function (el) {
          el.vlrSelecao = el.valorSelecao === 'true';
          return el;
        });
      });
    },
    requestPrimeiroContrato: function requestPrimeiroContrato() {
      if (this.contratosCombobox.length) {
        var selected = this.contratosCombobox[0];
        this.tipoAcordo = selected.nomeAcordo;
        this.requestPopularConfiguracoesContrato(selected);
      }
    }
  },
  mounted: function mounted() {
    this.requestPopular();
  }
};

/***/ }),
/* 403 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoOrcamento_vue_vue_type_script_lang_js___ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoOrcamento_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoOrcamento_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoOrcamento_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoOrcamento_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoOrcamento_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _isInteger = __webpack_require__(406);

var _isInteger2 = _interopRequireDefault(_isInteger);

var _assign = __webpack_require__(4);

var _assign2 = _interopRequireDefault(_assign);

var _configuracaoOrcamento = __webpack_require__(1151);

var _configuracaoOrcamento2 = _interopRequireDefault(_configuracaoOrcamento);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ConfiguracaoOrcamento',
  data: function data() {
    return {
      configuracaoOrcamentoResources: (0, _configuracaoOrcamento2.default)(this.$resource),
      configuracoesOrcamento: [],
      rateio: {},
      moduloOrcamento: {},
      notificacaoOrcamento: {
        valorParametro: false,
        observacaoFront: null
      },
      debounceTimeout: null,
      errors: {
        observacaoFront: null
      },
      orcamentoVisible: true,
      rateioVisible: true
    };
  },

  components: {},
  methods: {
    requestPopular: function requestPopular() {
      var _this = this;

      this.configuracaoOrcamentoResources.pesquisar().then(function (response) {
        var objeto = response.data;
        if (!objeto || !objeto.length) {
          return;
        }

        _this.configuracoesOrcamento = objeto.map(function (el) {
          el.valorParametro = el.valorParametro === 'true';
          if (el.chaveParametro === 'MODULO_ORCAMENTO') {
            _this.moduloOrcamento = el;
          }
          if (el.chaveParametro === 'RATEIO') {
            _this.rateio = el;
          }
          if (el.chaveParametro === 'NOTIFICACAO') {
            _this.notificacaoOrcamento = el;
          }
          return el;
        });
      });
    },
    requestValidarVisibilidadeRateio: function requestValidarVisibilidadeRateio() {
      var _this2 = this;

      this.configuracaoOrcamentoResources.pesquisarRateio().then(function (response) {
        _this2.rateioVisible = response.data;
      });
    },
    requestValidarVisibilidadeOrcamento: function requestValidarVisibilidadeOrcamento() {
      var _this3 = this;

      this.configuracaoOrcamentoResources.pesquisarOrcamento().then(function (response) {
        _this3.orcamentoVisible = response.data;
      });
    },
    requestAtualizar: function requestAtualizar(objeto) {
      var _this4 = this;

      var payload = (0, _assign2.default)({}, objeto);
      payload.valorParametro = !payload.valorParametro;
      this.configuracaoOrcamentoResources.atualizar(payload).then(function () {
        if (objeto.chaveParametro === 'MODULO_ORCAMENTO') {
          _this4.validateOrcamento(_this4.moduloOrcamento);
        }

        _this4.$toast.create(_this4.$t('message.atualizado_confira_tabela'), 'snack', 3E3);
      }).catch(function (err) {
        _this4.$error(_this4, err);
      });
    },
    validateOrcamento: function validateOrcamento(objeto) {
      var _this5 = this;

      if (objeto.valorParametro === false) {
        this.rateio.valorParametro = false;

        this.configuracaoOrcamentoResources.atualizar(this.rateio).then(function () {
          _this5.$toast.create(_this5.$t('message.atualizado_confira_tabela'), 'snack', 3E3);
        }).catch(function (err) {
          _this5.$error(_this5, err);
        });
      }
    },
    handleSwitchChange: function handleSwitchChange(isActive) {
      if (isActive && !this.notificacaoOrcamento.observacaoFront) {
        this.notificacaoOrcamento.observacaoFront = 1;
      }
      this.requestAtualizar(this.notificacaoOrcamento);
      this.validateDayInput();
    },
    validateDayInput: function validateDayInput() {
      this.errors.observacaoFront = null;

      if (this.notificacaoOrcamento.valorParametro) {
        var value = this.notificacaoOrcamento.observacaoFront;
        if (value === null || value === '' || value === undefined) {
          this.errors.observacaoFront = this.$t('validacoes.campo_obrigatorio');
          return false;
        }
        if (!(0, _isInteger2.default)(Number(value)) || value <= 0) {
          this.errors.observacaoFront = this.$t('validacoes.positivo_inteiro');
          return false;
        }

        if (value > 999) {
          this.errors.observacaoFront = this.$t('validacoes.max_digitos', { max: 3 });
          return false;
        }
      }

      return true;
    },
    atualizarDiaNotificacao: function atualizarDiaNotificacao() {
      var _this6 = this;

      if (!this.validateDayInput()) return;
      this.notificacaoOrcamento.observacaoFront = this.notificacaoOrcamento.observacaoFront || 1;

      clearTimeout(this.debounceTimeout);

      this.debounceTimeout = setTimeout(function () {
        if (!_this6.validateDayInput()) return;

        var payload = (0, _extends3.default)({}, _this6.notificacaoOrcamento, {
          observacaoFront: _this6.notificacaoOrcamento.observacaoFront || 1
        });

        _this6.configuracaoOrcamentoResources.atualizar(payload).then(function () {
          _this6.$toast.create(_this6.$t('message.atualizado_confira_tabela'), 'snack', 3E3);
        }).catch(function (err) {
          _this6.$error(_this6, err);
        });
      }, 500);
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearTimeout(this.debounceTimeout);
  },
  mounted: function mounted() {
    this.requestPopular();
    this.requestValidarVisibilidadeRateio();
    this.requestValidarVisibilidadeOrcamento();
  }
};

/***/ }),
/* 406 */,
/* 407 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoApuracaoAcordo_vue_vue_type_script_lang_js___ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoApuracaoAcordo_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoApuracaoAcordo_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoApuracaoAcordo_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoApuracaoAcordo_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoApuracaoAcordo_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _configuracaoApuracaoAcordo = __webpack_require__(1156);

var _configuracaoApuracaoAcordo2 = _interopRequireDefault(_configuracaoApuracaoAcordo);

var _helpers = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ConfiguracaoApuracao',
  data: function data() {
    return {
      configuracaoApuracaoAcordoResources: (0, _configuracaoApuracaoAcordo2.default)(this.$resource),
      contratos: [],
      negociacoes: [],
      configuracoesContrato: [],
      tipoAcordo: '',
      disableCheck: false
    };
  },

  computed: {
    hasConfiguracoesContrato: function hasConfiguracoesContrato() {
      return !!(this.configuracoesContrato && this.configuracoesContrato.length);
    },
    grupos: function grupos() {
      return this.hasConfiguracoesContrato ? this._.groupBy(this.configuracoesContrato, function (el) {
        return el.nomeGrupo;
      }) : [];
    },
    contratosCombobox: function contratosCombobox() {
      return this.contratos.length ? this.contratos.filter(function (el) {
        return el.valor;
      }) : [];
    }
  },
  methods: {
    convertToBool: function convertToBool() {
      this.contratos.forEach(function (el) {
        el.valor = el.valor === 'true';
      });
    },
    copyObject: function copyObject(el) {
      if (el.valor === true) {
        this.contratosCombobox.push(el);
      }
    },
    requestAtualizarConfiguracao: function requestAtualizarConfiguracao(item, $event) {
      var _this = this;

      if (!this.disableCheck) {
        this.disableCheck = true;
        setTimeout(function () {
          item.valor = $event;

          _this.configuracaoApuracaoAcordoResources.atualizarConfiguracoesApuracaoAcordo(item).catch(function (err) {
            _this.$error(_this, err);
          });

          _this.disableCheck = false;
        }, 500);
      }
    },
    requestAtualizarSubConfiguracao: function requestAtualizarSubConfiguracao(item) {
      var _this2 = this;

      if (!this.disableCheck) {
        this.disableCheck = true;
        setTimeout(function () {
          _this2.configuracaoApuracaoAcordoResources.atualizarSubConfiguracoesApuracaoAcordo(item).then(function () {
            _this2.$toast.create(_this2.$t('message.atualizado_confira_tabela'), 'snack', 3E3);
          }).catch(function (err) {
            _this2.$error(_this2, err);
          });

          _this2.disableCheck = false;
        }, 500);
      }
    },
    requestPopular: function requestPopular() {
      var _this3 = this;

      this.configuracaoApuracaoAcordoResources.pesquisar().then(function (response) {
        var objeto = response.data;
        if (!objeto || !objeto.length) {
          return;
        }

        _this3.contratos = objeto.filter(function (el) {
          return el.idConfiguracao === 'ACORDO';
        }).map(function (el) {
          el.valor = el.valor === 'true';
          return el;
        });

        if (_this3.contratos) {
          _this3.requestPrimeiroContrato();
        }
      });
    },
    requestPopularConfiguracoesContrato: function requestPopularConfiguracoesContrato(_ref) {
      var _this4 = this;

      var nomeAcordo = _ref.nomeAcordo;

      this.configuracaoApuracaoAcordoResources.pesquisarConfiguracoesApuracaoAcordo({ nomeAcordo: nomeAcordo }, {}).then(function (response) {
        var objeto = response.data;
        _this4.configuracoesContrato = objeto.map(function (el) {
          el.vlrSelecao = el.valor === 'true';
          return el;
        });
      });
    },
    requestPrimeiroContrato: function requestPrimeiroContrato() {
      if (this.contratosCombobox.length) {
        var selected = this.contratosCombobox[0];
        this.tipoAcordo = selected.nomeAcordo;
        this.requestPopularConfiguracoesContrato(selected);
      }
    }
  },
  mounted: function mounted() {
    this.requestPopular();
  }
};

/***/ }),
/* 410 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoPagamento_vue_vue_type_script_lang_js___ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoPagamento_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoPagamento_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoPagamento_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoPagamento_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoPagamento_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(4);

var _assign2 = _interopRequireDefault(_assign);

var _configuracaoPagamento = __webpack_require__(712);

var _configuracaoPagamento2 = _interopRequireDefault(_configuracaoPagamento);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ConfiguracaoPagamento',
  data: function data() {
    return {
      configuracaoPagamentoResource: (0, _configuracaoPagamento2.default)(this.$resource),
      configuracoes: [],
      moduloPagamento: {},
      sapVisible: true
    };
  },

  components: {},
  methods: {
    requestPopular: function requestPopular() {
      var _this = this;

      this.configuracaoPagamentoResource.pesquisar().then(function (response) {
        var objeto = response.data;
        if (!objeto || !objeto.length) {
          return;
        }

        _this.configuracoes = objeto.map(function (el) {
          el.valorParametro = el.valorParametro === 'true';
          if (el.chaveParametro === 'SAP_AUTOMATICO') {
            _this.moduloPagamento = el;
          }
          return el;
        });
      });
    },
    requestValidarVisibilidadeSap: function requestValidarVisibilidadeSap() {
      var _this2 = this;

      this.configuracaoPagamentoResource.pesquisarSap().then(function (response) {
        _this2.sapVisible = response.data;
      });
    },
    requestAtualizar: function requestAtualizar(objeto) {
      var _this3 = this;

      var payload = (0, _assign2.default)({}, objeto);
      payload.valorParametro = !payload.valorParametro;
      this.configuracaoPagamentoResource.atualizar(payload).then(function () {
        _this3.$toast.create(_this3.$t('message.atualizado_confira_tabela'), 'snack', 3E3);
      }).catch(function (err) {
        _this3.$error(_this3, err);
      });
    }
  },
  mounted: function mounted() {
    this.requestPopular();
    this.requestValidarVisibilidadeSap();
  }
};

/***/ }),
/* 413 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoCadastro_vue_vue_type_script_lang_js___ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoCadastro_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoCadastro_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoCadastro_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoCadastro_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoCadastro_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(4);

var _assign2 = _interopRequireDefault(_assign);

var _configuracaoCadastro = __webpack_require__(1165);

var _configuracaoCadastro2 = _interopRequireDefault(_configuracaoCadastro);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ConfiguracaoCadastro',
  data: function data() {
    return {
      configuracaoCadastroResource: (0, _configuracaoCadastro2.default)(this.$resource),
      configuracoes: [],
      sapVisible: true
    };
  },

  components: {},
  methods: {
    requestPopular: function requestPopular() {
      var _this = this;

      this.configuracaoCadastroResource.pesquisar().then(function (response) {
        var objeto = response.data;
        if (!objeto || !objeto.length) {
          return;
        }

        _this.configuracoes = objeto.map(function (el) {
          el.valorParametro = el.valorParametro === 'true';
          return el;
        });
      });
    },
    requestAtualizar: function requestAtualizar(objeto) {
      var _this2 = this;

      var payload = (0, _assign2.default)({}, objeto);
      payload.valorParametro = !payload.valorParametro;
      this.configuracaoCadastroResource.atualizar(payload).then(function () {
        _this2.$toast.create(_this2.$t('message.atualizado_confira_tabela'), 'snack', 3E3);
      }).catch(function (err) {
        _this2.$error(_this2, err);
      });
    }
  },
  mounted: function mounted() {
    this.requestPopular();
  }
};

/***/ }),
/* 416 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoNotificacaoEmail_vue_vue_type_script_lang_js___ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoNotificacaoEmail_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoNotificacaoEmail_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoNotificacaoEmail_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoNotificacaoEmail_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoNotificacaoEmail_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(9);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _values = __webpack_require__(42);

var _values2 = _interopRequireDefault(_values);

var _isInteger = __webpack_require__(406);

var _isInteger2 = _interopRequireDefault(_isInteger);

var _configuracaoNotificacaoEmail = __webpack_require__(1173);

var _configuracaoNotificacaoEmail2 = _interopRequireDefault(_configuracaoNotificacaoEmail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'configuracaoNotificacaoEmail',
  data: function data() {
    return {
      configuracaoNotificacaoEmailResources: (0, _configuracaoNotificacaoEmail2.default)(this.$resource),
      emailErrors: {
        negociacao: { numero: [], email: [] },
        apuracao: { numero: [], email: [] },
        pagamento: { numero: [], email: [] }
      },
      negociacao: [{
        status: 'label.status_em_cadastro',
        valorParametro: '',
        enviarAlternativo: false,
        emailAlternativo: '',
        chaveParametro: 'NEGOCIACAO-EM-CADASTRO'
      }, {
        status: 'label.status_em_aprovacao',
        valorParametro: '',
        enviarAlternativo: false,
        emailAlternativo: '',
        chaveParametro: 'NEGOCIACAO-EM-APROVACAO'
      }, {
        status: 'label.status_em_analise',
        valorParametro: '',
        enviarAlternativo: false,
        emailAlternativo: '',
        chaveParametro: 'NEGOCIACAO-EM-ANALISE'
      }],
      apuracao: [{
        status: 'label.status_em_apuracao',
        valorParametro: '',
        enviarAlternativo: false,
        emailAlternativo: '',
        chaveParametro: 'APURACAO-EM-APURACAO'
      }, {
        status: 'label.status_em_aprovacao',
        valorParametro: '',
        enviarAlternativo: false,
        emailAlternativo: '',
        chaveParametro: 'APURACAO-EM-APROVACAO'
      }, {
        status: 'label.status_em_analise',
        valorParametro: '',
        enviarAlternativo: false,
        emailAlternativo: '',
        chaveParametro: 'APURACAO-EM-ANALISE'
      }],
      pagamento: [{
        status: 'label.status_em_pendente_integracao',
        valorParametro: '',
        enviarAlternativo: false,
        emailAlternativo: '',
        chaveParametro: 'PAGAMENTO-PENDENTE-INTEGRACAO'
      }, {
        status: 'label.status_em_aguardando_pagamento',
        valorParametro: '',
        enviarAlternativo: false,
        emailAlternativo: '',
        chaveParametro: 'PAGAMENTO-AGUARDANDO-PAGAMENTO'
      }]
    };
  },

  methods: {
    validarCampos: function validarCampos() {
      var _this = this;

      this.emailErrors = {
        negociacao: { numero: [], email: [] },
        apuracao: { numero: [], email: [] },
        pagamento: { numero: [], email: [] }
      };

      var validarEmail = function validarEmail(item, tipo, index) {
        if (item.enviarAlternativo) {
          if (!item.emailAlternativo) {
            _this.emailErrors[tipo].email[index] = 'O e-mail é obrigatório.';
          } else {
            var emails = item.emailAlternativo.split(',').map(function (email) {
              return email.trim();
            });
            var invalidEmails = emails.filter(function (email) {
              return !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
            });

            if (invalidEmails.length > 0) {
              _this.emailErrors[tipo].email[index] = 'Os seguintes e-mails s\xE3o inv\xE1lidos: ' + invalidEmails.join(', ');
            } else {
              _this.emailErrors[tipo].email[index] = '';
            }
          }
        } else {
          _this.emailErrors[tipo].email[index] = '';
        }
      };

      var validarNumero = function validarNumero(item, tipo, index) {
        var valor = item.valorParametro;

        if (!valor) {
          _this.emailErrors[tipo].numero[index] = 'O campo número é obrigatório.';
        } else if (!(0, _isInteger2.default)(Number(valor)) || Number(valor) <= 0) {
          _this.emailErrors[tipo].numero[index] = 'O valor deve ser um número inteiro positivo.';
        } else {
          _this.emailErrors[tipo].numero[index] = '';
        }
      };

      this.negociacao.forEach(function (negociacao, index) {
        validarEmail(negociacao, 'negociacao', index);
        validarNumero(negociacao, 'negociacao', index);
      });

      this.apuracao.forEach(function (apuracao, index) {
        validarEmail(apuracao, 'apuracao', index);
        validarNumero(apuracao, 'apuracao', index);
      });

      this.pagamento.forEach(function (pagamento, index) {
        validarEmail(pagamento, 'pagamento', index);
        validarNumero(pagamento, 'pagamento', index);
      });
    },
    requestAtualizar: function requestAtualizar() {
      var _this2 = this;

      this.validarCampos();
      var hasErrors = (0, _values2.default)(this.emailErrors).some(function (group) {
        return group.numero.some(function (error) {
          return error !== '';
        }) || group.email.some(function (error) {
          return error !== '';
        });
      });

      if (hasErrors) {
        this.$toast.create('Corrija os erros antes de salvar.', 'snack', 3000);
        return;
      }
      if (hasErrors) {
        this.$toast.create('Corrija os erros antes de salvar.', 'snack', 3000);
        return;
      }
      var payload = [].concat((0, _toConsumableArray3.default)(this.negociacao), (0, _toConsumableArray3.default)(this.apuracao), (0, _toConsumableArray3.default)(this.pagamento)).map(function (item) {
        return {
          chaveParametro: item.chaveParametro,
          valorParametro: item.valorParametro,
          enviarAlternativo: item.enviarAlternativo,
          emailAlternativo: item.emailAlternativo
        };
      });

      this.configuracaoNotificacaoEmailResources.atualizar(payload).then(function () {
        _this2.$toast.create(_this2.$t('message.atualizado_confira_tabela'), 'snack', 3000);
      }).catch(function (err) {
        _this2.$error(_this2, err);
      });
    },
    requestPopular: function requestPopular() {
      var _this3 = this;

      this.configuracaoNotificacaoEmailResources.pesquisar().then(function (response) {
        var objeto = response.data;

        if (!objeto || !objeto.length) return;

        var mapeamento = function mapeamento(dados, chaveBase) {
          return dados.filter(function (el) {
            return el.chaveParametro.startsWith(chaveBase);
          }).map(function (el) {
            return {
              status: _this3.mapeiaStatus(el.chaveParametro),
              valorParametro: el.valorParametro === 'true' ? true : el.valorParametro,
              enviarAlternativo: el.enviarAlternativo || false,
              emailAlternativo: el.emailAlternativo || '',
              chaveParametro: el.chaveParametro
            };
          });
        };

        _this3.negociacao = mapeamento(objeto, 'NEGOCIACAO');
        _this3.apuracao = mapeamento(objeto, 'APURACAO');
        _this3.pagamento = mapeamento(objeto, 'PAGAMENTO');
      }).catch(function (error) {
        _this3.$error(_this3, error);
      });
    },
    mapeiaStatus: function mapeiaStatus(chaveParametro) {
      var mapeamentoStatus = {
        'NEGOCIACAO-EM-CADASTRO': 'label.status_em_cadastro',
        'NEGOCIACAO-EM-APROVACAO': 'label.status_em_aprovacao',
        'NEGOCIACAO-EM-ANALISE': 'label.status_em_analise',
        'APURACAO-EM-APURACAO': 'label.status_em_apuracao',
        'APURACAO-EM-APROVACAO': 'label.status_em_aprovacao',
        'APURACAO-EM-ANALISE': 'label.status_em_analise',
        'PAGAMENTO-PENDENTE-INTEGRACAO': 'label.status_em_pendente_integracao',
        'PAGAMENTO-AGUARDANDO-PAGAMENTO': 'label.status_em_aguardando_pagamento'
      };

      return mapeamentoStatus[chaveParametro] || chaveParametro;
    },
    cancelar: function cancelar() {
      this.requestPopular();
    }
  },
  mounted: function mounted() {
    this.requestPopular();
  }
};

/***/ }),
/* 419 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DashBoard_vue_vue_type_script_lang_js___ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DashBoard_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DashBoard_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DashBoard_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DashBoard_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DashBoard_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(6);

var _vueRouter = __webpack_require__(122);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _DashboardPlanejamento = __webpack_require__(1180);

var _DashboardPlanejamento2 = _interopRequireDefault(_DashboardPlanejamento);

var _DashboardNegociacao = __webpack_require__(1195);

var _DashboardNegociacao2 = _interopRequireDefault(_DashboardNegociacao);

var _DashboardApuracao = __webpack_require__(1204);

var _DashboardApuracao2 = _interopRequireDefault(_DashboardApuracao);

var _DashboardPagamento = __webpack_require__(1242);

var _DashboardPagamento2 = _interopRequireDefault(_DashboardPagamento);

var _DashboardAcompanhamento = __webpack_require__(1266);

var _DashboardAcompanhamento2 = _interopRequireDefault(_DashboardAcompanhamento);

var _ExecucaoSidebar = __webpack_require__(703);

var _ExecucaoSidebar2 = _interopRequireDefault(_ExecucaoSidebar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      dashboardOrcamentoResources: this.$api.dashboardOrcamento(this.$resource),
      valor: null,
      currentData: null,
      exibiuPlanejamento: false,
      exibiuNegociacao: false,
      exibiuApuracao: false,
      exibiuPagamento: false,
      exibiuAcompanhamento: false,
      parametros: null,
      dashboardCarregado: false,
      index: null,
      apuracaoEmit: {}
    };
  },
  mounted: function mounted() {
    if (this.carregamentoCliente()) {
      this.setTabCliente();
    } else if (this.carregamentoParametro()) {
      this.setTabPorUrl();
    } else {
      this.setTabPorPermissao();
    }
  },

  components: {
    DashboardPlanejamento: _DashboardPlanejamento2.default,
    DashboardNegociacao: _DashboardNegociacao2.default,
    DashboardApuracao: _DashboardApuracao2.default,
    DashboardPagamento: _DashboardPagamento2.default,
    DashboardAcompanhamento: _DashboardAcompanhamento2.default,
    VueRouter: _vueRouter2.default,
    ExecucaoSidebarApuracao: _ExecucaoSidebar2.default
  },
  methods: {
    abrirSideBarApuracao: function abrirSideBarApuracao(eventData) {
      this.apuracaoEmit = eventData;
      this.$refs.apuracaoExecSidebar.toggle();
    },
    fecharSideBarApuracao: function fecharSideBarApuracao() {
      this.apuracaoEmit.fecharSideBar();
    },
    carregamentoCliente: function carregamentoCliente() {
      return this.getAllRoles.indexOf('DASH_OPER_CLIENTE') !== -1;
    },
    carregamentoParametro: function carregamentoParametro() {
      return this.$el.baseURI.indexOf('tab') !== -1;
    },
    setTabPorPermissao: function setTabPorPermissao() {
      var _this = this;

      var index = null;
      if (this.podeAcessarDashboardOrcamento) {
        index = 0;
      } else if (this.podeAcessarDashboardNegociacao) {
        index = 1;
      } else if (this.podeAcessarDashboardApuracao) {
        index = 2;
      } else if (this.podeAcessarDashboardPagamento) {
        index = 3;
      }
      if (index === null) {
        return;
      }

      setTimeout(function () {
        _this.dashboardCarregado = true;
        _this.setTab(index);
      });
    },
    setTabCliente: function setTabCliente() {
      var _this2 = this;

      this.parametros = this.extrairParametrosUrl();
      setTimeout(function () {
        _this2.dashboardCarregado = true;
        _this2.setTab(4);
      });
    },
    setTabPorUrl: function setTabPorUrl() {
      var _this3 = this;

      var index = null;
      this.parametros = this.extrairParametrosUrl();

      if (this.parametros.tab === 'negociacao' && this.podeAcessarDashboardNegociacao) {
        index = 1;
      } else if (this.parametros.tab === 'apuracao' && this.podeAcessarDashboardApuracao) {
        index = 2;
      } else if (this.parametros.tab === 'pagamento' && this.podeAcessarDashboardPagamento) {
        index = 3;
      } else if (this.podeAcessarDashboardOrcamento) {
        index = 0;
      }

      if (index === null) {
        return;
      }

      setTimeout(function () {
        _this3.dashboardCarregado = true;
        _this3.setTab(index);
      });
    },
    setTab: function setTab(index) {
      if (!this.dashboardCarregado) {
        return;
      }

      if (index === 0) {
        this.exibiuPlanejamento = true;
        this.$refs.mdTab.activeTab = 'orcamento';
        this.$refs.mdTab.activeTabNumber = 0;
      } else if (index === 1) {
        this.exibiuNegociacao = true;
        this.$refs.mdTab.activeTab = 'negociacao';
        this.$refs.mdTab.activeTabNumber = 1;
      } else if (index === 2) {
        this.exibiuApuracao = true;
        this.$refs.mdTab.activeTab = 'apuracao';
        this.$refs.mdTab.activeTabNumber = 2;
      } else if (index === 3) {
        this.exibiuPagamento = true;
        this.$refs.mdTab.activeTab = 'pagamento';
        this.$refs.mdTab.activeTabNumber = 3;
      } else if (index === 4) {
        this.exibiuAcompanhamento = true;
        this.$refs.mdTab.activeTab = 'acompanhamento';
        this.$refs.mdTab.activeTabNumber = 4;
      }
      this.index = index;
      this.abreCarrega();
    },
    abreCarrega: function abreCarrega() {
      var ref = 'dash-' + this.$refs.mdTab.activeTab;
      this.$refs[ref].abreCarrega();
    },
    extrairParametrosUrl: function extrairParametrosUrl() {
      return this.$router.currentRoute.query || {};
    }
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('roles', ['getAllRoles']), (0, _vuex.mapGetters)('controlador', ['getControladoreSelecionado']), {
    canAccessPage: function canAccessPage() {
      return this.podeAcessarDashboardOrcamento || this.podeAcessarDashboardNegociacao || this.podeAcessarDashboardApuracao || this.podeAcessarDashboardPagamento || this.podeAcessarAcompanhamento;
    },
    podeAcessarDashboardOrcamento: function podeAcessarDashboardOrcamento() {
      if (!this.getAllRoles || this.carregamentoCliente()) {
        return false;
      }
      return this.getAllRoles.indexOf('DASH_OPER_ORC') >= 0;
    },
    podeAcessarDashboardNegociacao: function podeAcessarDashboardNegociacao() {
      if (!this.getAllRoles || this.carregamentoCliente()) {
        return false;
      }
      return this.getAllRoles.indexOf('DASH_OPER_NEG') >= 0;
    },
    podeAcessarDashboardApuracao: function podeAcessarDashboardApuracao() {
      if (!this.getAllRoles || this.carregamentoCliente()) {
        return false;
      }
      return this.getAllRoles.indexOf('DASH_OPER_APURACAO') >= 0;
    },
    podeAcessarDashboardPagamento: function podeAcessarDashboardPagamento() {
      if (!this.getAllRoles || this.carregamentoCliente()) {
        return false;
      }
      return this.getAllRoles.indexOf('DASH_OPER_PGTO') >= 0;
    },
    podeAcessarAcompanhamento: function podeAcessarAcompanhamento() {
      if (!this.getAllRoles || !this.carregamentoCliente()) {
        return false;
      }
      return this.getAllRoles.indexOf('DASH_OPER_CLIENTE') >= 0;
    }
  }),
  beforeDestroy: function beforeDestroy() {
    window.hitDestroy = new Date().getTime();
  }
};

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardPlanejamento_vue_vue_type_script_lang_js___ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardPlanejamento_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardPlanejamento_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardPlanejamento_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardPlanejamento_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardPlanejamento_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(9);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _OrcamentoTabelaDash = __webpack_require__(1183);

var _OrcamentoTabelaDash2 = _interopRequireDefault(_OrcamentoTabelaDash);

var _orcamento = __webpack_require__(1190);

var _orcamento2 = _interopRequireDefault(_orcamento);

var _SaldoRepresentante = __webpack_require__(429);

var _SaldoRepresentante2 = _interopRequireDefault(_SaldoRepresentante);

var _BoxValoresRepresentante = __webpack_require__(1191);

var _BoxValoresRepresentante2 = _interopRequireDefault(_BoxValoresRepresentante);

var _loading = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'DashboardPlanejamento',
  mixins: [_orcamento2.default],
  data: function data() {
    return {
      dashboardOrcamentoResources: this.$api.dashboardOrcamento(this.$resource),
      workflowOrcamentoResources: this.$api.workflowOrcamento(this.$resource),
      usuarioUnidadeNegocioResources: this.$api.usuarioUnidadeNegocio(this.$resource),
      anos: [],
      ano: null,
      consolidadoPlanejado: null,
      currentData: null,
      unidadesNegocio: [],
      idUnidadeNegocio: null,
      orcamentosListItens: [],
      lastSearchTableSize: 0,
      saldoRepresentante: null,
      carregado: false,
      carregandoBox: false,
      carregandoTable: false,
      bloquearConsulta: false,
      filtros: {},
      paginas: 0,
      idOrcamento: null,
      buscarComParametro: false
    };
  },

  props: {
    parametros: {
      type: Object,
      default: {}
    }
  },
  components: {
    OrcamentoTabela: _OrcamentoTabelaDash2.default,
    BoxValoresRepresentante: _BoxValoresRepresentante2.default
  },
  methods: {
    getAnos: function getAnos() {
      var _this = this;

      return new _promise2.default(function (resolve, reject) {
        (0, _loading.skipLoading)();
        _this.dashboardOrcamentoResources.anos().then(function (res) {
          _this.anos = res.data;

          var atual = (0, _moment2.default)().format('YYYY');
          var anoAtual = { ano: Number(atual) };
          if (!_this.searchInYears(anoAtual)) {
            _this.anos.push(anoAtual);
          }
          _this.podeIniciarBuscaFluxos = true;
          resolve();
        }).catch(reject);
      });
    },
    searchInYears: function searchInYears(ano) {
      var success = false;
      this.anos.forEach(function (el) {
        if (el.ano === ano.ano) {
          success = true;
        }
      });
      return success;
    },
    requestCargaMinhasAprovacoes: function requestCargaMinhasAprovacoes() {
      var _this2 = this;

      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var pagina = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      this.bloquearConsulta = true;
      if (params.status) {
        this.filtros.status = params.status;
      } else if (this.filtros.status === undefined) {
        this.filtros.status = 'AGUARDANDO_APROVACAO';
      }
      if (params.fluxo) {
        this.filtros.fluxo = params.fluxo;
      } else {
        delete this.filtros.fluxo;
      }
      if (!params.dataInicio && this.ano) {
        this.filtros.ano = this.ano;
      } else {
        delete this.filtros.ano;
      }
      if (params.tipo) {
        this.filtros.tipo = params.tipo;
      } else {
        delete this.filtros.tipo;
      }
      if (params.idsMarcas) {
        this.filtros.idsMarcas = params.idsMarcas;
      } else {
        delete this.filtros.idsMarcas;
      }
      if (params.dataInicio) {
        this.ano = null;
        this.filtros.dataInicio = params.dataInicio;
      } else {
        delete this.filtros.dataInicio;
      }
      if (params.dataFim) {
        this.filtros.dataFim = params.dataFim;
      } else {
        delete this.filtros.dataFim;
      }
      if (params.descricao) {
        this.filtros.descricao = params.descricao;
      } else {
        delete this.filtros.descricao;
      }
      this.filtros.meuPassoPendente = params.meuPassoPendente;
      this.filtros.meuPassoAprovado = params.meuPassoAprovado;
      if (this.filtros.meuPassoAprovado) {
        this.filtros.status = undefined;
      }

      if (params.idOrcamento) {
        this.filtros.idOrcamento = params.idOrcamento;
      }

      this.filtros.tamanhoPagina = 10;
      this.filtros.numeroPagina = pagina;

      (0, _loading.skipLoading)();
      this.carregandoTable = true;
      this.dashboardOrcamentoResources.fluxos(this.filtros).then(function (response) {
        var _orcamentosListItens;

        _this2.bloquearConsulta = false;
        delete _this2.filtros.idOrcamento;
        var fluxos = response.data.resposta;
        _this2.lastSearchTableSize = fluxos.length;

        var qtdeRegistros = response.data.quantidadeRegistrosPagina;
        _this2.paginas = Math.ceil(qtdeRegistros / _this2.filtros.tamanhoPagina);

        _this2.orcamentosListItens = [];
        (_orcamentosListItens = _this2.orcamentosListItens).push.apply(_orcamentosListItens, (0, _toConsumableArray3.default)(fluxos));
        _this2.orcamentosListItens.forEach(function (item) {
          item.selecionado = false;
        });
        _this2.carregandoTable = false;
      }).catch(function (err) {
        _this2.$error(_this2, err);
        _this2.bloquearConsulta = false;
        _this2.carregandoTable = false;
      });
    },
    carregarValoresConsolidadosOrcamentos: function carregarValoresConsolidadosOrcamentos() {
      var _this3 = this;

      (0, _loading.skipLoading)();
      this.carregandoBox = true;
      if (this.ano) {
        this.filtros.ano = this.ano;
      } else {
        delete this.filtros.ano;
      }
      this.dashboardOrcamentoResources.buscarPlanejado(this.filtros).then(function (res) {
        _this3.saldoRepresentante = new _SaldoRepresentante2.default(res.data);
        _this3.carregandoBox = false;
      }).catch(function (err) {
        _this3.$error(_this3, err);
        _this3.carregandoBox = false;
      });

      this.$forceUpdate();
    },
    requestGetUnidadesNegocio: function requestGetUnidadesNegocio() {
      var _this4 = this;

      return new _promise2.default(function (resolve, reject) {
        (0, _loading.skipLoading)();
        _this4.usuarioUnidadeNegocioResources.listarAtivos().then(function (response) {
          _this4.unidadesNegocio = response.data;
          resolve();
        }).catch(reject);
      });
    },
    filtrarFluxos: function filtrarFluxos(filtro) {
      this.$refs.orcamentoTabela.refazPaginacao();
      if (this.buscarComParametro) {
        this.requestCargaMinhasAprovacoes(this.filtrosPorParametros());
        this.buscarComParametro = false;
      } else {
        this.requestCargaMinhasAprovacoes(filtro);
      }
    },
    recarregarDashboard: function recarregarDashboard() {
      this.$refs.orcamentoTabela.refazPaginacao();
      if (this.ano) {
        this.filtros.ano = this.ano;
      } else {
        delete this.filtros.ano;
      }
      if (this.idUnidadeNegocio) {
        this.filtros.idUnidadeNegocio = this.idUnidadeNegocio;
      } else {
        delete this.filtros.idUnidadeNegocio;
      }

      this.carregarValoresConsolidadosOrcamentos();
      this.requestCargaMinhasAprovacoes(this.filtrosPorParametros());
    },
    filtrosPorParametros: function filtrosPorParametros() {
      var filter = { status: null };
      if (this.parametros && this.parametros.idOrcamento) {
        filter.idOrcamento = this.parametros.idOrcamento;
      }
      return filter;
    },
    temParametro: function temParametro() {
      return this.parametros && this.parametros.idOrcamento;
    },
    abreCarrega: function abreCarrega() {
      var _this5 = this;

      if (this.carregado) {
        return;
      }

      window.setTimeout(function () {
        _this5.getAnos().then(_this5.requestGetUnidadesNegocio).then(function () {
          _this5.filtros.ano = _this5.ano;
          _this5.carregarValoresConsolidadosOrcamentos();
          if (_this5.temParametro()) _this5.buscarComParametro = true;
          _this5.carregado = true;
        }).catch(function (err) {
          _this5.$toast.create(_this5.$t(err), 'snack', 3E3);
        });
      });
    }
  }
};

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_OrcamentoTabelaDash_vue_vue_type_script_lang_js___ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_OrcamentoTabelaDash_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_OrcamentoTabelaDash_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_OrcamentoTabelaDash_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_OrcamentoTabelaDash_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_OrcamentoTabelaDash_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(9);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuejsPaginate = __webpack_require__(27);

var _vuejsPaginate2 = _interopRequireDefault(_vuejsPaginate);

var _vuex = __webpack_require__(6);

var _TabelaGenerica = __webpack_require__(20);

var _TabelaGenerica2 = _interopRequireDefault(_TabelaGenerica);

var _helpers = __webpack_require__(5);

var _StatusPassos = __webpack_require__(57);

var _StatusPassos2 = _interopRequireDefault(_StatusPassos);

var _FiltrosDashOrcamento = __webpack_require__(1186);

var _FiltrosDashOrcamento2 = _interopRequireDefault(_FiltrosDashOrcamento);

var _rolesComputedGenerator = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'OrcamentoTabelaDash',
  extends: _TabelaGenerica2.default,
  components: {
    StatusPassos: _StatusPassos2.default,
    FiltrosDash: _FiltrosDashOrcamento2.default,
    Paginate: _vuejsPaginate2.default
  },
  props: {
    periodo: {
      type: Number,
      default: null
    },
    idUnidadeNegocio: {
      type: Number,
      default: null
    },
    carregando: Boolean,
    bloquearConsulta: Boolean,
    paginas: Number
  },
  data: function data() {
    return {
      workflowOrcamentoResources: this.$api.workflowOrcamento(this.$resource),
      workflowAjusteVerbaResources: this.$api.workflowAjusteVerba(this.$resource),
      workflowTransferenciaResources: this.$api.workflowTransferencia(this.$resource),
      podeAprovar: false,
      podeReprovar: false,
      primeiraBusca: false,
      objetosSelecionados: [],
      dialog: {
        ref: 'dialog1',
        from: 'saveRegisterFromButton',
        title: this.$t('label.atencao'),
        content: '',
        action: function action() {}
      },
      motivo: '',
      justificarOrcamento: {
        observacao: ''
      },
      indexPagina: 0,
      statusPassos: {},
      filtro: {
        status: 'AGUARDANDO_APROVACAO',
        meuPassoPendente: true,
        filtro: null,
        fluxo: null
      }
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('roles', ['getAllRoles']), (0, _rolesComputedGenerator.generateComputed)('ORC', ['canAccessPage']), {
    canAccessPageAjuste: function canAccessPageAjuste() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el === 'ORC_AJUSTE';
      }).length;
    },
    canAccessPageTransferir: function canAccessPageTransferir() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el === 'ORC_TRANSFERENCIA';
      }).length;
    }
  }),
  methods: {
    getMoney: _helpers.getMoney,
    requestAbrirAcompanhamento: function requestAbrirAcompanhamento(row) {
      var _this = this;

      var tipoOrcamento = 1,
          tipoAjuste = 3,
          tipoTransferencia = 4,
          idTipoWorkflow = row.idTipoWorkflow;

      var promise = null;
      if (idTipoWorkflow === tipoOrcamento) {
        var idOrcamento = row.idEntidade;
        promise = this.workflowOrcamentoResources.statusPasso({ idOrcamento: idOrcamento }, { idOrcamento: idOrcamento });
      }
      if (idTipoWorkflow === tipoAjuste) {
        var idAjuste = row.idEntidade;
        promise = this.workflowAjusteVerbaResources.statusPasso({ idAjuste: idAjuste }, { idAjuste: idAjuste });
      }
      if (idTipoWorkflow === tipoTransferencia) {
        var idTransferencia = row.idEntidade;
        promise = this.workflowTransferenciaResources.statusPasso({ idTransferencia: idTransferencia }, { idTransferencia: idTransferencia });
      }

      promise.then(function (res) {
        _this.statusPassos = res.data;
        _this.$refs.modalAcompanhamento.open();
      }).catch(function (err) {
        _this.$toast.create(_this.$t(err), 'snack', 3E3);
      });
    },
    temJustificativa: function temJustificativa(row) {
      return row.justificativa && row.justificativa !== '';
    },
    requestBuscarMotivoLog: function requestBuscarMotivoLog(row) {
      var id = row.idOrcamento;
      if (row) {
        if (row.idTipoWorkflow === 1) {
          this.buscarJustificativaOrcamento(id);
          return;
        }
        if (row.idTipoWorkflow === 3) {
          this.buscarJustificativaAjuste(id);
          return;
        }
        if (row.idTipoWorkflow === 4) {
          this.buscarJustificativaTransferencia(id);
        }
      }
    },
    buscarJustificativaOrcamento: function buscarJustificativaOrcamento(idOrcamento) {
      var _this2 = this;

      this.workflowOrcamentoResources.status({ idOrcamento: idOrcamento }, { idOrcamento: idOrcamento }).then(this.abrirDialogJustificativa).catch(function (err) {
        _this2.$error(_this2, err);
      });
    },
    buscarJustificativaAjuste: function buscarJustificativaAjuste(idAjuste) {
      var _this3 = this;

      this.workflowAjusteVerbaResources.status({ idAjuste: idAjuste }, { idAjuste: idAjuste }).then(this.abrirDialogJustificativa).catch(function (err) {
        _this3.$error(_this3, err);
      });
    },
    buscarJustificativaTransferencia: function buscarJustificativaTransferencia(id) {
      var _this4 = this;

      this.workflowTransferenciaResources.status({ id: id }, { id: id }).then(this.abrirDialogJustificativa).catch(function (err) {
        _this4.$error(_this4, err);
      });
    },
    clickHandler: function clickHandler(pagina) {
      this.indexPagina = pagina - 1;
      this.$emit('DASH_ORCAMENTO_TABELA_PAGINA', this.filtro, pagina);
    },
    refazPaginacao: function refazPaginacao() {
      this.indexPagina = 0;
    },
    abrirDialogJustificativa: function abrirDialogJustificativa(response) {
      if (response.data && response.data.passoAtual) {
        var content = response.data.passoAtual.observacao;
        this.setDialogContent(content, null, this.dialog.from, this.$t('title.justificativa'));
        this.openDialog(this.dialog.ref);
      }
    },
    podeVisualizar: function podeVisualizar(row) {
      if (row) {
        return row.idTipoWorkflow === 1 && this.canAccessPage || this.canAccessPageAjuste && row.idTipoWorkflow === 3 || this.canAccessPageTransferir && row.idTipoWorkflow === 4;
      }
      return false;
    },
    verItem: function verItem(row) {
      if (row) {
        if (row.idTipoWorkflow === 1) {
          this.$router.push({ name: 'verOrcamentoFluxo', params: { id: row.idOrcamento } });
          return;
        }
        if (row.idTipoWorkflow === 3) {
          this.$router.push({ name: 'verAjusteVerbaFluxo', params: { id: row.idOrcamento } });
          return;
        }
        if (row.idTipoWorkflow === 4) {
          this.$router.push({ name: 'verTransferenciaFluxo', params: { id: row.idOrcamento } });
        }
      }
    },
    limparSelecao: function limparSelecao() {
      this.podeAprovar = false;
      this.podeReprovar = false;
      this.clearCheckbox();
      this.objetosSelecionados = [];
    },
    filtrar: function filtrar() {
      this.$emit('ORCAMENTOTABELA_FILTRAR', this.filtro, this.closeLoading);
    },
    filtrarModal: function filtrarModal(filtro) {
      this.filtro = filtro;
      this.filtrar();
    },
    openDialogJustificativaReprovar: function openDialogJustificativaReprovar() {
      this.justificarOrcamento.observacao = '';
      this.justificarOrcamento.obrigatorio = true;
      this.justificarOrcamento.action = this.requestReprovar;

      this.openDialog('justificarDialog');
    },
    openDialogAprovar: function openDialogAprovar(ref, row) {
      this.objetosSelecionados = [row];
      var content = this.$t('message.deseja_aprovar');
      this.setDialogContent(content, this.requestAprovar, this.dialog.from);
      this.openDialog(ref || this.dialog.ref);
    },
    openDialogReprovar: function openDialogReprovar(ref, row) {
      this.objetosSelecionados = [row];
      var content = this.$t('message.deseja_reprovar');
      this.setDialogContent(content, this.openDialogJustificativaReprovar, this.dialog.from);
      this.openDialog(ref || this.dialog.ref);
    },
    requestAprovar: function requestAprovar() {
      var _this5 = this;

      var payload = {};
      payload.observacao = this.justificarOrcamento.observacao;
      var orcamentoListTemp = this.objetosSelecionados;
      if (orcamentoListTemp && orcamentoListTemp.length !== 0) {
        orcamentoListTemp.forEach(function (el, idx) {
          if (el.idTipoWorkflow === 1) {
            _this5.aprovarOrcamento(el, idx, payload);
          }
          if (el.idTipoWorkflow === 3) {
            _this5.aprovarAjuste(el, idx, payload);
          }
          if (el.idTipoWorkflow === 4) {
            _this5.aprovarTransferencia(el, idx, payload);
          }
        });
      }
    },
    aprovarTransferencia: function aprovarTransferencia(el, idx, payload) {
      var _this6 = this;

      var id = el.idOrcamento;
      this.workflowTransferenciaResources.aprovar({ id: id }, payload).then(function () {
        _this6.limparSelecao();
        _this6.filtrar();
        _this6.$toast.create(_this6.$t('message.transferencia_aprovado'), 'snack', 3E3);
      }).catch(function (err) {
        _this6.$error(_this6, err);
      });
    },
    aprovarAjuste: function aprovarAjuste(el, idx, payload) {
      var _this7 = this;

      var idAjuste = el.idOrcamento;
      this.workflowAjusteVerbaResources.aprovar({ idAjuste: idAjuste }, payload).then(function () {
        _this7.limparSelecao();
        _this7.filtrar();
        _this7.$toast.create(_this7.$t('message.ajuste_verba_aprovado'), 'snack', 3E3);
      }).catch(function (err) {
        _this7.$error(_this7, err);
      });
    },
    aprovarOrcamento: function aprovarOrcamento(el, idx, payload) {
      var _this8 = this;

      var idOrcamento = el.idOrcamento;
      this.workflowOrcamentoResources.aprovar({ idOrcamento: idOrcamento }, payload).then(function () {
        _this8.limparSelecao();
        _this8.filtrar();
        _this8.$toast.create(_this8.$t('message.orcamento_aprovado'), 'snack', 3E3);
      }).catch(function (err) {
        _this8.$error(_this8, err);
      });
    },
    requestReprovar: function requestReprovar() {
      var _this9 = this;

      var payload = {};
      payload.observacao = this.justificarOrcamento.observacao;
      var orcamentoListTemp = this.objetosSelecionados;
      if (orcamentoListTemp && orcamentoListTemp.length !== 0) {
        orcamentoListTemp.forEach(function (el, idx) {
          if (el.idTipoWorkflow === 1) {
            _this9.reprovarOrcamento(el, idx, payload);
          }
          if (el.idTipoWorkflow === 3) {
            _this9.reprovarAjuste(el, idx, payload);
          }
          if (el.idTipoWorkflow === 4) {
            _this9.reprovarTransferencia(el, idx, payload);
          }
        });
      }
    },
    reprovarTransferencia: function reprovarTransferencia(el, idx, payload) {
      var _this10 = this;

      var id = el.idOrcamento;
      this.workflowTransferenciaResources.reprovar({ id: id }, payload).then(function () {
        if (idx === _this10.objetosSelecionados.length - 1) {
          _this10.limparSelecao();
          _this10.filtrar();
          _this10.$toast.create(_this10.$t('message.transferencia_reprovado'), 'snack', 3E3);
        }
      }).catch(function (err) {
        _this10.$error(_this10, err);
      });
    },
    reprovarAjuste: function reprovarAjuste(el, idx, payload) {
      var _this11 = this;

      var idAjuste = el.idOrcamento;
      this.workflowAjusteVerbaResources.reprovar({ idAjuste: idAjuste }, payload).then(function () {
        if (idx === _this11.objetosSelecionados.length - 1) {
          _this11.limparSelecao();
          _this11.filtrar();
          _this11.$toast.create(_this11.$t('message.ajuste_verba_reprovado'), 'snack', 3E3);
        }
      }).catch(function (err) {
        _this11.$error(_this11, err);
      });
    },
    reprovarOrcamento: function reprovarOrcamento(el, idx, payload) {
      var _this12 = this;

      var idOrcamento = el.idOrcamento;
      this.workflowOrcamentoResources.reprovar({ idOrcamento: idOrcamento }, payload).then(function () {
        if (idx === _this12.objetosSelecionados.length - 1) {
          _this12.limparSelecao();
          _this12.filtrar();
          _this12.$toast.create(_this12.$t('message.orcamento_reprovado'), 'snack', 3E3);
        }
      }).catch(function (err) {
        _this12.$error(_this12, err);
      });
    },
    toggleSelecaoGeral: function toggleSelecaoGeral(selecao) {
      this.filteredList.forEach(function (item) {
        item.selecionado = selecao;
      });
      this.objetosSelecionados = !selecao ? [] : [].concat((0, _toConsumableArray3.default)(this.filteredList));

      this.requestPermiteAprovar();
      this.requestPermiteReprovar();
    },
    toggleSelecaoUnica: function toggleSelecaoUnica(row) {
      var _this13 = this;

      setTimeout(function () {
        var selecao = row.selecionado;
        if (selecao) {
          _this13.objetosSelecionados.push(row);
          _this13.requestPermiteAprovar();
          _this13.requestPermiteReprovar();
          return;
        }

        var indexO = null;
        _this13.objetosSelecionados.forEach(function (obj, index) {
          if (obj.idWorkflow === row.idWorkflow) {
            indexO = index;
          }
        });
        _this13.objetosSelecionados.splice(indexO, 1);
        _this13.requestPermiteAprovar();
        _this13.requestPermiteReprovar();
      });
    },
    requestPermiteAprovar: function requestPermiteAprovar() {
      var _this14 = this;

      this.podeAprovar = false;
      var lista = this.objetosSelecionados;
      if (!lista || lista.length === 0) {
        this.podeAprovar = false;
        return;
      }
      if (lista) {
        this.podeAprovar = true;
        lista.forEach(function (el) {
          if (el.statusFluxo !== 'AGUARDANDO_APROVACAO') {
            _this14.podeAprovar = false;
          }
        });
      }
    },
    requestPermiteReprovar: function requestPermiteReprovar() {
      var _this15 = this;

      this.podeReprovar = false;
      var lista = this.objetosSelecionados;
      if (!lista || lista.length === 0) {
        this.podeReprovar = false;
        return;
      }
      if (lista) {
        this.podeReprovar = true;
        lista.forEach(function (el) {
          if (el.statusFluxo !== 'AGUARDANDO_APROVACAO') {
            _this15.podeReprovar = false;
          }
        });
      }
    },
    setDialogContent: function setDialogContent(content, action, from, title) {
      this.dialog.content = content;
      this.dialog.action = action;
      this.dialog.title = title || this.$t('label.atencao');
      this.dialog.from = from || this.dialog.from;
    },
    openDialog: function openDialog(ref) {
      this.$refs[ref].open();
    },
    closeDialog: function closeDialog(ref, cb) {
      this.$refs[ref].close();
      if (cb) {
        cb();
      }
    }
  }
};

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosDashOrcamento_vue_vue_type_script_lang_js___ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosDashOrcamento_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosDashOrcamento_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosDashOrcamento_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosDashOrcamento_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosDashOrcamento_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(4);

var _assign2 = _interopRequireDefault(_assign);

var _mdAutocomplete = __webpack_require__(16);

var _mdAutocomplete2 = _interopRequireDefault(_mdAutocomplete);

var _workspaceFiltros = __webpack_require__(81);

var _workspaceFiltros2 = _interopRequireDefault(_workspaceFiltros);

var _dateUtils = __webpack_require__(30);

var _http = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_workspaceFiltros2.default],
  props: {
    filtro: Object,
    mdOpenFrom: String
  },
  data: function data() {
    var _this = this;

    return {
      entidade: 'DASH_ORCAMENTO',
      produtoResources: this.$api.produto(this.$resource),
      dashboardNegociacaoResources: this.$api.dashboardNegociacao(this.$resource),
      fluxos: [{ id: 1, nome: this.$t('label.orcamento') }, { id: 3, nome: this.$t('label.ajustar_verba') }, { id: 4, nome: this.$t('label.transferencia') }],
      statusOrcamentoLista: [{ status: 'AGUARDANDO_APROVACAO', descricao: this.$t('status_entidade.aguardando_aprovacao') }, { status: 'APROVADO', descricao: this.$tc('status_entidade.aprovado', 1) }, { status: 'REPROVADO', descricao: this.$tc('status_entidade.reprovado', 1) }],
      tipoAjuste: [{ id: 1, label: this.$t('label.adendo'), nome: 'ADENDO' }, { id: 2, label: this.$t('label.reducao'), nome: 'REDUCAO' }],
      marcas: [],
      statusBloqueado: true,
      habilitarDataFim: true,
      menuDataInicio: false,
      menuDataFim: false,
      dataInicio: '',
      dataFim: '',
      habilitarFiltro: false,

      rules: {
        required: function required(value) {
          return !!value || _this.$t('message.campo_obrigatorio');
        },
        validDate: function validDate(value) {
          return !value || value.length === 10 && _this.moment(value, 'DD-MM-YYYY').isValid() || _this.$t('message.data_invalida');
        }
      }
    };
  },

  watch: {
    dateInicioFormatada: function dateInicioFormatada(valor) {
      if (valor) {
        this.habilitarDataFim = false;
        if (this.dateFimFormatada !== null) {
          this.habilitarFiltro = false;
        } else {
          this.habilitarFiltro = true;
        }
      } else {
        this.habilitarDataFim = true;
        this.dateFimFormatada = null;
        this.habilitarFiltro = false;
      }
    },
    dateFimFormatada: function dateFimFormatada(valor) {
      if (valor) {
        this.habilitarFiltro = false;
      } else {
        this.habilitarFiltro = true;
        if (this.dateInicioFormatada === null) {
          this.habilitarFiltro = false;
        }
      }
    },

    dataInicio: {
      handler: function handler() {
        this.filtro.dataInicio = this.dataInicio;
        this.menuDataInicio = false;
      }
    },
    dataFim: {
      handler: function handler() {
        this.filtro.dataFim = this.dataFim;
        this.menuDataFim = false;
      }
    }
  },
  components: {
    mdAutocomplete: _mdAutocomplete2.default
  },
  computed: {
    dateInicioFormatada: {
      get: function get() {
        return (0, _dateUtils.formatDateDDMMYYYY)(this.dataInicio);
      },
      set: function set(newValue) {
        this.dataInicio = (0, _dateUtils.parseDateYYYYMMDD)(newValue);
      }
    },
    dateFimFormatada: {
      get: function get() {
        return (0, _dateUtils.formatDateDDMMYYYY)(this.dataFim);
      },
      set: function set(newValue) {
        this.dataFim = (0, _dateUtils.parseDateYYYYMMDD)(newValue);
      }
    }
  },
  methods: {
    prepareResponseData: _http.prepareResponseData,
    open: function open() {
      this.$refs.modal.open();
      this.onOpen();
    },
    defaultClose: function defaultClose() {
      this.$emit('GENERICMODAL_DEFAULT_CLOSE');
      this.menuDataFim = false;
      this.close();
    },
    onOpen: function onOpen() {
      this.$emit('GENERICMODAL_OPEN');
    },
    onClose: function onClose() {
      this.$emit('GENERICMODAL_CLOSE');
      this.menuDataInicio = false;
      this.menuDataFim = false;
    },
    close: function close() {
      this.$refs.modal.close();
      this.onClose();
    },
    filtrar: function filtrar() {
      var copiaFiltro = (0, _assign2.default)({}, this.filtro);
      (0, _http.removeParametrosNulos)(copiaFiltro);
      this.salvarWorkspace(this.entidade, copiaFiltro);
      this.$emit('FILTROSDASH_FILTRAR', copiaFiltro);
      this.defaultClose();
    },
    verificarMeuPassoPendente: function verificarMeuPassoPendente() {
      this.filtro.meuPassoPendente = !this.filtro.meuPassoPendente;
      if (this.filtro.meuPassoPendente) {
        this.filtro.status = 'AGUARDANDO_APROVACAO';
        this.statusBloqueado = true;
        this.filtro.meuPassoAprovado = false;
      } else {
        this.statusBloqueado = false;
      }
    },
    verificarMeuPassoAprovado: function verificarMeuPassoAprovado() {
      this.filtro.meuPassoAprovado = !this.filtro.meuPassoAprovado;
      if (this.filtro.meuPassoAprovado) {
        this.statusBloqueado = true;
        this.filtro.meuPassoPendente = false;
      } else {
        this.statusBloqueado = false;
      }
    },
    preencherFiltros: function preencherFiltros(filtros) {
      this.filtro.status = filtros.status;
      this.filtro.meuPassoPendente = filtros.meuPassoPendente;
      this.filtro.meuPassoAprovado = filtros.meuPassoAprovado;
      this.filtro.tipo = filtros.tipo;
      this.filtro.idsMarcas = filtros.idsMarcas || '';
      this.filtro.dataInicio = this.dataInicio;
      this.filtro.dataFim = this.dataFim;
      this.filtro.descricao = filtros.descricao;
      this.filtro.fluxo = filtros.fluxo || null;
      if (this.filtro.meuPassoPendente || this.filtro.meuPassoAprovado) {
        this.statusBloqueado = true;
      } else {
        this.statusBloqueado = false;
      }
    },
    setMarca: function setMarca(hit) {
      this.filtro.idsMarcas = hit.id;
    },
    limparMarca: function limparMarca() {
      this.filtro.idsMarcas = null;
    },
    limparFiltros: function limparFiltros() {
      this.filtro.meuPassoPendente = false;
      this.filtro.meuPassoAprovado = false;
      this.filtro.tipo = null;
      this.filtro.idsMarcas = null;
      this.dataInicio = null;
      this.dataFim = null;
      this.filtro.descricao = '';
    },
    fechaLista: function fechaLista() {
      var _this2 = this;

      setTimeout(function () {
        _this2.$refs.refMarca.isMenuActive = false;
      }, 3500);
    }
  },

  validarPeriodo: function validarPeriodo() {
    var inicio = this.moment(this.dataInicio, 'YYYY-MM-DD');
    var fim = this.moment(this.dataFim, 'YYYY-MM-DD');
    var diferencaMeses = fim.diff(inicio, 'months');
    return diferencaMeses <= 3;
  },
  mounted: function mounted() {
    var _this3 = this;

    this.carregarWorkspace(this.entidade, this.preencherFiltros).then(function () {
      return _this3.filtrar();
    });
    this.dashboardNegociacaoResources.listarMarcas().then(function (resultado) {
      _this3.marcas = resultado.data.resposta;
    });
  }
};

/***/ }),
/* 428 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(29);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SaldoRepresentante = function SaldoRepresentante(params) {
  (0, _classCallCheck3.default)(this, SaldoRepresentante);

  var data = params || {};
  this.vlrPlanejado = data.vlrPlanejado ? data.vlrPlanejado : 0;
  this.vlrConsumido = data.vlrConsumido ? data.vlrConsumido : 0;
  this.vlrReservado = data.vlrReservado ? data.vlrReservado : 0;
  this.vlrConfNegociacao = data.vlrConfAcao ? data.vlrConfAcao : 0;
  this.vlrConfApuracao = data.vlrConfApuracao ? data.vlrConfApuracao : 0;
  this.vlrDisponivel = data.vlrDisponivel ? data.vlrDisponivel : 0;
};

exports.default = SaldoRepresentante;

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_BoxValoresRepresentante_vue_vue_type_script_lang_js___ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_BoxValoresRepresentante_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_BoxValoresRepresentante_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_BoxValoresRepresentante_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_BoxValoresRepresentante_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_BoxValoresRepresentante_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SaldoRepresentante = __webpack_require__(429);

var _SaldoRepresentante2 = _interopRequireDefault(_SaldoRepresentante);

var _helpers = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    saldoRepresentante: {
      type: _SaldoRepresentante2.default,
      default: new _SaldoRepresentante2.default({})
    },
    carregando: Boolean
  },
  methods: {
    getMoney: _helpers.getMoney,
    getObjSaldo: function getObjSaldo() {
      return this.saldoRepresentante || {};
    }
  }
};

/***/ }),
/* 432 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardNegociacao_vue_vue_type_script_lang_js___ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardNegociacao_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardNegociacao_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardNegociacao_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardNegociacao_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardNegociacao_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(4);

var _assign2 = _interopRequireDefault(_assign);

var _toConsumableArray2 = __webpack_require__(9);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

var _AcordoTabelaDash = __webpack_require__(1198);

var _AcordoTabelaDash2 = _interopRequireDefault(_AcordoTabelaDash);

var _acordo = __webpack_require__(1202);

var _acordo2 = _interopRequireDefault(_acordo);

var _helpers = __webpack_require__(5);

var _loading = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'DashboardNegociacao',
  mixins: [_acordo2.default],
  data: function data() {
    return {
      dashboardNegociacaoResources: this.$api.dashboardNegociacao(this.$resource),
      usuarioUnidadeNegocioResources: this.$api.usuarioUnidadeNegocio(this.$resource),
      unidadesNegocio: [],
      unidadeNegocio: null,
      periodos: [],
      statusNegociacoes: [],
      tiposNegociacoes: [],
      negociacoes: [],
      periodoNegociacao: null,
      consolidadoNegociacao: {},
      bloquearConsulta: false,
      dialog: {
        ref: 'dialog1',
        from: 'saveRegisterFromButton',
        title: this.$t('label.atencao'),
        content: '',
        action: function action() {}
      },
      orcamentosListItens: null,
      fluxos: [{ id: 1, nome: this.$t('label.orcamento') }, { id: 2, nome: this.$t('label.transferencia') }],
      justificarOrcamento: {
        observacao: ''
      },
      motivo: '',
      objetosSelecionados: [],
      podeAprovar: false,
      podeReprovar: false,
      tipoFluxo: '',
      statusOrcamento: 'AGUARDANDO_APROVACAO',
      filtros: {},
      carregado: false,
      carregandoBox: false,
      carregandoTable: false,
      saldoRepresentante: 0,
      paginas: 0,
      buscarComParametro: false
    };
  },

  props: {
    parametros: {
      type: Object,
      default: {}
    }
  },
  components: {
    AcordoTabela: _AcordoTabelaDash2.default
  },
  methods: {
    getMoney: _helpers.getMoney,
    requestGetUnidadesNegocio: function requestGetUnidadesNegocio() {
      var _this = this;

      return new _promise2.default(function (resolve, reject) {
        (0, _loading.skipLoading)();
        _this.usuarioUnidadeNegocioResources.listarAtivos().then(function (response) {
          _this.unidadesNegocio = response.data;
          resolve();
        }).catch(reject);
      });
    },
    carregarDashboard: function carregarDashboard() {
      if (this.periodoNegociacao) {
        this.filtros.periodo = this.periodoNegociacao;
      } else {
        delete this.filtros.periodo;
      }
      if (this.unidadeNegocio) {
        this.filtros.idUnidadeNegocio = this.unidadeNegocio;
      } else {
        delete this.filtros.idUnidadeNegocio;
      }

      this.requestCargaConsolidados(this.filtros);
      this.requestCarregarNegociacoes();
    },
    recarregarDashboard: function recarregarDashboard() {
      this.$refs.acordoTabela.refazPaginacao();

      this.carregarDashboard();
    },
    filtrarFluxos: function filtrarFluxos(filtro) {
      this.$refs.acordoTabela.refazPaginacao();
      if (this.buscarComParametro) {
        this.requestCarregarNegociacoes(this.filtrosPorParametros());
        this.buscarComParametro = false;
      } else {
        this.requestCarregarNegociacoes(filtro);
      }
    },
    requestCargaConsolidados: function requestCargaConsolidados() {
      var _this2 = this;

      var filtro = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      (0, _loading.skipLoading)();
      this.carregandoBox = true;
      this.dashboardNegociacaoResources.listarDashNegociacoes(filtro).then(function (response) {
        _this2.consolidadoNegociacao = {};
        response.data.forEach(function (item) {
          _this2.consolidadoNegociacao[item.status.toLowerCase()] = item.consolidado;
        });
        _this2.carregandoBox = false;
      }).catch(function (err) {
        _this2.$error(_this2, err);
        _this2.carregandoBox = false;
      });
    },
    requestCarregarNegociacoes: function requestCarregarNegociacoes() {
      var filtros = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this3 = this;

      var numeroPagina = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var cb = arguments[2];

      this.bloquearConsulta = true;
      if (filtros) {
        this.filtros = this.prepararFiltro(filtros);
      }
      this.filtros.tamanhoPagina = 20;
      this.filtros.numeroPagina = numeroPagina;

      (0, _loading.skipLoading)();
      this.carregandoTable = true;
      this.dashboardNegociacaoResources.listarNegociacoes(this.filtros).then(function (response) {
        var _negociacoes;

        delete _this3.filtros.idCliente;
        delete _this3.filtros.idAcordo;

        _this3.bloquearConsulta = false;
        var fluxos = response.data.resposta;

        var qtdeRegistros = response.data.quantidadeRegistrosPagina;
        _this3.paginas = Math.ceil(qtdeRegistros / _this3.filtros.tamanhoPagina);

        _this3.negociacoes = [];
        (_negociacoes = _this3.negociacoes).push.apply(_negociacoes, (0, _toConsumableArray3.default)(fluxos));
        _this3.carregandoTable = false;
        if (cb) {
          cb();
        }
      }).catch(function (err) {
        _this3.$error(_this3, err);
        _this3.bloquearConsulta = false;
        _this3.carregandoTable = false;
      });
    },
    cleanTableNoResult: function cleanTableNoResult(cb) {
      this.negociacoes = [];
      if (cb) {
        cb();
      }
    },
    prepararFiltro: function prepararFiltro(filter) {
      var filtro = (0, _assign2.default)({}, this.filtros);

      filtro.meuPassoPendente = filter.meuPassoPendente;
      filtro.meuPassoAprovado = filter.meuPassoAprovado;
      if (filter.status) {
        filtro.status = filter.status;
      } else {
        delete filtro.status;
      }
      if (filter.tipoAcordo) {
        filtro.tipoAcordo = filter.tipoAcordo;
      } else {
        delete filtro.tipoAcordo;
      }
      if (filter.idCliente) {
        filtro.idCliente = filter.idCliente;
      } else {
        delete filtro.idCliente;
      }
      if (filter.idAcordo) {
        filtro.idAcordo = filter.idAcordo;
      } else {
        delete filtro.idACordo;
      }
      if (filter.idMarca) {
        filtro.idMarca = filter.idMarca;
      } else {
        delete filtro.idMarca;
      }
      if (filter.idLinhaProduto) {
        filtro.idLinhaProduto = filter.idLinhaProduto;
      } else {
        delete filtro.idLinhaProduto;
      }
      if (filter.idFamilia) {
        filtro.idFamilia = filter.idFamilia;
      } else {
        delete filtro.idFamilia;
      }
      if (filter.idProduto) {
        filtro.idProduto = filter.idProduto;
      } else {
        delete filtro.idProduto;
      }
      if (filter.idTipoLinhaOrcamento) {
        filtro.idTipoLinhaOrcamento = filter.idTipoLinhaOrcamento;
      } else {
        delete filtro.idTipoLinhaOrcamento;
      }
      return filtro;
    },
    requestCarregarStatusNegociacoes: function requestCarregarStatusNegociacoes() {
      var _this4 = this;

      this.dashboardNegociacaoResources.listarStatusNegociacoes().then(function (response) {
        _this4.statusNegociacoes = response.data.resposta;
      });
    },
    requestCarregarTiposNegociacoes: function requestCarregarTiposNegociacoes() {
      var _this5 = this;

      return new _promise2.default(function (resolve, reject) {
        (0, _loading.skipLoading)();
        _this5.dashboardNegociacaoResources.listarTiposNegociacoes().then(function (response) {
          _this5.tiposNegociacoes = response.data.resposta;
          resolve();
        }).catch(reject);
      });
    },
    requestCargaPeriodos: function requestCargaPeriodos() {
      var _this6 = this;

      return new _promise2.default(function (resolve, reject) {
        (0, _loading.skipLoading)();
        _this6.dashboardNegociacaoResources.listarPeriodos().then(function (response) {
          _this6.periodos = response.data;
          resolve();
        }).catch(reject);
      });
    },
    filtrosPorParametros: function filtrosPorParametros() {
      var filter = { status: 'AGUARDANDO_APROVACAO' };
      filter.meuPassoPendente = true;
      if (this.parametros) {
        if (this.parametros.idCliente) {
          filter.idCliente = this.parametros.idCliente;
        }
        if (this.parametros.idAcordo) {
          filter.idAcordo = this.parametros.idAcordo;
        }
      }
      return filter;
    },
    temParametro: function temParametro() {
      return this.parametros && this.parametros.idAcordo;
    },
    abreCarrega: function abreCarrega() {
      var _this7 = this;

      if (this.carregado) {
        return;
      }

      window.setTimeout(function () {
        _this7.requestCarregarTiposNegociacoes().then(_this7.requestGetUnidadesNegocio).then(_this7.requestCargaPeriodos).then(function () {
          _this7.requestCargaConsolidados();
          if (_this7.temParametro()) _this7.buscarComParametro = true;
          _this7.carregado = true;
        }).catch(function (err) {
          _this7.$toast.create(_this7.$t(err), 'snack', 3E3);
        });
      });
    }
  }
};

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AcordoTabelaDash_vue_vue_type_script_lang_js___ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AcordoTabelaDash_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AcordoTabelaDash_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AcordoTabelaDash_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AcordoTabelaDash_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AcordoTabelaDash_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(9);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _vuejsPaginate = __webpack_require__(27);

var _vuejsPaginate2 = _interopRequireDefault(_vuejsPaginate);

var _TabelaGenerica = __webpack_require__(20);

var _TabelaGenerica2 = _interopRequireDefault(_TabelaGenerica);

var _mdAutocomplete = __webpack_require__(16);

var _mdAutocomplete2 = _interopRequireDefault(_mdAutocomplete);

var _helpers = __webpack_require__(5);

var _http = __webpack_require__(22);

var _StatusPassos = __webpack_require__(57);

var _StatusPassos2 = _interopRequireDefault(_StatusPassos);

var _workspaceFiltros = __webpack_require__(81);

var _workspaceFiltros2 = _interopRequireDefault(_workspaceFiltros);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'AcordoTabelaDash',
  extends: _TabelaGenerica2.default,
  mixins: [_workspaceFiltros2.default],
  props: {
    contrato: Object,
    tiposNegociacoes: {
      type: Array,
      required: true
    },
    unidadeNegocio: {
      type: Number,
      default: null
    },
    periodoNegociacao: {
      type: Number,
      default: null
    },
    carregando: Boolean,
    bloquearConsulta: Boolean,
    paginas: Number
  },
  data: function data() {
    return {
      acordoResources: this.$api.acordo(this.$resource),
      tipoInvestimentoResources: this.$api.tipoInvestimento(this.$resource),
      dashboardNegociacaoResources: this.$api.dashboardNegociacao(this.$resource),
      clienteResources: this.$api.cliente(this.$resource),
      produtoResources: this.$api.produto(this.$resource),
      workflowAcordo: this.$api.workflowAcordo(this.$resource),
      entidade: 'DASH_ACORDO',
      canPost: false,
      somenteLeitura: false,
      nomContato: '',
      hasFilter: false,
      itemSelecionado: null,
      indexPagina: 0,
      justificativa: '',
      objetosSelecionados: [],
      podeAprovar: false,
      esperarRequest: false,
      justificativaGrid: 'Sem justificativa.',
      filtro: {
        tipoAcordo: '',
        status: 'AGUARDANDO_APROVACAO',
        tipoLinhaOrcamento: '',
        marca: '',
        linhaProduto: '',
        familia: '',
        produto: '',
        cliente: '',
        meuPassoPendente: true,
        meuPassoAprovado: false
      },
      filtroCopy: {},
      statusNegociacoes: [{ status: 'AGUARDANDO_APROVACAO', descricao: this.$t('status_entidade.aguardando_aprovacao') }, { status: 'APROVADO', descricao: this.$tc('status_entidade.aprovado', 1) }, { status: 'EM_ANALISE', descricao: this.$tc('status_entidade.em_analise', 1) }, { status: 'REPROVADO', descricao: this.$tc('status_entidade.reprovado', 1) }],
      statusBloqueado: true,
      statusPassos: {}
    };
  },

  computed: {
    hasSingleRowSelected: function hasSingleRowSelected() {
      return this.selected && this.selected.length === 1;
    }
  },
  components: {
    mdAutocomplete: _mdAutocomplete2.default,
    StatusPassos: _StatusPassos2.default,
    Paginate: _vuejsPaginate2.default
  },
  watch: {
    periodoNegociacao: function periodoNegociacao() {
      this.preencherFiltrosGerais();
    },
    unidadeNegocio: function unidadeNegocio() {
      this.preencherFiltrosGerais();
    }
  },
  methods: {
    prepareResponseData: _http.prepareResponseData,
    getMoney: _helpers.getMoney,
    clickHandler: function clickHandler(pagina) {
      this.indexPagina = pagina - 1;
      this.$emit('DASH_ACORDO_TABELA_PAGINA', this.filtro, pagina);
    },
    refazPaginacao: function refazPaginacao() {
      this.indexPagina = 0;
    },
    requestAbrirAcompanhamento: function requestAbrirAcompanhamento(row) {
      var _this = this;

      var idAcordo = row.id;
      this.workflowAcordo.statusPasso({ idAcordo: idAcordo }, { idAcordo: idAcordo }).then(function (res) {
        _this.statusPassos = res.data;
        _this.$refs.modalAcompanhamento.open();
      }).catch(function (err) {
        _this.$toast.create(_this.$t(err), 'snack', 3E3);
      });
    },
    verItem: function verItem(row) {
      if (row) {
        var rota = null;
        switch (row.codTipoAcordo) {
          case 'FIXO':
            rota = 'verDetalhesNegociacaoFixoFluxo';
            break;
          case 'TABLOIDE':
            rota = 'verDetalhesNegociacaoTabloideFluxo';
            break;
          case 'NEGOCIACAO_PRECO':
            rota = 'verDetalhesNegociacaoPrecoFluxo';
            break;
          case 'POSITIVACAO':
            rota = 'verDetalhesPositivacaoFluxo';
            break;
          case 'CRESCIMENTO':
            rota = 'verDetalhesCrescimentoFluxo';
            break;
          default:
            return;
        }
        this.$router.push({ name: rota, params: { id: row.id } });
      }
    },
    toggleSelecaoGeral: function toggleSelecaoGeral(selecao) {
      this.filteredList.forEach(function (item) {
        item.selecionado = selecao;
      });
      this.objetosSelecionados = !selecao ? [] : [].concat((0, _toConsumableArray3.default)(this.filteredList));

      this.requestPermiteAprovar();
      this.$forceUpdate();
    },
    toggleSelecaoUnica: function toggleSelecaoUnica(row) {
      var _this2 = this;

      setTimeout(function () {
        var selecao = row.selecionado;
        if (selecao) {
          _this2.objetosSelecionados.push(row);
          _this2.requestPermiteAprovar();
          return;
        }

        var indexO = null;
        _this2.objetosSelecionados.forEach(function (obj, index) {
          if (obj.idWorkflow === row.idWorkflow) {
            indexO = index;
          }
        });
        _this2.objetosSelecionados.splice(indexO, 1);
        _this2.requestPermiteAprovar();
      });
    },
    requestPermiteAprovar: function requestPermiteAprovar() {
      var _this3 = this;

      this.podeAprovar = false;
      var lista = this.objetosSelecionados;
      if (!lista || lista.length === 0) {
        this.podeAprovar = false;
        return;
      }
      if (lista) {
        this.podeAprovar = true;
        lista.forEach(function (el) {
          if (!_this3.ehAprovador(el)) {
            _this3.podeAprovar = false;
          }
        });
      }
    },
    limparSelecao: function limparSelecao() {
      this.podeAprovar = false;
      this.objetosSelecionados = [];
    },
    clickOnRow: function clickOnRow() {
      var row = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var index = arguments[1];

      this.$emit('ACORDOTABELA_CLICK_LINHA', this.contrato, row, index);
    },
    ehAprovador: function ehAprovador(row) {
      return row.status === 'AGUARDANDO_APROVACAO' && row.aprovador === true;
    },
    temJustificativa: function temJustificativa(row) {
      return row.justificativa && row.justificativa !== '';
    },
    defaultClose: function defaultClose() {
      this.getLimpaReferenciasJustificativa();
      this.$refs.modal.close();
    },
    getLimpaReferenciasJustificativa: function getLimpaReferenciasJustificativa() {
      this.$refs.inputJustificativaAnalise.hasValue = false;
      this.$refs.inputJustificativaAnalise.inputLength = 0;
      this.$refs.inputJustificativaAprovar.hasValue = false;
      this.$refs.inputJustificativaAprovar.inputLength = 0;
      this.$refs.inputJustificativaReprovar.hasValue = false;
      this.$refs.inputJustificativaReprovar.inputLength = 0;
      this.$forceUpdate();
    },
    fetchProduto: function fetchProduto(value) {
      value = this.montarFiltroProduto(value);

      return this.produtoResources.listarAtivos(value);
    },
    requestFecharModaisDefault: function requestFecharModaisDefault() {
      this.$refs.modalReprovar.close();
      this.$refs.modalAnalise.close();
      this.$refs.modalAprovar.close();
      this.$refs.modalComentario.close();
      this.justificativa = '';
    },
    requestRefreshFilteredList: function requestRefreshFilteredList() {
      this.requestBuscarNegociacoesFilter();
    },
    requestBuscarMotivoLog: function requestBuscarMotivoLog(row) {
      var _this4 = this;

      this.acordoResources.logAcordo({ codigo: row.id }).then(function (response) {
        var motivo = response.data && response.data.length ? response.data[response.data.length - 1].justificativa : 'Acordo sem justificativa.';
        _this4.justificativaGrid = motivo.justificativa || motivo;
        _this4.$refs.modalComentario.open();
      }).catch(function (err) {
        _this4.$error(_this4, err);
      });
    },
    filtrarModal: function filtrarModal() {
      this.requestBuscarNegociacoesFilter();
    },
    requestCleanFiltro: function requestCleanFiltro() {
      this.filtro.tipoAcordo = '';
      this.filtro.status = '';
      this.filtro.tipoLinhaOrcamento = '';
      this.filtro.marca = '';
      this.filtro.linhaProduto = '';
      this.filtro.familia = '';
      this.filtro.produto = '';
      this.filtro.cliente = '';
      this.filtro.meuPassoPendente = true;
      this.filtro.meuPassoAprovado = false;
      this.justificativa = '';

      if (this.filtro.idCliente) {
        delete this.filtro.idCliente;
      }
      if (this.filtro.idMarca) {
        delete this.filtro.idMarca;
      }
      if (this.filtro.idLinhaProduto) {
        delete this.filtro.idLinhaProduto;
      }
      if (this.filtro.idFamilia) {
        delete this.filtro.idFamilia;
      }
      if (this.filtro.idProduto) {
        delete this.filtro.idProduto;
      }
      if (this.filtro.idTipoLinhaOrcamento) {
        delete this.filtro.idTipoLinhaOrcamento;
      }
    },
    montarFiltroProduto: function montarFiltroProduto(value) {
      var filtros = value;

      if (this.filtro.idMarca) {
        filtros.id_marca = this.filtro.idMarca;
      }
      if (this.filtro.idLinhaProduto) {
        filtros.id_familia = this.filtro.idLinhaProduto;
      }
      if (this.filtro.idFamilia) {
        filtros.id_familia = this.filtro.idFamilia;
      }

      filtros.nome = value.nome;

      return filtros;
    },
    requestVoltarTelaInicial: function requestVoltarTelaInicial() {
      this.$refs.modal.close();
    },
    requestModalEnviarNegociacaoAnalise: function requestModalEnviarNegociacaoAnalise() {
      var row = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.getLimpaReferenciasJustificativa();
      this.$refs.modalAnalise.open();
      this.itemSelecionado = row;
    },
    requestModalAprovarPassoNegociacao: function requestModalAprovarPassoNegociacao() {
      var row = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.getLimpaReferenciasJustificativa();
      this.$refs.modalAprovar.open();
      this.itemSelecionado = row;
    },
    requestModalComentarioOpcional: function requestModalComentarioOpcional() {
      var row = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.getLimpaReferenciasJustificativa();
      this.$refs.modalComentario.open();
      this.itemSelecionado = row;
    },
    requestModalReprovarApuracaoNegociacao: function requestModalReprovarApuracaoNegociacao() {
      var row = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.getLimpaReferenciasJustificativa();
      this.$refs.modalReprovar.open();
      this.itemSelecionado = row;
    },
    requestAprovarPassosFluxoAcordo: function requestAprovarPassosFluxoAcordo() {
      var _this5 = this;

      if (this.esperarRequest) return;
      this.esperarRequest = true;

      if (this.itemSelecionado) {
        this.workflowAcordo.aprovar({ idAcordo: this.itemSelecionado.id }, { observacao: this.justificativa }).then(this.tratarAprovarSucesso).catch(function (err) {
          _this5.esperarRequest = false;
          _this5.$error(_this5, err);
        });
      } else {
        this.objetosSelecionados.forEach(function (el, idx) {
          _this5.workflowAcordo.aprovar({ idAcordo: el.id }, { observacao: _this5.justificativa }).then(function () {
            if (idx === _this5.objetosSelecionados.length - 1) {
              _this5.esperarRequest = false;
              _this5.recarregarAposAcaoEmMassa();
              _this5.$toast.create(_this5.$t('message.acordo_aprovado'), 'snack', 3E3);
            }
          }).catch(function (err) {
            _this5.esperarRequest = false;
            _this5.$error(_this5, err);
          });
        });
      }
    },
    requestEnviarNegociacaoParaAnalise: function requestEnviarNegociacaoParaAnalise() {
      var _this6 = this;

      if (this.itemSelecionado) {
        this.workflowAcordo.enviarAnalise({ idAcordo: this.itemSelecionado.id }, { observacao: this.justificativa }).then(this.tratarAnaliseSucesso).catch(function (err) {
          _this6.$error(_this6, err);
        });
      } else {
        this.objetosSelecionados.forEach(function (el, idx) {
          _this6.workflowAcordo.enviarAnalise({ idAcordo: el.id }, { observacao: _this6.justificativa }).then(function () {
            if (idx === _this6.objetosSelecionados.length - 1) {
              _this6.recarregarAposAcaoEmMassa();
              _this6.$toast.create(_this6.$t('message.acordo_enviado_analise'), 'snack', 3E3);
            }
          }).catch(function (err) {
            _this6.$error(_this6, err);
          });
        });
      }
    },
    requestReprovarPassosNegociacao: function requestReprovarPassosNegociacao() {
      var _this7 = this;

      if (this.esperarRequest) return;
      this.esperarRequest = true;

      if (this.itemSelecionado) {
        this.workflowAcordo.reprovar({ idAcordo: this.itemSelecionado.id }, { observacao: this.justificativa }).then(this.tratarReprovarSucesso).catch(function (err) {
          _this7.esperarRequest = false;
          _this7.$error(_this7, err);
        });
      } else {
        this.objetosSelecionados.forEach(function (el, idx) {
          _this7.workflowAcordo.reprovar({ idAcordo: el.id }, { observacao: _this7.justificativa }).then(function () {
            if (idx === _this7.objetosSelecionados.length - 1) {
              _this7.esperarRequest = false;
              _this7.recarregarAposAcaoEmMassa();
              _this7.$toast.create(_this7.$t('message.acordo_reprovado'), 'snack', 3E3);
            }
          }).catch(function (err) {
            _this7.esperarRequest = false;
            _this7.$error(_this7, err);
          });
        });
      }
    },
    recarregarAposAcaoEmMassa: function recarregarAposAcaoEmMassa() {
      this.requestFecharModaisDefault();
      this.requestVoltarTelaInicial();
      this.requestRefreshFilteredList();
    },
    tratarAprovarSucesso: function tratarAprovarSucesso() {
      this.esperarRequest = false;
      this.$toast.create(this.$t('message.acordo_aprovado'), 'snack', 3E3);
      this.tratarAlterarSucesso();
    },
    tratarReprovarSucesso: function tratarReprovarSucesso() {
      this.esperarRequest = false;
      this.$toast.create(this.$t('message.acordo_reprovado'), 'snack', 3E3);
      this.tratarAlterarSucesso();
    },
    tratarAnaliseSucesso: function tratarAnaliseSucesso() {
      this.$toast.create(this.$t('message.acordo_enviado_analise'), 'snack', 3E3);
      this.tratarAlterarSucesso();
    },
    tratarAlterarSucesso: function tratarAlterarSucesso() {
      this.itemSelecionado = null;
      this.requestFecharModaisDefault();
      this.requestRefreshFilteredList();
    },
    requestBuscarNegociacoesFilter: function requestBuscarNegociacoesFilter() {
      this.requestVoltarTelaInicial();
      this.preencherFiltrosGerais();
      this.buscar('ACORDOTABELA_FILTER');
    },
    preencherFiltrosGerais: function preencherFiltrosGerais() {
      this.filtro.periodo = this.periodoNegociacao;
      this.filtro.unidadeNegocio = this.unidadeNegocio;
    },
    buscar: function buscar(evento) {
      this.limparSelecao();
      this.salvarWorkspace(this.entidade, this.filtro);
      this.$emit(evento, this.filtro);
    },
    limparTipoInvestimentoOrcamento: function limparTipoInvestimentoOrcamento() {
      this.filtro.idTipoLinhaOrcamento = null;
    },
    setTipoInvestimentoOrcamento: function setTipoInvestimentoOrcamento(hit) {
      this.filtro.idTipoLinhaOrcamento = hit.id;
      this.filtro.tipoLinhaOrcamento = hit.nome;
    },
    setMarca: function setMarca(hit) {
      this.filtro.idMarca = hit.id;
      this.filtro.marca = hit.nomExtensao;
      this.limparProdutoCompleto();
    },
    limparMarca: function limparMarca() {
      this.filtro.idMarca = null;
      this.limparProdutoCompleto();
    },
    setFamilia: function setFamilia(hit) {
      this.filtro.idFamilia = hit.id;
      this.filtro.familia = hit.nomExtensao;
      this.limparProdutoCompleto();
    },
    limparFamilia: function limparFamilia() {
      this.filtro.idFamilia = null;
      this.limparProdutoCompleto();
    },
    setLinhaProduto: function setLinhaProduto(hit) {
      this.filtro.idLinhaProduto = hit.id;
      this.filtro.linhaProduto = hit.nomExtensao;
      this.limparProdutoCompleto();
    },
    limparLinhaProduto: function limparLinhaProduto() {
      this.filtro.idLinhaProduto = null;
      this.limparProdutoCompleto();
    },
    setProduto: function setProduto(hit) {
      this.filtro.idProduto = hit.id;
      this.filtro.produto = hit.nomProduto;
    },
    limparProdutoCompleto: function limparProdutoCompleto() {
      this.filtro.produto = '';
      this.limparProduto();
    },
    limparProduto: function limparProduto() {
      this.filtro.idProduto = null;
    },
    setCliente: function setCliente(hit) {
      this.filtro.idCliente = hit.id;
      this.filtro.cliente = hit.nomCliente;
    },
    limparCliente: function limparCliente() {
      this.filtro.idCliente = null;
    },
    setUnidadeNegocio: function setUnidadeNegocio(hit, row) {
      this.dependenciaUnidadeNegocio = {
        idUnidadeNegocio: hit.id,
        nomExtensao: hit.nomExtensao,
        unidadeNegocio: hit.nomExtensao
      };
      this.updateItemDependency(row, 'dependencias', this.dependenciaUnidadeNegocio);
    },
    verificarMeuPassoPendente: function verificarMeuPassoPendente() {
      this.filtro.meuPassoPendente = !this.filtro.meuPassoPendente;
      if (this.filtro.meuPassoPendente) {
        this.filtro.status = 'AGUARDANDO_APROVACAO';
        this.statusBloqueado = true;
        this.filtro.meuPassoAprovado = false;
      } else {
        this.statusBloqueado = false;
      }
    },
    verificarMeuPassoAprovado: function verificarMeuPassoAprovado() {
      this.filtro.meuPassoAprovado = !this.filtro.meuPassoAprovado;
      if (this.filtro.meuPassoAprovado) {
        this.statusBloqueado = true;
        this.filtro.meuPassoPendente = false;
      } else {
        this.statusBloqueado = false;
      }
    },
    preencherFiltros: function preencherFiltros(filtros) {
      this.filtro.tipoAcordo = filtros.tipoAcordo || null;
      this.filtro.status = filtros.status;
      this.filtro.tipoLinhaOrcamento = filtros.tipoLinhaOrcamento;
      this.filtro.marca = filtros.marca || '';
      this.filtro.linhaProduto = filtros.linhaProduto || '';
      this.filtro.familia = filtros.familia || '';
      this.filtro.produto = filtros.produto || '';
      this.filtro.cliente = filtros.cliente || '';
      this.filtro.meuPassoPendente = filtros.meuPassoPendente;
      this.filtro.meuPassoAprovado = filtros.meuPassoAprovado;

      this.filtro.idCliente = filtros.idCliente;
      this.filtro.idMarca = filtros.idMarca;
      this.filtro.idLinhaProduto = filtros.idLinhaProduto;
      this.filtro.idFamilia = filtros.idFamilia;
      this.filtro.idProduto = filtros.idProduto;
      this.filtro.idTipoLinhaOrcamento = filtros.idTipoLinhaOrcamento;

      this.statusBloqueado = this.filtro.meuPassoPendente || this.filtro.meuPassoAprovado;
    }
  },
  mounted: function mounted() {
    var _this8 = this;

    this.filtroCopy = this.filtro;
    this.carregarWorkspace(this.entidade, this.preencherFiltros).then(function () {
      return _this8.filtrarModal();
    });
  }
};

/***/ }),
/* 437 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 438 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardApuracao_vue_vue_type_script_lang_js___ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardApuracao_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardApuracao_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardApuracao_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardApuracao_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardApuracao_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _assign = __webpack_require__(4);

var _assign2 = _interopRequireDefault(_assign);

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

var _vuex = __webpack_require__(6);

var _downloads = __webpack_require__(54);

var _downloads2 = _interopRequireDefault(_downloads);

var _ApuracaoTabelaDash = __webpack_require__(1207);

var _ApuracaoTabelaDash2 = _interopRequireDefault(_ApuracaoTabelaDash);

var _ReivindicacaoTabelaDash = __webpack_require__(1236);

var _ReivindicacaoTabelaDash2 = _interopRequireDefault(_ReivindicacaoTabelaDash);

var _apuracao = __webpack_require__(1240);

var _apuracao2 = _interopRequireDefault(_apuracao);

var _helpers = __webpack_require__(5);

var _loading = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'DashboardApuracao',
  mixins: [_apuracao2.default],
  data: function data() {
    return {
      reivindicacoes: [],
      idMeta: 0,
      status: '',
      deletar: true,
      consolidadoApuracao: {},
      filtros: {},
      periodo: null,
      idUnidadeNegocio: null,
      carregado: false,
      carregandoBox: false,
      carregandoTableApuracoes: false,
      carregandoTableReivindicacoes: false,
      bloquearConsulta: false,
      paginasApuracao: 0,
      paginasReivindicacao: 0,
      buscarComParametro: false,
      totalPage: 0
    };
  },

  props: {
    parametros: {
      type: Object,
      default: {}
    }
  },
  components: {
    ApuracaoTabela: _ApuracaoTabelaDash2.default,
    ReivindicacaoTabela: _ReivindicacaoTabelaDash2.default
  },
  methods: {
    getMoney: _helpers.getMoney,
    downloadEvidencia: function downloadEvidencia(params) {
      var _this = this;

      var idRequisicao = params.id;
      var getBasePath = params.getBasePath;
      var resource = (0, _downloads2.default)(this.$http);
      resource.download(getBasePath, {
        limit: 500,
        url: 'download',
        id: idRequisicao,
        parametrosConsulta: {}
      }).then(function () {
        _this.$toast.create(_this.$t('message.download_efetuado'), 'snack', 3E3);
      }).catch(function () {
        _this.$toast.create('Erro ao exportar. Tente novamente.', 'snack', 3E3);
      });
    },
    requestCarregarConsolidadoApuracao: function requestCarregarConsolidadoApuracao() {
      var _this2 = this;

      (0, _loading.skipLoading)();
      this.carregandoBox = true;
      this.dashboardApuracaoResources.listarDashApuracao(this.filtros).then(function (response) {
        _this2.consolidadoApuracao = {};
        response.data.forEach(function (item) {
          _this2.consolidadoApuracao[item.status.toLowerCase()] = item.consolidado;
        });
        _this2.carregandoBox = false;
      }).catch(function (err) {
        _this2.$error(_this2, err);
        _this2.carregandoBox = false;
      });
      return this;
    },
    requestCargaPeriodos: function requestCargaPeriodos() {
      var _this3 = this;

      return new _promise2.default(function (resolve, reject) {
        (0, _loading.skipLoading)();
        _this3.dashboardApuracaoResources.listarPeriodos().then(function (response) {
          _this3.periodos = response.data;
          resolve();
        }).catch(reject);
      });
    },
    requestGetUnidadesNegocio: function requestGetUnidadesNegocio() {
      var _this4 = this;

      return new _promise2.default(function (resolve, reject) {
        (0, _loading.skipLoading)();
        _this4.usuarioUnidadeNegocioResources.listarAtivos().then(function (response) {
          _this4.unidadesNegocio = response.data;
          resolve();
        }).catch(reject);
      });
    },
    requestCargaDash: function requestCargaDash() {
      this.$refs.apuracaoTabela.refazPaginacao();
      if (this.periodo) {
        this.filtros.periodo = this.periodo;
      } else {
        delete this.filtros.periodo;
      }
      if (this.idUnidadeNegocio) {
        this.filtros.idUnidadeNegocio = this.idUnidadeNegocio;
      } else {
        delete this.filtros.idUnidadeNegocio;
      }

      this.requestCarregarReivindicacoes();
      this.requestCarregarConsolidadoApuracao();
    },
    requestCarregarApuracoes: function requestCarregarApuracoes(filtros) {
      var _this5 = this;

      var pagina = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var cb = arguments[2];

      this.filtros = (0, _assign2.default)(this.filtros, filtros || {});

      this.bloquearConsulta = true;
      var merged = (0, _assign2.default)({}, this.filtros);
      (0, _assign2.default)(merged, filtros);
      merged.tamanhoPagina = 20;
      merged.numeroPagina = pagina;

      (0, _loading.skipLoading)();
      this.carregandoTableApuracoes = true;
      this.dashboardApuracaoResources.listarApuracoes(merged).then(function (response) {
        _this5.bloquearConsulta = false;
        _this5.carregandoTableApuracoes = false;
        _this5.apuracoes = response.data.resposta;
        _this5.apuracoes.forEach(function (el, index) {
          el.index = index;
        });
        _this5.totalPage = response.data.quantidadeRegistrosPagina;
        var qtdeRegistros = response.data.quantidadeRegistrosPagina;
        _this5.paginasApuracao = Math.ceil(qtdeRegistros / merged.tamanhoPagina);
        if (cb) {
          cb();
        }
      }).catch(function (err) {
        _this5.bloquearConsulta = false;
        _this5.carregandoTableApuracoes = false;
        _this5.$toast.create(_this5.$t(err), 'snack', 3E3);
      });
    },
    requestCarregarReivindicacoes: function requestCarregarReivindicacoes(filtros) {
      var _this6 = this;

      var pagina = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var cb = arguments[2];

      var merged = (0, _assign2.default)({}, this.filtros);
      (0, _assign2.default)(merged, filtros);
      merged.tamanhoPagina = 20;
      merged.numeroPagina = pagina;
      (0, _loading.skipLoading)();
      this.carregandoTableReivindicacoes = true;
      this.dashboardApuracaoResources.listarReivindicacoes(merged).then(function (response) {
        _this6.carregandoTableReivindicacoes = false;
        _this6.reivindicacoes = response.data.resposta;
        var qtdeRegistros = response.data.quantidadeRegistrosPagina;
        _this6.paginasReivindicacao = Math.ceil(qtdeRegistros / merged.tamanhoPagina);
        if (cb) {
          cb();
        }
      }).catch(function (err) {
        _this6.carregandoTableReivindicacoes = false;
        _this6.$toast.create(_this6.$t(err), 'snack', 3E3);
      });
    },
    abrirSideBar: function abrirSideBar(row) {
      var eventData = {
        idMeta: row.idMeta,
        status: row.status,
        deletar: row.deletar,
        fecharSideBar: this.fecharSideBar
      };
      this.$emit('APURACAOTABELA_UPLOAD_EVIDENCIA', eventData);
    },
    fecharSideBar: function fecharSideBar() {
      this.idMeta = 0;
    },
    filtrarFluxos: function filtrarFluxos(filtro) {
      this.$refs.apuracaoTabela.refazPaginacao();
      if (this.buscarComParametro) {
        this.requestCarregarApuracoes(this.filtrosPorParametros());
        this.buscarComParametro = false;
      } else {
        this.requestCarregarApuracoes(filtro);
      }
    },
    filtrarFluxosReivindicacao: function filtrarFluxosReivindicacao(filtro) {
      this.$refs.reivindicacaoTabela.refazPaginacao();
      this.requestCarregarReivindicacoes(filtro);
    },
    filtrosPorParametros: function filtrosPorParametros() {
      var filter = { status: 'AGUARDANDO_APROVACAO' };
      filter.meuPassoPendente = true;
      if (this.parametros && this.parametros.idApuracao) {
        filter.idApuracao = this.parametros.idApuracao;
      }
      return filter;
    },
    temParametro: function temParametro() {
      return this.parametros && this.parametros.idApuracao;
    },
    abreCarrega: function abreCarrega() {
      var _this7 = this;

      if (this.carregado) {
        return;
      }

      window.setTimeout(function () {
        _this7.requestCargaPeriodos().then(_this7.requestGetUnidadesNegocio).then(function () {
          _this7.carregado = true;
          _this7.requestCarregarConsolidadoApuracao();
          if (_this7.temParametro()) _this7.buscarComParametro = true;
          delete _this7.filtros.idApuracao;
        }).catch(function (err) {
          _this7.$toast.create(_this7.$t(err), 'snack', 3E3);
        });
      });
    }
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('usuario', ['usuarioLogado'])),
  mounted: function mounted() {
    this.buscarPendencias();
  }
};

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ApuracaoTabelaDash_vue_vue_type_script_lang_js___ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ApuracaoTabelaDash_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ApuracaoTabelaDash_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ApuracaoTabelaDash_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ApuracaoTabelaDash_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ApuracaoTabelaDash_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(11);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(6);

var _alturaTabelaMixin = __webpack_require__(701);

var _alturaTabelaMixin2 = _interopRequireDefault(_alturaTabelaMixin);

var _FiltrosDash = __webpack_require__(443);

var _FiltrosDash2 = _interopRequireDefault(_FiltrosDash);

var _helpers = __webpack_require__(5);

var _http = __webpack_require__(22);

var _numeric = __webpack_require__(83);

var _StatusPassos = __webpack_require__(57);

var _StatusPassos2 = _interopRequireDefault(_StatusPassos);

var _Pendencias = __webpack_require__(1213);

var _Pendencias2 = _interopRequireDefault(_Pendencias);

var _Detalhes = __webpack_require__(1231);

var _Detalhes2 = _interopRequireDefault(_Detalhes);

var _MetasCrescimento = __webpack_require__(116);

var _MetasCrescimento2 = _interopRequireDefault(_MetasCrescimento);

var _PendenciaNegociacao = __webpack_require__(106);

var _PendenciaNegociacao2 = _interopRequireDefault(_PendenciaNegociacao);

var _Apuracao = __webpack_require__(107);

var _Apuracao2 = _interopRequireDefault(_Apuracao);

var _PendenciaApuracao = __webpack_require__(108);

var _PendenciaApuracao2 = _interopRequireDefault(_PendenciaApuracao);

var _ListarEvidencia = __webpack_require__(109);

var _ListarEvidencia2 = _interopRequireDefault(_ListarEvidencia);

var _bloqueioSistemaMixin = __webpack_require__(1234);

var _bloqueioSistemaMixin2 = _interopRequireDefault(_bloqueioSistemaMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ApuracaoTabelaDash',
  mixins: [_alturaTabelaMixin2.default, _bloqueioSistemaMixin2.default],
  props: {
    contrato: Object,
    pendencias: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      apuracaoGestaoResources: this.$api.apuracaoGestao(this.$resource),
      dashboardApuracaoResources: this.$api.dashboardApuracao(this.$resource),
      produtoResources: this.$api.produto(this.$resource),
      acordoResources: this.$api.acordo(this.$resource),
      workflowPassosResources: this.$api.workflowPassos(this.$resource),
      bloquearConsulta: false,
      statusPassos: {},
      indexPagina: 0,
      itemSelecionado: null,
      objetosSelecionados: [],
      justificativa: '',
      justificativaGrid: null,
      podeAprovar: false,
      esperarRequest: false,
      filtro: {
        status: 'AGUARDANDO_APROVACAO'
      },
      filtroAplicado: {},

      statusNegociacoes: [{ status: 'EM_CADASTRO', descricao: this.$t('status_entidade.em_cadastro') }, { status: 'AGUARDANDO_APROVACAO', descricao: this.$t('status_entidade.aguardando_aprovacao') }, { status: 'APROVADO', descricao: this.$tc('status_entidade.aprovado', 1) }, { status: 'REPROVADO', descricao: this.$tc('status_entidade.reprovado', 1) }, { status: 'ENCERRADO', descricao: this.$t('label.encerrado') }, { status: 'CANCELADO', descricao: this.$t('label.cancelado') }, { status: 'EM_ANALISE', descricao: this.$t('status_entidade.em_analise') }],
      headerApuracao: [{ text: this.$tc('label.acoes', 1), value: 'acoes', width: 100, sortable: false }, { text: this.$tc('label.evidencia', 1), value: 'possuiEvidenciaMeta', width: 120, sortable: false }, { text: this.$tc('label.codigo', 1), value: 'idAcordo', width: 120, sortable: false }, { text: this.$tc('label.realizado_meta', 1), value: 'realizadoMeta', width: 120, sortable: false }, { text: this.$tc('label.valor_pagamento', 1), value: 'vlrFinal', width: 120, sortable: false }, { text: this.$tc('label.valor_negociado', 1), value: 'vlrAssinado', width: 120, sortable: false }, { text: this.$tc('label.contrato_cliente', 1), value: 'contratoCliente', width: 120, sortable: false }, { text: this.$t('label.meta'), value: 'vlrMeta', width: 200, sortable: false }, { text: this.$tc('label.cliente', 1), value: 'nomCliente', width: 250, sortable: false }, { text: this.$tc('label.acordo'), value: 'descTipoAcordo', width: 150, sortable: false }, { text: this.$tc('label.solicitante'), value: 'solicitante', width: 250, sortable: false }, { text: this.$tc('label.descricao', 2), value: 'descricao', width: 250, sortable: false }, { text: this.$tc('label.marca', 2), value: 'marca', width: 250, sortable: false }, { text: this.$tc('label.linha_produto', 1), value: 'linhaProduto', width: 250, sortable: false }, { text: this.$tc('label.familia', 1), value: 'familia', width: 250, sortable: false }, { text: this.$tc('label.produto', 1), value: 'produto', width: 250, sortable: false }, { text: this.$tc('label.linha_orcamento', 1), value: 'tipoLinhaOrcamento', width: 250, sortable: false }],
      metasDoAcordo: [],
      modalVisualizarMetas: false,
      headersMetas: [{ text: this.$t('label.marca'), value: 'nomMarca', sortable: false }, { text: this.$t('label.linha_produto'), value: 'nomLinhaProduto', sortable: false }, { text: this.$t('label.familia'), value: 'nomFamilia', sortable: false }, { text: this.$tc('label.produto', 1), value: 'nomProduto', sortable: false }, { text: this.$t('label.tipo_linha_orcamento'), value: 'descTipoInvestimento', sortable: false }, { text: this.$t('label.linha_orcamento'), value: 'descricaoLinhaInvestimento', sortable: false }, { text: this.$tc('label.valor', 1), value: 'vlrAssinado', sortable: false }, { text: this.$t('label.valor_reservado'), value: 'vlrReservado', sortable: false }, { text: this.$t('label.investimento_venda'), value: 'roi', sortable: false }],
      dialog: {
        ref: 'dialog1',
        from: 'blockbtn',
        title: 'Atenção',
        content: 'Deseja realmente aplicar esta ação',
        action: function action() {
          return {};
        }
      },
      title: 'Apurações',
      apuracoes: [],
      totalPage: 0,
      pagination: {
        page: 1,
        itemsPerPage: 10
      },
      dialogModal: false,
      pendencia: null,
      item: null,
      recriarPaginacao: false,
      esperar: false,
      filtrosCarregados: false
    };
  },

  computed: (0, _extends3.default)({
    hasSingleRowSelected: function hasSingleRowSelected() {
      return this.selected && this.selected.length === 1;
    }
  }, (0, _vuex.mapGetters)('roles', ['getAllRoles']), {
    permiteExecucaoMeta: function permiteExecucaoMeta() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el === 'APU_UPLOAD' || el === 'APU_DOWNLOAD';
      }).length;
    },
    alturaInicial: function alturaInicial() {
      return window.innerHeight <= 768 ? 400 : this.altura;
    }
  }),
  components: {
    Pendencias: _Pendencias2.default,
    Detalhes: _Detalhes2.default,
    FiltrosDash: _FiltrosDash2.default,
    StatusPassos: _StatusPassos2.default,
    MetasCrescimento: _MetasCrescimento2.default,
    PendenciaNegociacao: _PendenciaNegociacao2.default,
    PendenciaApuracao: _PendenciaApuracao2.default,
    ListarEvidencia: _ListarEvidencia2.default
  },
  watch: {
    dialogModal: function dialogModal(val) {
      if (val) {
        this.preencherPendencias();
      } else {
        this.$emit('Detalhes_close');
      }
    },
    objetosSelecionados: function objetosSelecionados() {
      this.requestPermiteAprovar();
    },

    pagination: {
      handler: function handler() {
        if (this.filtrosCarregados) {
          this.filtrar();
        }
      },

      deep: true
    }
  },
  methods: {
    prepareResponseData: _http.prepareResponseData,
    getMoney: _helpers.getMoney,
    openDetalhes: function openDetalhes(item) {
      this.item = item;
      this.dialogModal = true;
    },
    openModalVisualizarMetas: function openModalVisualizarMetas(item) {
      var _this = this;

      this.showLoading = true;
      this.acordoResources.listarMetas({ id: item.idAcordo }).then(function (response) {
        _this.metasDoAcordo = _this.mapearMetas(response.data);
        _this.modalVisualizarMetas = true;
      }).catch(function (err) {
        _this.$error(_this, err);
      }).finally(function () {
        _this.showLoading = false;
      });
    },
    mapearMetas: function mapearMetas(metas) {
      var _this2 = this;

      return metas.map(function (meta) {
        return {
          nomLinhaProduto: meta.nomLinhaProduto || '--',
          nomProduto: meta.nomProduto || '--',
          nomFamilia: meta.nomFamilia || '--',
          roi: meta.roi || 0,
          nomMarca: meta.nomMarca || '--',
          vlrAssinado: _this2.getMoney(meta.vlrAssinado || 0),
          vlrReservado: _this2.getMoney(meta.vlrReservado || 0),
          descricaoLinhaInvestimento: meta.descricaoLinhaInvestimento || '--',
          descTipoInvestimento: meta.descTipoInvestimento || '--'
        };
      });
    },
    closeModalVisualizarMetas: function closeModalVisualizarMetas() {
      this.modalVisualizarMetas = false;
      this.metasDoAcordo = [];
    },
    preencherPendencias: function preencherPendencias() {
      var _this3 = this;

      var id = this.item.id;

      this.dashboardApuracaoResources.apuracao({ id: id }).then(function (response) {
        _this3.pendencia = new _Apuracao2.default(_this3.$t('title.negociacao'), _this3.item.id, _this3.item.idAcordo, response.data);
      });
    },
    requestAtualizarGrid: function requestAtualizarGrid(filtro) {
      this.pagination.page = 1;
      this.filtroAplicado = (0, _extends3.default)({}, filtro);
      this.filtrar();
    },
    recarregarPendencias: function recarregarPendencias() {
      this.$emit('Pendencias_recarregar');
      this.refazPaginacao();
    },
    defaultClose: function defaultClose() {
      this.requestCleanFiltro();
      this.getLimpaReferenciasJustificativa();
      this.$refs.modal.close();
    },
    getLimpaReferenciasJustificativa: function getLimpaReferenciasJustificativa() {
      this.justificativa = null;
      this.$forceUpdate();
    },
    verItem: function verItem(row) {
      if (row) {
        var rota = null;
        switch (row.codTipoAcordo) {
          case 'FIXO':
            rota = 'verDetalhesNegociacaoFixoFluxo';
            break;
          case 'TABLOIDE':
            rota = 'verDetalhesNegociacaoTabloideFluxo';
            break;
          case 'NEGOCIACAO_PRECO':
            rota = 'verDetalhesNegociacaoPrecoFluxo';
            break;
          case 'POSITIVACAO':
            rota = 'verDetalhesPositivacaoFluxo';
            break;
          case 'CRESCIMENTO':
            rota = 'verDetalhesCrescimentoFluxo';
            break;
          default:
            return;
        }
        this.$router.push({ name: rota, params: { id: row.idAcordo } });
      }
    },
    clickHandler: function clickHandler(pagina) {
      this.indexPagina = pagina - 1;
      this.$emit('DASH_APURACAO_TABELA_PAGINA', this.filtro, pagina);
    },
    campoDinheiro: function campoDinheiro(apuracao) {
      if (apuracao.codTipoAcordo === 'POSITIVACAO') {
        return false;
      }
      if (apuracao.tipoMetaBeneficio) {
        return apuracao.tipoMetaBeneficio.indexOf('VOLUME') < 0;
      }
      return true;
    },
    formatacaoRealizadoMeta: function formatacaoRealizadoMeta(apuracao, realizadoMeta) {
      if (this.campoDinheiro(apuracao)) {
        return this.getMoney(realizadoMeta);
      }
      return realizadoMeta;
    },
    refazPaginacao: function refazPaginacao() {
      var _this4 = this;

      this.pagination.page = 1;
      this.apuracoes = [];
      this.totalPage = 0;
      this.recriarPaginacao = true;
      setTimeout(function () {
        _this4.recriarPaginacao = false;
      }, 2E2);
    },
    requestAbrirModalExecucaoMetas: function requestAbrirModalExecucaoMetas(row) {
      this.$emit('APURACAOTABELA_UPLOAD_EVIDENCIA', row);
    },
    requestAbrirAcompanhamento: function requestAbrirAcompanhamento(row) {
      var _this5 = this;

      var id = row.id;
      this.workflowPassosResources.statusPassosApuracao({ id: id }, { id: id }).then(function (res) {
        _this5.statusPassos = res.data;
        _this5.$refs.modalAcompanhamento.open();
      }).catch(function (err) {
        _this5.$toast.create(_this5.$t(err), 'snack', 3E3);
      });
    },
    requestFecharModaisDefault: function requestFecharModaisDefault() {
      this.$refs.modalReprovar.close();
      this.$refs.modalAnalise.close();
      this.$refs.modalAprovar.close();
      this.$refs.modalComentario.close();
      this.$refs.modalAcompanhamento.close();
      this.justificativa = '';
    },
    temJustificativa: function temJustificativa(row) {
      return row.justificativa && row.justificativa !== '';
    },
    pararEsperar: function pararEsperar() {
      var _this6 = this;

      setTimeout(function () {
        _this6.esperar = false;
      }, 2E2);
    },
    requestBuscarMotivoLog: function requestBuscarMotivoLog(row) {
      var _this7 = this;

      this.apuracaoGestaoResources.buscaJustificativa({ idApuracao: row.id }).then(function (response) {
        _this7.justificativaGrid = response.data.justificativa ? response.data.justificativa : 'Sem justificativa';
        _this7.$refs.modalComentario.open();
      }).catch(function (err) {
        _this7.$error(_this7, err);
      });
    },
    filtrarModal: function filtrarModal(filtro) {
      if (!this.filtrosCarregados) {
        this.filtrosCarregados = true;
      }
      this.objetosSelecionados = [];
      this.requestAtualizarGrid(filtro);
    },
    requestCleanFiltro: function requestCleanFiltro() {
      this.filtro.tipoAcordo = '';
      this.filtro.status = 'AGUARDANDO_APROVACAO';
      this.filtro.tipoLinhaOrcamento = '';
      this.filtro.marca = '';
      this.filtro.linhaProduto = '';
      this.filtro.familia = '';
      this.filtro.produto = '';
      this.filtro.cliente = '';
      this.filtro.meuPassoPendente = true;
      this.filtro.meuPassoAprovado = false;
      this.justificativa = '';

      if (this.filtro.idCliente) {
        delete this.filtro.idCliente;
      }
      if (this.filtro.idExtensao) {
        delete this.filtro.idExtensao;
      }
      if (this.filtro.idLinhaProduto) {
        delete this.filtro.idLinhaProduto;
      }
      if (this.filtro.idMarca) {
        delete this.filtro.idMarca;
      }
      if (this.filtro.idProduto) {
        delete this.filtro.idProduto;
      }
      if (this.filtro.idTipoLinhaOrcamento) {
        delete this.filtro.idTipoLinhaOrcamento;
      }
    },
    requestVoltarTelaInicial: function requestVoltarTelaInicial() {
      this.$refs.modal.close();
    },
    requestModalEnviarNegociacaoAnalise: function requestModalEnviarNegociacaoAnalise() {
      var row = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.getLimpaReferenciasJustificativa();
      this.$refs.modalAnalise.open();
      this.itemSelecionado = row;
    },
    requestModalAprovarPassoNegociacao: function requestModalAprovarPassoNegociacao() {
      var row = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (this.bloqueioSistema) {
        this.mostrarMensagemBloqueio();
        return;
      }

      this.getLimpaReferenciasJustificativa();
      this.$refs.modalAprovar.open();
      this.itemSelecionado = row;
    },
    requestModalComentarioOpcional: function requestModalComentarioOpcional() {
      var row = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.getLimpaReferenciasJustificativa();
      this.$refs.modalComentario.open();
      this.itemSelecionado = row;
    },
    requestModalReprovarApuracaoNegociacao: function requestModalReprovarApuracaoNegociacao() {
      var row = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.getLimpaReferenciasJustificativa();
      this.$refs.modalReprovar.open();
      this.itemSelecionado = row;
    },
    requestAprovarPassosFluxoApuracao: function requestAprovarPassosFluxoApuracao() {
      var _this8 = this;

      if (this.esperarRequest) return;
      this.esperarRequest = true;

      if (this.itemSelecionado) {
        this.workflowPassosResources.aprovarPassosApuracao({ idApuracao: this.itemSelecionado.id }, { observacao: this.justificativa }).then(this.tratarAprovarSucesso).catch(function (err) {
          _this8.esperarRequest = false;
          _this8.$error(_this8, err);
        });
      } else {
        this.objetosSelecionados.forEach(function (el, idx) {
          _this8.workflowPassosResources.aprovarPassosApuracao({ idApuracao: el.id }, { observacao: _this8.justificativa }).then(function () {
            if (idx === _this8.objetosSelecionados.length - 1) {
              _this8.esperarRequest = false;
              _this8.recarregarAposAcaoEmMassa();
              _this8.$toast.create(_this8.$t('message.acordo_aprovado'), 'snack', 3E3);
            }
          }).catch(function (err) {
            _this8.esperarRequest = false;
            _this8.$error(_this8, err);
          });
        });
      }
    },
    requestEnviarApuracaoParaAnalise: function requestEnviarApuracaoParaAnalise() {
      var _this9 = this;

      if (this.itemSelecionado) {
        this.workflowPassosResources.enviarApuracaoAnalise({ idApuracao: this.itemSelecionado.id }, { observacao: this.justificativa }).then(this.tratarAnaliseSucesso).catch(function (err) {
          _this9.$error(_this9, err);
        });
      } else {
        this.objetosSelecionados.forEach(function (el, idx) {
          _this9.workflowPassosResources.enviarApuracaoAnalise({ idApuracao: el.id }, { observacao: _this9.justificativa }).then(function () {
            if (idx === _this9.objetosSelecionados.length - 1) {
              _this9.recarregarAposAcaoEmMassa();
              _this9.$toast.create(_this9.$t('message.acordo_enviado_analise'), 'snack', 3E3);
            }
          }).catch(function (err) {
            _this9.$error(_this9, err);
          });
        });
      }
    },
    requestReprovarPassosApuracao: function requestReprovarPassosApuracao() {
      var _this10 = this;

      if (this.esperarRequest) return;
      this.esperarRequest = true;

      if (this.itemSelecionado) {
        this.workflowPassosResources.reprovarPassosApuracao({ idApuracao: this.itemSelecionado.id }, { observacao: this.justificativa }).then(this.tratarReprovarSucesso).catch(function (err) {
          _this10.esperarRequest = false;
          _this10.$error(_this10, err);
        });
      } else {
        this.objetosSelecionados.forEach(function (el, idx) {
          _this10.workflowPassosResources.reprovarPassosApuracao({ idApuracao: el.id }, { observacao: _this10.justificativa }).then(function () {
            if (idx === _this10.objetosSelecionados.length - 1) {
              _this10.esperarRequest = false;
              _this10.recarregarAposAcaoEmMassa();
              _this10.$toast.create(_this10.$t('message.acordo_reprovado'), 'snack', 3E3);
            }
          }).catch(function (err) {
            _this10.esperarRequest = false;
            _this10.$error(_this10, err);
          });
        });
      }
    },
    recarregarAposAcaoEmMassa: function recarregarAposAcaoEmMassa() {
      this.requestFecharModaisDefault();
      this.requestVoltarTelaInicial();
      this.requestRefreshFilteredList();
    },
    tratarAprovarSucesso: function tratarAprovarSucesso() {
      this.esperarRequest = false;
      this.$toast.create(this.$t('message.acordo_aprovado'), 'snack', 3E3);
      this.tratarAlterarSucesso();
    },
    tratarReprovarSucesso: function tratarReprovarSucesso() {
      this.esperarRequest = false;
      this.$toast.create(this.$t('message.acordo_reprovado'), 'snack', 3E3);
      this.tratarAlterarSucesso();
    },
    tratarAnaliseSucesso: function tratarAnaliseSucesso() {
      this.$toast.create(this.$t('message.acordo_enviado_analise'), 'snack', 3E3);
      this.tratarAlterarSucesso();
    },
    tratarAlterarSucesso: function tratarAlterarSucesso() {
      this.itemSelecionado = null;
      this.requestFecharModaisDefault();
      this.requestRefreshFilteredList();
    },
    buscar: function buscar(evento) {
      this.limparSelecao();
      this.$emit(evento, this.filtro);
    },
    setTipoInvestimentoOrcamento: function setTipoInvestimentoOrcamento(hit) {
      this.filtro.idTipoLinhaOrcamento = hit.id;
      this.filtro.tipoLinhaOrcamento = hit.descTipoOrcamento;
    },
    setMarca: function setMarca(hit) {
      this.filtro.idExtensao = hit.id;
      this.filtro.marca = hit.nomExtensao;
    },
    setFamilia: function setFamilia(hit) {
      this.filtro.idMarca = hit.id;
      this.filtro.familia = hit.nomExtensao;
    },
    requestPermiteAprovar: function requestPermiteAprovar() {
      var _this11 = this;

      this.podeAprovar = false;
      var lista = this.objetosSelecionados;
      if (!lista || lista.length === 0) {
        this.podeAprovar = false;
        return;
      }
      if (lista) {
        this.podeAprovar = true;
        lista.forEach(function (el) {
          if (!_this11.ehAprovador(el)) {
            _this11.podeAprovar = false;
          }
        });
      }
    },
    limparSelecao: function limparSelecao() {
      this.podeAprovar = false;
      this.objetosSelecionados = [];
    },
    ehAprovador: function ehAprovador(row) {
      return row.status === 'AGUARDANDO_APROVACAO' && row.aprovador === true;
    },
    fetchProduto: function fetchProduto(value) {
      value = this.montarFiltroProduto(value);

      return this.produtoResources.listarAtivos(value);
    },
    requestRefreshFilteredList: function requestRefreshFilteredList() {
      this.filtrar();
      this.objetosSelecionados = [];
      this.recarregarPendencias();
    },
    setLinhaProduto: function setLinhaProduto(hit) {
      this.filtro.idLinhaProduto = hit.id;
      this.filtro.linhaProduto = hit.nomExtensao;
    },
    setProduto: function setProduto(hit) {
      this.filtro.idProduto = hit.id;
      this.filtro.produto = hit.nomProduto;
    },
    setCliente: function setCliente(hit) {
      this.filtro.idCliente = hit.id;
      this.filtro.cliente = hit.nomCliente;
    },
    setUnidadeNegocio: function setUnidadeNegocio(hit, row) {
      this.dependenciaUnidadeNegocio = {
        idUnidadeNegocio: hit.id,
        nomExtensao: hit.nomExtensao,
        unidadeNegocio: hit.nomExtensao
      };
      this.updateItemDependency(row, 'dependencias', this.dependenciaUnidadeNegocio);
    },
    exibirMeta: function exibirMeta(row, valor) {
      if (row.metasBeneficios === 'SELLOUT_VALOR' || row.metasBeneficios === 'SELLIN_VALOR') {
        return (0, _numeric.convertToMoney)(valor);
      }
      return (0, _numeric.convertToNumberFormat)(valor);
    },
    exibirPagamento: function exibirPagamento(row, valor) {
      if (row.bonificacao === 'PERCENTUAL') {
        return convertToPercent(valor);
      }
      return (0, _numeric.convertToMoney)(valor);
    },
    filtrar: function filtrar() {
      var _this12 = this;

      if (this.esperar) return;
      this.esperar = true;
      setTimeout(function () {
        _this12.requestCarregarApuracoes();
      }, 5E2);
    },
    requestCarregarApuracoes: function requestCarregarApuracoes(cb) {
      var _this13 = this;

      var filtroRequest = {
        numeroPagina: this.pagination.page,
        tamanhoPagina: this.pagination.itemsPerPage,
        asc: !this.pagination.sortDesc[0],
        colunaOrdenacao: this.pagination.sortBy[0]
      };
      filtroRequest = (0, _extends3.default)({}, filtroRequest, this.filtroAplicado);

      (0, _keys2.default)(filtroRequest).forEach(function (el) {
        if (!filtroRequest[el]) {
          delete filtroRequest[el];
        }
      });

      this.carregandoTableApuracoes = true;
      this.dashboardApuracaoResources.listarApuracoes(filtroRequest).then(function (response) {
        _this13.bloquearConsulta = false;
        _this13.carregandoTableApuracoes = false;

        _this13.apuracoes = response.data.resposta;
        _this13.apuracoes.forEach(function (el, index) {
          el.index = index;
        });
        _this13.totalPage = response.data.quantidadeRegistrosPagina;
        if (cb) {
          cb();
        }
        _this13.pararEsperar();
      }).catch(function (err) {
        _this13.pararEsperar();
        _this13.bloquearConsulta = false;
        _this13.carregandoTableApuracoes = false;
        _this13.$toast.create(_this13.$t(err), 'snack', 3E3);
      });
    }
  },
  mounted: function mounted() {
    this.filtroCopy = this.filtro;
    this.onResize('apuracao-tabela-dash');
  }
};

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FiltrosDash_vue_vue_type_template_id_4243819c___ = __webpack_require__(1210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FiltrosDash_vue_vue_type_script_lang_js___ = __webpack_require__(444);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__FiltrosDash_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__FiltrosDash_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FiltrosDash_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(1212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__FiltrosDash_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__FiltrosDash_vue_vue_type_template_id_4243819c___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__FiltrosDash_vue_vue_type_template_id_4243819c___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosDash_vue_vue_type_script_lang_js___ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosDash_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosDash_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosDash_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosDash_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosDash_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(4);

var _assign2 = _interopRequireDefault(_assign);

var _mdAutocomplete = __webpack_require__(16);

var _mdAutocomplete2 = _interopRequireDefault(_mdAutocomplete);

var _workspaceFiltros = __webpack_require__(81);

var _workspaceFiltros2 = _interopRequireDefault(_workspaceFiltros);

var _http = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_workspaceFiltros2.default],
  props: {
    filtro: Object,
    mdOpenFrom: String,
    entidade: ''
  },
  data: function data() {
    return {
      acordoResources: this.$api.acordo(this.$resource),
      tipoInvestimentoResources: this.$api.tipoInvestimento(this.$resource),
      dashboardNegociacaoResources: this.$api.dashboardNegociacao(this.$resource),
      dashboardApuracaoResources: this.$api.dashboardApuracao(this.$resource),
      clienteResources: this.$api.cliente(this.$resource),
      produtoResources: this.$api.produto(this.$resource),
      statusBloqueado: true,
      statusApuracao: [{ status: 'AGUARDANDO_APROVACAO', descricao: this.$t('status_entidade.aguardando_aprovacao') }, { status: 'APROVADO', descricao: this.$tc('status_entidade.aprovado', 1) }, { status: 'REPROVADO', descricao: this.$tc('status_entidade.reprovado', 1) }, { status: 'CANCELADO', descricao: this.$t('label.cancelado') }, { status: 'EM_ANALISE', descricao: this.$t('status_entidade.em_analise') }]
    };
  },

  computed: {},
  components: {
    mdAutocomplete: _mdAutocomplete2.default
  },
  methods: {
    prepareResponseData: _http.prepareResponseData,
    setMarca: function setMarca(hit) {
      this.filtro.idMarca = hit.id;
    },
    setTipoLinhaOrcamento: function setTipoLinhaOrcamento(hit) {
      this.filtro.idTipoLinhaOrcamento = hit.id;
    },
    setLinhaProduto: function setLinhaProduto(hit) {
      this.filtro.idLinhaProduto = hit.id;
    },
    setFamilia: function setFamilia(hit) {
      this.filtro.idFamilia = hit.id;
    },
    setProduto: function setProduto(hit) {
      this.filtro.idProduto = hit.id;
    },
    setCliente: function setCliente(hit) {
      this.filtro.idCliente = hit.id;
    },
    setTipoAcordo: function setTipoAcordo(hit) {
      this.filtro.idTipoAcordo = hit.id;
    },
    setSolicitante: function setSolicitante(hit) {
      this.filtro.idSolicitante = hit.id;
    },
    limparMarca: function limparMarca() {
      this.filtro.idMarca = null;
    },
    limparTipoLinhaOrcamento: function limparTipoLinhaOrcamento() {
      this.filtro.idTipoLinhaOrcamento = null;
    },
    limparLinhaProduto: function limparLinhaProduto() {
      this.filtro.idLinhaProduto = null;
    },
    limparFamilia: function limparFamilia() {
      this.filtro.idFamilia = null;
    },
    limparProduto: function limparProduto() {
      this.filtro.idProduto = null;
    },
    limparCliente: function limparCliente() {
      this.filtro.idCliente = null;
    },
    limparTipoAcordo: function limparTipoAcordo() {
      this.filtro.idTipoAcordo = null;
    },
    limparSolicitante: function limparSolicitante() {
      this.filtro.idSolicitante = null;
    },
    verificarMeuPassoPendente: function verificarMeuPassoPendente() {
      this.filtro.meuPassoPendente = !this.filtro.meuPassoPendente;
      if (this.filtro.meuPassoPendente) {
        this.filtro.status = 'AGUARDANDO_APROVACAO';
        this.statusBloqueado = true;
        this.filtro.meuPassoAprovado = false;
      } else {
        this.statusBloqueado = false;
      }
    },
    verificarMeuPassoAprovado: function verificarMeuPassoAprovado() {
      this.filtro.meuPassoAprovado = !this.filtro.meuPassoAprovado;
      if (this.filtro.meuPassoAprovado) {
        this.statusBloqueado = true;
        this.filtro.meuPassoPendente = false;
      } else {
        this.statusBloqueado = false;
      }
    },
    open: function open() {
      this.$refs.modal.open();
      this.onOpen();
    },
    defaultClose: function defaultClose() {
      this.$emit('GENERICMODAL_DEFAULT_CLOSE');
      this.close();
    },
    onOpen: function onOpen() {
      this.$emit('GENERICMODAL_OPEN');
    },
    onClose: function onClose() {
      this.$emit('GENERICMODAL_CLOSE');
    },
    close: function close() {
      this.$refs.modal.close();
      this.onClose();
    },
    filtrar: function filtrar() {
      var copiaFiltro = (0, _assign2.default)({}, this.filtro);
      (0, _http.removeParametrosNulos)(copiaFiltro);
      copiaFiltro.meuPassoPendente = this.filtro.meuPassoPendente;
      copiaFiltro.meuPassoAprovado = this.filtro.meuPassoAprovado;
      this.salvarWorkspace(this.entidade, copiaFiltro);
      this.$emit('FILTROSDASH_FILTRAR', copiaFiltro);
      this.defaultClose();
    },
    preencherFiltros: function preencherFiltros(filtros) {
      this.filtro.status = filtros.status;
      this.filtro.solicitante = filtros.solicitante || '';
      this.filtro.tipoAcordo = filtros.tipoAcordo || '';
      this.filtro.tipoLinhaOrcamento = filtros.tipoLinhaOrcamento || '';
      this.filtro.marca = filtros.marca || '';
      this.filtro.linhaProduto = filtros.linhaProduto || '';
      this.filtro.familia = filtros.familia || '';
      this.filtro.produto = filtros.produto || '';
      this.filtro.cliente = filtros.cliente || '';

      this.filtro.idMarca = filtros.idMarca;
      this.filtro.idTipoLinhaOrcamento = filtros.idTipoLinhaOrcamento;
      this.filtro.idLinhaProduto = filtros.idLinhaProduto;
      this.filtro.idFamilia = filtros.idFamilia;
      this.filtro.idProduto = filtros.idProduto;
      this.filtro.idCliente = filtros.idCliente;
      this.filtro.idTipoAcordo = filtros.idTipoAcordo;
      this.filtro.idSolicitante = filtros.idSolicitante;
      this.filtro.idAcordo = filtros.idAcordo;

      this.filtro.meuPassoPendente = !!filtros.meuPassoPendente;
      this.filtro.meuPassoAprovado = !!filtros.meuPassoAprovado;
      this.statusBloqueado = !!(this.filtro.meuPassoPendente || this.filtro.meuPassoAprovado);
      this.$forceUpdate();
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.carregarWorkspace(this.entidade, this.preencherFiltros).then(function () {
      return _this.filtrar();
    });
  }
};

/***/ }),
/* 446 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Pendencias_vue_vue_type_script_lang_js___ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Pendencias_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Pendencias_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Pendencias_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Pendencias_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Pendencias_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PendenciaNegociacao = __webpack_require__(106);

var _PendenciaNegociacao2 = _interopRequireDefault(_PendenciaNegociacao);

var _Apuracao = __webpack_require__(107);

var _Apuracao2 = _interopRequireDefault(_Apuracao);

var _PendenciaApuracao = __webpack_require__(108);

var _PendenciaApuracao2 = _interopRequireDefault(_PendenciaApuracao);

var _ListarEvidencia = __webpack_require__(109);

var _ListarEvidencia2 = _interopRequireDefault(_ListarEvidencia);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Pendencias',
  components: {
    ListarEvidencia: _ListarEvidencia2.default,
    PendenciaApuracao: _PendenciaApuracao2.default,
    PendenciaNegociacao: _PendenciaNegociacao2.default
  },
  props: {
    pendencias: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      dashboardApuracaoResources: this.$api.dashboardApuracao(this.$resource),
      dialog: false,
      page: 1,
      pendencia: null
    };
  },

  watch: {
    page: function page(val) {
      this.preencherPendencias(val);
    },
    dialog: function dialog(val) {
      if (val) {
        this.page = 1;
        this.preencherPendencias(this.page);
      } else {
        this.$emit('Pendencias_close');
      }
    }
  },
  computed: {
    ultimaPagina: function ultimaPagina() {
      return this.page === this.pendencias.length;
    }
  },
  methods: {
    irProximaApuracao: function irProximaApuracao() {
      this.page = this.page + 1;
    },
    preencherPendencias: function preencherPendencias(page) {
      var _this = this;

      var ids = this.pendencias[page - 1];

      this.dashboardApuracaoResources.apuracao({ id: ids.id }).then(function (response) {
        _this.pendencia = new _Apuracao2.default(_this.$t('title.negociacao'), ids.id, ids.idAcordo, response.data);
      });
    }
  }
};

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_PendenciaNegociacao_vue_vue_type_script_lang_js___ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_PendenciaNegociacao_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_PendenciaNegociacao_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_PendenciaNegociacao_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_PendenciaNegociacao_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_PendenciaNegociacao_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ClientePagador = __webpack_require__(1218);

var _ClientePagador2 = _interopRequireDefault(_ClientePagador);

var _AcaoFluxo = __webpack_require__(1221);

var _AcaoFluxo2 = _interopRequireDefault(_AcaoFluxo);

var _StatusPassos = __webpack_require__(57);

var _StatusPassos2 = _interopRequireDefault(_StatusPassos);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'PendenciaNegociacao',
  components: {
    StatusPassos: _StatusPassos2.default,
    AcaoFluxo: _AcaoFluxo2.default,
    ClientePagador: _ClientePagador2.default
  },
  props: {
    pendencia: null,
    ultimaPagina: false,
    exibirAcaoFluxo: true
  },
  data: function data() {
    return {
      workflowPassosResources: this.$api.workflowPassos(this.$resource),
      statusPassos: {},
      showTooltip: false,
      carregou: false
    };
  },

  watch: {
    showTooltip: function showTooltip() {
      var _this = this;

      if (!this.carregou) {
        setTimeout(function () {
          _this.showTooltip = false;
        }, 1E2);
        this.carregou = true;
      }
    }
  },
  methods: {
    irProximaApuracao: function irProximaApuracao(irProxima) {
      var _this2 = this;

      if (irProxima) {
        setTimeout(function () {
          _this2.$emit('PendenciaNegociacao_irProximaApuracao');
        }, 5E2);
      }
    },
    requestAbrirAcompanhamento: function requestAbrirAcompanhamento() {
      var _this3 = this;

      var id = this.pendencia.id;
      this.workflowPassosResources.statusPassosApuracao({ id: id }, { id: id }).then(function (res) {
        _this3.statusPassos = res.data;
        _this3.$refs.modalAcompanhamento.open();
      }).catch(function (err) {
        _this3.$toast.create(_this3.$t(err), 'snack', 3E3);
      });
    },
    aprovar: function aprovar(irProxima) {
      var _this4 = this;

      var urlParam = { idApuracao: this.pendencia.id };
      var bodyParam = { observacao: this.pendencia.justificativa };
      this.workflowPassosResources.aprovarPassosApuracao(urlParam, bodyParam).then(function () {
        _this4.pendencia.status = 'APROVADO';
        _this4.irProximaApuracao(irProxima);
        _this4.$toast.create(_this4.$t('message.apuracao_passos_aprovar'), 'snack', 3E3);
      }).catch(function (err) {
        _this4.$toast.create(err.data.error, 'snack', 3E3);
      });
    },
    enviarAnalise: function enviarAnalise(irProxima) {
      var _this5 = this;

      var urlParam = { idApuracao: this.pendencia.id };
      var bodyParam = { observacao: this.pendencia.justificativa };
      this.workflowPassosResources.enviarApuracaoAnalise(urlParam, bodyParam).then(function () {
        _this5.pendencia.status = 'EM_ANALISE';
        _this5.irProximaApuracao(irProxima);
        _this5.$toast.create(_this5.$t('message.apuracao_passos_enviar_analise'), 'snack', 3E3);
      }).catch(function (err) {
        _this5.$toast.create(err.data.error, 'snack', 3E3);
      });
    },
    reprovar: function reprovar(irProxima) {
      var _this6 = this;

      var urlParam = { idApuracao: this.pendencia.id };
      var bodyParam = { observacao: this.pendencia.justificativa };
      this.workflowPassosResources.reprovarPassosApuracao(urlParam, bodyParam).then(function () {
        _this6.pendencia.status = 'REPROVADO';
        _this6.irProximaApuracao(irProxima);
        _this6.$toast.create(_this6.$t('message.apuracao_passos_reprovar'), 'snack', 3E3);
      }).catch(function (err) {
        _this6.$toast.create(err.data.error, 'snack', 3E3);
      });
    }
  }
};

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ClientePagador_vue_vue_type_script_lang_js___ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ClientePagador_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ClientePagador_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ClientePagador_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ClientePagador_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ClientePagador_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'ClientePagador',
  props: {
    pendencia: null
  },
  data: function data() {
    return {
      menu: false
    };
  }
};

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AcaoFluxo_vue_vue_type_script_lang_js___ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AcaoFluxo_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AcaoFluxo_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AcaoFluxo_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AcaoFluxo_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_AcaoFluxo_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'AcaoFluxo',
  props: {
    corIcone: {
      type: String,
      default: null
    },
    icone: {
      type: String,
      default: ''
    },
    disabled: false,
    exibirJustificativa: false,
    pendencia: null,
    status: {
      type: String,
      default: ''
    },
    ultimaPagina: false,
    validarJustificativa: false,
    textoAcao: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      menu: false,
      valid: false,
      bloquearCampos: false,
      exibirPerguntaProximo: false
    };
  },
  watch: {
    menu: function menu(val) {
      var _this = this;

      if (val) {
        setTimeout(function () {
          return _this.$refs.textareaJustificativa.focus();
        }, 5E2);
      }
    },
    disabled: function disabled(val) {
      if (!val) {
        this.desbloquearCampos();
        this.exibirPerguntaProximo = false;
        this.$forceUpdate();
      }
    }
  },
  methods: {
    required: function required(v) {
      return !this.validarJustificativa || !!v || this.$t('label.campo_obrigatorio');
    },
    cancelar: function cancelar() {
      this.pendencia.justificativa = '';
      this.fechar();
    },
    fechar: function fechar() {
      this.menu = false;
    },
    naoIrProximo: function naoIrProximo() {
      this.fechar();
      this.$emit('AcaoFluxo_executarAcao', false);
    },
    irProximo: function irProximo() {
      this.fechar();
      this.$emit('AcaoFluxo_executarAcao', true);
    },
    acaoExecutada: function acaoExecutada() {
      this.exibirPerguntaProximo = true;
    },
    desbloquearCampos: function desbloquearCampos() {
      this.bloquearCampos = false;
    },
    executarAcao: function executarAcao() {
      if (this.bloqueioSistema) {
        this.mostrarMensagemBloqueio();
        return;
      }
      if (!this.$refs.form.validate()) return;
      this.bloquearCampos = true;
      if (!this.ultimaPagina) {
        this.acaoExecutada();
      } else {
        this.naoIrProximo();
      }
    },
    getStatus: function getStatus(status) {
      return {
        APROVADO: this.$tc('status_entidade.aprovado', 1),
        AGUARDANDO_APROVACAO: this.$tc('status_entidade.aprovado', 1),
        EM_ANALISE: this.$tc('status_entidade.em_analise', 1),
        REPROVADO: this.$tc('status_entidade.reprovado', 1)
      }[status];
    }
  }
};

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_PendenciaApuracao_vue_vue_type_script_lang_js___ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_PendenciaApuracao_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_PendenciaApuracao_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_PendenciaApuracao_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_PendenciaApuracao_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_PendenciaApuracao_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MetasCrescimento = __webpack_require__(116);

var _MetasCrescimento2 = _interopRequireDefault(_MetasCrescimento);

var _DetalhesConfMeta = __webpack_require__(1226);

var _DetalhesConfMeta2 = _interopRequireDefault(_DetalhesConfMeta);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'PendenciaApuracao',
  components: {
    DetalhesConfMeta: _DetalhesConfMeta2.default,
    MetasCrescimento: _MetasCrescimento2.default
  },
  props: {
    pendencia: null
  },
  data: function data() {
    return {
      evidencias: [{
        label: this.$t('label.sim'),
        value: true
      }, {
        label: this.$t('label.nao'),
        value: false
      }]
    };
  }
};

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DetalhesConfMeta_vue_vue_type_script_lang_js___ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DetalhesConfMeta_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DetalhesConfMeta_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DetalhesConfMeta_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DetalhesConfMeta_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DetalhesConfMeta_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'DetalhesConfMeta',
  props: {
    pendencia: null
  },
  data: function data() {
    return {
      menu: false
    };
  }
};

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ListarEvidencia_vue_vue_type_script_lang_js___ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ListarEvidencia_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ListarEvidencia_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ListarEvidencia_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ListarEvidencia_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ListarEvidencia_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(6);

var _downloads = __webpack_require__(54);

var _downloads2 = _interopRequireDefault(_downloads);

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ListarEvidencia',
  props: {
    pendencia: null
  },
  data: function data() {
    return {
      execucaoResources: this.$api.execucao(this.$resource),
      evidencias: []
    };
  },

  watch: {
    pendencia: function pendencia() {
      this.listarEvidencias();
    }
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('roles', ['getAllRoles']), {
    canAccessDownload: function canAccessDownload() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el === 'APU_DOWNLOAD';
      }).length;
    }
  }),
  methods: {
    listarEvidencias: function listarEvidencias() {
      var _this = this;

      if (!this.canAccessDownload) {
        return;
      }
      var id = this.pendencia.idMeta;
      this.execucaoResources.listar({ id: id }, { id: id }).then(function (response) {
        _this.evidencias = response.data;
      }).catch(function (err) {
        _this.$toast.create(err.data.error, 'snack', 3E3);
      });
    },
    visualizarArquivo: function visualizarArquivo(row) {
      var _this2 = this;

      var getBasePath = (0, _apiResource2.default)('execucao', 'execucao');
      var resource = (0, _downloads2.default)(this.$http);

      resource.downloadGetAba(getBasePath, {
        param: '',
        url: row.id + '/pdf'
      }).then(function () {}).catch(function () {
        _this2.$toast.create('Erro ao exportar. Tente novamente.', 'snack', 3E3);
      });
    }
  },
  mounted: function mounted() {
    this.listarEvidencias();
  }
};

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Detalhes_vue_vue_type_script_lang_js___ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Detalhes_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Detalhes_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Detalhes_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Detalhes_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Detalhes_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PendenciaNegociacao = __webpack_require__(106);

var _PendenciaNegociacao2 = _interopRequireDefault(_PendenciaNegociacao);

var _Apuracao = __webpack_require__(107);

var _Apuracao2 = _interopRequireDefault(_Apuracao);

var _PendenciaApuracao = __webpack_require__(108);

var _PendenciaApuracao2 = _interopRequireDefault(_PendenciaApuracao);

var _ListarEvidencia = __webpack_require__(109);

var _ListarEvidencia2 = _interopRequireDefault(_ListarEvidencia);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Detalhes',
  components: {
    ListarEvidencia: _ListarEvidencia2.default,
    PendenciaApuracao: _PendenciaApuracao2.default,
    PendenciaNegociacao: _PendenciaNegociacao2.default
  },
  props: {
    item: {
      type: Object,
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      dashboardApuracaoResources: this.$api.dashboardApuracao(this.$resource),
      dialog: false,
      pendencia: null
    };
  },

  watch: {
    dialog: function dialog(val) {
      if (val) {
        this.preencherPendencias();
      } else {
        this.$emit('Detalhes_close');
      }
    }
  },
  methods: {
    preencherPendencias: function preencherPendencias() {
      var _this = this;

      var id = this.item.id;

      this.dashboardApuracaoResources.apuracao({ id: id }).then(function (response) {
        _this.pendencia = new _Apuracao2.default(_this.$t('title.negociacao'), _this.item.id, _this.item.idAcordo, response.data);
      });
    }
  }
};

/***/ }),
/* 463 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ReivindicacaoTabelaDash_vue_vue_type_script_lang_js___ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ReivindicacaoTabelaDash_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ReivindicacaoTabelaDash_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ReivindicacaoTabelaDash_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ReivindicacaoTabelaDash_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ReivindicacaoTabelaDash_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(9);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _vuejsPaginate = __webpack_require__(27);

var _vuejsPaginate2 = _interopRequireDefault(_vuejsPaginate);

var _TabelaGenerica = __webpack_require__(20);

var _TabelaGenerica2 = _interopRequireDefault(_TabelaGenerica);

var _mdAutocomplete = __webpack_require__(16);

var _mdAutocomplete2 = _interopRequireDefault(_mdAutocomplete);

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

var _FiltrosDash = __webpack_require__(443);

var _FiltrosDash2 = _interopRequireDefault(_FiltrosDash);

var _helpers = __webpack_require__(5);

var _http = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  extends: _TabelaGenerica2.default,
  props: {
    contrato: Object,
    carregando: Boolean,
    paginas: Number
  },
  data: function data() {
    return {
      reivindicacaoResources: this.$api.reivindicacao(this.$resource),
      tipoInvestimentoResources: this.$api.tipoInvestimento(this.$resource),
      dashboardNegociacaoResources: this.$api.dashboardNegociacao(this.$resource),
      clienteResources: this.$api.cliente(this.$resource),
      produtoResources: this.$api.produto(this.$resource),
      canPost: false,
      somenteLeitura: false,
      nomContato: '',
      hasFilter: false,
      indexPagina: 0,
      itemSelecionado: null,
      justificativa: '',
      objetosSelecionados: [],
      justificativaGrid: null,
      filtro: {
        solicitante: '',
        tipoAcordo: '',
        status: 'APROVADO',
        tipoLinhaOrcamento: '',
        marca: '',
        linhaProduto: '',
        familia: '',
        produto: '',
        cliente: '',
        meuPassoPendente: true
      },
      filtroCopy: {},
      statusNegociacoes: [{ status: 'EM_CADASTRO', descricao: this.$t('status_entidade.em_cadastro') }, { status: 'AGUARDANDO_APROVACAO', descricao: this.$t('status_entidade.aguardando_aprovacao') }, { status: 'APROVADO', descricao: this.$tc('status_entidade.aprovado', 1) }, { status: 'REPROVADO', descricao: this.$tc('status_entidade.reprovado', 1) }, { status: 'ENCERRADO', descricao: this.$t('label.encerrado') }, { status: 'CANCELADO', descricao: this.$t('label.cancelado') }, { status: 'EM_ANALISE', descricao: this.$t('status_entidade.em_analise') }]
    };
  },

  computed: {
    hasSingleRowSelected: function hasSingleRowSelected() {
      return this.selected && this.selected.length === 1;
    }
  },
  components: {
    mdAutocomplete: _mdAutocomplete2.default,
    FiltrosDash: _FiltrosDash2.default,
    Paginate: _vuejsPaginate2.default
  },
  methods: {
    prepareResponseData: _http.prepareResponseData,
    toggleSelecaoGeral: function toggleSelecaoGeral(selecao) {
      this.filteredList.forEach(function (item) {
        item.selecionado = selecao;
      });
      this.objetosSelecionados = !selecao ? [] : [].concat((0, _toConsumableArray3.default)(this.filteredList));
    },
    toggleSelecaoUnica: function toggleSelecaoUnica(row) {
      var _this = this;

      setTimeout(function () {
        var selecao = row.selecionado;
        if (selecao) {
          _this.objetosSelecionados.push(row);
          return;
        }

        var indexO = null;
        _this.objetosSelecionados.forEach(function (obj, index) {
          if (obj.idWorkflow === row.idWorkflow) {
            indexO = index;
          }
        });
        _this.objetosSelecionados.splice(indexO, 1);
      });
    },
    clickOnRow: function clickOnRow() {
      var row = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var index = arguments[1];

      this.$emit('ACORDOTABELA_CLICK_LINHA', this.contrato, row, index);
    },
    defaultClose: function defaultClose() {
      this.requestCleanFiltro();
      this.getLimpaReferenciasJustificativa();
      this.$refs.modal.close();
    },
    getLimpaReferenciasJustificativa: function getLimpaReferenciasJustificativa() {
      this.$forceUpdate();
    },
    requestFecharModaisDefault: function requestFecharModaisDefault() {
      this.$refs.modalReprovar.close();
      this.$refs.modalAprovar.close();
      this.$refs.modalComentario.close();
      this.justificativa = '';
    },
    requestBuscarMotivoLog: function requestBuscarMotivoLog(row) {
      var _this2 = this;

      this.reivindicacaoResources.justificativa({ idReivindicacao: row.id }).then(function (response) {
        var motivo = response.data.justificativa;
        _this2.justificativaGrid = motivo.justificativa || motivo;
        _this2.$refs.modalComentario.open();
      }).catch(function (err) {
        _this2.$error(_this2, err);
      });
    },
    filtrarModal: function filtrarModal(filtro) {
      this.filtro = (0, _helpers.copyObject)(filtro);
      this.requestBuscarApuracoesFilter();
    },
    getMoney: function getMoney(str) {
      str = (0, _helpers.convertFloatToMoney)(String(str));
      str = str.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var money = str.split('.');
      return money[0].replace(/,/g, '.') + ',' + money[1];
    },
    requestCleanFiltro: function requestCleanFiltro() {
      this.filtro.tipoAcordo = '';
      this.filtro.status = 'APROVADO';
      this.filtro.tipoLinhaOrcamento = '';
      this.filtro.marca = '';
      this.filtro.linhaProduto = '';
      this.filtro.familia = '';
      this.filtro.produto = '';
      this.filtro.cliente = '';
      this.justificativa = '';
      this.meuPassoPendente = true;

      if (this.filtro.idCliente) {
        delete this.filtro.idCliente;
      }
      if (this.filtro.idExtensao) {
        delete this.filtro.idExtensao;
      }
      if (this.filtro.idLinhaProduto) {
        delete this.filtro.idLinhaProduto;
      }
      if (this.filtro.idMarca) {
        delete this.filtro.idMarca;
      }
      if (this.filtro.idProduto) {
        delete this.filtro.idProduto;
      }
      if (this.filtro.idTipoLinhaOrcamento) {
        delete this.filtro.idTipoLinhaOrcamento;
      }
    },
    requestVoltarTelaInicial: function requestVoltarTelaInicial() {
      this.$refs.modal.close();
    },
    requestModalAprovarPassoNegociacao: function requestModalAprovarPassoNegociacao(row) {
      this.getLimpaReferenciasJustificativa();
      this.$refs.modalAprovar.open();
      this.itemSelecionado = row;
    },
    requestModalComentarioOpcional: function requestModalComentarioOpcional(row) {
      this.getLimpaReferenciasJustificativa();
      this.$refs.modalComentario.open();
      this.itemSelecionado = row;
    },
    requestModalReprovarApuracaoNegociacao: function requestModalReprovarApuracaoNegociacao(row) {
      this.getLimpaReferenciasJustificativa();
      this.$refs.modalReprovar.open();
      this.itemSelecionado = row;
    },
    requestDownloadEvidenciaReivindicacao: function requestDownloadEvidenciaReivindicacao(row) {
      var idReivindicacao = row.idReivindicacao;
      this.$emit('APURACAOTABELA_DOWNLOAD', {
        getBasePath: (0, _apiResource2.default)('apuracao', 'reivindicacao'),
        id: idReivindicacao
      });
    },
    requestAprovarPassosFluxoAcordo: function requestAprovarPassosFluxoAcordo() {
      var _this3 = this;

      var item = this.itemSelecionado;
      this.reivindicacaoResources.aprovarReivindicacao({ idReivindicacao: item.idReivindicacao }, { observacao: this.justificativa }).then(function () {
        _this3.requestFecharModaisDefault();
        _this3.requestBuscarApuracoesFilter();
        _this3.$toast.create(_this3.$t('message.apuracao_reivindicacao_aprovar'), 'snack', 3E3);
      }).catch(function (err) {
        _this3.$error(_this3, err);
      });
    },
    requestReprovarPassosReivindicacao: function requestReprovarPassosReivindicacao() {
      var _this4 = this;

      var item = this.itemSelecionado;
      this.reivindicacaoResources.reprovarReivindicacao({ idReivindicacao: item.idReivindicacao }, { observacao: this.justificativa }).then(function () {
        _this4.requestFecharModaisDefault();
        _this4.requestBuscarApuracoesFilter();
        _this4.$toast.create(_this4.$t('message.apuracao_reivindicacao_reprovar'), 'snack', 3E3);
      }).catch(function (err) {
        _this4.$error(_this4, err);
      });
    },
    requestBuscarApuracoesFilter: function requestBuscarApuracoesFilter() {
      this.$emit('APURACAOTABELA_FILTER', this.filtro, this.requestVoltarTelaInicial);
    },
    setTipoInvestimentoOrcamento: function setTipoInvestimentoOrcamento(hit) {
      this.filtro.idTipoLinhaOrcamento = hit.id;
      this.filtro.tipoLinhaOrcamento = hit.descTipoOrcamento;
    },
    setMarca: function setMarca(hit) {
      this.filtro.idExtensao = hit.id;
      this.filtro.marca = hit.nomExtensao;
    },
    setFamilia: function setFamilia(hit) {
      this.filtro.idMarca = hit.id;
      this.filtro.familia = hit.nomExtensao;
    },
    setLinhaProduto: function setLinhaProduto(hit) {
      this.filtro.idLinhaProduto = hit.id;
      this.filtro.linhaProduto = hit.nomExtensao;
    },
    setProduto: function setProduto(hit) {
      this.filtro.idProduto = hit.id;
      this.filtro.produto = hit.nomProduto;
    },
    setCliente: function setCliente(hit) {
      this.filtro.idCliente = hit.id;
      this.filtro.cliente = hit.nomCliente;
    },
    setUnidadeNegocio: function setUnidadeNegocio(hit, row) {
      this.dependenciaUnidadeNegocio = {
        idUnidadeNegocio: hit.id,
        nomExtensao: hit.nomExtensao,
        unidadeNegocio: hit.nomExtensao
      };
      this.updateItemDependency(row, 'dependencias', this.dependenciaUnidadeNegocio);
    },
    clickHandler: function clickHandler(pagina) {
      this.indexPagina = pagina - 1;
      this.$emit('DASH_APURACAO_TABELA_PAGINA', this.filtro, pagina);
    },
    refazPaginacao: function refazPaginacao() {
      this.indexPagina = 0;
    }
  },
  mounted: function mounted() {
    this.filtroCopy = this.filtro;
  }
};

/***/ }),
/* 466 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 467 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardPagamento_vue_vue_type_script_lang_js___ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardPagamento_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardPagamento_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardPagamento_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardPagamento_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardPagamento_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(4);

var _assign2 = _interopRequireDefault(_assign);

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

var _PagamentosSolicitadosTabelaDash = __webpack_require__(1245);

var _PagamentosSolicitadosTabelaDash2 = _interopRequireDefault(_PagamentosSolicitadosTabelaDash);

var _PagamentosAprovacoesTabelaDash = __webpack_require__(1255);

var _PagamentosAprovacoesTabelaDash2 = _interopRequireDefault(_PagamentosAprovacoesTabelaDash);

var _pagamento = __webpack_require__(1260);

var _pagamento2 = _interopRequireDefault(_pagamento);

var _BoxValoresPagamentos = __webpack_require__(1261);

var _BoxValoresPagamentos2 = _interopRequireDefault(_BoxValoresPagamentos);

var _ValoresPagamentos = __webpack_require__(486);

var _ValoresPagamentos2 = _interopRequireDefault(_ValoresPagamentos);

var _loading = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'DashboardPagamento',
  mixins: [_pagamento2.default],
  data: function data() {
    return {
      filtros: {},
      carregado: false,
      carregandoBox: false,
      carregandoTable: false,
      bloquearConsulta: false,
      paginas: 0
    };
  },

  components: {
    PagamentosSolicitadosTabela: _PagamentosSolicitadosTabelaDash2.default,
    PagamentosAprovacoesTabela: _PagamentosAprovacoesTabelaDash2.default,
    BoxValoresPagamentos: _BoxValoresPagamentos2.default
  },
  methods: {
    organizar: function organizar(ordenacao) {
      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      sortTableColumn(source || this.negociacoes, ordenacao);
    },
    refreshData: function refreshData() {
      this.$refs.pagamentoTabela.refazPaginacao();
      if (this.periodo) {
        this.filtros.periodo = String(this.periodo).replace('/', '').replace(/^(\d{2})(\d{4})/, '$2$1');
      } else {
        delete this.filtros.periodo;
      }
      if (this.idUnidadeNegocio) {
        this.filtros.idUnidadeNegocio = this.idUnidadeNegocio;
      } else {
        delete this.filtros.idUnidadeNegocio;
      }

      this.requestCarregarConsolidadoPagamento();
      this.requestCarregarPagamentosAprovacoes();
    },
    requestCarregarConsolidadoPagamento: function requestCarregarConsolidadoPagamento() {
      var _this = this;

      (0, _loading.skipLoading)();
      this.carregandoBox = true;
      this.dashboardPagamentoResources.listarDash(this.filtros).then(function (response) {
        _this.carregandoBox = false;
        _this.valoresPagamentos = new _ValoresPagamentos2.default(response.data);
      }).catch(function (err) {
        _this.$toast.create(_this.$t(err), 'snack', 3E3);
        _this.carregandoBox = false;
      });
      return this;
    },
    requestCargaPeriodos: function requestCargaPeriodos() {
      var _this2 = this;

      return new _promise2.default(function (resolve, reject) {
        (0, _loading.skipLoading)();
        _this2.dashboardPagamentoResources.listarPeriodos().then(function (response) {
          _this2.periodos = response.data;
          resolve();
        }).catch(reject);
      });
    },
    requestGetUnidadesNegocio: function requestGetUnidadesNegocio() {
      var _this3 = this;

      return new _promise2.default(function (resolve, reject) {
        (0, _loading.skipLoading)();
        _this3.usuarioUnidadeNegocioResources.listarAtivos().then(function (response) {
          _this3.unidadesNegocio = response.data;
          resolve();
        }).catch(reject);
      });
    },
    filtrarFluxos: function filtrarFluxos(filtro) {
      this.$refs.pagamentoTabela.refazPaginacao();
      this.requestCarregarPagamentosAprovacoes(filtro);
    },
    requestCarregarPagamentosAprovacoes: function requestCarregarPagamentosAprovacoes() {
      var filtros = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _this4 = this;

      var pagina = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var cb = arguments[2];

      this.bloquearConsulta = true;
      var merged = (0, _assign2.default)(this.filtros, filtros);

      (0, _loading.skipLoading)();
      this.carregandoTable = true;

      merged.tamanhoPagina = 20;
      merged.numeroPagina = pagina;

      this.dashboardPagamentoResources.listarPagamentosAprovacoes(merged).then(function (response) {
        _this4.bloquearConsulta = false;
        _this4.pagamentosAprovacoes = response.data.resposta;
        var qtdeRegistros = response.data.quantidadeRegistrosPagina;
        _this4.paginas = Math.ceil(qtdeRegistros / merged.tamanhoPagina);
        _this4.carregandoTable = false;
        if (cb) {
          cb();
        }
      }).catch(function (err) {
        _this4.bloquearConsulta = false;
        _this4.$toast.create(_this4.$t(err), 'snack', 3E3);
        _this4.carregandoTable = false;
      });
    },
    abreCarrega: function abreCarrega() {
      var _this5 = this;

      if (this.carregado) {
        return;
      }

      window.setTimeout(function () {
        _this5.requestCargaPeriodos().then(_this5.requestGetUnidadesNegocio).then(function () {
          _this5.carregado = true;
          _this5.requestCarregarConsolidadoPagamento();
          _this5.requestCarregarPagamentosAprovacoes();
        }).catch(function (err) {
          _this5.$toast.create(_this5.$t(err), 'snack', 3E3);
        });
      });
    }
  }
};

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_PagamentosSolicitadosTabelaDash_vue_vue_type_script_lang_js___ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_PagamentosSolicitadosTabelaDash_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_PagamentosSolicitadosTabelaDash_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_PagamentosSolicitadosTabelaDash_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_PagamentosSolicitadosTabelaDash_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_PagamentosSolicitadosTabelaDash_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TabelaGenerica = __webpack_require__(20);

var _TabelaGenerica2 = _interopRequireDefault(_TabelaGenerica);

var _mdAutocomplete = __webpack_require__(16);

var _mdAutocomplete2 = _interopRequireDefault(_mdAutocomplete);

var _FiltrosDashPagamento = __webpack_require__(472);

var _FiltrosDashPagamento2 = _interopRequireDefault(_FiltrosDashPagamento);

var _RateioModal = __webpack_require__(476);

var _RateioModal2 = _interopRequireDefault(_RateioModal);

var _helpers = __webpack_require__(5);

var _http = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  extends: _TabelaGenerica2.default,
  props: {
    contrato: Object
  },
  data: function data() {
    return {
      workflowPassosResources: this.$api.workflowPassos(this.$resource),
      pagamentoResources: this.$api.pagamentoGestao(this.$resource),
      dashboardPagamentoResources: this.$api.dashboardPagamento(this.$resource),
      canPost: false,
      somenteLeitura: false,
      nomContato: '',
      hasFilter: false,
      itemSelecionado: null,
      justificativa: '',
      justificativaGrid: 'Sem justificativa.',
      filtro: {
        status: 'AGUARDANDO_APROVACAO'
      },
      filtroCopy: {},
      statusOpcoes: [{ status: 'AGUARDANDO_APROVACAO', descricao: this.$t('status_entidade.aguardando_aprovacao') }, { status: 'APROVADO', descricao: this.$tc('status_entidade.aprovado', 1) }, { status: 'REPROVADO', descricao: this.$tc('status_entidade.reprovado', 1) }, { status: 'EM_FLUXO', descricao: this.$tc('status_entidade.em_fluxo', 1) }, { status: 'EM_ANALISE', descricao: this.$tc('status_entidade.em_analise', 1) }, { status: 'AGUARDANDO_PAGAMENTO', descricao: this.$tc('status_entidade.aguardando_pagamento', 1) }, { status: 'CANCELADO', descricao: this.$tc('status_entidade.cancelado', 1) }, { status: 'TRANSFERIDO', descricao: this.$tc('status_entidade.transferido', 1) }, { status: 'CONDICAO_NAO_ATENDIDA', descricao: this.$tc('status_entidade.condicao_nao_atendida', 1) }],
      tableRowsRateio: [],
      tableHeaderRateio: [{
        name: this.$tc('label.cod_produto', 1),
        sortType: 'codigo_produto',
        classes: []
      }, {
        name: this.$tc('label.desc_produto', 1),
        sortType: 'nom_produto',
        classes: []
      }, {
        name: this.$tc('label.valor', 1),
        sortType: 'valor',
        classes: ['']
      }, {
        name: this.$tc('label.composicao', 1),
        sortType: 'composicao',
        classes: ['']
      }]
    };
  },

  computed: {
    hasSingleRowSelected: function hasSingleRowSelected() {
      return this.selected && this.selected.length === 1;
    }
  },
  components: {
    mdAutocomplete: _mdAutocomplete2.default,
    FiltrosDash: _FiltrosDashPagamento2.default,
    RateioModal: _RateioModal2.default
  },
  methods: {
    prepareResponseData: _http.prepareResponseData,
    getMoney: _helpers.getMoney,
    clickOnRow: function clickOnRow() {
      var row = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var index = arguments[1];

      this.$emit('ACORDOTABELA_CLICK_LINHA', this.contrato, row, index);
    },
    defaultClose: function defaultClose() {
      this.requestCleanFiltro();
      this.getLimpaReferenciasJustificativa();
      this.requestRefreshFilteredList();
      this.$refs.modal.close();
    },
    getLimpaReferenciasJustificativa: function getLimpaReferenciasJustificativa() {
      this.$refs.inputJustificativaAnalise.hasValue = false;
      this.$refs.inputJustificativaAnalise.inputLength = 0;
      this.$refs.inputJustificativaAprovar.hasValue = false;
      this.$refs.inputJustificativaAprovar.inputLength = 0;
      this.$refs.inputJustificativaReprovar.hasValue = false;
      this.$refs.inputJustificativaReprovar.inputLength = 0;
      this.$forceUpdate();
    },
    requestFecharModaisDefault: function requestFecharModaisDefault() {
      this.$refs.modalReprovar.close();
      this.$refs.modalAnalise.close();
      this.$refs.modalAprovar.close();
      this.$refs.modalComentario.close();
      this.justificativa = '';
    },
    requestRefreshFilteredList: function requestRefreshFilteredList() {
      this.$emit('ACORDOTABELA_REFRESH');
    },
    filtrarModal: function filtrarModal(filtro) {
      this.filtro = filtro;
      this.requestBuscarNegociacoesFilter();
    },
    requestCleanFiltro: function requestCleanFiltro() {
      this.filtro.tipoAcordo = '';
      this.filtro.status = '';
      this.filtro.tipoLinhaOrcamento = '';
      this.filtro.marca = '';
      this.filtro.linhaProduto = '';
      this.filtro.familia = '';
      this.filtro.produto = '';
      this.filtro.cliente = '';
      this.justificativa = '';

      if (this.filtro.idCliente) {
        delete this.filtro.idCliente;
      }
      if (this.filtro.idExtensao) {
        delete this.filtro.idExtensao;
      }
      if (this.filtro.idLinhaProduto) {
        delete this.filtro.idLinhaProduto;
      }
      if (this.filtro.idMarca) {
        delete this.filtro.idMarca;
      }
      if (this.filtro.idProduto) {
        delete this.filtro.idProduto;
      }
      if (this.filtro.idTipoLinhaOrcamento) {
        delete this.filtro.idTipoLinhaOrcamento;
      }
    },
    requestVoltarTelaInicial: function requestVoltarTelaInicial() {
      this.$refs.modal.close();
    },
    requestModalEnviarNegociacaoAnalise: function requestModalEnviarNegociacaoAnalise(row) {
      this.getLimpaReferenciasJustificativa();
      this.$refs.modalAnalise.open();
      this.itemSelecionado = row;
    },
    requestModalAprovarPassoNegociacao: function requestModalAprovarPassoNegociacao(row) {
      this.getLimpaReferenciasJustificativa();
      this.$refs.modalAprovar.open();
      this.itemSelecionado = row;
    },
    requestModalComentarioOpcional: function requestModalComentarioOpcional(row) {
      this.getLimpaReferenciasJustificativa();
      this.$refs.modalComentario.open();
      this.itemSelecionado = row;
    },
    requestModalReprovarApuracaoNegociacao: function requestModalReprovarApuracaoNegociacao(row) {
      this.getLimpaReferenciasJustificativa();
      this.$refs.modalReprovar.open();
      this.itemSelecionado = row;
    },
    requestAprovarPassosFluxoAcordo: function requestAprovarPassosFluxoAcordo() {
      var _this = this;

      var item = this.itemSelecionado;
      this.workflowPassosResources.aprovarPassosAcordo({ idAcordo: item.id }, { observacao: this.justificativa }).then(function () {
        _this.requestFecharModaisDefault();
      }).catch(function (err) {
        _this.$error(_this, err);
      });
    },
    requestEnviarNegociacaoParaAnalise: function requestEnviarNegociacaoParaAnalise() {
      var _this2 = this;

      var item = this.itemSelecionado;
      this.workflowPassosResources.enviarAcordoAnalise({ idAcordo: item.id }, { observacao: this.justificativa }).then(function () {
        _this2.requestFecharModaisDefault();
      }).catch(function (err) {
        _this2.$error(_this2, err);
      });
    },
    requestRateio: function requestRateio(id) {
      var _this3 = this;

      this.dashboardPagamentoResources.listarRateio({ id: id }).then(function (response) {
        _this3.tableRowsRateio = response.data;
        _this3.$refs.dialogRateio.open();
      });
    },
    requestReprovarPassosNegociacao: function requestReprovarPassosNegociacao() {
      var _this4 = this;

      var item = this.itemSelecionado;
      this.workflowPassosResources.reprovarAcordo({ idAcordo: item.id }, { observacao: this.justificativa }).then(function () {
        _this4.requestFecharModaisDefault();
      }).catch(function (err) {
        _this4.$error(_this4, err);
      });
    },
    requestBuscarNegociacoesFilter: function requestBuscarNegociacoesFilter() {
      this.$emit('ACORDOTABELA_FILTER', this.filtro, this.requestVoltarTelaInicial);
    },
    requestCancelarPagamento: function requestCancelarPagamento(row) {
      var _this5 = this;

      var id = row.id;
      var ids = [id];
      this.pagamentoResources.cancelar({ ids: ids }).then(function () {
        _this5.$emit('ACORDOTABELA_FILTER', _this5.filtro, _this5.requestVoltarTelaInicial);
      });
    },
    setTipoInvestimentoOrcamento: function setTipoInvestimentoOrcamento(hit) {
      this.filtro.idTipoLinhaOrcamento = hit.id;
      this.filtro.tipoLinhaOrcamento = hit.descTipoOrcamento;
    },
    setMarca: function setMarca(hit) {
      this.filtro.idExtensao = hit.id;
      this.filtro.marca = hit.nomExtensao;
    },
    setFamilia: function setFamilia(hit) {
      this.filtro.idMarca = hit.id;
      this.filtro.familia = hit.nomExtensao;
    },
    setLinhaProduto: function setLinhaProduto(hit) {
      this.filtro.idLinhaProduto = hit.id;
      this.filtro.linhaProduto = hit.nomExtensao;
    },
    setProduto: function setProduto(hit) {
      this.filtro.idProduto = hit.id;
      this.filtro.produto = hit.nomProduto;
    },
    setCliente: function setCliente(hit) {
      this.filtro.idCliente = hit.id;
      this.filtro.cliente = hit.nomCliente;
    },
    setUnidadeNegocio: function setUnidadeNegocio(hit, row) {
      this.dependenciaUnidadeNegocio = {
        idUnidadeNegocio: hit.id,
        nomExtensao: hit.nomExtensao,
        unidadeNegocio: hit.nomExtensao
      };
      this.updateItemDependency(row, 'dependencias', this.dependenciaUnidadeNegocio);
    },
    showJustificativa: function showJustificativa(row) {
      this.justificativa = row.justificativa;
      this.$refs.dialogJustificativa.open();
    }
  },
  mounted: function mounted() {
    this.filtroCopy = this.filtro;
  }
};

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FiltrosDashPagamento_vue_vue_type_template_id_0dbbbf7c___ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FiltrosDashPagamento_vue_vue_type_script_lang_js___ = __webpack_require__(473);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__FiltrosDashPagamento_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__FiltrosDashPagamento_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FiltrosDashPagamento_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__FiltrosDashPagamento_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__FiltrosDashPagamento_vue_vue_type_template_id_0dbbbf7c___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__FiltrosDashPagamento_vue_vue_type_template_id_0dbbbf7c___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosDashPagamento_vue_vue_type_script_lang_js___ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosDashPagamento_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosDashPagamento_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosDashPagamento_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosDashPagamento_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosDashPagamento_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(4);

var _assign2 = _interopRequireDefault(_assign);

var _mdAutocomplete = __webpack_require__(16);

var _mdAutocomplete2 = _interopRequireDefault(_mdAutocomplete);

var _http = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    filtro: Object,
    mdOpenFrom: String,
    statusOpcoes: {
      type: Array,
      default: null
    }
  },
  data: function data() {
    return {
      acordoResources: this.$api.acordo(this.$resource),
      tipoInvestimentoResources: this.$api.tipoInvestimento(this.$resource),
      dashboardPagamentoResources: this.$api.dashboardPagamento(this.$resource),
      clienteResources: this.$api.cliente(this.$resource),
      produtoResources: this.$api.produto(this.$resource),
      obj: {}
    };
  },

  computed: {},
  components: {
    mdAutocomplete: _mdAutocomplete2.default
  },
  methods: {
    prepareResponseData: _http.prepareResponseData,
    setMarca: function setMarca(hit) {
      this.filtro.idMarca = hit.id;
    },
    setTipoLinhaOrcamento: function setTipoLinhaOrcamento(hit) {
      this.filtro.idTipoLinhaOrcamento = hit.id;
    },
    setLinhaProduto: function setLinhaProduto(hit) {
      this.filtro.idLinhaProduto = hit.id;
    },
    setFamilia: function setFamilia(hit) {
      this.filtro.idFamilia = hit.id;
    },
    setProduto: function setProduto(hit) {
      this.filtro.idProduto = hit.id;
    },
    setCliente: function setCliente(hit) {
      this.filtro.idCliente = hit.id;
    },
    setTipoAcordo: function setTipoAcordo(hit) {
      this.filtro.idTipoAcordo = hit.id;
    },
    setSolicitante: function setSolicitante(hit) {
      this.filtro.idSolicitante = hit.id;
    },
    open: function open() {
      this.$refs.modal.open();
      this.onOpen();
    },
    defaultClose: function defaultClose() {
      this.$emit('GENERICMODAL_DEFAULT_CLOSE');
      this.close();
    },
    onOpen: function onOpen() {
      this.$emit('GENERICMODAL_OPEN');
    },
    onClose: function onClose() {
      this.$emit('GENERICMODAL_CLOSE');
    },
    close: function close() {
      this.$refs.modal.close();
      this.onClose();
    },
    filtrar: function filtrar() {
      var copiaFiltro = (0, _assign2.default)({}, this.filtro);
      (0, _http.removeParametrosNulos)(copiaFiltro);
      this.$emit('FILTROSDASH_FILTRAR', copiaFiltro);
      this.defaultClose();
    }
  }
};

/***/ }),
/* 475 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RateioModal_vue_vue_type_template_id_e052a14e_lang_html___ = __webpack_require__(1251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RateioModal_vue_vue_type_script_lang_js___ = __webpack_require__(477);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__RateioModal_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__RateioModal_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RateioModal_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__RateioModal_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__RateioModal_vue_vue_type_template_id_e052a14e_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__RateioModal_vue_vue_type_template_id_e052a14e_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_RateioModal_vue_vue_type_script_lang_js___ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_RateioModal_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_RateioModal_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_RateioModal_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_RateioModal_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_RateioModal_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TabelaGenerica = __webpack_require__(20);

var _TabelaGenerica2 = _interopRequireDefault(_TabelaGenerica);

var _helpers = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  extends: _TabelaGenerica2.default,
  props: {
    mdOpenFrom: String
  },
  methods: {
    defaultClose: function defaultClose() {
      this.$emit('GENERICMODAL_DEFAULT_CLOSE');
      this.close();
    },
    getMoney: function getMoney(str) {
      str = (0, _helpers.convertFloatToMoney)(String(str));
      str = str.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var money = str.split('.');
      return money[0].replace(/,/g, '.') + ',' + money[1];
    },
    open: function open() {
      this.$refs.dialogRateio.open();
      this.onOpen();
    },
    onOpen: function onOpen() {
      this.$emit('GENERICMODAL_OPEN');
    },
    onClose: function onClose() {
      this.$emit('GENERICMODAL_CLOSE');
    },
    close: function close() {
      this.$refs.dialogRateio.close();
      this.onClose();
    }
  }
};

/***/ }),
/* 479 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 480 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_PagamentosAprovacoesTabelaDash_vue_vue_type_script_lang_js___ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_PagamentosAprovacoesTabelaDash_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_PagamentosAprovacoesTabelaDash_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_PagamentosAprovacoesTabelaDash_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_PagamentosAprovacoesTabelaDash_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_PagamentosAprovacoesTabelaDash_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(9);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _vuejsPaginate = __webpack_require__(27);

var _vuejsPaginate2 = _interopRequireDefault(_vuejsPaginate);

var _TabelaGenerica = __webpack_require__(20);

var _TabelaGenerica2 = _interopRequireDefault(_TabelaGenerica);

var _mdAutocomplete = __webpack_require__(16);

var _mdAutocomplete2 = _interopRequireDefault(_mdAutocomplete);

var _FiltrosDashPagamento = __webpack_require__(472);

var _FiltrosDashPagamento2 = _interopRequireDefault(_FiltrosDashPagamento);

var _RateioModal = __webpack_require__(476);

var _RateioModal2 = _interopRequireDefault(_RateioModal);

var _passos = __webpack_require__(1258);

var _passos2 = _interopRequireDefault(_passos);

var _helpers = __webpack_require__(5);

var _http = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  extends: _TabelaGenerica2.default,
  mixins: [_passos2.default],
  props: {
    contrato: Object,
    carregando: Boolean,
    paginas: Number,
    bloquearConsulta: Boolean
  },
  data: function data() {
    return {
      workflowPassosResources: this.$api.workflowPassos(this.$resource),
      pagamentoResources: this.$api.pagamentoGestao(this.$resource),
      dashboardPagamentoResources: this.$api.dashboardPagamento(this.$resource),
      canPost: false,
      somenteLeitura: false,
      nomContato: '',
      hasFilter: false,
      indexPagina: 0,
      itemSelecionado: null,
      justificativa: '',
      objetosSelecionados: [],
      justificativaGrid: 'Sem justificativa.',
      filtro: {
        status: 'AGUARDANDO_APROVACAO'
      },
      filtroCopy: {},
      statusOpcoes: [{ status: 'AGUARDANDO_APROVACAO', descricao: this.$t('status_entidade.aguardando_aprovacao') }, { status: 'APROVADO', descricao: this.$tc('status_entidade.aprovado', 1) }, { status: 'REPROVADO', descricao: this.$tc('status_entidade.reprovado', 1) }, { status: 'EM_FLUXO', descricao: this.$tc('status_entidade.em_fluxo', 1) }, { status: 'AGUARDANDO_PAGAMENTO', descricao: this.$tc('status_entidade.aguardando_pagamento', 1) }, { status: 'CANCELADO', descricao: this.$tc('status_entidade.cancelado', 1) }, { status: 'TRANSFERIDO', descricao: this.$tc('status_entidade.transferido', 1) }, { status: 'CONDICAO_NAO_ATENDIDA', descricao: this.$tc('status_entidade.condicao_nao_atendida', 1) }],
      tableRowsRateio: [],
      tableHeaderRateio: [{
        name: this.$tc('label.cod_produto', 1),
        sortType: 'codigo_produto',
        classes: []
      }, {
        name: this.$tc('label.desc_produto', 1),
        sortType: 'nom_produto',
        classes: []
      }, {
        name: this.$tc('label.valor', 1),
        sortType: 'valor',
        classes: ['']
      }, {
        name: this.$tc('label.composicao', 1),
        sortType: 'composicao',
        classes: ['']
      }]
    };
  },

  computed: {
    hasSingleRowSelected: function hasSingleRowSelected() {
      return this.selected && this.selected.length === 1;
    }
  },
  components: {
    mdAutocomplete: _mdAutocomplete2.default,
    FiltrosDash: _FiltrosDashPagamento2.default,
    RateioModal: _RateioModal2.default,
    Paginate: _vuejsPaginate2.default
  },
  methods: {
    prepareResponseData: _http.prepareResponseData,
    getMoney: _helpers.getMoney,
    toggleSelecaoGeral: function toggleSelecaoGeral(selecao) {
      this.filteredList.forEach(function (item) {
        item.selecionado = selecao;
      });
      this.objetosSelecionados = !selecao ? [] : [].concat((0, _toConsumableArray3.default)(this.filteredList));
    },
    toggleSelecaoUnica: function toggleSelecaoUnica(row) {
      var _this = this;

      setTimeout(function () {
        var selecao = row.selecionado;
        if (selecao) {
          _this.objetosSelecionados.push(row);
          return;
        }

        var indexO = null;
        _this.objetosSelecionados.forEach(function (obj, index) {
          if (obj.idWorkflow === row.idWorkflow) {
            indexO = index;
          }
        });
        _this.objetosSelecionados.splice(indexO, 1);
      });
    },
    clickOnRow: function clickOnRow() {
      var row = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var index = arguments[1];

      this.$emit('ACORDOTABELA_CLICK_LINHA', this.contrato, row, index);
    },
    clickHandler: function clickHandler(pagina) {
      this.indexPagina = pagina - 1;
      this.$emit('DASH_PAGAMENTO_TABELA_PAGINA', this.filtro, pagina);
    },
    refazPaginacao: function refazPaginacao() {
      this.indexPagina = 0;
    },
    exibirModalAcompanhamentoDoPagamento: function exibirModalAcompanhamentoDoPagamento(row) {
      this.identificador = 'Pagamento';
      this.showPagamentoTimeline({ id: row.id });
    },
    defaultClose: function defaultClose() {
      this.requestCleanFiltro();
      this.getLimpaReferenciasJustificativa();
      this.requestRefreshFilteredList();
      this.$refs.modal.close();
    },
    getLimpaReferenciasJustificativa: function getLimpaReferenciasJustificativa() {
      this.$refs.inputJustificativaAprovar.hasValue = false;
      this.$refs.inputJustificativaAprovar.inputLength = 0;
      this.$refs.inputJustificativaReprovar.hasValue = false;
      this.$refs.inputJustificativaReprovar.inputLength = 0;
      this.$forceUpdate();
    },
    requestFecharModaisDefault: function requestFecharModaisDefault() {
      this.$refs.modalReprovar.close();
      this.$refs.modalAprovar.close();
      this.$refs.modalComentario.close();
      this.justificativa = '';
    },
    requestRefreshFilteredList: function requestRefreshFilteredList() {
      this.$emit('PAGAMENTOTABELA_REFRESH');
    },
    filtrarModal: function filtrarModal(filtro) {
      this.filtro = filtro;
      this.requestBuscarNegociacoesFilter();
    },
    requestCleanFiltro: function requestCleanFiltro() {
      this.filtro.tipoAcordo = '';
      this.filtro.status = '';
      this.filtro.tipoLinhaOrcamento = '';
      this.filtro.marca = '';
      this.filtro.linhaProduto = '';
      this.filtro.familia = '';
      this.filtro.produto = '';
      this.filtro.cliente = '';
      this.justificativa = '';

      if (this.filtro.idCliente) {
        delete this.filtro.idCliente;
      }
      if (this.filtro.idExtensao) {
        delete this.filtro.idExtensao;
      }
      if (this.filtro.idLinhaProduto) {
        delete this.filtro.idLinhaProduto;
      }
      if (this.filtro.idMarca) {
        delete this.filtro.idMarca;
      }
      if (this.filtro.idProduto) {
        delete this.filtro.idProduto;
      }
      if (this.filtro.idTipoLinhaOrcamento) {
        delete this.filtro.idTipoLinhaOrcamento;
      }
    },
    requestVoltarTelaInicial: function requestVoltarTelaInicial() {
      this.$refs.modal.close();
    },
    requestRateio: function requestRateio(id) {
      var _this2 = this;

      this.dashboardPagamentoResources.listarRateio({ id: id }).then(function (response) {
        _this2.tableRowsRateio = response.data;
        _this2.$refs.dialogRateio.open();
      });
    },
    requestModalAprovarPassoPagamento: function requestModalAprovarPassoPagamento(row) {
      this.getLimpaReferenciasJustificativa();
      this.$refs.modalAprovar.open();
      this.itemSelecionado = row;
    },
    requestModalComentarioOpcional: function requestModalComentarioOpcional(row) {
      this.getLimpaReferenciasJustificativa();
      this.$refs.modalComentario.open();
      this.itemSelecionado = row;
    },
    requestModalReprovarPassoPagamento: function requestModalReprovarPassoPagamento(row) {
      this.getLimpaReferenciasJustificativa();
      this.$refs.modalReprovar.open();
      this.itemSelecionado = row;
    },
    requestAprovarPassosFluxo: function requestAprovarPassosFluxo() {
      var _this3 = this;

      var item = this.itemSelecionado;
      this.workflowPassosResources.aprovarPassosPagamento({ id: item.id }, { observacao: this.justificativa }).then(function () {
        _this3.requestFecharModaisDefault();
        _this3.requestRefreshFilteredList();
      }).catch(function (err) {
        _this3.$error(_this3, err);
      });
    },
    requestReprovarPagamento: function requestReprovarPagamento() {
      var _this4 = this;

      var item = this.itemSelecionado;
      this.workflowPassosResources.reprovarPassosPagamento({ id: item.id }, { observacao: this.justificativa }).then(function () {
        _this4.requestFecharModaisDefault();
      }).catch(function (err) {
        _this4.$error(_this4, err);
      });
    },
    requestBuscarNegociacoesFilter: function requestBuscarNegociacoesFilter() {
      this.$emit('PAGAMENTOTABELA_FILTER', this.filtro, this.requestVoltarTelaInicial);
    },
    requestCancelarPagamento: function requestCancelarPagamento(row) {
      var _this5 = this;

      var id = row.id;
      var ids = [id];
      this.pagamentoResources.cancelar({ ids: ids }).then(function () {
        _this5.$emit('PAGAMENTOTABELA_FILTER', _this5.filtro, _this5.requestVoltarTelaInicial);
      });
    },
    setTipoInvestimentoOrcamento: function setTipoInvestimentoOrcamento(hit) {
      this.filtro.idTipoLinhaOrcamento = hit.id;
      this.filtro.tipoLinhaOrcamento = hit.descTipoOrcamento;
    },
    setMarca: function setMarca(hit) {
      this.filtro.idExtensao = hit.id;
      this.filtro.marca = hit.nomExtensao;
    },
    setFamilia: function setFamilia(hit) {
      this.filtro.idMarca = hit.id;
      this.filtro.familia = hit.nomExtensao;
    },
    setLinhaProduto: function setLinhaProduto(hit) {
      this.filtro.idLinhaProduto = hit.id;
      this.filtro.linhaProduto = hit.nomExtensao;
    },
    setProduto: function setProduto(hit) {
      this.filtro.idProduto = hit.id;
      this.filtro.produto = hit.nomProduto;
    },
    setCliente: function setCliente(hit) {
      this.filtro.idCliente = hit.id;
      this.filtro.cliente = hit.nomCliente;
    },
    setUnidadeNegocio: function setUnidadeNegocio(hit, row) {
      this.dependenciaUnidadeNegocio = {
        idUnidadeNegocio: hit.id,
        nomExtensao: hit.nomExtensao,
        unidadeNegocio: hit.nomExtensao
      };
      this.updateItemDependency(row, 'dependencias', this.dependenciaUnidadeNegocio);
    },
    showJustificativa: function showJustificativa(row) {
      this.justificativa = row.justificativa;
      this.$refs.dialogJustificativa.open();
    }
  },
  mounted: function mounted() {
    this.filtroCopy = this.filtro;
  }
};

/***/ }),
/* 483 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_BoxValoresPagamentos_vue_vue_type_script_lang_js___ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_BoxValoresPagamentos_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_BoxValoresPagamentos_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_BoxValoresPagamentos_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_BoxValoresPagamentos_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_BoxValoresPagamentos_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ValoresPagamentos = __webpack_require__(486);

var _ValoresPagamentos2 = _interopRequireDefault(_ValoresPagamentos);

var _helpers = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    valoresPagamentos: {
      type: _ValoresPagamentos2.default,
      default: new _ValoresPagamentos2.default({})
    },
    carregando: Boolean
  },
  methods: {
    getMoney: _helpers.getMoney
  }
};

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(29);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ValoresPagamentos = function ValoresPagamentos(data) {
  (0, _classCallCheck3.default)(this, ValoresPagamentos);

  this.vlrAguardandoPagamento = data.vlrAguardandoPagamento;
  this.vlrBloqueado = data.vlrBloqueado;
  this.vlrLiquidado = data.vlrLiquidado;
};

exports.default = ValoresPagamentos;

/***/ }),
/* 487 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 488 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardAcompanhamento_vue_vue_type_script_lang_js___ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardAcompanhamento_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardAcompanhamento_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardAcompanhamento_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardAcompanhamento_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardAcompanhamento_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(4);

var _assign2 = _interopRequireDefault(_assign);

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

var _helpers = __webpack_require__(5);

var _loading = __webpack_require__(14);

var _ExecucaoModal = __webpack_require__(1269);

var _ExecucaoModal2 = _interopRequireDefault(_ExecucaoModal);

var _ApuracaoFinalizadaTabela = __webpack_require__(1272);

var _ApuracaoFinalizadaTabela2 = _interopRequireDefault(_ApuracaoFinalizadaTabela);

var _ApuracaoPendentesTabela = __webpack_require__(1275);

var _ApuracaoPendentesTabela2 = _interopRequireDefault(_ApuracaoPendentesTabela);

var _NegociacoesAguardandoAprovacao = __webpack_require__(1278);

var _NegociacoesAguardandoAprovacao2 = _interopRequireDefault(_NegociacoesAguardandoAprovacao);

var _PagamentosLiquidadosTabela = __webpack_require__(1282);

var _PagamentosLiquidadosTabela2 = _interopRequireDefault(_PagamentosLiquidadosTabela);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    ApuracaoFinalizadaTabela: _ApuracaoFinalizadaTabela2.default,
    ApuracaoPendentesTabela: _ApuracaoPendentesTabela2.default,
    NegociacoesAguardandoAprovacao: _NegociacoesAguardandoAprovacao2.default,
    ExecucaoModal: _ExecucaoModal2.default,
    PagamentosLiquidadosTabela: _PagamentosLiquidadosTabela2.default
  },
  props: {
    parametros: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      dashboardPagamentoResources: this.$api.dashboardPagamento(this.$resource),
      dashboardApuracaoResources: this.$api.dashboardApuracao(this.$resource),
      dashboardNegociacaoResources: this.$api.dashboardNegociacao(this.$resource),

      limit: 5,
      filtros: {},
      competencia: null,
      cacheFiltros: {
        pendentes: {
          status: 'EM_PROCESSO_APURACAO'
        },
        finalizadas: {
          status: 'AGUARDANDO_PAGAMENTO'
        }
      },

      consolidado: {},
      competenciasPagamento: [],
      apuracoesFinalizadas: [],
      apuracoesPendentes: [],
      negociacoesAgAprovacao: [],

      paginasApuracoesFinalizadas: 0,
      paginasApuracoesPendentes: 0,
      paginasNegociacoesAgAprovacao: 0,

      carregado: false,
      carregandoBox: false,
      carregandoFinalizadas: false,
      carregandoPendentes: false,
      carregandoAgAprovacao: false
    };
  },

  methods: {
    getMoney: _helpers.getMoney,
    requestCarregarPeriodos: function requestCarregarPeriodos() {
      var _this = this;

      return new _promise2.default(function (resolve, reject) {
        (0, _loading.skipLoading)();
        _this.dashboardNegociacaoResources.periodosCliente().then(function (response) {
          _this.competenciasPagamento = response.data;
          if (_this.competenciasPagamento.length === 0) {
            return;
          }
          _this.competencia = _this.competenciasPagamento[0].valor;
          _this.filtros.competencia = _this.competencia;
          resolve();
        }).catch(reject);
      });
    },
    requestCarregarConsolidadoPagamento: function requestCarregarConsolidadoPagamento() {
      var _this2 = this;

      if (!this.competencia) {
        return;
      }
      (0, _loading.skipLoading)();
      this.carregandoBox = true;
      this.dashboardPagamentoResources.consolidadoCliente(this.filtros).then(function (response) {
        _this2.carregandoBox = false;
        _this2.consolidado = response.data;
      }).catch(function (err) {
        _this2.$toast.create(_this2.$t(err), 'snack', 3E3);
        _this2.carregandoBox = false;
      });
    },
    requestCarregarApuracoesFinalizadas: function requestCarregarApuracoesFinalizadas() {
      var _this3 = this;

      var pagina = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (!this.competencia) {
        return;
      }
      (0, _loading.skipLoading)();
      this.carregandoFinalizadas = true;

      if (status !== null) {
        this.cacheFiltros.finalizadas.status = status;
      }

      var mesclado = (0, _assign2.default)(this.cacheFiltros.finalizadas, this.filtros);
      mesclado.numeroPagina = pagina;
      mesclado.tamanhoPagina = this.limit;

      this.dashboardApuracaoResources.apuracoesFinalizadas(mesclado).then(function (response) {
        var data = response.data;

        _this3.carregandoFinalizadas = false;
        _this3.apuracoesFinalizadas = data.resposta;

        var qtdeRegistros = data.quantidadeRegistrosPagina;
        _this3.paginasApuracoesFinalizadas = Math.ceil(qtdeRegistros / _this3.limit);
      }).catch(function (err) {
        _this3.$toast.create(_this3.$t(err), 'snack', 3E3);
        _this3.carregandoFinalizadas = false;
      });
    },
    requestCarregarApuracoesPendentes: function requestCarregarApuracoesPendentes() {
      var _this4 = this;

      var pagina = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (!this.competencia) {
        return;
      }
      (0, _loading.skipLoading)();
      this.carregandoPendentes = true;

      if (status !== null) {
        this.cacheFiltros.pendentes.status = status;
      }

      var mesclado = (0, _assign2.default)(this.cacheFiltros.pendentes, this.filtros);
      mesclado.numeroPagina = pagina;
      mesclado.tamanhoPagina = this.limit;

      this.dashboardApuracaoResources.apuracoesPendentes(mesclado).then(function (response) {
        var data = response.data;

        _this4.carregandoPendentes = false;
        _this4.apuracoesPendentes = data.resposta;

        var qtdeRegistros = data.quantidadeRegistrosPagina;
        _this4.paginasApuracoesPendentes = Math.ceil(qtdeRegistros / _this4.limit);
      }).catch(function (err) {
        _this4.$toast.create(_this4.$t(err), 'snack', 3E3);
        _this4.carregandoPendentes = false;
      });
    },
    requestCarregarNegociacoesAgAprovacao: function requestCarregarNegociacoesAgAprovacao() {
      var _this5 = this;

      var pagina = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var filtrosParametros = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (!this.competencia) {
        return;
      }
      (0, _loading.skipLoading)();
      this.carregandoAgAprovacao = true;

      var filtrosNegociacoes = {};
      if (filtrosParametros !== null) {
        filtrosNegociacoes = (0, _assign2.default)({}, filtrosParametros);
      } else {
        filtrosNegociacoes = (0, _assign2.default)({}, this.filtros);
      }
      filtrosNegociacoes.numeroPagina = pagina;
      filtrosNegociacoes.tamanhoPagina = this.limit;

      this.dashboardNegociacaoResources.negociacoesAgAprovacao(filtrosNegociacoes).then(function (response) {
        var data = response.data;

        _this5.carregandoAgAprovacao = false;
        _this5.negociacoesAgAprovacao = data.resposta;

        var qtdeRegistros = data.quantidadeRegistrosPagina;
        _this5.paginasNegociacoesAgAprovacao = Math.ceil(qtdeRegistros / _this5.limit);
      }).catch(function (err) {
        _this5.$toast.create(_this5.$t(err), 'snack', 3E3);
        _this5.carregandoAgAprovacao = false;
      });
    },
    refreshDashboard: function refreshDashboard() {
      this.$refs.apuracoesFinalizadas.refazPaginacao();
      this.$refs.apuracoesPendentes.refazPaginacao();
      this.$refs.negociacoesAgAprovacao.refazPaginacao();
      this.$refs.pagamentosLiquidados.refazPaginacao();

      this.filtros.competencia = this.competencia;

      this.requestCarregarConsolidadoPagamento();
      this.requestCarregarApuracoesFinalizadas();
      this.requestCarregarApuracoesPendentes();
      this.requestCarregarNegociacoesAgAprovacao();
    },
    filtrosPorParametros: function filtrosPorParametros() {
      var filtros = {};
      if (this.parametros && this.parametros.idAcordo) {
        filtros.idAcordo = this.parametros.idAcordo;
      }
      return filtros;
    },
    exibirSidebar: function exibirSidebar(idMeta) {
      this.$refs.execucaoModal.abrir(idMeta);
    },
    abreCarrega: function abreCarrega() {
      var _this6 = this;

      if (this.carregado) {
        return;
      }

      this.requestCarregarPeriodos().then(function () {
        _this6.requestCarregarConsolidadoPagamento();
        _this6.requestCarregarApuracoesFinalizadas();
        _this6.requestCarregarApuracoesPendentes();
        _this6.requestCarregarNegociacoesAgAprovacao();
      }).catch(function (err) {
        _this6.$toast.create(_this6.$t(err), 'snack', 3E3);
      });

      this.carregado = true;
    }
  }
};

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ExecucaoModal_vue_vue_type_script_lang_js___ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ExecucaoModal_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ExecucaoModal_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ExecucaoModal_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ExecucaoModal_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ExecucaoModal_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

var _downloads = __webpack_require__(54);

var _downloads2 = _interopRequireDefault(_downloads);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      execucaoResources: this.$api.execucao(this.$resource),
      evidencias: []
    };
  },

  methods: {
    fechar: function fechar() {
      this.$refs.modal.close();
    },
    abrir: function abrir(idMeta) {
      var _this = this;

      var id = idMeta;
      this.execucaoResources.listar({ id: id }, { id: id }).then(function (response) {
        _this.evidencias = response.data;
        _this.$refs.modal.open();
      }).catch(function (err) {
        _this.$toast.create(err.data.error, 'snack', 3E3);
      });
    },
    visualizarArquivo: function visualizarArquivo(row) {
      var _this2 = this;

      var getBasePath = (0, _apiResource2.default)('execucao', 'execucao');
      var resource = (0, _downloads2.default)(this.$http);

      resource.downloadGetAba(getBasePath, {
        param: '',
        url: row.id + '/pdf'
      }).catch(function () {
        _this2.$toast.create(_this2.$t('message.exportacao_download'), 'snack', 3E3);
      });
    }
  }
};

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ApuracaoFinalizadaTabela_vue_vue_type_script_lang_js___ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ApuracaoFinalizadaTabela_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ApuracaoFinalizadaTabela_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ApuracaoFinalizadaTabela_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ApuracaoFinalizadaTabela_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ApuracaoFinalizadaTabela_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vuejsPaginate = __webpack_require__(27);

var _vuejsPaginate2 = _interopRequireDefault(_vuejsPaginate);

var _helpers = __webpack_require__(5);

var _informacoesContratoMixin = __webpack_require__(76);

var _informacoesContratoMixin2 = _interopRequireDefault(_informacoesContratoMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ApuracaoFinalizadaTabela',
  mixins: [_informacoesContratoMixin2.default],
  components: {
    Paginate: _vuejsPaginate2.default
  },
  props: {
    carregando: Boolean,
    apuracoes: Array,
    paginas: Number
  },
  data: function data() {
    return {
      indexPagina: 0,
      cabecalho: [this.$tc('label.acoes', 1), this.$t('label.numero_acordo'), this.$tc('label.cliente', 1), this.$t('label.acordo'), this.$t('label.tipo_acordo'), this.$tc('label.inicio_vigencia', 1), this.$tc('label.fim_vigencia', 1), this.$tc('label.representante', 1), this.$t('label.status'), this.$t('label.marca'), this.$t('label.linha_produto'), this.$t('label.familia'), this.$tc('label.produto', 1), this.$tc('label.pagamento', 1)],
      status: 'AGUARDANDO_PAGAMENTO',
      listaStatus: [{ status: 'AGUARDANDO_PAGAMENTO', descricao: this.$t('status_entidade.aguardando_pagamento') }, { status: 'BLOQUEADO', descricao: this.$t('status_entidade.bloqueado') }, { status: 'REPROVADO', descricao: this.$tc('status_entidade.reprovado', 1) }, { status: 'LIQUIDADO', descricao: this.$t('label.efetivado') }]
    };
  },

  methods: {
    getMoney: _helpers.getMoney,
    classeCabecalho: function classeCabecalho(index) {
      switch (index) {
        case 2:
        case 12:
          return 'Tabela__LargeColumn';
        case 3:
        case 7:
        case 8:
          return 'Tabela__BigColumn';
        case 4:
        case 9:
        case 10:
        case 11:
        case 13:
          return 'Tabela__MediumColumn';
        default:
          return '';
      }
    },
    possuiRegistros: function possuiRegistros() {
      return this.apuracoes.length !== 0;
    },
    filtraRegistros: function filtraRegistros() {
      var paginaInicial = 0;
      this.$emit('APURACAO_FINALIZADA_TABELA_PAGINA', paginaInicial, this.status);
    },
    clickHandler: function clickHandler(pagina) {
      this.indexPagina = pagina - 1;
      this.$emit('APURACAO_FINALIZADA_TABELA_PAGINA', pagina);
    },
    refazPaginacao: function refazPaginacao() {
      this.indexPagina = 0;
    },
    statusApuracao: function statusApuracao(status) {
      return this.$tc('status_entidade.' + status.toLowerCase(), 1);
    },
    exibirSidebar: function exibirSidebar(row) {
      var idMeta = row.idMeta;
      this.$emit('APURACAO_FINALIZADA_TABELA_EVIDENCIA', idMeta);
    }
  }
};

/***/ }),
/* 495 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ApuracaoPendentesTabela_vue_vue_type_script_lang_js___ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ApuracaoPendentesTabela_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ApuracaoPendentesTabela_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ApuracaoPendentesTabela_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ApuracaoPendentesTabela_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ApuracaoPendentesTabela_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vuejsPaginate = __webpack_require__(27);

var _vuejsPaginate2 = _interopRequireDefault(_vuejsPaginate);

var _informacoesContratoMixin = __webpack_require__(76);

var _informacoesContratoMixin2 = _interopRequireDefault(_informacoesContratoMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ApuracaoPendentesTabela',
  mixins: [_informacoesContratoMixin2.default],
  components: {
    Paginate: _vuejsPaginate2.default
  },
  props: {
    carregando: Boolean,
    apuracoes: Array,
    paginas: Number
  },
  data: function data() {
    return {
      indexPagina: 0,
      cabecalho: [this.$tc('label.acoes', 1), this.$t('label.numero_acordo'), this.$tc('label.cliente', 1), this.$t('label.acordo'), this.$t('label.tipo_acordo'), this.$tc('label.inicio_vigencia', 1), this.$tc('label.fim_vigencia', 1), this.$tc('label.representante', 1), this.$t('label.status'), this.$t('label.marca'), this.$t('label.linha_produto'), this.$t('label.familia'), this.$tc('label.produto', 1)],
      status: 'EM_PROCESSO_APURACAO',
      listaStatus: [{ status: 'EM_PROCESSO_APURACAO', descricao: this.$t('label.em_processo_apuracao') }, { status: 'APROVADO', descricao: this.$tc('status_entidade.aprovado', 1) }]
    };
  },

  methods: {
    classeCabecalho: function classeCabecalho(index) {
      switch (index) {
        case 2:
        case 12:
          return 'Tabela__LargeColumn';
        case 8:
        case 3:
        case 7:
          return 'Tabela__BigColumn';
        case 4:
        case 9:
        case 10:
        case 11:
          return 'Tabela__MediumColumn';
        default:
          return '';
      }
    },
    possuiRegistros: function possuiRegistros() {
      return this.apuracoes.length !== 0;
    },
    filtraRegistros: function filtraRegistros() {
      var paginaInicial = 0;
      this.$emit('APURACAO_PENDENTE_TABELA_PAGINA', paginaInicial, this.status);
    },
    clickHandler: function clickHandler(pagina) {
      this.indexPagina = pagina - 1;
      this.$emit('APURACAO_PENDENTE_TABELA_PAGINA', pagina);
    },
    refazPaginacao: function refazPaginacao() {
      this.indexPagina = 0;
    },
    statusApuracao: function statusApuracao(status) {
      return this.$tc('status_entidade.' + status.toLowerCase(), 1);
    },
    exibirSidebar: function exibirSidebar(row) {
      var idMeta = row.idMeta;
      this.$emit('APURACAO_PENDENTE_TABELA_EVIDENCIA', idMeta);
    }
  }
};

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_NegociacoesAguardandoAprovacao_vue_vue_type_script_lang_js___ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_NegociacoesAguardandoAprovacao_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_NegociacoesAguardandoAprovacao_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_NegociacoesAguardandoAprovacao_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_NegociacoesAguardandoAprovacao_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_NegociacoesAguardandoAprovacao_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vuejsPaginate = __webpack_require__(27);

var _vuejsPaginate2 = _interopRequireDefault(_vuejsPaginate);

var _StatusPassos = __webpack_require__(57);

var _StatusPassos2 = _interopRequireDefault(_StatusPassos);

var _helpers = __webpack_require__(5);

var _informacoesContratoMixin = __webpack_require__(76);

var _informacoesContratoMixin2 = _interopRequireDefault(_informacoesContratoMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ApuracaoFinalizadaTabela',
  mixins: [_informacoesContratoMixin2.default],
  components: {
    Paginate: _vuejsPaginate2.default,
    StatusPassos: _StatusPassos2.default
  },
  props: {
    carregando: Boolean,
    negociacoes: Array,
    paginas: Number
  },
  data: function data() {
    return {
      workflowAcordo: this.$api.workflowAcordo(this.$resource),

      statusPassos: {},
      linhaSelecionada: {},
      justificativaAvaliacao: '',

      indexPagina: 0,
      cabecalho: [this.$tc('label.acoes', 1), this.$t('label.numero_acordo'), this.$tc('label.cliente', 1), this.$t('label.acordo'), this.$t('label.tipo_acordo'), this.$tc('label.inicio_vigencia', 1), this.$tc('label.fim_vigencia', 1), this.$tc('label.representante', 1), this.$t('label.status')],
      esperarRequest: false
    };
  },

  methods: {
    getMoney: _helpers.getMoney,
    cancelarEnvioParaAnalise: function cancelarEnvioParaAnalise() {
      this.$refs.modalAnalise.close();
    },
    iniciarEnvioParaAnalise: function iniciarEnvioParaAnalise(row) {
      this.linhaSelecionada = row;
      this.justificativaAvaliacao = '';
      this.$refs.modalAnalise.open();
    },
    enviarParaAnalise: function enviarParaAnalise() {
      var _this = this;

      var idAcordo = this.linhaSelecionada.numeroAcordo;
      this.workflowAcordo.enviarAnalise({ idAcordo: idAcordo }, { observacao: this.justificativaAvaliacao }).then(function () {
        _this.$refs.modalAnalise.close();
        _this.refazConsulta();
      }).catch(function (err) {
        _this.$toast.create(_this.$t(err), 'snack', 3E3);
      });
    },
    cancelarReprovacao: function cancelarReprovacao() {
      this.$refs.modalReprovacao.close();
    },
    iniciarReprovacao: function iniciarReprovacao(row) {
      this.linhaSelecionada = row;
      this.justificativaAvaliacao = '';
      this.$refs.modalReprovacao.open();
    },
    reprovar: function reprovar() {
      var _this2 = this;

      if (this.esperarRequest) return;
      this.esperarRequest = true;

      var idAcordo = this.linhaSelecionada.numeroAcordo;
      this.workflowAcordo.reprovar({ idAcordo: idAcordo }, { observacao: this.justificativaAvaliacao }).then(function () {
        _this2.esperarRequest = false;
        _this2.$refs.modalReprovacao.close();
        _this2.refazConsulta();
      }).catch(function (err) {
        _this2.esperarRequest = false;
        _this2.$toast.create(_this2.$t(err), 'snack', 3E3);
      });
    },
    cancelarAprovacao: function cancelarAprovacao() {
      this.$refs.modalAprovacao.close();
    },
    iniciarAprovacao: function iniciarAprovacao(row) {
      this.linhaSelecionada = row;
      this.justificativaAvaliacao = '';
      this.$refs.modalAprovacao.open();
    },
    aprovar: function aprovar() {
      var _this3 = this;

      if (this.esperarRequest) return;
      this.esperarRequest = true;

      var idAcordo = this.linhaSelecionada.numeroAcordo;
      this.workflowAcordo.aprovar({ idAcordo: idAcordo }, { observacao: this.justificativaAvaliacao }).then(function () {
        _this3.esperarRequest = false;
        _this3.$refs.modalAprovacao.close();
        _this3.refazConsulta();
      }).catch(function (err) {
        _this3.esperarRequest = false;
        _this3.$toast.create(_this3.$t(err), 'snack', 3E3);
      });
    },
    exibirAcompanhamento: function exibirAcompanhamento(row) {
      var _this4 = this;

      var idAcordo = row.numeroAcordo;
      this.workflowAcordo.statusPasso({ idAcordo: idAcordo }, { idAcordo: idAcordo }).then(function (res) {
        _this4.statusPassos = res.data;
        _this4.$refs.modalAcompanhamento.open();
      }).catch(function (err) {
        _this4.$toast.create(_this4.$t(err), 'snack', 3E3);
      });
    },
    classeCabecalho: function classeCabecalho(index) {
      switch (index) {
        case 2:
          return 'Tabela__LargeColumn';
        case 3:
        case 7:
        case 8:
          return 'Tabela__BigColumn';
        case 4:
          return 'Tabela__MediumColumn';
        default:
          return '';
      }
    },
    styleCard: function styleCard() {
      var style = {};
      if (!this.possuiRegistros() || this.paginas === 1) {
        style['padding-bottom'] = '16px';
      }
      return style;
    },
    possuiRegistros: function possuiRegistros() {
      return this.negociacoes.length !== 0;
    },
    clickHandler: function clickHandler(pagina) {
      this.indexPagina = pagina - 1;
      this.$emit('NEGOCIACAO_AG_APROVACAO_TABELA_PAGINA', pagina);
    },
    refazConsulta: function refazConsulta() {
      var paginaInicial = 0;
      this.$emit('NEGOCIACAO_AG_APROVACAO_TABELA_PAGINA', paginaInicial);
    },
    refazPaginacao: function refazPaginacao() {
      this.indexPagina = 0;
    },
    statusApuracao: function statusApuracao(status) {
      return this.$tc('status_entidade.' + status.toLowerCase(), 1);
    }
  }
};

/***/ }),
/* 500 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_PagamentosLiquidadosTabela_vue_vue_type_script_lang_js___ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_PagamentosLiquidadosTabela_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_PagamentosLiquidadosTabela_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_PagamentosLiquidadosTabela_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_PagamentosLiquidadosTabela_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_PagamentosLiquidadosTabela_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vuejsPaginate = __webpack_require__(27);

var _vuejsPaginate2 = _interopRequireDefault(_vuejsPaginate);

var _informacoesContratoMixin = __webpack_require__(76);

var _informacoesContratoMixin2 = _interopRequireDefault(_informacoesContratoMixin);

var _loading = __webpack_require__(14);

var _dateUtils = __webpack_require__(30);

var _helpers = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'PagamentosLiquidadosTabela',
  mixins: [_informacoesContratoMixin2.default],
  components: {
    Paginate: _vuejsPaginate2.default
  },
  props: {
    periodo: Number,
    carregando: Boolean,
    paginas: Number,
    busca: {
      type: Function
    }
  },
  data: function data() {
    return {
      pagamentoResources: this.$api.pagamentoGestao(this.$resource),

      esperar: false,
      limit: 5,
      pagination: {
        page: 1
      },
      liquidados: [],
      totalPaginas: 0,
      headers: [{ text: this.$tc('label.cod_pagamento', 1), value: 'idPagamento', sortable: false, width: 110 }, { text: this.$t('label.numero_acordo'), value: 'idAcordo', sortable: false, width: 110 }, { text: this.$tc('label.contrato_cliente', 1), value: 'contratoCliente', sortable: false, width: 110 }, { text: this.$t('label.cod_cliente'), value: 'codCliente', sortable: false, width: 90 }, { text: this.$tc('label.cliente', 1), value: 'nomCliente', sortable: false, width: 200 }, { text: this.$tc('label.centro_custo', 1), value: 'centroCusto', sortable: false, width: 200 }, { text: this.$tc('label.tipo_pagamento', 1), value: 'tipoBeneficio', sortable: false, width: 200 }, { text: this.$tc('label.solicitante', 1), value: 'usuarioSolicitante', sortable: false, width: 160 }, { text: this.$t('label.cod_pagamento'), value: 'codPagamento', sortable: false, width: 120, hideColumn: true }, { text: this.$t('label.dta_liquidacao'), value: 'dtaLiquidacao', sortable: false, width: 130, hideColumn: true }, { text: this.$tc('label.valor', 1), value: 'valor', sortable: false, width: 120 }, { text: this.$t('label.usuario_criador'), value: 'usuarioCriador', sortable: false, width: 200 }]
    };
  },

  watch: {
    pagination: {
      handler: function handler() {
        this.filtrar();
      },

      deep: true
    },
    periodo: function periodo() {
      var _this = this;

      this.pagination.page = 1;
      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      this.timeout = window.setTimeout(function () {
        _this.filtrar();
      }, 500);
    }
  },
  methods: {
    filtrar: function filtrar() {
      var _this2 = this;

      if (this.esperar) return;
      if (this.periodo) {
        this.esperar = true;
        setTimeout(function () {
          _this2.buscaPagamentosLiquidados();
        }, 5E2);
      }
    },

    formatDatePattern: _dateUtils.formatDatePattern,
    getMoney: function getMoney(vlrModelo) {
      if (vlrModelo === null) return '-';
      var vlrFormatado = (0, _helpers.convertFloatToMoney)(String(vlrModelo));
      vlrFormatado = vlrFormatado.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var money = vlrFormatado.split('.');
      return 'R$ ' + money[0].replace(/,/g, '.') + ',' + money[1];
    },
    refazPaginacao: function refazPaginacao() {
      this.pagination.page = 1;
      this.$forceUpdate();
    },
    buscaPagamentosLiquidados: function buscaPagamentosLiquidados() {
      var _this3 = this;

      var parametros = {
        numeroPagina: this.pagination.page,
        tamanhoPagina: this.pagination.itemsPerPage,
        asc: !this.pagination.sortDesc[0],
        colunaOrdenacao: this.pagination.sortBy[0],
        competencia: this.periodo
      };
      (0, _loading.skipLoading)();
      this.pagamentoResources.liquidados(parametros).then(function (response) {
        _this3.liquidados = response.data.resposta;
        _this3.totalPaginas = response.data.quantidadeRegistrosPagina;
        _this3.esperar = false;
        _this3.$forceUpdate();
      }).catch(function (err) {
        _this3.$toast.create(_this3.$t(err), 'snack', 3E3);
        _this3.esperar = false;
      });
    }
  },
  mounted: function mounted() {
    this.filtrar();
  }
};

/***/ }),
/* 503 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 504 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CadastroDivisao_vue_vue_type_script_lang_js___ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CadastroDivisao_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CadastroDivisao_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CadastroDivisao_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CadastroDivisao_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_CadastroDivisao_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(6);

var _rolesComputedGenerator = __webpack_require__(8);

var _CRUDGenerico = __webpack_require__(23);

var _CRUDGenerico2 = _interopRequireDefault(_CRUDGenerico);

var _DivisaoForm = __webpack_require__(1313);

var _DivisaoForm2 = _interopRequireDefault(_DivisaoForm);

var _DivisaoTabela = __webpack_require__(1382);

var _DivisaoTabela2 = _interopRequireDefault(_DivisaoTabela);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'CadastroDivisao',
  extends: _CRUDGenerico2.default,
  data: function data() {
    return {
      divisaoResources: this.$api.divisao(this.$resource),
      estruturaUsuarioResources: this.$api.estruturaUsuario(this.$resource),
      resourceMetadado: this.$api.metadado(this.$resource),
      parametrizacaoClienteResources: this.$api.parametrizacaoCliente(this.$resource),

      configCarteira: null
    };
  },

  components: {
    DivisaoForm: _DivisaoForm2.default,
    DivisaoTabela: _DivisaoTabela2.default
  },
  computed: (0, _extends3.default)({}, (0, _rolesComputedGenerator.generateComputed)('Divisao', ['canEdit', 'canGet', 'canAccessPage']), (0, _vuex.mapGetters)('metadados', ['getDivisaoMetadado']), {
    somenteLeitura: function somenteLeitura() {
      return !this.canEdit && this.canGet;
    },
    carregouMetadados: function carregouMetadados() {
      var metadados = this.getDivisaoMetadado;
      return metadados != null;
    }
  }),
  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('metadados', ['setDivisaoMetadado']), {
    accessForbidden: function accessForbidden() {
      if (!this.canAccessPage) {
        this.$router.push({ name: 'inicio' });
        this.$toast.create('Acesso negado', 'snack', 3E3);
      }
    },
    popularMetadados: function popularMetadados() {
      if (this.getDivisaoMetadado) {
        return;
      }
      this.setDivisaoMetadado({
        resource: this.resourceMetadado.listarDivisao
      });
    },
    onCancelar: function onCancelar() {
      this.$refs.divisaoTabela.filtrar();
    },
    onEditarDivisao: function onEditarDivisao(divisao) {
      this.$refs.divisaoForm.editar(divisao);
      this.$refs.divisaoForm.buscarCarteirasCliente();
      this.$refs.divisaoForm.buscarDivisoesPorEstruturaDeUsuario();
      this.$refs.divisaoForm.buscarEstruturasDeUsuario(divisao.estruturaUsuario.nome);
    },
    onNovaDivisao: function onNovaDivisao() {
      this.$refs.divisaoTabela.filtrar();
    },
    requestPopular: function requestPopular() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (page && page.filter) {
        this.request(this.divisaoResources.listarFiltrado, page);
        return;
      }
      this.request(this.divisaoResources.listar, page);
    },
    verificaCarteira: function verificaCarteira() {
      var _this = this;

      var chave = 'CARTEIRA';
      this.parametrizacaoClienteResources.buscar({ chave: chave }).then(function (response) {
        if (response.data) {
          _this.configCarteira = response.data.valor;
        }
      }, function (err) {
        _this.$error(_this, err);
      });
    }
  }),
  beforeMount: function beforeMount() {
    var _this2 = this;

    if (!this.canAccessPage) {
      window.setTimeout(function () {
        _this2.accessForbidden();
      }, 1E3);
    } else {
      this.popularMetadados();
      this.verificaCarteira();
    }
  }
};

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DivisaoForm_vue_vue_type_script_lang_js___ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DivisaoForm_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DivisaoForm_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DivisaoForm_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DivisaoForm_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DivisaoForm_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(9);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(6);

var _Confirm = __webpack_require__(12);

var _Confirm2 = _interopRequireDefault(_Confirm);

var _Divisao = __webpack_require__(523);

var _Divisao2 = _interopRequireDefault(_Divisao);

var _MetadadosContainerLayout = __webpack_require__(1316);

var _MetadadosContainerLayout2 = _interopRequireDefault(_MetadadosContainerLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'DivisaoForm',
  data: function data() {
    var _this = this;

    return {
      buscaListaEstruturaUsuario: null,
      buscaListaDivisoesSuperiores: null,
      buscaListaCarteiras: null,
      carteirasClienteResources: this.$api.carteiraCliente(this.$resource),
      divisao: new _Divisao2.default(),
      divisaoResources: this.$api.divisao(this.$resource),
      estruturaUsuarioResources: this.$api.estruturaUsuario(this.$resource),
      inputLayout: {
        xs12: true,
        sm12: true,
        md12: true,
        sm6: false,
        md3: false,
        md4: false,
        md6: false,
        md9: false
      },
      layoutClass: { wrap: true },
      listaCarteirasCliente: [],
      listaDivisoes: [],
      listaEstruturaUsuarios: [],
      vlrSelecaoEstrutura: {},
      dialog: {
        content: ''
      },
      rules: {
        required: function required(value) {
          return !!value || _this.$t('message.campo_obrigatorio');
        },
        requiredEstrutura: function requiredEstrutura(value) {
          return !!value && !!value.id || _this.$t('message.campo_obrigatorio');
        },
        requiredMultiplaSelecao: function requiredMultiplaSelecao(value) {
          return value.length > 0 || _this.$t('message.campo_obrigatorio');
        }
      }
    };
  },

  props: {
    configCarteira: String
  },
  watch: {
    buscaListaCarteiras: function buscaListaCarteiras(val) {
      var _this2 = this;

      if (this.timeoutCarteira) {
        window.clearTimeout(this.timeoutCarteira);
      }
      this.timeoutCarteira = window.setTimeout(function () {
        if (val != null) _this2.buscarCarteirasCliente(val);
      }, 500);
    },
    buscaListaDivisoesSuperiores: function buscaListaDivisoesSuperiores(val) {
      var _this3 = this;

      if (this.timeoutDivisao) {
        window.clearTimeout(this.timeoutDivisao);
      }
      this.timeoutDivisao = window.setTimeout(function () {
        if (val != null) _this3.buscarDivisoesPorEstruturaDeUsuario(val);
      }, 500);
    },
    buscaListaEstruturaUsuario: function buscaListaEstruturaUsuario(val) {
      var _this4 = this;

      if (this.divisao.estruturaUsuario && this.divisao.estruturaUsuario.nomEstruturaUsuario) {
        var selecao = this.divisao.estruturaUsuario.nomEstruturaUsuario;
        if (selecao === val) {
          return;
        }
      }

      if (this.timeoutEstrutura) {
        window.clearTimeout(this.timeoutEstrutura);
      }
      this.timeoutEstrutura = window.setTimeout(function () {
        if (val != null) _this4.buscarEstruturasDeUsuario(val);
      }, 500);
    }
  },
  components: {
    Confirm: _Confirm2.default,
    MetadadosContainerLayout: _MetadadosContainerLayout2.default
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('metadados', ['getDivisaoMetadado']), {
    metadadosDivisao: function metadadosDivisao() {
      if (this.getDivisaoMetadado && this.getDivisaoMetadado.mapaEntidades) {
        return this.getDivisaoMetadado;
      }
      return undefined;
    }
  }),
  methods: {
    buscarCarteirasCliente: function buscarCarteirasCliente(filtroComponente) {
      var _this5 = this;

      return this.carteirasClienteResources.listarAtivos(filtroComponente).then(function (resultado) {
        _this5.listaCarteirasCliente = resultado.data.resposta;
        var selecao = _this5.divisao.carteirasCliente;
        _this5.listaCarteirasCliente = [].concat((0, _toConsumableArray3.default)(selecao), (0, _toConsumableArray3.default)(_this5.listaCarteirasCliente));
      });
    },
    buscarDivisoesPorEstruturaDeUsuario: function buscarDivisoesPorEstruturaDeUsuario(nome) {
      var _this6 = this;

      var filtro = {
        idEstruturaUsuario: this.divisao.estruturaUsuario.id,
        nome: nome
      };
      return this.divisaoResources.pesquisasrDivisoesSuperiores(filtro).then(function (resultado) {
        _this6.listaDivisoes = resultado.data.resposta;
        var selecao = _this6.divisao.divisoesSuperiores;
        _this6.listaDivisoes = [].concat((0, _toConsumableArray3.default)(selecao), (0, _toConsumableArray3.default)(_this6.listaDivisoes));
      });
    },
    buscarEstruturasDeUsuario: function buscarEstruturasDeUsuario(nomEstruturaUsuario) {
      var _this7 = this;

      var param = {
        autocomplete: nomEstruturaUsuario
      };
      return this.estruturaUsuarioResources.selecao(param).then(function (resultado) {
        _this7.listaEstruturaUsuarios = resultado.data;
      });
    },
    cancel: function cancel() {
      this.limparFormulario();
      this.$emit('FORMULARIO_CADASTRO_DIVISAO_CANCELAR');
    },
    editar: function editar(divisao) {
      this.divisao = new _Divisao2.default((0, _extends3.default)({}, divisao));
      this.divisao.montarEstruturaDinamica(divisao, this.metadadosDivisao);
    },
    limparFormulario: function limparFormulario() {
      this.divisao = new _Divisao2.default();
      this.$refs.form.reset();
    },
    closeDialog: function closeDialog(ref, cb) {
      this.$refs[ref].close();
      this.$refs[ref].active = false;
      if (cb) {
        cb();
      }
    },
    openSaveDialog: function openSaveDialog() {
      if (!this.$refs.form.validate()) return;
      this.dialog.content = this.$t('message.salvar_nova_divisao');
      this.$refs.confirmDialog.open();
    },
    onEstruturaUsuarioSelecionada: function onEstruturaUsuarioSelecionada(estruturaUsuarioSelecionada) {
      if (!estruturaUsuarioSelecionada) {
        if (this.divisao && this.divisao.estruturaUsuario) {
          this.divisao.estruturaUsuario = null;
        }
        this.buscarEstruturasDeUsuario();
        return;
      }
      this.buscarDivisoesPorEstruturaDeUsuario();
    },
    isDivisoesSuperioresDisabled: function isDivisoesSuperioresDisabled() {
      if (this.divisao && this.divisao.estruturaUsuario) {
        return !this.divisao.estruturaUsuario.id;
      }
      return true;
    },
    removeChipSelecao: function removeChipSelecao(item) {
      var selecao = this.divisao.divisoesSuperiores;
      var index = selecao.map(function (s) {
        return s.id;
      }).indexOf(item.id);
      if (index >= 0) selecao.splice(index, 1);
    },
    save: function save() {
      var _this8 = this;

      var objArmazenamento = (0, _extends3.default)({}, this.divisao);
      objArmazenamento.dependenciasMetadados = this.$refs.container.getValoresDependencias();

      var salvarOuAtualizar = void 0;
      if (this.divisao.id != null) {
        salvarOuAtualizar = this.divisaoResources.atualizarDivisao({ id: this.divisao.id }, objArmazenamento);
      } else {
        salvarOuAtualizar = this.divisaoResources.gravar(objArmazenamento);
      }

      salvarOuAtualizar.then(function () {
        return _this8.limparFormulario();
      }).then(function () {
        return _this8.$toast.create(_this8.$t('message.adicionado_confira_tabela'), 'snack', 3E3);
      }).then(function () {
        _this8.$emit('FORMULARIO_CADASTRO_DIVISAO_SALVAR');
      }).catch(function (err) {
        _this8.$error(_this8, err);
      });
    }
  },
  mounted: function mounted() {
    this.buscarEstruturasDeUsuario();
    this.buscarCarteirasCliente();
  }
};

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(4);

var _assign2 = _interopRequireDefault(_assign);

var _typeof2 = __webpack_require__(55);

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = __webpack_require__(11);

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__(29);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(43);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Divisao = function () {
  function Divisao() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    (0, _classCallCheck3.default)(this, Divisao);

    if (data) {
      this.id = data.id;
      this.nome = data.nome;
      this.idExterno = data.idExterno;
      this.estruturaUsuario = data.estruturaUsuario;
      this.nomeEstruturaUsuario = data.estruturaUsuario.nome;
      this.divisoesSuperiores = data.divisoesSuperiores;
      this.carteirasCliente = data.carteirasCliente;
      this.desAtributos = Divisao.montarDesAtributos(data);
    } else {
      this.estruturaUsuario = {
        nome: null,
        id: null
      };
      this.divisoesSuperiores = [];
      this.carteirasCliente = [];
      this.desAtributos = {
        regional: false,
        diretoria: false
      };
    }
  }

  (0, _createClass3.default)(Divisao, [{
    key: 'possuiDivisoesSuperiores',
    value: function possuiDivisoesSuperiores() {
      return this.divisoesSuperiores.length > 0;
    }
  }, {
    key: 'construirAPartirDaConsultaCompleta',
    value: function construirAPartirDaConsultaCompleta(dadosDaConsulta) {
      this.id = dadosDaConsulta.id;
      this.nome = dadosDaConsulta.nome;
      this.idExterno = dadosDaConsulta.idExterno;
      this.nomeEstruturaUsuario = dadosDaConsulta.nomeEstruturaUsuario;
      this.estruturaUsuario.nome = dadosDaConsulta.nomeEstruturaUsuario;
      this.estruturaUsuario.id = dadosDaConsulta.idEstruturaUsuario;
      this.divisoesSuperiores = Divisao.parsearCampos(dadosDaConsulta.divisoesSuperiores, 'nome');
      this.carteirasCliente = Divisao.parsearCampos(dadosDaConsulta.carteirasCliente, 'descricao');
      this.desAtributos = dadosDaConsulta.desAtributos;
    }
  }, {
    key: 'montarEstruturaDinamica',
    value: function montarEstruturaDinamica(dadosDaConsulta, metadados) {
      var _this = this;

      (0, _keys2.default)(dadosDaConsulta).forEach(function (dados) {
        (0, _keys2.default)(metadados.mapaEntidades).forEach(function (entidade) {
          if (dados === entidade) {
            _this[entidade] = Divisao.parsearMetadados(dadosDaConsulta[entidade], metadados.mapaEntidades[entidade].manyToMany);
          }
        });
      });
    }
  }, {
    key: 'getNomesSeparadosPorVirgula',
    value: function getNomesSeparadosPorVirgula(nomeObjeto, atributo) {
      if (!this[nomeObjeto] || Divisao.ehObjeto(this[nomeObjeto]) && Divisao.objetoVazio(this[nomeObjeto]) || Divisao.ehArray(this[nomeObjeto]) && this[nomeObjeto].length === 0) {
        return '';
      }

      if (Divisao.ehArray(this[nomeObjeto])) {
        return this[nomeObjeto].map(function (obj) {
          return obj[atributo];
        }).join(', ');
      }
      return this[nomeObjeto][atributo];
    }
  }, {
    key: 'montarArrayComIdsDasCarteirasDeCliente',
    value: function montarArrayComIdsDasCarteirasDeCliente() {
      return this.carteirasCliente.map(function (aa) {
        return aa.id;
      });
    }
  }, {
    key: 'montarArrayComIdsDasDivisoesSuperiores',
    value: function montarArrayComIdsDasDivisoesSuperiores() {
      return this.divisoesSuperiores.map(function (ds) {
        return ds.id;
      });
    }
  }, {
    key: 'ehEdicao',
    value: function ehEdicao() {
      return this.id;
    }
  }], [{
    key: 'parsearCampos',
    value: function parsearCampos(todasDivisoesEmUmaUnicaString, atributo) {
      if (!todasDivisoesEmUmaUnicaString) {
        return [];
      }
      if (todasDivisoesEmUmaUnicaString.includes(';;')) {
        return todasDivisoesEmUmaUnicaString.split(';;').map(function (umaDivisaoEmString) {
          var arrayComAtributosDaDivisao = umaDivisaoEmString.split('|');
          var retorno = {};
          retorno.id = parseInt(arrayComAtributosDaDivisao[0], 10);
          retorno[atributo] = arrayComAtributosDaDivisao[1];
          return retorno;
        });
      }
      return todasDivisoesEmUmaUnicaString.split(',').map(function (umaDivisaoEmString) {
        var arrayComAtributosDaDivisao = umaDivisaoEmString.split('|');
        var retorno = {};
        retorno.id = parseInt(arrayComAtributosDaDivisao[0], 10);
        retorno[atributo] = arrayComAtributosDaDivisao[1];
        return retorno;
      });
    }
  }, {
    key: 'parsearMetadados',
    value: function parsearMetadados(itemEmUmaString, manyToMany) {
      if (manyToMany) {
        if ((typeof itemEmUmaString === 'undefined' ? 'undefined' : (0, _typeof3.default)(itemEmUmaString)) === 'object') {
          return itemEmUmaString;
        }
        if (!itemEmUmaString) {
          return [];
        }
        return itemEmUmaString.split(',').map(function (umaDivisaoEmString) {
          var arrayComAtributosDaDivisao = umaDivisaoEmString.split('|');
          return {
            id: parseInt(arrayComAtributosDaDivisao[0], 10),
            idExterno: arrayComAtributosDaDivisao[1],
            nomExtensao: arrayComAtributosDaDivisao[2]
          };
        });
      }
      if (!itemEmUmaString) {
        return {};
      }

      var arrayComAtributosDaDivisao = null;
      if (Divisao.ehObjeto(itemEmUmaString)) {
        return itemEmUmaString;
      }

      arrayComAtributosDaDivisao = itemEmUmaString.split('|');
      return {
        id: parseInt(arrayComAtributosDaDivisao[0], 10),
        idExterno: arrayComAtributosDaDivisao[1],
        nomExtensao: arrayComAtributosDaDivisao[2]
      };
    }
  }, {
    key: 'objetoVazio',
    value: function objetoVazio(objeto) {
      return (0, _keys2.default)(objeto).length === 0 && objeto.constructor === Object;
    }
  }, {
    key: 'ehArray',
    value: function ehArray(objeto) {
      return Array.isArray(objeto);
    }
  }, {
    key: 'ehObjeto',
    value: function ehObjeto(objeto) {
      return objeto instanceof Object;
    }
  }, {
    key: 'montarDesAtributos',
    value: function montarDesAtributos(dados) {
      dados.desAtributos = dados.desAtributos && dados.desAtributos.value ? JSON.parse(dados.desAtributos.value) : {};

      return (0, _assign2.default)({}, dados.desAtributos);
    }
  }]);
  return Divisao;
}();

exports.default = Divisao;

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosContainerLayout_vue_vue_type_script_lang_js___ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosContainerLayout_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosContainerLayout_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosContainerLayout_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosContainerLayout_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosContainerLayout_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(11);

var _keys2 = _interopRequireDefault(_keys);

var _toConsumableArray2 = __webpack_require__(9);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _values = __webpack_require__(42);

var _values2 = _interopRequireDefault(_values);

var _MetadadosComponenteDinamico = __webpack_require__(1319);

var _MetadadosComponenteDinamico2 = _interopRequireDefault(_MetadadosComponenteDinamico);

var _MetadadosFiltrosRecursivos = __webpack_require__(1364);

var _MetadadosFiltrosRecursivos2 = _interopRequireDefault(_MetadadosFiltrosRecursivos);

var _metadadosUtils = __webpack_require__(1369);

var _MetadadosContainerLayoutGetters = __webpack_require__(1370);

var _MetadadosContainerLayoutGetters2 = _interopRequireDefault(_MetadadosContainerLayoutGetters);

var _MetadadosContainerLayoutRecursividade = __webpack_require__(1371);

var _MetadadosContainerLayoutRecursividade2 = _interopRequireDefault(_MetadadosContainerLayoutRecursividade);

var _MetadadosContainerLayoutCruzador = __webpack_require__(1381);

var _MetadadosContainerLayoutCruzador2 = _interopRequireDefault(_MetadadosContainerLayoutCruzador);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MetadadosContainerLayout',
  mixins: [_MetadadosContainerLayoutGetters2.default, _MetadadosContainerLayoutRecursividade2.default, _MetadadosContainerLayoutCruzador2.default],
  components: {
    MetadadosComponenteDinamico: _MetadadosComponenteDinamico2.default,
    MetadadosFiltrosRecursivos: _MetadadosFiltrosRecursivos2.default
  },
  props: {
    objeto: Object,
    metadadosEntidade: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    inputLayout: {
      type: Object,
      default: function _default() {
        return {
          sm12: false,
          sm6: true,
          md3: false,
          md4: true,
          md6: false,
          md9: false,
          md12: false
        };
      }
    },
    layoutClass: {
      type: Object,
      default: null
    },
    formularioFiltros: {
      type: Boolean,
      default: false
    },
    ignoraObrigatorios: {
      type: Boolean,
      default: false
    },
    explodeHierarquia: {
      type: Boolean,
      default: false
    },
    camposFormulario: {
      type: Object,
      default: function _default() {
        return { padrao: [] };
      }
    },
    somenteLeitura: {
      type: Boolean,
      default: false
    },
    novoCadastro: {
      type: Boolean,
      default: false
    },
    ordenacaoCampos: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filtroRapido: {
      type: Boolean,
      default: false
    },
    grupoAtivo: {
      type: Boolean,
      default: false
    },
    exibeLoadingOverlay: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    metadadosCamposDinamicos: function metadadosCamposDinamicos() {
      return this.metadadosEntidade.mapaCamposDinamicos ? (0, _values2.default)(this.metadadosEntidade.mapaCamposDinamicos) : [];
    },
    relacaoComponentesDinamicos: function relacaoComponentesDinamicos() {
      var _this = this;

      var dependencias = this.dependenciasDiretas(),
          camposDinamicos = this.metadadosCamposDinamicos,
          camposFixos = this.camposFormulario.padrao || [];

      return (0, _metadadosUtils.ordenaComponentesDinamicos)(this.ordenacaoCampos, dependencias, camposDinamicos, camposFixos).filter(function (metadado) {
        return _this.testaCondicionalCampo(metadado);
      });
    },
    smCol: function smCol() {
      if (this.inputLayout.sm12) {
        return 12;
      }
      if (this.inputLayout.sm6) {
        return 6;
      }
      return undefined;
    },
    mdCol: function mdCol() {
      if (this.inputLayout.md3) {
        return 3;
      }
      if (this.inputLayout.md4) {
        return 4;
      }
      if (this.inputLayout.md6) {
        return 6;
      }
      if (this.inputLayout.md9) {
        return 9;
      }
      if (this.inputLayout.md12) {
        return 12;
      }
      return undefined;
    }
  },
  data: function data() {
    return {
      dependenciasExtensoes: null,
      ready: false
    };
  },

  methods: {
    refresh: function refresh() {
      if (!this.$refs.componentes) return;
      this.$refs.componentes.forEach(function (componente) {
        return componente.refresh();
      });
    },
    dependenciasDiretas: function dependenciasDiretas() {
      var _this2 = this;

      if (!this.containerPossuiMapaEntidades()) {
        return [];
      }

      var metadados = this.metadadosEntidade,
          entidade = metadados.entidade;

      if (!this.ready) {
        return [];
      }
      if (this.dependenciasExtensoes != null) {
        return this.dependenciasExtensoes;
      }

      var dependencias = (0, _values2.default)(metadados.mapaEntidades);
      this.dependenciasExtensoes = dependencias.filter(function (dependencia) {
        return dependencia.dependentes.indexOf(entidade) >= 0;
      }).map(function (dependencia) {
        return (0, _metadadosUtils.formataDependencia)(dependencia, _this2.formularioFiltros);
      });

      return this.dependenciasExtensoes;
    },
    valorAlterado: function valorAlterado(alteracao) {
      var _this3 = this;

      if (!this.containerPossuiMapaEntidades()) {
        return;
      }

      var label = alteracao.label,
          dependentes = alteracao.dependentes;

      var metadados = this.metadadosEntidade,
          extensoesDependentes = (0, _values2.default)(metadados.mapaEntidades).filter(function (dependente) {
        return dependente.dependencias.indexOf(label) >= 0;
      }).map(function (dependente) {
        return dependente.label;
      });

      var relDependentes = [].concat((0, _toConsumableArray3.default)(dependentes), (0, _toConsumableArray3.default)(extensoesDependentes));

      relDependentes.forEach(function (dependente) {
        var objetoDependente = _this3.objeto[dependente];
        if (objetoDependente) {
          _this3.objeto[dependente] = null;
        }
      }, this);

      this.$emit('MetadadosContainerLayout_valorAlterado', alteracao);
      this.refresh();
    },
    abrirCadastro: function abrirCadastro(metadados) {
      this.$emit('MetadadosContainerLayout_abrirCadastro', metadados);
    },
    testaCondicionalCampo: function testaCondicionalCampo(campo) {
      var _this4 = this;

      if (!campo.desAtributos || !campo.desAtributos.condicional) {
        return true;
      }

      var condicional = campo.desAtributos.condicional;


      var validado = true;
      (0, _keys2.default)(condicional).forEach(function (key) {
        var esperado = condicional[key],
            atual = _this4.objeto[key];
        validado = validado && esperado === atual;
      }, this);

      return validado;
    },
    containerPossuiMapaEntidades: function containerPossuiMapaEntidades() {
      var mapaEntidades = this.metadadosEntidade.mapaEntidades;

      return !!mapaEntidades;
    }
  },
  mounted: function mounted() {
    if (this.explodeHierarquia) {
      this.vinculaTopoHierarquiaComDependentesIndiretos();
      this.vinculaEntidadeComDependenciasIndiretas();
    }
    this.montaDependenciasCruzadas();
    this.ready = true;
  }
};

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosComponenteDinamico_vue_vue_type_script_lang_js___ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosComponenteDinamico_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosComponenteDinamico_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosComponenteDinamico_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosComponenteDinamico_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosComponenteDinamico_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MetadadosExtensao = __webpack_require__(528);

var _MetadadosExtensao2 = _interopRequireDefault(_MetadadosExtensao);

var _MetadadosCampoDinamicoAutocomplete = __webpack_require__(1325);

var _MetadadosCampoDinamicoAutocomplete2 = _interopRequireDefault(_MetadadosCampoDinamicoAutocomplete);

var _MetadadosCampoDinamicoTexto = __webpack_require__(1329);

var _MetadadosCampoDinamicoTexto2 = _interopRequireDefault(_MetadadosCampoDinamicoTexto);

var _MetadadosCampoDinamicoDinheiro = __webpack_require__(1332);

var _MetadadosCampoDinamicoDinheiro2 = _interopRequireDefault(_MetadadosCampoDinamicoDinheiro);

var _MetadadosCampoDinamicoBoolean = __webpack_require__(1336);

var _MetadadosCampoDinamicoBoolean2 = _interopRequireDefault(_MetadadosCampoDinamicoBoolean);

var _MetadadosCampoDinamicoData = __webpack_require__(1339);

var _MetadadosCampoDinamicoData2 = _interopRequireDefault(_MetadadosCampoDinamicoData);

var _MetadadosCampoDinamicoHora = __webpack_require__(1342);

var _MetadadosCampoDinamicoHora2 = _interopRequireDefault(_MetadadosCampoDinamicoHora);

var _MetadadosCampoDinamicoNumerico = __webpack_require__(1345);

var _MetadadosCampoDinamicoNumerico2 = _interopRequireDefault(_MetadadosCampoDinamicoNumerico);

var _MetadadosCampoDinamicoPercentual = __webpack_require__(1348);

var _MetadadosCampoDinamicoPercentual2 = _interopRequireDefault(_MetadadosCampoDinamicoPercentual);

var _MetadadosCampoDinamicoMultiplaEscolha = __webpack_require__(1351);

var _MetadadosCampoDinamicoMultiplaEscolha2 = _interopRequireDefault(_MetadadosCampoDinamicoMultiplaEscolha);

var _MetadadosCampoDinamicoLista = __webpack_require__(1354);

var _MetadadosCampoDinamicoLista2 = _interopRequireDefault(_MetadadosCampoDinamicoLista);

var _MetadadosCampoDinamicoCheckbox = __webpack_require__(1357);

var _MetadadosCampoDinamicoCheckbox2 = _interopRequireDefault(_MetadadosCampoDinamicoCheckbox);

var _MetadadosCampoDinamicoListaCheckbox = __webpack_require__(1360);

var _MetadadosCampoDinamicoListaCheckbox2 = _interopRequireDefault(_MetadadosCampoDinamicoListaCheckbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    campoExtensao: {
      type: Boolean,
      default: false
    },
    objeto: Object,
    metadados: {
      type: Object,
      required: true
    },
    ignoraObrigatorios: {
      type: Boolean,
      default: false
    },
    ignoraFiltroRecursivo: {
      type: Boolean,
      default: false
    },
    novoCadastro: {
      type: Boolean,
      default: false
    },
    somenteLeitura: {
      type: Boolean,
      default: false
    },
    filtroRapido: {
      type: Boolean,
      default: false
    },
    grupoAtivo: {
      type: Boolean,
      default: false
    },
    getValoresDependencias: {
      type: Function,
      default: function _default() {
        return [];
      }
    },
    exibeLoadingOverlay: {
      type: Boolean,
      default: true
    }
  },
  components: {
    MetadadosCampoDinamicoListaCheckbox: _MetadadosCampoDinamicoListaCheckbox2.default,
    MetadadosCampoDinamicoCheckbox: _MetadadosCampoDinamicoCheckbox2.default,
    MetadadosExtensao: _MetadadosExtensao2.default,
    MetadadosCampoDinamicoAutocomplete: _MetadadosCampoDinamicoAutocomplete2.default,
    MetadadosCampoDinamicoTexto: _MetadadosCampoDinamicoTexto2.default,
    MetadadosCampoDinamicoDinheiro: _MetadadosCampoDinamicoDinheiro2.default,
    MetadadosCampoDinamicoBoolean: _MetadadosCampoDinamicoBoolean2.default,
    MetadadosCampoDinamicoData: _MetadadosCampoDinamicoData2.default,
    MetadadosCampoDinamicoHora: _MetadadosCampoDinamicoHora2.default,
    MetadadosCampoDinamicoNumerico: _MetadadosCampoDinamicoNumerico2.default,
    MetadadosCampoDinamicoPercentual: _MetadadosCampoDinamicoPercentual2.default,
    MetadadosCampoDinamicoMultiplaEscolha: _MetadadosCampoDinamicoMultiplaEscolha2.default,
    MetadadosCampoDinamicoLista: _MetadadosCampoDinamicoLista2.default
  },
  computed: {
    campoAutocomplete: function campoAutocomplete() {
      return !this.metadados.campoExtensao && this.metadados.async != null && (this.metadados.tipoCampo === 'MULTIPLA_ESCOLHA' || this.metadados.tipoCampo === 'LISTA');
    },
    campoTexto: function campoTexto() {
      return !this.metadados.campoExtensao && this.metadados.tipoCampo === 'TEXTO';
    },
    campoCheckbox: function campoCheckbox() {
      return !this.metadados.campoExtensao && this.metadados.tipoCampo === 'CHECKBOX';
    },
    campoListaCheckbox: function campoListaCheckbox() {
      return !this.metadados.campoExtensao && (this.metadados.tipoCampo === 'LISTA_CHECKBOX' || this.filtroRapido && (this.metadados.tipoCampo === 'LISTA' || this.metadados.tipoCampo === 'MULTIPLA_ESCOLHA'));
    },
    campoDinheiro: function campoDinheiro() {
      return !this.metadados.campoExtensao && this.metadados.tipoCampo === 'DINHEIRO';
    },
    campoBoolean: function campoBoolean() {
      return !this.metadados.campoExtensao && this.metadados.tipoCampo === 'BOOLEAN';
    },
    campoData: function campoData() {
      return !this.metadados.campoExtensao && this.metadados.tipoCampo === 'DATA';
    },
    campoHora: function campoHora() {
      return !this.metadados.campoExtensao && this.metadados.tipoCampo === 'HORA';
    },
    campoNumerico: function campoNumerico() {
      return !this.metadados.campoExtensao && this.metadados.tipoCampo === 'NUMERICO';
    },
    campoPercentual: function campoPercentual() {
      return !this.metadados.campoExtensao && this.metadados.tipoCampo === 'PERCENTUAL';
    },
    campoMultiplaEscolha: function campoMultiplaEscolha() {
      return !this.metadados.campoExtensao && this.metadados.tipoCampo === 'MULTIPLA_ESCOLHA' && !this.filtroRapido;
    },
    campoLista: function campoLista() {
      return !this.metadados.campoExtensao && this.metadados.tipoCampo === 'LISTA' && !this.filtroRapido;
    }
  },
  methods: {
    filtraAmostragemRecursiva: function filtraAmostragemRecursiva(metadadosExtensao) {
      this.$emit('MetadadosExtensao_FiltraAmostragemRecursiva', metadadosExtensao);
    },
    refresh: function refresh() {
      this.$forceUpdate();
      if (this.$refs.componente) {
        this.$refs.componente.refresh();
      }
    },
    valorAlterado: function valorAlterado(valor) {
      var label = this.metadados.label || this.metadados.labelCampo;
      var desAtributos = this.metadados.desAtributos;

      var alteracao = {
        valor: valor,
        label: label
      };
      if (this.metadados.dependentes) {
        alteracao.dependentes = this.metadados.dependentes;
      } else {
        alteracao.dependentes = desAtributos ? desAtributos.dependentes || [] : [];
      }

      this.$emit('MetadadosComponenteDinamico_valorAlterado', alteracao);
    },
    abrirCadastro: function abrirCadastro(metadados) {
      this.$emit('MetadadosComponenteDinamico_abrirCadastro', metadados);
    }
  }
};

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MetadadosExtensao_vue_vue_type_template_id_b2b13a88_lang_html___ = __webpack_require__(1322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MetadadosExtensao_vue_vue_type_script_lang_js___ = __webpack_require__(529);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__MetadadosExtensao_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__MetadadosExtensao_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MetadadosExtensao_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(1324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__MetadadosExtensao_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__MetadadosExtensao_vue_vue_type_template_id_b2b13a88_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__MetadadosExtensao_vue_vue_type_template_id_b2b13a88_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosExtensao_vue_vue_type_script_lang_js___ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosExtensao_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosExtensao_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosExtensao_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosExtensao_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosExtensao_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(11);

var _keys2 = _interopRequireDefault(_keys);

var _toConsumableArray2 = __webpack_require__(9);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(6);

var _loading = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MetadadosExtensao',
  props: {
    metadados: {
      type: Object,
      required: true
    },
    objetoContainer: {
      type: Object,
      required: true
    },
    ignoraFiltroRecursivo: {
      type: Boolean,
      default: false
    },
    ignoraObrigatorios: {
      type: Boolean,
      default: false
    },
    getValoresDependencias: {
      type: Function,
      default: function _default() {
        return [];
      }
    },
    value: {
      type: [Object, Array]
    },
    novoCadastro: {
      type: Boolean,
      default: false
    },
    somenteLeitura: {
      type: Boolean,
      default: false
    },
    exibeLoadingOverlay: {
      type: Boolean,
      default: true
    },
    funcaoBusca: Function
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('implantacao', ['indModoVarejo']), {
    inputId: function inputId() {
      return 'metadados-extensao-' + this.metadados.label;
    },
    label: function label() {
      var label = this.metadados.entidadeEstrangeira;
      return label + (this.campoObrigatorio ? ' *' : '');
    },
    exibeIconeFiltro: function exibeIconeFiltro() {
      return !this.ignoraFiltroRecursivo && this.metadados.recursiva;
    },
    campoObrigatorio: function campoObrigatorio() {
      return !this.ignoraObrigatorios && this.metadados.depObrigatoria;
    },
    valorDefault: function valorDefault() {
      var manyToMany = this.metadados.manyToMany;

      return manyToMany ? [] : {};
    },
    appendIcon: function appendIcon() {
      if (this.somenteLeitura) {
        return '';
      }
      return 'arrow_drop_down';
    },
    permiteCadastro: function permiteCadastro() {
      return this.metadados && this.metadados.desAtributos && this.metadados.desAtributos.permiteCadastro;
    },
    escondeCodigoExtensao: function escondeCodigoExtensao() {
      return this.metadados && this.metadados.desAtributos && this.metadados.desAtributos.escondeCodigo;
    },
    filtroAdicional: function filtroAdicional() {
      return this.metadados && this.metadados.desAtributos && this.metadados.desAtributos.filtroAdicional ? this.metadados.desAtributos.filtroAdicional : {};
    }
  }),
  data: function data() {
    var _this = this;

    return {
      itens: [],
      objetoInterno: null,

      trigger: null,
      timeoutTrigger: null,

      resourcesExtensao: this.$api.extensao(this.$resource),

      exibeBarraLoading: false,

      rules: {
        requiredNome: function requiredNome() {
          if (!_this.campoObrigatorio) {
            return true;
          }

          var msg = _this.$t('message.campo_obrigatorio');

          var val = _this.objetoInterno;
          if (_this.metadados.manyToMany) {
            return val && val.length && val.length > 0 || msg;
          }
          return !!val || msg;
        }
      }
    };
  },

  watch: {
    trigger: function trigger(val) {
      var _this2 = this;

      if (!this.metadados.manyToMany) {
        var selecao = this.objetoInterno,
            vlrSelecao = this.identificador(selecao);

        if (vlrSelecao === val) {
          return;
        }
      }
      if (this.timeoutTrigger) {
        window.clearTimeout(this.timeoutTrigger);
      }
      this.timeoutTrigger = window.setTimeout(function () {
        if (val != null) _this2.buscaExtensoes(val);
      }, 500);
    },

    value: {
      immediate: true,
      handler: function handler(alterado, anterior) {
        var selecaoAtual = alterado || this.valorDefault,
            selecaoAnterior = anterior || this.valorDefault;

        if (this.metadados.manyToMany) {
          if (this.listasDiferentes(this.objetoInterno || [], selecaoAtual)) {
            this.itens = [].concat((0, _toConsumableArray3.default)(selecaoAtual));
            this.objetoInterno = [].concat((0, _toConsumableArray3.default)(selecaoAtual));
          }
          return;
        }

        if (selecaoAtual.id === (this.objetoInterno || {}).id) return;

        if ((0, _keys2.default)(selecaoAtual).length === 0) {
          this.removeModelo(selecaoAnterior);
        } else {
          this.objetoInterno = (0, _extends3.default)({}, selecaoAtual);
          this.aplicaModelo(selecaoAtual);
        }
      }
    }
  },
  methods: {
    listasDiferentes: function listasDiferentes(lista1, lista2) {
      if (lista1.length === 0 || lista2.length === 0) {
        return true;
      }
      var hashItens = lista1.map(function (i) {
        return i.id;
      }).join(''),
          hashModelo = lista2.map(function (i) {
        return i.id;
      }).join('');
      return hashItens !== hashModelo;
    },
    filtraAmostragem: function filtraAmostragem(e) {
      e.stopPropagation();
      this.$emit('MetadadosExtensao_FiltraAmostragemRecursiva', this.metadados);
    },
    triggerClick: function triggerClick() {
      var id = this.inputId;
      setTimeout(function () {
        return document.getElementById(id).click();
      });
    },
    identificador: function identificador(item) {
      var obj = item || {};
      return this.escondeCodigoExtensao ? obj.nomExtensao : obj.idExterno + ' - ' + obj.nomExtensao;
    },
    removeChipSelecao: function removeChipSelecao(item) {
      var selecao = this.objetoInterno;
      var index = selecao.map(function (s) {
        return s.id;
      }).indexOf(item.id);
      if (index >= 0) {
        selecao.splice(index, 1);
        this.valorSelecionado(selecao);
      }
    },
    buscaPadraoExtensoes: function buscaPadraoExtensoes(filtro) {
      var _metadados = this.metadados,
          idNivelExtensao = _metadados.idNivelExtensao,
          indiceRecursao = _metadados.indiceRecursao,
          dependencias = _metadados.dependencias;


      var idsDependencias = this.getValoresDependencias(dependencias[0]).map(function (dependencia) {
        return dependencia.id;
      }) || [];

      var params = (0, _extends3.default)({
        nomExtensao: filtro,
        idExterno: filtro,
        idNivelExtensao: idNivelExtensao,
        indiceRecursao: indiceRecursao,
        idsDependencias: idsDependencias
      }, this.filtroAdicional);
      if (this.metadados.desAtributos && this.metadados.desAtributos.quantidadeRegistroSelect) {
        params.tamanhoPagina = this.metadados.desAtributos.quantidadeRegistroSelect;
      }
      return this.resourcesExtensao.listarAtivos(params);
    },
    buscaExtensoes: function buscaExtensoes(filtro) {
      var _this3 = this;

      if (typeof filtro !== 'string') {
        filtro = null;
      }

      if (!this.exibeLoadingOverlay) {
        this.exibeBarraLoading = true;
        (0, _loading.skipLoading)();
      }

      var promiseBusca = void 0;
      if (!this.funcaoBusca) {
        promiseBusca = this.buscaPadraoExtensoes(filtro);
      } else {
        promiseBusca = this.funcaoBusca(filtro);
      }

      promiseBusca.then(function (response) {
        return _this3.trataResposta(response);
      }).catch(function (err) {
        _this3.$toast.create(err.data.error, 'snack', 3E3);
      }).finally(function () {
        _this3.exibeBarraLoading = false;
      });
    },
    trataResposta: function trataResposta(response) {
      this.itens = Array.isArray(response.data) ? response.data : response.data.resposta;
      if (this.metadados.manyToMany) {
        var selecao = this.objetoInterno || this.valorDefault;
        this.itens = [].concat((0, _toConsumableArray3.default)(selecao), (0, _toConsumableArray3.default)(this.itens));
      }
    },
    aplicaModelo: function aplicaModelo(selecaoAtual) {
      if (this.metadados.manyToMany) {
        this.itens = [].concat((0, _toConsumableArray3.default)(selecaoAtual));
      } else {
        this.itens.push(selecaoAtual);
      }
    },
    removeModelo: function removeModelo(selecaoAnterior) {
      if (this.metadados.manyToMany) {
        var indice = 0;
        for (; indice < this.itens.length; indice += 1) {
          if (selecaoAnterior.id === valor.id) {
            break;
          }
        }
        this.itens.splice(indice, 1);
      } else {
        this.itens = [];
      }
    },
    refresh: function refresh() {
      this.$forceUpdate();
    },
    valorSelecionado: function valorSelecionado(selecao) {
      this.$emit('input', selecao);
      this.$emit('MetadadosExtensao_ValorSelecionado', { selecao: selecao, metadados: this.metadados });
    },
    abrirCadastro: function abrirCadastro() {
      this.$emit('MetadadosExtensao_abrirCadastro', this.metadados);
    }
  }
};

/***/ }),
/* 531 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoAutocomplete_vue_vue_type_script_lang_js___ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoAutocomplete_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoAutocomplete_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoAutocomplete_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoAutocomplete_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoAutocomplete_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(11);

var _keys2 = _interopRequireDefault(_keys);

var _toConsumableArray2 = __webpack_require__(9);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _metadadosCampoDinamicoComum = __webpack_require__(21);

var _metadadosCampoDinamicoComum2 = _interopRequireDefault(_metadadosCampoDinamicoComum);

var _loading = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MetadadosCampoDinamicoAutocomplete',
  mixins: [_metadadosCampoDinamicoComum2.default],
  props: {
    value: {
      type: [Object, Array]
    },
    exibeLoadingOverlay: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    valorDefaultSelecao: function valorDefaultSelecao() {
      return this.multiplaEscolha ? [] : {};
    },
    multiplaEscolha: function multiplaEscolha() {
      return this.metadados.tipoCampo === 'MULTIPLA_ESCOLHA';
    },
    appendIcon: function appendIcon() {
      return !this.campoDesabilitado ? 'search' : '';
    },
    menuProps: function menuProps() {
      return this.metadados.menuProps || {
        closeOnClick: false,
        closeOnContentClick: false,
        openOnClick: false,
        maxHeight: 300
      };
    }
  },
  watch: {
    trigger: function trigger(val) {
      var _this = this;

      if (!this.multiplaEscolha) {
        var selecao = this.objetoInterno || {},
            vlrSelecao = selecao[this.metadados.async.itemText];

        if (vlrSelecao === val) {
          return;
        }
      }
      if (this.timeoutTrigger) {
        window.clearTimeout(this.timeoutTrigger);
      }
      this.timeoutTrigger = window.setTimeout(function () {
        if (val != null) _this.buscarItens(val);
      }, 500);
    },

    value: {
      immediate: true,
      handler: function handler(alterado, anterior) {
        var selecaoAtual = alterado || this.valorDefaultSelecao,
            selecaoAnterior = anterior || this.valorDefaultSelecao;

        if (this.multiplaEscolha) {
          if (this.listasDiferentes(this.objetoInterno || [], selecaoAtual)) {
            this.itens = [].concat((0, _toConsumableArray3.default)(selecaoAtual));
            this.objetoInterno = [].concat((0, _toConsumableArray3.default)(selecaoAtual));
          }
          return;
        }

        if (selecaoAtual[this.metadados.async.itemValue] === (this.objetoInterno || {})[this.metadados.async.itemValue]) {
          return;
        }

        if ((0, _keys2.default)(selecaoAtual).length === 0) {
          this.removeModelo(selecaoAnterior);
          this.objetoInterno = {};
        } else {
          this.objetoInterno = (0, _extends3.default)({}, selecaoAtual);
          this.aplicaModelo(selecaoAtual);
        }
      }
    }
  },
  data: function data() {
    var _this2 = this;

    return {
      itens: [],
      objetoInterno: null,

      trigger: null,
      timeoutTrigger: null,

      exibeBarraLoading: false,

      rules: {
        requiredNome: function requiredNome() {
          if (!_this2.campoObrigatorio) {
            return true;
          }
          var msg = _this2.$t('message.campo_obrigatorio');
          var objeto = _this2.objetoInterno || _this2.valorDefaultSelecao;

          if (_this2.multiplaEscolha) {
            return objeto && objeto.length && objeto.length > 0 || msg;
          }

          var val = objeto[_this2.metadados.async.itemText];
          return !!val || msg;
        }
      }
    };
  },

  methods: {
    removeChipSelecao: function removeChipSelecao(item) {
      var selecao = this.objetoInterno;
      var index = selecao.map(function (s) {
        return s.id;
      }).indexOf(item.id);
      if (index >= 0) {
        selecao.splice(index, 1);
        this.emiteValorAlterado(selecao);
      }
    },
    listasDiferentes: function listasDiferentes(lista1, lista2) {
      if (!Array.isArray(lista1) || !Array.isArray(lista2) || lista1.length === 0 || lista2.length === 0) {
        return true;
      }
      var hashItens = lista1.map(function (i) {
        return i.id;
      }).join(''),
          hashModelo = lista2.map(function (i) {
        return i.id;
      }).join('');
      return hashItens !== hashModelo;
    },
    triggerSelecao: function triggerSelecao() {
      var id = this.inputId;
      setTimeout(function () {
        return document.getElementById(id).click();
      });
    },
    buscarItens: function buscarItens(autocomplete) {
      var _this3 = this;

      var async = this.metadados.async;

      if (typeof autocomplete !== 'string') {
        autocomplete = null;
      }
      if (!this.exibeLoadingOverlay) {
        this.exibeBarraLoading = true;
        (0, _loading.skipLoading)();
      }
      async.fetchFunction(autocomplete).then(function (response) {
        var data = response.data;

        _this3.itens = Array.isArray(data) ? data : data.resposta;
        if (_this3.multiplaEscolha) {
          var selecao = _this3.objetoInterno || [];
          _this3.itens = [].concat((0, _toConsumableArray3.default)(selecao), (0, _toConsumableArray3.default)(_this3.itens));
        }
      }).catch(function (err) {
        _this3.$toast.create(err.data.error, 'snack', 3E3);
      }).finally(function () {
        _this3.exibeBarraLoading = false;
      });
    },
    aplicaModelo: function aplicaModelo(selecaoAtual) {
      if (this.multiplaEscolha) {
        this.itens = [].concat((0, _toConsumableArray3.default)(selecaoAtual));
      } else {
        this.itens.push(selecaoAtual);
      }
    },
    removeModelo: function removeModelo(selecaoAnterior) {
      if (this.multiplaEscolha) {
        var indice = 0;
        for (; indice < this.itens.length; indice += 1) {
          if (selecaoAnterior.id === valor.id) {
            break;
          }
        }
        this.itens.splice(indice, 1);
      } else {
        this.itens = [];
      }
    }
  }
};

/***/ }),
/* 534 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoTexto_vue_vue_type_script_lang_js___ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoTexto_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoTexto_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoTexto_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoTexto_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoTexto_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _metadadosCampoDinamicoComum = __webpack_require__(21);

var _metadadosCampoDinamicoComum2 = _interopRequireDefault(_metadadosCampoDinamicoComum);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MetadadosCampoDinamicoTexto',
  props: {
    value: {
      type: [String]
    }
  },
  mixins: [_metadadosCampoDinamicoComum2.default],
  watch: {
    value: {
      immediate: true,
      handler: function handler(alterado) {
        this.valorInterno = alterado;
      }
    }
  },
  computed: {
    maxCaracteres: function maxCaracteres() {
      var desAtributos = this.metadados.desAtributos;

      if (!desAtributos) return null;
      return desAtributos.max;
    }
  },
  data: function data() {
    var _this = this;

    return {
      valorInterno: null,
      rules: {
        requiredTime: function requiredTime() {
          if (!_this.campoObrigatorio) {
            return true;
          }
          var msg = _this.$t('message.campo_obrigatorio');
          var val = _this.valorInterno;
          return !!val || msg;
        }
      }
    };
  }
};

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoDinheiro_vue_vue_type_script_lang_js___ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoDinheiro_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoDinheiro_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoDinheiro_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoDinheiro_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoDinheiro_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vMoney = __webpack_require__(98);

var _metadadosCampoDinamicoComum = __webpack_require__(21);

var _metadadosCampoDinamicoComum2 = _interopRequireDefault(_metadadosCampoDinamicoComum);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MetadadosCampoDinamicoDinheiro',
  props: {
    value: {
      type: [Number, String]
    }
  },
  mixins: [_metadadosCampoDinamicoComum2.default],
  components: {
    Money: _vMoney.Money
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler(alterado) {
        this.valorInterno = alterado;
      }
    }
  },
  computed: {
    hasErrors: function hasErrors() {
      if (!this.campoObrigatorio) {
        return false;
      }

      var val = this.valorInterno,
          hasErrors = val === null || val === this.valorVazioDinheiro;
      return hasErrors;
    },
    validaCampo: function validaCampo() {
      if (this.hasErrors) {
        return this.$t('message.campo_obrigatorio');
      }
      return null;
    }
  },
  data: function data() {
    var _this = this;

    return {
      dirty: false,
      focused: false,
      valorInterno: null,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      },
      valorVazioDinheiro: 0,
      rules: {
        requiredNome: function requiredNome() {
          if (!_this.campoObrigatorio || !_this.hasErrors) {
            return true;
          }
          return _this.$t('message.campo_obrigatorio');
        }
      }
    };
  },

  methods: {
    valorDinheiroAlterado: function valorDinheiroAlterado(valor) {
      if (valor === this.value) return;
      this.$emit('input', valor);
      this.emiteValorAlterado(valor);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    var input = document.getElementById(this.inputId);

    input.addEventListener('focus', function () {
      _this2.focused = true;
    }, false);

    input.addEventListener('keyup', function () {
      _this2.dirty = true;
    }, false);

    input.addEventListener('blur', function () {
      _this2.focused = false;
      _this2.dirty = true;
    }, false);
  }
};

/***/ }),
/* 539 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoBoolean_vue_vue_type_script_lang_js___ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoBoolean_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoBoolean_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoBoolean_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoBoolean_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoBoolean_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _metadadosCampoDinamicoComum = __webpack_require__(21);

var _metadadosCampoDinamicoComum2 = _interopRequireDefault(_metadadosCampoDinamicoComum);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MetadadosCampoDinamicoBoolean',
  props: {
    value: {
      type: [Boolean]
    }
  },
  mixins: [_metadadosCampoDinamicoComum2.default],
  watch: {
    value: {
      immediate: true,
      handler: function handler(alterado) {
        this.valorInterno = alterado;
      }
    },
    valorInterno: function valorInterno(novoValor) {
      if (novoValor === this.value) {
        return;
      }
      this.emiteValorAlterado(novoValor);
    }
  },
  data: function data() {
    var _this = this;

    return {
      valorInterno: null,
      rules: {
        requiredNome: function requiredNome() {
          if (!_this.campoObrigatorio) {
            return true;
          }
          var msg = _this.$t('message.campo_obrigatorio');
          var val = _this.objetoContainer[_this.metadados.labelCampo];
          return !!val || msg;
        }
      }
    };
  }
};

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoData_vue_vue_type_script_lang_js___ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoData_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoData_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoData_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoData_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoData_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _metadadosCampoDinamicoComum = __webpack_require__(21);

var _metadadosCampoDinamicoComum2 = _interopRequireDefault(_metadadosCampoDinamicoComum);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MetadadosCampoDinamicoData',
  props: {
    value: {
      type: [String]
    }
  },
  mixins: [_metadadosCampoDinamicoComum2.default],
  watch: {
    value: {
      immediate: true,
      handler: function handler(alterado) {
        var _this = this;

        this.valorInterno = alterado;
        setTimeout(function () {
          return _this.alteraValorApresentavel();
        });
      }
    }
  },
  computed: {
    formatoData: function formatoData() {
      var desAtributos = this.metadados.desAtributos;

      if (!desAtributos || !desAtributos.formatoData) return 'DD-MM-YYYY';
      return desAtributos.formatoData;
    }
  },
  data: function data() {
    var _this2 = this;

    return {
      valorInterno: null,
      valorApresentavel: null,
      pickerData: null,
      rules: {
        requiredDate: function requiredDate() {
          if (!_this2.campoObrigatorio) {
            return true;
          }
          var msg = _this2.$t('message.campo_obrigatorio');
          var val = _this2.valorInterno;
          return !!val || msg;
        }
      }
    };
  },

  methods: {
    alteraValorApresentavel: function alteraValorApresentavel() {
      this.valorApresentavel = !this.valorInterno ? null : (0, _moment2.default)(this.valorInterno, 'YYYY-MM-DD').format(this.formatoData);
    },
    limpaData: function limpaData() {
      var _this3 = this;

      this.valorInterno = null;
      this.emiteValorAlterado(null);
      setTimeout(function () {
        return _this3.alteraValorApresentavel();
      });
    },
    dataAlterada: function dataAlterada() {
      var _this4 = this;

      this.emiteValorAlterado(this.valorInterno);
      this.pickerData = false;
      setTimeout(function () {
        return _this4.alteraValorApresentavel();
      });
    }
  }
};

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoHora_vue_vue_type_script_lang_js___ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoHora_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoHora_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoHora_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoHora_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoHora_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _metadadosCampoDinamicoComum = __webpack_require__(21);

var _metadadosCampoDinamicoComum2 = _interopRequireDefault(_metadadosCampoDinamicoComum);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MetadadosCampoDinamicoHora',
  props: {
    value: {
      type: [String]
    }
  },
  mixins: [_metadadosCampoDinamicoComum2.default],
  watch: {
    value: {
      immediate: true,
      handler: function handler(alterado) {
        this.valorInterno = alterado;
      }
    }
  },
  data: function data() {
    var _this = this;

    return {
      valorInterno: null,
      pickerHora: null,
      time: null,
      rules: {
        requiredHour: function requiredHour() {
          if (!_this.campoObrigatorio) {
            return true;
          }
          var msg = _this.$t('message.campo_obrigatorio');
          var val = _this.valorInterno;
          return !!val || msg;
        }
      }
    };
  },

  methods: {
    limpaHora: function limpaHora() {
      this.valorInterno = null;
      this.emiteValorAlterado(null);
    },
    horaAlterada: function horaAlterada() {
      this.emiteValorAlterado(this.valorInterno);
      this.pickerHora = false;
    }
  }
};

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoNumerico_vue_vue_type_script_lang_js___ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoNumerico_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoNumerico_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoNumerico_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoNumerico_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoNumerico_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _metadadosCampoDinamicoComum = __webpack_require__(21);

var _metadadosCampoDinamicoComum2 = _interopRequireDefault(_metadadosCampoDinamicoComum);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MetadadosCampoDinamicoNumerico',
  props: {
    value: {
      type: [Number]
    }
  },
  mixins: [_metadadosCampoDinamicoComum2.default],
  watch: {
    value: {
      immediate: true,
      handler: function handler(alterado) {
        this.valorInterno = alterado;
      }
    }
  },
  data: function data() {
    var _this = this;

    return {
      valorInterno: null,
      rules: {
        requiredNome: function requiredNome() {
          if (!_this.campoObrigatorio) {
            return true;
          }
          var msg = _this.$t('message.campo_obrigatorio');
          var val = _this.valorInterno;
          return !!val || msg;
        },
        numeroValido: function numeroValido() {
          if (!_this.valorInterno) return true;

          var msg = _this.$t('message.numero_invalido');
          var val = _this.valorInterno;
          return !!val && !isNaN(val.toString()) || msg;
        },
        intervaloValido: function intervaloValido() {
          if (!_this.valorInterno) return true;

          var desAtributos = _this.metadados.desAtributos;

          if (!desAtributos || !desAtributos.max || !desAtributos.min) {
            return true;
          }
          var max = desAtributos.max,
              min = desAtributos.min;


          var msg = _this.$t('message.intervalo_numerico', desAtributos);
          var val = _this.valorInterno;
          return !!val && val <= max && val >= min || msg;
        }
      }
    };
  },

  methods: {
    numeroAlterado: function numeroAlterado(valor) {
      if (valor) {
        this.emiteValorAlterado(Number(valor));
      } else {
        this.emiteValorAlterado(null);
      }
    }
  }
};

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoPercentual_vue_vue_type_script_lang_js___ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoPercentual_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoPercentual_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoPercentual_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoPercentual_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoPercentual_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _metadadosCampoDinamicoComum = __webpack_require__(21);

var _metadadosCampoDinamicoComum2 = _interopRequireDefault(_metadadosCampoDinamicoComum);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MetadadosCampoDinamicoPercentual',
  props: {
    value: {
      type: [Number]
    }
  },
  mixins: [_metadadosCampoDinamicoComum2.default],
  watch: {
    value: {
      immediate: true,
      handler: function handler(alterado) {
        this.valorInterno = alterado;
      }
    }
  },
  data: function data() {
    var _this = this;

    return {
      valorInterno: null,
      rules: {
        requiredNome: function requiredNome() {
          if (!_this.campoObrigatorio) {
            return true;
          }
          var msg = _this.$t('message.campo_obrigatorio');
          var val = _this.valorInterno;
          return !!val || msg;
        },
        numeroValido: function numeroValido() {
          if (!_this.valorInterno) return true;

          var msg = _this.$t('message.numero_invalido');
          var val = _this.valorInterno;
          return !!val && !isNaN(val.toString()) || msg;
        },
        intervaloValido: function intervaloValido() {
          if (!_this.valorInterno) return true;

          var max = 100,
              min = 0;
          var msg = _this.$t('message.intervalo_numerico_percentual', { min: min, max: max });
          var val = _this.valorInterno;
          return !!val && val <= max && val >= min || msg;
        }
      }
    };
  },

  methods: {
    numeroAlterado: function numeroAlterado(valor) {
      this.emiteValorAlterado(Number(valor));
    }
  }
};

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoMultiplaEscolha_vue_vue_type_script_lang_js___ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoMultiplaEscolha_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoMultiplaEscolha_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoMultiplaEscolha_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoMultiplaEscolha_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoMultiplaEscolha_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(9);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _metadadosCampoDinamicoComum = __webpack_require__(21);

var _metadadosCampoDinamicoComum2 = _interopRequireDefault(_metadadosCampoDinamicoComum);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MetadadosCampoDinamicoMultiplaEscolha',
  mixins: [_metadadosCampoDinamicoComum2.default],
  props: {
    value: {
      type: [Array]
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler(alterado) {
        var selecaoAtual = alterado || [];
        this.objetoInterno = [].concat((0, _toConsumableArray3.default)(selecaoAtual));
      }
    }
  },
  data: function data() {
    var _this = this;

    return {
      itens: [],
      objetoInterno: null,
      textoItem: null,
      valorItem: null,

      rules: {
        requiredNome: function requiredNome() {
          if (!_this.campoObrigatorio) {
            return true;
          }
          var msg = _this.$t('message.campo_obrigatorio');
          var objeto = _this.objetoInterno || [];

          return objeto && objeto.length && objeto.length > 0 || msg;
        }
      }
    };
  },

  methods: {
    carregarItens: function carregarItens() {
      var _this2 = this;

      var desAtributos = this.metadados.desAtributos;

      if (!desAtributos) {
        throw new Error('DesAtributos não pode ser null!');
      }

      var textoItem = desAtributos.textoItem,
          valorItem = desAtributos.valorItem,
          lista = desAtributos.lista;

      if (textoItem) {
        this.textoItem = textoItem;
        this.valorItem = valorItem;
        this.itens = lista;
      } else {
        this.textoItem = 'texto';
        this.valorItem = 'valor';

        this.itens = lista.map(function (item) {
          var formatado = {};
          formatado[_this2.textoItem] = item;
          formatado[_this2.valorItem] = item;
          return formatado;
        });
      }
    }
  },
  mounted: function mounted() {
    this.carregarItens();
  }
};

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoLista_vue_vue_type_script_lang_js___ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoLista_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoLista_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoLista_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoLista_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoLista_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _metadadosCampoDinamicoComum = __webpack_require__(21);

var _metadadosCampoDinamicoComum2 = _interopRequireDefault(_metadadosCampoDinamicoComum);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MetadadosCampoDinamicoLista',
  mixins: [_metadadosCampoDinamicoComum2.default],
  props: {
    value: {
      type: [String]
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler(alterado) {
        var selecaoAtual = alterado || '';
        this.objetoInterno = selecaoAtual;
      }
    }
  },
  data: function data() {
    var _this = this;

    return {
      itens: [],
      objetoInterno: null,
      textoItem: null,
      valorItem: null,

      rules: {
        requiredNome: function requiredNome() {
          if (!_this.campoObrigatorio) {
            return true;
          }
          var msg = _this.$t('message.campo_obrigatorio');
          var val = _this.objetoInterno || '';

          return !!val || msg;
        }
      }
    };
  },

  methods: {
    carregarItens: function carregarItens() {
      var _this2 = this;

      var desAtributos = this.metadados.desAtributos;

      if (!desAtributos) {
        throw new Error('DesAtributos não pode ser null!');
      }

      var textoItem = desAtributos.textoItem,
          valorItem = desAtributos.valorItem,
          lista = desAtributos.lista;

      if (textoItem) {
        this.textoItem = textoItem;
        this.valorItem = valorItem;
        this.itens = lista;
      } else {
        this.textoItem = 'texto';
        this.valorItem = 'valor';

        this.itens = lista.map(function (item) {
          var formatado = {};
          formatado[_this2.textoItem] = item;
          formatado[_this2.valorItem] = item;
          return formatado;
        });
      }
    }
  },
  mounted: function mounted() {
    this.carregarItens();
  }
};

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoCheckbox_vue_vue_type_script_lang_js___ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoCheckbox_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoCheckbox_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoCheckbox_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoCheckbox_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoCheckbox_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _metadadosCampoDinamicoComum = __webpack_require__(21);

var _metadadosCampoDinamicoComum2 = _interopRequireDefault(_metadadosCampoDinamicoComum);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MetadadosCampoDinamicoCheckbox',
  props: {
    value: {
      type: [String]
    }
  },
  mixins: [_metadadosCampoDinamicoComum2.default],
  watch: {
    value: {
      immediate: true,
      handler: function handler(alterado) {
        this.valorInterno = alterado;
      }
    }
  },
  data: function data() {
    var _this = this;

    return {
      valorInterno: null,
      rules: {
        requiredTime: function requiredTime() {
          if (!_this.campoObrigatorio) {
            return true;
          }
          var msg = _this.$t('message.campo_obrigatorio');
          var val = _this.valorInterno;
          return !!val || msg;
        }
      }
    };
  }
};

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoListaCheckbox_vue_vue_type_script_lang_js___ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoListaCheckbox_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoListaCheckbox_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoListaCheckbox_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoListaCheckbox_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoListaCheckbox_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(9);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _metadadosCampoDinamicoComum = __webpack_require__(21);

var _metadadosCampoDinamicoComum2 = _interopRequireDefault(_metadadosCampoDinamicoComum);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MetadadosCampoDinamicoListaCheckbox',
  props: {
    value: {
      type: [Array]
    },
    grupoAtivo: {
      type: Boolean,
      default: false
    }
  },
  mixins: [_metadadosCampoDinamicoComum2.default],
  watch: {
    value: {
      immediate: true,
      handler: function handler(alterado) {
        var selecaoAtual = alterado || [];
        this.objetoInterno = [].concat((0, _toConsumableArray3.default)(selecaoAtual));
        this.montaObjetoInternoCheckbox();
      }
    },
    grupoAtivo: function grupoAtivo(val) {
      this.active = val;
    },
    active: function active(val) {
      if (val) {
        this.$emit('MetadadosCampoDinamicoListaCheckbox_GrupoAtivo', true);
      }
    }
  },
  computed: {
    quantidadeItens: function quantidadeItens() {
      return this.objetoInterno.length ? ' (' + this.objetoInterno.length + ')' : '';
    }
  },
  data: function data() {
    return {
      itens: [],
      objetoInterno: [],
      objetoInternoCheckbox: {},
      active: false
    };
  },

  methods: {
    montaObjetoInternoCheckbox: function montaObjetoInternoCheckbox() {
      var _this = this;

      this.itens.forEach(function (item) {
        _this.objetoInternoCheckbox[item[_this.valorItem]] = _this.estaMarcado(item[_this.valorItem]);
      });
    },
    setValue: function setValue(value) {
      if (this.estaMarcado(value)) {
        this.objetoInternoCheckbox[value] = false;
        this.objetoInterno.splice(this.objetoInterno.indexOf(value), 1);
      } else {
        this.objetoInternoCheckbox[value] = true;
        this.objetoInterno.push(value);
      }
      this.$forceUpdate();
      this.emiteValorAlterado(this.objetoInterno);
    },
    estaMarcado: function estaMarcado(value) {
      return this.objetoInterno.includes(value);
    },
    carregarItens: function carregarItens() {
      var _this2 = this;

      var _metadados = this.metadados,
          desAtributos = _metadados.desAtributos,
          async = _metadados.async;

      if (!desAtributos && !async) {
        throw new Error('DesAtributos e async não pode ser null!');
      }

      if (desAtributos) {
        var textoItem = desAtributos.textoItem,
            valorItem = desAtributos.valorItem,
            lista = desAtributos.lista;

        if (textoItem) {
          this.textoItem = textoItem;
          this.valorItem = valorItem;
          this.itens = lista;
        } else {
          this.textoItem = 'texto';
          this.valorItem = 'valor';
          this.itens = lista.map(function (item) {
            var formatado = {};
            formatado[_this2.textoItem] = item;
            formatado[_this2.valorItem] = item;
            return formatado;
          });
        }
        this.montaObjetoInternoCheckbox();
      } else {
        var fetchFunction = async.fetchFunction,
            itemValue = async.itemValue,
            itemText = async.itemText;

        this.textoItem = itemText;
        this.valorItem = itemValue;

        fetchFunction().then(function (response) {
          var data = response.data;

          _this2.itens = Array.isArray(data) ? data : data.resposta;
          _this2.itens = [].concat((0, _toConsumableArray3.default)(_this2.itens));
          _this2.montaObjetoInternoCheckbox();
        }).catch(function (err) {
          _this2.$toast.create(err.data.error, 'snack', 3E3);
        });
      }
    }
  },
  mounted: function mounted() {
    this.carregarItens();
  }
};

/***/ }),
/* 558 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosFiltrosRecursivos_vue_vue_type_script_lang_js___ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosFiltrosRecursivos_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosFiltrosRecursivos_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosFiltrosRecursivos_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosFiltrosRecursivos_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosFiltrosRecursivos_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _values = __webpack_require__(42);

var _values2 = _interopRequireDefault(_values);

var _maxSafeInteger = __webpack_require__(561);

var _maxSafeInteger2 = _interopRequireDefault(_maxSafeInteger);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = __webpack_require__(9);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _keys = __webpack_require__(11);

var _keys2 = _interopRequireDefault(_keys);

var _MetadadosExtensao = __webpack_require__(528);

var _MetadadosExtensao2 = _interopRequireDefault(_MetadadosExtensao);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    MetadadosExtensao: _MetadadosExtensao2.default
  },
  props: {
    metadadosEntidade: {
      type: Object,
      default: {}
    },
    objeto: Object,
    callbackFiltro: Function
  },
  data: function data() {
    return {
      dialogRecursao: false,
      entidadeRecursivaEmFiltro: null,
      dependenciasRecursivas: [],

      filtroRecursao: {}
    };
  },

  computed: {
    raizRecursao: function raizRecursao() {
      var raiz = this.dependenciasRecursivas.filter(function (dependencia) {
        return dependencia.indiceRecursao === 0;
      })[0],
          label = raiz.label;

      return label;
    }
  },
  methods: {
    filtraAmostragemRecursiva: function filtraAmostragemRecursiva(metadadosExtensao) {
      var _this = this;

      this.entidadeRecursivaEmFiltro = metadadosExtensao;
      this.determinaDependenciasRecursivas();

      this.dialogRecursao = true;
      setTimeout(function () {
        return _this.carregaValoresPrevios();
      });
    },
    carregaValoresPrevios: function carregaValoresPrevios() {
      var filtro = this.filtroRecursao,
          objeto = this.objeto;

      this.dependenciasRecursivas.filter(function (dependencia) {
        var label = dependencia.label,
            valor = objeto[label];

        return valor != null && (0, _keys2.default)(valor).length !== 0;
      }).forEach(function (dependencia) {
        var label = dependencia.label;

        if (dependencia.manyToMany) {
          filtro[label] = [].concat((0, _toConsumableArray3.default)(objeto[label]));
        } else {
          filtro[label] = (0, _extends3.default)({}, objeto[label]);
        }
      });

      this.filtroRecursao = (0, _extends3.default)({}, filtro);
    },
    campoFiltrado: function campoFiltrado() {
      var entidade = this.filtroRecursao[this.raizRecursao];
      return entidade != null && (0, _keys2.default)(entidade) !== 0;
    },
    valorSelecionado: function valorSelecionado(alteracao) {
      var _alteracao$metadados = alteracao.metadados,
          dependentes = _alteracao$metadados.dependentes,
          label = _alteracao$metadados.label,
          selecao = alteracao.selecao,
          dependente = dependentes[0];


      if (selecao) {
        if (alteracao.metadados.manyToMany) {
          this.filtroRecursao[label] = [].concat((0, _toConsumableArray3.default)(selecao));
        } else {
          this.filtroRecursao[label] = (0, _extends3.default)({}, selecao);
        }
      } else {
        delete this.filtroRecursao[label];
      }

      this.limpaDependentes(dependente);
    },
    limpaDependentes: function limpaDependentes(dependencia) {
      var listaDependentes = this.getDependentes(dependencia);
      var objeto = this.filtroRecursao;
      listaDependentes.forEach(function (entidade) {
        delete objeto[entidade.label];
      });
      this.filtroRecursao = (0, _extends3.default)({}, objeto);
    },
    getValoresDependencias: function getValoresDependencias(dependente) {
      if (!dependente) return [];

      var listaDependencias = this.getDependencias(dependente),
          valores = [],
          objeto = this.filtroRecursao;

      listaDependencias.filter(function (entidade) {
        var label = entidade.label;

        return objeto[label] && (0, _keys2.default)(objeto[label]).length !== 0;
      }).forEach(function (entidade) {
        var label = entidade.label,
            idNivelExtensao = entidade.idNivelExtensao,
            indiceRecursao = entidade.indiceRecursao;
        var id = objeto[label].id;

        valores.push({ id: id, idNivelExtensao: idNivelExtensao, indiceRecursao: indiceRecursao });
      });

      if (valores.length === 0) {
        return [];
      }

      var menorIndiceRecursao = _maxSafeInteger2.default;
      var menorDependencia = null;
      valores.forEach(function (valor) {
        if (valor.indiceRecursao < menorIndiceRecursao) {
          menorIndiceRecursao = valor.indiceRecursao;
          menorDependencia = valor;
        }
      });
      return [menorDependencia];
    },
    getDependentes: function getDependentes(dependencia) {
      var listaDependentes = [];
      var dependencias = [].concat((0, _toConsumableArray3.default)(this.dependenciasRecursivas));
      var referencia = dependencia;

      while (referencia !== null) {
        var dependente = dependencias.filter(function (dependenciaRec) {
          var label = dependenciaRec.label;

          return referencia === label;
        })[0];

        if (dependente) {
          listaDependentes.push(dependente);
          referencia = dependente.dependentes[0];
        } else {
          referencia = null;
        }
      }

      return listaDependentes;
    },
    getDependencias: function getDependencias(dependente) {
      var listaDependencias = [];
      var dependencias = [].concat((0, _toConsumableArray3.default)(this.dependenciasRecursivas));
      var referencia = dependente;

      while (referencia !== null) {
        var dependencia = dependencias.filter(function (dependenciaRec) {
          var label = dependenciaRec.label;

          return referencia === label;
        })[0];

        if (dependencia) {
          listaDependencias.push(dependencia);
          referencia = dependencia.dependencias[0];
        } else {
          referencia = null;
        }
      }

      return listaDependencias;
    },
    determinaDependenciasRecursivas: function determinaDependenciasRecursivas() {
      var metadados = this.metadadosEntidade,
          entidade = metadados.entidade;

      var dependenciasIndiretas = (0, _values2.default)(metadados.mapaEntidades).filter(function (dependencia) {
        return dependencia.dependentes.indexOf(entidade) < 0;
      });

      var eleitasFiltro = {};

      var novaEleita = null;
      var dependente = this.entidadeRecursivaEmFiltro.label;
      do {
        novaEleita = dependenciasIndiretas.filter(function (dependencia) {
          return dependencia.dependentes.indexOf(dependente) >= 0;
        }).filter(function (dependencia) {
          return !eleitasFiltro[dependencia.label];
        })[0];
        eleitasFiltro[novaEleita.label] = novaEleita;

        if (novaEleita.dependencias.length > 0) {
          dependente = novaEleita.label;
        } else {
          dependente = null;
        }
      } while (dependente);

      this.dependenciasRecursivas = [this.entidadeRecursivaEmFiltro].concat((0, _toConsumableArray3.default)((0, _values2.default)(eleitasFiltro))).reverse();
    },
    aplicarFiltroAmostragem: function aplicarFiltroAmostragem() {
      var copia = (0, _extends3.default)({}, this.filtroRecursao);
      this.callbackFiltro(copia);

      this.dialogRecursao = false;
      this.entidadeRecursivaEmFiltro = null;
      this.filtroRecursao = {};
    },
    cancelarFiltroAmostragem: function cancelarFiltroAmostragem() {
      this.dialogRecursao = false;
      this.entidadeRecursivaEmFiltro = null;
      this.filtroRecursao = {};
    }
  }
};

/***/ }),
/* 561 */,
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DivisaoTabela_vue_vue_type_script_lang_js___ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DivisaoTabela_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DivisaoTabela_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DivisaoTabela_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DivisaoTabela_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_DivisaoTabela_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(11);

var _keys2 = _interopRequireDefault(_keys);

var _assign = __webpack_require__(4);

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(6);

var _rolesComputedGenerator = __webpack_require__(8);

var _Divisao = __webpack_require__(523);

var _Divisao2 = _interopRequireDefault(_Divisao);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      carteiraClienteResources: this.$api.carteiraCliente(this.$resource),
      divisaoResources: this.$api.divisao(this.$resource),
      divisoes: [],
      esperar: false,
      headers: [{ text: this.$tc('label.cod_divisao', 1), width: '10%', value: 'id_externo' }, { text: this.$tc('label.nome', 1), value: 'nome' }, { text: this.$tc('label.estrutura_usuario', 1), value: 'nom_estrutura_usuario' }, { text: this.$tc('label.divisao_superior', 1), value: 'divisoes_superiores' }, { text: this.$tc('label.diretoria', 1), value: 'is_diretoria', width: '10%', sortable: false }],
      pagination: {},
      totalPage: 0,
      searchQuery: '',
      registros: []
    };
  },

  props: {
    title: String,
    configCarteira: String
  },
  watch: {
    pagination: {
      handler: function handler() {
        this.filtrar();
      },

      deep: true
    },
    searchQuery: function searchQuery() {
      var _this = this;

      this.pagination.page = 1;
      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      this.timeout = window.setTimeout(function () {
        _this.filtrar();
      }, 500);
    }
  },
  computed: (0, _extends3.default)({
    filteredList: function filteredList() {
      return [];
    }
  }, (0, _rolesComputedGenerator.generateComputed)('Divisao', ['canEdit', 'canGet', 'canAccessPage']), (0, _vuex.mapGetters)('metadados', ['getDivisaoMetadado']), {
    metadadosDivisao: function metadadosDivisao() {
      if (this.getDivisaoMetadado && this.getDivisaoMetadado.mapaEntidades) {
        return this.getDivisaoMetadado;
      }
      return undefined;
    },
    headersDinamico: function headersDinamico() {
      var _this2 = this;

      var headers = (0, _assign2.default)([], this.headers);

      if (this.configCarteira === 'EXPLICITA') {
        headers.push({
          text: this.$tc('label.carteira_cliente', 1),
          value: 'carteiras_cliente',
          sortable: false
        });
      }

      if (!this.metadadosDivisao) return headers;

      (0, _keys2.default)(this.metadadosDivisao.mapaEntidades).forEach(function (entidade) {
        var mapeamentoEntidade = _this2.metadadosDivisao.mapaEntidades[entidade];
        headers.push({
          text: mapeamentoEntidade.entidadeEstrangeira,
          value: mapeamentoEntidade.label,
          sortable: false
        });
      });

      if (!this.somenteLeitura) {
        headers.unshift({ text: '', value: 'acoes', sortable: false, width: '1%', align: 'center' });
      }

      return headers;
    },
    somenteLeitura: function somenteLeitura() {
      return !this.canEdit && this.canGet;
    }
  }),
  methods: {
    buscar: function buscar() {
      var _this3 = this;

      var params = {
        filtro: this.searchQuery,
        page: this.pagination.page,
        size: this.pagination.itemsPerPage,
        asc: !this.pagination.sortDesc[0],
        colunaOrdenacao: this.pagination.sortBy[0]
      };

      this.divisaoResources.listar(params).then(function (response) {
        _this3.registros = response.data.resposta;
        _this3.montarObjetoDivisoes();
        _this3.totalPage = response.data.quantidadeRegistrosPagina;
        _this3.pararEsperar();
      }, function (err) {
        _this3.pararEsperar();
        _this3.$error(_this3, err);
      });
    },
    buscarCarteirasCliente: function buscarCarteirasCliente(filtroComponente) {
      var filtro = (0, _assign2.default)({}, filtroComponente, { size: 50, page: 0 });
      return this.carteiraClienteResources.listar(filtro);
    },
    buscarDivisoesPorEstruturaDeUsuario: function buscarDivisoesPorEstruturaDeUsuario(divisaoSelecionada) {
      var _this4 = this;

      return function (filtro) {
        var params = (0, _assign2.default)({}, filtro, {
          idEstruturaUsuario: divisaoSelecionada.estruturaUsuario.id
        });
        return _this4.divisaoResources.pesquisasrDivisoesSuperiores(params);
      };
    },
    buscarEstruturasDeUsuario: function buscarEstruturasDeUsuario() {
      var nomeEstruturaUsuario = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var filtro = (0, _assign2.default)({}, nomeEstruturaUsuario, { size: 50, page: 0 });
      return this.estruturaUsuarioResources.listar(filtro);
    },
    filtrar: function filtrar() {
      var _this5 = this;

      if (this.esperar) return;
      this.esperar = true;
      setTimeout(function () {
        _this5.buscar();
      }, 5E2);
    },
    getDiretoria: function getDiretoria(divisao) {
      divisao = divisao && divisao.value ? JSON.parse(divisao.value) : {};
      return divisao ? divisao.diretoria : false;
    },
    montarColunasDinamicas: function montarColunasDinamicas() {
      var _this6 = this;

      var objeto = [];
      (0, _keys2.default)(this.metadadosDivisao.mapaEntidades).forEach(function (entidade) {
        objeto.push(_this6.metadadosDivisao.mapaEntidades[entidade].label);
      });
      return objeto;
    },
    montarObjetoDivisoes: function montarObjetoDivisoes() {
      var _this7 = this;

      this.divisoes = this.registros.map(function (data) {
        var divisao = new _Divisao2.default();
        divisao.construirAPartirDaConsultaCompleta(data);
        divisao.montarEstruturaDinamica(data, _this7.metadadosDivisao);
        return divisao;
      });
    },
    onEditaAreaDeAtuacao: function onEditaAreaDeAtuacao(divisao) {
      this.divisaoResources.atualizarAreaAtuacao({ id: divisao.id }, divisao.montarArrayComIdsDasCarteirasDeCliente());
    },
    onEditaDivisoesSuperiores: function onEditaDivisoesSuperiores(divisao) {
      this.divisaoResources.atualizarDivisoesSuperiores({
        id: divisao.id,
        idEstruturaUsuario: divisao.estruturaUsuario.id
      }, divisao.montarArrayComIdsDasDivisoesSuperiores());
    },
    onEditarDivisao: function onEditarDivisao(divisao) {
      if (!divisao.desAtributos) {
        divisao.desAtributos = { diretoria: false };
      }
      this.$emit('PESQUISA_DIVISAO_EDITAR', divisao);
    },
    pararEsperar: function pararEsperar() {
      var _this8 = this;

      setTimeout(function () {
        _this8.esperar = false;
      }, 2E2);
    },
    setEstruturaUsuario: function setEstruturaUsuario(hit, row, nome) {
      this.objEstruturaUsuario.id = row.id;
      this.objEstruturaUsuario.nomEstruturaUsuario = nome;
      this.objEstruturaUsuario.estruturaUsuarioPaiId = hit.map(function (el) {
        return el.id;
      });
      this.updateItemDependency(row, 'estruturaUsuarioPai', this.objEstruturaUsuario);
    }
  },
  mounted: function mounted() {
    this.filtrar();
  }
};

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_EstruturaCadastro_vue_vue_type_script_lang_js___ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_EstruturaCadastro_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_EstruturaCadastro_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_EstruturaCadastro_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_EstruturaCadastro_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_EstruturaCadastro_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _rolesComputedGenerator = __webpack_require__(8);

var _CRUDGenerico = __webpack_require__(23);

var _CRUDGenerico2 = _interopRequireDefault(_CRUDGenerico);

var _EstruturaForm = __webpack_require__(1389);

var _EstruturaForm2 = _interopRequireDefault(_EstruturaForm);

var _EstruturaTabela = __webpack_require__(1392);

var _EstruturaTabela2 = _interopRequireDefault(_EstruturaTabela);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'EstruturaCadastro',
  extends: _CRUDGenerico2.default,
  data: function data() {
    return {
      estruturaUsuarioResources: this.$api.estruturaUsuario(this.$resource)
    };
  },

  components: {
    EstruturaForm: _EstruturaForm2.default,
    EstruturaTabela: _EstruturaTabela2.default
  },
  computed: (0, _extends3.default)({}, (0, _rolesComputedGenerator.generateComputed)('Estrutura', ['canAccessCRUD', 'canAccessPage']), {
    somenteLeitura: function somenteLeitura() {
      return !this.canAccessCRUD;
    }
  }),
  methods: {
    onEditarEstrutura: function onEditarEstrutura(estrutura) {
      this.$refs.formularioCadastroDeDivisao.editar(estrutura);
      this.$refs.dialogoFormularioCadastroDeDivisao.editar(estrutura);
      this.$refs.dialog1.open();
    },
    onNovaEstrutura: function onNovaEstrutura() {
      this.$refs.tabelaEstruturaUsuario.filtrar();
      if (this.$refs.dialog1) {
        this.$refs.dialog1.close();
      }
    },
    accessForbidden: function accessForbidden() {
      if (!this.canAccessPage) {
        this.$router.push({ name: 'inicio' });
        this.$toast.create('Acesso negado', 'snack', 3E3);
      }
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;

    if (!this.canAccessPage) {
      window.setTimeout(function () {
        _this.accessForbidden();
      }, 1E3);
    }
  }
};

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_EstruturaForm_vue_vue_type_script_lang_js___ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_EstruturaForm_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_EstruturaForm_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_EstruturaForm_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_EstruturaForm_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_EstruturaForm_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(4);

var _assign2 = _interopRequireDefault(_assign);

var _RegisterForm = __webpack_require__(36);

var _RegisterForm2 = _interopRequireDefault(_RegisterForm);

var _mdAutocomplete = __webpack_require__(16);

var _mdAutocomplete2 = _interopRequireDefault(_mdAutocomplete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'EstruturaForm',
  props: {
    prepareResponseData: Function
  },
  data: function data() {
    var _this = this;

    return {
      estruturaUsuarioResources: this.$api.estruturaUsuario(this.$resource),
      valid: true,
      required: function required(value) {
        return !!value || _this.$t('message.campo_obrigatorio');
      },
      dialog: {
        ref: 'dialog1',
        from: 'saveRegisterFromButton',
        title: this.$t('label.atencao'),
        content: '',
        action: function action() {}
      },
      estruturaUsuario: {
        id: null,
        nomEstruturaUsuario: '',
        indHierarquia: true,
        indRepresentante: false,
        indRateio: false,
        indExtensao: false,
        indAtivo: true,
        idEstruturaUsuarioPai: null,
        estruturaUsuarioPai: ''
      }
    };
  },

  components: {
    mdAutocomplete: _mdAutocomplete2.default,
    RegisterForm: _RegisterForm2.default
  },
  methods: {
    cancel: function cancel() {
      this.limparFormulario();
      this.$emit('FORMULARIO_CADASTRO_ESTRUTURA_CANCELAR');
    },
    limparFormulario: function limparFormulario() {
      this.estruturaUsuario = {
        id: null,
        nomEstruturaUsuario: '',
        indHierarquia: true,
        indRepresentante: false,
        indRateio: false,
        indExtensao: false,
        indAtivo: true,
        idEstruturaUsuarioPai: null,
        estruturaUsuarioPai: ''
      };
      this.$refs.form.reset();
    },
    closeDialog: function closeDialog(ref, cb) {
      this.$refs[ref].close();
      this.$refs[ref].active = false;
      if (cb) {
        cb();
      }
    },
    openDialog: function openDialog(ref) {
      this.$refs[ref].open();
      this.$refs[ref].active = true;
    },
    openSaveDialog: function openSaveDialog(ref, from) {
      if (this.$refs.form.validate()) {
        var content = this.$t('message.salvar_nova_estrutura_usuario');
        this.setDialogContent(content, this.save, from || this.dialog.from);

        this.openDialog(ref || this.dialog.ref);
      }
    },
    save: function save() {
      var _this2 = this;

      var salvarOuAtualizar = void 0;
      if (this.estruturaUsuario.id != null) {
        salvarOuAtualizar = this.estruturaUsuarioResources.atualizar({ id: this.estruturaUsuario.id }, this.estruturaUsuario);
      } else {
        salvarOuAtualizar = this.estruturaUsuarioResources.gravar(this.estruturaUsuario);
      }

      salvarOuAtualizar.then(function () {
        return _this2.limparFormulario();
      }).then(function () {
        return _this2.$toast.create(_this2.$t('message.adicionado_confira_tabela'), 'snack', 3E3);
      }).then(function () {
        return _this2.$emit('FORMULARIO_CADASTRO_ESTRUTURA_SALVAR', (0, _assign2.default)({}, _this2.estruturaUsuario));
      }).catch(function (err) {
        _this2.$error(_this2, err);
      });
    },
    setDialogContent: function setDialogContent(content, action, from) {
      this.dialog.content = content || this.$t('message.salvar_novo_registro');
      this.dialog.action = action || this.save;
      this.dialog.from = from || this.dialog.from;
    },
    editar: function editar(estruturaUsuario) {
      this.estruturaUsuario = estruturaUsuario;
    },
    setEstruturaUsuarioPai: function setEstruturaUsuarioPai(hit) {
      if (hit.id) {
        this.estruturaUsuario.idEstruturaUsuarioPai = hit.id;
        this.estruturaUsuario.estruturaUsuarioPai = hit.nomEstruturaUsuario;
      } else {
        this.estruturaUsuario.idEstruturaUsuarioPai = null;
        this.estruturaUsuario.estruturaUsuarioPai = '';
      }
    }
  }
};

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_EstruturaTabela_vue_vue_type_script_lang_js___ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_EstruturaTabela_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_EstruturaTabela_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_EstruturaTabela_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_EstruturaTabela_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_EstruturaTabela_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _rolesComputedGenerator = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      esperar: false,
      estruturaUsuarioResources: this.$api.estruturaUsuario(this.$resource),
      estruturasUsuarios: [],
      headers: [{ text: this.$tc('label.nome', 1), value: 'nom_estrutura_usuario' }, { text: this.$tc('label.estrutura_pai', 2), value: 'estrutura_usuario_pai' }, { text: this.$tc('label.estrutura_usuario', 2), value: 'ind_hierarquia' }, { text: this.$tc('label.unidade_negocio', 2), value: 'ind_extensao' }, { text: this.$tc('label.representante', 2), value: 'ind_representante' }, { text: this.$tc('label.rateio', 2), value: 'ind_rateio' }, { text: this.$tc('label.ativo', 1), value: 'ind_ativo' }],
      pagination: {},
      statusFilter: 'true',
      totalPage: 0,
      search: ''
    };
  },

  watch: {
    pagination: {
      handler: function handler() {
        this.filtrar();
      },

      deep: true
    },
    search: function search() {
      var _this = this;

      this.pagination.page = 1;
      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      this.timeout = window.setTimeout(function () {
        _this.filtrar();
      }, 500);
    }
  },
  computed: (0, _extends3.default)({}, (0, _rolesComputedGenerator.generateComputed)('Estrutura', ['canEdit', 'canGet', 'canSearch'])),
  methods: {
    buscar: function buscar() {
      var _this2 = this;

      var params = {
        nome: this.search,
        numeroPagina: this.pagination.page,
        tamanhoPagina: this.pagination.itemsPerPage,
        asc: !this.pagination.sortDesc[0],
        colunaOrdenacao: this.pagination.sortBy[0]
      };
      if (this.statusFilter !== '') {
        params.indAtivo = this.statusFilter;
      }

      this.estruturaUsuarioResources.listar(params).then(function (response) {
        _this2.estruturasUsuarios = response.data.resposta;
        _this2.totalPage = response.data.quantidadeRegistrosPagina;
        _this2.pararEsperar();
      }).catch(function (err) {
        _this2.pararEsperar();
        _this2.$error(_this2, err);
      });
    },
    converterBoolean: function converterBoolean(valor) {
      if (valor) return this.$t('label.sim');
      return this.$t('label.nao');
    },
    edit: function edit(row) {
      this.$emit('ESTRUTURAUSUARIOTABELA_EDITAR', row);
    },
    filtrar: function filtrar() {
      var _this3 = this;

      if (this.esperar) return;
      this.esperar = true;
      setTimeout(function () {
        _this3.buscar();
      }, 5E2);
    },
    montarNomes: function montarNomes(estruturaUsuarioPai) {
      return estruturaUsuarioPai.map(function (u) {
        return u.nomEstruturaUsuario;
      }).join(', ');
    },
    pararEsperar: function pararEsperar() {
      var _this4 = this;

      setTimeout(function () {
        _this4.esperar = false;
      }, 2E2);
    },
    handleStatusFilterChange: function handleStatusFilterChange() {
      this.paginationPage = 0;
      this.buscar();
    }
  },
  mounted: function mounted() {
    this.buscar();
    if (this.canEdit || !this.canEdit && this.canGet) {
      this.headers.unshift({ text: '', value: 'acoes', sortable: false, width: '1%', align: 'center' });
    }
  }
};

/***/ }),
/* 570 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_GestaoAprovacao_vue_vue_type_script_lang_js___ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_GestaoAprovacao_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_GestaoAprovacao_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_GestaoAprovacao_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_GestaoAprovacao_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_GestaoAprovacao_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(4);

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(6);

var _FiltrosGestaoAprovacao = __webpack_require__(1400);

var _FiltrosGestaoAprovacao2 = _interopRequireDefault(_FiltrosGestaoAprovacao);

var _GestaoAprovacaoTabela = __webpack_require__(1403);

var _GestaoAprovacaoTabela2 = _interopRequireDefault(_GestaoAprovacaoTabela);

var _TransferirModal = __webpack_require__(1406);

var _TransferirModal2 = _interopRequireDefault(_TransferirModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'GestaoAprovacao',
  components: {
    TransferirModal: _TransferirModal2.default,
    GestaoAprovacaoTabela: _GestaoAprovacaoTabela2.default,
    FiltrosGestaoAprovacao: _FiltrosGestaoAprovacao2.default
  },
  data: function data() {
    return {
      filtros: {},
      passo: {},
      idPerfilParaModal: null
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('roles', ['getAllRoles']), {
    podeAcessarPagina: function podeAcessarPagina() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el === 'FLUXO_GEST_APRO';
      }).length;
    }
  }),
  methods: {
    preencharFiltro: function preencharFiltro(filtros) {
      this.filtros = (0, _assign2.default)({}, filtros);
    },
    transferirPasso: function transferirPasso(passo) {
      this.passo = passo;
      this.$refs.transgerirModal.open();
    },
    recarregarUsuariosNoModal: function recarregarUsuariosNoModal(idPerfil) {
      var _this = this;

      this.idPerfilParaModal = idPerfil;
      this.$nextTick(function () {
        if (_this.$refs.transgerirModal) {
          _this.$refs.transgerirModal.buscarUsuario();
        }
      });
    }
  },
  mounted: function mounted() {
    if (!this.podeAcessarPagina) {
      this.$router.push({ name: 'inicio' });
    }
  }
};

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosGestaoAprovacao_vue_vue_type_script_lang_js___ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosGestaoAprovacao_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosGestaoAprovacao_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosGestaoAprovacao_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosGestaoAprovacao_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosGestaoAprovacao_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'FiltrosGestaoAprovacao',
  data: function data() {
    var _this = this;

    return {
      resourceFluxo: this.$api.fluxoAprovacao(this.$resource),
      resourceFluxoExecucao: this.$api.workflowPassos(this.$resource),
      tipos: [],
      passos: [],
      solicitantes: [],
      aprovadores: [],
      idPerfilPasso: null,
      filtros: {
        idAcordo: null,
        tipo: null,
        solicitante: null,
        aprovador: null
      },
      valid: false,
      passoCliente: false,
      rules: {
        required: function required(value) {
          return !!value || _this.$t('message.campo_obrigatorio');
        }
      }
    };
  },

  methods: {
    requestTipos: function requestTipos() {
      var _this2 = this;

      this.resourceFluxo.buscarTipos().then(function (response) {
        _this2.tipos = response.data;
      }).catch(function (err) {
        _this2.$error(_this2, err);
      });
    },
    buscarTarefas: function buscarTarefas(tipo) {
      var _this3 = this;

      this.limparPassos();

      if (!tipo) {
        this.passos = [];
        return;
      }

      this.resourceFluxo.buscarDescricoes({ idTipo: tipo.id, status: 'AGUARDANDO_APROVACAO' }).then(function (response) {
        _this3.passos = response.data;
      }).catch(function (err) {
        _this3.$error(_this3, err);
      });
    },
    preencherFiltroCliente: function preencherFiltroCliente(hit) {
      this.limparSolicitante();
      this.limparAprovadores();
      if (!hit) {
        this.limparPassos();
        return;
      }
      this.passoCliente = hit.passocliente;

      this.buscarSolicitante({
        idTipo: this.filtros.tipo.id,
        passo: hit.descricao
      });

      this.buscarAprovadores({
        idTipo: this.filtros.tipo.id,
        passo: hit.descricao,
        passoCliente: this.passoCliente
      });
    },
    buscarAprovadores: function buscarAprovadores(parametros) {
      var _this4 = this;

      this.resourceFluxoExecucao.aprovadoresPasso(parametros).then(function (response) {
        _this4.aprovadores = response.data;
        if (response.data && response.data.length > 0 && response.data[0].idperfil) {
          _this4.idPerfilPasso = response.data[0].idperfil;
        } else {
          _this4.idPerfilPasso = null;
        }
      }).catch(function (err) {
        _this4.$error(_this4, err);
      });
    },
    buscarSolicitante: function buscarSolicitante(parametros) {
      var _this5 = this;

      this.resourceFluxoExecucao.solicitantesPasso(parametros).then(function (response) {
        _this5.solicitantes = response.data;
      }).catch(function (err) {
        _this5.$error(_this5, err);
      });
    },
    limparAprovadores: function limparAprovadores() {
      this.filtros.aprovador = null;
      this.aprovadores = [];
    },
    limparSolicitante: function limparSolicitante() {
      this.filtros.solicitante = null;
      this.solicitantes = [];
    },
    limparPassos: function limparPassos() {
      this.passoCliente = false;
      this.filtros.passo = null;
    },
    filtrar: function filtrar() {
      if (this.$refs.form.validate()) {
        this.$emit('filtrar', this.filtros);
        this.$emit('recarregarUsuarios', this.idPerfilPasso);
      }
    },
    limparFiltros: function limparFiltros() {
      this.$refs.form.reset();
    }
  },
  mounted: function mounted() {
    this.requestTipos();
  }
};

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_GestaoAprovacaoTabela_vue_vue_type_script_lang_js___ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_GestaoAprovacaoTabela_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_GestaoAprovacaoTabela_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_GestaoAprovacaoTabela_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_GestaoAprovacaoTabela_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_GestaoAprovacaoTabela_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'GestaoAprovacaoTabela',
  props: {
    filtros: null
  },
  data: function data() {
    return {
      resourceFluxoExecucao: this.$api.workflowPassos(this.$resource),
      passos: [],
      totalPassos: 0,
      loading: false,
      pagination: {}
    };
  },

  watch: {
    filtros: function filtros() {
      this.$forceUpdate();
      if (this.pagination.page === 1) {
        this.buscarPassos();
      } else {
        this.pagination.page = 1;
      }
    },

    pagination: {
      handler: function handler() {
        this.buscarPassos();
      },

      deep: true
    }
  },
  computed: {
    tipoNaoSelecionado: function tipoNaoSelecionado() {
      return !this.filtros.tipo || !this.filtros.tipo.id;
    },
    headers: function headers() {
      var isFilteringByAcordo = !!this.filtros.idAcordo;
      var headerText = isFilteringByAcordo ? this.$t('label.numero_acordo') : this.$t('label.tipo_de_fluxo');
      return [{
        text: headerText,
        sortable: false,
        value: 'tipo'
      }, {
        text: this.$t('label.solicitante'),
        value: 'solicitante'
      }, {
        text: this.$t('label.data_solicitacao'),
        value: 'dta_solicitacao'
      }, {
        text: this.$t('label.aprovador_atual'),
        value: 'aprovador_atual'
      }, {
        text: this.$tc('label.acoes', 2),
        align: 'center',
        sortable: false,
        value: ''
      }];
    }
  },
  methods: {
    transferirTodos: function transferirTodos() {
      if (this.tipoNaoSelecionado) return;
      var passo = {
        tipo: this.filtros.tipo.nome,
        solicitante: this.filtros.solicitante ? this.filtros.solicitante.solicitante : null,
        usuarioAprovador: this.filtros.aprovador ? this.filtros.aprovador.aprovador : null,
        idAprovador: this.filtros.aprovador ? this.filtros.aprovador.id : null,
        tarefaAprovacao: this.filtros.passo.descricao,
        passocliente: this.filtros.passo.passocliente
      };
      this.$emit('TransferirPasso', passo);
    },
    transferirPasso: function transferirPasso(passo) {
      passo.passocliente = this.filtros.passo.passocliente;
      passo.tarefaAprovacao = this.filtros.passo.descricao;
      this.$emit('TransferirPasso', passo);
    },
    buscarPassos: function buscarPassos() {
      var _this = this;

      if (this.tipoNaoSelecionado) return;
      this.loading = true;
      this.resourceFluxoExecucao.buscarPassos(this.preencherFiltro()).then(function (response) {
        _this.loading = false;
        _this.passos = response.data.resposta;
        _this.totalPassos = response.data.quantidadeRegistrosPagina;
      }).catch(function (err) {
        _this.$error(_this, err);
        _this.loading = false;
      });
    },
    preencherFiltro: function preencherFiltro() {
      var filtro = {};
      var _pagination = this.pagination,
          sortBy = _pagination.sortBy,
          sortDesc = _pagination.sortDesc,
          page = _pagination.page,
          itemsPerPage = _pagination.itemsPerPage;

      if (this.filtros.aprovador && this.filtros.aprovador.id) {
        filtro.idAprovador = this.filtros.aprovador.id;
      }
      if (this.filtros.solicitante && this.filtros.solicitante.id) {
        filtro.idSolicitante = this.filtros.solicitante.id;
      }
      if (this.filtros.idAcordo) {
        filtro.idAcordo = this.filtros.idAcordo;
      }
      filtro.idTipo = this.filtros.tipo.id;
      filtro.passo = this.filtros.passo.descricao;
      filtro.passoCliente = this.filtros.passo.passocliente;
      filtro.numeroPagina = page;
      filtro.tamanhoPagina = itemsPerPage;
      filtro.colunaOrdenacao = sortBy[0];
      filtro.asc = !sortDesc[0];
      return filtro;
    }
  }
};

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferirModal_vue_vue_type_script_lang_js___ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferirModal_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferirModal_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferirModal_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferirModal_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferirModal_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'TransferirModal',
  props: {
    filtros: null,
    passo: null,
    idPerfilFiltro: {
      type: [Number, String, null],
      default: null
    }
  },
  data: function data() {
    var _this = this;

    return {
      fluxoExecucaoResource: this.$api.workflowPassos(this.$resource),
      perfilResources: this.$api.perfil(this.$resource),
      estruturaUsuarioResources: this.$api.estruturaUsuario(this.$resource),
      usuarioResources: this.$api.usuario(this.$resource),
      usuarioClienteResources: this.$api.usuarioCliente(this.$resource),
      dialog: false,
      tipoAprovador: null,
      perfis: [],
      valid: true,
      estruturas: [],
      usuarios: [],
      usuariosCliente: [],
      idUsuarioCliente: null,
      usuariosAprovadores: null,
      grupos: null,
      subgrupos: null,
      rules: {
        required: function required(value) {
          return !!value || _this.$t('message.campo_obrigatorio');
        },
        requiredArray: function requiredArray(value) {
          return !!value && !!value.length || _this.$t('message.campo_obrigatorio');
        }
      },
      tipoAprovadores: [{
        descricao: this.$t('label.workflow_solicitante_usuario'),
        value: 'usuario'
      }, {
        descricao: this.$t('label.workflow_solicitante_grupo'),
        value: 'grupo'
      }]
    };
  },

  computed: {
    ehUsuario: function ehUsuario() {
      return this.tipoAprovador === 'usuario';
    },
    ehGrupo: function ehGrupo() {
      return this.tipoAprovador === 'grupo';
    },
    ehCliente: function ehCliente() {
      return !!this.passo.passocliente;
    }
  },
  methods: {
    transferir: function transferir() {
      if (!this.$refs.form.validate()) return;
      if (this.passo.passocliente && this.passo.id) {
        this.transferirPassoCliente();
      } else if (this.passo.id) {
        this.transferirPasso();
      } else {
        this.transferirPassos();
      }
    },
    transferirPassos: function transferirPassos() {
      this.fluxoExecucaoResource.transferirPassos({
        idTipo: this.filtros.tipo.id
      }, this.preencherParametrosPassos()).then(this.transferidoComSucesso).catch(this.erroRequisicao);
    },
    transferirPasso: function transferirPasso() {
      this.fluxoExecucaoResource.transferirPasso({
        idPasso: this.passo.id,
        idFluxo: this.passo.idFluxoExecucao
      }, this.preencherParametrosPasso()).then(this.transferidoComSucesso).catch(this.erroRequisicao);
    },
    preencherParametrosPasso: function preencherParametrosPasso() {
      var parametros = {};
      parametros.usuarios = this.usuariosAprovadores || [];
      parametros.grupos = this.grupos || [];
      parametros.subgrupos = this.subgrupos || [];
      return parametros;
    },
    preencherParametrosPassos: function preencherParametrosPassos() {
      var parametros = this.preencherParametrosPasso();
      if (this.passo.idAprovador && this.passo.idAprovador) {
        parametros.idAprovador = this.passo.idAprovador;
      }
      if (this.filtros.solicitante && this.filtros.solicitante.id) {
        parametros.idSolicitante = this.filtros.solicitante.id;
      }
      parametros.idTipo = this.filtros.tipo.id;
      parametros.idUsuarioCliente = this.idUsuarioCliente;
      parametros.passo = this.passo.tarefaAprovacao;
      parametros.passoCliente = this.passo.passocliente;
      return parametros;
    },
    transferirPassoCliente: function transferirPassoCliente() {
      this.fluxoExecucaoResource.transferirPassoCliente({
        idPasso: this.passo.id,
        idAcordo: this.passo.idAcordo,
        idUsuarioCliente: this.idUsuarioCliente
      }, {}).then(this.transferidoComSucesso).catch(this.erroRequisicao);
    },
    transferidoComSucesso: function transferidoComSucesso() {
      this.$emit('filtrar', this.filtros);
      this.$toast.create(this.$t('message.aprovacao_transferida'), 'snack', 3E3);
      this.close();
    },
    erroRequisicao: function erroRequisicao(err) {
      this.$error(this, err);
    },
    limparCampo: function limparCampo() {
      var _this2 = this;

      this.grupos = null;
      this.subgrupos = null;
      this.usuariosAprovadores = null;
      this.idUsuarioCliente = null;
      this.valid = true;
      setTimeout(function () {
        if (_this2.ehCliente) {
          _this2.tipoAprovador = 'usuario';
        } else {
          _this2.tipoAprovador = null;
        }
      }, 1E2);
    },
    open: function open() {
      var _this3 = this;

      this.limparCampo();
      setTimeout(function () {
        return _this3.buscarUsuarioClientePasso();
      }, 1E2);
      this.dialog = true;
    },
    close: function close() {
      this.dialog = false;
    },
    buscarUsuarioClientePasso: function buscarUsuarioClientePasso() {
      if (!this.ehCliente) return;
      if (this.passo.id) {
        this.buscarAprovadorPorPasso(this.passo.id);
      } else {
        this.buscarAprovadorPorUsuario(this.passo.idAprovador);
      }
    },
    buscarAprovadorPorUsuario: function buscarAprovadorPorUsuario(id) {
      var _this4 = this;

      this.usuarioClienteResources.obterUsuariosMesmaConfiguracaoUsuarioId({ id: id }).then(function (response) {
        _this4.usuariosCliente = response.data.filter(function (u) {
          return u.id !== _this4.passo.idAprovador;
        });
      }).catch(this.erroRequisicao);
    },
    buscarAprovadorPorPasso: function buscarAprovadorPorPasso(idPassoExecucao) {
      var _this5 = this;

      this.fluxoExecucaoResource.aprovadoresPassosClientes({ idPassoExecucao: idPassoExecucao }).then(function (response) {
        _this5.usuariosCliente = response.data.filter(function (u) {
          return u.id !== _this5.passo.idAprovador;
        });
      }).catch(this.erroRequisicao);
    },
    buscarUsuario: function buscarUsuario() {
      var _this6 = this;

      var perfilId = this.idPerfilFiltro;
      var parametros = {
        nome: '',
        tamanhoPagina: 50000,
        tipo: 'FUNCIONARIO'
      };
      if (perfilId) {
        parametros.perfil = perfilId;
      }
      this.usuarioResources.listarAtivos(parametros).then(function (response) {
        _this6.usuarios = response.data.resposta.filter(function (u) {
          return u.id !== _this6.passo.idAprovador;
        });
      }).catch(this.erroRequisicao);
    },
    buscarPerfil: function buscarPerfil() {
      var _this7 = this;

      this.perfilResources.listarAtivos({
        nome: '',
        indAtivo: true,
        tamanhoPagina: 50000
      }).then(function (response) {
        _this7.perfis = response.data.resposta;
      }).catch(this.erroRequisicao);
    },
    buscarEstruturas: function buscarEstruturas() {
      var _this8 = this;

      this.estruturaUsuarioResources.listarAtivos({
        nome: '',
        indAtivo: true,
        tamanhoPagina: 50000
      }).then(function (response) {
        _this8.estruturas = response.data.resposta;
      }).catch(this.erroRequisicao);
    }
  },
  mounted: function mounted() {
    this.buscarPerfil();
    this.buscarEstruturas();
    this.buscarUsuario();
  }
};

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Importacao_vue_vue_type_script_lang_js___ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Importacao_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Importacao_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Importacao_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Importacao_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Importacao_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(6);

var _GenericModal = __webpack_require__(704);

var _GenericModal2 = _interopRequireDefault(_GenericModal);

var _ImportacaoLateral = __webpack_require__(1413);

var _ImportacaoLateral2 = _interopRequireDefault(_ImportacaoLateral);

var _ImportacaoTabela = __webpack_require__(1417);

var _ImportacaoTabela2 = _interopRequireDefault(_ImportacaoTabela);

var _ImportacaoDialogErros = __webpack_require__(1420);

var _ImportacaoDialogErros2 = _interopRequireDefault(_ImportacaoDialogErros);

var _ImportacaoFinalizadaDialog = __webpack_require__(1424);

var _ImportacaoFinalizadaDialog2 = _interopRequireDefault(_ImportacaoFinalizadaDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Importacao',
  data: function data() {
    return {
      idErro: -1,
      importacaoResources: this.$api.importacoes(this.$resource),
      tabSelecionada: null,
      cabecalhoImportacoes: [{ text: 'Tipo', value: 'desImportacao', sortable: false }, { text: 'Nome', value: 'nomArquivoOrigem', sortable: false }, { text: 'Data', value: 'dtaCriacao', sortable: false }, { text: '', value: 'desResultado', sortable: false }],
      cabecalhoImportacoesFinalizados: [{ text: 'Tipo', value: 'desImportacao', sortable: false }, { text: 'Nome', value: 'nomArquivoOrigem', sortable: false }, { text: 'Data', value: 'dtaCriacao', sortable: false }, { text: '', value: 'desResultado', sortable: false }],
      cabecalhoImportacoesAndamento: [{ text: 'Tipo', value: 'desImportacao', sortable: false }, { text: 'Nome', value: 'nomArquivoOrigem', sortable: false }, { text: 'Status', value: 'indStatus', sortable: false }],
      tableHeaderDetalheErros: [{ text: 'Linha', value: 'linha', sortable: false }, { text: 'Descrição', value: 'descricao', sortable: false }],
      tableHeaderDetalheFinalizados: [{ text: 'Ação', value: 'label', sortable: false }, { text: 'Registros', value: 'value', sortable: false }],
      importacaoDetalheErros: [],
      importacaoDetalheFinalizados: []
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('importacao', {
    importacoesAndamento: 'getImportacoesAndamento',
    importacoesFinalizadas: 'getImportacoesFinalizados',
    importacoesErros: 'getImportacoesErros',
    tiposImportacao: 'getTiposImportacao'
  }), (0, _vuex.mapGetters)('roles', ['getAllRoles']), {
    canImport: function canImport() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el.endsWith('_IMPORTAR') || el.endsWith('_CRUD');
      }).length;
    },
    getTiposImportacaoFiltrados: function getTiposImportacaoFiltrados() {
      return this.tiposImportacao;
    }
  }),
  components: {
    ImportacaoTabela: _ImportacaoTabela2.default,
    ImportacaoLateral: _ImportacaoLateral2.default,
    GenericModal: _GenericModal2.default,
    ImportacaoDialogErros: _ImportacaoDialogErros2.default,
    ImportacaoFinalizadaDialog: _ImportacaoFinalizadaDialog2.default
  },
  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('importacao', ['popularImportacoesAndamento', 'popularImportacoesFinalizados', 'popularImportacoesErros']), {
    accessForbidden: function accessForbidden() {
      if (!this.canImport) {
        this.$router.push({ name: 'inicio' });
        this.$toast.create('Acesso negado', 'snack', 3E3);
      }
    },
    uploadRealizado: function uploadRealizado() {
      var _this = this;

      setTimeout(function () {
        _this.popularImportacoes('tab-importacoes-andamento');
      }, 3000);
    },
    openDialog: function openDialog(ref) {
      this.$refs[ref].open();
    },
    closeDialog: function closeDialog(ref) {
      this.$refs[ref].close();
    },
    getImportacoesDetalhesErros: function getImportacoesDetalhesErros(row) {
      this.importacaoDetalheErros = this.separateErros(row.desResultado);
      this.openDialog('modalErros');
    },
    getImportacoesDetalhesFinalizados: function getImportacoesDetalhesFinalizados(row) {
      this.importacaoDetalheFinalizados = this.separateDetalhes(row.desResultado);
      this.importacaoDetalheErros = this.separateErros(row.desResultado);
      this.openDialog('modalFinalizada');
    },
    separateErros: function separateErros(item) {
      var _this2 = this;

      var resultado = JSON.parse(item.value);
      var erros = [];
      if (resultado.erros) {
        erros = resultado.erros.map(function (e) {
          var erroMap = e.split(' ');
          var linha = parseInt(erroMap[0], 10);
          var param = erroMap[2] ? erroMap[2].replace(/_/g, ' ').replace(/\|/g, ', ') : '';

          var descricao = _this2.$t('errors.importacao.' + erroMap[1], { param: param });
          return { linha: linha, descricao: descricao };
        });

        erros.sort(function (e1, e2) {
          if (e1.linha > e2.linha) {
            return 1;
          }
          if (e2.linha > e1.linha) {
            return -1;
          }
          return 0;
        });
      }
      return erros;
    },
    separateDetalhes: function separateDetalhes(item) {
      var resultado = JSON.parse(item.value);
      return [{
        label: this.$t('label.registros_inseridos'),
        value: resultado.registros_inseridos ? resultado.registros_inseridos[0] : '0'
      }, {
        label: this.$t('label.registros_atualizados'),
        value: resultado.registros_atualizados ? resultado.registros_atualizados[0] : '0'
      }];
    },
    popularImportacoes: function popularImportacoes(param) {
      var _this3 = this;

      this.tabSelecionada = param;

      switch (this.tabSelecionada) {
        case 'tab-importacoes-finalizadas':
          this.popularImportacoesFinalizados(this.importacaoResources.listarFinalizado).catch(function () {
            _this3.$toast.create(_this3.$t('message.erro_buscar_importacoes'), 'snack', 1000);
          });
          break;
        case 'tab-importacoes-erros':
          this.popularImportacoesErros(this.importacaoResources.listarErro).catch(function () {
            _this3.$toast.create(_this3.$t('message.erro_buscar_importacoes'), 'snack', 1000);
          });
          break;
        default:
          this.popularImportacoesAndamento(this.importacaoResources.listarAndamento).catch(function () {
            _this3.$toast.create(_this3.$t('message.erro_buscar_importacoes'), 'snack', 1000);
          });
          break;
      }
    }
  }),
  mounted: function mounted() {
    var _this4 = this;

    if (!this.canImport) {
      window.setTimeout(function () {
        return _this4.accessForbidden();
      }, 1E3);
    }
  }
};

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoLateral_vue_vue_type_script_lang_js___ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoLateral_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoLateral_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoLateral_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoLateral_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoLateral_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(38);

var _stringify2 = _interopRequireDefault(_stringify);

var _RegisterForm = __webpack_require__(36);

var _RegisterForm2 = _interopRequireDefault(_RegisterForm);

var _UploadFile = __webpack_require__(37);

var _UploadFile2 = _interopRequireDefault(_UploadFile);

var _InputDatepicker = __webpack_require__(56);

var _InputDatepicker2 = _interopRequireDefault(_InputDatepicker);

var _importacoes = __webpack_require__(99);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ImportacaoSideColumn',
  props: {
    tipos: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    exibeCancelar: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      dialog: {
        ref: 'dialog1',
        from: 'saveRegisterFromButton',
        title: this.$t('label.atencao'),
        content: '',
        action: function action() {}
      },
      uploadFileUrl: _importacoes.basePath + '/importacao',
      foo: 'hello',
      importacaoId: -1,
      showBlockDropzone: true,
      dataInicio: '',
      dataFim: '',
      urlFim: ''
    };
  },

  computed: {
    hasUploadFileUrl: function hasUploadFileUrl() {
      var _this = this;

      var notEmpty = this.uploadFileUrl !== 'empty';
      if (notEmpty) {
        var timeout = setTimeout(function () {
          _this.showBlockDropzone = false;
          clearTimeout(timeout);
        }, 3E2);
      }
      return notEmpty;
    },
    importacao: function importacao() {
      var _this2 = this;

      return this.importacaoId !== -1 ? this.tipos.find(function (el) {
        return el.id === _this2.importacaoId;
      }) : { arquivosSuportados: '' };
    },
    showImportSellIn: function showImportSellIn() {
      if (!this.errors.has('data_inicio') && this.dataInicio !== '' && this.dataInicio.length === 10 && !this.errors.has('data_fim') && this.dataFim !== '' && this.dataFim.length === 10) {
        return this.validarDatas();
      }
      return false;
    },
    showImportSellOut: function showImportSellOut() {
      if (!this.errors.has('data_inicio') && this.dataInicio !== '' && this.dataInicio.length === 10 && !this.errors.has('data_fim') && this.dataFim !== '' && this.dataFim.length === 10) {
        return this.validarDatas();
      }
      return false;
    },
    uploadFileDropzoneId: function uploadFileDropzoneId() {
      return 'myVueDropzone' + (Math.random() * Math.random() * 100).toString().replace('.', '');
    }
  },
  components: {
    RegisterForm: _RegisterForm2.default,
    UploadFile: _UploadFile2.default,
    InputDatepicker: _InputDatepicker2.default
  },
  methods: {
    enviandoArquivo: function enviandoArquivo(data, xhr, formData) {
      var parametros = { data_inicio: this.dataInicio, data_fim: this.dataFim };
      formData.append('id_tipo_importacao', this.importacao.id);
      formData.append('parametros', (0, _stringify2.default)(parametros));
    },
    cancelarImportacao: function cancelarImportacao() {
      this.$emit('IMPORTACAO_LATERACAO_CANCELAR');
    },
    closeDialog: function closeDialog(ref, cb) {
      this.$refs[ref].close();
      if (cb) {
        cb();
      }
    },
    dataInicialFormatada: function dataInicialFormatada(dataInicial) {
      this.dataInicio = dataInicial;
    },
    dataFimFormatada: function dataFimFormatada(dataFim) {
      this.dataFim = dataFim;
    },
    validarDatas: function validarDatas() {
      var inicio = this.moment(this.dataInicio, 'DD-MM-YYYY');
      var fim = this.moment(this.dataFim, 'DD-MM-YYYY');
      if (inicio > fim) {
        this.$toast.create(this.$t('errors.data.final_antes_inicial'), 'snack', 8E3);
        return false;
      }
      return true;
    },
    openDialog: function openDialog(ref) {
      this.$refs[ref].open();
    },
    openSaveDialog: function openSaveDialog(ref, from) {
      if (this.validateFields()) {
        var content = this.$t('message.salvar_novo_canal');
        this.setDialogContent(content, null, from || this.dialog.from);

        this.openDialog(ref || this.dialog.ref);
      }
    },
    setDialogContent: function setDialogContent(content, action, from) {
      this.dialog.content = content || this.$t('message.deseja_importar');
      this.dialog.action = action || this.save;
      this.dialog.from = from || this.dialog.from;
    },
    uploadError: function uploadError(file, msg) {
      this.$toast.create(msg || this.$t('message.erro_tente_importar_novamente'), 'snack', 5E3);
    },
    uploadSuccess: function uploadSuccess() {
      this.$toast.create(this.$t('message.importado_em_breve_sera_processado'), 'snack', 8E3);
      this.$emit('IMPORTACAO_LATERACAO_UPLOAD');
    }
  }
};

/***/ }),
/* 583 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoTabela_vue_vue_type_script_lang_js___ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoTabela_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoTabela_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoTabela_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoTabela_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoTabela_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    headers: Array,
    isErros: Boolean,
    registros: Array,
    title: String
  },
  data: function data() {
    return {
      search: ''
    };
  },

  computed: {
    possuiData: function possuiData() {
      return this.headers.filter(function (header) {
        return header.text === 'data';
      }).length > 0;
    }
  },
  methods: {
    openDialogErros: function openDialogErros(row) {
      this.$emit('IMPORTACAOTABELA_OPEN_DIALOG_ERROS', row);
    }
  }
};

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoDialogErros_vue_vue_type_script_lang_js___ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoDialogErros_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoDialogErros_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoDialogErros_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoDialogErros_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoDialogErros_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    headers: Array,
    registros: Array
  },
  methods: {
    closeDialog: function closeDialog() {
      this.$emit('IMPORTACAODIALOGERROS_CLOSE_DIALOG');
    }
  }
};

/***/ }),
/* 588 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoFinalizadaDialog_vue_vue_type_script_lang_js___ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoFinalizadaDialog_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoFinalizadaDialog_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoFinalizadaDialog_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoFinalizadaDialog_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoFinalizadaDialog_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ImportacaoSucessoTabela = __webpack_require__(1427);

var _ImportacaoSucessoTabela2 = _interopRequireDefault(_ImportacaoSucessoTabela);

var _ImportacaoErroTabela = __webpack_require__(1430);

var _ImportacaoErroTabela2 = _interopRequireDefault(_ImportacaoErroTabela);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ImportacaoFinalizadaDialog',
  props: {
    tableRowsFinalizado: {
      type: Array,
      default: []
    },
    tableHeaderFinalizado: {
      type: Array,
      default: []
    },
    tableRowsErros: {
      type: Array,
      default: []
    },
    tableHeaderErros: {
      type: Array,
      default: []
    }
  },
  components: {
    ImportacaoSucessoTabela: _ImportacaoSucessoTabela2.default,
    ImportacaoErroTabela: _ImportacaoErroTabela2.default
  },
  methods: {
    closeDialog: function closeDialog() {
      this.$emit('IMPORTACAO_FINALIZADA_DIALOG_CLOSE');
    }
  }
};

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoSucessoTabela_vue_vue_type_script_lang_js___ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoSucessoTabela_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoSucessoTabela_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoSucessoTabela_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoSucessoTabela_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoSucessoTabela_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    headers: Array,
    registros: Array
  }
};

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoErroTabela_vue_vue_type_script_lang_js___ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoErroTabela_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoErroTabela_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoErroTabela_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoErroTabela_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoErroTabela_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    headers: Array,
    registros: Array
  },
  watch: {
    registros: function registros() {
      this.$forceUpdate();
    }
  },
  methods: {
    alterandoValor: function alterandoValor(props) {
      var _console = console,
          log = _console.log;

      log('estou aqui');
      log(props);
      return this.$t('errors.importacao.' + props.item.descricao.toLowerCase(), { param: props.item.param });
    }
  },
  mounted: function mounted() {}
};

/***/ }),
/* 595 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MargemContribuicao_vue_vue_type_script_lang_js___ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MargemContribuicao_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MargemContribuicao_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MargemContribuicao_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MargemContribuicao_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MargemContribuicao_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(6);

var _TabelaGenerica = __webpack_require__(20);

var _TabelaGenerica2 = _interopRequireDefault(_TabelaGenerica);

var _exportacoes = __webpack_require__(39);

var _exportacoes2 = _interopRequireDefault(_exportacoes);

var _helpers = __webpack_require__(5);

var _UploadFile = __webpack_require__(37);

var _UploadFile2 = _interopRequireDefault(_UploadFile);

var _MargemContribuicaoSidebar = __webpack_require__(1438);

var _MargemContribuicaoSidebar2 = _interopRequireDefault(_MargemContribuicaoSidebar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  extends: _TabelaGenerica2.default,
  name: 'MargemContribuicao',
  data: function data() {
    return {
      resources: this.$api.margemcontribuicao(this.$resource),
      esperar: true,
      pagination: {
        itemsPerPage: 10
      },
      totalPage: 0,

      headers: [{ text: 'Ano', align: 'center', sortable: false, value: 'ano' }, { text: 'Mes', sortable: false, value: 'mes' }, { text: 'Código do produto', sortable: false, value: 'codigoProduto' }, { text: 'Nome do produto', sortable: false, value: 'nomeProduto' }, { text: 'Código do cliente', sortable: false, value: 'codigoCliente' }, { text: 'Nome do cliente', sortable: false, value: 'nomeCliente' }, { text: 'Volume Vendido (Kg)', sortable: false, value: 'volumeVendido' }, { text: 'Faturamento liquido', sortable: false, value: 'faturamentoLiquido' }, { text: 'Custo total', sortable: false, value: 'custoTotal' }, { text: 'Canal', sortable: false, value: 'canal' }, { text: 'Holding', sortable: false, value: 'holding' }],
      margens: []
    };
  },

  components: {
    MargemContribuicaoSidebar: _MargemContribuicaoSidebar2.default,
    UploadFile: _UploadFile2.default
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('roles', ['getAllRoles']), {
    canAccessPage: function canAccessPage() {
      return this.getAllRoles.indexOf('MARGEM_ROI') >= 0;
    }
  }),
  watch: {
    pagination: {
      handler: function handler() {
        this.requestPopularMargens();
      },

      deep: true
    },
    searchQuery: function searchQuery() {
      var _this = this;

      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      this.timeout = window.setTimeout(function () {
        _this.paginationPage = 0;
        _this.requestPopularMargens();
      }, 500);
    }
  },
  methods: {
    getMoney: _helpers.getMoney,
    getNumber: _helpers.getNumber,
    openSideBar: function openSideBar() {
      this.$refs.sidebar.open();
    },
    requestPopularMargens: function requestPopularMargens() {
      var _this2 = this;

      var filtros = {
        numeroPagina: this.pagination.page,
        tamanhoPagina: this.pagination.itemsPerPage,
        asc: !this.pagination.sortDesc[0],
        colunaOrdenacao: this.pagination.sortBy[0]
      };
      if (this.searchQuery !== '') {
        filtros.filtro = this.searchQuery;
      }
      this.resources.listar(filtros).then(function (response) {
        _this2.margens = response.data.resposta;
        _this2.totalPage = response.data.quantidadeRegistrosPagina;
        _this2.esperar = false;
      }).catch(function (err) {
        _this2.esperar = false;
        _this2.$error(_this2, err);
      });
    },
    exportarFiltros: function exportarFiltros(filtros, cb, nomeExportador) {
      var _this3 = this;

      var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 500;
      var timeout = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 120000;

      var resource = (0, _exportacoes2.default)(this.$http, timeout);
      resource.download(nomeExportador, {
        limit: limit,
        parametrosConsulta: filtros
      }).then(function () {
        _this3.$toast.create(_this3.$t('message.exportacao_download'), 'snack', 3E3);
      }).catch(function () {
        _this3.$toast.create('Erro ao exportar. Tente novamente.', 'snack', 3E3);
      });
    },
    requestExportacao: function requestExportacao(cb) {
      this.exportar(cb, 'margem_contribuicao');
    },
    exportar: function exportar(cb, nomeExportador) {
      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 500;
      var timeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 120000;

      var filtros = {
        filtro: this.searchQuery
      };
      this.exportarFiltros(filtros, cb, nomeExportador, limit, timeout);
    },
    accessForbidden: function accessForbidden() {
      if (!this.canAccessPage) {
        this.$router.push({ name: 'inicio' });
        this.$toast.create(this.$t('message.acesso_negado'), 'snack', 3E3);
      }
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    if (!this.canAccessPage) {
      window.setTimeout(function () {
        _this4.accessForbidden();
      }, 1E3);
    }
    this.requestPopularMargens();
  }
};

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MargemContribuicaoSidebar_vue_vue_type_script_lang_js___ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MargemContribuicaoSidebar_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MargemContribuicaoSidebar_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MargemContribuicaoSidebar_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MargemContribuicaoSidebar_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_MargemContribuicaoSidebar_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(6);

var _UploadFile = __webpack_require__(37);

var _UploadFile2 = _interopRequireDefault(_UploadFile);

var _importacoes = __webpack_require__(82);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MargemContribuicaoSidebar',
  data: function data() {
    return {
      dialogForm: false
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('importacao', {
    tiposImportacao: 'getTiposImportacao'
  }), {
    importUrl: function importUrl() {
      return _importacoes.basePath + '/importacao';
    },
    subtitle: function subtitle() {
      return this.$t('subtitle.importar_arquivo', {
        thing: this.$tc('label.margemcontribuicao', 1).toLowerCase()
      });
    },
    uploadFileDropzoneId: function uploadFileDropzoneId() {
      return 'myVueDropzone' + (Math.random() * Math.random() * 100).toString().replace('.', '');
    },
    tipoImportacao: function tipoImportacao() {
      return this.tiposImportacao.find(function (el) {
        return el.nome === 'importacao_margemContribuicaoRoi';
      });
    }
  }),
  components: {
    UploadFile: _UploadFile2.default
  },
  methods: {
    enviandoArquivo: function enviandoArquivo(data, xhr, formData) {
      formData.append('id_tipo_importacao', this.importacao.id);
    },
    open: function open() {
      this.dialogForm = true;
    },
    uploadError: function uploadError(file, msg) {
      this.$toast.create(msg || this.$t('message.erro_tente_importar_novamente'), 'snack', 5E3);
    },
    uploadSuccess: function uploadSuccess() {
      this.$toast.create(this.$t('message.importado_em_breve_sera_processado'), 'snack', 8E3);
      this.dialogForm = false;
    }
  }
};

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_RegiaoCadastro_vue_vue_type_script_lang_js___ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_RegiaoCadastro_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_RegiaoCadastro_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_RegiaoCadastro_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_RegiaoCadastro_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_RegiaoCadastro_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _rolesComputedGenerator = __webpack_require__(8);

var _CRUDGenerico = __webpack_require__(23);

var _CRUDGenerico2 = _interopRequireDefault(_CRUDGenerico);

var _exportacao = __webpack_require__(1452);

var _exportacao2 = _interopRequireDefault(_exportacao);

var _RegiaoForm = __webpack_require__(1453);

var _RegiaoForm2 = _interopRequireDefault(_RegiaoForm);

var _RegiaoTabela = __webpack_require__(1456);

var _RegiaoTabela2 = _interopRequireDefault(_RegiaoTabela);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'RegiaoCadastro',
  extends: _CRUDGenerico2.default,
  data: function data() {
    return {
      regiaoResources: this.$api.regiao(this.$resource)
    };
  },

  components: {
    RegiaoForm: _RegiaoForm2.default,
    RegiaoTabela: _RegiaoTabela2.default
  },
  computed: (0, _extends3.default)({}, (0, _rolesComputedGenerator.generateComputed)('Regiao', ['canAccessPage', 'canAccessCRUD']), {
    somenteLeitura: function somenteLeitura() {
      return !this.canAccessCRUD;
    }
  }),
  methods: {
    accessForbidden: function accessForbidden() {
      if (!this.canAccessPage) {
        this.$router.push({ name: 'inicio' });
        this.$toast.create(this.$t('message.acesso_negado'), 'snack', 3E3);
      }
    },
    onCancelar: function onCancelar() {
      this.$refs.regiaoTabela.filtrar();
    },
    onEditarRegiao: function onEditarRegiao(regiao) {
      this.$refs.regiaoForm.editar(regiao);
    },
    onNovoRegiao: function onNovoRegiao() {
      this.$refs.regiaoTabela.filtrar();
    },
    requestAdicionar: function requestAdicionar(objeto) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.requestAdicionarGenerico(this.regiaoResources.gravar, objeto, cb);
    },
    requestAtivarInativar: function requestAtivarInativar(index) {
      var row = this.tableRows[index],
          id = row.id;
      return this.requestAtivarInativarGenerico(row, id, this.regiaoResources);
    },
    requestAtualizar: function requestAtualizar(objeto) {
      this.requestAtualizarGenerico(this.regiaoResources.atualizar, objeto);
    },
    requestExportacao: function requestExportacao(cb) {
      var params = {
        filtro: this.$refs.regiaoTabela.getSearchQuery() || ''
      };
      _exportacao2.default.exportar(cb, 'regiao_simples', this, params);
    },
    requestPopular: function requestPopular() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (page && page.filter) {
        this.request(this.regiaoResources.listarFiltrado, page);
        return;
      }
      this.request(this.regiaoResources.listar, page);
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (!this.canAccessPage) {
      window.setTimeout(function () {
        return _this.accessForbidden();
      }, 1E3);
    }
  }
};

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_RegiaoForm_vue_vue_type_script_lang_js___ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_RegiaoForm_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_RegiaoForm_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_RegiaoForm_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_RegiaoForm_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_RegiaoForm_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(4);

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _Confirm = __webpack_require__(12);

var _Confirm2 = _interopRequireDefault(_Confirm);

var _Regiao = __webpack_require__(604);

var _Regiao2 = _interopRequireDefault(_Regiao);

var _rolesComputedGenerator = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'RegiaoForm',
  data: function data() {
    var _this = this;

    return {
      regiao: new _Regiao2.default(),
      regiaoResources: this.$api.regiao(this.$resource),
      disableButton: false,
      layoutClass: { wrap: true },
      dialog: {
        content: ''
      },
      rules: {
        required: function required(value) {
          return !!value || _this.$t('message.campo_obrigatorio');
        }
      }
    };
  },

  computed: (0, _extends3.default)({}, (0, _rolesComputedGenerator.generateComputed)('Regiao', ['canAccessCRUD'])),
  components: {
    Confirm: _Confirm2.default
  },
  methods: {
    cancel: function cancel() {
      this.limparFormulario();
    },
    editar: function editar(regiao) {
      this.regiao = new _Regiao2.default((0, _extends3.default)({}, regiao));
    },
    limparFormulario: function limparFormulario() {
      this.regiao = new _Regiao2.default();
      this.$refs.form.reset();
    },
    openSaveDialog: function openSaveDialog() {
      if (!this.$refs.form.validate()) return;
      this.dialog.content = this.$t('message.salvar');
      this.$refs.confirmDialog.open();
    },
    save: function save() {
      var _this2 = this;

      var objArmazenamento = (0, _extends3.default)({}, this.regiao);

      var salvarOuAtualizar = void 0;
      var inclusao = true;
      if (this.regiao.id != null) {
        inclusao = false;
        salvarOuAtualizar = this.regiaoResources.atualizar(objArmazenamento);
      } else {
        salvarOuAtualizar = this.regiaoResources.gravar(objArmazenamento);
      }

      salvarOuAtualizar.then(function () {
        return _this2.limparFormulario();
      }).then(function () {
        return _this2.$toast.create(_this2.$t(inclusao ? 'message.adicionado_confira_tabela' : 'message.atualizado_confira_tabela'), 'snack', 3E3);
      }).then(function () {
        _this2.$emit('FORMULARIO_CADASTRO_REGIAO_SALVAR', (0, _assign2.default)({}, _this2.regiao));
      }).catch(function (err) {
        _this2.$error(_this2, err);
      });
    }
  },
  mounted: function mounted() {}
};

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(29);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(43);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Regiao = function () {
  function Regiao() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    (0, _classCallCheck3.default)(this, Regiao);

    if (data) {
      this.id = data.id;
      this.nomRegiao = data.nomRegiao;
      this.indAtivo = data.indAtivo;
      this.codRegiao = data.codRegiao;
    } else {
      this.indAtivo = true;
    }
  }

  (0, _createClass3.default)(Regiao, [{
    key: "construirAPartirDaConsultaCompleta",
    value: function construirAPartirDaConsultaCompleta(dadosDaConsulta) {
      this.id = dadosDaConsulta.id;
      this.nomRegiao = dadosDaConsulta.nomRegiao;
      this.indAtivo = dadosDaConsulta.indAtivo;
      this.codRegiao = dadosDaConsulta.codRegiao;
    }
  }, {
    key: "ehEdicao",
    value: function ehEdicao() {
      return this.id;
    }
  }]);
  return Regiao;
}();

exports.default = Regiao;

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_RegiaoTabela_vue_vue_type_script_lang_js___ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_RegiaoTabela_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_RegiaoTabela_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_RegiaoTabela_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_RegiaoTabela_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_RegiaoTabela_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _rolesComputedGenerator = __webpack_require__(8);

var _Regiao = __webpack_require__(604);

var _Regiao2 = _interopRequireDefault(_Regiao);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      regiaoResources: this.$api.regiao(this.$resource),
      bloquearBotaoExportacao: false,
      regioes: [],
      esperar: false,
      headers: [{ text: this.$tc('label.cod_regiao', 1), value: 'cod_regiao' }, { text: this.$tc('label.nome', 1), value: 'nom_regiao' }, { text: this.$tc('label.ativo', 1), value: 'ind_ativo', sortable: true }, { text: '', value: 'acoes', sortable: false }],
      pagination: {},
      totalPage: 0,
      searchQuery: '',
      registros: [],
      selected: []
    };
  },

  props: {
    title: String
  },
  watch: {
    pagination: {
      handler: function handler() {
        this.filtrar();
      },

      deep: true
    },
    searchQuery: function searchQuery() {
      var _this = this;

      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      this.timeout = window.setTimeout(function () {
        _this.filtrar();
      }, 500);
    }
  },
  computed: (0, _extends3.default)({
    filteredList: function filteredList() {
      return [];
    }
  }, (0, _rolesComputedGenerator.generateComputed)('Regiao', ['canAccessPage', 'canAccessCRUD']), {
    somenteLeitura: function somenteLeitura() {
      return !this.canAccessCRUD;
    }
  }),
  methods: {
    buscar: function buscar() {
      var _this2 = this;

      if (this.searchQuery) {
        this.pagination.page = 1;
      }

      var params = {
        nome: this.searchQuery,
        page: this.pagination.page,
        size: this.pagination.itemsPerPage,
        asc: !this.pagination.sortDesc[0],
        colunaOrdenacao: this.pagination.sortBy[0]
      };

      this.regiaoResources.listar(params).then(function (response) {
        _this2.registros = response.data.resposta;
        _this2.montarObjetoRegiao();
        _this2.totalPage = response.data.quantidadeRegistrosPagina;
        _this2.pararEsperar();
      }, function (err) {
        _this2.pararEsperar();
        _this2.$error(_this2, err);
      });
    },
    exportar: function exportar() {
      var _this3 = this;

      this.bloquearBotaoExportacao = true;
      this.$emit('TABELA_EXPORTAR_DADOS', function () {
        _this3.bloquearBotaoExportacao = false;
      });
    },
    filtrar: function filtrar() {
      var _this4 = this;

      if (this.esperar) return;
      this.esperar = true;
      setTimeout(function () {
        _this4.buscar();
      }, 5E2);
    },
    getSearchQuery: function getSearchQuery() {
      return this.searchQuery;
    },
    montarObjetoRegiao: function montarObjetoRegiao() {
      this.regioes = this.registros.map(function (data) {
        var regiao = new _Regiao2.default();
        regiao.construirAPartirDaConsultaCompleta(data);
        return regiao;
      });
    },
    onEditarRegiao: function onEditarRegiao(regiao) {
      this.$emit('PESQUISA_REGIAO_EDITAR', regiao);
    },
    pararEsperar: function pararEsperar() {
      var _this5 = this;

      setTimeout(function () {
        _this5.esperar = false;
      }, 2E2);
    },
    mudarOrdenacao: function mudarOrdenacao(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    toggleAll: function toggleAll() {
      if (this.selected.length) this.selected = [];else this.selected = this.regioes.slice();
    },
    limparSelecionados: function limparSelecionados() {
      this.selected = [];
    },
    ativarInativarRegistros: function ativarInativarRegistros() {
      var _this6 = this;

      this.selected.forEach(function (item, idx) {
        var resource = item.indAtivo ? _this6.regiaoResources.inativar : _this6.regiaoResources.ativar;

        var id = item.id;

        resource({ id: id }, { id: id }).then(function () {
          if (idx + 1 === _this6.selected.length) {
            _this6.$toast.create(_this6.$t('message.atualizado_confira_tabela'), 'snack', 3E3);
            _this6.limparSelecionados();
            _this6.filtrar();
          }
        }).catch(function (err) {
          _this6.$error(_this6, err);
        });
      });
    }
  },
  mounted: function mounted() {
    this.filtrar();
  }
};

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SellIn_vue_vue_type_script_lang_js___ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SellIn_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SellIn_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SellIn_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SellIn_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SellIn_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(9);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(6);

var _CRUDGenerico = __webpack_require__(23);

var _CRUDGenerico2 = _interopRequireDefault(_CRUDGenerico);

var _SellInLateral = __webpack_require__(1471);

var _SellInLateral2 = _interopRequireDefault(_SellInLateral);

var _SellinTabelaConsolidado = __webpack_require__(1475);

var _SellinTabelaConsolidado2 = _interopRequireDefault(_SellinTabelaConsolidado);

var _SellinTabelaDetalhado = __webpack_require__(1478);

var _SellinTabelaDetalhado2 = _interopRequireDefault(_SellinTabelaDetalhado);

var _rolesComputedGenerator = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'SellIn',
  extends: _CRUDGenerico2.default,
  data: function data() {
    return {
      importacaoVisivel: false,
      tabelaDetalhadoAtiva: false,
      consolidado: null,
      sellInResources: this.$api.sellIn(this.$resource),
      tableHeaderConsolidado: [{
        name: this.$t('label.competencia'),
        tooltip: this.$t('label.competencia'),
        classes: []
      }, {
        name: this.$tc('label.cliente', 1),
        tooltip: this.$tc('label.cliente', 1),
        classes: []
      }, {
        name: this.$t('label.numero_nf'),
        tooltip: this.$t('label.numero_nota_fiscal'),
        classes: ['md-hide-medium']
      }, {
        name: this.$t('label.quantidade'),
        tooltip: this.$t('label.quantidade'),
        classes: ['md-hide-medium']
      }, {
        name: this.$tc('label.valor', 1),
        tooltip: this.$tc('label.valor', 1),
        classes: ['md-hide-medium']
      }],
      tableRowsConsolidado: [],
      paginasConsolidado: 0,
      carregandoConsolidado: false,

      tableHeaderDetalhado: [{
        name: this.$t('label.competencia'),
        tooltip: this.$t('label.competencia'),
        classes: []
      }, {
        name: this.$t('label.numero_nf'),
        tooltip: this.$t('label.numero_nota_fiscal'),
        classes: []
      }, {
        name: this.$tc('label.cliente', 1),
        tooltip: this.$tc('label.cliente', 1),
        classes: []
      }, {
        name: this.$t('label.seq_item'),
        tooltip: this.$t('label.seq_item'),
        classes: []
      }, {
        name: this.$tc('label.produto', 1),
        tooltip: this.$tc('label.produto', 1),
        classes: []
      }, {
        name: this.$t('label.un_medida'),
        tooltip: this.$t('label.unidade_medida'),
        classes: ['md-hide-medium']
      }, {
        name: this.$t('label.qtd'),
        tooltip: this.$t('label.quantidade_produto'),
        classes: ['md-hide-medium']
      }, {
        name: this.$t('label.valor_total'),
        tooltip: this.$t('label.valor_total'),
        classes: []
      }, {
        name: this.$t('label.valor_liquido'),
        tooltip: this.$t('label.valor_liquido'),
        classes: ['md-hide-medium']
      }],
      tableRowsDetalhado: [],
      filtro: null
    };
  },

  computed: (0, _extends3.default)({}, (0, _rolesComputedGenerator.generateComputed)('Sellin', ['canImport', 'canExport']), (0, _vuex.mapGetters)('roles', ['getAllRoles']), {
    canAccessPage: function canAccessPage() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el.startsWith('SELLIN');
      }).length;
    }
  }),
  components: {
    ConteudoSellInConsolidado: _SellinTabelaConsolidado2.default,
    ConteudoSellInDetalhado: _SellinTabelaDetalhado2.default,
    ImportacaoLateral: _SellInLateral2.default
  },
  methods: {
    accessForbidden: function accessForbidden() {
      if (!this.canAccessPage) {
        this.$router.push({ name: 'inicio' });
        this.$toast.create('Acesso negado', 'snack', 3E3);
      }
    },
    toggleImportacao: function toggleImportacao() {
      this.importacaoVisivel = !this.importacaoVisivel;
    },
    organizarConsolidado: function organizarConsolidado(ordenacao) {
      this.organizar(ordenacao, this.tableRowsConsolidado);
    },
    organizarDetalhado: function organizarDetalhado(ordenacao) {
      this.organizar(ordenacao, this.tableRowsDetalhado);
    },
    requestExportacao: function requestExportacao(competencia, cb) {
      if (!this.canExport) {
        return;
      }
      var timeout = 1000 * 60 * 10;
      var limit = 50000;
      var filtros = { ano_mes: competencia };

      this.exportarFiltros(filtros, cb, 'sellin_simples', limit, timeout);
    },
    cleanTableNoResultConsolidado: function cleanTableNoResultConsolidado(cb) {
      this.tableRowsConsolidado = [];
      if (cb) {
        cb();
      }
    },
    requestPopularConsolidadoFiltro: function requestPopularConsolidadoFiltro(filtro) {
      if (filtro) {
        this.filtro = filtro.filter;
        this.requestPopularConsolidado();
      } else {
        this.filtro = null;
      }
    },
    requestPopularConsolidado: function requestPopularConsolidado() {
      var _this = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.tabelaDetalhadoAtiva = false;
      this.consolidado = null;
      var pagination = { size: 10, page: 1 };
      if (page) {
        pagination.page = page;
      }
      if (this.filtro) {
        pagination.filtro = this.filtro;
      }

      this.carregandoConsolidado = true;
      this.sellInResources.listarConsolidado(pagination).then(function (response) {
        _this.tableRowsConsolidado = response.data.resposta;

        var qtdeRegistros = response.data.quantidadeRegistrosPagina;
        _this.paginasConsolidado = Math.ceil(qtdeRegistros / pagination.size);

        _this.carregandoConsolidado = false;
        if (cb) {
          cb();
        }
      }).catch(function (err) {
        _this.$error(_this, err);
        _this.carregandoConsolidado = false;
      });
    },
    requestPopularDetalhado: function requestPopularDetalhado(_ref) {
      var _this2 = this;

      var idcliente = _ref.idcliente,
          competencia = _ref.competencia,
          numeronotafiscal = _ref.numeronotafiscal;
      var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.sellInResources.listarDetalhado({
        nota: numeronotafiscal,
        competencia: competencia,
        idcliente: idcliente,
        filter: filter
      }).then(function (response) {
        var objetos = response.data;
        _this2.tableRowsDetalhado = [];

        if (objetos && objetos.hasOwnProperty('length') && objetos.length) {
          var _tableRowsDetalhado;

          (_tableRowsDetalhado = _this2.tableRowsDetalhado).push.apply(_tableRowsDetalhado, (0, _toConsumableArray3.default)(objetos));
          if (!_this2.tabelaDetalhadoAtiva) {
            _this2.tabelaDetalhadoAtiva = true;
          }
        }
      }).catch(function (err) {
        _this2.$error(_this2, err);
      });
    },
    detalharConsolidado: function detalharConsolidado(consolidado) {
      this.consolidado = consolidado;
      this.tableRowsDetalhado = [];
      this.tabelaDetalhadoAtiva = false;
      this.requestPopularDetalhado(consolidado);
    },
    detalhadoBusca: function detalhadoBusca(filter) {
      this.requestPopularDetalhado(this.consolidado, filter);
    },
    exibirTabConsolidado: function exibirTabConsolidado() {
      this.tabelaDetalhadoAtiva = false;
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    if (!this.canAccessPage) {
      window.setTimeout(function () {
        return _this3.accessForbidden();
      }, 1E3);
    }
    this.requestPopularConsolidado();
  }
};

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SellInLateral_vue_vue_type_script_lang_js___ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SellInLateral_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SellInLateral_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SellInLateral_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SellInLateral_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SellInLateral_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(38);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(6);

var _UploadFile = __webpack_require__(37);

var _UploadFile2 = _interopRequireDefault(_UploadFile);

var _InputDatepicker = __webpack_require__(56);

var _InputDatepicker2 = _interopRequireDefault(_InputDatepicker);

var _importacoes = __webpack_require__(82);

var _rolesComputedGenerator = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'SellInSideColumn',
  props: {
    exibeCancelar: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      dataInicio: '',
      dataFim: ''
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('importacao', {
    tiposImportacao: 'getTiposImportacao'
  }), (0, _rolesComputedGenerator.generateComputed)('Sellin', ['canImport', 'canExport']), {
    showImport: function showImport() {
      if (this.dataInicio === '' || this.dataFim === '') {
        return false;
      }
      var inicio = this.moment(this.dataInicio, 'DD-MM-YYYY');
      var fim = this.moment(this.dataFim, 'DD-MM-YYYY');
      if (inicio > fim) {
        this.$toast.create(this.$t('errors.data.final_antes_inicial'), 'snack', 8E3);
        return false;
      }
      return true;
    },
    tipoImportacao: function tipoImportacao() {
      return this.tiposImportacao.find(function (el) {
        return el.nome === 'importacao_sellin';
      });
    },
    uploadFileDropzoneId: function uploadFileDropzoneId() {
      return 'myVueDropzone' + (Math.random() * Math.random() * 100).toString().replace('.', '');
    },
    importUrl: function importUrl() {
      return _importacoes.basePath + '/importacao';
    }
  }),
  components: {
    UploadFile: _UploadFile2.default,
    InputDatepicker: _InputDatepicker2.default
  },
  methods: {
    enviandoArquivo: function enviandoArquivo(data, xhr, formData) {
      var parametros = { data_inicio: this.dataInicio, data_fim: this.dataFim };

      formData.append('id_tipo_importacao', 8);
      formData.append('parametros', (0, _stringify2.default)(parametros));
    },
    cancelarImportacao: function cancelarImportacao() {
      this.$emit('IMPORTACAO_LATERACAO_CANCELAR');
    },
    dataInicialFormatada: function dataInicialFormatada(dataInicial) {
      this.dataInicio = dataInicial;
    },
    dataFimFormatada: function dataFimFormatada(dataFim) {
      this.dataFim = dataFim;
    },
    dataFimMoment: function dataFimMoment() {},
    uploadError: function uploadError(file, msg) {
      this.$toast.create(msg || this.$t('message.erro_tente_importar_novamente'), 'snack', 5E3);
    },
    uploadSuccess: function uploadSuccess() {
      this.$toast.create(this.$t('message.importado_em_breve_sera_processado'), 'snack', 8E3);
    },
    validarDatas: function validarDatas() {
      if (this.dataInicio === '' || this.dataFim === '') {
        return false;
      }
      var inicio = this.moment(this.dataInicio, 'DD-MM-YYYY');
      var fim = this.moment(this.dataFim, 'DD-MM-YYYY');
      if (inicio > fim) {
        this.$toast.create(this.$t('errors.data.final_antes_inicial'), 'snack', 8E3);
        return false;
      }
      return true;
    }
  }
};

/***/ }),
/* 611 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SellinTabelaConsolidado_vue_vue_type_script_lang_js___ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SellinTabelaConsolidado_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SellinTabelaConsolidado_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SellinTabelaConsolidado_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SellinTabelaConsolidado_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SellinTabelaConsolidado_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(4);

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuejsPaginate = __webpack_require__(27);

var _vuejsPaginate2 = _interopRequireDefault(_vuejsPaginate);

var _mdAutocomplete = __webpack_require__(16);

var _mdAutocomplete2 = _interopRequireDefault(_mdAutocomplete);

var _http = __webpack_require__(22);

var _rolesComputedGenerator = __webpack_require__(8);

var _tabelaCommonsMixin = __webpack_require__(117);

var _tabelaCommonsMixin2 = _interopRequireDefault(_tabelaCommonsMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_tabelaCommonsMixin2.default],
  components: {
    Paginate: _vuejsPaginate2.default,
    mdAutocomplete: _mdAutocomplete2.default
  },
  props: {
    isExportAvailable: {
      type: Boolean,
      default: true
    },
    isSearchAvailable: {
      type: Boolean,
      default: true
    },
    tableHeader: Array
  },
  computed: (0, _extends3.default)({}, (0, _rolesComputedGenerator.generateComputed)('Sellin', ['canImport', 'canExport'])),
  watch: {
    searchQuery: function searchQuery() {
      var _this = this;

      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      this.timeout = window.setTimeout(function () {
        _this.paginationPage = 0;
        _this.filterDatasource();
      }, 500);
    }
  },
  data: function data() {
    return {
      sellInResources: this.$api.sellIn(this.$resource),
      competenciaExportacao: null,
      competenciaExportacaoValor: null,
      blockExportButton: false,

      openSearchToolbar: false,
      searchQuery: '',
      sortData: { name: 'dessert', type: 'desc' },
      periodos: []
    };
  },

  methods: {
    prepareResponseData: _http.prepareResponseData,
    setCompetenciaExportacao: function setCompetenciaExportacao(hit) {
      this.competenciaExportacao = hit.mesAno;
      this.competenciaExportacaoValor = hit.anoMes;
    },
    buscarPeriodos: function buscarPeriodos(filtro) {
      var parametros = (0, _assign2.default)({}, filtro, { size: 5, page: 0 });
      (0, _http.removeParametrosNulos)(parametros);
      return this.sellInResources.periodos(parametros);
    },
    toggleImportacao: function toggleImportacao() {
      this.$emit('SELLINTABELACONSOLIDADO_TOGGLE_IMPORTACAO');
    },
    fechaModalExportacao: function fechaModalExportacao() {
      this.blockExportButton = false;
      this.$refs.modalExportacao.close();
      this.competenciaExportacao = null;
      this.competenciaExportacaoValor = null;
    },
    exportarSellIn: function exportarSellIn() {
      this.blockExportButton = true;
      this.$emit('TABELAGENERICA_EXPORTAR_DADOS', this.competenciaExportacaoValor, this.fechaModalExportacao);
    },
    onSort: function onSort(obj) {
      this.sortData = obj;
      this.$emit('TABELAGENERICA_ORDENAR', this.sortData);
    },
    closeSearchHeader: function closeSearchHeader() {
      this.searchQuery = '';
      this.openSearchToolbar = false;
    },
    focusSearchInput: function focusSearchInput(id) {
      this.openSearchToolbar = true;
      setTimeout(function () {
        var input = document.getElementById(id);
        input.focus();
      }, 100);
    },
    filterDatasource: function filterDatasource() {
      this.showLoading = true;
      this.paginationPage = 1;

      var pagination = {
        size: this.limitePagina,
        page: this.paginationPage,
        filter: this.searchQuery
      };

      (0, _http.removeParametrosNulos)(pagination);

      this.$emit('TABELAGENERICA_BUSCAR_PROXIMA_PAGINA', pagination, this.closeLoading);
    },
    detalharConsolidado: function detalharConsolidado(row) {
      this.$emit('SELLINTABELACONSOLIDADO_DETALHAR', row);
    }
  }
};

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SellinTabelaDetalhado_vue_vue_type_script_lang_js___ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SellinTabelaDetalhado_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SellinTabelaDetalhado_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SellinTabelaDetalhado_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SellinTabelaDetalhado_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SellinTabelaDetalhado_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _TabelaGenerica = __webpack_require__(20);

var _TabelaGenerica2 = _interopRequireDefault(_TabelaGenerica);

var _rolesComputedGenerator = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  extends: _TabelaGenerica2.default,
  props: {
    isExportAvailable: {
      type: Boolean,
      default: true
    },
    isSearchAvailable: {
      type: Boolean,
      default: true
    },
    isPaginationAvailable: {
      type: Boolean,
      default: true
    }
  },
  computed: (0, _extends3.default)({}, (0, _rolesComputedGenerator.generateComputed)('Sellin', ['canImport', 'canExport']), {
    isContentAvailable: function isContentAvailable() {
      return !!this.tableData && !!this.tableData.length;
    },
    filteredList: function filteredList() {
      return [];
    }
  }),
  watch: {
    searchQuery: function searchQuery() {
      var _this = this;

      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      this.timeout = window.setTimeout(function () {
        _this.filterDatasource();
      }, 500);
    }
  },
  methods: {
    filterDatasource: function filterDatasource() {
      this.$emit('SELLINTABELADETALHADO_BUSCA', this.searchQuery);
    },
    formatCurrency: function formatCurrency(val) {
      return (val || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
    },
    formatDecimal: function formatDecimal(val) {
      return (val || 0).toLocaleString('pt-br', { style: 'decimal' });
    },
    formatPercent: function formatPercent(val) {
      return (val / 100 || 0).toLocaleString('pt-br', { style: 'percent' });
    },
    retornarSellInConsolidado: function retornarSellInConsolidado() {
      this.$emit('SELLINTABELACONSOLIDADO_EXIBIR');
    }
  }
};

/***/ }),
/* 616 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SellOut_vue_vue_type_script_lang_js___ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SellOut_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SellOut_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SellOut_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SellOut_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SellOut_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(9);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(6);

var _CRUDGenerico = __webpack_require__(23);

var _CRUDGenerico2 = _interopRequireDefault(_CRUDGenerico);

var _SellOutLateral = __webpack_require__(1486);

var _SellOutLateral2 = _interopRequireDefault(_SellOutLateral);

var _SelloutTabelaConsolidado = __webpack_require__(1490);

var _SelloutTabelaConsolidado2 = _interopRequireDefault(_SelloutTabelaConsolidado);

var _SelloutTabelaDetalhado = __webpack_require__(1493);

var _SelloutTabelaDetalhado2 = _interopRequireDefault(_SelloutTabelaDetalhado);

var _rolesComputedGenerator = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'SellOut',
  extends: _CRUDGenerico2.default,
  data: function data() {
    return {
      tabelaDetalhadoAtiva: false,
      consolidado: null,
      sellOutResources: this.$api.sellOut(this.$resource),
      tableHeaderConsolidado: [{
        name: this.$t('label.competencia'),
        tooltip: this.$t('label.competencia'),
        sortType: 'competencia',
        classes: []
      }, {
        name: this.$t('label.distribuidor'),
        tooltip: this.$t('label.distribuidor'),
        sortType: 'distribuidor',
        classes: ['md-hide-medium']
      }, {
        name: this.$t('label.cnpj_cliente'),
        tooltip: this.$t('label.cnpj_cliente'),
        sortType: 'cnpjcliente',
        classes: []
      }, {
        name: this.$tc('label.cliente', 1),
        tooltip: this.$tc('label.cliente', 1),
        sortType: 'nomecliente',
        classes: []
      }, {
        name: this.$t('label.quantidade'),
        tooltip: this.$t('label.quantidade'),
        sortType: 'quantidadeprodutos',
        classes: ['md-hide-medium']
      }, {
        name: this.$t('label.valor_total'),
        tooltip: this.$tc('label.valor', 1),
        sortType: 'valortotal',
        classes: ['md-hide-medium']
      }],
      tableRowsConsolidado: [],
      tableHeaderDetalhado: [{
        name: this.$t('label.competencia'),
        tooltip: this.$t('label.competencia'),
        sortType: 'competencia',
        classes: []
      }, {
        name: this.$t('label.numero_nf'),
        tooltip: this.$t('label.numero_nota_fiscal'),
        sortType: 'numeronotafiscal',
        classes: []
      }, {
        name: this.$t('label.cnpj_distribuidor'),
        tooltip: this.$t('label.cnpj_distribuidor'),
        sortType: 'cnpjdistribuidor',
        classes: []
      }, {
        name: this.$t('label.distribuidor'),
        tooltip: this.$t('label.distribuidor'),
        sortType: 'distribuidor',
        classes: []
      }, {
        name: this.$t('label.cnpj_loja'),
        tooltip: this.$t('label.cnpj_loja'),
        sortType: 'cnpjloja',
        classes: []
      }, {
        name: this.$tc('label.ean', 1),
        tooltip: this.$tc('label.ean', 1),
        sortType: 'ean',
        classes: []
      }, {
        name: this.$tc('label.produto', 1),
        tooltip: this.$tc('label.produto', 1),
        sortType: 'nomeproduto',
        classes: []
      }, {
        name: this.$t('label.un_medida'),
        tooltip: this.$t('label.unidade_medida'),
        sortType: 'unidademedida',
        classes: ['md-hide-medium']
      }, {
        name: this.$t('label.qtd'),
        tooltip: this.$t('label.quantidade_produto'),
        sortType: 'quantidadeproduto',
        classes: ['md-hide-medium']
      }, {
        name: this.$t('label.valor_unitario'),
        tooltip: this.$t('label.valor_unitario'),
        sortType: 'valorunitario',
        classes: ['md-hide-medium']
      }, {
        name: this.$t('label.valor_total'),
        tooltip: this.$t('label.valor_total'),
        sortType: 'valortotal',
        classes: []
      }, {
        name: this.$t('label.valor_liquido'),
        tooltip: this.$t('label.valor_liquido'),
        sortType: 'valorliquido',
        classes: ['md-hide-medium']
      }],
      tableRowsDetalhado: []
    };
  },

  computed: (0, _extends3.default)({}, (0, _rolesComputedGenerator.generateComputed)('Sellout', ['canImport', 'canExport']), (0, _vuex.mapGetters)('roles', ['getAllRoles']), {
    canAccessPage: function canAccessPage() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el.startsWith('SELLOUT');
      }).length;
    }
  }),
  components: {
    ConteudoSellOutConsolidado: _SelloutTabelaConsolidado2.default,
    ConteudoSellOutDetalhado: _SelloutTabelaDetalhado2.default,
    ImportacaoLateral: _SellOutLateral2.default
  },
  methods: {
    accessForbidden: function accessForbidden() {
      if (!this.canAccessPage) {
        this.$router.push({ name: 'inicio' });
        this.$toast.create('Acesso negado', 'snack', 3E3);
      }
    },
    organizarConsolidado: function organizarConsolidado(ordenacao) {
      this.organizar(ordenacao, this.tableRowsConsolidado);
    },
    organizarDetalhado: function organizarDetalhado(ordenacao) {
      this.organizar(ordenacao, this.tableRowsDetalhado);
    },
    requestExportacao: function requestExportacao(cb) {
      if (!this.canExport) {
        return;
      }
      this.exportar(cb, 'sellout_simples');
    },
    cleanTableNoResultConsolidado: function cleanTableNoResultConsolidado(cb) {
      this.tableRowsConsolidado = [];
      if (cb) {
        cb();
      }
    },
    requestPopularConsolidado: function requestPopularConsolidado() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this = this;

      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      this.tabelaDetalhadoAtiva = false;
      this.consolidado = null;
      var pagination = page || { size: 20, page: 1 };

      this.sellOutResources.listarConsolidado(pagination).then(function (response) {
        var objetos = response.data.resposta;

        if (!objetos.length) {
          if (pagination.page < 2) {
            _this.cleanTableNoResultConsolidado(cb);
          } else if (cb) {
            cb(true);
          }
          return;
        }

        if (objetos && objetos.hasOwnProperty('length') && objetos.length) {
          if (pagination.page < 2) {
            if (source) {
              var _source;

              source = [];
              (_source = source).push.apply(_source, (0, _toConsumableArray3.default)(objetos));
            } else {
              var _tableRowsConsolidado;

              _this.tableRowsConsolidado = [];
              (_tableRowsConsolidado = _this.tableRowsConsolidado).push.apply(_tableRowsConsolidado, (0, _toConsumableArray3.default)(objetos));
            }
          } else {
            var _ref;

            (_ref = source || _this.tableRowsConsolidado).push.apply(_ref, (0, _toConsumableArray3.default)(objetos));
          }
        }
        if (cb) {
          cb();
        }
      }).catch(function (err) {
        _this.$error(_this, err);
      });
    },
    requestPopularDetalhado: function requestPopularDetalhado(_ref2) {
      var _this2 = this;

      var idcliente = _ref2.idcliente,
          competencia = _ref2.competencia,
          numeronotafiscal = _ref2.numeronotafiscal;
      var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.sellOutResources.listarDetalhado({
        nota: numeronotafiscal,
        competencia: competencia,
        idcliente: idcliente,
        filter: filter
      }).then(function (response) {
        var objetos = response.data;
        _this2.tableRowsDetalhado = [];

        if (objetos && objetos.hasOwnProperty('length') && objetos.length) {
          var _tableRowsDetalhado;

          (_tableRowsDetalhado = _this2.tableRowsDetalhado).push.apply(_tableRowsDetalhado, (0, _toConsumableArray3.default)(objetos));
          if (!_this2.tabelaDetalhadoAtiva) {
            _this2.tabelaDetalhadoAtiva = true;
          }
        }
      }).catch(function (err) {
        _this2.$error(_this2, err);
      });
    },
    detalharConsolidado: function detalharConsolidado(consolidado) {
      this.consolidado = consolidado;
      this.tableRowsDetalhado = [];
      this.tabelaDetalhadoAtiva = false;
      this.requestPopularDetalhado(consolidado);
    },
    detalhadoBusca: function detalhadoBusca(filter) {
      this.requestPopularDetalhado(this.consolidado, filter);
    },
    exibirTabConsolidado: function exibirTabConsolidado() {
      this.tabelaDetalhadoAtiva = false;
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    if (!this.canAccessPage) {
      window.setTimeout(function () {
        return _this3.accessForbidden();
      }, 1E3);
    }
  }
};

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SellOutLateral_vue_vue_type_script_lang_js___ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SellOutLateral_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SellOutLateral_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SellOutLateral_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SellOutLateral_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SellOutLateral_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(38);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(6);

var _UploadFile = __webpack_require__(37);

var _UploadFile2 = _interopRequireDefault(_UploadFile);

var _importacoes = __webpack_require__(82);

var _rolesComputedGenerator = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'SellOutSideColumn',
  data: function data() {
    return {
      dataInicio: '',
      dataFim: ''
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('importacao', {
    tiposImportacao: 'getTiposImportacao'
  }), (0, _rolesComputedGenerator.generateComputed)('Sellout', ['canImport', 'canExport']), {
    showImport: function showImport() {
      if (!this.errors.has('data_inicio') && this.dataInicio !== '' && this.dataInicio.length === 10 && !this.errors.has('data_fim') && this.dataFim !== '' && this.dataFim.length === 10) {
        return this.validarDatas();
      }
      return false;
    },
    tipoImportacao: function tipoImportacao() {
      return this.tiposImportacao.find(function (el) {
        return el.nome === 'importacao_sellout';
      });
    },
    uploadFileDropzoneId: function uploadFileDropzoneId() {
      return 'myVueDropzone' + (Math.random() * Math.random() * 100).toString().replace('.', '');
    },
    importUrl: function importUrl() {
      return _importacoes.basePath + '/importacao';
    }
  }),
  components: {
    UploadFile: _UploadFile2.default
  },
  methods: {
    enviandoArquivo: function enviandoArquivo(data, xhr, formData) {
      var parametros = { data_inicio: this.dataInicio, data_fim: this.dataFim };

      formData.append('id_tipo_importacao', 14);
      formData.append('parametros', (0, _stringify2.default)(parametros));
    },
    uploadError: function uploadError(file, msg) {
      this.$toast.create(msg || this.$t('message.erro_tente_importar_novamente'), 'snack', 5E3);
    },
    uploadSuccess: function uploadSuccess() {
      this.$toast.create(this.$t('message.importado_em_breve_sera_processado'), 'snack', 8E3);
    },
    validarDatas: function validarDatas() {
      var inicio = this.moment(this.dataInicio, 'DD-MM-YYYY');
      var fim = this.moment(this.dataFim, 'DD-MM-YYYY');
      if (inicio > fim) {
        this.$toast.create(this.$t('errors.data.final_antes_inicial'), 'snack', 8E3);
        return false;
      }
      return true;
    }
  }
};

/***/ }),
/* 621 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SelloutTabelaConsolidado_vue_vue_type_script_lang_js___ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SelloutTabelaConsolidado_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SelloutTabelaConsolidado_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SelloutTabelaConsolidado_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SelloutTabelaConsolidado_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SelloutTabelaConsolidado_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _TabelaGenerica = __webpack_require__(20);

var _TabelaGenerica2 = _interopRequireDefault(_TabelaGenerica);

var _rolesComputedGenerator = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  extends: _TabelaGenerica2.default,
  props: {
    isExportAvailable: {
      type: Boolean,
      default: true
    },
    isSearchAvailable: {
      type: Boolean,
      default: true
    },
    isPaginationAvailable: {
      type: Boolean,
      default: true
    }
  },
  computed: (0, _extends3.default)({}, (0, _rolesComputedGenerator.generateComputed)('Sellout', ['canImport', 'canExport']), {
    isContentAvailable: function isContentAvailable() {
      return !!this.tableData && !!this.tableData.length;
    },
    filteredList: function filteredList() {
      return [];
    }
  }),
  watch: {
    searchQuery: function searchQuery() {
      var _this = this;

      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      this.timeout = window.setTimeout(function () {
        _this.paginationPage = 0;
        _this.filterDatasource();
      }, 500);
    }
  },
  methods: {
    filterDatasource: function filterDatasource() {
      this.showLoading = true;
      this.paginationPage = 1;

      var pagination = {
        size: this.paginationSize,
        page: this.paginationPage,
        filter: this.searchQuery
      };

      this.$emit('TABELAGENERICA_BUSCAR_PROXIMA_PAGINA', pagination, this.closeLoading);
    },
    formatCurrency: function formatCurrency(val) {
      return (val || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
    },
    formatDecimal: function formatDecimal(val) {
      return (val || 0).toLocaleString('pt-br', { style: 'decimal' });
    },
    formatPercent: function formatPercent(val) {
      return (val || 0).toLocaleString('pt-br', { style: 'percent' });
    },
    detalharConsolidado: function detalharConsolidado(row) {
      this.$emit('SELLOUTTABELACONSOLIDADO_DETALHAR', row);
    }
  }
};

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SelloutTabelaDetalhado_vue_vue_type_script_lang_js___ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SelloutTabelaDetalhado_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SelloutTabelaDetalhado_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SelloutTabelaDetalhado_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SelloutTabelaDetalhado_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SelloutTabelaDetalhado_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _TabelaGenerica = __webpack_require__(20);

var _TabelaGenerica2 = _interopRequireDefault(_TabelaGenerica);

var _rolesComputedGenerator = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  extends: _TabelaGenerica2.default,
  props: {
    isExportAvailable: {
      type: Boolean,
      default: true
    },
    isSearchAvailable: {
      type: Boolean,
      default: true
    },
    isPaginationAvailable: {
      type: Boolean,
      default: true
    }
  },
  computed: (0, _extends3.default)({}, (0, _rolesComputedGenerator.generateComputed)('Sellout', ['canExport', 'canImport']), {
    isContentAvailable: function isContentAvailable() {
      return !!this.tableData && !!this.tableData.length;
    },
    filteredList: function filteredList() {
      return [];
    }
  }),
  watch: {
    searchQuery: function searchQuery() {
      var _this = this;

      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      this.timeout = window.setTimeout(function () {
        _this.filterDatasource();
      }, 500);
    }
  },
  methods: {
    filterDatasource: function filterDatasource() {
      this.$emit('SELLOUTTABELADETALHADO_BUSCA', this.searchQuery);
    },
    formatCurrency: function formatCurrency(val) {
      return (val || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
    },
    formatDecimal: function formatDecimal(val) {
      return (val || 0).toLocaleString('pt-br', { style: 'decimal' });
    },
    formatPercent: function formatPercent(val) {
      return (val / 100 || 0).toLocaleString('pt-br', { style: 'percent' });
    },
    retornarSellOutConsolidado: function retornarSellOutConsolidado() {
      this.$emit('SELLOUTTABELACONSOLIDADO_EXIBIR');
    }
  }
};

/***/ }),
/* 626 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TermoAceiteLista_vue_vue_type_script_lang_js___ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TermoAceiteLista_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TermoAceiteLista_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TermoAceiteLista_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TermoAceiteLista_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TermoAceiteLista_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(6);

var _exportacoes = __webpack_require__(39);

var _exportacoes2 = _interopRequireDefault(_exportacoes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'TermoAceiteLista',
  components: {},
  data: function data() {
    return {
      termoAceiteResources: this.$api.termoAceite(this.$resource),

      pagination: {},
      totalPage: 0,
      searchQuery: '',
      headers: [{ text: this.$tc('label.objetivo', 1), value: 'objetivo', sortable: false }, { text: this.$tc('label.data_inicio', 1), value: 'dataInicio', sortable: false }, { text: this.$tc('label.frequencia', 1), value: 'frequencia', sortable: false }, { text: this.$tc('label.ativo', 1), value: 'indAtivo', sortable: false }],
      termos: []
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('roles', ['getAllRoles']), (0, _vuex.mapGetters)('usuario', ['usuarioLogado']), (0, _vuex.mapGetters)('implantacao', ['indModoVarejo']), {
    idUsuario: function idUsuario() {
      return this.usuarioLogado.id;
    },
    canAccessPage: function canAccessPage() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el.startsWith('TERMO_ACEITE');
      }).length;
    },
    canCRUD: function canCRUD() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el === 'TERMO_ACEITE_CRUD';
      }).length;
    }
  }),
  watch: {
    searchQuery: function searchQuery() {
      var _this = this;

      if (this.timeoutTemp) {
        window.clearTimeout(this.timeoutTemp);
      }
      this.timeoutTemp = window.setTimeout(function () {
        _this.buscarTermos();
      }, 500);
    },

    pagination: {
      handler: function handler() {
        this.buscarTermos();
      },

      deep: true
    }
  },
  methods: {
    accessForbidden: function accessForbidden() {
      this.$router.push({ name: 'inicio' });
      this.$toast.create(this.$t('message.acesso_negado'), 'snack', 3E3);
    },
    abrirForm: function abrirForm() {
      this.$router.push({ name: 'novoTermoAceite' });
    },
    buscarTermos: function buscarTermos() {
      var _this2 = this;

      var params = {
        tamanhoPagina: this.pagination.itemsPerPage || 10,
        numeroPagina: this.pagination.page || 1,
        filter: this.searchQuery
      };

      this.termoAceiteResources.listarFiltrado(params).then(function (response) {
        _this2.termos = response.data.resposta;
        _this2.totalPage = response.data.quantidadeRegistrosPagina;
      }, function (err) {
        _this2.$error(_this2, err);
      });
    },
    editar: function editar(item) {
      this.$router.push({ name: 'editarTermoAceite', params: { id: item.id } });
    },
    verDetalhes: function verDetalhes(item) {
      this.$router.push({ name: 'verTermoAceite', params: { id: item.id } });
    },
    ativarInativar: function ativarInativar(item) {
      var _this3 = this;

      var codigo = item.id;
      this.termoAceiteResources.ativacao({ codigo: codigo }, { codigo: codigo }).then(function () {
        item.indAtivo = !item.indAtivo;
        _this3.$toast.create(_this3.$t('message.atualizado_confira_tabela'), 'snack', 3E3);
      }, function (err) {
        _this3.$error(_this3, err);
      });
    },
    requestExportacao: function requestExportacao(cb) {
      this.exportar(cb, 'termo_aceite_usuario');
    },
    exportar: function exportar(cb, nomeExportador) {
      var _this4 = this;

      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 500;
      var timeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 120000;

      var resource = (0, _exportacoes2.default)(this.$http, timeout);
      var payload = this.idUsuario && nomeExportador === 'termo_aceite_usuario' ? { parametrosConsulta: {
          idUsuario: this.idUsuario
        },
        limit: limit
      } : { limit: limit };
      resource.download(nomeExportador, payload).then(function () {
        _this4.$toast.create(_this4.$t('message.exportacao_download'), 'snack', 3E3);
      }).catch(function () {
        _this4.$toast.create('Erro ao exportar. Tente novamente.', 'snack', 3E3);
      });
    }
  },
  beforeMount: function beforeMount() {
    var _this5 = this;

    if (!this.canAccessPage) {
      window.setTimeout(function () {
        _this5.accessForbidden();
      }, 1E3);
    }
  },
  mounted: function mounted() {
    if (this.indModoVarejo) {
      this.headers.unshift({ text: this.$tc('label.acoes', 2), value: 'acoes', width: '2%', sortable: false }, { text: this.$tc('label.descricao', 1), value: 'descricao', sortable: false }, { text: this.$tc('label.grupo_fornecedor', 1), value: 'grupos_fornecedor', sortable: false });
    } else {
      this.headers.unshift({ text: this.$tc('label.acoes', 2), value: 'acoes', width: '2%', sortable: false }, { text: this.$tc('label.descricao', 1), value: 'descricao', sortable: false }, { text: this.$tc('label.unidade_negocio', 1), value: 'unidade_negocio', sortable: false });
    }
  }
};

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TermoAceiteForm_vue_vue_type_script_lang_js___ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TermoAceiteForm_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TermoAceiteForm_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TermoAceiteForm_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TermoAceiteForm_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TermoAceiteForm_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(4);

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(6);

var _dateUtils = __webpack_require__(30);

var _autocompleteUtils = __webpack_require__(1507);

var _Confirm = __webpack_require__(12);

var _Confirm2 = _interopRequireDefault(_Confirm);

var _Editor = __webpack_require__(1508);

var _Editor2 = _interopRequireDefault(_Editor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'TermoAceiteForm',
  components: {
    Confirm: _Confirm2.default,
    Editor: _Editor2.default
  },
  props: {
    somenteLeitura: { type: Boolean, default: false },
    criarNovoTermoAceite: { type: Boolean }
  },
  data: function data() {
    var _this = this;

    return {
      extensaoResources: this.$api.extensao(this.$resource),
      termoAceiteResources: this.$api.termoAceite(this.$resource),

      rules: {
        required: function required(value) {
          return !!value || _this.$t('message.campo_obrigatorio');
        },
        validDate: function validDate(value) {
          return !value || value.length === 10 && _this.moment(value, 'DD-MM-YYYY').isValid() || _this.$t('message.data_invalida');
        }
      },
      objetivos: [{ text: this.$t('label.primeiro_acesso'), value: 'PRIMEIRO_ACESSO' }, { text: this.$t('label.revalidacao'), value: 'REVALIDACAO' }],
      objetivosSemRevalidacao: [{ text: this.$t('label.primeiro_acesso'), value: 'PRIMEIRO_ACESSO' }],
      frequencias: [{ text: this.$t('label.sempre'), value: 'SEMPRE' }, { text: this.$t('label.unica_vez'), value: 'UNICA_VEZ' }],
      tiposUsuario: [{ text: this.$tc('label.fornecedor', 1), value: 'FORNECEDOR' }, { text: this.$tc('label.cliente', 1), value: 'CLIENTE' }],
      termo: {
        descricao: '',
        objetivo: undefined,
        frequencia: undefined,
        unidades: [],
        gruposFornecedor: [],
        tipoUsuario: undefined,
        conteudo: ''
      },
      menuDataInicio: false,
      dataInicio: '',
      unidades: [],
      gruposFornecedor: [],
      triggerGrupoFornecedor: null,
      timeoutTrigger: null
    };
  },

  watch: {
    triggerGrupoFornecedor: function triggerGrupoFornecedor(val) {
      var _this2 = this;

      if (this.timeoutTrigger) {
        window.clearTimeout(this.timeoutTrigger);
      }
      this.timeoutTrigger = window.setTimeout(function () {
        if (val != null) _this2.buscarGruposFornecedores(val);
      }, 500);
    }
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('roles', ['getAllRoles']), (0, _vuex.mapGetters)('implantacao', ['indModoVarejo']), {
    canAccessPage: function canAccessPage() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el.startsWith('TERMO_ACEITE');
      }).length;
    },

    dateInicioFormatada: {
      get: function get() {
        return (0, _dateUtils.formatDateDDMMYYYY)(this.dataInicio);
      },
      set: function set(newValue) {
        this.dataInicio = (0, _dateUtils.parseDateYYYYMMDD)(newValue);
      }
    }
  }),
  methods: {
    buscaAutocomplete: _autocompleteUtils.buscaAutocomplete,
    triggerSelecao: _autocompleteUtils.triggerSelecao,
    accessForbidden: function accessForbidden() {
      this.$router.push({ name: 'inicio' });
      this.$toast.create(this.$t('message.acesso_negado'), 'snack', 3E3);
    },
    buscarUnidades: function buscarUnidades() {
      var _this3 = this;

      var value = {
        tamanhoPagina: 1000,
        idNivelExtensao: 1
      };
      return this.extensaoResources.listarPorUsuario(value).then(function (resultado) {
        _this3.unidades = resultado.data.resposta;
      });
    },
    buscarGruposFornecedores: function buscarGruposFornecedores() {
      var _this4 = this;

      var filtro = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var value = {
        tamanhoPagina: 5000,
        idNivelExtensao: 3,
        nome: filtro
      };
      return this.extensaoResources.listarAtivos(value).then(function (resultado) {
        _this4.gruposFornecedor = resultado.data.resposta;
      });
    },
    abrirDialogSalvar: function abrirDialogSalvar() {
      if (!this.$refs.form.validate()) return;
      var texto = this.$refs.editor.getTexto();
      if (!texto || texto === '' || texto === ' ') {
        this.$toast.create(this.$t('message.insira_conteudo'), 'snack', 3E3);
        return;
      }
      this.$refs.confirmDialog.open();
    },
    salvar: function salvar() {
      var _this5 = this;

      this.$refs.confirmDialog.close();
      this.termo.idsExtensoes = [];
      if (this.indModoVarejo) {
        this.termo.idsExtensoes = this.termo.idsExtensoes.concat(this.termo.gruposFornecedor.map(function (el) {
          return el.id;
        }));
      } else {
        this.termo.idsExtensoes = this.termo.idsExtensoes.concat(this.termo.unidades.map(function (el) {
          return el.id;
        }));
      }
      this.termo.dataInicio = this.dataInicio;
      this.termo.conteudo = this.$refs.editor.getTexto();

      if (this.termo.id) {
        this.termoAceiteResources.atualizar(this.termo).then(function () {
          _this5.$router.push({ name: 'termo-aceite' });
          _this5.$toast.create(_this5.$t('message.atualizado_confira_tabela'), 'snack', 3E3);
        }).catch(function (err) {
          _this5.$toast.create(err.data.error, 'snack', 3E3);
        });
      } else {
        this.termoAceiteResources.gravar(this.termo).then(function () {
          _this5.$router.push({ name: 'termo-aceite' });
          _this5.$toast.create(_this5.$t('message.adicionado_confira_tabela'), 'snack', 3E3);
        }).catch(function (err) {
          _this5.$toast.create(err.data.error, 'snack', 3E3);
        });
      }
    },
    cancelar: function cancelar() {
      this.$router.push({ name: 'termo-aceite' });
    },
    carregarTermo: function carregarTermo(id) {
      var _this6 = this;

      this.termoAceiteResources.buscar({ id: id }).then(function (res) {
        _this6.termo = (0, _assign2.default)({}, _this6.termo, res.body);
        _this6.dataInicio = _this6.termo.dataInicio;
        if (_this6.indModoVarejo) {
          _this6.termo.gruposFornecedor = [];
          if (_this6.termo.idsExtensoes && _this6.termo.idsExtensoes.length) {
            _this6.gruposFornecedor.forEach(function (gf) {
              if (_this6.termo.idsExtensoes.indexOf(gf.id) !== -1) {
                _this6.termo.gruposFornecedor.push(gf);
              }
            });
          }
        } else {
          _this6.termo.unidades = [];
          _this6.unidades.forEach(function (u) {
            if (_this6.termo.idsExtensoes.indexOf(u.id) !== -1) {
              _this6.termo.unidades.push(u);
            }
          });
        }
        window.setTimeout(function () {
          _this6.$refs.editor.setTexto(_this6.termo.conteudo);
        }, 1000);
      }).catch(function (err) {
        _this6.$error(_this6, err);
      });
    }
  },
  mounted: function mounted() {
    var _this7 = this;

    if (this.indModoVarejo) {
      this.termo.tipoUsuario = 'FORNECEDOR';
      this.termo.objetivo = 'PRIMEIRO_ACESSO';
      this.buscarGruposFornecedores().then(function () {
        var id = _this7.$route.params.id;
        if (id) {
          _this7.carregarTermo(id);
        }
      });
    } else {
      this.termo.tipoUsuario = 'CLIENTE';
      this.termo.objetivo = 'PRIMEIRO_ACESSO';
      this.buscarUnidades().then(function () {
        var id = _this7.$route.params.id;
        if (id) {
          _this7.carregarTermo(id);
        }
      });
    }
  },
  beforeMount: function beforeMount() {
    var _this8 = this;

    if (!this.canAccessPage) {
      window.setTimeout(function () {
        _this8.accessForbidden();
      }, 1E3);
    }
  }
};

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Editor_vue_vue_type_script_lang_js___ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Editor_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Editor_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Editor_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Editor_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Editor_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jszip = __webpack_require__(705);

var _jszip2 = _interopRequireDefault(_jszip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    id: { type: String, default: 'editor' },
    texto: { type: String, default: '' }
  },
  data: function data() {
    return {
      editor: undefined
    };
  },

  methods: {
    criar: function criar() {
      this.editor = $('#' + this.id).kendoEditor();
    },
    startKendoUI: function startKendoUI() {
      window.kendo.culture('pt-BR');
      this.criar();
    },
    getTexto: function getTexto() {
      return this.editor.data('kendoEditor').value();
    },
    setTexto: function setTexto(valor) {
      if (this.editor) {
        this.editor.data('kendoEditor').value(valor);
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    window.JSZip = _jszip2.default;
    if (window.kendo) {
      this.startKendoUI();
      return;
    }

    $.getScript('static/js/kendoui/kendoui.js', function () {
      _this.startKendoUI();
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80)))

/***/ }),
/* 633 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 634 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 635 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TermoAceiteRealizado_vue_vue_type_script_lang_js___ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TermoAceiteRealizado_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TermoAceiteRealizado_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TermoAceiteRealizado_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TermoAceiteRealizado_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TermoAceiteRealizado_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'TermoAceiteRealizado',
  data: function data() {
    return {
      termoAceiteResources: this.$api.termoAceite(this.$resource),

      items: [],
      termo: {},
      pagination: {
        rowsPerPage: 10
      },
      totalPage: 0,
      searchQuery: ''
    };
  },

  computed: {},
  watch: {
    searchQuery: function searchQuery() {
      var _this = this;

      if (this.timeoutTemp) {
        window.clearTimeout(this.timeoutTemp);
      }
      this.timeoutTemp = window.setTimeout(function () {
        _this.buscarTermos();
      }, 500);
    },

    pagination: {
      handler: function handler() {
        this.buscarTermos();
      },

      deep: true
    }
  },
  methods: {
    buscarTermos: function buscarTermos() {
      var _this2 = this;

      var params = {
        tamanhoPagina: this.pagination.itemsPerPage || 10,
        numeroPagina: this.pagination.page || 1,
        filter: this.searchQuery
      };

      this.termoAceiteResources.listarRealizados(params).then(function (response) {
        _this2.items = response.data.resposta;
        _this2.totalPage = response.data.quantidadeRegistrosPagina;
      }, function (err) {
        _this2.$error(_this2, err);
      });
    },
    selecionar: function selecionar(item) {
      this.termo = item;
    }
  },
  mounted: function mounted() {}
};

/***/ }),
/* 638 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoAcao_vue_vue_type_script_lang_js___ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoAcao_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoAcao_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoAcao_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoAcao_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoAcao_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _CRUDGenerico = __webpack_require__(23);

var _CRUDGenerico2 = _interopRequireDefault(_CRUDGenerico);

var _TipoAcaoLateral = __webpack_require__(1522);

var _TipoAcaoLateral2 = _interopRequireDefault(_TipoAcaoLateral);

var _TipoAcaoTabela = __webpack_require__(1525);

var _TipoAcaoTabela2 = _interopRequireDefault(_TipoAcaoTabela);

var _rolesComputedGenerator = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'TipoAcao',
  extends: _CRUDGenerico2.default,
  data: function data() {
    return {
      tipoAcaoResources: this.$api.tipoAcao(this.$resource),
      tableHeader: [{
        name: this.$t('label.codigo'),
        tooltip: this.$t('label.codigo'),
        sortType: 'idExterno',
        classes: []
      }, {
        name: this.$t('label.nome'),
        tooltip: this.$t('label.nome'),
        sortType: 'nome',
        classes: []
      }, {
        name: this.$tc('label.tipo_provisao', 1),
        tooltip: this.$tc('label.tipo_provisao', 1),
        sortType: 'tipo',
        classes: []
      }],
      tableRows: []
    };
  },

  components: {
    TipoAcaoLateral: _TipoAcaoLateral2.default,
    TipoAcaoTabela: _TipoAcaoTabela2.default
  },
  computed: (0, _extends3.default)({}, (0, _rolesComputedGenerator.generateComputed)('Tipo Acao', ['canAccessPage', 'canAccessCRUD'])),
  methods: {
    accessForbidden: function accessForbidden() {
      if (!this.canAccessPage) {
        this.$router.push({ name: 'inicio' });
        this.$toast.create('Acesso negado', 'snack', 3E3);
      }
    },
    alterarTamanhoPagina: function alterarTamanhoPagina(valor) {
      this.requestPopular({ size: valor, page: 1 });
    },
    requestAdicionar: function requestAdicionar(objeto) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.requestAdicionarGenerico(this.tipoAcaoResources.gravar, objeto, cb);
    },
    requestAtivarInativar: function requestAtivarInativar(index) {
      var row = this.tableRows[index],
          id = row.id;
      return this.requestAtivarInativarGenerico(row, id, this.tipoAcaoResources);
    },
    requestAtualizar: function requestAtualizar(objeto) {
      this.requestAtualizarGenerico(this.tipoAcaoResources.atualizar, objeto);
    },
    requestExportacao: function requestExportacao(cb) {
      this.exportar(cb, 'tipo_acao_simples');
    },
    requestPopular: function requestPopular() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.requestPopularGenerico(this.tipoAcaoResources.listar, page, cb);
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (!this.canAccessPage) {
      window.setTimeout(function () {
        return _this.accessForbidden();
      }, 1E3);
    }
  }
};

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoAcaoLateral_vue_vue_type_script_lang_js___ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoAcaoLateral_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoAcaoLateral_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoAcaoLateral_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoAcaoLateral_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoAcaoLateral_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(4);

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _RegisterForm = __webpack_require__(36);

var _RegisterForm2 = _interopRequireDefault(_RegisterForm);

var _helpers = __webpack_require__(5);

var _rolesComputedGenerator = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'TipoAcaoSideColumn',
  data: function data() {
    return {
      dialog: {
        ref: 'dialog1',
        from: 'saveRegisterFromButton',
        title: this.$t('label.atencao'),
        content: '',
        action: function action() {}
      },
      disableButton: false,
      originalTipoAcao: {
        nome: '',
        idExterno: null,
        indAtivo: true
      },
      tipoAcao: {
        nome: '',
        idExterno: null,
        indAtivo: true,
        tipo: 'MARGEM'
      },
      tipos: [{ tipo: 'FIXO', descricao: this.$t('label.gasto_fixo') }, { tipo: 'MARGEM', descricao: this.$t('label.margem') }]
    };
  },

  components: {
    RegisterForm: _RegisterForm2.default
  },
  computed: (0, _extends3.default)({}, (0, _rolesComputedGenerator.generateComputed)('Tipo Acao', ['canAccessCRUD'])),
  methods: {
    cancel: function cancel() {
      this.$emit('SIDECOLUMN_CANCEL_ACTION');
      this.clearForm();
    },
    clearForm: function clearForm() {
      var _this = this;

      this.tipoAcao = (0, _helpers.copyObject)(this.originalTipoAcao);
      setTimeout(function () {
        _this.errors.clear();
        _this.source = [];
      }, 1E2);
    },
    closeDialog: function closeDialog(ref, cb) {
      this.$refs[ref].close();
      if (cb) {
        cb();
      }
    },
    openDialog: function openDialog(ref) {
      this.$refs[ref].open();
    },
    openSaveDialog: function openSaveDialog(ref, from) {
      var _this2 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (!isValid) {
          return;
        }
        var content = _this2.$t('message.salvar_novo_tipo_acao');
        _this2.setDialogContent(content, _this2.save, from || _this2.dialog.from);
        _this2.openDialog(ref || _this2.dialog.ref);
      });
    },
    save: function save(item) {
      var tipoAcao = (0, _assign2.default)({}, item || this.tipoAcao);
      this.$emit('SIDECOLUMN_SAVE_ACTION', tipoAcao, this.clearForm);
    },
    setDialogContent: function setDialogContent(content, action, from) {
      this.dialog.content = content || this.$t('message.salvar_novo_registro');
      this.dialog.action = action || this.save;
      this.dialog.from = from || this.dialog.from;
    }
  },
  mounted: function mounted() {
    this.originalTipoAcao = (0, _helpers.copyObject)(this.tipoAcao);
  }
};

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoAcaoTabela_vue_vue_type_script_lang_js___ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoAcaoTabela_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoAcaoTabela_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoAcaoTabela_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoAcaoTabela_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoAcaoTabela_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _TabelaGenerica = __webpack_require__(20);

var _TabelaGenerica2 = _interopRequireDefault(_TabelaGenerica);

var _rolesComputedGenerator = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  extends: _TabelaGenerica2.default,
  computed: (0, _extends3.default)({}, (0, _rolesComputedGenerator.generateComputed)('Tipo Acao', ['canAccessCRUD'])),
  watch: {
    paginationSize: function paginationSize(valor) {
      this.$emit('PAGINACAO_ALTERANDO_TAMANHO_PAGINA', valor);
    }
  },
  data: function data() {
    return {
      tipos: [{ tipo: 'FIXO', descricao: this.$t('label.gasto_fixo') }, { tipo: 'MARGEM', descricao: this.$t('label.margem') }]
    };
  }
};

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoInvestimento_vue_vue_type_script_lang_js___ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoInvestimento_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoInvestimento_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoInvestimento_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoInvestimento_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoInvestimento_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _rolesComputedGenerator = __webpack_require__(8);

var _TipoInvestimentoForm = __webpack_require__(1532);

var _TipoInvestimentoForm2 = _interopRequireDefault(_TipoInvestimentoForm);

var _TipoInvestimentoTabela = __webpack_require__(1535);

var _TipoInvestimentoTabela2 = _interopRequireDefault(_TipoInvestimentoTabela);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'TipoInvestimento',
  data: function data() {
    return {
      tipoInvestimentoResources: this.$api.tipoInvestimento(this.$resource)
    };
  },

  components: {
    TipoInvestimentoForm: _TipoInvestimentoForm2.default,
    TipoInvestimentoTabela: _TipoInvestimentoTabela2.default
  },
  computed: (0, _extends3.default)({}, (0, _rolesComputedGenerator.generateComputed)('tipo linha', ['canAccessCRUD', 'canAccessPage']), {
    somenteLeitura: function somenteLeitura() {
      return !this.canAccessCRUD;
    }
  }),
  methods: {
    accessForbidden: function accessForbidden() {
      if (!this.canAccessPage) {
        this.$router.push({ name: 'inicio' });
        this.$toast.create(this.$t('message.acesso_negado'), 'snack', 3E3);
      }
    },
    onCancelar: function onCancelar() {
      this.$refs.tipoInvestimentoTabela.filtrar();
    },
    onEditar: function onEditar(item) {
      this.$refs.tipoInvestimentoForm.editar(item);
    },
    onNovo: function onNovo() {
      this.$refs.tipoInvestimentoTabela.filtrar();
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;

    if (!this.canAccessPage) {
      window.setTimeout(function () {
        _this.accessForbidden();
      }, 1E3);
    }
  }
};

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoInvestimentoForm_vue_vue_type_script_lang_js___ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoInvestimentoForm_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoInvestimentoForm_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoInvestimentoForm_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoInvestimentoForm_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoInvestimentoForm_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(4);

var _assign2 = _interopRequireDefault(_assign);

var _Confirm = __webpack_require__(12);

var _Confirm2 = _interopRequireDefault(_Confirm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'TipoInvestimentoForm',
  data: function data() {
    var _this = this;

    return {
      tipoInvestimentoResources: this.$api.tipoInvestimento(this.$resource),
      dialog: {
        content: ''
      },
      rules: {
        required: function required(value) {
          return !!value || _this.$t('message.campo_obrigatorio');
        }
      },
      tipoInvestimento: {}
    };
  },

  watch: {},
  components: {
    Confirm: _Confirm2.default
  },
  computed: {
    ehEdicao: function ehEdicao() {
      return this.tipoInvestimento.id;
    }
  },
  methods: {
    cancel: function cancel() {
      this.limparFormulario();
      this.$emit('FORMULARIO_CANCELAR');
    },
    editar: function editar(item) {
      this.tipoInvestimento = item;
    },
    limparFormulario: function limparFormulario() {
      this.tipoInvestimento = {};
      this.$refs.form.reset();
    },
    openSaveDialog: function openSaveDialog() {
      if (!this.$refs.form.validate()) return;
      this.dialog.content = this.$t('message.salvar');
      this.$refs.confirmDialog.open();
    },
    save: function save() {
      var _this2 = this;

      var salvarOuAtualizar = void 0;
      var inclusao = true;
      if (this.tipoInvestimento.id) {
        inclusao = false;
        salvarOuAtualizar = this.tipoInvestimentoResources.atualizar(this.tipoInvestimento);
      } else {
        salvarOuAtualizar = this.tipoInvestimentoResources.gravar(this.tipoInvestimento);
      }

      salvarOuAtualizar.then(function () {
        return _this2.limparFormulario();
      }).then(function () {
        return _this2.$toast.create(_this2.$t(inclusao ? 'message.adicionado_confira_tabela' : 'message.atualizado_confira_tabela'), 'snack', 3E3);
      }).then(function () {
        _this2.$emit('FORMULARIO_SALVAR', (0, _assign2.default)({}, _this2.tipoInvestimento));
      }).catch(function (err) {
        _this2.$error(_this2, err);
      });
    }
  },
  mounted: function mounted() {}
};

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoInvestimentoTabela_vue_vue_type_script_lang_js___ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoInvestimentoTabela_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoInvestimentoTabela_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoInvestimentoTabela_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoInvestimentoTabela_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoInvestimentoTabela_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _rolesComputedGenerator = __webpack_require__(8);

var _exportacoes = __webpack_require__(39);

var _exportacoes2 = _interopRequireDefault(_exportacoes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      tipoInvestimentoResources: this.$api.tipoInvestimento(this.$resource),
      tipos: [],
      esperar: false,
      headers: [{ text: '', value: 'acoes', width: '2%', sortable: false }, { text: this.$tc('label.codigo', 1), value: 'id_externo', sortable: true }, { text: this.$tc('label.nome', 1), value: 'nome', sortable: true }, { text: this.$tc('label.ativo', 1), value: 'ind_ativo', sortable: true }],
      pagination: {},
      totalPage: 0,
      searchQuery: '',
      selected: []
    };
  },

  props: {
    title: String
  },
  watch: {
    pagination: {
      handler: function handler() {
        this.filtrar();
      },

      deep: true
    },
    searchQuery: function searchQuery() {
      var _this = this;

      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      this.timeout = window.setTimeout(function () {
        _this.filtrar();
      }, 500);
    }
  },
  computed: (0, _extends3.default)({
    filteredList: function filteredList() {
      return [];
    }
  }, (0, _rolesComputedGenerator.generateComputed)('tipo_linha', ['canAccessCRUD', 'canAccessPage']), {
    somenteLeitura: function somenteLeitura() {
      return !this.canAccessCRUD;
    }
  }),
  methods: {
    buscar: function buscar() {
      var _this2 = this;

      if (this.searchQuery) {
        this.pagination.page = 1;
      }

      var params = {
        texto: this.searchQuery,
        page: this.pagination.page,
        size: this.pagination.itemsPerPage,
        asc: !this.pagination.sortDesc[0],
        colunaOrdenacao: this.pagination.sortBy[0]
      };

      this.tipoInvestimentoResources.listar(params).then(function (response) {
        _this2.tipos = response.data.resposta;
        _this2.totalPage = response.data.quantidadeRegistrosPagina;
        _this2.pararEsperar();
      }, function (err) {
        _this2.pararEsperar();
        _this2.$error(_this2, err);
      });
    },
    filtrar: function filtrar() {
      var _this3 = this;

      if (this.esperar) return;
      this.esperar = true;
      setTimeout(function () {
        _this3.buscar();
      }, 5E2);
    },
    onEditar: function onEditar(item) {
      this.$emit('PESQUISA_EDITAR', item);
    },
    pararEsperar: function pararEsperar() {
      var _this4 = this;

      setTimeout(function () {
        _this4.esperar = false;
      }, 2E2);
    },
    mudarOrdenacao: function mudarOrdenacao(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    toggleAll: function toggleAll() {
      if (this.selected.length) this.selected = [];else this.selected = this.tipos.slice();
    },
    ativarDesativarRegistros: function ativarDesativarRegistros() {
      this.requestAtivarInativar();
    },
    requestAtivarInativar: function requestAtivarInativar() {
      var _this5 = this;

      if (this.selected && this.selected.length > 0) {
        this.tipoInvestimentoResources.ativarMassa(this.selected).then(function () {
          _this5.selected = [];
          _this5.$toast.create(_this5.$t('message.alteracao_massa_sucesso'), 'snack', 3E3);
          _this5.filtrar();
        }).catch(function (err) {
          return _this5.$error(_this5, err);
        });
      }
    },
    exportar: function exportar() {
      var _this6 = this;

      var filtros = {};
      var limit = 500;
      var timeout = 120000;
      var resource = (0, _exportacoes2.default)(this.$http, timeout);
      resource.download('tipo_investimento_simples', {
        limit: limit,
        parametrosConsulta: filtros
      }).then(function () {
        _this6.$toast.create(_this6.$t('message.exportacao_download'), 'snack', 3E3);
      }).catch(function () {
        if (cb) {
          cb();
        }
        _this6.$toast.create('Erro ao exportar. Tente novamente.', 'snack', 3E3);
      });
    }
  },
  mounted: function mounted() {
    this.filtrar();
  }
};

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoOrcamento_vue_vue_type_script_lang_js___ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoOrcamento_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoOrcamento_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoOrcamento_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoOrcamento_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoOrcamento_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(4);

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _CRUDGenerico = __webpack_require__(23);

var _CRUDGenerico2 = _interopRequireDefault(_CRUDGenerico);

var _SideColumn = __webpack_require__(1542);

var _SideColumn2 = _interopRequireDefault(_SideColumn);

var _TipoOrcamentoTabela = __webpack_require__(1545);

var _TipoOrcamentoTabela2 = _interopRequireDefault(_TipoOrcamentoTabela);

var _helpers = __webpack_require__(5);

var _rolesComputedGenerator = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'TipoOrcamento',
  extends: _CRUDGenerico2.default,
  data: function data() {
    return {
      tipoInvestimentoResources: this.$api.tipoInvestimento(this.$resource),
      tipoOrcamentoResources: this.$api.tipoOrcamento(this.$resource),
      tableHeader: [{
        name: this.$t('label.codigo'),
        tooltip: this.$t('label.cod_tipo_orcamento'),
        sortType: 'idExterno',
        classes: ['md-hide-medium']
      }, {
        name: this.$t('label.nome'),
        tooltip: this.$t('label.nome_tipo_orcamento'),
        sortType: 'descricao',
        classes: []
      }, {
        name: this.$tc('label.tipo_investimento', 2),
        tooltip: this.$t('label.tipo_investimento_tipo_orcamento'),
        sortType: 'tiposInvestimento',
        classes: ['md-hide-medium']
      }],
      tableRows: []
    };
  },

  computed: (0, _extends3.default)({}, (0, _rolesComputedGenerator.generateComputed)('Tipo Orc', ['canAccessPage', 'canAccessCRUD'])),
  components: {
    SideColumn: _SideColumn2.default,
    TipoOrcamentoTabela: _TipoOrcamentoTabela2.default
  },
  methods: {
    accessForbidden: function accessForbidden() {
      if (!this.canAccessPage) {
        this.$router.push({ name: 'inicio' });
        this.$toast.create('Acesso negado', 'snack', 3E3);
      }
    },
    requestAdicionar: function requestAdicionar(objeto) {
      var _this = this;

      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var payload = (0, _helpers.copyObject)(objeto);
      payload.tiposInvestimento = objeto.tiposInvestimento.map(function (el) {
        return el.id;
      });

      this.tipoOrcamentoResources.gravar(payload).then(function (docs) {
        objeto.id = docs.data.id;
        _this.tableRows.unshift(objeto);
        _this.$toast.create(_this.$t('message.adicionado_confira_tabela'), 'snack', 3E3);
        if (cb) {
          cb();
        }
      }).catch(function (err) {
        _this.$error(_this, err);
      });
    },
    requestAtivarInativar: function requestAtivarInativar(index) {
      var row = this.tableRows[index],
          id = row.id;
      return this.requestAtivarInativarGenerico(row, id, this.tipoOrcamentoResources);
    },
    requestAtualizar: function requestAtualizar(objeto) {
      var _this2 = this;

      var payload = (0, _assign2.default)({}, objeto);

      payload.tiposInvestimento = objeto.tiposInvestimento.map(function (el) {
        return el.id;
      });

      delete payload.dependencias;

      this.tipoOrcamentoResources.atualizar(payload).then(function () {
        _this2.$toast.create(_this2.$t('message.atualizado_confira_tabela'), 'snack', 3E3);
        _this2.atualizar(objeto);
      }).catch(function (err) {
        _this2.$error(_this2, err);
      });
    },
    requestExportacao: function requestExportacao(cb) {
      this.exportar(cb, 'tipo_orcamento_simples');
    },
    requestPopular: function requestPopular() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.requestPopularGenerico(this.tipoOrcamentoResources.listar, page, cb);
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    if (!this.canAccessPage) {
      window.setTimeout(function () {
        return _this3.accessForbidden();
      }, 1E3);
    }
  }
};

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SideColumn_vue_vue_type_script_lang_js___ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SideColumn_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SideColumn_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SideColumn_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SideColumn_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_SideColumn_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(4);

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _UploadFile = __webpack_require__(37);

var _UploadFile2 = _interopRequireDefault(_UploadFile);

var _RegisterForm = __webpack_require__(36);

var _RegisterForm2 = _interopRequireDefault(_RegisterForm);

var _mdChipsAutocomplete = __webpack_require__(65);

var _mdChipsAutocomplete2 = _interopRequireDefault(_mdChipsAutocomplete);

var _helpers = __webpack_require__(5);

var _rolesComputedGenerator = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'TipoOrcamentoSideColumn',
  props: {
    fetchFunction: Function,
    prepareResponseData: Function
  },
  data: function data() {
    return {
      chipsTipoInvestimento: [],
      dialog: {
        ref: 'dialog1',
        from: 'saveRegisterFromButton',
        title: this.$t('label.atencao'),
        content: '',
        action: function action() {}
      },
      disableButton: false,
      tipoOrcamento: {
        indAtivo: true,
        idExterno: '',
        nome: '',
        tiposInvestimento: []
      },
      originalTipoOrcamento: null,
      source: []
    };
  },

  computed: (0, _extends3.default)({}, (0, _rolesComputedGenerator.generateComputed)('Tipo Orc', ['canAccessCRUD']), {
    importUrl: function importUrl() {
      return basePath + '/importacao?tipo_importacao';
    }
  }),
  components: {
    mdChipsAutocomplete: _mdChipsAutocomplete2.default,
    RegisterForm: _RegisterForm2.default,
    UploadFile: _UploadFile2.default
  },
  methods: {
    addTipoInvestimentoChip: function addTipoInvestimentoChip(value) {
      this.chipsTipoInvestimento = value.map(function (el) {
        return el.id;
      });

      this.tipoOrcamento.tiposInvestimento = {};
      this.tipoOrcamento.tiposInvestimento = value;
    },
    cancel: function cancel() {
      this.$emit('SIDECOLUMN_CANCEL_ACTION');
      this.clearForm();
    },
    clearForm: function clearForm() {
      var _this = this;

      this.tipoOrcamento = (0, _helpers.copyObject)(this.originalTipoOrcamento);
      setTimeout(function () {
        _this.fields.reset();
        _this.errors.clear();
        _this.$refs.containerIdExterno.inputLength = 0;
        _this.$refs.containerOrcamento.inputLength = 0;
        _this.source = [];
        _this.$refs.tipoLinhaOrcamento.selectedChips = [];
        _this.chipsTipoInvestimento = [];
      }, 1E2);
    },
    cleantipoInvestimento: function cleantipoInvestimento() {
      this.tipoOrcamento.tiposInvestimento = [];
      this.tipoOrcamento.tipoInvestimento = '';
    },
    closeDialog: function closeDialog(ref, cb) {
      this.$refs[ref].close();
      this.$refs[ref].active = false;
      if (cb) {
        cb();
      }
    },
    openDialog: function openDialog(ref) {
      this.$refs[ref].open();
      this.$refs[ref].active = true;
    },
    openSaveDialog: function openSaveDialog(ref, from) {
      var _this2 = this;

      this.$validator.validateAll().then(function (isValid) {
        if (!isValid) {
          return;
        }
        var content = _this2.$t('message.salvar_novo_tipoOrcamento');
        _this2.setDialogContent(content, _this2.save, from || _this2.dialog.from);

        _this2.openDialog(ref || _this2.dialog.ref);
      });
    },
    save: function save(obj) {
      var objTipoOrcamento = (0, _assign2.default)({}, obj || this.tipoOrcamento);
      objTipoOrcamento.descricao = objTipoOrcamento.nome;
      this.$emit('SIDECOLUMN_SAVE_ACTION', objTipoOrcamento, this.clearForm);
    },
    setDialogContent: function setDialogContent(content, action, from) {
      this.dialog.content = content || this.$t('message.salvar_novo_registro');
      this.dialog.action = action || this.save;
      this.dialog.from = from || this.dialog.from;
    },
    uploadError: function uploadError(file, msg) {
      this.$toast.create(msg || this.$t('message.erro_tente_importar_novamente'), 'snack', 5E3);
    },
    uploadSuccess: function uploadSuccess() {
      this.$toast.create(this.$t('message.importado_em_breve_sera_processado'), 'snack', 8E3);
    }
  },
  mounted: function mounted() {
    this.originalTipoOrcamento = (0, _helpers.copyObject)(this.tipoOrcamento);
  }
};

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoOrcamentoTabela_vue_vue_type_script_lang_js___ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoOrcamentoTabela_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoOrcamentoTabela_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoOrcamentoTabela_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoOrcamentoTabela_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoOrcamentoTabela_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(4);

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _TabelaGenerica = __webpack_require__(20);

var _TabelaGenerica2 = _interopRequireDefault(_TabelaGenerica);

var _mdChipsAutocomplete = __webpack_require__(65);

var _mdChipsAutocomplete2 = _interopRequireDefault(_mdChipsAutocomplete);

var _rolesComputedGenerator = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  extends: _TabelaGenerica2.default,
  data: function data() {
    return {
      chipsTipoInvestimento: []
    };
  },

  props: {
    fetchFunction: Function,
    prepareResponseData: Function
  },
  components: {
    mdChipsAutocomplete: _mdChipsAutocomplete2.default
  },
  computed: (0, _extends3.default)({}, (0, _rolesComputedGenerator.generateComputed)('Tipo Orc', ['canAccessCRUD']), {
    tipoOrcamentoFilteredList: function tipoOrcamentoFilteredList() {
      var _this = this;

      return this.filteredList.map(function (elemento) {
        if (typeof elemento.tiposInvestimento !== 'string') {
          return elemento;
        }

        var row = (0, _assign2.default)({}, elemento);

        var tiposInvestimento = _this.stringToArray(elemento.tiposInvestimento);

        row.tiposInvestimento = tiposInvestimento;
        return row;
      });
    }
  }),
  methods: {
    addTipoInvestimentoChip: function addTipoInvestimentoChip(value) {
      this.currentEditItem.tiposInvestimento = value;
    },
    extractTipoInvestimentoName: function extractTipoInvestimentoName(row) {
      return row.tiposInvestimento.map(function (el) {
        return el.nome;
      }).join(', ');
    },
    stringToArray: function stringToArray(string) {
      return string.split(',').map(function (cat) {
        var tiposInvestimentoStr = cat.split(':');
        return {
          id: parseInt(tiposInvestimentoStr[0], 10),
          nome: tiposInvestimentoStr[1]
        };
      });
    }
  }
};

/***/ }),
/* 657 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaForm_vue_vue_type_script_lang_js___ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaForm_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaForm_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaForm_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaForm_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaForm_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(6);

var _CRUDGenerico = __webpack_require__(23);

var _CRUDGenerico2 = _interopRequireDefault(_CRUDGenerico);

var _RegisterForm = __webpack_require__(36);

var _RegisterForm2 = _interopRequireDefault(_RegisterForm);

var _InputMoneyOld = __webpack_require__(79);

var _InputMoneyOld2 = _interopRequireDefault(_InputMoneyOld);

var _helpers = __webpack_require__(5);

var _ModalVoltar = __webpack_require__(119);

var _ModalVoltar2 = _interopRequireDefault(_ModalVoltar);

var _TransferenciaDesdobramento = __webpack_require__(1556);

var _TransferenciaDesdobramento2 = _interopRequireDefault(_TransferenciaDesdobramento);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'TransferenciaForm',
  extends: _CRUDGenerico2.default,
  props: {
    somenteLeitura: Boolean,
    novo: Boolean,
    fluxo: Boolean
  },
  data: function data() {
    return {
      workflowTransferenciaResources: this.$api.workflowTransferencia(this.$resource),
      transferenciaResource: this.$api.transferencia(this.$resource),
      carregarComponentes: false,
      justificativaReprovacao: '',
      transferencia: {
        tipo: 'TRANSFERENCIA',
        idDesdobramento: null,
        idRepresentante: null,
        vlrDisponivel: 0,
        valor: 0,
        justificativa: '',
        idDesdobramentoDestino: null,
        idRepresentanteDestino: null,
        vlrDisponivelDestino: 0,
        valorDestino: 0
      },
      justificarTransferencia: {
        observacao: '',
        obrigatorio: false
      },
      fluxoTransferencia: {},
      podeAprovar: false,
      podeReprovar: false,
      disableButton: false,
      dialog: {
        ref: 'dialog1',
        from: 'saveRegisterFromButton',
        title: this.$t('label.atencao'),
        content: '',
        action: function action() {}
      }
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('roles', ['getAllRoles']), {
    canAccessPage: function canAccessPage() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el === 'ORC_TRANSFERENCIA';
      }).length;
    },
    canPost: function canPost() {
      return this.canAccessPage;
    },
    canSearch: function canSearch() {
      return this.canAccessPage;
    },
    valorDestino: function valorDestino() {
      return this.transferencia.valor + this.transferencia.valorDestino;
    }
  }),
  methods: {
    preencherDesdobramento: function preencherDesdobramento() {
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.transferencia.idDesdobramentoOrigem = id;
    },
    preencherOrcamento: function preencherOrcamento() {
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.transferencia.idOrcamentoOrigem = id;
    },
    preencherRepresentante: function preencherRepresentante() {
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.transferencia.idControladorOrigem = id;
    },
    preencherValores: function preencherValores(valor) {
      this.transferencia.vlrDisponivel = valor;
    },
    preencherDesdobramentoDestino: function preencherDesdobramentoDestino() {
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.transferencia.idDesdobramento = id;
    },
    preencherRepresentanteDestino: function preencherRepresentanteDestino() {
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.transferencia.idControladorDestino = id;
    },
    preencherValoresDestino: function preencherValoresDestino(valor) {
      this.transferencia.valorDestino = valor;
    },
    openSaveDialog: function openSaveDialog(ref, from) {
      var _this = this;

      if (!this.canPost) {
        return;
      }
      this.$refs.desdobramento.$validator.validateAll().then(function (isValid) {
        return isValid && _this.$validator.validateAll();
      }).then(function (isValid) {
        return isValid && _this.$refs.desdobramentoDestino.$validator.validateAll();
      }).then(function (isValid) {
        if (!_this.validarValor() || !isValid) {
          return;
        }
        _this.setDialogContent(_this.$t('message.salvar_novo_transferencia'), _this.save, from || _this.dialog.from);
        _this.openDialog(ref || _this.dialog.ref);
      });
    },
    openSaveDialogVoltar: function openSaveDialogVoltar() {
      var _this2 = this;

      if (!this.canPost) {
        return;
      }
      this.$refs.desdobramento.$validator.validateAll().then(function (isValid) {
        return isValid && _this2.$validator.validateAll();
      }).then(function (isValid) {
        return isValid && _this2.$refs.desdobramentoDestino.$validator.validateAll();
      }).then(function (isValid) {
        if (!_this2.validarValor() || !isValid) {
          return;
        }
        _this2.save();
      });
    },
    validarValor: function validarValor() {
      if (this.transferencia.valor <= 0) {
        this.$toast.create(this.$t('errors.valor.maior_zero'), 'snack', 3E3);
        return false;
      }
      if (this.transferencia.valor > this.transferencia.vlrDisponivel) {
        this.$toast.create(this.$t('errors.valor.disponivel.excedido'), 'snack', 3E3);
        return false;
      }
      return true;
    },
    save: function save() {
      var _this3 = this;

      if (!this.canPost) {
        return;
      }
      var objeto = (0, _helpers.copyObject)(this.transferencia);
      this.transferenciaResource.gravar(objeto).then(this.tratarSalvoSucesso).catch(function (err) {
        _this3.$error(_this3, err);
      });
    },
    tratarSalvoSucesso: function tratarSalvoSucesso(response) {
      this.$router.push({ name: 'orcamento' });

      if (response.data.status === 'APROVADO') {
        this.$toast.create(this.$t('message.transferencia_finalizada'), 'snack', 3E3);
      } else {
        this.$toast.create(this.$t('message.transferencia_enviada_aprovacao'), 'snack', 3E3);
      }
    },
    openCancelDialog: function openCancelDialog() {
      this.$refs.voltarDialog.open();
    },
    cancel: function cancel() {
      this.voltar();
    },
    voltar: function voltar() {
      if (this.fluxo) {
        this.$router.push({ name: 'dashboard' });
      } else {
        this.$router.push({ name: 'orcamento' });
      }
    },
    openDialogReprovar: function openDialogReprovar(ref, from) {
      var content = this.$t('message.deseja_reprovar_transferencia');
      this.setDialogContent(content, this.openDialogJustificativaReprovar, from || this.dialog.from);
      this.openDialog(ref || this.dialog.ref);
    },
    openDialogJustificativaReprovar: function openDialogJustificativaReprovar() {
      this.justificarTransferencia.observacao = '';
      this.justificarTransferencia.obrigatorio = true;
      this.justificarTransferencia.action = this.requestReprovar;

      this.openDialog('justificarDialog');
    },
    requestReprovar: function requestReprovar() {
      var _this4 = this;

      var payload = {};
      payload.observacao = this.justificarTransferencia.observacao;
      var id = this.transferencia.id;
      this.workflowTransferenciaResources.reprovar({ id: id }, payload).then(function () {
        _this4.voltar();
        _this4.$toast.create(_this4.$t('message.transferencia_reprovado'), 'snack', 3E3);
      }).catch(function (err) {
        _this4.$error(_this4, err);
      });
    },
    openDialogAprovar: function openDialogAprovar(ref, from) {
      if (!this.validarValor()) {
        return;
      }
      var content = this.$t('message.deseja_aprovar_transferencia');
      this.setDialogContent(content, this.requestAprovar, from || this.dialog.from);
      this.openDialog(ref || this.dialog.ref);
    },
    requestAprovar: function requestAprovar() {
      var _this5 = this;

      var id = this.transferencia.id;
      this.workflowTransferenciaResources.aprovar({ id: id }, { id: id }).then(function () {
        _this5.voltar();
        _this5.$toast.create(_this5.$t('message.transferencia_aprovado'), 'snack', 3E3);
      }).catch(function (err) {
        _this5.$error(_this5, err);
      });
    },
    requestPermiteAprovar: function requestPermiteAprovar() {
      var _this6 = this;

      this.podeAprovar = false;
      this.podeReprovar = false;
      if (this.fluxo && this.fluxoTransferencia.statusFluxo === 'AGUARDANDO_APROVACAO') {
        var id = this.$route.params.id;
        this.workflowTransferenciaResources.aprovador({ id: id }).then(function (response) {
          if (response.data.usuarioHabilitado) {
            _this6.podeAprovar = true;
            _this6.podeReprovar = true;
          }
        }).catch(function (err) {
          _this6.$error(_this6, err);
        });
      }
    },
    closeDialog: function closeDialog(ref, cb) {
      this.$refs[ref].close();
      if (cb) {
        cb();
      }
    },
    setDialogContent: function setDialogContent(content, action, from) {
      this.dialog.content = content || this.$t('message.salvar_novo_registro');
      this.dialog.action = action || this.save;
      this.dialog.from = from || this.dialog.from;
    },
    carregarTransferencia: function carregarTransferencia(id) {
      var _this7 = this;

      this.transferenciaResource.obter({ id: id }).then(function (response) {
        _this7.preencherTransferencia(response.data);
      }).then(this.carregarFluxo).catch(function (err) {
        _this7.$error(_this7, err);
      });
    },
    preencherTransferencia: function preencherTransferencia(data) {
      this.transferencia.id = data.id;
      this.transferencia.idDesdobramento = data.idDesdobramento;
      this.transferencia.idDesdobramentoDestino = data.idDesdobramentoDestino;
      this.transferencia.idRepresentante = data.idRepresentante;
      this.transferencia.idRepresentanteDestino = data.idRepresentanteDestino;
      this.transferencia.justificativa = data.justificativa;
      this.transferencia.status = data.status;
      this.transferencia.valor = data.valor;
      this.carregarComponentes = true;
    },
    carregarFluxo: function carregarFluxo() {
      var _this8 = this;

      if (this.fluxo || this.transferencia.status === 'REPROVADO') {
        this.fluxoTransferencia.usuarioSolicitante = {};
        var id = this.$route.params.id;
        this.workflowTransferenciaResources.status({ id: id }, { id: id }).then(function (response) {
          _this8.fluxoTransferencia = response.data;
          _this8.preencherJustificativaReprovacao();
          _this8.requestPermiteAprovar();
        }).catch(function (err) {
          _this8.$error(_this8, err);
        });
      }
    },
    preencherJustificativaReprovacao: function preencherJustificativaReprovacao() {
      if (this.fluxoTransferencia && this.fluxoTransferencia.passoAtual) {
        this.justificativaReprovacao = this.fluxoTransferencia.passoAtual.observacao;
      }
    }
  },
  beforeMount: function beforeMount() {
    if (this.$route.params.id) {
      this.carregarTransferencia(this.$route.params.id);
    } else {
      this.carregarComponentes = true;
    }
  },

  components: {
    RegisterForm: _RegisterForm2.default,
    TransferenciaDesdobramento: _TransferenciaDesdobramento2.default,
    InputMoneyOld: _InputMoneyOld2.default,
    ModalVoltar: _ModalVoltar2.default
  }
};

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaDesdobramento_vue_vue_type_script_lang_js___ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaDesdobramento_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaDesdobramento_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaDesdobramento_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaDesdobramento_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaDesdobramento_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mdAutocomplete = __webpack_require__(16);

var _mdAutocomplete2 = _interopRequireDefault(_mdAutocomplete);

var _InputMoneyOld = __webpack_require__(79);

var _InputMoneyOld2 = _interopRequireDefault(_InputMoneyOld);

var _http = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'TransferenciaDesdobramento',
  props: {
    somenteLeitura: Boolean,
    idDesdobramento: Number,
    idRepresentante: Number,
    idOrcamentoOrigem: Number,
    idDesdobramentoOrigem: {
      type: Number,
      default: null
    }
  },
  data: function data() {
    return {
      fetchOrcamentoFunction: this.$api.orcamento(this.$resource).listarAprovados,
      fetchLinhaFunction: this.$api.linhasInvestimento(this.$resource).buscarPorOrcamento,
      orcamentoResource: this.$api.orcamento(this.$resource),
      desdobramentoResource: this.$api.desdobramento(this.$resource),
      representanteResource: this.$api.representante(this.$resource),
      disableLinha: true,
      disableDesdobramento: true,
      disableRepresentante: true,
      desdobramento: {
        idOrcamento: null,
        descricaoOrcamento: '',
        idLinhaInvestimento: null,
        descricaoLinha: '',
        idDesdobramento: null,
        competencia: '',
        idRepresentante: null,
        representante: '',
        vlrPlanejado: 0,
        vlrDisponivel: 0
      }
    };
  },

  watch: {
    idDesdobramentoOrigem: function idDesdobramentoOrigem() {
      this.limparOrcamento();
      this.desdobramento.descricaoOrcamento = '';
    }
  },
  methods: {
    setOrcamento: function setOrcamento(hit) {
      if (!hit.id) {
        this.limparOrcamento();
        return;
      }
      this.disableLinha = false;
      this.desdobramento.idOrcamento = hit.id;
      this.desdobramento.descricaoOrcamento = hit.descricao;
      this.desdobramento.descricaoLinha = '';
      if (!this.idOrcamentoOrigem) {
        this.$emit('TRANSFERENCIAORCAMENTO_SET', hit.id);
      }
      this.limparLinha();
    },
    setLinha: function setLinha(hit) {
      if (!hit.id) {
        this.limparLinha();
        return;
      }
      this.disableDesdobramento = false;
      this.desdobramento.idLinhaInvestimento = hit.id;
      this.desdobramento.descricaoLinha = hit.descricao.trim();
      this.desdobramento.competencia = '';
      this.limparDesdobramento();
    },
    setDesdobramento: function setDesdobramento(hit) {
      if (!hit.id) {
        this.limparDesdobramento();
        return;
      }
      this.disableRepresentante = false;
      this.desdobramento.idDesdobramento = hit.id;
      this.desdobramento.competencia = hit.anoMes;
      this.$emit('TRANSFERENCIADESDOBRAMENTO_SET', hit.id);
      this.desdobramento.representante = '';
      this.limparRepresentante();
    },
    setRepresentante: function setRepresentante(hit) {
      if (!hit.idRepresentante) {
        this.limparRepresentante();
        return;
      }
      this.desdobramento.idRepresentante = hit.idRepresentante;
      this.desdobramento.representante = hit.nome;
      this.buscarValoresRepresentante();
      this.$emit('TRANSFERENCIADESDOBRAMENTO_SET_REPRESENTANTE', hit.idControladorTrade);
    },
    buscarLinha: function buscarLinha(row) {
      row.codigo = this.desdobramento.idOrcamento;
      return this.fetchLinhaFunction(row);
    },
    buscarDesdobramento: function buscarDesdobramento(row) {
      if (this.idDesdobramentoOrigem) {
        return this.desdobramentoResource.buscarDestinoVigentesPorLinhaInvestimento({ codigo: this.desdobramento.idLinhaInvestimento,
          anoMes: row.anoMes,
          idDesdobramentoOrigem: this.idDesdobramentoOrigem });
      }
      return this.desdobramentoResource.buscarVigentesPorLinhaInvestimentoTransferencia({ codigo: this.desdobramento.idLinhaInvestimento, anoMes: row.anoMes });
    },
    buscarOrcamentos: function buscarOrcamentos(row) {
      if (this.idOrcamentoOrigem) {
        return this.orcamentoResource.listarDestinoAprovados({ descricao: row.descricao,
          idOrcamentoOrigem: this.idOrcamentoOrigem });
      }
      return this.orcamentoResource.listarAprovados({ descricao: row.descricao });
    },
    buscarRepresentante: function buscarRepresentante(row) {
      row.codigo = this.desdobramento.idDesdobramento;
      return this.desdobramentoResource.buscarRepresentantes(row);
    },
    buscarValores: function buscarValores() {
      var _this = this;

      return this.desdobramentoResource.buscarPlanejadoDisponivel({ codigo: this.desdobramento.idDesdobramento }).then(this.preencherValores).catch(function (err) {
        _this.$error(_this, err);
      });
    },
    buscarValoresRepresentante: function buscarValoresRepresentante() {
      var _this2 = this;

      return this.desdobramentoResource.buscarPlanejadoDisponivelRepresentante({ codigo: this.desdobramento.idDesdobramento,
        idRepresentante: this.desdobramento.idRepresentante }).then(this.preencherValores).catch(function (err) {
        _this2.$error(_this2, err);
      });
    },
    preencherValores: function preencherValores(response) {
      this.desdobramento.vlrPlanejado = response.data.vlrPlanejado;
      this.desdobramento.vlrDisponivel = response.data.vlrDisponivel;
      this.$emit('TRANSFERENCIADESDOBRAMENTO_SET_VALORES', response.data.vlrDisponivel);
    },
    limparOrcamento: function limparOrcamento() {
      this.desdobramento.idOrcamento = null;
      this.desdobramento.descricaoLinha = '';
      this.disableLinha = true;
      if (!this.idOrcamentoOrigem) {
        this.$emit('TRANSFERENCIAORCAMENTO_SET');
      }
      this.limparLinha();
    },
    limparLinha: function limparLinha() {
      this.desdobramento.idLinhaInvestimento = null;
      this.desdobramento.competencia = '';
      this.disableDesdobramento = true;
      this.limparDesdobramento();
    },
    limparDesdobramento: function limparDesdobramento() {
      this.disableRepresentante = true;
      this.desdobramento.idDesdobramento = null;
      this.desdobramento.representante = '';
      this.desdobramento.vlrPlanejado = 0;
      this.desdobramento.vlrDisponivel = 0;
      this.desdobramento.idRepresentante = null;
      this.$emit('TRANSFERENCIADESDOBRAMENTO_SET');
      this.$emit('TRANSFERENCIADESDOBRAMENTO_SET_VALORES', this.desdobramento.vlrDisponivel);
    },
    limparRepresentante: function limparRepresentante() {
      this.desdobramento.idRepresentante = null;
      if (this.desdobramento.idDesdobramento) this.buscarValores();
      this.$emit('TRANSFERENCIADESDOBRAMENTO_SET_REPRESENTANTE');
    },
    carregarValores: function carregarValores() {
      if (this.desdobramento.idRepresentante) {
        this.buscarValoresRepresentante();
        return;
      }
      this.buscarValores();
    },
    carregarRepresentante: function carregarRepresentante() {
      var _this3 = this;

      if (this.idRepresentante) {
        this.representanteResource.obter({ id: this.idRepresentante }).then(function (response) {
          _this3.desdobramento.representante = response.data.nome;
        }).catch(function (err) {
          return _this3.$error(_this3, err);
        });
      }
    },
    carregarDesdobramento: function carregarDesdobramento() {
      var _this4 = this;

      this.desdobramento.idDesdobramento = this.idDesdobramento;
      this.desdobramento.idRepresentante = this.idRepresentante;
      this.desdobramentoResource.buscarHierarquia({ codigo: this.idDesdobramento }).then(function (response) {
        _this4.preencherDesdobramento(response.data);
      }).then(this.carregarRepresentante).then(this.carregarValores).catch(function (err) {
        _this4.$error(_this4, err);
      });
    },
    preencherDesdobramento: function preencherDesdobramento(data) {
      this.desdobramento.idDesdobramento = data.id;
      this.desdobramento.competencia = data.competencia;
      this.desdobramento.descricaoLinha = data.descricaoLinha;
      this.desdobramento.descricaoOrcamento = data.descricaoOrcamento;
      this.desdobramento.idLinhaInvestimento = data.idLinhaInvestimento;
      this.desdobramento.idOrcamento = data.idOrcamento;
    },

    prepareResponseData: _http.prepareResponseData
  },
  beforeMount: function beforeMount() {
    if (this.idDesdobramento) {
      this.carregarDesdobramento();
    }
  },

  components: {
    mdAutocomplete: _mdAutocomplete2.default,
    InputMoneyOld: _InputMoneyOld2.default
  }
};

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseAbas_vue_vue_type_script_lang_js___ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseAbas_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseAbas_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseAbas_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseAbas_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseAbas_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TransferenciaPosseForm = __webpack_require__(1566);

var _TransferenciaPosseForm2 = _interopRequireDefault(_TransferenciaPosseForm);

var _Confirm = __webpack_require__(12);

var _Confirm2 = _interopRequireDefault(_Confirm);

var _TransferenciaPosseDefinitiva = __webpack_require__(1569);

var _TransferenciaPosseDefinitiva2 = _interopRequireDefault(_TransferenciaPosseDefinitiva);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'TransferenciaPosseAbas',
  components: {
    TransferenciaPosseForm: _TransferenciaPosseForm2.default,
    Confirm: _Confirm2.default,
    TransferenciaPosseDefinitiva: _TransferenciaPosseDefinitiva2.default
  },
  props: {},
  data: function data() {
    var _this = this;

    return {
      tabSelecionada: null,
      canAccessPage: true,
      dialogForm: false,
      esperar: false,
      posse: {},
      possesTemporarias: [],
      historicoPosses: [],
      resources: this.$api.transferenciaPosse(this.$resource),
      paginationTemporaria: {
        totalPage: 0
      },
      paginationHistorico: {
        totalPage: 0
      },
      posseSelecionada: null,
      searchQueryTemporaria: '',
      searchQueryHistorico: '',
      totalPage: 0,
      alturaTela: screen.height,
      headersPossesTemporarias: [{ text: this.$tc('label.de', 2), value: 'de' }, { text: this.$tc('label.para', 1), value: 'para' }, { text: this.$tc('label.motivo', 1), value: 'motivo' }, { text: this.$tc('label.data_criacao', 1), value: 'dtaCriacao', sortable: false }, { text: '', value: 'opcao', sortable: false }],
      headersHistoricoPosses: [{ text: this.$tc('label.de', 2), value: 'de' }, { text: this.$tc('label.para', 1), value: 'para' }, { text: this.$tc('label.motivo', 1), value: 'motivo' }, { text: this.$tc('label.data_criacao', 1), value: 'dtaCriacao', sortable: false }, { text: this.$tc('label.data_fim', 1), value: 'dtaEncerrado', sortable: false }],
      rules: {
        validDate: function validDate(value) {
          return _this.isDataValida(value) || _this.$t('message.data_invalida');
        }
      }
    };
  },

  watch: {
    searchQueryTemporaria: function searchQueryTemporaria() {
      var _this2 = this;

      if (this.timeoutTemp) {
        window.clearTimeout(this.timeoutTemp);
      }
      this.timeoutTemp = window.setTimeout(function () {
        _this2.buscarPossesTemporarias();
      }, 500);
    },
    searchQueryHistorico: function searchQueryHistorico() {
      var _this3 = this;

      if (this.timeoutHist) {
        window.clearTimeout(this.timeoutHist);
      }
      this.timeoutHist = window.setTimeout(function () {
        _this3.buscarHistoricoPosses();
      }, 500);
    },

    paginationTemporaria: {
      handler: function handler() {
        this.buscarPossesTemporarias();
      },

      deep: true
    },
    paginationHistorico: {
      handler: function handler() {
        this.buscarHistoricoPosses();
      },

      deep: true
    }
  },
  methods: {
    abrirForm: function abrirForm() {
      this.dialogForm = true;
    },
    abrirDialogRemover: function abrirDialogRemover(item) {
      this.posseSelecionada = item;
      this.$refs.confirmDialog.open();
    },
    buscarPossesTemporarias: function buscarPossesTemporarias() {
      var _this4 = this;

      var params = {
        nome: this.search,
        numeroPagina: this.paginationTemporaria.page || 1,
        tamanhoPagina: this.paginationTemporaria.itemsPerPage || 10,
        asc: !this.paginationTemporaria.sortDesc[0],
        colunaOrdenacao: this.paginationTemporaria.sortBy[0] || '',
        filtro: this.searchQueryTemporaria
      };

      this.resources.listarTemporarios(params).then(function (response) {
        _this4.possesTemporarias = response.data.resposta;
        _this4.paginationTemporaria.totalPage = response.data.quantidadeRegistrosPagina;
      }, function (err) {
        _this4.$error(_this4, err);
      });
    },
    buscarHistoricoPosses: function buscarHistoricoPosses() {
      var _this5 = this;

      var params = {
        nome: this.search,
        numeroPagina: this.paginationHistorico.page || 1,
        tamanhoPagina: this.paginationHistorico.itemsPerPage || 10,
        asc: !this.paginationHistorico.sortDesc[0],
        colunaOrdenacao: this.paginationHistorico.sortBy[0] || '',
        filtro: this.searchQueryHistorico
      };

      this.resources.listarHistorico(params).then(function (response) {
        _this5.historicoPosses = response.data.resposta;
        _this5.paginationHistorico.totalPage = response.data.quantidadeRegistrosPagina;
      }, function (err) {
        _this5.$error(_this5, err);
      });
    },
    carregarGrids: function carregarGrids() {
      this.dialogForm = false;
      this.buscarHistoricoPosses();
      this.buscarPossesTemporarias();
    },
    fecharForm: function fecharForm() {
      this.idEvento = null;
      this.dialogForm = false;
    },
    removerTransferenciaTemporaria: function removerTransferenciaTemporaria() {
      var _this6 = this;

      this.resources.remover(this.posseSelecionada.idControladorTrade).then(function () {
        _this6.carregarGrids();
      }, function (err) {
        _this6.$error(_this6, err);
      });
    }
  },
  beforeMount: function beforeMount() {
    if (this.canAccessPage) {
      this.headersPossesTemporarias.push({ text: '', value: 'acao', sortable: false });
    }
  },
  mounted: function mounted() {
    this.carregarGrids();
  }
};

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseForm_vue_vue_type_script_lang_js___ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseForm_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseForm_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseForm_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseForm_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseForm_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(4);

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(6);

var _Confirm = __webpack_require__(12);

var _Confirm2 = _interopRequireDefault(_Confirm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'TransferenciaPosseForm',
  components: {
    Confirm: _Confirm2.default
  },
  props: {
    somenteLeitura: true
  },
  data: function data() {
    var _this = this;

    return {
      resources: this.$api.transferenciaPosse(this.$resource),
      radioGroup: 'FUNCIONARIO',
      listaDe: [],
      listaPara: [],
      tipo: 'de',
      posse: {
        id: null,
        de: null,
        para: null,
        motivo: '',
        definitiva: false
      },
      rules: {
        required: function required(value) {
          return !!value || _this.$t('message.campo_obrigatorio');
        },
        requiredDe: function requiredDe() {
          return !!_this.posse.de || _this.$t('message.campo_obrigatorio');
        },
        requiredPara: function requiredPara() {
          return !!_this.posse.para || _this.$t('message.campo_obrigatorio');
        },
        maxLength50: function maxLength50(v) {
          return v && v.length <= 50 || _this.$t('message.limite_caracteres_excedido');
        }
      },
      buscaListaDe: null,
      buscaListaPara: null
    };
  },

  watch: {
    buscaListaDe: function buscaListaDe(val) {
      var _this2 = this;

      if (this.posse.de && this.posse.de.nome === val) return;
      if (this.timeoutDe) {
        window.clearTimeout(this.timeoutDe);
      }
      this.timeoutDe = window.setTimeout(function () {
        if (val) _this2.buscaListaDePara(val);
      }, 500);
    },
    buscaListaPara: function buscaListaPara(val) {
      var _this3 = this;

      if (this.posse.para && this.posse.para.nome === val) return;
      if (this.timeoutPara) {
        window.clearTimeout(this.timeoutPara);
      }
      this.timeoutPara = window.setTimeout(function () {
        if (val && _this3.posse.de) {
          _this3.buscaListaDePara(val, 'para', _this3.posse.de ? _this3.posse.de.id : null);
        }
      }, 500);
    }
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('roles', ['getAllRoles']), {
    podeTransferenciaDiv: function podeTransferenciaDiv() {
      if (!this.getAllRoles) {
        return false;
      }
      return this.getAllRoles.includes('TRANS_POSSE_DIV');
    },
    podeTransferenciaFun: function podeTransferenciaFun() {
      if (!this.getAllRoles) {
        return false;
      }
      return this.getAllRoles.includes('TRANS_POSSE_FUN');
    },
    podeTransferenciaDefinitiva: function podeTransferenciaDefinitiva() {
      if (!this.getAllRoles) {
        return false;
      }
      return this.getAllRoles.includes('TRANS_POSSE_DEF');
    }
  }),
  methods: {
    abrirDialogSalvar: function abrirDialogSalvar() {
      if (!this.$refs.form.validate()) return;
      this.$refs.confirmDialog.open();
    },
    alterarListas: function alterarListas() {
      this.posse.de = null;
      this.posse.para = null;
      this.buscaListaDePara();
    },
    buscarDivisoes: function buscarDivisoes() {
      var busca = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this4 = this;

      var tipo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'de';
      var idNotIn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var param = {
        nome: busca,
        tamanhoPagina: 20,
        idNotIn: idNotIn
      };

      if (tipo === 'para') {
        param.ativo = true;
      }

      this.resources.listarDivisoes(param).then(function (response) {
        if (tipo === 'de') {
          _this4.listaDe = (0, _assign2.default)([], response.data.resposta);
        } else if (tipo === 'para') {
          _this4.listaPara = (0, _assign2.default)([], response.data.resposta);
        }
      }, function (err) {
        _this4.$error(_this4, err);
      });
    },
    buscarFuncionarios: function buscarFuncionarios() {
      var busca = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this5 = this;

      var tipo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'de';
      var idNotIn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var param = {
        nome: busca,
        tamanhoPagina: 20,
        idNotIn: idNotIn
      };

      if (tipo === 'para') {
        param.ativo = true;
      }

      this.resources.listarFuncionarios(param).then(function (response) {
        if (tipo === 'de') {
          _this5.listaDe = (0, _assign2.default)([], response.data.resposta);
        } else if (tipo === 'para') {
          _this5.listaPara = (0, _assign2.default)([], response.data.resposta);
        }
      }, function (err) {
        _this5.$error(_this5, err);
      });
    },
    buscaListaDePara: function buscaListaDePara() {
      var busca = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var tipo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'de';
      var idNotIn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      if (this.radioGroup === 'FUNCIONARIO') this.buscarFuncionarios(busca, tipo, idNotIn);else if (this.radioGroup === 'DIVISAO') this.buscarDivisoes(busca, tipo, idNotIn);
    },
    cancelar: function cancelar() {
      this.$refs.form.reset();
      this.$emit('cancelar');
    },
    salvar: function salvar() {
      var _this6 = this;

      var param = {
        motivo: this.posse.motivo,
        definitiva: this.posse.definitiva
      };

      if (this.radioGroup === 'FUNCIONARIO') {
        param.idFuncionarioOrigem = this.posse && this.posse.de ? this.posse.de.id : null;
        param.idFuncionarioDestino = this.posse && this.posse.para ? this.posse.para.id : null;
      } else if (this.radioGroup === 'DIVISAO') {
        param.idDivisaoOrigem = this.posse && this.posse.de ? this.posse.de.id : null;
        param.idDivisaoDestino = this.posse && this.posse.para ? this.posse.para.id : null;
      }

      this.resources.transferir(param).then(function () {
        _this6.$toast.create(_this6.$t('message.adicionado_confira_tabela'), 'snack', '3E3');
        _this6.$emit('atualizarGrid');
      }, function (err) {
        _this6.$error(_this6, err);
      });
    },
    limparPara: function limparPara() {
      this.posse.para = null;
      this.buscaListaDePara(null, 'para', this.posse.de ? this.posse.de.id : null);
    },
    setPara: function setPara(item) {
      this.posse.para = item;
    }
  },
  beforeMount: function beforeMount() {
    if (this.podeTransferenciaDiv && !this.podeTransferenciaFun) {
      this.radioGroup = 'DIVISAO';
    }
  }
};

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitiva_vue_vue_type_script_lang_js___ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitiva_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitiva_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitiva_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitiva_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitiva_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'TransferenciaPosseDefinitiva',
  props: {},
  data: function data() {
    return {
      posses: [],
      resources: this.$api.transferenciaPosseDefinitiva(this.$resource),
      pagination: {},
      searchQueryDef: '',
      totalPage: 0,
      headers: [{ text: this.$tc('label.de', 2), value: 'de' }, { text: this.$tc('label.para', 1), value: 'para' }, { text: this.$tc('label.motivo', 1), value: 'motivo' }, { text: this.$tc('label.usuario', 1), value: 'usuario' }, { text: this.$tc('label.data_criacao', 1), value: 'dtaCriacao', sortable: false }]
    };
  },

  watch: {
    searchQueryDef: function searchQueryDef() {
      var _this = this;

      if (this.timeoutTemp) {
        window.clearTimeout(this.timeoutTemp);
      }
      this.timeoutTemp = window.setTimeout(function () {
        _this.buscarPosses();
      }, 500);
    },

    pagination: {
      handler: function handler() {
        this.buscarPosses();
      },

      deep: true
    }
  },
  methods: {
    buscarPosses: function buscarPosses() {
      var _this2 = this;

      var params = {
        numeroPagina: this.pagination.page || 1,
        tamanhoPagina: this.pagination.itemsPerPage || 10,
        asc: !this.pagination.sortDesc[0],
        colunaOrdenacao: this.pagination.sortBy[0] || '',
        filtro: this.searchQueryDef
      };

      this.resources.listar(params).then(function (response) {
        _this2.posses = response.data.resposta;
        _this2.totalPage = response.data.quantidadeRegistrosPagina;
      }, function (err) {
        _this2.$error(_this2, err);
      });
    },
    abrirForm: function abrirForm() {
      this.$router.push({ name: 'novaTransferenciaDefinitiva' });
    }
  },
  mounted: function mounted() {
    this.buscarPosses();
  }
};

/***/ }),
/* 668 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaForm_vue_vue_type_script_lang_js___ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaForm_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaForm_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaForm_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaForm_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaForm_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(6);

var _TransferenciaPosseDefinitivaPasso = __webpack_require__(1576);

var _TransferenciaPosseDefinitivaPasso2 = _interopRequireDefault(_TransferenciaPosseDefinitivaPasso);

var _TransferenciaPosseDefinitivaPasso3 = __webpack_require__(1583);

var _TransferenciaPosseDefinitivaPasso4 = _interopRequireDefault(_TransferenciaPosseDefinitivaPasso3);

var _TransferenciaPosseDefinitivaPasso5 = __webpack_require__(1587);

var _TransferenciaPosseDefinitivaPasso6 = _interopRequireDefault(_TransferenciaPosseDefinitivaPasso5);

var _TransferenciaPosseDefinitivaPasso7 = __webpack_require__(1591);

var _TransferenciaPosseDefinitivaPasso8 = _interopRequireDefault(_TransferenciaPosseDefinitivaPasso7);

var _TransferenciaPosseDefinitivaPasso9 = __webpack_require__(1595);

var _TransferenciaPosseDefinitivaPasso10 = _interopRequireDefault(_TransferenciaPosseDefinitivaPasso9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'TransferenciaPosseDefinitivaForm',
  data: function data() {
    return {
      resources: this.$api.transferenciaPosseDefinitiva(this.$resource),

      e1: 0,
      cenario2e3: false,
      objeto: {}
    };
  },

  components: {
    TransferenciaPosseDefinitivaPasso1: _TransferenciaPosseDefinitivaPasso2.default,
    TransferenciaPosseDefinitivaPasso2: _TransferenciaPosseDefinitivaPasso4.default,
    TransferenciaPosseDefinitivaPasso3: _TransferenciaPosseDefinitivaPasso6.default,
    TransferenciaPosseDefinitivaPasso4: _TransferenciaPosseDefinitivaPasso8.default,
    TransferenciaPosseDefinitivaPasso5: _TransferenciaPosseDefinitivaPasso10.default
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('roles', ['getAllRoles']), {
    canAccessPage: function canAccessPage() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles.filter(function (el) {
        return el === 'TRANS_POSSE_FUN';
      }).length;
    }
  }),
  methods: {
    accessForbidden: function accessForbidden() {
      if (!this.canAccessPage) {
        this.$router.push({ name: 'inicio' });
        this.$toast.create('Acesso negado', 'snack', 3E3);
      }
    },
    cancelar: function cancelar() {
      this.$router.push({ name: 'transferencia-posse' });
    },
    continuar: function continuar(proximoPasso, objeto) {
      this.objeto = objeto;
      if (proximoPasso === 2) {
        if (objeto.cenario === 2 || objeto.cenario === 3) {
          this.cenario2e3 = true;
          this.$refs.passo2.buscarCarteiras(this.objeto.funcionarioDe, this.objeto.funcionarioPara);
          this.$refs.passo3.buscarResponsaveis(this.objeto.funcionarioDe, this.objeto.funcionarioPara);
        } else {
          proximoPasso = 4;
        }
      }
      if (proximoPasso === 4) {
        this.$refs.passo4.buscarOrcamentos(this.objeto.funcionarioDe);
      }
      this.e1 = proximoPasso;
    },
    voltar: function voltar(passo) {
      if (!this.cenario2e3 && passo === 3) {
        passo = 1;
      }
      this.e1 = passo;
    },
    concluir: function concluir(objeto) {
      var _this = this;

      objeto.idFuncionarioDe = objeto.funcionarioDe.id;
      objeto.idFuncionarioPara = objeto.funcionarioPara.id;

      objeto.idsClientes = objeto.clientes.map(function (el) {
        return el.idCliente;
      });
      objeto.idsLinhasOrcamento = objeto.orcamentos.map(function (el) {
        return el.idLinha;
      });
      objeto.idsTime = objeto.usuarios.map(function (el) {
        return el.id;
      });
      this.resources.transferir(objeto).then(function () {
        _this.$toast.create(_this.$t('message.adicionado_confira_tabela'), 'snack', '3E3');
        _this.$router.push({ name: 'transferencia-posse' });
      }, function (err) {
        _this.$toast.create(err.erros[0], 'snack', 5E3);
      });
    }
  },
  beforeMount: function beforeMount() {
    var _this2 = this;

    if (!this.canAccessPage) {
      window.setTimeout(function () {
        _this2.accessForbidden();
      }, 1E3);
    }
  }
};

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso1_vue_vue_type_script_lang_js___ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso1_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso1_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso1_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso1_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso1_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(4);

var _assign2 = _interopRequireDefault(_assign);

var _TransferenciaDefinitiva = __webpack_require__(1579);

var _TransferenciaDefinitiva2 = _interopRequireDefault(_TransferenciaDefinitiva);

var _TooltipAjuda = __webpack_require__(78);

var _TooltipAjuda2 = _interopRequireDefault(_TooltipAjuda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'TransferenciaPosseDefinitivaPasso1',
  components: {
    TooltipAjuda: _TooltipAjuda2.default
  },
  data: function data() {
    var _this = this;

    return {
      resources: this.$api.transferenciaPosseDefinitiva(this.$resource),

      passo: 1,
      rules: {
        required: function required(value) {
          return !!value || _this.$t('message.campo_obrigatorio');
        }
      },
      transferencia: new _TransferenciaDefinitiva2.default(),
      listaDe: [],
      listaPara: [],
      buscaListaDe: null,
      buscaListaPara: null,
      vendedoresDe: [],
      vendedoresPara: []
    };
  },

  watch: {
    buscaListaDe: function buscaListaDe(val) {
      var _this2 = this;

      if (this.transferencia.funcionarioDe && this.transferencia.funcionarioDe.nome === val) return;
      if (this.timeoutDe) {
        window.clearTimeout(this.timeoutDe);
      }
      this.timeoutDe = window.setTimeout(function () {
        if (val) _this2.buscarFuncionarioDe(val);
      }, 500);
    },
    buscaListaPara: function buscaListaPara(val) {
      var _this3 = this;

      if (this.transferencia.funcionarioPara && this.transferencia.funcionarioPara.nome === val) return;
      if (this.timeoutDe) {
        window.clearTimeout(this.timeoutDe);
      }
      this.timeoutDe = window.setTimeout(function () {
        if (val) _this3.buscarFuncionarioPara(val);
      }, 500);
    }
  },
  methods: {
    cancelar: function cancelar() {
      this.$emit('TRANSFERENCIA_DEFINITIVA_CANCELAR');
    },
    proximoPasso: function proximoPasso() {
      if (this.$refs.form.validate()) {
        if (this.transferencia.cenario === 3) {
          var selecionados = this.vendedoresPara.filter(function (p) {
            return p.origem === 'de';
          });
          if (this.vendedoresDe.length) {
            this.$toast.create(this.$t('message.selecione_vendedores_transferir'), 'snack', 3E3);
            return;
          }
          this.transferencia.usuarios = selecionados;
        }
        this.$emit('TRANSFERENCIA_DEFINITIVA_CONTINUAR', this.passo + 1, this.transferencia);
      }
    },
    buscarFuncionarioDe: function buscarFuncionarioDe() {
      var _this4 = this;

      var busca = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (typeof busca !== 'string') {
        busca = null;
      }

      var param = {
        filtro: busca,
        rateio: true,
        vendedor: true,
        estruturaFolha: true,
        tamanhoPagina: 20
      };

      if (this.transferencia.cenario === 4) {
        param.vendedor = false;
        param.estruturaFolha = false;
      } else if (this.transferencia.cenario === 3) {
        param.estruturaPai = true;
        param.estruturaFolha = false;
      }

      this.resources.listarFuncionarios(param).then(function (response) {
        _this4.listaDe = (0, _assign2.default)([], response.data.resposta);
      }, function (err) {
        _this4.$error(_this4, err);
      });
    },
    buscarFuncionarioPara: function buscarFuncionarioPara() {
      var _this5 = this;

      var busca = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (this.transferencia.funcionarioDe) {
        if (typeof busca !== 'string') {
          busca = null;
        }

        var param = {
          filtro: busca,
          rateio: true,
          mesmoCanal: true,
          mesmaUnidade: true,
          idNotIn: this.transferencia.funcionarioDe.id,
          tamanhoPagina: 20
        };

        if (this.transferencia.cenario === 1) {
          param.estruturaPai = true;
          param.mesmaEstruturaPai = true;
        } else if (this.transferencia.cenario === 2) {
          param.estruturaFolha = true;
          param.vendedor = true;
        } else if (this.transferencia.cenario === 4) {
          param.vendedor = false;
          param.mesmaEstrutura = true;
        } else if (this.transferencia.cenario === 3) {
          param.estruturaPai = true;
          param.vendedor = true;
        }

        this.resources.listarFuncionarios(param).then(function (response) {
          _this5.listaPara = (0, _assign2.default)([], response.data.resposta);
        }, function (err) {
          _this5.$error(_this5, err);
        });
      }
    },
    selecionaUsuarioDe: function selecionaUsuarioDe(superior) {
      var _this6 = this;

      if (this.transferencia.cenario === 3 && superior) {
        var param = {
          vendedor: true,
          idSuperior: superior.id,
          tamanhoPagina: 50
        };
        this.resources.listarFuncionarios(param).then(function (response) {
          _this6.vendedoresDe = (0, _assign2.default)([], response.data.resposta);
        }, function (err) {
          _this6.$error(_this6, err);
        });
      }
    },
    selecionaUsuarioPara: function selecionaUsuarioPara(superior) {
      var _this7 = this;

      if (this.transferencia.cenario === 3 && superior) {
        var param = {
          vendedor: true,
          idSuperior: superior.id,
          tamanhoPagina: 50
        };
        this.resources.listarFuncionarios(param).then(function (response) {
          _this7.vendedoresPara = (0, _assign2.default)([], response.data.resposta);
        }, function (err) {
          _this7.$error(_this7, err);
        });
      }
    },
    labelSelecaoUsuarioDe: function labelSelecaoUsuarioDe() {
      if (this.transferencia.cenario === 1 || this.transferencia.cenario === 2) {
        return this.$tc('label.de_vendedor', 1);
      } else if (this.transferencia.cenario === 3) {
        return this.$tc('label.de_gestor', 1);
      } else if (this.transferencia.cenario === 4) {
        return this.$tc('label.de_usuario_distribui_verba', 1);
      }
      return this.$tc('label.de', 1);
    },
    labelSelecaoUsuarioPara: function labelSelecaoUsuarioPara() {
      if (this.transferencia.cenario === 1) {
        return this.$tc('label.para_novo_superior_imediato', 1);
      } else if (this.transferencia.cenario === 2) {
        return this.$tc('label.para_vendedor', 1);
      } else if (this.transferencia.cenario === 3) {
        return this.$tc('label.para_gestor', 1);
      } else if (this.transferencia.cenario === 4) {
        return this.$tc('label.para_usuario_distribui_verba', 1);
      }
      return this.$tc('label.para', 1);
    },
    limparPara: function limparPara(superior) {
      this.transferencia.funcionarioPara = null;
      this.listaPara = [];
      this.selecionaUsuarioDe(superior);
    },
    limparSelecaoUsuario: function limparSelecaoUsuario() {
      this.transferencia.funcionarioDe = null;
      this.listaDe = [];
      this.transferencia.funcionarioPara = null;
      this.listaPara = [];
      this.vendedoresDe = [];
      this.vendedoresPara = [];
    },
    enviarDePara: function enviarDePara() {
      var selecionados = [];
      for (var i = this.vendedoresDe.length - 1; i >= 0; i -= 1) {
        var v = this.vendedoresDe[i];
        v.origem = 'de';
        selecionados.push(v);
      }
      if (selecionados.length) {
        this.vendedoresDe = [];
        this.vendedoresPara = this.vendedoresPara.concat(selecionados);
      }
    },
    enviarParaDe: function enviarParaDe() {
      var selecionados = this.vendedoresPara.filter(function (v) {
        return v.origem === 'de';
      });
      var para = this.vendedoresPara.filter(function (v) {
        return v.origem !== 'de';
      });
      if (selecionados.length) {
        this.vendedoresDe = this.vendedoresDe.concat(selecionados);
        this.vendedoresPara = para;
      }
    }
  }
};

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TooltipAjuda_vue_vue_type_script_lang_js___ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TooltipAjuda_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TooltipAjuda_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TooltipAjuda_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TooltipAjuda_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TooltipAjuda_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'TooltipAjuda',
  props: {
    mensagem: String,
    color: {
      type: String,
      default: 'white'
    }
  }
};

/***/ }),
/* 675 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso2_vue_vue_type_script_lang_js___ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso2_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso2_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso2_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso2_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso2_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TooltipAjuda = __webpack_require__(78);

var _TooltipAjuda2 = _interopRequireDefault(_TooltipAjuda);

var _filtroCliente = __webpack_require__(120);

var _filtroCliente2 = _interopRequireDefault(_filtroCliente);

var _exportacoes = __webpack_require__(39);

var _exportacoes2 = _interopRequireDefault(_exportacoes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'TransferenciaPosseDefinitivaPasso2',
  components: {
    TooltipAjuda: _TooltipAjuda2.default
  },
  props: {
    transferencia: Object
  },
  data: function data() {
    return {
      resources: this.$api.transferenciaPosseDefinitiva(this.$resource),
      filtroClienteResource: (0, _filtroCliente2.default)(this.$resource),
      fetchRegiaoFunction: this.$api.regiao(this.$resource).listar,
      fetchExtensaoFuncion: this.$api.extensao(this.$resource).listar,
      fetchClienteFunction: this.$api.cliente(this.$resource).listarFiltrado,

      passo: 2,
      carteiras: [],
      pagination: {},
      totalPage: 0,
      headers: [{ text: this.$tc('label.codigo', 1), value: 'idExterno', sortable: false }, { text: this.$tc('label.nome', 1), value: 'nomCliente', sortable: false }, { text: this.$tc('label.cnpj', 1), value: 'desCnpj', sortable: false }, { text: this.$tc('label.holding', 1), value: 'holding', sortable: false }, { text: this.$tc('label.regiao', 1), value: 'nomRegiao', sortable: false }, { text: this.$tc('label.transferir', 1) + '?', value: 'transferir', sortable: false }],
      filtros: [],
      filtroSelecionado: {},
      lista: [],
      itensFiltro: [],
      buscaLista: null,
      selecionados: []
    };
  },

  watch: {
    buscaLista: function buscaLista(val) {
      var _this = this;

      if (this.timeoutDe) {
        window.clearTimeout(this.timeoutDe);
      }
      this.timeoutDe = window.setTimeout(function () {
        if (val) _this.buscarLista(val);
      }, 500);
    }
  },
  methods: {
    cancelar: function cancelar() {
      this.$emit('TRANSFERENCIA_DEFINITIVA_CANCELAR');
    },
    proximoPasso: function proximoPasso() {
      if (this.transferencia.transferenciaCarteira === 1) {
        this.transferencia.carteiras = this.carteiras;
      } else if (this.transferencia.transferenciaCarteira === 2) {
        if (!this.carteiras.length) {
          this.$toast.create(this.$t('message.nenhuma_carteira_para_transferir'), 'snack', 3E3);
          return;
        }
        this.transferencia.carteiras = this.carteiras;
      } else if (this.transferencia.transferenciaCarteira === 3) {
        var selecionados = this.carteiras.filter(function (p) {
          return p.transferir;
        });
        if (!selecionados.length) {
          this.$toast.create(this.$t('message.nenhuma_carteira_selecionada_para_transferir'), 'snack', 3E3);
          return;
        }
        this.transferencia.carteiras = selecionados;
      }
      this.$emit('TRANSFERENCIA_DEFINITIVA_CONTINUAR', this.passo + 1, this.transferencia);
    },
    voltarPasso: function voltarPasso() {
      this.$emit('TRANSFERENCIA_DEFINITIVA_VOLTAR', this.passo - 1);
    },
    buscarCarteiras: function buscarCarteiras(funcDe, funcPara) {
      var _this2 = this;

      if (funcDe && funcPara) {
        var params = {
          numeroPagina: this.pagination.page,
          tamanhoPagina: this.pagination.itemsPerPage,
          idUsuarioDe: funcDe.id,
          idUsuarioPara: funcPara.id
        };

        if (this.filtroSelecionado.nomCampoId) {
          params[this.filtroSelecionado.nomCampoId] = this.itensFiltro;
        }

        this.resources.listarCarteiras(params).then(function (response) {
          _this2.carteiras = response.data;
          _this2.selecionados.forEach(function (s) {
            var cart = _this2.carteiras.filter(function (c) {
              return c.idCarteira === s.idCarteira && c.idCliente === s.idCliente;
            });
            if (cart && cart.length) {
              cart[0].transferir = true;
            }
          });
          _this2.totalPage = response.data.quantidadeRegistrosPagina;
        }, function (err) {
          _this2.$error(_this2, err);
        });
      }
    },
    buscarFiltros: function buscarFiltros() {
      var _this3 = this;

      this.filtroClienteResource.listarAtivos().then(function (response) {
        var objetos = response.body.resposta;
        if (!objetos || !objetos.length) {
          return;
        }
        _this3.filtros = objetos;
        _this3.filtros.forEach(function (f) {
          f.nome = _this3.$t('label.filtro_cliente_' + f.nomCampoId);
        });
      }).catch(function (err) {
        _this3.$error(_this3, err);
      });
    },
    buscarLista: function buscarLista() {
      var busca = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (this.filtroSelecionado.nomCampoId) {
        if (typeof busca !== 'string') {
          busca = null;
        }
        var param = {
          nome: busca,
          indAtivo: true,
          size: 20,
          page: 1
        };

        if (this.filtroSelecionado.nomCampoId === 'id_regiao') {
          this.buscarRegiao(param);
        } else if (this.filtroSelecionado.nomCampoId === 'id_cliente') {
          param.filter = busca;
          this.buscarCliente(param);
        } else {
          param.idNivelExtensao = this.filtroSelecionado.idNivelExtensao;
          this.buscarExtensao(param);
        }
      }
    },
    buscarRegiao: function buscarRegiao(param) {
      var _this4 = this;

      this.fetchRegiaoFunction(param).then(function (response) {
        response.data = response.data.resposta.map(function (el) {
          var rt = {
            nome: el.nomRegiao,
            id: el.id,
            codRegiao: el.codRegiao
          };

          return rt;
        });

        _this4.lista = response.data;
      }).catch(function (err) {
        _this4.$error(_this4, err);
      });
    },
    buscarExtensao: function buscarExtensao(param) {
      var _this5 = this;

      param.idUsuario = this.transferencia.funcionarioDe.id;
      this.fetchExtensaoFuncion(param).then(function (response) {
        response.data = response.data.resposta.map(function (el) {
          var rt = {
            nome: el.nomExtensao,
            id: el.id,
            idExterno: el.idExterno
          };

          return rt;
        });

        _this5.lista = response.data;
      }).catch(function (err) {
        _this5.$error(_this5, err);
      });
    },
    buscarCliente: function buscarCliente(param) {
      var _this6 = this;

      this.fetchClienteFunction(param).then(function (response) {
        response.data = response.data.resposta.map(function (el) {
          var rt = {
            nome: el.cod_nom_cliente,
            id: el.id,
            idExterno: el.idExterno
          };

          return rt;
        });

        _this6.lista = response.data;
      }).catch(function (err) {
        _this6.$error(_this6, err);
      });
    },
    limparFiltro: function limparFiltro() {
      this.lista = [];
      this.itensFiltro = [];
      this.selecionados = [];
    },
    aplicarFiltro: function aplicarFiltro() {
      this.selecionados = [];
      this.pagination.page = 1;
      this.buscarCarteiras(this.transferencia.funcionarioDe, this.transferencia.funcionarioPara);
    },
    exportar: function exportar() {
      var _this7 = this;

      var resource = (0, _exportacoes2.default)(this.$http);
      var parametrosConsulta = {
        idUsuarioDe: this.transferencia.funcionarioDe.id,
        idUsuarioPara: this.transferencia.funcionarioPara.id
      };

      resource.download('transferencia-definitiva-carteira', { limit: 500, parametrosConsulta: parametrosConsulta }, 'usuario').then(function () {
        return _this7.$toast.create(_this7.$t('message.exportacao_download'), 'snack', 3E3);
      }).catch(function () {
        return _this7.$toast.create('Erro ao exportar. Tente novamente.', 'snack', 3E3);
      });
    },
    selecionar: function selecionar(item) {
      if (item.transferir) {
        this.selecionados.push(item);
      } else {
        this.selecionados.splice(this.selecionados.indexOf(item), 1);
      }
    }
  },
  mounted: function mounted() {
    this.buscarFiltros();
  }
};

/***/ }),
/* 678 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso3_vue_vue_type_script_lang_js___ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso3_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso3_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso3_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso3_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso3_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TooltipAjuda = __webpack_require__(78);

var _TooltipAjuda2 = _interopRequireDefault(_TooltipAjuda);

var _filtroCliente = __webpack_require__(120);

var _filtroCliente2 = _interopRequireDefault(_filtroCliente);

var _exportacoes = __webpack_require__(39);

var _exportacoes2 = _interopRequireDefault(_exportacoes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'TransferenciaPosseDefinitivaPasso3',
  components: {
    TooltipAjuda: _TooltipAjuda2.default
  },
  props: {
    transferencia: Object
  },
  data: function data() {
    return {
      resources: this.$api.transferenciaPosseDefinitiva(this.$resource),
      filtroClienteResource: (0, _filtroCliente2.default)(this.$resource),
      fetchRegiaoFunction: this.$api.regiao(this.$resource).listar,
      fetchExtensaoFuncion: this.$api.extensao(this.$resource).listar,
      fetchClienteFunction: this.$api.cliente(this.$resource).listarFiltrado,

      passo: 3,
      clientes: [],
      pagination: {},
      totalPage: 0,
      headers: [{ text: this.$tc('label.codigo', 1), value: 'idExterno', sortable: false }, { text: this.$tc('label.nome', 1), value: 'nomCliente', sortable: false }, { text: this.$tc('label.cnpj', 1), value: 'desCnpj', sortable: false }, { text: this.$tc('label.holding', 1), value: 'holding', sortable: false }, { text: this.$tc('label.regiao', 1), value: 'nomRegiao', sortable: false }, { text: this.$tc('label.transferir', 1) + '?', value: 'transferir', sortable: false }],
      filtros: [],
      filtroSelecionado: {},
      lista: [],
      itensFiltro: [],
      buscaLista: null,
      selecionados: []
    };
  },

  watch: {
    buscaLista: function buscaLista(val) {
      var _this = this;

      if (this.timeoutDe) {
        window.clearTimeout(this.timeoutDe);
      }
      this.timeoutDe = window.setTimeout(function () {
        if (val) _this.buscarLista(val);
      }, 500);
    },

    pagination: {
      handler: function handler() {
        this.buscarResponsaveis(this.transferencia.funcionarioDe, this.transferencia.funcionarioPara);
      },

      deep: true
    }
  },
  methods: {
    cancelar: function cancelar() {
      this.$emit('TRANSFERENCIA_DEFINITIVA_CANCELAR');
    },
    proximoPasso: function proximoPasso() {
      if (this.transferencia.transferenciaResponsavelFaturamento === 1) {
        this.transferencia.clientes = this.clientes;
      } else if (this.transferencia.transferenciaResponsavelFaturamento === 2) {
        if (!this.clientes.length) {
          this.$toast.create(this.$t('message.nenhum_cliente_para_transferir'), 'snack', 3E3);
          return;
        }
        this.transferencia.clientes = this.clientes;
      } else if (this.transferencia.transferenciaResponsavelFaturamento === 3) {
        var selecionados = this.clientes.filter(function (p) {
          return p.transferir;
        });
        if (!selecionados.length) {
          this.$toast.create(this.$t('message.nenhum_cliente_selecionado_para_transferir'), 'snack', 3E3);
          return;
        }
        this.transferencia.clientes = selecionados;
      }
      this.$emit('TRANSFERENCIA_DEFINITIVA_CONTINUAR', this.passo + 1, this.transferencia);
    },
    voltarPasso: function voltarPasso() {
      this.$emit('TRANSFERENCIA_DEFINITIVA_VOLTAR', this.passo - 1);
    },
    buscarResponsaveis: function buscarResponsaveis(funcDe, funcPara) {
      var _this2 = this;

      if (funcDe && funcPara) {
        var params = {
          numeroPagina: this.pagination.page,
          tamanhoPagina: this.pagination.itemsPerPage,
          idUsuarioDe: funcDe.id,
          idUsuarioPara: funcPara.id
        };

        if (this.filtroSelecionado.nomCampoId) {
          params[this.filtroSelecionado.nomCampoId] = this.itensFiltro;
        }

        this.resources.listarResponsaveis(params).then(function (response) {
          _this2.clientes = response.data.resposta;
          _this2.selecionados.forEach(function (s) {
            var cli = _this2.clientes.filter(function (c) {
              return c.idCliente === s.idCliente;
            });
            if (cli && cli.length) {
              cli[0].transferir = true;
            }
          });
          _this2.totalPage = response.data.quantidadeRegistrosPagina;
        }, function (err) {
          _this2.$error(_this2, err);
        });
      }
    },
    buscarFiltros: function buscarFiltros() {
      var _this3 = this;

      this.filtroClienteResource.listarAtivos().then(function (response) {
        var objetos = response.body.resposta;
        if (!objetos || !objetos.length) {
          return;
        }
        _this3.filtros = objetos;
        _this3.filtros.forEach(function (f) {
          f.nome = _this3.$t('label.filtro_cliente_' + f.nomCampoId);
        });
      }).catch(function (err) {
        _this3.$error(_this3, err);
      });
    },
    buscarLista: function buscarLista() {
      var busca = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (this.filtroSelecionado.nomCampoId) {
        if (typeof busca !== 'string') {
          busca = null;
        }
        var param = {
          nome: busca,
          indAtivo: true,
          size: 20,
          page: 1
        };

        if (this.filtroSelecionado.nomCampoId === 'id_regiao') {
          this.buscarRegiao(param);
        } else if (this.filtroSelecionado.nomCampoId === 'id_cliente') {
          param.filter = busca;
          this.buscarCliente(param);
        } else {
          param.idNivelExtensao = this.filtroSelecionado.idNivelExtensao;
          this.buscarExtensao(param);
        }
      }
    },
    buscarRegiao: function buscarRegiao(param) {
      var _this4 = this;

      this.fetchRegiaoFunction(param).then(function (response) {
        response.data = response.data.resposta.map(function (el) {
          var rt = {
            nome: el.nomRegiao,
            id: el.id,
            codRegiao: el.codRegiao
          };

          return rt;
        });

        _this4.lista = response.data;
      }).catch(function (err) {
        _this4.$error(_this4, err);
      });
    },
    buscarExtensao: function buscarExtensao(param) {
      var _this5 = this;

      param.idUsuario = this.transferencia.funcionarioDe.id;
      this.fetchExtensaoFuncion(param).then(function (response) {
        response.data = response.data.resposta.map(function (el) {
          var rt = {
            nome: el.nomExtensao,
            id: el.id,
            idExterno: el.idExterno
          };

          return rt;
        });

        _this5.lista = response.data;
      }).catch(function (err) {
        _this5.$error(_this5, err);
      });
    },
    buscarCliente: function buscarCliente(param) {
      var _this6 = this;

      this.fetchClienteFunction(param).then(function (response) {
        response.data = response.data.resposta.map(function (el) {
          var rt = {
            nome: el.cod_nom_cliente,
            id: el.id,
            idExterno: el.idExterno
          };

          return rt;
        });

        _this6.lista = response.data;
      }).catch(function (err) {
        _this6.$error(_this6, err);
      });
    },
    limparFiltro: function limparFiltro() {
      this.lista = [];
      this.itensFiltro = [];
      this.selecionados = [];
    },
    aplicarFiltro: function aplicarFiltro() {
      this.selecionados = [];
      this.pagination.page = 1;
      this.buscarResponsaveis(this.transferencia.funcionarioDe, this.transferencia.funcionarioPara);
    },
    exportar: function exportar() {
      var _this7 = this;

      var resource = (0, _exportacoes2.default)(this.$http);
      var parametrosConsulta = {
        idUsuarioDe: this.transferencia.funcionarioDe.id,
        idUsuarioPara: this.transferencia.funcionarioPara.id
      };

      resource.download('transferencia-definitiva-responsavel', { limit: 500, parametrosConsulta: parametrosConsulta }, 'usuario').then(function () {
        return _this7.$toast.create(_this7.$t('message.exportacao_download'), 'snack', 3E3);
      }).catch(function () {
        return _this7.$toast.create('Erro ao exportar. Tente novamente.', 'snack', 3E3);
      });
    },
    selecionar: function selecionar(item) {
      if (item.transferir) {
        this.selecionados.push(item);
      } else {
        this.selecionados.splice(this.selecionados.indexOf(item), 1);
      }
    }
  },
  mounted: function mounted() {
    this.buscarFiltros();
  }
};

/***/ }),
/* 681 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso4_vue_vue_type_script_lang_js___ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso4_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso4_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso4_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso4_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso4_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(9);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _values = __webpack_require__(42);

var _values2 = _interopRequireDefault(_values);

var _dateUtils = __webpack_require__(30);

var _TooltipAjuda = __webpack_require__(78);

var _TooltipAjuda2 = _interopRequireDefault(_TooltipAjuda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'TransferenciaPosseDefinitivaPasso4',
  components: {
    TooltipAjuda: _TooltipAjuda2.default
  },
  props: {
    transferencia: Object
  },
  data: function data() {
    var _this = this;

    return {
      resources: this.$api.transferenciaPosseDefinitiva(this.$resource),
      fetchExtensaoFuncion: this.$api.extensao(this.$resource).listar,

      passo: 4,
      orcamentos: [],
      pagination: {},
      totalPage: 0,
      headers: [{ text: this.$tc('label.orcamento', 1), value: 'orcamento', sortable: false }, { text: this.$tc('label.marca', 1), value: 'marca', sortable: false }, { text: this.$tc('label.linha_orcamento', 1), value: 'linha', sortable: false }, { text: this.$tc('label.data_inicio', 1), value: 'dtaInicioOrcamento', sortable: false }, { text: this.$tc('label.data_fim', 1), value: 'dtaFimOrcamento', sortable: false }, { text: this.$tc('label.planejado', 1), value: 'vlrPlanejado', sortable: false }, { text: this.$tc('label.reservado', 1), value: 'vlrReservado', sortable: false }, { text: this.$tc('label.conf_negociacao', 1), value: 'vlrConfAcao', sortable: false }, { text: this.$tc('label.conf_apuracao', 1), value: 'vlrConfApuracao', sortable: false }, { text: this.$tc('label.consumido', 1), value: 'vlrConsumido', sortable: false }, { text: this.$tc('label.acoes', 2), value: 'acoes', sortable: false }, { text: this.$tc('label.transferir', 1) + '?', value: 'transferir', sortable: false }],
      dataInicio: '',
      dataFim: '',
      menuDataInicio: false,
      menuDataFim: false,
      rules: {
        validDate: function validDate(value) {
          return !value || value.length === 10 && _this.moment(value, 'DD-MM-YYYY').isValid() || _this.$t('message.data_invalida');
        },
        dataFimMaiorInicio: function dataFimMaiorInicio() {
          return !_this.isDataFimMaiorInicio() || _this.$t('message.data_inicial_maior_final');
        }
      },
      filtroMarcas: [],
      marcas: [],
      searchMarca: null,
      selecionados: {}
    };
  },

  watch: {
    searchMarca: function searchMarca(val) {
      var _this2 = this;

      if (this.timeoutDe) {
        window.clearTimeout(this.timeoutDe);
      }
      this.timeoutDe = window.setTimeout(function () {
        if (val) _this2.buscarMarcas(val);
      }, 500);
    },

    pagination: {
      handler: function handler() {
        this.buscarOrcamentos(this.transferencia.funcionarioDe);
      },

      deep: true
    }
  },
  computed: {
    dateInicioFormatada: {
      get: function get() {
        return (0, _dateUtils.formatDateDDMMYYYY)(this.dataInicio);
      },
      set: function set(newValue) {
        this.dataInicio = (0, _dateUtils.parseDateYYYYMMDD)(newValue);
      }
    },
    dateFimFormatada: {
      get: function get() {
        return (0, _dateUtils.formatDateDDMMYYYY)(this.dataFim);
      },
      set: function set(newValue) {
        this.dataFim = (0, _dateUtils.parseDateYYYYMMDD)(newValue);
      }
    }
  },
  methods: {
    cancelar: function cancelar() {
      this.$emit('TRANSFERENCIA_DEFINITIVA_CANCELAR');
    },
    proximoPasso: function proximoPasso() {
      var selecionados = (0, _values2.default)(this.selecionados);
      if (selecionados.length === 0) {
        this.$toast.create(this.$t('message.nenhum_orcamento_selecionado_para_transferir'), 'snack', 3E3);
        return;
      }
      this.transferencia.orcamentos = [].concat((0, _toConsumableArray3.default)(selecionados));
      this.$emit('TRANSFERENCIA_DEFINITIVA_CONTINUAR', this.passo + 1, this.transferencia);
    },
    voltarPasso: function voltarPasso() {
      this.$emit('TRANSFERENCIA_DEFINITIVA_VOLTAR', this.passo - 1);
    },
    buscarOrcamentos: function buscarOrcamentos(funcDe) {
      var _this3 = this;

      if (funcDe) {
        var params = {
          numeroPagina: this.pagination.page,
          tamanhoPagina: this.pagination.itemsPerPage,
          idUsuarioDe: funcDe.id,
          dataInicio: this.dataInicio,
          dataFim: this.dataFim
        };
        if (this.filtroMarcas.length) {
          params.marcas = this.filtroMarcas;
        }
        this.resources.orcamento(params).then(function (response) {
          _this3.orcamentos = response.data.resposta;
          _this3.orcamentos.forEach(function (e) {
            e.vlrPlanejado = e.vlrPlanejado.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
            e.vlrReservado = e.vlrReservado.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
            e.vlrConfAcao = e.vlrConfAcao.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
            e.vlrConfApuracao = e.vlrConfApuracao.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
            e.vlrConsumido = e.vlrConsumido.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
          });
          _this3.totalPage = response.data.quantidadeRegistrosPagina;
        }, function (err) {
          _this3.$error(_this3, err);
        });
      }
    },
    limparFiltro: function limparFiltro() {
      this.lista = [];
      this.itensFiltro = [];
      this.selecionados = {};
    },
    aplicarFiltro: function aplicarFiltro() {
      this.selecionados = {};
      this.pagination.page = 1;
      this.buscarOrcamentos(this.transferencia.funcionarioDe);
    },
    isDataFimMaiorInicio: function isDataFimMaiorInicio() {
      var dtInicio = this.moment(this.dataInicio, 'YYYY-MM-DD');
      var dtFinal = this.moment(this.dataFim, 'YYYY-MM-DD');
      return dtFinal.isBefore(dtInicio);
    },
    buscarMarcas: function buscarMarcas() {
      var _this4 = this;

      var busca = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (typeof busca !== 'string') {
        busca = null;
      }
      var param = {
        idNivelExtensao: 2,
        nome: busca,
        indAtivo: true,
        size: 20,
        page: 1
      };
      this.fetchExtensaoFuncion(param).then(function (response) {
        _this4.marcas = response.data.resposta;
      }).catch(function (err) {
        _this4.$error(_this4, err);
      });
    },
    selecionar: function selecionar(item) {
      var orcamento = item.orcamento,
          idLinha = item.idLinha;

      var chave = orcamento + '-' + idLinha;

      if (this.selecionados[chave] == null) {
        this.selecionados[chave] = item;
      } else {
        delete this.selecionados[chave];
      }
    }
  },
  mounted: function mounted() {}
};

/***/ }),
/* 684 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso5_vue_vue_type_script_lang_js___ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso5_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso5_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso5_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso5_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso5_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Confirm = __webpack_require__(12);

var _Confirm2 = _interopRequireDefault(_Confirm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'TransferenciaPosseDefinitivaPasso5',
  props: {
    transferencia: Object
  },
  components: {
    Confirm: _Confirm2.default
  },
  data: function data() {
    var _this = this;

    return {
      resources: this.$api.transferenciaPosseDefinitiva(this.$resource),

      passo: 5,
      rules: {
        required: function required(value) {
          return !!value || _this.$t('message.campo_obrigatorio');
        }
      }
    };
  },

  methods: {
    cancelar: function cancelar() {
      this.$emit('TRANSFERENCIA_DEFINITIVA_CANCELAR');
    },
    concluir: function concluir() {
      if (this.$refs.form.validate()) {
        this.$emit('TRANSFERENCIA_DEFINITIVA_CONCLUIR', this.transferencia);
      }
    },
    voltarPasso: function voltarPasso() {
      this.$emit('TRANSFERENCIA_DEFINITIVA_VOLTAR', this.passo - 1);
    },
    confirmarConclusao: function confirmarConclusao() {
      if (this.$refs.form.validate()) {
        this.$refs.confirmDialog.open();
      }
    }
  },
  mounted: function mounted() {}
};

/***/ }),
/* 687 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 688 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_UnidadeMedidaCadastro_vue_vue_type_script_lang_js___ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_UnidadeMedidaCadastro_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_UnidadeMedidaCadastro_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_UnidadeMedidaCadastro_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_UnidadeMedidaCadastro_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_UnidadeMedidaCadastro_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _rolesComputedGenerator = __webpack_require__(8);

var _UnidadeMedidaForm = __webpack_require__(1604);

var _UnidadeMedidaForm2 = _interopRequireDefault(_UnidadeMedidaForm);

var _UnidadeMedidaLista = __webpack_require__(1607);

var _UnidadeMedidaLista2 = _interopRequireDefault(_UnidadeMedidaLista);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'UnidadeMedidaCadastro',
  data: function data() {
    return {};
  },

  components: {
    UnidadeMedidaForm: _UnidadeMedidaForm2.default,
    UnidadeMedidaLista: _UnidadeMedidaLista2.default
  },
  computed: (0, _extends3.default)({}, (0, _rolesComputedGenerator.generateComputed)('unid medida', ['canAccessCRUD', 'canAccessPage']), {
    somenteLeitura: function somenteLeitura() {
      return !this.canAccessCRUD;
    }
  }),
  methods: {
    accessForbidden: function accessForbidden() {
      if (!this.canAccessPage) {
        this.$router.push({ name: 'inicio' });
        this.$toast.create(this.$t('message.acesso_negado'), 'snack', 3E3);
      }
    },
    onEditarUnidade: function onEditarUnidade(unidade) {
      this.$refs.unidadeMedidaForm.editar(unidade);
    },
    onUnidadeSalva: function onUnidadeSalva() {
      this.$refs.unidadeTabela.filtrar();
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;

    if (!this.canAccessPage) {
      window.setTimeout(function () {
        _this.accessForbidden();
      }, 1E3);
    }
  }
};

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_UnidadeMedidaForm_vue_vue_type_script_lang_js___ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_UnidadeMedidaForm_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_UnidadeMedidaForm_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_UnidadeMedidaForm_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_UnidadeMedidaForm_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_UnidadeMedidaForm_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _Confirm = __webpack_require__(12);

var _Confirm2 = _interopRequireDefault(_Confirm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'UnidadeMedidaForm',
  data: function data() {
    var _this = this;

    return {
      unidadeMedidaResources: this.$api.unidadeMedida(this.$resource),

      unidade: {},
      rules: {
        required: function required(value) {
          return !!value || _this.$t('message.campo_obrigatorio');
        }
      },
      dialog: {
        content: ''
      }
    };
  },

  watch: {},
  components: {
    Confirm: _Confirm2.default
  },
  methods: {
    cancel: function cancel() {
      this.limparFormulario();
    },
    editar: function editar(unidade) {
      this.unidade = (0, _extends3.default)({}, unidade);
    },
    limparFormulario: function limparFormulario() {
      this.unidade = {};
      this.$refs.form.reset();
    },
    openSaveDialog: function openSaveDialog() {
      if (!this.$refs.form.validate()) return;
      this.dialog.content = this.$t('message.salvar');
      this.$refs.confirmDialog.open();
    },
    save: function save() {
      var _this2 = this;

      var salvarOuAtualizar = void 0;
      var inclusao = true;

      if (this.unidade.id != null) {
        inclusao = false;
        salvarOuAtualizar = this.unidadeMedidaResources.atualizar(this.unidade);
      } else {
        salvarOuAtualizar = this.unidadeMedidaResources.gravar(this.unidade);
      }

      salvarOuAtualizar.then(function () {
        return _this2.limparFormulario();
      }).then(function () {
        return _this2.$toast.create(_this2.$t(inclusao ? 'message.adicionado_confira_tabela' : 'message.atualizado_confira_tabela'), 'snack', 3e3);
      }).then(function () {
        _this2.$emit('FORMULARIO_CADASTRO_UNIDADE_SALVAR', _this2.unidade, _this2.clearForm);
      }).catch(function (err) {
        _this2.$error(_this2, err);
      });
    }
  },
  computed: {
    ehEdicao: function ehEdicao() {
      return this.unidade.id;
    }
  },
  mounted: function mounted() {}
};

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_UnidadeMedidaLista_vue_vue_type_script_lang_js___ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_UnidadeMedidaLista_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_UnidadeMedidaLista_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_UnidadeMedidaLista_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_UnidadeMedidaLista_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_UnidadeMedidaLista_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _rolesComputedGenerator = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      unidadeMedidaResources: this.$api.unidadeMedida(this.$resource),
      lista: [],
      esperar: false,
      totalPage: 0,
      headers: [{ text: this.$tc('label.sigla', 1), value: 'sigla', sortable: false }, { text: this.$tc('label.nome', 1), value: 'nome', sortable: false }, { text: '', value: 'acoes', sortable: false }],
      pagination: {},
      searchQuery: ''
    };
  },

  watch: {
    pagination: {
      handler: function handler() {
        this.filtrar();
      },

      deep: true
    },
    searchQuery: function searchQuery() {
      var _this = this;

      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      this.timeout = window.setTimeout(function () {
        _this.filtrar();
      }, 500);
    }
  },
  props: {
    title: String
  },
  computed: (0, _extends3.default)({}, (0, _rolesComputedGenerator.generateComputed)('unid medida', ['canAccessCRUD']), {
    somenteLeitura: function somenteLeitura() {
      return !this.canAccessCRUD;
    }
  }),
  methods: {
    buscar: function buscar() {
      var _this2 = this;

      if (this.searchQuery) {
        this.pagination.page = 1;
      }

      var params = {
        nome: this.searchQuery,
        page: this.pagination.page,
        size: this.pagination.itemsPerPage,
        asc: !this.pagination.sortDesc[0],
        colunaOrdenacao: this.pagination.sortBy[0]
      };

      this.unidadeMedidaResources.listar(params).then(function (response) {
        _this2.lista = response.data.resposta;
        _this2.totalPage = response.data.quantidadeRegistrosPagina;
        _this2.pararEsperar();
      }, function (err) {
        _this2.pararEsperar();
        _this2.$error(_this2, err);
      });
    },
    filtrar: function filtrar() {
      var _this3 = this;

      if (this.esperar) return;
      this.esperar = true;
      setTimeout(function () {
        _this3.buscar();
      }, 5E2);
    },
    getSearchQuery: function getSearchQuery() {
      return this.searchQuery;
    },
    onEditar: function onEditar(unidade) {
      this.$emit('PESQUISA_UNIDADE_EDITAR', unidade);
    },
    pararEsperar: function pararEsperar() {
      var _this4 = this;

      setTimeout(function () {
        _this4.esperar = false;
      }, 2E2);
    }
  }
};

/***/ }),
/* 695 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Usuario_vue_vue_type_script_lang_js___ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Usuario_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Usuario_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Usuario_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Usuario_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_Usuario_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _rolesComputedGenerator = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Usuario',
  methods: {
    accessForbidden: function accessForbidden() {
      this.$router.push({ name: 'inicio' });
      this.$toast.create('Acesso negado', 'snack', 3E3);
    }
  },
  computed: (0, _extends3.default)({}, (0, _rolesComputedGenerator.generateComputed)('usr', ['canAccessPage'])),
  beforeMount: function beforeMount() {
    var _this = this;

    if (!this.canAccessPage) {
      window.setTimeout(function () {
        return _this.accessForbidden();
      }, 1E3);
    }
  }
};

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_script_lang_js___ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_script_lang_js____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_script_lang_js___);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_strip_loader_lib_index_js_strip_debug_strip_debugger_strip_console_log_strip_console_warn_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_script_lang_js____default.a); 

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'app',
  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('roles', ['setToken'])),
  mounted: function mounted() {
    this.setToken(this.$auth.token);
  }
};

/***/ }),
/* 700 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      alturaTela: window.innerHeight,
      posicaoTopTabela: 0
    };
  },

  computed: {
    altura: function altura() {
      return this.alturaTela - 180 - this.posicaoTopTabela;
    }
  },
  methods: {
    onResize: function onResize(tabela, recarregar) {
      var tabelas = document.getElementsByClassName(tabela);
      if (tabelas && tabelas.length && (!this.posicaoTopTabela || recarregar)) {
        this.posicaoTopTabela = tabelas[0].getBoundingClientRect().top;
      }
      this.alturaTela = window.innerHeight;
    }
  }
};

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InputMoney_vue_vue_type_template_id_0e8feb0a___ = __webpack_require__(1029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InputMoney_vue_vue_type_script_lang_js___ = __webpack_require__(317);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__InputMoney_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__InputMoney_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InputMoney_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(1031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__InputMoney_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__InputMoney_vue_vue_type_template_id_0e8feb0a___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__InputMoney_vue_vue_type_template_id_0e8feb0a___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ExecucaoSidebar_vue_vue_type_template_id_68886914___ = __webpack_require__(1067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ExecucaoSidebar_vue_vue_type_script_lang_js___ = __webpack_require__(348);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__ExecucaoSidebar_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__ExecucaoSidebar_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ExecucaoSidebar_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__ExecucaoSidebar_vue_vue_type_template_id_68886914___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ExecucaoSidebar_vue_vue_type_template_id_68886914___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GenericModal_vue_vue_type_template_id_2cf891ef_scoped_true_lang_html___ = __webpack_require__(1078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GenericModal_vue_vue_type_script_lang_js___ = __webpack_require__(358);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__GenericModal_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__GenericModal_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GenericModal_css_vue_type_style_index_0_id_2cf891ef_lang_css_scoped_true___ = __webpack_require__(1080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__GenericModal_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__GenericModal_vue_vue_type_template_id_2cf891ef_scoped_true_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__GenericModal_vue_vue_type_template_id_2cf891ef_scoped_true_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  "2cf891ef",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dropzone_vue_vue_type_template_id_4810c88c___ = __webpack_require__(1060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dropzone_vue_vue_type_script_lang_js___ = __webpack_require__(341);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__Dropzone_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__Dropzone_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dropzone_scss_vue_type_style_index_0_lang_scss___ = __webpack_require__(1063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Dropzone_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__Dropzone_vue_vue_type_template_id_4810c88c___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Dropzone_vue_vue_type_template_id_4810c88c___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'exportacao_arquivo');

exports.default = function ($http, timeout) {
  var getResponseProperty = function getResponseProperty(obj) {
    for (var _len = arguments.length, params = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      params[_key - 1] = arguments[_key];
    }

    var attribute = params.filter(function (el) {
      return obj.hasOwnProperty(el);
    })[0];
    var value = obj[attribute];
    return value[0];
  };

  var getFileName = function getFileName(response) {
    var header = getResponseProperty(response.headers.map, 'content-disposition', 'Content-Disposition');
    var temp = header.split('filename=');
    var fileName = temp[1];
    return fileName;
  };

  var onError = function onError(response) {
    console.error('TODO: falha ao exportar', response);
    throw Error('Erro ao exportar');
  };

  var onFileDownloaded = function onFileDownloaded(response) {
    if (!response || !response.data) {
      return onError(response);
    }
    var fileName = getFileName(response);
    var type = getResponseProperty(response.headers.map, 'content-type', 'Content-Type');
    var file = new window.Blob([response.data], { type: type });
    var a = document.createElement('a');
    a.download = fileName;
    a.href = window.URL.createObjectURL(file);
    document.body.appendChild(a);
    a.click();
    return a;
  };

  return {
    download: function download(nomeExportacao, parametros) {
      var resourceOptional = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var variableBasePath = resourceOptional != null ? (0, _apiResource2.default)(resourceOptional, 'exportacao_arquivo') : basePath;
      var downloadUrl = variableBasePath + '/planilha/' + nomeExportacao;
      return $http.post(downloadUrl, parametros, { responseType: 'arraybuffer', timeout: timeout }).then(onFileDownloaded).catch(onError);
    }
  };
};

/***/ }),
/* 710 */,
/* 711 */,
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'configuracao-pagamento');

var configuracaoPagamentoActions = {
  atualizar: { method: 'PUT', url: '' + basePath },
  pesquisar: { method: 'GET', url: '' + basePath },
  pesquisarSap: { method: 'GET', url: basePath + '/chave/SAP_AUTOMATICO' },
  verificar: { method: 'GET', url: basePath + '/habilitado?chave={chave}' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, configuracaoPagamentoActions);
};

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(44);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(6);

var _vuex2 = _interopRequireDefault(_vuex);

var _vueRouter = __webpack_require__(122);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _veeValidate = __webpack_require__(123);

var _vuexRouterSync = __webpack_require__(717);

__webpack_require__(718);

__webpack_require__(720);

var _store = __webpack_require__(721);

var _store2 = _interopRequireDefault(_store);

var _plugins = __webpack_require__(759);

var _plugins2 = _interopRequireDefault(_plugins);

var _vuetify = __webpack_require__(894);

var _vuetify2 = _interopRequireDefault(_vuetify);

var _directives = __webpack_require__(898);

var _directives2 = _interopRequireDefault(_directives);

var _validations = __webpack_require__(909);

var _validations2 = _interopRequireDefault(_validations);

var _theme = __webpack_require__(246);

var _theme2 = _interopRequireDefault(_theme);

var _interceptors = __webpack_require__(915);

var _interceptors2 = _interopRequireDefault(_interceptors);

var _router = __webpack_require__(928);

var _router2 = _interopRequireDefault(_router);

var _i18n = __webpack_require__(1617);

var _i18n2 = _interopRequireDefault(_i18n);

var _auth = __webpack_require__(105);

var _auth2 = _interopRequireDefault(_auth);

var _dicionario = __webpack_require__(1619);

var _dicionario2 = _interopRequireDefault(_dicionario);

var _App = __webpack_require__(1620);

var _App2 = _interopRequireDefault(_App);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.jQuery = __webpack_require__(80);
window.$ = window.jQuery;
window.$logger = console;

(0, _plugins2.default)(_vue2.default, _vuex2.default, _vueRouter2.default);
(0, _directives2.default)(_vue2.default);
(0, _theme2.default)(_vue2.default);
(0, _validations2.default)(_veeValidate.Validator);
(0, _interceptors2.default)(_vue2.default);

_vue2.default.config.ignoredElements = ['angular-gauge-chart', 'bar-chart-3d', 'clustered-chart', 'column-chart', 'data-grid', 'line-chart', 'lined-bar-chart', 'pie-chart', 'sbx-dashboard'];
_vue2.default.config.productionTip = false;

_auth.auth.loginRequired().then(_dicionario2.default.carregar).then(function (resDicionario) {
  var store = new _vuex2.default.Store(_store2.default);
  var router = (0, _router2.default)(_vueRouter2.default);

  (0, _vuexRouterSync.sync)(store, router);
  var i18nData = (0, _i18n2.default)(_vue2.default, resDicionario);
  i18nData.locale = 'pt-br';

  new _vue2.default({
    router: router,
    store: store,
    vuetify: _vuetify2.default,
    i18n: i18nData,
    el: '#app',
    template: '<App/>',
    components: { App: _App2.default },
    created: function created() {
      _auth.auth.createInterceptors();

      _vue2.default.use(_auth2.default);
    }
  });
}).catch(function (e) {
  if (e.status && e.message && e.status === 403) {
    window.alert(e.message);
  }
});

/***/ }),
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 719 */,
/* 720 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _importacao = __webpack_require__(722);

var _importacao2 = _interopRequireDefault(_importacao);

var _controlador = __webpack_require__(723);

var _controlador2 = _interopRequireDefault(_controlador);

var _metadados = __webpack_require__(738);

var _metadados2 = _interopRequireDefault(_metadados);

var _roles = __webpack_require__(739);

var _roles2 = _interopRequireDefault(_roles);

var _usuario = __webpack_require__(749);

var _usuario2 = _interopRequireDefault(_usuario);

var _parametros = __webpack_require__(757);

var _parametros2 = _interopRequireDefault(_parametros);

var _implantacao = __webpack_require__(758);

var _implantacao2 = _interopRequireDefault(_implantacao);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  modules: {
    importacao: _importacao2.default,
    controlador: _controlador2.default,
    metadados: _metadados2.default,
    roles: _roles2.default,
    usuario: _usuario2.default,
    parametros: _parametros2.default,
    implantacao: _implantacao2.default
  },
  strict: true
};

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var mutations = {
  popularImportacoesAndamento: function popularImportacoesAndamento(state, importacao) {
    if (importacao) {
      state.andamento = importacao;
    }
  },
  popularImportacoesFinalizados: function popularImportacoesFinalizados(state, importacao) {
    if (importacao) {
      state.finalizados = importacao;
    }
  },
  popularImportacoesErros: function popularImportacoesErros(state, importacao) {
    if (importacao) {
      state.erros = importacao;
    }
  },
  popularTiposImportacao: function popularTiposImportacao(state, _ref) {
    var tiposImportacao = _ref.tiposImportacao,
        _ref$roles = _ref.roles,
        roles = _ref$roles === undefined ? [] : _ref$roles;

    if (tiposImportacao) {
      var lista = tiposImportacao.filter(function (t) {
        return t.role === null || roles.indexOf(t.role) !== -1;
      });
      lista.forEach(function (el) {
        el.arquivosSuportados = '.'.concat(el.arquivosSuportados.replace(/ /g, '').replace(/,/g, ',.'));
      });
      state.tiposImportacao = lista.sort(function (a, b) {
        if (a.id > b.id) {
          return 1;
        }
        return -1;
      });
    }
  }
};

var actions = {
  popularImportacoesAndamento: function popularImportacoesAndamento(_ref2, resource) {
    var commit = _ref2.commit;

    return resource().then(function (response) {
      commit('popularImportacoesAndamento', response.data);
    }).catch(function (err) {
      throw err;
    });
  },
  popularImportacoesFinalizados: function popularImportacoesFinalizados(_ref3, resource) {
    var commit = _ref3.commit;

    return resource().then(function (response) {
      commit('popularImportacoesFinalizados', response.data);
    }).catch(function (err) {
      throw err;
    });
  },
  popularImportacoesErros: function popularImportacoesErros(_ref4, resource) {
    var commit = _ref4.commit;

    return resource().then(function (response) {
      commit('popularImportacoesErros', response.data);
    }).catch(function (err) {
      throw err;
    });
  },
  popularTiposImportacao: function popularTiposImportacao(_ref5, _ref6) {
    var commit = _ref5.commit;
    var resource = _ref6.resource,
        roles = _ref6.roles;

    return resource().then(function (response) {
      var tiposImportacao = response.data;
      commit('popularTiposImportacao', { tiposImportacao: tiposImportacao, roles: roles });
    }).catch(function (err) {
      throw err;
    });
  }
};

var getters = {
  getImportacoesAndamento: function getImportacoesAndamento(state) {
    return state.andamento;
  },
  getImportacoesFinalizados: function getImportacoesFinalizados(state) {
    return state.finalizados;
  },
  getImportacoesErros: function getImportacoesErros(state) {
    return state.erros;
  },
  getAtualImportacao: function getAtualImportacao(state) {
    return state.atual;
  },
  getTiposImportacao: function getTiposImportacao(state) {
    return state.tiposImportacao;
  }
};

var state = {
  andamento: [],
  finalizados: [],
  erros: [],
  tiposImportacao: []
};

exports.default = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

var _stringify = __webpack_require__(38);

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mutations = {
  setControladores: function setControladores(state, controladores) {
    state.controladores = controladores;
  },
  setControladoreSelecionado: function setControladoreSelecionado(state, controlador) {
    window.sessionStorage.setItem('controladorTrade', (0, _stringify2.default)(controlador));
    state.controladoreSelecionado = controlador;
  },
  desmarcaSelecao: function desmarcaSelecao(state) {
    window.sessionStorage.removeItem('controladorTrade');
    state.controladoreSelecionado = null;
  }
};

var actions = {
  carregarControladores: function carregarControladores(_ref, resource) {
    var commit = _ref.commit;

    return new _promise2.default(function (resolve, reject) {
      resource().then(function (response) {
        var controladores = response.data || [];
        var titulares = controladores.filter(function (c) {
          return c.ehTitular;
        });
        commit('setControladores', controladores);
        commit('setControladoreSelecionado', titulares[0] || controladores[0] || {});
        resolve();
      }).catch(reject);
    });
  },
  setControladoreSelecionado: function setControladoreSelecionado(_ref2, controlador) {
    var commit = _ref2.commit;

    commit('setControladoreSelecionado', controlador);
  },
  desmarcaSelecao: function desmarcaSelecao(_ref3) {
    var commit = _ref3.commit;

    commit('desmarcaSelecao');
  }
};

var getters = {
  getControladores: function getControladores(state) {
    return state.controladores;
  },
  getControladoreSelecionado: function getControladoreSelecionado(state) {
    return state.controladoreSelecionado;
  }
};

var state = {
  controladores: [],
  controladoreSelecionado: {}
};

exports.default = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var mutations = {
  setMetadado: function setMetadado(state, _ref) {
    var owner = _ref.owner,
        metadado = _ref.metadado;

    if (state.hasOwnProperty(owner)) {
      state[owner] = metadado;
    }
  }
};

var actions = {
  setMetadado: function setMetadado(_ref2, _ref3) {
    var commit = _ref2.commit;
    var owner = _ref3.owner,
        resource = _ref3.resource,
        _ref3$params = _ref3.params,
        params = _ref3$params === undefined ? null : _ref3$params,
        callback = _ref3.callback;

    if (owner && resource) {
      resource(params).then(function (res) {
        var metadado = res.body;
        commit('setMetadado', { owner: owner, metadado: metadado });
        if (callback) {
          callback();
        }
      });
    }
  },
  setClienteMetadado: function setClienteMetadado(_ref4, _ref5) {
    var commit = _ref4.commit;
    var resource = _ref5.resource,
        params = _ref5.params,
        callback = _ref5.callback;

    actions.setMetadado({ commit: commit }, {
      owner: 'cliente',
      resource: resource,
      params: params,
      callback: callback
    });
  },
  setUsuarioMetadado: function setUsuarioMetadado(_ref6, _ref7) {
    var commit = _ref6.commit;
    var resource = _ref7.resource,
        params = _ref7.params;

    actions.setMetadado({ commit: commit }, {
      owner: 'usuario',
      resource: resource,
      params: params
    });
  },
  setProdutoMetadado: function setProdutoMetadado(_ref8, _ref9) {
    var commit = _ref8.commit;
    var resource = _ref9.resource,
        params = _ref9.params;

    actions.setMetadado({ commit: commit }, {
      owner: 'produto',
      resource: resource,
      params: params
    });
  },
  setAcaoTaticaMetadado: function setAcaoTaticaMetadado(_ref10, _ref11) {
    var commit = _ref10.commit;
    var resource = _ref11.resource,
        params = _ref11.params;

    actions.setMetadado({ commit: commit }, {
      owner: 'acaoTatica',
      resource: resource,
      params: params
    });
  },
  setRelatorioMetadado: function setRelatorioMetadado(_ref12, _ref13) {
    var commit = _ref12.commit;
    var resource = _ref13.resource,
        params = _ref13.params;

    actions.setMetadado({ commit: commit }, {
      owner: 'relatorio',
      resource: resource,
      params: params
    });
  },
  setCarteiraClienteMetadado: function setCarteiraClienteMetadado(_ref14, _ref15) {
    var commit = _ref14.commit;
    var resource = _ref15.resource,
        params = _ref15.params;

    actions.setMetadado({ commit: commit }, {
      owner: 'carteiraCliente',
      resource: resource,
      params: params
    });
  },
  setDivisaoMetadado: function setDivisaoMetadado(_ref16, _ref17) {
    var commit = _ref16.commit;
    var resource = _ref17.resource,
        params = _ref17.params;

    actions.setMetadado({ commit: commit }, {
      owner: 'divisao',
      resource: resource,
      params: params
    });
  },
  setCentroCustoMetadado: function setCentroCustoMetadado(_ref18, _ref19) {
    var commit = _ref18.commit;
    var resource = _ref19.resource,
        params = _ref19.params;

    actions.setMetadado({ commit: commit }, {
      owner: 'ceco',
      resource: resource,
      params: params
    });
  },
  setOrcamentoMetadado: function setOrcamentoMetadado(_ref20, _ref21) {
    var commit = _ref20.commit;
    var resource = _ref21.resource,
        params = _ref21.params,
        callback = _ref21.callback;

    actions.setMetadado({ commit: commit }, {
      owner: 'orcamento',
      resource: resource,
      params: params,
      callback: callback
    });
  },
  setLinhaInvestimentoMetadado: function setLinhaInvestimentoMetadado(_ref22, _ref23) {
    var commit = _ref22.commit;
    var resource = _ref23.resource,
        params = _ref23.params,
        callback = _ref23.callback;

    actions.setMetadado({ commit: commit }, {
      owner: 'linhaInvestimento',
      resource: resource,
      params: params,
      callback: callback
    });
  },
  setAcaoMetadado: function setAcaoMetadado(_ref24, _ref25) {
    var commit = _ref24.commit;
    var resource = _ref25.resource,
        params = _ref25.params,
        callback = _ref25.callback;

    actions.setMetadado({ commit: commit }, {
      owner: 'acao',
      resource: resource,
      params: params,
      callback: callback
    });
  },
  setContratoMetadado: function setContratoMetadado(_ref26, _ref27) {
    var commit = _ref26.commit;
    var resource = _ref27.resource,
        params = _ref27.params,
        callback = _ref27.callback;

    actions.setMetadado({ commit: commit }, {
      owner: 'contrato',
      resource: resource,
      params: params,
      callback: callback
    });
  },
  setFornecedorMetadado: function setFornecedorMetadado(_ref28, _ref29) {
    var commit = _ref28.commit;
    var resource = _ref29.resource,
        params = _ref29.params,
        callback = _ref29.callback;

    actions.setMetadado({ commit: commit }, {
      owner: 'fornecedor',
      resource: resource,
      params: params,
      callback: callback
    });
  },
  setFilialMetadado: function setFilialMetadado(_ref30, _ref31) {
    var commit = _ref30.commit;
    var resource = _ref31.resource,
        params = _ref31.params,
        callback = _ref31.callback;

    actions.setMetadado({ commit: commit }, {
      owner: 'filial',
      resource: resource,
      params: params,
      callback: callback
    });
  }
};

var getters = {
  getClienteMetadado: function getClienteMetadado(state) {
    return state.cliente;
  },
  getProdutoMetadado: function getProdutoMetadado(state) {
    return state.produto;
  },
  getUsuarioMetadado: function getUsuarioMetadado(state) {
    return state.usuario;
  },
  getAcaoTaticaMetadado: function getAcaoTaticaMetadado(state) {
    return state.acaoTatica;
  },
  getRelatorioMetadado: function getRelatorioMetadado(state) {
    return state.relatorio;
  },
  getCarteiraClienteMetadado: function getCarteiraClienteMetadado(state) {
    return state.carteiraCliente;
  },
  getDivisaoMetadado: function getDivisaoMetadado(state) {
    return state.divisao;
  },
  getCentroCustoMetadado: function getCentroCustoMetadado(state) {
    return state.ceco;
  },
  getOrcamentoMetadado: function getOrcamentoMetadado(state) {
    return state.orcamento;
  },
  getLinhaInvestimentoMetadado: function getLinhaInvestimentoMetadado(state) {
    return state.linhaInvestimento;
  },
  getAcaoMetadado: function getAcaoMetadado(state) {
    return state.acao;
  },
  getContratoMetadado: function getContratoMetadado(state) {
    return state.contrato;
  },
  getFornecedorMetadado: function getFornecedorMetadado(state) {
    return state.fornecedor;
  },
  getFilialMetadado: function getFilialMetadado(state) {
    return state.filial;
  }
};

var state = {
  cliente: null,
  produto: null,
  usuario: null,
  acaoTatica: null,
  relatorio: null,
  carteiraCliente: null,
  divisao: null,
  ceco: null,
  orcamento: null,
  linhaInvestimento: null,
  acao: null,
  contrato: null,
  fornecedor: null,
  filial: null
};

exports.default = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(73);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = __webpack_require__(4);

var _assign2 = _interopRequireDefault(_assign);

var _keys = __webpack_require__(11);

var _keys2 = _interopRequireDefault(_keys);

var _jwtDecode = __webpack_require__(746);

var _jwtDecode2 = _interopRequireDefault(_jwtDecode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var removeString = function removeString(remove, string) {
  return string.replace(remove, '');
};

var reduceTradelinksRoles = function reduceTradelinksRoles(resourceAccess, keyExample) {
  return (0, _keys2.default)(resourceAccess).reduce(function (acc, curr) {
    var key = removeString(keyExample + '_', curr);
    return curr.indexOf(keyExample) !== -1 ? (0, _assign2.default)(acc, (0, _defineProperty3.default)({}, key, resourceAccess[curr])) : acc;
  }, {});
};

var mutations = {
  setAccess: function setAccess(state, access) {
    if (access) {
      state.access = access;
    }
  },
  setAllRoles: function setAllRoles(state, access) {
    var resourceRoles = (0, _keys2.default)(access.resource_access).reduce(function (acc, curr) {
      return acc.concat(access.resource_access[curr].roles);
    }, []);
    state.allRoles = resourceRoles.concat(access.realm_access.roles);
  },
  setRoles: function setRoles(state, access) {
    var resourceRoles = reduceTradelinksRoles(access.resource_access, 'tradelinks');

    var roles = (0, _assign2.default)(resourceRoles, { realm_access: access.realm_access }, {});
    if (roles && (0, _keys2.default)(roles).length) {
      state.roles = roles;
    }
  },
  setToken: function setToken(state, token) {
    state.token = token;
  },
  setUsuario: function setUsuario(state, name) {
    state.name = name;
  }
};

var actions = {
  setToken: function setToken(_ref, token) {
    var commit = _ref.commit;

    if (!token) {
      return;
    }
    commit('setToken', token);
    var decoded = (0, _jwtDecode2.default)(token),
        access = {
      realm_access: decoded.realm_access,
      resource_access: decoded.resource_access
    },
        name = decoded.name;
    commit('setAccess', access);
    commit('setAllRoles', access);
    commit('setRoles', access);
    commit('setUsuario', name);
  }
};

var getters = {
  getAccess: function getAccess(state) {
    return state.access;
  },
  getAllRoles: function getAllRoles(state) {
    return state.allRoles;
  },
  getRoles: function getRoles(state) {
    return state.roles;
  },
  getToken: function getToken(state) {
    return state.token;
  },
  getUsuario: function getUsuario(state) {
    return state.name;
  }
};

var state = {
  access: {},
  allRoles: [],
  roles: [],
  token: null,
  name: ''
};

exports.default = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

var _taggedTemplateLiteral2 = __webpack_require__(750);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['', ', ', ' - ', ' - ', ', ', ' - ', ', ', ''], ['', ', ', ' - ', ' - ', ', ', ' - ', ', ', '']);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function formatarEndereco(strings, logradouro, numero, complemento, bairro, cidade, estado, cep) {
  var endereco = logradouro;

  if (numero) {
    endereco += strings[1] + numero;
  }

  if (complemento) {
    endereco += strings[2] + complemento;
  }

  if (bairro) {
    endereco += strings[3] + bairro;
  }

  if (cidade) {
    endereco += strings[4] + cidade;
  }

  if (estado) {
    endereco += strings[5] + estado;
  }

  if (cep) {
    endereco += strings[6] + cep;
  }

  return endereco;
}

var mutations = {
  alterarInformacoesDoUsuario: function alterarInformacoesDoUsuario(state, dados) {
    state.usuario.id = dados.id;
    state.usuario.ehCliente = dados.usuarioCliente;
    state.usuario.email = dados.email;
    state.usuario.estruturaUsuario = dados.estruturaUsuario;
    state.usuario.nomUsuario = dados.nomUsuario;
    state.usuario.perfil = dados.perfil;
    state.usuario.idPerfil = dados.idPerfil;
    state.usuario.aprovadorAcordo = dados.aprovadorAcordo;
    state.usuario.tipo = dados.tipo;
    state.usuario.relatUsuario = dados.relatUsuario;
    state.usuario.indUsuarioExternoMaster = dados.indUsuarioExternoMaster;
    state.usuario.endereco = formatarEndereco(_templateObject, dados.logradouro, dados.numero, dados.complemento, dados.bairro, dados.cidade, dados.estado, dados.cep);
  }
};

var actions = {
  carregarInformacoesUsuario: function carregarInformacoesUsuario(_ref, resource) {
    var commit = _ref.commit;

    return new _promise2.default(function (resolve, reject) {
      resource().then(function (response) {
        commit('alterarInformacoesDoUsuario', response.data);
        resolve();
      }).catch(reject);
    });
  }
};

var getters = {
  usuarioLogado: function usuarioLogado(state) {
    return state.usuario;
  }
};

var state = {
  usuario: {
    ehCliente: false
  }
};

exports.default = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mutations = {
  alterarParametroExibicaoMateriais: function alterarParametroExibicaoMateriais(state, exibirMateriais) {
    state.parametros.exibirMateriais = exibirMateriais;
  }
};

var actions = {
  carregarParametroExibicaoMateriais: function carregarParametroExibicaoMateriais(_ref, resource) {
    var commit = _ref.commit;

    return new _promise2.default(function (resolve, reject) {
      resource().then(function (response) {
        commit('alterarParametroExibicaoMateriais', response.data);
        resolve();
      }).catch(reject);
    });
  }
};

var getters = {
  parametros: function parametros(state) {
    return state.parametros;
  }
};

var state = {
  parametros: {
    exibirMateriais: false
  }
};

exports.default = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mutations = {
  alterarImplantacao: function alterarImplantacao(state, dados) {
    state.implantacao.ambiente_produtivo = dados.ambiente_produtivo;
    state.implantacao.chave_empresa = dados.chave_empresa;
    state.implantacao.descricao = dados.descricao;
    state.implantacao.logomarca = dados.logomarca;
    state.implantacao.modo = dados.modo;
    state.implantacao.indVarejo = dados.modo === 'VAREJO';
    state.implantacao.nome = dados.nome;
  }
};

var actions = {
  carregarImplantacao: function carregarImplantacao(_ref, resource) {
    var commit = _ref.commit;

    return new _promise2.default(function (resolve, reject) {
      resource().then(function (response) {
        commit('alterarImplantacao', response.data);
        resolve();
      }).catch(reject);
    });
  }
};

var getters = {
  implantacao: function implantacao(state) {
    return state.implantacao;
  },
  indModoVarejo: function indModoVarejo(state) {
    return state.implantacao.indVarejo;
  },
  indAmbienteProdutivo: function indAmbienteProdutivo(state) {
    return state.implantacao.ambiente_produtivo;
  }
};

var state = {
  implantacao: {}
};

exports.default = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueMaterial = __webpack_require__(760);

var _vueMaterial2 = _interopRequireDefault(_vueMaterial);

var _vueResource = __webpack_require__(761);

var _vueResource2 = _interopRequireDefault(_vueResource);

var _vueTouch = __webpack_require__(763);

var _vueTouch2 = _interopRequireDefault(_vueTouch);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

var _veeValidate = __webpack_require__(123);

var _veeValidate2 = _interopRequireDefault(_veeValidate);

var _vMoney = __webpack_require__(98);

var _vMoney2 = _interopRequireDefault(_vMoney);

var _vueTheMask = __webpack_require__(766);

var _vueTheMask2 = _interopRequireDefault(_vueTheMask);

var _toast = __webpack_require__(767);

var _toast2 = _interopRequireDefault(_toast);

var _errorHandler = __webpack_require__(771);

var _errorHandler2 = _interopRequireDefault(_errorHandler);

var _moment3 = __webpack_require__(772);

var _moment4 = _interopRequireDefault(_moment3);

var _lodash = __webpack_require__(773);

var _lodash2 = _interopRequireDefault(_lodash);

var _resources = __webpack_require__(775);

var _resources2 = _interopRequireDefault(_resources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Vue) {
  for (var _len = arguments.length, params = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    params[_key - 1] = arguments[_key];
  }

  _veeValidate.Validator.installDateTimeValidators(_moment2.default);
  params.filter(function (el) {
    return typeof el !== 'undefined';
  }).map(function (le) {
    return Vue.use(le);
  });
  Vue.use(_vueMaterial2.default);
  Vue.use(_vueTouch2.default);
  Vue.use(_veeValidate2.default);
  Vue.use(_vueResource2.default);
  Vue.use(_toast2.default);
  Vue.use(_moment4.default);
  Vue.use(_errorHandler2.default);
  Vue.use(_lodash2.default);
  Vue.use(_resources2.default);
  Vue.use(_vMoney2.default, { precision: 2 });
  Vue.use(_vueTheMask2.default);
};

/***/ }),
/* 760 */,
/* 761 */,
/* 762 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 763 */,
/* 764 */,
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 140,
	"./af.js": 140,
	"./ar": 141,
	"./ar-ma": 142,
	"./ar-ma.js": 142,
	"./ar-sa": 143,
	"./ar-sa.js": 143,
	"./ar-tn": 144,
	"./ar-tn.js": 144,
	"./ar.js": 141,
	"./az": 145,
	"./az.js": 145,
	"./be": 146,
	"./be.js": 146,
	"./bg": 147,
	"./bg.js": 147,
	"./bn": 148,
	"./bn.js": 148,
	"./bo": 149,
	"./bo.js": 149,
	"./br": 150,
	"./br.js": 150,
	"./bs": 151,
	"./bs.js": 151,
	"./ca": 152,
	"./ca.js": 152,
	"./cs": 153,
	"./cs.js": 153,
	"./cv": 154,
	"./cv.js": 154,
	"./cy": 155,
	"./cy.js": 155,
	"./da": 156,
	"./da.js": 156,
	"./de": 157,
	"./de-at": 158,
	"./de-at.js": 158,
	"./de.js": 157,
	"./dv": 159,
	"./dv.js": 159,
	"./el": 160,
	"./el.js": 160,
	"./en-au": 161,
	"./en-au.js": 161,
	"./en-ca": 162,
	"./en-ca.js": 162,
	"./en-gb": 163,
	"./en-gb.js": 163,
	"./en-ie": 164,
	"./en-ie.js": 164,
	"./en-nz": 165,
	"./en-nz.js": 165,
	"./eo": 166,
	"./eo.js": 166,
	"./es": 167,
	"./es-do": 168,
	"./es-do.js": 168,
	"./es.js": 167,
	"./et": 169,
	"./et.js": 169,
	"./eu": 170,
	"./eu.js": 170,
	"./fa": 171,
	"./fa.js": 171,
	"./fi": 172,
	"./fi.js": 172,
	"./fo": 173,
	"./fo.js": 173,
	"./fr": 174,
	"./fr-ca": 175,
	"./fr-ca.js": 175,
	"./fr-ch": 176,
	"./fr-ch.js": 176,
	"./fr.js": 174,
	"./fy": 177,
	"./fy.js": 177,
	"./gd": 178,
	"./gd.js": 178,
	"./gl": 179,
	"./gl.js": 179,
	"./he": 180,
	"./he.js": 180,
	"./hi": 181,
	"./hi.js": 181,
	"./hr": 182,
	"./hr.js": 182,
	"./hu": 183,
	"./hu.js": 183,
	"./hy-am": 184,
	"./hy-am.js": 184,
	"./id": 185,
	"./id.js": 185,
	"./is": 186,
	"./is.js": 186,
	"./it": 187,
	"./it.js": 187,
	"./ja": 188,
	"./ja.js": 188,
	"./jv": 189,
	"./jv.js": 189,
	"./ka": 190,
	"./ka.js": 190,
	"./kk": 191,
	"./kk.js": 191,
	"./km": 192,
	"./km.js": 192,
	"./ko": 193,
	"./ko.js": 193,
	"./ky": 194,
	"./ky.js": 194,
	"./lb": 195,
	"./lb.js": 195,
	"./lo": 196,
	"./lo.js": 196,
	"./lt": 197,
	"./lt.js": 197,
	"./lv": 198,
	"./lv.js": 198,
	"./me": 199,
	"./me.js": 199,
	"./mk": 200,
	"./mk.js": 200,
	"./ml": 201,
	"./ml.js": 201,
	"./mr": 202,
	"./mr.js": 202,
	"./ms": 203,
	"./ms-my": 204,
	"./ms-my.js": 204,
	"./ms.js": 203,
	"./my": 205,
	"./my.js": 205,
	"./nb": 206,
	"./nb.js": 206,
	"./ne": 207,
	"./ne.js": 207,
	"./nl": 208,
	"./nl.js": 208,
	"./nn": 209,
	"./nn.js": 209,
	"./pa-in": 210,
	"./pa-in.js": 210,
	"./pl": 211,
	"./pl.js": 211,
	"./pt": 212,
	"./pt-br": 213,
	"./pt-br.js": 213,
	"./pt.js": 212,
	"./ro": 214,
	"./ro.js": 214,
	"./ru": 215,
	"./ru.js": 215,
	"./se": 216,
	"./se.js": 216,
	"./si": 217,
	"./si.js": 217,
	"./sk": 218,
	"./sk.js": 218,
	"./sl": 219,
	"./sl.js": 219,
	"./sq": 220,
	"./sq.js": 220,
	"./sr": 221,
	"./sr-cyrl": 222,
	"./sr-cyrl.js": 222,
	"./sr.js": 221,
	"./ss": 223,
	"./ss.js": 223,
	"./sv": 224,
	"./sv.js": 224,
	"./sw": 225,
	"./sw.js": 225,
	"./ta": 226,
	"./ta.js": 226,
	"./te": 227,
	"./te.js": 227,
	"./th": 228,
	"./th.js": 228,
	"./tl-ph": 229,
	"./tl-ph.js": 229,
	"./tlh": 230,
	"./tlh.js": 230,
	"./tr": 231,
	"./tr.js": 231,
	"./tzl": 232,
	"./tzl.js": 232,
	"./tzm": 233,
	"./tzm-latn": 234,
	"./tzm-latn.js": 234,
	"./tzm.js": 233,
	"./uk": 235,
	"./uk.js": 235,
	"./uz": 236,
	"./uz.js": 236,
	"./vi": 237,
	"./vi.js": 237,
	"./x-pseudo": 238,
	"./x-pseudo.js": 238,
	"./zh-cn": 239,
	"./zh-cn.js": 239,
	"./zh-tw": 240,
	"./zh-tw.js": 240
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 765;

/***/ }),
/* 766 */,
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(9);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = __webpack_require__(29);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(43);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Toast = function () {
  function Toast() {
    (0, _classCallCheck3.default)(this, Toast);
    this.queue = [];
  }

  (0, _createClass3.default)(Toast, [{
    key: 'toast',
    value: function toast(location) {
      var toast = document.createElement('div');

      toast.classList.add('toast');
      toast.classList.add('toast--' + location);

      document.body.appendChild(toast);

      return toast;
    }
  }, {
    key: 'checkQueue',
    value: function checkQueue() {
      var _this = this;

      var cb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return function () {
        if (cb) {
          cb();
        }
        var next = _this.queue.shift();
        if (next && next.length) {
          _this.launchToast.apply(_this, (0, _toConsumableArray3.default)(next));
        }
      };
    }
  }, {
    key: 'addOnQueue',
    value: function addOnQueue() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var location = arguments[1];
      var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3000;
      var cb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      var _this2 = this;

      var cbmessage = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
      var cbbutton = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;

      var params = [message, location, duration, this.checkQueue(cb), cbmessage, cbbutton];
      this.queue.push(params);
      if (this.queue.length === 1) {
        setTimeout(function () {
          _this2.launchToast.apply(_this2, (0, _toConsumableArray3.default)(_this2.queue.shift()));
        }, 5E2);
      }
    }
  }, {
    key: 'launchToast',
    value: function launchToast(message) {
      var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'right';
      var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3000;
      var cb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var cbmessage = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
      var cbbutton = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;

      var toast = document.querySelector('.toast--' + location);

      if (!toast) {
        toast = this.toast(location);
      }

      var content = document.createElement('div');
      content.classList.add('toast__content');

      if (location === 'snack') {
        var snackMessage = document.createElement('span');
        snackMessage.classList.add('toast__message');
        snackMessage.innerHTML = message;
        content.appendChild(snackMessage);

        if (cbmessage && cbbutton) {
          var snackButton = document.createElement('button');
          snackButton.classList.add('md-button');
          snackButton.classList.add('md-accent');
          snackButton.classList.add('md-theme-default');
          snackButton.innerHTML = cbmessage;
          snackButton.addEventListener('click', cbbutton);
          content.appendChild(snackButton);
        }
      } else {
        content.innerHTML = message;
      }

      toast.appendChild(content);
      setTimeout(function () {
        return content.classList.add('toast__content--active');
      }, 10);

      setTimeout(function () {
        content.classList.remove('toast__content--active');
        content.classList.add('toast__content--remove');

        setTimeout(function () {
          content.remove();

          if (cb) {
            cb();
          }
        }, 3E2);
      }, duration);
    }
  }, {
    key: 'create',
    value: function create(message) {
      var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'right';
      var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3000;
      var cb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var cbmessage = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
      var cbbutton = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;

      if (location === 'snack') {
        this.addOnQueue(message, location, duration, cb, cbmessage, cbbutton);
        return;
      }
      this.launchToast(message, location, duration, cb, cbmessage, cbbutton);
    }
  }]);
  return Toast;
}();

function plugin(Vue) {
  Vue.prototype.$toast = new Toast();
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(plugin);
}

exports.default = plugin;

/***/ }),
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function getError(context, err) {
  if (err.status === 403) {
    return context.$t('message.acesso_negado');
  }
  return err.data && err.data.error ? err.data.error : err;
}

var errorHandler = function errorHandler(context, err, callback) {
  var toastType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'snack';
  var toastTime = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 3E3;

  var error = getError(context, err);
  context.$toast.create(error, toastType, toastTime);
  if (callback) {
    callback();
  }
};

var acessoNegado = function acessoNegado(context, error) {
  var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
  var route = arguments[3];

  if (error && error.status !== 403) {
    errorHandler(context, error, callback);
  } else {
    context.$toast.create(context.$t('message.acesso_negado'), 'snack', 3E3);
    context.$router.push({ name: route || 'dashboard' });
    callback();
  }
};

function plugin(Vue) {
  Vue.prototype.$error = errorHandler;
  Vue.prototype.$acessoNegado = acessoNegado;
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(plugin);
}

exports.default = plugin;

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function plugin(Vue) {
  Vue.prototype.moment = _moment2.default;
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(plugin);
}

exports.default = plugin;

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(774);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function plugin(Vue) {
  Vue.prototype._ = {
    groupBy: _lodash2.default
  };
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(plugin);
}

exports.default = plugin;

/***/ }),
/* 774 */,
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _acessoUsuario = __webpack_require__(776);

var _acessoUsuario2 = _interopRequireDefault(_acessoUsuario);

var _redefinicaoEmailUsuario = __webpack_require__(777);

var _redefinicaoEmailUsuario2 = _interopRequireDefault(_redefinicaoEmailUsuario);

var _acordo = __webpack_require__(778);

var _acordo2 = _interopRequireDefault(_acordo);

var _agendamento = __webpack_require__(779);

var _agendamento2 = _interopRequireDefault(_agendamento);

var _ajusteVerba = __webpack_require__(780);

var _ajusteVerba2 = _interopRequireDefault(_ajusteVerba);

var _alcada = __webpack_require__(781);

var _alcada2 = _interopRequireDefault(_alcada);

var _anoFiscal = __webpack_require__(782);

var _anoFiscal2 = _interopRequireDefault(_anoFiscal);

var _anoFiscalRelatorio = __webpack_require__(783);

var _anoFiscalRelatorio2 = _interopRequireDefault(_anoFiscalRelatorio);

var _apuracaoAcaoListagem = __webpack_require__(784);

var _apuracaoAcaoListagem2 = _interopRequireDefault(_apuracaoAcaoListagem);

var _apuracaoCrescimento = __webpack_require__(785);

var _apuracaoCrescimento2 = _interopRequireDefault(_apuracaoCrescimento);

var _apuracaoFixo = __webpack_require__(786);

var _apuracaoFixo2 = _interopRequireDefault(_apuracaoFixo);

var _apuracaoGestao = __webpack_require__(787);

var _apuracaoGestao2 = _interopRequireDefault(_apuracaoGestao);

var _apuracaoNegociacaoPreco = __webpack_require__(788);

var _apuracaoNegociacaoPreco2 = _interopRequireDefault(_apuracaoNegociacaoPreco);

var _apuracaoPositivacao = __webpack_require__(789);

var _apuracaoPositivacao2 = _interopRequireDefault(_apuracaoPositivacao);

var _apuracaoReprocessamento = __webpack_require__(790);

var _apuracaoReprocessamento2 = _interopRequireDefault(_apuracaoReprocessamento);

var _apuracaoTabloide = __webpack_require__(791);

var _apuracaoTabloide2 = _interopRequireDefault(_apuracaoTabloide);

var _apuracoesVencidas = __webpack_require__(792);

var _apuracoesVencidas2 = _interopRequireDefault(_apuracoesVencidas);

var _bloqueioSistema = __webpack_require__(793);

var _bloqueioSistema2 = _interopRequireDefault(_bloqueioSistema);

var _cacheManager = __webpack_require__(794);

var _cacheManager2 = _interopRequireDefault(_cacheManager);

var _carteiraCliente = __webpack_require__(795);

var _carteiraCliente2 = _interopRequireDefault(_carteiraCliente);

var _calendario = __webpack_require__(796);

var _calendario2 = _interopRequireDefault(_calendario);

var _cep = __webpack_require__(797);

var _cep2 = _interopRequireDefault(_cep);

var _cidade = __webpack_require__(798);

var _cidade2 = _interopRequireDefault(_cidade);

var _centroCusto = __webpack_require__(799);

var _centroCusto2 = _interopRequireDefault(_centroCusto);

var _cliente = __webpack_require__(800);

var _cliente2 = _interopRequireDefault(_cliente);

var _clienteCarteiraImplicita = __webpack_require__(801);

var _clienteCarteiraImplicita2 = _interopRequireDefault(_clienteCarteiraImplicita);

var _configuracao = __webpack_require__(802);

var _configuracao2 = _interopRequireDefault(_configuracao);

var _configuracaoNegociacao = __webpack_require__(803);

var _configuracaoNegociacao2 = _interopRequireDefault(_configuracaoNegociacao);

var _configuracaoPlanejamento = __webpack_require__(804);

var _configuracaoPlanejamento2 = _interopRequireDefault(_configuracaoPlanejamento);

var _configuracaoWorkflowAprovacao = __webpack_require__(805);

var _configuracaoWorkflowAprovacao2 = _interopRequireDefault(_configuracaoWorkflowAprovacao);

var _configuracaoWorkflowContrato = __webpack_require__(806);

var _configuracaoWorkflowContrato2 = _interopRequireDefault(_configuracaoWorkflowContrato);

var _contaCorrente = __webpack_require__(807);

var _contaCorrente2 = _interopRequireDefault(_contaCorrente);

var _contrato = __webpack_require__(808);

var _contrato2 = _interopRequireDefault(_contrato);

var _contratoLoja = __webpack_require__(809);

var _contratoLoja2 = _interopRequireDefault(_contratoLoja);

var _controladorTrade = __webpack_require__(241);

var _controladorTrade2 = _interopRequireDefault(_controladorTrade);

var _dashboardApuracao = __webpack_require__(810);

var _dashboardApuracao2 = _interopRequireDefault(_dashboardApuracao);

var _dashboardGerencial = __webpack_require__(811);

var _dashboardGerencial2 = _interopRequireDefault(_dashboardGerencial);

var _dashboardNegociacao = __webpack_require__(812);

var _dashboardNegociacao2 = _interopRequireDefault(_dashboardNegociacao);

var _dashboardOrcamento = __webpack_require__(813);

var _dashboardOrcamento2 = _interopRequireDefault(_dashboardOrcamento);

var _dashboardPagamento = __webpack_require__(814);

var _dashboardPagamento2 = _interopRequireDefault(_dashboardPagamento);

var _desdobramento = __webpack_require__(815);

var _desdobramento2 = _interopRequireDefault(_desdobramento);

var _dicionario = __webpack_require__(242);

var _dicionario2 = _interopRequireDefault(_dicionario);

var _divisao = __webpack_require__(816);

var _divisao2 = _interopRequireDefault(_divisao);

var _endereco = __webpack_require__(817);

var _endereco2 = _interopRequireDefault(_endereco);

var _estado = __webpack_require__(818);

var _estado2 = _interopRequireDefault(_estado);

var _estruturaUsuario = __webpack_require__(819);

var _estruturaUsuario2 = _interopRequireDefault(_estruturaUsuario);

var _execucao = __webpack_require__(820);

var _execucao2 = _interopRequireDefault(_execucao);

var _exportacoes = __webpack_require__(709);

var _exportacoes2 = _interopRequireDefault(_exportacoes);

var _extensao = __webpack_require__(821);

var _extensao2 = _interopRequireDefault(_extensao);

var _filtroCliente = __webpack_require__(822);

var _filtroCliente2 = _interopRequireDefault(_filtroCliente);

var _funcionario = __webpack_require__(823);

var _funcionario2 = _interopRequireDefault(_funcionario);

var _workflowCadastro = __webpack_require__(824);

var _workflowCadastro2 = _interopRequireDefault(_workflowCadastro);

var _geracaoExportacao = __webpack_require__(825);

var _geracaoExportacao2 = _interopRequireDefault(_geracaoExportacao);

var _grupoProduto = __webpack_require__(826);

var _grupoProduto2 = _interopRequireDefault(_grupoProduto);

var _historicoVendas = __webpack_require__(827);

var _historicoVendas2 = _interopRequireDefault(_historicoVendas);

var _importacoes = __webpack_require__(99);

var _importacoes2 = _interopRequireDefault(_importacoes);

var _linhasInvestimento = __webpack_require__(828);

var _linhasInvestimento2 = _interopRequireDefault(_linhasInvestimento);

var _loja = __webpack_require__(829);

var _loja2 = _interopRequireDefault(_loja);

var _margemContribuicao = __webpack_require__(830);

var _margemContribuicao2 = _interopRequireDefault(_margemContribuicao);

var _metadado = __webpack_require__(831);

var _metadado2 = _interopRequireDefault(_metadado);

var _metas = __webpack_require__(832);

var _metas2 = _interopRequireDefault(_metas);

var _nivelCliente = __webpack_require__(833);

var _nivelCliente2 = _interopRequireDefault(_nivelCliente);

var _nivelProduto = __webpack_require__(834);

var _nivelProduto2 = _interopRequireDefault(_nivelProduto);

var _orcamentoCad = __webpack_require__(835);

var _orcamentoCad2 = _interopRequireDefault(_orcamentoCad);

var _orcamentoListagem = __webpack_require__(836);

var _orcamentoListagem2 = _interopRequireDefault(_orcamentoListagem);

var _orcamentoConfiguracao = __webpack_require__(837);

var _orcamentoConfiguracao2 = _interopRequireDefault(_orcamentoConfiguracao);

var _pagamentoCriacao = __webpack_require__(838);

var _pagamentoCriacao2 = _interopRequireDefault(_pagamentoCriacao);

var _pagamentoGestao = __webpack_require__(839);

var _pagamentoGestao2 = _interopRequireDefault(_pagamentoGestao);

var _pagamentoIntegracao = __webpack_require__(840);

var _pagamentoIntegracao2 = _interopRequireDefault(_pagamentoIntegracao);

var _parametrizacaoAcao = __webpack_require__(841);

var _parametrizacaoAcao2 = _interopRequireDefault(_parametrizacaoAcao);

var _parametrizacaoCliente = __webpack_require__(842);

var _parametrizacaoCliente2 = _interopRequireDefault(_parametrizacaoCliente);

var _parametrizacaoOrcamento = __webpack_require__(843);

var _parametrizacaoOrcamento2 = _interopRequireDefault(_parametrizacaoOrcamento);

var _perfil = __webpack_require__(844);

var _perfil2 = _interopRequireDefault(_perfil);

var _planejamentoAcaoConfiguracao = __webpack_require__(845);

var _planejamentoAcaoConfiguracao2 = _interopRequireDefault(_planejamentoAcaoConfiguracao);

var _planejamentoAcaoCadastro = __webpack_require__(846);

var _planejamentoAcaoCadastro2 = _interopRequireDefault(_planejamentoAcaoCadastro);

var _planejamentoAcaoListagem = __webpack_require__(847);

var _planejamentoAcaoListagem2 = _interopRequireDefault(_planejamentoAcaoListagem);

var _planejamentoMaterial = __webpack_require__(848);

var _planejamentoMaterial2 = _interopRequireDefault(_planejamentoMaterial);

var _planejamentoPeca = __webpack_require__(849);

var _planejamentoPeca2 = _interopRequireDefault(_planejamentoPeca);

var _planejamentoTatico = __webpack_require__(850);

var _planejamentoTatico2 = _interopRequireDefault(_planejamentoTatico);

var _planejamentoTaticoArquivo = __webpack_require__(851);

var _planejamentoTaticoArquivo2 = _interopRequireDefault(_planejamentoTaticoArquivo);

var _planejamentoTaticoMaterial = __webpack_require__(852);

var _planejamentoTaticoMaterial2 = _interopRequireDefault(_planejamentoTaticoMaterial);

var _produto = __webpack_require__(853);

var _produto2 = _interopRequireDefault(_produto);

var _orcamentoRateio = __webpack_require__(854);

var _orcamentoRateio2 = _interopRequireDefault(_orcamentoRateio);

var _orcamentoTipoVerba = __webpack_require__(855);

var _orcamentoTipoVerba2 = _interopRequireDefault(_orcamentoTipoVerba);

var _regiao = __webpack_require__(856);

var _regiao2 = _interopRequireDefault(_regiao);

var _reivindicacao = __webpack_require__(857);

var _reivindicacao2 = _interopRequireDefault(_reivindicacao);

var _representante = __webpack_require__(858);

var _representante2 = _interopRequireDefault(_representante);

var _representanteCliente = __webpack_require__(859);

var _representanteCliente2 = _interopRequireDefault(_representanteCliente);

var _representanteLogado = __webpack_require__(860);

var _representanteLogado2 = _interopRequireDefault(_representanteLogado);

var _reporteTatico = __webpack_require__(861);

var _reporteTatico2 = _interopRequireDefault(_reporteTatico);

var _roi = __webpack_require__(862);

var _roi2 = _interopRequireDefault(_roi);

var _sellIn = __webpack_require__(863);

var _sellIn2 = _interopRequireDefault(_sellIn);

var _sellOut = __webpack_require__(864);

var _sellOut2 = _interopRequireDefault(_sellOut);

var _grupo = __webpack_require__(865);

var _grupo2 = _interopRequireDefault(_grupo);

var _role = __webpack_require__(866);

var _role2 = _interopRequireDefault(_role);

var _usuario = __webpack_require__(867);

var _usuario2 = _interopRequireDefault(_usuario);

var _termoAceite = __webpack_require__(244);

var _termoAceite2 = _interopRequireDefault(_termoAceite);

var _tipoAcao = __webpack_require__(868);

var _tipoAcao2 = _interopRequireDefault(_tipoAcao);

var _tipoBeneficio = __webpack_require__(869);

var _tipoBeneficio2 = _interopRequireDefault(_tipoBeneficio);

var _tipoInvestimento = __webpack_require__(870);

var _tipoInvestimento2 = _interopRequireDefault(_tipoInvestimento);

var _tipoOrcamento = __webpack_require__(871);

var _tipoOrcamento2 = _interopRequireDefault(_tipoOrcamento);

var _transferencia = __webpack_require__(872);

var _transferencia2 = _interopRequireDefault(_transferencia);

var _transferenciaPosse = __webpack_require__(873);

var _transferenciaPosse2 = _interopRequireDefault(_transferenciaPosse);

var _transferenciaPosseDefinitiva = __webpack_require__(874);

var _transferenciaPosseDefinitiva2 = _interopRequireDefault(_transferenciaPosseDefinitiva);

var _uploadReivindicacao = __webpack_require__(875);

var _uploadReivindicacao2 = _interopRequireDefault(_uploadReivindicacao);

var _unidadeMedida = __webpack_require__(876);

var _unidadeMedida2 = _interopRequireDefault(_unidadeMedida);

var _usuario3 = __webpack_require__(245);

var _usuario4 = _interopRequireDefault(_usuario3);

var _usuarioCliente = __webpack_require__(877);

var _usuarioCliente2 = _interopRequireDefault(_usuarioCliente);

var _usuarioLogado = __webpack_require__(878);

var _usuarioLogado2 = _interopRequireDefault(_usuarioLogado);

var _usuarioUnidadeNegocio = __webpack_require__(879);

var _usuarioUnidadeNegocio2 = _interopRequireDefault(_usuarioUnidadeNegocio);

var _workflowAcao = __webpack_require__(880);

var _workflowAcao2 = _interopRequireDefault(_workflowAcao);

var _workflowAcordo = __webpack_require__(881);

var _workflowAcordo2 = _interopRequireDefault(_workflowAcordo);

var _workflowApuracao = __webpack_require__(882);

var _workflowApuracao2 = _interopRequireDefault(_workflowApuracao);

var _workflowApuracaoReivindicacao = __webpack_require__(883);

var _workflowApuracaoReivindicacao2 = _interopRequireDefault(_workflowApuracaoReivindicacao);

var _workflowAjusteVerba = __webpack_require__(884);

var _workflowAjusteVerba2 = _interopRequireDefault(_workflowAjusteVerba);

var _workflowOrcamento = __webpack_require__(885);

var _workflowOrcamento2 = _interopRequireDefault(_workflowOrcamento);

var _workflowPassos = __webpack_require__(886);

var _workflowPassos2 = _interopRequireDefault(_workflowPassos);

var _workflowPlanejamento = __webpack_require__(887);

var _workflowPlanejamento2 = _interopRequireDefault(_workflowPlanejamento);

var _workflowTransferencia = __webpack_require__(888);

var _workflowTransferencia2 = _interopRequireDefault(_workflowTransferencia);

var _workspaceFiltros = __webpack_require__(889);

var _workspaceFiltros2 = _interopRequireDefault(_workspaceFiltros);

var _pendencias = __webpack_require__(890);

var _pendencias2 = _interopRequireDefault(_pendencias);

var _historicoRelatorio = __webpack_require__(891);

var _historicoRelatorio2 = _interopRequireDefault(_historicoRelatorio);

var _organograma = __webpack_require__(892);

var _organograma2 = _interopRequireDefault(_organograma);

var _relatorioAcordo = __webpack_require__(893);

var _relatorioAcordo2 = _interopRequireDefault(_relatorioAcordo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function plugin(Vue) {
  Vue.prototype.$api = {
    acordo: _acordo2.default,
    acessoUsuario: _acessoUsuario2.default,
    agendamento: _agendamento2.default,
    ajusteVerba: _ajusteVerba2.default,
    alcada: _alcada2.default,
    anoFiscal: _anoFiscal2.default,
    anoFiscalRelatorio: _anoFiscalRelatorio2.default,
    apuracaoAcaoListagem: _apuracaoAcaoListagem2.default,
    apuracaoCrescimento: _apuracaoCrescimento2.default,
    apuracaoFixo: _apuracaoFixo2.default,
    apuracaoGestao: _apuracaoGestao2.default,
    apuracaoTabloide: _apuracaoTabloide2.default,
    apuracoesVencidas: _apuracoesVencidas2.default,
    apuracaoNegociacaoPreco: _apuracaoNegociacaoPreco2.default,
    apuracaoPositivacao: _apuracaoPositivacao2.default,
    apuracaoReprocessamento: _apuracaoReprocessamento2.default,
    bloqueioSistema: _bloqueioSistema2.default,
    cacheManager: _cacheManager2.default,
    carteiraCliente: _carteiraCliente2.default,
    calendario: _calendario2.default,
    cidade: _cidade2.default,
    cep: _cep2.default,
    centroCusto: _centroCusto2.default,
    cliente: _cliente2.default,
    clienteCarteiraImplicita: _clienteCarteiraImplicita2.default,
    configuracao: _configuracao2.default,
    configuracaoNegociacao: _configuracaoNegociacao2.default,
    configuracaoPlanejamento: _configuracaoPlanejamento2.default,
    configuracaoWorkflowAprovacao: _configuracaoWorkflowAprovacao2.default,
    configuracaoWorkflowContrato: _configuracaoWorkflowContrato2.default,
    contaCorrente: _contaCorrente2.default,
    contrato: _contrato2.default,
    contratoLoja: _contratoLoja2.default,
    controladorTrade: _controladorTrade2.default,
    dashboardApuracao: _dashboardApuracao2.default,
    dashboardGerencial: _dashboardGerencial2.default,
    dashboardNegociacao: _dashboardNegociacao2.default,
    dashboardOrcamento: _dashboardOrcamento2.default,
    dashboardPagamento: _dashboardPagamento2.default,
    desdobramento: _desdobramento2.default,
    dicionario: _dicionario2.default,
    divisao: _divisao2.default,
    endereco: _endereco2.default,
    estado: _estado2.default,
    estruturaUsuario: _estruturaUsuario2.default,
    execucao: _execucao2.default,
    exportacoes: _exportacoes2.default,
    extensao: _extensao2.default,
    filtroCliente: _filtroCliente2.default,
    fluxoAprovacao: _workflowCadastro2.default,
    funcionario: _funcionario2.default,
    geracaoExportacao: _geracaoExportacao2.default,
    grupoProduto: _grupoProduto2.default,
    historicoVendas: _historicoVendas2.default,
    historicoRelatorio: _historicoRelatorio2.default,
    importacoes: _importacoes2.default,
    linhasInvestimento: _linhasInvestimento2.default,
    loja: _loja2.default,
    margemcontribuicao: _margemContribuicao2.default,
    metadado: _metadado2.default,
    metas: _metas2.default,
    nivelCliente: _nivelCliente2.default,
    nivelProduto: _nivelProduto2.default,
    orcamento: _orcamentoCad2.default,
    orcamentoListagem: _orcamentoListagem2.default,
    orcamentoConfiguracao: _orcamentoConfiguracao2.default,
    orcamentoTipoVerba: _orcamentoTipoVerba2.default,
    pagamentoCriacao: _pagamentoCriacao2.default,
    pagamentoGestao: _pagamentoGestao2.default,
    pagamentoIntegracao: _pagamentoIntegracao2.default,
    parametrizacaoAcao: _parametrizacaoAcao2.default,
    parametrizacaoCliente: _parametrizacaoCliente2.default,
    parametrizacaoOrcamento: _parametrizacaoOrcamento2.default,
    perfil: _perfil2.default,
    planejamentoAcaoConfiguracao: _planejamentoAcaoConfiguracao2.default,
    planejamentoAcaoCadastro: _planejamentoAcaoCadastro2.default,
    planejamentoAcaoListagem: _planejamentoAcaoListagem2.default,
    planejamentoMaterial: _planejamentoMaterial2.default,
    planejamentoPeca: _planejamentoPeca2.default,
    planejamentoTatico: _planejamentoTatico2.default,
    planejamentoTaticoArquivo: _planejamentoTaticoArquivo2.default,
    planejamentoTaticoMaterial: _planejamentoTaticoMaterial2.default,
    produto: _produto2.default,
    redefinicaoEmailUsuario: _redefinicaoEmailUsuario2.default,
    rateioOrcamento: _orcamentoRateio2.default,
    regiao: _regiao2.default,
    representante: _representante2.default,
    representanteCliente: _representanteCliente2.default,
    representanteLogado: _representanteLogado2.default,
    reporteTatico: _reporteTatico2.default,
    roi: _roi2.default,
    sellIn: _sellIn2.default,
    sellOut: _sellOut2.default,
    ssoUsuario: _usuario2.default,
    ssoGrupo: _grupo2.default,
    ssoRole: _role2.default,
    termoAceite: _termoAceite2.default,
    tipoAcao: _tipoAcao2.default,
    tipoBeneficio: _tipoBeneficio2.default,
    tipoInvestimento: _tipoInvestimento2.default,
    tipoOrcamento: _tipoOrcamento2.default,
    transferencia: _transferencia2.default,
    transferenciaPosse: _transferenciaPosse2.default,
    transferenciaPosseDefinitiva: _transferenciaPosseDefinitiva2.default,
    unidadeMedida: _unidadeMedida2.default,
    usuario: _usuario4.default,
    usuarioCliente: _usuarioCliente2.default,
    usuarioLogado: _usuarioLogado2.default,
    usuarioUnidadeNegocio: _usuarioUnidadeNegocio2.default,
    workflowAcao: _workflowAcao2.default,
    workflowAcordo: _workflowAcordo2.default,
    workflowApuracao: _workflowApuracao2.default,
    workflowApuracaoReivindicacao: _workflowApuracaoReivindicacao2.default,
    workflowAjusteVerba: _workflowAjusteVerba2.default,
    workflowOrcamento: _workflowOrcamento2.default,
    workflowPassos: _workflowPassos2.default,
    workflowPlanejamento: _workflowPlanejamento2.default,
    workflowTransferencia: _workflowTransferencia2.default,
    workspaceFiltros: _workspaceFiltros2.default,
    reivindicacao: _reivindicacao2.default,
    relatorioPendencias: _pendencias2.default,
    uploadReivindicacao: _uploadReivindicacao2.default,
    organograma: _organograma2.default,
    relatorioAcordo: _relatorioAcordo2.default
  };
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(plugin);
}

exports.default = plugin;

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('usuario', 'eventosusuario');

var acessoUsuarioActions = {
  listar: { method: 'GET', url: basePath + '?tamanhoPagina={size}&numeroPagina={page}&idUsuario={userid}&startDate={dateini}&endDate={dateend}' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, acessoUsuarioActions);
};

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('usuario', 'usuario');

var redefinicaoEmailUsuarioActions = {
  listar: { method: 'GET', url: basePath + '/simples?tamanhoPagina={size}&numeroPagina={page}' },
  filtrar: { method: 'GET', url: basePath + '/simples?tamanhoPagina={size}&numeroPagina={page}&nome={nome}' },
  salvar: { method: 'POST', url: basePath + '/email/redefinicao' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, redefinicaoEmailUsuarioActions);
};

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('negociacao', 'acordo');

var acordoActions = {
  pesquisar: { method: 'GET', url: '' + basePath },
  obter: { method: 'GET', url: basePath + '/{id}' },
  gravar: { method: 'POST', url: '' + basePath },
  atualizar: { method: 'PUT', url: '' + basePath },
  finalizar: { method: 'PUT', url: basePath + '/{id}/finalizar' },
  ajustar: { method: 'PUT', url: basePath + '/{id}/ajustar' },
  ajustarMultiplos: { method: 'PUT', url: basePath + '/ajustar' },
  encerrarPorId: { method: 'PUT', url: basePath + '/{idAcordo}/encerrar' },
  encerrar: { method: 'PUT', url: basePath + '/encerrar' },
  cancelar: { method: 'PUT', url: basePath + '/{id}/cancelar' },
  cancelarMultiplos: { method: 'PUT', url: basePath + '/cancelar' },
  copiar: { method: 'GET', url: basePath + '/{id}/copiar' },
  logAcordo: { method: 'GET', url: basePath + '/{codigo}/justificativas' },
  listarTiposAcordo: { method: 'GET', url: basePath + '/tipos-acordo' },
  historico: { logsmehtod: 'GET', url: basePath + '/{id}/logs' },
  anos: { method: 'GET', url: basePath + '/anos' },
  meses: { method: 'GET', url: basePath + '/meses' },
  listarMetas: { method: 'GET', url: basePath + '/{id}/metas' },
  validarProdutosEleitos: { method: 'GET', url: basePath + '/{id}/metas/validar/produtos-eleitos' },
  encerramentoSaldoRetornavel: { method: 'GET', url: basePath + '/{idAcordo}/encerramento/saldo-retornavel' },
  permiteEncerrarAcordo: { method: 'GET', url: basePath + '/{idAcordo}/permite-encerrar' },
  tiposLinhaAcordo: { method: 'GET', url: basePath + '/conta-corrente/tipo-investimento?colunaOrdenacao=desc_investimento' },
  linhasInvestimentoAcordo: { method: 'GET', url: basePath + '/conta-corrente/tipo-investimento/{idTipoInvestimento}?colunaOrdenacao=desc_investimento' },
  saldoDisponivel: { method: 'GET', url: basePath + '/conta-corrente/{idLinhaInvestimento}/saldo?anoMesInicio={anoMesInicio}&anoMesFim={anoMesFim}' },
  ratear: { method: 'POST', url: basePath + '/rateio' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, acordoActions);
};

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'agendamento');

var agendamentoActions = {
  listar: { method: 'GET', url: '' + basePath },
  atualizar: { method: 'PUT', url: '' + basePath },
  reagendar: { method: 'PUT', url: basePath + '/proxima-execucao' },
  listarLogs: { method: 'GET', url: basePath + '/{id}/logs' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, agendamentoActions);
};

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('planejamento', 'ajuste_verba');

var ajusteVerbaActions = {
  gravar: { method: 'POST', url: '' + basePath },
  obter: { method: 'GET', url: basePath + '/{id}' },
  solicitante: { method: 'GET', url: basePath + '/solicitante' },
  verificarDadosExportacao: { methods: 'GET', url: basePath + '/verificar-dados-exportacao' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, ajusteVerbaActions);
};

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

var _genericResource = __webpack_require__(7);

var _genericResource2 = _interopRequireDefault(_genericResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'alcada');

var alcadaActions = (0, _extends3.default)({}, (0, _genericResource2.default)(basePath), {
  listarTiposFluxo: { method: 'GET', url: basePath + '/tipos-fluxo/?workflowTipo={nome}&colunaOrdenacao=nome' },
  listarAtivos: { method: 'GET', url: basePath + '/ativos/tipos-fluxo/{id}' },
  ativarInativarRegistros: { method: 'POST', url: basePath + '/ativarInativarRegistros' }
});

exports.default = function (resource) {
  return resource('' + basePath, {}, alcadaActions);
};

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'ano-fiscal');

var anoFiscalActions = {
  pesquisarPorTipo: { method: 'GET', url: basePath + '/{idTipoVerba}' },
  pesquisarPorTipoVigente: { method: 'GET', url: basePath + '?idTipoVerba={idTipoVerba}&vigenteOuComBloqueio=true' },
  alterarStatus: { method: 'PUT', url: basePath + '/{id}/status' },
  gravar: { method: 'POST', url: '' + basePath },
  periodos: { method: 'GET', url: basePath + '/{idTipoVerba}/periodo' },
  buscarPeriodosAnoFiscal: { method: 'GET', url: basePath + '/periodo?{&idsAnoFiscal*}' },
  buscar: { method: 'GET', url: '' + basePath },
  autocompletePeriodo: { method: 'GET', url: basePath + '/1/periodo/autocomplete' },
  periodoPaginado: { method: 'GET', url: basePath + '/1/periodo/paginado' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, anoFiscalActions);
};

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'ano-fiscal');

var anoFiscalActions = {
  pesquisarAno: { method: 'GET', url: '' + basePath },
  pesquisar: { method: 'GET', url: basePath + '/relatorio' },
  pesquisarTrimestres: { method: 'GET', url: basePath + '/trimestre' },
  pesquisarPeriodo: { method: 'GET', url: basePath + '/periodo' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, anoFiscalActions);
};

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('apuracao_acao', 'listagem');

var apuracaoActions = {
  listarPorCliente: { method: 'GET', url: basePath + '/por-cliente' },
  listarPorHolding: { method: 'GET', url: basePath + '/por-holding' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, apuracaoActions);
};

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('apuracao', 'crescimento');
var gestaoApuracao = (0, _apiResource2.default)('apuracao', 'gestao');

var apuracaoCrescimentoActions = {
  competencias: { method: 'GET', url: basePath + '/competencias' },
  configuracao: { method: 'GET', url: basePath + '/configuracao-apuracao' },
  pagina: { method: 'GET', url: basePath + '/pagina?tamanhoPagina={size}&numeroPagina={page}' },
  salvar: { method: 'PUT', url: basePath + '/salvar' },
  alterarRealizado: { method: 'PUT', url: basePath + '/realizado' },
  resgatar: { method: 'PUT', url: basePath + '/{idApuracao}/resgatar' },
  finalizar: { method: 'PUT', url: gestaoApuracao + '/{idApuracao}/finalizar' },
  ajustar: { method: 'PUT', url: basePath + '/{idApuracao}/ajustar' },
  validaEnvioFluxo: { method: 'GET', url: basePath + '/{idApuracao}/valida-envio-fluxo' },
  registraUsuario: { method: 'PUT', url: gestaoApuracao + '/{idApuracao}/registra/usuario' },
  simulaPagamento: { method: 'GET', url: basePath + '/realizado/pagamento' },
  assinado: { method: 'GET', url: gestaoApuracao + '/{idApuracao}/assinado' },
  contaCorrenteMeta: { method: 'GET', url: gestaoApuracao + '/meta/conta_corrente' },
  contaCorrenteMetaMeses: { method: 'GET', url: gestaoApuracao + '/meta/conta_corrente/meses' },
  planejadoDisponivel: { method: 'GET', url: gestaoApuracao + '/meta/conta_corrente/{idContaCorrente}/planejado_disponivel' },
  salvarContratoCliente: { method: 'PUT', url: basePath + '/atualizar/{id}/contrato_cliente/{codContratoCliente}' },
  enviarFilaApuracao: { method: 'POST', url: gestaoApuracao + '/enviar-fila-apuracao' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, apuracaoCrescimentoActions);
};

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('apuracao', 'fixo');
var gestaoApuracao = (0, _apiResource2.default)('apuracao', 'gestao');

var apuracaoFixoActions = {
  competencias: { method: 'GET', url: basePath + '/competencias' },
  configuracao: { method: 'GET', url: basePath + '/configuracao-apuracao' },
  pagina: { method: 'GET', url: basePath + '/pagina?tamanhoPagina={size}&numeroPagina={page}' },
  salvar: { method: 'PUT', url: basePath + '/salvar' },
  resgatar: { method: 'PUT', url: basePath + '/{idApuracao}/resgatar' },
  finalizar: { method: 'PUT', url: gestaoApuracao + '/{idApuracao}/finalizar' },
  enviarFilaApuracao: { method: 'POST', url: gestaoApuracao + '/enviar-fila-apuracao' },
  desdobramentoMeta: { method: 'GET', url: gestaoApuracao + '/desdobramento-meta' },
  ajustar: { method: 'PUT', url: basePath + '/{idApuracao}/ajustar' },
  registraUsuario: { method: 'PUT', url: gestaoApuracao + '/{idApuracao}/registra/usuario' },
  salvarContratoCliente: { method: 'PUT', url: basePath + '/atualizar/{id}/contrato_cliente/{codContratoCliente}' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, apuracaoFixoActions);
};

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('apuracao', 'gestao');

var apuracaoFixoActions = {
  basesCalculo: { method: 'GET', url: basePath + '/bases-calculo' },
  buscaJustificativa: { method: 'GET', url: basePath + '/{idApuracao}/justificativa-apuracao' },
  configuracao: { method: 'GET', url: basePath + '/configuracao-apuracao' },
  formasBonificacoes: { method: 'GET', url: basePath + '/formas-bonificacoes' },
  metasBeneficios: { method: 'GET', url: basePath + '/metas-beneficios' },
  registraUsuario: { method: 'PUT', url: basePath + '/{idApuracao}/registra/usuario' },
  unidadesMedida: { method: 'GET', url: basePath + '/unidades-medida' },
  enviarFilaApuracao: { method: 'POST', url: basePath + '/enviar-fila-apuracao' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, apuracaoFixoActions);
};

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('apuracao', 'negociacao-preco');
var gestaoApuracao = (0, _apiResource2.default)('apuracao', 'gestao');

var apuracaoNegociacaoPrecoActions = {
  competencias: { method: 'GET', url: basePath + '/competencias' },
  configuracao: { method: 'GET', url: basePath + '/configuracao-apuracao' },
  pagina: { method: 'GET', url: basePath + '/pagina?tamanhoPagina={size}&numeroPagina={page}' },
  salvar: { method: 'PUT', url: basePath + '/salvar' },
  alterarRealizado: { method: 'PUT', url: basePath + '/realizado' },
  finalizar: { method: 'PUT', url: gestaoApuracao + '/{idApuracao}/finalizar' },
  ajustar: { method: 'PUT', url: basePath + '/{idApuracao}/ajustar' },
  validaEnvioFluxo: { method: 'GET', url: basePath + '/{idApuracao}/valida-envio-fluxo' },
  registraUsuario: { method: 'PUT', url: gestaoApuracao + '/{idApuracao}/registra/usuario' },
  simulaPagamento: { method: 'GET', url: basePath + '/realizado/pagamento' },
  assinado: { method: 'GET', url: gestaoApuracao + '/{idApuracao}/assinado' },
  contaCorrenteMeta: { method: 'GET', url: gestaoApuracao + '/meta/conta_corrente' },
  contaCorrenteMetaMeses: { method: 'GET', url: gestaoApuracao + '/meta/conta_corrente/meses' },
  planejadoDisponivel: { method: 'GET', url: gestaoApuracao + '/meta/conta_corrente/{idContaCorrente}/planejado_disponivel' },
  salvarContratoCliente: { method: 'PUT', url: basePath + '/atualizar/{id}/contrato_cliente/{codContratoCliente}' },
  enviarFilaApuracao: { method: 'POST', url: gestaoApuracao + '/enviar-fila-apuracao' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, apuracaoNegociacaoPrecoActions);
};

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('apuracao', 'positivacao');
var gestaoApuracao = (0, _apiResource2.default)('apuracao', 'gestao');

var apuracaoPositivacaoActions = {
  competencias: { method: 'GET', url: basePath + '/competencias' },
  configuracao: { method: 'GET', url: basePath + '/configuracao-apuracao' },
  pagina: { method: 'GET', url: basePath + '/pagina?tamanhoPagina={size}&numeroPagina={page}' },
  salvar: { method: 'PUT', url: basePath + '/salvar' },
  alterarRealizado: { method: 'PUT', url: basePath + '/realizado' },
  finalizar: { method: 'PUT', url: gestaoApuracao + '/{idApuracao}/finalizar' },
  ajustar: { method: 'PUT', url: basePath + '/{idApuracao}/ajustar' },
  validaEnvioFluxo: { method: 'GET', url: basePath + '/{idApuracao}/valida-envio-fluxo' },
  registraUsuario: { method: 'PUT', url: gestaoApuracao + '/{idApuracao}/registra/usuario' },
  simulaPagamento: { method: 'GET', url: basePath + '/realizado/pagamento' },
  assinado: { method: 'GET', url: gestaoApuracao + '/{idApuracao}/assinado' },
  contaCorrenteMeta: { method: 'GET', url: gestaoApuracao + '/meta/conta_corrente' },
  contaCorrenteMetaMeses: { method: 'GET', url: gestaoApuracao + '/meta/conta_corrente/meses' },
  planejadoDisponivel: { method: 'GET', url: gestaoApuracao + '/meta/conta_corrente/{idContaCorrente}/planejado_disponivel' },
  salvarContratoCliente: { method: 'PUT', url: basePath + '/atualizar/{id}/contrato_cliente/{codContratoCliente}' },
  enviarFilaApuracao: { method: 'POST', url: gestaoApuracao + '/enviar-fila-apuracao' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, apuracaoPositivacaoActions);
};

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('apuracao', 'reprocessamento');

var apuracaoReprocessamentoActions = {
  reprocessar: { method: 'PUT', url: basePath + '/{idMeta}/{tipoAcordo}/executar' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, apuracaoReprocessamentoActions);
};

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('apuracao', 'tabloide');
var gestaoApuracao = (0, _apiResource2.default)('apuracao', 'gestao');

var apuracaoTabloideActions = {
  competencias: { method: 'GET', url: basePath + '/competencias' },
  configuracao: { method: 'GET', url: basePath + '/configuracao-apuracao' },
  pagina: { method: 'GET', url: basePath + '/pagina?tamanhoPagina={size}&numeroPagina={page}' },
  salvar: { method: 'PUT', url: basePath + '/salvar' },
  resgatar: { method: 'PUT', url: basePath + '/{idApuracao}/resgatar' },
  finalizar: { method: 'PUT', url: gestaoApuracao + '/{idApuracao}/finalizar' },
  desdobramentoMeta: { method: 'GET', url: basePath + '/desdobramento-meta' },
  ajustar: { method: 'PUT', url: basePath + '/{idApuracao}/ajustar' },
  registraUsuario: { method: 'PUT', url: gestaoApuracao + '/{idApuracao}/registra/usuario' },
  salvarContratoCliente: { method: 'PUT', url: basePath + '/atualizar/{id}/contrato_cliente/{codContratoCliente}' },
  enviarFilaApuracao: { method: 'POST', url: gestaoApuracao + '/enviar-fila-apuracao' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, apuracaoTabloideActions);
};

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('apuracao', 'apuracoes-vencidas');

var apuracoesVencidasActions = {
  listarTipos: { method: 'GET', url: '' + basePath },
  pesquisar: { method: 'GET', url: basePath + '/por-tipo' },
  cancelar: { method: 'PUT', url: basePath + '/cancelar' },
  cancelarApuracoes: { method: 'PUT', url: basePath + '/cancelar-apuracoes' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, apuracoesVencidasActions);
};

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'bloqueio-sistema');

var bloqueioSistemaActions = {
  pesquisar: { method: 'GET', url: '' + basePath },
  pesquisarPagamento: { method: 'GET', url: basePath + '/integracao-pagamento' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, bloqueioSistemaActions);
};

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('cadastro', 'cache-manager');

var actions = {
  dropCache: { method: 'PUT', url: '' + basePath }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, actions);
};

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

var _genericResource = __webpack_require__(7);

var _genericResource2 = _interopRequireDefault(_genericResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'carteira-cliente');

var areaAtuacaoActions = (0, _extends3.default)({}, (0, _genericResource2.default)(basePath), {
  obter: { method: 'GET', url: basePath + '/{id}' },
  obterClientes: { method: 'GET', url: basePath + '/{id}/cliente' },
  obterDivisoes: { method: 'GET', url: basePath + '/{id}/divisao' },
  pesquisar: { method: 'GET', url: '' + basePath },
  pesquisarPorDivisao: { method: 'GET', url: basePath + '/divisao{?idsCarteiraNotIn*&idsDivisao*}' }
});

exports.default = function (resource) {
  return resource('' + basePath, {}, areaAtuacaoActions);
};

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

var _genericResource = __webpack_require__(7);

var _genericResource2 = _interopRequireDefault(_genericResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'calendario');

var calendarioActions = (0, _extends3.default)({}, (0, _genericResource2.default)(basePath), {
  tipos: { method: 'GET', url: basePath + '/tipos' },
  obter: { method: 'GET', url: basePath + '/{id}' },
  ativarInativar: { method: 'PUT', url: basePath + '/ativacao/{id}/{status}' },
  cancelar: { method: 'PUT', url: basePath + '/{id}/cancelar' },
  tiposAtivos: { method: 'GET', url: basePath + '/ativos?tipo={tipo}' }
});

exports.default = function (resource) {
  return resource('' + basePath, {}, calendarioActions);
};

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'cep');

var cepActions = {
  obter: { method: 'GET', url: basePath + '/{cep}' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, cepActions);
};

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

var _genericResource = __webpack_require__(7);

var _genericResource2 = _interopRequireDefault(_genericResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'cidade');

var cidadeActions = (0, _extends3.default)({}, (0, _genericResource2.default)(basePath), {
  listarAtivos: { method: 'GET', url: basePath + '?nome={nome}&colunaOrdenacao=nom_cidade' }
});

exports.default = function (resource) {
  return resource('' + basePath, {}, cidadeActions);
};

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

var _genericResource = __webpack_require__(7);

var _genericResource2 = _interopRequireDefault(_genericResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'centro-custo');

var centroCustoActions = (0, _extends3.default)({}, (0, _genericResource2.default)(basePath), {
  listarAtivos: { method: 'GET', url: basePath + '?indAtivo=true' },
  listarAutocomplete: { method: 'GET', url: basePath + '?autocomplete={autocomplete}&indAtivo=true' }
});

exports.default = function (resource) {
  return resource('' + basePath, {}, centroCustoActions);
};

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

var _genericResource = __webpack_require__(7);

var _genericResource2 = _interopRequireDefault(_genericResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'cliente');

var clienteActions = (0, _extends3.default)({}, (0, _genericResource2.default)(basePath), {
  buscar: { method: 'GET', url: basePath + '/{id}' },
  buscarLojas: { method: 'GET', url: basePath + '/{id}/lojas' },
  ativarMassa: { method: 'PUT', url: basePath + '/ativacao-massa' },
  listarFiltrado: { method: 'GET', url: basePath + '?tamanhoPagina={size}&numeroPagina={page}&filtro={filter}' },
  obter: { method: 'GET', url: basePath + '/{codigo}' },
  listarAutocomplete: { method: 'GET', url: basePath + '/autocompletar?tamanhoPagina=6&numeroPagina=1&indAtivo=true' },
  listarAtivosConsiderandoUsuario: { method: 'GET', url: basePath + '/considerando-usuario?nome={nome}&indAtivo=true&colunaOrdenacao=nom_cliente' }
});

exports.default = function (resource) {
  return resource('' + basePath, {}, clienteActions);
};

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'cliente/{idCliente}/carteira-cliente');

var carteiraClienteActions = {
  pesquisar: { method: 'GET', url: '' + basePath }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, carteiraClienteActions);
};

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

var _genericResource = __webpack_require__(7);

var _genericResource2 = _interopRequireDefault(_genericResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'configuracao');

var configuracaoActions = (0, _extends3.default)({}, (0, _genericResource2.default)(basePath));

exports.default = function (resource) {
  return resource('' + basePath, {}, configuracaoActions);
};

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('negociacao', 'configuracao');

var configuracaoNegociacaoActions = {
  orcamentoHabilitado: { method: 'GET', url: basePath + '/orcamento-habilitado' },
  roiHabilitado: { method: 'GET', url: basePath + '/roi-habilitado/{tipoAcordo}' },
  workflowHabilitado: { method: 'GET', url: basePath + '/workflow-habilitado' },
  valorParametro: { method: 'GET', url: basePath + '/{tipoAcordo}/{grupo}/{chave}' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, configuracaoNegociacaoActions);
};

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'configuracao-tatico/planejamento');

var configuracaoWorkflowContratoActions = {
  atualizar: { method: 'POST', url: basePath + '/atualizar' },
  salvar: { method: 'POST', url: basePath + '/salvar' },
  pesquisar: { method: 'GET', url: basePath + '/{chave}' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, configuracaoWorkflowContratoActions);
};

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'configuracao-workflow-aprovacao');

var configuracaoWorkflowAprovacaoActions = {
  atualizar: { method: 'PUT', url: '' + basePath },
  pesquisar: { method: 'GET', url: basePath + '?tamanhoPagina={size}&numeroPagina={page}' },
  verificar: { method: 'GET', url: basePath + '/habilitado?chave={chave}' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, configuracaoWorkflowAprovacaoActions);
};

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'configuracao/contrato');

var configuracaoWorkflowContratoActions = {
  atualizarTipoAcordo: { method: 'PUT', url: basePath + '/{nomeAcordo}?valorSelecao={valorSelecao}' },
  atualizarTipoProvisao: { method: 'PUT', url: basePath + '/tipo-provisao/{nomeAcordo}' },
  pesquisarTipoProvisao: { method: 'GET', url: basePath + '/tipo-provisao/{nomeAcordo}' },
  atualizarConfiguracoesContrato: { method: 'PUT', url: '' + basePath },
  atualizarSubConfiguracoesContrato: { method: 'PUT', url: basePath + '/sub-configuracao' },
  pesquisar: { method: 'GET', url: basePath + '?tamanhoPagina={size}&numeroPagina={page}' },
  pesquisarConfiguracoesContrato: { method: 'GET', url: basePath + '/{nomeAcordo}' },
  pesquisarRoiBaseCalculo: {
    method: 'GET',
    url: basePath + '/{nomeAcordo}/roi/base-calculo'
  },
  pesquisarBaseCalculo: {
    method: 'GET',
    url: basePath + '/{nomeAcordo}/base-calculo'
  },
  pesquisarBonificacao: {
    method: 'GET',
    url: basePath + '/{nomeAcordo}/bonificacao'
  },
  pesquisarMetasBeneficios: {
    method: 'GET',
    url: basePath + '/{nomeAcordo}/metas-beneficios'
  },
  obtemValorConfiguracao: {
    method: 'GET',
    url: basePath + '/{nomeAcordo}/configuracao/{nomeConfig}'
  },
  obtemValorSubConfiguracao: {
    method: 'GET',
    url: basePath + '/{nomeAcordo}/sub-configuracao/{nomeConfig}'
  }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, configuracaoWorkflowContratoActions);
};

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('planejamento_tatico', 'conta-corrente');

var contaCorrenteActions = {
  divisao: { method: 'GET', url: basePath + '/divisao/{id}' },
  divisaoTransferencia: { method: 'GET', url: basePath + '/divisao/{id}/transferencia' },
  funcionario: { method: 'GET', url: basePath + '/funcionario/{id}' },
  cliente: { method: 'GET', url: basePath + '/cliente/{id}' },
  transferir: { method: 'PUT', url: basePath + '/divisao/{idOrigem}/transfere/{idDestino}' },
  transferirVerbaFuncionarios: { method: 'PUT', url: basePath + '/funcionario/{idOrigem}/transfere/{idDestino}' },
  buscarSaldoDoUsuario: { method: 'GET', url: basePath + '/saldo/usuario' },
  buscarExtratoDaDivisao: { method: 'GET', url: basePath + '/divisao/{id}/extrato?tamanhoPagina={size}&numeroPagina={page}' },
  buscarExtratoDoCliente: { method: 'GET', url: basePath + '/cliente/{id}/extrato?tamanhoPagina={size}&numeroPagina={page}' },
  buscarSaldoDivisao: { method: 'GET', url: basePath + '/saldo-divisao-hierarquia?tamanhoPagina={size}&numeroPagina={page}' },
  buscarSaldoCliente: { method: 'GET', url: basePath + '/saldo-cliente?tamanhoPagina={size}&numeroPagina={page}' },
  buscarSaldoDivisaoPorAdmin: { method: 'GET', url: basePath + '/saldo-divisao-admin?tamanhoPagina={size}&numeroPagina={page}' },
  buscarlSaldoClientePorAdmin: { method: 'GET', url: basePath + '/saldo-cliente-admin?tamanhoPagina={size}&numeroPagina={page}' },
  filtrarClienteDaHierarquia: { method: 'GET', url: basePath + '/cliente-hierarquia' },
  buscarSaldoMateriaisDivisao: { method: 'GET', url: basePath + '/saldo/{idDivisao}' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, contaCorrenteActions);
};

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('negociacao', 'contrato');

var contratoActions = {
  atualizar: { method: 'PUT', url: '' + basePath },
  gravar: { method: 'POST', url: '' + basePath },
  listarClientes: { method: 'GET', url: basePath + '/clientes' },
  listarContratos: { method: 'GET', url: basePath + '?descricao={descricao}' },
  obter: { method: 'GET', url: basePath + '/{id}' },
  upload: { method: 'POST', url: basePath + '/arquivo/{id}/upload' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, contratoActions);
};

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('negociacao', 'contrato');

var contratoLojaActions = {
  vincular: { method: 'PUT', url: basePath + '/{codigoContrato}/loja' },
  pesquisar: { method: 'GET', url: basePath + '/{codigoContrato}/loja' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, contratoLojaActions);
};

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('apuracao', 'dashboard');

var apuracaoActions = {
  pendencias: { method: 'GET', url: basePath + '/pendencias' },
  apuracao: { method: 'GET', url: basePath + '/apuracao/{id}' },
  listarDashApuracao: { method: 'GET', url: '' + basePath },
  listarApuracoes: { method: 'GET', url: basePath + '/apuracoes' },
  listarReivindicacoes: { method: 'GET', url: basePath + '/reinvidicacoes' },
  listarTiposNegociacoes: { method: 'GET', url: basePath + '/tipos-negociacoes' },
  listarMarcas: { method: 'GET', url: basePath + '/marcas?marca={nome}' },
  listarFamilia: { method: 'GET', url: basePath + '/familia?familia={nome}' },
  listarLinhaProduto: { method: 'GET', url: basePath + '/linha-produto?linhaProduto={nome}' },
  listarPeriodos: { method: 'GET', url: basePath + '/periodo' },
  listarSolicitantes: { method: 'GET', url: basePath + '/solicitante' },
  listarTipoAcordo: { method: 'GET', url: basePath + '/tipo-acordo' },
  statusEntidade: { method: 'GET', url: basePath + '/status-entidade' },
  apuracoesFinalizadas: { method: 'GET', url: basePath + '/cliente/finalizadas?competencia={competencia}' },
  apuracoesPendentes: { method: 'GET', url: basePath + '/cliente/pendentes?competencia={competencia}' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, apuracaoActions);
};

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePathPlanoComparativo = (0, _apiResource2.default)('relatorio', 'plano-comparativo');
var basePathPartInvest = (0, _apiResource2.default)('relatorio', 'participacao-investimento');
var baseAnaliseInvest = (0, _apiResource2.default)('relatorio', 'analise-investimento');
var basePathFechamento = (0, _apiResource2.default)('relatorio', 'fechamento');
var basePathAcompanhamento = (0, _apiResource2.default)('relatorio', 'acompanhamento');
var basePathGerencial = (0, _apiResource2.default)('relatorio', 'gerencial');
var basePathSimuladorInvestimento = (0, _apiResource2.default)('relatorio', 'simulador-investimento');

var apuracaoActions = {
  listarPlanoComparativoMarcas: { method: 'POST', url: basePathPlanoComparativo + '/marcas' },
  listarPlanoComparativoHierarquiaUsuario: { method: 'POST', url: basePathPlanoComparativo + '/hierarquia-usuario' },

  listarConsolidado: { method: 'POST', url: basePathPartInvest + '/consolidado' },
  listarPartInvestTipoHolding: { method: 'POST', url: basePathPartInvest + '/holding' },
  listarPartInvestTipoCliente: { method: 'POST', url: basePathPartInvest + '/cliente' },
  listarPartInvestTipoNegociacaoMarca: { method: 'POST', url: basePathPartInvest + '/tipo-negociacao-marca' },

  listarClientes: { method: 'GET', url: basePathGerencial + '/clientes' },
  listarContratoAcordo: { method: 'GET', url: basePathGerencial + '/contrato-acordo' },
  listarTipoAcao: { method: 'GET', url: basePathGerencial + '/tipo-acao' },
  listarTipoInvestimento: { method: 'GET', url: basePathGerencial + '/tipo-investimento' },
  listarTipoAcordo: { method: 'GET', url: basePathGerencial + '/tipo-acordo' },

  listarAnaliseInvestHistorico: { method: 'POST', url: baseAnaliseInvest + '/historico' },
  listarAnaliseInvestMarca: { method: 'POST', url: baseAnaliseInvest + '/marca' },

  savingResumo: { method: 'POST', url: basePathFechamento + '/saving/resumo' },
  savingDetalhe: { method: 'POST', url: basePathFechamento + '/saving/detalhe' },

  listarAcompanhamentoNegociacoes: { method: 'POST', url: basePathAcompanhamento + '/negociacao' },
  listarAcompanhamentoApuracoes: { method: 'POST', url: basePathAcompanhamento + '/apuracao' },

  listarSimuladorInvestimentoGrid: { method: 'POST', url: basePathSimuladorInvestimento + '/grid' },
  listarSimuladorInvestimentoGrafico: { method: 'POST', url: basePathSimuladorInvestimento + '/grafico' }
};

exports.default = function (resource) {
  return resource('', {}, apuracaoActions);
};

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('negociacao', 'dashboard-negociacao');

var negociacaoActions = {
  listarDashNegociacoes: { method: 'GET', url: '' + basePath },
  listarNegociacoes: { method: 'GET', url: basePath + '/negociacoes' },
  listarTiposNegociacoes: { method: 'GET', url: basePath + '/tipos-negociacoes' },
  listarMarcas: { method: 'GET', url: basePath + '/marcas?marca={nome}' },
  listarFamilia: { method: 'GET', url: basePath + '/familia?familia={nome}' },
  listarLinhaProduto: { method: 'GET', url: basePath + '/linha-produto?linhaProduto={nome}' },
  listarPeriodos: { method: 'GET', url: basePath + '/periodo' },
  statusEntidade: { method: 'GET', url: basePath + '/status-entidade' },
  negociacoesAgAprovacao: { method: 'GET', url: basePath + '/cliente' },
  periodosCliente: { method: 'GET', url: basePath + '/cliente/periodos' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, negociacaoActions);
};

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('planejamento', 'dashboard-orcamento');

var orcamentoActions = {
  anos: { method: 'GET', url: basePath + '/anos' },
  fluxos: { method: 'GET', url: basePath + '/fluxos{?idsMarcas*}' },
  buscarPlanejado: { method: 'GET', url: basePath + '/planejado' },
  linhasInvestimento: { method: 'GET', url: basePath + '/linhas-investimento/{codigo}' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, orcamentoActions);
};

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('pagamento_verbas_estruturais', 'dashboard');

var pagamentoActions = {
  listarDash: { method: 'GET', url: '' + basePath },
  listarPagamentos: { method: 'GET', url: basePath + '/pagamentos-solicitados' },
  listarPagamentosAprovacoes: { method: 'GET', url: basePath + '/pagamentos-aprovacoes' },
  listarReinvidicados: { method: 'GET', url: basePath + '/reinvidicados' },
  listarTiposNegociacoes: { method: 'GET', url: basePath + '/tipos-negociacoes' },
  listarMarcas: { method: 'GET', url: basePath + '/marcas?marca={nome}' },
  listarFamilia: { method: 'GET', url: basePath + '/familia?familia={nome}' },
  listarLinhaProduto: { method: 'GET', url: basePath + '/linha-produto?linhaProduto={nome}' },
  listarPeriodos: { method: 'GET', url: basePath + '/periodo' },
  listarSolicitantes: { method: 'GET', url: basePath + '/solicitante?colunaOrdenacao=nome' },
  listarTipoAcordo: { method: 'GET', url: basePath + '/tipo-acordo' },
  statusEntidade: { method: 'GET', url: basePath + '/status-entidade' },
  listarRateio: { method: 'GET', url: basePath + '/rateio/{id}' },
  consolidadoCliente: { method: 'GET', url: basePath + '/cliente?competencia={competencia}' },
  periodosCliente: { method: 'GET', url: basePath + '/cliente/periodos' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, pagamentoActions);
};

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('planejamento', 'desdobramento');

var desdobramentoActions = {
  desdobramentos: { method: 'GET', url: basePath + '/desdobramentos/{id}' },
  transferir: { method: 'PUT', url: basePath + '/transferir/{object}' },
  buscarPorLinhaInvestimento: { method: 'GET', url: basePath + '/linhas-investimento/{codigo}?anoMes={anoMes}&vigente=false' },
  buscarVigentesPorLinhaInvestimento: { method: 'GET', url: basePath + '/linhas-investimento/{codigo}?anoMes={anoMes}&vigente=true' },
  buscarVigentesPorLinhaInvestimentoTransferencia: { method: 'GET', url: basePath + '/linhas-investimento/{codigo}?anoMes={anoMes}&vigente=true&valorMaiorZero=true' },
  buscarDestinoVigentesPorLinhaInvestimento: { method: 'GET', url: basePath + '/linhas-investimento/{codigo}?anoMes={anoMes}&vigente=true&idDesdobramentoOrigem={idDesdobramentoOrigem}' },
  buscarRepresentantes: { method: 'GET', url: basePath + '/{codigo}/representantes?nome={nome}' },
  buscarHierarquia: { method: 'GET', url: basePath + '/{codigo}/hierarquia' },
  buscarPlanejadoDisponivel: { method: 'GET', url: basePath + '/{codigo}/saldo-planejado-disponivel' },
  buscarPlanejadoDisponivelRepresentante: { method: 'GET', url: basePath + '/{codigo}/saldo-planejado-disponivel/{idRepresentante}' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, desdobramentoActions);
};

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

var _genericResource = __webpack_require__(7);

var _genericResource2 = _interopRequireDefault(_genericResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'divisao');

var divisaoActions = (0, _extends3.default)({}, (0, _genericResource2.default)(basePath), {
  hierarquia: { method: 'GET', url: basePath + '/hierarquia' },
  hierarquiaFilha: { method: 'GET', url: basePath + '/hierarquia-filha' },
  pesquisasrDivisoesSuperiores: { method: 'GET', url: basePath + '/pai/hierarquia/{idEstruturaUsuario}' },
  listarFiltrado: { method: 'GET', url: basePath + '?tamanhoPagina={size}&numeroPagina={page}&filtro={filter}' },
  atualizarDivisao: { method: 'PUT', url: basePath + '/{id}' },
  listarAutocomplete: { method: 'GET', url: basePath + '?nome={nome}' }
});

exports.default = function (resource) {
  return resource('' + basePath, {}, divisaoActions);
};

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'endereco');

var enderecoActions = {
  obter: { method: 'GET', url: basePath + '/{id}' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, enderecoActions);
};

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.estadoResource = undefined;

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

var _genericResource = __webpack_require__(7);

var _genericResource2 = _interopRequireDefault(_genericResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'estado');

var estadoActions = (0, _extends3.default)({}, (0, _genericResource2.default)(basePath));

var estadoResource = exports.estadoResource = function estadoResource(resource) {
  return resource('' + basePath, {}, estadoActions);
};

exports.default = estadoResource;

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

var _genericResource = __webpack_require__(7);

var _genericResource2 = _interopRequireDefault(_genericResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'estrutura-usuario');

var estruturaUsuarioActions = (0, _extends3.default)({}, (0, _genericResource2.default)(basePath), {
  listar: { method: 'GET', url: '' + basePath },
  obter: { method: 'GET', url: basePath + '/{id}' },
  listarEstruturasPai: { method: 'GET', url: basePath + '?nome={nome}&idEdicao={idEdicao}' },
  inserirUsuarioRel: { method: 'POST', url: basePath + '/inserirUsuarioRel' },
  atualizaUsuarioRel: { method: 'PUT', url: basePath + '/atualizarUsuarioRel' },
  listarAutocomplete: { method: 'GET', url: basePath + '?nome={nome}&indAtivo=true&{&idsEstruturaUsuarioNotIn*}' }
});

exports.default = function (resource) {
  return resource('' + basePath, {}, estruturaUsuarioActions);
};

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('execucao', 'execucao');

var execucaoActions = {
  listar: { method: 'GET', url: basePath + '/meta/{id}' },
  remover: { method: 'DELETE', url: basePath + '/{idExecucao}' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, execucaoActions);
};

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

var _genericResource = __webpack_require__(7);

var _genericResource2 = _interopRequireDefault(_genericResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'extensao');

var extensaoActions = (0, _extends3.default)({}, (0, _genericResource2.default)(basePath), {
  listarAtivos: { method: 'GET', url: basePath + '?nome={nome}&indAtivo=true&colunaOrdenacao=nom_extensao&idNivelExtensao={idNivelExtensao}{&idsNotIn*}{&idsExternosObrigatorios*}' },
  listarModalidadesAtivas: { method: 'GET', url: basePath + '/modalidades?nome={nome}&indAtivo=true&colunaOrdenacao=nom_extensao&idNivelExtensao={idNivelExtensao}{&idsNotIn*}{&idsExternosObrigatorios*}' },
  listarQuantidadeMaiorAtivos: { method: 'GET', url: basePath + '?nome={nome}&indAtivo=true&colunaOrdenacao=nom_extensao&idNivelExtensao={idNivelExtensao}{&idsNotIn*}{&idsExternosObrigatorios*}' },
  listarPorUsuario: { method: 'GET', url: basePath + '?tamanhoPagina=10&numeroPagina=1&nome={nome}&indAtivo=true&idNivelExtensao={idNivelExtensao}&usuarioLogado=true&colunaOrdenacao=nom_extensao' },
  listarAutocomplete: { method: 'GET', url: basePath + '?autocomplete={autocomplete}&indAtivo=true&idNivelExtensao={idNivelExtensao}&colunaOrdenacao=nom_extensao' },
  obter: { method: 'GET', url: basePath + '/{id}' },
  listarAtivosPorRepresentante: { method: 'GET', url: basePath + '/por-representante?&nome={nome}&indAtivo=true&colunaOrdenacao=nom_extensao' }
});

exports.default = function (resource) {
  return resource('' + basePath, {}, extensaoActions);
};

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

var _genericResource = __webpack_require__(7);

var _genericResource2 = _interopRequireDefault(_genericResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'filtro-cliente');

var filtroClienteActions = (0, _extends3.default)({}, (0, _genericResource2.default)(basePath), {
  listarAtivos: { method: 'GET', url: basePath + '?tamanhoPagina=40&numeroPagina=1&indAtivo=true' }
});

exports.default = function (resource) {
  return resource('' + basePath, {}, filtroClienteActions);
};

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('usuario', 'funcionario');

var divisaoActions = {
  hierarquia: { method: 'GET', url: basePath + '/hierarquia' },
  hierarquiaFilha: { method: 'GET', url: basePath + '/hierarquia-filha' },
  autocomplete: { method: 'GET', url: basePath + '/autocomplete' },
  selecao: { method: 'GET', url: basePath + '/selecao' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, divisaoActions);
};

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('workflow_estrutural', '');

var workflowActions = {
  atualizar: { method: 'PUT', url: basePath + 'cadastro' },
  ativar: { method: 'PUT', url: basePath + 'cadastro/ativacao/{id}/true' },
  gravar: { method: 'POST', url: basePath + 'cadastro' },
  buscaUnica: { method: 'GET', url: basePath + 'cadastro/{id}' },
  busca: { method: 'GET', url: basePath + 'cadastro/fluxo/{id}' },
  inativar: { method: 'PUT', url: basePath + 'cadastro/ativacao/{id}/false' },
  buscarTipos: { method: 'GET', url: basePath + 'cadastro/tipos' },
  buscarCondicionais: { method: 'GET', url: basePath + 'cadastro/condicional/{id}' },
  listar: { method: 'GET', url: basePath + 'cadastro?tamanhoPagina={size}&numeroPagina={page}' },
  listarAtivos: { method: 'GET', url: basePath + '?tamanhoPagina=40&numeroPagina=1&nome={nome}&indAtivo=true' },
  buscarDescricoes: { method: 'GET', url: basePath + 'cadastro/passo/descricao{/idTipo}' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, workflowActions);
};

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.basePath = undefined;

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = exports.basePath = (0, _apiResource2.default)('job', '/exportacao-evidencias');

var geracaoExportacaoActions = {
  gerarExportacao: { method: 'POST', url: '' + basePath }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, geracaoExportacaoActions);
};

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

var _genericResource = __webpack_require__(7);

var _genericResource2 = _interopRequireDefault(_genericResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'grupo-produtos');

var produtoActions = (0, _extends3.default)({}, (0, _genericResource2.default)(basePath));

exports.default = function (resource) {
  return resource('' + basePath, {}, produtoActions);
};

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('negociacao', 'historico-vendas');

var historicoVendasActions = {
  vlrHistoricoExtensoes: { method: 'GET', url: basePath + '/vlr-historico/extensoes{?idExtensao*}' },
  vlrHistoricoProduto: { method: 'GET', url: basePath + '/vlr-historico/produto/{idProduto}' },
  vlrHistoricoTipoAcordoExtensoes: { method: 'GET', url: basePath + '/vlr-historico/{tipoAcordo}/extensoes{?idExtensao*}' },
  vlrHistoricoTipoAcordoProduto: { method: 'GET', url: basePath + '/vlr-historico/{tipoAcordo}/produto/{idProduto}' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, historicoVendasActions);
};

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('planejamento', 'linha-investimento');

var linhaIvestimentoActions = {
  atualizar: { method: 'PUT', url: '' + basePath },
  linhasInvestimento: { method: 'GET', url: basePath + '/linhas-investimento/{codigo}' },
  buscarPorOrcamento: { method: 'GET', url: basePath + '/orcamento/{codigo}' },
  transferir: { method: 'PUT', url: basePath + '/transferir/{object}' },
  saldoDisponivel: { method: 'GET', url: basePath + '/{codigo}/saldo-planejado-disponivel?anoMesInicio={anoMesInicio}&anoMesFim={anoMesFim}' },
  buscarLinhaPorOrcamentos: { method: 'POST', url: basePath + '/orcamento' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, linhaIvestimentoActions);
};

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

var _genericResource = __webpack_require__(7);

var _genericResource2 = _interopRequireDefault(_genericResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'loja');

var lojaActions = (0, _extends3.default)({}, (0, _genericResource2.default)(basePath), {
  buscar: { method: 'GET', url: basePath + '/{id}' }
});

exports.default = function (resource) {
  return resource('' + basePath, {}, lojaActions);
};

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'margemcontribuicao');

var margemContribuicaoActions = {
  listar: { method: 'GET', url: '' + basePath }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, margemContribuicaoActions);
};

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.marcaResource = undefined;

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'metadados/entidade');

var marcaActions = {
  listarCliente: { method: 'GET', url: basePath + '/cliente' },
  listarCarteiraCliente: { method: 'GET', url: basePath + '/carteira_cliente' },
  listarProduto: { method: 'GET', url: basePath + '/produto' },
  listarUsuario: { method: 'GET', url: basePath + '/usuario' },
  listarAcaoTatica: { method: 'GET', url: basePath + '/acao_tatica' },
  listarPlanejamentoMaterial: { method: 'GET', url: basePath + '/planejamento-material' },
  listarRelatorio: { method: 'GET', url: basePath + '/relatorio' },
  listarDivisao: { method: 'GET', url: basePath + '/divisao' },
  definicaoOrcamento: { method: 'GET', url: basePath + '/orcamento' },
  definicaoLinhaInvestimento: { method: 'GET', url: basePath + '/linha_investimento' },
  definicaoCentroCusto: { method: 'GET', url: basePath + '/ceco' },
  definicaoAcao: { method: 'GET', url: basePath + '/acao' }
};

var marcaResource = exports.marcaResource = function marcaResource(resource) {
  return resource('' + basePath, {}, marcaActions);
};

exports.default = marcaResource;

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('planejamento', 'metas');

var alcadaActions = {
  calculoBase: { method: 'GET', url: basePath + '/calculo/tipo/{tipo}/idCliente/{cliente}?periodo={periodo}&nro_periodo={nroPeriodo}' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, alcadaActions);
};

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

var _genericResource = __webpack_require__(7);

var _genericResource2 = _interopRequireDefault(_genericResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'nivel-cliente');

var nivelProdutoActions = (0, _extends3.default)({}, (0, _genericResource2.default)(basePath), {
  orcamento: { method: 'GET', url: basePath + '/orcamento' },
  acao: { method: 'GET', url: basePath + '/acao' }
});

exports.default = function (resource) {
  return resource('' + basePath, {}, nivelProdutoActions);
};

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

var _genericResource = __webpack_require__(7);

var _genericResource2 = _interopRequireDefault(_genericResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'nivel-produto');

var nivelProdutoActions = (0, _extends3.default)({}, (0, _genericResource2.default)(basePath), {
  listarPorEntidadeOrcamento: { method: 'GET', url: basePath + '/entidade?entidade=ORCAMENTO' },
  labels: { method: 'GET', url: basePath + '/labels' },
  categorias: { method: 'GET', url: basePath + '/categorias-recursivas' },
  orcamento: { method: 'GET', url: basePath + '/orcamento' },
  acao: { method: 'GET', url: basePath + '/acao' }
});

exports.default = function (resource) {
  return resource('' + basePath, {}, nivelProdutoActions);
};

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('planejamento', 'orcamento');

var orcamentoActions = {
  anos: { method: 'GET', url: basePath + '/anos' },
  meses: { method: 'GET', url: basePath + '/meses' },
  atualizar: { method: 'PUT', url: '' + basePath },
  buscar: { method: 'GET', url: basePath + '/{codigo}' },
  cancelar: { method: 'PUT', url: basePath + '/cancelar/{id}' },
  desdobramentos: { method: 'GET', url: basePath + '/desdobramentos/{id}' },
  finalizar: { method: 'PUT', url: basePath + '/finalizar/{id}' },
  gravar: { method: 'POST', url: '' + basePath },
  linhasInvestimento: { method: 'GET', url: basePath + '/linhas-investimento/{codigo}' },
  listar: { method: 'GET', url: basePath + '?completo=true' },
  listarAprovados: { method: 'GET', url: basePath + '?status=APROVADO&descricao={descricao}&colunaOrdenacao=descricao' },
  listarDestinoAprovados: { method: 'GET', url: basePath + '?status=APROVADO&descricao={descricao}&idOrcamentoOrigem={idOrcamentoOrigem}&colunaOrdenacao=descricao' },
  logs: { method: 'GET', url: basePath + '{/id}/logs' },
  orcamentoCompleto: { method: 'GET', url: basePath + '/completo/{codigo}' },
  saldo: { method: 'GET', url: basePath + '/saldo/{codigo}' },
  transferir: { method: 'PUT', url: basePath + '/transferir/{object}' },
  buscarConsumo: { method: 'GET', url: basePath + '{/id}/consumo' },
  buscarOrcamento: { method: 'GET', url: basePath + '/buscar/{id}' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, orcamentoActions);
};

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buscaOrcamentos = exports.buscarTiposVerbaOrcamento = undefined;

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

var _metadadosResourceBuilder = __webpack_require__(243);

var _metadadosResourceBuilder2 = _interopRequireDefault(_metadadosResourceBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('orcamento', 'orcamento');

var orcamentoActions = {
  buscarOrcamento: { methods: 'GET', url: basePath + '/carregamento/{idOrcamento}' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, orcamentoActions);
};

var buscarTiposVerbaOrcamento = exports.buscarTiposVerbaOrcamento = function buscarTiposVerbaOrcamento(parametros, resource) {
  return _metadadosResourceBuilder2.default.buildGET(resource, basePath, 'listagem/tipo_verba', parametros).doGet();
};

var buscaOrcamentos = exports.buscaOrcamentos = function buscaOrcamentos(parametros, resource) {
  return _metadadosResourceBuilder2.default.buildGET(resource, basePath, 'listagem/tipo_verba/orcamentos', parametros).doGet();
};

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('orcamento', 'orcamento');

var orcamentoActions = {
  buscarConfigTiposVerba: { methods: 'GET', url: basePath + '/configuracao' },
  buscarConfigVigente: { methods: 'GET', url: basePath + '/configuracao/vigente/{idTipoVerba}' },
  buscarConfigSnapshot: { methods: 'GET', url: basePath + '/configuracao/snapshot/{idOrcamento}' },
  buscarCamposGrid: { methods: 'GET', url: basePath + '/configuracao/campos/grid/{idTipoVerba}' },
  buscarCamposFiltro: { methods: 'GET', url: basePath + '/configuracao/campos/filtro' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, orcamentoActions);
};

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('pagamento_verbas_estruturais', 'criacao');

var pagamentoActions = {
  criar: { method: 'POST', url: basePath + '/{idApuracao}' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, pagamentoActions);
};

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('pagamento_verbas_estruturais', 'gestao');

var pagamentoGestaoActions = {
  competencias: { method: 'GET', url: basePath + '/competencias' },
  aprovados: { method: 'GET', url: basePath + '/aprovados' },
  pendente: { method: 'GET', url: basePath + '/pendente_integracao' },
  agPagamento: { method: 'GET', url: basePath + '/aguardando_pagamento' },
  liquidados: { method: 'GET', url: basePath + '/liquidados' },
  naoLiquidados: { method: 'GET', url: basePath + '/nao_liquidados' },
  bloqueados: { method: 'GET', url: basePath + '/bloqueados' },
  resgatar: { method: 'PUT', url: basePath + '/resgatar/{idPagamento}' },
  exportar: { method: 'PUT', url: basePath + '/status/aguardando_pagamento' },
  cancelar: { method: 'POST', url: basePath + '/cancelamento' },
  resgatarPagamentos: { method: 'POST', url: basePath + '/resgate' },
  cancelarUnico: { method: 'DELETE', url: basePath + '/{id}' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, pagamentoGestaoActions);
};

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('pagamento_verbas_estruturais', 'integracao');

var pagamentoActions = {
  reenviar: { method: 'PUT', url: basePath + '/reenviar' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, pagamentoActions);
};

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

var _genericResource = __webpack_require__(7);

var _genericResource2 = _interopRequireDefault(_genericResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'parametrizacao-acao');

var parametrizacaoAcaoActions = (0, _extends3.default)({}, (0, _genericResource2.default)(basePath), {
  buscar: { method: 'GET', url: '' + basePath },
  obterPasso1: { method: 'GET', url: basePath + '/{id}/passo1' },
  obterPasso2: { method: 'GET', url: basePath + '/{id}/passo2' },
  obterPasso3: { method: 'GET', url: basePath + '/{id}/passo3' },
  obterPasso4: { method: 'GET', url: basePath + '/{id}/passo4' },
  obterPasso5: { method: 'GET', url: basePath + '/{id}/passo5' },
  obterPasso6: { method: 'GET', url: basePath + '/{id}/passo6' },
  obterPasso7: { method: 'GET', url: basePath + '/{id}/passo7' },
  obterPasso8: { method: 'GET', url: basePath + '/{id}/passo8' }
});

exports.default = function (resource) {
  return resource('' + basePath, {}, parametrizacaoAcaoActions);
};

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'cliente-configuracao');

var parametrizacaoClienteActions = {
  buscar: { method: 'GET', url: basePath + '/{chave}' },
  salvar: { method: 'PUT', url: basePath + '/{chave}' },
  buscarTodas: { method: 'GET', url: '' + basePath }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, parametrizacaoClienteActions);
};

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

var _genericResource = __webpack_require__(7);

var _genericResource2 = _interopRequireDefault(_genericResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'parametrizacao-orcamento');

var parametrizacaoOrcamentoActions = (0, _extends3.default)({}, (0, _genericResource2.default)(basePath), {
  buscar: { method: 'GET', url: '' + basePath },
  obter: { method: 'GET', url: basePath + '/{id}' },
  salvarPasso2: { method: 'PUT', url: basePath + '/passo2' },
  salvarPasso3: { method: 'PUT', url: basePath + '/{id}/passo3' },
  salvarPasso4: { method: 'PUT', url: basePath + '/{id}/passo4' },
  salvarPasso5: { method: 'PUT', url: basePath + '/{id}/passo5' },
  obterPasso2: { method: 'GET', url: basePath + '/{id}/passo2' },
  obterPasso3: { method: 'GET', url: basePath + '/{id}/passo3' },
  obterPasso4: { method: 'GET', url: basePath + '/passo4' },
  obterPasso5: { method: 'GET', url: basePath + '/passo5' },
  listarTipoInvestimento: { method: 'GET', url: basePath + '/tipo-investimento' },
  listarEntidadeProduto: { method: 'GET', url: basePath + '/entidade-produto{?labels*}' }
});

exports.default = function (resource) {
  return resource('' + basePath, {}, parametrizacaoOrcamentoActions);
};

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

var _genericResource = __webpack_require__(7);

var _genericResource2 = _interopRequireDefault(_genericResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('usuario', 'perfil');

var perfilActions = (0, _extends3.default)({}, (0, _genericResource2.default)(basePath));

exports.default = function (resource) {
  return resource('' + basePath, {}, perfilActions);
};

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('planejamento_acao', 'configuracao');

var configuracaoActions = {
  buscarCamposFiltro: { methods: 'GET', url: basePath + '/campos/filtro' },
  buscarCamposGrid: { methods: 'GET', url: basePath + '/campos/grid/{idTipoAcao}' },
  buscarConfigVigente: { methods: 'GET', url: basePath + '/vigente/{idTipoAcao}' },
  buscarConfigSnapshot: { methods: 'GET', url: basePath + '/snapshot/{idAcao}' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, configuracaoActions);
};

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('planejamento_acao', 'cadastro');

var planejamentoAcaoActions = {
  salvarAcao: { method: 'POST', url: '' + basePath },
  atualizarAcao: { method: 'PUT', url: '' + basePath },
  buscarTiposAcao: { method: 'GET', url: basePath + '/campos/tipo_acao' },
  buscarHoldings: { method: 'GET', url: basePath + '/campos/holding' },
  buscarClientes: { method: 'GET', url: basePath + '/campos/cliente' },
  buscarDivisoes: { method: 'GET', url: basePath + '/campos/divisao' },
  buscarUnidadesNegocioDivisao: { method: 'GET', url: basePath + '/campos/divisao/{idDivisao}/unidade_negocio' },
  buscarClientesPagadores: { method: 'GET', url: basePath + '/campos/cliente/pagador' },
  buscarPeriodos: { method: 'GET', url: basePath + '/campos/periodo' },
  buscarContasCorrentesElegiveis: { method: 'GET', url: basePath + '/conta_corrente/elegiveis{?id_produto*}' },
  executarAnalise: { method: 'PUT', url: basePath + '/{idAcao}/executarAnalise' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, planejamentoAcaoActions);
};

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buscarAcoes = exports.buscarTiposAcao = undefined;

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

var _metadadosResourceBuilder = __webpack_require__(243);

var _metadadosResourceBuilder2 = _interopRequireDefault(_metadadosResourceBuilder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('planejamento_acao', '');

var planejamentoAcaoActions = {
  buscarAcao: { methods: 'GET', url: basePath + 'carregamento/{idAcao}' },
  verificarSeUsuarioPossuiAcesso: { methods: 'GET', url: basePath + 'listagem/acesso/{idAcao}' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, planejamentoAcaoActions);
};

var buscarTiposAcao = exports.buscarTiposAcao = function buscarTiposAcao(parametros, resource) {
  return _metadadosResourceBuilder2.default.buildGET(resource, basePath, 'listagem/tipo_acao', parametros).doGet();
};

var buscarAcoes = exports.buscarAcoes = function buscarAcoes(parametros, resource) {
  return _metadadosResourceBuilder2.default.buildGET(resource, basePath, 'listagem/tipo_acao/acoes', parametros).doGet();
};

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

var _genericResource = __webpack_require__(7);

var _genericResource2 = _interopRequireDefault(_genericResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'planejamento-material');

var planejamentoMaterialActions = (0, _extends3.default)({}, (0, _genericResource2.default)(basePath), {
  listarFiltrado: { method: 'GET', url: basePath + '?tamanhoPagina={size}&numeroPagina={page}&filtro={filter}' },
  buscar: { method: 'GET', url: basePath + '/{id}' }
});

exports.default = function (resource) {
  return resource('' + basePath, {}, planejamentoMaterialActions);
};

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

var _genericResource = __webpack_require__(7);

var _genericResource2 = _interopRequireDefault(_genericResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'planejamento-peca');

var planejamentoPecaActions = (0, _extends3.default)({}, (0, _genericResource2.default)(basePath), {
  listarFiltrado: { method: 'GET', url: basePath + '?tamanhoPagina={size}&numeroPagina={page}&filtro={filter}' },
  pesquisar: { method: 'GET', url: '' + basePath },
  buscar: { method: 'GET', url: basePath + '/{id}' },
  removerArquivo: { method: 'DELETE', url: basePath + '/arquivo?arquivo={arquivo}' },
  getThumb: { method: 'GET', url: basePath + '/thumb' },
  listaLog: { method: 'GET', url: basePath + '/log-download-catalogo' }
});

exports.default = function (resource) {
  return resource('' + basePath, {}, planejamentoPecaActions);
};

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('planejamento_tatico', 'planejamento-tatico');

var planejamentoActions = {
  listar: { method: 'GET', url: basePath + '?tamanhoPagina={size}&numeroPagina={page}&filtro={filter}' },
  autoComplete: { method: 'GET', url: basePath + '?descricao={descricao}' },
  solicitante: { method: 'GET', url: basePath + '/solicitante' },
  concluir: { method: 'POST', url: basePath + '/fluxo' },
  copiar: { method: 'POST', url: basePath + '/{id}/copia' },
  aprovar: { method: 'PUT', url: basePath + '/aprovar' },
  reprovar: { method: 'PUT', url: basePath + '/reprovar' },
  enviarParaAnalise: { method: 'PUT', url: basePath + '/analise' },
  cancelar: { method: 'PUT', url: basePath + '/cancelar' },
  executarAnalise: { method: 'PUT', url: basePath + '/executar/analise' },
  gravar: { method: 'POST', url: basePath },
  obter: { method: 'GET', url: basePath + '/{id}' },
  alterar: { method: 'PUT', url: basePath + '/{id}' },
  listarAcoes: { method: 'GET', url: basePath + '/{id}/acao-tatica/{entidade}/{idEntidade}' },
  validarTaxasDasAcoes: { method: 'GET', url: basePath + '/{id}/acao-tatica/taxas' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, planejamentoActions);
};

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('planejamento_tatico', 'planejamento-tatico-arquivo/{idPlanejamento}');

var planejamentoActions = {
  listar: { method: 'GET', url: '' + basePath },
  registrarArquivo: { method: 'POST', url: basePath + '/salvar' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, planejamentoActions);
};

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('planejamento_tatico', 'planejamento-tatico-material');

var planejamentoActions = {
  listar: { method: 'GET', url: basePath + '/{idPlanejamento}' },
  listarPorAcao: { method: 'GET', url: basePath + '/acao/{idPlanejamentoAcao}' },
  salvar: { method: 'POST', url: '' + basePath },
  salvarPorAcao: { method: 'POST', url: basePath + '/acao' },
  buscarSaldoMateriais: { method: 'GET', url: basePath + '/saldo/{idPlanejamento}' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, planejamentoActions);
};

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

var _genericResource = __webpack_require__(7);

var _genericResource2 = _interopRequireDefault(_genericResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'produto');

var produtoActions = (0, _extends3.default)({}, (0, _genericResource2.default)(basePath), {
  buscar: { method: 'GET', url: basePath + '/{id}' },
  ativarMassa: { method: 'PUT', url: basePath + '/ativacao-massa' },
  listarFiltrado: { method: 'GET', url: basePath + '?colunaOrdenacao=nom_produto&tamanhoPagina={size}&numeroPagina={page}' },
  listarAutocompletePagina: { method: 'GET', url: basePath + '?colunaOrdenacao=nom_produto' },
  listarAutocompleteRelatorio: { method: 'GET', url: basePath + '/relatorio?colunaOrdenacao=nom_produto{&id_marca*}{&id_familia*}{&id_linha_produto*}{&idUnidadeNegocio*}' },
  listarAutocomplete: { method: 'GET', url: basePath + '?tamanhoPagina=6&numeroPagina=1&autocomplete={autocomplete}&indAtivo=true' },
  buscarExtensoesRelacionadas: { method: 'GET', url: basePath + '/extensao-relacionada?nome={nome}&indAtivo=true&idNivelExtensao={idNivelExtensao}&colunaOrdenacao=nom_extensao{&idExtensaoFiltro*}' },
  buscarExtensoesRelacionadasRelatorio: { method: 'GET', url: basePath + '/extensao-relacionada/relatorio?nome={nome}&indAtivo=true&idNivelExtensao={idNivelExtensao}&colunaOrdenacao=nom_extensao{&idExtensaoFiltro*}' }
});

exports.default = function (resource) {
  return resource('' + basePath, {}, produtoActions);
};

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

var _genericResource = __webpack_require__(7);

var _genericResource2 = _interopRequireDefault(_genericResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('planejamento', 'orcamento/rateio');

var rateioActions = (0, _extends3.default)({}, (0, _genericResource2.default)(basePath), {
  cabecalho: { method: 'GET', url: basePath + '/{id}/cabecalho' },
  rateio: { method: 'GET', url: basePath + '/{id}' },
  buscarFuncionarios: { method: 'GET', url: basePath + '/{idOrcamento}/funcionarios' },
  buscarNovosVendedores: { method: 'GET', url: basePath + '/{idOrcamento}/novos-vendedores' },
  adicionarNovosVendedores: { method: 'PUT', url: basePath + '/{idOrcamento}/novos-vendedores' }
});

exports.default = function (resource) {
  return resource('' + basePath, {}, rateioActions);
};

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'orcamento-tipo-verba');

var orcamentoActions = {
  buscarAtivos: { method: 'GET', url: basePath + '/ativos' },
  buscarTipoVerba: { method: 'GET', url: basePath + '/{id}' },
  ultimoAno: { method: 'GET', url: basePath + '/{id}/ultimo-ano' },
  buscarPorIdVerbaInvestimento: { method: 'GET', url: basePath + '/investimento/{idOrcamentoVerbaInvestimento}' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, orcamentoActions);
};

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

var _genericResource = __webpack_require__(7);

var _genericResource2 = _interopRequireDefault(_genericResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'regiao');

var regiaoActions = (0, _extends3.default)({}, (0, _genericResource2.default)(basePath), {
  listarAtivosPorRepresentante: { method: 'GET', url: basePath + '/por-representante?&nome={nome}&indAtivo=true&colunaOrdenacao=nom_regiao' }
});

exports.default = function (resource) {
  return resource('' + basePath, {}, regiaoActions);
};

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('apuracao', 'reivindicacao');

var reivindicacaoActions = {
  justificativa: { method: 'GET', url: basePath + '/{idReivindicacao}/justificativa' },
  solicitar: { method: 'POST', url: basePath + '/solicitar/{idApuracao}' },
  iniciaFluxo: { method: 'POST', url: basePath + '/fluxo/{idReivindicacao}' },
  upload: { method: 'POST', url: basePath + '/upload' },
  reprovarReivindicacao: { method: 'PUT', url: basePath + '/{idReivindicacao}/reprovar' },
  aprovarReivindicacao: { method: 'PUT', url: basePath + '/{idReivindicacao}/aprovar' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, reivindicacaoActions);
};

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'representante');

var representanteActions = {
  listarAtivos: { method: 'GET', url: basePath + '?email={email}&ativo=true' },
  listarHierarquia: { method: 'GET', url: basePath + '?ativo=true&hierarquia=true' },
  obter: { method: 'GET', url: basePath + '/{id}' },
  canaisVenda: { method: 'GET', url: basePath + '/canais-venda?nome={nome}&colunaOrdenacao=nom_extensao' },
  vendedoresRepresentantes: { method: 'GET', url: basePath + '/vendedores-representantes?ativo=true' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, representanteActions);
};

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'cliente/{idCliente}/representante');

var representanteClienteActions = {
  ativar: { method: 'PUT', url: basePath + '/{id}/ativacao/true' },
  buscar: { method: 'GET', url: '' + basePath },
  inativar: { method: 'PUT', url: basePath + '/{id}/ativacao/false' },
  gravar: { method: 'POST', url: '' + basePath }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, representanteClienteActions);
};

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'representante-logado');

var representanteLogadoActions = {
  clientes: { method: 'GET', url: basePath + '/clientes?indAtivo=true&colunaOrdenacao=nom_cliente' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, representanteLogadoActions);
};

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

var _genericResource = __webpack_require__(7);

var _genericResource2 = _interopRequireDefault(_genericResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('execucao_acao_tatica', 'reporte-tatico');

var reporteTaticoActions = (0, _extends3.default)({}, (0, _genericResource2.default)(basePath), {
  listarFiltrado: { method: 'GET', url: basePath + '?tamanhoPagina={size}&numeroPagina={page}&filtro={filter}' },
  buscar: { method: 'GET', url: basePath + '/{id}' },
  buscarPelaAcao: { method: 'GET', url: basePath + '/acao/{id}' },
  removerArquivo: { method: 'DELETE', url: basePath + '/arquivo/{tipo}' },
  getThumb: { method: 'GET', url: basePath + '/thumb' }
});

exports.default = function (resource) {
  return resource('' + basePath, {}, reporteTaticoActions);
};

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('negociacao', 'roi');

var roiActions = {
  roiExtensoes: { method: 'GET', url: basePath + '/extensoes{?idExtensao*}' },
  roiProduto: { method: 'GET', url: basePath + '/produto/{idProduto}' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, roiActions);
};

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

var _genericResource = __webpack_require__(7);

var _genericResource2 = _interopRequireDefault(_genericResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'sell-in');

var sellInActions = (0, _extends3.default)({}, (0, _genericResource2.default)(basePath), {
  listarConsolidado: { method: 'GET', url: basePath + '/consolidado?tamanhoPagina={size}&numeroPagina={page}' },
  listarDetalhado: { method: 'GET', url: basePath + '/obter/detalhado?nota={nota}&competencia={competencia}&cliente={idcliente}&filtro={filter}' },
  periodos: { method: 'GET', url: basePath + '/periodos' }
});

exports.default = function (resource) {
  return resource('' + basePath, {}, sellInActions);
};

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

var _genericResource = __webpack_require__(7);

var _genericResource2 = _interopRequireDefault(_genericResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'sell-out');

var sellInActions = (0, _extends3.default)({}, (0, _genericResource2.default)(basePath), {
  listarConsolidado: { method: 'GET', url: basePath + '/consolidado?tamanhoPagina={size}&numeroPagina={page}&filtro={filter}' },
  listarDetalhado: { method: 'GET', url: basePath + '/obter/detalhado?nota={nota}&competencia={competencia}&cliente={idcliente}&filtro={filter}' }
});

exports.default = function (resource) {
  return resource('' + basePath, {}, sellInActions);
};

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('usuario', 'sso/grupo');

var grupoActions = {
  listar: { method: 'GET', url: '' + basePath },
  obter: { method: 'GET', url: basePath + '/{id}' },
  excluir: { method: 'DELETE', url: basePath + '/{id}' },
  salvar: { method: 'PUT', url: '' + basePath },
  adicionar: { method: 'POST', url: '' + basePath }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, grupoActions);
};

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('usuario', 'sso/role');

var roleActions = {
  listar: { method: 'GET', url: '' + basePath }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, roleActions);
};

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('usuario', 'sso/usuario');

var usuarioActions = {
  listar: { method: 'GET', url: basePath + '?tamanhoPagina={size}&numeroPagina={page}&filtro={filter}' },
  quantidade: { method: 'GET', url: basePath + '/quantidade?tamanhoPagina={size}&numeroPagina={page}&filtro={filter}' },
  buscarGrupo: { method: 'GET', url: basePath + '/{idUsuario}/grupo' },
  buscarUsuario: { method: 'GET', url: basePath + '/{idUsuario}' },
  salvar: { method: 'PUT', url: '' + basePath },
  inserir: { method: 'POST', url: '' + basePath }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, usuarioActions);
};

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

var _genericResource = __webpack_require__(7);

var _genericResource2 = _interopRequireDefault(_genericResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'contrato-tipo-acao');

var tipoAcaoActions = (0, _extends3.default)({}, (0, _genericResource2.default)(basePath), {
  buscarAtivos: { method: 'GET', url: basePath + '/ativos' },
  buscarTipoAcaoComConfiguracao: { method: 'GET', url: basePath + '/{idTipoAcao}/configuracao' },
  buscarTipoAcao: { method: 'GET', url: basePath + '/{id}' }
});

exports.default = function (resource) {
  return resource('' + basePath, {}, tipoAcaoActions);
};

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('negociacao', 'tipo-beneficio');

var tipoBeneficioActions = {
  listarAtivos: { method: 'GET', url: basePath + '?nome={nome}&indAtivo=true' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, tipoBeneficioActions);
};

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

var _genericResource = __webpack_require__(7);

var _genericResource2 = _interopRequireDefault(_genericResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'tipo-investimento');
var basePathPlanejamento = (0, _apiResource2.default)('planejamento', 'tipo-investimento');

var tipoInvestimentoActions = (0, _extends3.default)({}, (0, _genericResource2.default)(basePath), {
  listarAtivos: { method: 'GET', url: basePath + '?descInvestimento={nome}&indAtivo=true' },
  listarTiposLinhasInvestimentos: { method: 'GET', url: basePathPlanejamento + '?colunaOrdenacao=desc_investimento' },
  listarLinhasInvestimentos: { method: 'GET', url: basePathPlanejamento + '/{idTipoInvestimento}/linha-investimento' },
  ativarMassa: { method: 'PUT', url: basePath + '/ativacao-massa' }
});

exports.default = function (resource) {
  return resource('' + basePath, {}, tipoInvestimentoActions);
};

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

var _genericResource = __webpack_require__(7);

var _genericResource2 = _interopRequireDefault(_genericResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'orcamento-tipo-verba');

var tipoOrcamentoActions = (0, _extends3.default)({}, (0, _genericResource2.default)(basePath), {
  listarAtivos: { method: 'GET', url: basePath + '?descInvestimento={nome}&indAtivo=true&colunaOrdenacao=nome' }
});

exports.default = function (resource) {
  return resource('' + basePath, {}, tipoOrcamentoActions);
};

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('planejamento', 'transferencia');

var transferenciaActions = {
  gravar: { method: 'POST', url: '' + basePath },
  obter: { method: 'GET', url: basePath + '/{id}' },
  solicitante: { method: 'GET', url: basePath + '/solicitante' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, transferenciaActions);
};

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('usuario', 'transferencia');

var transferenciaPosseActions = {
  listarTemporarios: { method: 'GET', url: basePath + '?tamanhoPagina={tamanhoPagina}&numeroPagina={numeroPagina}' },
  listarHistorico: { method: 'GET', url: basePath + '/historico?tamanhoPagina={tamanhoPagina}&numeroPagina={numeroPagina}' },
  listarDivisoes: { method: 'GET', url: basePath + '/divisao?nome={nome}&{&idNotIn*}' },
  listarFuncionarios: { method: 'GET', url: basePath + '/funcionario?nome={nome}&{&idNotIn*}' },
  remover: { method: 'PUT', url: '' + basePath },
  transferir: { method: 'POST', url: '' + basePath }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, transferenciaPosseActions);
};

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('usuario', 'transferencia-definitiva');

var transferenciaPosseActions = {
  listarFuncionarios: { method: 'GET', url: basePath + '/funcionario' },
  listarCarteiras: { method: 'GET', url: basePath + '/carteira-cliente?{&id_regiao*}{&id_cliente*}{&id_holding*}' },
  listarResponsaveis: { method: 'GET', url: basePath + '/responsavel-faturamento?{&id_regiao*}{&id_cliente*}{&id_holding*}' },
  orcamento: { method: 'GET', url: basePath + '/orcamentos?{&marcas*}' },
  transferir: { method: 'POST', url: '' + basePath },
  listar: { method: 'GET', url: basePath + '?tamanhoPagina={tamanhoPagina}&numeroPagina={numeroPagina}' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, transferenciaPosseActions);
};

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.basePath = undefined;

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = exports.basePath = (0, _apiResource2.default)('apuracao', 'reivindicacao');

var importacaoActions = {
  upload: { method: 'POST', url: '' + basePath }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, importacaoActions);
};

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

var _genericResource = __webpack_require__(7);

var _genericResource2 = _interopRequireDefault(_genericResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'unidade-medida');

var unidadeMedidaActions = (0, _extends3.default)({}, (0, _genericResource2.default)(basePath));

exports.default = function (resource) {
  return resource('' + basePath, {}, unidadeMedidaActions);
};

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

var _genericResource = __webpack_require__(7);

var _genericResource2 = _interopRequireDefault(_genericResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('usuario', 'usuario-cliente');

var regiaoActions = (0, _extends3.default)({}, (0, _genericResource2.default)(basePath), {
  obterUsuariosMesmaConfiguracaoUsuarioId: { method: 'GET', url: basePath + '/usuarios/mesma-configuracao/usuario/{id}' }
});

exports.default = function (resource) {
  return resource('' + basePath, {}, regiaoActions);
};

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'usuario-logado');

var divisaoActions = {
  divisao: { method: 'GET', url: basePath + '/divisao' },
  hierarquiaDivisao: { method: 'GET', url: basePath + '/divisao/hierarquia{?exceto*}' },
  regional: { method: 'GET', url: basePath + '/regional' },
  cliente: { method: 'GET', url: basePath + '/divisao/cliente' },
  clienteHierarquia: { method: 'GET', url: basePath + '/divisao/hierarquia/clientes{?exceto*&idsDivisao*}' }

};

exports.default = function (resource) {
  return resource('' + basePath, {}, divisaoActions);
};

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

var _genericResource = __webpack_require__(7);

var _genericResource2 = _interopRequireDefault(_genericResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('usuario', 'usuario-unidade-negocio');

var usuarioUnidadeNegocioActions = (0, _extends3.default)({}, (0, _genericResource2.default)(basePath), {
  ativarDesativar: { method: 'PUT', url: basePath + '/{idUsuario}/ativacao' },
  listarAtivos: { method: 'GET', url: basePath + '/lista-unidades-do-usuario' }
});

exports.default = function (resource) {
  return resource('' + basePath, {}, usuarioUnidadeNegocioActions);
};

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('workflow', 'execucao/acao');

var workflowAcaoActions = {
  solicitante: { method: 'GET', url: basePath + '/solicitante/{idAcao}' },
  buscaPassosClientes: { method: 'GET', url: basePath + '/{idAcao}/passos/cliente' },
  associaUsuarioClienteAprovador: { method: 'POST', url: basePath + '/{idAcao}/passos/{idPasso}/cliente/usuario/{idUsuario}' },
  iniciaFluxo: { method: 'POST', url: basePath + '/{idAcao}' },
  aprovador: { method: 'GET', url: basePath + '/{idAcao}/passos/aprovador' },
  aprovarPasso: { method: 'PUT', url: basePath + '/{idAcao}/passos/aprovar' },
  reprovar: { method: 'PUT', url: basePath + '/{idAcao}/passos/reprovar' },
  enviarAnalise: { method: 'PUT', url: basePath + '/{idAcao}/passos/analise' },
  status: { method: 'GET', url: basePath + '/{idAcao}/status' },
  statusPasso: { method: 'GET', url: basePath + '/{idAcao}/passos/status' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, workflowAcaoActions);
};

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('workflow_estrutural', 'execucao/acordo');

var workflowAcordoActions = {
  gravar: { method: 'POST', url: basePath + '/{idAcordo}' },
  cancelar: { method: 'PUT', url: basePath + '/{idAcordo}/cancelar' },
  aprovar: { method: 'PUT', url: basePath + '/{idAcordo}/passos/aprovar' },
  reprovar: { method: 'PUT', url: basePath + '/{idAcordo}/passos/reprovar' },
  enviarAnalise: { method: 'PUT', url: basePath + '/{idAcordo}/passos/analise' },
  status: { method: 'GET', url: basePath + '/{idAcordo}/status' },
  aprovador: { method: 'GET', url: basePath + '/{idAcordo}/passos/aprovador' },
  buscaPassosClientes: { method: 'GET', url: basePath + '/{idAcordo}/passos/cliente' },
  statusPasso: { method: 'GET', url: basePath + '/{idAcordo}/passos/status' },
  solicitante: { method: 'GET', url: basePath + '/solicitante' },
  associaUsuarioClienteAprovador: { method: 'POST', url: basePath + '/{idAcordo}/passos/{idPasso}/cliente/usuario/{idUsuario}' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, workflowAcordoActions);
};

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('workflow_estrutural', 'execucao/apuracao');

var workflowApuracaoActions = {
  aprovador: { method: 'GET', url: basePath + '/{idApuracao}/passos/aprovador' },
  aprovar: { method: 'PUT', url: basePath + '/{idApuracao}/passos/aprovar' },
  cancelar: { method: 'PUT', url: basePath + '/{idApuracao}/cancelar' },
  gravar: { method: 'POST', url: basePath + '/{idApuracao}' },
  pendentes: { method: 'GET', url: basePath + '/busca-fluxo-pendente' },
  reprovar: { method: 'PUT', url: basePath + '/{idApuracao}/passos/reprovar' },
  status: { method: 'GET', url: basePath + '/{idApuracao}/status' },
  statusPasso: { method: 'GET', url: basePath + '/{idApuracao}/passos/status' },
  minhasAprovacoes: { method: 'GET', url: basePath + '/fluxos/aprovador' },
  iniciaFluxo: { method: 'POST', url: basePath + '/{idApuracao}' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, workflowApuracaoActions);
};

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('workflow_estrutural', 'execucao/apuracao/reivindicacao');

var workflowApuracaoReivindicacaoActions = {
  aprovador: { method: 'GET', url: basePath + '/{idReivindicacao}/passos/aprovador' },
  aprovar: { method: 'PUT', url: basePath + '/{idReivindicacao}/passos/aprovar' },
  cancelar: { method: 'PUT', url: basePath + '/{idReivindicacao}/cancelar' },
  gravar: { method: 'POST', url: basePath + '/{idReivindicacao}' },
  pendentes: { method: 'GET', url: basePath + '/busca-fluxo-pendente' },
  reprovar: { method: 'PUT', url: basePath + '/{idReivindicacao}/passos/reprovar' },
  status: { method: 'GET', url: basePath + '/{idReivindicacao}/status' },
  statusPasso: { method: 'GET', url: basePath + '?idReivindicacao={idReivindicacao}/passos/status' },
  minhasAprovacoes: { method: 'GET', url: basePath + '/fluxos/aprovador' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, workflowApuracaoReivindicacaoActions);
};

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('workflow_estrutural', 'execucao/ajuste_verba');

var workflowAjusteVerbaActions = {
  aprovador: { method: 'GET', url: basePath + '/{idAjuste}/passos/aprovador' },
  aprovar: { method: 'PUT', url: basePath + '/{idAjuste}/passos/aprovar' },
  cancelar: { method: 'PUT', url: basePath + '/{idAjuste}/cancelar' },
  gravar: { method: 'POST', url: basePath + '/{idAjuste}' },
  pendentes: { method: 'GET', url: basePath + '/busca-fluxo-pendente' },
  reprovar: { method: 'PUT', url: basePath + '/{idAjuste}/passos/reprovar' },
  status: { method: 'GET', url: basePath + '/{idAjuste}/status' },
  statusPasso: { method: 'GET', url: basePath + '/{idAjuste}/passos/status' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, workflowAjusteVerbaActions);
};

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('workflow_estrutural', 'execucao/orcamento');

var workflowOrcamento = {
  aprovador: { method: 'GET', url: basePath + '/{idOrcamento}/passos/aprovador' },
  aprovar: { method: 'PUT', url: basePath + '/{idOrcamento}/passos/aprovar' },
  cancelar: { method: 'PUT', url: basePath + '/{idOrcamento}/cancelar' },
  gravar: { method: 'POST', url: basePath + '/{idOrcamento}' },
  pendentes: { method: 'GET', url: basePath + '/busca-fluxo-pendente' },
  reprovar: { method: 'PUT', url: basePath + '/{idOrcamento}/passos/reprovar' },
  status: { method: 'GET', url: basePath + '/{idOrcamento}/status' },
  statusPasso: { method: 'GET', url: basePath + '/{idOrcamento}/passos/status' },
  minhasAprovacoes: { method: 'GET', url: basePath + '/fluxos/aprovador' },
  solicitante: { method: 'GET', url: basePath + '/solicitante' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, workflowOrcamento);
};

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('workflow_estrutural', 'execucao');

var workflowAcordoCrescimentoActions = {
  aprovarAcordo: { method: 'POST', url: basePath + '/acordo{/id}' },
  aprovarContrato: { method: 'POST', url: basePath + '/contrato{/id}/acordos' },
  acordo: { method: 'GET', url: basePath + '/acordo{/id}/passos/status' },
  cancelarAcordo: { method: 'PUT', url: basePath + '/acordo{/id}/cancelar' },
  aprovarPassosAcordo: { method: 'PUT', url: basePath + '/acordo{/idAcordo}/passos/aprovar' },
  reprovarAcordo: { method: 'PUT', url: basePath + '/acordo{/idAcordo}/passos/reprovar' },
  enviarAcordoAnalise: { method: 'PUT', url: basePath + '/acordo{/idAcordo}/passos/analise' },
  contrato: { method: 'GET', url: basePath + '/contrato{/id}/passos/status' },
  orcamento: { method: 'GET', url: basePath + '/orcamento{/id}/passos/status' },
  pagamento: { method: 'GET', url: basePath + '/pagamento{/id}/passos/status' },
  statusPassosApuracao: { method: 'GET', url: basePath + '/apuracao{/id}/passos/status' },
  aprovarPassosPagamento: { method: 'PUT', url: basePath + '/pagamento{/id}/passos/aprovar' },
  reprovarPassosPagamento: { method: 'PUT', url: basePath + '/pagamento{/id}/passos/reprovar' },
  aprovarPassosApuracao: { method: 'PUT', url: basePath + '/apuracao{/idApuracao}/passos/aprovar' },
  enviarApuracaoAnalise: { method: 'PUT', url: basePath + '/apuracao{/idApuracao}/passos/analise' },
  reprovarPassosApuracao: { method: 'PUT', url: basePath + '/apuracao{/idApuracao}/passos/reprovar' },
  solicitantesPasso: { method: 'GET', url: basePath + '/{idTipo}/solicitante/{passo}' },
  aprovadoresPasso: { method: 'GET', url: basePath + '/{idTipo}/aprovador/{passo}' },
  aprovadoresPassosClientes: { method: 'GET', url: basePath + '/passo/{idPassoExecucao}/aprovador/cliente' },
  buscarPassos: { method: 'GET', url: basePath + '/{idTipo}/passos' },
  transferirPasso: { method: 'POST', url: basePath + '/fluxo/{idFluxo}/passo/{idPasso}/transferencia' },
  transferirPassoCliente: { method: 'POST', url: basePath + '/passo/{idPasso}/acordo/{idAcordo}/usuario-cliente/{idUsuarioCliente}/transferencia' },
  transferirPassos: { method: 'POST', url: basePath + '/tipo/{idTipo}/passos/transferencia' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, workflowAcordoCrescimentoActions);
};

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('workflow_tatico', 'execucao/planejamento-tatico');

var workflowPlanejamento = {
  statusPasso: { method: 'GET', url: basePath + '/{idPlanejamento}/passos/status' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, workflowPlanejamento);
};

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('workflow_estrutural', 'execucao/transferencia');

var workflowTransferenciaActions = {
  aprovador: { method: 'GET', url: basePath + '/{id}/passos/aprovador' },
  aprovar: { method: 'PUT', url: basePath + '/{id}/passos/aprovar' },
  cancelar: { method: 'PUT', url: basePath + '/{idAjuste}/cancelar' },
  gravar: { method: 'POST', url: basePath + '/{id}' },
  pendentes: { method: 'GET', url: basePath + '/busca-fluxo-pendente' },
  reprovar: { method: 'PUT', url: basePath + '/{id}/passos/reprovar' },
  status: { method: 'GET', url: basePath + '/{id}/status' },
  statusPasso: { method: 'GET', url: basePath + '/{idTransferencia}/passos/status' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, workflowTransferenciaActions);
};

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'workspace-filtros/{entidade}');

var workspaceFiltrosActions = {
  pesquisar: { method: 'GET', url: '' + basePath },
  pesquisarPorIdEntidade: { method: 'GET', url: basePath + '?idEntidade={idEntidade}' },
  inserir: { method: 'POST', url: '' + basePath },
  atualizar: { method: 'PUT', url: '' + basePath }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, workspaceFiltrosActions);
};

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('relatorio', 'pendencias');

var relatorioActions = {
  acaoAgAnalise: { method: 'GET', url: basePath + '/acao-ag-analise' },
  acaoAgAprovacao: { method: 'GET', url: basePath + '/acao-ag-aprovacao' },
  orcamentoAgAprovacao: { method: 'GET', url: basePath + '/orcamento-ag-aprovacao' },
  pagamentoAgAprovacao: { method: 'GET', url: basePath + '/pagamento-ag-aprovacao' },
  acaoAgOrcamento: { method: 'GET', url: basePath + '/acao-ag-orcamento' },
  orcamentoAgAnalise: { method: 'GET', url: basePath + '/orcamento-ag-analise' },
  pagamentoAgAnalise: { method: 'GET', url: basePath + '/pagamento-ag-analise' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, relatorioActions);
};

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('relatorio', 'historico');

var relatorioActions = {
  salvaHistoricoProvisao: { method: 'POST', url: basePath + '/salvar-historico-provisao' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, relatorioActions);
};

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('relatorio', 'exportacao_arquivo');

var relatorioActions = {
  verificaExistemRegistros: { method: 'POST', url: basePath + '/planilha/organograma/validar' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, relatorioActions);
};

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('apuracao', 'acordo');
var basePlanejamentoPath = (0, _apiResource2.default)('planejamento', 'orcamento');

var relatorioAcordo = {
  pesquisar: { method: 'POST', url: '' + basePath },
  pesquisarFiltroOrcamento: { method: 'GET', url: basePlanejamentoPath + '/filtro-acordo' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, relatorioAcordo);
};

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _vue = __webpack_require__(44);

var _vue2 = _interopRequireDefault(_vue);

var _vuetify = __webpack_require__(895);

var _vuetify2 = _interopRequireDefault(_vuetify);

var _pt = __webpack_require__(896);

var _pt2 = _interopRequireDefault(_pt);

__webpack_require__(897);

var _theme = __webpack_require__(246);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuetify2.default);

exports.default = new _vuetify2.default({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: (0, _extends3.default)({}, _theme.themeVuetify)
    }
  },
  lang: {
    locales: { pt: _pt2.default },
    current: 'pt'
  },
  icons: {
    iconfont: 'md'
  }
});

/***/ }),
/* 895 */,
/* 896 */,
/* 897 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _numberic = __webpack_require__(899);

var _numberic2 = _interopRequireDefault(_numberic);

var _masks = __webpack_require__(900);

var _documentMasks = __webpack_require__(908);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (Vue) {
  Vue.directive('cnpj', _masks.vCNPJ);
  Vue.directive('cpf', _masks.vCPF);
  Vue.directive('cpfcnpj', _documentMasks.vCpfCnpj);
  Vue.directive('cep', _masks.vCEP);
  Vue.directive('datefull', _masks.vDateFull);
  Vue.directive('dateinternational', _masks.vDateInternational);
  Vue.directive('hour', _masks.vHour);
  Vue.directive('mesAno', _masks.vMesAno);
  Vue.directive('money', _masks.vMoney);
  Vue.directive('numeric', _numberic2.default);
  Vue.directive('phone', _masks.vPhone);
  Vue.directive('integer', _masks.vInteger);
};

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _trigger = __webpack_require__(100);

var _trigger2 = _interopRequireDefault(_trigger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  update: function update(el) {
    var compare = el.value.replace(/[^0-9.,]/gi, '');

    if (el.value !== compare) {
      el.value = compare;
      (0, _trigger2.default)(el, 'input');
    }
  }
};

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.vInteger = exports.vMoney = exports.vCEP = exports.vCPF = exports.vCNPJ = exports.vPhone = exports.vDate = exports.vDateInternational = exports.vDateFull = exports.vMesAno = exports.vHour = exports.vHourFull = undefined;

var _weakMap = __webpack_require__(247);

var _weakMap2 = _interopRequireDefault(_weakMap);

var _vanillaMasker = __webpack_require__(53);

var _vanillaMasker2 = _interopRequireDefault(_vanillaMasker);

var _trigger = __webpack_require__(100);

var _trigger2 = _interopRequireDefault(_trigger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var updateValue = function updateValue(el, compare, mask) {
  if (el.value !== compare) {
    el.value = _vanillaMasker2.default.toPattern(compare, mask);
    (0, _trigger2.default)(el, 'input');
  }
};

var vHourFullMask = '99:99:99';
var vHourFull = exports.vHourFull = {
  bind: function bind(el) {
    (0, _vanillaMasker2.default)(el).maskPattern(vHourFullMask);
  },
  update: function update(el) {
    var compare = el.value.substring(0, vHourFullMask.length).replace(/[^0-9:]/gi, '');

    updateValue(el, compare, vHourFullMask);
  }
};

var vHourMask = '99:99';
var vHour = exports.vHour = {
  bind: function bind(el) {
    (0, _vanillaMasker2.default)(el).maskPattern(vHourMask);
  },
  update: function update(el) {
    var compare = el.value.substring(0, vHourMask.length).replace(/[^0-9:]/gi, '');

    updateValue(el, compare, vHourMask);
  }
};

var vMesAnoMask = '99-9999';
var vMesAno = exports.vMesAno = {
  bind: function bind(el) {
    (0, _vanillaMasker2.default)(el).maskPattern(vMesAnoMask);
  },
  update: function update(el) {
    if (el.value) {
      var compare = el.value.substring(0, vMesAnoMask.length).replace(/[^0-9-]/gi, '');
      updateValue(el, compare, vMesAnoMask);
    }
  }
};

var vDateFullMask = '99-99-9999';
var vDateFull = exports.vDateFull = {
  bind: function bind(el) {
    (0, _vanillaMasker2.default)(el).maskPattern(vDateFullMask);
  },
  update: function update(el) {
    var compare = el.value.substring(0, vDateFullMask.length).replace(/[^0-9-]/gi, '');

    updateValue(el, compare, vDateFullMask);
  }
};

var vDateInternationalMask = '9999-99-99';
var vDateInternational = exports.vDateInternational = {
  bind: function bind(el) {
    (0, _vanillaMasker2.default)(el).maskPattern(vDateInternationalMask);
  },
  update: function update(el) {
    var compare = el.value.substring(0, vDateInternationalMask.length).replace(/[^0-9-]/gi, '');

    updateValue(el, compare, vDateInternationalMask);
  }
};

var vDateMask = '99/99/99';
var vDate = exports.vDate = {
  bind: function bind(el) {
    (0, _vanillaMasker2.default)(el).maskPattern(vDateMask);
  },
  update: function update(el) {
    var compare = el.value.substring(0, vDateMask.length).replace(/[^0-9/]/gi, '');

    updateValue(el, compare, vDateMask);
  }
};

var vPhoneMask = '(99) 99999-9999';
var vPhone = exports.vPhone = {
  bind: function bind(el, binding) {
    var pattern = binding.value ? binding.value.mask : vPhoneMask;
    (0, _vanillaMasker2.default)(el).maskPattern(pattern);
  },
  update: function update(el) {
    var compare = el.value.substring(0, vPhoneMask.length).replace(/[^0-9-()\s]/gi, '');
    if (el.value.length === 1) {
      updateValue(el, '', vPhoneMask);
    }
    updateValue(el, compare, vPhoneMask);
  }
};

var CNPJ_MASK_LEN = 14;
var vCnpjHandlersMap = new _weakMap2.default();

var getInputNode = function getInputNode(el) {
  if (el.tagName === 'INPUT') return el;
  return el.querySelector('input');
};

var formatCnpjAlfanumerico = function formatCnpjAlfanumerico(raw) {
  var head = raw.substring(0, 12);
  var tail = raw.substring(12, CNPJ_MASK_LEN).replace(/[^0-9]/g, '');
  var cleaned = head + tail;

  return cleaned.replace(/^([A-Z0-9]{2})([A-Z0-9]{1,3})/, '$1.$2').replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})([A-Z0-9]{1,3})/, '$1.$2.$3').replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})\.([A-Z0-9]{3})([A-Z0-9]{1,4})/, '$1.$2.$3/$4').replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})\.([A-Z0-9]{3})\/([A-Z0-9]{4})(\d{1,2})/, '$1.$2.$3/$4-$5');
};

var aplicarMascaraCnpj = function aplicarMascaraCnpj(rawInput) {
  var raw = (rawInput || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  return formatCnpjAlfanumerico(raw);
};

var aplicarMascaraCnpjNoInput = function aplicarMascaraCnpjNoInput(input) {
  var masked = aplicarMascaraCnpj(input.value);
  if (input.value !== masked) {
    input.value = masked;
    (0, _trigger2.default)(input, 'input');
  }
};

var vCNPJ = exports.vCNPJ = {
  bind: function bind(el) {
    var input = getInputNode(el);
    if (!input) return;

    var handler = function handler() {
      return aplicarMascaraCnpjNoInput(input);
    };
    vCnpjHandlersMap.set(el, { input: input, handler: handler });
    input.addEventListener('input', handler);

    if (input.value) {
      aplicarMascaraCnpjNoInput(input);
    }
  },
  update: function update(el) {
    var input = getInputNode(el);
    if (!input) return;
    aplicarMascaraCnpjNoInput(input);
  },
  unbind: function unbind(el) {
    var stored = vCnpjHandlersMap.get(el);
    if (stored && stored.input && stored.handler) {
      stored.input.removeEventListener('input', stored.handler);
      vCnpjHandlersMap.delete(el);
    }
  }
};

var vCPFMask = '999.999.999-99';
var vCPF = exports.vCPF = {
  bind: function bind(el) {
    (0, _vanillaMasker2.default)(el).maskPattern(vCPFMask);
  },
  update: function update(el) {
    var compare = el.value.substring(0, vCPFMask.length).replace(/[^0-9.,-/]/gi, '');

    updateValue(el, compare, vCPFMask);
  }
};

var vCEPMask = '99999-999';
var vCEP = exports.vCEP = {
  bind: function bind(el) {
    (0, _vanillaMasker2.default)(el).maskPattern(vCEPMask);
  },
  update: function update(el) {
    var compare = el.value.substring(0, vCEPMask.length).replace(/[^0-9.,-/]/gi, '');

    updateValue(el, compare, vCEPMask);
  }
};

var vMoney = exports.vMoney = {
  bind: function bind(el, binding) {
    var params = binding.value || {};

    (0, _vanillaMasker2.default)(el).maskMoney({
      precision: params.precision || 2,

      separator: params.separator || ',',

      delimiter: params.delimiter || '.',

      unit: params.unit || 'R$',

      suffixUnit: params.suffixUnit || '',

      zeroCents: !!params.zeroCents
    });
  },
  update: function update(el) {
    var cleanInput = el.value.replace(/[^0-9]/gi, '');
    var tempDollars = cleanInput.substring(0, cleanInput.length - 2);
    var tempCents = cleanInput.substring(cleanInput.length - 2, cleanInput.length);
    var dollars = tempDollars || '0';
    var cents = tempCents || '00';
    var compare = dollars + '.' + cents;

    if (el.value !== compare) {
      el.value = 'R$ ' + _vanillaMasker2.default.toMoney(compare);
      window.setTimeout(function () {
        (0, _trigger2.default)(el, 'input');
      }, 100);
    }
  }
};

var vInteger = exports.vInteger = {
  bind: function bind(el) {
    (0, _vanillaMasker2.default)(el).maskNumber();
  },
  update: function update(el) {
    var cleanInput = el.value.replace(/[^0-9]/gi, '');
    var defaultValue = '0';
    if (!cleanInput) {
      el.value = +_vanillaMasker2.default.toNumber(defaultValue);
      window.setTimeout(function () {
        (0, _trigger2.default)(el, 'input');
      }, 100);
    } else {
      el.value = +cleanInput;
    }
  }
};

/***/ }),
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.vCpfCnpj = undefined;

var _weakMap = __webpack_require__(247);

var _weakMap2 = _interopRequireDefault(_weakMap);

var _trigger = __webpack_require__(100);

var _trigger2 = _interopRequireDefault(_trigger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CPF_MASK_LEN = 11;
var CNPJ_MASK_LEN = 14;

var getChildrenNode = function getChildrenNode(el) {
  if (el.tagName === 'INPUT') return el;
  return el.querySelector('input');
};

var handlersMap = new _weakMap2.default();

var isCpf = function isCpf(raw, tipoPessoa) {
  if (tipoPessoa === 'FISICA') return true;
  if (tipoPessoa === 'JURIDICA') return false;
  if (/[A-Z]/.test(raw)) return false;
  return raw.length <= CPF_MASK_LEN;
};

var formatCpf = function formatCpf(raw) {
  return raw.substring(0, CPF_MASK_LEN).replace(/^(\d{3})(\d{1,3})/, '$1.$2').replace(/^(\d{3})\.(\d{3})(\d{1,3})/, '$1.$2.$3').replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d{1,2})/, '$1.$2.$3-$4');
};

var formatCnpj = function formatCnpj(raw) {
  var head = raw.substring(0, 12);
  var tail = raw.substring(12, CNPJ_MASK_LEN).replace(/[^0-9]/g, '');
  var cleaned = head + tail;

  return cleaned.replace(/^([A-Z0-9]{2})([A-Z0-9]{1,3})/, '$1.$2').replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})([A-Z0-9]{1,3})/, '$1.$2.$3').replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})\.([A-Z0-9]{3})([A-Z0-9]{1,4})/, '$1.$2.$3/$4').replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})\.([A-Z0-9]{3})\/([A-Z0-9]{4})(\d{1,2})/, '$1.$2.$3/$4-$5');
};

var aplicarMascaraAdaptativa = function aplicarMascaraAdaptativa(rawInput, tipoPessoa) {
  var raw = (rawInput || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  return isCpf(raw, tipoPessoa) ? formatCpf(raw) : formatCnpj(raw);
};

var aplicarMascara = function aplicarMascara(el, input) {
  var tipoPessoa = el && el.dataset && el.dataset.tipoPessoa || input && input.dataset && input.dataset.tipoPessoa || null;
  var masked = aplicarMascaraAdaptativa(input.value, tipoPessoa);
  if (input.value !== masked) {
    input.value = masked;
    (0, _trigger2.default)(input, 'input');
  }
};

var vCpfCnpj = exports.vCpfCnpj = {
  bind: function bind(el) {
    var input = getChildrenNode(el);
    if (!input) return;

    var handler = function handler() {
      return aplicarMascara(el, input);
    };
    handlersMap.set(el, handler);
    input.addEventListener('input', handler);

    if (input.value) {
      aplicarMascara(el, input);
    }
  },
  update: function update(el) {
    var input = getChildrenNode(el);
    if (!input) return;
    aplicarMascara(el, input);
  },
  unbind: function unbind(el) {
    var input = getChildrenNode(el);
    var handler = handlersMap.get(el);
    if (input && handler) {
      input.removeEventListener('input', handler);
      handlersMap.delete(el);
    }
  }
};

exports.default = vCpfCnpj;

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _social = __webpack_require__(910);

var _decimal = __webpack_require__(911);

var _decimal2 = _interopRequireDefault(_decimal);

var _moneyRequired = __webpack_require__(912);

var _moneyRequired2 = _interopRequireDefault(_moneyRequired);

var _moneyMax = __webpack_require__(913);

var _moneyMax2 = _interopRequireDefault(_moneyMax);

var _time = __webpack_require__(914);

var _time2 = _interopRequireDefault(_time);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var messages = {
  moneyrequired: function moneyrequired() {
    return 'Este campo é obrigatório';
  },
  moneymax: function moneymax() {
    return 'Excedeu o valor disponível.';
  },
  required: function required() {
    return 'Este campo é obrigatório';
  },
  email: function email() {
    return 'Este email é inválido';
  },
  digits: function digits(value, args) {
    return 'Campo num\xE9rico com ' + args + ' d\xEDgitos obrigat\xF3rios';
  },
  decimalcomma: function decimalcomma(value, args) {
    return 'M\xE1ximo de ' + args + ' casas decimais';
  },
  min_value: function min_value(value, args) {
    return 'O valor m\xEDnimo \xE9 ' + args;
  },
  max_value: function max_value(value, args) {
    return 'O valor m\xE1ximo \xE9 ' + Number(args).toLocaleString();
  },
  max: function max(value, args) {
    return 'M\xE1ximo de ' + args + ' d\xEDgitos';
  },
  numeric: function numeric() {
    return 'Este campo aceita apenas números';
  },
  date_format: function date_format() {
    return 'Data inválido';
  }
};

var dictionary = {
  en: {
    messages: messages
  },
  pt: {
    messages: messages
  },
  ptbr: {
    messages: messages
  }
};

exports.default = function (Validator) {
  Validator.extend('cnpj', _social.cnpjNumber);
  Validator.extend('cpf', _social.cpfNumber);
  Validator.extend('cpfcnpj', _social.cpfCnpjNumber);
  Validator.extend('decimalcomma', _decimal2.default);
  Validator.extend('dateformat', _time2.default);
  Validator.extend('moneyrequired', _moneyRequired2.default);
  Validator.extend('moneymax', _moneyMax2.default);
  Validator.updateDictionary(dictionary);
};

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var removePunctuation = function removePunctuation(str) {
  str = str.replace('.', '');
  str = str.replace('.', '');
  str = str.replace('.', '');
  str = str.replace('-', '');
  str = str.replace('/', '');
  return str;
};

var normalizarDocumento = function normalizarDocumento(str) {
  return removePunctuation(str).toUpperCase();
};

var validarCnpjAlfanumerico = function validarCnpjAlfanumerico(str) {
  return (/^[A-Z0-9]{12}\d{2}$/.test(str) && str !== '00000000000000'
  );
};

var validarCpf = function validarCpf(str) {
  var Soma = void 0;
  var Resto = void 0;
  Soma = 0;
  if (str == "00000000000") return false;

  for (var i = 1; i <= 9; i++) {
    Soma = Soma + parseInt(str.substring(i - 1, i)) * (11 - i);
  }Resto = Soma * 10 % 11;

  if (Resto == 10 || Resto == 11) Resto = 0;
  if (Resto != parseInt(str.substring(9, 10))) return false;

  Soma = 0;
  for (var _i = 1; _i <= 10; _i++) {
    Soma = Soma + parseInt(str.substring(_i - 1, _i)) * (12 - _i);
  }Resto = Soma * 10 % 11;

  if (Resto == 10 || Resto == 11) Resto = 0;
  if (Resto != parseInt(str.substring(10, 11))) return false;
  return true;
};

var validarCnpj = function validarCnpj(str) {
  var cnpj = str;
  var numeros, digitos, soma, i, resultado, pos, tamanho, digitos_iguais;
  digitos_iguais = 1;
  if (cnpj.length < 14 && cnpj.length < 15) return false;
  for (i = 0; i < cnpj.length - 1; i++) {
    if (cnpj.charAt(i) != cnpj.charAt(i + 1)) {
      digitos_iguais = 0;
      break;
    }
  }if (!digitos_iguais) {
    tamanho = cnpj.length - 2;
    numeros = cnpj.substring(0, tamanho);
    digitos = cnpj.substring(tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(0)) return false;
    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(1)) return false;
    return true;
  } else return false;
};

var cnpjNumber = exports.cnpjNumber = {
  getMessage: function getMessage() {
    return 'CNPJ inválido';
  },
  validate: function validate(str) {
    str = normalizarDocumento(str);
    if (str.length !== 14) {
      return false;
    }
    if (/^\d{14}$/.test(str)) {
      return validarCnpj(str);
    }
    return validarCnpjAlfanumerico(str);
  }
};

var cpfNumber = exports.cpfNumber = {
  getMessage: function getMessage() {
    return 'CPF inválido';
  },
  validate: function validate(str) {
    str = removePunctuation(str);
    return validarCpf(str);
  }
};
var cpfCnpjNumber = exports.cpfCnpjNumber = {
  getMessage: function getMessage() {
    return 'Documento inválido';
  },
  validate: function validate(str) {
    var third = str.length >= 4 ? str.slice(3, 4) : ".";
    str = normalizarDocumento(str);
    if (str.length <= 11 && third === ".") {
      return validarCpf(str);
    }
    if (/^\d{14}$/.test(str)) {
      return validarCnpj(str);
    }
    return validarCnpjAlfanumerico(str);
  }
};

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (value, params) {
  var decimals = Array.isArray(params) ? params[0] || '*' : '*';
  if (Array.isArray(value)) {
    return false;
  }

  if (value === null || value === undefined || value === '') {
    return true;
  }

  if (Number(decimals) === 0) {
    return (/^-?\d*$/.test(value)
    );
  }

  var regexPart = decimals === '*' ? '+' : '{0,' + decimals + '}';
  var regex = new RegExp('^-?\\d*(\\,\\d' + regexPart + ')?$');

  if (!regex.test(value)) {
    return false;
  }

  var parsedValue = parseFloat(value);

  return parsedValue === parsedValue;
};

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _helpers = __webpack_require__(5);

exports.default = function (value) {
  var decimals = (0, _helpers.convertMoneytoFloat)(value);
  return decimals !== 0;
};

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _helpers = __webpack_require__(5);

exports.default = function (value, args) {
  var decimals = (0, _helpers.convertMoneytoFloat)(value);
  return decimals <= parseFloat(args[0]);
};

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validateDate = function validateDate(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD/MM/YYYY';
  return (0, _moment2.default)(date, format, true).isValid();
};

exports.default = {
  getMessage: function getMessage() {
    return 'Data inválida';
  },
  validate: function validate(val) {
    return validateDate(val, 'DD-MM-YYYY');
  }
};

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _message = __webpack_require__(916);

var _message2 = _interopRequireDefault(_message);

var _loading = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var warnPropRewrite = function warnPropRewrite(msg) {
  if (process && Object({"NODE_ENV":"production"}) && "production" && "production" === 'development') {}
};

exports.default = function (Vue) {
  Vue.http.interceptors.push(function (request, next) {
    (0, _loading.showLoading)();
    next(function (response) {
      (0, _loading.hideLoading)();
      return response;
    });
  });
  Vue.http.interceptors.push(function (request, next) {
    var controlador = window.sessionStorage.getItem('controladorTrade');

    if (controlador) {
      controlador = JSON.parse(controlador);
      if (controlador.idFuncionarioTitular) {
        request.headers.append('idFuncionario', controlador.idFuncionarioTitular.toString());
      }
      if (controlador.idDivisaoTitular) {
        request.headers.append('idDivisao', controlador.idDivisaoTitular.toString());
      }
    }
    next();
  });
  Vue.http.interceptors.push(function (request, next) {
    next(function (response) {
      if (response.status >= 400) {
        response.data = {
          error: (0, _message2.default)(response.data, Vue.config.lang)
        };
        warnPropRewrite('Alterando a resposta quando existe erro. Mensagem vai sumir em producao');
      }
      return response;
    });
  });
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(121)))

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(55);

var _typeof3 = _interopRequireDefault(_typeof2);

var _toConsumableArray2 = __webpack_require__(9);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _helpers = __webpack_require__(5);

var _i18n = __webpack_require__(253);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var errors = function errors(lang) {
  return _i18n2.default.messages[lang].errors;
};

var extractMessage = function extractMessage(error, lang) {
  var splitParams = error.split('|');
  var msg = (0, _helpers.accessObjectViaString)(errors(lang), splitParams[0]);

  if (splitParams.length > 1) {
    var param = splitParams[1].replace(/(\w+):/g, '').split('&&');
    return msg.apply(undefined, (0, _toConsumableArray3.default)(param));
  }

  return msg;
};

var extractMessages = function extractMessages(error, lang) {
  var splitParams = error.split('||');
  var errorsArray = [];
  splitParams.forEach(function (el) {
    return errorsArray.push(extractMessage(el, lang));
  });
  return errorsArray;
};

var extractErrorMessage = function extractErrorMessage(error, lang) {
  if (error.indexOf('||') > -1) {
    return extractMessages(error, lang);
  }
  return extractMessage(error, lang);
};

exports.default = function (params) {
  var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'pt-br';

  if (!params) {
    return 'Erro inesperado. Tente novamente.';
  }

  var err = params.erros || params.error;

  if (!err) {
    return 'Erro inesperado. Tente novamente.';
  }

  if ((typeof err === 'undefined' ? 'undefined' : (0, _typeof3.default)(err)) === 'object' && err.hasOwnProperty('length')) {
    return err.map(function (el) {
      return extractErrorMessage(el, lang);
    }).join('<br>');
  }

  return extractErrorMessage(err, lang);
};

/***/ }),
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  title: {
    acao_planejamento: 'Ação em Cadastro de Ações',
    acao_ag_analise_planejamento: 'Ação Aguardando Análise no Cadastro de Ações',
    acao_ag_aprovacao_planejamento: 'Ação Aguardando Aprovação no Cadastro de Ações',
    acao_ag_orcamento: 'Ação Aguardando Orçamento',
    acao_orcamento_ag_analise: 'Ação com Orçamento Aguardando Análise',
    acesso_cliente: 'Acesso cliente',
    acesso_divisao: 'Acesso divisão',
    acesso_estrutura_usuario: 'Acesso estrutura de usuário',
    acao: 'Ação | Ações',
    acompanhamento: 'Acompanhamento',
    acordo: 'Acordo | Acordos',
    acordo_crescimento: 'Acordo de crescimento | Acordos de crescimento',
    acordo_fixo: 'Acordo fixo',
    acordo_metas: 'Acordos e metas',
    acordo_negociacao_preco: 'Acordo Negociação de Preço',
    acordo_positivacao: 'Acordo Positivação',
    acordo_tabloide: 'Acordo tablóide',
    ajustar_acordo: 'Ajustar acordo',
    ajustar_contrato: 'Ajustar contrato',
    ajuste_verba: 'Ajuste de verba',
    ano_fiscal: 'Ano fiscal',
    analisar_acordo: 'Analisar acordo',
    analisar_contrato: 'Analisar contrato',
    analise_investimento: 'Análise de Investimento',
    analitico_acoes: 'Analítico de ações',
    ano: 'Ano',
    aporte: 'Aporte | Aportes',
    aporte_verba: 'Aporte de verbas',
    aporte_verba_cliente: 'Aporte de verbas cliente',
    aporte_verba_divisao: 'Aporte de verbas divisão',
    aprovacoes_contratos: 'Aprovações de contratos',
    apuracao: 'Apuração',
    apuracao_pendente: 'Pend. Apuração',
    apuracao_rejeitada: 'Apuração Rejeitada',
    apuracoes: 'Apurações',
    apurado: 'Apurado',
    aviso: 'Aviso',
    apuracoes_finalizadas: 'Apurações Finalizadas',
    apuracoes_pendentes: 'Apurações Pendentes',
    apuracoes_lote: 'Apurações em lote',
    atencao: 'Atenção',
    atualizacao_entrega: 'Atualização de entrega',
    base_calculo: 'Base de cálculo',
    cadastrar: 'Cadastrar',
    cadastrar_contato: 'Cadastrar contato',
    cadastrar_ano_fiscal: 'Cadastrar período',
    cadastrar_nova_area_atuacao: 'Cadastrar área de atuação',
    cadastrar_nova_alcada: 'Cadastrar nova alçada',
    cadastrar_nova_divisao: 'Cadastrar nova divisão',
    cadastrar_novo_canal: 'Cadastrar novo canal',
    cadastrar_novo_cliente: 'Cadastrar novo cliente',
    cadastrar_novo_concorrente: 'Cadastrar novo concorrente',
    cadastrar_novo_centro_custo: 'Cadastrar novo centro custo',
    cadastrar_novo_contato: 'Cadastrar novo contato',
    cadastrar_nova_estrutura_usuario: 'Cadastrar nova estrutura de usuário',
    cadastrar_nova_extensao: 'Cadastrar nova Extensao',
    cadastrar_nova_filial: 'Cadastrar nova Filial',
    cadastrar_novo_funcionario: 'Cadastrar funcionário',
    cadastrar_novo_grupo_produto: 'Cadastrar grupo de produto',
    cadastrar_nova_loja: 'Cadastrar nova loja',
    cadastrar_nova_marca: 'Cadastrar nova marca',
    cadastrar_novo_material: 'Cadastar novo material',
    cadastrar_novo_orcamento: 'Cadastrar novo orçamento',
    cadastrar_nova_peca: 'Cadastrar nova peça',
    cadastrar_novo_planejamento: 'Cadastrar novo planejamento',
    cadastrar_novo_produto: 'Cadastrar novo produto',
    cadastrar_nova_regiao: 'Cadastrar nova região',
    cadastrar_novo_reporte: 'Cadastrar novo reporte',
    cadastrar_novo_segmento: 'Cadastrar novo segmento',
    cadastrar_novo_tipo_acao: 'Cadastrar novo tipo de ação',
    cadastrar_novo_tipo_investimento: 'Cadastrar novo tipo de investimento',
    cadastrar_novo_tipo_orcamento: 'Cadastrar novo tipo de orçamento',
    cadastrar_nova_unidade_medida: 'Cadastrar nova unidade de medida',
    cadastrar_nova_unidade_negocio: 'Cadastrar nova unidade de negócio',
    cadastrar_meta: 'Cadastrar meta',
    cadastrar_intervalo_meta: 'Cadastrar intervalo da meta',
    cadastrar_negociacao: 'Cadastrar negociação',
    cadastrar_usuario: 'Cadastrar usuário',
    cadastro_peca: 'Cadastro de Peças',
    calculo_apuracao: 'Cálculo da apuração',
    calculo_bonificacao: 'Cálculo da bonificação',
    calendario: 'Calendário',
    calendario_aprovacoes: 'Calendário de aprovações',
    campos_customizados: 'Campo customizado | Campos customizados',
    campo_geral: 'Campo geral | Campos gerais',
    campo_geral_planejamento_acao: 'Campo geral | Campos gerais',
    campo_padrao: 'Campo padrão | Campos padrões',
    cancelar_acordo: 'Cancelar acordo',
    cancelar_contrato: 'Cancelar contrato',
    carteira_cliente: 'Carteira de cliente',
    catalogo_log: 'Log de Download de arquivos',
    categorias: 'Categoria | Categorias',
    comportamento: 'Comportamento',
    confirmar: 'Confirmar',
    cenario: 'Cenário',
    cliente: 'Cliente | Clientes',
    cliente_conta_corrente: 'Cliente Conta Corrente',
    criacao_pagamento: 'Criação do pagamento',
    concluir_pedido_pecas: 'Concluir pedido de peças',
    configuracao: 'Configuração',
    conta_corrente: 'Conta Corrente',
    consolidado_verbas_aprovadas: 'Consolidado de verbas aprovadas',
    consumo_saldo_orcamento: 'Consumo de saldo Orçamento',
    contato: 'Contato | Contatos',
    contrato: 'Contrato | Contratos',
    contrato_acordos_metas: 'Acordos e metas de crescimento',
    contrato_fechamento: 'Contrato - Fechamento',
    copiar: 'Copiar',
    copiar_contrato: 'Copia contrato',
    dados_ajuste: 'Dados do ajuste',
    dados_importacoes: 'Dados das importações',
    dados_orcamento: 'Dados do orçamento',
    dashboard_acao: 'Dashboard de ação | Dashboard de ações',
    desconto_calculo: 'Desconto no cálculo | Descontos no cálculo',
    documentos_ag_aprovacao_pagamento: 'Documentos Aguardando Aprovação no Pagamento',
    documentos_ag_analise_pagamento: 'Documentos Aguardando Análise no Pagamento',
    duvidas_frequentes: 'Dúvidas Frequentes',
    editar: 'Editar',
    editar_acordo: 'Editar acordo',
    editar_alcada: 'Editar alçada',
    editar_cliente: 'Editar cliente',
    editar_concorrente: 'Editar concorrente',
    editar_divisao: 'Editar divisão',
    editar_centro_custo: 'Editar centro de custo',
    editar_estrutura_usuario: 'Editar estrutura de usuário',
    editar_filial: 'Editar filial',
    editar_funcionario: 'Editar funcionário',
    editar_loja: 'Editar loja',
    editar_grupo_produto: 'Editar grupo de produto',
    editar_contrato: 'Editar contrato',
    editar_material: 'Editar material',
    editar_meta: 'Editar meta',
    editar_intervalo_meta: 'Editar intervalo da meta',
    editar_negociacao: 'Editar negociação',
    editar_peca: 'Editar peça',
    editar_produto: 'Editar produto',
    editar_planejamento: 'Editar planejamento',
    editar_regiao: 'Editar região',
    editar_reporte: 'Editar reporte',
    editar_orcamento: 'Editar orçamento',
    editar_usuario: 'Editar usuário',
    editar_periodo: 'Editar período',
    editar_perfil: 'Editar perfil',
    editar_tipo_investimento: 'Editar tipo de investimento',
    editar_unidade_medida: 'Editar unidade de medida',
    elegibilidade_adesao: 'Elegibilidade de adesão',
    execucao: 'Execução',
    execucao_orcamento: 'Orçamentos de Execução',
    execucao_incluir_pecas: 'Execução - Incluir peças',
    erro: 'Erro | Erros',
    encerrar_contrato: 'Encerrar contrato',
    encerrar_acordo: 'Encerrar acordo',
    fechamento: 'Fechamento',
    fechamento_ano_fiscal: 'Fechamento de período',
    fechamento_mensal: 'Fechamento Mensal',
    fechamento_pedido: 'Fechamento de pedido | Fechamento de pedidos',
    filtrar: 'Filtrar',
    filtro: 'Filtro | Filtros',
    filtros_da_entidade: 'Filtros de {entidade}',
    fluxo_aprovacao: 'Fluxo de aprovação',
    foco_da_acao: 'Foco da ação',
    forca_vendas: 'Força de vendas | Forças de vendas',
    forma_bonificacao: 'Forma de bonificação',
    formulario: 'Formulário',
    fornecedor: 'Fornecedor | Fornecedores',
    gestao_aprovacao: 'Gestão De Aprovação',
    hierarquia_usuario: 'Hierarquia de usuário | Hierarquia de usuários',
    historico_aprovacoes: 'Histórico de aprovações',
    inclusao_vendedor_orcamento: 'Inclusão de vendedor no orçamento',
    informacao_financeira: 'Informação financeira | Informações financeiras',
    informe_valor_reservado: 'Informe o valor reservado',
    imagem: 'Imagem',
    importar_arquivo: 'Importar arquivo',
    inclusao_divisao_rateio: 'Inclusão de divisão no rateio',
    inicio_processo_apuracao: 'Início do processo de apuração',
    integracao_software_terceiro: 'Integração com software terceiro',
    investimento_area_atuacao: 'Investimento por área de atuação',
    investimento_cliente: 'Investimento por Cliente',
    investimento_cultivo: 'Investimento por cultivo',
    investimento_materiais: 'Investimento por materiais',
    investimento_pecas: 'Investimento por peças',
    investimento_vendas: 'Investimento sobre vendas',
    justificativa: 'Justificativa',
    li_aceito_termos_condicoes: 'Li e Aceito Termos e Condições',
    liquidacao: 'Liquidação',
    loja: 'Loja | Lojas',
    marcas: 'Marca | Marcas',
    margemcontribuicao: 'Margem Contribuição ROI',
    material: 'Material | Materiais',
    materiais_a_produzir: 'Material à produzir',
    metas: 'Metas',
    meta_beneficio: 'Meta e benefício | Metas e benefícios',
    metas_crescimento: 'Metas de crescimento',
    minhas_aprovacoes: 'Minhas aprovações',
    minhas_aprovacoes_pendentes: 'Minhas aprovações pendentes',
    minhas_solicitacoes_aprovacoes: 'Minhas solicitações/aprovações',
    motivo: 'Motivo',
    metas_do_acordo: 'Metas do acordo',
    negociacao: 'Negociação',
    negociacao_verbas: 'Negociação de Verbas Comerciais',
    negociacoes: 'Negociações',
    negociacoes_aguardando_aprovacao: 'Negociações aguardando aprovação',
    nota: 'Nota | Notas',
    novo_ajuste: 'Novo ajuste',
    nota_debito: 'Nota de débito | Notas de débito',
    operacao: 'Operação | Operações',
    orcamento: 'Orçamento | Orçamentos',
    orcamento_execucao: 'Orçamento de execução',
    orientacao_geral: 'Orientação geral | Orientações gerais',
    origem_da_acao: 'Origem da ação',
    orcamento_ag_aprovacao: 'Orçamento Aguardando Aprovação',
    pagamento: 'Pagamento | Pagamentos',
    pagamentos_liquidados: 'Pagamentos Liquidados',
    para: 'Para',
    parametrizacao_acao: 'Parametrização de ação',
    parametrizacao_cliente: 'Parametrização de cliente',
    parametrizacao_contrato: 'Parametrização de contrato',
    parametrizacao_orcamento: 'Parametrização de orçamento',
    parametrizacao_periodo: 'Parametrização de período',
    participacao_investimento: 'Participação Sobre Investimento',
    planejado_x_realizado: 'Planejado x Realizado por Período',
    planejamento: 'Planejamento',
    percentual_rebate: 'Percentual de rebate',
    pendencias: 'Pendências',
    pendencia_apuracao: 'Pendência de Apuração | Pendências de Apuração',
    pendencia_planejamento: 'Pendência de Planejamento | Pendências de Planejamento',
    peca: 'Peça | Peças',
    periodo: 'Período',
    periodo_apuracao: 'Período de apuração',
    planejamento_incluir_materiais: 'Planejamento - Incluir materiais',
    plano_comparativo: 'Plano Comparativo',
    produto: 'Produto | Produtos',
    periodo_orcamento: 'Período de orçamento',
    periodo_planejamento: 'Período de planejamento',
    programa_marketing: 'Programa Marketing',
    ranking: 'Ranking',
    ranking_recebimento: 'Ranking de recebimento | Ranking de recebimentos',
    ranking_pagamento: 'Ranking de pagamento | Ranking de pagamentos',
    rateio_orcamento: 'Rateio de orçamento',
    redefinicao_email_usuario: 'Redefinição do e-mail do usuário.',
    reducao_verba: 'Redução de verbas',
    reducao_verba_cliente: 'Redução de verbas cliente',
    reducao_verba_divisao: 'Redução de verbas divisão',
    reembolso: 'Reembolso',
    relatorio: 'Relatório | Relatórios',
    representante: 'Representante | Representantes',
    reporte: 'Reporte | Reportes',
    reportes_pendentes_de_criacao: 'Reportes Pendentes de Criação',
    resultado_fluxo: 'Resultado fluxo de aprovação',
    resumo: 'Resumo',
    roi: 'ROI',
    saldo_disponivel: 'Saldo disponível',
    saving_total: 'Saving(Total)',
    selecao: 'Seleção',
    selecao_aprovador: 'Seleção de aprovador',
    selecao_divisao: 'Seleção de Divisão',
    selecao_aprovador_cliente: 'Seleção do cliente aprovador do acordo',
    selecao_aprovador_fornecedor: 'Seleção do fornecedor aprovador da ação',
    selecao_carteira: 'Seleção da carteira',
    selecao_cliente: 'Seleção do cliente | Seleção dos clientes',
    selecao_orcamento: 'Seleção de orçamento | Seleção de orçamentos',
    selecao_usuario: 'Seleção do usuário | Seleção dos usuários',
    sellin_consolidado: 'Sell In consolidado',
    sellin_detalhado: 'Sell In detalhado',
    sellout_consolidado: 'Sell Out consolidado',
    sellout_detalhado: 'Sell Out detalhado',
    senha: 'Senha',
    sessao_expirada: 'Sessão expirada...',
    simulador_investimento: 'Simulador de Investimento',
    termos_condicoes: 'Termos e condições',
    transferencia_carteira: 'Transferência de carteira',
    sintetico_acoes: 'Sintético de ações',
    transferencia_passo: 'Transferências do passo',
    transferencia_valores: 'Transferência de valores',
    transferencia_conta_corrente: 'Transferência entre Contas Correntes',
    transferencia_responsabilidade_faturamento: 'Transferência de responsabilidade de faturamento',
    transferencia_verba: 'Transferência de verba',
    transferir_de: 'Transferir De',
    thumbnail: 'Thumbnail',
    tipo_linha_orcamento: 'Tipo Linha Orçamento',
    tipo_pagamento: 'Tipo de pagamento',
    top_10: 'TOP 10',
    top_20: 'TOP 20',
    unidades: 'Unidade | Unidades',
    unidades_negocio: 'Unidades de negócio',
    upload_evidencia: 'Upload de evidência',
    usuario: 'Usuário | Usuários',
    usuario_x_cliente: 'Usuário de Cliente | Usuários de Clientes',
    usuarios_x_uni_negocio: 'Usuários X Unid. Negócio',
    valor_acao: 'Valor da ação',
    valor_base_crescimento: 'Valor base de crescimento',
    valor_contrato: 'Valor do contrato',
    validade_configuracao_campos: 'Validade e configuração dos campos',
    visibilidade_configuracao_campos: 'Visibilidade e configuração dos campos',
    vinculo_acao_tipo_orcamento: 'Vínculo da ação com tipo de orçamento',
    vincular_representante: 'Vincular representante',
    workflow: 'Workflow | Workflows',
    email_alerta_negociacao: 'Email de Alerta - NEGOCIAÇÃO',
    email_alerta_apuracao: 'Email de Alerta - APURAÇÃO',
    email_alerta_pagamento: 'Email de Alerta - PAGAMENTO'
  },
  icon: {
    negociacao: {
      NEGOCIACAO_PRECO: 'attach_money',
      TABLOIDE: 'import_contacts',
      FIXO: 'gavel',
      CRESCIMENTO: 'trending_up',
      POSITIVACAO: 'thumb_up'
    }
  },
  subtitle: {
    aprovacoes_ultima_semana: 'Aprovações feitas na última semana',
    linhas_investimento: 'Linhas de orçamento',
    linhas_orcamento: 'Linhas de orçamento',
    pack_comercial: 'Pack comercial',
    somente_leitura: 'Somente leitura',
    importar_arquivo: 'Utilize a área abaixo para realizar a importação de {thing}'
  },
  label: {
    a: 'a | à',
    a_partir_inicio_vigencia: 'A partir do início da vigência',
    a_partir_vigencia_concluida: 'A partir da vigência concluída',
    aba_divisao: 'Aporte de verbas Divisão',
    acerto_preco: 'Acerto de preço',
    acao: 'Ação',
    acao_avulsa: 'Ação avulsa',
    acao_verba_fixa: 'Ação com verba fixa',
    acao_passo_cliente: 'Cliente aprovador',
    acao_passo_fornecedor: 'Fornecedor aprovador',
    acao_tatica: 'Ação tática | Ações táticas',
    aceites_realizados: 'Aceites realizados',
    acesso_usuario: 'Acessos do usuário',
    acoes: 'Ação | Ações',
    acoes_adicionadas: 'Ações adicionadas',
    acompanhamento: 'Acompanhamento',
    acompanhamento_fluxo: 'Acompanhamento do fluxo',
    acordo: 'Acordo',
    acordo_apuracao: 'Acordo | Apuração',
    acordo_passo_cliente: 'Cliente aprovador',
    acordo_acima_minimo: 'Acordo acima do mínimo',
    acordos_vencidos: 'Acordos Vencidos',
    adendo: 'Adendo',
    adicionar: 'Adicionar',
    adicionar_acao: 'Adicionar ação',
    adicionar_canal: 'Adicionar canal',
    adicionar_categoria: 'Adicionar categoria',
    adicionar_cliente: 'Adicionar cliente',
    adicionar_desdobramento: 'Adicionar desdobramento',
    adicionar_justificativa: 'Adicionar justificativa',
    adicionar_linha_investimento: 'Adicionar linha de orçamento',
    adicionar_meta: 'Adicionar meta',
    adicionar_negociacao: 'Adicionar negociação',
    adicionar_orcamento: 'Adiconar orçamento',
    adicionar_passo: 'Adicionar passo',
    adicionar_produto: 'Adicionar produto',
    adicionar_regiao: 'Adicionar região',
    adicionar_segmento: 'Adicionar segmento',
    adicione_opcoes_lista: 'Adicione',
    aditivo: 'Aditivo',
    administracao: 'Administração',
    agencia: 'Agência',
    agendamento_tarefa: 'Agendamento tarefa',
    aguardando_aprovacao: 'Aguardando aprovação',
    aguardando_apuracao: 'Aguardando apuração',
    aguardando_execucao_metas: 'Aguardando execução metas',
    aguardando_pagamento: 'Aguardando pagamento',
    aguardando_processo_de_aprovacao: 'Aguardando processo de aprovação',
    ajustar: 'Ajustar',
    ajustar_verba: 'Ajustar verba',
    ajuste_verba: 'Ajuste de Verba',
    ajuste_saldo_orcamento: 'Ajuste saldo Orçamento',
    liberacao_saldo_orcamento: 'Liberação de saldo do orçamento',
    solicitacao_saldo_orcamento: 'Solicitação de saldo do orçamento',
    confirmacao_alteracao_pagamento: 'Confirmação de alteração do pagamento',
    ajuste_saldo_representante: 'Ajuste saldo Representante',
    ajuste: 'Ajuste | Ajustes',
    alta: 'Alta',
    alcada: 'Alçada | Alçadas',
    aliquota: 'Alíquota',
    alterar: 'Alterar',
    alterar_orcamento: 'Alterar Orçamento',
    alterar_parametrizacao: 'Alterar Parametrização',
    alteracao_saldo_representante: 'Alteração saldo representante',
    alterar_selecionados: 'Alterar selecionados',
    alterar_todos: 'Alterar todos',
    altura_cm: 'Altura (cm)',
    analise_investimento: 'Análise de Investimento',
    anexo: 'Anexo',
    ano: 'Ano',
    anterior: 'Anterior',
    ano_fiscal: 'Ano fiscal',
    ano_fiscal_Atual: 'Ano fiscal atual',
    ano_fiscal_anterior: 'Ano fiscal anterior',
    anual: 'Anual',
    aplicar_alteracao: 'Aplicar alteração | Aplicar alterações',
    aplicar: 'Aplicar',
    aplicar_periodo: 'Aplicar período',
    aplicar_se_a: 'Aplicar-se à',
    aprova_acordo: 'Aprova acordo',
    aprova_workflow: 'Aprova workflow',
    aprovacoes: 'Aprovações',
    aprovado: 'Aprovado',
    aprovado_por: 'Aprovado por',
    aprovador: 'Aprovador',
    aprovador_atual: 'Aprovador atual',
    aprovador_anterior: 'Aprovador anterior',
    aprovadores: 'Aprovadores',
    aprovar: 'Aprovar',
    aprovacao: 'Aprovação',
    aprovacao_layout: 'Aprovação de Layout',
    aprovacao_orcamento: 'Aprovação de Orçamento',
    aprovador_conforme_modalidade: 'Aprovador Conforme Modalidade',
    aprovar_contrato: 'Aprovar contrato',
    aprovar_todas: 'Aprovar todas',
    aprovar_todos: 'Aprovar todos',
    aprovacoes_pendentes: 'Aprovações pendentes',
    aportado: 'Aportado',
    aportado_pdi: 'Aportado PDI',
    apuracao: 'Apuração | Apurações',
    apuracao_contrato: 'Apuração',
    apuracao_acima_minimo: 'Apuração acima do mínimo',
    apuracao_aprovada: 'Apuração aprovada',
    apuracao_iniciou_fluxo: 'Apuração iniciou Fluxo',
    apuracao_nao_conforme: 'Apuração não conforme',
    apuracao_previa: 'Apuração prévia',
    apuracao_rejeitada: 'Apuração rejeitada',
    apuracoes_vencidas: 'Apurações vencidas',
    apurado: 'Apurado | Apurado ?',
    apurar: 'Apurar | Apurar ?',
    area_atuacao: 'Área de Atuação | Áreas de Atuação',
    area_basf: 'Área BASF',
    armazenar_historico: 'Armazenar histórico',
    arquivo: 'Arquivo',
    ate: 'até | Até',
    atencao: 'Atenção',
    atingimento: 'Atingimento',
    atingimento_marca_forte: 'Atingimento em marca forte | Atingimento em marcas fortes',
    atingimento_total: 'Atingimento total',
    ativar: 'Ativar',
    ativar_inativa: 'Ativar/Inativar',
    ativar_inativar_reg: 'Ativar/Inativar área de atuação | Ativar/Inativar divisão | Ativar/Inativar estrutura do usuário',
    ativo: 'Ativo',
    atualizar: 'Atualizar',
    atualizar_vigencia: 'Atualizar vigência',
    autenticacao_externa: 'Autenticação externa',
    automatico: 'Automático',
    avaliado_por: 'Avaliado por',
    avancar: 'Avançar',
    ativos: 'Ativos',
    aviso_credito: 'Aviso de crédito',
    bairro: 'Bairro',
    baixar_todos: 'Baixar todos',
    banco: 'Banco',
    banco_agencia_conta: 'Banco - Agência - Conta Corrente',
    bandeira: 'Bandeira',
    bloqueado: 'Bloqueado',
    atualizador: 'Atualizador',
    base_calculo: 'Base de cálculo',
    base_calculo_apuracao: 'Base de cálculo (Apuração)',
    base_calculo_da_apuracao: 'Base de cálculo da apuração',
    base_calculo_roi: 'Base de cálculo (ROI)',
    baixa: 'Baixa',
    basf: 'BASF',
    bloquear: 'Bloquear',
    boleto: 'Boleto',
    bonificacao: 'Forma de Bonificação',
    bonificacao_pagamento: 'Bonificação/Pagamento',
    bonificacao_produtos: 'Bonificação em produtos',
    budget: 'Budget',
    budget_previsto: 'Budget Previsto',
    buscar: 'Buscar',
    buscar_por: 'Buscar por',
    buscar_canal: 'Buscar canal',
    buscar_categoria: 'Buscar categoria | Buscar categorias',
    buscar_cliente: 'Buscar cliente',
    buscar_estrutura: 'Buscar estrutura | Buscar estruturas',
    buscar_perfil: 'Buscar perfil | Buscar perfis',
    buscar_produto: 'Buscar produto',
    buscar_regiao: 'Buscar região',
    buscar_segmento: 'Buscar segmento | Buscar segmentos',
    buscar_tipo_orcamento: 'Buscar tipo de orçamento',
    buscar_tipo_investimento: 'Buscar tipo de linha de Orçamento',
    buscar_usuario: 'Buscar usuário | Buscar usuários',
    buscar_5_itens: 'Buscar por 05 itens',
    buscar_10_itens: 'Buscar por 10 itens',
    buscar_15_itens: 'Buscar por 15 itens',
    buscar_20_itens: 'Buscar por 20 itens',
    buscar_50_itens: 'Buscar por 50 itens',
    buscar_100_itens: 'Buscar por 100 itens',
    cadastrar: 'Cadastrar',
    cadastrar_carteira_cliente: 'Cadastrar carteira de cliente',
    cadastrar_editar_campo_customizado: 'Cadastrar/editar campo customizado',
    cadastrar_editar: 'Cadastrar/editar',
    cadastrar_extensao: 'Não encontrado. Clique para cadastrar',
    cadastro: 'Cadastro | Cadastros',
    cadastro_acao: 'Cadastro de Ação | Cadastro de Ações',
    cadastro_orcamento: 'Cadastro de orçamento',
    calculo_apuracao: 'Cálculo da apuração',
    calculo_bonificacao: 'Cálculo da bonificação',
    calculado_sistema: 'Calculado pelo sistema',
    calendario: 'Calendário',
    campo: 'Campo | Campos',
    campo_busca: 'Campo de busca',
    campo_nao_preenchido_ou_invalido: 'Campo não preenchido ou inválido',
    campo_obrigatorio: 'Campo obrigatório',
    campo_obrigatorio_ou_invalido: 'Campo obrigatório ou inválido',
    campo_customizado: 'Campo customizado | Campos customizados',
    campos_customizados: 'Campos customizados',
    campos_gerais: 'Campos Gerais',
    campo_pesquisar_vencimento: 'Campo de pesquisa (Data vencimento e Número da ND) - campos separados',
    campo_reservado: 'Campo reservado | Campos reservados',
    calculado_automaticamente: 'Calculado automaticamente',
    canal: 'Canal',
    canal_venda: 'Canal Venda',
    cancelado: 'Cancelado',
    cancelar: 'Cancelar',
    cancelar_acordo: 'Cancelar Acordo',
    cancelar_apuracao: 'Cancelar Apuracao',
    cancelar_contrato: 'Cancelar Contrato',
    cancelar_entrega_materiais: 'Cancelar Entrega de Materiais',
    cancelar_execucao: 'Cancelar Execução',
    cancelar_pedido_materiais: 'Cancelar Pedido de Materiais',
    carregar_de: 'Carregar de',
    cargo: 'Cargo',
    carteira: 'Carteira | Carteiras',
    carteira_cliente: 'Carteira de cliente',
    carteira_cliente_ativar: 'ativado(s) com sucesso.',
    carteira_cliente_inativar: 'Inativado(s) com sucesso.',
    catalogo_material: 'Catálogo de material | Catálogo de materiais',
    catalogo_peca: 'Catálogo de peça | Catálogo de peças',
    categoria: 'Categoria | Categorias',
    categoria_marca: 'Categoria da marca',
    categoria_produto: 'Categoria do produto',
    categoria_produto_apuracao: 'Categoria de produto da apuração',
    categoria_produto_contrato: 'Categoria de produto do contrato',
    centro_custo: 'Centro de custo',
    celular: 'Celular',
    celula: 'Célula',
    cep: 'CEP',
    cidade: 'Cidade',
    cidade_loja: 'Cidade da loja',
    classificacao: 'Classificação',
    classificacao_acao: 'Classificação Ação',
    classificacao_crm: 'Classificação CRM',
    cliente: 'Cliente | Clientes',
    cliente_aprovador: 'Cliente aprovador do passo {sequencia}',
    cliente_dash: 'Cliente',
    distribuidor_cliente: 'Distribuidor/Cliente',
    cliente_pagador: 'Cliente pagador',
    cliente_prospect: 'Cliente prospect',
    cnpj: 'CNPJ',
    cnpj_cpf: 'CNPJ/CPF',
    cod_area_atuacao: 'Código área de atuação',
    codigo: 'Código',
    cod_acao: 'Cód. Ação',
    cod_acordo: 'Cód. Acordo',
    cod_alcada: 'Cód. Alçada',
    cod_apuracao: 'Cód. Apuração',
    cod_canal: 'Cód. Canal',
    cod_categoria: 'Cód. Categoria',
    cod_centro_custo: 'Cód. Centro custo',
    cod_cliente: 'Cód. Cliente',
    cod_cliente_pagador: 'Cód. Cliente Pagador',
    cod_contato: 'Cód. Contato',
    cod_contrato: 'Cód. Contrato',
    cod_divisao: 'Cód. Divisão',
    cod_filial: 'Cód. Filial',
    cod_fornecedor: 'Cód. Fornecedor',
    cod_loja: 'Cód. Loja',
    cod_marca: 'Cód. Marca',
    cod_meta: 'Cód. Meta',
    cod_pagamento: 'Cód. Pagamento',
    cod_produto: 'Cód. produto',
    cod_regiao: 'Cód. Região',
    cod_representante: 'Cód. Representante',
    cod_segmento: 'Cód. Segmento',
    cod_tipo_acao: 'Cód. Tipo Ação',
    cod_tipo_investimento: 'Cód. tipo Linha de Orçamento',
    cod_tipo_orcamento: 'Cód. tipo orçamento',
    codigo_tipo_investimento: 'Código do tipo de Linha de Orçamento',
    codigo_cliente: 'Código do Cliente',
    codigo_matriz: 'Código Matriz',
    cod_unidade_negocio: 'Cód. unidade negócio',
    cod_usuario: 'Cód. Usuário',
    codigo_acao: 'Código Ação',
    codigo_pagamento: 'Código Pagamento',
    codigo_planejamento: 'Código Planejamento',
    compoe_relatorio: ' Ausente usuários mensal',
    concluido: 'Concluído',
    concordo: 'Concordo',
    conf_apuracao: 'Conf. apuração',
    conf_negociacao: 'Conf. negociação',
    cotacao: 'Cotação',
    cnpj_distribuidor: 'Cnpj distribuidor',
    cnpj_cliente: 'Cnpj cliente',
    cnpj_loja: 'Cnpj loja',
    com_anexo: 'Com anexo',
    com_erros: 'Com erros',
    comparacao: 'Comparação',
    competencia: 'Competência',
    competencia_sellin_consolidado: 'Competência',
    complemento: 'Complemento',
    complexidade: 'Complexidade',
    complexidade_acao: 'Complexidade ação',
    composicao: 'Composição',
    compra: 'Compra | Compras',
    comprimento_cm: 'Comprimento (cm)',
    comprometido: 'Comprometido',
    comprovacao: 'Comprovação',
    comprovante_pagamento: 'Comprovante Pgto',
    configuracao: 'Configuração | Configurações',
    configuracao_planejamento_acao: 'Configuração | Configurações',
    configuracao_do_sistema: 'Configurações do Sistema',
    confirma_validacao_reporte: 'Confirmo que validei o reporte',
    concluir: 'concluir',
    concluir2: 'Concluir',
    concluir_acoes: 'Concluir ações',
    concluir_apuracao: 'Concluir apuração',
    concluir_este_cliente: 'concluir este cliente',
    concorrente: 'Concorrente',
    condicao: 'Condição',
    condicoes_percentuais: 'Condições percentuais',
    confirmacao: 'Confirmação',
    confirmado_apuracao: 'Confirmado apuração',
    confirmar: 'Confirmar',
    consolidado: 'Consolidado',
    consulta: 'Consulta | Consultas',
    consultar_todas: 'Consultar todas',
    consumido: 'Consumido',
    conta: 'Conta',
    conta_corrente: 'Conta Corrente | Contas Correntes',
    conta_corrente_cliente: 'Conta corrente de cliente',
    conta_corrente_destino: 'Conta Corrente Destino',
    conta_corrente_origem: 'Conta Corrente Origem',
    contabilizacao: 'Contabilização',
    contagem: 'Contagem',
    contato: 'Contato',
    contexto: 'Contexto',
    continuar: 'Continuar',
    contrato: 'Contrato | Contratos',
    contrato_cliente: 'Contrato cliente (KA)',
    contrato_passo_cliente: 'Cliente aprovador',
    controlador_carteira_cliente: 'Controlador da carteira de cliente',
    controle_estoque: 'Controle Estoque',
    copiar: 'Copiar',
    copiar_acao: 'Copiar Ação',
    copiar_acordo: 'Copiar Acordo',
    copiar_contrato: 'Copiar contrato',
    cor: 'Cor | Cores',
    cpf: 'CPF',
    cpf_cnpj: 'CPF/CNPJ',
    credito: 'Crédito',
    crescimento: 'Crescimento',
    criacao_acao: 'Criação de Ação',
    criacao_contrato: 'Criação de Contrato',
    criador: 'Criador | Criadores',
    cultivo: 'Cultivo',
    cultivo_foco_acao: 'Cultivo / Foco da Ação',
    cultura: 'Cultura',
    dash: 'Dashboard',
    dashboard: 'Dashboard Operacional',
    dashboard_gerencial: 'Dashboard Gerencial',
    dashboard_inicial: 'Dashboard Inicial',
    dashboard_orcamento: 'Dashboard Orçamento',
    data: 'Data',
    data_acao: 'Data da ação',
    data_alteracao: 'Data de alteração',
    data_aniversario: 'Data de aniversário',
    data_arquivo: 'Data do arquivo',
    data_atualizacao: 'Data da atualização',
    data_avaliacao: 'Data da avaliação',
    data_cancelamento: 'Data do cancelamento: ',
    data_conferencia: 'Data de conferência',
    data_contabilizacao: 'Data da contabilização',
    data_criacao_documento: 'Data Criação Documento',
    data_do_cancelamento: 'Data do cancelamento',
    data_emissao: 'Data de emissão',
    data_emissao_lista_detalhado: 'Data de emissão',
    data_emissao_exportacao: 'Data de emissão',
    data_encerramento: 'Data do encerramento: ',
    data_entrega: 'Data entrega',
    data_entrega_desejada: 'Data de entrega desejada',
    data_hora: 'Data/Hora',
    data_indefinida: 'N/A',
    data_inicio: 'Data início',
    data_inicio_acao: 'Data inicial da ação',
    data_inicio_apu: 'Data início',
    data_inicio_cont: 'Data início',
    data_inicio_pagamento: 'Data inicial do pagamento',
    data_inicio_venc: 'Data início',
    data_inicio_vigencia: 'Data início da vigência',
    data_fim: 'Data fim',
    data_fim_acao: 'Data final da ação',
    data_fim_apu: 'Data fim',
    data_fim_cont: 'Data fim',
    data_fim_pagamento: 'Data final do pagamento',
    data_fim_venc: 'Data fim',
    data_fim_vigencia: 'Data final da vigência',
    data_criacao: 'Data de criação',
    data_montagem: 'Data da montagem',
    data_pagamento: 'Data de pagamento',
    data_pedido: 'Data de pedido',
    data_prevista_fim: 'Data prevista fim',
    data_proxima_execucao: 'Data da próxima execução',
    data_remessa: 'Data da Remessa',
    data_solicitacao: 'Data de solicitação',
    data_transferencia: 'Data de transferência',
    data_ultima_alteracao: 'Data da última alteração.',
    data_ultima_aprovacao: 'Data da última aprovação',
    data_ultima_execucao: 'Data da última execução',
    data_vencimento: 'Data de vencimento',
    data_vencimento_nf: 'Data vencimento NF',
    data_Upload: 'Data de upload',
    data_Upload_NF: 'Data de upload NF',
    data_Upload_Orcamento: 'Data de upload Orçamento',
    de: 'de | De',
    debito: 'Débito',
    de_gestor: 'De (Gestor)',
    de_usuario_distribui_verba: 'De (Usuário que distribui verba)',
    de_vendedor: 'De (Vendedor)',
    definitiva: 'Definitiva',
    definir_data: 'Definir data',
    deposito_conta: 'Depósito em conta',
    departamento: 'Departamento',
    desbloquear: 'Desbloquear',
    desconto: 'Desconto | Descontos',
    desconto_nota: 'Desconto em nota',
    descreva_oque_deve_ser_alterado: 'Descreva o que deve ser alterado',
    descricao: 'Descrição',
    descricao_planejamento_acao: 'Descrição',
    descricao_detalhada: 'Descrição detalhada',
    desc_acordo: 'Descrição do acordo',
    desc_produto: 'Descrição do produto',
    descricao_acao: 'Descrição da ação',
    descricao_campo: 'Descrição do campo',
    descricao_contrato: 'Descrição do contrato',
    descricao_linha_investimento: 'Descrição da linha de investimento',
    descricao_orcamento: 'Descrição Orçamento',
    desdobramento: 'Desdobramento | Desdobramentos',
    destino: 'Destino',
    destino_acao: 'Destino da ação',
    destino_verba: 'Destino verba',
    detalhado: 'Detalhado',
    detalhamento: 'Detalhamento',
    detalhamento_briefing: 'Detalhamento de Briefing',
    detalhe: 'Detalhe | Detalhes',
    detalhe_campo: 'Detalhes do campo',
    detalhe_orcamento: 'Detalhes do orçamento',
    devolucao: 'Devolução | Devoluções',
    devolucoes: 'Devoluções',
    dias_uteis_producao: 'Dias úteis Produção',
    diagnostico_aprovacao: 'Diagnóstico/Aprovação',
    digite_para_buscar: 'Digite para buscar',
    diretoria: 'Diretoria',
    distribuidor: 'Distribuidor',
    distribuicao_valor: 'Distribuição de valor | Distribuição de valores',
    disponivel: 'Disponível',
    disponivel_planejado: 'Disponível planejado',
    divisao: 'Divisão | Divisões',
    divisao_hierarquica: 'Divisão hierárquica',
    divisao_superior: 'Divisão superior | Divisões superiores',
    documento: 'Documento',
    dolar: 'Dólar | Dólares',
    dominio: 'Dominio',
    download: 'Download',
    donwload_evidencia_apuracao: 'Download evidência',
    donwload_evidencia_reivindicacao: 'Fluxo de Aprovação de Reinvindicação em andamento para a meta.',
    download_arquivo_negociacao: 'Download Arquivo de Negociação',
    download_projeto_fachadas: 'Download Projeto Fachadas',
    dta_liquidacao: 'Data de liquidação',
    duracao: 'Duração',
    duracao_orcamento: 'Duração do orçamento',
    e: 'e',
    e_representante: 'É Representante?',
    ean: 'EAN',
    ean_produto: 'EAN do produto',
    edicao_status_aprovado: 'Edição no status Aprovado',
    editar: 'Editar',
    editar_a_acao: 'Editar a ação',
    editar_campo_customizado: 'Editar campo customizado',
    editar_carteira_cliente: 'Editar carteira de cliente',
    editar_categoria: 'Editar categoria',
    editar_cliente: 'Editar cliente',
    editar_negociacao: 'Editar negociação',
    editar_produto: 'Editar produto',
    editar_marca: 'Editar marca',
    editar_unidade: 'Editar unidade',
    editar_unidadenegocio: 'Editar unidade de negócio',
    efetivado: 'Efetivado',
    elegivel: 'Elegível',
    email: 'Email',
    em_analise: 'Em análise',
    em_andamento: 'Em andamento',
    em_cadastro: 'Em cadastro',
    em_execucao: 'Em execução',
    em_comum: 'Em comum',
    em_reivindicacao: 'Em reivindicação',
    em_processo_apuracao: 'Em processo de apuração',
    encargo: 'Encargo | Encargos',
    encerrado: 'Encerrado',
    encerrar_apuracao: 'Encerrar apuração',
    encerrar_contrato: 'Encerrar contrato',
    encerrar_acordo: 'Encerrar acordo',
    encontro_contas: 'Encontro de contas',
    endereco: 'Endereço',
    endereco_acao: 'Endereço ação',
    endereco_entrega: 'Endereço entrega',
    entidade: 'Entidade',
    enviado: 'Enviado | Enviados',
    enviar: 'Enviar',
    enviar_alteracao: 'Enviar para alteração',
    enviar_analise: 'Enviar para análise',
    enviar_aprovacao: 'Enviar para aprovação | Enviar aprovação',
    erro: 'Erro | Erros',
    escolha_importacao_acima: 'Escolha uma forma de importação acima',
    escolha_periodo_importacao: 'Escolha um periodo para importação',
    escolha_tipo_importacao_acima: 'Escolha um tipo de importação acima',
    escolha_solicitante: 'Escolha um solicitante',
    especifico: 'Específico',
    estado: 'Estado',
    estoque_atual: 'Estoque atual',
    estoque_minimo: 'Estoque mínimo',
    estrutura: 'Estrutura',
    estrutura_cliente: 'Estrutura cliente',
    estrutura_divisao: 'Estrutura da divisão',
    estrutura_pai: 'Estrutura pai',
    estrutura_verba: 'Estrutura da verba',
    estrutura_usuario: 'Estrutura de usuário | Estrutura usuário',
    estrutura_usuario_clique: 'clique para alterar',
    evento: 'Evento',
    eventos_cancelados: 'Eventos cancelados',
    evidencia: 'Evidência?',
    evidencia_apuracao: 'Evidência',
    evidencias: 'Evidências',
    excecao: 'Exceção | Exceções',
    excluir: 'Excluir',
    excluir_a_acao: 'Excluir a ação',
    excluir_perfil: 'Excluir perfil',
    execucao: 'Execução | Execuções',
    execucao_criador_da_acao: 'Condicional de criador da ação',
    execucoes_meta: 'Execuções da meta',
    executar: 'Executar',
    executar_analise: 'Executar análise',
    executar_metas: 'Executar metas | Executar metas ?',
    execucao_orcamento: 'Orçamentos de execução',
    exemplo_senha: 'Exemplo de senha',
    exibe_catalogo: 'Exibe no catálogo',
    exibicao: 'Exibição',
    exibir_somente_selecionados: 'Exibir somente selecionados',
    explicita: 'Explícita',
    exportar: 'Exportar',
    exportar_conteudo: 'Exportar Conteúdo',
    exportar_modelo: 'Exportar Modelo',
    exportar_nf: 'Exportar NFs',
    exportar_relatorio_acesso: 'Exportar relatório de acesso',
    extrato: 'Extrato',
    extrato_conta_corrente: 'Extrato conta corrente',
    foco_acao_cliente: 'Cliente',
    foco_divisao: 'Divisão',
    fornecedor_escolhido: 'Fornecedor escolhido',
    fornecedor_escolhido_orcamento: 'Fornecedor escolhido no orçamento',
    fornecedor_pagador: 'Fornecedor pagador',
    fornecedor_valor_final: 'Fornecedor/Valor Final',
    familia: 'Família',
    faturamento: 'Faturamento',
    faturamento_canal: 'Faturamento por Canal',
    faturamento_marca: 'Faturamento por Marca',
    fazer_nova_importacao: 'Fazer nova importação',
    fazer_nova_importacao_de: 'Fazer nova importação de',
    fechar: 'Fechar',
    filial: 'Filial',
    filtrar: 'Filtrar',
    filtrar_por: 'Filtrar por',
    filtro: 'Filtro | Filtros',
    filtro_apuracao_sem_evidencia: 'Filtrar apuração sem evidência.',
    filtro_apuracao_sem_reprocessamento: 'Filtrar apuração sem reprocessamento.',
    filtro_cliente: 'Filtro cliente',
    filtro_cliente_: 'Selecione um filtro de cliente',
    filtro_cliente_id_cliente: 'Cliente',
    filtro_cliente_id_regiao: 'Região',
    filtro_cliente_id_holding: 'Holding',
    filtro_produto_utilizado: 'Filtros de Produto utilizados',
    filtro_usuario: 'Filtro usuário',
    fim: 'Fim',
    fim_solicitacao_reembolso: 'Fim Solicitação Reembolso',
    fim_vigencia: 'Fim de vigência | Fim vigência',
    finalizar: 'Finalizar',
    finalizar_apuracao: 'Finalizar apuração | Finalizar apurações',
    finalizar_selecionados: 'Finalizar selecionados',
    finalizar_tudo: 'Finalizar tudo',
    fisica: 'Física',
    finalizados: 'Finalizados',
    finalizado_por: 'Finalizado por',
    fixo: 'Fixo',
    foco: 'Foco',
    foco_acao: 'Foco da ação',
    foco_cliente: 'Cliente',
    forma_bonificacao: 'Forma de bonificação',
    forma_rateio: 'Forma de rateio',
    formato_data: 'Formato da data',
    fornecedor: 'Fornecedor',
    fornecedores: 'Fornecedores',
    fornecedor_sugerido: 'Fornecedor Sugerido',
    foto_catalogo: 'Foto Catálogo',
    fotos_evento: 'Fotos do evento',
    frequencia: 'Frequência',
    frete: 'Frete | Fretes',
    fluxo: 'Fluxo',
    fluxo_aprovacao: 'Fluxo de aprovação',
    fluxo_apuracao_concluido: 'Apuração concluída.',
    fluxo_descricao: 'Descrição fluxo',
    fluxo_reivindicacao_meta_andamento: 'Reivindicar | Reinvindicação em andamento',
    fluxo_trademarketing: 'Fluxo de trademarketing',
    funcionario: 'Funcionário | Funcionários',
    funcionalidade_bloqueada: 'Funcionalidade bloqueada',
    gestao_aprovacao: 'Gestão de aprovação',
    gasto_fixo: 'Gasto fixo',
    gerar_grade: 'Gerar grade',
    gerar_novamente: 'Gerar novamente',
    geral: 'Geral',
    gestao_usuario: 'Gestão de usuário | Gestão de usuários',
    gestor: 'Gestor',
    grid: 'Grid',
    grid_filtros: 'Grid e filtros',
    gr: 'GR',
    grupo_fornecedor: 'Grupo de fornecedor',
    grupo_produto: 'Grupo de produto',
    grupo: 'Grupo | Grupos',
    habilita: 'Habilita',
    habilita_informacoes_bancarias: 'Informações bancárias (Banco, Agência e Conta Corrente) obrigatórias para solicitar aprovação do acordo',
    habilitar_acao_cliente: 'Cliente',
    habilitar_acao_cliente_pagador: 'Habilitar cliente pagador',
    habilitar_acao_divisao: 'Divisão',
    habilitar_acao_fornecedor: 'Habilitar fornecedor',
    habilitar_acao_fornecedor_pagador: 'Habilitar fornecedor pagador',
    habilitar_acao_grupo_fornecedor: 'Habilitar grupo de fornecedor',
    habilitar_acao_holding: 'Holding',
    habilitar_acao_regional: 'Regional',
    habilitar_alocacao_verba_parcial: 'Habilitar alocação da verba parcial',
    habilitar_divisao_orcamento: 'Habilitar divisão no cadastro do orçamento',
    habilitar_programa_marketing: 'Liberado para modalidade 4',
    habilitar_fluxo_aprovacao: 'Habilitar fluxo de aprovação',
    hierarquia: 'Hierarquia',
    hierarquia_de: 'Hierarquia de',
    hierarquia_funcionario: 'Hierarquia de funcionário',
    historico: 'Histórico',
    historico_ano_anterior: 'Histórico do ano anterior',
    historico_de: 'Histórico de ',
    historico_faturamento_investimento: 'Histórico - Faturamento e Investimento',
    historico_faturamento_investimento_marca: 'Histórico - Investimento e Faturamento - Por Marca',
    historico_importacoes_sellin_sellout: 'Histórico importações Sellin/Sellout',
    historico_meses: 'Histórico de meses',
    holding: 'Holding',
    honorario: 'Honorário | Honorários',
    hora: 'Hora',
    hora_final: 'Hora Final',
    hora_inicial: 'Hora Inicial',
    hora_montagem: 'Hora da Montagem',
    icms: 'ICMS',
    icone: 'Ícone',
    id: 'ID',
    id_acao: 'Cód. da ação',
    id_cliente: 'Id Cliente',
    id_orcamento: 'ID do orçamento',
    id_acordo: 'Numero do acordo',
    ids: 'ID',
    ie: 'IE',
    imprimir: 'Imprimir',
    inativar: 'Inativar',
    inativar_usuario_migracao: 'Inativar usuário pós migração',
    incluir: 'Incluir',
    incluir_acao: 'Incluir ação',
    inclusao_execucao: 'Inclusão da execução',
    inconsistencia: 'Inconsistência | Inconsistências',
    indicador: 'Indicador | Indicadores',
    informado_manualmente: 'Informado manualmente',
    informacoes_adicionais_acao: 'Informações adicionais da Ação',
    iniciar_periodo: 'Iniciar período',
    integracao: 'Integração',
    inicio_solicitacao_reembolso: 'Início Solicitação Reembolso',
    invest: 'Invest.',
    implicita: 'Implícita',
    importacoes_andamento: 'Importações em Andamento',
    importacoes_erros: 'Importações Com Erros',
    importacoes_finalizadas: 'Importações Finalizadas',
    importar: 'Importar',
    importar_conteudo: 'Importar Conteúdo',
    imposto: 'Imposto | Impostos',
    impressao_contrato: 'Impressão Contrato',
    inativo: 'Inativo',
    informacoes: 'Informações',
    informar_novo_endereco: 'Informar um Novo Endereço',
    inicio: 'Início',
    inicio_vigencia: 'Início de vigência | Início vigência',
    informacoes_bancarias: 'Informações bancárias',
    informacao_orcamento: 'Informações do Orçamento',
    informe_justificativa: 'Informe a justificativa.',
    info_contrato: 'Informação de Contrato',
    info_cliente: 'Informação de Cliente',
    inscricao_estadual: 'Inscrição estadual',
    intervalo: 'Intervalo',
    intervalo_meta: 'Intervalo da meta',
    investimento: 'Investimento',
    invest_fat: 'Invest. sobre Fat.',
    investimento_margem: 'Investimento vs. Margem',
    investimento_x_faturamento: '% Inv/Fat',
    investimento_canal: 'Investimento por Canal',
    investimento_marca: 'Investimento por Marca',
    investimento_faturamento: 'Investimento sobre Faturamento',
    investimento_venda: 'Investimento sobre vendas',
    ipi: 'IPI',
    ir_topo: 'Ir para topo',
    item: 'Item',
    item_acao: 'Item Ação | Itens Ação',
    item_pagamento: 'Item do pagamento | Itens do pagamento',
    inativos: 'Inativos',
    juridica: 'Jurídica',
    justificar_acao: 'Descreva o motivo de {acao} {extra}',
    justificativa: 'Justificativa',
    justificativa_reprovacao: 'Justificativa reprovação',
    holding_regiao: 'Holding/Região',
    layout: 'Layout',
    largura_cm: 'Largura (cm)',
    li_aceito_condicoes: 'Li e aceito as condições',
    li_aceito_termos_condicoes: 'Li e aceito os termos e condições',
    li_concordo: 'Li e concordo',
    li_concordo_termos_condicoes: 'Li e concordo com os termos e condições',
    liberado: 'Liberado',
    lider_conta: 'Líder de conta',
    limpar: 'Limpar',
    limpar_filtros: 'Limpar filtros',
    linha: 'Linha',
    linha_investimento: 'Linha de orçamento | Linhas de Orçamento',
    linha_orcamento: 'Linha de orçamento',
    linha_produto: 'Linha de produto',
    liquidacao: 'Liquidação',
    liquidado: 'Liquidado',
    limpar_carrinho: 'Limpar carrinho',
    linhas_por_pagina: 'Linhas por página',
    lista: 'Lista',
    lista_passo1_parametrizacao_orcamento: 'Qualquer alteração nas configurações desse tipo de orçamento será aplicada para os novos orçamentos e os orçamentos que estão no status Em cadastro. Os demais status (Aprovado, Aguardando aprovação, Em análise, Reprovado e Cancelado) não serão impactados.',
    lista_passo2_parametrizacao_orcamento: 'Se um Tipo de Investimento for inativado ele não será apresentado em sua respectiva seção.',
    lista_presenca: 'Lista de presença',
    log: 'Log | Logs',
    login: 'Login',
    logradouro: 'Logradouro',
    local: 'Local | Locais',
    localidade: 'Localidade (ex.: Hotel, Restaurante, Cidade)',
    loja: 'Loja | Lojas',
    logout: 'Logout',
    manual: 'Manual',
    matricula: 'Matrícula',
    mais_detalhes: 'Mais detalhes',
    mapa_provisao: 'Mapa de Provisão',
    marca: 'Marca',
    marca_produto: 'Marca do produto',
    marca_representante: 'Marcar como representante',
    margem: 'Margem',
    margemcontribuicao: 'Margem Contribuição ROI',
    material: 'Material | Materiais',
    media: 'Média',
    meio_acesso: 'Meio de acesso',
    mes: 'Mês',
    mes_fiscal: 'Mês Fiscal',
    mensal: 'Mensal',
    mes_referencia: 'Mês de referência',
    meta: 'Meta | Metas',
    meta_atingida: 'Meta atingida',
    meta_de: 'Meta de',
    meta_ate: 'Meta até',
    meta_beneficio: 'Meta e benefício | Metas e benefícios',
    metas_beneficios: 'Meta/Benefício',
    meta_nao_se_aplica: 'Meta não se aplica',
    meus_passos_aprovados: 'Meus passos aprovados',
    migrar_saldo_disponivel: 'Migrar saldo disponível',
    minhas_aprovacoes: 'Minhas aprovações',
    minhas_aprovacoes_pendentes: 'Minhas aprovações pendentes',
    minima: 'Mínima',
    modalidade: 'Modalidade',
    monetario: 'Monetário',
    motivo: 'Motivo',
    mostrar: 'Mostrar',
    mover_passo: 'Mover passo',
    multipla_escolha: 'Múltipla escolha',
    multiplas_liquidacoes: 'Múltiplas liquidações',
    nao: 'Não',
    nao_aplica: 'N/A',
    nao_se_aplica: 'Não se aplica',
    nao_encontrou_clique_aqui: 'Não encontrou {text}? Clique aqui para cadastrar',
    nao_encontrou_campo_clique_aqui: 'Não encontrou o campo? Clique aqui para cadastrar',
    nao_encontrou_familia_clique_aqui: 'Não encontrou a família? Clique aqui para cadastrar',
    nao_enviado: 'Não enviado | Não enviados',
    nao_alocado: 'Não alocado',
    nao_existem_materiais_disponiveis: 'Não existem materiais disponíveis para essa ação.',
    nao_liberado: 'Não liberado',
    nao_salvar: 'Não salvar',
    nd: 'ND',
    nd_previa: 'ND Prévia',
    negociacao: 'Negociação',
    negociacao_faturamento: 'Negociação vs. Faturamento',
    negociacao_preco: 'Negociação Preço',
    negociado: 'Negociado',
    nivel_cliente: 'Nível cliente',
    nivel_fornecedor: 'Nível fornecedor',
    nivel_produto: 'Nível produto',
    nome: 'Nome',
    nome_acao: 'Nome da ação',
    nome_campo: 'Nome do campo',
    nome_canal: 'Nome do canal',
    nome_cliente: 'Nome do cliente',
    nome_categoria: 'Nome da categoria',
    nome_estrutura_pai: 'Nome da estrutura pai',
    nome_evento: 'Nome do evento',
    nome_fantasia: 'Nome fantasia',
    nome_fornecedor: 'Nome do fornecedor',
    nome_grupo_produto: 'Nome do grupo de produto',
    nome_interno: 'Nome interno',
    nome_loja: 'Nome da loja',
    nome_marca: 'Nome da marca',
    nome_produto: 'Nome do produto',
    nome_regiao: 'Nome da região',
    nome_segmento: 'Nome do segmento',
    nome_solicitante: 'Nome solicitante',
    nome_tipo_investimento: 'Nome do tipo de linha de orçamento',
    nome_tipo_orcamento: 'Nome do tipo de orçamento',
    nome_unidade_negocio: 'Nome da unidade de negócio',
    nota: 'Nota | Notas',
    nota_debito: 'Nota de débito | Notas de débito',
    nota_devolucao: 'Nota de devolução | Notas de devolução',
    nota_fiscal: 'Nota fiscal',
    nova_associacao_usuario_cliente: 'Nova associação usuário x cliente',
    nova_associacao_usuario_unidade_negocio: 'Nova associação usuário x un. negócio',
    nova_divisao: 'Nova divisão',
    nova_estrutura_usuario: 'Nova estrutura de usuário',
    nova_execucao: 'Nova execução',
    nova_parametrizacao: 'Nova parametrização',
    nova_peca: 'Nova peça',
    novo: 'Novo',
    novo_acordo: 'Novo acordo',
    novo_contrato: 'Novo contrato',
    novo_cliente: 'Novo cliente',
    novo_funcionario: 'Novo funcionário',
    novo_item_adicionado: 'Novo item adicionado',
    novo_material: 'Novo material',
    novo_orcamento: 'Novo orçamento',
    novo_pagamento: 'Novo pagamento',
    nova_perfil: 'Novo perfil',
    novo_periodo: 'Novo período',
    novo_planejamento: 'Novo planejamento',
    novo_programa_marketing: 'Novo Programa de marketing',
    novo_produto: 'Novo produto',
    novo_reporte: 'Novo reporte',
    novo_registro: 'Novo registro',
    novo_tipo: 'Novo tipo',
    novo_usuario: 'Novo usuário',
    numerico: 'Numérico',
    numero: 'Número',
    numero_abreviado: 'Nº',
    numero_acordo: 'Número do acordo',
    numero_participantes: 'Número de participantes',
    numero_pedido: 'Número do Pedido',
    numero_oi: 'Número OI',
    numero_nf: 'Número NF.',
    numero_nota_fiscal: 'Número Nota Fiscal',
    objetivo: 'Objetivo',
    objetivo_acao: 'Objetivo da ação',
    objetivo_atingido: 'Objetivo atingido',
    obrigatorio: 'Obrigatório',
    observacao: 'Observação | Observações',
    observacoes_detalhamento_da_acao: 'Observações / Detalhamento da Ação (escreva maiores detalhes da Ação)',
    oi: 'OI',
    oi_cc: 'OI/CC',
    ok: 'Ok',
    opcao: 'Opção | Opções',
    ocultar: 'Ocultar',
    opcoes_lista: 'Opções da lista',
    operacao: 'Operação',
    orcamento: 'Orçamento',
    orcamento_execucao: 'Orçamento de execução',
    ordem_interna: 'Ordem interna',
    orcamento_aguardando_aprovacao: 'Orçamento aguardando aprovação',
    orcamento_aprovado: 'Orçamento aprovado',
    orcamento_em_alteracao: 'Orçamento em alteração',
    orcamento_em_analise: 'Orçamento em análise',
    orcamento_em_cadastro: 'Orçamento em cadastro',
    orcamento_reprovado: 'Orçamento reprovado',
    ordem_interna_centro_custo: 'Ordem Interna Centro Custo',
    ordenacao: 'Ordenação',
    ordenar_por: 'Ordenar por',
    ordernar_crescente: 'Ordenar crescente',
    ordenar_decrescente: 'Ordenar decrescente',
    ordernar_limpar: 'Limpar ordenação',
    orgao_expedidor: 'Órgão expedidor',
    orientacao: 'Orientação | Orientações',
    origem: 'Origem',
    origem_acao: 'Origem da ação',
    origem_contrato: 'Origem do contrato',
    origem_transferencia: 'Origem da transferência',
    origem_verba: 'Origem de verba',
    outro_reporte: 'Outro reporte | Outros reportes',
    pagina: 'Página',
    pai: 'Pai',
    papel: 'Papel',
    passo_transferido: 'Passo de aprovação transferido',
    passos: 'Passo | Passos',
    passos_workflow: 'Passos do workflow',
    pagamento: 'Pagamento | Pagamentos',
    pagamento_andamento: 'Pagamento em andamento',
    pagamento_concluido: 'Pagamento concluído',
    pagamento_efetivado: 'Pagamento efetivado',
    pagamento_rejeitado: 'Pagamento reprovado/bloqueado/não liquidado',
    pagamento_enviado: 'Pagamento enviado | Pagamentos enviados',
    pagamento_a_partir_aprovacao_acao: 'A partir da aprovação da ação',
    pagamento_a_partir_inicio_vigencia: 'A partir do início da vigência',
    pagamento_a_partir_vigencia_concluida: 'A partir da vigência concluída',
    pagamento_pendente: 'Pagamento pendente',
    para: 'Para',
    para_cadastrar: 'para cadastrar',
    parametrizacao: 'Parametrização',
    parametrizacao_permitir_transferencia: 'Permite transferência de verbas entre orçamentos',
    parametrizacao_permitir_adendo: 'Permite adendo de verba',
    parametrizacao_permitir_reducao: 'Permite redução de verba',
    para_gestor: 'Para (Gestor)',
    para_novo_superior_imediato: 'Para (Novo superior imediato)',
    para_usuario_distribui_verba: 'Para (Usuário que distribui verba)',
    para_vendedor: 'Para (Vendedor)',
    part_faturamento: 'Part. sobre Fat.',
    part_investimento: 'Part. sobre Invest.',
    patrocinio_referente: 'Patrocínio referente',
    patrocinio_referente_a: 'Patrocínio referente a',
    participa_aprovacao_acordo: 'Participa na aprovação do acordo',
    participacao_investimento: 'Participação Sobre Investimento',
    participacao_x_investimento: '% Part sobre Inv',
    percentual_participacao_investimento: '% Part. invest.',
    participacao_investimento_canal: 'Participação no Investimento por Canal',
    peca: 'Peça',
    pendencia: 'Pendência | Pendências',
    pendencia_aprovacao: 'Pendência de aprovação',
    pendente_apuracao: 'Pendente Apuração',
    pendente_distribuicao: 'Pendente distribuição',
    pendente_reserva: 'Pendente reserva',
    percentual_investimento: 'Percentual de Investimento',
    perc_investimento: '% Investimento',
    perc_provisao: 'Percentual de provisão',
    perfil: 'Perfil | Perfis',
    pergunta: 'Pergunta | Perguntas',
    periodo: 'Período',
    periodo_apuracao: 'Período de apuração',
    periodo_apuracao_de: 'Período de apuração De',
    periodo_apuracao_ate: 'Período de apuração Até',
    periodo_fiscal: 'Período fiscal',
    periodo_fiscal_atual: 'Período fiscal atual',
    periodo_fiscal_anterior: 'Período fiscal anterior',
    periodo_planejamento: 'Período de planejamento',
    periodo_orcamentario: 'Período orçamentário',
    periodo_orcamentario_igual_planejamento: 'Período de orçamento igual ao período de planejamento',
    periodo_pdi: 'Período PDI',
    pedido: 'Pedido',
    percentual: 'Percentual',
    pesquisa_filtro_cliente: 'Pesquisa de Filtro Cliente',
    pesquisar: 'Pesquisar',
    peso: 'Peso',
    peso_kg: 'Peso (kg)',
    peso_produto: 'Peso do produto',
    pis_cofins: 'PIS/COFINS',
    planejamento: 'Planejamento',
    planejamento_tatico: 'Planejamento tático',
    planejado: 'Planejado',
    planejado_distribuido: 'Planejado distribuído',
    planejado_nao_distribuido: 'Planejado não distribuído',
    planejado_x_faturamento: '% Plan/Fat',
    planejado_x_realizado_area_atuacao: 'Valor Planejado x Realizado por Área de Atuação',
    planejado_x_realizado_cliente: 'Valor Planejado x Realizado por Cliente',
    planejado_x_realizado_cultivo: 'Valor Planejado x Realizado por Cultivo',
    planejado_x_realizado_periodo: 'Valor Planejado x Realizado por Período',
    plano_acao_aprovacao: 'Plano de ação/Aprovação',
    plano_comparativo: 'Plano Comparativo',
    preco_negociado: 'Preço Negociado',
    principal: '',
    ponto: 'Ponto | Pontos',
    pontuacao: 'Pontuação',
    pontuacao_minima_total: 'Pontuação minima total',
    por_mes: 'Por Mês',
    por_periodo_fiscal: 'Por Período Fiscal',
    por_periodo_planejamento: 'Por Período de Planejamento',
    por_planejamento_fiscal: 'Por Planejamento Fiscal',
    por_tipo_investimento: 'Por Tipo de Investimento',
    por_tipo_investimento_marca: 'Por Tipo de Investimento vs. Marca',
    por_tipo_negociacao_marca: 'Por Tipo de Negociação vs. Marca',
    positivacao: 'Positivação',
    prazo_vencimento_dias: 'Prazo de vencimento (dias)',
    prazo_vencimento_acao_dias: 'Prazo de vencimento de ação avulsa (dias)',
    prazo_vencimento_contrato_dias: 'Prazo de vencimento de contrato (dias)',
    preenchimento_automatico: 'Preenchimento automático',
    primeiro_acesso: 'Primeiro acesso',
    preencha_campos_abaixo: 'Preencha os campos abaixo',
    produto: 'Produto | Produtos',
    programa: 'Programa',
    programa_marketing: 'Programa de marketing',
    provisao: 'Provisão | Provisões',
    proximo: 'Próximo | Próximos',
    proximo_passo: 'Próximo passo',
    prospect: 'Prospect',
    publico: 'Público',
    publico_estimado: 'Público estimado',
    quantidade: 'Quantidade',
    quantidade_aprovada: 'Quantidade aprovada',
    quantidade_apuracao: 'Quantidade de apurações',
    quantidade_minima: 'Quantidade mínima',
    quantidade_pedido: 'Quantidade pedido',
    quantidade_por_contrato: 'Quantidade por contrato',
    quantidade_produto: 'Quantidade de produtos',
    qtd: 'Qtd.',
    quantidade_acoes: 'Quantidade de Ações',
    quantidade_acoes_execucao: 'Quantidade de ações em execução',
    quantidade_acoes_planejadas: 'Quantidade de ações planejadas',
    quantidade_estoque: 'Quantidade estoque',
    quantidade_inconsistencia: 'Quantidade de inconsistências',
    quantidade_maior_disponivel: 'Quantidade maior que o disponível',
    qtd_acao: 'Qtd. Ação',
    qtd_disponivel: 'Qtd. Disponível',
    range: 'Range',
    rascunho: 'Rascunho',
    rating: 'Rating',
    razao_social: 'Razão Social',
    realizar_alteracao: 'Realizar Alteração',
    rateio: 'Rateio',
    rateio_acordo: 'Rateio de acordo',
    rateio_orcamento: 'Rateio Orçamento',
    rateio_proporcional_cliente: 'Rateio proporcional por cliente',
    rateio_proporcional_fornecedor: 'Rateio proporcional por fornecedor',
    realizado: 'Realizado',
    realizado_meta: 'Realizado',
    reagendar: 'Reagendar',
    rebate: 'Rebate',
    recarregar: 'Recarregar',
    recebe_mail: 'Recebe e-mail',
    recebimento: 'Recebimento',
    recebido: 'Recebido',
    recusar: 'Recusar',
    recusar_lote: 'Recusar lote',
    redefinir_senha: 'Redefinir senha',
    redefinicao_email_usuario: 'Redefinição e-mail usuário.',
    redirecionamento: 'Redirecionamento',
    redirecionamento_fluxo: 'Redirecionamento do fluxo',
    reducao: 'Redução',
    reembolso_solicitado: 'Reembolso Solicitado',
    reenviar: 'Reenviar',
    reenviar_pagamento: 'Reenviar pagamento',
    reenviar_recebimento: 'Reenviar recebimento',
    referencia_de: 'Referência de',
    referencia_ate: 'Referência até',
    regiao: 'Região',
    regiao_loja: 'Região da loja',
    regional: 'Regional | Regionais',
    registros_acesso: 'Registro de acesso',
    registros_inseridos: 'Registros Inseridos',
    registros_inativados: 'Registros Inativados',
    registro_atualizado_com_sucesso: 'Registro atualizado com sucesso! | Registros atualizados com sucesso!',
    registros_atualizados: 'Registros Atualizados',
    reivindicacao: 'Reivindicaçao | Reivindicações',
    reivindicar: 'Reivindicar',
    reivindicar_apuracao: 'Reivindicar Apuração',
    relatorio: 'Relatório | Relatórios',
    relatorios: {
      roi: 'ROI',
      tipo_investimento: 'Tipo de Investimento',
      faturamento_periodo_anterior: 'Faturamento Período Anterior',
      faturamento_periodo_atual: 'Faturamento Período Atual',
      custo_total_periodo_anterior: 'Custo total Período Anterior',
      custo_total_periodo_atual: 'Custo total Período Atual',
      margem_periodo_anterior: 'Margem Período Anterior',
      margem_periodo_atual: 'Margem Período Atual',
      investimento_periodo_anterior: 'Investimento Período Anterior',
      investimento_periodo_atual: 'Investimento Período Atual'
    },
    reload_grid: 'Recarregar grid',
    remanescente: 'Remanescente | Remanescentes',
    remover: 'Remover',
    remover_passo: 'Remover passo',
    remover_justificativa: 'Remover justificativa',
    renovar: 'Renovar',
    reportada: 'Reportada',
    reportes_pendentes: 'Reportes Pendentes',
    representante: 'Representante',
    representante_marcado: 'Marcado',
    representante_desmarcado: 'Desmarcado',
    repres_invest: 'Repres. Invest.',
    reprocessar: 'Reprocessar | Calculado atual diferente do Valor Apurado (Pendente Reprocessamento)',
    reprocessar_lote: 'Reprocessar lote',
    reprocessar_todos: 'Reprocessar todos',
    reprocessar_cinquenta: 'Reprocessar Cinquenta',
    reprovar: 'Reprovar',
    reprovado: 'Reprovado',
    reprovar_todas: 'Reprovar todas',
    reprovar_todos: 'Reprovar todos',
    reservado: 'Reservado',
    resetar: 'Resetar',
    resetar_e_reenviar: 'Resetar e reenviar',
    resgatar: 'Resgatar',
    responsavel: 'Responsável | Responsáveis',
    responsavel_faturamento: 'Responsável pelo faturamento',
    resposta: 'Resposta | Respostas',
    restante: 'Restante',
    resumo: 'Resumo',
    resumo_contrato: 'Resumo do contrato',
    resultado_avaliacao: 'Resultado Avaliação',
    resultado_esperado: 'Resultado Esperado | Resultados Esperados',
    revalidacao: 'Revalidação',
    risco: 'Risco',
    rg: 'RG',
    roi: 'ROI',
    saldo: 'Saldo',
    saldo_ajustado: 'Saldo ajustado',
    saldo_atual: 'Saldo atual',
    saldo_conta_corrente: 'Saldo Conta Corrente',
    saldo_disponivel: 'Saldo disponível',
    saldo_disponivel_insuficiente: 'Saldo insuficiente, solicite um adendo.',
    saldo_comprometido_periodo: 'Saldo Comprometido: ',
    saldo_disponivel_periodo: 'Saldo Disponível: ',
    saldo_disponivel_materiais: 'Saldo disponível materiais',
    saldo_pdi: 'Saldo PDI',
    saldo_solicitado: 'Saldo Solicitado',
    saldo_total: 'Saldo total',
    saldo_vendedor: 'Saldo por Vendedor',
    saldo_orcamento: 'Saldo de Orçamento',
    detalhamento_orcamento: 'Detalhamento de Orçamento',
    verbas_transferidas: 'Verbas transferidas',
    saldo_periodo: 'Saldo Período',
    salvar: 'Salvar',
    salvar_acao: 'Salvar ação',
    salvar_continuar: 'Salvar e continuar',
    salvar_mais_um: 'Salvar +1',
    salvar_rascunho: 'Salvar rascunho',
    sap_pagador: 'SAP pagador',
    secao: 'Seção',
    selecione: 'Selecione',
    selecione_aprovadores: 'Selecione aprovadores',
    selecione_modalidade: 'Selecione a modalidade',
    selecione_solicitante: 'Selecione solicitante',
    selecione_divisoes: 'Selecione as divisões',
    sellin: 'Sell In',
    sellin_detalhado: 'Sell In Detalhado',
    sellin_valor: 'Sell In valor',
    sellin_volume: 'Sell In volume',
    sellout: 'Sell Out',
    sellout_valor: 'Sell Out valor',
    sellout_volume: 'Sell Out volume',
    sellin_sellout: 'Sell In/Sell Out',
    sem_alcada: 'Sem alçada',
    sem_comprovacao: 'Sem comprovação',
    sem_condicional: 'Sem condicional',
    sem_controle_estoque: 'Sem Controle de Estoque',
    sem_valor_final: 'Sem valor final',
    sempre: 'Sempre',
    senha_temporaria: 'Senha temporária',
    setor: 'Setor | Setores',
    seq_item: 'Seq. Item',
    servico: 'Serviço | Serviços',
    sim: 'Sim',
    sim_nao: 'Sim/Não',
    segmento: 'Segmento | Segmentos',
    sigla: 'Sigla',
    situacao: 'Situação',
    sla: 'SLA (horas)',
    status: 'Status',
    status_ano_fiscal: {
      BLOQUEIO: 'Bloqueio',
      VIGENTE: 'Vigente',
      VIGENTE_COM_BLOQUEIO: 'Vigente com bloqueio',
      FECHADO: 'Fechado',
      PROXIMO: 'Próximo',
      EM_CADASTRO: 'Em Cadastro',
      VIGENTE_NAO_INICIADO: 'Vigente não iniciado'
    },
    status_acordo: 'Status do acordo',
    status_acao: 'Status da ação',
    status_apuracao: 'Status da apuração',
    status_entidade: 'Status entidade',
    status_entrega: 'Status entrega',
    status_integracao: 'Status da integração',
    status_fluxo: 'Status do fluxo',
    status_layout: 'Status do Layout',
    status_nd: 'Status ND',
    status_negociacao: 'Status das Negociações',
    status_negociacao_singular: 'Status da negociação',
    status_orcamento: 'Status do orçamento',
    status_pagamento: 'Status do pagamento',
    status_planejamento: 'Status do planejamento',
    status_reembolso: 'Status Reembolso',
    segmento_canal: 'Segmento do canal',
    sobrenome: 'Sobrenome',
    solicitacao_reembolso: 'Solicitação Reembolso',
    solicitado: 'Solicitado | Solicitados',
    solicitado_por: 'Solicitado por',
    solicitante: 'Solicitante',
    solicitar_analise: 'Solicitar análise',
    solicitar_aprovacao: 'Solicitar aprovação',
    solicitar_reembolso: 'Solicitar reembolso',
    solicitar_reembolso_liberados: 'Solicitar reembolso de liberados',
    soma: 'Soma',
    subcategoria: 'Subcategoria',
    subgrupo: 'Subgrupo',
    sub_regioes: 'Sub-Regiões',
    sugestao_fornecedor: 'Sugestão fornecedor',
    sugestao_fornecedor_aqui: 'Faça aqui a sugestão de um fornecedor (informe dados para contato) ou descreva melhor o item',
    superior: 'Superior',
    superior_imediato: 'Superior Imediato',
    superior_imediato_atual: 'Superior imediato atual',
    supervisor: 'Supervisor',
    suporte: 'Suporte',
    sem_metas: 'Sem metas',
    tarefa_aprovacao: 'Tarefa de aprovação',
    tabela_sem_conteudo: 'Nenhuma informação encontrada.',
    tabloide: 'Tablóide',
    tamanho: 'Tamanho | Tamanhos',
    tamanho_maximo_descritivo_texto: 'Máximo (ex: 200)',
    tamanho_maximo_descritivo_numerico: 'Máximo',
    tamanho_minimo_descritivo_numerico: 'Mínimo',
    telefone: 'Telefone',
    tempo: 'Tempo',
    template: 'Template',
    template_calculo: 'Template de cálculo',
    territorio: 'Território',
    termos_condicoes: 'Termos e condições',
    termo_aceite: 'Termo de aceite',
    texto: 'Texto',
    taxas_servico: 'Taxas de serviço',
    tipo: 'Tipo | Tipos',
    tipo_acao: 'Tipo de ação',
    tipo_acordo: 'Tipo de acordo',
    tipo_apuracao: 'Tipo de apuração',
    tipo_campo: 'Tipo do campo',
    tipo_contrato: 'Tipo de contrato',
    tipo_de_verba: 'Tipo de verba',
    tipo_documento: 'Tipo de documento',
    tipo_provisao: 'Tipo de provisão',
    tipo_rateio: 'Tipo de rateio',
    tipo_valor: 'Tipo de valor',
    tipo_verba: 'Tipo verba',
    tipo_ano_fiscal: {
      empresa: 'Empresa',
      cliente: 'Cliente'
    },
    tipo_bonificacao: 'Tipo de bonificação',
    tipo_destino_verba: {
      PATROCINIO: 'Patrocínio',
      ESTANDE: 'Estande',
      MATERIAL_PROMOCIONAL: 'Material promocional',
      PROJETO_ESPECIAL: 'Projeto especial',
      PROJETO_FACHADAS: 'Projeto fachadas',
      OUTROS: 'Outros'
    },
    tipo_de_fluxo: 'Tipo de fluxo',
    tipo_fluxo: 'Tipo fluxo',
    tipo_negociacao: 'Tipo de Negociação',
    tipo_ajuste: 'Tipo de Ajuste',
    tipo_importacao: 'Tipo de importação',
    tipo_de_investimento: 'Tipo de linha de orçamento',
    tipo_investimento: 'Tipo de linha de orçamento | Tipos de linha de orçamento',
    tipo_investimento_gerencial: 'Tipo investimento',
    tipo_linha_investimento: 'Tipo de linha',
    tipo_linha_orcamento: 'Tipo de linha de orçamento',
    tipo_orcamento: 'Tipo de Orçamento',
    tipo_investimento_tipo_orcamento: 'Tipo de linha de orçamento do tipo orçamento',
    tipo_pagamento: 'Tipo de pagamento',
    tipos_pagamento: 'Tipos de pagamento',
    tipos_pagamentos_aceitos: 'Tipos de pagamentos aceitos',
    tipo_patrocinio: 'Tipo de Patrocínio',
    tipo_pessoa: 'Tipo pessoa',
    tipo_usuario: 'Tipo de usuário',
    todos: 'Todos',
    totais: 'Totais',
    total: 'Total',
    total_ajustado: 'Total ajustado',
    total_disponivel: 'Total disponível',
    total_geral: 'Total geral',
    total_de_recebimento: 'Total de recebimentos',
    total_de_recebimento_contrato: 'Total de recebimentos do contrato',
    total_recebimento: 'Total receb.',
    total_pagamento: 'Total pagamento. | Total pagamentos.',
    total_verba_materiais: 'Total pedido materiais:',
    total_verba_planejada: 'Total verba {tipoVerba} planejada:',
    tradelinks: 'Tradelinks - Solução Eletrônica de Negócios',
    tradelinks_curto: 'Tradelinks',
    transferencia: 'Transferência',
    transferencia_posse: 'Transferência de Posse',
    transferencia_temporaria: 'Temporária',
    transferido_por: 'Transferido por',
    transferir: 'Transferir',
    transferir_todos: 'Transferir todos',
    transporte_aprovado: 'Transporte aprovado',
    trimestre: 'Trimestre',
    trimestral: 'Trimestral',
    uf: 'UF',
    un_medida: 'UN. Medida',
    unica_execucao: 'Única execução',
    unica_liquidacao: 'Única liquidação',
    unica_vez: 'Única vez',
    unidade: 'Unidade',
    unidade_medida: 'Unidade de medida',
    unidadenegocio: 'Unidade de negócio',
    unidade_negocio: 'Unidade de negócio | Unidade negócio',
    unidades_negocio: 'Unidades de negócio',
    unidade_negocio_produto: 'Unidade de negócio do produto',
    unidade_dinheiro: 'R$',
    unidade_dinheiro_litro: 'R$/L',
    upload: 'Upload',
    upload_acordo: 'Upload de Acordo',
    upload_arquivo_negociacao: 'Upload Arquivo de Negociação',
    upload_anexo: 'Upload de anexo',
    upload_evidencia: 'Upload de Evidência',
    upload_evidencia_layout: 'Evidência de Layout',
    upload_evidencia_orcamento: 'Evidência de Orçamento',
    upload_arquivo_obrigatorio: 'Upload de arquivo é obrigatório',
    upload_arquivo_sucesso: 'Upload de arquivo realizado com sucesso',
    upload_arquivo_obrigatorio_aprovacao: 'Upload de arquivo é obrigatório para solicitar aprovação',
    upload_obrigadorio_programa_marketing: 'Upload de arquivo Plano de Ação PDI Bônus é obrigatório para o programa de marketing {param}',
    usar_proprio_endereco: 'Usar o próprio endereço',
    usuario: 'Usuário | Usuários',
    usuario_alteracao: 'Usuário de alteração',
    usuario_aprovador: 'Usuário aprovador',
    usuario_criador: 'Usuário criador',
    usuario_criacao: 'Usuário de criação',
    usuario_externo_master: '{tipo_usuario} master',
    usuario_ultima_aprovacao: 'Usuário da última aprovação',
    usuarios_sem_perfil: 'Usuários sem Perfil',
    validacao: 'Validação | Validações',
    valor: 'Valor | Valores',
    valor_acao: 'Valor da ação',
    valor_acordo: 'Valor do acordo',
    valor_ajustado: 'Valor ajustado',
    valor_ajuste: 'Valor do ajuste',
    valor_base: 'Valor Base',
    valor_base_crescimento: 'Valor Base Crescimento',
    valor_bruto: 'Valor bruto',
    valor_confirmado_negociacao: 'Valor Confirmado Negociação',
    valor_consumido: 'Valor consumido',
    valor_consumido_orcamento: 'Valor consumido do orçamento',
    valor_contrato: 'Valor do contrato',
    valor_desdobramento: 'Valor Desdobramento',
    valor_disponivel: 'Valor disponível',
    valor_disponivel_pos_transferencia: 'Valor disponivel pós transferência',
    valor_encargos: 'Valor encargos',
    valor_final: 'Valor Final',
    valor_fixo: 'Valor fixo',
    valor_honorarios: 'Valor honorários',
    valor_icms: 'Valor ICMS',
    valor_ipi: 'Valor IPI',
    valor_pis_cofins: 'Valor PIS/COFINS',
    valor_aportado: 'Valor aportado',
    valor_aportar: 'Valor a aportar',
    valor_final_frete: 'Valor final frete',
    valor_historico: 'Valor histórico',
    valor_assinado: 'Valor assinado',
    valor_atual: 'Valor atual',
    valor_inicial: 'Valor Inicial',
    valor_investimento: 'Valor Investimento',
    valor_oi_invalido: 'Valor da soma das OI\'s inválido',
    valor_minimo: 'Valor mínimo',
    valor_negociado: 'Valor negociado',
    valor_nota_debito: 'Valor da Nota de Débito',
    valor_nf: 'Valor da NF',
    valor_nao_alocado: 'Valor não alocado',
    valor_orcamento: 'Valor do orçamento',
    valor_pago: 'Valor pago',
    valor_pagamento: 'Valor do Pagamento',
    valor_pagamento_calculado: 'Valor calculado do Pagamento',
    valor_percentagem_oi_invalido: 'A soma dos percentuais das OIs devem ser 100%',
    valor_planejado: 'Valor planejado',
    valor_provisionado: 'Valor provisionado',
    valor_realizado: 'Valor realizado',
    valor_realizado_original: 'Valor original',
    valor_realizado_solicitado: 'Valor alterado',
    valor_recebido: 'Valor recebido',
    valor_recebimento: 'Valor do recebimento',
    valor_reduzir: 'Valor a reduzir',
    valor_reivindicado: 'Valor reivindicado',
    valor_remanescente: 'Valor remanescente',
    valor_restante_orcamento: 'Valor restante do orçamento',
    valor_liquido: 'Valor líquido',
    valor_mercadoria: 'Valor da mercadoria',
    valor_percentual: 'Valor Percentual',
    valor_total: 'Valor total',
    valor_total_aprovado: 'Valor Total Aprovado',
    valor_total_pedido: 'Valor Total Pedido',
    valor_transferencia: 'Valor Transferência',
    valor_unitario: 'Valor Unitário',
    valor_variavel: 'Valor variável',
    variavel: 'Variável',
    var_margem: 'VAR Margem',
    var_investimento: 'VAR Investimento',
    var_investimento_trade: 'VAR Investimento Trade',
    vencimento: 'Vencimento',
    verba_sobre_fat: 'Verba sobre Fat.',
    vendedor: 'Vendedor',
    vendedores_usuario: 'Vendedores do usuário',
    ver_mais: 'Ver mais',
    ver_todos: 'Ver todos',
    verba: 'Verba',
    verba_aprovada: 'Verba aprovada',
    verba_disponivel: 'Verba disponível',
    verba_consumida: 'Verba consumida',
    verba_estrutural: 'Verba Estrutural | Verbas Estruturais',
    verba_excedente: 'Verba excedente',
    verba_liberada: 'Verba liberada?',
    verba_negociacao_preco: 'Verba de Negociação de Preço?',
    verba_tatica: 'Verba Tática | Verbas Táticas',
    verbas_tecnicas: 'Verbas Técnicas',
    verba_cliente_representante: 'Representante',
    verba_cliente_regional: 'Regional',
    valor_reservado: 'Valor reservado',
    view: 'View',
    views: 'Views',
    vigencia: 'Vigência',
    vigencia_contrato: 'Vigência do contrato',
    vigencia_aberta: 'Vigência aberta',
    vigencia_inicial: 'Vigência inicial',
    vigencia_final: 'Vigência final',
    vigencia_orcamento: 'Vigência do orçamento',
    vigencia_periodo_configurado: 'Vigência do período configurado',
    vinculo: 'Vínculo',
    vinculo_carteira_cliente: 'Vínculo na carteira de cliente',
    vinculo_industria: 'Vínculo com a indústria',
    visibilidade: 'Visibilidade',
    visao: 'Visão',
    visualizar: 'Visualizar',
    visualizar_acao: 'Visualizar ação',
    visualizar_cliente: 'Visualizar cliente | Visualizar clientes',
    visualizar_detalhes: 'Detalhes',
    visualizar_divisao: 'Visualizar divisão',
    visualizar_erros: 'Visualizar erros',
    visualizar_execucao: 'Visualizar execução',
    visualizar_gestor: 'Visualizar gestor | Visualizar gestores',
    visualizar_orcamento: 'Visualizar orçamento',
    visualizar_perfil: 'Visualizar perfil',
    visualizar_peca: 'Visualizar peças',
    visualizar_produto: 'Visualizar produto',
    visualizar_reporte: 'Visualizar Reporte',
    visualizar_usuario: 'Visualizar usuário',
    visualizar_estrutura_usuario: 'Visualizar estruturas de usuário',
    voltar: 'Voltar',
    voltar_dashboard: 'Voltar ao Dashboard Inicial',
    voltar_passo: 'Voltar passo',
    volume: 'Volume',
    volume_m: 'Volume (m³)',
    volume_produto: 'Volume do produto',
    vlr_adendo: 'Valor adendo',
    vlr_aditivo: 'Valor aditivo',
    vlr_aportado: 'Valor aportado',
    vlr_base_crescimento: 'Valor Base Crescimento',
    vlr_calculado: 'Calculado',
    vlr_conf_apuracao: 'Valor confirmado apuração',
    vlr_conf_negociacao: 'Confirmado negociação',
    vlr_consumido: 'Valor consumido',
    vlr_comp_orcamento: 'Complemento de orçamento',
    vlr_comprometido: 'Valor comprometido',
    vlr_incial_maior_vlr_final: 'O valor inicial é maior que o valor final',
    vlr_investido: 'Valor Investido',
    vlr_conflitante: 'Valores conflitantes com outro fluxo',
    vlr_gasto: 'Valor gasto',
    vlr_pendente: 'Pendente',
    vlr_planejado: 'Valor planejado',
    vlr_reducao: 'Valor redução',
    vlr_reivindicado: 'Reivindicado',
    vlr_reservado: 'Valor reservado',
    vlr_saldo: 'Saldo disponível',
    vlr_unitario: 'Vlr. Unitário',
    vlr_total: 'Vlr. Total',
    workflow: 'Workflow',
    workflow_aprovacao: 'Workflow de aprovação',
    workflow_buscar_grupos: 'Buscar Perfis',
    workflow_buscar_subgrupos: 'Buscar Estruturas de Usuário',
    workflow_buscar_usuarios: 'Buscar Usuários',
    worfklow_passo: 'Passo {passo}',
    workflow_seleciona_aprovador: 'Seleciona aprovador?',
    workflow_solicitante: 'Solicitante',
    workflow_solicitante_grupo: 'Perfil',
    workflow_solicitante_usuario: 'Usuário',
    workflow_tooltip: '{placeholder} do Workflow',
    email_alerta: 'Email de Alerta',
    status_em_cadastro: 'Status "Em cadastro": Enviar email após',
    status_em_aprovacao: 'Status "Aguardando aprovação": Enviar email após',
    status_em_analise: 'Status "Em análise": Enviar email após',
    status_em_apuracao: 'Status "Aguardando apuração": Enviar email após',
    status_em_pendente_integracao: 'Status "Pendente integração": Enviar email após',
    status_em_aguardando_pagamento: 'Status "Aguardando Pagamento": Enviar email após',
    dias_inatividade: 'dias de inatividade.',
    ativar_envio_email: 'Ativar o envio de email alternativo:',
    data_inativacao: 'Data Inativação'
  },
  message: {
    acao_aprovada: 'Ação aprovada.',
    acao_atualizada: 'Ação atualizada com sucesso.',
    acao_cancelada: 'Ação cancelada com sucesso.',
    acao_enviada_analise: 'Ação enviada para análise.',
    acao_necessaria_contrato: 'Nenhuma ação associada ao contrato',
    acao_nao_reportada: 'Ação não reportada. É obrigatório realizar o Reporte da ação antes de enviar o Pagamento para aprovação.',
    acao_reprovada: 'Ação reprovada.',
    acao_pdv_remover_material: 'A ação PDV precisa ter pelo menos um material.',
    acesso_negado: 'Acesso negado.',
    acao_removida: 'Ação removida com sucesso.',
    acoes_saldo_de_para: 'Todas as ações e saldo do usuário {de} serão transferidos permanentemente para {para};',
    acrescente_um_peca_carrinho: 'Acrescente pelo menos 01 para incluir a peça no carrinho.',
    advertencia_periodos_iguais: 'Ao selecionar períodos de orçamento igual aos períodos de planejamento, todos os períodos de orçamento previamente incluídos, serão excluídos e substituídos por períodos idênticos aos períodos planejados. Deseja continuar?',
    copiado_area_transferencia: 'Copiado para a área de transferência',
    pwd_min: 'Mínimo de {n} caracteres',
    pwd_lower: 'Pelo menos 1 letra minúscula',
    pwd_upper: 'Pelo menos 1 letra maiúscula',
    pwd_digit: 'Pelo menos 1 número',
    pwd_special: 'Pelo menos 1 caractere especial',
    nao_foi_possivel_copiar: 'Não foi possível copiar',
    ajuda: {
      parametrizacao_orcamento: {
        campo_padrao: 'Apresenta os campos padrões que sempre farão parte do cadastro do orçamento e sua obrigatoriedade',
        campos_customizados: 'Apresenta os campos customizados, ativos e associados a entidade Orçamento. Caso ele faça parte do cadastro do orçamento você deve <br />selecionar as opções "Resumo" (informações gerais do orçamento) ou "Linha de investimento" (detalhe da alocação de verba no orçamento)',
        campos_gerais: '<ol><li>Centro de custo: para incluir esses campos no cadastro do orçamento você deve selecionar as opções "Resumo" <br />(informações gerais do orçamento) ou "Linha de investimento" (detalhe da alocação de verba no orçamento)</li></ol>',
        cliente: '<ol><li>Para incluir alguma informação de cliente no cadastro do orçamento você deve selecionar as opções "Resumo" <br />(informações gerais do orçamento) ou "Linha de investimento" (detalhe da alocação de verba no orçamento)</li><li>Se você selecionar Cliente a seleção será um cliente específico, por esse motivo recomenda-se não incluir essa opção <br />no Resumo do orçamento mas sim no detalhe na linha de investimento</li><li>Se você selecionar Canal a seleção será um Canal específico, por esse motivo recomenda-se não incluir essa opção <br /> no Resumo do orçamento mas sim no detalhe na linha de investimento</li></ol>',
        comportamento: 'Define como o orçamento será planejado: <ol><li>Com preenchimento manual o cadastro do orçamento será manual</li><li>Com preenchimento automático sem projeção de verba será aplicada normalmente para verbas de cliente. O Tradelinks irá disponibilizar <br />automaticamente a verba a partir do cumprimento de alguma ação acordada com o cliente</li><li>Com preenchimento automático com projeção de verba será aplicada normalmente para verbas de cliente. O Tradelinks irá disponibilizar automaticamente <br />a verba a partir do cumprimento de alguma ação acordada com o cliente porém poderá ser informada manualmente a projeção de <br />verba esperada antes que as ações sejam apuradas</li></ol>',
        divisao: '<ol><li>A divisão sempre estará associada a linha de investimento</li><li>Selecione apenas as divisões que são responsáveis por iniciar a distribuição de verba após conclusão/aprovação do orçamento</li><li>Se você selecionou uma Divisão pai de alguma outra Divisão, as divisões filhas não poderão ser selecionadas</li></ol>',
        grid_filtros: 'Definição dos campos que serão apresentados no grid e/ou filtro: <br />Restrições de grid <ol><li>Os campos de linha de orçamento não serão apresentados no grid</li><li>Os campos com apresentação pré-definida no grid não poderão ser retirados</li></ol> Restrições de filtro<ol><li>Campos padrões: os campos textos e numéricos não poderão compor o filtro</li><li>Campos customizados: apenas os campos customizados dos tipos Lista, Múltipla escolha e Sim/Não poderão compor os filtros</li></ol>',
        ordenacao: 'Ordenação dos campos apresentados no formulário de cadastro, edição e rateio do orçamento. Essa ordenação será considerada <br />para apresentação dos campos no grid de listagem do orçamento',
        produto: '<ol><li>Para incluir alguma informação de produto no cadastro do orçamento você deve selecionar as opções "Resumo" <br />(informações gerais do orçamento) ou "Linha de investimento" (detalhe da alocação de verba no orçamento)</li><li>Recomenda-se incluir no resumo do orçamento campos mais abrangentes como Marca e Categoria e no detalhe na linha <br />de investimento campos menos gerais como produto (SKU)</li></ol>',
        rateio: 'Forma de rateio por divisão <ol><li>O rateio por Divisão deverá ser utilizado quando a distribuição de verba é realizada considerando a estrutura <br />organizacional da indústria que poderá ser geográfica ou não</li><li>Para a identificação das divisões que farão parte do rateio serão consideradas todas as divisões <br />associadas a(s) divisão(ões) selecionadas no Passo 2</li><li>A composição por Canal e/ou Cliente só serão apresentadas se foram selecionadas no Passo 2 e caso sejam <br />selecionadas atuarão para restrição na pesquisa das divisões</li></ol>',
        resumo: '<ol><li>Nome e descrição do tipo de orçamento. O nome será apresentado no menu Novo da tela de Orçamento</li><li>Ícone que será apresentado no menu Novo da tela de Orçamento e deve receber o nome da imagem do material design</li><li>Qualquer alteração nas configurações desse tipo de orçamento será aplicada para os novos orçamentos. Os demais status <br />(Em cadastro, Aprovado, Aguardando aprovação, Em análise, Reprovado e Cancelado) não serão impactados</li></ol>',
        tipo_investimento: 'Define quais investimentos poderão ser planejados para o tipo de orçamento. Se um Tipo de Investimento for inativado ele não será apresentado',
        validacao: '<ol><li>Habilitar alocação da verba parcial: caso essa regra seja habilitada, o usuário poderá concluir ou enviar um <br />fluxo de aprovação de orçamento sem distribuir totalmente o valor do orçamento</li></ol>'
      },
      parametrizacao_acao: {
        acesso_cliente: 'Habilite essa opção caso o cliente da indústria possa criar ações desse tipo de ação',
        acesso_divisao: 'Selecione as divisões que poderão criar esse tipo de ação na tela de Planejamento. Caso não seja selecionada uma Divisão, todos os usuários com privilégios poderão criar esse tipo de ação',
        acesso_estrutura_usuario: 'Selecione as estruturas de usuário que poderão criar esse tipo de ação na tela de Planejamento. <br />Caso não seja selecionada uma Estrutura de usuário, todos os usuários com privilégios poderão criar esse tipo de ação',
        apuracao: 'Configure como será a apuração da ação: <br />Manual (upload de evidência manual) ou <br />Automática (calculado a partir da importação de SellIn e/ou SellOut a partir de um template de cálculo)',
        apuracao_base_calculo: 'Para as metas de valor com forma de bonificação em percentual,<br /> representa se o foco será o valor líquido ou bruto do SellIn para cálculo do atingimento ou <br />pagamento da meta ou SellOut para cálculo do atingimento da meta',
        apuracao_bonificacao: 'Representa como será calculado o pagamento caso a meta definida na ação seja atingida: <ol><li>Fixo: pagamento de um valor fixo</li><li>Variável: pagamento calculado para cada unidade vendida paga-se um valor</li><li>Percentual: pagamento a partir de um percentual do valor líquido ou bruto do SellIn</li></ol>',
        apuracao_evidencia: 'Defina se o upload de evidências será habilitado na Apuração.',
        apuracao_inicio: 'Defina quando a ação poderá ser apurada: <br />após a conclusão do período da vigência ou a partir do início da vigência',
        apuracao_meta_beneficio: 'Representa o foco da definição da meta de atingimento desse tipo de ação, <br />ou seja, se o foco será Valor ou Volume baseado no SellIn ou SellOut. <br />Essa informação será utilizada para calcular se o cliente atingiu a meta acordada',
        apuracao_pagamento: 'Defina quais as opções de pagamento desse tipo de ação',
        apuracao_periodo: 'Defina como serão os períodos de apuração do tipo de ação. <br />Isso permite que uma mesma ação seja apurada em vários períodos. <br />A opção “Específico” estará habilitada se a vigência for configurada como aberta no Passo 4',
        apuracao_vendas: 'Fornece a razão entre o valor da ação (investimento) <br /> sobre o faturamento (líquido ou bruto) do SellIn para apoio na avaliação da ação.',
        campo_padrao: 'Apresenta os campos padrões que sempre farão parte do cadastro do tipo de ação e sua obrigatoriedade. <br />Além disso, você pode definir qual o campo poderá ser editado quando a ação estiver no status aprovado',
        campos_customizados: 'Apresenta os campos customizados, ativos e associados a entidade Ação. Caso ele faça parte do cadastro da ação você deve <br />selecionar pelo menos uma opção do Fluxo de Trademarketing (Planejamento, Execução, Apuração e/ou Pagamento).<br />Essas opções serão apresentadas conforme opção selecionada no Passo 1 – Fluxo de Trademarketing.<br />Além disso, você pode definir qual o campo poderá ser editado quando a ação estiver no status aprovado',
        cliente: 'Informe pelo menos uma opção para habilitar a informação de cliente na criação desse tipo de ação.<br />Isso é necessário pois toda ação deve ter como foco um cliente específico ou uma holding.<br />Caso necessário, informe se terá a informação de cliente pagador',
        grid_filtros: 'Definição dos campos que serão apresentados no grid e/ou filtro: <br />Restrições de grid <ol><li>Os campos com apresentação pré-definida no grid não poderão ser retirados</li></ol> Restrições de filtro<ol><li>Campos padrões: os campos textos e numéricos não poderão compor o filtro</li><li>Campos customizados: apenas os campos customizados dos tipos Lista, Múltipla escolha e Sim/Não poderão compor os filtros</li></ol>',
        ordenacao: 'Ordenação dos campos apresentados no formulário de cadastro, consulta e edição do tipo de ação.<br />Essa ordenação será considerada para apresentação dos campos no grid de listagem das ações',
        pagamento: 'Defina se é permitido o pagamento parcial. Além disso, configurar se existe ou não integração de pagamento com software terceiro',
        periodo: 'Escolha como será a definição da vigência da ação. Se poderá ser escolhida pelo usuário ou se deverá respeitar o período de planejamento configurado na tela de Período',
        produto: '<ol><li>Para incluir alguma informação de produto no cadastro da ação você deve selecionar pelo menos uma opção do Fluxo de Trademarketing (Planejamento, Execução, Apuração e/ou Pagamento).<br />Essas opções serão apresentadas conforme opção selecionada no Passo 1 – Fluxo de Trademarketing</li><li>Defina também se o campo é obrigatório no cadastro da ação, ou seja, no módulo Planejamento</li></ol>',
        resumo: '<ol><li>Nome e descrição do tipo de ação. O nome será apresentado no menu Novo da tela de Planejamento</li><li>Qualquer alteração nas configurações desse tipo de ação será aplicada para as novas ações. Os demais status (Em cadastro, Aprovado, Aguardando aprovação, Em análise, Reprovado e Cancelado) não serão impactados</li>',
        tipo_investimento: 'Selecione as contas correntes que esse tipo de ação poderá creditar ou debitar verba. Caso nenhuma conta corrente seja habilitada não haverá controle de verba na criação da ação',
        valor: 'Configure se o valor da ação será informado manualmente ou será calculado a partir de um template de cálculo',
        vinculo: 'Para cada tipo de orçamento defina quais as informações em comuns parametrizadas na ação e no tipo de orçamento devem ser consideradas e validadas na criação da ação'
      },
      transferencia_definitiva: {
        carteira_cliente: '<ol><li>Apresenta a carteira de clientes do usuário de origem selecionado no Passo 1.<br/>A carteira apresentada é composta somente de clientes que ainda não fazem parte da carteira de clientes do usuário de destino</li><li>A carteira de clientes é utilizada para recuperar os clientes e holdings do usuário ao criar uma nova negociação</li></ol>',
        cenario: 'Selecione o cenário de transferência de hierarquia.<br/>Atente para o tipo de cenário selecionado com o motivo que originou a realização dessa transferência.<br/>Se o motivo não se enquadrar em nenhum dos cenários apresentados, entre em contato com o suporte para alinhar sobre a necessidade.',
        cliente: '<ol><li>Apresenta todos os clientes cujo usuário de origem selecionado no Passo 1 está sinalizado como responsável principal pelo faturamento. A responsabilidade apresentada é composta somente de clientes que o usuário de destino não é o responsável principal</li><li>A responsabilidade pelo faturamento é utilizada nos relatórios gerenciais na consolidação dos valores de faturamento por vendedor e gestor</li></ol>',
        motivo: 'Informe o motivo que originou a realização dessa transferência.',
        orientacao_geral: 'A transferência definitiva se aplica quando um funcionário da AB Brasil for assumir definitivamente as ações, carteira de clientes e verba nos orçamentos vigentes de um outro funcionário, que por algum motivo deixará de exercer as suas funções no time comercial.',
        orientacao_geral_premissa: 'Segue algumas premissas dessa operação:',
        orientacao_geral_premissa_1: 'A operação é irreversível, ou seja, todos as operações de cada cenário não poderão ser desfeitas após a confirmação. Somente uma nova transferência definitiva poderá desfazer essas operações;',
        orientacao_geral_premissa_2: 'A operação só poderá ser realizada entre funcionários de mesmo Canal e Unidade de Negócio;',
        orientacao_geral_premissa_3: 'Os totais de faturamento e investimento (apresentados nos relatórios gerenciais) e que foram impactados pela transferência, passarão a compor os valores do funcionário que assumiu as funções do outro funcionário e sua respectiva hierarquia;',
        orientacao_geral_premissa_4: 'Os totais de orçamento apresentados no relatório Plano Comparativo, apresentarão os seus totais nos meses selecionados na transferência do funcionário que assumiu as funções do outro funcionário e sua respectiva hierarquia. Nos demais meses os valores estarão no funcionário que foi substituído e na sua hierarquia.',
        selecao_carteira: 'Se você deseja transferir parcialmente a carteira do usuário de origem, utilize os filtros para selecionar os clientes desejados.<br/>Caso você transfira a carteira completa, não é necessário a utilização dos filtros.',
        selecao_cliente: 'Se você deseja transferir parcialmente a responsabilidade pelo faturamento do usuário de origem, utilize os filtros para selecionar os clientes desejados.<br/>Caso você transfira a responsabilidade completa, não é necessário a utilização dos filtros.',
        selecao_orcamentos: 'Selecione os orçamentos que deverão ser transferidos. A partir desses orçamentos é que as ações serão identificadas e transferidas.',
        transferencia_carteira: '<ol><li>Transferir toda a carteira de clientes: transfere totalmente a carteira de clientes do usuário de origem para o usuário de destino</li><li>Transferir a carteira selecionado no filtro: transfere a carteira de clientes  resultado dos filtros selecionados do usuário de origem para o usuário de destino</li><li>Transferir os clientes selecionados: transfere somente os clientes selecionados na seção Carteira de clientes do usuário de origem para o usuário de destino</li></ol>',
        transferencia_responsabilidade_faturamento: '<ol><li>Transferir toda a responsabilidade: transfere totalmente a responsabilidade de faturamento de clientes do usuário de origem para o usuário de destino</li><li>Transferir todos os clientes selecionados no filtro cujo usuário de origem é o responsável principal : transfere a responsabilidade de faturamento dos clientes resultado dos filtros selecionados do usuário de origem para o usuário de destino</li><li>Transferir apenas os clientes selecionados cujo usuário de origem é o responsável principal : transfere a responsabilidade de faturamento dos clientes selecionados na seção Clientes do usuário de origem para o usuário de destino</li></ol>',
        usuario_de: '<ol><li>Se cenário 1 selecionado: Selecione o vendedor que você deseja alterar o gestor (superior imediato).</li><li>Se cenário 2 selecionado: Selecione o vendedor de origem do qual você está transferindo as ações, verba e carteira de clientes.</li><li>Se cenário 3 selecionado: Selecione o gestor de origem do qual você está transferindo as ações, verba e carteira de clientes. Obrigatoriamente o superior imediato do time de vendedores do gestor de origem será alterado para o gestor de destino.</li><li>Se cenário 4 selecionado: Selecione o usuário que faz parte da hierarquia de distribuição de verba no rateio e que não atua como vendedor para incluí-lo no rateio dos orçamentos aprovados.</li></ol>',
        usuario_para: '<ol><li>Se cenário 1 selecionado: Selecione o novo gestor (superior imediato) do vendedor selecionado na seção De.</li><li>Se cenário 2 selecionado: Selecione o vendedor de destino que assumirá definitivamente as ações, verba e carteira de clientes do vendedor selecionado na seção De.</li><li>Se cenário 3 selecionado: Selecione o gestor de destino que assumirá definitivamente as ações, verba e carteira de clientes do gestor selecionado na seção De.</li><li>Se cenário 4 selecionado: Selecione o usuário de destino que assumirá a distribuição da verba na hierarquia dos rateios de orçamento já criados, aprovados e vigentes.</li></ol>'
      },
      parametrizacao_periodo: {
        remover_condicao: 'Esta operação será irreversível, deseja prosseguir e remover esta condição percentual?'
      }
    },
    aporte_automatico_com_projecao: 'Aporte automático com projeção de verba',
    aporte_automatico_sem_projecao: 'Aporte automático sem projeção de verba',
    aporte_manual_verba: 'Aporte manual de verba',
    aporte_saldo_negativo: 'Saldo insuficiente.',
    aprovacao_transferida: 'Aprovação transferida com sucesso',
    apuracao_nao_finalizada_vlr_recebimento: 'Esta apuração não será finalizada por não ter valor de recebimento.',
    aprovado_sucesso: 'Item aprovado com sucesso!',
    apuracao_fluxo_cancelado: 'Fluxo da apuração cancelado.',
    apuracao_enviada_analise: 'Apuração enviada para análise.',
    apuracao_finalizada_sem_fluxo: 'Apuração aprovada automaticamente. Não há fluxo de aprovação.',
    apuracao_reprovada: 'Apuração reprovada',
    arquivo_removido: 'Arquivo removido com sucesso.',
    associar_carteira_cliente: 'Deve existir pelo menos uma carteira associada ao Cliente',
    associar_produto_fornecedor: 'Deve existir pelo menos um produto associado ao Fornecedor',
    associar_tipo_acao_contrato: 'Deve existir pelo menos um tipo de ação associado ao Contrato',
    adicionado_confira_tabela: 'Adicionado com sucesso!',
    adicionar_meta: 'Adicione uma meta para criar um acordo',
    adicionar_negociacao: 'Adicione uma negociação para criar um meta',
    acordos_datas_mesmo_mes: 'Data inicial e final devem pertencer ao mesmo mês',
    acordos_por_salvar: 'Tem acordos sem salvar, confira na tabela',
    autocomplete_required: 'Execute a busca e selecione um(a) {entidade}',
    atualizado_com_sucesso: 'Atualizado com sucesso.',
    atualizado_confira_tabela: 'Atualizado com sucesso.',
    alteracao_massa_sucesso: 'Alteração em massa executada com sucesso.',
    alteracao_nao_salvas: 'Você irá perder as alterações não persistidas, deseja realmente sair?',
    acompanhamento_finalizado: ' não possue histórico de acopanhamento de Workflow, pois foi finalizado.',
    alterar_forma_bonificacao_redefinir_meta: 'Ao alterar o Tipo de verba você terá que redefinir a verba de todos os intervalos cadastrados. | Ao alterar o Tipo de verba você terá que redefinir a verba de todos os intervalos cadastrados. Deseja continuar?',
    acordo_alterado: 'Acordo atualizado com sucesso!',
    acordo_aprovado: 'Acordo(s) aprovado(s).',
    acordo_enviado_analise: 'Acordo(s) enviado(s) para análise.',
    acordo_possui_fluxo_apuracao_em_andamento: 'Acordo possui fluxo de aprovação de apuração em andamento. Não será possível encerrá-lo.',
    acordo_reprovado: 'Acordo(s) reprovado(s).',
    acordo_finalizado: 'Acordo finalizado com sucesso!',
    acordo_incluido: 'Acordo incluído com sucesso!',
    acordo_cancelar: 'Acordo cancelado!',
    acordo_encerrado: 'Acordo(s) encerrado(s)!',
    acordo_em_cadastro: 'Acordo em cadastro',
    acordo_nao_esta_aprovado: function acordo_nao_esta_aprovado(desAcordo, descNegociacao) {
      return 'Acordo n\xE3o est\xE1 aprovado! Acordo: ' + desAcordo + ', Negocia\xE7\xE3o: ' + descNegociacao;
    },
    ajuste_verba_aprovado: 'Ajustes(s) de verba aprovado(s).',
    ajuste_verba_orcamento: 'Esta alteração ocasionará ajuste no saldo do Orçamento.',
    confirmacao_liberacao_saldo_orcamento: 'Ao alterar o valor de pagamento de {valorOriginal} para {valorAlterado}, serão devolvidos {valorDelta} do saldo comprometido da ação ao orçamento (rateado nos meses do período). Deseja continuar?',
    confirmacao_solicitacao_saldo_orcamento: 'Essa alteração solicita {valorDelta} adicionais do orçamento. O valor será rateado igualmente entre os meses do período, conforme o saldo disponível de cada mês. Deseja continuar?',
    confirmacao_alteracao_pagamento_sem_saldo: 'O valor de pagamento será alterado de {valorOriginal} para {valorAlterado}, sem ajuste de saldo no orçamento. Deseja continuar?',
    ajuste_verba_reprovado: 'Ajustes(s) de verba reprovado(s).',
    ajuste_verba_finalizado: 'Ajustes de verba finalizado.',
    ajuste_verba_enviado_aprovacao: 'Ajustes de verba enviado para aprovação.',
    ano_anterior_ano_atual_igual: 'Ano fiscal anterior igual ao atual',
    ajuste_verba_erro_azion: 'Operação não concluída devido a restrições de segurança.Entre em contato com o suporte para mais informações.',
    ao_concluir_transferencia_operacoes_efetivadas: 'Ao concluir essa transferência, as seguintes operações serão efetivadas:',
    apos_efetivacao_transferencia_nao_desfeita: 'Após efetivação da transferência, a mesma não poderá ser desfeita.',
    apuracao_ajustada: 'Apuração ajustada.',
    apuracao_aprovada: 'Apuração aprovada.',
    apuracao_finalizada: 'Apuração finalizada!',
    apuracao_iniciou_fluxo: 'Apuração iniciou fluxo!',
    apuracao_passos_aprovar: 'Passo(s) apuracao aprovado(s) com sucesso!',
    apuracao_passos_enviar_analise: 'Passo(s) apuracao enviado(s) para análise com sucesso!',
    apuracao_passos_reprovar: 'Passo(s) apuracao reprovado(s) com sucesso!',
    apuracao_reivindicacao_aprovar: 'Passo(s) Reivindicação aprovada com sucesso!',
    apuracao_reivindicacao_enviar_analise: 'Reivindicação(ções) apuracao enviado(s) para análise com sucesso!',
    apuracao_reivindicacao_reprovar: 'Reivindicação(ções) reprovada(s) com sucesso!',
    apuracao_reprocessada: 'Apuração reprocessada com sucesso!',
    apuracao_resgatada: 'Apuração resgatada com sucesso!',
    arquivo_evidencia_obrigatorio: 'Não foi possível finalizar/enviar para fluxo de aprovação. Arquivo de evidência, é obrigatório!',
    arquivo_evidencia_obrigatorio_sellin: 'Upload de arquivo obrigatório. Meta sem comprovação de SellIn.',
    arqivos_execucao_inexistente: 'Não existem arquivos de execução.',
    ativado_com_sucesso: 'Ativado com Sucesso',
    alteracoes_aplicadas_orcamentos_vendedor_de: 'As alterações serão aplicadas para todos os orçamentos que o usuário {de} está associado;',
    aviso_anexar_evidencias: 'Antes de enviar o acordo para aprovação, anexe os arquivos de evidência disponíveis.',
    alterar_ano_fiscal: 'Este procedimento irá alterar um Período existente conforme dados informados. Deseja continuar a operação?',
    bloqueio_efetuado_com_sucesso: 'Bloqueio efetuado com sucesso',
    bloqueio_periodo_fiscal_enviado: 'Bloqueio encaminhado com sucesso. Assim que o procedimento for finalizado, você será notificado.',
    bloqueio_sistema: 'Há um período de fechamento ativo no momento. Algumas funcionalidades estarão indisponíveis.',
    campo_obrigatorio: 'Este campo é obrigatório',
    campo_obrigatorio_ou_invalido: 'Campo obrigatório ou inválido',
    campo_formato_invalido: 'Formato do campo inválido. Exemplo válido: {exemplo}',
    campo_obrigatorio_item_especifico: 'Favor informar {nome_campo} do item {nome_item}',
    campo_obrigatorio_pessoa_juridica: 'Este campo é obrigatório para Pessoa Jurídica',
    cancelado_confira_tabela: 'Cancelado com sucesso!',
    cancelar_entrega_materiais: 'Você está ciente que ao selecionar essa opção, os materiais retornarão à "Qtd Disponível" e esta ação não receberá nenhum material.',
    cancelamento_execucao_negado_orcamento_aprovado: 'Não foi possível cancelar a execução, pois existe um orçamento aprovado para esta ação.',
    cancelamento_execucao_negado_pagamento_iniciado: 'Não foi possível cancelar a execução, pois o pagamento já foi realizado.',
    cancelamento_execucao_negado_um_item_iniciado: 'Não foi possível cancelar a execução, pois existe {item} item com pagamento concluído para esta ação. | Não foi possível cancelar a execução, pois existem {item} itens com pagamento concluído para esta ação.',
    cancelamento_execucao_negado_reporte_iniciado: 'Não foi possível cancelar a execução, pois existe um reporte cadastrado para esta ação.',
    carteira_cliente_erro_inativar: 'Areas de atuação com vínculos. Impossível inativar.',
    carteira_cliente_responsavel_serao_ajustadas: 'A carteira de clientes e responsabilidade no faturamento serão ajustadas conforme seleção;',
    catalogo_material_download: 'O download do catálogo de materiais começará em breve!',
    catalogo_peca_download: 'O download do catálogo de peças começará em breve!',
    classificacao_invalida: 'A classificação não é válida para solicitar aprovação.',
    classificacao_nao_selecionada: 'Classificação não selecionada.',
    classificacao_nao_configurada: 'Classificação não configurada.',
    cnpj_tamanho: 'O tamanho do CNPJ deve ser de 14 dígitos',
    cpf_tamanho: 'O tamanho do CPF deve ser de 11 dígitos',
    documento_invalido: 'Documento inválido. Informe um CPF (11 dígitos) ou um CNPJ (14 caracteres alfanuméricos), conforme IN RFB nº 2.229/2024.',
    condicao_percentual_aprovada: 'Condição percentual aprovada.',
    condicao_percentual_enviada_analise: 'Condição percentual enviada para análise.',
    confirmacao_alterar_email: 'Confirma alteração destes emails ?',
    concluir_frete_materiais: 'Confirma a opção de frete escolhida?',
    concluir_aporte: 'Deseja concluir este aporte?',
    concluir_reducao: 'Deseja concluir esta redução?',
    configuracao_produto_ja_utilizada: 'Já existe uma ação criada para esse contrato com as mesmas configurações de produto. (Ação "{descricao}")',
    configuracao_conflito: 'Configuração em conflito!',
    configuracao_cancelar: 'As configurações definidas até o momento serão perdidas, deseja cancelar mesmo assim?',
    configuracao_voltar_passo: 'As configurações não salvas deste passo serão perdidas, deseja voltar mesmo assim?',
    configuracao_salva: 'Configuração salva com sucesso!',
    configuracao_finalizada: 'Configuração finalizada com sucesso!',
    confirmacao_peca_sem_foto: 'Nenhuma foto foi carregada para esta Peça, deseja continuar?',
    confirmacao_drop_cache: 'Confirma drop cache?',
    conta_corrente_filtros_alterados: 'As alterações realizadas refletirão na seleção das contas correntes no Passo 3 e você deverá distribuir verba novamente. Deseja continuar?',
    contrato_anexacao_desabilitada: 'Só é possível inserir anexos com o DPM salvo.',
    contrato_aprovado: 'Contrato aprovado.',
    contrato_cancelado: 'Contrato cancelado com sucesso.',
    contrato_cancelar: 'Contrato cancelado!',
    contrato_encerrar: 'Contrato encerrado!',
    contrato_enviado_analise: 'Contrato enviado para análise.',
    contrato_finalizado: 'Contrato finalizado com sucesso!',
    contrato_finalizado_sem_fluxo: 'Contrato finalizado sem fluxo de aprovação',
    contrato_reprovado: 'Contrato reprovado.',
    criar_ano_fiscal: 'Este procedimento irá criar um novo Período conforme dados informados. Deseja continuar a operação?',
    data_entrega_desejada: 'Data de entrega desejada inválida.',
    data_inicial_invalida: 'Data inicial inválida. Verifique o formato.',
    data_inicio_invalida: 'Data ou hora inicial inválida. Verifique o formato.',
    data_invalida: 'Data inválida. Verifique o formato.',
    data_fim_invalida: 'Data ou hora final inválida. Verifique o formato.',
    data_final_invalida: 'Data final inválida. Verifique o formato.',
    data_final_antes_inicial: 'Data inicial maior ou igual que data final.',
    data_inicial_maior_final: 'Data Inicial maior que a Data Final.',
    data_inicial_menor_dia_seguinte: 'Data Inicial menor que o Dia Seguinte.',
    data_final_e_inicial: 'Data inicial e final devem ser informadas.',
    definir_todas_data_contabilizacao: 'Define a data de contabilização para todas as notas de débito selecionadas.',
    desbloqueio_efetuado_com_sucesso: 'Desbloqueio efetuado com sucesso',
    desbloqueio_periodo_fiscal_enviado: 'Desbloqueio encaminhado com sucesso. Assim que o procedimento for finalizado, você será notificado.',
    deseja_adicionar_acao: 'Deseja adicionar esta ação?',
    deseja_adicionar_carrinho: 'Deseja adicionar esta peça ao carrinho?',
    deseja_aplicar_data_contabilizacao: 'Deseja aplicar esta data para os itens selecionados?',
    deseja_ajustar_acordo: 'Deseja ajustar o Acordo?',
    deseja_ativar_inativar: 'Deseja ativar/inativar o registro?',
    deseja_aprovar: 'Deseja aprovar o(s) item(ns)?',
    deseja_aprovar_ajuste_verba: 'Deseja aprovar o(s) ajustes(s) de verba?',
    deseja_aprovar_contrato: 'Deseja aprovar contrato?',
    deseja_aprovar_item: 'Deseja aprovar o item?',
    deseja_aprovar_layout: 'Deseja aprovar o layout?',
    deseja_aprovar_planejamento: 'Deseja aprovar planejamento?',
    deseja_aprovar_orcamento: 'Deseja aprovar o(s) orçamento(s)?',
    deseja_aprovar_transferencia: 'Deseja aprovar a(s) transferência(s)?',
    deseja_aprovar_servico: 'Deseja aprovar o serviço?',
    deseja_cancelar_acao: 'Deseja cancelar essa ação?',
    deseja_cancelar_acordo: 'Deseja cancelar o(s) acordo(s)?',
    deseja_cancelar_apuracao: 'Deseja cancelar a apuração?',
    deseja_cancelar_contrato: 'Deseja cancelar esse contrato?',
    deseja_cancelar_edicao: 'Deseja cancelar a edição?',
    deseja_cancelar_evento: 'Deseja cancelar este evento?',
    deseja_cancelar_execucao: 'Deseja cancelar a execução?',
    deseja_cancelar_pagamento: 'Deseja cancelar o pagamentos?',
    deseja_cancelar_pagamento_acao: 'Deseja cancelar este item da ação?',
    deseja_cancelar_planejamento: 'Deseja cancelar o planejamento?',
    deseja_cancelar_orcamento: 'Deseja cancelar o(s) orçamento(s)?',
    deseja_cancelar_recebimento: 'Deseja cancelar o recebimento?',
    deseja_cancelar_transferencia: 'Deseja cancelar a transferência?',
    deseja_concluir: 'Deseja concluir este(a) {text}?',
    deseja_concluir_apuracao: 'Deseja concluir essa apuração? </br> Após conclusão, será criado o recebimento e a apuração não poderá ser mais alterada',
    deseja_concluir_materiais: 'Deseja concluir estes materiais?',
    deseja_concluir_edicao: 'Deseja concluir a edição deste(a) {text}?',
    deseja_concluir_edicoes: 'Deseja concluir a edição destes(as) {text}?',
    deseja_concluir_planejamento: 'Deseja concluir este planejamento?',
    deseja_confirmar_conclusao: 'Deseja confirmar conclusão?',
    deseja_continuar: 'Deseja continuar?',
    deseja_editar_item: 'Deseja editar o item?',
    deseja_desfazer_solicitacao_reembolso: 'Deseja desfazer a solicitação de reembolso?',
    deseja_encerrar_acordo: 'Deseja encerrar o(s) acordo(s)?',
    deseja_enviar_analise: 'Deseja enviar para análise?',
    deseja_enviar_analise_planejamento: 'Deseja enviar para análise o planejamento?',
    deseja_enviar_aprovacao_orcamento: 'Deseja enviar o orçamento para aprovação?',
    deseja_enviar_aprovacao_layout: 'Deseja enviar o layout para aprovação?',
    deseja_excluir: 'Deseja excluir {text}?',
    deseja_excluir_indicador: 'Em caso de exclusão, o indicador não será utilizado na composição de pontos da Classificação. Deseja continuar?',
    deseja_excluir_configuracao_classificacao: 'Deseja excluir a configuração da classificação?',
    deseja_executar_analise: 'Deseja executar a análise?',
    deseja_executar_analise_acao: 'Deseja executar a análise desta ação?',
    deseja_executar_analise_condicao_percentual: 'Deseja executar a análise desta condição percentual?',
    deseja_executar_analise_contrato: 'Deseja executar a análise deste contrato?',
    deseja_executar_analise_planejamento: 'Deseja executar a análise do planejamento?',
    deseja_exportar: 'Deseja realizar exportação?',
    deseja_finalizar_orcamento: 'Deseja finalizar o orçamento?',
    deseja_finalizar_contrato: 'Deseja finalizar o contrato?',
    deseja_gerar_grade: 'Deseja gerar grade?',
    deseja_importar: 'Deseja importar?',
    deseja_importar_novo: 'Deseja importar novo',
    deseja_imprimir: 'Deseja realizar a impressão?',
    deseja_ativar_inativar_registros: 'Deseja ativar/inativar os {quantidade} registro(s) selecionado(s)?',
    deseja_realizar_alteracao: 'Deseja realizar a alteração?',
    deseja_redefinir_senha: 'Deseja redefinir senha?',
    deseja_reenviar_pagamento: 'Deseja reenviar o pagamento?',
    deseja_reenviar_recebimento: 'Deseja reenviar o recebimento?',
    deseja_remover_estrutura_pai: 'Deseja remover a estrutura pai?',
    deseja_remover_material: 'Deseja remover este material?',
    deseja_remover_meta: 'Deseja remover a meta?',
    deseja_remover_peca: 'Deseja remover a peça?',
    deseja_remover_todas_peca: 'Deseja remover todas as peças?',
    deseja_remover_servico: 'Deseja remover o serviço da ação?',
    deseja_reprovar: 'Deseja reprovar o(s) item(ns)?',
    deseja_reprovar_ajuste_verba: 'Deseja reprovar o(s) ajustes(s) de verba?',
    deseja_reprovar_item: 'Deseja reprovar o item?',
    deseja_reprovar_planejamento: 'Deseja reprovar planejamento?',
    deseja_reprovar_layout: 'Deseja reprovar o layout?',
    deseja_reprovar_orcamento: 'Deseja reprovar o(s) orçamento(s)?',
    deseja_reprovar_execucao_orcamento: 'Deseja reprovar o orçamento?</br>Esta ação é irreversível e irá cancelar a execução da ação e a ação no planejamento.',
    deseja_reprovar_transferencia: 'Deseja reprovar a(s) transferência(s)?',
    deseja_solicitar_aprovacao_acordo: 'Deseja solicitar aprovação do acordo?',
    deseja_solicitar_aprovacao_acordo_sem_salvar: 'Você irá perder as alterações não persistidas, deseja realmente solicitar aprovação do acordo?',
    deseja_solicitar_aprovacao_apuracao: 'Deseja solicitar aprovação da apuração?',
    deseja_solicitar_aprovacao_condicao_percentual: 'Deseja solicitar aprovação da condição percentual?',
    deseja_solicitar_aprovacao_planejamento: 'Deseja solicitar aprovação do planejamento?',
    deseja_solicitar_aprovacao_orcamento: 'Deseja solicitar aprovação do orçamento?',
    deseja_solicitar_reembolso: 'Deseja solicitar reembolso?',
    deseja_salvar: 'Deseja salvar este(a) {text}?',
    deseja_salvar_acao: 'Deseja salvar esta ação?',
    deseja_salvar_contrato_cliente: 'Deseja salvar o codigo do cliente?',
    deseja_alterar_codigo_cliente: 'Deseja alterar o campo Contrato Cliente(KA)?',
    deseja_salvar_edicao: 'Deseja salvar a edição deste(a) {text}?',
    deseja_salvar_edicoes: 'Deseja salvar a edição destes(as) {text}?',
    deseja_salvar_informacoes: 'Deseja salvar estes(as) {text}?',
    deseja_salvar_material: 'Deseja salvar este material?',
    deseja_salvar_materiais: 'Deseja salvar estes materiais?',
    deseja_salvar_pagamento: 'Deseja salvar este pagamento?',
    deseja_salvar_pagamento_enviar_aprovacao: 'Deseja salvar este pagamento e enviar para aprovação?',
    deseja_salvar_peca: 'Deseja salvar esta peça?',
    deseja_salvar_pedido: 'Deseja salvar?',
    deseja_salvar_planejamento: 'Deseja salvar este planejamento?',
    deseja_salvar_reporte: 'Deseja salvar este reporte?',
    deseja_salvar_taxas_alteradas: 'Houve incidência de taxas sobre o valor das Ações abaixo. Deseja prosseguir?',
    deseja_seguir_proxima_apuracao: 'Deseja seguir para a próxima apuração?',
    deseja_voltar: 'Deseja voltar?',
    deseja_voltar_pagamento: 'Deseja voltar para lista de pagamentos?',
    diferente_valor_liquido: 'Soma dos valores informados diferente do valor líquido',
    visualizar_valor_dividido_por_extensao: 'Clique aqui para visualizar o valor dividido por OI',
    divisao_preenchida: 'Confirma a inclusão de um Funcionário sem Divisão informada?',
    download_efetuado: 'Downloado efetuado!',
    download_pedido_pecas: 'É de total responsabilidade do usuário a utilização deste arquivo respeitando <br/>as especificações técnicas para não haver distorção de cor e tamanho.<br/>É proibida a edição deste material, como por exemplo<br/> alterações no logotipo (tamanho/localização), fontes, texto legal, etc.<br/> Ao produzir o material, você é responsável por garantir a qualidade<br/> e utilização do mesmo de acordo com as diretrizes {placeholder}.',
    edicao_agendamento: '**Editar essas informações não altera a data da próxima execução',
    encerramento_acordo: 'Com este encerramento o saldo do Representante será restituido em ',
    enviado_aprovacao_sucesso: 'Item enviado para aprovação!',
    enviado_analise_sucesso: 'Item enviado para análise!',
    enviar_ajuste: 'Deseja enviar o acordo para ajuste',
    enviado_analise: 'Item enviado para análise.',
    estrutura_usuario_definicao_obrigatoria: 'Selecione pelo menos uma das duas opções: "Estrutura usuário", "Unidade negocio"',
    erro_buscar_importacoes: 'Erro ao buscar importações',
    erro_buscar_tipos_importacao: 'Erro ao buscar tipos de importação',
    erro_salvar_centro_sem_produto_cliente: 'O centro de custo deve ter selecionado pelo uma das opções Cliente/Produto.',
    erro_salvar_peca_falta_arquivos: 'É necessário o upload de pelo menos um arquivo.',
    erro_estrutura_pai_inexistente: 'Erro! Estrutura pai inexistente',
    erro_tente_importar_novamente: 'Erro! Tente importar novamente',
    evidencia_removida: 'Evidência removida com sucesso.',
    excluido_sucesso: '{param} excluido com sucesso.',
    execucao_acao_incluida: 'Execução incluída com sucesso.',
    execucao_acao_concluida: 'Execução concluída com sucesso.',
    execucao_acao_alterado: 'Execução atualizada com sucesso!',
    execucao_cancelada: 'Execução cancelada com sucesso!',
    execucao_metas: 'Execução metas efetuado com sucesso.',
    execucao_layout: 'Evidência de layout enviada com sucesso.',
    execucao_orcamento: 'Evidência de orçamento enviada com sucesso.',
    execucao_removida: 'Execução removida com sucesso.',
    existem_arquivos_anexados_para_execucao: 'Existe um pagamento iniciado para esta execução, deseja continuar?',
    erro_carregar_metas: 'Erro ao carregar as metas do acordo.',
    exportacao_download: 'A exportação começará em breve!',
    fechamento_ano_fiscal: 'Esta operação fechará o atual período. Este procedimento é irreversível, deseja continuar com a alteração?',
    fechamento_ano_fiscal_enviado: 'O período foi encaminhado para fechamento. Assim que o procedimento for finalizado, você será notificado.',
    fechamento_periodo_fiscal_enviado: 'Fechamento encaminhado com sucesso. Assim que o procedimento for finalizado, você será notificado.',
    fechamento_periodo_fiscal: 'Esta operação fechará o atual período. Este procedimento é irreversível, deseja continuar com a alteração?',
    finalizar_acordo: 'Deseja finalizar este Acordo?',
    finalizar_alteracao_nao_salvas: 'Não é possível finalizar, você tem alterações não persistidas!',
    finalizar_apuracao: 'Deseja concluir essa apuração?<br />Após conclusão, será criado o recebimento e a apuração não poderá ser mais alterada.',
    finalizar_apuracao_lote: 'Ao confirmar a finalização das apurações, a apuração será aprovada e o recebimento gerado. Não será possível realizar alterações. Deseja continuar?',
    finalizar_apuracao_sem_recebimento: 'Algumas apurações não serão finalizadas, pois, não possuem valor de recebimento.',
    fluxo_redirecionado_sucesso: 'O redirecionamento de fluxo foi realizado com sucesso',
    fluxo_cancelado_sucesso: 'O fluxo de aprovação foi cancelado com sucesso.',
    habilitar_calculo_automatico_investimento_vendas: 'Habilitar cálculo automático de investimento sobre vendas',
    habilitar_integracao_envio_pagamento: 'Habilitar integração para envio de pagamento',
    habilitar_integracao_retorno_pagamento: 'Habilitar integração para retorno de pagamento',
    habilitar_integracao_envio_recebimento: 'Habilitar integração para envio de recebimento',
    habilitar_integracao_retorno_recebimento: 'Habilitar integração para retorno de recebimento',
    habilitar_liquidacao_parcial: 'Habilitar liquidação parcial',
    habilitar_pagamento_parcial: 'Habilitar pagamento parcial',
    historico_orcamento_investimento_faturamento_serao_alterados: 'O histórico de valores de orçamento, investimento e faturamento apresentados nos relatórios gerenciais serão alterados após transferência.',
    importado_em_breve_sera_processado: 'Importado! Em breve o arquivo será processado e estará disponível na tabela',
    inativado_com_sucesso: 'Inativado com Sucesso',
    InativarDivisao: 'Não é possivel inativar. Divisão com vinculos.',
    InativarCarteiraCliente: 'Não é possivel inativar. Carteira de Cliente com vinculos.',
    InativarEstruturaUsuario: 'Não é possivel inativar. Estrutura do usuário com vinculos.',
    inconsistencia_continua_pendente: 'A inconsistência continua pendente',
    inconsistencia_integrada_sucesso: 'A inconsistência foi integrada com sucesso',
    inconsistencia_reprocessar: 'Deseja reprocessar esta inconsistência?',
    inconsistencia_recusar: 'Deseja recusar esta inconsistência?',
    indicador_nao_configurado: 'Indicador não configurado.',
    informe_periodo_historico_meses_anteriores: 'Informe o período histórico de meses anteriores ao período de apuração da ação:',
    iniciado_fluxo: 'Iniciado fluxo de aprovação',
    iniciar_periodo: 'Deseja iniciar o Período?',
    insira_conteudo: 'Insira um conteúdo.',
    intervalo_meta_obrigatorio: 'Intervalo da meta é obrigatório',
    intervalo_numerico: 'Número deve estar entre o intervalo: {min} e {max}',
    intervalo_numerico_percentual: 'Percentual deve estar entre o intervalo: {min} e {max}',
    item_cancelado_com_sucesso: 'Item cancelado com sucesso',
    item_enviado_alteracao: 'Item enviado para alteração.',
    justificado: 'Justificado e enviado com sucesso.',
    justificativa_apuracao: 'Apuração sem justificativa.',
    lgpd: 'Caro usuário, devido à Lei Geral de Proteção dos Dados (13.709/2018), os dados informados nesta página serão tratados automaticamente. Aguarde a atualização desta página para obter os novos dados.',
    lgpd_importacao: 'Caro usuário, devido à Lei Geral de Proteção dos Dados (13.709/2018), os dados importados nesta página e que identifiquem uma pessoa física serão tratados automaticamente. Após a conclusão da importação, confira os novos dados em suas respectivas telas de cadastro.',
    justificativa_reivindicacao: 'Reivindicação sem justificativa.',
    lider_conta_obrigatorio: 'Selecione pelo menos um opção como líder de conta',
    limite_caracteres_excedido: 'Limite de caracteres excedido!',
    lojas_contrato_incluidas: 'Lojas do contrato incluídas',
    lojas_contrato_ja_incluidas: 'Loja já está incluída no contrato',
    lojas_contrato_removida: 'Loja removida do contrato',
    lote_continua_pendente: 'Ainda existem inconsistências para o lote',
    lote_integrado_sucesso: 'O lote foi integrada com sucesso',
    lote_reprocessado_possiveis: 'Reprocessado todos lotes possíveis',
    lote_reprocessar: 'Deseja reprocessar este lote?',
    lote_reprocessar_possiveis: 'Deseja tentar reprocessar todos lotes possíveis?',
    lote_recusar: 'Deseja recusar este lote?',
    materiais_alterados: 'Materiais atualizados com sucesso!',
    materiais_frete_pendente: 'Você incluiu materiais mas não escolheu o tipo de frete. Cancele o pedido ou escolha o tipo de frete para concluir a Execução.',
    materiais_pendentes: 'Você não incluiu nenhum Material à Ação, deseja prosseguir?',
    mes_importacao_obrigatorio: 'Mês de importação obrigatório',
    meses_verba_alocada: 'Somente meses que possuem verba alocada.',
    meta_quantidade_evidencia_excedida: 'Excedeu a quantidade máxima de evidências permitidas.',
    minimo_maior_maximo: 'Valor mínimo maior que valor máximo.',
    nao: 'Não',
    nao_ano_fiscal_vigente: 'Não foi encontrado ano fiscal vigente.',
    nao_ha_conteudo: 'Não há conteúdo para ser mostrado nesta tabela.',
    nao_existe_erro_importacao: 'Não ocorreram erros nessa importação',
    nao_permite_finalizar_apuracao: 'Apuração não pode ser finalizada',
    nao_permite_ajuste: 'Não existem mais Competências para Ajuste de Verba.',
    nao_possivel_concluir_pagamento_ano_fiscal_fechado: 'Não é possível concluir este Pagamento. Esta ação pertence a um Período já encerrado.',
    nao_tem_cliente_aprovador: 'O cliente não participará do fluxo de aprovação deste acordo. É necessário que seja realizado o upload do contrato assinado após a aprovação final da negociação.',
    nao_tem_fornecedor_aprovador: 'O fornecedor não participará do fluxo de aprovação deste acordo. É necessário que seja realizado o upload do contrato assinado após a aprovação final da negociação.',
    necessario_parametrizacao_tipo_orcamento: 'Não foi encontrado nenhum tipo de orçamento parametrizado. É necessário a parametrização prévia de pelo menos um tipo de orçamento para que se possa cadastrar períodos.',
    necessario_uma_condicao: 'É necessário cadastrar ao menos uma condição percentual.',
    nenhum_arquivo_anexado: 'Nenhum arquivo anexado',
    nenhum_cliente_adicionado: 'Nenhum cliente adicionado',
    nenhum_material_adicionado: 'Nenhum material foi adicionado. Adicione uma quantidade ao material desejado para continuar.',
    nehum_pagamento_selecionado: 'Nenhum pagamento selecionado.',
    nenhum_registro_encontrado: 'Nenhum registro encontrado pelos filtros informados',
    nenhum_registro: 'Nenhum registro encontrado',
    nenhum_registro_pendente_aprovacao: 'Nenhum registro pendente de aprovação',
    nenhum_valor_informado: 'Nenhum valor informado.',
    numero_invalido: 'Número inválido',
    nenhum_cliente_para_transferir: 'Não há clientes para serem transferidos.',
    nenhum_cliente_selecionado_para_transferir: 'Nenhum cliente foi selecionado para ser transferido.',
    nenhum_intervalo: 'Nenhum intervalo adicionado.',
    nenhuma_carteira_para_transferir: 'Não há carteiras para serem transferidas.',
    nenhuma_carteira_selecionada_para_transferir: 'Nenhuma carteira foi selecionada para ser transferida.',
    nenhum_orcamento_selecionado_para_transferir: 'Nenhum orçamento foi selecionado para ser transferido.',
    novo_superior_imediato_de_sera: 'O novo superior imediato do usuário {de} será {para};',
    operacao_irreversivel_deseja_continuar: 'Essa operação é irreversível. Deseja continuar?',
    orcamento_aprovado: 'Orçamento(s) aprovado(s).',
    orcamento_cancelado: 'Orçamento(s) cancelado(s).',
    orcamento_enviado_aprovacao: 'Orçamento enviado para aprovação.',
    orcamento_concluido: 'Orçamento concluido.',
    orcamento_finalizado: 'Orçamento finalizado.',
    orcamento_habilitado_alteracao: 'Orçamento habilitado para alteração.',
    orcamento_reprovado: 'Orçamento(s) reprovado(s).',
    orcamento_valor_finalizar: 'Valor remanescente não pode ser igual ao valor planejado para finalizar.',
    pagamento_criado: 'Pagamento criado.',
    pagamento_salvo_com_sucesso: 'Pagamento salvo com sucesso',
    pagamento_cancelado: 'Pagamento cancelado com sucesso.',
    pagamento_concluido: 'Pagamento concluído com sucesso',
    pagamento_reenviado: 'Pagamento(s) reenviado(s).',
    pagamento_resgatado: 'Pagamento resgatado com sucesso.',
    pagina_inexistente: 'Ops... Essa página não existe.',
    pedido_peca_finalizado: 'Pedido de peças finalizado com sucesso.',
    permitir_cliente_criar_acao: 'Permitir que o cliente crie esse tipo de ação',
    periodo_adicionado_planilha: 'Periodo atualizado na planilha',
    periodo_anterior_periodo_atual_igual: 'Período fiscal anterior igual ao atual',
    periodo_iniciado_sucesso: 'Período iniciado com sucesso',
    periodo_fechado_sucesso: 'Período fechado com sucesso',
    periodo_salvo_com_sucesso: 'Período salvo com sucesso',
    planejamento_aprovado: 'Planejamento aprovado.',
    planejamento_atualizado: 'Planejamento atualizado.',
    planejamento_cancelado: 'Planejamento cancelado.',
    planejamento_concluido: 'Planejamento concluído.',
    planejamento_enviado_analise: 'Planejamento enviado para análise.',
    planejamento_enviado_aprovacao: 'Planejamento enviado para aprovação.',
    planejamento_reprovado: 'Planejamento reprovado.',
    ponto_virgula_invalido: 'Caracter ; inválido.',
    preco_negociado_maior_zero: 'Preço Negociado deve ser maior que R$0,00.',
    projeto_fachadas_download: 'O download do arquivo de Projeto Fachadas começará em breve!',
    produto_alterado_com_sucesso: 'Produto alterado com sucesso',
    produto_salvo_com_sucesso: 'Produto salvo com sucesso',
    prg_marketing: 'Existem Distribuidores/Clientes não liberados para utilização na <b>Modalidade 4</b>, por este motivo não estão listados. Para realizar uma Ação para este Distribuidor/Cliente desejado será necessário escolher outra Modalidade. Clique em Cancelar e reinicie o cadastro da Ação',
    quantidade_material: 'Este valor pode ser alterado apenas para um valor menor que o já solicitado.',
    recusados: 'O(s) itens {recusados} não foram enviados para aprovação, verifique a apuração e tente novamente.',
    rascunho_salvo: 'Rascunho salvo com sucesso!',
    rateio_atualizado: 'Rateio de orçamento atualizado',
    rateio_novas_divisoes: 'Existem novas divisões que não estão na estrutura do rateio. Clique para visualizar as novas divisões e incluí-las no rateio.',
    rateio_novos_vendedores: 'Existem novos vendedores que não estão na estrutura do rateio. <br/>Clique para visualizar e incluí-los.',
    rebate_nao_configurado: 'Rebate não configurado',
    recalculo_valor_final: 'Recalculo de valor de pagamento mediante alteração do realizado da meta',
    redirecionando_para_home: 'Você será redirecionado para a página inicial.',
    reivindicacao_efetuada: 'Reivindicação efetuada com sucesso.',
    reivindicacao_em_andamento: 'Não foi possível finalizar/enviar para fluxo de aprovação. Meta possui reivindicação em andamento!',
    reivindicacao_fluxo: 'Fluxo da reivindicação iniciado.',
    remover_arquivo: 'Deseja remover o arquivo?',
    remover_arquivo_nome: 'Deseja remover o arquivo {fileName}? Este procedimento é irreversível.',
    remover_acao: 'Deseja remover a ação?',
    remover_execucao: 'Deseja remover a execução selecionada?',
    remover_foto: 'Deseja remover a foto?',
    remover_meta: 'Deseja remover a(s) meta(s) selecionada(s)?',
    remover_transferencia_posse: 'Deseja remover a transferência de posse selecionada?',
    reprovado_sucesso: 'Item reprovado com sucesso!',
    reporte_sem_lista_ou_foto: 'É necessário uma foto ou uma lista de presença.',
    resgate_sucesso: 'Resgate realizado com sucesso!',
    saldo_total_consumido: 'Você está consumindo 100% do seu saldo disponível',
    saldo_disponivel_consumido: 'Você já consumiu todo o seu saldo disponível',
    saldo_indisponivel: 'Operação não efetudada. Saldo indisponível.',
    saldo_insuficiente_aumentar_consumo: 'Saldo insuficiente para pagamento maior que o budget previsto',
    saldo_menor_vlr_aportado: 'Saldo insuficiente.',
    salvar: 'Deseja salvar?',
    salvar_aporte: 'Deseja salvar este aporte?',
    salvar_novo_acordo: 'Deseja salvar este novo Acordo?',
    salvar_acordo_valor_divergente: 'A somatória do valor das metas está diferente do valor do acordo. Deseja salvar?',
    salvar_ano_fiscal: 'Este procedimento é irreversível, deseja continuar com a alteração?',
    salvar_nova_alcada: 'Deseja salvar esta nova Alçada?',
    salvar_nova_area_atuacao: 'Deseja salvar esta área de atuação?',
    salvar_nova_categoria: 'Deseja salvar esta nova Categoria?',
    salvar_novo_centro_custo: 'Deseja salvar o Centro de Custo?',
    salvar_nova_divisao: 'Deseja salvar esta divisão?',
    salvar_nova_estrutura_usuario: 'Deseja salvar esta nova Estrutura de Usuário?',
    salvar_nova_filial: 'Deseja salvar esta nova filial?',
    salvar_novo_grupo_produto: 'Deseja salvar este novo Grupo de produto?',
    salvar_nova_loja: 'Deseja salvar esta nova Loja?',
    salvar_nova_marca: 'Deseja salvar esta nova Marca?',
    salvar_nova_negociacao: 'Deseja salvar esta nova negociação?',
    salvar_nova_unidade_negocio: 'Deseja salvar esta nova unidade de negócio?',
    salvar_nova_unidade_medida: 'Deseja salvar esta nova unidade de medida?',
    salvar_nova_regiao: 'Deseja salvar esta nova Região?',
    salvar_novo_ajuste_verba: 'Deseja salvar este ajuste de verba?',
    salvar_novo_transferencia: 'Deseja salvar esta Transferência?',
    salvar_novo_canal: 'Deseja salvar este novo Canal?',
    salvar_nova_cliente: 'Deseja salvar este novo Cliente?',
    salvar_novo_concorrente: 'Deseja salvar este novo concorrente?',
    salvar_novo_registro: 'Deseja salvar novo registro?',
    salvar_novo_orcamento: 'Deseja salvar este novo orçamento?',
    salvar_novo_produto: 'Deseja salvar este novo produto?',
    salvar_novo_segmento: 'Deseja salvar este novo segmento?',
    salvar_novo_tipo_acao: 'Deseja salvar este novo tipo ação?',
    salvar_novo_tipo_investimento: 'Deseja salvar este novo tipo de Linha de Orçamento?',
    salvar_novo_tipoOrcamento: 'Deseja salvar este novo tipo de orçamento?',
    salvar_orcamento: 'Deseja salvar este orçamento?',
    salvar_usuario: 'Deseja salvar este usuário?',
    selecionar_role: 'É necessário escolher uma permissão',
    selecione_foco_acao: 'Selecione foco da ação para prosseguir.',
    selecione_divisao: 'Selecione divisão para prosseguir.',
    selecione_origem_acao: 'Selecione origem da ação para prosseguir.',
    selecione_tipo_acao: 'Selecione o tipo de ação',
    selecione_tipo_acao_para_pesquisar: 'Selecione um tipo de ação para pesquisar',
    selecione_tipo_acao_para_contrato: 'Selecione o tipo de ação para adicionar ao contrato',
    selecione_tipo_contrato: 'Selecione o tipo de contrato',
    selecione_tipo_investimento: 'Selecione tipo de investimento',
    selecionar_tipo_liquidacao: 'Selecione pelo menos uma das duas opções: "Unica liquidação", "Múltiplas liquidações"',
    selecione_uma_acao: 'Selecione pelo menos 1 Ação',
    selecione_divisao_configuracao_orcamento: 'Selecione pelo menos 1 divisão no Passo 2 -> Cadastro de orçamento” para garantir que esse rateio seja selecionado.',
    selecione_vendedores_transferir: 'Selecione todos os vendedores para transferir.',
    sem_dados: 'Sem dados para mostrar',
    sem_dados_exportacao: 'Não existem dados à serem exportados.',
    sem_dados_exportacao_periodo: 'Não existem dados à serem exportados para o período selecionado.',
    sem_dados_para_exportacao: 'Não existem dados para serem exportados.',
    sem_dados_notas_fiscais: 'Não existem notas fiscais vinculadas a esta ação!',
    sem_historico: 'Sem Histórico para mostrar',
    sem_passos: 'Sem informações de passos.',
    sem_saldo_disponivel: 'Você não tem saldo disponível para o valor provisionado da meta definida.<br/>Solicite um adendo de verba na respectiva linha de orçamento para<br/>prosseguir com o cadastro da meta',
    senha_redefinida: 'Senha redefinida com sucesso.',
    servico_incluido: 'Serviço incluído com sucesso.',
    servico_quantidade_evidencia_excedida: 'Excedeu a quantidade máxima de evidências permitidas.',
    so_letra_minuscula_e_underline: 'Preencher somente com letras minúsculas e underline',
    solicitacao_aprovacao: 'Solicitação de aprovação realizada!',
    perguntas_respostas_cadastradas: 'A pergunta e a resposta foram cadastradas com sucesso!',
    tem_certeza_cancelar: 'Tem certeza que deseja cancelar?',
    tem_certeza_exluir_perfil: 'Tem certeza que deseja excluir o perfil {param}? <br />Lembrando que todos os usuários vinculados a este perfil serão inativados.',
    tem_certeza_limpar_selecao: 'Suas alterações serão perdidas se não salvá-las.<br/>Tem certeza que deseja limpar?',
    time_vendedores_serao_transferidos: 'O time de vendedores do usuário {de} serão transferidos para {para};',
    tipo_linha_orcamento: 'Tipo Linha Orçamento',
    tipo_provisao_obrigatorio: 'Tipo de provisão é obrigatório.',
    tipo_orc_associado_param_acao: 'O tipo de investimento está associado a uma parametrização de tipo de ação.',
    transferencia_aprovado: 'Transferência(s) aprovada(s).',
    transferencia_definitiva_carteira_filtro: 'Transferir a carteira selecionada no filtro',
    transferencia_definitiva_carteira_selecionada: 'Transferir apenas os clientes selecionados',
    transferencia_definitiva_cenario_1: 'Alteração do superior imediato de um vendedor - use esta opção quando for necessário alterar o gestor de um vendedor',
    transferencia_definitiva_cenario_2: 'Transferência de carteira de clientes, ações e verba de orçamento entre vendedores - use esta opção quando um vendedor não fizer mais parte do time comercial e outro vendedor irá assumir a sua respectiva carteira de clientes',
    transferencia_definitiva_cenario_3: 'Transferência entre gestores e do time de vendedores do gestor - use esta opção quando um gestor não fizer mais parte do time comercial e outro gestor for assumir a sua respectiva carteira de clientes. Obrigatoriamente você deve transferir também o time de vendedores do Gestor de Origem',
    transferencia_definitiva_cenario_4: 'Alteração de usuários que não atuam como vendedores mas que são responsáveis pela distribuição de verba no orçamento - use esta opção quando for necessário alterar um usuário que não é Gestor e nem Vendedor mas que é responsável pela distribuição de verba no orçamento (Exemplo: Gerente Nacional e Gerente de Canal)',
    transferencia_definitiva_cliente_filtro: 'Transferir todos os clientes selecionados no filtro cujo usuário de origem é o responsável principal',
    transferencia_definitiva_cliente_selecionado: 'Transferir apenas os clientes selecionados cujo usuário de origem é o responsável principal',
    transferencia_definitiva_toda_carteira: 'Transferir toda a carteira de clientes',
    transferencia_definitiva_toda_responsabilidade: 'Transferir toda a responsabilidade',
    transferencia_reprovado: 'Transferência(s) reprovada(s).',
    transferencia_finalizada: 'Transferência finalizada.',
    transferencia_enviada_aprovacao: 'Transferência enviada para aprovação.',
    transferencia: {
      mesma_competencia: 'Não pode realizar transferência para a mesma competência.'
    },
    upload: 'Upload arquivo aceito.',
    upload_evidencia_obrigatoria: 'Upload de evidência obrigatório',
    habilitar_upload_evidencia: 'Habilitar upload de evidência',
    upload_evidencia_obrigatoria_sellin: 'Upload de evidência obrigatório para ações de Sell In sem comprovação do valor realizado',
    upload_evidencia_obrigatoria_sellout: 'Upload de evidência obrigatório para ações de Sell Out',
    upload_evidencia_pendente: 'Upload de arquivo como evidência pendente',
    valor_invalido: 'Valor inválido.',
    valor_lista_invalido: 'Valor inválido. Possíveis valores são: {valores}',
    valor_nao_considera_metas: '** Este valor não considera as demais metas com a mesma linha de orçamento deste acordo.',
    valor_meta_maior_zero: 'Valor Meta deve ser maior ou igual a 0,01',
    valor_reservado_maior_zero: 'Valor Reservado deve ser maior ou igual a 0,01',
    valor_pagamento_maior_zero: 'Valor Bonificação/Pagamento deve ser maior ou igual a 0,01',
    budget_previsto_maior_zero: 'Budget previsto deve ser maior ou igual a 0,01',
    valor_remanescente_orcamento: 'Valor total distribuído está diferente do valor planejado. ',
    variaveis_termo_aceite_industria: '<p>Na seção abaixo escreva o conteúdo do termo de aceite que será apresentado para o cliente.</br> Utilize as seguintes variáveis para que o sistema faça a substituição automática no conteúdo do termo: <ul><li>[CLIENTE]: código e nome do cliente (se o usuário estiver associado a mais de 1 cliente serão separados por vírgula);</li> <li>[LINK]: link do Tradelinks;</li> <li>[USUARIO]: usuário (login) para o qual o termo de aceite foi apresentado;</li> <li>[SENHA_PADRAO]: senha padrão definida na tela de Gestão de usuário no Tradelinks.</li></ul> Atenção! Para que o Tradelinks reconheça as variáveis elas devem ser escritas da seguinte forma: entre colchetes e com a descrição em letra maiúscula idêntica às variáveis apresentadas nesse texto de apoio.</p>',
    variaveis_termo_aceite_varejo: '<p>Na seção abaixo escreva o conteúdo do termo de aceite que será apresentado para o fornecedor.</br> Utilize as seguintes variáveis para que o sistema faça a substituição automática no conteúdo do termo: <ul><li>[GRUPO_FORNECEDOR]: nome do grupo fornecedor do usuário;</li> <li>[CNPJ]: CNPJs que compõem o grupo fornecedor do usuário;</li> <li>[NOME_COMPLETO]: nome completo do usuário;</li> <li>[CPF]: número do CPF do usuário;</li> <li>[DATA_ATUAL]: data do momento da abertura do termo;</li> <li>[LINK]: link do Tradelinks;</li> <li>[USUARIO]: usuário (login) para o qual o termo de aceite foi apresentado;</li> <li>[SENHA_PADRAO]: senha padrão definida na tela de Gestão de usuário no Tradelinks.</li></ul> Atenção! Para que o Tradelinks reconheça as variáveis elas devem ser escritas da seguinte forma: entre colchetes e com a descrição em letra maiúscula idêntica às variáveis apresentadas nesse texto de apoio.</p>',
    view_reprocessada: 'View reprocessada com sucesso.',
    verba_gestores_de_para_sera_alterada: 'A verba dos gestores {superiorDe} e {superiorPara} será alterada conforme verba do usuário de origem {de};',
    voltar_orcamento: 'Deseja voltar para a tela de orçamento?',
    voltar_aviso: 'Suas alterações serão perdidas se não salvá-las.',
    voltar_deseja_salvar: 'Deseja salvar as alterações realizadas antes de Voltar?',
    upload_sucesso: 'Sucesso no upload do arquivo!',
    upload_falha: 'Falha no upload do arquivo!',
    email_invalido: 'Campo obrigatorio'
  },
  errors: {
    campo_documento_invalido: 'Campo {tipo} inválido',
    acao: {
      nao_existe: 'Ação inexistente!',
      acao_nao_reportada: 'Ação não reportada. É obrigatório realizar o Reporte da ação antes de enviar o Pagamento para aprovação.'
    },
    acordo: {
      obrigatorio: 'Acordo é obrigatório.',
      valor_selecao: 'Acordo possui valor da seleção errado.',
      inexistente: 'Acordo inexistente',
      info_bancaria_obrigatoria: 'Informações bancárias do cliente são obrigatórias!',
      multiplos_passos_cliente: 'Múltiplos passos cliente encontrados no fluxo de aprovação. Necessário ajustá-lo.',
      multiplos_passos_fornecedor: 'Múltiplos passos fornecedor encontrados no fluxo de aprovação. Necessário ajustá-lo.',
      contrato_cliente_faltando: 'Contrato cliente (KA) é obrigatório'
    },
    ano_fiscal: {
      nao_encontrado: 'Período vigente não encontrado.',
      ja_existente_periodo: 'Período Fiscal já cadastrado.'
    },
    aporte: {
      valor_aportar: 'Valor a aportar é obrigatório.',
      valor_aportar_invalido: 'Valor a aportar inválido.'
    },
    apuracao: {
      inexistente: 'Apuracao inexistente',
      em_reivindicacao: 'Apuração em reivindicação.',
      em_fluxo: 'Apuração em fluxo.',
      nao_pode_ser_vazia: 'Lista de apurações não pode ser vazia',
      sem_execucao_metas: 'Apuração sem execução de metas.',
      status_nao_permitido: 'Status da apuração não permitido para a operação.'
    },
    arquivo: {
      obrigatorio: function obrigatorio(tipo) {
        return 'Arquivo de ' + tipo + ' \xE9 obrigat\xF3rio.';
      }
    },
    ativacao: {
      massa: 'Falha ao ativar/inativar todos registros em massa.'
    },
    base_calculo: {
      obrigatoria: 'Base de Cálculo é obrigatório.'
    },
    campo_customizado: {
      tipo_existente: 'Nome interno já existente na entidade informada.'
    },
    campos_obrigatorios: {
      nao_informados: 'Campos obrigatórios não informados'
    },
    canal_marca: {
      nao_informados: 'Campos Canal, Marca e Unidade de negócio são obrigatórios.'
    },
    carteira_cliente: {
      associada: 'Não é possível remover unidade de negócio associada a carteira de cliente.',
      existente: 'Vínculo existente.',
      divisao_impedida_edicao: 'Não é possível editar a divisão pois esta possui clientes em uma de suas carteiras'
    },
    cep: {
      nao_encontrado: 'CEP não encontrado.'
    },
    cliente: {
      obrigatorio: 'Cliente é obrigatório',
      inativo: 'Cliente está inativo',
      nao_cadastrado: 'Cliente não está cadastrado',
      sem_saldo: function sem_saldo(cliente) {
        return 'Cliente ' + cliente + ' n\xE3o tem saldo dispon\xEDvel.';
      },
      config_controlador_nao_alteravel: 'Não é possível alterar configuração de controlador',
      config_vinculo_nao_alteravel: 'Nao é possível alterar configuração de vínculo',
      ja_adicionado: 'Este cliente já foi adicionado'
    },
    cnpj: {
      existente: 'CNPJ já cadastrado no sistema',
      obrigatorio: 'CNPJ é obrigatório',
      tamanho: function tamanho(min, max) {
        return 'CNPJ dever\xE1 ter um tamanho m\xEDnimo de ' + min + ' e m\xE1ximo de ' + max + ' caracteres';
      }
    },
    cnpj_cpf: {
      obrigatorio: 'CPF/CNPJ é obrigatório'
    },
    cpf: {
      existente: 'CPF já cadastrado no sistema',
      invalido: 'CPF inválido'
    },
    codigo: {
      obrigatorio: 'Código é obrigatório',
      existente: 'Código já cadastrado no sistema'
    },
    competencia: {
      obrigatoria: 'Competência é obrigatória',
      destino: {
        obrigatoria: 'Competência de destino é obrigatória'
      }
    },
    condicional: {
      cliente_aprovador: 'Falha na execução do fluxo: condicional de cliente aprovador não pôde ser avaliada pois o passo não possui usuário de um cliente!'
    },
    config_rebate: {
      ja_cadastrado: 'Condição percentual já cadastrada ou duplicada',
      condicao_sem_upload: 'Necessário o upload de arquivo nas condições percentuais'
    },
    conta_corrente: {
      sem_saldo: 'Conta corrente não tem saldo disponível.',
      tipo_sem_saldo: function tipo_sem_saldo(tipo) {
        return 'Conta corrente ' + tipo + ' n\xE3o tem saldo dispon\xEDvel.';
      },
      valor_nao_distribuido: 'Valor não distribuído corretamente entre as contas correntes'
    },
    contrato: {
      conflitante: function conflitante(cliente) {
        return 'J\xE1 existe um contrato como cliente: ' + cliente + ' .';
      },
      configuracao_conflitante: 'Já existe um contrato para o mesmo período, tipo e foco.',
      obrigatorio: 'Contrato não existe na base.',
      sem_acao_cadastrada: 'Deve haver pelo menos uma ação detalhada.',
      loja: {
        sem_vinculo_cliente: 'Não há lojas vinculadas'
      }
    },
    data: {
      mesmo_mes: 'Data inicial e final devem pertencer ao mesmo mês',
      finalantesinicial: function finalantesinicial(entidade) {
        return 'Data inicial de ' + entidade + ' maior que data final.';
      },
      inicio_antes_seguinte: 'Data Inicial menor que Dia Seguinte',
      final_antes_inicial: 'Data Inicial maior que Data Final',
      fora_vigencia: 'Data fora da vigência do contrato',
      japassou: 'Apenas datas futuras podem ser selecionadas',
      obrigatoria: 'Data é obrigatória',
      periodo_excedido: 'O período máximo para exportação são de 3 meses',
      periodo_excedido12: 'O período máximo para exportação são de 12 meses',
      conflitante: function conflitante(entidade, filha, range) {
        return 'Data ' + range + ' de ' + filha + ' est\xE1 fora do per\xEDodo do ' + entidade + '.';
      },
      retroativa_erro: 'Data retroativa maior que a data atual',
      inicial_menor_final: 'Data inicial deve ser menor que data final.'
    },
    divisao: {
      superior_invalida: 'Divisão superior inválida, analise a estrutura de usuário',
      nao_encontrada: 'Divisão não encontrada',
      associada: {
        estrutura_usuario: 'Estrutura de usuário já esta associado a uma divisão'
      },
      divisao_diferente: function divisao_diferente(entidade) {
        return 'Voc\xEA n\xE3o possui a mesma divis\xE3o do ' + entidade + '.';
      },
      ja_adicionado: 'Esta divisão já foi adicionada.'
    },
    dta_inicio: {
      obrigatoria: 'Data início é obrigatória',
      menor_atual: 'Data início menor que data atual',
      menor_ultimo_periodo: 'Data início presente em outro período fiscal.'
    },
    dta_fim: {
      obrigatoria: 'Data fim é obrigatória'
    },
    definicao: {
      obrigatoria: 'Definição de usuário é obrigatória',
      inexistente: function inexistente(dependencia) {
        return dependencia + ' n\xE3o encontrado no sistema';
      }
    },
    dependencia: {
      obrigatoria: 'Dependência é obrigatória',
      inexistente: function inexistente(dependencia) {
        return dependencia + ' n\xE3o encontrado no sistema';
      }
    },
    dependencia_especifica: {
      obrigatorio: function obrigatorio(dependencia) {
        return dependencia + ' \xE9 obrigat\xF3rio';
      }
    },
    descricao: {
      existente: 'Descrição já cadastrado no sistema'
    },
    descricao_acao: {
      obrigatorio: 'Descrição da Ação é obrigatória'
    },
    download: {
      arquivo_invalido: 'Arquivo inválido para importação.',
      erro_desconhecido: 'Erro ao baixar o arquivo. Tente novamente.'
    },
    ean: {
      duplicado: 'EAN já está em uso',
      obrigatorio: 'EAN é obrigatório',
      invalido: 'EAN inválido',
      tamanho: function tamanho(max) {
        return 'O EAN dever\xE1 ter ' + max + ' caracteres';
      }
    },
    email: {
      duplicado: 'E-mail já cadastrado no sistema',
      obrigatorio: 'E-mail é obrigatório',
      tamanho: function tamanho(min, max) {
        return 'E-mail dever\xE1 ter um tamanho m\xEDnimo de ' + min + ' e m\xE1ximo de ' + max + ' caracteres';
      },
      formato_invalido: 'E-mail com formato inválido'
    },
    endereco: {
      bairro_obrigatorio: 'Bairro é obrigatório',
      cep_obrigatorio: 'CEP é obrigatório',
      cidade_obrigatorio: 'Cidade é obrigatória',
      numero_obrigatorio: 'Número é obrigatório',
      endereco_obrigatorio: 'O Endereço é obrigatório'
    },
    entidade: {
      duplicada: function duplicada(entidade) {
        return entidade + ' em conflito com outro(a) ' + entidade + ' j\xE1 cadastrado(a) no sistema.';
      },
      inexistente: function inexistente(entidade) {
        return entidade + ' n\xE3o encontrado(a) no sistema.';
      },
      obrigatoria: function obrigatoria(entidade) {
        return entidade + ' \xE9 obrigat\xF3rio(a).';
      },
      associada: function associada(entidade) {
        return entidade + ' j\xE1 associado(a).';
      },
      associada_identificador: function associada_identificador(entidade, identificador) {
        return identificador + ' associado(a) com ' + entidade + '.';
      },
      nao_associada: function nao_associada(entidade, identificador) {
        return entidade + ' n\xE3o associado(a) com ' + identificador + '.';
      },
      sem_representante: function sem_representante(entidade) {
        return entidade + ' n\xE3o possui representantes.';
      },
      campos_obrigatorios: function campos_obrigatorios(entidade) {
        return 'Campos obrigat\xF3rios da ' + entidade + ' n\xE3o informados';
      }
    },
    estrutura_usuario: {
      nao_trocar_estrutura_divisao: 'Não é possível trocar a estrutura da divisão, já possui filhos',
      ja_existente: 'Nome de estrutura de usuário já existente!',
      ja_adicionado: 'Esta estrutura de usuário já foi adicionada.'
    },
    eventos: {
      ja_existente_periodo: 'Já existe um evento cadastrado para este período'
    },
    evidencia: {
      nao_existe: 'Evidência inexistente!'
    },
    execucao: {
      inexistente: 'Arquivo de Execução metas inexistente',
      execucao_ja_concluida: 'A Execução já foi concluído. Não é possível alterar suas informações.',
      bloqueada: 'Existem ações executadas no período fiscal atual que não foram reportadas. Verifique.',
      nao_existe: 'Execução tática inexistente!',
      alteracao_status_erro: function alteracao_status_erro(status) {
        return 'N\xE3o foi poss\xEDvel alterar o status para ' + status + '.';
      },
      aprovar: 'Não foi possível aprovar.',
      enviar_aprovacao: 'Erro ao enviar para aprovação.',
      reprovar: 'Não foi possível reprovar.'
    },
    extensao_arquivo: {
      invalido: 'A extensão do arquivo está incorreta'
    },
    exportacao: 'Erro ao exportar. Tente novamente.',
    extensao: {
      nivel: {
        invalido: 'Nivel da extensão é inválido',
        obrigatorio: 'Nivel da extensão é obrigatório'
      },
      nao_validas_para_unidade_negocio: 'Unidades de negócio inválidas ou duplicadas',
      selecionar: 'Execute a busca e selecione um(a) {text}',
      mal_formatada: function mal_formatada(extensao) {
        return 'Extens\xE3o m\xE1 formatada: ' + extensao;
      }
    },
    fluxo: {
      cliente_nao_encontrado: 'Cliente aprovador não encontrado para a configuração do passo',
      existente: 'Workflow existente',
      duplicado_solicitante: 'Workflow já cadastrado para o solicitante',
      fluxo_reivindicacao_inexistente: 'Fluxo reivindicação inexistente.',
      ja_solicitado: 'Workflow já solicitado para a entidade',
      nao_apuravel: 'Fluxo aprovação não apurável.',
      nao_encontrado: 'Workflow não encontrado',
      nao_encontrado_solicitante: 'Workflow não encontrado para o solicitante',
      nao_encontrado_passo: 'Passo não encontrado',
      nao_encontrado_passo_elegivel: 'Fluxo de aprovação não pode ser iniciado pois não foi encontrado passo de aprovação elegível.',
      nao_iniciado: 'Fluxo não Iniciado',
      nao_pode_ser_avaliado: 'Passo não pode ser avaliado',
      nao_transferivel: 'Passo não pode ter transferência de aprovador',
      passo_obrigatorio: 'É necessário pelo menos um passo para cadastro do Workflow',
      passo_elegivel_obrigatorio: 'É necessário pelo menos um passo de aprovação elegível para dar continuidade ao fluxo.',
      passo_unico_nao_atende_condicao: 'O(s) passo(s) ativo(s) não atendem à condição do fluxo.',
      rejeicao_obrigatoria: 'Motivo de rejeição é obrigatório',
      selecionar_configuracao: 'É necessário escolher usuário ou perfil',
      solicitante_pagamento: 'Usuário não pode solicitar pagamentos para a apuração.',
      ultimo_passo_condicional: 'Não é permitido selecionar condicional no último passo do fluxo',
      usuario_nao_aprova: 'Usuário não pode aprovar o passo'
    },
    fornecedor: {
      obrigatorio: 'Fornecedor é obrigatório',
      inativo: 'Fornecedor está inativo',
      nao_cadastrado: 'Fornecedor não está cadastrado',
      ja_adicionado: 'Este fornecedor já foi adicionado'
    },
    id: {
      existente: 'Código já cadastrado no sistema',
      inexistente: 'Código inexistente no sistema'
    },
    id_externo: {
      existente: 'Código já cadastrado no sistema',
      obrigatorio: 'Código externo é obrigatório'
    },
    id_regiao: {
      obrigatorio: 'Região é obrigatória'
    },
    id_tipo_investimento: {
      obrigatorio: 'Tipo de linha de orçamento é obrigatorio'
    },
    id_tipo_orcamento: {
      obrigatorio: 'Tipo de orçamento é obrigatorio'
    },
    inicializacao: 'Ocorreu um erro desconhecido na inicialização da aplicação, tente mais tarde ou contate o administrador',
    inicializacao_sem_perfil: 'O seu usuário não está vinculado a um perfil, contate o administrador',
    justificativa: {
      obrigatoria: 'Justificativa é obrigatória'
    },
    importacao: {
      chave: {
        duplicada: 'Registro duplicado na planilha: {param}'
      },
      documento: {
        tamanho_invalido: 'O campo deve conter 11 (CPF) ou 14 (CNPJ) dígitos.',
        cpf_com_letras: 'CPF inválido: O campo não deve conter letras.',
        caracteres_especiais: 'Formato inválido: O campo contém caracteres especiais não permitidos.',
        pontuacao_invalida: 'Pontuação inválida da máscara: (XXX.XXX.XXX-XX para CPF e XX.XXX.XXX/XXXX-XX para CNPJ)',
        digitos_verificadores_invalidos: 'Dígitos verificadores inválidos'
      },
      generico: 'Erro na importação contate o administrador do sistema: {param}',
      nao_generico: '{param}',
      produto: {
        inexistente: 'Produto Inexistente'
      },
      quantidade_linhas_ignoradas_data: 'Quantidade de linhas ignoradas por estarem fora do intervalo de datas: {param}',
      valor: {
        duplicado: 'Valor duplicado na coluna: {param}',
        existente: 'Valor já existente no banco de dados, na coluna: {param}',
        excendente: 'Campo com tamanho excedente: {param}',
        formato: 'Campo com formato inválido na coluna: {param}',
        fora: 'Campo fora do período permitido: {param}',
        inativo: 'Valor inativo na coluna: {param}',
        inexistente: 'Valor inexistente na coluna: {param}',
        marca: 'Valor inexistente na coluna: {param}',
        nao_associado: 'Valor não associado com a dependência obrigatória: {param}',
        negativo: 'Um dos Hierarquia e/ou Unidade de negócio tem de ter o valor SIM',
        vazio: 'Valor vazio na coluna: {param}',
        incorreto: 'Valor incorreto: {param}',
        invalido: 'Valor Inválido: {param}',
        invalido_na_coluna: 'Valor inválido na coluna: {param}',
        decimal_6: 'O {param} deve conter no máximo 6 casas decimais.',
        inteiro_5: 'O {param} deve conter no máximo 5 casas inteiras.',
        sellout: 'Sell Out duplicado.'
      },
      vinculo: {
        existente: 'Vínculo existente',
        inexistente: 'Vínculo inexistente: {param}',
        extensao: {
          nao_remover: 'Os vínculos removidos são utilizados em outros pontos do sistema. Não é possível realizar esta ação!'
        }
      },
      layout: {
        diferente: 'Planilha com o formato inválido: {param}',
        tipo: 'Planilha importada não é do tipo {param}'
      },
      meta: {
        nao_existe: 'Meta inexistente!'
      },
      dependencia: {
        ativa: 'Possui dependência Ativo(a): {param}',
        inexistente: 'Possui dependência(s) Inexistente(s) na coluna(s): {param}',
        espaco_branco: 'Pode ser que possua espaço(s) em branco na(s) coluna(s): {param}',
        caractere_invalido: 'Possui caractere(s) inválido(s) na(s) coluna(s): {param}',
        duplicada: 'Possui dependência Duplicada: {param}'
      },
      quantidade: {
        colunas: 'A quantidade de colunas com valores está divergente da quantidade esperada: {param}'
      },
      relacionamento: {
        duplicado: 'Relacionamento já realizado'
      },
      responsavel: {
        principal: {
          duplicado: '{param} - 2 vendedores ativos para o mesmo cliente e unidade de negócio na coluna "Responsável Principal"'
        }
      },
      servico: {
        nao_existe: 'Serviço inexistente!'
      }
    },
    imprimir: 'Falha ao solicitar impressão',
    inconsistencia: {
      registro_inexistente: 'Registro não encontrado. Alguma inconsistência na base?'
    },
    linha: {
      inexistente: function inexistente(entidade, linha) {
        return 'Linha ' + linha + ': ' + entidade + ' n\xE3o encontrado(a) no sistema.';
      },
      obrigatoria: function obrigatoria(entidade, linha) {
        return 'Linha ' + linha + ': ' + entidade + ' \xE9 obrigat\xF3rio(a).';
      },
      nao_associada: function nao_associada(entidade, identificador, linha) {
        return 'Linha ' + linha + ': ' + entidade + ' n\xE3o associado(a) com ' + identificador + '.';
      },
      sem_representante: function sem_representante(entidade, linha) {
        return 'Linha ' + linha + ': ' + entidade + ' n\xE3o possui representantes.';
      },
      invalida: function invalida(entidade, linha) {
        return 'Linha ' + linha + ': ' + entidade + ' inv\xE1lido(a) para os demais par\xE2metros especificados na linha de investimento.';
      }
    },
    linha_investimento: {
      duplicada: function duplicada(linha, entidades) {
        return 'Linha de or\xE7amento ' + linha + ' em conflito com a(s) linha(s): ' + entidades + '.';
      },
      obrigatoria: 'Linha de orçamento é obrigatório.'
    },
    login: {
      duplicado: 'Login já cadastrado no sistema.'
    },
    marca: {
      selecionar: 'Execute a busca e selecione uma marca'
    },
    material: {
      estoque_excedido_envio_aprovacao: function estoque_excedido_envio_aprovacao(material, pedido, estoque) {
        return 'N\xE3o \xE9 poss\xEDvel enviar para Aprova\xE7\xE3o\n        pois n\xE3o h\xE1 estoque dispon\xEDvel de [' + material + '].<br/>\n        Quantidade no pedido: ' + pedido + '. Quantidade em Estoque: ' + estoque;
      },
      quantidade_minima: 'Quantidade mínima não atingida',
      quantidade_maior_disponivel: 'Quantidade de material informada maior do que o disponível',
      ja_concluido: 'O controle de Materiais já foi concluído. Não é possível alterar suas informações.',
      quantidade_estoque_excedida: 'Quantidade indisponível em estoque para o pedido.'
    },
    matricula: {
      duplicada: 'Matrícula já cadastrada no sistema'
    },
    meta: {
      apuracao: {
        em_fluxo: 'Meta com apuração em fluxo'
      },
      cliente: {
        extensao: {
          obrigatoria: 'Cliente não associado à unidade de negócio referenciada na Meta'
        }
      },
      intervalos: {
        obrigatorios: 'A meta deve ter pelo menos um intervalo cadastrado.',
        conflito: 'Intervalo de valores em conflito com outro intervalo da mesma meta.'
      },
      inexistente: 'Meta inexistente para fazer upload arquivo',
      meta_anterior_ate_maior_meta_atual_de: 'Verifique os campos de data da meta',
      meta_ate: {
        menor_meta_de: 'Data menor que o campo \'meta de\'',
        obrigatoria: 'O campo meta até é origatório'
      },
      negativa: 'Meta não pode ser negativa',
      obrigatoria: 'Meta é obrigatória',
      valor_base_crescimento_obrigatorio: '',
      valor: {
        diferente_acordo: 'A somatória do valor das metas está diferente do valor do acordo',
        disponivel: {
          excedido: 'Excedeu o valor disponível, confira na tabela de metas.'
        }
      }
    },
    motivo: {
      obrigatorio: 'Deve-se enviar o motivo. Campo obrigatório.'
    },
    nome: {
      existente: 'Nome já cadastrado no sistema',
      obrigatorio: 'Nome é obrigatório',
      tamanho: function tamanho(min, max) {
        return 'Nome dever\xE1 ter um tamanho m\xEDnimo de ' + min + ' e m\xE1ximo de ' + max + ' caracteres';
      }
    },
    nota_fiscal: {
      campos_obrigatorios: 'Campos obrigatórios da Nota Fiscal não informados'
    },
    nome_fantasia: {
      existente: 'Nome Fantasia já cadastrado no sistema.',
      obrigatorio: 'Nome Fantasia é obrigatório',
      tamanho: function tamanho(min, max) {
        return 'Nome Fantasia dever\xE1 ter um tamanho m\xEDnimo de ' + min + ' e m\xE1ximo de ' + max + ' caracteres';
      }
    },
    nro_nota: {
      obrigatorio: 'Número da nota é obrigatório',
      tamanho: function tamanho(min, max) {
        return 'N\xFAmero da nota dever\xE1 ter um tamanho m\xEDnimo de ' + min + ' e m\xE1ximo de ' + max + ' caracteres';
      }
    },
    numerico: {
      tamanho: function tamanho(campo, inteiro, decimal) {
        return 'O ' + campo + ' deve conter no m\xE1ximo ' + inteiro + ' casas inteiras e ' + decimal + ' casas decimais';
      }
    },
    orcamento: {
      descricao_obrigatorio: 'Descrição é obrigatória',
      existente: 'Orçamento existente',
      tipo_linha_orcamento_obrigatorio: 'Tipo de linha de orçamento é obrigatório',
      canal_obrigatorio: 'Canal é obrigatório',
      centro_custo_obrigatorio: 'Centro de Custo é obrigatório',
      linha_orcamento_obrigatorio: 'Linha de orçamento é obrigatória.',
      marca_obrigatorio: 'Marca é obrigatório',
      duplicado: function duplicado(entidades) {
        return 'As datas est\xE3o conflitantes com outro(s) or\xE7amento(s) do mesmo tipo. Or\xE7amento(s) em conflito: ' + entidades + '.';
      },
      descricao_duplicada: 'Já existe um orçamento com essa descrição.',
      orcamento_valor_linha_nova: 'Valor da linha deve ser igual a zero.',
      valor_planejado_obrigatorio: 'Valor planejado deve ser maior que zero.',
      valor_invalido_rateio_competencia: 'Valor inválido no rateio para a competencia {competencia}. {inativo}'
    },
    pagamento: {
      id_obrigatorio: 'Selecione um ou mais pagamentos',
      iniciado: 'A ação já tem pagamento cadastrado.',
      ja_cancelado: 'Um ou mais pagamentos selecionados já foram cancelados.',
      ja_concluido: 'Manutenção concluída, atualize a página.',
      cancelado_concluido: 'Operação não realizada,o item já estava Concluído/Cancelado.'
    },
    pedido: {
      data_obrigatoria: 'Data de entrega é obrigatória.',
      valor_obrigatorio: 'Valor final frete é obrigatório.'
    },
    planejamento: {
      acoes_sem_materiais: function acoes_sem_materiais(acoes) {
        return 'A\xE7\xE3o PDV sem materiais vinculados: ' + acoes + '. Adicione materiais para prosseguir.';
      },
      obrigatorio: 'Planejamento é obrigatório.',
      acao_obrigatorio: 'Ação é obrigatória.',
      copia: {
        nao_encontrado: 'Planejamento de origem não foi encontrado.'
      }
    },
    planilha: {
      linha_investimento_requerida: 'Pelo menos uma linha de orçamento precisa estar preenchida',
      relacionamento: 'Relacionamento inconsistente entre o {entidade} [{valor}] e {entidade_ref} [{valor_ref}]',
      entidade_invalida: 'O(a) {entidade} [{valor}] não existe na base de dados',
      obrigatorio: 'O(a) {entidade} é obrigatório(a) no cadastro',
      distribuido: 'Valor distribuído nas linhas não confere com o total planejado'
    },
    periodo: {
      utilizado: {
        em_planejamento: 'Período já utilizado em um planejamento'
      },
      com_bloqueio: 'Período Fiscal com bloqueio',
      conflito: 'Período em conflito',
      obrigatorio: 'Período é obrigatório',
      invalido: 'Período inválido',
      fora: function fora(entidade, pai) {
        return 'Per\xEDodo de ' + entidade + ', est\xE1 fora do per\xEDodo de ' + pai;
      }
    },
    preco_negociacao: {
      obrigatorio: 'Preço negociação é obrigatório'
    },
    produto: {
      obrigatorio: 'Produto é obrigatório'
    },
    produto_eleito: {
      nao_encontrato: function nao_encontrato(configuracao) {
        return 'Nenhum produto encontrado para a configura\xE7\xE3o da meta: ' + configuracao;
      }
    },
    qtde: {
      obrigatoria: 'Quantidade é obrigatória'
    },
    rateio: {
      dist_invalida: 'Distribuição inválida do rateio. Atente-se para o totalizador.',
      dist_invalida_saldo: 'Distribuição inválida do rateio. Atente-se para o saldo disponível.',
      dist_invalida_vlr_alocado: 'Valor distribuído não pode ser menor que o valor já alocado.',
      dist_invalida_vlr_minimo: 'Valor distribuído não pode ser menor que o valor mínimo.',
      sem_estrutura_representante: 'Não é possível fazer rateio sem estrutura de usuário para representante.',
      sem_estrutura_usuario: function sem_estrutura_usuario(estrutura) {
        return 'Nenhum usu\xE1rio encontrado para a estrutura ' + estrutura + '.';
      },
      mais_de_um_superior: function mais_de_um_superior(usuario) {
        return 'Usu\xE1rio ' + usuario + ' possui mais de um superior imediato no rateio.';
      },
      saldo_negativo: 'Saldo negativo {saldo} para a divisão {divisao}'
    },
    razao_social: {
      existente: 'Razão Social já cadastrada no sistema.',
      obrigatorio: 'Razão Social é obrigatório',
      tamanho: function tamanho(min, max) {
        return 'Raz\xE3o Social dever\xE1 ter um tamanho m\xEDnimo de ' + min + ' e m\xE1ximo de ' + max + ' caracteres';
      }
    },
    reducao: {
      valor_reduzir: 'Valor a reduzir é obrigatório.',
      valor_reduzir_invalido: 'Valor a reduzir inválido.'
    },
    registros: {
      ativos: {
        dependentes: 'Não é possivel inativar pois existem cadastros ativos que dependem deste registro.'
      }
    },
    required: 'Este campo é obrigatório',
    role: {
      obrigatoria: 'Role é obrigatória'
    },
    saldo_conta_corrente: {
      obrigatorio: 'Saldo da conta corrente é obrigatório'
    },
    selecionar: {
      canal_vendas: 'Execute a busca e selecione um canal de vendas',
      familia_produto: 'Execute a busca e selecione uma família',
      linha_investimento: 'Execute a busca e selecione uma linha de orçamento',
      marca: 'Execute a busca e selecione uma marca',
      tipo_acao: 'Execute a busca e selecione um tipo de ação',
      tipo_linha_investimento: 'Execute a busca e selecione um tipo de linha de orçamento',
      unidade_medida: 'Execute a busca e selecione uma unidade de medida'
    },
    sem_permissao: {
      alterar: function alterar(entidade) {
        return 'O usu\xE1rio n\xE3o tem permiss\xE3o para alterar o(a) ' + entidade;
      },
      visualizar: function visualizar(entidade) {
        return 'O usu\xE1rio n\xE3o tem permiss\xE3o para visualizar o(a) ' + entidade;
      }
    },
    servico: {
      tipo_verba_nao_permitido: 'O Tipo de Verba informado não permite inserir serviços.'
    },
    sessao_expirada: 'A sessão expirou, será necessário realizar novo login!',
    sigla: {
      obrigatoria: 'Sigla é obrigatória',
      existente: 'Sigla já cadastrada no sistema',
      tamanho: function tamanho(min, max) {
        return 'Sigla dever\xE1 ter um tamanho m\xEDnimo de ' + min + ' e m\xE1ximo de ' + max + ' caracteres';
      }
    },
    sistema: {
      bloqueio: 'O sistema se encontra bloqueado para a funcionalidade solicitada.'
    },
    status: {
      saldo_insuficiente: 'Saldo insuficiente',
      necessario: function necessario() {
        for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
          params[_key] = arguments[_key];
        }

        return 'O status do contrato atual deveria ser: ' + params.toString();
      },
      incorreto: function incorreto() {
        for (var _len2 = arguments.length, params = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          params[_key2] = arguments[_key2];
        }

        return 'O status atual deveria ser: ' + params.toString();
      },
      obrigatorio: 'Status é obrigatório',
      transferencia: function transferencia() {
        for (var _len3 = arguments.length, params = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          params[_key3] = arguments[_key3];
        }

        return 'Transfer\xEAncia n\xE3o efetuada. O status do Or\xE7amento deve ser: ' + params.toString();
      },
      alteracao_inadequada: function alteracao_inadequada() {
        for (var _len4 = arguments.length, params = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
          params[_key4] = arguments[_key4];
        }

        return 'N\xE3o \xE9 poss\xEDvel alterar o status para ' + params.toString();
      }
    },
    tamanho: {
      rg: function rg(min, max) {
        return 'RG dever\xE1 ter um tamanho m\xEDnimo de ' + min + ' e m\xE1ximo de ' + max + ' caracteres';
      },
      telefone: function telefone(min, max) {
        return 'Telefone dever\xE1 ter um tamanho m\xEDnimo de ' + min + ' e m\xE1ximo de ' + max + ' caracteres';
      },
      celular: function celular(min, max) {
        return 'Celular dever\xE1 ter um tamanho m\xEDnimo de ' + min + ' e m\xE1ximo de ' + max + ' caracteres';
      },
      orgao_expedidor: function orgao_expedidor(min, max) {
        return '\xD3rg\xE3o expedidor dever\xE1 ter um tamanho m\xEDnimo de ' + min + ' e m\xE1ximo de ' + max + ' caracteres';
      }
    },
    tipo_acordo: {
      obrigatorio: 'Tipo acordo é obrigatório',
      inexistente: 'Tipo acordo inexistente'
    },
    tipo_beneficio: {
      obrigatorio: 'Tipo benefício é obrigatório'
    },
    tipo: {
      beneficio: {
        diferente: function diferente(entidade) {
          return 'Tipo benef\xEDcio \xE9 diferente do ' + entidade;
        }
      },
      selecionar: 'Execute a busca e selecione um tipo'
    },
    tipo_linha_orcamento: {
      em_uso: 'Tipo de linha de orçamento está em uso'
    },
    transferencia: {
      saldo_menor_vlr_transferido: 'Saldo insuficiente'
    },
    transferencia_posse: {
      ja_realizada_funcionario: 'Transferência de posse já realizada para esse funcionário.',
      ja_realizada_divisao: 'Transferência de posse já realizada para essa divisão.'
    },
    un_medida: {
      obrigatoria: 'Unidade de medida é obrigatória'
    },
    upload: {
      falha_diretorio: 'Diretório não encontrato'
    },
    usuario: {
      asociado_cliente: 'Usuário já associado com um Cliente',
      estrutura_usuario: 'Usuário não tem definição Hirarquia/Unidade de Negócio.',
      obrigatorio: 'Usuário é obrigatório',
      inativo: 'Usuário inativo.'
    },
    valor: {
      conflitante: function conflitante(range) {
        return 'Valor limite ' + range + ' conflitante com os limites do fluxo anterior.';
      },
      disponivel: {
        excedido: 'Excedeu o valor disponível.',
        representante: {
          excedido: function excedido(representante) {
            return 'Representante ' + representante + ' excedeu o valor dispon\xEDvel.';
          }
        }
      },
      excedido: function excedido(entidade, pai) {
        return 'Valor ' + entidade + ' excedeu valor m\xE1ximo de ' + pai + '.';
      },
      final: 'Alçada anterior é a final.',
      intervalos: {
        conflito: 'Intervalo de valores em conflito com outro intervalo.'
      },
      maior: 'Valor inicial está maior que valor final.',
      menor: 'Valor final está menor que valor inicial.',
      maior_zero: 'Valor deve ser maior que 0,00',
      maior_zero_inteiro: 'Valor deve ser maior que 0',
      minimo: 'Valor deve ser maior ou igual a {min}',
      maximo: 'Valor deve ser menor ou igual a {max}',
      negativo: 'Valor não pode ser negativo',
      obrigatorio: function obrigatorio(entidade) {
        return 'Valor ' + entidade + ' obrigatorio.';
      }
    },
    valor_previsto: {
      obrigatorio: 'Valor Previsto obrigatório'
    },
    vinculo: {
      existente: 'Vínculo existente'
    },
    vlr_aliquota: {
      obrigatorio: 'Valor da alíquota é obrigatório'
    },
    vlr_impostos: {
      obrigatorio: 'Valor de impostos é obrigatório'
    },
    valor_de_maior_ate: 'Valor até deve ser maior que valor de',
    valor_inicial_mayor_final: 'Valor final deve ser maior que valor inicial',
    meta_ate_maior_meta_de: '"Meta até" deve ser maior que "Meta de"',
    vlr_investimento: {
      obrigatorio: 'Valor de Linha de Orçamento é obrigatório'
    },
    vlr_unitario: {
      obrigatorio: 'Valor unitário é obrigatório'
    },
    volume: {
      tamanho: 'O volume deve conter no máximo {inteiro} casas inteiras e {decimal} casas decimais'
    },
    workflow: {
      fluxo_sem_aprovador_valido: 'Fluxo não tem um aprovador válido.'
    }
  },
  roles: {
    ACAO_CRUD: {
      titulo: 'Manutenção de Planejamento de Ação',
      descricao: 'Permite acesso ao módulo Planejamento de ação para cadastro de uma nova ação e manutenção de suas informações'
    },
    ACAO_PAGINA: {
      titulo: 'Consulta de Planejamento de Ação',
      descricao: 'Permite acesso ao módulo de Planejamento de ação para consulta'
    },
    ACD_PAGINA: {
      titulo: 'Consultar Acordo',
      descricao: 'Permite acesso ao módulo Acordo apenas para consulta'
    },
    ACORDO_RATEIO_PAGINA: {
      titulo: 'Suporte Rateio Manual',
      descricao: 'Permite acesso à tela de suporte para refazer o rateio manual de acordos aprovados'
    },
    ACESSO_FORNECEDOR: {
      titulo: 'Consultas gerais do fornecedor no Tradelinks',
      descricao: 'Permite ao usuário acesso aos módulos de Planejamento, Apuração e Recebimento para consultas gerais'
    },
    ACESSO_CLIENTE: {
      titulo: 'Consultas gerais do cliente no Tradelinks',
      descricao: 'Permite ao usuário acesso aos módulos de Planejamento, Apuração e Pagamento para consultas gerais'
    },
    ADMINISTRACAO_PAGINA: {
      titulo: 'Administração',
      descricao: 'Permite acesso a página de administração'
    },
    APU_ACAO_CRUD: {
      titulo: 'Manutenção de Apuração de Ação',
      descricao: 'Permite acesso ao módulo de apuração de ação para alteração, cancelamento e solicitação de aprovação'
    },
    APU_ACAO_PAGINA: {
      titulo: 'Consulta de Apuração de Ação',
      descricao: 'Permite acesso ao módulo de apuração de ação para consulta'
    },
    LOG_DOWN_CAT_PECA: {
      titulo: 'Consulta log dos downloads',
      descricao: 'Permite acesso ao tela de log dos downloads dos catalogos'
    },
    DOWN_CAT_PECAS: {
      titulo: 'Download catalogo de peças',
      descricao: 'Permite ao usuário fazer download do catalogo de pecas'
    },
    CARTEIRA_PAGINA: {
      titulo: 'Consulta de Carteira de Cliente',
      descricao: 'Permite acesso ao Cadastro de Carteira de Cliente apenas para consulta'
    },
    CARTEIRA_CRUD: {
      titulo: 'Cadastro de Carteira de Cliente',
      descricao: 'Permite acesso ao Cadastro de Carteira de Cliente para realização de cadastro e edição de registros de Carteira de Cliente'
    },
    CONFIG_PLAN: {
      titulo: 'Configuração de planejamento',
      descricao: 'Acesso a Configuração de Planejamento'
    },
    CANCELAR_CONTRATO: {
      titulo: 'Cancelamento de contrato',
      descricao: 'Permite acesso a cancelar um contrato aprovado'
    },
    CONTRATO_CRUD: {
      titulo: 'Manter planejamento de contrato',
      descricao: 'Permite o acesso ao módulo de Contrato para criar, editar e solicitar aprovação'
    },
    CONTRATO_PAGINA: {
      titulo: 'Consultar planejamento de contrato',
      descricao: 'Permite o acesso ao módulo de Contrato para consulta e acompanhamento do fluxo de aprovação'
    },
    CONT_UPLOAD_ARQ: {
      titulo: 'Realizar upload de arquivos no contrato',
      descricao: 'Permite acesso para realizar upload de arquivos no contrato independente do status do contrato'
    },
    FLUXO_GEST_APRO: {
      titulo: 'Gestão de aprovações',
      descricao: 'Permite alterar o aprovador dos fluxos em andamento ou remover passos.'
    },
    EVT_PAGINA: {
      titulo: 'Consultar Eventos Acesso',
      descricao: 'Consultar eventos de acesso do usuário'
    },
    FILIAL_CRUD: {
      titulo: 'Cadastro de filiais',
      descricao: 'Permite acesso à tela de filial para cadastro'
    },
    FILIAL_PAGINA: {
      titulo: 'Consulta de filiais',
      descricao: 'Permite acesso à tela de filial para consulta'
    },
    FUNC_PAGINA: {
      titulo: 'Consulta de Funcionário',
      descricao: 'Permite acesso ao Cadastro de Funcionário apenas para consulta'
    },
    FUNC_CRUD_ATUALIZAR: {
      titulo: 'Cadastro de Funcionário',
      descricao: 'Permite acesso ao Cadastro de Funcionário para realização de edição de registros de Funcionário'
    },
    FUNC_CRUD_INSERIR: {
      titulo: 'Cadastro de Funcionário',
      descricao: 'Permite acesso ao Cadastro de Funcionário para realização de cadastro de registros de Funcionário'
    },
    PECA_PAGINA: {
      titulo: 'Consulta de Peças',
      descricao: 'Permite acesso ao Cadastro de Peças apenas para consulta'
    },
    CAL_PAGINA: {
      titulo: 'Consultar Calendário',
      descricao: 'Permite acesso ao Cadastro de Calendário apenas para consulta'
    },
    CAL_CRUD: {
      titulo: 'Cadastrar Calendário',
      descricao: 'Permite acesso ao Cadastro de Calendário para realização de cadastro'
    },
    CAL_VISUALIZAR: {
      titulo: 'Cadastrar Calendário',
      descricao: 'Permite acesso a visualização do calendário no toolbar'
    },
    PECA_CRUD: {
      titulo: 'Cadastro de Peças',
      descricao: 'Permite acesso ao Cadastro de Peças para realização de cadastro e edição de registros de Peças'
    },
    MATERIAL_PAGINA: {
      titulo: 'Consulta de Materais',
      descricao: 'Permite acesso ao Cadastro de Materiais apenas para consulta'
    },
    MATERIAL_CRUD: {
      titulo: 'Cadastro de Materiais',
      descricao: 'Permite acesso ao Cadastro de Materiais para realização de cadastro e edição de registros de Materiais'
    },
    DIVISAO_PAGINA: {
      titulo: 'Consulta de Divisão',
      descricao: 'Permite acesso ao Cadastro de Divisão apenas para consulta'
    },
    DIVISAO_CRUD: {
      titulo: 'Cadastro de Divisão',
      descricao: 'Permite acesso ao Cadastro de Divisão para realização de cadastro e edição de registros de Divisão'
    },
    APORTE_DIVISAO: {
      titulo: 'Aporte BASF',
      descricao: 'Permite realização de Aporte de Verbas BASF nas Divisões'
    },
    APORTE_CLIENTE: {
      titulo: 'Aporte Cliente',
      descricao: 'Permite realização de Aporte de Verbas para Clientes'
    },
    VERBA_MATERIAIS: {
      titulo: 'Verba Materiais',
      descricao: 'Permite realização de aporte, redução e transferência de verbas para matérias'
    },
    APORTE_INFINITO: {
      titulo: 'Aporte Infinito',
      descricao: 'Permite realização de Aporte de Verbas BASF nas Divisões sem limitar ao Saldo da Conta Corrente'
    },
    RED_DIVISAO: {
      titulo: 'Redução BASF',
      descricao: 'Permite realização de Redução de Verbas BASF nas Divisões'
    },
    LIQ_DTA_CONT_CRUD: {
      titulo: 'Alterar data de contabilização',
      descricao: 'Permite que o usuário informe a Data de Contabilização na aprovação da ação avulsa (planejamento ou apuração)'
    },
    LIQ_DTA_CONT_PAGINA: {
      titulo: 'Consultar nota de débito sem data de contabilização',
      descricao: 'Permite ao usuário consultar as notas de débito pendentes, ou seja, sem data de contabilização informada'
    },
    LIQ_ND_PAGINA: {
      titulo: 'Consultar Nota de débito',
      descricao: 'Permite acesso a tela de consulta de Nota de Débito'
    },
    MARGEM_ROI: {
      titulo: 'Margem ROI',
      descricao: 'Permite acesso a tela de margem ROI'
    },
    MARGEM_ROI_IMPORTAR: {
      titulo: 'Margem ROI Importar',
      descricao: 'Permite acesso ao módulo Importação Margem ROI'
    },
    MARGEM_ROI_EXPORTAR: {
      titulo: 'Margem ROI Exportar',
      descricao: 'Permite acesso ao módulo Exportação do Margem ROI'
    },
    NOTA_PAGINA: {
      titulo: 'Consultar e exportar dados de notas',
      descricao: 'Permite o acesso a tela de nota para consulta e exportação'
    },
    NOTA_CRUD: {
      titulo: 'Importar e resolver inconsistências de integração de notas',
      descricao: 'Permite o acesso a tela de nota para importação e resolução de inconsistências de integração'
    },
    RED_CLIENTE: {
      titulo: 'Redução Cliente',
      descricao: 'Permite realização de Redução de Verbas para Clientes'
    },
    TRANS_PAGINA: {
      titulo: 'Transferência Conta Corrente',
      descricao: 'Permite realização de Transferência de Verbas BASF entre as Divisões'
    },
    SLD_DIVISAO: {
      titulo: 'Consulta Saldo Conta Corrente BASF',
      descricao: 'Permite consulta ao Saldo de Conta Corrente de Verbas BASF das Divisões'
    },
    SLD_CLIENTE: {
      titulo: 'Consulta Saldo Conta Corrente Cliente',
      descricao: 'Permite consulta ao Saldo de Conta Corrente de Verbas dos Clientes'
    },
    EXT_DIVISAO: {
      titulo: 'Consulta Extrato Conta Corrente BASF',
      descricao: 'Permite consulta ao Extrato de Conta Corrente de Verbas BASF das Divisões'
    },
    EXT_CLIENTE: {
      titulo: 'Consulta Extrato Conta Corrente Cliente',
      descricao: 'Permite consulta ao Extrato de Conta Corrente de Verbas dos Clientes'
    },
    ANO_FISCAL: {
      titulo: 'Cadastro Período',
      descricao: 'Permite acesso ao processo de encerramento e cadastro de Períodos, Períodos de planejamento e Períodos orçamentários'
    },
    PERIODO_FISCAL: {
      titulo: 'Fechamento Período de Planejamento',
      descricao: 'Permite acesso ao processo de encerramento Períodos de Planejamento'
    },
    PLAN_PAGINA: {
      titulo: 'Visualizar Planejamento',
      descricao: 'Permite acesso ao Módulo Planejamento apenas para consulta'
    },
    PLAN_DIVISAO: {
      titulo: 'Criar Planejamento Verba BASF',
      descricao: 'Permite acesso ao Módulo Planejamento para Criação de Planejamento com Ações utilizando apenas verba BASF'
    },
    PLAN_CLIENTE: {
      titulo: 'Criar Planejamento Verba Cliente',
      descricao: 'Permite acesso ao Módulo Planejamento para Criação de Planejamento com Ações utilizando verba de CLIENTE'
    },
    PLAN_WORKFLOW: {
      titulo: 'Fluxo Aprovação Planejamento',
      descricao: 'Permite aprovar, reprovar e enviar para analise os planejamentos de acordo com a hierarquia do usuário.'
    },
    EXECUCAO_PAGINA: {
      titulo: 'Consulta de Execução',
      descricao: 'Permite acesso ao Módulo Execução apenas para consulta'
    },
    ORCAMENTO_PAGINA: {
      titulo: 'Visualizar Orçamento Execução',
      descricao: 'Permite acesso ao Módulo Orçamento Execução apenas para consulta'
    },
    ORCAMENTO_AGENCIA: {
      titulo: 'Orçamento Execução - Agência',
      descricao: 'Permite acesso ao Módulo Orçamento Execução para envio de Orçamentos e Layouts para aprovação - Acesso Agência'
    },
    ORCAMENTO_EMPRESA: {
      titulo: 'Orçamento Execução - BASF',
      descricao: 'Permite acesso ao Módulo Orçamento Execução para aprovação/reprovação de Orçamentos e Layouts - Acesso BASF'
    },
    GERAR_GRADE_MAT: {
      titulo: 'Gerar Grade Pedido de Materiais',
      descricao: 'Permite Geração de Grade de Pedidos de Materiais - Acesso Operador Logístico'
    },
    STS_ENTREGA_MAT: {
      titulo: 'Atualizar Status de Entrega Materiais',
      descricao: 'Permite Atualização de Status de Entrega de Pedidos de Materiais - Acesso Operador Logístico'
    },
    REPORTE_PAGINA: {
      titulo: 'Consulta de Reporte',
      descricao: 'Permite acesso ao Módulo Reporte apenas para consulta'
    },
    REPORTE_CRUD: {
      titulo: 'Cadastro de Reporte',
      descricao: 'Permite acesso ao Módulo Reporte para registro e edição de Reporte de Ação'
    },
    PGTO_CRUD_AGENCIA: {
      titulo: 'Cadastro de Pagamento - AGÊNCIA',
      descricao: 'Permite acesso ao Módulo Pagamento para registro de Pagamento de Ação Modalidade 2 e 3 - Acesso Agência'
    },
    PGTO_CRUD_EMPRESA: {
      titulo: 'Cadastro de Pagamento - BASF',
      descricao: 'Permite acesso ao Módulo Pagamento para registro de Pagamento de Ação Modalidade 1 e 2 - Acesso BASF'
    },
    REC_ACAO_CRUD: {
      titulo: 'Manutenção de Recebimento de Ação',
      descricao: 'Permite acesso ao módulo de recebimento de ação para alteração, cancelamento e solicitação de aprovação'
    },
    REC_ACAO_PAGINA: {
      titulo: 'Consulta de Recebimento de Ação',
      descricao: 'Permitr acesso ao módulo de recebimento de ação para consulta'
    },
    REL_USR_ACESSO: {
      titulo: 'Relatório Acesso de Usuário',
      descricao: 'Acesso ao relatório Acesso de Usuário'
    },
    REL_ANALITICO_ACOES: {
      titulo: 'Relatório Analítico de Ações',
      descricao: 'Permite acesso ao Relatório Analítico de Ações'
    },
    REL_INV_AREA: {
      titulo: 'Relatório Investimento por Área de Atuação',
      descricao: 'Permite acesso ao Relatório Investimento por Área de Atuação'
    },
    REL_INV_CLIENTE: {
      titulo: 'Relatório Investimento por Distribuidor/Cliente',
      descricao: 'Permite acesso ao Relatório Investimento por Cliente'
    },
    REL_INV_CULTIVO: {
      titulo: 'Relatório Investimento por Cultivo',
      descricao: 'Permite acesso ao Relatório Investimento por Cultivo'
    },
    REL_PERIODO: {
      titulo: 'Relatório Planejado x Realizado por Período',
      descricao: 'Permite acesso ao Relatório Planejado x Realizado por Período'
    },
    REL_INV_MATERIAIS: {
      titulo: 'Relatório Investimento por Materiais',
      descricao: 'Permite acesso ao Relatório Investimento por Materiais'
    },
    REL_INV_PECAS: {
      titulo: 'Relatório Investimento por Peças',
      descricao: 'Permite acesso ao Relatório Investimento por Peças'
    },
    REL_MAT_PRODUZIR: {
      titulo: 'Relatório Material a Produzir',
      descricao: 'Permite acesso ao Relatório Material a Produzir'
    },
    REL_PENDENCIAS: {
      titulo: 'Dashboard Pendências',
      descricao: 'Permite acesso as pendências no dashboard'
    },
    REL_PENDENCIAS_AGENCIA: {
      titulo: 'Dashboard Pendências Agência',
      descricao: 'Permite acesso as pendências da agência no dashboard'
    },
    TRADELINKS_ADMIN: {
      titulo: 'Acesso Administrador',
      descricao: 'Acesso a todas as divisões independente da hierarquia do usuário em telas como Redução, Planejamento, Relatório, transferência, entre outras.  '
    },
    TRADELINKS_AGENCIA: {
      titulo: 'Acesso Agência',
      descricao: 'Acesso a todas as divisões independente da hierarquia do usuário (apenas para usuários do tipo agência).  '
    },
    CLIENTE_PAGINA: {
      titulo: 'Consultar Cliente',
      descricao: 'Permite acesso ao Cadastro de Cliente apenas para consulta'
    },
    CLIENTE_CRUD: {
      titulo: 'Cadastrar Cliente',
      descricao: 'Permite acesso ao Cadastro de Cliente nas operações: Cadastrar / Importar / Exportar / Associar Loja / Associar Vendedor'
    },
    EXECUCAO_CRUD: {
      titulo: 'Alteração de status da ação',
      descricao: 'Permite acesso ao Módulo Planejamento para alteração do status de uma Ação'
    },
    CECO_PAGINA: {
      titulo: 'Consultar Centro de Custo',
      descricao: 'Permite acesso ao Cadastro de Centro de Custo apenas para consulta'
    },
    CECO_CRUD: {
      titulo: 'Cadastrar Centro de Custo',
      descricao: 'Permite acesso ao Cadastro de Centro de Custo para realização de cadastro'
    },
    ESTRUTURA_PAGINA: {
      titulo: 'Consultar Estrutura de Usuário',
      descricao: 'Permite acesso ao Cadastro de Estrutura de Usuário apenas para consulta'
    },
    ESTRUTURA_CRUD: {
      titulo: 'Cadastrar Estrutura de Usuário',
      descricao: 'Permite acesso ao Cadastro de Estrutura de Usuário para realização de cadastro'
    },
    USR_PAGINA: {
      titulo: 'Consultar Gestão de Usuário',
      descricao: 'Permite acesso ao Cadastro de Gestão de Usuário apenas para consulta'
    },
    USR_CRUD: {
      titulo: 'Cadastrar Gestão de Usuário',
      descricao: 'Permite acesso ao Cadastro de Gestão de Usuário para realização de cadastro'
    },
    USR_INSERIR: {
      titulo: 'Cadastrar Usuário',
      descricao: 'Permite acesso ao Cadastro de Gestão de Usuário para realização de cadastro'
    },
    USR_ATUALIZAR: {
      titulo: 'Atualização de Usuário',
      descricao: 'Permite acesso ao Módulo Gestão de Usuário para atualização de Usuário'
    },
    PARAM_PERIODO_CRUD: {
      titulo: 'Realizar a parametrização de período',
      descricao: 'Permite acesso a parametrização de período'
    },
    PARAM_PERIODO_PAGINA: {
      titulo: 'Visualizar a parametrização de período',
      descricao: 'Permite acesso a visualização de parametrização de período'
    },
    PRD_PAGINA: {
      titulo: 'Consultar Produto',
      descricao: 'Permite acesso ao Cadastro de Produto apenas para consulta'
    },
    PRD_CRUD: {
      titulo: 'Cadastrar Produto',
      descricao: 'Permite acesso ao Cadastro de Produto para realização de cadastro'
    },
    REGIAO_PAGINA: {
      titulo: 'Consultar Região',
      descricao: 'Permite acesso ao Cadastro de Região apenas para consulta'
    },
    REGIAO_CRUD: {
      titulo: 'Cadastrar Região',
      descricao: 'Permite acesso ao Cadastro de Região para realização de cadastro'
    },
    TERMO_ACEITE_PAGINA: {
      titulo: 'Consultar Termo de aceite',
      descricao: 'Permite acesso a tela de consulta de Termo de aceite'
    },
    TERMO_ACEITE_CRUD: {
      titulo: 'Cadastrar Termo de aceite',
      descricao: 'Permite acesso ao Cadastro de Termo de aceite nas operações: Cadastrar / Exportar / Editar / Inativar'
    },
    TIPO_LINHA_PAGINA: {
      titulo: 'Consultar Tipo de Linha de Orçamento',
      descricao: 'Permite acesso ao Cadastro de Tipo de Linha de Orçamento apenas para consulta'
    },
    TIPO_LINHA_CRUD: {
      titulo: 'Cadastrar Tipo de Linha de Orçamento',
      descricao: 'Permite acesso ao Cadastro de Tipo de Linha de Orçamento para realização de cadastro'
    },
    TIPO_ACAO_PAGINA: {
      titulo: 'Consultar Tipo de Ação',
      descricao: 'Permite acesso ao Cadastro de Tipo de Ação apenas para consulta'
    },
    TIPO_ACAO_CRUD: {
      titulo: 'Cadastrar Tipo de Ação',
      descricao: 'Permite acesso ao Cadastro de Tipo de Ação para realização de cadastro'
    },
    TIPO_ORC_PAGINA: {
      titulo: 'Consultar Tipo de Orçamento',
      descricao: 'Permite acesso ao Cadastro de Tipo de Orçamento apenas para consulta'
    },
    TIPO_ORC_CRUD: {
      titulo: 'Cadastrar Tipo de Orçamento',
      descricao: 'Permite acesso ao Cadastro de Tipo de Orçamento para realização de cadastro'
    },
    UNID_MEDIDA_PAGINA: {
      titulo: 'Consultar Unidade de Medida',
      descricao: 'Permite acesso ao Cadastro de Unidade de Medida apenas para consulta'
    },
    UNID_MEDIDA_CRUD: {
      titulo: 'Cadastrar Unidade de Medida',
      descricao: 'Permite acesso ao Cadastro de Unidade de Medida para realização de cadastro'
    },
    FLUXO_PAGINA: {
      titulo: 'Consultar Workflow',
      descricao: 'Permite acesso ao Cadastro de Wokflow apenas para consulta'
    },
    FLUXO_CRUD: {
      titulo: 'Cadastrar Workflow',
      descricao: 'Permite acesso ao Cadastro de Wokflow para realização de cadastro'
    },
    ALCADA_PAGINA: {
      titulo: 'Consultar Alçada',
      descricao: 'Permite acesso ao Cadastro de Alçada apenas para consulta'
    },
    ALCADA_CRUD: {
      titulo: 'Cadastrar Alçada',
      descricao: 'Permite acesso ao Cadastro de Alçada para realização de cadastro'
    },
    CONFIG_FLUXO: {
      titulo: 'Configurar Workflow de Aprovação',
      descricao: 'Permite acesso a alteração de configuações de Workflow de Aprovação'
    },
    CONFIG_NEG: {
      titulo: 'Configurar Negociação',
      descricao: 'Permite acesso a alteração de configuações de Negociação'
    },
    CONFIG_CALENDARIO: {
      titulo: 'Configurar Calendário de Aprovações',
      descricao: 'Permite acesso a alteração de configuações de Calendário de Aprovações'
    },
    CONFIG_ORC: {
      titulo: 'Configurar Orçamento',
      descricao: 'Permite acesso a alteração de configuações de Orçamento'
    },
    CONFIG_APURACAO: {
      titulo: 'Configurar Apuração',
      descricao: 'Permite acesso a alteração de configuações de Apuração'
    },
    CONFIG_PGTO: {
      titulo: 'Configurar Pagamento',
      descricao: 'Permite acesso a alteração de configuações de Pagamento'
    },
    CONFIG_EMAIL: {
      titulo: 'Configurar notificação email',
      descricao: 'Permite acesso a alteração de configurações de notificação de acordo via email'
    },
    DASH_ACOES: {
      titulo: 'Dashboard de Ações',
      descricao: 'Permite acesso ao Dashboard de Ações'
    },
    DASH_OPER_ORC: {
      titulo: 'Dashboard de Orçamento',
      descricao: 'Permite acesso ao Dashboard Operacional de Orçamento'
    },
    DASH_OPER_NEG: {
      titulo: 'Dashboard de Negociação',
      descricao: 'Permite acesso ao Dashboard Operacional de Negociação'
    },
    DASH_OPER_APURACAO: {
      titulo: 'Dashboard de Apuração',
      descricao: 'Permite acesso ao Dashboard Operacional de Apuração'
    },
    DASH_OPER_PGTO: {
      titulo: 'Dashboard de Pagamento',
      descricao: 'Permite acesso ao Dashboard Operacional de Pagamento'
    },
    DASH_OPER_CLIENTE: {
      titulo: 'Dashboard de Cliente',
      descricao: 'Permite acesso ao Dashboard Operacional de Cliente'
    },
    DASH_GER_ROI: {
      titulo: 'Dashboard ROI',
      descricao: 'Permite acesso ao Dashboard Gerencial ROI'
    },
    DASH_GER_FECHAMENTO: {
      titulo: 'Dashboard Gerencial - Fechamento',
      descricao: 'Permite acesso ao Dashboard Gerencial Fechamento'
    },
    DASH_GER_PLANO_COMPARATIVO: {
      titulo: 'Dashboard Plano Comparativo',
      descricao: 'Permite acesso ao Dashboard Gerencial Plano Comparativo'
    },
    DASH_GER_PART_INVESTIMENTO: {
      titulo: 'Dashboard Participação sobre Investimento',
      descricao: 'Permite acesso ao Dashboard Gerencial Participação sobre Investimento'
    },
    DASH_GER_ANALISE_INVESTIMENTO: {
      titulo: 'Dashboard Análise de Investimento',
      descricao: 'Permite acesso ao Dashboard Gerencial Plano Análise de Investimento'
    },
    DASH_GER_RELATORIOS: {
      titulo: 'Dashboard Relatórios',
      descricao: 'Permite acesso ao Dashboard Gerencial Relatórios'
    },
    DASH_GER_RELATORIOS_EVI: {
      titulo: 'Dashboard Relatório de Evidências',
      descricao: 'Permite acesso aos relatório de evidências do Dashboard Gerencial Relatórios'
    },
    DASH_GER_RELATORIOS_FIN: {
      titulo: 'Dashboard Relatórios Financeiros',
      descricao: 'Permite acesso aos relatórios financeiros do Dashboard Gerencial Relatórios'
    },
    DASH_GER_ACOMPANHAMENTO: {
      titulo: 'Dashboard Acompanhamento',
      descricao: 'Permite acesso ao Dashboard Gerencial Acompanhamento'
    },
    ORC_PAGINA: {
      titulo: 'Consultar Orçamento',
      descricao: 'Permite acesso ao módulo Orçamento apenas para consulta'
    },
    ORC_CRUD: {
      titulo: 'Cadastrar Orçamento',
      descricao: 'Permite acesso ao módulo Orçamento para cadastro de um novo Orçamento'
    },
    ORC_RATEIO: {
      titulo: 'Rateio de Orçamento',
      descricao: 'Permite acesso ao módulo Orçamento para realização de Rateio'
    },
    ORC_RATEIO_ADD_VEND: {
      titulo: 'Inclusão de vendedor em rateio',
      descricao: 'Permite acesso a funcionalidade de incluir um novo vendedor em um orçamento que já foi aprovado'
    },
    ORC_TRANSFERENCIA: {
      titulo: 'Transferência de Orçamento',
      descricao: 'Permite acesso ao módulo Orçamento para realização de Transferência de Verba'
    },
    ORC_AJUSTE: {
      titulo: 'Ajuste de Verba de Orçamento',
      descricao: 'Permite acesso ao módulo Orçamento para realização de Adendo e Redução de Verba'
    },
    NEG_PAGINA: {
      titulo: 'Consultar Negociação',
      descricao: 'Permite acesso ao módulo Negociação apenas para consulta'
    },
    NEG_CRUD: {
      titulo: 'Cadastrar/Cancelar Negociação',
      descricao: 'Permite acesso ao módulo Negociação para realização de Cadastro e Cancelamento'
    },
    NEG_ENCERRAR: {
      titulo: 'Encerrar Negociação',
      descricao: 'Permite acesso ao módulo Negociação para realização de Encerramento'
    },
    NEG_IMPRIMIR: {
      titulo: 'Imprimir Negociação',
      descricao: 'Permite acesso ao módulo Negociação para realização de Impressão'
    },
    APU_CONTR_PAGINA: {
      titulo: 'Consultar apuração de contrato',
      descricao: 'Permite ao usuário acesso ao módulo de Apuração de Contrato para consulta e acompanhamento'
    },
    APU_CONTR_CRUD: {
      titulo: 'Alterar e manter apuração de contrato',
      descricao: 'Permite ao usuário acesso ao módulo de Apuração de Contrato para edição e conclusão'
    },
    APU_CRUD: {
      titulo: 'Apuração - Edição',
      descricao: 'Permite acesso ao módulo Apuração para Edição'
    },
    APU_DOWNLOAD: {
      titulo: 'Apuração - Download Evidência',
      descricao: 'Permite acesso ao módulo Apuração para Download de arquivo para Execução de Meta'
    },
    APU_PAGINA: {
      titulo: 'Apuração - Consulta',
      descricao: 'Permite acesso ao módulo Apuração apenas para consulta'
    },
    APU_UPLOAD: {
      titulo: 'Apuração - Upload Evidência',
      descricao: 'Permite acesso ao módulo Apuração para Upload de arquivo para Execução de Meta'
    },
    PGTO_PAGINA: {
      titulo: 'Consultar Pagamento',
      descricao: 'Permite acesso ao módulo Pagamento apenas para consulta'
    },
    PGTO_CRUD: {
      titulo: 'Alterar e manter Pagamento',
      descricao: 'Permite acesso ao módulo Pagamento para Edição'
    },
    PGTO_EXPORTAR: {
      titulo: 'Exportar Pagamento',
      descricao: 'Permite acesso ao módulo Pagamento para Exportação de Pagamento'
    },
    PGTO_IMPORTAR: {
      titulo: 'Importar Pagamento',
      descricao: 'Permite acesso ao módulo Pagamento para Importação de Pagamento'
    },
    PGTO_CANCELAR: {
      titulo: 'Cancelar Pagamento',
      descricao: 'Permite acesso ao módulo Pagamento para Cancelamento de Pagamento'
    },
    PGTO_RESGATAR: {
      titulo: 'Resgatar Pagamento',
      descricao: 'Permite acesso ao módulo Pagamento para Resgate de Pagamento'
    },
    PGTO_REENVIAR: {
      titulo: 'Reenviar Pagamento',
      descricao: 'Permite acesso ao módulo Pagamento para Reenvio de Pagamento'
    },
    REL_CONTA_CORRENTE: {
      titulo: 'Relatório Conta Corrente',
      descricao: 'Permite acesso ao Relatório Conta Corrente'
    },
    REL_CLI_CONTA_CORRENTE: {
      titulo: 'Relatório Cliente Conta Corrente',
      descricao: 'Permite acesso ao Relatório Cliente Conta Corrente'
    },
    REL_PAGAMENTO: {
      titulo: 'Relatório Pagamento',
      descricao: 'Permite acesso ao Relatório Pagamento'
    },
    REL_SINTETICO_ACOES: {
      titulo: 'Relatório Sintético de Ações',
      descricao: 'Permite acesso ao Relatório Sintético de Ações'
    },
    SELLIN_PAGINA: {
      titulo: 'Consultar Sell In',
      descricao: 'Permite acesso ao módulo Sell In apenas para consulta'
    },
    SELLIN_IMPORTAR: {
      titulo: 'Importar Sell In',
      descricao: 'Permite acesso ao módulo Sell In para realizar Importação de Sell In'
    },
    SELLIN_EXPORTAR: {
      titulo: 'Exportar Sell In',
      descricao: 'Permite acesso ao módulo Sell In para realizar Exportação de Sell In'
    },
    SELLOUT_PAGINA: {
      titulo: 'Consultar Sell Out',
      descricao: 'Permite acesso ao módulo Sell Out apenas para consulta'
    },
    SELLOUT_IMPORTAR: {
      titulo: 'Importar Sell Out',
      descricao: 'Permite acesso ao módulo Sell Out para realizar Importação de Sell Out'
    },
    SELLOUT_EXPORTAR: {
      titulo: 'Exportar Sell Out',
      descricao: 'Permite acesso ao módulo Sell Out para realizar Exportação de Sell Out'
    },
    PARAM_ACAO_CRUD: {
      titulo: 'Realizar a parametrização de ação',
      descricao: 'Permite acesso a parametrização de Ação'
    },
    PARAM_CLIENTE_CRUD: {
      titulo: 'Realizar a parametrização de cliente',
      descricao: 'Permite acesso a parametrizacao de Cliente'
    },
    PARAM_CONTRATO_CRUD: {
      titulo: 'Realizar a parametrização de contrato',
      descricao: 'Permite acesso a parametrizacao de Contrato'
    },
    PARAM_ORC_CRUD: {
      titulo: 'Realizar parametrização de orçamento',
      descricao: 'Permite acesso a parametrização de Orçamento'
    },
    PERFIL_PAGINA: {
      titulo: 'Consultar Perfil',
      descricao: 'Permite acesso ao Cadastro de Perfil apenas para consulta'
    },
    PERFIL_CRUD: {
      titulo: 'Cadastrar Perfil',
      descricao: 'Permite acesso ao Cadastro de Perfil para realização de cadastro'
    },
    TRANS_POSSE: {
      titulo: 'Transferência de Posse',
      descricao: 'Acesso a Transferência de Posse'
    },
    TRANS_POSSE_DIV: {
      titulo: 'Transferência de Posse Divisão',
      descricao: 'Acesso a Transferência de Posse de Divisão'
    },
    TRANS_POSSE_FUN: {
      titulo: 'Transferência de Posse Funcionário',
      descricao: 'Acesso a Transferência de Posse de Funcionário'
    },
    TRANS_POSSE_DEF: {
      titulo: 'Transferência de Posse Definitiva',
      descricao: 'Acesso a Transferência de Posse Definitiva'
    },
    NIVEL_CLIENTE_PAGINA: {
      titulo: 'Consultar Nível de Cliente',
      descricao: 'Permite acesso ao Cadastro de Nível de Cliente apenas para consulta'
    },
    NIVEL_CLIENTE_CRUD: {
      titulo: 'Cadastrar Nível de Cliente',
      descricao: 'Permite acesso ao Cadastro de Nível de Cliente para realização de cadastro e edição de registros de Nível de Cliente'
    },
    NIVEL_FORNECEDOR_PAGINA: {
      titulo: 'Consultar Nível de Fornecedor',
      descricao: 'Permite acesso ao Cadastro de Nível de Fornecedor apenas para consulta'
    },
    NIVEL_FORNECEDOR_CRUD: {
      titulo: 'Cadastrar Nível de Fornecedor',
      descricao: 'Permite acesso ao Cadastro de Nível de Fornecedor para realização de cadastro e edição de registros de Nível de Fornecedor'
    },
    NIVEL_PRD_PAGINA: {
      titulo: 'Consultar Nível de Produto',
      descricao: 'Permite acesso ao Cadastro de Nível de Produto apenas para consulta'
    },
    NIVEL_PRD_CRUD: {
      titulo: 'Cadastrar Nível de Produto',
      descricao: 'Permite acesso ao Cadastro de Nível de Produto para realização de cadastro e edição de registros de Nível de Produto'
    },
    ORC_DETALHES: {
      titulo: 'Detalhes do Orçamento',
      descricao: 'Permite acesso ao módulo Orçamento para visualizar detalhes'
    },
    ORC_RATEIO_ADD_DIV: {
      titulo: 'Inclusão de divisão em orçamento aprovado',
      descricao: 'Permite acesso a funcionalidade de incluir uma nova Divisão em um orçamento que já foi aprovado'
    },
    CONFIG_CAMPOS_CUSTOMIZADOS: {
      titulo: 'Configurar Campos Customizados',
      descricao: 'Permite acesso ao Cadastro de Campos Customizados'
    },
    TIPO_INVEST_PAGINA: {
      titulo: 'Consultar Tipo de Investimento',
      descricao: 'Permite acesso ao Cadastro de Tipo de Investimento apenas para consulta'
    },
    TIPO_INVEST_CRUD: {
      titulo: 'Cadastrar Tipo de Investimento',
      descricao: 'Permite acesso ao Cadastro de Tipo de Investimento para realização de cadastro'
    },
    FORN_PAGINA: {
      titulo: 'Consultar Fornecedor',
      descricao: 'Permite acesso ao Cadastro de Fornecedor apenas para consulta'
    },
    FORN_CRUD: {
      titulo: 'Cadastrar Fornecedor',
      descricao: 'Permite acesso ao Cadastro de Fornecedor para criar ou editar um fornecedor via importação'
    },
    DASH_VAREJO: {
      titulo: 'Acessar o Dashboard inicial na visão do varejo',
      descricao: 'Permite o acesso ao Dashboard Inicial para acompanhamento dos recebimentos e pendências de ações avulsas e contratos'
    },
    DASH_INDUSTRIA: {
      titulo: 'Acessar o Dashboard inicial na visão da indústria',
      descricao: 'Permite o acesso ao Dashboard Inicial para acompanhamento dos pagamentos e pendências de ações avulsas e contratos'
    },
    CONCORRENTE_PAGINA: {
      titulo: 'Consultar Concorrente',
      descricao: 'Permite acesso ao Cadastro de Concorrente apenas para consulta'
    },
    CONCORRENTE_CRUD: {
      titulo: 'Cadastrar Concorrente',
      descricao: 'Permite acesso ao Cadastro de Concorrente para realização de cadastro'
    },
    REL_CONTRATO: {
      titulo: 'Relatório de Contrato',
      descricao: 'Permite acesso aos Relatórios de Contrato'
    },
    SIMULADOR: {
      titulo: 'Simulador',
      descricao: 'Permite acesso ao Simulador'
    }
  },
  configuracao: {
    APROVAR_ACORDO: 'Habilitar Aprovação Acordo',
    APROVAR_ACORDO_DESCRICAO: '(Cadastrar e alterar Acordo)',
    APROVAR_ADENDO_REDUCAO: 'Habilitar Adendos e Reduções',
    APROVAR_ADENDO_REDUCAO_DESCRICAO: '(Realizar e aprovar Adendos e Reduções)',
    APROVAR_ADITIVO_ORCAMENTO: 'Habilitar Aditivos de Orçamento',
    APROVAR_ADITIVO_ORCAMENTO_DESCRICAO: '(Realizar e aprovar Aditivos de Orçamento)',
    APROVAR_APURACAO: 'Habilitar Aprovação de Apuração',
    APROVAR_APURACAO_DESCRICAO: '(Realizar e aprovar Apurações)',
    APROVAR_APURACAO_REINVIDICACAO: 'Habilitar Aprovação de Reivindicação Apuração',
    APROVAR_APURACAO_REINVIDICACAO_DESCRICAO: '(Realizar e aprovar Reivindicação de Apurações)',
    APROVAR_CONTRATO: 'Habilitar Aprovação Contrato',
    APROVAR_CONTRATO_DESCRICAO: '(Cadastrar e alterar Contratos)',
    APROVAR_PLANO_ACAO: 'Habilitar Aprovação Plano de Ação',
    APROVAR_PLANO_ACAO_DESCRICAO: '(Cadastrar e alterar Plano de Ação)',
    APROVAR_ORCAMENTO: 'Habilitar Aprovação de Orçamento (Aprovar Orçamento)',
    APROVAR_PAGAMENTO: 'Habilitar Aprovação de Pagamento',
    APROVAR_PAGAMENTO_DESCRICAO: '(Aprovar e reprovar pagamentos)',
    APROVAR_TRANSFERENCIA: 'Habilitar Aprovação de Transferência',
    APROVAR_TRANSFERENCIA_DESCRICAO: '(Aprovar e reprovar Transferências)',
    AUTOMATICA: 'Automática',
    AUTOMATICA_DESCRICAO: '',
    HABILITAR_CONTROLE_ALCADAS_PASSOS: 'Habilitar controle de alçadas nos passos',

    SELLOUT: 'Sellout',
    SELLOUT_DESCRICAO: '',
    SELLIN: 'Sellin',
    SELLIN_DESCRICAO: '',
    EVIDENCIA_OBRIGATORIA_SELLOUT: 'Arquivo de evidência obrigatório?',
    HABILITAR_UPLOAD_SELLIN: 'Habilitar upload de evidência',
    EVIDENCIA_OBRIGATORIA_SELLIN: 'Arquivo de evidência obrigatório na ausência de comprovação no Sellin?',

    MODULO_ORCAMENTO: 'Orçamento',
    MODULO_ORCAMENTO_DESCRICAO: '(Informar se o módulo de orçamento será utilizado pelo sistema)',
    MODULO_ORCAMENTO_TOGGLE: 'Ativar o módulo de orçamento',
    MANUAL: 'Manual',
    MANUAL_DESCRICAO: '',
    RATEIO: 'Rateio',
    RATEIO_DESCRICAO: '(Informar se o rateio de orçamento será automático)',
    RATEIO_TOGGLE: 'Ativar rateio automático',
    NOTIFICACAO: 'Notificação',
    NOTIFICACAO_DESCRICAO: '(Notificação sobre expiração de horas)',
    NOTIFICACAO_TOGGLE_PART1: 'Enviar notificação de expiração de saldo no dia',
    NOTIFICACAO_TOGGLE_PART2: 'do mês',

    SAP: 'SAP',
    SAP_DESCRICAO: '(Informar se o envio para o SAP será automático)',
    SAP_TOGGLE: 'Ativar envio para SAP automático',

    CRESCIMENTO: 'Crescimento',
    CRESCIMENTO_DESCRICAO: '(Definir metas de crescimento para os Clientes)',
    HABILITAR_UPLOAD_SELLOUT: 'Habilitar upload de SellOut',
    SORTIMENTO: 'Sortimento',
    SORTIMENTO_DESCRICAO: '',
    VISIBILIDADE: 'Visibilidade',
    VISIBILIDADE_DESCRICAO: '',
    COMPRA_MINIMA: 'Compra Mínima',
    COMPRA_MINIMA_DESCRICAO: '',
    EVIDENCIA: 'Evidência',
    EVIDENCIA_DESCRICAO: '',
    EVIDENCIA_OBRIGATORIA: 'Arquivo de evidência obrigatório?',
    NEGOCIACAO_PRECO: 'Negociação de Preço',
    NEGOCIACAO_PRECO_DESCRICAO: '',
    REBAIXA: 'Rebaixa',
    REBAIXA_DESCRICAO: '',
    TABLOIDE: 'Tablóide',
    TABLOIDE_DESCRICAO: '',
    POSITIVACAO: 'Positivação',
    POSITIVACAO_DESCRICAO: '',
    ABERTURA_INFORMACAO: 'Abertura de Informação',
    ABERTURA_INFORMACAO_DESCRICAO: '',
    FIXO: 'Fixo',
    FIXO_DESCRICAO: '(Valor informado pelo usuário)',
    DOCUMENTO_EVIDENCIA_OBRIGATORIO: 'Documento de evidência obrigatório',
    LOJA_AUDITADA: 'Lojas Auditadas',
    LOJA_AUDITADA_DESCRICAO: '(Selecionar lojas que serão auditadas)',
    SENHA_TEMPORARIA: 'Senha temporária para novos usuários.',
    GERAR_AUTOMATICAMENTE: 'Gerar automaticamente',
    SENHA_TEMPORARIA_FIXA: 'Senha temporária (fixa)',
    VALOR_LIQUIDO: 'Valor líquido',
    VALOR_LIQUIDO_DESCRICAO: '',
    VALOR_BRUTO: 'Valor Bruto',
    VALOR_BRUTO_DESCRICAO: '',
    calendario_aprovacoes: {
      PLANEJAMENTO_DESCRICAO: 'Planejamento',
      APURACAO_DESCRICAO: 'Apuração',
      ADENDO_REDUCAO_DESCRICAO: 'Adendo/Redução',
      COLETA_DESCRICAO: 'Coleta',
      PAGAMENTOS_DESCRICAO: 'Pagamentos'
    },
    META_ATE: {
      EDITAVEL: 'Editável',
      EDITAVEL_DESCRICAO: '(Informado pelo usuário)',
      INFINITA: 'Infinita',
      INFINITA_DESCRICAO: '(Campo Meta até não será apresentado no cadastro das metas, havendo apenas um percentual mínimo a ser atingido)'
    },
    VALOR_BASE_CRESCIMENTO: {
      FIXO: 'Fixo',
      FIXO_DESCRICAO: '(Valor informado pelo usuário)',
      CALCULADO_SISTEMA: 'Calculado pelo sistema',
      CALCULADO_SISTEMA_DESCRICAO: '(Informação buscada no Sell In ou Sell Out)'
    },
    ROI: {
      BASE_CALCULO: {
        VALOR_BRUTO: 'Valor Bruto',
        VALOR_BRUTO_DESCRICAO: '',
        VALOR_LIQUIDO: 'Valor Líquido',
        VALOR_LIQUIDO_DESCRICAO: ''
      },
      HABILITAR_CALCULO_AUTOMATICO_ROI: 'Habilitar cálculo automático do ROI  ',
      HABILITAR_CALCULO_AUTOMATICO_ROI_DESCRICAO: '',
      PERIODO_HISTORICO_MESES: 'Período histórico de meses',
      PERIODO_HISTORICO_MESES_DESCRICAO: '',
      BASE_CALCULO_VR_BRUTO: 'Base de cálculo Valor Bruto',
      BASE_CALCULO_VR_BRUTO_DESCRICAO: '',
      BASE_CALCULO_VR_LIQUIDO: 'Base de cálculo Valor Líquido',
      BASE_CALCULO_VR_LIQUIDO_DESCRICAO: ''
    },
    BASE_CALCULO: {
      VALOR_BRUTO: 'Valor Bruto',
      VALOR_BRUTO_DESCRICAO: '',
      VALOR_LIQUIDO: 'Valor Líquido',
      VALOR_LIQUIDO_DESCRICAO: '',
      DESCONTO_NOTA: 'Desconto em nota',
      DESCONTO_NOTA_DESCRICAO: '',
      PAGAMENTO_MOEDA: 'Pagamento em moeda',
      PAGAMENTO_MOEDA_DESCRICAO: '',
      BONIFICACAO_PRODUTOS: 'Bonificação em produtos',
      BONIFICACAO_PRODUTOS_DESCRICAO: '',
      CREDITO: 'Crédito',
      CREDITO_DESCRICAO: ''
    },
    BONIFICACAO: {
      VALOR_FIXO: 'Valor Fixo',
      VALOR_FIXO_DESCRICAO: '',
      VALOR_VARIAVEL: 'Valor Variável',
      VALOR_VARIAVEL_DESCRICAO: '',
      PERCENTUAL: 'Percentual',
      PERCENTUAL_DESCRICAO: ''
    },
    METAS_BENEFICIOS: {
      SELLIN_VALOR: 'Sell In Valor',
      SELLIN_VALOR_DESCRICAO: '(Informações de valores monetários do Sell In)',
      SELLIN_VOLUME: 'Sell In Volume',
      SELLIN_VOLUME_DESCRICAO: '(Informações referentes ao volume do Sell In)',
      SELLOUT_VALOR: 'Sell Out Valor',
      SELLOUT_VALOR_DESCRICAO: '(Informações de valores monetários do Sell Out)',
      SELLOUT_VOLUME: 'Sell Out Volume',
      SELLOUT_VOLUME_DESCRICAO: '(Informações referentes ao volume do Sell Out)',
      SELLOUT: 'Sell Out',
      SELLOUT_DESCRICAO: ''
    },
    TIPO_PAGAMENTO: {
      DESCONTO_NOTA: 'Desconto em nota',
      DESCONTO_NOTA_DESCRICAO: '',
      DESCONTO_CONTA: 'Desconto em conta',
      DESCONTO_CONTA_DESCRICAO: '',
      DEPOSITO_CONTA: 'Depósito em conta',
      DEPOSITO_CONTA_DESCRICAO: '',
      BONIFICACAO_PRODUTOS: 'Bonificação em produtos',
      BONIFICACAO_PRODUTOS_DESCRICAO: '',
      CREDITO: 'Crédito',
      CREDITO_DESCRICAO: ''
    }
  },
  validacoes: {
    campo_obrigatorio: 'Campo obrigatorio',
    positivo_inteiro: 'O valor deve ser positvo e inteiro',
    max_digitos: 'O campo deve conter no maxímo 3 digítos'
  },
  historico: {
    ADENDO: 'Adendo por ',
    AJUSTE: 'Ajustado por ',
    ALTERACAO: 'Alteração por ',
    APROVACAO: 'Aprovação por ',
    CANCELAMENTO: 'Cancelamento por ',
    DEDUCAO: 'Dedução por ',
    ENCERRAMENTO: 'Encerrado por ',
    ENVIO_APROVACAO: 'Envio para aprovação por ',
    ENVIO_ANALISE: 'Envio para análise por ',
    INSERCAO: 'Inclusão por ',
    REPROVACAO: 'Reprovação por ',
    TRANSFERENCIA_ADENDO: 'Transferência adendo por ',
    TRANSFERENCIA_DEDUCAO: 'Transferência dedução por ',
    SOLICITA_APROVACAO: 'Envio para aprovação por '
  },
  status_entidade: {
    apurado: 'Apurado',
    aguardando_analise: 'Aguardando análise',
    aguardando_aprovacao: 'Aguardando aprovação',
    aguardando_apuracao: 'Aguardando apuração',
    aguardando_pagamento: 'Aguardando pagamento',
    pendente_integracao: 'Pendente Integração',
    aprovado: 'Aprovado | Aprovados',
    apuracao_previa: 'Apuração prévia',
    bloqueado: 'Bloqueado',
    cancelada: 'Cancelada',
    cancelado: 'Cancelado',
    concluido: 'Concluído',
    confirmado_acao: 'Confirmado Ação',
    condicao_nao_atendida: 'Condição não atendida',
    em_alteracao: 'Em alteração',
    em_analise: 'Em análise',
    em_cadastro: 'Em cadastro',
    em_execucao: 'Em execução',
    em_fluxo: 'Em fluxo',
    em_reivindicacao: 'Em reivindicação',
    encerrado: 'Encerrado',
    executado: 'Executado',
    iniciado: 'Iniciado',
    liquidado: 'Liquidado',
    nao_iniciado: 'Não iniciado',
    nao_liquidado: 'Não liquidado',
    pendente: 'Pendente',
    programado: 'Programado',
    reivindicado: 'Reivindicado',
    reprovado: 'Reprovado | Reprovados',
    transferido: 'Transferido',
    orcamento_em_cadastro: 'Orçamento em cadastro',
    reprovada: 'Reprovada',
    orcamento_aguardando_aprovacao: 'Orçamento aguardando aprovação',
    orcamento_em_analise: 'Orçamento em análise',
    pagamento_em_andamento: 'Pagamento em andamento',
    pagamento_aguardando_aprovacao: 'Pagamento aguardando aprovação',
    pagamento_aguardando_ajuste: 'Pagamento aguardando ajuste',
    pagamento_concluido: 'Pagamento concluído'
  },
  status_item_pagamento: {
    NAO_INICIADO: 'Não iniciado',
    INICIADO: 'Iniciado',
    AGUARDANDO_APROVACAO: 'Aguardando pagamento | Aguardando aprovação',
    APROVADO: 'Em andamento',
    CANCELADO: 'Cancelado',
    CONCLUIDO: 'Pagamento concluído',
    EM_ANALISE: 'Documentos em Análise | Aguardando Alteração'
  },
  status_integracao: {
    INTEGRADO: 'Integrado',
    PENDENTE: 'Pendente',
    PENDENTE_INTEGRACAO: 'Pendente integração',
    ERRO: 'Erro'
  },
  status_pedido: {
    EM_ROTA: 'Em rota',
    ENTREGUE: 'Entregue'
  },
  meses: {
    '01': 'Janeiro',
    '02': 'Fevereiro',
    '03': 'Março',
    '04': 'Abril',
    '05': 'Maio',
    '06': 'Junho',
    '07': 'Julho',
    '08': 'Agosto',
    '09': 'Setembro',
    10: 'Outubro',
    11: 'Novembro',
    12: 'Dezembro'
  },
  motivo_entrega: {
    UMA_REENTREGA: '1 Reentrega',
    DUAS_REENTREGAS: '2 Reentregas',
    TRES_REENTREGAS: '3 Reentregas',
    DEVOLUCAO: 'Devolução'
  },
  tipo_usuario: {
    CLIENTE: 'Cliente',
    FUNCIONARIO: 'Funcionário',
    FORNECEDOR: 'Fornecedor'
  },
  tipos_pagamentos: {
    DESCONTO_NOTA: 'Desconto em nota',
    DEPOSITO_CONTA: 'Depósito em conta',
    BONIFICACAO_PRODUTOS: 'Bonificação em produtos',
    CREDITO: 'Crédito',
    ENCONTRO_CONTAS: 'Encontro de contas',
    BOLETO: 'Boleto',
    AVISO_CREDITO: 'Aviso de crédito',
    NOTA_CREDITO: 'Nota de Crédito',
    ORDEM_INTERNA: 'Ordem Interna'
  },
  registro_acesso: {
    logou: 'Logou no período',
    nao_logou: 'Não logou no período'
  },
  periodo_apuracao: {
    anual: 'Anual',
    mensal: 'Mensal',
    trimestral: 'Trimestral',
    unica_vez: 'Única vez'
  },
  relatorio_organograma: {
    title: 'Organograma'
  },
  tooltip: {
    planejado: 'Soma do valor distribuído do orçamento',
    reservado: 'Soma do valor de negociações com status "Aguardando aprovação"',
    consumido: 'Soma do valor de pagamentos com status "Liquidado"',
    conf_negociacao: 'Soma do valor de negociações com status "Aprovado" e apurações com status "Aguardando apuração" e "Aguardando aprovação"',
    conf_apuracao: 'Soma do valor de negociações e apurações com status "Aprovado", desde que o pagamento ainda não tenha status "Liquidado"'
  }
};

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VueRouterObject = exports.routes = undefined;

var _Home = __webpack_require__(929);

var _Home2 = _interopRequireDefault(_Home);

var _NotFound = __webpack_require__(962);

var _NotFound2 = _interopRequireDefault(_NotFound);

var _administracao = __webpack_require__(966);

var _administracao2 = _interopRequireDefault(_administracao);

var _ajusteVerba = __webpack_require__(997);

var _ajusteVerba2 = _interopRequireDefault(_ajusteVerba);

var _alcada = __webpack_require__(1022);

var _alcada2 = _interopRequireDefault(_alcada);

var _anoFiscal = __webpack_require__(1035);

var _anoFiscal2 = _interopRequireDefault(_anoFiscal);

var _apuracao = __webpack_require__(1057);

var _apuracao2 = _interopRequireDefault(_apuracao);

var _apuracoesVencidas = __webpack_require__(1077);

var _apuracoesVencidas2 = _interopRequireDefault(_apuracoesVencidas);

var _carteiraCliente = __webpack_require__(1082);

var _carteiraCliente2 = _interopRequireDefault(_carteiraCliente);

var _calendario = __webpack_require__(1086);

var _calendario2 = _interopRequireDefault(_calendario);

var _centroCusto = __webpack_require__(1105);

var _centroCusto2 = _interopRequireDefault(_centroCusto);

var _cliente = __webpack_require__(1122);

var _cliente2 = _interopRequireDefault(_cliente);

var _configuracao = __webpack_require__(1126);

var _configuracao2 = _interopRequireDefault(_configuracao);

var _dashboard = __webpack_require__(1176);

var _dashboard2 = _interopRequireDefault(_dashboard);

var _dashboardGerencial = __webpack_require__(1287);

var _dashboardGerencial2 = _interopRequireDefault(_dashboardGerencial);

var _divisao = __webpack_require__(1309);

var _divisao2 = _interopRequireDefault(_divisao);

var _estruturaUsuario = __webpack_require__(1385);

var _estruturaUsuario2 = _interopRequireDefault(_estruturaUsuario);

var _gestaoAprovacao = __webpack_require__(1396);

var _gestaoAprovacao2 = _interopRequireDefault(_gestaoAprovacao);

var _importacoes = __webpack_require__(1409);

var _importacoes2 = _interopRequireDefault(_importacoes);

var _margemContribuicao = __webpack_require__(1434);

var _margemContribuicao2 = _interopRequireDefault(_margemContribuicao);

var _negociacao = __webpack_require__(1441);

var _negociacao2 = _interopRequireDefault(_negociacao);

var _orcamento = __webpack_require__(1442);

var _orcamento2 = _interopRequireDefault(_orcamento);

var _produto = __webpack_require__(1443);

var _produto2 = _interopRequireDefault(_produto);

var _pagamento = __webpack_require__(1447);

var _pagamento2 = _interopRequireDefault(_pagamento);

var _regiao = __webpack_require__(1448);

var _regiao2 = _interopRequireDefault(_regiao);

var _ssoGrupo = __webpack_require__(1459);

var _ssoGrupo2 = _interopRequireDefault(_ssoGrupo);

var _ssoUsuario = __webpack_require__(1463);

var _ssoUsuario2 = _interopRequireDefault(_ssoUsuario);

var _sellIn = __webpack_require__(1467);

var _sellIn2 = _interopRequireDefault(_sellIn);

var _sellOut = __webpack_require__(1482);

var _sellOut2 = _interopRequireDefault(_sellOut);

var _termoAceite = __webpack_require__(1497);

var _termoAceite2 = _interopRequireDefault(_termoAceite);

var _tipoAcao = __webpack_require__(1518);

var _tipoAcao2 = _interopRequireDefault(_tipoAcao);

var _tipoInvestimento = __webpack_require__(1528);

var _tipoInvestimento2 = _interopRequireDefault(_tipoInvestimento);

var _tipoOrcamento = __webpack_require__(1538);

var _tipoOrcamento2 = _interopRequireDefault(_tipoOrcamento);

var _transferencia = __webpack_require__(1549);

var _transferencia2 = _interopRequireDefault(_transferencia);

var _transferenciaPosse = __webpack_require__(1559);

var _transferenciaPosse2 = _interopRequireDefault(_transferenciaPosse);

var _unidadeMedida = __webpack_require__(1600);

var _unidadeMedida2 = _interopRequireDefault(_unidadeMedida);

var _usuario = __webpack_require__(1611);

var _usuario2 = _interopRequireDefault(_usuario);

var _workflow = __webpack_require__(1615);

var _workflow2 = _interopRequireDefault(_workflow);

var _acordo = __webpack_require__(1616);

var _acordo2 = _interopRequireDefault(_acordo);

var _loading = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var configureGuards = function configureGuards(router) {
  router.afterEach(function (route) {
    if (route.params.menu) {
      (0, _loading.hideLoading)();
    }
  });
};

var routes = exports.routes = [{
  path: '/',
  name: 'inicio',
  component: _Home2.default,
  redirect: '/dashboard',
  children: [_administracao2.default, _ajusteVerba2.default, _apuracao2.default, _apuracoesVencidas2.default, _anoFiscal2.default, _alcada2.default, _calendario2.default, _carteiraCliente2.default, _centroCusto2.default, _cliente2.default, _configuracao2.default, _dashboard2.default, _dashboardGerencial2.default, _divisao2.default, _gestaoAprovacao2.default, _estruturaUsuario2.default, _importacoes2.default, _margemContribuicao2.default, _negociacao2.default, _orcamento2.default, _pagamento2.default, _produto2.default, _regiao2.default, _sellIn2.default, _sellOut2.default, _ssoGrupo2.default, _ssoUsuario2.default, _termoAceite2.default, _tipoAcao2.default, _tipoInvestimento2.default, _tipoOrcamento2.default, _transferencia2.default, _transferenciaPosse2.default, _usuario2.default, _unidadeMedida2.default, _workflow2.default, _acordo2.default]
}, {
  path: '*',
  component: _NotFound2.default
}];

var VueRouterObject = exports.VueRouterObject = {
  routes: routes,
  saveScrollPosition: true
};

exports.default = function (VueRouter) {
  var vueRouter = new VueRouter(VueRouterObject);
  configureGuards(vueRouter);
  return vueRouter;
};

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Home_vue_vue_type_template_id_ca997528_lang_html___ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Home_vue_vue_type_script_lang_js___ = __webpack_require__(254);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__Home_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__Home_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Home_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Home_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__Home_vue_vue_type_template_id_ca997528_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Home_vue_vue_type_template_id_ca997528_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Home_vue_vue_type_template_id_ca997528_lang_html___ = __webpack_require__(931);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Home_vue_vue_type_template_id_ca997528_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Home_vue_vue_type_template_id_ca997528_lang_html___["b"]; });


/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.termos.length && !_vm.aceito)?_c('div',[_c('termo-aceite-login',{attrs:{"termos":_vm.termos,"title":_vm.implantacao.nome},on:{"ACEITO":_vm.termoAceito}})],1):_c('div',[_c('sidebar',{ref:"sidenav",attrs:{"abrir":_vm.abrirMenu,"title":_vm.implantacao.nome,"logo":_vm.implantacao.logomarca,"perfilUsuario":_vm.usuarioLogado.perfil,"nomeUsuario":_vm.usuario,"estruturaUsuario":_vm.usuarioLogado.estrutura_usuario,"menuList":_vm.filteredMenuList}}),_vm._v(" "),_c('toolbar',{staticClass:"Home__PageTeller",attrs:{"title":_vm.implantacao.nome,"hideMenu":_vm.hideMenu,"usuario":_vm.usuario,"perfil":_vm.usuarioLogado.perfil,"estruturaUsuario":_vm.usuarioLogado.estrutura_usuario,"mail":_vm.usuarioLogado.email},on:{"Toolbar_rotaAlterada":function($event){return _vm.$refs.sidenav.resetSidebar()},"TOGGLE_SIDEBAR":_vm.toggleSidenav}}),_vm._v(" "),_c('v-content',{attrs:{"id":"content"}},[(_vm.dicionarioCarregado)?_c('v-container',{staticClass:"fill-height py-0",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[(_vm.dicionarioCarregado)?_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[(!_vm.recarregar)?_c('router-view'):_vm._e()],1):_vm._e()],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('md-layout',{staticClass:"HOME__base_loading",staticStyle:{"display":"none"},attrs:{"id":"spinner-loading","md-align":"center"}},[_c('md-spinner',{staticClass:"md-primary HOME__md-spinner",attrs:{"id":"spinner_","md-size":120,"md-stroke":1,"md-indeterminate":""}}),_vm._v(" "),_c('div',{staticClass:"HOME__md-spinner HOME__logo_div"},[_c('div',{staticClass:"HOME__logo"},[_c('svg',{attrs:{"width":"77","height":"77","viewBox":"0 0 77 77","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('g',{attrs:{"id":"Canvas","transform":"translate(-1586 1931)"}},[_c('g',{attrs:{"id":"Group"}},[_c('g',{attrs:{"id":"Vector"}},[_c('use',{attrs:{"xlink:href":"#path0_fill","transform":"translate(1603.96 -1911.3)","fill":"#1E88E5"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Vector"}},[_c('use',{attrs:{"xlink:href":"#path1_fill","transform":"translate(1586.44 -1930.85)","fill":"#1E88E5"}})])])]),_vm._v(" "),_c('defs',[_c('path',{attrs:{"id":"path0_fill","d":"M 40.8409 7.47789L 34.9391 0L 6.18726 0L 0.235115 7.57895C -0.471071 8.64 0.638652 8.69053 0.638652 8.69053L 0.739534 8.69053L 0.789979 11.8232C 0.638654 14.7537 3.4634 16.0168 3.4634 16.0168L 3.41296 34.2568L 1.2944 34.2568C 0.28556 34.3074 0.588207 35.7726 0.588207 35.7726C 0.638649 37.2379 1.49616 36.9347 1.49616 36.9347L 39.7311 36.9347C 40.8913 36.8842 40.5382 35.2674 40.5382 35.2674C 40.5382 34.2568 39.9329 34.2568 39.9329 34.2568L 37.7135 34.2568L 37.7639 16.0168C 40.3869 15.6126 40.3869 12.1263 40.3869 12.1263L 40.3364 8.64C 41.6479 8.48842 40.8409 7.47789 40.8409 7.47789ZM 34.9391 34.2063L 25.6578 34.2063L 25.6578 19.5537C 25.6578 19.5537 25.91 18.5937 24.5481 18.4926C 24.5481 18.4926 23.1357 18.24 23.1862 19.7053L 23.1862 30.8716L 5.78372 30.6695L 5.78372 16.2695C 5.78372 16.2695 7.75096 15.9663 8.25538 14.2989C 8.25538 14.2989 8.70936 13.1874 9.31466 14.2989C 9.31466 14.2989 10.3235 16.5221 13.0474 16.2695C 13.0474 16.2695 15.1659 16.3705 16.1243 14.4505C 16.1243 14.4505 16.5279 13.2884 17.1836 14.4505C 17.1836 14.4505 18.0411 16.32 20.6137 16.32C 20.6137 16.32 23.1862 16.5726 23.8924 14.6021C 23.8924 14.6021 24.5481 13.1368 25.2039 14.5011C 25.2039 14.5011 25.91 16.4716 28.7852 16.3705C 28.7852 16.3705 30.9038 16.4716 31.8622 14.4505C 31.8622 14.4505 32.4171 13.2884 32.9719 14.4C 32.9719 14.4 33.325 15.7642 34.9391 16.0674L 34.9391 34.2063Z"}}),_vm._v(" "),_c('path',{attrs:{"id":"path1_fill","d":"M 38.0332 0C 17.0494 0 0 17.0274 0 38.0968C 0 59.1663 16.9989 76.1937 38.0332 76.1937C 59.017 76.1937 76.0664 59.1663 76.0664 38.0968C 76.0664 17.0274 59.0675 0 38.0332 0ZM 38.0332 71.3937C 19.6723 71.3937 4.79198 56.4884 4.79198 38.0968C 4.79198 19.7053 19.6723 4.8 38.0332 4.8C 56.394 4.8 71.2744 19.7053 71.2744 38.0968C 71.2744 56.4884 56.4445 71.3937 38.0332 71.3937Z"}})])])])])],1)],1),_vm._v(" "),_c('md-dialog',{ref:"modalSessao"},[_c('md-dialog-title',[_vm._v(_vm._s(_vm.$t('title.sessao_expirada')))]),_vm._v(" "),_c('md-dialog-content',[_vm._v(_vm._s(_vm.$t('errors.sessao_expirada')))]),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",nativeOn:{"click":function($event){return _vm.logoutAceito()}}},[_vm._v(_vm._s(_vm.$t('label.ok')))])],1)],1),_vm._v(" "),_c('md-dialog',{ref:"modalErroInicializacaoAplicacao"},[_c('md-dialog-title',[_vm._v(_vm._s(_vm.$tc('title.aviso', 1)))]),_vm._v(" "),_c('md-dialog-content',[_vm._v(_vm._s(_vm.mensagemModalInicializacao))]),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",nativeOn:{"click":function($event){return _vm.recarregarAplicacao($event)}}},[_vm._v(_vm._s(_vm.$t('label.recarregar')))]),_vm._v(" "),_c('md-button',{staticClass:"md-primary",nativeOn:{"click":function($event){return _vm.fecharModalErro($event)}}},[_vm._v(_vm._s(_vm.$t('label.ok')))])],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Sidebar = __webpack_require__(933);

var _Sidebar2 = _interopRequireDefault(_Sidebar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Sidebar2.default;

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Sidebar_vue_vue_type_template_id_c2e4e3c6_lang_html___ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sidebar_vue_vue_type_script_lang_js___ = __webpack_require__(256);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__Sidebar_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__Sidebar_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_scss_vue_type_style_index_0_lang_scss___ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Sidebar_vue_vue_type_style_index_1_lang_scss___ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);







/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_4__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Sidebar_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__Sidebar_vue_vue_type_template_id_c2e4e3c6_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Sidebar_vue_vue_type_template_id_c2e4e3c6_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Sidebar_vue_vue_type_template_id_c2e4e3c6_lang_html___ = __webpack_require__(935);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Sidebar_vue_vue_type_template_id_c2e4e3c6_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Sidebar_vue_vue_type_template_id_c2e4e3c6_lang_html___["b"]; });


/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',{staticClass:"SideBar__Menu",staticStyle:{"overflow":"hidden"},attrs:{"app":"","temporary":"","width":"300"},model:{value:(_vm.abrirMenu),callback:function ($$v) {_vm.abrirMenu=$$v},expression:"abrirMenu"}},[_c('div',[_c('div',{staticClass:"imagem_menu"},[_c('img',{attrs:{"src":_vm.logo,"alt":""}})])]),_vm._v(" "),_c('v-list',{staticClass:"listaMenu",staticStyle:{"height":"76vh","overflow-y":"auto"}},[_vm._l((_vm.menuList),function(item){return [(item.sub)?_c('v-list-group',{key:item.text,attrs:{"prepend-icon":item.icon,"no-action":""},model:{value:(item.model),callback:function ($$v) {_vm.$set(item, "model", $$v)},expression:"item.model"}},[_c('v-list-item',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"black-text"},[_vm._v("\n              "+_vm._s(item.text)+"\n            ")])],1)],1),_vm._v(" "),_vm._l((item.sub),function(child,i){return _c('v-list-item',{key:i,on:{"click":function($event){return _vm.goToPage(child.route)}}},[(child.icon)?_c('v-list-item-action',[_c('v-icon',[_vm._v(_vm._s(child.icon))])],1):_vm._e(),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"black-text"},[_vm._v("\n              "+_vm._s(child.text)+"\n            ")])],1)],1)})],2):_c('v-list-item',{key:item.text,on:{"click":function($event){return _vm.goToPage(item.route)}}},[_c('v-list-item-action',[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"black-text"},[_vm._v("\n            "+_vm._s(item.text)+"\n          ")])],1)],1)]})],2),_vm._v(" "),_c('v-footer',{staticClass:"footer",staticStyle:{"margin-top":"13px"},attrs:{"inset":""}},[_c('span',[_vm._v("Tradelinks")])])],1)}
var staticRenderFns = []



/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_Sidebar_scss_vue_type_style_index_0_lang_scss___ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_Sidebar_scss_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_Sidebar_scss_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_Sidebar_scss_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_node_modules_vue_loader_lib_index_js_vue_loader_options_Sidebar_vue_vue_type_style_index_1_lang_scss___ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_node_modules_vue_loader_lib_index_js_vue_loader_options_Sidebar_vue_vue_type_style_index_1_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_node_modules_vue_loader_lib_index_js_vue_loader_options_Sidebar_vue_vue_type_style_index_1_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_node_modules_vue_loader_lib_index_js_vue_loader_options_Sidebar_vue_vue_type_style_index_1_lang_scss____default.a); 

/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Toolbar_vue_vue_type_template_id_a03aa3e8_lang_html___ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Toolbar_vue_vue_type_script_lang_js___ = __webpack_require__(261);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__Toolbar_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__Toolbar_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_toolbar_Toolbar_scss_vue_type_style_index_0_lang_scss___ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Toolbar_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__Toolbar_vue_vue_type_template_id_a03aa3e8_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Toolbar_vue_vue_type_template_id_a03aa3e8_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Toolbar_vue_vue_type_template_id_a03aa3e8_lang_html___ = __webpack_require__(940);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Toolbar_vue_vue_type_template_id_a03aa3e8_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Toolbar_vue_vue_type_template_id_a03aa3e8_lang_html___["b"]; });


/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"fixed":"","dark":"","color":"primary","elevate-on-scroll":"","app":""}},[_c('v-app-bar-nav-icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hideMenu),expression:"!hideMenu"}],attrs:{"name":"toolbar-button-sidenav-menu"},nativeOn:{"click":function($event){return _vm.toggleSidenav($event)}}}),_vm._v(" "),(_vm.$vuetify.breakpoint.smAndDown)?_c('v-spacer'):_vm._e(),_vm._v(" "),_c('v-toolbar-title',{staticClass:"white--text"},[_c('img',{staticClass:"Toolbar__Image--size",attrs:{"src":__webpack_require__(260),"alt":""}}),_vm._v(" "),(_vm.$vuetify.breakpoint.mdAndUp)?_c('span',[_vm._v("Tradelinks "+_vm._s(_vm.title === 'Tradelinks' ? '' : ("- " + _vm.title)))]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_vm._l((_vm.options),function(option,index){return _c('v-button',{key:index},[_c('md-icon',[_vm._v(_vm._s(option.icon))])],1)}),_vm._v(" "),_c('usuario-toolbar',{attrs:{"usuario":_vm.usuario,"mail":_vm.mail,"estrutura-usuario":_vm.estruturaUsuario,"perfil":_vm.perfil},on:{"UsuarioToolBar_selecionar":_vm.irInicio}}),_vm._v(" "),_c('calendario-toolbar'),_vm._v(" "),(_vm.termos.length)?_c('md-button',{staticClass:"md-icon-button Toolbar__Import",attrs:{"id":"component_btn_aceite"},nativeOn:{"click":function($event){return _vm.goToAceitePage($event)}}},[_c('md-tooltip',[_vm._v("Aceites")]),_vm._v(" "),_c('md-icon',[_vm._v("check_circle_outline")])],1):_vm._e(),_vm._v(" "),_c('badge')],2)}
var staticRenderFns = []



/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Badge_vue_vue_type_template_id_56bc9b68_lang_html___ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Badge_vue_vue_type_script_lang_js___ = __webpack_require__(263);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__Badge_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__Badge_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Badge_css_vue_type_style_index_0_lang_css___ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Badge_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__Badge_vue_vue_type_template_id_56bc9b68_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Badge_vue_vue_type_template_id_56bc9b68_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Badge_vue_vue_type_template_id_56bc9b68_lang_html___ = __webpack_require__(943);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Badge_vue_vue_type_template_id_56bc9b68_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Badge_vue_vue_type_template_id_56bc9b68_lang_html___["b"]; });


/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tiposImportacao.length)?_c('md-button',{staticClass:"md-icon-button Toolbar__Import",attrs:{"id":"component_btn_cloud"},nativeOn:{"click":function($event){return _vm.goToImportPage($event)}}},[_c('md-tooltip',[_vm._v("Importações")]),_vm._v(" "),(!_vm.done)?_c('md-icon',{attrs:{"id":"component_icon_cloud","data-badge":"2"}},[_vm._v("\n    "+_vm._s((_vm.quantidadeAndamento > 1) ? 'cloud_upload' : 'cloud_queue')+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.done)?_c('md-icon',[_vm._v("done")]):_vm._e(),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.quantidadeAndamento),expression:"quantidadeAndamento"}],staticClass:"Toolbar__Badge"},[_vm._v("\n    "+_vm._s((_vm.quantidadeAndamento > 9) ? '9+' : _vm.quantidadeAndamento)+"\n  ")]),_vm._v(" "),_c('md-spinner',{directives:[{name:"show",rawName:"v-show",value:(_vm.transition && _vm.progress < 115),expression:"transition && progress < 115"}],staticClass:"md-accent Toolbar__Spinner",attrs:{"md-progress":_vm.progress}})],1):_vm._e()}
var staticRenderFns = []



/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_Badge_css_vue_type_style_index_0_lang_css___ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_Badge_css_vue_type_style_index_0_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_Badge_css_vue_type_style_index_0_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_Badge_css_vue_type_style_index_0_lang_css____default.a); 

/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UsuarioToolbar_vue_vue_type_template_id_8a2d9f2a_scoped_true___ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UsuarioToolbar_vue_vue_type_script_lang_js___ = __webpack_require__(266);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__UsuarioToolbar_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__UsuarioToolbar_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__UsuarioToolbar_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__UsuarioToolbar_vue_vue_type_template_id_8a2d9f2a_scoped_true___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__UsuarioToolbar_vue_vue_type_template_id_8a2d9f2a_scoped_true___["b" /* staticRenderFns */],
  false,
  null,
  "8a2d9f2a",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_UsuarioToolbar_vue_vue_type_template_id_8a2d9f2a_scoped_true___ = __webpack_require__(947);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_UsuarioToolbar_vue_vue_type_template_id_8a2d9f2a_scoped_true___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_UsuarioToolbar_vue_vue_type_template_id_8a2d9f2a_scoped_true___["b"]; });


/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{attrs:{"close-on-content-click":false,"nudge-width":200,"left":"","offset-x":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [(_vm.$vuetify.breakpoint.mdAndUp)?_c('v-btn',_vm._g({staticClass:"elevation-0",attrs:{"dark":"","color":"primary"}},on),[_c('b',[_vm._v(_vm._s(_vm.usuario))]),_vm._v(" "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("keyboard_arrow_down")])],1):_c('v-btn',_vm._g({attrs:{"text":"","dark":"","icon":""}},on),[_c('v-icon',[_vm._v("account_box")])],1)]}}]),model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_vm._v(" "),_c('v-card',[_c('v-list',{staticClass:"py-0"},[_c('v-list-item',[_c('v-list-item-avatar',{staticClass:"white--text headline",attrs:{"color":"accent"}},[_vm._v("\n          "+_vm._s(_vm.usuario.substring(0,1).toUpperCase())+"\n        ")]),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',[(_vm.estruturaUsuario)?_c('span',[_vm._v(_vm._s(_vm.estruturaUsuario)+" - ")]):_vm._e(),_vm._v(_vm._s(_vm.usuario))]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v(_vm._s(_vm.mail))]),_vm._v(" "),_c('v-list-item-subtitle',[_c('span',{staticClass:"text--primary"},[_vm._v(_vm._s(_vm.$tc('label.perfil', 1))+": ")]),_vm._v(_vm._s(_vm.perfil))])],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),(_vm.exibirControladores)?_c('v-list',{staticClass:"py-0"},_vm._l((_vm.controladores),function(item,index){return _c('v-list-item',{key:index,on:{"click":function($event){return _vm.selecionar(item)}}},[_c('v-list-item-content',{staticClass:"grey--text text--darken-1"},[_vm._v("\n          "+_vm._s(item.descricao)+"\n        ")]),_vm._v(" "),_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":_vm.itemSelecionado(item) ? 'primary' : 'grey'}},[_vm._v("done_outline")])],1)],1)}),1):_vm._e(),_vm._v(" "),(_vm.exibirControladores)?_c('v-divider'):_vm._e(),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":_vm.logout}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("power_settings_new")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$tc('label.logout', 2)))])],1)],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

var _genericResource = __webpack_require__(104);

var _genericResource2 = _interopRequireDefault(_genericResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'termo-aceite');

var termoAceiteActions = (0, _extends3.default)({}, (0, _genericResource2.default)(basePath), {
  listarFiltrado: { method: 'GET', url: basePath + '?tamanhoPagina={tamanhoPagina}&numeroPagina={numeroPagina}&filtro={filter}' },
  buscar: { method: 'GET', url: basePath + '/{id}' },
  ativacao: { method: 'PUT', url: basePath + '/ativacao/{codigo}' },
  buscarTermosLogin: { method: 'GET', url: basePath + '/login' },
  aceitarTermos: { method: 'POST', url: basePath + '/aceito' },
  listarRealizados: { method: 'GET', url: basePath + '/realizados?tamanhoPagina={tamanhoPagina}&numeroPagina={numeroPagina}&filtro={filter}' }
});

exports.default = function (resource) {
  return resource('' + basePath, {}, termoAceiteActions);
};

/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CalendarioToolbar_vue_vue_type_template_id_76b0a366___ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CalendarioToolbar_vue_vue_type_script_lang_js___ = __webpack_require__(268);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__CalendarioToolbar_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__CalendarioToolbar_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__CalendarioToolbar_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__CalendarioToolbar_vue_vue_type_template_id_76b0a366___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__CalendarioToolbar_vue_vue_type_template_id_76b0a366___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioToolbar_vue_vue_type_template_id_76b0a366___ = __webpack_require__(951);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioToolbar_vue_vue_type_template_id_76b0a366___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioToolbar_vue_vue_type_template_id_76b0a366___["b"]; });


/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canAccessView)?_c('v-menu',{attrs:{"close-on-content-click":false,"transition":"slide-x-transition","nudge-width":200,"offset-x":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"text":"","dark":"","icon":""}},on),[_c('v-icon',[_vm._v("today")])],1)]}}],null,false,4216167020),model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_vm._v(" "),(_vm.menu)?_c('calendario-card'):_vm._e()],1):_vm._e()}
var staticRenderFns = []



/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CalendarioCard_vue_vue_type_template_id_d6d6dd70___ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CalendarioCard_vue_vue_type_script_lang_js___ = __webpack_require__(270);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__CalendarioCard_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__CalendarioCard_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__CalendarioCard_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__CalendarioCard_vue_vue_type_template_id_d6d6dd70___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__CalendarioCard_vue_vue_type_template_id_d6d6dd70___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioCard_vue_vue_type_template_id_d6d6dd70___ = __webpack_require__(954);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioCard_vue_vue_type_template_id_d6d6dd70___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioCard_vue_vue_type_template_id_d6d6dd70___["b"]; });


/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-date-picker',{attrs:{"locale":"pt-br","width":"500","landscape":"","events":_vm.ehEvento,"event-color":_vm.corDoEvento},on:{"update:pickerDate":_vm.alterarMes,"input":_vm.limparSelecao},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),(_vm.listaEventos && !!_vm.listaEventos.length)?_c('v-list',{staticStyle:{"max-height":"400px","overflow-y":"scroll"},attrs:{"two-line":""}},_vm._l((_vm.listaEventos),function(item,index){return _c('v-list-item',{key:index},[_c('v-list-item-avatar',[_c('v-avatar',{attrs:{"size":22,"color":item.cor}})],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(item.descricao)+" - "+_vm._s(item.nome))]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v(_vm._s(_vm.formatarData(item)))]),_vm._v(" "),(item.descricao === _vm.$t('title.fechamento_mensal'))?_c('div',[_vm._v(_vm._s(_vm.obterInformacaoFechamento(item)))]):_vm._e()],1)],1)}),1):_vm._e()],1)}
var staticRenderFns = []



/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_Toolbar_scss_vue_type_style_index_0_lang_scss___ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_Toolbar_scss_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_Toolbar_scss_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_Toolbar_scss_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 956 */,
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (context) {
  return [{ text: context.$t('label.acordo'), icon: 'dashboard', route: 'acordo', role: 'ACD_PAGINA' }, { text: context.$t('label.dashboard'), icon: 'dashboard', route: 'dashboard', role: 'DASH_OPER' }, { text: context.$t('label.dashboard_gerencial'), icon: 'dashboard', route: 'dashboard-gerencial', role: 'DASH_GER' }, {
    text: context.$tc('label.cadastro', 2),
    icon: 'input',
    sub: [{ text: context.$tc('label.alcada', 1), icon: 'monetization_on', route: 'alcada', role: 'ALCADA' }, { text: context.$tc('label.cliente', 1), icon: 'people_outline', route: 'cliente', role: 'CLIENTE' }, { text: context.$t('label.centro_custo'), icon: 'attach_money', route: 'centro-custo', role: 'CECO' }, { text: context.$tc('label.estrutura_usuario', 1), icon: 'recent_actors', route: 'estrutura-usuario', role: 'ESTRUTURA' }, { text: context.$tc('label.gestao_usuario', 1), icon: 'perm_identity', route: 'usuario', role: 'USR' }, { text: context.$tc('label.perfil', 1), icon: 'group', route: 'sso-grupo', role: 'PERFIL' }, { text: context.$tc('label.produto', 1), icon: 'shopping_basket', route: 'produto', role: 'PRD' }, { text: context.$t('label.regiao'), icon: 'location_on', route: 'regiao', role: 'REGIAO' }, { text: context.$t('label.sellin'), icon: 'payment', route: 'sellin', role: 'SELLIN' }, { text: context.$tc('label.tipo_investimento', 1), icon: 'attach_money', route: 'tipo-investimento', role: 'TIPO_LINHA' }, { text: context.$tc('label.tipo_acao', 1), icon: 'content_paste', route: 'tipo-acao', role: 'TIPO_ACAO' }, { text: context.$t('label.tipo_orcamento'), icon: 'trending_up', route: 'tipo-orcamento', role: 'TIPO_ORC' }, { text: context.$tc('label.unidade_medida', 1), icon: 'aspect_ratio', route: 'unidade-medida', role: 'UNID_MEDIDA' }, { text: context.$t('label.workflow'), icon: 'group_work', route: 'workflow', role: ['FLUXO_PAGINA', 'FLUXO_CRUD'] }, { text: context.$t('label.calendario'), icon: 'calendar_today', route: 'calendario', role: ['CONFIG_CALENDARIO'] }]
  }, {
    text: context.$tc('label.administracao', 1),
    icon: 'track_changes',
    sub: [{ text: context.$tc('label.configuracao', 2), icon: 'settings', route: 'configuracao', role: 'CONFIG' }, { text: context.$tc('label.suporte', 1), icon: 'build', route: 'administracao', role: 'ADMINISTRACAO' }, { text: context.$tc('label.transferencia_posse', 2), icon: 'transfer_within_a_station', route: 'transferencia-posse', role: ['TRANS_POSSE_FUN', 'TRANS_POSSE_DIV'] }, { text: context.$tc('label.termo_aceite', 1), icon: 'description', route: 'termo-aceite', role: 'TERMO_ACEITE' }, { text: context.$tc('label.gestao_aprovacao', 1), icon: 'linear_scale', route: 'gestao-aprovacao', role: 'FLUXO_GEST_APRO' }]
  }, { text: context.$tc('label.apuracao', 1), icon: 'playlist_add_check', route: 'apuracao', role: ['APU_CRUD', 'APU_PAGINA'] }, { text: context.$t('label.acordos_vencidos'), icon: 'alarm_off', route: 'apuracoes-vencidas', role: 'CANC_APU_CRUD' }, { text: context.$tc('label.negociacao', 1), icon: 'content_paste', route: 'negociacao', role: 'NEG' }, { text: context.$t('label.orcamento'), icon: 'find_in_page', route: 'orcamento', role: ['ORC_PAGINA', 'ORC_CRUD'] }, { text: context.$tc('label.pagamento', 1), icon: 'payment', route: 'pagamento', role: 'PGTO' }, { text: context.$tc('label.margemcontribuicao', 1), icon: 'track_changes', route: 'margem-contribuicao', role: ['MARGEM_ROI'] }];
};

/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TermoAceiteLogin_vue_vue_type_template_id_4ed1c51f_lang_html___ = __webpack_require__(959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TermoAceiteLogin_vue_vue_type_script_lang_js___ = __webpack_require__(273);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__TermoAceiteLogin_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__TermoAceiteLogin_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__TermoAceiteLogin_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__TermoAceiteLogin_vue_vue_type_template_id_4ed1c51f_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__TermoAceiteLogin_vue_vue_type_template_id_4ed1c51f_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TermoAceiteLogin_vue_vue_type_template_id_4ed1c51f_lang_html___ = __webpack_require__(960);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TermoAceiteLogin_vue_vue_type_template_id_4ed1c51f_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TermoAceiteLogin_vue_vue_type_template_id_4ed1c51f_lang_html___["b"]; });


/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-app-bar',{attrs:{"dark":"","app":"","color":"primary","elevate-on-scroll":"","clipped-right":""}},[_c('v-toolbar-title',{staticClass:"white--text"},[_c('img',{staticClass:"Toolbar__Image--size",attrs:{"src":__webpack_require__(260),"alt":""}}),_vm._v(" "),(_vm.$vuetify.breakpoint.mdAndUp)?_c('span',[_vm._v("Tradelinks "+_vm._s(_vm.title === 'Tradelinks' ? '' : ("- " + _vm.title)))]):_vm._e()]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-content',[_c('v-container',{staticStyle:{"width":"80%"},attrs:{"mt-5":""}},[_c('v-card',[_c('v-card-title',[_c('h4',{staticClass:"headline mb-0"},[_vm._v(_vm._s(_vm.$t('label.termo_aceite'))+" - "+_vm._s(_vm.termo.descricao))])]),_vm._v(" "),_c('v-container',{staticStyle:{"padding-top":"10px"},attrs:{"grid-list-xl":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.termo.conteudo)}})])],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","justify-end":""}},[_c('div',[_c('v-radio-group',{attrs:{"row":"","disabled":_vm.timeout},model:{value:(_vm.termoAceito),callback:function ($$v) {_vm.termoAceito=$$v},expression:"termoAceito"}},[_c('v-radio',{attrs:{"label":("" + (_vm.$tc('label.li_concordo_termos_condicoes'))),"value":true}})],1)],1)]),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","justify-end":""}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{nativeOn:{"click":function($event){return _vm.logout($event)}}},[_vm._v(_vm._s(_vm.$t('label.cancelar')))]),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.termoAceito,"color":"primary"},nativeOn:{"click":function($event){return _vm.proximo($event)}}},[_vm._v(_vm._s(_vm.continuar ? _vm.$t('label.continuar') : _vm.$t('label.finalizar')))])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_node_modules_vue_loader_lib_index_js_vue_loader_options_Home_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_node_modules_vue_loader_lib_index_js_vue_loader_options_Home_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_node_modules_vue_loader_lib_index_js_vue_loader_options_Home_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_node_modules_vue_loader_lib_index_js_vue_loader_options_Home_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NotFound_vue_vue_type_template_id_6ee8c274_lang_html___ = __webpack_require__(963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NotFound_vue_vue_type_script_lang_js___ = __webpack_require__(276);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__NotFound_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__NotFound_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NotFound_vue_vue_type_style_index_0_media_scss_lang_css___ = __webpack_require__(965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__NotFound_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__NotFound_vue_vue_type_template_id_6ee8c274_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__NotFound_vue_vue_type_template_id_6ee8c274_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_NotFound_vue_vue_type_template_id_6ee8c274_lang_html___ = __webpack_require__(964);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_NotFound_vue_vue_type_template_id_6ee8c274_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_NotFound_vue_vue_type_template_id_6ee8c274_lang_html___["b"]; });


/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"NotFound__Wrapper"},[_c('span',{staticClass:"md-display-2",staticStyle:{"width":"100%"}},[_vm._v("\n      "+_vm._s(_vm.$t('message.pagina_inexistente'))+" "),_c('br'),_vm._v(_vm._s(_vm.$t('message.redirecionando_para_home'))+"\n    ")])])])}
var staticRenderFns = []



/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_NotFound_vue_vue_type_style_index_0_media_scss_lang_css___ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_NotFound_vue_vue_type_style_index_0_media_scss_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_NotFound_vue_vue_type_style_index_0_media_scss_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_NotFound_vue_vue_type_style_index_0_media_scss_lang_css____default.a); 

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Administracao = __webpack_require__(967);

var _Administracao2 = _interopRequireDefault(_Administracao);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  path: 'administracao',
  name: 'administracao',
  component: _Administracao2.default
};

/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Administracao_vue_vue_type_template_id_54a67193_lang_html___ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Administracao_vue_vue_type_script_lang_js___ = __webpack_require__(279);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__Administracao_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__Administracao_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Administracao_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Administracao_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__Administracao_vue_vue_type_template_id_54a67193_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Administracao_vue_vue_type_template_id_54a67193_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Administracao_vue_vue_type_template_id_54a67193_lang_html___ = __webpack_require__(969);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Administracao_vue_vue_type_template_id_54a67193_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Administracao_vue_vue_type_template_id_54a67193_lang_html___["b"]; });


/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"administracao__tabs"},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-tabs',{attrs:{"centered":"","background-color":"rgba(0,0,0,0)","color":"accent"},model:{value:(_vm.tabSelecionada),callback:function ($$v) {_vm.tabSelecionada=$$v},expression:"tabSelecionada"}},[_vm._v("\n​\n        "),_c('v-tab',{attrs:{"href":"#tab-agendamento"}},[_vm._v("\n          "+_vm._s(_vm.$t('label.agendamento_tarefa'))+"\n        ")]),_vm._v("\n​\n        "),_c('v-tab',{attrs:{"href":"#tab-rateio-acordo"}},[_vm._v("\n          "+_vm._s(_vm.$t('label.rateio_acordo'))+"\n        ")]),_vm._v("\n​\n        "),_c('v-tab',{attrs:{"href":"#tab-cache-manager"}},[_vm._v("\n          Cache Manager\n        ")]),_vm._v("\n​\n        "),_vm._v(" "),_c('v-tabs-items',{model:{value:(_vm.tabSelecionada),callback:function ($$v) {_vm.tabSelecionada=$$v},expression:"tabSelecionada"}},[_c('v-tab-item',{attrs:{"id":"tab-agendamento"}},[_c('agendamento-tarefa',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabSelecionada === 'tab-agendamento'),expression:"tabSelecionada === 'tab-agendamento'"}]})],1),_vm._v("\n​\n          "),_c('v-tab-item',{attrs:{"id":"tab-rateio-acordo"}},[_c('rateio-acordo',{directives:[{name:"show",rawName:"v-show",value:(_vm.tabSelecionada === 'tab-rateio-acordo'),expression:"tabSelecionada === 'tab-rateio-acordo'"}]})],1),_vm._v("\n​\n          "),_c('v-tab-item',{attrs:{"id":"tab-cache-manager"}},[_c('cache-manager')],1),_vm._v("\n​\n          ")],1)],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AgendamentoTarefa_vue_vue_type_template_id_8d60eae6_lang_html___ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AgendamentoTarefa_vue_vue_type_script_lang_js___ = __webpack_require__(281);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__AgendamentoTarefa_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__AgendamentoTarefa_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__AgendamentoTarefa_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__AgendamentoTarefa_vue_vue_type_template_id_8d60eae6_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__AgendamentoTarefa_vue_vue_type_template_id_8d60eae6_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AgendamentoTarefa_vue_vue_type_template_id_8d60eae6_lang_html___ = __webpack_require__(972);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AgendamentoTarefa_vue_vue_type_template_id_8d60eae6_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AgendamentoTarefa_vue_vue_type_template_id_8d60eae6_lang_html___["b"]; });


/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ma-3"},[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.agendamentos,"disable-pagination":"","hide-default-footer":"","no-data-text":_vm.$t('label.tabela_sem_conteudo')},scopedSlots:_vm._u([{key:"item.ind_unica_execucao",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v("\n              "+_vm._s(item.ind_unica_execucao ? _vm.$t('label.sim') : _vm.$t('label.nao'))+"\n            ")])]}},{key:"item.ind_ativo",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v("\n              "+_vm._s(item.ind_ativo ? _vm.$t('label.sim') : _vm.$t('label.nao'))+"\n            ")])]}},{key:"item.opcoes",fn:function(ref){
var item = ref.item;
return [_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.edit(item)}}},on),[_c('v-icon',[_vm._v("edit")])],1)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.editar')))])]),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.requestLogs(item)}}},on),[_c('v-icon',[_vm._v("assignment")])],1)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$tc('label.log', 2)))])]),_vm._v(" "),(item.ind_ativo)?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.reagendar(item)}}},on),[_c('v-icon',[_vm._v("access_time")])],1)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.reagendar')))])]):_vm._e()]}}])})],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"1200"},model:{value:(_vm.dialogForm),callback:function ($$v) {_vm.dialogForm=$$v},expression:"dialogForm"}},[_c('v-form',{ref:"form",attrs:{"lazy-validation":""}},[_c('v-card',[_c('v-card-title',[_c('h3',{staticClass:"headline mb-0"},[_vm._v(_vm._s(_vm.$t('label.agendamento_tarefa')))])]),_vm._v(" "),_c('v-card-text',[_c('v-row',[_c('span',[_vm._v(" "+_vm._s(_vm.$t('message.edicao_agendamento')))])]),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"6","md":"4"}},[_c('v-text-field',{staticClass:"Form-text__invalid",attrs:{"id":"nome","name":"nome","label":((_vm.$t('label.nome')) + " *"),"counter":50,"maxlength":"50","rules":[_vm.rules.required],"readonly":true},model:{value:(_vm.agendamento.nome),callback:function ($$v) {_vm.$set(_vm.agendamento, "nome", $$v)},expression:"agendamento.nome"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","sm":"6","md":"4"}},[_c('v-select',{staticClass:"Form-text__invalid",attrs:{"id":"periodo","name":"periodo","items":_vm.periodos,"label":((_vm.$tc('label.periodo', 1)) + " *"),"rules":[_vm.rules.required]},model:{value:(_vm.agendamento.periodo),callback:function ($$v) {_vm.$set(_vm.agendamento, "periodo", $$v)},expression:"agendamento.periodo"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","sm":"3","md":"2"}},[_c('v-text-field',{staticClass:"Form-text__invalid",attrs:{"id":"tempo","name":"tempo","label":((_vm.$t('label.tempo')) + " *"),"type":"number","min":"0","rules":[_vm.rules.required]},model:{value:(_vm.agendamento.coeficiente_tempo),callback:function ($$v) {_vm.$set(_vm.agendamento, "coeficiente_tempo", $$v)},expression:"agendamento.coeficiente_tempo"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","sm":"3","md":"2"}},[_c('v-switch',{attrs:{"label":((_vm.$t('label.ativo')) + " *"),"color":"primary"},model:{value:(_vm.agendamento.ind_ativo),callback:function ($$v) {_vm.$set(_vm.agendamento, "ind_ativo", $$v)},expression:"agendamento.ind_ativo"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{nativeOn:{"click":function($event){return _vm.fechar($event)}}},[_vm._v(_vm._s(_vm.$t('label.cancelar')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.abrirDialogSalvar($event)}}},[_vm._v(_vm._s(_vm.$t('label.salvar')))])],1)],1),_vm._v(" "),_c('confirm',{ref:"confirmDialog",attrs:{"message":_vm.$t('message.deseja_salvar', {text: _vm.$t('label.agendamento_tarefa')}),"persistent":true},on:{"agree":_vm.salvar}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"800"},model:{value:(_vm.dialogReagendar),callback:function ($$v) {_vm.dialogReagendar=$$v},expression:"dialogReagendar"}},[_c('v-form',{ref:"formReagendar",attrs:{"lazy-validation":""}},[_c('v-card',[_c('v-card-title',[_c('h3',{staticClass:"headline mb-0"},[_vm._v(_vm._s(_vm.$t('label.reagendar')))])]),_vm._v(" "),_c('v-card-text',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-text-field',{attrs:{"mask":"##-##-#### ##:##","label":_vm.$t('label.data_proxima_execucao'),"hint":"DD/MM/AAAA HH:mm","return-masked-value":true},model:{value:(_vm.dataProximaExecucao),callback:function ($$v) {_vm.dataProximaExecucao=$$v},expression:"dataProximaExecucao"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{nativeOn:{"click":function($event){return _vm.fechar($event)}}},[_vm._v(_vm._s(_vm.$t('label.cancelar')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.abrirDialogSalvarReagendar($event)}}},[_vm._v(_vm._s(_vm.$t('label.salvar')))])],1)],1),_vm._v(" "),_c('confirm',{ref:"confirmDialogReagendar",attrs:{"message":_vm.$t('message.deseja_salvar', {text: _vm.$t('label.agendamento_tarefa')}),"persistent":true},on:{"agree":_vm.salvarReagendar}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"800"},model:{value:(_vm.dialogLog),callback:function ($$v) {_vm.dialogLog=$$v},expression:"dialogLog"}},[_c('v-card',[_c('v-card-title',[_c('h3',{staticClass:"headline mb-0"},[_vm._v(_vm._s(_vm.$tc('label.log', 2)))])]),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headersLog,"items":_vm.logs,"hide-default-footer":"","no-data-text":_vm.$t('label.tabela_sem_conteudo')}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('div',{staticStyle:{"padding":"0 15px 0 0"}},[_c('v-btn',_vm._g({staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.requestLogs(_vm.agendamentoAberto)}}},_vm.on),[_c('v-icon',[_vm._v("update")])],1)],1),_vm._v(" "),_c('v-btn',{nativeOn:{"click":function($event){return _vm.fechar($event)}}},[_vm._v(_vm._s(_vm.$t('label.fechar')))])],1)],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Confirm_vue_vue_type_template_id_fbcbea64___ = __webpack_require__(974);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Confirm_vue_vue_type_template_id_fbcbea64___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Confirm_vue_vue_type_template_id_fbcbea64___["b"]; });


/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":_vm.persistent,"max-width":"290"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v(_vm._s(_vm.titleDialog))]),_vm._v(" "),_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.message || _vm.messageDialog)}}),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),(!_vm.hideDisagree)?_c('v-btn',{attrs:{"id":"nao","color":"primary darken-1","text":""},nativeOn:{"click":function($event){return _vm.disagree($event)}}},[_vm._v("\n        "+_vm._s(_vm.disagreeLabel ? _vm.disagreeLabel : _vm.$t('label.nao'))+"\n      ")]):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"id":"sim","color":"primary darken-1","text":""},nativeOn:{"click":function($event){return _vm.agree($event)}}},[_vm._v("\n        "+_vm._s(_vm.agreeLabel ? _vm.agreeLabel : _vm.$t('label.sim'))+"\n      ")])],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RateioAcordo_vue_vue_type_template_id_2d00bd34_lang_html___ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RateioAcordo_vue_vue_type_script_lang_js___ = __webpack_require__(285);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__RateioAcordo_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__RateioAcordo_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__RateioAcordo_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__RateioAcordo_vue_vue_type_template_id_2d00bd34_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__RateioAcordo_vue_vue_type_template_id_2d00bd34_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_RateioAcordo_vue_vue_type_template_id_2d00bd34_lang_html___ = __webpack_require__(977);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_RateioAcordo_vue_vue_type_template_id_2d00bd34_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_RateioAcordo_vue_vue_type_template_id_2d00bd34_lang_html___["b"]; });


/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ma-3"},[_c('h1',{staticClass:"md-title"},[_vm._v(_vm._s(_vm.$t('label.rateio_acordo')))]),_vm._v(" "),_c('v-container',{staticClass:"ml-3",attrs:{"fluid":"","grid-list-md":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"2"}},[_c('input-datepicker',{staticStyle:{"width":"100%"},attrs:{"tabindex":1,"id":"status_negociacao_data_inicio","name":"status_negociacao_data_inicio","dataVvRules":"required|date_format:DD-MM-YYYY","format":"DD-MM-YYYY","required":true,"dateIsClicked":true,"label":_vm.$t('label.data_inicio')},on:{"INPUTDATEPICKER_FORMATTED_DATE":_vm.dataInicialFormatadaStatusNegociacoes},model:{value:(_vm.dataInicial),callback:function ($$v) {_vm.dataInicial=$$v},expression:"dataInicial"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","sm":"2"}},[_c('input-datepicker',{staticStyle:{"width":"100%"},attrs:{"tabindex":2,"id":"status_negociacao_data_fim","name":"status_negociacao_data_fim","dataVvRules":"required|date_format:DD-MM-YYYY","format":"DD-MM-YYYY","required":true,"dateIsClicked":true,"label":_vm.$t('label.data_fim')},on:{"INPUTDATEPICKER_FORMATTED_DATE":_vm.dataFinalFormatadaStatusNegociacoes},model:{value:(_vm.dataFinal),callback:function ($$v) {_vm.dataFinal=$$v},expression:"dataFinal"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","sm":"2"}},[_c('v-btn',{attrs:{"color":"accent","text":""},on:{"click":_vm.aplicar}},[_vm._v(_vm._s(_vm.$t('label.aplicar')))])],1)],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_InputDatepicker_vue_vue_type_template_id_0b04765f_lang_html___ = __webpack_require__(985);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_InputDatepicker_vue_vue_type_template_id_0b04765f_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_InputDatepicker_vue_vue_type_template_id_0b04765f_lang_html___["b"]; });


/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('md-input-container',{class:{ 'md-input-invalid': _vm.errors.has(_vm.name) }},[_c('label',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('md-input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.validate),expression:"validate"},{name:"datefull",rawName:"v-datefull"}],class:_vm.classDesign,attrs:{"id":"datepicker-trigger","type":"text","tabindex":_vm.tabindex,"required":_vm.required,"data-vv-name":_vm.name,"autocomplete":"off","disabled":_vm.disabled,"data-vv-rules":_vm.dataVvRules},nativeOn:{"click":function($event){return _vm.showDatepickerEvent($event)},"focus":function($event){return _vm.showDatepickerEvent($event)}},model:{value:(_vm.dateValue),callback:function ($$v) {_vm.dateValue=$$v},expression:"dateValue"}}),_vm._v(" "),_c('span',{staticClass:"md-error"},[_vm._v("\n        "+_vm._s(_vm.errors.first(_vm.name))+"\n      ")])],1),_vm._v(" "),_c('datepicker',{ref:"datepicker",staticClass:"InputDatepicker__Datepicker--open",attrs:{"timepicker":_vm.timepicker,"disable-passed-days":_vm.disablePassedDays,"disable-passed-months":_vm.disablePassedMonths,"disable-previous-days":_vm.disablePreviousDays,"doubled":_vm.doubled,"format":_vm.format,"disabled-days":_vm.disabledDays,"lang":_vm.lang,"orientation":_vm.orientation,"show":_vm.isVisible},on:{"clicked-day":_vm.selectDate,"hide":_vm.hideDatePicker,"cancel":_vm.cancelDateSelection}})],1)}
var staticRenderFns = []



/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Datepicker_vue_vue_type_template_id_a7c40f7c_scoped_true___ = __webpack_require__(987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Datepicker_vue_vue_type_script_lang_js___ = __webpack_require__(289);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__Datepicker_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__Datepicker_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Datepicker_scss_vue_type_style_index_0_id_a7c40f7c_lang_scss_scoped_true___ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Datepicker_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__Datepicker_vue_vue_type_template_id_a7c40f7c_scoped_true___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Datepicker_vue_vue_type_template_id_a7c40f7c_scoped_true___["b" /* staticRenderFns */],
  false,
  null,
  "a7c40f7c",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Datepicker_vue_vue_type_template_id_a7c40f7c_scoped_true___ = __webpack_require__(988);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Datepicker_vue_vue_type_template_id_a7c40f7c_scoped_true___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Datepicker_vue_vue_type_template_id_a7c40f7c_scoped_true___["b"]; });


/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"datepicker-slide"}},[(_vm.show)?_c('div',{staticClass:"datepicker",class:{
      'double': _vm.isDoubled,
      'portrait': _vm.classOrientation === 'portrait',
      'datepicker--isDatepicker': _vm.isDatepicker,
    },on:{"click":function($event){$event.stopPropagation();}}},[(_vm.noheader === false)?_c('div',{staticClass:"datepicker-header",class:[_vm.classOrientation]},[_c('div',{staticClass:"datepicker-year",on:{"click":_vm.showOrHideYears}},[_c('transition-group',{attrs:{"name":"slideh"}},_vm._l(([_vm.year]),function(year,index){return _c('span',{key:index,class:_vm.dayDirection},[_vm._v("\n            "+_vm._s(year)+"\n          ")])}),0)],1),_vm._v(" "),_c('div',{staticClass:"datepicker-date",class:[_vm.classOrientation]},[_c('transition-group',{attrs:{"name":"slideh"}},_vm._l(([_vm.dateFormatted]),function(dateFormatted,index){return _c('span',{key:index,class:[_vm.dayDirection]},[_vm._v("\n            "+_vm._s(dateFormatted)+"\n          ")])}),0)],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"datepicker-body",class:[_vm.classOrientation]},[_c('div',{staticClass:"datepicker-controls",class:[_vm.isDoubled, _vm.classOrientation]},[_c('button',{staticClass:"datepicker-next",on:{"click":_vm.nextMonth}},[_c('svg',{staticClass:"datepicker-arrow",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0.5 900.5 30 30","enable-background":"new 0.5 900.5 30 30"}},[_c('path',{attrs:{"d":"M8.779 928.31c-.473.567-.396 1.406.171 1.88.566.474 1.409.396 1.881-.17l11.391-13.664c.208-.247.31-.551.31-.855 0-.304-.103-.607-.31-.855l-11.391-13.666c-.472-.566-1.315-.644-1.881-.17-.565.473-.643 1.313-.171 1.881l10.679 12.809-10.679 12.81z"}})])]),_vm._v(" "),_c('button',{staticClass:"datepicker-prev",on:{"click":_vm.prevMonth}},[_c('svg',{staticClass:"datepicker-arrow",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0.5 900.5 30 30","enable-background":"new 0.5 900.5 30 30"}},[_c('path',{attrs:{"d":"M22.221 928.31l-10.679-12.81 10.679-12.809c.472-.567.395-1.408-.171-1.881-.565-.474-1.409-.396-1.881.17l-11.39 13.665c-.208.248-.31.552-.31.855 0 .305.103.608.31.855l11.391 13.664c.472.566 1.315.644 1.881.17.566-.473.643-1.312.17-1.879z"}})])])]),_vm._v(" "),_vm._l((_vm.months),function(month,index){return _c('div',{key:index,staticClass:"datepicker-month"},[_c('transition-group',{attrs:{"name":"slidev"}},_vm._l(([month]),function(month,index){return _c('div',{key:index,staticClass:"datepicker-month-label",class:_vm.classDirection},[_vm._v("\n            "+_vm._s(month.getFormatted())+"\n          ")])}),0),_vm._v(" "),_c('div',{staticClass:"datepicker-week"},_vm._l((_vm.weekDays),function(day,index){return _c('div',{key:index,staticClass:"datepicker-weekday",attrs:{"track-by":"$index"}},[_vm._v("\n            "+_vm._s(day)+"\n          ")])}),0),_vm._v(" "),_c('div',{staticClass:"datepicker-days"},[_c('transition-group',{attrs:{"name":"slidev"}},_vm._l(([month]),function(month,index){return _c('div',{key:index,class:_vm.classDirection},[_c('div',{staticClass:"datepicker-day",style:({ width: (month.getWeekStart() * 41) + 'px' })}),_vm._v(" "),_vm._l((month.getDays()),function(day,index){return _c('div',{key:index,staticClass:"datepicker-day",class:{ selected: _vm.isSelected(day) },attrs:{"disabled":_vm.isDisabled(day)},on:{"click":function($event){return _vm.selectDate(day)}}},[_c('span',{staticClass:"datepicker-day-effect"}),_vm._v(" "),_c('span',{staticClass:"datepicker-day-text"},[_vm._v(_vm._s(day.format('D')))])])})],2)}),0)],1)],1)}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.yearsVisible),expression:"yearsVisible"}],staticClass:"datepicker-years",class:[_vm.isDoubled, _vm.classOrientation],attrs:{"transition":"fade"}},[_c('div',{staticClass:"datepicker-years-content"},_vm._l((_vm.years),function(year,index){return _c('div',{key:index,staticClass:"datepicker-year",class:_vm.classYear(year),on:{"click":function($event){return _vm.selectYear(year)}}},[_vm._v("\n              "+_vm._s(year.year())+"\n            ")])}),0)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showActions),expression:"showActions"}],staticClass:"datepicker-actions"},[_c('button',{on:{"click":function($event){return _vm.cancel()}}},[_vm._v(_vm._s(_vm.language[1]))]),_vm._v(" "),_c('button',{on:{"click":function($event){return _vm.submitDay()}}},[_vm._v(_vm._s(_vm.language[0]))])])],2)]):_vm._e()])}
var staticRenderFns = []



/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWeekDays = exports.getYears = exports.getDayRange = exports.getWeeksRange = exports.getMonthsRange = exports.getYearsRange = exports.defaultRange = exports.getDaysRange = undefined;

var _classCallCheck2 = __webpack_require__(29);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(43);

var _createClass3 = _interopRequireDefault(_createClass2);

var _moment = __webpack_require__(2);

var _moment2 = _interopRequireDefault(_moment);

__webpack_require__(990);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getDaysRange = exports.getDaysRange = function getDaysRange(start, end) {
  return _moment2.default.range(start, end).toArray('days');
};

var defaultRange = exports.defaultRange = function defaultRange() {
  var range = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'year';
  var startDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var endDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var format = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'DD-MM-YYYY';

  var start = startDate ? (0, _moment2.default)(startDate, format) : (0, _moment2.default)();
  var end = endDate ? (0, _moment2.default)(endDate, format) : (0, _moment2.default)();
  return getDaysRange(start.startOf(range), end.endOf(range));
};

var getYearsRange = exports.getYearsRange = function getYearsRange(startDate, endDate, format) {
  return defaultRange('year', startDate, endDate, format);
};

var getMonthsRange = exports.getMonthsRange = function getMonthsRange(startDate, endDate, format) {
  return defaultRange('month', startDate, endDate, format);
};

var getWeeksRange = exports.getWeeksRange = function getWeeksRange(startDate, endDate, format) {
  return defaultRange('week', startDate, endDate, format);
};

var getDayRange = exports.getDayRange = function getDayRange(startDate, endDate, format) {
  return defaultRange('days', startDate, endDate, format);
};

var _getYears = function _getYears(startYear) {
  var start = (0, _moment2.default)([startYear.year() - 50, 0]),
      end = (0, _moment2.default)([startYear.year() + 50, 0]);

  return _moment2.default.range(start, end).toArray('years');
};

exports.getYears = _getYears;
var getWeekDays = exports.getWeekDays = function getWeekDays(lang) {
  var days = [];

  _moment2.default.locale(lang);

  for (var i = 0; i < 7; i += 1) {
    days.push((0, _moment2.default)().weekday(i).format('dd'));
  }

  return days;
};

var Month = function () {
  function Month(month, year) {
    (0, _classCallCheck3.default)(this, Month);

    this.start = (0, _moment2.default)([year, month]);
    this.end = this.start.clone().endOf('month');
    this.month = month;
    this.year = year;
  }

  (0, _createClass3.default)(Month, [{
    key: 'getWeekStart',
    value: function getWeekStart() {
      return this.start.weekday();
    }
  }, {
    key: 'getDays',
    value: function getDays() {
      var start = this.start;
      return getDaysRange(start, this.end);
    }
  }, {
    key: 'getFormatted',
    value: function getFormatted() {
      return this.start.format('MMMM YYYY');
    }
  }, {
    key: 'getWeeks',
    value: function getWeeks() {
      return this.end.week() - this.start.week() + 1;
    }
  }, {
    key: 'getYears',
    value: function getYears() {
      return _getYears(this.start);
    }
  }]);
  return Month;
}();

exports.default = Month;

/***/ }),
/* 990 */,
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_Datepicker_scss_vue_type_style_index_0_id_a7c40f7c_lang_scss_scoped_true___ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_Datepicker_scss_vue_type_style_index_0_id_a7c40f7c_lang_scss_scoped_true____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_Datepicker_scss_vue_type_style_index_0_id_a7c40f7c_lang_scss_scoped_true___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_Datepicker_scss_vue_type_style_index_0_id_a7c40f7c_lang_scss_scoped_true____default.a); 

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var margin = 8;
var isAboveOfViewport = function isAboveOfViewport(element, position) {
  position.top <= margin - parseInt(window.getComputedStyle(element).marginTop, 10);
};
var isBelowOfViewport = function isBelowOfViewport(element, position) {
  position.top + element.offsetHeight + margin >= window.innerHeight - parseInt(window.getComputedStyle(element).marginTop, 10);
};
var isOnTheLeftOfViewport = function isOnTheLeftOfViewport(element, position) {
  position.left <= margin - parseInt(window.getComputedStyle(element).marginLeft, 10);
};
var isOnTheRightOfViewport = function isOnTheRightOfViewport(element, position) {
  position.left + element.offsetWidth + margin >= window.innerWidth - parseInt(window.getComputedStyle(element).marginLeft, 10);
};
var getInViewPosition = function getInViewPosition(element, position) {
  var computedStyle = window.getComputedStyle(element);
  if (isAboveOfViewport(element, position)) {
    position.top = margin - parseInt(computedStyle.marginTop, 10);
  }
  if (isOnTheLeftOfViewport(element, position)) {
    position.left = margin - parseInt(computedStyle.marginLeft, 10);
  }
  if (isOnTheRightOfViewport(element, position)) {
    position.left = window.innerWidth - margin - element.offsetWidth - parseInt(computedStyle.marginLeft, 10);
  }
  if (isBelowOfViewport(element, position)) {
    position.top = window.innerHeight - margin - element.offsetHeight - parseInt(computedStyle.marginTop, 10);
  }
  return position;
};
exports.default = getInViewPosition;

/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CacheManager_vue_vue_type_template_id_e19833d0___ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CacheManager_vue_vue_type_script_lang_js___ = __webpack_require__(292);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__CacheManager_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__CacheManager_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__CacheManager_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__CacheManager_vue_vue_type_template_id_e19833d0___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__CacheManager_vue_vue_type_template_id_e19833d0___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CacheManager_vue_vue_type_template_id_e19833d0___ = __webpack_require__(995);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CacheManager_vue_vue_type_template_id_e19833d0___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CacheManager_vue_vue_type_template_id_e19833d0___["b"]; });


/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mt-6"},[_c('v-row',{attrs:{"alignment":"center","justify":"center"}},[_c('v-btn',{attrs:{"color":"red"},on:{"click":_vm.checkAndDrop}},[_vm._v("\n      Drop Redis Cache\n    ")])],1),_vm._v(" "),_c('confirm',{ref:"dialog",attrs:{"persistent":true,"message":_vm.$t('message.confirmacao_drop_cache')},on:{"agree":function($event){return _vm.dropCache()}}})],1)}
var staticRenderFns = []



/***/ }),
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Administracao_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Administracao_vue_vue_type_style_index_0_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Administracao_vue_vue_type_style_index_0_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Administracao_vue_vue_type_style_index_0_lang_css____default.a); 

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AjusteVerba = __webpack_require__(998);

var _AjusteVerba2 = _interopRequireDefault(_AjusteVerba);

var _AjusteVerbaForm = __webpack_require__(1001);

var _AjusteVerbaForm2 = _interopRequireDefault(_AjusteVerbaForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  path: 'ajuste-verba',
  name: 'ajuste-verba',
  component: _AjusteVerba2.default,
  children: [{
    path: 'novo',
    name: 'novoAjusteVerba',
    component: _AjusteVerbaForm2.default,
    props: {
      fluxo: false,
      somenteLeitura: false,
      novo: true
    }
  }, {
    path: ':id',
    name: 'verAjusteVerba',
    component: _AjusteVerbaForm2.default,
    props: {
      somenteLeitura: true,
      novo: false,
      fluxo: false
    }
  }, {
    path: ':id/fluxo',
    name: 'verAjusteVerbaFluxo',
    component: _AjusteVerbaForm2.default,
    props: {
      somenteLeitura: true,
      novo: false,
      fluxo: true
    }
  }]
};

/***/ }),
/* 998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AjusteVerba_vue_vue_type_template_id_31394433___ = __webpack_require__(999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__AjusteVerba_vue_vue_type_template_id_31394433___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__AjusteVerba_vue_vue_type_template_id_31394433___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AjusteVerba_vue_vue_type_template_id_31394433___ = __webpack_require__(1000);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AjusteVerba_vue_vue_type_template_id_31394433___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AjusteVerba_vue_vue_type_template_id_31394433___["b"]; });


/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c('router-view')],1)}
var staticRenderFns = []



/***/ }),
/* 1001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AjusteVerbaForm_vue_vue_type_template_id_67a4fea2_lang_html___ = __webpack_require__(1002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AjusteVerbaForm_vue_vue_type_script_lang_js___ = __webpack_require__(295);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__AjusteVerbaForm_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__AjusteVerbaForm_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__AjusteVerbaForm_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__AjusteVerbaForm_vue_vue_type_template_id_67a4fea2_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__AjusteVerbaForm_vue_vue_type_template_id_67a4fea2_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AjusteVerbaForm_vue_vue_type_template_id_67a4fea2_lang_html___ = __webpack_require__(1003);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AjusteVerbaForm_vue_vue_type_template_id_67a4fea2_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AjusteVerbaForm_vue_vue_type_template_id_67a4fea2_lang_html___["b"]; });


/***/ }),
/* 1003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canAccessPage)?_c('section',[_c('register-form',{attrs:{"title":_vm.$t('title.ajuste_verba'),"elevation":"2","cancel":_vm.somenteLeitura ? _vm.voltar : _vm.openCancelDialog,"save":_vm.somenteLeitura || !_vm.canPost ? null : _vm.openSaveDialog,"cancelLabel":_vm.$t('label.voltar'),"saveLabel":_vm.$t('label.ajustar'),"subtitle":''}},[_c('div',{staticStyle:{"width":"100%"},attrs:{"slot":"content"},slot:"content"},[_c('md-layout',[_c('md-radio',{staticClass:"md-primary",attrs:{"tabindex":"1","id":"adendo","disabled":_vm.somenteLeitura,"name":"tipo","md-value":"ADENDO"},model:{value:(_vm.ajuste.tipo),callback:function ($$v) {_vm.$set(_vm.ajuste, "tipo", $$v)},expression:"ajuste.tipo"}},[_vm._v(_vm._s(_vm.$t('label.adendo'))+"\n        ")]),_vm._v(" "),_c('md-radio',{staticClass:"md-primary",attrs:{"id":"reducao","disabled":_vm.somenteLeitura,"name":"tipo","md-value":"REDUCAO"},model:{value:(_vm.ajuste.tipo),callback:function ($$v) {_vm.$set(_vm.ajuste, "tipo", $$v)},expression:"ajuste.tipo"}},[_vm._v(_vm._s(_vm.$t('label.reducao'))+"\n        ")])],1),_vm._v(" "),_c('md-layout',{attrs:{"md-gutter":"16"}},[_c('md-layout',{attrs:{"md-flex":"33","md-flex-medium":"50","md-flex-small":"100","md-flex-xsmall":"100"}},[_c('md-input-container',{class:{
                'md-input-invalid': _vm.errors.has('orcamento')
              }},[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('label.orcamento')))]),_vm._v(" "),_c('md-autocomplete',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"tabindex":"2","id":"orcamento","name":"orcamento","required":true,"maxlength":"50","data-vv-name":"orcamento","data-vv-rules":"required","fetch":_vm.fetchOrcamentoFunction,"min-chars":1,"disabled":_vm.somenteLeitura,"prepareResponseData":_vm.prepareResponseData,"printAttribute":"descricao","queryParam":"descricao"},on:{"selected":_vm.setOrcamento},model:{value:(_vm.ajuste.descricaoOrcamento),callback:function ($$v) {_vm.$set(_vm.ajuste, "descricaoOrcamento", $$v)},expression:"ajuste.descricaoOrcamento"}}),_vm._v(" "),_c('md-icon',{staticStyle:{"cursor":"pointer"},attrs:{"md-autocomplete-search":""}},[_vm._v("search")]),_vm._v(" "),_c('span',{staticClass:"md-error"},[_vm._v("\n                "+_vm._s(_vm.errors.first('orcamento'))+"\n              ")])],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"33","md-flex-medium":"50","md-flex-small":"100","md-flex-xsmall":"100"}},[_c('md-input-container',{class:{
                'md-input-invalid': _vm.errors.has('linha')
              }},[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.$tc('label.linha_investimento', 1)))]),_vm._v(" "),_c('md-autocomplete',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"tabindex":"3","id":"linha","name":"linha","maxlength":"50","required":true,"data-vv-name":"linha","data-vv-rules":"required","fetch":_vm.buscarLinha,"min-chars":1,"disabled":_vm.somenteLeitura || _vm.disableLinha,"prepareResponseData":_vm.prepareResponseData,"printAttribute":"descricao","queryParam":"descricao"},on:{"selected":_vm.setLinha},model:{value:(_vm.ajuste.descricaoLinha),callback:function ($$v) {_vm.$set(_vm.ajuste, "descricaoLinha", $$v)},expression:"ajuste.descricaoLinha"}}),_vm._v(" "),_c('md-icon',{staticStyle:{"cursor":"pointer"},attrs:{"md-autocomplete-search":""}},[_vm._v("search")]),_vm._v(" "),_c('span',{staticClass:"md-error"},[_vm._v("\n                "+_vm._s(_vm.errors.first('linha'))+"\n              ")])],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"33","md-flex-medium":"50","md-flex-small":"100","md-flex-xsmall":"100"}},[_c('md-input-container',{class:{
                'md-input-invalid': _vm.errors.has('desdobramento')
              }},[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('label.competencia')))]),_vm._v(" "),_c('md-autocomplete',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"tabindex":"4","id":"desdobramento","name":"desdobramento","maxlength":"7","required":true,"data-vv-name":"desdobramento","data-vv-rules":"required","fetch":_vm.buscarDesdobramento,"min-chars":1,"disabled":_vm.somenteLeitura || _vm.disableDesdobramento,"prepareResponseData":_vm.prepareResponseData,"printAttribute":"anoMes","queryParam":"anoMes"},on:{"selected":_vm.setDesdobramento},model:{value:(_vm.ajuste.competencia),callback:function ($$v) {_vm.$set(_vm.ajuste, "competencia", $$v)},expression:"ajuste.competencia"}}),_vm._v(" "),_c('md-icon',{staticStyle:{"cursor":"pointer"},attrs:{"md-autocomplete-search":""}},[_vm._v("search")]),_vm._v(" "),_c('span',{staticClass:"md-error"},[_vm._v("\n                "+_vm._s(_vm.errors.first('desdobramento'))+"\n              ")])],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"33","md-flex-medium":"50","md-flex-small":"100","md-flex-xsmall":"100"}},[_c('md-input-container',{class:{
                'md-input-invalid': _vm.errors.has('representante')
              }},[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.$tc('label.representante', 1)))]),_vm._v(" "),_c('md-autocomplete',{attrs:{"tabindex":"5","id":"representante","name":"representante","maxlength":"100","data-vv-name":"representante","fetch":_vm.buscarRepresentante,"min-chars":1,"disabled":_vm.somenteLeitura || _vm.disableRepresentante,"prepareResponseData":_vm.prepareResponseData,"printAttribute":"nome","queryParam":"nome"},on:{"selected":_vm.setRepresentante},nativeOn:{"change":function($event){return _vm.limparRepresentante($event)}},model:{value:(_vm.ajuste.representante),callback:function ($$v) {_vm.$set(_vm.ajuste, "representante", $$v)},expression:"ajuste.representante"}}),_vm._v(" "),_c('md-icon',{staticStyle:{"cursor":"pointer"},attrs:{"md-autocomplete-search":""}},[_vm._v("search")]),_vm._v(" "),_c('span',{staticClass:"md-error"},[_vm._v("\n                "+_vm._s(_vm.errors.first('representante'))+"\n              ")])],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"33","md-flex-medium":"50","md-flex-small":"100","md-flex-xsmall":"100"}},[_c('md-input-container',[_c('label',[_vm._v(_vm._s(_vm.$t('label.valor_planejado')))]),_vm._v(" "),_c('InputMoney',{attrs:{"disabled":true,"tabindex":"-1","id":"vlr_planejado","name":"vlr_planejado","one-way-bind":_vm.ajuste.vlrPlanejado}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"33","md-flex-medium":"50","md-flex-small":"100","md-flex-xsmall":"100"}},[_c('md-input-container',[_c('label',[_vm._v(_vm._s(_vm.$t('label.valor_disponivel')))]),_vm._v(" "),_c('InputMoney',{attrs:{"disabled":true,"tabindex":"-1","id":"vlr_disponivel","name":"vlr_disponivel","one-way-bind":_vm.ajuste.vlrDisponivel}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"33","md-flex-medium":"50","md-flex-small":"100","md-flex-xsmall":"100"}},[_c('md-input-container',{class:{
                'md-input-invalid': _vm.errors.has('vlr_ajuste')
              }},[_c('label',[_vm._v(_vm._s(_vm.$t('label.valor_ajuste')))]),_vm._v(" "),_c('InputMoney',{attrs:{"disabled":_vm.somenteLeitura,"tabindex":"6","id":"vlr_ajuste","maxlength":13,"name":"vlr_ajuste","one-way-bind":_vm.ajuste.valor},on:{"change":function (n) { return _vm.ajuste.valor = n; }}}),_vm._v(" "),_c('span',{staticClass:"md-error"},[_vm._v("\n                "+_vm._s(_vm.errors.first('vlr_ajuste'))+"\n              ")])],1)],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-gutter":"16"}},[_c('md-layout',{attrs:{"md-flex-small":"100","md-flex-xsmall":"100"}},[_c('md-input-container',{class:{
              'md-input-invalid': _vm.errors.has('justificativa')
            }},[_c('label',[_vm._v(_vm._s(_vm.$t('label.justificativa')))]),_vm._v(" "),_c('md-textarea',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"id":"justificativa","name":"justificativa","tabindex":"7","maxlength":"250","required":"","data-vv-name":"justificativa","data-vv-rules":"required","disabled":_vm.somenteLeitura},model:{value:(_vm.ajuste.justificativa),callback:function ($$v) {_vm.$set(_vm.ajuste, "justificativa", $$v)},expression:"ajuste.justificativa"}}),_vm._v(" "),_c('span',{staticClass:"md-error"},[_vm._v("\n              "+_vm._s(_vm.errors.first('justificativa'))+"\n            ")])],1)],1),_vm._v(" "),(_vm.ajuste.status === 'REPROVADO')?_c('md-layout',{attrs:{"md-flex-small":"100","md-flex-xsmall":"100"}},[_c('md-input-container',{class:{
              'md-input-invalid': _vm.errors.has('justificativa_reprovacao')
            }},[_c('label',[_vm._v(_vm._s(_vm.$t('label.justificativa_reprovacao')))]),_vm._v(" "),_c('md-textarea',{attrs:{"id":"justificativa_reprovacao","name":"justificativa_reprovacao","tabindex":"-1","disabled":true},model:{value:(_vm.justificativaReprovacao),callback:function ($$v) {_vm.justificativaReprovacao=$$v},expression:"justificativaReprovacao"}}),_vm._v(" "),_c('span',{staticClass:"md-error"},[_vm._v("\n              "+_vm._s(_vm.errors.first('justificativa_reprovacao'))+"\n            ")])],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"button"},slot:"button"},[_c('md-card-actions',{staticClass:"RegisterForm__Boxing",staticStyle:{"text-align":"right"}},[_c('md-button',{staticClass:"md-raised",attrs:{"id":"cancelRegisterFromButton"},nativeOn:{"click":function($event){_vm.somenteLeitura ? _vm.voltar() : _vm.openCancelDialog()}}},[_vm._v("\n          "+_vm._s(_vm.$t('label.voltar'))+"\n        ")]),_vm._v(" "),(!_vm.somenteLeitura)?_c('md-button',{staticClass:"md-accent md-raised",attrs:{"id":"saveRegisterFromButton"},nativeOn:{"click":function($event){return _vm.openSaveDialog(_vm.dialog.ref)}}},[_vm._v("\n          "+_vm._s(_vm.$t('label.ajustar'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('md-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.podeReprovar),expression:"podeReprovar"}],staticClass:"md-raised md-warn",nativeOn:{"click":function($event){return _vm.openDialogReprovar(_vm.dialog.ref)}}},[_vm._v("\n          "+_vm._s(_vm.$tc('label.reprovar'))+"\n        ")]),_vm._v(" "),_c('md-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.podeAprovar),expression:"podeAprovar"}],staticClass:"md-raised md-accent",nativeOn:{"click":function($event){return _vm.openDialogAprovar(_vm.dialog.ref)}}},[_vm._v("\n          "+_vm._s(_vm.$tc('label.aprovar'))+"\n        ")])],1)],1)]),_vm._v(" "),_c('md-dialog',{ref:"justificarDialog"},[_c('md-dialog-title',[_vm._v("\n      "+_vm._s(_vm.$t('label.justificativa'))+"\n    ")]),_vm._v(" "),_c('md-dialog-content',[_c('div',{staticStyle:{"width":"300px"}},[(!_vm.justificarAjuste.obrigatorio)?_c('md-input-container',[_c('label',[_vm._v("\n            "+_vm._s(_vm.$t('label.motivo'))+"\n          ")]),_vm._v(" "),_c('md-textarea',{attrs:{"name":"justificativa_ajuste"},model:{value:(_vm.justificarAjuste.observacao),callback:function ($$v) {_vm.$set(_vm.justificarAjuste, "observacao", $$v)},expression:"justificarAjuste.observacao"}})],1):_vm._e(),_vm._v(" "),(_vm.justificarAjuste.obrigatorio)?_c('md-input-container',{class:{
            'md-input-invalid': _vm.errors.has('justificativa_ajuste'),
          }},[_c('label',[_vm._v("\n            "+_vm._s(_vm.$t('label.motivo'))+"\n          ")]),_vm._v(" "),_c('md-textarea',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"required":"","data-vv-rules":"required","id":"justificativa_ajuste","name":"justificativa_ajuste"},model:{value:(_vm.justificarAjuste.observacao),callback:function ($$v) {_vm.$set(_vm.justificarAjuste, "observacao", $$v)},expression:"justificarAjuste.observacao"}})],1):_vm._e()],1)]),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",nativeOn:{"click":function($event){return _vm.closeDialog('justificarDialog')}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.cancelar'))+"\n      ")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary",nativeOn:{"click":function($event){return _vm.closeDialog('justificarDialog', _vm.justificarAjuste.action)}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.salvar'))+"\n      ")])],1)],1),_vm._v(" "),_c('md-dialog',{ref:_vm.dialog.ref,attrs:{"md-open-from":("#" + (_vm.dialog.from)),"md-close-to":("#" + (_vm.dialog.from))}},[_c('md-dialog-title',[_vm._v(_vm._s(_vm.dialog.title))]),_vm._v(" "),_c('md-dialog-content',[_vm._v(_vm._s(_vm.dialog.content))]),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",attrs:{"disabled":_vm.disableButton},nativeOn:{"click":function($event){return _vm.closeDialog('dialog1')}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.cancelar'))+"\n      ")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary",attrs:{"disabled":_vm.disableButton},nativeOn:{"click":function($event){return _vm.closeDialog('dialog1', _vm.dialog.action)}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.sim'))+"\n      ")])],1)],1),_vm._v(" "),_c('modal-voltar',{ref:"voltarDialog",attrs:{"actionSim":this.openSaveDialogVoltar,"actionNao":this.cancel}})],1):_vm._e()}
var staticRenderFns = []



/***/ }),
/* 1004 */,
/* 1005 */,
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortTableColumn = exports.sortTruthy = undefined;

var _typeof2 = __webpack_require__(55);

var _typeof3 = _interopRequireDefault(_typeof2);

var _helpers = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sortTruthy = exports.sortTruthy = function sortTruthy(array, truthyIndex) {
  array.sort(function (item) {
    return item[truthyIndex] ? -1 : 1;
  });
};

var sortComparison = function sortComparison(first, second, type) {
  var replaceNull = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var auxFirst = replaceNull || first,
      auxSecond = replaceNull || second;

  if (auxFirst < auxSecond) {
    return type === 'desc' ? -1 : 1;
  }
  if (auxFirst > auxSecond) {
    return type === 'desc' ? 1 : -1;
  }
  return 0;
};

var extractSortableData = function extractSortableData(data) {
  var castDataToNumber = Number(data);
  if (isNaN(castDataToNumber)) {
    if (typeof data === 'string') {
      return data.indexOf(';') !== -1 ? data.replace(/[0-9:,;]/g, '').toLowerCase() : data.toLowerCase();
    }
    return data;
  }
  return castDataToNumber;
};

var sortTableColumn = exports.sortTableColumn = function sortTableColumn(array, sortObject) {
  var replaceNull = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var type = sortObject.type;
  if (sortObject && (typeof sortObject === 'undefined' ? 'undefined' : (0, _typeof3.default)(sortObject)) === 'object') {
    array.sort(function (a, b) {
      var index = sortObject.name,
          first = extractSortableData((0, _helpers.accessObjectViaString)(a, index)),
          second = extractSortableData((0, _helpers.accessObjectViaString)(b, index));

      return sortComparison(first, second, type, replaceNull);
    });
  }
};

/***/ }),
/* 1007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_RegisterForm_vue_vue_type_template_id_198e55a6_scoped_true_lang_html___ = __webpack_require__(1008);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_RegisterForm_vue_vue_type_template_id_198e55a6_scoped_true_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_RegisterForm_vue_vue_type_template_id_198e55a6_scoped_true_lang_html___["b"]; });


/***/ }),
/* 1008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"elevation":_vm.elevation,"color":_vm.color}},[(_vm.showHeader)?_vm._t("header",[_c('v-card-title',[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_vm._v(" "),_c('v-card-text',[_c('span',[_vm._v(_vm._s(_vm.subtitle))]),_vm._v(" "),_vm._t("content")],2),_vm._v(" "),(_vm.showButton)?_vm._t("button",[_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),(_vm.cancel)?_c('v-btn',{nativeOn:{"click":function($event){return _vm.cancelAction($event)}}},[_vm._v(_vm._s(_vm.cancelLabel))]):_vm._e(),_vm._v(" "),(_vm.save)?_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.saveAction($event)}}},[_vm._v(_vm._s(_vm.saveLabel))]):_vm._e()],1)]):_vm._e()],2)}
var staticRenderFns = []



/***/ }),
/* 1009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_RegisterForm_css_vue_type_style_index_0_id_198e55a6_lang_css_scoped_true___ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_RegisterForm_css_vue_type_style_index_0_id_198e55a6_lang_css_scoped_true____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_RegisterForm_css_vue_type_style_index_0_id_198e55a6_lang_css_scoped_true___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_RegisterForm_css_vue_type_style_index_0_id_198e55a6_lang_css_scoped_true____default.a); 

/***/ }),
/* 1010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_mdAutocomplete_vue_vue_type_template_id_064cd0dc_lang_html___ = __webpack_require__(1011);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_mdAutocomplete_vue_vue_type_template_id_064cd0dc_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_mdAutocomplete_vue_vue_type_template_id_064cd0dc_lang_html___["b"]; });


/***/ }),
/* 1011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-autocomplete",on:{"focus":_vm.onFocus,"blur":_vm.onBlur}},[_c('md-menu',{ref:"menu",staticClass:"md-autocomplete-menu",attrs:{"md-offset-x":8,"md-offset-y":"45","md-direction":_vm.direction}},[_c('span',{attrs:{"md-menu-trigger":""}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.query),expression:"query"}],ref:"input",staticClass:"md-input",attrs:{"type":"text","disabled":_vm.disabled,"required":"required","id":_vm.inputIdComputado,"autocomplete":"off","placeholder":_vm.placeholder,"maxlength":_vm.maxlength,"name":_vm.name},domProps:{"value":(_vm.query)},on:{"focus":_vm.onFocus,"blur":_vm.blurInput,"input":[function($event){if($event.target.composing){ return; }_vm.query=$event.target.value},_vm.debounceUpdate]}}),_vm._v(" "),_c('md-menu-content',{style:(("z-index: 1000; " + _vm.menuStyle))},[(_vm.loading)?_c('md-menu-item',[_c('md-layout',{attrs:{"md-align":"center"}},[_c('md-spinner',{attrs:{"md-size":30,"md-stroke":2,"md-indeterminate":""}})],1)],1):_vm._e(),_vm._v(" "),_vm._l((_vm.items),function(item,index){return (_vm.items.length && !_vm.printFunction && !_vm.loading)?_c('md-menu-item',{key:index,on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.hit(item)}},nativeOn:{"click":function($event){return _vm.hit(item)}}},[_vm._v("\n        "+_vm._s(item[_vm.printAttribute])+"\n      ")]):_vm._e()}),_vm._v(" "),_vm._l((_vm.items),function(item,index){return (_vm.items.length && _vm.printFunction && !_vm.loading)?_c('md-menu-item',{key:index,on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.hit(item)}},nativeOn:{"click":function($event){return _vm.hit(item)}}},[_vm._v("\n        "+_vm._s(_vm.printFunction(item))+"\n      ")]):_vm._e()}),_vm._v(" "),(_vm.verMais && _vm.items.length && !_vm.loading)?_c('md-menu-item',{on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.verMaisRegistros()}},nativeOn:{"click":function($event){return _vm.verMaisRegistros()}}},[_c('a',[_vm._v(_vm._s(_vm.$tc('label.proximo', 2)))])]):_vm._e(),_vm._v(" "),(_vm.extensao && !_vm.items.length && !_vm.loading)?_c('md-menu-item',{nativeOn:{"click":function($event){return _vm.addExtension($event)}}},[_c('a',[_vm._v(_vm._s(_vm.$t('label.cadastrar_extensao')))])]):_vm._e(),_vm._v(" "),(!_vm.extensao && !_vm.items.length && !_vm.loading)?_c('md-menu-item',[_vm._v("\n        "+_vm._s(_vm.$t('label.tabela_sem_conteudo'))+"\n      ")]):_vm._e()],2)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    value: [String, Number],
    disabled: Boolean,
    required: Boolean,
    maxlength: [Number, String],
    placeholder: String
  },
  watch: {
    value: function value(_value) {
      this.setParentValue(_value);
      this.updateValues(_value);
    },
    disabled: function disabled() {
      this.setParentDisabled();
    },
    required: function required() {
      this.setParentRequired();
    },
    placeholder: function placeholder() {
      this.setParentPlaceholder();
    },
    maxlength: function maxlength() {
      this.handleMaxLength();
    }
  },
  methods: {
    handleMaxLength: function handleMaxLength() {
      this.parentContainer.enableCounter = this.maxlength > 0;
      this.parentContainer.counterLength = this.maxlength;
    },
    setParentValue: function setParentValue(value) {
      this.parentContainer.setValue(value || this.$el.value);
    },
    setParentDisabled: function setParentDisabled() {
      this.parentContainer.isDisabled = this.disabled;
    },
    setParentRequired: function setParentRequired() {
      this.parentContainer.isRequired = this.required;
    },
    setParentPlaceholder: function setParentPlaceholder() {
      this.parentContainer.hasPlaceholder = !!this.placeholder;
    },
    updateValues: function updateValues(value) {
      var newValue = value || this.$el.value || this.value;

      this.setParentValue(newValue);
      this.parentContainer.inputLength = newValue ? newValue.length : 0;
    },
    onFocus: function onFocus() {
      if (this.parentContainer) {
        this.parentContainer.isFocused = true;
      }
    },
    onBlur: function onBlur() {
      this.parentContainer.isFocused = false;
      this.setParentValue();
    },
    onInput: function onInput() {
      this.updateValues();
      this.$emit('change', this.$el.value);
      this.$emit('input', this.$el.value);
    }
  }
};

/***/ }),
/* 1013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_mdAutocomplete_scss_vue_type_style_index_0_lang_scss___ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_mdAutocomplete_scss_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_mdAutocomplete_scss_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_mdAutocomplete_scss_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 1014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_mdAutocomplete_vue_vue_type_style_index_1_lang_css___ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_mdAutocomplete_vue_vue_type_style_index_1_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_mdAutocomplete_vue_vue_type_style_index_1_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_mdAutocomplete_vue_vue_type_style_index_1_lang_css____default.a); 

/***/ }),
/* 1015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_InputMoneyOld_vue_vue_type_template_id_5940dc7e___ = __webpack_require__(1016);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_InputMoneyOld_vue_vue_type_template_id_5940dc7e___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_InputMoneyOld_vue_vue_type_template_id_5940dc7e___["b"]; });


/***/ }),
/* 1016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-input',{directives:[{name:"mask",rawName:"v-mask",value:('money'),expression:"'money'"}],class:_vm.inputClass,attrs:{"type":"text","disabled":_vm.disabled,"readonly":_vm.readonly,"required":_vm.required,"placeholder":_vm.placeholder,"maxlength":_vm.maxlength},nativeOn:{"change":function($event){return _vm.alteracao($event)},"blur":function($event){return _vm.consequencia($event)}},model:{value:(_vm.valor),callback:function ($$v) {_vm.valor=$$v},expression:"valor"}})}
var staticRenderFns = []



/***/ }),
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ModalVoltar_vue_vue_type_template_id_72de9d0e_lang_html___ = __webpack_require__(1021);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ModalVoltar_vue_vue_type_template_id_72de9d0e_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ModalVoltar_vue_vue_type_template_id_72de9d0e_lang_html___["b"]; });


/***/ }),
/* 1021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-dialog',{ref:"voltarDialog",attrs:{"md-open-from":"voltarDialog","md-close-to":"voltarDialog","mdClickOutsideToClose":_vm.mdClickOutsideToClose}},[_c('md-dialog-title',[_vm._v(_vm._s(_vm.$t('label.atencao')))]),_vm._v(" "),_c('md-dialog-content',[_c('label',[_vm._v(" "+_vm._s(_vm.$t('message.voltar_aviso'))+" ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',[_vm._v(" "+_vm._s(_vm.$t('message.voltar_deseja_salvar'))+" ")])]),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",nativeOn:{"click":function($event){return _vm.defaultActionSim($event)}}},[_vm._v("\n      "+_vm._s(_vm.$t('label.salvar'))+"\n    ")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary",nativeOn:{"click":function($event){return _vm.defaultActionNao($event)}}},[_vm._v("\n      "+_vm._s(_vm.$t('label.nao_salvar'))+"\n    ")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary",nativeOn:{"click":function($event){return _vm.defaultClose($event)}}},[_vm._v("\n      "+_vm._s(_vm.$t('label.cancelar'))+"\n    ")])],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AlcadaCadastro = __webpack_require__(1023);

var _AlcadaCadastro2 = _interopRequireDefault(_AlcadaCadastro);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  path: 'alcada',
  name: 'alcada',
  component: _AlcadaCadastro2.default
};

/***/ }),
/* 1023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AlcadaCadastro_vue_vue_type_template_id_0b04a82a_lang_html___ = __webpack_require__(1024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AlcadaCadastro_vue_vue_type_script_lang_js___ = __webpack_require__(313);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__AlcadaCadastro_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__AlcadaCadastro_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__AlcadaCadastro_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__AlcadaCadastro_vue_vue_type_template_id_0b04a82a_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__AlcadaCadastro_vue_vue_type_template_id_0b04a82a_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AlcadaCadastro_vue_vue_type_template_id_0b04a82a_lang_html___ = __webpack_require__(1025);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AlcadaCadastro_vue_vue_type_template_id_0b04a82a_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AlcadaCadastro_vue_vue_type_template_id_0b04a82a_lang_html___["b"]; });


/***/ }),
/* 1025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canAccessPage)?_c('div',[_c('v-row',[(!_vm.somenteLeitura)?_c('v-col',{attrs:{"cols":"12","md":"3"}},[_c('alcada-form',{ref:"alcadaForm",on:{"FORMULARIO_CADASTRO_ALCADA_SALVAR":_vm.onNovoAlcada,"FORMULARIO_CADASTRO_ALCADA_CANCELAR":_vm.onCancelar}})],1):_vm._e(),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":!_vm.somenteLeitura ? 9 : 12}},[_c('alcada-tabela',{ref:"alcadaTabela",staticClass:"CRUDGenerico__ContentTable",attrs:{"title":_vm.$tc('label.alcada', 2)},on:{"PESQUISA_ALCADA_EDITAR":_vm.onEditarAlcada}})],1)],1)],1):_vm._e()}
var staticRenderFns = []



/***/ }),
/* 1026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AlcadaForm_vue_vue_type_template_id_70a9bf1b_lang_html___ = __webpack_require__(1027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AlcadaForm_vue_vue_type_script_lang_js___ = __webpack_require__(315);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__AlcadaForm_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__AlcadaForm_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__AlcadaForm_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__AlcadaForm_vue_vue_type_template_id_70a9bf1b_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__AlcadaForm_vue_vue_type_template_id_70a9bf1b_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AlcadaForm_vue_vue_type_template_id_70a9bf1b_lang_html___ = __webpack_require__(1028);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AlcadaForm_vue_vue_type_template_id_70a9bf1b_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AlcadaForm_vue_vue_type_template_id_70a9bf1b_lang_html___["b"]; });


/***/ }),
/* 1028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{ref:"form",attrs:{"lazy-validation":""}},[_c('v-card',[_c('v-card-title',[_c('h2',{staticClass:"mb-0",staticStyle:{"font-size":"18px","width":"100%"}},[_vm._v(_vm._s(_vm.alcada.ehEdicao() ? _vm.$t('title.editar_alcada') : _vm.$t('title.cadastrar_nova_alcada')))])]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-xl":"","fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-autocomplete',{attrs:{"id":"alcada_fluxo","name":"alcada_fluxo","items":_vm.listaFluxos,"no-data-text":_vm.$tc('message.nenhum_registro', 1),"item-text":"nome","item-value":"id","rules":[_vm.rules.required],"label":((_vm.$tc('label.fluxo', 1)) + " *"),"clearable":"","return-object":""},model:{value:(_vm.alcada.fluxo),callback:function ($$v) {_vm.$set(_vm.alcada, "fluxo", $$v)},expression:"alcada.fluxo"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12"}},[_c('v-text-field',{staticClass:"Form-text__invalid",attrs:{"id":"alcada_descricao","name":"alcada_descricao","label":((_vm.$tc('label.descricao', 1)) + " *"),"counter":50,"maxlength":"50","rules":[_vm.rules.required]},model:{value:(_vm.alcada.descricao),callback:function ($$v) {_vm.$set(_vm.alcada, "descricao", $$v)},expression:"alcada.descricao"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12"}},[_c('v-switch',{staticClass:"mt-3",attrs:{"color":"primary","label":_vm.$t('label.sem_valor_final'),"disabled":false},model:{value:(_vm.alcada.indSemValorFim),callback:function ($$v) {_vm.$set(_vm.alcada, "indSemValorFim", $$v)},expression:"alcada.indSemValorFim"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","sm":"6"}},[_c('input-money',{attrs:{"label":("" + (_vm.$tc('label.valor_inicial', 1))),"required":true,"disabled":false},model:{value:(_vm.alcada.vlrLimiteInicial),callback:function ($$v) {_vm.$set(_vm.alcada, "vlrLimiteInicial", $$v)},expression:"alcada.vlrLimiteInicial"}})],1),_vm._v(" "),(!_vm.alcada.indSemValorFim)?_c('v-col',{attrs:{"cols":"12","sm":"6","md":"6"}},[_c('input-money',{attrs:{"label":("" + (_vm.$tc('label.valor_final', 1))),"rules":[_vm.rules.valorFinalMaiorInicial],"required":true,"disabled":false},model:{value:(_vm.alcada.vlrLimiteFinal),callback:function ($$v) {_vm.$set(_vm.alcada, "vlrLimiteFinal", $$v)},expression:"alcada.vlrLimiteFinal"}})],1):_vm._e(),_vm._v(" "),_c('v-col',{attrs:{"cols":"12"}},[_c('v-autocomplete',{attrs:{"id":"alcada_estrutura_usuario","name":"alcada_estrutura_usuario","items":_vm.listaEstruturaUsuarios,"no-data-text":_vm.$tc('message.nenhum_registro', 1),"item-text":"nomEstruturaUsuario","item-value":"id","rules":[_vm.rules.required],"label":((_vm.$tc('label.estrutura_usuario', 1)) + " *"),"clearable":"","return-object":""},model:{value:(_vm.alcada.estruturaUsuario),callback:function ($$v) {_vm.$set(_vm.alcada, "estruturaUsuario", $$v)},expression:"alcada.estruturaUsuario"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{nativeOn:{"click":function($event){return _vm.cancel($event)}}},[_vm._v(_vm._s(_vm.$t('label.cancelar')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.openSaveDialog($event)}}},[_vm._v(_vm._s(_vm.$t('label.salvar')))])],1)],1),_vm._v(" "),_c('confirm',{ref:"confirmDialog",attrs:{"message":_vm.dialog.content,"persistent":true},on:{"agree":function($event){return _vm.save()}}})],1)}
var staticRenderFns = []



/***/ }),
/* 1029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_InputMoney_vue_vue_type_template_id_0e8feb0a___ = __webpack_require__(1030);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_InputMoney_vue_vue_type_template_id_0e8feb0a___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_InputMoney_vue_vue_type_template_id_0e8feb0a___["b"]; });


/***/ }),
/* 1030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-input',{staticClass:"InputMoney v-text-field",class:{focused: _vm.focused, dirty: _vm.dirty, alignRight: _vm.alignRight},attrs:{"label":_vm.label,"rules":_vm.rules,"error-messages":_vm.validaCampo,"required":_vm.required,"disabled":_vm.disabled,"hint":_vm.hint,"persistent-hint":_vm.persistentHint,"dense":_vm.dense,"single-line":_vm.singleLine,"hide-details":_vm.hideDetails},model:{value:(_vm.valorInterno),callback:function ($$v) {_vm.valorInterno=$$v},expression:"valorInterno"}},[_c('money',_vm._b({attrs:{"id":_vm.id,"disabled":_vm.disabled},on:{"input":_vm.valorDinheiroAlterado},model:{value:(_vm.valorInterno),callback:function ($$v) {_vm.valorInterno=$$v},expression:"valorInterno"}},'money',_vm.money,false))],1)}
var staticRenderFns = []



/***/ }),
/* 1031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_InputMoney_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_InputMoney_vue_vue_type_style_index_0_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_InputMoney_vue_vue_type_style_index_0_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_InputMoney_vue_vue_type_style_index_0_lang_css____default.a); 

/***/ }),
/* 1032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AlcadaTabela_vue_vue_type_template_id_5022f620_lang_html___ = __webpack_require__(1033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AlcadaTabela_vue_vue_type_script_lang_js___ = __webpack_require__(321);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__AlcadaTabela_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__AlcadaTabela_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__AlcadaTabela_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__AlcadaTabela_vue_vue_type_template_id_5022f620_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__AlcadaTabela_vue_vue_type_template_id_5022f620_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AlcadaTabela_vue_vue_type_template_id_5022f620_lang_html___ = __webpack_require__(1034);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AlcadaTabela_vue_vue_type_template_id_5022f620_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AlcadaTabela_vue_vue_type_template_id_5022f620_lang_html___["b"]; });


/***/ }),
/* 1034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"card-size"},[_c('v-card-title',[_c('h2',{staticClass:"headline mb-0",domProps:{"textContent":_vm._s(_vm.title)}})]),_vm._v(" "),_c('v-container',{staticClass:"py-0",attrs:{"fluid":""}},[_c('v-row',[_c('v-spacer'),_vm._v(" "),(_vm.selected.length)?_c('v-btn',{staticClass:"mt-5 mr-3",attrs:{"text":"","icon":""},on:{"click":function($event){return _vm.dialogConfirmarInativacao()}}},[_c('v-icon',[_vm._v("block")])],1):_vm._e(),_vm._v(" "),_c('v-col',{staticClass:"mr-3 py-0",attrs:{"cols":"12","sm":"6","md":"3"}},[_c('v-text-field',{attrs:{"append-icon":"search","label":_vm.$t('label.pesquisar'),"single-line":"","clearable":"","hide-details":""},on:{"input":_vm.filtrar},model:{value:(_vm.searchQuery),callback:function ($$v) {_vm.searchQuery=$$v},expression:"searchQuery"}})],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.listaAlcadas,"show-select":"","item-key":"id","options":_vm.pagination,"server-items-length":_vm.totalPage,"no-data-text":_vm.$t('label.tabela_sem_conteudo'),"footer-props":{
        itemsPerPageOptions: [10, 25, 50],
      }},on:{"update:options":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"item.fluxo",fn:function(ref){
      var item = ref.item;
return [_vm._v("\n        "+_vm._s(item.fluxo.nome)+"\n      ")]}},{key:"item.nom_estrutura_usuario",fn:function(ref){
      var item = ref.item;
return [_vm._v("\n        "+_vm._s(item.estruturaUsuario.nomEstruturaUsuario)+"\n      ")]}},{key:"item.ind_ativo",fn:function(ref){
      var item = ref.item;
return [_vm._v("\n        "+_vm._s(item.indAtivo ? _vm.$t('label.sim') : _vm.$t('label.nao'))+"\n      ")]}},{key:"item.vlr_limite_inicial",fn:function(ref){
      var item = ref.item;
return [_vm._v("\n        "+_vm._s(_vm.convertToMoney(item.vlrLimiteInicial))+"\n      ")]}},{key:"item.vlr_limite_final",fn:function(ref){
      var item = ref.item;
return [_vm._v("\n        "+_vm._s(item.vlrLimiteFinal ? _vm.convertToMoney(item.vlrLimiteFinal) : '')+"\n      ")]}},{key:"item.acoes",fn:function(ref){
      var item = ref.item;
return [(!_vm.somenteLeitura)?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
      var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();return _vm.onEditarAlcada(item)}}},on),[_c('v-icon',[_vm._v("edit")])],1)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.editar')))])]):_vm._e()]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1),_vm._v(" "),_c('confirm',{ref:"dialogConfirmaInativacao",attrs:{"message":_vm.$t('message.deseja_ativar_inativar_registros', {quantidade: _vm.selected.length}),"persistent":true},on:{"agree":_vm.ativarInativarRegistros}})],1)}
var staticRenderFns = []



/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AnoFiscal = __webpack_require__(1036);

var _AnoFiscal2 = _interopRequireDefault(_AnoFiscal);

var _AnoFiscalPesquisar = __webpack_require__(1039);

var _AnoFiscalPesquisar2 = _interopRequireDefault(_AnoFiscalPesquisar);

var _AnoFiscalForm = __webpack_require__(1046);

var _AnoFiscalForm2 = _interopRequireDefault(_AnoFiscalForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  path: 'ano-fiscal',
  component: _AnoFiscal2.default,
  children: [{
    path: '',
    name: 'ano-fiscal',
    component: _AnoFiscalPesquisar2.default
  }, {
    path: ':tipo/novo',
    name: 'novoAnoFiscal',
    component: _AnoFiscalForm2.default
  }, {
    path: ':tipo/novo/fechar/:idAnoFechar',
    name: 'novoFecharAnoFiscal',
    component: _AnoFiscalForm2.default,
    props: {
      fecharDepoisSalvar: true
    }
  }]
};

/***/ }),
/* 1036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AnoFiscal_vue_vue_type_template_id_8ffe21de___ = __webpack_require__(1037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AnoFiscal_vue_vue_type_script_lang_js___ = __webpack_require__(323);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__AnoFiscal_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__AnoFiscal_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__AnoFiscal_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__AnoFiscal_vue_vue_type_template_id_8ffe21de___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__AnoFiscal_vue_vue_type_template_id_8ffe21de___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscal_vue_vue_type_template_id_8ffe21de___ = __webpack_require__(1038);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscal_vue_vue_type_template_id_8ffe21de___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscal_vue_vue_type_template_id_8ffe21de___["b"]; });


/***/ }),
/* 1038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canAccessPage)?_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c('router-view')],1):_vm._e()}
var staticRenderFns = []



/***/ }),
/* 1039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AnoFiscalPesquisar_vue_vue_type_template_id_1de785e2_lang_html___ = __webpack_require__(1040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AnoFiscalPesquisar_vue_vue_type_script_lang_js___ = __webpack_require__(325);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__AnoFiscalPesquisar_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__AnoFiscalPesquisar_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__AnoFiscalPesquisar_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__AnoFiscalPesquisar_vue_vue_type_template_id_1de785e2_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__AnoFiscalPesquisar_vue_vue_type_template_id_1de785e2_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalPesquisar_vue_vue_type_template_id_1de785e2_lang_html___ = __webpack_require__(1041);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalPesquisar_vue_vue_type_template_id_1de785e2_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalPesquisar_vue_vue_type_template_id_1de785e2_lang_html___["b"]; });


/***/ }),
/* 1041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canAccessPage)?_c('div',[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',{staticClass:"mb-3"},[_c('h3',{staticClass:"headline mb-0"},[_vm._v(_vm._s(_vm.$t('title.ano_fiscal')))])]),_vm._v(" "),_c('v-row',[_vm._l((_vm.tipos),function(item,i){return _c('v-col',{key:i,staticClass:"pa-3",attrs:{"cols":"12","sm":"6","md":"4","lg":"3"}},[_c('ano-fiscal-card',{attrs:{"tipo-verba":item,"habilitar-bloqueio":_vm.habilitarBloqueio,"habilitar-fechamento":_vm.habilitarFechamento,"habilitar-periodos-orcamento":_vm.habilitarPeriodosOrcamento}})],1)}),_vm._v(" "),(_vm.carregouTipos && (!_vm.tipos || _vm.tipos.length === 0))?_c('v-subheader',[_vm._v("\n        "+_vm._s(_vm.$t('message.necessario_parametrizacao_tipo_orcamento'))+"\n      ")]):_vm._e()],2)],1)],1):_vm._e()}
var staticRenderFns = []



/***/ }),
/* 1042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AnoFiscalCard_vue_vue_type_template_id_5fb8cdef_lang_html___ = __webpack_require__(1043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AnoFiscalCard_vue_vue_type_script_lang_js___ = __webpack_require__(327);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__AnoFiscalCard_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__AnoFiscalCard_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AnoFiscalCard_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(1045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__AnoFiscalCard_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__AnoFiscalCard_vue_vue_type_template_id_5fb8cdef_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__AnoFiscalCard_vue_vue_type_template_id_5fb8cdef_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalCard_vue_vue_type_template_id_5fb8cdef_lang_html___ = __webpack_require__(1044);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalCard_vue_vue_type_template_id_5fb8cdef_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalCard_vue_vue_type_template_id_5fb8cdef_lang_html___["b"]; });


/***/ }),
/* 1044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticStyle:{"width":"100%"}},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('h3',{staticClass:"headline mb-0 text-center",staticStyle:{"width":"100%"}},[_vm._v(_vm._s(_vm.tipoVerba.nome))])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-container',[_c('v-row',[_c('v-btn',{attrs:{"text":"","icon":"","disabled":!_vm.habilitarVoltar},on:{"click":_vm.voltarAno}},[_c('v-icon',[_vm._v("keyboard_arrow_left")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('span',{staticClass:"mt-2 title"},[_vm._v(_vm._s(_vm.anoFiscal.descricao))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"text":"","icon":"","disabled":!_vm.habilitarProximo},on:{"click":_vm.proximoAno}},[_c('v-icon',[_vm._v("keyboard_arrow_right")])],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),(!_vm.exibirNovo)?_c('v-container',{attrs:{"grid-list-xl":""}},[(_vm.mensagem)?_c('v-row',[_c('p',{staticClass:"text-center",staticStyle:{"color":"#EF5350"}},[_vm._v(_vm._s(_vm.mensagem))])]):_vm._e(),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"6"}},[_vm._v(_vm._s(_vm.$tc('label.data_inicio', 1))+":")]),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","sm":"6"}},[_vm._v(_vm._s(_vm.formatarData(_vm.anoFiscal.dataInicio)))])],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"6"}},[_vm._v(_vm._s(_vm.$tc('label.data_prevista_fim', 1))+":")]),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","sm":"6"}},[_vm._v(_vm._s(_vm.formatarData(_vm.anoFiscal.dataPrevistaFim)))])],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"6"}},[_vm._v(_vm._s(_vm.$tc('label.status', 1))+":")]),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","sm":"6"}},[_vm._v(_vm._s(_vm.traduzStatus))])],1)],1):_vm._e(),_vm._v(" "),(!_vm.exibirNovo)?_c('v-divider'):_vm._e(),_vm._v(" "),(_vm.exibirNovo)?_c('v-card-actions',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"v-btn__fab",attrs:{"fab":"","color":"primary"},on:{"click":function($event){return _vm.novo('novoAnoFiscal')}}},on),[_c('v-icon',[_vm._v("add")])],1)]}}],null,false,1821611701)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.novo')))])])],1)],1)],1)],1):_vm._e(),_vm._v(" "),(!_vm.exibirNovo)?_c('v-card-actions',[_c('v-row',{attrs:{"justify":"space-between"}},[(_vm.habilitarBloqueio && _vm.anoFiscalBloqueado && _vm.anoFiscalVigente)?_c('v-col',{staticClass:"text-center",attrs:{"cols":"3"}},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"v-btn__fab",attrs:{"fab":"","color":"primary","disabled":_vm.executandoProcedimento},on:{"click":function($event){return _vm.desbloquearAnoFiscal(_vm.tipoVerba.id, _vm.anoFiscal.id)}}},on),[_c('v-icon',[_vm._v("lock")])],1)]}}],null,false,1291674371)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.desbloquear')))])])],1):_vm._e(),_vm._v(" "),(_vm.habilitarBloqueio && !_vm.anoFiscalBloqueado && _vm.anoFiscalVigente)?_c('v-col',{staticClass:"text-center",attrs:{"cols":"3"}},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"v-btn__fab",attrs:{"fab":"","color":"primary","disabled":_vm.executandoProcedimento},on:{"click":function($event){return _vm.bloquearAnoFiscal(_vm.tipoVerba.id, _vm.anoFiscal.id)}}},on),[_c('v-icon',[_vm._v("lock_open")])],1)]}}],null,false,3048898650)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.bloquear')))])])],1):_vm._e(),_vm._v(" "),(_vm.habilitarFechamento && _vm.anoFiscalVigente)?_c('v-col',{staticClass:"text-center",attrs:{"cols":"3"}},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"v-btn__fab",attrs:{"fab":"","color":"primary","disabled":_vm.executandoProcedimento},on:{"click":function($event){return _vm.fecharConfirmacao(_vm.anoFiscal)}}},on),[_c('v-icon',[_vm._v("close")])],1)]}}],null,false,3385784356)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.fechar')))])])],1):_vm._e(),_vm._v(" "),_c('v-col',{staticClass:"text-center",attrs:{"cols":"3"}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-width":200,"left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var menu = ref.on;
return [_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var tooltip = ref.on;
return [_c('v-btn',_vm._g({staticClass:"v-btn__fab",attrs:{"fab":"","color":"primary"}},Object.assign({}, tooltip, menu)),[_c('v-icon',[_vm._v("date_range")])],1)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('title.periodo_planejamento')))])])]}}],null,false,3439415205)},[_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headersPeriodo,"items":_vm.anoFiscal.periodos,"no-data-text":_vm.$t('label.tabela_sem_conteudo'),"hide-default-footer":""},scopedSlots:_vm._u([{key:"item.dataInicio",fn:function(ref){
var item = ref.item;
return [_vm._v("\n              "+_vm._s(_vm.formatarData(item.dataInicio))+"\n            ")]}},{key:"item.dataFim",fn:function(ref){
var item = ref.item;
return [_vm._v("\n              "+_vm._s(_vm.formatarData(item.dataFim))+"\n            ")]}},(_vm.canPeriodoFiscal)?{key:"item.acoes",fn:function(ref){
var item = ref.item;
return [(_vm.periodoBloqueado(item.status) && _vm.periodoVigente(item.status))?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var tooltip = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":"","text":"","color":"accent","disabled":_vm.executandoProcedimento},on:{"click":function($event){return _vm.desbloquearPeriodo(_vm.tipoVerba.id, item.id)}}},Object.assign({}, tooltip)),[_c('v-icon',[_vm._v("lock")])],1)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.desbloquear')))])]):_vm._e(),_vm._v(" "),(!_vm.periodoBloqueado(item.status) && _vm.periodoVigente(item.status))?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var tooltip = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":"","text":"","color":"accent","disabled":_vm.executandoProcedimento},on:{"click":function($event){return _vm.bloquearPeriodo(_vm.tipoVerba.id, item.id)}}},Object.assign({}, tooltip)),[_c('v-icon',[_vm._v("lock_open")])],1)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.bloquear')))])]):_vm._e(),_vm._v(" "),(_vm.periodoVigente(item.status))?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var tooltip = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":"","text":"","color":"accent","disabled":_vm.executandoProcedimento},on:{"click":function($event){return _vm.fecharPeriodoConfirmacao(_vm.tipoVerba.id, item.id)}}},Object.assign({}, tooltip)),[_c('v-icon',[_vm._v("close")])],1)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.fechar')))])]):_vm._e()]}}:null],null,true)})],1)],1),_vm._v(" "),(_vm.habilitarPeriodosOrcamento)?_c('v-col',{staticClass:"text-center",attrs:{"cols":"3"}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-width":200,"left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var menu = ref.on;
return [_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var tooltip = ref.on;
return [_c('v-btn',_vm._g({staticClass:"v-btn__fab",attrs:{"fab":"","color":"primary","disabled":!_vm.anoFiscal.periodosOrcamento || _vm.anoFiscal.periodosOrcamento.length == 0}},Object.assign({}, tooltip, menu)),[_c('v-icon',[_vm._v("attach_money")])],1)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('title.periodo_orcamento')))])])]}}],null,false,2262394738)},[_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headersPeriodo,"items":_vm.anoFiscal.periodosOrcamento,"no-data-text":_vm.$t('label.tabela_sem_conteudo'),"hide-default-footer":""},scopedSlots:_vm._u([{key:"item.dataInicio",fn:function(ref){
var item = ref.item;
return [_vm._v("\n              "+_vm._s(_vm.formatarData(item.dataInicio))+"\n            ")]}},{key:"item.dataFim",fn:function(ref){
var item = ref.item;
return [_vm._v("\n              "+_vm._s(_vm.formatarData(item.dataFim))+"\n            ")]}},(_vm.canPeriodoFiscal)?{key:"item.acoes",fn:function(ref){
var item = ref.item;
return [(_vm.periodoBloqueado(item.status) && _vm.periodoVigente(item.status))?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var tooltip = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":"","text":"","color":"accent","disabled":_vm.executandoProcedimento},on:{"click":function($event){return _vm.desbloquearPeriodo(_vm.tipoVerba.id, item.id)}}},Object.assign({}, tooltip)),[_c('v-icon',[_vm._v("lock")])],1)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.desbloquear')))])]):_vm._e(),_vm._v(" "),(!_vm.periodoBloqueado(item.status) && _vm.periodoVigente(item.status))?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var tooltip = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":"","text":"","color":"accent","disabled":_vm.executandoProcedimento},on:{"click":function($event){return _vm.bloquearPeriodo(_vm.tipoVerba.id, item.id)}}},Object.assign({}, tooltip)),[_c('v-icon',[_vm._v("lock_open")])],1)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.bloquear')))])]):_vm._e(),_vm._v(" "),(_vm.periodoVigente(item.status))?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var tooltip = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":"","text":"","color":"accent","disabled":_vm.executandoProcedimento},on:{"click":function($event){return _vm.fecharPeriodoConfirmacao(_vm.tipoVerba.id, item.id)}}},Object.assign({}, tooltip)),[_c('v-icon',[_vm._v("close")])],1)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.fechar')))])]):_vm._e()]}}:null],null,true)})],1)],1):_vm._e()],1)],1):_vm._e(),_vm._v(" "),_c('confirm',{ref:"confirmDialog",attrs:{"message":_vm.message},on:{"agree":_vm.acaoFechar}})],1)}
var staticRenderFns = []



/***/ }),
/* 1045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalCard_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalCard_vue_vue_type_style_index_0_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalCard_vue_vue_type_style_index_0_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalCard_vue_vue_type_style_index_0_lang_css____default.a); 

/***/ }),
/* 1046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AnoFiscalForm_vue_vue_type_template_id_23448c57_lang_html___ = __webpack_require__(1047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AnoFiscalForm_vue_vue_type_script_lang_js___ = __webpack_require__(331);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__AnoFiscalForm_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__AnoFiscalForm_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__AnoFiscalForm_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__AnoFiscalForm_vue_vue_type_template_id_23448c57_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__AnoFiscalForm_vue_vue_type_template_id_23448c57_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalForm_vue_vue_type_template_id_23448c57_lang_html___ = __webpack_require__(1048);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalForm_vue_vue_type_template_id_23448c57_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalForm_vue_vue_type_template_id_23448c57_lang_html___["b"]; });


/***/ }),
/* 1048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{ref:"form",attrs:{"lazy-validation":""}},[_c('v-card',{staticClass:"elevation-1"},[_c('v-card-title',[_c('h3',{staticClass:"headline mb-0"},[_vm._v(_vm._s(_vm.$t('title.cadastrar_ano_fiscal')))])]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-xl":"","fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"6","md":"4"}},[_c('v-text-field',{staticStyle:{"font-weight":"bold"},attrs:{"id":"tipo","name":"tipo","label":_vm.$tc('label.verba', 1),"readonly":""},model:{value:(_vm.tipo.descricao),callback:function ($$v) {_vm.$set(_vm.tipo, "descricao", $$v)},expression:"tipo.descricao"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","sm":"6","md":"4"}},[_c('v-text-field',{attrs:{"id":"descricao_ano","name":"descricao_ano","label":((_vm.$t('label.descricao')) + " *"),"readonly":_vm.somenteLeitura,"counter":200,"maxlength":"200","rules":[_vm.rules.required]},model:{value:(_vm.anoFiscal.descricao),callback:function ($$v) {_vm.$set(_vm.anoFiscal, "descricao", $$v)},expression:"anoFiscal.descricao"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"6","md":"4"}},[_c('v-menu',{ref:"data_inicio_ano",attrs:{"close-on-content-click":false,"id":"dp_data_inicio_ano","name":"dp_data_inicio_ano","nudge-right":40,"transition":"scale-transition","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({ref:"dataInicioAno",staticClass:"Form-text__invalid",attrs:{"required":"","return-masked-value":true,"mask":"##-##-####","rules":[_vm.rules.required, _vm.rules.validDate],"label":((_vm.$t('label.data_inicio')) + " *"),"prepend-icon":"event","readonly":""},model:{value:(_vm.dataInicioFormatada),callback:function ($$v) {_vm.dataInicioFormatada=$$v},expression:"dataInicioFormatada"}},on))]}}]),model:{value:(_vm.menuDataInicio),callback:function ($$v) {_vm.menuDataInicio=$$v},expression:"menuDataInicio"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"pt-br","color":"primary"},on:{"input":function($event){_vm.menuDataInicio = false}},model:{value:(_vm.dataInicio),callback:function ($$v) {_vm.dataInicio=$$v},expression:"dataInicio"}})],1)],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","sm":"6","md":"4"}},[_c('v-text-field',{attrs:{"disabled":"","id":"data_fim_ano","name":"data_fim_ano","label":_vm.$t('label.data_prevista_fim'),"readonly":""},model:{value:(_vm.dataPrevistaFim),callback:function ($$v) {_vm.dataPrevistaFim=$$v},expression:"dataPrevistaFim"}})],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('ano-fiscal-periodos',{ref:"periodos",attrs:{"somenteLeitura":_vm.somenteLeitura,"periodos":_vm.periodos,"dataInicio":_vm.dataInicio},on:{"PERIODO_INCLUIDO_OU_EXCLUIDO":_vm.tratarAlteracaoPeriodo}}),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('ano-fiscal-periodos-orcamento',{ref:"periodosOrcamento",attrs:{"somenteLeitura":_vm.somenteLeitura,"periodos":_vm.periodosOrcamento,"dataInicio":_vm.dataInicio},on:{"PERIODO_INCLUIDO_OU_EXCLUIDO":_vm.tratarAlteracaoPeriodo,"SINCRONIZACAO_PERIODOS":_vm.sincronizacaoPeriodos}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{nativeOn:{"click":function($event){return _vm.cancel($event)}}},[_vm._v(_vm._s(_vm.$t('label.cancelar')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.validarAno($event)}}},[_vm._v(_vm._s(_vm.$t('label.salvar')))])],1)],1),_vm._v(" "),_c('confirm',{ref:"confirmDialog",attrs:{"message":_vm.$t('message.salvar_ano_fiscal')},on:{"agree":_vm.save}})],1)}
var staticRenderFns = []



/***/ }),
/* 1049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AnoFiscalPeriodos_vue_vue_type_template_id_2f8e17e6_lang_html___ = __webpack_require__(1050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AnoFiscalPeriodos_vue_vue_type_script_lang_js___ = __webpack_require__(333);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__AnoFiscalPeriodos_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__AnoFiscalPeriodos_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AnoFiscalPeriodos_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(1052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__AnoFiscalPeriodos_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__AnoFiscalPeriodos_vue_vue_type_template_id_2f8e17e6_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__AnoFiscalPeriodos_vue_vue_type_template_id_2f8e17e6_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalPeriodos_vue_vue_type_template_id_2f8e17e6_lang_html___ = __webpack_require__(1051);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalPeriodos_vue_vue_type_template_id_2f8e17e6_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalPeriodos_vue_vue_type_template_id_2f8e17e6_lang_html___["b"]; });


/***/ }),
/* 1051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card-title',[_c('h3',{staticClass:"title mb-0"},[_vm._v(_vm._s(_vm.$t('title.periodo_planejamento')))])]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-xl":"","fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"12","md":"8"}},[_c('v-text-field',{ref:"descricaoAnoPeriodo",attrs:{"id":"descricao_ano_periodo","name":"descricao_ano_periodo","label":((_vm.$t('label.descricao')) + " *"),"readonly":_vm.somenteLeitura,"counter":200,"maxlength":"200","rules":[_vm.rules.required]},model:{value:(_vm.periodo.descricao),callback:function ($$v) {_vm.$set(_vm.periodo, "descricao", $$v)},expression:"periodo.descricao"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"6","md":"4"}},[_c('v-menu',{ref:"ano_periodo_data_inicio",attrs:{"close-on-content-click":false,"id":"ano_periodo_data_inicio","name":"ano_periodo_data_inicio","nudge-right":40,"readonly":_vm.somenteLeitura,"transition":"scale-transition","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({ref:"anoPeriodoDataInicio",staticClass:"Form-text__invalid",attrs:{"required":"","return-masked-value":true,"mask":"##-##-####","rules":[_vm.rules.required, _vm.rules.validDate],"label":((_vm.$t('label.data_inicio')) + " *"),"prepend-icon":"event"},model:{value:(_vm.dataInicioFormatada),callback:function ($$v) {_vm.dataInicioFormatada=$$v},expression:"dataInicioFormatada"}},on))]}}]),model:{value:(_vm.menuDataInicio),callback:function ($$v) {_vm.menuDataInicio=$$v},expression:"menuDataInicio"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"pt-br","color":"primary","min":_vm.dataInicioPeriodo,"show-current":_vm.dataInicioPeriodo},on:{"input":function($event){_vm.menuDataInicio = false}},model:{value:(_vm.dataInicioPicker),callback:function ($$v) {_vm.dataInicioPicker=$$v},expression:"dataInicioPicker"}})],1)],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","sm":"6","md":"4"}},[_c('v-menu',{ref:"ano_periodo_data_fim",attrs:{"close-on-content-click":false,"id":"ano_periodo_data_fim","name":"ano_periodo_data_fim","nudge-right":40,"readonly":_vm.somenteLeitura,"transition":"scale-transition","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({ref:"anoPeriodoDataFim",staticClass:"Form-text__invalid",attrs:{"required":"","return-masked-value":true,"mask":"##-##-####","rules":[_vm.rules.required, _vm.rules.validDate],"label":((_vm.$t('label.data_fim')) + " *"),"prepend-icon":"event"},model:{value:(_vm.dataFimFormatada),callback:function ($$v) {_vm.dataFimFormatada=$$v},expression:"dataFimFormatada"}},on))]}}]),model:{value:(_vm.menuDataFim),callback:function ($$v) {_vm.menuDataFim=$$v},expression:"menuDataFim"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"pt-br","color":"primary","min":!!_vm.periodo.dataInicio ? _vm.periodo.dataInicio : _vm.dataInicioPeriodo,"show-current":_vm.periodo.dataInicio},on:{"input":function($event){_vm.menuDataFim = false}},model:{value:(_vm.dataFimPicker),callback:function ($$v) {_vm.dataFimPicker=$$v},expression:"dataFimPicker"}})],1)],1),_vm._v(" "),(!_vm.somenteLeitura)?_c('v-col',{attrs:{"cols":"12"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"id":"incluir_intervalo","color":"accent"},nativeOn:{"click":function($event){return _vm.incluirPeriodo($event)}}},[_vm._v(_vm._s(_vm.$t('label.incluir')))]),_vm._v(" "),(_vm.hasPeriodosSelecionados && !_vm.somenteLeitura)?_c('v-btn',{staticClass:"ml-2",attrs:{"id":"excluir_intervalo"},nativeOn:{"click":function($event){return _vm.remover($event)}}},[_vm._v(_vm._s(_vm.$t('label.excluir')))]):_vm._e()],1):_vm._e()],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.periodos,"item-key":"descricao","hide-default-footer":"","show-select":"","no-data-text":_vm.$t('label.tabela_sem_conteudo')},scopedSlots:_vm._u([{key:"item.dataInicio",fn:function(ref){
var item = ref.item;
return [_vm._v("\n      "+_vm._s(_vm.formatDateDDMMYYYY(item.dataInicio))+"\n    ")]}},{key:"item.dataFim",fn:function(ref){
var item = ref.item;
return [_vm._v("\n      "+_vm._s(_vm.formatDateDDMMYYYY(item.dataFim))+"\n    ")]}}]),model:{value:(_vm.periodosSelecionados),callback:function ($$v) {_vm.periodosSelecionados=$$v},expression:"periodosSelecionados"}})],1)}
var staticRenderFns = []



/***/ }),
/* 1052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalPeriodos_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalPeriodos_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalPeriodos_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalPeriodos_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 1053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AnoFiscalPeriodosOrcamento_vue_vue_type_template_id_8dbb9354_lang_html___ = __webpack_require__(1054);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AnoFiscalPeriodosOrcamento_vue_vue_type_script_lang_js___ = __webpack_require__(336);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__AnoFiscalPeriodosOrcamento_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__AnoFiscalPeriodosOrcamento_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AnoFiscalPeriodosOrcamento_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(1056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__AnoFiscalPeriodosOrcamento_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__AnoFiscalPeriodosOrcamento_vue_vue_type_template_id_8dbb9354_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__AnoFiscalPeriodosOrcamento_vue_vue_type_template_id_8dbb9354_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalPeriodosOrcamento_vue_vue_type_template_id_8dbb9354_lang_html___ = __webpack_require__(1055);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalPeriodosOrcamento_vue_vue_type_template_id_8dbb9354_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalPeriodosOrcamento_vue_vue_type_template_id_8dbb9354_lang_html___["b"]; });


/***/ }),
/* 1055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card-title',[_c('h3',{staticClass:"title mb-0",staticStyle:{"margin-right":"50px"}},[_vm._v(_vm._s(_vm.$t('title.periodo_orcamento')))]),_vm._v(" "),_c('v-switch',{attrs:{"label":_vm.$t('label.periodo_orcamentario_igual_planejamento')},on:{"change":_vm.changeIgualPlanejamento},model:{value:(_vm.igualAoPlanejamento),callback:function ($$v) {_vm.igualAoPlanejamento=$$v},expression:"igualAoPlanejamento"}})],1),_vm._v(" "),(!_vm.igualAoPlanejamento)?_c('v-container',{attrs:{"grid-list-xl":"","fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"12","md":"8"}},[_c('v-text-field',{ref:"descricaoAnoPeriodo",attrs:{"id":"descricao_ano_periodo_orcamento","name":"descricao_ano_periodo_orcamento","label":((_vm.$t('label.descricao')) + " *"),"readonly":_vm.somenteLeitura,"counter":200,"maxlength":"200","rules":[_vm.rules.required]},model:{value:(_vm.periodo.descricao),callback:function ($$v) {_vm.$set(_vm.periodo, "descricao", $$v)},expression:"periodo.descricao"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"6","md":"4"}},[_c('v-menu',{ref:"ano_periodo_data_inicio",attrs:{"close-on-content-click":false,"id":"ano_periodo_orcamento_data_inicio","name":"ano_periodo_orcamento_data_inicio","nudge-right":40,"readonly":_vm.somenteLeitura,"transition":"scale-transition","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({ref:"anoPeriodoDataInicio",staticClass:"Form-text__invalid",attrs:{"required":"","return-masked-value":true,"mask":"##-##-####","rules":[_vm.rules.required, _vm.rules.validDate],"label":((_vm.$t('label.data_inicio')) + " *"),"prepend-icon":"event"},model:{value:(_vm.dataInicioFormatada),callback:function ($$v) {_vm.dataInicioFormatada=$$v},expression:"dataInicioFormatada"}},on))]}}],null,false,2427074518),model:{value:(_vm.menuDataInicio),callback:function ($$v) {_vm.menuDataInicio=$$v},expression:"menuDataInicio"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"pt-br","color":"primary","min":_vm.dataInicioPeriodo,"show-current":_vm.dataInicioPeriodo},on:{"input":function($event){_vm.menuDataInicio = false}},model:{value:(_vm.dataInicioPicker),callback:function ($$v) {_vm.dataInicioPicker=$$v},expression:"dataInicioPicker"}})],1)],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","sm":"6","md":"4"}},[_c('v-menu',{ref:"ano_periodo_data_fim",attrs:{"close-on-content-click":false,"id":"ano_periodo_orcamento_data_fim","name":"ano_periodo_orcamento_data_fim","nudge-right":40,"readonly":_vm.somenteLeitura,"transition":"scale-transition","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({ref:"anoPeriodoDataFim",staticClass:"Form-text__invalid",attrs:{"required":"","return-masked-value":true,"mask":"##-##-####","rules":[_vm.rules.required, _vm.rules.validDate],"label":((_vm.$t('label.data_fim')) + " *"),"prepend-icon":"event"},model:{value:(_vm.dataFimFormatada),callback:function ($$v) {_vm.dataFimFormatada=$$v},expression:"dataFimFormatada"}},on))]}}],null,false,994457983),model:{value:(_vm.menuDataFim),callback:function ($$v) {_vm.menuDataFim=$$v},expression:"menuDataFim"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"pt-br","color":"primary","min":!!_vm.periodo.dataInicio ? _vm.periodo.dataInicio : _vm.dataInicioPeriodo,"show-current":_vm.periodo.dataInicio},on:{"input":function($event){_vm.menuDataFim = false}},model:{value:(_vm.dataFimPicker),callback:function ($$v) {_vm.dataFimPicker=$$v},expression:"dataFimPicker"}})],1)],1),_vm._v(" "),(!_vm.somenteLeitura)?_c('v-col',{attrs:{"cols":"12"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"id":"incluir_intervalo_orcamento","color":"accent"},nativeOn:{"click":function($event){return _vm.incluirPeriodo($event)}}},[_vm._v(_vm._s(_vm.$t('label.incluir')))]),_vm._v(" "),(_vm.hasPeriodosSelecionados && !_vm.somenteLeitura)?_c('v-btn',{attrs:{"id":"excluir_intervalo_orcamento"},nativeOn:{"click":function($event){return _vm.remover($event)}}},[_vm._v(_vm._s(_vm.$t('label.excluir')))]):_vm._e()],1):_vm._e()],1)],1):_vm._e(),_vm._v(" "),_c('confirm',{ref:"confirmDialog",attrs:{"message":_vm.dialog.content,"persistent":true},on:{"agree":function($event){return _vm.tratarPeriodosIguais()},"disagree":function($event){return _vm.reverterOpcao()}}}),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.periodos,"item-key":"descricao","hide-default-footer":"","show-select":"","no-data-text":_vm.$t('label.tabela_sem_conteudo')},scopedSlots:_vm._u([{key:"item.dataInicio",fn:function(ref){
var item = ref.item;
return [_vm._v("\n      "+_vm._s(_vm.formatDateDDMMYYYY(item.dataInicio))+"\n    ")]}},{key:"item.dataFim",fn:function(ref){
var item = ref.item;
return [_vm._v("\n      "+_vm._s(_vm.formatDateDDMMYYYY(item.dataFim))+"\n    ")]}}]),model:{value:(_vm.periodosSelecionados),callback:function ($$v) {_vm.periodosSelecionados=$$v},expression:"periodosSelecionados"}})],1)}
var staticRenderFns = []



/***/ }),
/* 1056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalPeriodosOrcamento_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalPeriodosOrcamento_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalPeriodosOrcamento_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_node_modules_vue_loader_lib_index_js_vue_loader_options_AnoFiscalPeriodosOrcamento_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var Apuracao = function Apuracao() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1656));
};

exports.default = {
  path: 'apuracao',
  name: 'apuracao',
  component: Apuracao
};

/***/ }),
/* 1058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_UploadFile_vue_vue_type_template_id_25e3d179_lang_html___ = __webpack_require__(1059);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_UploadFile_vue_vue_type_template_id_25e3d179_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_UploadFile_vue_vue_type_template_id_25e3d179_lang_html___["b"]; });


/***/ }),
/* 1059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:(_vm.id + "-" + (new Date().getTime()))},[(_vm.title)?_c('v-card-title',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),(_vm.subtitle)?_c('v-card-text',[_vm._v(_vm._s(_vm.subtitle))]):_vm._e(),_vm._v(" "),_c('v-container',[_c('dropzone',{attrs:{"id":_vm.id,"name":_vm.name,"accepted-file-types":_vm.acceptedFileTypes,"maxFileSizeInMB":_vm.maxFileSizeInMB,"maxNumberOfFiles":_vm.maxNumberOfFiles,"url":_vm.url,"numMaxArquivos":_vm.numMaxArquivos},on:{"UPLOADFILE_FILE_ADDED":_vm.fileAdded,"UPLOADFILE_FILE_REMOVED":_vm.fileRemoved,"UPLOADFILE_SUCCESS":_vm.uploadSuccess,"UPLOADFILE_ERROR":_vm.uploadError,"UPLOADFILE_SENDING":_vm.uploadSending}})],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Dropzone_vue_vue_type_template_id_4810c88c___ = __webpack_require__(1061);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Dropzone_vue_vue_type_template_id_4810c88c___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Dropzone_vue_vue_type_template_id_4810c88c___["b"]; });


/***/ }),
/* 1061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"entrypoint"},[_c('form',{staticClass:"dropzone",attrs:{"action":_vm.url,"name":"dropzone","id":_vm.id,"numMaxArquivos":_vm.numMaxArquivos}})])}
var staticRenderFns = []



/***/ }),
/* 1062 */,
/* 1063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_Dropzone_scss_vue_type_style_index_0_lang_scss___ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_Dropzone_scss_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_Dropzone_scss_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_Dropzone_scss_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 1064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetasCrescimento_vue_vue_type_template_id_6be13fe0___ = __webpack_require__(1065);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetasCrescimento_vue_vue_type_template_id_6be13fe0___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetasCrescimento_vue_vue_type_template_id_6be13fe0___["b"]; });


/***/ }),
/* 1065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{attrs:{"close-on-content-click":false,"nudge-width":400,"bottom":"","offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [(_vm.isActivatorInput)?_c('v-select',{staticClass:"select--sem--linha",attrs:{"items":_vm.items,"append-icon":"","label":_vm.$tc('label.meta', 1),"multiple":"","readonly":""},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var item = ref.item;
return [_c('v-icon',_vm._g({},on),[_vm._v(_vm._s(item))])]}}],null,true),model:{value:(_vm.item),callback:function ($$v) {_vm.item=$$v},expression:"item"}}):_c('v-btn',_vm._g({attrs:{"text":"","icon":""}},on),[_c('v-icon',[_vm._v(_vm._s(_vm.item))])],1)]}}]),model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_vm._v(" "),_c('v-card',[_c('v-data-table',{attrs:{"headers":_vm.headers(),"items":_vm.pendencia.metasCrescimento,"hide-default-footer":"","no-data-text":_vm.$t('label.tabela_sem_conteudo')},scopedSlots:_vm._u([{key:"item.meta_de",fn:function(ref){
var item = ref.item;
return [_c('span',{class:{ 'font-weight-bold': item.metaAlcancada }},[_vm._v(_vm._s(_vm.exibirMeta(item.metaDe || item.vlrMetaDe)))])]}},{key:"item.meta_ate",fn:function(ref){
var item = ref.item;
return [_c('span',{class:{ 'font-weight-bold': item.metaAlcancada }},[_vm._v(_vm._s(_vm.exibirMeta(item.metaAte || item.vlrMetaAte)))])]}},{key:"item.bonificacao_pagamento",fn:function(ref){
var item = ref.item;
return [_c('span',{class:{ 'font-weight-bold': item.metaAlcancada }},[_vm._v(_vm._s(_vm.exibirPagamento(item.pagamento || item.vlrPagamento)))])]}}])})],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_MetasCrescimento_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_MetasCrescimento_vue_vue_type_style_index_0_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_MetasCrescimento_vue_vue_type_style_index_0_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_MetasCrescimento_vue_vue_type_style_index_0_lang_css____default.a); 

/***/ }),
/* 1067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ExecucaoSidebar_vue_vue_type_template_id_68886914___ = __webpack_require__(1068);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ExecucaoSidebar_vue_vue_type_template_id_68886914___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ExecucaoSidebar_vue_vue_type_template_id_68886914___["b"]; });


/***/ }),
/* 1068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',{ref:"execucaoSidenav",attrs:{"absolute":"","temporary":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[(_vm.showImport && _vm.permiteUpload && _vm.canAccessUpload && _vm.tela === 'APURACAO')?_c('upload-file',{ref:"dropZoneExecucaoMetas",attrs:{"name":"execucao-metas-upload","id":_vm.uploadFileMetaDropzoneId,"title":_vm.$tc('label.executar_metas', 1),"upload-multiple":false,"maxFileSizeInMB":_vm.maxFileSizeInMB,"url":(_vm.importUrlExcucaoMetas + "=" + (this.idMeta)),"accepted-file-types":_vm.arquivosSuportados},on:{"UPLOADFILE_SUCCESS":_vm.uploadMetaSuccess,"UPLOADFILE_ERROR":_vm.uploadError}}):_vm._e(),_vm._v(" "),(_vm.showImport && _vm.permiteUpload && _vm.canAccessUpload && _vm.tela === 'NEGOCIACAO')?_c('upload-file',{ref:"dropZoneExecucaoMetas",attrs:{"name":"execucao-metas-upload","id":_vm.uploadFileMetaDropzoneId,"title":_vm.$tc('label.evidencias', 1),"upload-multiple":false,"maxFileSizeInMB":_vm.maxFileSizeInMB,"url":(_vm.importUrlExcucaoMetas + "=" + (this.idMeta)),"accepted-file-types":_vm.arquivosSuportados},on:{"UPLOADFILE_SUCCESS":_vm.uploadMetaSuccess,"UPLOADFILE_ERROR":_vm.uploadError}}):_vm._e(),_vm._v(" "),(_vm.showImport && _vm.canAccessDownload)?_c('md-table',[_c('md-table-header',[_c('md-table-row',[_c('md-table-head',[_vm._v(_vm._s(_vm.$t('label.arquivo')))]),_vm._v(" "),_c('md-table-head')],1)],1),_vm._v(" "),(_vm.evidencias)?_c('md-table-body',_vm._l((_vm.evidencias),function(row,index){return _c('md-table-row',{key:index},[_c('md-table-cell',{staticStyle:{"max-width":"145px","word-wrap":"break-word"}},[_vm._v(_vm._s(row.descricao))]),_vm._v(" "),_c('md-table-cell',{staticStyle:{"max-width":"110px"}},[(_vm.permiteDeletar)?_c('md-button',{staticClass:"md-icon-button",attrs:{"id":("remover-evidencia-" + index)},nativeOn:{"click":function($event){return _vm.openConfirmDialog(row)}}},[_c('md-icon',[_vm._v("delete")])],1):_vm._e(),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",attrs:{"id":("visualizar-evidencia-" + index)},nativeOn:{"click":function($event){return _vm.visualizarArquivo(row)}}},[_c('md-icon',[_vm._v("visibility")])],1)],1)],1)}),1):_vm._e(),_vm._v(" "),(!_vm.possuiEvidencias)?_c('md-table-body',[_c('md-table-row',[_c('md-table-cell',[_vm._v(_vm._s(_vm.$t('message.arqivos_execucao_inexistente')))])],1)],1):_vm._e()],1):_vm._e(),_vm._v(" "),_c('md-dialog',{ref:"confirmDialog",attrs:{"md-open-from":"confirmDialog","md-close-to":"confirmDialog"}},[_c('md-dialog-title',[_vm._v(_vm._s(_vm.$t('label.atencao')))]),_vm._v(" "),_c('md-dialog-content',[_vm._v(_vm._s(_vm.$t('message.remover_execucao')))]),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",nativeOn:{"click":function($event){return _vm.closeDialog('confirmDialog')}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.nao'))+"\n      ")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary",nativeOn:{"click":function($event){return _vm.closeDialog('confirmDialog', _vm.removerEvidencia)}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.sim'))+"\n      ")])],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_StatusPassos_vue_vue_type_template_id_17e9e3c3_lang_html___ = __webpack_require__(1070);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_StatusPassos_vue_vue_type_template_id_17e9e3c3_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_StatusPassos_vue_vue_type_template_id_17e9e3c3_lang_html___["b"]; });


/***/ }),
/* 1070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"width":"600","persistent":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"title",attrs:{"primary-title":""}},[_vm._v(_vm._s(_vm.titulo))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',{staticClass:"historico_card_text"},[_c('v-timeline',{staticClass:"ma-3",attrs:{"dense":""}},[(_vm.fluxoCopiado.cabecalhoFluxo)?_c('v-timeline-item',{attrs:{"color":_vm.colorPalette[0],"fill-dot":"","small":"","right":""}},[_c('v-card',{staticClass:"elevation-2"},[_c('v-card-title',{staticClass:"title historico_header"},[_vm._v(_vm._s(_vm.$t('label.solicitado_por') + ' ' + _vm.fluxoCopiado.cabecalhoFluxo.usuarioSolicitante.nome))]),_vm._v(" "),_c('v-card-text',[_c('v-container',[_c('v-row',[_c('span',[_c('b',[_vm._v(_vm._s(_vm.$t('label.descricao'))+": ")])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.fluxoCopiado.cabecalhoFluxo.descricao))])]),_vm._v(" "),_c('v-row',[_c('span',[_c('b',[_vm._v(_vm._s(_vm.$t('label.data_solicitacao'))+": ")])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.toDate(_vm.fluxoCopiado.cabecalhoFluxo.dtaSolicitacao)))])])],1)],1)],1)],1):_vm._e(),_vm._v(" "),_vm._l((_vm.fluxoCopiado.passos),function(item,index){return (_vm.exibePasso(item))?_c('v-timeline-item',{key:index,attrs:{"color":_vm.styles(item.statusPasso),"fill-dot":"","small":"","right":""}},[_c('template',{slot:"icon"},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('span',_vm._g({staticStyle:{"cursor":"default"}},on),[_vm._v("  ")])]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$tc(("status_entidade." + (item.statusPasso.toLowerCase())), 1)))])])],1),_vm._v(" "),_c('status-passos-item',{attrs:{"item":item,"cliente":_vm.fluxoCopiado.cliente}},[_c('historico-transferencia',{attrs:{"slot":"historico","passos-transferidos":_vm.passosTransferidos,"sequencia":item.sequencia,"cliente":_vm.source.cliente},slot:"historico"})],1)],2):_vm._e()})],2)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"text":"","color":"accent","text":""},on:{"click":_vm.close}},[_vm._v(_vm._s(_vm.$t('label.fechar')))])],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_StatusPassosItem_vue_vue_type_template_id_962171be___ = __webpack_require__(1072);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_StatusPassosItem_vue_vue_type_template_id_962171be___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_StatusPassosItem_vue_vue_type_template_id_962171be___["b"]; });


/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"elevation-2"},[_c('v-card-title',{staticClass:"title historico_header"},[(_vm.item.usuarioAprovador)?_c('div',{staticClass:"title"},[_vm._v("\n      "+_vm._s(_vm.$t('label.avaliado_por') + ' ' + _vm.item.usuarioAprovador.nome)+"\n      "),(_vm.item.idCondicional === 2)?_c('span',[_c('br'),_vm._v(_vm._s(_vm.cliente))]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.aguardandoAprovacao(_vm.item))?_c('div',{staticClass:"title"},[_vm._v("\n      "+_vm._s(_vm.$t('label.aprovadores'))+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.transferido(_vm.item))?_c('div',{staticClass:"title"},[_vm._v("\n      "+_vm._s(_vm.$t('label.aprovador_anterior'))+"\n    ")]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_vm._t("historico")],2),_vm._v(" "),_c('v-card-text',{staticClass:"historico_body"},[_c('v-container',[(_vm.aguardandoAprovacao(_vm.item) || _vm.transferido(_vm.item))?_c('v-row',[_c('v-list',{attrs:{"two-line":""}},[_vm._l((_vm.item.usuariosAprovadores.usuarios),function(usuario,uIndex){return _c('v-list-item',{key:usuario.id},[_c('v-list-item-avatar',[(uIndex === 0)?_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("person")]):_vm._e()],1),_vm._v(" "),_c('v-list-item-content',[(_vm.transferido(_vm.item) && _vm.item.idCondicional === 2)?_c('v-list-item-title',[_vm._v(_vm._s(_vm.item.usuarioTransferenciaPasso.usuarioCliente))]):_c('v-list-item-title',[_vm._v(_vm._s(usuario.nome))]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v(_vm._s(_vm.$tc('label.usuario', 1)))]),_vm._v(" "),(_vm.item.idCondicional === 2)?_c('v-list-item-subtitle',[_vm._v(_vm._s(_vm.cliente))]):_vm._e()],1)],1)}),_vm._v(" "),_vm._l((_vm.item.usuariosAprovadores.grupos),function(grupo,pIndex){return _c('v-list-item',{key:grupo.id},[_c('v-list-item-avatar',[(pIndex === 0)?_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("group_work")]):_vm._e()],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(grupo.nome))]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v(_vm._s(_vm.$tc('label.perfil', 1)))])],1)],1)}),_vm._v(" "),_vm._l((_vm.item.usuariosAprovadores.subgrupos),function(subgrupo,eIndex){return _c('v-list-item',{key:subgrupo.id},[_c('v-list-item-avatar',[(eIndex === 0)?_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("recent_actors")]):_vm._e()],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(subgrupo.nome))]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v(_vm._s(_vm.$tc('label.estrutura_usuario', 0)))])],1)],1)})],2)],1):_vm._e(),_vm._v(" "),(_vm.item.sla)?_c('v-row',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('span',[_c('b',[_vm._v(_vm._s(_vm.$t('label.sla'))+": ")])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.item.sla))])]):_vm._e(),_vm._v(" "),(_vm.transferido(_vm.item))?_c('v-row',[_c('span',[_c('b',[_vm._v(_vm._s(_vm.$t('label.transferido_por'))+": ")])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.item.usuarioTransferenciaPasso.usuarioTransferencia))])]):_vm._e(),_vm._v(" "),(_vm.transferido(_vm.item))?_c('v-row',[_c('span',[_c('b',[_vm._v(_vm._s(_vm.$t('label.data_transferencia'))+": ")])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.item.usuarioTransferenciaPasso.dtaTransferencia))])]):_vm._e(),_vm._v(" "),(!_vm.aguardandoAprovacao(_vm.item) && !_vm.transferido(_vm.item))?_c('v-row',[_c('span',[_c('b',[_vm._v(_vm._s(_vm.$t('label.data'))+": ")])]),_vm._v(" "),(_vm.item.dtaAvaliacao)?_c('span',[_vm._v(_vm._s(_vm.toDate(_vm.item.dtaAvaliacao)))]):_vm._e(),_vm._v(" "),(!_vm.item.dtaAvaliacao)?_c('span',[_vm._v(_vm._s(_vm.$t('label.data_indefinida')))]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.item.observacao)?_c('v-row',[_c('span',[_c('b',[_vm._v(_vm._s(_vm.$tc('label.observacao', 1))+": ")])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.item.observacao))])]):_vm._e(),_vm._v(" "),_vm._l((_vm.item.dados),function(dados,xIndex){return _c('v-row',{key:xIndex},[_c('span',[_vm._v(" "+_vm._s(dados)+" ")])])})],2)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HistoricoTransferencia_vue_vue_type_template_id_8efed64a___ = __webpack_require__(1074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HistoricoTransferencia_vue_vue_type_script_lang_js___ = __webpack_require__(355);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__HistoricoTransferencia_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__HistoricoTransferencia_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__HistoricoTransferencia_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__HistoricoTransferencia_vue_vue_type_template_id_8efed64a___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__HistoricoTransferencia_vue_vue_type_template_id_8efed64a___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_HistoricoTransferencia_vue_vue_type_template_id_8efed64a___ = __webpack_require__(1075);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_HistoricoTransferencia_vue_vue_type_template_id_8efed64a___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_HistoricoTransferencia_vue_vue_type_template_id_8efed64a___["b"]; });


/***/ }),
/* 1075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-menu',{attrs:{"close-on-content-click":false,"max-width":500,"min-width":500,"transition":"scale-transition","offset-x":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var menu = ref.on;
return [(_vm.seguenciaComPassoTransferido)?_c('v-tooltip',{attrs:{"left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var tooltip = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":"","text":"","color":"primary"}},Object.assign({}, tooltip, menu)),[_c('v-icon',[_vm._v("info")])],1)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.passo_transferido')))])]):_vm._e()]}}]),model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_vm._v(" "),_c('v-card',[_c('v-card-title',{staticClass:"title",attrs:{"primary-title":""}},[_vm._v(_vm._s(_vm.$t('title.transferencia_passo')))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-container',{staticClass:"historico_card_text",attrs:{"fluid":"","grid-list-lg":""}},[_c('v-row',_vm._l((_vm.passosTransferidosDaSequencia),function(item,index){return _c('v-col',{key:index,attrs:{"cols":"12"}},[_c('status-passos-item',{attrs:{"item":item,"cliente":_vm.cliente}})],1)}),1)],1)],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_StatusPassos_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_StatusPassos_vue_vue_type_style_index_0_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_StatusPassos_vue_vue_type_style_index_0_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_StatusPassos_vue_vue_type_style_index_0_lang_css____default.a); 

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ApuracoesVencidas = function ApuracoesVencidas() {
  return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 1657));
};
var ApuracoesVencidasList = function ApuracoesVencidasList() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1658));
};
var DetalhesNegociacao = function DetalhesNegociacao() {
  return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 711));
};

exports.default = {
  path: 'apuracoes-vencidas',
  component: ApuracoesVencidas,
  children: [{
    path: '',
    name: 'apuracoes-vencidas',
    component: ApuracoesVencidasList
  }, {
    path: 'detalhes/fixo/:id',
    name: 'verDetalhesFixo',
    component: DetalhesNegociacao,
    props: {
      tipoAcordo: 'FIXO',
      somenteLeitura: true,
      edicao: false,
      isApuracoesVencidas: true
    }
  }, {
    path: 'detalhes/tabloide/:id',
    name: 'verDetalhesTabloide',
    component: DetalhesNegociacao,
    props: {
      tipoAcordo: 'TABLOIDE',
      somenteLeitura: true,
      edicao: false,
      isApuracoesVencidas: true
    }
  }, {
    path: 'detalhes/negociacao_preco/:id',
    name: 'verDetalhesPreco',
    component: DetalhesNegociacao,
    props: {
      tipoAcordo: 'NEGOCIACAO_PRECO',
      somenteLeitura: true,
      edicao: false,
      isApuracoesVencidas: true
    }
  }, {
    path: 'detalhes/positivacao/:id',
    name: 'verDetalhesPositivacao',
    component: DetalhesNegociacao,
    props: {
      tipoAcordo: 'POSITIVACAO',
      somenteLeitura: true,
      edicao: false,
      isApuracoesVencidas: true
    }
  }, {
    path: 'detalhes/crescimento/:id',
    name: 'verDetalhesCrescimento',
    component: DetalhesNegociacao,
    props: {
      tipoAcordo: 'CRESCIMENTO',
      somenteLeitura: true,
      edicao: false,
      isApuracoesVencidas: true
    }
  }]
};

/***/ }),
/* 1078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GenericModal_vue_vue_type_template_id_2cf891ef_scoped_true_lang_html___ = __webpack_require__(1079);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GenericModal_vue_vue_type_template_id_2cf891ef_scoped_true_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GenericModal_vue_vue_type_template_id_2cf891ef_scoped_true_lang_html___["b"]; });


/***/ }),
/* 1079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":!_vm.mdClickOutsideToClose,"scrollable":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_vm._t("header",[(_vm.title)?_c('v-card-title',[_c('span',{staticClass:"headline",domProps:{"textContent":_vm._s(_vm.title)}})]):_vm._e()]),_vm._v(" "),_c('v-card-text',[_vm._t("body")],2),_vm._v(" "),_vm._t("footer",[_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),(_vm.close)?_c('v-btn',{attrs:{"color":"primary","text":""},nativeOn:{"click":function($event){return _vm.defaultClose($event)}}},[_vm._v(_vm._s(_vm.$t('label.cancelar')))]):_vm._e(),_vm._v(" "),(_vm.open)?_c('v-btn',{attrs:{"color":"primary","text":""},nativeOn:{"click":function($event){return _vm.defaultSave($event)}}},[_vm._v(_vm._s(_vm.$t(("label." + _vm.saveLabel))))]):_vm._e()],1)])],2)],1)}
var staticRenderFns = []



/***/ }),
/* 1080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_GenericModal_css_vue_type_style_index_0_id_2cf891ef_lang_css_scoped_true___ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_GenericModal_css_vue_type_style_index_0_id_2cf891ef_lang_css_scoped_true____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_GenericModal_css_vue_type_style_index_0_id_2cf891ef_lang_css_scoped_true___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_GenericModal_css_vue_type_style_index_0_id_2cf891ef_lang_css_scoped_true____default.a); 

/***/ }),
/* 1081 */,
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CarteiraCliente = __webpack_require__(1083);

var _CarteiraCliente2 = _interopRequireDefault(_CarteiraCliente);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CarteirasClientes = function CarteirasClientes() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 1659));
};

exports.default = {
  path: 'carteira-cliente',
  component: _CarteiraCliente2.default,
  children: [{
    path: '',
    name: 'carteira-cliente',
    component: CarteirasClientes
  }]
};

/***/ }),
/* 1083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CarteiraCliente_vue_vue_type_template_id_715e164b___ = __webpack_require__(1084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CarteiraCliente_vue_vue_type_script_lang_js___ = __webpack_require__(364);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__CarteiraCliente_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__CarteiraCliente_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__CarteiraCliente_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__CarteiraCliente_vue_vue_type_template_id_715e164b___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__CarteiraCliente_vue_vue_type_template_id_715e164b___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CarteiraCliente_vue_vue_type_template_id_715e164b___ = __webpack_require__(1085);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CarteiraCliente_vue_vue_type_template_id_715e164b___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CarteiraCliente_vue_vue_type_template_id_715e164b___["b"]; });


/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canAccessPage)?_c('v-slide-y-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1):_vm._e()}
var staticRenderFns = []



/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Calendario = __webpack_require__(1087);

var _Calendario2 = _interopRequireDefault(_Calendario);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  path: 'calendario',
  name: 'calendario',
  component: _Calendario2.default
};

/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Calendario_vue_vue_type_template_id_a8335104___ = __webpack_require__(1088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Calendario_vue_vue_type_script_lang_js___ = __webpack_require__(366);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__Calendario_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__Calendario_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Calendario_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(1104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Calendario_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__Calendario_vue_vue_type_template_id_a8335104___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Calendario_vue_vue_type_template_id_a8335104___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Calendario_vue_vue_type_template_id_a8335104___ = __webpack_require__(1089);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Calendario_vue_vue_type_template_id_a8335104___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Calendario_vue_vue_type_template_id_a8335104___["b"]; });


/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"persistent":"","max-width":"1200"},model:{value:(_vm.dialogForm),callback:function ($$v) {_vm.dialogForm=$$v},expression:"dialogForm"}},[(_vm.dialogForm)?_c('calendario-form',{attrs:{"id-evento":_vm.idEvento,"somente-leitura":!_vm.canAccessCRUD},on:{"cancelar":_vm.fecharForm,"atualizarGrid":_vm.buscar}}):_vm._e()],1),_vm._v(" "),_c('calendario-tabela',{ref:"tabela",attrs:{"somente-leitura":!_vm.canAccessCRUD},on:{"edit":_vm.edit}}),_vm._v(" "),(_vm.canAccessCRUD)?_c('v-btn',{staticClass:"Calendario__btn--floating__heigth",attrs:{"fixed":"","fab":"","bottom":"","right":"","color":"primary"},on:{"click":_vm.abrirForm}},[_c('v-icon',[_vm._v("add")])],1):_vm._e()],1)}
var staticRenderFns = []



/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CalendarioTabela_vue_vue_type_template_id_5015f734___ = __webpack_require__(1091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CalendarioTabela_vue_vue_type_script_lang_js___ = __webpack_require__(368);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__CalendarioTabela_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__CalendarioTabela_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CalendarioTabela_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(1093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__CalendarioTabela_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__CalendarioTabela_vue_vue_type_template_id_5015f734___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__CalendarioTabela_vue_vue_type_template_id_5015f734___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioTabela_vue_vue_type_template_id_5015f734___ = __webpack_require__(1092);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioTabela_vue_vue_type_template_id_5015f734___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioTabela_vue_vue_type_template_id_5015f734___["b"]; });


/***/ }),
/* 1092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{attrs:{"grid-list-xl":"","fluid":""}},[_c('v-row',{attrs:{"justify-end":""}},[_c('v-col',{attrs:{"cols":"12","sm":"6","md":"3"}},[_c('h3',{staticClass:"headline mb-0"},[_vm._v(_vm._s(_vm.$t('title.calendario')))])]),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","sm":"6","md":"3"}},[_c('v-switch',{attrs:{"color":"primary","append-icon":"search","label":_vm.$t('label.eventos_cancelados'),"single-line":"","hide-details":""},on:{"change":_vm.filtrar},model:{value:(_vm.indCancelado),callback:function ($$v) {_vm.indCancelado=$$v},expression:"indCancelado"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","sm":"6","md":"3"}},[_c('v-text-field',{attrs:{"append-icon":"search","label":_vm.$t('label.pesquisar'),"single-line":"","hide-details":""},on:{"input":_vm.filtrar},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","sm":"6","md":"3"}},[_c('v-menu',{ref:"mes_pesquisa",attrs:{"close-on-content-click":false,"id":"mes_pesquisa","name":"mes_pesquisa","nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({staticClass:"CalendarioTabela-data__text",attrs:{"return-masked-value":true,"mask":"##-####","rules":[_vm.rules.validDate],"label":_vm.$t('label.mes'),"prepend-icon":"event"},model:{value:(_vm.mesPesquisaFormatado),callback:function ($$v) {_vm.mesPesquisaFormatado=$$v},expression:"mesPesquisaFormatado"}},on))]}}]),model:{value:(_vm.menuMesPesquisa),callback:function ($$v) {_vm.menuMesPesquisa=$$v},expression:"menuMesPesquisa"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"pt-br","color":"primary","type":"month"},on:{"input":function($event){_vm.menuMesPesquisa = false}},model:{value:(_vm.mesPesquisa),callback:function ($$v) {_vm.mesPesquisa=$$v},expression:"mesPesquisa"}})],1)],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.eventos,"options":_vm.pagination,"server-items-length":_vm.totalPage,"no-data-text":_vm.$t('label.tabela_sem_conteudo'),"footer-props":{
      itemsPerPageOptions: [10, 25, 50],
    }},on:{"update:options":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"item.nome",fn:function(ref){
    var item = ref.item;
return [_vm._v(" "+_vm._s(item.nome))]}},{key:"item.descricao",fn:function(ref){
    var item = ref.item;
return [_vm._v(" "+_vm._s(item.descricao))]}},{key:"item.dataInicio",fn:function(ref){
    var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.convertDate(item.dataInicio)))]}},{key:"item.dataFim",fn:function(ref){
    var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.convertDate(item.dataFim)))]}},{key:"item.cancelamento",fn:function(ref){
    var item = ref.item;
return [(_vm.dataFimMaiorQueDataAtual(item) && !item.indCancelado)?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
    var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.cancelarItem(item)}}},on),[_c('v-icon',[_vm._v("cancel")])],1)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.cancelar')))])]):_vm._e()]}},{key:"pageText",fn:function(props){return [_vm._v("\n      "+_vm._s(props.pageStart)+" - "+_vm._s(props.pageStop)+" "+_vm._s(_vm.$tc('label.de', 1))+" "+_vm._s(props.itemsLength)+"\n    ")]}}])}),_vm._v(" "),_c('confirm',{ref:"cancelDialog",attrs:{"message":_vm.$t('message.deseja_cancelar_evento'),"persistent":true},on:{"disagree":_vm.cancelarAlteracaoStatus,"agree":_vm.cancelarEvento}}),_vm._v(" "),_c('confirm',{ref:"confirmDialog",attrs:{"message":_vm.$t('message.deseja_ativar_inativar'),"persistent":true},on:{"disagree":_vm.cancelarAlteracaoStatus,"agree":_vm.alterarStatus}})],1)}
var staticRenderFns = []



/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioTabela_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioTabela_vue_vue_type_style_index_0_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioTabela_vue_vue_type_style_index_0_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioTabela_vue_vue_type_style_index_0_lang_css____default.a); 

/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CalendarioForm_vue_vue_type_template_id_690d7618___ = __webpack_require__(1095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CalendarioForm_vue_vue_type_script_lang_js___ = __webpack_require__(371);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__CalendarioForm_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__CalendarioForm_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CalendarioForm_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(1097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__CalendarioForm_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__CalendarioForm_vue_vue_type_template_id_690d7618___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__CalendarioForm_vue_vue_type_template_id_690d7618___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioForm_vue_vue_type_template_id_690d7618___ = __webpack_require__(1096);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioForm_vue_vue_type_template_id_690d7618___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioForm_vue_vue_type_template_id_690d7618___["b"]; });


/***/ }),
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{ref:"form",attrs:{"lazy-validation":""}},[_c('v-card',[_c('v-card-title',[_c('h3',{staticClass:"headline mb-0"},[_vm._v(_vm._s(_vm.$t('title.calendario')))])]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-xl":"","fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"6","md":"4"}},[_c('v-text-field',{staticClass:"CalendarioForm-data__text",attrs:{"id":"nome","name":"nome","label":((_vm.$t('label.nome')) + " *"),"counter":50,"evento":"","rules":[_vm.rules.required, _vm.rules.maxLength50],"readonly":_vm.somenteLeitura},model:{value:(_vm.evento.nome),callback:function ($$v) {_vm.$set(_vm.evento, "nome", $$v)},expression:"evento.nome"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","sm":"6","md":"4"}},[_c('v-select',{staticClass:"CalendarioForm-data__text",attrs:{"items":_vm.tipos,"item-text":"descricao","item-value":"id","label":((_vm.$tc('label.tipo', 1)) + " *"),"rules":[_vm.rules.requiredTipo]},on:{"change":_vm.exibeObservacoes},model:{value:(_vm.evento.idTipo),callback:function ($$v) {_vm.$set(_vm.evento, "idTipo", $$v)},expression:"evento.idTipo"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","sm":"6","md":"4"}},[_c('v-menu',{ref:"data_inicio",attrs:{"close-on-content-click":false,"id":"data_inicio","name":"data_inicio","nudge-right":40,"lazy":"","readonly":_vm.somenteLeitura,"transition":"scale-transition","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({staticClass:"CalendarioForm-data__text",attrs:{"return-masked-value":true,"mask":"##-##-####","rules":[_vm.rules.required, _vm.rules.validDate, _vm.rules.dataInicioMenorQueDiaSeguinte],"label":((_vm.$t('label.data_inicio')) + " *"),"prepend-icon":"event"},model:{value:(_vm.dateInicioFormatada),callback:function ($$v) {_vm.dateInicioFormatada=$$v},expression:"dateInicioFormatada"}},on))]}}]),model:{value:(_vm.menuDataInicio),callback:function ($$v) {_vm.menuDataInicio=$$v},expression:"menuDataInicio"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"pt-br","color":"primary","min":_vm.dataDiaSeguinte},on:{"input":function($event){_vm.menuDataInicio = false}},model:{value:(_vm.dataInicio),callback:function ($$v) {_vm.dataInicio=$$v},expression:"dataInicio"}})],1)],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","sm":"6","md":"4"}},[_c('v-menu',{ref:"data_fim",attrs:{"close-on-content-click":false,"id":"data_fim","name":"data_fim","nudge-right":40,"lazy":"","readonly":_vm.somenteLeitura,"transition":"scale-transition","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({staticClass:"CalendarioForm-data__text",attrs:{"return-masked-value":true,"mask":"##-##-####","rules":[_vm.rules.required, _vm.rules.validDate, _vm.rules.dataFimMaiorInicio],"label":((_vm.$t('label.data_fim')) + " *"),"prepend-icon":"event"},model:{value:(_vm.dateFimFormatada),callback:function ($$v) {_vm.dateFimFormatada=$$v},expression:"dateFimFormatada"}},on))]}}]),model:{value:(_vm.menuDataFim),callback:function ($$v) {_vm.menuDataFim=$$v},expression:"menuDataFim"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"pt-br","color":"primary","min":_vm.dataInicio},on:{"input":function($event){_vm.menuDataFim = false}},model:{value:(_vm.dataFim),callback:function ($$v) {_vm.dataFim=$$v},expression:"dataFim"}})],1)],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"6","sm":"3","md":"2"}},[_c('v-menu',{ref:"cor",attrs:{"id":"cor","name":"cor","lazy":"","readonly":_vm.somenteLeitura,"transition":"scale-transition","max-width":"290px","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticStyle:{"width":"100%"},attrs:{"block":"","color":_vm.evento.cor,"dark":""}},on),[_vm._v("\n                "+_vm._s(_vm.$tc('label.cor', 1))+"\n              ")])]}}]),model:{value:(_vm.menuCor),callback:function ($$v) {_vm.menuCor=$$v},expression:"menuCor"}},[_vm._v(" "),_c('v-list',_vm._l((_vm.cores),function(item,i){return _c('v-list-item',{key:i,attrs:{"color":item},on:{"click":function () { return _vm.evento.cor = item; }}},[_c('v-card',{staticStyle:{"width":"100%"},attrs:{"dark":"","color":item}},[_c('v-card-text')],1)],1)}),1)],1)],1)],1),_vm._v(" "),_c('v-row',[(_vm.observacoes)?_c('v-col',[(_vm.observacoes.cabecalho)?_c('p',[_vm._v(_vm._s(_vm.observacoes.cabecalho))]):_vm._e(),_vm._v(" "),(_vm.observacoes.texto)?_c('p',[_vm._v(_vm._s(_vm.observacoes.texto))]):_vm._e(),_vm._v(" "),(_vm.observacoes.lista)?_c('ul',_vm._l((_vm.observacoes.lista),function(item){return _c('li',{key:item},[_vm._v("\n              "+_vm._s(item)+"\n            ")])}),0):_vm._e()]):_vm._e()],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{nativeOn:{"click":function($event){return _vm.cancelar($event)}}},[_vm._v(_vm._s(_vm.$t('label.cancelar')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.abrirDialogSalvar($event)}}},[_vm._v(_vm._s(_vm.$t('label.salvar')))])],1)],1),_vm._v(" "),_c('confirm',{ref:"confirmDialog",attrs:{"message":_vm.$t('message.deseja_salvar', {text: _vm.$t('label.data')}),"persistent":true},on:{"agree":_vm.salvar}})],1)}
var staticRenderFns = []



/***/ }),
/* 1097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioForm_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioForm_vue_vue_type_style_index_0_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioForm_vue_vue_type_style_index_0_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioForm_vue_vue_type_style_index_0_lang_css____default.a); 

/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CalendarioToolbar_vue_vue_type_template_id_4f841afb___ = __webpack_require__(1099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CalendarioToolbar_vue_vue_type_script_lang_js___ = __webpack_require__(374);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__CalendarioToolbar_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__CalendarioToolbar_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__CalendarioToolbar_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__CalendarioToolbar_vue_vue_type_template_id_4f841afb___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__CalendarioToolbar_vue_vue_type_template_id_4f841afb___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioToolbar_vue_vue_type_template_id_4f841afb___ = __webpack_require__(1100);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioToolbar_vue_vue_type_template_id_4f841afb___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioToolbar_vue_vue_type_template_id_4f841afb___["b"]; });


/***/ }),
/* 1100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canAccessView)?_c('v-menu',{attrs:{"close-on-content-click":false,"transition":"slide-x-transition","nudge-width":200,"offset-x":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"text":"","dark":"","icon":""}},on),[_c('v-icon',[_vm._v("today")])],1)]}}],null,false,4216167020),model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_vm._v(" "),(_vm.menu)?_c('calendario-card'):_vm._e()],1):_vm._e()}
var staticRenderFns = []



/***/ }),
/* 1101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CalendarioCard_vue_vue_type_template_id_02a1d97e___ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CalendarioCard_vue_vue_type_script_lang_js___ = __webpack_require__(376);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__CalendarioCard_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__CalendarioCard_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__CalendarioCard_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__CalendarioCard_vue_vue_type_template_id_02a1d97e___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__CalendarioCard_vue_vue_type_template_id_02a1d97e___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioCard_vue_vue_type_template_id_02a1d97e___ = __webpack_require__(1103);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioCard_vue_vue_type_template_id_02a1d97e___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CalendarioCard_vue_vue_type_template_id_02a1d97e___["b"]; });


/***/ }),
/* 1103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-date-picker',{attrs:{"locale":"pt-br","width":"500","landscape":"","events":_vm.ehEvento,"event-color":_vm.corDoEvento},on:{"update:pickerDate":_vm.alterarMes,"input":_vm.limparSelecao},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),(_vm.listaEventos && !!_vm.listaEventos.length)?_c('v-list',{staticStyle:{"max-height":"400px","overflow-y":"scroll"},attrs:{"two-line":""}},_vm._l((_vm.listaEventos),function(item,index){return _c('v-list-item',{key:index},[_c('v-list-item-avatar',[_c('v-avatar',{attrs:{"size":22,"color":item.cor}})],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(item.descricao)+" - "+_vm._s(item.nome))]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v(_vm._s(_vm.formatarData(item)))])],1)],1)}),1):_vm._e()],1)}
var staticRenderFns = []



/***/ }),
/* 1104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Calendario_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Calendario_vue_vue_type_style_index_0_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Calendario_vue_vue_type_style_index_0_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Calendario_vue_vue_type_style_index_0_lang_css____default.a); 

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CentroCusto = __webpack_require__(1106);

var _CentroCusto2 = _interopRequireDefault(_CentroCusto);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  path: 'centro-custo',
  name: 'centro-custo',
  component: _CentroCusto2.default
};

/***/ }),
/* 1106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CentroCusto_vue_vue_type_template_id_62d78af7_lang_html___ = __webpack_require__(1107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CentroCusto_vue_vue_type_script_lang_js___ = __webpack_require__(379);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__CentroCusto_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__CentroCusto_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__CentroCusto_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__CentroCusto_vue_vue_type_template_id_62d78af7_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__CentroCusto_vue_vue_type_template_id_62d78af7_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CentroCusto_vue_vue_type_template_id_62d78af7_lang_html___ = __webpack_require__(1108);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CentroCusto_vue_vue_type_template_id_62d78af7_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CentroCusto_vue_vue_type_template_id_62d78af7_lang_html___["b"]; });


/***/ }),
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CRUDGenerico__Wrapper"},[(_vm.canAccessPage)?_c('md-layout',{staticClass:"md-gutter-16",attrs:{"md-row":""}},[(_vm.canAccessCRUD)?_c('md-layout',{staticClass:"CRUDGenerico__SideMenu md-hide-medium",attrs:{"md-column":"","md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"100","md-flex-large":"20","md-flex-xlarge":"20"}},[_c('side-column',{attrs:{"fetch-function":_vm.centroCustoResources.listarAtivos,"fetchExtensaoFunction":_vm.extensaoResources.listarAtivos,"prepareResponseData":_vm.prepareResponseData},on:{"SIDECOLUMN_SAVE_ACTION":_vm.requestAdicionar}})],1):_vm._e(),_vm._v(" "),(_vm.canAccessCRUD)?_c('md-dialog',{ref:"dialog1",attrs:{"md-open-from":"#fab","md-close-to":"#fab"}},[_c('side-column',{attrs:{"fetch-function":_vm.centroCustoResources.listarAtivos,"prepareResponseData":_vm.prepareResponseData},on:{"SIDECOLUMN_CANCEL_ACTION":function($event){return _vm.closeDialog('dialog1')},"SIDECOLUMN_SAVE_ACTION":_vm.closeDialogSave}})],1):_vm._e(),_vm._v(" "),_c('md-layout',{staticClass:"CRUDGenerico__TableWrapper",attrs:{"md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"100","md-flex-large":"80","md-flex-xlarge":"80"}},[_c('centro-custo-tabela',{ref:"centroCustoTabela",staticClass:"CRUDGenerico__ContentTable",attrs:{"title":_vm.$t('label.centro_custo'),"table-rows":_vm.tableRows,"table-header":_vm.tableHeader,"fetchExtensaoFunction":_vm.extensaoResources.listarAtivos,"prepareResponseData":_vm.prepareResponseData,"visible-columns":['idExterno', 'nome', 'unidadeNegocio', 'canais', 'marcas', 'indCliente', 'indProduto'],"mobile-invisible-columns":['dependencias'],"ignore-columns":['id', 'idNivelExtensao'],"registros":_vm.tableRows,"paginas":_vm.paginas,"carregando":_vm.carregando},on:{"TABELAGENERICA_ATUALIZAR":_vm.requestAtualizar,"TABELA_BUSCAR_PROXIMA_PAGINA":_vm.requestPopular,"TABELAGENERICA_EXPORTAR_DADOS":_vm.requestExportacao,"TABELAGENERICA_ORDENAR":_vm.organizar,"TABELA_FILTRAR_PAGINA":_vm.filtrar,"TABELA_FILTRAR_STATUS":_vm.filtrarPorStatus,"PAGINACAO_ALTERANDO_TAMANHO_PAGINA":_vm.alterarTamanhoPagina,"TABELAGENERICA_BLOQUEAR_SELECIONADOS":_vm.ativarInativar}})],1)],1):_vm._e(),_vm._v(" "),(_vm.canAccessCRUD)?_c('md-button',{staticClass:"md-fab md-fab-bottom-right md-hide-large-and-up",staticStyle:{"position":"fixed","z-index":"5"},attrs:{"id":"fab"},nativeOn:{"click":function($event){return _vm.openDialog('dialog1')}}},[_c('md-icon',[_vm._v("add")])],1):_vm._e()],1)}
var staticRenderFns = []



/***/ }),
/* 1109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SideColumn_vue_vue_type_template_id_6b6f20ab_lang_html___ = __webpack_require__(1110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SideColumn_vue_vue_type_script_lang_js___ = __webpack_require__(381);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__SideColumn_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__SideColumn_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__SideColumn_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__SideColumn_vue_vue_type_template_id_6b6f20ab_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__SideColumn_vue_vue_type_template_id_6b6f20ab_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SideColumn_vue_vue_type_template_id_6b6f20ab_lang_html___ = __webpack_require__(1111);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SideColumn_vue_vue_type_template_id_6b6f20ab_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SideColumn_vue_vue_type_template_id_6b6f20ab_lang_html___["b"]; });


/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-card',[(_vm.canAccessCRUD)?_c('register-form',{attrs:{"title":_vm.$t('title.cadastrar_novo_centro_custo'),"cancel":_vm.cancel,"save":_vm.openSaveDialog}},[_c('div',{attrs:{"slot":"content"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.openSaveDialog(_vm.dialog.ref, 'saveRegisterFromButton')}},slot:"content"},[_c('md-layout',[_c('md-switch',{staticClass:"md-primary",attrs:{"tabindex":"1","id":"centroCusto_indCliente","name":"centroCusto_indCliente"},model:{value:(_vm.centroCusto.indCliente),callback:function ($$v) {_vm.$set(_vm.centroCusto, "indCliente", $$v)},expression:"centroCusto.indCliente"}},[_vm._v("\n          "+_vm._s(_vm.$tc('label.cliente', 1))+"\n        ")])],1),_vm._v(" "),_c('md-layout',[_c('md-switch',{staticClass:"md-primary",attrs:{"tabindex":"2","id":"centroCusto_indProduto","name":"centroCusto_indProduto"},model:{value:(_vm.centroCusto.indProduto),callback:function ($$v) {_vm.$set(_vm.centroCusto, "indProduto", $$v)},expression:"centroCusto.indProduto"}},[_vm._v("\n          "+_vm._s(_vm.$tc('label.produto', 1))+"\n        ")])],1),_vm._v(" "),_c('md-input-container',{ref:"containerIdExterno",class:{
          'md-input-invalid': _vm.errors.has('centroCusto_code')
        }},[_c('label',[_vm._v(_vm._s(_vm.$t('label.cod_centro_custo')))]),_vm._v(" "),_c('md-input',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"type":"text","required":"","tabindex":"3","name":"centroCusto_code","data-vv-name":"centroCusto_code","data-vv-rules":"required","maxlength":"10"},model:{value:(_vm.centroCusto.idExterno),callback:function ($$v) {_vm.$set(_vm.centroCusto, "idExterno", $$v)},expression:"centroCusto.idExterno"}}),_vm._v(" "),_c('span',{staticClass:"md-error"},[_vm._v("\n          "+_vm._s(_vm.errors.first('centroCusto_code'))+"\n        ")])],1),_vm._v(" "),_c('md-input-container',{ref:"containerNome",class:{
          'md-input-invalid': _vm.errors.has('centroCusto_nome')
        }},[_c('label',[_vm._v(_vm._s(_vm.$t('label.nome')))]),_vm._v(" "),_c('md-input',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"type":"text","tabindex":"4","id":"centroCusto_nome","name":"centroCusto_nome","required":"","data-vv-name":"centroCusto_nome","data-vv-rules":"required","maxlength":"100"},model:{value:(_vm.centroCusto.nome),callback:function ($$v) {_vm.$set(_vm.centroCusto, "nome", $$v)},expression:"centroCusto.nome"}}),_vm._v(" "),_c('span',{staticClass:"md-error"},[_vm._v("\n          "+_vm._s(_vm.errors.first('centroCusto_nome'))+"\n        ")])],1),_vm._v(" "),_c('md-input-container',{class:{
          'md-input-invalid': _vm.errors.has('centroCusto_unidadeNegocio')
        }},[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.$tc('label.unidade_negocio', 1)))]),_vm._v(" "),_c('md-autocomplete',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"tabindex":"5","id":"centroCusto_unidadeNegocio","name":"centroCusto_unidadeNegocio","required":"","data-vv-name":"centroCusto_unidadeNegocio","data-vv-rules":"required","fetch":_vm.fetchSuperiorUnidadeNegocioFunction(),"min-chars":1,"prepareResponseData":_vm.prepareResponseData,"printAttribute":"nomExtensao"},on:{"selected":_vm.setUnidadeNegocio},model:{value:(_vm.centroCusto.dependencias.unidadeNegocio.nomExtensao),callback:function ($$v) {_vm.$set(_vm.centroCusto.dependencias.unidadeNegocio, "nomExtensao", $$v)},expression:"centroCusto.dependencias.unidadeNegocio.nomExtensao"}}),_vm._v(" "),_c('md-icon',{staticStyle:{"cursor":"pointer"},attrs:{"md-autocomplete-search":""}},[_vm._v("search")]),_vm._v(" "),_c('span',{staticClass:"md-error"},[_vm._v("\n          "+_vm._s(_vm.errors.first('centroCusto_unidadeNegocio'))+"\n        ")])],1),_vm._v(" "),(this.centroCusto.indProduto)?_c('md-input-container',{class:{
          'md-input-invalid': _vm.errors.has('centroCusto_marcas')
        }},[_c('md-chips-autocomplete',{directives:[{name:"validate",rawName:"v-validate"}],ref:"marcaAutoComplete",attrs:{"tabindex":"6","id":"centroCusto_marcas","name":"centroCusto_marcas","required":"","data-vv-name":"centroCusto_marcas","data-vv-rules":"required","fetch":_vm.fetchSuperiorMarcaFunction(),"min-chars":1,"mdInputPlaceholder":_vm.$t('label.marca'),"prepareResponseData":_vm.prepareResponseData,"printAttribute":"nomExtensao"},on:{"change":_vm.addMarcaChip},model:{value:(_vm.centroCusto.dependencias.marcas),callback:function ($$v) {_vm.$set(_vm.centroCusto.dependencias, "marcas", $$v)},expression:"centroCusto.dependencias.marcas"}}),_vm._v(" "),_c('span',{staticClass:"md-error"},[_vm._v("\n          "+_vm._s(_vm.errors.first('centroCusto_marcas'))+"\n        ")])],1):_vm._e(),_vm._v(" "),(this.centroCusto.indCliente)?_c('md-input-container',{class:{
          'md-input-invalid': _vm.errors.has('centroCusto_canais')
        }},[_c('md-chips-autocomplete',{directives:[{name:"validate",rawName:"v-validate"}],ref:"canalAutoComplete",attrs:{"tabindex":"7","id":"centroCusto_canais","name":"centroCusto_canais","required":"","data-vv-name":"centroCusto_canais","data-vv-rules":"required","fetch":_vm.fetchSuperiorCanalFunction(),"min-chars":1,"mdInputPlaceholder":_vm.$t('label.canal'),"prepareResponseData":_vm.prepareResponseData,"printAttribute":"nomExtensao"},on:{"change":_vm.addCanalChip},model:{value:(_vm.centroCusto.dependencias.canais),callback:function ($$v) {_vm.$set(_vm.centroCusto.dependencias, "canais", $$v)},expression:"centroCusto.dependencias.canais"}}),_vm._v(" "),_c('span',{staticClass:"md-error"},[_vm._v("\n          "+_vm._s(_vm.errors.first('centroCusto_canais'))+"\n        ")])],1):_vm._e()],1)]):_vm._e(),_vm._v(" "),_c('md-dialog',{ref:_vm.dialog.ref,attrs:{"md-open-from":("#" + (_vm.dialog.from)),"md-close-to":("#" + (_vm.dialog.from))}},[_c('md-dialog-title',[_vm._v(_vm._s(_vm.dialog.title))]),_vm._v(" "),_c('md-dialog-content',[_vm._v(_vm._s(_vm.dialog.content))]),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",attrs:{"id":"tipoOrcamento-side-dialog-button-cancel","disabled":_vm.disableButton},nativeOn:{"click":function($event){return _vm.closeDialog('dialog1')}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.cancelar'))+"\n      ")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary",attrs:{"id":"tipoOrcamento-side-dialog-button-save","disabled":_vm.disableButton},nativeOn:{"click":function($event){return _vm.closeDialog('dialog1', _vm.dialog.action)}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.sim'))+"\n      ")])],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_mdChipsAutocomplete_vue_vue_type_template_id_31514c06_lang_html___ = __webpack_require__(1113);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_mdChipsAutocomplete_vue_vue_type_template_id_31514c06_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_mdChipsAutocomplete_vue_vue_type_template_id_31514c06_lang_html___["b"]; });


/***/ }),
/* 1113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-chips md-chips-autocomplete",class:[_vm.themeClass, _vm.classes],on:{"focus":_vm.onFocus,"blur":_vm.onBlur}},[_c('md-layout',{attrs:{"md-column":""}},[_c('label',{class:_vm.selectedChips.length ? 'md-chips-autocomplete-has-value' : ''},[_vm._v(" "+_vm._s(_vm.mdInputPlaceholder))]),_vm._v(" "),_c('md-layout',{attrs:{"md-row":""}},[(_vm.selectedChips)?_c('md-layout',{staticStyle:{"max-width":"100%"},attrs:{"md-flex":"100"}},_vm._l((_vm.selectedChips),function(chip,index){return _c('md-chip',{key:index,staticStyle:{"margin-top":"10px"},attrs:{"md-deletable":!_vm.mdStatic,"disabled":_vm.disabled},on:{"delete":function($event){return _vm.deleteChip(chip)}}},[_c('span',{domProps:{"textContent":_vm._s(_vm.textoChip(chip))}})])}),1):_vm._e(),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"100"}},[_c('md-autocomplete',{ref:"autocomplete",staticClass:"md-chips-autocomplete",attrs:{"debounce":_vm.debounce,"disabled":_vm.disabled,"required":_vm.required,"list":_vm.list,"filterList":_vm.filterList,"id":_vm.inputId,"fetch":_vm.fetch,"identifier":_vm.identifier,"chips":_vm.selectedChips,"prepareResponseData":_vm.prepareResponseData,"printAttribute":_vm.printAttribute,"printFunction":_vm.printFunction,"queryParam":_vm.queryParam,"extensao":_vm.extensao},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.stopPropagation();return _vm.addChip($event)},"selected":_vm.addChip,"addExtension":_vm.addExtension},model:{value:(_vm.currentChip),callback:function ($$v) {_vm.currentChip=$$v},expression:"currentChip"}})],1),_vm._v(" "),_c('md-layout',{attrs:{"md-align":"end"}},[_c('md-icon',{staticStyle:{"cursor":"pointer","position":"absolute"},attrs:{"md-autocomplete-search":""}},[_vm._v("search")])],1)],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    mdTheme: String
  },
  data: function data() {
    return {
      closestThemedParent: false
    };
  },
  methods: {
    getClosestThemedParent: function getClosestThemedParent($parent) {
      if (!$parent || !$parent.$el || $parent._uid === 0) {
        return false;
      }

      if ($parent.mdTheme || $parent.mdName) {
        return $parent;
      }

      return this.getClosestThemedParent($parent.$parent);
    }
  },
  computed: {
    themeClass: function themeClass() {
      if (this.mdTheme) {
        return 'md-theme-' + this.mdTheme;
      }

      var theme = this.closestThemedParent.mdTheme;

      if (!theme) {
        theme = this.closestThemedParent ? this.closestThemedParent.mdName : this.$material.currentTheme;
      }

      return 'md-theme-' + theme;
    }
  },
  mounted: function mounted() {
    this.closestThemedParent = this.getClosestThemedParent(this.$parent);

    if (!this.$material.currentTheme) {
      this.$material.setCurrentTheme('default');
    }
  }
};

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var uniqueId = function uniqueId() {
  return Math.random().toString(36).slice(4);
};

exports.default = uniqueId;

/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_mdChipsAutocomplete_scss_vue_type_style_index_0_lang_scss___ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_mdChipsAutocomplete_scss_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_mdChipsAutocomplete_scss_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_mdChipsAutocomplete_scss_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 1117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_mdChipsAutocomplete_vue_vue_type_style_index_1_lang_css___ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_mdChipsAutocomplete_vue_vue_type_style_index_1_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_mdChipsAutocomplete_vue_vue_type_style_index_1_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_mdChipsAutocomplete_vue_vue_type_style_index_1_lang_css____default.a); 

/***/ }),
/* 1118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CentroCustoTabela_vue_vue_type_template_id_89ee37b4_lang_html___ = __webpack_require__(1119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CentroCustoTabela_vue_vue_type_script_lang_js___ = __webpack_require__(387);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__CentroCustoTabela_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__CentroCustoTabela_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_generico_Pagination_css_vue_type_style_index_0_lang_css___ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CentroCustoTabela_vue_vue_type_style_index_1_lang_css___ = __webpack_require__(1121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);







/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_4__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__CentroCustoTabela_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__CentroCustoTabela_vue_vue_type_template_id_89ee37b4_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__CentroCustoTabela_vue_vue_type_template_id_89ee37b4_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CentroCustoTabela_vue_vue_type_template_id_89ee37b4_lang_html___ = __webpack_require__(1120);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CentroCustoTabela_vue_vue_type_template_id_89ee37b4_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CentroCustoTabela_vue_vue_type_template_id_89ee37b4_lang_html___["b"]; });


/***/ }),
/* 1120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"tabindex":"100"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.preventDefault();return _vm.onArrowUpPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.preventDefault();return _vm.onArrowDownPress($event)}]}},[_c('md-dialog',{ref:_vm.dialog.ref,attrs:{"md-open-from":("#" + (_vm.dialog.from))}},[_c('md-dialog-title',[_vm._v(_vm._s(_vm.dialog.title))]),_vm._v(" "),_c('md-dialog-content',[_vm._v(_vm._s(_vm.dialog.content))]),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",attrs:{"id":"centroCusto-table-dialog-button-cancel"},nativeOn:{"click":function($event){return _vm.closeDialog('dialog1')}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.cancelar'))+"\n      ")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary",attrs:{"id":"centroCusto-table-dialog-button-save"},nativeOn:{"click":function($event){return _vm.closeDialog('dialog1', _vm.dialog.action)}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.sim'))+"\n      ")])],1)],1),_vm._v(" "),(_vm.isHeaderAvailable)?_c('md-table-card',[_c('md-toolbar',[_c('h1',{staticClass:"md-title",domProps:{"textContent":_vm._s(_vm.title)}}),_vm._v(" "),_c('div',{staticClass:"status-filter-container"},[_c('md-input-container',[_c('md-select',{staticClass:"TabelaGenerica__Filters__Select md-hide-medium",staticStyle:{"border-bottom":"1px solid #070707"},on:{"change":_vm.handleStatusFilterChange},model:{value:(_vm.statusFilter),callback:function ($$v) {_vm.statusFilter=$$v},expression:"statusFilter"}},[_c('md-option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.$t('label.todos')))]),_vm._v(" "),_c('md-option',{attrs:{"value":"true"}},[_vm._v(_vm._s(_vm.$t('label.ativos')))]),_vm._v(" "),_c('md-option',{attrs:{"value":"false"}},[_vm._v(_vm._s(_vm.$t('label.inativos')))])],1)],1)],1),_vm._v(" "),_c('md-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.canAccessCRUD),expression:"canAccessCRUD"}],staticClass:"md-icon-button",attrs:{"id":"centroCusto-table-button-export"},nativeOn:{"click":function($event){return _vm.exportData($event)}}},[_c('md-icon',[_vm._v("get_app")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"top"}},[_vm._v(_vm._s(_vm.$t('label.exportar_conteudo')))])],1),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",attrs:{"id":"centroCusto-table-button-search"},nativeOn:{"click":function($event){return _vm.focusSearchInput('centroCusto-table-input-search')}}},[_c('md-icon',[_vm._v("search")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"top"}},[_vm._v(_vm._s(_vm.$t('label.buscar')))])],1),_vm._v(" "),_c('md-select',{staticClass:"TabelaGenerica__Filters__Select md-hide-medium",attrs:{"md-menu-class":"md-pagination-select","id":"requestNumber"},model:{value:(_vm.paginationSize),callback:function ($$v) {_vm.paginationSize=$$v},expression:"paginationSize"}},[_c('md-option',{attrs:{"value":5}},[_vm._v(_vm._s(_vm.$t('label.buscar_5_itens')))]),_vm._v(" "),_c('md-option',{attrs:{"value":10}},[_vm._v(_vm._s(_vm.$t('label.buscar_10_itens')))]),_vm._v(" "),_c('md-option',{attrs:{"value":15}},[_vm._v(_vm._s(_vm.$t('label.buscar_15_itens')))]),_vm._v(" "),_c('md-option',{attrs:{"value":20}},[_vm._v(_vm._s(_vm.$t('label.buscar_20_itens')))])],1),_vm._v(" "),(_vm.openSearchToolbar)?_c('div',{staticClass:"TabelaGenerica__SearchWrapper",class:{
          'TabelaGenerica__SearchWrapper--active': _vm.openSearchToolbar,
        }},[_c('md-input-container',{staticClass:"TabelaGenerica__SearchInput md-accent"},[_c('label',[_vm._v(_vm._s(_vm.$t('label.buscar')))]),_vm._v(" "),_c('md-input',{attrs:{"autoFocus":"true","id":"centroCusto-table-input-search","type":"text"},model:{value:(_vm.searchQuery),callback:function ($$v) {_vm.searchQuery=$$v},expression:"searchQuery"}}),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",attrs:{"id":"centroCusto-table-button-search-close"},nativeOn:{"click":function($event){return _vm.closeSearchHeader($event)}}},[_c('md-icon',[_vm._v("close")])],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('md-table-alternate-header',{attrs:{"md-selected-label":_vm.selecionadoLabel()}},[_c('md-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.canAccessCRUD),expression:"canAccessCRUD"}],staticClass:"md-icon-button",attrs:{"id":"blockbtn"},nativeOn:{"click":function($event){return _vm.openBlockDialog('dialog1', 'blockbtn')}}},[_c('md-icon',[_vm._v("block")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"top"}},[_vm._v(_vm._s(_vm.$t('label.ativar_inativa')))])],1)],1),_vm._v(" "),_c('div',{staticClass:"TabelaGenerica__TableWrapper CENTROCUSTOTABELA_TABLE"},[_c('md-table',{ref:"myTable",staticClass:"TabelaGenerica__Table ",attrs:{"md-sort":_vm.sortData.name,"md-sort-type":_vm.sortData.type},on:{"select":_vm.onSelect,"sort":_vm.onSort}},[(_vm.isHeaderAvailable)?_c('md-table-header',[_c('md-table-row',_vm._l((_vm.tableHeader),function(head,index){return _c('md-table-head',{key:index,class:head.classes,attrs:{"id":("centroCusto-table-head-" + index),"md-tooltip":head.tooltip,"md-sort-by":head.sortType}},[_vm._v("\n              "+_vm._s(head.name)+"\n            ")])}),1)],1):_vm._e(),_vm._v(" "),(_vm.isContentAvailable)?_c('md-table-body',{attrs:{"tabindex":"110"}},_vm._l((_vm.centroCustoFilteredList),function(row,rowIndex){return _c('md-table-row',{key:rowIndex,class:{
              'TabelaGenerica__TableRow--highlight': _vm.currentEditItem && _vm.currentEditItem === row,
              'TabelaGenerica__TableRow--disabled': !row.indAtivo,
            },attrs:{"md-item":row,"md-selection":""}},[(_vm.isColumnVisible('idExterno'))?_c('md-table-cell',{key:'idExterno',class:{
                  'md-hide-medium': _vm.hideOnMedium('idExterno'),
              },attrs:{"md-numeric":_vm.isNumericField('idExterno')},nativeOn:{"mouseover":function($event){return _vm.onCelMouseEnter(row, 'idExterno')},"mouseleave":function($event){return _vm.onCelMouseLeave($event)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onKeyEscPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateItem(row, rowIndex, 'idExterno')}]}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'idExterno')),expression:"!(currentEditItem && currentEditItem === row && currentColumn === 'idExterno')"}]},[_vm._v("\n                "+_vm._s(row.idExterno)+"\n              ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.canAccessCRUD && _vm.editItem === row && !_vm.currentEditItem && _vm.currentColumn === 'idExterno'),expression:"canAccessCRUD && editItem === row && !currentEditItem && currentColumn === 'idExterno'"}],staticClass:"TabelaGenerica__ChangeOnHover"},[_c('md-button',{staticClass:"md-icon-button md-dense",attrs:{"id":("centroCusto-table-button-edit-" + rowIndex)},nativeOn:{"click":function($event){return _vm.onClickEdit(row, row['idExterno'])}}},[_c('md-icon',[_vm._v("edit")])],1)],1),_vm._v(" "),(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'idExterno')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.edition),expression:"edition"}],ref:"currentinput",refInFor:true,staticClass:"TabelaGenerica__EditInput",attrs:{"type":"text","name":("centroCusto-table-button-edit-idExterno-" + rowIndex),"maxlength":"10","autofocus":""},domProps:{"value":(_vm.edition)},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }$event.stopPropagation();$event.preventDefault();return _vm.onTabPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.stopPropagation();return _vm.updateItem(row, 'idExterno')}],"blur":_vm.cleanEdition,"input":function($event){if($event.target.composing){ return; }_vm.edition=$event.target.value}},nativeOn:{"focus":function($event){return _vm.onCelMouseEnter(row.idExterno, 'idExterno')}}}):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('nome'))?_c('md-table-cell',{key:'nome',class:{
                'md-hide-medium': _vm.hideOnMedium('nome'),
              },attrs:{"md-numeric":_vm.isNumericField('nome')},nativeOn:{"mouseover":function($event){return _vm.onCelMouseEnter(row, 'nome')},"mouseleave":function($event){return _vm.onCelMouseLeave($event)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onKeyEscPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateItem(row, rowIndex, 'nome')}]}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'nome')),expression:"!(currentEditItem && currentEditItem === row && currentColumn === 'nome')"}]},[_vm._v("\n                "+_vm._s(row.nome)+"\n              ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.canAccessCRUD && _vm.editItem === row && !_vm.currentEditItem && _vm.currentColumn === 'nome'),expression:"canAccessCRUD && editItem === row && !currentEditItem && currentColumn === 'nome'"}],staticClass:"TabelaGenerica__ChangeOnHover"},[_c('md-button',{staticClass:"md-icon-button md-dense",nativeOn:{"click":function($event){return _vm.onClickEdit(row, row['nome'])}}},[_c('md-icon',[_vm._v("edit")])],1)],1),_vm._v(" "),(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'nome')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.edition),expression:"edition"}],ref:"currentinput",refInFor:true,staticClass:"TabelaGenerica__EditInput",attrs:{"type":"text","name":("centroCusto-table-button-edit-nome-" + rowIndex),"autofocus":""},domProps:{"value":(_vm.edition)},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }$event.stopPropagation();$event.preventDefault();return _vm.onTabPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.stopPropagation();return _vm.updateItem(row, 'nome')}],"input":function($event){if($event.target.composing){ return; }_vm.edition=$event.target.value}},nativeOn:{"focus":function($event){return _vm.onCelMouseEnter(row.nome, 'nome')}}}):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('unidadeNegocio'))?_c('md-table-cell',{key:'unidadeNegocio',class:{
                'md-hide-medium': _vm.hideOnMedium('unidadeNegocio'),
              },attrs:{"md-numeric":_vm.isNumericField('unidadeNegocio')},nativeOn:{"mouseover":function($event){return _vm.onCelMouseEnter(row, 'unidadeNegocio')},"mouseleave":function($event){return _vm.onCelMouseLeave($event)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onKeyEscPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateItem(row, rowIndex, 'unidadeNegocio')}]}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'unidadeNegocio')),expression:"!(currentEditItem && currentEditItem === row && currentColumn === 'unidadeNegocio')"}]},[_vm._v("\n                "+_vm._s(row.dependencias.unidadeNegocio.nomExtensao)+"\n              ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.canAccessCRUD && _vm.editItem === row && !_vm.currentEditItem && _vm.currentColumn === 'unidadeNegocio'),expression:"canAccessCRUD && editItem === row && !currentEditItem && currentColumn === 'unidadeNegocio'"}],staticClass:"TabelaGenerica__ChangeOnHover"},[_c('md-button',{staticClass:"md-icon-button md-dense",nativeOn:{"click":function($event){return _vm.onClickEdit(row, row.dependencias.unidadeNegocio.nomExtensao)}}},[_c('md-icon',[_vm._v("edit")])],1)],1),_vm._v(" "),(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'unidadeNegocio')?_c('md-input-container',[_c('md-autocomplete',{directives:[{name:"validate",rawName:"v-validate"}],ref:"unidadeNegocioAutoComplete",refInFor:true,attrs:{"required":"","tabindex":"3","name":("centroCusto_tipoInvestimento-unidadeNegocio-" + rowIndex),"data-vv-name":"centroCusto_tipoInvestimento","data-vv-rules":"required","fetch":_vm.fetchSuperiorUnidadeNegocioFunction,"min-chars":1,"printAttribute":"nomExtensao","prepareResponseData":_vm.prepareResponseData,"query-param":"nome"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }$event.stopPropagation();$event.preventDefault();return _vm.onTabPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.stopPropagation();return _vm.updateItem(row, 'unidadeNegocio')}],"selected":function($event){return _vm.setUnidadeNegocio($event, row)}},nativeOn:{"focus":function($event){return _vm.onCelMouseEnter(row.dependencias.unidadeNegocio, 'unidadeNegocio')}},model:{value:(row.dependencias.unidadeNegocio.nomExtensao),callback:function ($$v) {_vm.$set(row.dependencias.unidadeNegocio, "nomExtensao", $$v)},expression:"row.dependencias.unidadeNegocio.nomExtensao"}}),_vm._v(" "),_c('md-icon',{staticStyle:{"cursor":"pointer"},attrs:{"md-autocomplete-search":""}},[_vm._v("search")])],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('canais'))?_c('md-table-cell',{key:'canais',class:{
                'md-hide-medium': _vm.hideOnMedium('canais'),
              },attrs:{"md-numeric":_vm.isNumericField('canais')},nativeOn:{"mouseover":function($event){return _vm.onCelMouseEnter(row, 'canais')},"mouseleave":function($event){return _vm.onCelMouseLeave($event)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onKeyEscPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateItem(row, rowIndex, 'canais')}]}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'canais')),expression:"!(currentEditItem && currentEditItem === row && currentColumn === 'canais')"}]},[_vm._v("\n                "+_vm._s(_vm.extractCanaisName(row))+"\n              ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.canAccessCRUD && _vm.editItem === row && !_vm.currentEditItem && _vm.currentColumn === 'canais'),expression:"canAccessCRUD && editItem === row && !currentEditItem && currentColumn === 'canais'"}],staticClass:"TabelaGenerica__ChangeOnHover"},[_c('md-button',{staticClass:"md-icon-button md-dense",nativeOn:{"click":function($event){return _vm.onClickEdit(row, row.dependencias.canais)}}},[_c('md-icon',[_vm._v("edit")])],1)],1),_vm._v(" "),(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'canais')?_c('md-input-container',[_c('md-chips-autocomplete',{directives:[{name:"validate",rawName:"v-validate"}],ref:"canalAutoComplete",refInFor:true,attrs:{"tabindex":"4","name":("centroCusto_tipoInvestimento-canais-" + rowIndex),"data-vv-name":"centroCusto_tipoInvestimento","data-vv-rules":"required","fetch":_vm.fetchSuperiorCanalFunction,"min-chars":1,"printAttribute":"nomExtensao","prepareResponseData":_vm.prepareResponseData,"query-param":"nome"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }$event.stopPropagation();$event.preventDefault();return _vm.onTabPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.stopPropagation();return _vm.updateItem(row, 'canais')}]},nativeOn:{"focus":function($event){return _vm.onCelMouseEnter(row.dependencias.canais, 'canais')}},model:{value:(row.dependencias.canais),callback:function ($$v) {_vm.$set(row.dependencias, "canais", $$v)},expression:"row.dependencias.canais"}})],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('marcas'))?_c('md-table-cell',{key:'marcas',class:{
                'md-hide-medium': _vm.hideOnMedium('marcas'),
              },attrs:{"md-numeric":_vm.isNumericField('marcas')},nativeOn:{"mouseover":function($event){return _vm.onCelMouseEnter(row, 'marcas')},"mouseleave":function($event){return _vm.onCelMouseLeave($event)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onKeyEscPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateItem(row, rowIndex, 'marcas')}]}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'marcas')),expression:"!(currentEditItem && currentEditItem === row && currentColumn === 'marcas')"}]},[_vm._v("\n                "+_vm._s(_vm.extractMarcasName(row))+"\n              ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.canAccessCRUD && _vm.editItem === row && !_vm.currentEditItem && _vm.currentColumn === 'marcas'),expression:"canAccessCRUD && editItem === row && !currentEditItem && currentColumn === 'marcas'"}],staticClass:"TabelaGenerica__ChangeOnHover"},[_c('md-button',{staticClass:"md-icon-button md-dense",nativeOn:{"click":function($event){return _vm.onClickEdit(row, row.dependencias.marcas)}}},[_c('md-icon',[_vm._v("edit")])],1)],1),_vm._v(" "),(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'marcas')?_c('md-input-container',[_c('md-chips-autocomplete',{directives:[{name:"validate",rawName:"v-validate"}],ref:"marcaAutoComplete",refInFor:true,attrs:{"tabindex":"5","name":("centroCusto_tipoInvestimento-marcas-" + rowIndex),"data-vv-name":"centroCusto_tipoInvestimento","data-vv-rules":"required","fetch":_vm.fetchSuperiorMarcaFunction,"min-chars":1,"printAttribute":"nomExtensao","prepareResponseData":_vm.prepareResponseData,"query-param":"nome"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }$event.stopPropagation();$event.preventDefault();return _vm.onTabPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.stopPropagation();return _vm.updateItem(row, 'marcas')}]},nativeOn:{"focus":function($event){return _vm.onCelMouseEnter(row.dependencias.marcas, 'marcas')}},model:{value:(row.dependencias.marcas),callback:function ($$v) {_vm.$set(row.dependencias, "marcas", $$v)},expression:"row.dependencias.marcas"}})],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('indCliente'))?_c('md-table-cell',{key:'indCliente',class:{
                'md-hide-medium': _vm.hideOnMedium('indCliente'),
              },attrs:{"md-numeric":_vm.isNumericField('indCliente')},nativeOn:{"mouseover":function($event){return _vm.onCelMouseEnter(row, 'indCliente')},"mouseleave":function($event){return _vm.onCelMouseLeave($event)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onKeyEscPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.validadeUpdateItem(row, rowIndex, 'indCliente')}]}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'indCliente')),expression:"!(currentEditItem && currentEditItem === row && currentColumn === 'indCliente')"}]},[_vm._v("\n                "+_vm._s(row.indCliente ? 'Sim' : 'Não')+"\n              ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.canAccessCRUD && _vm.editItem === row && !_vm.currentEditItem && _vm.currentColumn === 'indCliente'),expression:"canAccessCRUD && editItem === row && !currentEditItem && currentColumn === 'indCliente'"}],staticClass:"TabelaGenerica__ChangeOnHover"},[_c('md-button',{staticClass:"md-icon-button md-dense",nativeOn:{"click":function($event){return _vm.onClickEdit(row, row.indCliente)}}},[_c('md-icon',[_vm._v("edit")])],1)],1),_vm._v(" "),(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'indCliente')?_c('md-switch',{staticClass:"md-primary",attrs:{"tabindex":"1","id":"centroCusto_indCliente","name":"centroCusto_indCliente"},model:{value:(row.indCliente),callback:function ($$v) {_vm.$set(row, "indCliente", $$v)},expression:"row.indCliente"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('indProduto'))?_c('md-table-cell',{key:'indProduto',class:{
                'md-hide-medium': _vm.hideOnMedium('indProduto'),
              },attrs:{"md-numeric":_vm.isNumericField('indProduto')},nativeOn:{"mouseover":function($event){return _vm.onCelMouseEnter(row, 'indProduto')},"mouseleave":function($event){return _vm.onCelMouseLeave($event)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onKeyEscPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.validadeUpdateItem(row, rowIndex, 'indProduto')}]}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'indProduto')),expression:"!(currentEditItem && currentEditItem === row && currentColumn === 'indProduto')"}]},[_vm._v("\n                "+_vm._s(row.indProduto ? 'Sim' : 'Não')+"\n              ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.canAccessCRUD && _vm.editItem === row && !_vm.currentEditItem && _vm.currentColumn === 'indProduto'),expression:"canAccessCRUD && editItem === row && !currentEditItem && currentColumn === 'indProduto'"}],staticClass:"TabelaGenerica__ChangeOnHover"},[_c('md-button',{staticClass:"md-icon-button md-dense",nativeOn:{"click":function($event){return _vm.onClickEdit(row, row.indProduto)}}},[_c('md-icon',[_vm._v("edit")])],1)],1),_vm._v(" "),(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'indProduto')?_c('md-switch',{staticClass:"md-primary",attrs:{"tabindex":"1","id":"centroCusto_indProduto","name":"centroCusto_indProduto"},model:{value:(row.indProduto),callback:function ($$v) {_vm.$set(row, "indProduto", $$v)},expression:"row.indProduto"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('indAtivo'))?_c('md-table-cell',{key:'indAtivo',class:{
                'md-hide-medium': _vm.hideOnMedium('indAtivo'),
              },attrs:{"md-numeric":_vm.isNumericField('indAtivo')},nativeOn:{"mouseover":function($event){return _vm.onCelMouseEnter(row, 'indAtivo')},"mouseleave":function($event){return _vm.onCelMouseLeave($event)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onKeyEscPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateItem(row, rowIndex, 'indAtivo')}]}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'indAtivo')),expression:"!(currentEditItem && currentEditItem === row && currentColumn === 'indAtivo')"}]},[_vm._v("\n                "+_vm._s(row.indAtivo ? 'Ativo' : 'Inativo')+"\n              ")])]):_vm._e()],1)}),1):_vm._e()],1),_vm._v(" "),(!_vm.carregando)?_c('paginate',{directives:[{name:"show",rawName:"v-show",value:(_vm.isContentAvailable && _vm.paginas > 1),expression:"isContentAvailable && paginas > 1"}],attrs:{"page-count":_vm.paginas,"click-handler":_vm.clickHandler,"initial-page":_vm.indexPagina,"prev-text":_vm.$tc('label.anterior', 1),"next-text":_vm.$tc('label.proximo', 1),"container-class":'pagination'}}):_vm._e(),_vm._v(" "),_c('h4',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isContentAvailable),expression:"!isContentAvailable"}],staticClass:"TabelaGenerica__NoContent"},[_vm._v("\n        "+_vm._s(_vm.$t('label.tabela_sem_conteudo'))+"\n      ")]),_vm._v(" "),_c('md-spinner',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLoading),expression:"showLoading"}],staticClass:"TabelaGenerica__InterminateLoader",attrs:{"slot":"spinner","md-indeterminate":""},slot:"spinner"})],1)],1):_vm._e()],1)}
var staticRenderFns = []



/***/ }),
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_CentroCustoTabela_vue_vue_type_style_index_1_lang_css___ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_CentroCustoTabela_vue_vue_type_style_index_1_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_CentroCustoTabela_vue_vue_type_style_index_1_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_CentroCustoTabela_vue_vue_type_style_index_1_lang_css____default.a); 

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Cliente = __webpack_require__(1123);

var _Cliente2 = _interopRequireDefault(_Cliente);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClienteList = function ClienteList() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1660));
};
var ClienteForm = function ClienteForm() {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 1661));
};

exports.default = {
  path: 'cliente',
  component: _Cliente2.default,
  children: [{
    path: '',
    name: 'cliente',
    component: ClienteList
  }, {
    path: 'novo',
    name: 'novoCliente',
    component: ClienteForm,
    props: {
      default: false,
      somenteLeitura: false,
      copia: false
    }
  }, {
    path: ':id',
    name: 'verCliente',
    component: ClienteForm,
    props: {
      default: true,
      somenteLeitura: true,
      copia: false
    }
  }, {
    path: ':id/editar',
    name: 'editarCliente',
    component: ClienteForm,
    props: {
      default: true,
      somenteLeitura: false,
      copia: false
    }
  }]
};

/***/ }),
/* 1123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Cliente_vue_vue_type_template_id_0215b049___ = __webpack_require__(1124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Cliente_vue_vue_type_script_lang_js___ = __webpack_require__(391);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__Cliente_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__Cliente_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Cliente_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__Cliente_vue_vue_type_template_id_0215b049___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Cliente_vue_vue_type_template_id_0215b049___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Cliente_vue_vue_type_template_id_0215b049___ = __webpack_require__(1125);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Cliente_vue_vue_type_template_id_0215b049___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Cliente_vue_vue_type_template_id_0215b049___["b"]; });


/***/ }),
/* 1125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c('router-view')],1)}
var staticRenderFns = []



/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Configuracao = __webpack_require__(1127);

var _Configuracao2 = _interopRequireDefault(_Configuracao);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  path: 'configuracao',
  name: 'configuracao',
  component: _Configuracao2.default
};

/***/ }),
/* 1127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Configuracao_vue_vue_type_template_id_50c9c960_lang_html___ = __webpack_require__(1128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Configuracao_vue_vue_type_script_lang_js___ = __webpack_require__(393);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__Configuracao_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__Configuracao_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Configuracao_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__Configuracao_vue_vue_type_template_id_50c9c960_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Configuracao_vue_vue_type_template_id_50c9c960_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Configuracao_vue_vue_type_template_id_50c9c960_lang_html___ = __webpack_require__(1129);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Configuracao_vue_vue_type_template_id_50c9c960_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Configuracao_vue_vue_type_template_id_50c9c960_lang_html___["b"]; });


/***/ }),
/* 1129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canAccessPage)?_c('div',[_c('md-tabs',{staticClass:"md-transparent",attrs:{"md-fixed":""},on:{"change":function($event){}}},[(_vm.canAccessPageWorkflowAprovacao)?_c('md-tab',{attrs:{"id":"configuracao-tab-pageWorkflowAprovacao","md-label":_vm.$t('label.workflow_aprovacao')}},[_c('configuracao-workflow-aprovacao')],1):_vm._e(),_vm._v(" "),(_vm.canAccessPageWorkflowContrato)?_c('md-tab',{attrs:{"id":"configuracao-tab-pageWorkflowContrato","md-label":_vm.$tc('label.negociacao', 1)}},[_c('configuracao-workflow-contrato')],1):_vm._e(),_vm._v(" "),(_vm.canAccessPageCalendario)?_c('md-tab',{attrs:{"id":"configuracao-tab-pageCalendario","md-label":_vm.$t('title.calendario_aprovacoes')}},[_c('configuracao-calendario-aprovacao')],1):_vm._e(),_vm._v(" "),(_vm.canAccessPageOrcamento)?_c('md-tab',{attrs:{"id":"configuracao-tab-pageOrcamento","md-label":_vm.$t('label.orcamento')}},[_c('configuracao-orcamento')],1):_vm._e(),_vm._v(" "),(_vm.canAccessPageApuracaoAcordo)?_c('md-tab',{attrs:{"id":"configuracao-tab-pageApuracaoAcordo","md-label":_vm.$tc('label.apuracao', 1)}},[_c('configuracao-apuracao-acordo')],1):_vm._e(),_vm._v(" "),(_vm.canAccessPagePagamento)?_c('md-tab',{attrs:{"id":"configuracao-tab-pagePagamento","md-label":_vm.$tc('label.pagamento', 1)}},[_c('configuracao-pagamento')],1):_vm._e(),_vm._v(" "),(_vm.canAccessPageCadastro)?_c('md-tab',{attrs:{"id":"configuracao-tab-pageCadastro","md-label":_vm.$tc('label.cadastro', 1)}},[_c('configuracao-cadastro')],1):_vm._e(),_vm._v(" "),(_vm.canAccessPageNotificacaoEmail)?_c('md-tab',{attrs:{"id":"configuracao-tab-notificacaoEmail","md-label":_vm.$t('label.email_alerta')}},[_c('configuracao-notificacao-email')],1):_vm._e()],1)],1):_vm._e()}
var staticRenderFns = []



/***/ }),
/* 1130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ConfiguracaoWorkflowAprovacao_vue_vue_type_template_id_8c3da792_lang_html___ = __webpack_require__(1131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ConfiguracaoWorkflowAprovacao_vue_vue_type_script_lang_js___ = __webpack_require__(395);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__ConfiguracaoWorkflowAprovacao_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__ConfiguracaoWorkflowAprovacao_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ConfiguracaoWorkflowAprovacao_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(1134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ConfiguracaoWorkflowAprovacao_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__ConfiguracaoWorkflowAprovacao_vue_vue_type_template_id_8c3da792_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ConfiguracaoWorkflowAprovacao_vue_vue_type_template_id_8c3da792_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoWorkflowAprovacao_vue_vue_type_template_id_8c3da792_lang_html___ = __webpack_require__(1132);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoWorkflowAprovacao_vue_vue_type_template_id_8c3da792_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoWorkflowAprovacao_vue_vue_type_template_id_8c3da792_lang_html___["b"]; });


/***/ }),
/* 1132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"md-title"},[_vm._v(_vm._s(_vm.$t('label.fluxo'))+":")]),_vm._v(" "),_vm._l((_vm.aprovacoes),function(item,index){return _c('md-layout',{key:index},[_c('md-layout',{staticClass:"ConfiguracaoWorkflowAprovacao__pading32",attrs:{"md-row":"","md-gutter":"","md-flex":"100"}},[_c('md-checkbox',{staticClass:"md-primary",attrs:{"id":("configuracao-workflow-aprovacao-checkbox-" + index),"tabindex":"1","md-gutter":"","disabled":_vm.disableCheck},on:{"change":function($event){return _vm.requestAtualizar(item)}},model:{value:(item.valorParametro),callback:function ($$v) {_vm.$set(item, "valorParametro", $$v)},expression:"item.valorParametro"}}),_vm._v(" "),_c('md-layout',{attrs:{"md-gutter":""}},[_c('span',{staticClass:"ConfiguracaoWorkflowAprovacao__margin14 Configuracao__fontsize",domProps:{"textContent":_vm._s(_vm.$t(("configuracao." + (item.chaveParametro))))}}),_vm._v(" "),_c('span',{staticClass:"md-caption ConfiguracaoWorkflowAprovacao__margin18",domProps:{"textContent":_vm._s(_vm.$t(("configuracao." + (item.chaveParametro) + "_DESCRICAO")))}})])],1),_vm._v(" "),_c('md-layout',{staticClass:"ConfiguracaoWorkflowAprovacao__pading48"},[_c('md-switch',{staticClass:"md-primary",attrs:{"id":"configuracao-workflow-aprovacao-switch-habilitaAlcadaPasso","tabindex":"2","md-column":"","md-gutter":"","disabled":_vm.disableCheck},on:{"change":function($event){return _vm.requestAtualizar(item)}},model:{value:(item.habilitaAlcadaPasso),callback:function ($$v) {_vm.$set(item, "habilitaAlcadaPasso", $$v)},expression:"item.habilitaAlcadaPasso"}}),_vm._v(" "),_c('md-layout',{attrs:{"md-column":"","md-gutter":""}},[_c('span',{staticClass:"ConfiguracaoWorkflowAprovacao__margin12",domProps:{"textContent":_vm._s(_vm.$t('configuracao.HABILITAR_CONTROLE_ALCADAS_PASSOS'))}})])],1)],1)})],2)}
var staticRenderFns = []



/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'configuracao-workflow-aprovacao');

var configuracaoWorkflowAprovacaoActions = {
  atualizar: { method: 'PUT', url: '' + basePath },
  pesquisar: { method: 'GET', url: basePath + '?tamanhoPagina={size}&numeroPagina={page}' },
  verificar: { method: 'GET', url: basePath + '/habilitado?chave={chave}' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, configuracaoWorkflowAprovacaoActions);
};

/***/ }),
/* 1134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoWorkflowAprovacao_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoWorkflowAprovacao_vue_vue_type_style_index_0_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoWorkflowAprovacao_vue_vue_type_style_index_0_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoWorkflowAprovacao_vue_vue_type_style_index_0_lang_css____default.a); 

/***/ }),
/* 1135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ConfiguracaoCalendarioAprovacao_vue_vue_type_template_id_0afdbd92_lang_html___ = __webpack_require__(1136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ConfiguracaoCalendarioAprovacao_vue_vue_type_script_lang_js___ = __webpack_require__(398);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__ConfiguracaoCalendarioAprovacao_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__ConfiguracaoCalendarioAprovacao_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ConfiguracaoCalendarioAprovacao_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(1139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ConfiguracaoCalendarioAprovacao_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__ConfiguracaoCalendarioAprovacao_vue_vue_type_template_id_0afdbd92_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ConfiguracaoCalendarioAprovacao_vue_vue_type_template_id_0afdbd92_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoCalendarioAprovacao_vue_vue_type_template_id_0afdbd92_lang_html___ = __webpack_require__(1137);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoCalendarioAprovacao_vue_vue_type_template_id_0afdbd92_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoCalendarioAprovacao_vue_vue_type_template_id_0afdbd92_lang_html___["b"]; });


/***/ }),
/* 1137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"md-title"},[_vm._v("Evento:")]),_vm._v(" "),_vm._l((_vm.aprovacoes),function(item,index){return _c('md-layout',{key:index,attrs:{"md-flex":""}},[_c('md-layout',{staticClass:"Configuracao__fontsize ConfiguracaoCalendarioAprovacao__pading32",attrs:{"md-flex":"100"}},[_c('md-checkbox',{staticClass:"md-primary",attrs:{"tabindex":1 + index,"id":("configuracao-calendario-aprovacao-checkbox-" + index),"disabled":_vm.disableCheck},on:{"change":function($event){return _vm.requestAtualizar(item)}},model:{value:(item.valorParametro),callback:function ($$v) {_vm.$set(item, "valorParametro", $$v)},expression:"item.valorParametro"}},[_c('span',{domProps:{"textContent":_vm._s(_vm.$t(("configuracao.calendario_aprovacoes." + (item.chaveParametro) + "_DESCRICAO")))}})])],1)],1)})],2)}
var staticRenderFns = []



/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'configuracao-calendario-aprovacao');

var configuracaoCalendarioAprovacaoActions = {
  atualizar: { method: 'PUT', url: '' + basePath },
  pesquisar: { method: 'GET', url: '' + basePath }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, configuracaoCalendarioAprovacaoActions);
};

/***/ }),
/* 1139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoCalendarioAprovacao_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoCalendarioAprovacao_vue_vue_type_style_index_0_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoCalendarioAprovacao_vue_vue_type_style_index_0_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoCalendarioAprovacao_vue_vue_type_style_index_0_lang_css____default.a); 

/***/ }),
/* 1140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ConfiguracaoWorkflowContrato_vue_vue_type_template_id_124eeb26_scoped_true_lang_html___ = __webpack_require__(1141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ConfiguracaoWorkflowContrato_vue_vue_type_script_lang_js___ = __webpack_require__(401);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__ConfiguracaoWorkflowContrato_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__ConfiguracaoWorkflowContrato_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ConfiguracaoWorkflowContrato_vue_vue_type_style_index_0_id_124eeb26_lang_css_scoped_true___ = __webpack_require__(1144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ConfiguracaoWorkflowContrato_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__ConfiguracaoWorkflowContrato_vue_vue_type_template_id_124eeb26_scoped_true_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ConfiguracaoWorkflowContrato_vue_vue_type_template_id_124eeb26_scoped_true_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  "124eeb26",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoWorkflowContrato_vue_vue_type_template_id_124eeb26_scoped_true_lang_html___ = __webpack_require__(1142);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoWorkflowContrato_vue_vue_type_template_id_124eeb26_scoped_true_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoWorkflowContrato_vue_vue_type_template_id_124eeb26_scoped_true_lang_html___["b"]; });


/***/ }),
/* 1142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.negociacoes.length > 0)?_c('h1',{staticClass:"md-title"},[_vm._v(_vm._s(_vm.$t('title.negociacoes'))+":")]):_vm._e(),_vm._v(" "),_vm._l((_vm.negociacoes),function(item,index){return (_vm.negociacoes.length > 0)?_c('md-layout',{key:item.nomeAcordo},[_c('md-layout',{staticClass:"ConfiguracaoWorkflowContrato__pading32",attrs:{"md-row":"","md-gutter":"","md-flex":"100"}},[_c('md-checkbox',{staticClass:"md-primary",attrs:{"id":("configuracao-negociacao-" + index),"tabindex":"1","md-gutter":"","disabled":_vm.disableCheck},on:{"change":function($event){return _vm.requestAtualizar(item, $event)}},model:{value:(item.valor),callback:function ($$v) {_vm.$set(item, "valor", $$v)},expression:"item.valor"}}),_vm._v(" "),_c('md-layout',{attrs:{"md-gutter":""}},[_c('span',{staticClass:"ConfiguracaoWorkflowContrato__margin14 Configuracao__fontsize",domProps:{"textContent":_vm._s(_vm.$t(("configuracao." + (item.nomeAcordo))))}}),_vm._v(" "),_c('span',{staticClass:"md-caption ConfiguracaoWorkflowContrato__margin18",domProps:{"textContent":_vm._s(_vm.$t(("configuracao." + (item.nomeAcordo) + "_DESCRICAO")))}})])],1)],1):_vm._e()}),_vm._v(" "),_c('h1',{staticClass:"md-title"},[_vm._v(_vm._s(_vm.$tc('label.acordo', 2))+":")]),_vm._v(" "),_vm._l((_vm.contratos),function(item,index){return _c('md-layout',{key:index},[_c('md-layout',{staticClass:"ConfiguracaoWorkflowContrato__pading32",attrs:{"md-row":"","md-gutter":"","md-flex":"100"}},[_c('md-checkbox',{staticClass:"md-primary",attrs:{"id":("configuracao-workflow-contrato-checkbox-valor-contrato-" + index),"tabindex":"1","md-gutter":"","disabled":_vm.disableCheck},on:{"change":function($event){return _vm.requestAtualizar(item, $event)}},model:{value:(item.valor),callback:function ($$v) {_vm.$set(item, "valor", $$v)},expression:"item.valor"}}),_vm._v(" "),_c('md-layout',{attrs:{"md-gutter":""}},[_c('span',{staticClass:"ConfiguracaoWorkflowContrato__margin14 Configuracao__fontsize",domProps:{"textContent":_vm._s(_vm.$t(("configuracao." + (item.nomeAcordo))))}}),_vm._v(" "),_c('span',{staticClass:"md-caption ConfiguracaoWorkflowContrato__margin18",domProps:{"textContent":_vm._s(_vm.$t(("configuracao." + (item.nomeAcordo) + "_DESCRICAO")))}})])],1)],1)}),_vm._v(" "),_c('hr',{attrs:{"color":"#DFDFDF"}}),_vm._v(" "),_c('h1',{staticClass:"md-title"},[_vm._v(_vm._s(_vm.$t('label.tipo_acordo'))+":")]),_vm._v(" "),_c('md-layout',{staticClass:"ConfiguracaoWorkflowContrato__pading32",attrs:{"md-row":"","md-gutter":"","md-flex":"50"}},[_c('md-input-container',[_c('label',[_vm._v(_vm._s(_vm.$t('label.selecione')))]),_vm._v(" "),_c('md-select',{attrs:{"id":"configuracao-workflow-contrato-select-nomeAcordo","tabindex":"2"},model:{value:(_vm.tipoAcordo),callback:function ($$v) {_vm.tipoAcordo=$$v},expression:"tipoAcordo"}},_vm._l((_vm.contratosCombobox),function(item,index){return _c('md-option',{key:index,attrs:{"value":item.nomeAcordo},on:{"selected":function($event){return _vm.requestPopularConfiguracoesContrato(item)}}},[_vm._v("\n          "+_vm._s(_vm.$t(("configuracao." + (item.nomeAcordo))))+"\n        ")])}),1)],1)],1),_vm._v(" "),_c('md-layout',{staticClass:"ConfiguracaoWorkflowContrato__pading32",attrs:{"md-row":"","md-gutter":"","md-flex":"50"}},[_c('md-input-container',[_c('label',[_vm._v(_vm._s(_vm.$t('label.tipo_provisao')))]),_vm._v(" "),_c('md-select',{attrs:{"id":"configuracao-workflow-contrato-select-tipoProvisao","tabindex":"2"},model:{value:(_vm.tipoProvisao),callback:function ($$v) {_vm.tipoProvisao=$$v},expression:"tipoProvisao"}},_vm._l((_vm.tipos),function(item,index){return _c('md-option',{key:index,attrs:{"value":item.tipo},on:{"selected":function($event){return _vm.requestAtualizarTipoProvisao(item)}}},[_vm._v("\n          "+_vm._s(item.descricao)+"\n        ")])}),1)],1)],1),_vm._v(" "),_vm._l((_vm.grupos),function(grupo,key){return (_vm.hasConfiguracoesContrato)?[_c('hr',{attrs:{"color":"#DFDFDF"}}),_vm._v(" "),_c('h1',{staticClass:"md-title"},[_vm._v(_vm._s(_vm.$tc(("label." + (key.toLowerCase())), 1))+":")]),_vm._v(" "),_vm._l((grupo),function(subGrupo,keySub){return _c('div',[(keySub !== 'SEM_SUB_GRUPO')?_c('h2',{staticClass:"ConfiguracaoWorkflowContrato__pading32"},[_vm._v(_vm._s(_vm.$tc(("label." + (keySub.toLowerCase())), 1))+":")]):_vm._e(),_vm._v(" "),_vm._l((subGrupo),function(item,index){return (keySub !== 'SEM_SUB_GRUPO')?_c('md-layout',{key:index},[(!(item.atributos && item.atributos.label && item.atributos.tipo === 'input'))?_c('md-layout',{staticClass:"ConfiguracaoWorkflowContrato__pading48",attrs:{"md-row":"","md-gutter":"","md-flex":"100"}},[_c('md-checkbox',{staticClass:"md-primary",attrs:{"id":("configuracao-workflow-contrato-checkbox-vlrSelecao-grupo-" + key + "-" + keySub),"md-gutter":"","disabled":_vm.disableCheck},on:{"change":function($event){return _vm.requestAtualizarConfiguracao(item, $event)}},model:{value:(item.vlrSelecao),callback:function ($$v) {_vm.$set(item, "vlrSelecao", $$v)},expression:"item.vlrSelecao"}}),_vm._v(" "),_c('md-layout',{attrs:{"md-gutter":""}},[_c('span',{staticClass:"ConfiguracaoWorkflowContrato__margin14 Configuracao__fontsize",domProps:{"textContent":_vm._s(_vm.$t(("configuracao." + key + "." + keySub + "." + (item.nomeConfiguracao))))}}),_vm._v(" "),_c('span',{staticClass:"md-caption ConfiguracaoWorkflowContrato__margin18",domProps:{"textContent":_vm._s(_vm.$t(("configuracao." + key + "." + keySub + "." + (item.nomeConfiguracao) + "_DESCRICAO")))}})])],1):_vm._e(),_vm._v(" "),(item.atributos)?_c('md-layout',{staticClass:"ConfiguracaoWorkflowContrato__pading64"},[(item.atributos.tipo === 'switch')?_c('md-switch',{staticClass:"md-primary",attrs:{"tabindex":"2","md-column":"","md-gutter":"","disable":_vm.disableCheck,"disabled":!_vm.grupos[key][keySub][index].vlrSelecao},on:{"change":function($event){return _vm.requestAtualizarSubConfiguracao(item)}},model:{value:(item.atributos.valor),callback:function ($$v) {_vm.$set(item.atributos, "valor", $$v)},expression:"item.atributos.valor"}}):_vm._e(),_vm._v(" "),(item.atributos && item.atributos.label && item.atributos.tipo === 'switch')?_c('md-layout',{attrs:{"md-column":"","md-gutter":""}},[_c('span',{domProps:{"textContent":_vm._s(_vm.$t('label.' +  item.atributos.label))}})]):_vm._e(),_vm._v(" "),(item.atributos && item.atributos.label && item.atributos.tipo === 'input')?_c('md-layout',[_c('md-input-container',[_c('label',[_vm._v(_vm._s(_vm.$t(("configuracao." + key + "." + keySub + "." + (item.atributos.label)))))]),_vm._v(" "),_c('md-input',{attrs:{"type":"text","tabindex":"3"},nativeOn:{"blur":function($event){return _vm.requestAtualizarSubConfiguracao(item)}},model:{value:(item.atributos.valor),callback:function ($$v) {_vm.$set(item.atributos, "valor", $$v)},expression:"item.atributos.valor"}})],1)],1):_vm._e()],1):_vm._e()],1):_vm._e()}),_vm._v(" "),_vm._l((subGrupo),function(item,index){return (keySub === 'SEM_SUB_GRUPO')?_c('md-layout',{key:index},[(!(item.atributos && item.atributos.label && item.atributos.tipo === 'input'))?_c('md-layout',{staticClass:"ConfiguracaoWorkflowContrato__pading32",attrs:{"md-row":"","md-gutter":"","md-flex":"100"}},[_c('md-checkbox',{staticClass:"md-primary",attrs:{"id":("configuracao-workflow-contrato-checkbox-vlrSelecao-grupo-" + key),"md-gutter":"","disabled":_vm.disableCheck},on:{"change":function($event){return _vm.requestAtualizarConfiguracao(item, $event)}},model:{value:(item.vlrSelecao),callback:function ($$v) {_vm.$set(item, "vlrSelecao", $$v)},expression:"item.vlrSelecao"}}),_vm._v(" "),_c('md-layout',{attrs:{"md-gutter":""}},[_c('span',{staticClass:"ConfiguracaoWorkflowContrato__margin14 Configuracao__fontsize",domProps:{"textContent":_vm._s(_vm.$t(("configuracao." + key + "." + (item.nomeConfiguracao))))}}),_vm._v(" "),_c('span',{staticClass:"md-caption ConfiguracaoWorkflowContrato__margin18",domProps:{"textContent":_vm._s(_vm.$t(("configuracao." + key + "." + (item.nomeConfiguracao) + "_DESCRICAO")))}})])],1):_vm._e(),_vm._v(" "),(item.atributos)?_c('md-layout',{staticClass:"ConfiguracaoWorkflowAprovacao__pading48"},[(item.atributos.tipo === 'switch')?_c('md-switch',{staticClass:"md-primary",attrs:{"tabindex":"2","md-column":"","md-gutter":"","disable":_vm.disableCheck,"disabled":!_vm.grupos[key][keySub][index].vlrSelecao},on:{"change":function($event){return _vm.requestAtualizarSubConfiguracao(item)}},model:{value:(item.atributos.valor),callback:function ($$v) {_vm.$set(item.atributos, "valor", $$v)},expression:"item.atributos.valor"}}):_vm._e(),_vm._v(" "),(item.atributos && item.atributos.label && item.atributos.tipo === 'switch')?_c('md-layout',{attrs:{"md-column":"","md-gutter":""}},[_c('span',{domProps:{"textContent":_vm._s(_vm.$t('label.' +  item.atributos.label))}})]):_vm._e(),_vm._v(" "),(item.atributos && item.atributos.label && item.atributos.tipo === 'input')?_c('md-layout',[_c('md-input-container',[_c('label',[_vm._v(_vm._s(_vm.$t(("configuracao." + key + "." + (item.atributos.label)))))]),_vm._v(" "),_c('md-input',{attrs:{"type":"text","tabindex":"3"},nativeOn:{"blur":function($event){return _vm.requestAtualizarSubConfiguracao(item)}},model:{value:(item.atributos.valor),callback:function ($$v) {_vm.$set(item.atributos, "valor", $$v)},expression:"item.atributos.valor"}})],1)],1):_vm._e()],1):_vm._e()],1):_vm._e()})],2)})]:_vm._e()}),_vm._v(" "),_c('hr',{attrs:{"color":"#DFDFDF"}})],2)}
var staticRenderFns = []



/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'configuracao/contrato');

var configuracaoWorkflowContratoActions = {
  atualizarTipoAcordo: { method: 'PUT', url: basePath + '/{nomeAcordo}?valorSelecao={valorSelecao}' },
  atualizarTipoProvisao: { method: 'PUT', url: basePath + '/tipo-provisao/{nomeAcordo}' },
  pesquisarTipoProvisao: { method: 'GET', url: basePath + '/tipo-provisao/{nomeAcordo}' },
  atualizarConfiguracoesContrato: { method: 'PUT', url: '' + basePath },
  atualizarSubConfiguracoesContrato: { method: 'PUT', url: basePath + '/sub-configuracao' },
  pesquisar: { method: 'GET', url: basePath + '?tamanhoPagina={size}&numeroPagina={page}' },
  pesquisarConfiguracoesContrato: { method: 'GET', url: basePath + '/{nomeAcordo}' },
  pesquisarRoiBaseCalculo: {
    method: 'GET',
    url: basePath + '/{nomeAcordo}/roi/base-calculo'
  },
  pesquisarBaseCalculo: {
    method: 'GET',
    url: basePath + '/{nomeAcordo}/base-calculo'
  },
  pesquisarBonificacao: {
    method: 'GET',
    url: basePath + '/{nomeAcordo}/bonificacao'
  },
  pesquisarMetasBeneficios: {
    method: 'GET',
    url: basePath + '/{nomeAcordo}/metas-beneficios'
  },
  obtemValorConfiguracao: {
    method: 'GET',
    url: basePath + '/{nomeAcordo}/configuracao/{nomeConfig}'
  },
  obtemValorSubConfiguracao: {
    method: 'GET',
    url: basePath + '/{nomeAcordo}/sub-configuracao/{nomeConfig}'
  }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, configuracaoWorkflowContratoActions);
};

/***/ }),
/* 1144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoWorkflowContrato_vue_vue_type_style_index_0_id_124eeb26_lang_css_scoped_true___ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoWorkflowContrato_vue_vue_type_style_index_0_id_124eeb26_lang_css_scoped_true____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoWorkflowContrato_vue_vue_type_style_index_0_id_124eeb26_lang_css_scoped_true___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoWorkflowContrato_vue_vue_type_style_index_0_id_124eeb26_lang_css_scoped_true____default.a); 

/***/ }),
/* 1145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ConfiguracaoOrcamento_vue_vue_type_template_id_18a70b30_lang_html___ = __webpack_require__(1146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ConfiguracaoOrcamento_vue_vue_type_script_lang_js___ = __webpack_require__(404);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__ConfiguracaoOrcamento_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__ConfiguracaoOrcamento_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ConfiguracaoOrcamento_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(1152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ConfiguracaoOrcamento_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__ConfiguracaoOrcamento_vue_vue_type_template_id_18a70b30_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ConfiguracaoOrcamento_vue_vue_type_template_id_18a70b30_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoOrcamento_vue_vue_type_template_id_18a70b30_lang_html___ = __webpack_require__(1147);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoOrcamento_vue_vue_type_template_id_18a70b30_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoOrcamento_vue_vue_type_template_id_18a70b30_lang_html___["b"]; });


/***/ }),
/* 1147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.orcamentoVisible)?_c('md-layout',[_c('md-layout',{attrs:{"md-row":"","md-gutter":"","md-flex":"15"}},[_c('h1',{staticClass:"md-title"},[_vm._v(_vm._s(_vm.$t('configuracao.MODULO_ORCAMENTO'))+":")]),_vm._v(" "),_c('span',{staticClass:" Configuracao__fontsize",domProps:{"textContent":_vm._s(_vm.$t('configuracao.MODULO_ORCAMENTO_DESCRICAO'))}})]),_vm._v(" "),_c('md-layout',{staticClass:"ConfiguracaoOrcamento__pading32",attrs:{"md-flex":"85"}},[_c('md-switch',{staticClass:"md-primary",attrs:{"id":"configuracao-orcamento-switch-moduloOrcamento-valorParametro","tabindex":"1","md-gutter":""},on:{"change":function($event){return _vm.requestAtualizar(_vm.moduloOrcamento)}},model:{value:(_vm.moduloOrcamento.valorParametro),callback:function ($$v) {_vm.$set(_vm.moduloOrcamento, "valorParametro", $$v)},expression:"moduloOrcamento.valorParametro"}}),_vm._v(" "),_c('span',{staticClass:"ConfiguracaoOrcamento__margin12",domProps:{"textContent":_vm._s(_vm.$t('configuracao.MODULO_ORCAMENTO_TOGGLE'))}})],1),_vm._v(" "),_c('hr')],1):_vm._e(),_vm._v(" "),(_vm.rateioVisible)?_c('md-layout',[_c('md-layout',{attrs:{"md-row":"","md-gutter":"","md-flex":"15"}},[_c('h1',{staticClass:"md-title"},[_vm._v(_vm._s(_vm.$t('configuracao.RATEIO'))+":")]),_vm._v(" "),_c('span',{staticClass:" Configuracao__fontsize",domProps:{"textContent":_vm._s(_vm.$t('configuracao.RATEIO_DESCRICAO'))}})]),_vm._v(" "),_c('md-layout',{staticClass:"ConfiguracaoOrcamento__pading32",attrs:{"md-flex":"85"}},[_c('md-switch',{staticClass:"md-primary",attrs:{"id":"configuracao-orcamento-switch-rateio-valorParametro","md-gutter":"","disabled":!_vm.moduloOrcamento.valorParametro},on:{"change":function($event){return _vm.requestAtualizar(_vm.rateio)}},model:{value:(_vm.rateio.valorParametro),callback:function ($$v) {_vm.$set(_vm.rateio, "valorParametro", $$v)},expression:"rateio.valorParametro"}}),_vm._v(" "),_c('span',{staticClass:"ConfiguracaoOrcamento__margin12",domProps:{"textContent":_vm._s(_vm.$t('configuracao.RATEIO_TOGGLE'))}})],1),_vm._v(" "),_c('hr')],1):_vm._e(),_vm._v(" "),(_vm.rateioVisible)?_c('md-layout',[_c('md-layout',{attrs:{"md-row":"","md-gutter":"","md-flex":"15"}},[_c('h1',{staticClass:"md-title"},[_vm._v(_vm._s(_vm.$t('configuracao.NOTIFICACAO'))+":")]),_vm._v(" "),_c('span',{staticClass:" Configuracao__fontsize",domProps:{"textContent":_vm._s(_vm.$t('configuracao.NOTIFICACAO_DESCRICAO'))}})]),_vm._v(" "),_c('md-layout',{staticClass:"ConfiguracaoOrcamento__pading32 ConfiguracaoOrcamento__align-items",attrs:{"md-flex":"85"}},[_c('md-switch',{staticClass:"md-primary",attrs:{"id":"configuracao-orcamento-switch-notificacao-valorParametro","disabled":!_vm.moduloOrcamento.valorParametro},on:{"change":function($event){return _vm.requestAtualizar(_vm.notificacaoOrcamento)}},model:{value:(_vm.notificacaoOrcamento.valorParametro),callback:function ($$v) {_vm.$set(_vm.notificacaoOrcamento, "valorParametro", $$v)},expression:"notificacaoOrcamento.valorParametro"}}),_vm._v(" "),_c('div',{staticClass:"ConfiguracaoOrcamento__text-group"},[_c('span',[_vm._v(_vm._s(_vm.$t('configuracao.NOTIFICACAO_TOGGLE_PART1')))]),_vm._v(" "),_c('md-input-container',{staticClass:"ConfiguracaoOrcamento__day-input"},[_c('md-input',{attrs:{"type":"number","min":1,"max":31,"disabled":!_vm.notificacaoOrcamento.valorParametro},on:{"change":_vm.atualizarDiaNotificacao},model:{value:(_vm.notificacaoOrcamento.observacaoFront),callback:function ($$v) {_vm.$set(_vm.notificacaoOrcamento, "observacaoFront", $$v)},expression:"notificacaoOrcamento.observacaoFront"}}),_vm._v(" "),(_vm.errors.observacaoFront)?_c('span',{staticClass:"md-error"},[_vm._v(_vm._s(_vm.errors.observacaoFront))]):_vm._e()],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('configuracao.NOTIFICACAO_TOGGLE_PART2')))])],1)],1),_vm._v(" "),_c('hr')],1):_vm._e()],1)}
var staticRenderFns = []



/***/ }),
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'configuracao-orcamento');

var configuracaoOrcamentoActions = {
  atualizar: { method: 'PUT', url: '' + basePath },
  pesquisar: { method: 'GET', url: '' + basePath },
  pesquisarRateio: { method: 'GET', url: basePath + '/chave/rateio' },
  pesquisarOrcamento: { method: 'GET', url: basePath + '/chave/modulo_orcamento' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, configuracaoOrcamentoActions);
};

/***/ }),
/* 1152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoOrcamento_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoOrcamento_vue_vue_type_style_index_0_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoOrcamento_vue_vue_type_style_index_0_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoOrcamento_vue_vue_type_style_index_0_lang_css____default.a); 

/***/ }),
/* 1153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ConfiguracaoApuracaoAcordo_vue_vue_type_template_id_787ed353_lang_html___ = __webpack_require__(1154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ConfiguracaoApuracaoAcordo_vue_vue_type_script_lang_js___ = __webpack_require__(408);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__ConfiguracaoApuracaoAcordo_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__ConfiguracaoApuracaoAcordo_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ConfiguracaoApuracaoAcordo_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(1157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ConfiguracaoApuracaoAcordo_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__ConfiguracaoApuracaoAcordo_vue_vue_type_template_id_787ed353_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ConfiguracaoApuracaoAcordo_vue_vue_type_template_id_787ed353_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoApuracaoAcordo_vue_vue_type_template_id_787ed353_lang_html___ = __webpack_require__(1155);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoApuracaoAcordo_vue_vue_type_template_id_787ed353_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoApuracaoAcordo_vue_vue_type_template_id_787ed353_lang_html___["b"]; });


/***/ }),
/* 1155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"md-title"},[_vm._v(_vm._s(_vm.$t('label.tipo_acordo'))+":")]),_vm._v(" "),_c('md-layout',{staticClass:"ConfiguracaoApuracao__pading32",attrs:{"md-row":"","md-gutter":"","md-flex":"50"}},[_c('md-input-container',[_c('label',[_vm._v(_vm._s(_vm.$t('label.selecione')))]),_vm._v(" "),_c('md-select',{attrs:{"id":"configuracao-workflow-contrato-select-nomeAcordo","tabindex":"2"},model:{value:(_vm.tipoAcordo),callback:function ($$v) {_vm.tipoAcordo=$$v},expression:"tipoAcordo"}},_vm._l((_vm.contratosCombobox),function(item,index){return _c('md-option',{key:index,attrs:{"value":item.nomeAcordo},on:{"selected":function($event){return _vm.requestPopularConfiguracoesContrato(item)}}},[_vm._v("\n          "+_vm._s(item.nomeAcordo)+"\n        ")])}),1)],1)],1),_vm._v(" "),_vm._l((_vm.grupos),function(grupo,key){return (_vm.hasConfiguracoesContrato)?[_c('hr',{attrs:{"color":"#DFDFDF"}}),_vm._v(" "),_c('h1',{staticClass:"md-title"},[_vm._v(_vm._s(_vm.$tc(("label." + (key.toLowerCase())), 1))+":")]),_vm._v(" "),_vm._l((grupo),function(item,index){return _c('md-layout',{key:index},[_c('md-layout',{staticClass:"ConfiguracaoApuracao__pading32",attrs:{"md-row":"","md-gutter":"","md-flex":"100"}},[_c('md-checkbox',{staticClass:"md-primary",attrs:{"id":("configuracao-workflow-contrato-checkbox-vlrSelecao-grupo-" + key),"md-gutter":"","disabled":_vm.disableCheck},on:{"change":function($event){return _vm.requestAtualizarConfiguracao(item, $event)}},model:{value:(item.vlrSelecao),callback:function ($$v) {_vm.$set(item, "vlrSelecao", $$v)},expression:"item.vlrSelecao"}}),_vm._v(" "),_c('md-layout',{attrs:{"md-gutter":""}},[_c('span',{staticClass:"ConfiguracaoApuracao__margin14 Configuracao__fontsize",domProps:{"textContent":_vm._s(_vm.$t(("configuracao." + (item.nome))))}}),_vm._v(" "),_c('span',{staticClass:"md-caption ConfiguracaoApuracao__margin18",domProps:{"textContent":_vm._s(_vm.$t(("configuracao." + (item.nome) + "_DESCRICAO")))}})])],1),_vm._v(" "),(item.atributos)?_c('md-layout',{staticClass:"ConfiguracaoWorkflowAprovacao__pading48"},[(item.atributos.tipo === 'switch')?_c('md-switch',{staticClass:"md-primary",attrs:{"id":"configuracao-workflow-aprovacao-switch-habilitaCondicaoPasso","tabindex":"2","md-column":"","md-gutter":"","disabled":!_vm.grupos[key][index].vlrSelecao,"disabled":_vm.disableCheck},on:{"change":function($event){return _vm.requestAtualizarSubConfiguracao(item)}},model:{value:(item.atributos.valor),callback:function ($$v) {_vm.$set(item.atributos, "valor", $$v)},expression:"item.atributos.valor"}}):_vm._e(),_vm._v(" "),(item.atributos && item.atributos.label && item.atributos.tipo === 'switch')?_c('md-layout',{attrs:{"md-column":"","md-gutter":""}},[_c('span',{staticClass:"ConfiguracaoWorkflowAprovacao__margin12",domProps:{"textContent":_vm._s(_vm.$t('configuracao.' +  item.atributos.label))}})]):_vm._e()],1):_vm._e(),_vm._v(" "),(item.atributos)?_c('md-layout',{staticClass:"ConfiguracaoWorkflowAprovacao__pading48",attrs:{"md-row":"","md-flex":"100"}},[(item.atributos.evidencia === 'evidencia')?_c('md-switch',{staticClass:"md-primary",attrs:{"id":"configuracao-workflow-aprovacao-switch-habilitaObrigatoriedadeEvidencia","tabindex":"3","md-column":"","md-gutter":"","disabled":!_vm.grupos[key][index].vlrSelecao,"disabled":_vm.disableCheck},on:{"change":function($event){return _vm.requestAtualizarSubConfiguracao(item)}},model:{value:(item.atributos.valor_evidencia),callback:function ($$v) {_vm.$set(item.atributos, "valor_evidencia", $$v)},expression:"item.atributos.valor_evidencia"}}):_vm._e(),_vm._v(" "),(item.atributos && item.atributos.label && item.atributos.evidencia === 'evidencia')?_c('md-layout',{attrs:{"md-column":"","md-gutter":""}},[_c('span',{staticClass:"ConfiguracaoWorkflowAprovacao__margin12",domProps:{"textContent":_vm._s(_vm.$t('configuracao.' +  item.atributos.label_evidencia))}})]):_vm._e()],1):_vm._e()],1)})]:_vm._e()}),_vm._v(" "),_c('hr',{attrs:{"color":"#DFDFDF"}})],2)}
var staticRenderFns = []



/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'configuracao/apuracao-acordo');

var configuracaoApuracaoAcordo = {
  atualizarTipoAcordo: { method: 'PUT', url: basePath + '/{nomeAcordo}?valorSelecao={valorSelecao}' },
  atualizarConfiguracoesApuracaoAcordo: { method: 'PUT', url: '' + basePath },
  atualizarSubConfiguracoesApuracaoAcordo: { method: 'PUT', url: basePath + '/sub-configuracao' },
  pesquisar: { method: 'GET', url: basePath + '?tamanhoPagina={size}&numeroPagina={page}' },
  pesquisarConfiguracoesApuracaoAcordo: { method: 'GET', url: basePath + '/{nomeAcordo}' }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, configuracaoApuracaoAcordo);
};

/***/ }),
/* 1157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoApuracaoAcordo_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoApuracaoAcordo_vue_vue_type_style_index_0_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoApuracaoAcordo_vue_vue_type_style_index_0_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoApuracaoAcordo_vue_vue_type_style_index_0_lang_css____default.a); 

/***/ }),
/* 1158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ConfiguracaoPagamento_vue_vue_type_template_id_04c0d7e2_lang_html___ = __webpack_require__(1159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ConfiguracaoPagamento_vue_vue_type_script_lang_js___ = __webpack_require__(411);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__ConfiguracaoPagamento_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__ConfiguracaoPagamento_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ConfiguracaoPagamento_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(1161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ConfiguracaoPagamento_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__ConfiguracaoPagamento_vue_vue_type_template_id_04c0d7e2_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ConfiguracaoPagamento_vue_vue_type_template_id_04c0d7e2_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoPagamento_vue_vue_type_template_id_04c0d7e2_lang_html___ = __webpack_require__(1160);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoPagamento_vue_vue_type_template_id_04c0d7e2_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoPagamento_vue_vue_type_template_id_04c0d7e2_lang_html___["b"]; });


/***/ }),
/* 1160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.sapVisible)?_c('md-layout',[_c('md-layout',{attrs:{"md-row":"","md-gutter":"","md-flex":"15"}},[_c('h1',{staticClass:"md-title"},[_vm._v(_vm._s(_vm.$t('configuracao.SAP'))+":")]),_vm._v(" "),_c('span',{staticClass:" Configuracao__fontsize",domProps:{"textContent":_vm._s(_vm.$t('configuracao.SAP_DESCRICAO'))}})]),_vm._v(" "),_c('md-layout',{staticClass:"ConfiguracaoOrcamento__pading32",attrs:{"md-flex":"85"}},[_c('md-switch',{staticClass:"md-primary",attrs:{"id":"configuracao-pagamento-switch-rateio-valorParametro","md-gutter":""},on:{"change":function($event){return _vm.requestAtualizar(_vm.moduloPagamento)}},model:{value:(_vm.moduloPagamento.valorParametro),callback:function ($$v) {_vm.$set(_vm.moduloPagamento, "valorParametro", $$v)},expression:"moduloPagamento.valorParametro"}}),_vm._v(" "),_c('span',{staticClass:"ConfiguracaoOrcamento__margin12",domProps:{"textContent":_vm._s(_vm.$t('configuracao.SAP_TOGGLE'))}})],1),_vm._v(" "),_c('hr')],1):_vm._e()],1)}
var staticRenderFns = []



/***/ }),
/* 1161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoPagamento_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoPagamento_vue_vue_type_style_index_0_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoPagamento_vue_vue_type_style_index_0_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoPagamento_vue_vue_type_style_index_0_lang_css____default.a); 

/***/ }),
/* 1162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ConfiguracaoCadastro_vue_vue_type_template_id_61d509c8_lang_html___ = __webpack_require__(1163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ConfiguracaoCadastro_vue_vue_type_script_lang_js___ = __webpack_require__(414);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__ConfiguracaoCadastro_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__ConfiguracaoCadastro_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ConfiguracaoCadastro_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(1166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ConfiguracaoCadastro_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__ConfiguracaoCadastro_vue_vue_type_template_id_61d509c8_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ConfiguracaoCadastro_vue_vue_type_template_id_61d509c8_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoCadastro_vue_vue_type_template_id_61d509c8_lang_html___ = __webpack_require__(1164);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoCadastro_vue_vue_type_template_id_61d509c8_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoCadastro_vue_vue_type_template_id_61d509c8_lang_html___["b"]; });


/***/ }),
/* 1164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.configuracoes),function(grupo,key){return _c('md-layout',{key:key},[_c('md-layout',{attrs:{"md-row":"","md-gutter":"","md-flex":"15"}},[_c('h1',{staticClass:"md-title"},[_vm._v(_vm._s(_vm.$tc(("label." + (grupo.chaveParametro.toLowerCase())), 1))+":")])]),_vm._v(" "),_c('md-layout',{staticClass:"ConfiguracaoOrcamento__pading32",attrs:{"md-flex":"85"}},[_c('md-switch',{staticClass:"md-primary",attrs:{"id":"configuracao-pagamento-switch-rateio-valorParametro","md-gutter":""},on:{"change":function($event){return _vm.requestAtualizar(grupo)}},model:{value:(grupo.valorParametro),callback:function ($$v) {_vm.$set(grupo, "valorParametro", $$v)},expression:"grupo.valorParametro"}})],1),_vm._v(" "),_c('hr')],1)}),1)}
var staticRenderFns = []



/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'configuracao-cadastro');

var configuracaoCadastroActions = {
  atualizar: { method: 'PUT', url: '' + basePath },
  pesquisar: { method: 'GET', url: '' + basePath }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, configuracaoCadastroActions);
};

/***/ }),
/* 1166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoCadastro_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoCadastro_vue_vue_type_style_index_0_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoCadastro_vue_vue_type_style_index_0_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoCadastro_vue_vue_type_style_index_0_lang_css____default.a); 

/***/ }),
/* 1167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ConfiguracaoNotificacaoEmail_vue_vue_type_template_id_31a96a35_scoped_true___ = __webpack_require__(1168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ConfiguracaoNotificacaoEmail_vue_vue_type_script_lang_js___ = __webpack_require__(417);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__ConfiguracaoNotificacaoEmail_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__ConfiguracaoNotificacaoEmail_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ConfiguracaoNotificacaoEmail_vue_vue_type_style_index_0_id_31a96a35_scoped_true_lang_css___ = __webpack_require__(1174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ConfiguracaoNotificacaoEmail_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__ConfiguracaoNotificacaoEmail_vue_vue_type_template_id_31a96a35_scoped_true___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ConfiguracaoNotificacaoEmail_vue_vue_type_template_id_31a96a35_scoped_true___["b" /* staticRenderFns */],
  false,
  null,
  "31a96a35",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoNotificacaoEmail_vue_vue_type_template_id_31a96a35_scoped_true___ = __webpack_require__(1169);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoNotificacaoEmail_vue_vue_type_template_id_31a96a35_scoped_true___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoNotificacaoEmail_vue_vue_type_template_id_31a96a35_scoped_true___["b"]; });


/***/ }),
/* 1169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"md-title"},[_vm._v(_vm._s(_vm.$t('title.email_alerta_negociacao')))]),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":""}},_vm._l((_vm.negociacao),function(negociacao,index){return _c('md-layout',{key:index,staticClass:"ConfiguracaoLinha",attrs:{"md-flex":"100"}},[_c('span',{staticClass:"ConfiguracaoTexto"},[_vm._v("\n        "+_vm._s(_vm.$t(negociacao.status))+":\n      ")]),_vm._v(" "),_c('div',{staticClass:"ConfiguracaoNumero"},[_c('md-input-container',[_c('md-input',{staticClass:"campo-numero",class:{ 'erro': _vm.emailErrors.negociacao.numero[index] },attrs:{"type":"number","for":"teste-numero"},model:{value:(negociacao.valorParametro),callback:function ($$v) {_vm.$set(negociacao, "valorParametro", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"negociacao.valorParametro"}}),_vm._v(" "),(_vm.emailErrors.negociacao.numero[index])?_c('span',{staticClass:"error-message"},[_vm._v("\n            "+_vm._s(_vm.emailErrors.negociacao.numero[index])+"\n          ")]):_vm._e()],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.dias_inatividade')))])],1),_vm._v(" "),_c('div',{staticClass:"ConfiguracaoSwitch"},[_c('md-switch',{staticClass:"md-primary",attrs:{"id":("switch-linha-" + index),"md-gutter":""},model:{value:(negociacao.enviarAlternativo),callback:function ($$v) {_vm.$set(negociacao, "enviarAlternativo", $$v)},expression:"negociacao.enviarAlternativo"}},[_vm._v("\n          "+_vm._s(_vm.$t('label.ativar_envio_email'))+"\n        ")])],1),_vm._v(" "),_c('div',{staticClass:"ConfiguracaoTextoEmail"},[_c('md-input-container',[_c('md-input',{staticClass:"campo-texto",class:{ 'erro': _vm.emailErrors.negociacao.email[index] },attrs:{"type":"text","readonly":!negociacao.enviarAlternativo},model:{value:(negociacao.emailAlternativo),callback:function ($$v) {_vm.$set(negociacao, "emailAlternativo", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"negociacao.emailAlternativo"}}),_vm._v(" "),(_vm.emailErrors.negociacao.email[index])?_c('span',{staticClass:"error-message"},[_vm._v("\n            "+_vm._s(_vm.emailErrors.negociacao.email[index])+"\n          ")]):_vm._e()],1)],1)])}),1),_vm._v(" "),_c('hr',{staticClass:"hr"}),_vm._v(" "),_c('h1',{staticClass:"md-title"},[_vm._v(_vm._s(_vm.$t('title.email_alerta_apuracao')))]),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":""}},_vm._l((_vm.apuracao),function(apuracao,index){return _c('md-layout',{key:index,staticClass:"ConfiguracaoLinha",attrs:{"md-flex":"100"}},[_c('span',{staticClass:"ConfiguracaoTexto"},[_vm._v("\n        "+_vm._s(_vm.$t(apuracao.status))+":\n      ")]),_vm._v(" "),_c('div',{staticClass:"ConfiguracaoNumero"},[_c('md-input-container',[_c('md-input',{staticClass:"campo-numero",class:{ 'erro': _vm.emailErrors.apuracao.numero[index] },attrs:{"type":"number","for":"teste-numero"},model:{value:(apuracao.valorParametro),callback:function ($$v) {_vm.$set(apuracao, "valorParametro", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"apuracao.valorParametro"}}),_vm._v(" "),(_vm.emailErrors.apuracao.numero[index])?_c('span',{staticClass:"error-message"},[_vm._v("\n            "+_vm._s(_vm.emailErrors.apuracao.numero[index])+"\n          ")]):_vm._e()],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.dias_inatividade')))])],1),_vm._v(" "),_c('div',{staticClass:"ConfiguracaoSwitch"},[_c('md-switch',{staticClass:"md-primary",attrs:{"id":("switch-nova-linha-" + index),"md-gutter":""},model:{value:(apuracao.enviarAlternativo),callback:function ($$v) {_vm.$set(apuracao, "enviarAlternativo", $$v)},expression:"apuracao.enviarAlternativo"}},[_vm._v("\n          "+_vm._s(_vm.$t('label.ativar_envio_email'))+"\n        ")])],1),_vm._v(" "),_c('div',{staticClass:"ConfiguracaoTextoEmail"},[_c('md-input-container',[_c('md-input',{staticClass:"campo-texto",class:{ 'erro': _vm.emailErrors.apuracao.email[index] },attrs:{"type":"text","readonly":!apuracao.enviarAlternativo},model:{value:(apuracao.emailAlternativo),callback:function ($$v) {_vm.$set(apuracao, "emailAlternativo", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"apuracao.emailAlternativo"}}),_vm._v(" "),(_vm.emailErrors.apuracao.email[index])?_c('span',{staticClass:"error-message"},[_vm._v("\n            "+_vm._s(_vm.emailErrors.apuracao.email[index])+"\n          ")]):_vm._e()],1)],1)])}),1),_vm._v(" "),_c('hr',{staticClass:"hr"}),_vm._v(" "),_c('h1',{staticClass:"md-title"},[_vm._v(_vm._s(_vm.$t('title.email_alerta_pagamento')))]),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":""}},_vm._l((_vm.pagamento),function(pagamento,index){return _c('md-layout',{key:index,staticClass:"ConfiguracaoLinha",attrs:{"md-flex":"100"}},[_c('span',{staticClass:"ConfiguracaoTexto"},[_vm._v("\n        "+_vm._s(_vm.$t(pagamento.status))+":\n      ")]),_vm._v(" "),_c('div',{staticClass:"ConfiguracaoNumero"},[_c('md-input-container',[_c('md-input',{staticClass:"campo-numero",class:{ 'erro': _vm.emailErrors.pagamento.numero[index] },attrs:{"type":"number","for":"teste-numero"},model:{value:(pagamento.valorParametro),callback:function ($$v) {_vm.$set(pagamento, "valorParametro", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"pagamento.valorParametro"}}),_vm._v(" "),(_vm.emailErrors.pagamento.numero[index])?_c('span',{staticClass:"error-message"},[_vm._v("\n            "+_vm._s(_vm.emailErrors.pagamento.numero[index])+"\n          ")]):_vm._e()],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.dias_inatividade')))])],1),_vm._v(" "),_c('div',{staticClass:"ConfiguracaoSwitch"},[_c('md-switch',{staticClass:"md-primary",attrs:{"id":("switch-linha-" + index),"md-gutter":""},model:{value:(pagamento.enviarAlternativo),callback:function ($$v) {_vm.$set(pagamento, "enviarAlternativo", $$v)},expression:"pagamento.enviarAlternativo"}},[_vm._v("\n          "+_vm._s(_vm.$t('label.ativar_envio_email'))+"\n        ")])],1),_vm._v(" "),_c('div',{staticClass:"ConfiguracaoTextoEmail"},[_c('md-input-container',[_c('md-input',{staticClass:"campo-texto",class:{ 'erro': _vm.emailErrors.pagamento.email[index] },attrs:{"type":"text","readonly":!pagamento.enviarAlternativo},model:{value:(pagamento.emailAlternativo),callback:function ($$v) {_vm.$set(pagamento, "emailAlternativo", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"pagamento.emailAlternativo"}}),_vm._v(" "),(_vm.emailErrors.pagamento.email[index])?_c('span',{staticClass:"error-message"},[_vm._v("\n            "+_vm._s(_vm.emailErrors.pagamento.email[index])+"\n          ")]):_vm._e()],1)],1)])}),1),_vm._v(" "),_c('div',{staticClass:"botoes-acoes"},[_c('v-btn',{nativeOn:{"click":function($event){return _vm.cancelar($event)}}},[_vm._v(_vm._s(_vm.$t('label.cancelar')))]),_vm._v(" "),_c('v-btn',{staticClass:"md-primary",nativeOn:{"click":function($event){return _vm.requestAtualizar($event)}}},[_vm._v(_vm._s(_vm.$t('label.salvar')))])],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'configuracao-notificacao-email');

var configuracaoNotificacaoEmail = {
  atualizar: { method: 'PUT', url: '' + basePath },
  pesquisar: { method: 'GET', url: '' + basePath }
};

exports.default = function (resource) {
  return resource('' + basePath, {}, configuracaoNotificacaoEmail);
};

/***/ }),
/* 1174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoNotificacaoEmail_vue_vue_type_style_index_0_id_31a96a35_scoped_true_lang_css___ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoNotificacaoEmail_vue_vue_type_style_index_0_id_31a96a35_scoped_true_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoNotificacaoEmail_vue_vue_type_style_index_0_id_31a96a35_scoped_true_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ConfiguracaoNotificacaoEmail_vue_vue_type_style_index_0_id_31a96a35_scoped_true_lang_css____default.a); 

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

var _genericResource = __webpack_require__(104);

var _genericResource2 = _interopRequireDefault(_genericResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basePath = (0, _apiResource2.default)('api', 'configuracao');

var configuracaoActions = (0, _extends3.default)({}, (0, _genericResource2.default)(basePath));

exports.default = function (resource) {
  return resource('' + basePath, {}, configuracaoActions);
};

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DashBoard = __webpack_require__(1177);

var _DashBoard2 = _interopRequireDefault(_DashBoard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  path: 'dashboard',
  name: 'dashboard',
  component: _DashBoard2.default
};

/***/ }),
/* 1177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DashBoard_vue_vue_type_template_id_8fca085e_scoped_true_lang_html___ = __webpack_require__(1178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DashBoard_vue_vue_type_script_lang_js___ = __webpack_require__(420);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__DashBoard_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__DashBoard_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DashBoard_vue_vue_type_style_index_1_lang_scss___ = __webpack_require__(1286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__DashBoard_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__DashBoard_vue_vue_type_template_id_8fca085e_scoped_true_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__DashBoard_vue_vue_type_template_id_8fca085e_scoped_true_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  "8fca085e",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DashBoard_vue_vue_type_template_id_8fca085e_scoped_true_lang_html___ = __webpack_require__(1179);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DashBoard_vue_vue_type_template_id_8fca085e_scoped_true_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DashBoard_vue_vue_type_template_id_8fca085e_scoped_true_lang_html___["b"]; });


/***/ }),
/* 1179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canAccessPage)?_c('v-row',[_c('md-tabs',{ref:"mdTab",staticClass:"md-transparent dashboard-tabs",attrs:{"md-fixed":""},on:{"change":_vm.setTab}},[_c('md-tab',{attrs:{"id":"orcamento","md-label":_vm.$tc('label.orcamento', 2),"md-disabled":!_vm.podeAcessarDashboardOrcamento}},[(_vm.podeAcessarDashboardOrcamento)?_c('dashboard-planejamento',{directives:[{name:"show",rawName:"v-show",value:(_vm.index === 0),expression:"index === 0"}],ref:"dash-orcamento",attrs:{"parametros":_vm.parametros}}):_vm._e()],1),_vm._v(" "),_c('md-tab',{attrs:{"id":"negociacao","md-label":_vm.$tc('label.negociacao', 2),"md-disabled":!_vm.podeAcessarDashboardNegociacao}},[(_vm.podeAcessarDashboardNegociacao)?_c('dashboard-negociacao',{directives:[{name:"show",rawName:"v-show",value:(_vm.index === 1),expression:"index === 1"}],ref:"dash-negociacao",attrs:{"parametros":_vm.parametros}}):_vm._e()],1),_vm._v(" "),_c('md-tab',{attrs:{"id":"apuracao","md-label":_vm.$tc('label.apuracao', 1),"md-disabled":!_vm.podeAcessarDashboardApuracao}},[(_vm.podeAcessarDashboardApuracao)?_c('dashboard-apuracao',{directives:[{name:"show",rawName:"v-show",value:(_vm.index === 2),expression:"index === 2"}],ref:"dash-apuracao",attrs:{"parametros":_vm.parametros},on:{"APURACAOTABELA_UPLOAD_EVIDENCIA":_vm.abrirSideBarApuracao}}):_vm._e()],1),_vm._v(" "),_c('md-tab',{attrs:{"id":"pagamento","md-label":_vm.$tc('label.pagamento', 1),"md-disabled":!_vm.podeAcessarDashboardPagamento}},[(_vm.podeAcessarDashboardPagamento)?_c('dashboard-pagamento',{directives:[{name:"show",rawName:"v-show",value:(_vm.index === 3),expression:"index === 3"}],ref:"dash-pagamento",attrs:{"parametros":_vm.parametros}}):_vm._e()],1),_vm._v(" "),_c('md-tab',{attrs:{"id":"acompanhamento","md-label":_vm.$t('title.negociacao_verbas'),"md-disabled":!_vm.podeAcessarAcompanhamento}},[(_vm.podeAcessarAcompanhamento)?_c('dashboard-acompanhamento',{directives:[{name:"show",rawName:"v-show",value:(_vm.index === 4),expression:"index === 4"}],ref:"dash-acompanhamento",attrs:{"parametros":_vm.parametros}}):_vm._e()],1)],1),_vm._v(" "),_c('execucao-sidebar-apuracao',{ref:"apuracaoExecSidebar",staticClass:"no-md-card",attrs:{"idMeta":_vm.apuracaoEmit.idMeta,"status":_vm.apuracaoEmit.status,"deletar":_vm.apuracaoEmit.deletar},on:{"EXECUCAOSIDEBAR_CLOSE":_vm.fecharSideBarApuracao}})],1):_vm._e()}
var staticRenderFns = []



/***/ }),
/* 1180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DashboardPlanejamento_vue_vue_type_template_id_7f595411_lang_html___ = __webpack_require__(1181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DashboardPlanejamento_vue_vue_type_script_lang_js___ = __webpack_require__(422);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__DashboardPlanejamento_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__DashboardPlanejamento_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__DashboardPlanejamento_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__DashboardPlanejamento_vue_vue_type_template_id_7f595411_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__DashboardPlanejamento_vue_vue_type_template_id_7f595411_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardPlanejamento_vue_vue_type_template_id_7f595411_lang_html___ = __webpack_require__(1182);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardPlanejamento_vue_vue_type_template_id_7f595411_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardPlanejamento_vue_vue_type_template_id_7f595411_lang_html___["b"]; });


/***/ }),
/* 1182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('md-layout',{attrs:{"md-column":""}},[_c('md-layout',[(_vm.anos)?_c('md-layout',{staticStyle:{"padding-left":"30px"},attrs:{"md-flex":"15","md-flex-medium":"30","md-flex-small":"100","md-flex-xsmall":"100"}},[_c('md-input-container',[_c('label',{attrs:{"for":"ano"}},[_vm._v(_vm._s(_vm.$t('label.ano')))]),_vm._v(" "),_c('md-select',{attrs:{"name":"ano","id":"anoPlanejamentoSelect","disabled":_vm.bloquearConsulta},model:{value:(_vm.ano),callback:function ($$v) {_vm.ano=$$v},expression:"ano"}},[_c('md-option',{attrs:{"value":null},on:{"selected":_vm.recarregarDashboard}},[_vm._v(_vm._s(_vm.$t('label.ver_todos')))]),_vm._v(" "),_vm._l((_vm.anos),function(opt,index){return _c('md-option',{key:index,attrs:{"value":opt.ano},on:{"selected":_vm.recarregarDashboard}},[_vm._v("\n              "+_vm._s(opt.ano)+"\n            ")])})],2)],1)],1):_vm._e(),_vm._v(" "),(_vm.unidadesNegocio.length)?_c('md-layout',{staticStyle:{"padding-left":"30px"},attrs:{"md-flex":"15","md-flex-medium":"30","md-flex-small":"100","md-flex-xsmall":"100"}},[_c('md-input-container',[_c('label',{attrs:{"for":"unidadeNegocioNegociacaoOrcamento"}},[_vm._v(_vm._s(_vm.$tc('label.unidade_negocio' ,1)))]),_vm._v(" "),_c('md-select',{attrs:{"name":"unidadeNegocioNegociacaoOrcamento","id":"unidadeNegocioNegociacaoOrcamentoSelect","disabled":_vm.bloquearConsulta},model:{value:(_vm.idUnidadeNegocio),callback:function ($$v) {_vm.idUnidadeNegocio=$$v},expression:"idUnidadeNegocio"}},[_c('md-option',{attrs:{"value":null},on:{"selected":_vm.recarregarDashboard}},[_vm._v("\n                "+_vm._s(_vm.$t('label.ver_todos'))+"\n              ")]),_vm._v(" "),_vm._l((_vm.unidadesNegocio),function(opt,index){return _c('md-option',{key:index,attrs:{"value":opt.id},on:{"selected":_vm.recarregarDashboard}},[_vm._v("\n                "+_vm._s(opt.nomExtensao)+"\n              ")])})],2)],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('box-valores-representante',{attrs:{"saldo-representante":_vm.saldoRepresentante,"carregando":_vm.carregandoBox}}),_vm._v(" "),(_vm.carregado)?_c('orcamento-tabela',{ref:"orcamentoTabela",staticClass:"CRUDGenerico__ContentTable",attrs:{"id":"DashOrcamentosPendentes","title":_vm.$tc('title.orcamento', 1),"bloquear-consulta":_vm.bloquearConsulta,"table-header":_vm.tableHeader,"table-rows":_vm.orcamentosListItens,"last-search-table-size":_vm.lastSearchTableSize,"periodo":_vm.ano,"id-unidade-negocio":_vm.idUnidadeNegocio,"carregando":_vm.carregandoTable,"paginas":_vm.paginas,"visible-columns":['nomeTipoWorkflow', 'tipo', 'nomeSolicitante', 'dtaSolicitacao', 'descricaoOrcamento', 'vlrOrcamento']},on:{"ORCAMENTOTABELA_FILTRAR":_vm.filtrarFluxos,"DASH_ORCAMENTO_TABELA_PAGINA":_vm.requestCargaMinhasAprovacoes}}):_vm._e()],1)}
var staticRenderFns = []



/***/ }),
/* 1183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OrcamentoTabelaDash_vue_vue_type_template_id_4f70164d_lang_html___ = __webpack_require__(1184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OrcamentoTabelaDash_vue_vue_type_script_lang_js___ = __webpack_require__(424);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__OrcamentoTabelaDash_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__OrcamentoTabelaDash_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_generico_Pagination_css_vue_type_style_index_0_lang_css___ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__OrcamentoTabelaDash_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__OrcamentoTabelaDash_vue_vue_type_template_id_4f70164d_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__OrcamentoTabelaDash_vue_vue_type_template_id_4f70164d_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_OrcamentoTabelaDash_vue_vue_type_template_id_4f70164d_lang_html___ = __webpack_require__(1185);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_OrcamentoTabelaDash_vue_vue_type_template_id_4f70164d_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_OrcamentoTabelaDash_vue_vue_type_template_id_4f70164d_lang_html___["b"]; });


/***/ }),
/* 1185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"tabindex":"100"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.preventDefault();return _vm.onArrowUpPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.preventDefault();return _vm.onArrowDownPress($event)}]}},[_c('md-dialog',{ref:_vm.dialog.ref,attrs:{"md-open-from":("#" + (_vm.dialog.from))}},[_c('md-dialog-title',[_vm._v(_vm._s(_vm.dialog.title))]),_vm._v(" "),_c('md-dialog-content',[_vm._v(_vm._s(_vm.dialog.content))]),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",attrs:{"id":"orcamento-tabela-dialog-cancel"},nativeOn:{"click":function($event){return _vm.closeDialog('dialog1')}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.cancelar'))+"\n      ")]),_vm._v(" "),(_vm.dialog.action)?_c('md-button',{staticClass:"md-primary",attrs:{"id":"orcamento-tabela-dialog-save"},nativeOn:{"click":function($event){return _vm.closeDialog('dialog1', _vm.dialog.action)}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.sim'))+"\n      ")]):_vm._e()],1)],1),_vm._v(" "),_c('status-passos',{ref:"modalAcompanhamento",attrs:{"source":_vm.statusPassos}}),_vm._v(" "),_c('md-dialog',{ref:"justificarDialog"},[_c('md-dialog-title',[_vm._v("\n      "+_vm._s(_vm.$t('label.justificativa'))+"\n    ")]),_vm._v(" "),_c('md-dialog-content',[_c('div',{staticStyle:{"width":"300px"}},[_c('md-input-container',{directives:[{name:"show",rawName:"v-show",value:(!_vm.justificarOrcamento.obrigatorio),expression:"!justificarOrcamento.obrigatorio"}]},[_c('label',[_vm._v("\n            "+_vm._s(_vm.$t('label.motivo'))+"\n          ")]),_vm._v(" "),_c('md-textarea',{attrs:{"name":"justificativa_orcamento"},model:{value:(_vm.justificarOrcamento.observacao),callback:function ($$v) {_vm.$set(_vm.justificarOrcamento, "observacao", $$v)},expression:"justificarOrcamento.observacao"}})],1),_vm._v(" "),_c('md-input-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.justificarOrcamento.obrigatorio),expression:"justificarOrcamento.obrigatorio"}],class:{
            'md-input-invalid': _vm.errors.has('justificativa_orcamento_obrigatorio'),
          }},[_c('label',[_vm._v("\n            "+_vm._s(_vm.$t('label.motivo'))+"\n          ")]),_vm._v(" "),_c('md-textarea',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"required":"","data-vv-rules":"required","name":"justificativa_orcamento_obrigatorio"},model:{value:(_vm.justificarOrcamento.observacao),callback:function ($$v) {_vm.$set(_vm.justificarOrcamento, "observacao", $$v)},expression:"justificarOrcamento.observacao"}})],1)],1)]),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",nativeOn:{"click":function($event){return _vm.closeDialog('justificarDialog')}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.cancelar'))+"\n      ")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary",nativeOn:{"click":function($event){return _vm.closeDialog('justificarDialog', _vm.justificarOrcamento.action)}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.salvar'))+"\n      ")])],1)],1),_vm._v(" "),(_vm.isHeaderAvailable)?_c('md-table-card',[_c('md-toolbar',[_c('h1',{staticClass:"md-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",attrs:{"id":"alcada-tabela-button-add","disabled":_vm.bloquearConsulta},nativeOn:{"click":function($event){return _vm.$refs.modal.open()}}},[_c('md-icon',[_vm._v("filter_list")])],1)],1),_vm._v(" "),_c('filtros-dash',{ref:"modal",attrs:{"filtro":_vm.filtro},on:{"FILTROSDASH_FILTRAR":_vm.filtrarModal}}),_vm._v(" "),_c('div',{staticClass:"TabelaGenerica__TableWrapper"},[_c('div',{staticClass:"md-table TabelaGenerica__Table"},[_c('table',{ref:"myTable"},[_c('thead',{staticClass:"md-table-header"},[_c('tr',{staticClass:"md-table-row"},[_c('td',{staticClass:"md-table-cell md-table-selection md-has-action"},[_c('div',{staticClass:"md-table-cell-container"},[_c('md-checkbox',{staticClass:"md-accent",on:{"change":_vm.toggleSelecaoGeral}})],1)]),_vm._v(" "),_vm._l((_vm.tableHeader),function(head,index){return _c('th',{key:index,staticClass:"md-table-head",class:head.classes,attrs:{"md-tooltip":head.tooltip,"md-sort-by":head.sortType}},[_vm._v("\n                "+_vm._s(head.name)+"\n              ")])})],2)]),_vm._v(" "),_c('tbody',{staticClass:"md-table-body"},_vm._l((_vm.filteredList),function(row,rowIndex){return _c('tr',{key:rowIndex,staticClass:"md-table-row",class:{
                'TabelaGenerica__TableRow--highlight': _vm.currentEditItem && _vm.currentEditItem === row,
              },attrs:{"md-item":row,"md-selection":""}},[_c('td',{staticClass:"md-table-cell md-table-selection md-has-action"},[_c('div',{staticClass:"md-table-cell-container"},[_c('md-checkbox',{staticClass:"md-accent",on:{"change":function($event){return _vm.toggleSelecaoUnica(row)}},model:{value:(row.selecionado),callback:function ($$v) {_vm.$set(row, "selecionado", $$v)},expression:"row.selecionado"}})],1)]),_vm._v(" "),_c('td',{staticClass:"md-table-cell"},[_c('span',{domProps:{"textContent":_vm._s(row.nomeTipoWorkflow)}})]),_vm._v(" "),_c('td',{staticClass:"md-table-cell"},[(row.idTipoWorkflow !== 3)?_c('span',{domProps:{"textContent":_vm._s(row.tipo)}}):_vm._e(),_vm._v(" "),(row.idTipoWorkflow === 3)?_c('span',{domProps:{"textContent":_vm._s(_vm.$t(("label." + (row.tipo.toLowerCase()))))}}):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"md-table-cell"},[_c('span',{domProps:{"textContent":_vm._s(row.nomeSolicitante)}})]),_vm._v(" "),_c('td',{staticClass:"md-table-cell"},[_c('span',{domProps:{"textContent":_vm._s(row.dtaSolicitacao)}})]),_vm._v(" "),_c('td',{staticClass:"md-table-cell"},[_c('span',{domProps:{"textContent":_vm._s(row.descricaoOrcamento)}})]),_vm._v(" "),_c('td',{staticClass:"md-table-cell"},[_c('span',{domProps:{"textContent":_vm._s(_vm.getMoney(row.vlrOrcamento))}})]),_vm._v(" "),_c('td',{staticClass:"md-table-cell"},[_c('md-menu',{attrs:{"md-direction":"top left","md-size":"4"}},[_c('md-button',{staticClass:"md-icon-button",attrs:{"md-menu-trigger":""}},[_c('md-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('md-menu-content',[_c('md-menu-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.temJustificativa(row)),expression:"temJustificativa(row)"}],nativeOn:{"click":function($event){return _vm.requestBuscarMotivoLog(row)}}},[_c('md-icon',[_vm._v("view_headline")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.justificativa')))])],1),_vm._v(" "),_c('md-menu-item',{nativeOn:{"click":function($event){return _vm.verItem(row)}}},[_c('md-icon',[_vm._v("equalizer")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.mais_detalhes')))])],1),_vm._v(" "),(row.usuarioAprovador)?_c('md-menu-item',{nativeOn:{"click":function($event){return _vm.openDialogReprovar(_vm.dialog.ref, row)}}},[_c('md-icon',[_vm._v("thumb_down")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.reprovar')))])],1):_vm._e(),_vm._v(" "),(row.usuarioAprovador)?_c('md-menu-item',{nativeOn:{"click":function($event){return _vm.openDialogAprovar(_vm.dialog.ref, row)}}},[_c('md-icon',[_vm._v("thumb_up")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.aprovar')))])],1):_vm._e(),_vm._v(" "),_c('md-menu-item',{nativeOn:{"click":function($event){return _vm.requestAbrirAcompanhamento(row)}}},[_c('md-icon',[_vm._v("assignment_turned_in")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.acompanhamento')))])],1)],1)],1)],1)])}),0)])]),_vm._v(" "),(!_vm.carregando)?_c('paginate',{directives:[{name:"show",rawName:"v-show",value:(_vm.isContentAvailable && _vm.paginas > 1),expression:"isContentAvailable && paginas > 1"}],attrs:{"page-count":_vm.paginas,"click-handler":_vm.clickHandler,"initial-page":_vm.indexPagina,"prev-text":_vm.$t('label.anterior'),"next-text":_vm.$tc('label.proximo', 1),"container-class":'pagination'}}):_vm._e(),_vm._v(" "),_c('h4',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isContentAvailable && !_vm.carregando),expression:"!isContentAvailable && !carregando"}],staticClass:"TabelaGenerica__NoContent"},[_vm._v("\n          "+_vm._s(_vm.$t('label.tabela_sem_conteudo'))+"\n      ")]),_vm._v(" "),_c('md-spinner',{directives:[{name:"show",rawName:"v-show",value:(_vm.carregando),expression:"carregando"}],staticClass:"TabelaGenerica__InterminateLoader",attrs:{"md-indeterminate":""}})],1)],1):_vm._e()],1)}
var staticRenderFns = []



/***/ }),
/* 1186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FiltrosDashOrcamento_vue_vue_type_template_id_a7110b48___ = __webpack_require__(1187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FiltrosDashOrcamento_vue_vue_type_script_lang_js___ = __webpack_require__(426);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__FiltrosDashOrcamento_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__FiltrosDashOrcamento_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FiltrosDashOrcamento_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(1189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__FiltrosDashOrcamento_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__FiltrosDashOrcamento_vue_vue_type_template_id_a7110b48___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__FiltrosDashOrcamento_vue_vue_type_template_id_a7110b48___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosDashOrcamento_vue_vue_type_template_id_a7110b48___ = __webpack_require__(1188);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosDashOrcamento_vue_vue_type_template_id_a7110b48___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosDashOrcamento_vue_vue_type_template_id_a7110b48___["b"]; });


/***/ }),
/* 1188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-dialog',{ref:"modal",staticClass:"ResponsiveModal",attrs:{"md-open-from":_vm.mdOpenFrom},on:{"open":_vm.onOpen,"close":_vm.onClose}},[_c('md-dialog-title',[_vm._v(_vm._s(_vm.$tc('title.filtro', 2)))]),_vm._v(" "),_c('md-dialog-content',[_c('md-layout',{attrs:{"md-gutter":"6"}},[_c('md-layout',{staticClass:"MdFlexCustom",attrs:{"md-flex":"45","md-flex-medium":"45","md-flex-small":"95","md-flex-xsmall":"95"}},[_c('md-input-container',[_c('label',{attrs:{"for":"tipoFluxo"}},[_vm._v(_vm._s(_vm.$t('label.fluxo')))]),_vm._v(" "),_c('md-select',{attrs:{"name":"tipoFluxo","id":"tipoFluxoSelect"},model:{value:(_vm.filtro.fluxo),callback:function ($$v) {_vm.$set(_vm.filtro, "fluxo", $$v)},expression:"filtro.fluxo"}},[_c('md-option',{attrs:{"value":null}},[_vm._v(_vm._s(_vm.$t('label.ver_todos')))]),_vm._v(" "),_vm._l((_vm.fluxos),function(opt,index){return _c('md-option',{key:index,attrs:{"value":opt.id}},[_vm._v("\n                "+_vm._s(opt.nome)+"\n              ")])})],2)],1)],1),_vm._v(" "),_c('md-layout',{staticClass:"MdFlexCustom",attrs:{"md-flex":"45","md-flex-medium":"45","md-flex-small":"95","md-flex-xsmall":"95"}},[_c('md-input-container',[_c('label',{attrs:{"for":"statusOrcamento"}},[_vm._v(_vm._s(_vm.$t('label.status')))]),_vm._v(" "),_c('md-select',{attrs:{"name":"statusOrcamento","id":"statusOrcamentoSelect","disabled":_vm.statusBloqueado},model:{value:(_vm.filtro.status),callback:function ($$v) {_vm.$set(_vm.filtro, "status", $$v)},expression:"filtro.status"}},_vm._l((_vm.statusOrcamentoLista),function(opt,index){return _c('md-option',{key:index,attrs:{"value":opt.status}},[_vm._v("\n                "+_vm._s(opt.descricao)+"\n              ")])}),1)],1)],1),_vm._v(" "),_c('md-layout',{staticClass:"MdFlexCustom",attrs:{"md-flex":"45","md-flex-medium":"45","md-flex-small":"95","md-flex-xsmall":"95"}},[_c('md-switch',{staticClass:"md-primary",attrs:{"type":"button"},on:{"change":_vm.verificarMeuPassoPendente},model:{value:(_vm.filtro.meuPassoPendente),callback:function ($$v) {_vm.$set(_vm.filtro, "meuPassoPendente", $$v)},expression:"filtro.meuPassoPendente"}},[_vm._v("\n              "+_vm._s(_vm.$t('label.minhas_aprovacoes_pendentes'))+"\n          ")])],1),_vm._v(" "),_c('md-layout',{staticClass:"MdFlexCustom",attrs:{"md-flex":"45","md-flex-medium":"45","md-flex-small":"95","md-flex-xsmall":"95"}},[_c('md-switch',{staticClass:"md-primary",attrs:{"type":"button"},on:{"change":_vm.verificarMeuPassoAprovado},model:{value:(_vm.filtro.meuPassoAprovado),callback:function ($$v) {_vm.$set(_vm.filtro, "meuPassoAprovado", $$v)},expression:"filtro.meuPassoAprovado"}},[_vm._v("\n              "+_vm._s(_vm.$t('label.meus_passos_aprovados'))+"\n          ")])],1),_vm._v(" "),_c('md-layout',{staticClass:"MdFlexCustom",attrs:{"md-flex":"45","md-flex-medium":"45","md-flex-small":"95","md-flex-xsmall":"95"}},[_c('v-menu',{ref:"data_inicio",staticStyle:{"z-index":"10000!important"},attrs:{"id":"data_inicio","name":"data_inicio","nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({staticClass:"dataInicio",attrs:{"return-masked-value":true,"mask":"##-##-####","rules":[_vm.rules.validDate],"label":((_vm.$t('label.data_inicio')) + " *")},model:{value:(_vm.dateInicioFormatada),callback:function ($$v) {_vm.dateInicioFormatada=$$v},expression:"dateInicioFormatada"}},on))]}}]),model:{value:(_vm.menuDataInicio),callback:function ($$v) {_vm.menuDataInicio=$$v},expression:"menuDataInicio"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"pt-br","color":"primary"},on:{"input":function($event){_vm.menuDataInicio = false}},model:{value:(_vm.dataInicio),callback:function ($$v) {_vm.dataInicio=$$v},expression:"dataInicio"}})],1)],1),_vm._v(" "),_c('md-layout',{staticClass:"MdFlexCustom",attrs:{"md-flex":"45","md-flex-medium":"45","md-flex-small":"95","md-flex-xsmall":"95"}},[_c('v-menu',{ref:"data_fim",staticStyle:{"z-index":"10000!important"},attrs:{"close-on-content-click":false,"id":"data_fim","name":"data_fim","nudge-right":40,"lazy":"","readonly":false,"transition":"scale-transition","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({staticClass:"data_fim",attrs:{"disabled":_vm.habilitarDataFim,"return-masked-value":true,"mask":"##-##-####","rules":[_vm.rules.required, _vm.rules.validDate],"label":((_vm.$t('label.data_fim')) + " *")},model:{value:(_vm.dateFimFormatada),callback:function ($$v) {_vm.dateFimFormatada=$$v},expression:"dateFimFormatada"}},on))]}}]),model:{value:(_vm.menuDataFim),callback:function ($$v) {_vm.menuDataFim=$$v},expression:"menuDataFim"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"pt-br","color":"primary","min":_vm.dataInicio},on:{"input":function($event){_vm.menuDataFim = false}},model:{value:(_vm.dataFim),callback:function ($$v) {_vm.dataFim=$$v},expression:"dataFim"}})],1)],1),_vm._v(" "),_c('md-layout',{staticClass:"MdFlexCustom",attrs:{"md-flex":"45","md-flex-medium":"45","md-flex-small":"95","md-flex-xsmall":"95"}},[_c('md-input-container',[_c('label',{attrs:{"for":"tipo_ajuste"}},[_vm._v(_vm._s(_vm.$tc('label.tipo_ajuste', 1)))]),_vm._v(" "),_c('md-select',{attrs:{"name":"tipo_ajuste","id":"tipo_ajuste"},model:{value:(_vm.filtro.tipo),callback:function ($$v) {_vm.$set(_vm.filtro, "tipo", $$v)},expression:"filtro.tipo"}},[_c('md-option',{attrs:{"value":null}},[_vm._v(_vm._s(_vm.$t('label.ver_todos')))]),_vm._v(" "),_vm._l((_vm.tipoAjuste),function(opt,index){return _c('md-option',{key:index,attrs:{"value":opt.nome}},[_vm._v("\n                 "+_vm._s(_vm.$t(("" + (opt.label))))+"\n              ")])})],2)],1)],1),_vm._v(" "),_c('md-layout',{staticClass:"MdFlexCustom",attrs:{"md-flex":"45","md-flex-medium":"45","md-flex-small":"95","md-flex-xsmall":"95"}},[_c('md-input-container',[_c('v-autocomplete',{ref:"refMarca",staticClass:"filtro-autocomplete-marca",attrs:{"item-text":"nomExtensao","item-value":"id","multiple":"","label":_vm.$tc('label.marca', 1),"no-data-text":_vm.$tc('message.nenhum_registro', 1),"items":_vm.marcas,"chips":"","deletable-chips":"","clearable":""},nativeOn:{"click":function($event){return _vm.fechaLista($event)}},model:{value:(_vm.filtro.idsMarcas),callback:function ($$v) {_vm.$set(_vm.filtro, "idsMarcas", $$v)},expression:"filtro.idsMarcas"}})],1)],1),_vm._v(" "),_c('md-layout',{staticClass:"MdFlexCustom",attrs:{"md-flex":"95","md-flex-medium":"95","md-flex-small":"95","md-flex-xsmall":"95"}},[_c('md-input-container',[_c('label',{attrs:{"for":"descricao_orcamento"}},[_vm._v(_vm._s(_vm.$t('label.descricao_orcamento')))]),_vm._v(" "),_c('md-input',{attrs:{"id":"descrição_orcamento","type":"text"},model:{value:(_vm.filtro.descricao),callback:function ($$v) {_vm.$set(_vm.filtro, "descricao", $$v)},expression:"filtro.descricao"}})],1)],1)],1)],1),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{nativeOn:{"click":function($event){return _vm.limparFiltros($event)}}},[_vm._v("\n          "+_vm._s(_vm.$t('label.limpar_filtros'))+"\n        ")]),_vm._v(" "),_c('md-button',{nativeOn:{"click":function($event){return _vm.defaultClose($event)}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.cancelar'))+"\n      ")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary",attrs:{"disabled":_vm.habilitarFiltro},nativeOn:{"click":function($event){return _vm.filtrar($event)}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.filtrar'))+"\n      ")])],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosDashOrcamento_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosDashOrcamento_vue_vue_type_style_index_0_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosDashOrcamento_vue_vue_type_style_index_0_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosDashOrcamento_vue_vue_type_style_index_0_lang_css____default.a); 

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'DashboardOrcamento',
  data: function data() {
    return {
      tableHeader: [{
        name: this.$t('label.fluxo'),
        tooltip: this.$t('label.fluxo'),
        classes: []
      }, {
        name: this.$tc('label.tipo', 1),
        tooltip: this.$tc('label.tipo', 1),
        classes: []
      }, {
        name: this.$t('label.solicitante'),
        tooltip: this.$t('label.solicitante'),
        classes: []
      }, {
        name: this.$t('label.data_solicitacao'),
        tooltip: this.$t('label.data_solicitacao'),
        classes: []
      }, {
        name: this.$t('label.descricao'),
        tooltip: this.$t('label.descricao'),
        classes: []
      }, {
        name: this.$tc('label.valor', 1),
        tooltip: this.$tc('label.valor', 1),
        classes: []
      }, {
        name: '',
        classes: []
      }],
      stackData: {
        type: 'serial',
        theme: 'light',
        legend: {
          horizontalGap: 10,
          maxColumns: 1,
          position: 'right',
          useGraphSettings: true,
          markerSize: 10
        },
        dataProvider: [{
          year: 2003,
          europe: 2.5,
          namerica: 2.5,
          asia: 2.1
        }, {
          year: 2004,
          europe: 2.6,
          namerica: 2.7,
          asia: 2.2
        }, {
          year: 2005,
          europe: 2.8,
          namerica: 2.9,
          asia: 2.4
        }],
        valueAxes: [{
          stackType: 'regular',
          axisAlpha: 0.3,
          gridAlpha: 0
        }],
        graphs: [{
          balloonText: '<b>[[title]]</b><br><span style="font-size:14px">[[categor]: <b>[[value]]</b></span>',
          fillAlphas: 0.8,
          labelText: '[[value]]',
          lineAlpha: 0.3,
          title: 'Europe',
          type: 'column',
          color: '#000000',
          valueField: 'europe'
        }, {
          balloonText: '<b>[[title]]</b><br><span style="font-size:14px">[[categor]: <b>[[value]]</b></span>',
          fillAlphas: 0.8,
          labelText: '[[value]]',
          lineAlpha: 0.3,
          title: 'North America',
          type: 'column',
          color: '#000000',
          valueField: 'namerica'
        }, {
          balloonText: '<b>[[title]]</b><br><span style="font-size:14px">[[categor]: <b>[[value]]</b></span>',
          fillAlphas: 0.8,
          labelText: '[[value]]',
          lineAlpha: 0.3,
          title: 'Asia-Pacific',
          type: 'column',
          color: '#000000',
          valueField: 'asia'
        }],
        categoryField: 'year',
        categoryAxis: {
          gridPosition: 'start',
          axisAlpha: 0,
          gridAlpha: 0,
          position: 'left'
        },
        export: {
          enabled: true
        }
      }
    };
  },

  methods: {}
};

/***/ }),
/* 1191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BoxValoresRepresentante_vue_vue_type_template_id_2d037770_lang_html___ = __webpack_require__(1192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BoxValoresRepresentante_vue_vue_type_script_lang_js___ = __webpack_require__(430);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__BoxValoresRepresentante_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__BoxValoresRepresentante_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BoxValoresRepresentante_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(1194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__BoxValoresRepresentante_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__BoxValoresRepresentante_vue_vue_type_template_id_2d037770_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__BoxValoresRepresentante_vue_vue_type_template_id_2d037770_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_BoxValoresRepresentante_vue_vue_type_template_id_2d037770_lang_html___ = __webpack_require__(1193);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_BoxValoresRepresentante_vue_vue_type_template_id_2d037770_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_BoxValoresRepresentante_vue_vue_type_template_id_2d037770_lang_html___["b"]; });


/***/ }),
/* 1193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-layout',{staticClass:"Consolidados",attrs:{"md-gutter":"8"}},[_c('md-layout',{attrs:{"md-flex":"16","md-flex-medium":"33"}},[_c('md-whiteframe',{attrs:{"md-elevation":"6"}},[_c('div',{staticClass:"ValuesConsolidados",style:({
        'background-color': '#03a9f4'
      })},[_c('div',{staticClass:"Consolidados_Valores"},[_c('span',{staticClass:"Consolidados_Valores_Fonts"},[_vm._v(_vm._s(_vm.$t('label.planejado')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.carregando),expression:"!carregando"}],staticClass:"Consolidados_Valores_Fonts",attrs:{"id":"dash_op_card_planejado_val"}},[_vm._v(_vm._s(_vm.getMoney(this.getObjSaldo().vlrPlanejado, 0)))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.carregando),expression:"carregando"}],staticClass:"Consolidados_Valores_Fonts"},[_c('md-spinner',{attrs:{"md-size":30,"md-stroke":2,"md-indeterminate":""}})],1)])])])],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"16","md-flex-medium":"33"}},[_c('md-whiteframe',{attrs:{"md-elevation":"6"}},[_c('div',{staticClass:"ValuesConsolidados",style:({
        'background-color': '#ba68c8'
      })},[_c('div',{staticClass:"Consolidados_Valores"},[_c('span',{staticClass:"Consolidados_Valores_Fonts"},[_vm._v(_vm._s(_vm.$t('label.reservado')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.carregando),expression:"!carregando"}],staticClass:"Consolidados_Valores_Fonts"},[_vm._v(_vm._s(_vm.getMoney(this.getObjSaldo().vlrReservado, 0)))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.carregando),expression:"carregando"}],staticClass:"Consolidados_Valores_Fonts"},[_c('md-spinner',{attrs:{"md-size":30,"md-stroke":2,"md-indeterminate":""}})],1)])])])],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"16","md-flex-medium":"33"}},[_c('md-whiteframe',{attrs:{"md-elevation":"6"}},[_c('div',{staticClass:"ValuesConsolidados",style:({
        'background-color': '#ff80ab'
      })},[_c('div',{staticClass:"Consolidados_Valores"},[_c('span',{staticClass:"Consolidados_Valores_Fonts"},[_vm._v(_vm._s(_vm.$t('label.vlr_conf_negociacao')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.carregando),expression:"!carregando"}],staticClass:"Consolidados_Valores_Fonts"},[_vm._v(_vm._s(_vm.getMoney(this.getObjSaldo().vlrConfNegociacao, 0)))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.carregando),expression:"carregando"}],staticClass:"Consolidados_Valores_Fonts"},[_c('md-spinner',{attrs:{"md-size":30,"md-stroke":2,"md-indeterminate":""}})],1)])])])],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"16","md-flex-medium":"33"}},[_c('md-whiteframe',{attrs:{"md-elevation":"6"}},[_c('div',{staticClass:"ValuesConsolidados",style:({
        'background-color': '#ffc107'
      })},[_c('div',{staticClass:"Consolidados_Valores"},[_c('span',{staticClass:"Consolidados_Valores_Fonts"},[_vm._v(_vm._s(_vm.$t('label.confirmado_apuracao')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.carregando),expression:"!carregando"}],staticClass:"Consolidados_Valores_Fonts"},[_vm._v(_vm._s(_vm.getMoney(this.getObjSaldo().vlrConfApuracao, 0)))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.carregando),expression:"carregando"}],staticClass:"Consolidados_Valores_Fonts"},[_c('md-spinner',{attrs:{"md-size":30,"md-stroke":2,"md-indeterminate":""}})],1)])])])],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"16","md-flex-medium":"33"}},[_c('md-whiteframe',{attrs:{"md-elevation":"6"}},[_c('div',{staticClass:"ValuesConsolidados",style:({
        'background-color': '#fb8c00'
      })},[_c('div',{staticClass:"Consolidados_Valores"},[_c('span',{staticClass:"Consolidados_Valores_Fonts"},[_vm._v(_vm._s(_vm.$t('label.consumido')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.carregando),expression:"!carregando"}],staticClass:"Consolidados_Valores_Fonts"},[_vm._v(_vm._s(_vm.getMoney(this.getObjSaldo().vlrConsumido, 0)))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.carregando),expression:"carregando"}],staticClass:"Consolidados_Valores_Fonts"},[_c('md-spinner',{attrs:{"md-size":30,"md-stroke":2,"md-indeterminate":""}})],1)])])])],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"16","md-flex-medium":"33"}},[_c('md-whiteframe',{attrs:{"md-elevation":"6"}},[_c('div',{staticClass:"ValuesConsolidados",style:({
        'background-color': '#4caf50'
      })},[_c('div',{staticClass:"Consolidados_Valores"},[_c('span',{staticClass:"Consolidados_Valores_Fonts"},[_vm._v(_vm._s(_vm.$t('label.disponivel')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.carregando),expression:"!carregando"}],staticClass:"Consolidados_Valores_Fonts",attrs:{"id":"dash_op_card_disponivel_val"}},[_vm._v(_vm._s(_vm.getMoney(this.getObjSaldo().vlrDisponivel, 0)))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.carregando),expression:"carregando"}],staticClass:"Consolidados_Valores_Fonts"},[_c('md-spinner',{attrs:{"md-size":30,"md-stroke":2,"md-indeterminate":""}})],1)])])])],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_BoxValoresRepresentante_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_BoxValoresRepresentante_vue_vue_type_style_index_0_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_BoxValoresRepresentante_vue_vue_type_style_index_0_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_BoxValoresRepresentante_vue_vue_type_style_index_0_lang_css____default.a); 

/***/ }),
/* 1195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DashboardNegociacao_vue_vue_type_template_id_07daa004_scoped_true_lang_html___ = __webpack_require__(1196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DashboardNegociacao_vue_vue_type_script_lang_js___ = __webpack_require__(433);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__DashboardNegociacao_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__DashboardNegociacao_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DashboardNegociacao_vue_vue_type_style_index_0_id_07daa004_scoped_true_lang_css___ = __webpack_require__(1203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__DashboardNegociacao_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__DashboardNegociacao_vue_vue_type_template_id_07daa004_scoped_true_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__DashboardNegociacao_vue_vue_type_template_id_07daa004_scoped_true_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  "07daa004",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardNegociacao_vue_vue_type_template_id_07daa004_scoped_true_lang_html___ = __webpack_require__(1197);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardNegociacao_vue_vue_type_template_id_07daa004_scoped_true_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardNegociacao_vue_vue_type_template_id_07daa004_scoped_true_lang_html___["b"]; });


/***/ }),
/* 1197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('md-dialog',{ref:_vm.dialog.ref,attrs:{"md-open-from":("#" + (_vm.dialog.from)),"md-close-to":("#" + (_vm.dialog.from))}},[_c('md-dialog-title',[_vm._v(_vm._s(_vm.dialog.title))]),_vm._v(" "),_c('md-dialog-content',[_vm._v("\n      "+_vm._s(_vm.dialog.content)+"\n    ")])],1),_vm._v(" "),_c('md-layout',[_c('md-layout',{staticStyle:{"padding-left":"30px"},attrs:{"md-flex":"15","md-flex-medium":"30","md-flex-small":"100","md-flex-xsmall":"100"}},[_c('md-input-container',[_c('label',{attrs:{"for":"periodoNegociacao"}},[_vm._v(_vm._s(_vm.$t('label.periodo')))]),_vm._v(" "),_c('md-select',{attrs:{"name":"periodoNegociacao","id":"periodoNegociacaoSelect","disabled":_vm.bloquearConsulta},model:{value:(_vm.periodoNegociacao),callback:function ($$v) {_vm.periodoNegociacao=$$v},expression:"periodoNegociacao"}},[_c('md-option',{attrs:{"value":null},on:{"selected":_vm.recarregarDashboard}},[_vm._v(_vm._s(_vm.$t('label.ver_todos')))]),_vm._v(" "),_vm._l((_vm.periodos),function(opt,index){return _c('md-option',{key:index,attrs:{"value":opt.valor},on:{"selected":_vm.recarregarDashboard}},[_vm._v("\n            "+_vm._s(opt.periodo)+"\n          ")])})],2)],1)],1),_vm._v(" "),_c('md-layout',{staticStyle:{"padding-left":"30px"},attrs:{"md-flex":"15","md-flex-medium":"30","md-flex-small":"100","md-flex-xsmall":"100"}},[_c('md-input-container',[_c('label',{attrs:{"for":"unidadeNegocioNegociacao"}},[_vm._v(_vm._s(_vm.$tc('label.unidade_negocio' ,1)))]),_vm._v(" "),_c('md-select',{attrs:{"name":"unidadeNegocioNegociacao","id":"unidadeNegocioNegociacaoSelect","disabled":_vm.bloquearConsulta},model:{value:(_vm.unidadeNegocio),callback:function ($$v) {_vm.unidadeNegocio=$$v},expression:"unidadeNegocio"}},[_c('md-option',{attrs:{"value":null},on:{"selected":_vm.recarregarDashboard}},[_vm._v("\n            "+_vm._s(_vm.$t('label.ver_todos'))+"\n          ")]),_vm._v(" "),_vm._l((_vm.unidadesNegocio),function(opt,index){return _c('md-option',{key:index,attrs:{"value":opt.id},on:{"selected":_vm.recarregarDashboard}},[_vm._v("\n            "+_vm._s(opt.nomExtensao)+"\n          ")])})],2)],1)],1)],1),_vm._v(" "),_c('md-layout',{staticClass:"Consolidados"},[_c('md-layout',{attrs:{"md-gutter":"8"}},[_c('md-layout',{attrs:{"md-flex":"20"}},[_c('md-whiteframe',{staticStyle:{"width":"100%"},attrs:{"md-elevation":"6"}},[_c('div',{staticClass:"ValuesConsolidados",staticStyle:{"background-color":"#03a9f4"}},[_c('div',{staticClass:"Consolidados_Valores"},[_c('span',{staticClass:"Consolidados_Valores_Fonts"},[_vm._v(_vm._s(_vm.$t('status_entidade.em_cadastro')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.carregandoBox),expression:"!carregandoBox"}],staticClass:"Consolidados_Valores_Fonts"},[_vm._v("\n                "+_vm._s(_vm.getMoney(_vm.consolidadoNegociacao.em_cadastro, 0))+"\n              ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.carregandoBox),expression:"carregandoBox"}],staticClass:"Consolidados_Valores_Fonts"},[_c('md-spinner',{attrs:{"md-size":30,"md-stroke":2,"md-indeterminate":""}})],1)])])])],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"20"}},[_c('md-whiteframe',{staticStyle:{"width":"100%"},attrs:{"md-elevation":"6"}},[_c('div',{staticClass:"ValuesConsolidados",staticStyle:{"background-color":"#ba68c8"}},[_c('div',{staticClass:"Consolidados_Valores"},[_c('span',{staticClass:"Consolidados_Valores_Fonts"},[_vm._v(_vm._s(_vm.$t('label.reservado')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.carregandoBox),expression:"!carregandoBox"}],staticClass:"Consolidados_Valores_Fonts"},[_vm._v("\n                "+_vm._s(_vm.getMoney(_vm.consolidadoNegociacao.aguardando_aprovacao, 0))+"\n              ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.carregandoBox),expression:"carregandoBox"}],staticClass:"Consolidados_Valores_Fonts"},[_c('md-spinner',{attrs:{"md-size":30,"md-stroke":2,"md-indeterminate":""}})],1)])])])],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"20"}},[_c('md-whiteframe',{staticStyle:{"width":"100%"},attrs:{"md-elevation":"6"}},[_c('div',{staticClass:"ValuesConsolidados",staticStyle:{"background-color":"#ff80ab"}},[_c('div',{staticClass:"Consolidados_Valores"},[_c('span',{staticClass:"Consolidados_Valores_Fonts"},[_vm._v(_vm._s(_vm.$t('status_entidade.confirmado_acao')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.carregandoBox),expression:"!carregandoBox"}],staticClass:"Consolidados_Valores_Fonts"},[_vm._v("\n                "+_vm._s(_vm.getMoney(_vm.consolidadoNegociacao.aprovado, 0))+"\n              ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.carregandoBox),expression:"carregandoBox"}],staticClass:"Consolidados_Valores_Fonts"},[_c('md-spinner',{attrs:{"md-size":30,"md-stroke":2,"md-indeterminate":""}})],1)])])])],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"20"}},[_c('md-whiteframe',{staticStyle:{"width":"100%"},attrs:{"md-elevation":"6"}},[_c('div',{staticClass:"ValuesConsolidados",staticStyle:{"background-color":"#fb8c00"}},[_c('div',{staticClass:"Consolidados_Valores"},[_c('span',{staticClass:"Consolidados_Valores_Fonts"},[_vm._v(_vm._s(_vm.$tc('status_entidade.reprovado', 1)))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.carregandoBox),expression:"!carregandoBox"}],staticClass:"Consolidados_Valores_Fonts"},[_vm._v("\n                "+_vm._s(_vm.getMoney(_vm.consolidadoNegociacao.reprovado, 0))+"\n              ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.carregandoBox),expression:"carregandoBox"}],staticClass:"Consolidados_Valores_Fonts"},[_c('md-spinner',{attrs:{"md-size":30,"md-stroke":2,"md-indeterminate":""}})],1)])])])],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"20"}},[_c('md-whiteframe',{staticStyle:{"width":"100%"},attrs:{"md-elevation":"6"}},[_c('div',{staticClass:"ValuesConsolidados",staticStyle:{"background-color":"#4cae50"}},[_c('div',{staticClass:"Consolidados_Valores"},[_c('span',{staticClass:"Consolidados_Valores_Fonts"},[_vm._v(_vm._s(_vm.$t('label.disponivel')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.carregandoBox),expression:"!carregandoBox"}],staticClass:"Consolidados_Valores_Fonts"},[_vm._v("\n                "+_vm._s(_vm.getMoney(_vm.consolidadoNegociacao.disponivel, 0))+"\n              ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.carregandoBox),expression:"carregandoBox"}],staticClass:"Consolidados_Valores_Fonts"},[_c('md-spinner',{attrs:{"md-size":30,"md-stroke":2,"md-indeterminate":""}})],1)])])])],1)],1)],1),_vm._v(" "),(_vm.carregado)?_c('acordo-tabela',{ref:"acordoTabela",staticClass:"CRUDGenerico__ContentTable",attrs:{"bloquear-consulta":_vm.bloquearConsulta,"unidadeNegocio":_vm.unidadeNegocio,"periodoNegociacao":_vm.periodoNegociacao,"title":_vm.$tc('title.negociacoes', 2),"table-rows":_vm.negociacoes,"tipos-negociacoes":_vm.tiposNegociacoes,"table-header":_vm.tableHeaderAcordos,"carregando":_vm.carregandoTable,"paginas":_vm.paginas,"visible-columns":['id', 'cliente', 'negociacao', 'acordo', 'tipoAcordo', 'solicitante', 'dataInicioVigencia', 'dataFimVigencia',
      'valor', 'acoes'],"mobile-invisible-columns":['descricao', 'timeline']},on:{"ACORDOTABELA_FILTER":_vm.filtrarFluxos,"DASH_ACORDO_TABELA_PAGINA":_vm.requestCarregarNegociacoes}}):_vm._e()],1)}
var staticRenderFns = []



/***/ }),
/* 1198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AcordoTabelaDash_vue_vue_type_template_id_2bc12df5_scoped_true_lang_html___ = __webpack_require__(1199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AcordoTabelaDash_vue_vue_type_script_lang_js___ = __webpack_require__(435);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__AcordoTabelaDash_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__AcordoTabelaDash_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AcordoTabelaDash_vue_vue_type_style_index_0_id_2bc12df5_scoped_true_lang_css___ = __webpack_require__(1201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_generico_Pagination_css_vue_type_style_index_1_lang_css___ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);







/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_4__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__AcordoTabelaDash_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__AcordoTabelaDash_vue_vue_type_template_id_2bc12df5_scoped_true_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__AcordoTabelaDash_vue_vue_type_template_id_2bc12df5_scoped_true_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  "2bc12df5",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AcordoTabelaDash_vue_vue_type_template_id_2bc12df5_scoped_true_lang_html___ = __webpack_require__(1200);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AcordoTabelaDash_vue_vue_type_template_id_2bc12df5_scoped_true_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AcordoTabelaDash_vue_vue_type_template_id_2bc12df5_scoped_true_lang_html___["b"]; });


/***/ }),
/* 1200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"tabindex":"100"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.preventDefault();return _vm.onArrowUpPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.preventDefault();return _vm.onArrowDownPress($event)}]}},[_c('md-dialog',{ref:_vm.dialog.ref,attrs:{"md-open-from":("#" + (_vm.dialog.from))}},[_c('md-dialog-title',[_vm._v(_vm._s(_vm.dialog.title))]),_vm._v(" "),_c('md-dialog-content',[_vm._v(_vm._s(_vm.dialog.content))]),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",attrs:{"id":"acordo-tabela-dialog-cancel"},nativeOn:{"click":function($event){return _vm.closeDialog('dialog1')}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.cancelar'))+"\n      ")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary",attrs:{"id":"acordo-tabela-dialog-save"},nativeOn:{"click":function($event){return _vm.closeDialog('dialog1', _vm.dialog.action)}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.sim'))+"\n      ")])],1)],1),_vm._v(" "),_c('status-passos',{ref:"modalAcompanhamento",attrs:{"source":_vm.statusPassos}}),_vm._v(" "),(_vm.isHeaderAvailable)?_c('md-table-card',[_c('md-toolbar',[_c('h1',{staticClass:"md-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",attrs:{"id":"alcada-tabela-button-add","disabled":_vm.bloquearConsulta},nativeOn:{"click":function($event){return _vm.$refs.modal.open()}}},[_c('md-icon',[_vm._v("filter_list")])],1)],1),_vm._v(" "),_c('md-dialog',{ref:"modal",staticClass:"AcordoTabela GenericModal__Wrapper"},[_c('md-dialog-title',[_vm._v(_vm._s(_vm.$t('title.negociacoes')))]),_vm._v(" "),_c('md-dialog-content',[_c('md-layout',{attrs:{"md-gutter":"6"}},[_c('md-layout',{staticClass:"MdFlexCustom",attrs:{"md-flex":"30","md-flex-medium":"45","md-flex-small":"95","md-flex-xsmall":"95"}},[_c('md-input-container',[_c('label',{attrs:{"for":"statusNegociacao"}},[_vm._v(_vm._s(_vm.$t('label.status')))]),_vm._v(" "),_c('md-select',{attrs:{"name":"statusNegociacao","id":"statusNegociacaoSelect","disabled":_vm.statusBloqueado},model:{value:(_vm.filtro.status),callback:function ($$v) {_vm.$set(_vm.filtro, "status", $$v)},expression:"filtro.status"}},_vm._l((_vm.statusNegociacoes),function(opt,index){return _c('md-option',{key:index,attrs:{"value":opt.status}},[_vm._v("\n                    "+_vm._s(opt.descricao)+"\n                  ")])}),1)],1)],1),_vm._v(" "),_c('md-layout',{staticClass:"MdFlexCustom",attrs:{"md-flex":"30","md-flex-medium":"45","md-flex-small":"95","md-flex-xsmall":"95"}},[_c('md-input-container',[_c('label',{attrs:{"for":"tipoAcordoNegociacao"}},[_vm._v(_vm._s(_vm.$t('label.tipo_negociacao')))]),_vm._v(" "),_c('md-select',{attrs:{"name":"tipoAcordoNegociacao","id":"tipoAcordoNegociacaoSelect"},model:{value:(_vm.filtro.tipoAcordo),callback:function ($$v) {_vm.$set(_vm.filtro, "tipoAcordo", $$v)},expression:"filtro.tipoAcordo"}},[_c('md-option',{attrs:{"value":null},on:{"selected":function($event){}}},[_vm._v(_vm._s(_vm.$t('label.ver_todos')))]),_vm._v(" "),_vm._l((_vm.tiposNegociacoes),function(opt,index){return _c('md-option',{key:index,attrs:{"value":opt.codTipoAcordo}},[_vm._v("\n                    "+_vm._s(opt.descTipoAcordo)+"\n                  ")])})],2)],1)],1),_vm._v(" "),_c('md-layout',{staticClass:"MdFlexCustom",attrs:{"md-flex":"30","md-flex-medium":"45","md-flex-small":"95","md-flex-xsmall":"95"}},[_c('md-input-container',[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('label.tipo_de_investimento')))]),_vm._v(" "),_c('md-autocomplete',{attrs:{"tabindex":"3","name":"orcamento_tipo_orcamento","fetch":_vm.tipoInvestimentoResources.listarAtivos,"min-chars":1,"printAttribute":"nome","prepareResponseData":_vm.prepareResponseData,"queryParam":"nome"},on:{"selected":_vm.setTipoInvestimentoOrcamento},nativeOn:{"change":function($event){return _vm.limparTipoInvestimentoOrcamento($event)}},model:{value:(_vm.filtro.tipoLinhaOrcamento),callback:function ($$v) {_vm.$set(_vm.filtro, "tipoLinhaOrcamento", $$v)},expression:"filtro.tipoLinhaOrcamento"}}),_vm._v(" "),_c('md-icon',{staticStyle:{"cursor":"pointer"},attrs:{"md-autocomplete-search":""}},[_vm._v("search")])],1)],1),_vm._v(" "),_c('md-layout',{staticClass:"MdFlexCustom",attrs:{"md-flex":"30","md-flex-medium":"45","md-flex-small":"95","md-flex-xsmall":"95"}},[_c('md-input-container',[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('label.marca')))]),_vm._v(" "),_c('md-autocomplete',{attrs:{"tabindex":"4","name":"filtro_dash_marca","fetch":_vm.dashboardNegociacaoResources.listarMarcas,"min-chars":1,"printAttribute":"nomExtensao","prepareResponseData":_vm.prepareResponseData,"queryParam":"nome"},on:{"selected":_vm.setMarca},nativeOn:{"change":function($event){return _vm.limparMarca($event)}},model:{value:(_vm.filtro.marca),callback:function ($$v) {_vm.$set(_vm.filtro, "marca", $$v)},expression:"filtro.marca"}}),_vm._v(" "),_c('md-icon',{staticStyle:{"cursor":"pointer"},attrs:{"md-autocomplete-search":""}},[_vm._v("search")])],1)],1),_vm._v(" "),_c('md-layout',{staticClass:"MdFlexCustom",attrs:{"md-flex":"30","md-flex-medium":"45","md-flex-small":"95","md-flex-xsmall":"95"}},[_c('md-input-container',[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('label.linha_produto')))]),_vm._v(" "),_c('md-autocomplete',{attrs:{"tabindex":"4","name":"filtro_dash_linha_produto","fetch":_vm.dashboardNegociacaoResources.listarLinhaProduto,"min-chars":1,"printAttribute":"nomExtensao","prepareResponseData":_vm.prepareResponseData,"queryParam":"nome"},on:{"selected":_vm.setLinhaProduto},nativeOn:{"change":function($event){return _vm.limparLinhaProduto($event)}},model:{value:(_vm.filtro.linhaProduto),callback:function ($$v) {_vm.$set(_vm.filtro, "linhaProduto", $$v)},expression:"filtro.linhaProduto"}}),_vm._v(" "),_c('md-icon',{staticStyle:{"cursor":"pointer"},attrs:{"md-autocomplete-search":""}},[_vm._v("search")])],1)],1),_vm._v(" "),_c('md-layout',{staticClass:"MdFlexCustom",attrs:{"md-flex":"30","md-flex-medium":"45","md-flex-small":"95","md-flex-xsmall":"95"}},[_c('md-input-container',[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('label.familia')))]),_vm._v(" "),_c('md-autocomplete',{attrs:{"tabindex":"4","name":"filtro_dash_linha_produto","fetch":_vm.dashboardNegociacaoResources.listarFamilia,"min-chars":1,"printAttribute":"nomExtensao","prepareResponseData":_vm.prepareResponseData,"queryParam":"nome"},on:{"selected":_vm.setFamilia},nativeOn:{"change":function($event){return _vm.limparFamilia($event)}},model:{value:(_vm.filtro.familia),callback:function ($$v) {_vm.$set(_vm.filtro, "familia", $$v)},expression:"filtro.familia"}}),_vm._v(" "),_c('md-icon',{staticStyle:{"cursor":"pointer"},attrs:{"md-autocomplete-search":""}},[_vm._v("search")])],1)],1),_vm._v(" "),_c('md-layout',{staticClass:"MdFlexCustom",attrs:{"md-flex":"30","md-flex-medium":"45","md-flex-small":"95","md-flex-xsmall":"95"}},[_c('md-input-container',[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.$tc('label.produto', 1)))]),_vm._v(" "),_c('md-autocomplete',{attrs:{"tabindex":"4","name":"filtro_dash_produto","fetch":_vm.fetchProduto,"min-chars":1,"printAttribute":"nomProduto","prepareResponseData":_vm.prepareResponseData,"queryParam":"nome"},on:{"selected":_vm.setProduto},nativeOn:{"change":function($event){return _vm.limparProduto($event)}},model:{value:(_vm.filtro.produto),callback:function ($$v) {_vm.$set(_vm.filtro, "produto", $$v)},expression:"filtro.produto"}}),_vm._v(" "),_c('md-icon',{staticStyle:{"cursor":"pointer"},attrs:{"md-autocomplete-search":""}},[_vm._v("search")])],1)],1),_vm._v(" "),_c('md-layout',{staticClass:"MdFlexCustom",attrs:{"md-flex":"30","md-flex-medium":"45","md-flex-small":"95","md-flex-xsmall":"95"}},[_c('md-input-container',[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.$tc('label.cliente', 1)))]),_vm._v(" "),_c('md-autocomplete',{attrs:{"tabindex":"4","name":"filtro_dash_cliente","fetch":_vm.clienteResources.listarAtivosConsiderandoUsuario,"min-chars":1,"printAttribute":"cod_nom_cliente","prepareResponseData":_vm.prepareResponseData,"queryParam":"nome"},on:{"selected":_vm.setCliente},nativeOn:{"change":function($event){return _vm.limparCliente($event)}},model:{value:(_vm.filtro.cliente),callback:function ($$v) {_vm.$set(_vm.filtro, "cliente", $$v)},expression:"filtro.cliente"}}),_vm._v(" "),_c('md-icon',{staticStyle:{"cursor":"pointer"},attrs:{"md-autocomplete-search":""}},[_vm._v("search")])],1)],1),_vm._v(" "),_c('md-layout',{staticClass:"MdFlexCustom",attrs:{"md-flex":"30","md-flex-medium":"45","md-flex-small":"95","md-flex-xsmall":"95"}},[_c('md-switch',{staticClass:"md-primary",attrs:{"type":"button"},on:{"change":_vm.verificarMeuPassoPendente},model:{value:(_vm.filtro.meuPassoPendente),callback:function ($$v) {_vm.$set(_vm.filtro, "meuPassoPendente", $$v)},expression:"filtro.meuPassoPendente"}},[_vm._v("\n                  "+_vm._s(_vm.$t('label.minhas_aprovacoes_pendentes'))+"\n              ")])],1),_vm._v(" "),_c('md-layout',{staticClass:"MdFlexCustom",attrs:{"md-flex":"30","md-flex-medium":"45","md-flex-small":"95","md-flex-xsmall":"95"}},[_c('md-switch',{staticClass:"md-primary",attrs:{"type":"button"},on:{"change":_vm.verificarMeuPassoAprovado},model:{value:(_vm.filtro.meuPassoAprovado),callback:function ($$v) {_vm.$set(_vm.filtro, "meuPassoAprovado", $$v)},expression:"filtro.meuPassoAprovado"}},[_vm._v("\n                  "+_vm._s(_vm.$t('label.meus_passos_aprovados'))+"\n              ")])],1)],1)],1),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{nativeOn:{"click":function($event){return _vm.defaultClose($event)}}},[_vm._v("\n            "+_vm._s(_vm.$t('label.cancelar'))+"\n          ")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary",nativeOn:{"click":function($event){return _vm.filtrarModal($event)}}},[_vm._v("\n            "+_vm._s(_vm.$t('label.filtrar'))+"\n          ")])],1)],1),_vm._v(" "),_c('md-dialog',{ref:"modalAprovar",staticClass:"AcordoTabelaGrid GenericModal__Wrapper"},[_c('div',{staticClass:"GenericModal__Content GenericModal__PaddingDialog"},[_vm._t("header",[_c('h2',[_vm._v(_vm._s(_vm.$t('label.aprovar')))])]),_vm._v(" "),_c('md-input-container',{ref:"inputJustificativaAprovar"},[_c('label',[_vm._v(_vm._s(_vm.$t('label.justificativa')))]),_vm._v(" "),_c('md-textarea',{attrs:{"id":"justificativa_aprovar","name":"justificativa_aprovar","tabindex":"-1"},model:{value:(_vm.justificativa),callback:function ($$v) {_vm.justificativa=$$v},expression:"justificativa"}})],1),_vm._v(" "),_c('md-layout',{attrs:{"md-align":"end"}},[_c('md-button',{staticClass:"md-primary",nativeOn:{"click":function($event){return _vm.requestFecharModaisDefault($event)}}},[_vm._v("\n            "+_vm._s(_vm.$t('label.cancelar'))+"\n          ")]),_vm._v(" "),_c('md-button',{staticClass:"md-accent",nativeOn:{"click":function($event){return _vm.requestAprovarPassosFluxoAcordo($event)}}},[_vm._v("\n            "+_vm._s(_vm.$t('label.salvar'))+"\n          ")])],1)],2)]),_vm._v(" "),_c('md-dialog',{ref:"modalReprovar",staticClass:"AcordoTabelaGrid GenericModal__Wrapper"},[_c('div',{staticClass:"GenericModal__Content GenericModal__PaddingDialog"},[_vm._t("header",[_c('h2',[_vm._v(_vm._s(_vm.$t('label.reprovar')))])]),_vm._v(" "),_c('md-input-container',{ref:"inputJustificativaReprovar",class:{
              'md-input-invalid': _vm.errors.has('justificativa_reprovar')
            }},[_c('label',[_vm._v(_vm._s(_vm.$t('label.justificativa')))]),_vm._v(" "),_c('md-textarea',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"required":"","id":"justificativa_reprovar","name":"justificativa_reprovar","tabindex":"-1","data-vv-rules":"required","data-vv-name":"justificativa_reprovar"},model:{value:(_vm.justificativa),callback:function ($$v) {_vm.justificativa=$$v},expression:"justificativa"}}),_vm._v(" "),_c('span',{staticClass:"md-error"},[_vm._v("\n            "+_vm._s(_vm.errors.first('justificativa_reprovar'))+"\n          ")])],1),_vm._v(" "),_c('md-layout',{attrs:{"md-align":"end"}},[_c('md-button',{staticClass:"md-primary",nativeOn:{"click":function($event){return _vm.requestFecharModaisDefault($event)}}},[_vm._v("\n              "+_vm._s(_vm.$t('label.cancelar'))+"\n            ")]),_vm._v(" "),_c('md-button',{staticClass:"md-accent",nativeOn:{"click":function($event){return _vm.requestReprovarPassosNegociacao($event)}}},[_vm._v("\n              "+_vm._s(_vm.$t('label.salvar'))+"\n            ")])],1)],2)]),_vm._v(" "),_c('md-dialog',{ref:"modalAnalise",staticClass:"AcordoTabelaGrid GenericModal__Wrapper"},[_c('div',{staticClass:"GenericModal__Content GenericModal__PaddingDialog"},[_vm._t("header",[_c('h2',[_vm._v(_vm._s(_vm.$t('label.enviar_analise')))])]),_vm._v(" "),_c('md-input-container',{ref:"inputJustificativaAnalise",class:{
            'md-input-invalid': _vm.errors.has('justificativa_analise')
          }},[_c('label',[_vm._v(_vm._s(_vm.$t('label.justificativa')))]),_vm._v(" "),_c('md-textarea',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"required":"","id":"justificativa_analise","name":"justificativa_analise","tabindex":"-1","data-vv-rules":"required","data-vv-name":"justificativa_analise"},model:{value:(_vm.justificativa),callback:function ($$v) {_vm.justificativa=$$v},expression:"justificativa"}}),_vm._v(" "),_c('span',{staticClass:"md-error"},[_vm._v("\n            "+_vm._s(_vm.errors.first('justificativa_analise'))+"\n          ")])],1),_vm._v(" "),_c('md-layout',{attrs:{"md-align":"end"}},[_c('md-button',{staticClass:"md-primary",nativeOn:{"click":function($event){return _vm.requestFecharModaisDefault($event)}}},[_vm._v("\n              "+_vm._s(_vm.$t('label.cancelar'))+"\n            ")]),_vm._v(" "),_c('md-button',{staticClass:"md-accent",nativeOn:{"click":function($event){return _vm.requestEnviarNegociacaoParaAnalise($event)}}},[_vm._v("\n              "+_vm._s(_vm.$t('label.salvar'))+"\n            ")])],1)],2)]),_vm._v(" "),_c('md-dialog',{ref:"modalComentario",staticClass:"AcordoTabelaGrid GenericModal__Wrapper"},[_c('div',{staticClass:"GenericModal__Content GenericModal__PaddingDialog"},[_vm._t("header",[_c('h2',[_vm._v(_vm._s(_vm.$t('title.justificativa')))])]),_vm._v(" "),_c('div',{attrs:{"slot":"body","id":"modal_comentario"},slot:"body"},[_c('md-layout',{attrs:{"md-gutter":"6"}},[_c('span',[_vm._v(_vm._s(this.justificativaGrid))])])],1),_vm._v(" "),_c('md-layout',{attrs:{"md-align":"end"}},[_c('md-button',{staticClass:"md-primary",nativeOn:{"click":function($event){return _vm.requestFecharModaisDefault($event)}}},[_vm._v("\n            "+_vm._s(_vm.$t('label.fechar'))+"\n          ")])],1)],2)]),_vm._v(" "),_c('div',{staticClass:"TabelaGenerica__TableWrapper"},[_c('div',{staticClass:"md-table TabelaGenerica__Table"},[_c('table',[_c('thead',{staticClass:"md-table-header"},[_c('tr',{staticClass:"md-table-row"},[_c('th',{staticClass:"md-table-head md-table-selection md-has-action"},[_c('div',{staticClass:"md-table-cell-container"},[_c('md-checkbox',{staticClass:"md-accent",staticStyle:{"padding-right":"16px","padding-left":"24px"},on:{"change":_vm.toggleSelecaoGeral}})],1)]),_vm._v(" "),_vm._l((_vm.tableHeader),function(head,index){return _c('th',{key:1000 + index,staticClass:"md-table-head",class:head.classes,attrs:{"md-tooltip":head.tooltip,"md-sort-by":head.sortType}},[_c('div',{staticClass:"md-table-head-container"},[_c('div',{staticClass:"md-table-head-text md-test"},[_vm._v("\n                    "+_vm._s(head.name)+"\n                  ")])])])})],2)]),_vm._v(" "),(_vm.isContentAvailable)?_c('tbody',{staticClass:"md-table-body"},_vm._l((_vm.filteredList),function(row,rowIndex){return _c('tr',{key:rowIndex,staticClass:"md-table-row",class:{
                  'TabelaGenerica__TableRow--highlight': _vm.currentEditItem && _vm.currentEditItem === row,
                },attrs:{"md-item":row}},[_c('td',{staticClass:"md-table-cell md-table-selection md-has-action"},[_c('div',{staticClass:"md-table-cell-container"},[_c('md-checkbox',{staticClass:"md-accent",on:{"change":function($event){return _vm.toggleSelecaoUnica(row)}},model:{value:(row.selecionado),callback:function ($$v) {_vm.$set(row, "selecionado", $$v)},expression:"row.selecionado"}})],1)]),_vm._v(" "),(_vm.isColumnVisible('id'))?_c('td',{staticClass:"md-table-cell",class:{ 'md-hide-medium': _vm.hideOnMedium('id') },nativeOn:{"click":function($event){return _vm.clickOnRow(row, rowIndex)}}},[_c('md-tooltip',[_vm._v(_vm._s(_vm.$t('label.codigo')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(row.id))])],1):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('cliente'))?_c('td',{staticClass:"md-table-cell",class:{ 'md-hide-medium': _vm.hideOnMedium('cliente')},nativeOn:{"click":function($event){return _vm.clickOnRow(row, rowIndex)}}},[_c('md-tooltip',[_vm._v(_vm._s(_vm.$t('label.cliente_dash')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(row.cliente))])],1):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('acordo'))?_c('td',{staticClass:"md-table-cell",class:{ 'md-hide-medium': _vm.hideOnMedium('acordo') },nativeOn:{"click":function($event){return _vm.clickOnRow(row, rowIndex)}}},[_c('md-tooltip',[_vm._v(_vm._s(_vm.$t('label.acordo')))]),_vm._v(" "),_c('span',{domProps:{"textContent":_vm._s(row.acordo)}})],1):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('tipoAcordo'))?_c('td',{staticClass:"md-table-cell",class:{ 'md-hide-medium': _vm.hideOnMedium('tipoAcordo') },nativeOn:{"click":function($event){return _vm.clickOnRow(row, rowIndex)}}},[_c('md-tooltip',[_vm._v(_vm._s(_vm.$t('label.tipo_acordo')))]),_vm._v(" "),_c('span',{domProps:{"textContent":_vm._s(row.tipoAcordo)}})],1):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('solicitante'))?_c('td',{staticClass:"md-table-cell",class:{ 'md-hide-medium': _vm.hideOnMedium('solicitante') },nativeOn:{"click":function($event){return _vm.clickOnRow(row, rowIndex)}}},[_c('md-tooltip',[_vm._v(_vm._s(_vm.$t('label.solicitante')))]),_vm._v(" "),_c('span',{domProps:{"textContent":_vm._s(row.solicitante)}})],1):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('dataInicioVigencia'))?_c('td',{staticClass:"md-table-cell",class:{ 'md-hide-medium': _vm.hideOnMedium('dataInicioVigencia') },nativeOn:{"click":function($event){return _vm.clickOnRow(row, rowIndex)}}},[_c('md-tooltip',[_vm._v(_vm._s(_vm.$tc('label.inicio_vigencia', 2)))]),_vm._v(" "),_c('span',{domProps:{"textContent":_vm._s(row.dataInicioVigencia)}})],1):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('dataFimVigencia'))?_c('td',{staticClass:"md-table-cell",class:{ 'md-hide-medium': _vm.hideOnMedium('dataFimVigencia') },nativeOn:{"click":function($event){return _vm.clickOnRow(row, rowIndex)}}},[_c('md-tooltip',[_vm._v(_vm._s(_vm.$tc('label.fim_vigencia',2)))]),_vm._v(" "),_c('span',{domProps:{"textContent":_vm._s(row.dataFimVigencia)}})],1):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('valor'))?_c('td',{staticClass:"md-table-cell",class:{ 'md-hide-medium': _vm.hideOnMedium('valor') },nativeOn:{"click":function($event){return _vm.clickOnRow(row, rowIndex)}}},[_c('md-tooltip',[_vm._v(_vm._s(_vm.$tc('label.valor', 1)))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getMoney(row.valor)))])],1):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('acoes'))?_c('td',{staticClass:"md-table-cell",class:{ 'md-hide-medium': _vm.hideOnMedium('acoes') },nativeOn:{"click":function($event){return _vm.clickOnRow(row, rowIndex)}}},[_c('md-menu',{attrs:{"md-direction":"top left","md-size":"4"}},[_c('md-button',{staticClass:"md-icon-button",attrs:{"md-menu-trigger":""}},[_c('md-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('md-menu-content',[_c('md-menu-item',{nativeOn:{"click":function($event){return _vm.verItem(row)}}},[_c('md-icon',[_vm._v("equalizer")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.mais_detalhes')))])],1),_vm._v(" "),(_vm.temJustificativa(row))?_c('md-menu-item',{nativeOn:{"click":function($event){return _vm.requestBuscarMotivoLog(row)}}},[_c('md-icon',[_vm._v("view_headline")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.justificativa')))])],1):_vm._e(),_vm._v(" "),(_vm.ehAprovador(row))?_c('md-menu-item',{nativeOn:{"click":function($event){return _vm.requestModalEnviarNegociacaoAnalise(row)}}},[_c('md-icon',[_vm._v("chat_bubble")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.enviar_analise')))])],1):_vm._e(),_vm._v(" "),(_vm.ehAprovador(row))?_c('md-menu-item',{nativeOn:{"click":function($event){return _vm.requestModalReprovarApuracaoNegociacao(row)}}},[_c('md-icon',[_vm._v("thumb_down")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.reprovar')))])],1):_vm._e(),_vm._v(" "),(_vm.ehAprovador(row))?_c('md-menu-item',{nativeOn:{"click":function($event){return _vm.requestModalAprovarPassoNegociacao(row)}}},[_c('md-icon',[_vm._v("thumb_up")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.aprovar')))])],1):_vm._e(),_vm._v(" "),_c('md-menu-item',{nativeOn:{"click":function($event){return _vm.requestAbrirAcompanhamento(row)}}},[_c('md-icon',[_vm._v("assignment_turned_in")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.acompanhamento')))])],1)],1)],1)],1):_vm._e()])}),0):_vm._e()])]),_vm._v(" "),(!_vm.carregando)?_c('paginate',{directives:[{name:"show",rawName:"v-show",value:(_vm.isContentAvailable && _vm.paginas > 1),expression:"isContentAvailable && paginas > 1"}],attrs:{"page-count":_vm.paginas,"click-handler":_vm.clickHandler,"initial-page":_vm.indexPagina,"prev-text":_vm.$t('label.anterior'),"next-text":_vm.$tc('label.proximo', 1),"container-class":'pagination'}}):_vm._e(),_vm._v(" "),_c('h4',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isContentAvailable && !_vm.carregando),expression:"!isContentAvailable && !carregando"}],staticClass:"TabelaGenerica__NoContent"},[_vm._v("\n          "+_vm._s(_vm.$t('label.tabela_sem_conteudo'))+"\n      ")]),_vm._v(" "),_c('md-spinner',{directives:[{name:"show",rawName:"v-show",value:(_vm.carregando),expression:"carregando"}],staticClass:"TabelaGenerica__InterminateLoader",attrs:{"md-indeterminate":""}}),_vm._v(" "),_c('md-layout',{staticStyle:{"min-height":"48px"},attrs:{"md-align":"end"}},[_c('md-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.podeAprovar),expression:"podeAprovar"}],nativeOn:{"click":function($event){return _vm.requestModalEnviarNegociacaoAnalise(null)}}},[_vm._v("\n            "+_vm._s(_vm.$tc('label.enviar_analise'))+"\n          ")]),_vm._v(" "),_c('md-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.podeAprovar),expression:"podeAprovar"}],nativeOn:{"click":function($event){return _vm.requestModalReprovarApuracaoNegociacao(null)}}},[_vm._v("\n            "+_vm._s(_vm.$tc('label.reprovar'))+"\n          ")]),_vm._v(" "),_c('md-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.podeAprovar),expression:"podeAprovar"}],nativeOn:{"click":function($event){return _vm.requestModalAprovarPassoNegociacao(null)}}},[_vm._v("\n            "+_vm._s(_vm.$tc('label.aprovar'))+"\n          ")])],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []



/***/ }),
/* 1201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_AcordoTabelaDash_vue_vue_type_style_index_0_id_2bc12df5_scoped_true_lang_css___ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_AcordoTabelaDash_vue_vue_type_style_index_0_id_2bc12df5_scoped_true_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_AcordoTabelaDash_vue_vue_type_style_index_0_id_2bc12df5_scoped_true_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_AcordoTabelaDash_vue_vue_type_style_index_0_id_2bc12df5_scoped_true_lang_css____default.a); 

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      acordoResources: this.$api.acordo(this.$resource),
      acordo: {
        metas: []
      },
      acordosCopia: [],
      acordoEmpty: null,
      tableHeaderAcordos: [{
        name: this.$t('label.codigo'),
        classes: ['pl-12']
      }, {
        name: this.$t('label.cliente_dash'),
        classes: []
      }, {
        name: this.$tc('label.acordo'),
        classes: []
      }, {
        name: this.$tc('label.tipo_acordo'),
        classes: []
      }, {
        name: this.$tc('label.solicitante'),
        classes: []
      }, {
        name: this.$tc('label.inicio_vigencia', 2),
        classes: []
      }, {
        name: this.$tc('label.fim_vigencia', 2),
        classes: []
      }, {
        name: this.$tc('label.valor', 1),
        classes: []
      }, {
        name: this.$tc('label.acoes', 2),
        classes: []
      }]
    };
  },

  methods: {}
};

/***/ }),
/* 1203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardNegociacao_vue_vue_type_style_index_0_id_07daa004_scoped_true_lang_css___ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardNegociacao_vue_vue_type_style_index_0_id_07daa004_scoped_true_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardNegociacao_vue_vue_type_style_index_0_id_07daa004_scoped_true_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardNegociacao_vue_vue_type_style_index_0_id_07daa004_scoped_true_lang_css____default.a); 

/***/ }),
/* 1204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DashboardApuracao_vue_vue_type_template_id_3dd38884_scoped_true_lang_html___ = __webpack_require__(1205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DashboardApuracao_vue_vue_type_script_lang_js___ = __webpack_require__(439);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__DashboardApuracao_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__DashboardApuracao_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DashboardApuracao_vue_vue_type_style_index_0_id_3dd38884_scoped_true_lang_css___ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__DashboardApuracao_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__DashboardApuracao_vue_vue_type_template_id_3dd38884_scoped_true_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__DashboardApuracao_vue_vue_type_template_id_3dd38884_scoped_true_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  "3dd38884",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardApuracao_vue_vue_type_template_id_3dd38884_scoped_true_lang_html___ = __webpack_require__(1206);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardApuracao_vue_vue_type_template_id_3dd38884_scoped_true_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardApuracao_vue_vue_type_template_id_3dd38884_scoped_true_lang_html___["b"]; });


/***/ }),
/* 1206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('md-layout',[_c('md-layout',{staticStyle:{"padding-left":"30px"},attrs:{"md-flex":"15","md-flex-medium":"30","md-flex-small":"100","md-flex-xsmall":"100"}},[_c('md-input-container',[_c('label',{attrs:{"for":"periodoNegociacao"}},[_vm._v(_vm._s(_vm.$t('label.periodo')))]),_vm._v(" "),_c('md-select',{attrs:{"name":"periodoNegociacao","id":"periodoNegociacaoSelect","disabled":_vm.bloquearConsulta},model:{value:(_vm.periodo),callback:function ($$v) {_vm.periodo=$$v},expression:"periodo"}},[_c('md-option',{attrs:{"value":null},on:{"selected":_vm.requestCargaDash}},[_vm._v("\n            "+_vm._s(_vm.$t('label.ver_todos'))+"\n          ")]),_vm._v(" "),_vm._l((_vm.periodos),function(opt,index){return _c('md-option',{key:index,attrs:{"value":opt.periodo},on:{"selected":_vm.requestCargaDash}},[_vm._v("\n          "+_vm._s(String(opt.periodo).replace(/^(\d{4})(\d{2})/, '$2/$1'))+"\n          ")])})],2)],1)],1),_vm._v(" "),(!_vm.usuarioLogado.ehCliente && _vm.unidadesNegocio.length)?_c('md-layout',{staticStyle:{"padding-left":"30px"},attrs:{"md-flex":"15","md-flex-medium":"30","md-flex-small":"100","md-flex-xsmall":"100"}},[_c('md-input-container',[_c('label',{attrs:{"for":"unidadeNegocioNegociacao"}},[_vm._v(_vm._s(_vm.$tc('label.unidade_negocio' ,1)))]),_vm._v(" "),_c('md-select',{attrs:{"name":"unidadeNegocioNegociacao","id":"unidadeNegocioNegociacaoSelect","disabled":_vm.bloquearConsulta},model:{value:(_vm.idUnidadeNegocio),callback:function ($$v) {_vm.idUnidadeNegocio=$$v},expression:"idUnidadeNegocio"}},[_c('md-option',{attrs:{"value":null},on:{"selected":[function($event){},_vm.requestCargaDash]}},[_vm._v("\n            "+_vm._s(_vm.$t('label.ver_todos'))+"\n          ")]),_vm._v(" "),_vm._l((_vm.unidadesNegocio),function(opt,index){return _c('md-option',{key:index,attrs:{"value":opt.id},on:{"selected":_vm.requestCargaDash}},[_vm._v("\n            "+_vm._s(opt.nomExtensao)+"\n          ")])})],2)],1)],1):_vm._e()],1),_vm._v(" "),_c('md-layout',{staticClass:"Consolidados"},[_c('md-layout',{attrs:{"md-gutter":"8"}},[_c('md-layout',{attrs:{"md-flex":"25"}},[_c('md-whiteframe',{staticStyle:{"width":"100%"},attrs:{"md-elevation":"6"}},[_c('div',{staticClass:"ValuesConsolidados",staticStyle:{"background-color":"#03a9f4"}},[_c('div',{staticClass:"Consolidados_Valores"},[_c('span',{staticClass:"Consolidados_Valores_Fonts"},[_vm._v(_vm._s(_vm.$t('status_entidade.apurado')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.carregandoBox),expression:"!carregandoBox"}],staticClass:"Consolidados_Valores_Fonts"},[_vm._v("\n                "+_vm._s(_vm.getMoney(_vm.consolidadoApuracao.aguardando_apuracao, 0))+"\n              ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.carregandoBox),expression:"carregandoBox"}],staticClass:"Consolidados_Valores_Fonts"},[_c('md-spinner',{attrs:{"md-size":30,"md-stroke":2,"md-indeterminate":""}})],1)])])])],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"25"}},[_c('md-whiteframe',{staticStyle:{"width":"100%"},attrs:{"md-elevation":"6"}},[_c('div',{staticClass:"ValuesConsolidados",staticStyle:{"background-color":"#4caf50"}},[_c('div',{staticClass:"Consolidados_Valores"},[_c('span',{staticClass:"Consolidados_Valores_Fonts"},[_vm._v(_vm._s(_vm.$tc('label.confirmado_apuracao', 1)))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.carregandoBox),expression:"!carregandoBox"}],staticClass:"Consolidados_Valores_Fonts"},[_vm._v("\n                "+_vm._s(_vm.getMoney(_vm.consolidadoApuracao.aprovado, 0))+"\n              ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.carregandoBox),expression:"carregandoBox"}],staticClass:"Consolidados_Valores_Fonts"},[_c('md-spinner',{attrs:{"md-size":30,"md-stroke":2,"md-indeterminate":""}})],1)])])])],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"25"}},[_c('md-whiteframe',{staticStyle:{"width":"100%"},attrs:{"md-elevation":"6"}},[_c('div',{staticClass:"ValuesConsolidados",staticStyle:{"background-color":"#fb8c00"}},[_c('div',{staticClass:"Consolidados_Valores"},[_c('span',{staticClass:"Consolidados_Valores_Fonts"},[_vm._v(_vm._s(_vm.$t('status_entidade.em_analise')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.carregandoBox),expression:"!carregandoBox"}],staticClass:"Consolidados_Valores_Fonts"},[_vm._v("\n                "+_vm._s(_vm.getMoney(_vm.consolidadoApuracao.em_analise, 0))+"\n              ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.carregandoBox),expression:"carregandoBox"}],staticClass:"Consolidados_Valores_Fonts"},[_c('md-spinner',{attrs:{"md-size":30,"md-stroke":2,"md-indeterminate":""}})],1)])])])],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"25"}},[_c('md-whiteframe',{staticStyle:{"width":"100%"},attrs:{"md-elevation":"6"}},[_c('div',{staticClass:"ValuesConsolidados",staticStyle:{"background-color":"#ba68c8"}},[_c('div',{staticClass:"Consolidados_Valores"},[_c('span',{staticClass:"Consolidados_Valores_Fonts"},[_vm._v(_vm._s(_vm.$tc('status_entidade.reprovado', 1)))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.carregandoBox),expression:"!carregandoBox"}],staticClass:"Consolidados_Valores_Fonts"},[_vm._v("\n                "+_vm._s(_vm.getMoney(_vm.consolidadoApuracao.reprovado, 0))+"\n              ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.carregandoBox),expression:"carregandoBox"}],staticClass:"Consolidados_Valores_Fonts"},[_c('md-spinner',{attrs:{"md-size":30,"md-stroke":2,"md-indeterminate":""}})],1)])])])],1)],1)],1),_vm._v(" "),(!_vm.usuarioLogado.ehCliente)?_c('md-layout',[(_vm.carregado)?_c('apuracao-tabela',{ref:"apuracaoTabela",staticClass:"CRUDGenerico__ContentTable tableDashApuracao",attrs:{"pendencias":_vm.pendencias,"id":"dash_op_aba_apurac_cont_tab_apurac","title":_vm.$tc('label.apuracao', 2),"bloquear-consulta":_vm.bloquearConsulta,"carregando":_vm.carregandoTableApuracoes,"paginas":_vm.paginasApuracao,"totalPage":_vm.totalPage},on:{"Pendencias_recarregar":_vm.buscarPendencias,"APURACAOTABELA_FILTER":_vm.filtrarFluxos,"APURACAOTABELA_UPLOAD_EVIDENCIA":_vm.abrirSideBar}}):_vm._e()],1):_vm._e()],1)}
var staticRenderFns = []



/***/ }),
/* 1207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ApuracaoTabelaDash_vue_vue_type_template_id_5eb143d2_scoped_true_lang_html___ = __webpack_require__(1208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ApuracaoTabelaDash_vue_vue_type_script_lang_js___ = __webpack_require__(441);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__ApuracaoTabelaDash_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__ApuracaoTabelaDash_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ApuracaoTabelaDash_vue_vue_type_style_index_0_id_5eb143d2_scoped_true_lang_css___ = __webpack_require__(1235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ApuracaoTabelaDash_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__ApuracaoTabelaDash_vue_vue_type_template_id_5eb143d2_scoped_true_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ApuracaoTabelaDash_vue_vue_type_template_id_5eb143d2_scoped_true_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  "5eb143d2",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ApuracaoTabelaDash_vue_vue_type_template_id_5eb143d2_scoped_true_lang_html___ = __webpack_require__(1209);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ApuracaoTabelaDash_vue_vue_type_template_id_5eb143d2_scoped_true_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ApuracaoTabelaDash_vue_vue_type_template_id_5eb143d2_scoped_true_lang_html___["b"]; });


/***/ }),
/* 1209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"tabindex":"100"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.preventDefault();return _vm.onArrowUpPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.preventDefault();return _vm.onArrowDownPress($event)}]}},[_c('status-passos',{ref:"modalAcompanhamento",attrs:{"source":_vm.statusPassos}}),_vm._v(" "),_c('md-dialog',{ref:_vm.dialog.ref,attrs:{"md-open-from":("#" + (_vm.dialog.from))}},[_c('md-dialog-title',[_vm._v(_vm._s(_vm.dialog.title))]),_vm._v(" "),_c('md-dialog-content',[_vm._v(_vm._s(_vm.dialog.content))]),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",attrs:{"id":"apuracao-tabela-dialog-cancel"},nativeOn:{"click":function($event){return _vm.closeDialog('dialog1')}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.cancelar'))+"\n      ")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary",attrs:{"id":"apuracao-tabela-dialog-save"},nativeOn:{"click":function($event){return _vm.closeDialog('dialog1', _vm.dialog.action)}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.sim'))+"\n      ")])],1)],1),_vm._v(" "),_c('md-table-card',[_c('md-toolbar',[_c('h1',{staticClass:"md-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('pendencias',{attrs:{"pendencias":_vm.pendencias},on:{"Pendencias_close":_vm.recarregarPendencias}}),_vm._v(" "),_c('v-btn',{attrs:{"text":"","icon":"","id":"alcada-tabela-button-add","disabled":_vm.bloquearConsulta},nativeOn:{"click":function($event){return _vm.$refs.modal.open()}}},[_c('v-icon',[_vm._v("filter_list")])],1)],1),_vm._v(" "),_c('filtros-dash',{ref:"modal",attrs:{"entidade":"DASH_APURACAO","filtro":_vm.filtro},on:{"FILTROSDASH_FILTRAR":_vm.filtrarModal}}),_vm._v(" "),_c('md-dialog',{ref:"modalAprovar",staticClass:"AcordoTabelaGrid GenericModal__Wrapper"},[_c('div',{staticClass:"GenericModal__Content GenericModal__PaddingDialog"},[_vm._t("header",[_c('h2',[_vm._v(_vm._s(_vm.$t('label.aprovar')))])]),_vm._v(" "),_c('md-input-container',{ref:"inputJustificativaAprovar"},[_c('label',[_vm._v(_vm._s(_vm.$t('label.justificativa')))]),_vm._v(" "),_c('md-textarea',{attrs:{"id":"justificativa_aprovar","name":"justificativa_aprovar"},model:{value:(_vm.justificativa),callback:function ($$v) {_vm.justificativa=$$v},expression:"justificativa"}})],1),_vm._v(" "),_c('md-layout',{attrs:{"md-align":"end"}},[_c('md-button',{staticClass:"md-primary",nativeOn:{"click":function($event){return _vm.requestFecharModaisDefault($event)}}},[_vm._v("\n              "+_vm._s(_vm.$t('label.cancelar'))+"\n            ")]),_vm._v(" "),_c('md-button',{staticClass:"md-accent",attrs:{"id":"dash_op_aba_apurac_dlg_aprov_btn_aprov"},nativeOn:{"click":function($event){return _vm.requestAprovarPassosFluxoApuracao($event)}}},[_vm._v("\n              "+_vm._s(_vm.$t('label.aprovar'))+"\n            ")])],1)],2)]),_vm._v(" "),_c('md-dialog',{ref:"modalReprovar",staticClass:"AcordoTabelaGrid GenericModal__Wrapper"},[_c('div',{staticClass:"GenericModal__Content GenericModal__PaddingDialog"},[_vm._t("header",[_c('h2',[_vm._v(_vm._s(_vm.$t('label.reprovar')))])]),_vm._v(" "),_c('md-input-container',{ref:"inputJustificativaReprovar",class:{
                'md-input-invalid': _vm.errors.has('justificativa_reprovar')
              }},[_c('label',[_vm._v(_vm._s(_vm.$t('label.justificativa')))]),_vm._v(" "),_c('md-textarea',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"required":"","id":"justificativa_reprovar","name":"justificativa_reprovar","data-vv-rules":"required","data-vv-name":"justificativa_reprovar"},model:{value:(_vm.justificativa),callback:function ($$v) {_vm.justificativa=$$v},expression:"justificativa"}}),_vm._v(" "),_c('span',{staticClass:"md-error"},[_vm._v("\n              "+_vm._s(_vm.errors.first('justificativa_reprovar'))+"\n            ")])],1),_vm._v(" "),_c('md-layout',{attrs:{"md-align":"end"}},[_c('md-button',{staticClass:"md-primary",nativeOn:{"click":function($event){return _vm.requestFecharModaisDefault($event)}}},[_vm._v("\n                "+_vm._s(_vm.$t('label.cancelar'))+"\n              ")]),_vm._v(" "),_c('md-button',{staticClass:"md-accent",nativeOn:{"click":function($event){return _vm.requestReprovarPassosApuracao($event)}}},[_vm._v("\n                "+_vm._s(_vm.$t('label.reprovar'))+"\n              ")])],1)],2)]),_vm._v(" "),_c('md-dialog',{ref:"modalAnalise",staticClass:"AcordoTabelaGrid GenericModal__Wrapper"},[_c('div',{staticClass:"GenericModal__Content GenericModal__PaddingDialog"},[_vm._t("header",[_c('h2',[_vm._v(_vm._s(_vm.$t('label.enviar_analise')))])]),_vm._v(" "),_c('md-input-container',{ref:"inputJustificativaAnalise",class:{
              'md-input-invalid': _vm.errors.has('justificativa_analise')
            }},[_c('label',[_vm._v(_vm._s(_vm.$t('label.justificativa')))]),_vm._v(" "),_c('md-textarea',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"required":"","id":"justificativa_analise","name":"justificativa_analise","data-vv-rules":"required","data-vv-name":"justificativa_analise"},model:{value:(_vm.justificativa),callback:function ($$v) {_vm.justificativa=$$v},expression:"justificativa"}}),_vm._v(" "),_c('span',{staticClass:"md-error"},[_vm._v("\n              "+_vm._s(_vm.errors.first('justificativa_analise'))+"\n            ")])],1),_vm._v(" "),_c('md-layout',{attrs:{"md-align":"end"}},[_c('md-button',{staticClass:"md-primary",nativeOn:{"click":function($event){return _vm.requestFecharModaisDefault($event)}}},[_vm._v("\n                "+_vm._s(_vm.$t('label.cancelar'))+"\n              ")]),_vm._v(" "),_c('md-button',{staticClass:"md-accent",nativeOn:{"click":function($event){return _vm.requestEnviarApuracaoParaAnalise($event)}}},[_vm._v("\n                "+_vm._s(_vm.$t('label.enviar_analise'))+"\n              ")])],1)],2)]),_vm._v(" "),_c('md-dialog',{ref:"modalComentario",staticClass:"AcordoTabelaGrid GenericModal__Wrapper"},[_c('div',{staticClass:"GenericModal__Content GenericModal__PaddingDialog"},[_vm._t("header",[_c('h2',[_vm._v(_vm._s(_vm.$t('title.justificativa')))])]),_vm._v(" "),_c('div',{attrs:{"slot":"body","id":"modal_comentario"},slot:"body"},[_c('md-layout',{attrs:{"md-gutter":"6"}},[_c('span',[_vm._v(_vm._s(this.justificativaGrid !== null ? this.justificativaGrid : _vm.$t('message.justificativa_reivindicacao')))])])],1),_vm._v(" "),_c('md-layout',{attrs:{"md-align":"end"}},[_c('md-button',{staticClass:"md-primary",nativeOn:{"click":function($event){return _vm.requestFecharModaisDefault($event)}}},[_vm._v("\n            "+_vm._s(_vm.$t('label.fechar'))+"\n          ")])],1)],2)]),_vm._v(" "),_c('v-card',[(!_vm.recriarPaginacao)?_c('v-data-table',{directives:[{name:"resize",rawName:"v-resize",value:(function () { return _vm.onResize('apuracao-tabela-dash'); }),expression:"() => onResize('apuracao-tabela-dash')"}],staticClass:"apuracao-tabela-dash",attrs:{"show-select":"","items":_vm.apuracoes,"fixed-header":"","height":_vm.alturaInicial,"headers":_vm.headerApuracao,"options":_vm.pagination,"server-items-length":_vm.totalPage,"no-data-text":_vm.$t('label.tabela_sem_conteudo'),"footer-props":{
          itemsPerPageOptions: [5, 10, 25, 50],
        }},on:{"update:options":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"item.acoes",fn:function(ref){
        var item = ref.item;
return [_c('v-menu',{attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
        var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"text":"","icon":""}},on),[_c('v-icon',[_vm._v("more_vert")])],1)]}}],null,true)},[_vm._v(" "),_c('v-list',[_c('detalhes',{attrs:{"item":item},on:{"openDetalhes":_vm.openDetalhes,"Pendencias_close":_vm.recarregarPendencias}}),_vm._v(" "),(_vm.permiteExecucaoMeta)?_c('v-list-item',{attrs:{"id":"dash_op_aba_apurac_dlg_item_exec_meta"},nativeOn:{"click":function($event){return _vm.requestAbrirModalExecucaoMetas(item)}}},[_c('v-list-item-icon',[_c('v-icon',{staticClass:"IconesColorBefore",class:{ 'IconesColorAfter': item.evidenciaMeta }},[_vm._v("attachment")])],1),_vm._v(" "),_c('v-list-item-title',[_vm._v(_vm._s(_vm.$t('label.execucoes_meta')))])],1):_vm._e(),_vm._v(" "),(_vm.ehAprovador(item))?_c('v-list-item',{attrs:{"id":"dash_op_aba_apurac_dlg_item_analise"},nativeOn:{"click":function($event){return _vm.requestModalEnviarNegociacaoAnalise(item)}}},[_c('v-list-item-icon',[_c('v-icon',[_vm._v("chat_bubble")])],1),_vm._v(" "),_c('v-list-item-title',[_vm._v(_vm._s(_vm.$t('label.enviar_analise')))])],1):_vm._e(),_vm._v(" "),(_vm.ehAprovador(item))?_c('v-list-item',{class:{ 'bloqueio-sistema-item': _vm.bloqueioSistema },attrs:{"id":"dash_op_aba_apurac_dlg_item_reprov","disabled":_vm.bloqueioSistema},nativeOn:{"click":function($event){return _vm.requestModalReprovarApuracaoNegociacao(item)}}},[_c('v-list-item-icon',[_c('v-icon',[_vm._v("thumb_down")])],1),_vm._v(" "),_c('v-list-item-title',[_vm._v(_vm._s(_vm.$tc('label.reprovar', 1)))])],1):_vm._e(),_vm._v(" "),(_vm.ehAprovador(item))?_c('v-list-item',{class:{ 'bloqueio-sistema-item': _vm.bloqueioSistema },attrs:{"id":"dash_op_aba_apurac_dlg_item_aprov","disabled":_vm.bloqueioSistema},nativeOn:{"click":function($event){return _vm.requestModalAprovarPassoNegociacao(item)}}},[_c('v-list-item-icon',[_c('v-icon',[_vm._v("thumb_up")])],1),_vm._v(" "),_c('v-list-item-title',[_vm._v(_vm._s(_vm.$t('label.aprovar')))])],1):_vm._e(),_vm._v(" "),_c('v-list-item',{attrs:{"id":"dash_op_aba_apurac_dlg_item_acomp"},nativeOn:{"click":function($event){return _vm.requestAbrirAcompanhamento(item)}}},[_c('v-list-item-icon',[_c('v-icon',[_vm._v("assignment_turned_in")])],1),_vm._v(" "),_c('v-list-item-title',[_vm._v(_vm._s(_vm.$t('label.acompanhamento')))])],1)],1)],1),_vm._v(" "),(item.idAcordo)?_c('v-btn',{attrs:{"text":"","icon":"","small":"","id":"dash_op_aba_apurac_btn_visualizar_metas"},on:{"click":function($event){$event.stopPropagation();return _vm.openModalVisualizarMetas(item)}}},[_c('v-icon',[_vm._v("visibility")])],1):_vm._e()]}},{key:"item.possuiEvidenciaMeta",fn:function(ref){
        var item = ref.item;
return [_c('v-checkbox',{attrs:{"disabled":""},model:{value:(item.possuiEvidenciaMeta),callback:function ($$v) {_vm.$set(item, "possuiEvidenciaMeta", $$v)},expression:"item.possuiEvidenciaMeta"}})]}},{key:"item.idAcordo",fn:function(ref){
        var item = ref.item;
return [_vm._v("\n          "+_vm._s(item.idAcordo)+"\n        ")]}},{key:"item.realizadoMeta",fn:function(ref){
        var item = ref.item;
return [_vm._v("\n          "+_vm._s(_vm.formatacaoRealizadoMeta(item, item.realizadoMeta))+"\n        ")]}},{key:"item.vlrFinal",fn:function(ref){
        var item = ref.item;
return [_vm._v("\n          "+_vm._s(_vm.getMoney(item.vlrFinal))+"\n        ")]}},{key:"item.vlrAssinado",fn:function(ref){
        var item = ref.item;
return [_vm._v("\n          "+_vm._s(_vm.getMoney(item.vlrAssinado))+"\n        ")]}},{key:"item.contratoCliente",fn:function(ref){
        var item = ref.item;
return [_vm._v(" "+_vm._s(item.contratoCliente)+" ")]}},{key:"item.vlrMeta",fn:function(ref){
        var item = ref.item;
return [(item.codTipoAcordo === 'CRESCIMENTO')?_c('metas-crescimento',{attrs:{"is-activator-input":false,"pendencia":{
              metasCrescimento: item.metaIntervalos,
              ehValor: (item.metasBeneficios === 'SELLOUT_VALOR' || item.metasBeneficios === 'SELLIN_VALOR'),
              ehPercentual: item.tipoBonificacao === 'PERCENTUAL' }}}):_vm._e()]}},{key:"item.nomCliente",fn:function(ref){
              var item = ref.item;
return [_vm._v(" "+_vm._s(item.nomCliente)+" ")]}},{key:"item.descTipoAcordo",fn:function(ref){
              var item = ref.item;
return [_vm._v(" "+_vm._s(item.descTipoAcordo)+" ")]}},{key:"item.solicitante",fn:function(ref){
              var item = ref.item;
return [_vm._v(" "+_vm._s(item.solicitante)+" ")]}},{key:"item.descricao",fn:function(ref){
              var item = ref.item;
return [_vm._v(" "+_vm._s(item.descricao)+" ")]}},{key:"item.marca",fn:function(ref){
              var item = ref.item;
return [_vm._v(" "+_vm._s(item.marca)+" ")]}},{key:"item.linhaProduto",fn:function(ref){
              var item = ref.item;
return [_vm._v(" "+_vm._s(item.linhaProduto)+" ")]}},{key:"item.familia",fn:function(ref){
              var item = ref.item;
return [_vm._v(" "+_vm._s(item.familia)+" ")]}},{key:"item.produto",fn:function(ref){
              var item = ref.item;
return [_vm._v(" "+_vm._s(item.produto)+" ")]}},{key:"item.tipoLinhaOrcamento",fn:function(ref){
              var item = ref.item;
return [_vm._v(" "+_vm._s(item.tipoLinhaOrcamento)+" ")]}}],null,false,3290901909),model:{value:(_vm.objetosSelecionados),callback:function ($$v) {_vm.objetosSelecionados=$$v},expression:"objetosSelecionados"}}):_vm._e(),_vm._v(" "),(_vm.podeAprovar)?_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{on:{"click":function($event){return _vm.requestModalEnviarNegociacaoAnalise(null)}}},[_vm._v("\n          "+_vm._s(_vm.$tc('label.enviar_analise'))+"\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"warning","disabled":_vm.bloqueioSistema},on:{"click":function($event){return _vm.requestModalReprovarApuracaoNegociacao(null)}}},[_vm._v("\n          "+_vm._s(_vm.$tc('label.reprovar'))+"\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","disabled":_vm.bloqueioSistema},nativeOn:{"click":function($event){return _vm.requestModalAprovarPassoNegociacao(null)}}},[_vm._v("\n          "+_vm._s(_vm.$tc('label.aprovar'))+"\n        ")])],1):_vm._e()],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"1300"},model:{value:(_vm.dialogModal),callback:function ($$v) {_vm.dialogModal=$$v},expression:"dialogModal"}},[_c('v-card',{staticClass:"pa-3"},[(_vm.pendencia)?_c('pendencia-negociacao',{attrs:{"pendencia":_vm.pendencia,"exibir-acao-fluxo":false}}):_vm._e(),_vm._v(" "),_c('v-divider'),_vm._v(" "),(_vm.pendencia)?_c('pendencia-apuracao',{attrs:{"pendencia":_vm.pendencia}}):_vm._e(),_vm._v(" "),_c('v-divider'),_vm._v(" "),(_vm.pendencia)?_c('listar-evidencia',{attrs:{"pendencia":_vm.pendencia}}):_vm._e()],1)],1),_vm._v(" "),_c('v-dialog',{model:{value:(_vm.modalVisualizarMetas),callback:function ($$v) {_vm.modalVisualizarMetas=$$v},expression:"modalVisualizarMetas"}},[_c('v-card',[_c('v-card-title',[_c('h2',[_vm._v(_vm._s(_vm.$t('title.metas_do_acordo')))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticStyle:{"color":"black"},attrs:{"icon":"","color":"black"},on:{"click":_vm.closeModalVisualizarMetas}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{attrs:{"headers":_vm.headersMetas,"items":_vm.metasDoAcordo,"no-data-text":_vm.$t('label.sem_metas')},scopedSlots:_vm._u([{key:"item.vlrAssinado",fn:function(ref){
              var item = ref.item;
return [_vm._v("\n              "+_vm._s((item.vlrAssinado))+"\n            ")]}},{key:"item.vlrReservado",fn:function(ref){
              var item = ref.item;
return [_vm._v("\n              "+_vm._s((item.vlrReservado))+"\n            ")]}},{key:"item.roi",fn:function(ref){
              var item = ref.item;
return [_vm._v("\n              "+_vm._s(item.roi)+"%\n            ")]}}])})],1)],1)],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosDash_vue_vue_type_template_id_4243819c___ = __webpack_require__(1211);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosDash_vue_vue_type_template_id_4243819c___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosDash_vue_vue_type_template_id_4243819c___["b"]; });


/***/ }),
/* 1211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-dialog',{ref:"modal",staticClass:"ResponsiveModal",attrs:{"md-open-from":_vm.mdOpenFrom},on:{"open":_vm.onOpen,"close":_vm.onClose}},[_c('md-dialog-title',[_vm._v(_vm._s(_vm.$tc('title.filtro', 2)))]),_vm._v(" "),_c('md-dialog-content',[_c('md-layout',{attrs:{"md-gutter":"8"}},[_c('md-layout',{staticClass:"MdFlexCustom",attrs:{"md-flex":"30","md-flex-medium":"45","md-flex-small":"95","md-flex-xsmall":"95"}},[_c('md-input-container',[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.$tc('label.solicitante', 1)))]),_vm._v(" "),_c('md-autocomplete',{attrs:{"id":"dash_op_aba_apurac_filtro_solicit","tabindex":"4","name":"filtro_dash_marca","fetch":_vm.dashboardApuracaoResources.listarSolicitantes,"min-chars":1,"printAttribute":"nomeSobrenome","prepareResponseData":_vm.prepareResponseData,"queryParam":"nome"},on:{"selected":_vm.setSolicitante},nativeOn:{"change":function($event){return _vm.limparSolicitante($event)}},model:{value:(_vm.filtro.solicitante),callback:function ($$v) {_vm.$set(_vm.filtro, "solicitante", $$v)},expression:"filtro.solicitante"}}),_vm._v(" "),_c('md-icon',{staticStyle:{"cursor":"pointer"},attrs:{"md-autocomplete-search":""}},[_vm._v("search")])],1)],1),_vm._v(" "),_c('md-layout',{staticClass:"MdFlexCustom",attrs:{"md-flex":"30","md-flex-medium":"45","md-flex-small":"95","md-flex-xsmall":"95"}},[_c('md-input-container',[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.$tc('label.tipo_acordo', 1)))]),_vm._v(" "),_c('md-autocomplete',{attrs:{"id":"dash_op_aba_apurac_filtro_tipo_acord","tabindex":"4","name":"filtro_dash_marca","fetch":_vm.dashboardApuracaoResources.listarTipoAcordo,"min-chars":1,"printAttribute":"desc_tipo_acordo","prepareResponseData":_vm.prepareResponseData,"queryParam":"nome"},on:{"selected":_vm.setTipoAcordo},nativeOn:{"change":function($event){return _vm.limparTipoAcordo($event)}},model:{value:(_vm.filtro.tipoAcordo),callback:function ($$v) {_vm.$set(_vm.filtro, "tipoAcordo", $$v)},expression:"filtro.tipoAcordo"}}),_vm._v(" "),_c('md-icon',{staticStyle:{"cursor":"pointer"},attrs:{"md-autocomplete-search":""}},[_vm._v("search")])],1)],1),_vm._v(" "),_c('md-layout',{staticClass:"MdFlexCustom",attrs:{"md-flex":"30","md-flex-medium":"45","md-flex-small":"95","md-flex-xsmall":"95"}},[_c('md-input-container',[_c('label',{attrs:{"for":"periodoNegociacao"}},[_vm._v(_vm._s(_vm.$tc('label.status')))]),_vm._v(" "),_c('md-select',{attrs:{"disabled":_vm.statusBloqueado,"name":"periodoNegociacao","id":"periodoNegociacaoSelect"},model:{value:(_vm.filtro.status),callback:function ($$v) {_vm.$set(_vm.filtro, "status", $$v)},expression:"filtro.status"}},_vm._l((_vm.statusApuracao),function(opt,index){return _c('md-option',{key:index,attrs:{"value":opt.status}},[_vm._v("\n                "+_vm._s(opt.descricao)+"\n              ")])}),1)],1)],1),_vm._v(" "),_c('md-layout',{staticClass:"MdFlexCustom",attrs:{"md-flex":"30","md-flex-medium":"45","md-flex-small":"95","md-flex-xsmall":"95"}},[_c('md-input-container',[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.$tc('label.tipo_linha_orcamento', 1)))]),_vm._v(" "),_c('md-autocomplete',{attrs:{"id":"dash_op_aba_apurac_filtro_linha_orc","tabindex":"4","name":"filtro_dash_marca","fetch":_vm.tipoInvestimentoResources.listarAtivos,"min-chars":1,"printAttribute":"nome","prepareResponseData":_vm.prepareResponseData,"queryParam":"nome"},on:{"selected":_vm.setTipoLinhaOrcamento},nativeOn:{"change":function($event){return _vm.limparTipoLinhaOrcamento($event)}},model:{value:(_vm.filtro.tipoLinhaOrcamento),callback:function ($$v) {_vm.$set(_vm.filtro, "tipoLinhaOrcamento", $$v)},expression:"filtro.tipoLinhaOrcamento"}}),_vm._v(" "),_c('md-icon',{staticStyle:{"cursor":"pointer"},attrs:{"md-autocomplete-search":""}},[_vm._v("search")])],1)],1),_vm._v(" "),_c('md-layout',{staticClass:"MdFlexCustom",attrs:{"md-flex":"30","md-flex-medium":"45","md-flex-small":"95","md-flex-xsmall":"95"}},[_c('md-input-container',[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.$tc('label.marca', 1)))]),_vm._v(" "),_c('md-autocomplete',{attrs:{"id":"dash_op_aba_apurac_filtro_marca_prod","tabindex":"4","name":"filtro_dash_marca","fetch":_vm.dashboardNegociacaoResources.listarMarcas,"min-chars":1,"printAttribute":"nomExtensao","prepareResponseData":_vm.prepareResponseData,"queryParam":"nome"},on:{"selected":_vm.setMarca},nativeOn:{"change":function($event){return _vm.limparMarca($event)}},model:{value:(_vm.filtro.marca),callback:function ($$v) {_vm.$set(_vm.filtro, "marca", $$v)},expression:"filtro.marca"}}),_vm._v(" "),_c('md-icon',{staticStyle:{"cursor":"pointer"},attrs:{"md-autocomplete-search":""}},[_vm._v("search")])],1)],1),_vm._v(" "),_c('md-layout',{staticClass:"MdFlexCustom",attrs:{"md-flex":"30","md-flex-medium":"45","md-flex-small":"95","md-flex-xsmall":"95"}},[_c('md-input-container',[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.$tc('label.linha_produto', 1)))]),_vm._v(" "),_c('md-autocomplete',{attrs:{"id":"dash_op_aba_apurac_filtro_linha_prod","tabindex":"4","name":"filtro_dash_marca","fetch":_vm.dashboardNegociacaoResources.listarLinhaProduto,"min-chars":1,"printAttribute":"nomExtensao","prepareResponseData":_vm.prepareResponseData,"queryParam":"nome"},on:{"selected":_vm.setLinhaProduto},nativeOn:{"change":function($event){return _vm.limparLinhaProduto($event)}},model:{value:(_vm.filtro.linhaProduto),callback:function ($$v) {_vm.$set(_vm.filtro, "linhaProduto", $$v)},expression:"filtro.linhaProduto"}}),_vm._v(" "),_c('md-icon',{staticStyle:{"cursor":"pointer"},attrs:{"md-autocomplete-search":""}},[_vm._v("search")])],1)],1),_vm._v(" "),_c('md-layout',{staticClass:"MdFlexCustom",attrs:{"md-flex":"30","md-flex-medium":"45","md-flex-small":"95","md-flex-xsmall":"95"}},[_c('md-input-container',[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.$tc('label.familia', 1)))]),_vm._v(" "),_c('md-autocomplete',{attrs:{"id":"dash_op_aba_apurac_filtro_familia","tabindex":"4","name":"filtro_dash_marca","fetch":_vm.dashboardNegociacaoResources.listarFamilia,"min-chars":1,"printAttribute":"nomExtensao","prepareResponseData":_vm.prepareResponseData,"queryParam":"nome"},on:{"selected":_vm.setFamilia},nativeOn:{"change":function($event){return _vm.limparFamilia($event)}},model:{value:(_vm.filtro.familia),callback:function ($$v) {_vm.$set(_vm.filtro, "familia", $$v)},expression:"filtro.familia"}}),_vm._v(" "),_c('md-icon',{staticStyle:{"cursor":"pointer"},attrs:{"md-autocomplete-search":""}},[_vm._v("search")])],1)],1),_vm._v(" "),_c('md-layout',{staticClass:"MdFlexCustom",attrs:{"md-flex":"30","md-flex-medium":"45","md-flex-small":"95","md-flex-xsmall":"95"}},[_c('md-input-container',[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.$tc('label.produto', 1)))]),_vm._v(" "),_c('md-autocomplete',{attrs:{"id":"dash_op_aba_apurac_filtro_produto","tabindex":"4","name":"filtro_dash_marca","fetch":_vm.produtoResources.listarAtivos,"min-chars":1,"printAttribute":"nomProduto","prepareResponseData":_vm.prepareResponseData,"queryParam":"nome"},on:{"selected":_vm.setProduto},nativeOn:{"change":function($event){return _vm.limparProduto($event)}},model:{value:(_vm.filtro.produto),callback:function ($$v) {_vm.$set(_vm.filtro, "produto", $$v)},expression:"filtro.produto"}}),_vm._v(" "),_c('md-icon',{staticStyle:{"cursor":"pointer"},attrs:{"md-autocomplete-search":""}},[_vm._v("search")])],1)],1),_vm._v(" "),_c('md-layout',{staticClass:"MdFlexCustom",attrs:{"md-flex":"30","md-flex-medium":"45","md-flex-small":"95","md-flex-xsmall":"95"}},[_c('md-input-container',[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.$tc('label.cliente', 1)))]),_vm._v(" "),_c('md-autocomplete',{attrs:{"id":"dash_op_aba_apurac_filtro_cliente","tabindex":"4","name":"filtro_dash_marca","fetch":_vm.clienteResources.listarAtivos,"min-chars":1,"printAttribute":"cod_nom_cliente","prepareResponseData":_vm.prepareResponseData,"queryParam":"nome"},on:{"selected":_vm.setCliente},nativeOn:{"change":function($event){return _vm.limparCliente($event)}},model:{value:(_vm.filtro.cliente),callback:function ($$v) {_vm.$set(_vm.filtro, "cliente", $$v)},expression:"filtro.cliente"}}),_vm._v(" "),_c('md-icon',{staticStyle:{"cursor":"pointer"},attrs:{"md-autocomplete-search":""}},[_vm._v("search")])],1)],1),_vm._v(" "),_c('md-layout',{staticClass:"MdFlexCustom",attrs:{"md-flex":"30","md-flex-medium":"45","md-flex-small":"95","md-flex-xsmall":"95"}},[_c('md-input-container',[_c('label',{attrs:{"for":"FiltrosDash_id_acordo"}},[_vm._v(_vm._s(_vm.$t('label.numero_acordo')))]),_vm._v(" "),_c('md-input',{attrs:{"id":"FiltrosDash_id_acordo","type":"text"},model:{value:(_vm.filtro.idAcordo),callback:function ($$v) {_vm.$set(_vm.filtro, "idAcordo", $$v)},expression:"filtro.idAcordo"}})],1)],1),_vm._v(" "),_c('md-layout',{staticClass:"MdFlexCustom",attrs:{"md-flex":"30","md-flex-medium":"45","md-flex-small":"95","md-flex-xsmall":"95"}},[_c('md-switch',{staticClass:"md-primary",attrs:{"type":"button"},on:{"change":_vm.verificarMeuPassoPendente},model:{value:(_vm.filtro.meuPassoPendente),callback:function ($$v) {_vm.$set(_vm.filtro, "meuPassoPendente", $$v)},expression:"filtro.meuPassoPendente"}},[_vm._v("\n              "+_vm._s(_vm.$t('label.minhas_aprovacoes_pendentes'))+"\n          ")])],1),_vm._v(" "),_c('md-layout',{staticClass:"MdFlexCustom",attrs:{"md-flex":"30","md-flex-medium":"45","md-flex-small":"95","md-flex-xsmall":"95"}},[_c('md-switch',{staticClass:"md-primary",attrs:{"type":"button"},on:{"change":_vm.verificarMeuPassoAprovado},model:{value:(_vm.filtro.meuPassoAprovado),callback:function ($$v) {_vm.$set(_vm.filtro, "meuPassoAprovado", $$v)},expression:"filtro.meuPassoAprovado"}},[_vm._v("\n              "+_vm._s(_vm.$t('label.meus_passos_aprovados'))+"\n          ")])],1)],1)],1),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{nativeOn:{"click":function($event){return _vm.defaultClose($event)}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.cancelar'))+"\n      ")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary",nativeOn:{"click":function($event){return _vm.filtrar($event)}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.filtrar'))+"\n      ")])],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosDash_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosDash_vue_vue_type_style_index_0_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosDash_vue_vue_type_style_index_0_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosDash_vue_vue_type_style_index_0_lang_css____default.a); 

/***/ }),
/* 1213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pendencias_vue_vue_type_template_id_044368c7___ = __webpack_require__(1214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Pendencias_vue_vue_type_script_lang_js___ = __webpack_require__(447);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__Pendencias_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__Pendencias_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Pendencias_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__Pendencias_vue_vue_type_template_id_044368c7___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Pendencias_vue_vue_type_template_id_044368c7___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Pendencias_vue_vue_type_template_id_044368c7___ = __webpack_require__(1215);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Pendencias_vue_vue_type_template_id_044368c7___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Pendencias_vue_vue_type_template_id_044368c7___["b"]; });


/***/ }),
/* 1215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.pendencias.length)?_c('v-dialog',{attrs:{"width":"1300"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var dialog = ref.on;
return [_c('v-tooltip',{staticClass:"mr-2",attrs:{"left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var tooltip = ref.on;
return [_c('v-badge',{attrs:{"left":"","color":"primary"},scopedSlots:_vm._u([{key:"badge",fn:function(){return [_vm._v(_vm._s(_vm.pendencias.length))]},proxy:true}],null,true),model:{value:(_vm.pendencias.length),callback:function ($$v) {_vm.$set(_vm.pendencias, "length", $$v)},expression:"pendencias.length"}},[_vm._v(" "),_c('v-icon',_vm._g({attrs:{"disabled":!_vm.pendencias.length}},Object.assign({}, tooltip, dialog)),[_vm._v("list")])],1)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.minhas_aprovacoes_pendentes')))])])]}}],null,false,3941714326),model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('div',{staticClass:"text-xs-center my-2"},[_c('v-pagination',{attrs:{"length":_vm.pendencias.length,"total-visible":7},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}})],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),(_vm.pendencia)?_c('pendencia-negociacao',{attrs:{"pendencia":_vm.pendencia,"exibir-acao-fluxo":true,"ultima-pagina":_vm.ultimaPagina},on:{"PendenciaNegociacao_irProximaApuracao":_vm.irProximaApuracao}}):_vm._e(),_vm._v(" "),_c('v-divider'),_vm._v(" "),(_vm.pendencia)?_c('pendencia-apuracao',{attrs:{"pendencia":_vm.pendencia}}):_vm._e(),_vm._v(" "),_c('v-divider'),_vm._v(" "),(_vm.pendencia)?_c('listar-evidencia',{attrs:{"pendencia":_vm.pendencia}}):_vm._e()],1)],1)],1):_vm._e(),_vm._v(" "),(!_vm.pendencias.length)?_c('v-tooltip',{staticClass:"mr-2",attrs:{"left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({attrs:{"disabled":!_vm.pendencias.length}},on),[_vm._v("list")])]}}],null,false,4104207077)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.minhas_aprovacoes_pendentes')))])]):_vm._e()],1)}
var staticRenderFns = []



/***/ }),
/* 1216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_PendenciaNegociacao_vue_vue_type_template_id_9dd7ca00___ = __webpack_require__(1217);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_PendenciaNegociacao_vue_vue_type_template_id_9dd7ca00___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_PendenciaNegociacao_vue_vue_type_template_id_9dd7ca00___["b"]; });


/***/ }),
/* 1217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"px-3"},[_c('v-row',{staticClass:"mx-0"},[_c('v-row',{attrs:{"align":"center"}},[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.pendencia.titulo))]),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":""},on:{"click":_vm.requestAbrirAcompanhamento}},on),[_c('v-icon',[_vm._v("assignment_turned_in")])],1)]}}]),model:{value:(_vm.showTooltip),callback:function ($$v) {_vm.showTooltip=$$v},expression:"showTooltip"}},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.acompanhamento')))])])],1),_vm._v(" "),(_vm.exibirAcaoFluxo)?_c('v-row',{attrs:{"justify":"end"}},[(_vm.pendencia.exibirAprovado)?_c('acao-fluxo',{ref:"acaoAprovar",attrs:{"cor-icone":"success","icone":"thumb_up","disabled":_vm.pendencia.naoExecutarAcoes,"texto-acao":_vm.$t('label.aprovar'),"status":_vm.pendencia.status,"exibir-justificativa":_vm.pendencia.exibirJustificativa,"pendencia":_vm.pendencia,"ultima-pagina":_vm.ultimaPagina},on:{"AcaoFluxo_executarAcao":_vm.aprovar}}):_vm._e(),_vm._v(" "),(_vm.pendencia.exibirAnalisar)?_c('acao-fluxo',{ref:"acaoEmAnalise",attrs:{"icone":"announcement","disabled":_vm.pendencia.naoExecutarAcoes,"texto-acao":_vm.$t('label.solicitar_analise'),"status":_vm.pendencia.status,"exibir-justificativa":_vm.pendencia.exibirJustificativa,"pendencia":_vm.pendencia,"ultima-pagina":_vm.ultimaPagina,"validar-justificativa":true},on:{"AcaoFluxo_executarAcao":_vm.enviarAnalise}}):_vm._e(),_vm._v(" "),(_vm.pendencia.exibirReprovado)?_c('acao-fluxo',{ref:"acaoReprovar",attrs:{"cor-icone":"warning","icone":"thumb_down","texto-acao":_vm.$t('label.reprovar'),"status":_vm.pendencia.status,"disabled":_vm.pendencia.naoExecutarAcoes,"exibir-justificativa":_vm.pendencia.exibirJustificativa,"pendencia":_vm.pendencia,"ultima-pagina":_vm.ultimaPagina,"validar-justificativa":true},on:{"AcaoFluxo_executarAcao":_vm.reprovar}}):_vm._e()],1):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"mx-3 px-2 boby-1"},[_c('div',[_vm._v(_vm._s(_vm.pendencia.descricao))]),_vm._v(" "),(!_vm.pendencia.ehMetaComContraPartida)?_c('div',[_vm._v(_vm._s(((_vm.$t('label.data_inicio')) + ": " + (_vm.pendencia.dataInicio))))]):_vm._e(),_vm._v(" "),(!_vm.pendencia.ehMetaComContraPartida)?_c('div',[_vm._v(_vm._s(((_vm.$t('label.data_fim')) + ": " + (_vm.pendencia.dataFinal))))]):_vm._e(),_vm._v(" "),(_vm.pendencia.ehMetaComContraPartida)?_c('div',[_vm._v(_vm._s(((_vm.$t('label.periodo_apuracao')) + ": " + (_vm.pendencia.periodo))))]):_vm._e()]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('div',{staticClass:"px-3"},[_c('v-row',[_c('p',{staticClass:"mb-0"},[_c('span',{staticClass:"headline",staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(_vm.$tc('title.cliente', 1)))]),_vm._v(" "),_c('cliente-pagador',{attrs:{"pendencia":_vm.pendencia}})],1)]),_vm._v(" "),_c('v-row',[(_vm.pendencia.ehCliente)?_c('v-col',{staticClass:"pa-2",attrs:{"cols":"12","sm":"6","md":"4"}},[_c('v-text-field',{attrs:{"label":_vm.$tc('label.cod_cliente', 1),"readonly":""},model:{value:(_vm.pendencia.codCliente),callback:function ($$v) {_vm.$set(_vm.pendencia, "codCliente", $$v)},expression:"pendencia.codCliente"}})],1):_vm._e(),_vm._v(" "),(_vm.pendencia.ehCliente)?_c('v-col',{staticClass:"pa-2",attrs:{"cols":"12","sm":"6","md":"4"}},[_c('v-text-field',{attrs:{"label":_vm.$tc('label.cliente', 1),"readonly":""},model:{value:(_vm.pendencia.cliente),callback:function ($$v) {_vm.$set(_vm.pendencia, "cliente", $$v)},expression:"pendencia.cliente"}})],1):_vm._e(),_vm._v(" "),(_vm.pendencia.ehHolding)?_c('v-col',{staticClass:"pa-2",attrs:{"cols":"12","sm":"6","md":"4"}},[_c('v-text-field',{attrs:{"label":_vm.$tc('label.holding', 1),"readonly":""},model:{value:(_vm.pendencia.holding),callback:function ($$v) {_vm.$set(_vm.pendencia, "holding", $$v)},expression:"pendencia.holding"}})],1):_vm._e(),_vm._v(" "),(_vm.pendencia.ehRegiao)?_c('v-col',{staticClass:"pa-2",attrs:{"cols":"12","sm":"6","md":"4"}},[_c('v-text-field',{attrs:{"label":_vm.$tc('label.regiao', 1),"readonly":""},model:{value:(_vm.pendencia.regiao),callback:function ($$v) {_vm.$set(_vm.pendencia, "regiao", $$v)},expression:"pendencia.regiao"}})],1):_vm._e(),_vm._v(" "),(_vm.pendencia.contratoCliente)?_c('v-col',{staticClass:"pa-2",attrs:{"cols":"12","sm":"6","md":"4"}},[_c('v-text-field',{attrs:{"label":_vm.$tc('label.contrato_cliente', 1),"readonly":""},model:{value:(_vm.pendencia.contratoCliente),callback:function ($$v) {_vm.$set(_vm.pendencia, "contratoCliente", $$v)},expression:"pendencia.contratoCliente"}})],1):_vm._e()],1)],1),_vm._v(" "),_c('status-passos',{ref:"modalAcompanhamento",attrs:{"source":_vm.statusPassos}})],1)}
var staticRenderFns = []



/***/ }),
/* 1218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ClientePagador_vue_vue_type_template_id_6f69cb29___ = __webpack_require__(1219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ClientePagador_vue_vue_type_script_lang_js___ = __webpack_require__(451);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__ClientePagador_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__ClientePagador_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ClientePagador_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__ClientePagador_vue_vue_type_template_id_6f69cb29___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ClientePagador_vue_vue_type_template_id_6f69cb29___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ClientePagador_vue_vue_type_template_id_6f69cb29___ = __webpack_require__(1220);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ClientePagador_vue_vue_type_template_id_6f69cb29___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ClientePagador_vue_vue_type_template_id_6f69cb29___["b"]; });


/***/ }),
/* 1220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{attrs:{"close-on-content-click":false,"nudge-width":400,"offset-x":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"text":"","icon":"","color":"black"}},on),[_c('v-icon',[_vm._v("credit_card")])],1)]}}]),model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_vm._v(" "),_c('v-card',[_c('v-list',[_c('v-list-item',[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.$t('label.cliente_pagador')))])],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',[_c('v-list-item',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.pendencia.clientePagador))])],1),_vm._v(" "),_c('v-list-item',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.pendencia.descTipoBeneficio))])],1),_vm._v(" "),(_vm.pendencia.ehDepositoEmConta)?_c('v-list-item',[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.pendencia.contaCorrente))]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v(_vm._s(_vm.$t('label.banco_agencia_conta')))])],1)],1):_vm._e()],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AcaoFluxo_vue_vue_type_template_id_6c03ec56___ = __webpack_require__(1222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AcaoFluxo_vue_vue_type_script_lang_js___ = __webpack_require__(453);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__AcaoFluxo_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__AcaoFluxo_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__AcaoFluxo_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__AcaoFluxo_vue_vue_type_template_id_6c03ec56___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__AcaoFluxo_vue_vue_type_template_id_6c03ec56___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AcaoFluxo_vue_vue_type_template_id_6c03ec56___ = __webpack_require__(1223);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AcaoFluxo_vue_vue_type_template_id_6c03ec56___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_AcaoFluxo_vue_vue_type_template_id_6c03ec56___["b"]; });


/***/ }),
/* 1223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.disabled)?_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-width":400,"transition":"scale-transition","offset-x":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var onMenu = ref.on;
return [_c('v-tooltip',{attrs:{"left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var onTooltip = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":"","color":_vm.corIcone}},Object.assign({}, onTooltip, onMenu)),[_c('v-icon',[_vm._v(_vm._s(_vm.icone))])],1)]}}],null,true)},[_vm._v(" "),(_vm.exibirJustificativa)?_c('span',[_vm._v(_vm._s(_vm.pendencia.justificativa))]):_vm._e(),_vm._v(" "),(!_vm.exibirJustificativa)?_c('span',[_vm._v(_vm._s(_vm.textoAcao))]):_vm._e()])]}}],null,false,2794017462),model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('div',[_c('h3',{staticClass:"headline mb-0"},[_vm._v(_vm._s(_vm.textoAcao))])])]),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-textarea',{ref:"textareaJustificativa",attrs:{"index":"1","name":"Acaofluxo_justificativa","rules":[_vm.required],"disabled":_vm.bloquearCampos,"label":_vm.validarJustificativa ? ((_vm.$t('label.justificativa')) + " *") : _vm.$t('label.justificativa'),"counter":500,"maxlength":"500","rows":"1","auto-grow":""},model:{value:(_vm.pendencia.justificativa),callback:function ($$v) {_vm.$set(_vm.pendencia, "justificativa", $$v)},expression:"pendencia.justificativa"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-tooltip',{staticClass:"mr-3",attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":"","disabled":_vm.bloquearCampos},on:{"click":_vm.cancelar}},on),[_c('v-icon',[_vm._v("cancel")])],1)]}}],null,false,1459681578)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.cancelar')))])]),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":"","color":_vm.corIcone,"disabled":_vm.bloquearCampos},on:{"click":_vm.executarAcao}},on),[_c('v-icon',[_vm._v(_vm._s(_vm.icone))])],1)]}}],null,false,3382912612)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.textoAcao))])])],1)],1),_vm._v(" "),(_vm.exibirPerguntaProximo)?_c('v-card',[_c('v-card-text',[_vm._v("\n        "+_vm._s(_vm.$t('message.deseja_seguir_proxima_apuracao'))+"\n      ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.naoIrProximo}},[_vm._v("\n          "+_vm._s(_vm.$t('label.nao'))+"\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent"},on:{"click":_vm.irProximo}},[_vm._v("\n          "+_vm._s(_vm.$t('label.sim'))+"\n        ")])],1)],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.disabled)?_c('v-tooltip',{attrs:{"left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":"","color":_vm.corIcone,"disabled":_vm.disabled}},on),[_c('v-icon',[_vm._v(_vm._s(_vm.icone))])],1)]}}],null,false,644416900)},[_vm._v(" "),(_vm.exibirJustificativa)?_c('span',[_vm._v(_vm._s(_vm.pendencia.justificativa))]):_vm._e(),_vm._v(" "),(!_vm.exibirJustificativa)?_c('span',[_vm._v(_vm._s(_vm.getStatus(_vm.status)))]):_vm._e()]):_vm._e()],1)}
var staticRenderFns = []



/***/ }),
/* 1224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_PendenciaApuracao_vue_vue_type_template_id_3dd482c4___ = __webpack_require__(1225);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_PendenciaApuracao_vue_vue_type_template_id_3dd482c4___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_PendenciaApuracao_vue_vue_type_template_id_3dd482c4___["b"]; });


/***/ }),
/* 1225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"px-3"},[_c('v-row',[_c('p',{class:{
        'mb-0': true,
        'py-2': !_vm.pendencia.ehCrescimentoOuNegociacaoPreco
       }},[_c('span',{staticClass:"headline py-2",staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(_vm.$t('title.apuracao')))]),_vm._v(" "),(_vm.pendencia.ehCrescimentoOuNegociacaoPreco)?_c('detalhes-conf-meta',{attrs:{"pendencia":_vm.pendencia}}):_vm._e()],1)]),_vm._v(" "),_c('v-row',[(_vm.pendencia.ehCrescimento)?_c('v-col',{staticClass:"pa-2",attrs:{"cols":"12","sm":"6","md":"3"}},[_c('p',{staticClass:"mb-0"},[_c('metas-crescimento',{attrs:{"pendencia":_vm.pendencia}})],1)]):_vm._e(),_vm._v(" "),(_vm.pendencia.ehPositivacaoOuNegociacaoPreco)?_c('v-col',{staticClass:"pa-2",attrs:{"cols":"12","sm":"6","md":"3"}},[_c('v-text-field',{attrs:{"label":_vm.$tc('label.meta', 1),"readonly":""},model:{value:(_vm.pendencia.valorMeta),callback:function ($$v) {_vm.$set(_vm.pendencia, "valorMeta", $$v)},expression:"pendencia.valorMeta"}})],1):_vm._e(),_vm._v(" "),(_vm.pendencia.ehMetaComContraPartida)?_c('v-col',{staticClass:"pa-2",attrs:{"cols":"12","sm":"6","md":"3"}},[_c('v-text-field',{attrs:{"label":_vm.$tc('label.realizado', 1),"readonly":""},model:{value:(_vm.pendencia.valorRelizado),callback:function ($$v) {_vm.$set(_vm.pendencia, "valorRelizado", $$v)},expression:"pendencia.valorRelizado"}})],1):_vm._e(),_vm._v(" "),_c('v-col',{staticClass:"pa-2",attrs:{"cols":"12","sm":"6","md":"3"}},[_c('v-text-field',{attrs:{"label":_vm.$tc('label.valor_negociado', 1),"readonly":""},model:{value:(_vm.pendencia.valorNegociado),callback:function ($$v) {_vm.$set(_vm.pendencia, "valorNegociado", $$v)},expression:"pendencia.valorNegociado"}})],1),_vm._v(" "),_c('v-col',{staticClass:"pa-2",attrs:{"cols":"12","sm":"6","md":"3"}},[_c('v-text-field',{attrs:{"label":_vm.$tc('label.valor_pagamento', 1),"readonly":""},model:{value:(_vm.pendencia.valorPagamento),callback:function ($$v) {_vm.$set(_vm.pendencia, "valorPagamento", $$v)},expression:"pendencia.valorPagamento"}})],1),_vm._v(" "),_c('v-col',{staticClass:"pa-2",attrs:{"cols":"12","sm":"6","md":"3"}},[_c('v-select',{attrs:{"items":_vm.evidencias,"label":_vm.$tc('label.evidencia_apuracao', 1),"item-text":"label","append-icon":"","item-value":"value","readonly":""},model:{value:(_vm.pendencia.evidencia),callback:function ($$v) {_vm.$set(_vm.pendencia, "evidencia", $$v)},expression:"pendencia.evidencia"}})],1),_vm._v(" "),(_vm.pendencia.ehTabloide)?_c('v-col',{staticClass:"pa-2",attrs:{"cols":"12","sm":"6","md":"3"}},[_c('v-text-field',{attrs:{"label":_vm.$tc('label.preco_negociado', 1),"readonly":""},model:{value:(_vm.pendencia.precoNegociado),callback:function ($$v) {_vm.$set(_vm.pendencia, "precoNegociado", $$v)},expression:"pendencia.precoNegociado"}})],1):_vm._e(),_vm._v(" "),_c('v-col',{staticClass:"pa-2",attrs:{"cols":"12","sm":"6","md":"3"}},[_c('v-text-field',{attrs:{"label":_vm.$tc('label.marca', 1),"readonly":""},model:{value:(_vm.pendencia.marca),callback:function ($$v) {_vm.$set(_vm.pendencia, "marca", $$v)},expression:"pendencia.marca"}})],1),_vm._v(" "),(_vm.pendencia.linhaDeProduto)?_c('v-col',{staticClass:"pa-2",attrs:{"cols":"12","sm":"6","md":"3"}},[_c('v-text-field',{attrs:{"label":_vm.$tc('label.linha_produto', 1),"readonly":""},model:{value:(_vm.pendencia.linhaDeProduto),callback:function ($$v) {_vm.$set(_vm.pendencia, "linhaDeProduto", $$v)},expression:"pendencia.linhaDeProduto"}})],1):_vm._e(),_vm._v(" "),(_vm.pendencia.familia)?_c('v-col',{staticClass:"pa-2",attrs:{"cols":"12","sm":"6","md":"3"}},[_c('v-text-field',{attrs:{"label":_vm.$tc('label.familia', 1),"readonly":""},model:{value:(_vm.pendencia.familia),callback:function ($$v) {_vm.$set(_vm.pendencia, "familia", $$v)},expression:"pendencia.familia"}})],1):_vm._e(),_vm._v(" "),(_vm.pendencia.produto)?_c('v-col',{staticClass:"pa-2",attrs:{"cols":"12","sm":"6","md":"3"}},[_c('v-text-field',{attrs:{"label":_vm.$tc('label.produto', 1),"readonly":""},model:{value:(_vm.pendencia.produto),callback:function ($$v) {_vm.$set(_vm.pendencia, "produto", $$v)},expression:"pendencia.produto"}})],1):_vm._e()],1)],1)])}
var staticRenderFns = []



/***/ }),
/* 1226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DetalhesConfMeta_vue_vue_type_template_id_0037838f___ = __webpack_require__(1227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DetalhesConfMeta_vue_vue_type_script_lang_js___ = __webpack_require__(457);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__DetalhesConfMeta_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__DetalhesConfMeta_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__DetalhesConfMeta_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__DetalhesConfMeta_vue_vue_type_template_id_0037838f___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__DetalhesConfMeta_vue_vue_type_template_id_0037838f___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DetalhesConfMeta_vue_vue_type_template_id_0037838f___ = __webpack_require__(1228);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DetalhesConfMeta_vue_vue_type_template_id_0037838f___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DetalhesConfMeta_vue_vue_type_template_id_0037838f___["b"]; });


/***/ }),
/* 1228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{attrs:{"close-on-content-click":false,"nudge-width":400,"offset-x":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"text":"","icon":"","color":"black"}},on),[_c('v-icon',[_vm._v("info")])],1)]}}]),model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_vm._v(" "),_c('v-card',[_c('v-list',[_c('v-list-item',[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.$t(("configuracao.BONIFICACAO." + (_vm.pendencia.tipoBonificacao)))))]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v(_vm._s(_vm.$t('label.tipo_de_verba')))])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-item',[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.$t(("configuracao.METAS_BENEFICIOS." + (_vm.pendencia.tipoMetaBeneficio)))))]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v(_vm._s(_vm.$t('label.tipo_apuracao')))])],1)],1),_vm._v(" "),(_vm.pendencia.baseCalculoApuracao)?_c('v-divider'):_vm._e(),_vm._v(" "),(_vm.pendencia.baseCalculoApuracao)?_c('v-list-item',[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.$t(("configuracao.BASE_CALCULO." + (_vm.pendencia.baseCalculoApuracao)))))]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v(_vm._s(_vm.$t('label.base_calculo_da_apuracao')))])],1)],1):_vm._e(),_vm._v(" "),(_vm.pendencia.unidadeMedida)?_c('v-divider'):_vm._e(),_vm._v(" "),(_vm.pendencia.unidadeMedida)?_c('v-list-item',[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.pendencia.unidadeMedida))]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v(_vm._s(_vm.$t('label.unidade_medida')))])],1)],1):_vm._e()],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ListarEvidencia_vue_vue_type_template_id_f2387790___ = __webpack_require__(1230);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ListarEvidencia_vue_vue_type_template_id_f2387790___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ListarEvidencia_vue_vue_type_template_id_f2387790___["b"]; });


/***/ }),
/* 1230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canAccessDownload && _vm.evidencias.length)?_c('div',[_c('div',{staticClass:"px-3"},[_c('v-row',[_c('p',{staticClass:"mb-0 py-2"},[_c('span',{staticClass:"headline",staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(_vm.$t('label.execucoes_meta')))])])]),_vm._v(" "),_c('v-list',_vm._l((_vm.evidencias),function(evidencia){return _c('v-list-item',{key:evidencia.id,on:{"click":function($event){return _vm.visualizarArquivo(evidencia)}}},[_c('v-list-item-title',[_vm._v(_vm._s(evidencia.descricao))]),_vm._v(" "),_c('v-list-item-action',[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("visibility")])],1)],1)],1)}),1)],1)]):_vm._e()}
var staticRenderFns = []



/***/ }),
/* 1231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Detalhes_vue_vue_type_template_id_5cc34bf8___ = __webpack_require__(1232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Detalhes_vue_vue_type_script_lang_js___ = __webpack_require__(461);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__Detalhes_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__Detalhes_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Detalhes_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__Detalhes_vue_vue_type_template_id_5cc34bf8___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Detalhes_vue_vue_type_template_id_5cc34bf8___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Detalhes_vue_vue_type_template_id_5cc34bf8___ = __webpack_require__(1233);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Detalhes_vue_vue_type_template_id_5cc34bf8___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Detalhes_vue_vue_type_template_id_5cc34bf8___["b"]; });


/***/ }),
/* 1233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',{attrs:{"id":"dash_op_aba_apurac_dlg_item_detalhes"},nativeOn:{"click":function($event){return _vm.$emit('openDetalhes', _vm.item)}}},[_c('v-list-item-icon',[_c('v-icon',[_vm._v("list")])],1),_vm._v(" "),_c('v-list-item-title',[_vm._v(_vm._s(_vm.$t('label.mais_detalhes')))])],1)}
var staticRenderFns = []



/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      bloqueioSistema: false,
      bloqueioSistemaResouce: this.$api.bloqueioSistema(this.$resource)
    };
  },

  methods: {
    verificaBloqueioSistema: function verificaBloqueioSistema() {
      var _this = this;

      this.bloqueioSistemaResouce.pesquisar().then(function (response) {
        if (response.data) {
          _this.bloqueioSistema = true;
          _this.mostrarMensagemBloqueio();
        }
      }).catch(function () {});
    },
    mostrarMensagemBloqueio: function mostrarMensagemBloqueio() {
      this.$toast.create(this.$t('message.bloqueio_sistema'), 'snack', 3E3);
    }
  },
  mounted: function mounted() {
    this.verificaBloqueioSistema();
  }
};

/***/ }),
/* 1235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ApuracaoTabelaDash_vue_vue_type_style_index_0_id_5eb143d2_scoped_true_lang_css___ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ApuracaoTabelaDash_vue_vue_type_style_index_0_id_5eb143d2_scoped_true_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ApuracaoTabelaDash_vue_vue_type_style_index_0_id_5eb143d2_scoped_true_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ApuracaoTabelaDash_vue_vue_type_style_index_0_id_5eb143d2_scoped_true_lang_css____default.a); 

/***/ }),
/* 1236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ReivindicacaoTabelaDash_vue_vue_type_template_id_29ba444f_lang_html___ = __webpack_require__(1237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ReivindicacaoTabelaDash_vue_vue_type_script_lang_js___ = __webpack_require__(464);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__ReivindicacaoTabelaDash_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__ReivindicacaoTabelaDash_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ReivindicacaoTabelaDash_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(1239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_generico_Pagination_css_vue_type_style_index_1_lang_css___ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);







/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_4__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ReivindicacaoTabelaDash_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__ReivindicacaoTabelaDash_vue_vue_type_template_id_29ba444f_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ReivindicacaoTabelaDash_vue_vue_type_template_id_29ba444f_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ReivindicacaoTabelaDash_vue_vue_type_template_id_29ba444f_lang_html___ = __webpack_require__(1238);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ReivindicacaoTabelaDash_vue_vue_type_template_id_29ba444f_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ReivindicacaoTabelaDash_vue_vue_type_template_id_29ba444f_lang_html___["b"]; });


/***/ }),
/* 1238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"tabindex":"100"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.preventDefault();return _vm.onArrowUpPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.preventDefault();return _vm.onArrowDownPress($event)}]}},[_c('md-dialog',{ref:_vm.dialog.ref,attrs:{"md-open-from":("#" + (_vm.dialog.from))}},[_c('md-dialog-title',[_vm._v(_vm._s(_vm.dialog.title))]),_vm._v(" "),_c('md-dialog-content',[_vm._v(_vm._s(_vm.dialog.content))]),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",attrs:{"id":"acordo-tabela-dialog-cancel"},nativeOn:{"click":function($event){return _vm.closeDialog('dialog1')}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.cancelar'))+"\n      ")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary",attrs:{"id":"acordo-tabela-dialog-save"},nativeOn:{"click":function($event){return _vm.closeDialog('dialog1', _vm.dialog.action)}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.sim'))+"\n      ")])],1)],1),_vm._v(" "),(_vm.isHeaderAvailable)?_c('md-table-card',[_c('md-toolbar',[_c('h1',{staticClass:"md-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('v-btn',{attrs:{"text":"","icon":"","id":"alcada-tabela-button-add"},nativeOn:{"click":function($event){return _vm.$refs.modal.open()}}},[_c('v-icon',[_vm._v("filter_list")])],1)],1),_vm._v(" "),_c('filtros-dash',{ref:"modal",attrs:{"entidade":"DASH_APURACAO_REIVINDICACAO","filtro":_vm.filtro},on:{"FILTROSDASH_FILTRAR":_vm.filtrarModal}}),_vm._v(" "),_c('md-dialog',{ref:"modalAprovar",staticClass:"AcordoTabelaGrid GenericModal__Wrapper"},[_c('div',{staticClass:"GenericModal__Content GenericModal__PaddingDialog"},[_vm._t("header",[_c('h2',[_vm._v(_vm._s(_vm.$t('label.aprovar')))])]),_vm._v(" "),_c('md-input-container',{ref:"inputJustificativaAprovar"},[_c('label',[_vm._v(_vm._s(_vm.$t('label.justificativa')))]),_vm._v(" "),_c('md-textarea',{attrs:{"id":"justificativa_aprovar","name":"justificativa_aprovar"},model:{value:(_vm.justificativa),callback:function ($$v) {_vm.justificativa=$$v},expression:"justificativa"}})],1),_vm._v(" "),_c('md-layout',{attrs:{"md-align":"end"}},[_c('md-button',{staticClass:"md-primary",nativeOn:{"click":function($event){return _vm.requestFecharModaisDefault($event)}}},[_vm._v("\n            "+_vm._s(_vm.$t('label.cancelar'))+"\n          ")]),_vm._v(" "),_c('md-button',{staticClass:"md-accent",nativeOn:{"click":function($event){return _vm.requestAprovarPassosFluxoAcordo($event)}}},[_vm._v("\n            "+_vm._s(_vm.$t('label.aprovar'))+"\n          ")])],1)],2)]),_vm._v(" "),_c('md-dialog',{ref:"modalReprovar",staticClass:"AcordoTabelaGrid GenericModal__Wrapper"},[_c('div',{staticClass:"GenericModal__Content GenericModal__PaddingDialog"},[_vm._t("header",[_c('h2',[_vm._v(_vm._s(_vm.$t('label.reprovar')))])]),_vm._v(" "),_c('md-input-container',{ref:"inputJustificativaReprovar",class:{
              'md-input-invalid': _vm.errors.has('justificativa_reprovar')
            }},[_c('label',[_vm._v(_vm._s(_vm.$t('label.justificativa')))]),_vm._v(" "),_c('md-textarea',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"required":"","id":"justificativa_reprovar","name":"justificativa_reprovar","data-vv-rules":"required","data-vv-name":"justificativa_reprovar"},model:{value:(_vm.justificativa),callback:function ($$v) {_vm.justificativa=$$v},expression:"justificativa"}}),_vm._v(" "),_c('span',{staticClass:"md-error"},[_vm._v("\n            "+_vm._s(_vm.errors.first('justificativa_reprovar'))+"\n          ")])],1),_vm._v(" "),_c('md-layout',{attrs:{"md-align":"end"}},[_c('md-button',{staticClass:"md-primary",nativeOn:{"click":function($event){return _vm.requestFecharModaisDefault($event)}}},[_vm._v("\n              "+_vm._s(_vm.$t('label.cancelar'))+"\n            ")]),_vm._v(" "),_c('md-button',{staticClass:"md-accent",nativeOn:{"click":function($event){return _vm.requestReprovarPassosReivindicacao($event)}}},[_vm._v("\n              "+_vm._s(_vm.$t('label.reprovar'))+"\n            ")])],1)],2)]),_vm._v(" "),_c('md-dialog',{ref:"modalComentario",staticClass:"AcordoTabelaGrid GenericModal__Wrapper"},[_c('div',{staticClass:"GenericModal__Content GenericModal__PaddingDialog"},[_vm._t("header",[_c('h2',[_vm._v(_vm._s(_vm.$t('title.justificativa')))])]),_vm._v(" "),_c('div',{attrs:{"slot":"body","id":"modal_comentario"},slot:"body"},[_c('md-layout',{attrs:{"md-gutter":"6"}},[_c('span',[_vm._v(_vm._s(this.justificativaGrid !== null ? this.justificativaGrid : _vm.$t('message.justificativa_reivindicacao')))])])],1),_vm._v(" "),_c('md-layout',{attrs:{"md-align":"end"}},[_c('md-button',{staticClass:"md-primary",nativeOn:{"click":function($event){return _vm.requestFecharModaisDefault($event)}}},[_vm._v("\n            "+_vm._s(_vm.$t('label.fechar'))+"\n          ")])],1)],2)]),_vm._v(" "),_c('div',{staticClass:"TabelaGenerica__TableWrapper"},[_c('div',{staticClass:"md-table TabelaGenerica__Table ReivindicacaoTabelaDash"},[_c('table',[_c('thead',{staticClass:"md-table-header"},[_c('tr',{staticClass:"md-table-row"},[_c('td',{staticClass:"md-table-cell md-table-selection md-has-action"},[_c('div',{staticClass:"md-table-cell-container"},[_c('md-checkbox',{staticClass:"md-accent",on:{"change":_vm.toggleSelecaoGeral}})],1)]),_vm._v(" "),_vm._l((_vm.tableHeader),function(head,index){return _c('th',{key:index,staticClass:"md-table-head",class:head.classes,attrs:{"md-tooltip":head.tooltip,"md-sort-by":head.sortType}},[_c('div',{staticClass:"md-table-head-container"},[_c('div',{staticClass:"md-table-head-text md-test"},[_vm._v("\n                    "+_vm._s(head.name)+"\n                  ")])])])})],2)]),_vm._v(" "),(_vm.isContentAvailable)?_c('tbody',{staticClass:"md-table-body"},_vm._l((_vm.filteredList),function(row,rowIndex){return _c('tr',{key:rowIndex,staticClass:"md-table-row",class:{ 'TabelaGenerica__TableRow--highlight': _vm.currentEditItem && _vm.currentEditItem === row },attrs:{"md-item":row}},[_c('td',{staticClass:"md-table-cell md-table-selection md-has-action"},[_c('div',{staticClass:"md-table-cell-container"},[_c('md-checkbox',{staticClass:"md-accent",on:{"change":function($event){return _vm.toggleSelecaoUnica(row)}},model:{value:(row.selecionado),callback:function ($$v) {_vm.$set(row, "selecionado", $$v)},expression:"row.selecionado"}})],1)]),_vm._v(" "),(_vm.isColumnVisible('acoes'))?_c('td',{staticClass:"md-table-cell",class:{ 'md-hide-medium': _vm.hideOnMedium('acoes') },nativeOn:{"click":function($event){return _vm.clickOnRow(row, rowIndex)}}},[_c('md-menu',{attrs:{"md-direction":"top left","md-size":"4"}},[_c('md-button',{staticClass:"md-icon-button",attrs:{"md-menu-trigger":""}},[_c('md-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('md-menu-content',{staticClass:"MenuActions"},[(true)?_c('md-menu-item',{nativeOn:{"click":function($event){return _vm.requestBuscarMotivoLog(row)}}},[_c('md-icon',[_vm._v("view_headline")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.justificativa')))])],1):_vm._e(),_vm._v(" "),(true)?_c('md-menu-item',{nativeOn:{"click":function($event){return _vm.requestModalReprovarApuracaoNegociacao(row)}}},[_c('md-icon',[_vm._v("thumb_down")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.reprovar')))])],1):_vm._e(),_vm._v(" "),(true)?_c('md-menu-item',{nativeOn:{"click":function($event){return _vm.requestModalAprovarPassoNegociacao(row)}}},[_c('md-icon',[_vm._v("thumb_up")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.aprovar')))])],1):_vm._e(),_vm._v(" "),_c('md-menu-item',{nativeOn:{"click":function($event){return _vm.requestDownloadEvidenciaReivindicacao(row)}}},[_c('md-icon',{staticClass:"IconesColorBefore",class:{ 'IconesColorAfter': true }},[_vm._v("record_voice_over")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$tc('label.fluxo_reivindicacao_meta_andamento', 2)))])],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('td',{staticClass:"md-table-cell",nativeOn:{"click":function($event){return _vm.clickOnRow(row, rowIndex)}}},[_c('span',[_vm._v(_vm._s(_vm.getMoney(row.vlrConfAcao)))])]),_vm._v(" "),(_vm.isColumnVisible('vlrReivindicado'))?_c('td',{staticClass:"md-table-cell",class:{ 'md-hide-medium': _vm.hideOnMedium('vlrReivindicado')},nativeOn:{"click":function($event){return _vm.clickOnRow(row, rowIndex)}}},[_c('span',[_vm._v(" "+_vm._s(_vm.getMoney(row.vlrReivindicado)))])]):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('descricao'))?_c('td',{staticClass:"md-table-cell",class:{ 'md-hide-medium': _vm.hideOnMedium('descricao') },nativeOn:{"click":function($event){return _vm.clickOnRow(row, rowIndex)}}},[_c('span',{domProps:{"textContent":_vm._s(row.descricao)}})]):_vm._e()])}),0):_vm._e()])]),_vm._v(" "),(!_vm.carregando)?_c('paginate',{directives:[{name:"show",rawName:"v-show",value:(_vm.isContentAvailable && _vm.paginas > 1),expression:"isContentAvailable && paginas > 1"}],attrs:{"page-count":_vm.paginas,"click-handler":_vm.clickHandler,"initial-page":_vm.indexPagina,"prev-text":_vm.$t('label.anterior'),"next-text":_vm.$tc('label.proximo', 1),"container-class":'pagination'}}):_vm._e(),_vm._v(" "),_c('h4',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isContentAvailable && !_vm.carregando),expression:"!isContentAvailable && !carregando"}],staticClass:"TabelaGenerica__NoContent"},[_vm._v("\n          "+_vm._s(_vm.$t('label.tabela_sem_conteudo'))+"\n      ")]),_vm._v(" "),_c('md-spinner',{directives:[{name:"show",rawName:"v-show",value:(_vm.carregando),expression:"carregando"}],staticClass:"TabelaGenerica__InterminateLoader",attrs:{"md-indeterminate":""}})],1)],1):_vm._e()],1)}
var staticRenderFns = []



/***/ }),
/* 1239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ReivindicacaoTabelaDash_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ReivindicacaoTabelaDash_vue_vue_type_style_index_0_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ReivindicacaoTabelaDash_vue_vue_type_style_index_0_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ReivindicacaoTabelaDash_vue_vue_type_style_index_0_lang_css____default.a); 

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'DashboardPlanejamento',
  data: function data() {
    return {
      dashboardNegociacaoResources: this.$api.dashboardNegociacao(this.$resource),
      dashboardApuracaoResources: this.$api.dashboardApuracao(this.$resource),
      usuarioUnidadeNegocioResources: this.$api.usuarioUnidadeNegocio(this.$resource),
      apuracoes: [],
      pendencias: [],
      reinvidicacoes: [],
      periodo: '',
      anos: [],
      ano: null,
      consolidadoApuracao: null,
      vazio: '',
      unidadesNegocio: [],
      idUnidadeNegocio: '',
      periodos: [],
      filtro: {}
    };
  },

  methods: {
    buscarPendencias: function buscarPendencias() {
      var _this = this;

      this.dashboardApuracaoResources.pendencias().then(function (response) {
        _this.pendencias = response.data;
      });
    }
  }
};

/***/ }),
/* 1241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardApuracao_vue_vue_type_style_index_0_id_3dd38884_scoped_true_lang_css___ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardApuracao_vue_vue_type_style_index_0_id_3dd38884_scoped_true_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardApuracao_vue_vue_type_style_index_0_id_3dd38884_scoped_true_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardApuracao_vue_vue_type_style_index_0_id_3dd38884_scoped_true_lang_css____default.a); 

/***/ }),
/* 1242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DashboardPagamento_vue_vue_type_template_id_22c196de_scoped_true_lang_html___ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DashboardPagamento_vue_vue_type_script_lang_js___ = __webpack_require__(468);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__DashboardPagamento_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__DashboardPagamento_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DashboardPagamento_vue_vue_type_style_index_0_id_22c196de_scoped_true_lang_css___ = __webpack_require__(1265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__DashboardPagamento_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__DashboardPagamento_vue_vue_type_template_id_22c196de_scoped_true_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__DashboardPagamento_vue_vue_type_template_id_22c196de_scoped_true_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  "22c196de",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardPagamento_vue_vue_type_template_id_22c196de_scoped_true_lang_html___ = __webpack_require__(1244);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardPagamento_vue_vue_type_template_id_22c196de_scoped_true_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardPagamento_vue_vue_type_template_id_22c196de_scoped_true_lang_html___["b"]; });


/***/ }),
/* 1244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('md-layout',{attrs:{"md-column":""}},[_c('md-layout',[_c('md-layout',{staticStyle:{"padding-left":"30px"},attrs:{"md-flex":"15","md-flex-medium":"30","md-flex-small":"100","md-flex-xsmall":"100"}},[_c('md-input-container',[_c('label',{attrs:{"for":"periodoNegociacao"}},[_vm._v(_vm._s(_vm.$t('label.periodo')))]),_vm._v(" "),_c('md-select',{attrs:{"name":"periodoNegociacao","id":"periodoNegociacaoSelect","disabled":_vm.bloquearConsulta},model:{value:(_vm.periodo),callback:function ($$v) {_vm.periodo=$$v},expression:"periodo"}},[_c('md-option',{attrs:{"value":_vm.vazio},on:{"selected":_vm.refreshData}},[_vm._v("\n              "+_vm._s(_vm.$t('label.ver_todos'))+"\n            ")]),_vm._v(" "),_vm._l((_vm.periodos),function(opt,index){return _c('md-option',{key:index,attrs:{"value":opt.periodo},on:{"selected":_vm.refreshData}},[_vm._v("\n              "+_vm._s(opt.periodo)+"\n            ")])})],2)],1)],1),_vm._v(" "),_c('md-layout',{staticStyle:{"padding-left":"30px"},attrs:{"md-flex":"15","md-flex-medium":"30","md-flex-small":"100","md-flex-xsmall":"100"}},[_c('md-input-container',[_c('label',{attrs:{"for":"unidadeNegocioNegociacao"}},[_vm._v(_vm._s(_vm.$tc('label.unidade_negocio' ,1)))]),_vm._v(" "),_c('md-select',{attrs:{"name":"unidadeNegocioNegociacao","id":"unidadeNegocioNegociacaoSelect","disabled":_vm.bloquearConsulta},model:{value:(_vm.idUnidadeNegocio),callback:function ($$v) {_vm.idUnidadeNegocio=$$v},expression:"idUnidadeNegocio"}},[_c('md-option',{attrs:{"value":null},on:{"selected":_vm.refreshData}},[_vm._v("\n              "+_vm._s(_vm.$t('label.ver_todos'))+"\n            ")]),_vm._v(" "),_vm._l((_vm.unidadesNegocio),function(opt,index){return _c('md-option',{key:index,attrs:{"value":opt.id},on:{"selected":_vm.refreshData}},[_vm._v("\n              "+_vm._s(opt.nomExtensao)+"\n            ")])})],2)],1)],1)],1),_vm._v(" "),_c('box-valores-pagamentos',{attrs:{"carregando":_vm.carregandoBox,"valores-pagamentos":this.valoresPagamentos}}),_vm._v(" "),_c('md-layout',[_c('pagamentos-aprovacoes-tabela',{ref:"pagamentoTabela",staticClass:"CRUDGenerico__ContentTable tableDashApuracao",attrs:{"title":_vm.$tc('label.pagamento', 2),"bloquear-consulta":_vm.bloquearConsulta,"table-rows":_vm.pagamentosAprovacoes,"table-header":_vm.tableHeaderPagamentosAprovacoes,"visible-columns":['idExternoCliente', 'cliente', 'solicitante', 'descTipoAcordo', 'descAcordo', 'status', 'vlrPagamento'],"mobile-invisible-columns":['descricao', 'timeline'],"carregando":_vm.carregandoTable,"paginas":_vm.paginas},on:{"TABELAGENERICA_ORDENAR":_vm.organizar,"PAGAMENTOTABELA_FILTER":_vm.filtrarFluxos,"DASH_PAGAMENTO_TABELA_PAGINA":_vm.requestCarregarPagamentosAprovacoes}})],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PagamentosSolicitadosTabelaDash_vue_vue_type_template_id_3bbf5cde_lang_html___ = __webpack_require__(1246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PagamentosSolicitadosTabelaDash_vue_vue_type_script_lang_js___ = __webpack_require__(470);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__PagamentosSolicitadosTabelaDash_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__PagamentosSolicitadosTabelaDash_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PagamentosSolicitadosTabelaDash_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(1254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__PagamentosSolicitadosTabelaDash_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__PagamentosSolicitadosTabelaDash_vue_vue_type_template_id_3bbf5cde_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__PagamentosSolicitadosTabelaDash_vue_vue_type_template_id_3bbf5cde_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_PagamentosSolicitadosTabelaDash_vue_vue_type_template_id_3bbf5cde_lang_html___ = __webpack_require__(1247);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_PagamentosSolicitadosTabelaDash_vue_vue_type_template_id_3bbf5cde_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_PagamentosSolicitadosTabelaDash_vue_vue_type_template_id_3bbf5cde_lang_html___["b"]; });


/***/ }),
/* 1247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"tabindex":"100"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.preventDefault();return _vm.onArrowUpPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.preventDefault();return _vm.onArrowDownPress($event)}]}},[_c('md-dialog',{ref:_vm.dialog.ref,attrs:{"md-open-from":("#" + (_vm.dialog.from))}},[_c('md-dialog-title',[_vm._v(_vm._s(_vm.dialog.title))]),_vm._v(" "),_c('md-dialog-content',[_vm._v(_vm._s(_vm.dialog.content))]),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",attrs:{"id":"acordo-tabela-dialog-cancel"},nativeOn:{"click":function($event){return _vm.closeDialog('dialog1')}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.cancelar'))+"\n      ")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary",attrs:{"id":"acordo-tabela-dialog-save"},nativeOn:{"click":function($event){return _vm.closeDialog('dialog1', _vm.dialog.action)}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.sim'))+"\n      ")])],1)],1),_vm._v(" "),_c('md-dialog',{ref:'dialogJustificativa'},[_c('md-dialog-title',[_vm._v(_vm._s(_vm.$t('label.justificativa')))]),_vm._v(" "),_c('md-dialog-content',[_vm._v(_vm._s(_vm.justificativa))]),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",attrs:{"id":"acordo-tabela-dialog-cancel"},nativeOn:{"click":function($event){return _vm.closeDialog('dialogJustificativa')}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.voltar'))+"\n      ")])],1)],1),_vm._v(" "),(_vm.isHeaderAvailable)?_c('md-table-card',[_c('md-toolbar',[_c('h1',{staticClass:"md-title"},[_vm._v(_vm._s(_vm.title)+"\n      "),_c('label',{staticClass:"md-subhead"},[_vm._v("("+_vm._s(_vm.$tc('label.solicitado', 2))+")")])]),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",attrs:{"id":"alcada-tabela-button-add"},nativeOn:{"click":function($event){return _vm.$refs.modal.open()}}},[_c('md-icon',[_vm._v("filter_list")])],1)],1),_vm._v(" "),_c('filtros-dash',{ref:"modal",attrs:{"filtro":_vm.filtro,"status-opcoes":_vm.statusOpcoes},on:{"FILTROSDASH_FILTRAR":_vm.filtrarModal}}),_vm._v(" "),_c('rateio-modal',{ref:"dialogRateio",staticClass:"CRUDGenerico__ContentTable",attrs:{"table-rows":_vm.tableRowsRateio,"table-header":_vm.tableHeaderRateio,"visible-columns":['codigo_produto', 'nom_produto', 'valor', 'composicao'],"mobile-invisible-columns":[],"ignore-columns":[]},on:{"TABELAGENERICA_BUSCAR_PROXIMA_PAGINA":_vm.requestRateio}}),_vm._v(" "),_c('md-dialog',{ref:"modalAprovar",staticClass:"AcordoTabelaGrid GenericModal__Wrapper"},[_c('div',{staticClass:"GenericModal__Content GenericModal__PaddingDialog"},[_vm._t("header",[_c('h2',[_vm._v(_vm._s(_vm.$t('label.aprovar')))])]),_vm._v(" "),_c('md-input-container',{ref:"inputJustificativaAprovar"},[_c('label',[_vm._v(_vm._s(_vm.$t('label.justificativa')))]),_vm._v(" "),_c('md-textarea',{attrs:{"id":"justificativa_aprovar","name":"justificativa_aprovar"},model:{value:(_vm.justificativa),callback:function ($$v) {_vm.justificativa=$$v},expression:"justificativa"}})],1),_vm._v(" "),_c('md-layout',{attrs:{"md-align":"end"}},[_c('md-button',{staticClass:"md-primary",nativeOn:{"click":function($event){return _vm.requestFecharModaisDefault($event)}}},[_vm._v("\n            "+_vm._s(_vm.$t('label.cancelar'))+"\n          ")]),_vm._v(" "),_c('md-button',{staticClass:"md-accent",nativeOn:{"click":function($event){return _vm.requestAprovarPassosFluxoAcordo($event)}}},[_vm._v("\n            "+_vm._s(_vm.$t('label.salvar'))+"\n          ")])],1)],2)]),_vm._v(" "),_c('md-dialog',{ref:"modalReprovar",staticClass:"AcordoTabelaGrid GenericModal__Wrapper"},[_c('div',{staticClass:"GenericModal__Content GenericModal__PaddingDialog"},[_vm._t("header",[_c('h2',[_vm._v(_vm._s(_vm.$t('label.reprovar')))])]),_vm._v(" "),_c('md-input-container',{ref:"inputJustificativaReprovar",class:{
              'md-input-invalid': _vm.errors.has('justificativa_reprovar')
            }},[_c('label',[_vm._v(_vm._s(_vm.$t('label.justificativa')))]),_vm._v(" "),_c('md-textarea',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"required":"","id":"justificativa_reprovar","name":"justificativa_reprovar","data-vv-rules":"required","data-vv-name":"justificativa_reprovar"},model:{value:(_vm.justificativa),callback:function ($$v) {_vm.justificativa=$$v},expression:"justificativa"}}),_vm._v(" "),_c('span',{staticClass:"md-error"},[_vm._v("\n            "+_vm._s(_vm.errors.first('justificativa_reprovar'))+"\n          ")])],1),_vm._v(" "),_c('md-layout',{attrs:{"md-align":"end"}},[_c('md-button',{staticClass:"md-primary",nativeOn:{"click":function($event){return _vm.requestFecharModaisDefault($event)}}},[_vm._v("\n              "+_vm._s(_vm.$t('label.cancelar'))+"\n            ")]),_vm._v(" "),_c('md-button',{staticClass:"md-accent",nativeOn:{"click":function($event){return _vm.requestReprovarPassosNegociacao($event)}}},[_vm._v("\n              "+_vm._s(_vm.$t('label.salvar'))+"\n            ")])],1)],2)]),_vm._v(" "),_c('md-dialog',{ref:"modalAnalise",staticClass:"AcordoTabelaGrid GenericModal__Wrapper"},[_c('div',{staticClass:"GenericModal__Content GenericModal__PaddingDialog"},[_vm._t("header",[_c('h2',[_vm._v(_vm._s(_vm.$t('label.enviar_analise')))])]),_vm._v(" "),_c('md-input-container',{ref:"inputJustificativaAnalise",class:{
            'md-input-invalid': _vm.errors.has('justificativa_analise')
          }},[_c('label',[_vm._v(_vm._s(_vm.$t('label.justificativa')))]),_vm._v(" "),_c('md-input',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"type":"text","required":"","id":"justificativa_analise","name":"justificativa_analise","data-vv-rules":"required","data-vv-name":"justificativa_analise"},model:{value:(_vm.justificativa),callback:function ($$v) {_vm.justificativa=$$v},expression:"justificativa"}}),_vm._v(" "),_c('span',{staticClass:"md-error"},[_vm._v("\n            "+_vm._s(_vm.errors.first('justificativa_analise'))+"\n          ")])],1),_vm._v(" "),_c('md-layout',{attrs:{"md-align":"end"}},[_c('md-button',{staticClass:"md-primary",nativeOn:{"click":function($event){return _vm.requestFecharModaisDefault($event)}}},[_vm._v("\n              "+_vm._s(_vm.$t('label.cancelar'))+"\n            ")]),_vm._v(" "),_c('md-button',{staticClass:"md-accent",nativeOn:{"click":function($event){return _vm.requestEnviarNegociacaoParaAnalise($event)}}},[_vm._v("\n              "+_vm._s(_vm.$t('label.salvar'))+"\n            ")])],1)],2)]),_vm._v(" "),_c('md-dialog',{ref:"modalComentario",staticClass:"AcordoTabelaGrid GenericModal__Wrapper"},[_c('div',{staticClass:"GenericModal__Content GenericModal__PaddingDialog"},[_vm._t("header",[_c('h2',[_vm._v(_vm._s(_vm.$t('title.justificativa')))])]),_vm._v(" "),_c('div',{attrs:{"slot":"body","id":"modal_comentario"},slot:"body"},[_c('md-layout',{attrs:{"md-gutter":"6"}},[_c('span',[_vm._v(_vm._s(this.justificativaGrid))])])],1),_vm._v(" "),_c('md-layout',{attrs:{"md-align":"end"}},[_c('md-button',{staticClass:"md-primary",nativeOn:{"click":function($event){return _vm.requestFecharModaisDefault($event)}}},[_vm._v("\n            "+_vm._s(_vm.$t('label.fechar'))+"\n          ")])],1)],2)]),_vm._v(" "),_c('div',{staticClass:"TabelaGenerica__TableWrapper"},[_c('md-table',{ref:"myTable",staticClass:"TabelaGenerica__Table",attrs:{"md-sort":_vm.sortData.name,"md-sort-type":_vm.sortData.type},on:{"select":_vm.onSelect,"sort":_vm.onSort}},[(_vm.isHeaderAvailable)?_c('md-table-header',[_c('md-table-row',_vm._l((_vm.tableHeader),function(head,index){return _c('md-table-head',{key:index,class:head.classes,attrs:{"md-tooltip":head.tooltip,"md-sort-by":head.sortType}},[_vm._v("\n              "+_vm._s(head.name)+"\n            ")])}),1)],1):_vm._e(),_vm._v(" "),(_vm.isContentAvailable)?_c('md-table-body',{attrs:{"tabindex":"110"}},[_vm._l((_vm.filteredList),function(row,rowIndex){return _c('md-table-row',{key:rowIndex,class:{
              'TabelaGenerica__TableRow--highlight': _vm.currentEditItem && _vm.currentEditItem === row,
            },attrs:{"md-item":row,"md-selection":""}},[(_vm.isColumnVisible('idExternoCliente'))?_c('md-table-cell',{key:"rowIndex",class:{
                'md-hide-medium': _vm.hideOnMedium('idExternoCliente'),
              },nativeOn:{"click":function($event){return _vm.clickOnRow(row, rowIndex)}}},[_c('span',[_vm._v(_vm._s(row.idExternoCliente))])]):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('cliente'))?_c('md-table-cell',{key:rowIndex,class:{
                'md-hide-medium': _vm.hideOnMedium('cliente'),
              },nativeOn:{"click":function($event){return _vm.clickOnRow(row, rowIndex)}}},[_c('span',{domProps:{"textContent":_vm._s(row.cliente)}})]):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('aprovador'))?_c('md-table-cell',{key:rowIndex,class:{
                'md-hide-medium': _vm.hideOnMedium('aprovador'),
              },nativeOn:{"click":function($event){return _vm.clickOnRow(row, rowIndex)}}},[_c('span',{domProps:{"textContent":_vm._s(row.aprovador)}})]):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('descTipoAcordo'))?_c('md-table-cell',{key:rowIndex,class:{
                'md-hide-medium': _vm.hideOnMedium('descTipoAcordo'),
              },nativeOn:{"click":function($event){return _vm.clickOnRow(row, rowIndex)}}},[_c('span',{domProps:{"textContent":_vm._s(row.descTipoAcordo)}})]):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('descAcordo'))?_c('md-table-cell',{key:rowIndex,class:{
                'md-hide-medium': _vm.hideOnMedium('descAcordo'),
              },nativeOn:{"click":function($event){return _vm.clickOnRow(row, rowIndex)}}},[_c('span',{domProps:{"textContent":_vm._s(row.descAcordo)}})]):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('status'))?_c('md-table-cell',{key:rowIndex,class:{
                'md-hide-medium': _vm.hideOnMedium('status'),
              },nativeOn:{"click":function($event){return _vm.clickOnRow(row, rowIndex)}}},[_c('span',[_vm._v(_vm._s(_vm.$tc(("status_entidade." + (row.status.toLowerCase())), 1)))])]):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('vlrPagamento'))?_c('md-table-cell',{key:rowIndex,class:{
                'md-hide-medium': _vm.hideOnMedium('vlrPagamento'),
              },nativeOn:{"click":function($event){return _vm.clickOnRow(row, rowIndex)}}},[_c('span',[_vm._v(_vm._s(_vm.getMoney(row.vlrPagamento)))])]):_vm._e(),_vm._v(" "),_c('md-table-cell',{key:rowIndex,class:{
              },nativeOn:{"click":function($event){return _vm.clickOnRow(row, rowIndex)}}},[_c('md-menu',{attrs:{"md-direction":"top left","md-size":"4"}},[_c('md-button',{staticClass:"md-icon-button",attrs:{"md-menu-trigger":""}},[_c('md-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('md-menu-content',[_c('md-menu-item',{directives:[{name:"show",rawName:"v-show",value:(row.justificativa),expression:"row.justificativa"}],nativeOn:{"click":function($event){return _vm.showJustificativa(row)}}},[_c('md-icon',[_vm._v("view_headline")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.justificativa')))])],1),_vm._v(" "),_c('md-menu-item',{directives:[{name:"show",rawName:"v-show",value:(true),expression:"true"}],nativeOn:{"click":function($event){return _vm.requestRateio(row.id)}}},[_c('md-icon',[_vm._v("call_split")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.rateio')))])],1),_vm._v(" "),(row.status === 'AGUARDANDO_APROVACAO')?_c('md-menu-item',{nativeOn:{"click":function($event){return _vm.requestCancelarPagamento(row)}}},[_c('md-icon',[_vm._v("block")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.cancelar')))])],1):_vm._e()],1)],1)],1)],1)}),_vm._v(" "),_c('infinite-loading',{ref:"infiniteLoading",attrs:{"distance":100,"on-infinite":_vm.onInfinite}},[_c('div',{attrs:{"slot":"spinner"},slot:"spinner"})])],2):_vm._e()],1),_vm._v(" "),_c('h4',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isContentAvailable),expression:"!isContentAvailable"}],staticClass:"TabelaGenerica__NoContent"},[_vm._v("\n          "+_vm._s(_vm.$t('label.tabela_sem_conteudo'))+"\n      ")]),_vm._v(" "),_c('md-spinner',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLoading),expression:"showLoading"}],staticClass:"TabelaGenerica__InterminateLoader",attrs:{"slot":"spinner","md-indeterminate":""},slot:"spinner"})],1)],1):_vm._e()],1)}
var staticRenderFns = []



/***/ }),
/* 1248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosDashPagamento_vue_vue_type_template_id_0dbbbf7c___ = __webpack_require__(1249);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosDashPagamento_vue_vue_type_template_id_0dbbbf7c___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosDashPagamento_vue_vue_type_template_id_0dbbbf7c___["b"]; });


/***/ }),
/* 1249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-dialog',{ref:"modal",staticClass:"ResponsiveModal",attrs:{"md-open-from":_vm.mdOpenFrom},on:{"open":_vm.onOpen,"close":_vm.onClose}},[_c('md-dialog-title',[_vm._v(_vm._s(_vm.$tc('title.filtro', 2)))]),_vm._v(" "),_c('md-dialog-content',[_c('md-layout',{attrs:{"md-gutter":"8"}},[_c('md-layout',{staticClass:"MdFlexCustom",attrs:{"md-flex":"30","md-flex-medium":"45","md-flex-small":"95","md-flex-xsmall":"95"}},[_c('md-input-container',[_c('label',{attrs:{"for":"periodoNegociacao"}},[_vm._v(_vm._s(_vm.$tc('label.status', 1)))]),_vm._v(" "),_c('md-select',{attrs:{"name":"periodoNegociacao","id":"periodoNegociacaoSelect"},model:{value:(_vm.filtro.status),callback:function ($$v) {_vm.$set(_vm.filtro, "status", $$v)},expression:"filtro.status"}},_vm._l((_vm.statusOpcoes),function(opt,index){return _c('md-option',{key:index,attrs:{"value":opt.status}},[_vm._v("\n              "+_vm._s(opt.descricao)+"\n              ")])}),1)],1)],1),_vm._v(" "),_c('md-layout',{staticClass:"MdFlexCustom",attrs:{"md-flex":"30","md-flex-medium":"45","md-flex-small":"95","md-flex-xsmall":"95"}},[_c('md-input-container',[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.$tc('label.solicitante', 1)))]),_vm._v(" "),_c('md-autocomplete',{attrs:{"tabindex":"4","name":"filtro_dash_marca","fetch":_vm.dashboardPagamentoResources.listarSolicitantes,"min-chars":1,"printAttribute":"nomeSobrenome","prepareResponseData":_vm.prepareResponseData,"queryParam":"nome"},on:{"selected":_vm.setSolicitante},model:{value:(_vm.obj.solicitante),callback:function ($$v) {_vm.$set(_vm.obj, "solicitante", $$v)},expression:"obj.solicitante"}}),_vm._v(" "),_c('md-icon',{staticStyle:{"cursor":"pointer"},attrs:{"md-autocomplete-search":""}},[_vm._v("search")])],1)],1),_vm._v(" "),_c('md-layout',{staticClass:"MdFlexCustom",attrs:{"md-flex":"30","md-flex-medium":"45","md-flex-small":"95","md-flex-xsmall":"95"}},[_c('md-input-container',[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.$tc('label.tipo_acordo', 1)))]),_vm._v(" "),_c('md-autocomplete',{attrs:{"tabindex":"4","name":"filtro_dash_marca","fetch":_vm.dashboardPagamentoResources.listarTipoAcordo,"min-chars":1,"printAttribute":"desc_tipo_acordo","prepareResponseData":_vm.prepareResponseData,"queryParam":"nome"},on:{"selected":_vm.setTipoAcordo},model:{value:(_vm.obj.tipoAcordo),callback:function ($$v) {_vm.$set(_vm.obj, "tipoAcordo", $$v)},expression:"obj.tipoAcordo"}}),_vm._v(" "),_c('md-icon',{staticStyle:{"cursor":"pointer"},attrs:{"md-autocomplete-search":""}},[_vm._v("search")])],1)],1),_vm._v(" "),_c('md-layout',{staticClass:"MdFlexCustom",attrs:{"md-flex":"30","md-flex-medium":"45","md-flex-small":"95","md-flex-xsmall":"95"}},[_c('md-input-container',[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.$tc('label.marca', 1)))]),_vm._v(" "),_c('md-autocomplete',{attrs:{"tabindex":"4","name":"filtro_dash_marca","fetch":_vm.dashboardPagamentoResources.listarMarcas,"min-chars":1,"printAttribute":"nomExtensao","prepareResponseData":_vm.prepareResponseData,"queryParam":"nome"},on:{"selected":_vm.setMarca},model:{value:(_vm.obj.marca),callback:function ($$v) {_vm.$set(_vm.obj, "marca", $$v)},expression:"obj.marca"}}),_vm._v(" "),_c('md-icon',{staticStyle:{"cursor":"pointer"},attrs:{"md-autocomplete-search":""}},[_vm._v("search")])],1)],1),_vm._v(" "),_c('md-layout',{staticClass:"MdFlexCustom",attrs:{"md-flex":"30","md-flex-medium":"45","md-flex-small":"95","md-flex-xsmall":"95"}},[_c('md-input-container',[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.$tc('label.linha_produto', 1)))]),_vm._v(" "),_c('md-autocomplete',{attrs:{"tabindex":"4","name":"filtro_dash_marca","fetch":_vm.dashboardPagamentoResources.listarLinhaProduto,"min-chars":1,"printAttribute":"nomExtensao","prepareResponseData":_vm.prepareResponseData,"queryParam":"nome"},on:{"selected":_vm.setLinhaProduto},model:{value:(_vm.obj.linhaProduto),callback:function ($$v) {_vm.$set(_vm.obj, "linhaProduto", $$v)},expression:"obj.linhaProduto"}}),_vm._v(" "),_c('md-icon',{staticStyle:{"cursor":"pointer"},attrs:{"md-autocomplete-search":""}},[_vm._v("search")])],1)],1),_vm._v(" "),_c('md-layout',{staticClass:"MdFlexCustom",attrs:{"md-flex":"30","md-flex-medium":"45","md-flex-small":"95","md-flex-xsmall":"95"}},[_c('md-input-container',[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.$tc('label.familia', 1)))]),_vm._v(" "),_c('md-autocomplete',{attrs:{"tabindex":"4","name":"filtro_dash_marca","fetch":_vm.dashboardPagamentoResources.listarFamilia,"min-chars":1,"printAttribute":"nomExtensao","prepareResponseData":_vm.prepareResponseData,"queryParam":"nome"},on:{"selected":_vm.setFamilia},model:{value:(_vm.obj.familia),callback:function ($$v) {_vm.$set(_vm.obj, "familia", $$v)},expression:"obj.familia"}}),_vm._v(" "),_c('md-icon',{staticStyle:{"cursor":"pointer"},attrs:{"md-autocomplete-search":""}},[_vm._v("search")])],1)],1),_vm._v(" "),_c('md-layout',{staticClass:"MdFlexCustom",attrs:{"md-flex":"30","md-flex-medium":"45","md-flex-small":"95","md-flex-xsmall":"95"}},[_c('md-input-container',[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.$tc('label.produto', 1)))]),_vm._v(" "),_c('md-autocomplete',{attrs:{"tabindex":"4","name":"filtro_dash_marca","fetch":_vm.produtoResources.listarAtivos,"min-chars":1,"printAttribute":"nomProduto","prepareResponseData":_vm.prepareResponseData,"queryParam":"nome"},on:{"selected":_vm.setProduto},model:{value:(_vm.obj.produto),callback:function ($$v) {_vm.$set(_vm.obj, "produto", $$v)},expression:"obj.produto"}}),_vm._v(" "),_c('md-icon',{staticStyle:{"cursor":"pointer"},attrs:{"md-autocomplete-search":""}},[_vm._v("search")])],1)],1),_vm._v(" "),_c('md-layout',{staticClass:"MdFlexCustom",attrs:{"md-flex":"30","md-flex-medium":"45","md-flex-small":"95","md-flex-xsmall":"95"}},[_c('md-input-container',[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.$tc('label.cliente', 1)))]),_vm._v(" "),_c('md-autocomplete',{attrs:{"tabindex":"4","name":"filtro_dash_marca","fetch":_vm.clienteResources.listarAtivos,"min-chars":1,"printAttribute":"nomCliente","prepareResponseData":_vm.prepareResponseData,"queryParam":"nome"},on:{"selected":_vm.setCliente},model:{value:(_vm.obj.cliente),callback:function ($$v) {_vm.$set(_vm.obj, "cliente", $$v)},expression:"obj.cliente"}}),_vm._v(" "),_c('md-icon',{staticStyle:{"cursor":"pointer"},attrs:{"md-autocomplete-search":""}},[_vm._v("search")])],1)],1)],1)],1),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{nativeOn:{"click":function($event){return _vm.defaultClose($event)}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.cancelar'))+"\n      ")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary",nativeOn:{"click":function($event){return _vm.filtrar($event)}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.filtrar'))+"\n      ")])],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosDashPagamento_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosDashPagamento_vue_vue_type_style_index_0_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosDashPagamento_vue_vue_type_style_index_0_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosDashPagamento_vue_vue_type_style_index_0_lang_css____default.a); 

/***/ }),
/* 1251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_RateioModal_vue_vue_type_template_id_e052a14e_lang_html___ = __webpack_require__(1252);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_RateioModal_vue_vue_type_template_id_e052a14e_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_RateioModal_vue_vue_type_template_id_e052a14e_lang_html___["b"]; });


/***/ }),
/* 1252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-dialog',{ref:"dialogRateio",attrs:{"md-open-from":_vm.mdOpenFrom},on:{"open":_vm.onOpen,"close":_vm.onClose}},[_c('md-dialog-content',[_c('md-toolbar',[_c('h1',{staticClass:"md-title",domProps:{"textContent":_vm._s(_vm.$tc('label.rateio', 2))}}),_vm._v(" "),_c('md-layout',{attrs:{"md-align":"end"}},[_c('md-button',{staticClass:"md-icon-button",attrs:{"id":"tipoInvestimento-tabela-button-search"},nativeOn:{"click":function($event){return _vm.focusSearchInput('tipoInvestimento-tabela-input-search')}}},[_c('md-icon',[_vm._v("search")])],1)],1),_vm._v(" "),(_vm.openSearchToolbar)?_c('div',{staticClass:"TabelaGenerica__SearchWrapper",class:{
      'TabelaGenerica__SearchWrapper--active': _vm.openSearchToolbar,
      }},[_c('md-input-container',{staticClass:"TabelaGenerica__SearchInput md-accent"},[_c('label',[_vm._v(_vm._s(_vm.$t('label.buscar')))]),_vm._v(" "),_c('md-input',{attrs:{"autoFocus":"true","id":"tipoInvestimento-tabela-input-search","type":"text"},model:{value:(_vm.searchQuery),callback:function ($$v) {_vm.searchQuery=$$v},expression:"searchQuery"}}),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",attrs:{"id":"tipoInvestimento-tabela-button-search-close"},nativeOn:{"click":function($event){return _vm.closeSearchHeader($event)}}},[_c('md-icon',[_vm._v("close")])],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"TabelaGenerica__TableWrapper"},[_c('md-table',{ref:"myTable",staticClass:"TabelaGenerica__Table",attrs:{"md-sort":_vm.sortData.name,"md-sort-type":_vm.sortData.type},on:{"sort":_vm.onSort}},[_c('md-table-header',[_c('md-table-row',_vm._l((_vm.tableHeader),function(head,index){return _c('md-table-head',{key:index,class:head.classes,attrs:{"id":("tipoInvestimento-tabela-head-" + index),"md-tooltip":head.tooltip,"md-sort-by":head.sortType}},[_vm._v("\n              "+_vm._s(head.name)+"\n            ")])}),1)],1),_vm._v(" "),(_vm.isContentAvailable)?_c('md-table-body',{attrs:{"tabindex":"110"}},_vm._l((_vm.filteredList),function(row,rowIndex){return _c('md-table-row',{key:rowIndex,class:{
              'TabelaGenerica__TableRow--highlight': _vm.currentEditItem && _vm.currentEditItem === row,
            },attrs:{"md-item":row}},[(_vm.isColumnVisible('codigo_produto'))?_c('md-table-cell',{key:"rowIndex",class:{
                'md-hide-medium': _vm.hideOnMedium('codigo_produto'),
              },nativeOn:{"click":function($event){return _vm.clickOnRow(row, rowIndex)}}},[_c('span',[_vm._v(_vm._s(row.codigo_produto))])]):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('nom_produto'))?_c('md-table-cell',{key:rowIndex,class:{
                'md-hide-medium': _vm.hideOnMedium('nom_produto'),
              },nativeOn:{"click":function($event){return _vm.clickOnRow(row, rowIndex)}}},[_c('span',{domProps:{"textContent":_vm._s(row.nom_produto)}})]):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('valor'))?_c('md-table-cell',{key:rowIndex,class:{
                'md-hide-medium': _vm.hideOnMedium('valor'),
              },nativeOn:{"click":function($event){return _vm.clickOnRow(row, rowIndex)}}},[_c('span',[_vm._v(_vm._s(_vm.getMoney(row.valor)))])]):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('composicao'))?_c('md-table-cell',{key:rowIndex,class:{
                'md-hide-medium': _vm.hideOnMedium('composicao'),
              },nativeOn:{"click":function($event){return _vm.clickOnRow(row, rowIndex)}}},[_c('span',{domProps:{"textContent":_vm._s(row.composicao)}})]):_vm._e()],1)}),1):_vm._e()],1),_vm._v(" "),_c('h4',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isContentAvailable),expression:"!isContentAvailable"}],staticClass:"TabelaGenerica__NoContent"},[_vm._v("\n      "+_vm._s(_vm.$t('message.nao_ha_conteudo'))+"\n      ")])],1)],1),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{nativeOn:{"click":function($event){return _vm.defaultClose($event)}}},[_vm._v("\n      "+_vm._s(_vm.$t('label.voltar'))+"\n    ")])],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_node_modules_vue_loader_lib_index_js_vue_loader_options_RateioModal_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_node_modules_vue_loader_lib_index_js_vue_loader_options_RateioModal_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_node_modules_vue_loader_lib_index_js_vue_loader_options_RateioModal_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_node_modules_vue_loader_lib_index_js_vue_loader_options_RateioModal_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 1254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_PagamentosSolicitadosTabelaDash_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_PagamentosSolicitadosTabelaDash_vue_vue_type_style_index_0_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_PagamentosSolicitadosTabelaDash_vue_vue_type_style_index_0_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_PagamentosSolicitadosTabelaDash_vue_vue_type_style_index_0_lang_css____default.a); 

/***/ }),
/* 1255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PagamentosAprovacoesTabelaDash_vue_vue_type_template_id_c9415b6e_lang_html___ = __webpack_require__(1256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PagamentosAprovacoesTabelaDash_vue_vue_type_script_lang_js___ = __webpack_require__(481);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__PagamentosAprovacoesTabelaDash_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__PagamentosAprovacoesTabelaDash_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PagamentosAprovacoesTabelaDash_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_generico_Pagination_css_vue_type_style_index_1_lang_css___ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);







/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_4__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__PagamentosAprovacoesTabelaDash_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__PagamentosAprovacoesTabelaDash_vue_vue_type_template_id_c9415b6e_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__PagamentosAprovacoesTabelaDash_vue_vue_type_template_id_c9415b6e_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_PagamentosAprovacoesTabelaDash_vue_vue_type_template_id_c9415b6e_lang_html___ = __webpack_require__(1257);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_PagamentosAprovacoesTabelaDash_vue_vue_type_template_id_c9415b6e_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_PagamentosAprovacoesTabelaDash_vue_vue_type_template_id_c9415b6e_lang_html___["b"]; });


/***/ }),
/* 1257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"tabindex":"100"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.preventDefault();return _vm.onArrowUpPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.preventDefault();return _vm.onArrowDownPress($event)}]}},[_c('md-dialog',{ref:_vm.dialog.ref,attrs:{"md-open-from":("#" + (_vm.dialog.from))}},[_c('md-dialog-title',[_vm._v(_vm._s(_vm.dialog.title))]),_vm._v(" "),_c('md-dialog-content',[_vm._v(_vm._s(_vm.dialog.content))]),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",attrs:{"id":"acordo-tabela-dialog-cancel"},nativeOn:{"click":function($event){return _vm.closeDialog('dialog1')}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.cancelar'))+"\n      ")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary",attrs:{"id":"acordo-tabela-dialog-save"},nativeOn:{"click":function($event){return _vm.closeDialog('dialog1', _vm.dialog.action)}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.sim'))+"\n      ")])],1)],1),_vm._v(" "),_c('md-dialog',{ref:'dialogJustificativa'},[_c('md-dialog-title',[_vm._v(_vm._s(_vm.$t('label.justificativa')))]),_vm._v(" "),_c('md-dialog-content',[_vm._v(_vm._s(_vm.justificativa))]),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",attrs:{"id":"acordo-tabela-dialog-cancel"},nativeOn:{"click":function($event){return _vm.closeDialog('dialogJustificativa')}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.cancelar'))+"\n      ")])],1)],1),_vm._v(" "),(_vm.isHeaderAvailable)?_c('md-table-card',[_c('md-toolbar',[_c('h1',{staticClass:"md-title"},[_vm._v(_vm._s(_vm.title)+"\n      "),_c('label',{staticClass:"md-subhead"},[_vm._v("("+_vm._s(_vm.$tc('label.aprovacoes', 1))+")")])]),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",attrs:{"id":"alcada-tabela-button-add","disabled":_vm.bloquearConsulta},nativeOn:{"click":function($event){return _vm.$refs.modal.open()}}},[_c('md-icon',[_vm._v("filter_list")])],1)],1),_vm._v(" "),_c('filtros-dash',{ref:"modal",attrs:{"filtro":_vm.filtro,"status-opcoes":_vm.statusOpcoes},on:{"FILTROSDASH_FILTRAR":_vm.filtrarModal}}),_vm._v(" "),_c('rateio-modal',{ref:"dialogRateio",attrs:{"table-rows":_vm.tableRowsRateio,"table-header":_vm.tableHeaderRateio,"visible-columns":['codigo_produto', 'nom_produto', 'valor', 'composicao'],"mobile-invisible-columns":[],"ignore-columns":[]}}),_vm._v(" "),_c('md-dialog',{ref:"modalAprovar",staticClass:"AcordoTabelaGrid GenericModal__Wrapper"},[_c('div',{staticClass:"GenericModal__Content GenericModal__PaddingDialog"},[_vm._t("header",[_c('h2',[_vm._v(_vm._s(_vm.$t('label.aprovar')))])]),_vm._v(" "),_c('md-input-container',{ref:"inputJustificativaAprovar"},[_c('label',[_vm._v(_vm._s(_vm.$t('label.justificativa')))]),_vm._v(" "),_c('md-textarea',{attrs:{"id":"justificativa_aprovar","name":"justificativa_aprovar"},model:{value:(_vm.justificativa),callback:function ($$v) {_vm.justificativa=$$v},expression:"justificativa"}})],1),_vm._v(" "),_c('md-layout',{attrs:{"md-align":"end"}},[_c('md-button',{staticClass:"md-primary",nativeOn:{"click":function($event){return _vm.requestFecharModaisDefault($event)}}},[_vm._v("\n            "+_vm._s(_vm.$t('label.cancelar'))+"\n          ")]),_vm._v(" "),_c('md-button',{staticClass:"md-accent",nativeOn:{"click":function($event){return _vm.requestAprovarPassosFluxo($event)}}},[_vm._v("\n            "+_vm._s(_vm.$t('labedialogRateio.salvar'))+"\n          ")])],1)],2)]),_vm._v(" "),_c('md-dialog',{ref:"modalReprovar",staticClass:"AcordoTabelaGrid GenericModal__Wrapper"},[_c('div',{staticClass:"GenericModal__Content GenericModal__PaddingDialog"},[_vm._t("header",[_c('h2',[_vm._v(_vm._s(_vm.$t('label.reprovar')))])]),_vm._v(" "),_c('md-input-container',{ref:"inputJustificativaReprovar",class:{
              'md-input-invalid': _vm.errors.has('justificativa_reprovar')
            }},[_c('label',[_vm._v(_vm._s(_vm.$t('label.justificativa')))]),_vm._v(" "),_c('md-textarea',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"required":"","id":"justificativa_reprovar","name":"justificativa_reprovar","data-vv-rules":"required","data-vv-name":"justificativa_reprovar"},model:{value:(_vm.justificativa),callback:function ($$v) {_vm.justificativa=$$v},expression:"justificativa"}}),_vm._v(" "),_c('span',{staticClass:"md-error"},[_vm._v("\n            "+_vm._s(_vm.errors.first('justificativa_reprovar'))+"\n          ")])],1),_vm._v(" "),_c('md-layout',{attrs:{"md-align":"end"}},[_c('md-button',{staticClass:"md-primary",nativeOn:{"click":function($event){return _vm.requestFecharModaisDefault($event)}}},[_vm._v("\n              "+_vm._s(_vm.$t('label.cancelar'))+"\n            ")]),_vm._v(" "),_c('md-button',{staticClass:"md-accent",nativeOn:{"click":function($event){return _vm.requestReprovarPagamento($event)}}},[_vm._v("\n              "+_vm._s(_vm.$t('label.salvar'))+"\n            ")])],1)],2)]),_vm._v(" "),_c('md-dialog',{ref:"modalComentario",staticClass:"AcordoTabelaGrid GenericModal__Wrapper"},[_c('div',{staticClass:"GenericModal__Content GenericModal__PaddingDialog"},[_vm._t("header",[_c('h2',[_vm._v(_vm._s(_vm.$t('title.justificativa')))])]),_vm._v(" "),_c('div',{attrs:{"slot":"body","id":"modal_comentario"},slot:"body"},[_c('md-layout',{attrs:{"md-gutter":"6"}},[_c('span',[_vm._v(_vm._s(this.justificativaGrid))])])],1),_vm._v(" "),_c('md-layout',{attrs:{"md-align":"end"}},[_c('md-button',{staticClass:"md-primary",nativeOn:{"click":function($event){return _vm.requestFecharModaisDefault($event)}}},[_vm._v("\n            "+_vm._s(_vm.$t('label.voltar'))+"\n          ")])],1)],2)]),_vm._v(" "),_c('div',{staticClass:"TabelaGenerica__TableWrapper"},[_c('div',{staticClass:"md-table TabelaGenerica__Table"},[_c('table',[_c('thead',{staticClass:"md-table-header"},[_c('tr',{staticClass:"md-table-row"},[_c('td',{staticClass:"md-table-cell md-table-selection md-has-action"},[_c('div',{staticClass:"md-table-cell-container"},[_c('md-checkbox',{staticClass:"md-accent",on:{"change":_vm.toggleSelecaoGeral}})],1)]),_vm._v(" "),_vm._l((_vm.tableHeader),function(head,index){return _c('th',{key:index,staticClass:"md-table-head",class:head.classes,attrs:{"md-tooltip":head.tooltip,"md-sort-by":head.sortType}},[_c('div',{staticClass:"md-table-head-container"},[_c('div',{staticClass:"md-table-head-text md-test"},[_vm._v("\n                    "+_vm._s(head.name)+"\n                  ")])])])})],2)]),_vm._v(" "),(_vm.isContentAvailable)?_c('tbody',{staticClass:"md-table-body"},_vm._l((_vm.filteredList),function(row,rowIndex){return _c('tr',{key:rowIndex,staticClass:"md-table-row",class:{
                      'TabelaGenerica__TableRow--highlight': _vm.currentEditItem && _vm.currentEditItem === row,
                    },attrs:{"md-item":row}},[_c('td',{staticClass:"md-table-cell md-table-selection md-has-action"},[_c('div',{staticClass:"md-table-cell-container"},[_c('md-checkbox',{staticClass:"md-accent",on:{"change":function($event){return _vm.toggleSelecaoUnica(row)}},model:{value:(row.selecionado),callback:function ($$v) {_vm.$set(row, "selecionado", $$v)},expression:"row.selecionado"}})],1)]),_vm._v(" "),(_vm.isColumnVisible('idExternoCliente'))?_c('td',{staticClass:"md-table-cell",class:{ 'md-hide-medium': _vm.hideOnMedium('idExternoCliente') },nativeOn:{"click":function($event){return _vm.clickOnRow(row, rowIndex)}}},[_c('span',[_vm._v(_vm._s(row.idExternoCliente))])]):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('cliente'))?_c('td',{staticClass:"md-table-cell",class:{ 'md-hide-medium': _vm.hideOnMedium('cliente')},nativeOn:{"click":function($event){return _vm.clickOnRow(row, rowIndex)}}},[_c('span',{domProps:{"textContent":_vm._s(row.cliente)}})]):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('solicitante'))?_c('td',{staticClass:"md-table-cell",class:{ 'md-hide-medium': _vm.hideOnMedium('solicitante') },nativeOn:{"click":function($event){return _vm.clickOnRow(row, rowIndex)}}},[_c('span',{domProps:{"textContent":_vm._s(row.solicitante)}})]):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('descTipoAcordo'))?_c('td',{staticClass:"md-table-cell",class:{ 'md-hide-medium': _vm.hideOnMedium('descTipoAcordo') },nativeOn:{"click":function($event){return _vm.clickOnRow(row, rowIndex)}}},[_c('span',{domProps:{"textContent":_vm._s(row.descTipoAcordo)}})]):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('descAcordo'))?_c('td',{staticClass:"md-table-cell",class:{ 'md-hide-medium': _vm.hideOnMedium('descAcordo') },nativeOn:{"click":function($event){return _vm.clickOnRow(row, rowIndex)}}},[_c('span',{domProps:{"textContent":_vm._s(row.descAcordo)}})]):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('status'))?_c('td',{staticClass:"md-table-cell",class:{ 'md-hide-medium': _vm.hideOnMedium('status') },nativeOn:{"click":function($event){return _vm.clickOnRow(row, rowIndex)}}},[_c('span',[_vm._v(_vm._s(_vm.$tc(("status_entidade." + (row.status.toLowerCase())), 1)))])]):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('vlrPagamento'))?_c('td',{staticClass:"md-table-cell",class:{ 'md-hide-medium': _vm.hideOnMedium('vlrPagamento') },nativeOn:{"click":function($event){return _vm.clickOnRow(row, rowIndex)}}},[_c('span',[_vm._v(_vm._s(_vm.getMoney(row.vlrPagamento)))])]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"md-table-cell",nativeOn:{"click":function($event){return _vm.clickOnRow(row, rowIndex)}}},[_c('md-menu',{attrs:{"md-direction":"top left","md-size":"4"}},[_c('md-button',{staticClass:"md-icon-button",attrs:{"md-menu-trigger":""}},[_c('md-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('md-menu-content',[(row.justificativa)?_c('md-menu-item',{nativeOn:{"click":function($event){return _vm.showJustificativa(row)}}},[_c('md-icon',[_vm._v("view_headline")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.justificativa')))])],1):_vm._e(),_vm._v(" "),_c('md-menu-item',{directives:[{name:"show",rawName:"v-show",value:(true),expression:"true"}],nativeOn:{"click":function($event){return _vm.requestRateio(row.id)}}},[_c('md-icon',[_vm._v("call_split")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.rateio')))])],1),_vm._v(" "),_c('md-menu-item',{directives:[{name:"show",rawName:"v-show",value:(true),expression:"true"}],nativeOn:{"click":function($event){return _vm.exibirModalAcompanhamentoDoPagamento(row)}}},[_c('md-icon',[_vm._v("assignment_turned_in")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.acompanhamento')))])],1),_vm._v(" "),(row.aprovador && row.status === 'AGUARDANDO_APROVACAO')?_c('md-menu-item',{nativeOn:{"click":function($event){return _vm.requestModalReprovarPassoPagamento(row)}}},[_c('md-icon',[_vm._v("thumb_down")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.reprovar')))])],1):_vm._e(),_vm._v(" "),(row.aprovador && row.status === 'AGUARDANDO_APROVACAO')?_c('md-menu-item',{nativeOn:{"click":function($event){return _vm.requestModalAprovarPassoPagamento(row)}}},[_c('md-icon',[_vm._v("thumb_up")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.aprovar')))])],1):_vm._e()],1)],1)],1)])}),0):_vm._e()])]),_vm._v(" "),(!_vm.carregando)?_c('paginate',{directives:[{name:"show",rawName:"v-show",value:(_vm.isContentAvailable && _vm.paginas > 1),expression:"isContentAvailable && paginas > 1"}],attrs:{"page-count":_vm.paginas,"click-handler":_vm.clickHandler,"initial-page":_vm.indexPagina,"prev-text":_vm.$t('label.anterior'),"next-text":_vm.$tc('label.proximo', 1),"container-class":'pagination'}}):_vm._e(),_vm._v(" "),_c('h4',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isContentAvailable && !_vm.carregando),expression:"!isContentAvailable && !carregando"}],staticClass:"TabelaGenerica__NoContent"},[_vm._v("\n          "+_vm._s(_vm.$t('label.tabela_sem_conteudo'))+"\n      ")]),_vm._v(" "),_c('md-spinner',{directives:[{name:"show",rawName:"v-show",value:(_vm.carregando),expression:"carregando"}],staticClass:"TabelaGenerica__InterminateLoader",attrs:{"md-indeterminate":""}})],1)],1):_vm._e()],1)}
var staticRenderFns = []



/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      passosResources: this.$api.workflowPassos(this.$resource),
      timelinePagamento: null
    };
  },

  methods: {
    limparTimeline: function limparTimeline() {
      this.timelinePagamento = null;
    },
    showPagamentoTimeline: function showPagamentoTimeline(pagamento) {
      var _this = this;

      if (!pagamento) {
        return;
      }
      var id = pagamento.id;
      this.passosResources.pagamento({ id: id }, { id: id }).then(function (res) {
        _this.timelinePagamento = res.data.passos;
        _this.showTimeline();
      }).catch(function () {
        _this.showTimeline();
      });
    },
    showTimeline: function showTimeline() {
      this.openDialog('modalTimeline');
    },
    closeDialogPagamento: function closeDialogPagamento() {
      this.$refs.modalTimeline.close();
    }
  }
};

/***/ }),
/* 1259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_PagamentosAprovacoesTabelaDash_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_PagamentosAprovacoesTabelaDash_vue_vue_type_style_index_0_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_PagamentosAprovacoesTabelaDash_vue_vue_type_style_index_0_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_PagamentosAprovacoesTabelaDash_vue_vue_type_style_index_0_lang_css____default.a); 

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'DashboardPlanejamento',
  data: function data() {
    return {
      dashboardPagamentoResources: this.$api.dashboardPagamento(this.$resource),
      usuarioUnidadeNegocioResources: this.$api.usuarioUnidadeNegocio(this.$resource),
      pagamentosSolicitados: [],
      pagamentosAprovacoes: [],
      reinvidicacoes: [],
      periodo: '',
      anos: [],
      ano: null,
      valoresPagamentos: null,
      vazio: '',
      unidadesNegocio: [],
      idUnidadeNegocio: '',
      periodos: [],
      tableHeaderPagamentosSolicitados: [{
        name: this.$tc('label.codigo_cliente', 1),
        sortType: 'idExternoCliente',
        classes: []
      }, {
        name: this.$tc('label.cliente', 1),
        sortType: 'cliente',
        classes: []
      }, {
        name: this.$tc('label.aprovador', 1),
        sortType: 'aprovador',
        classes: ['md-hide-medium']
      }, {
        name: this.$tc('label.tipo_acordo'),
        sortType: 'descTipoAcordo',
        classes: ['md-hide-medium']
      }, {
        name: this.$tc('label.desc_acordo'),
        sortType: 'descAcordo',
        classes: ['md-hide-medium']
      }, {
        name: this.$tc('label.status_pagamento', 2),
        sortType: 'status',
        classes: []
      }, {
        name: this.$tc('label.valor_pagamento', 2),
        sortType: 'vlrPagamento',
        classes: ['md-hide-medium']
      }],
      tableHeaderPagamentosAprovacoes: [{
        name: this.$tc('label.codigo_cliente', 1),
        sortType: 'idExternoCliente',
        classes: []
      }, {
        name: this.$tc('label.cliente', 1),
        sortType: 'cliente',
        classes: []
      }, {
        name: this.$tc('label.solicitante', 1),
        sortType: 'aprovador',
        classes: ['md-hide-medium']
      }, {
        name: this.$tc('label.tipo_acordo'),
        sortType: 'descTipoAcordo',
        classes: ['md-hide-medium']
      }, {
        name: this.$tc('label.desc_acordo'),
        sortType: 'descAcordo',
        classes: ['md-hide-medium']
      }, {
        name: this.$tc('label.status_pagamento', 2),
        sortType: 'status',
        classes: []
      }, {
        name: this.$tc('label.valor_pagamento', 2),
        sortType: 'vlrPagamento',
        classes: ['md-hide-medium']
      }],
      filtro: {}
    };
  },

  methods: {}
};

/***/ }),
/* 1261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BoxValoresPagamentos_vue_vue_type_template_id_9fc54102_scoped_true_lang_html___ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BoxValoresPagamentos_vue_vue_type_script_lang_js___ = __webpack_require__(484);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__BoxValoresPagamentos_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__BoxValoresPagamentos_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BoxValoresPagamentos_vue_vue_type_style_index_0_id_9fc54102_scoped_true_lang_css___ = __webpack_require__(1264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__BoxValoresPagamentos_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__BoxValoresPagamentos_vue_vue_type_template_id_9fc54102_scoped_true_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__BoxValoresPagamentos_vue_vue_type_template_id_9fc54102_scoped_true_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  "9fc54102",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_BoxValoresPagamentos_vue_vue_type_template_id_9fc54102_scoped_true_lang_html___ = __webpack_require__(1263);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_BoxValoresPagamentos_vue_vue_type_template_id_9fc54102_scoped_true_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_BoxValoresPagamentos_vue_vue_type_template_id_9fc54102_scoped_true_lang_html___["b"]; });


/***/ }),
/* 1263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.valoresPagamentos)?_c('div',{staticClass:"Consolidados"},[_c('md-whiteframe',{staticStyle:{"flex-basis":"32%"},attrs:{"md-elevation":"6"}},[_c('div',{staticClass:"ValuesConsolidados",style:({
         'background-color': '#03a9f4'
       })},[_c('div',{staticClass:"Consolidados_Valores"},[_c('span',{staticClass:"Consolidados_Valores_Fonts"},[_vm._v(_vm._s(_vm.$t('label.aguardando_pagamento')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.carregando),expression:"!carregando"}],staticClass:"Consolidados_Valores_Fonts"},[_vm._v(" "+_vm._s(_vm.getMoney(this.valoresPagamentos.vlrAguardandoPagamento)))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.carregando),expression:"carregando"}],staticClass:"Consolidados_Valores_Fonts"},[_c('md-spinner',{attrs:{"md-size":30,"md-stroke":2,"md-indeterminate":""}})],1)])])]),_vm._v(" "),_c('md-whiteframe',{staticStyle:{"flex-basis":"32%"},attrs:{"md-elevation":"6"}},[_c('div',{staticClass:"ValuesConsolidados",style:({
         'background-color': '#4caf50'
       })},[_c('div',{staticClass:"Consolidados_Valores"},[_c('span',{staticClass:"Consolidados_Valores_Fonts"},[_vm._v(_vm._s(_vm.$t('label.bloqueado')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.carregando),expression:"!carregando"}],staticClass:"Consolidados_Valores_Fonts"},[_vm._v(" "+_vm._s(_vm.getMoney(this.valoresPagamentos.vlrBloqueado)))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.carregando),expression:"carregando"}],staticClass:"Consolidados_Valores_Fonts"},[_c('md-spinner',{attrs:{"md-size":30,"md-stroke":2,"md-indeterminate":""}})],1)])])]),_vm._v(" "),_c('md-whiteframe',{staticStyle:{"flex-basis":"32%"},attrs:{"md-elevation":"6"}},[_c('div',{staticClass:"ValuesConsolidados",style:({
         'background-color': '#fb8c00'
       })},[_c('div',{staticClass:"Consolidados_Valores"},[_c('span',{staticClass:"Consolidados_Valores_Fonts"},[_vm._v(_vm._s(_vm.$t('label.liquidado')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.carregando),expression:"!carregando"}],staticClass:"Consolidados_Valores_Fonts"},[_vm._v(" "+_vm._s(_vm.getMoney(this.valoresPagamentos.vlrLiquidado)))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.carregando),expression:"carregando"}],staticClass:"Consolidados_Valores_Fonts"},[_c('md-spinner',{attrs:{"md-size":30,"md-stroke":2,"md-indeterminate":""}})],1)])])])],1):_vm._e()}
var staticRenderFns = []



/***/ }),
/* 1264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_BoxValoresPagamentos_vue_vue_type_style_index_0_id_9fc54102_scoped_true_lang_css___ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_BoxValoresPagamentos_vue_vue_type_style_index_0_id_9fc54102_scoped_true_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_BoxValoresPagamentos_vue_vue_type_style_index_0_id_9fc54102_scoped_true_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_BoxValoresPagamentos_vue_vue_type_style_index_0_id_9fc54102_scoped_true_lang_css____default.a); 

/***/ }),
/* 1265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardPagamento_vue_vue_type_style_index_0_id_22c196de_scoped_true_lang_css___ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardPagamento_vue_vue_type_style_index_0_id_22c196de_scoped_true_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardPagamento_vue_vue_type_style_index_0_id_22c196de_scoped_true_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardPagamento_vue_vue_type_style_index_0_id_22c196de_scoped_true_lang_css____default.a); 

/***/ }),
/* 1266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DashboardAcompanhamento_vue_vue_type_template_id_2950bb69_scoped_true_lang_html___ = __webpack_require__(1267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DashboardAcompanhamento_vue_vue_type_script_lang_js___ = __webpack_require__(489);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__DashboardAcompanhamento_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__DashboardAcompanhamento_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DashboardAcompanhamento_vue_vue_type_style_index_0_id_2950bb69_scoped_true_lang_css___ = __webpack_require__(1285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__DashboardAcompanhamento_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__DashboardAcompanhamento_vue_vue_type_template_id_2950bb69_scoped_true_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__DashboardAcompanhamento_vue_vue_type_template_id_2950bb69_scoped_true_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  "2950bb69",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardAcompanhamento_vue_vue_type_template_id_2950bb69_scoped_true_lang_html___ = __webpack_require__(1268);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardAcompanhamento_vue_vue_type_template_id_2950bb69_scoped_true_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardAcompanhamento_vue_vue_type_template_id_2950bb69_scoped_true_lang_html___["b"]; });


/***/ }),
/* 1268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"DashboardAcompanhamento"},[_c('div',{attrs:{"id":"ok"}},[_c('execucao-modal',{ref:"execucaoModal"})],1),_vm._v(" "),_c('md-layout',{attrs:{"md-column":""}},[_c('md-layout',[_c('md-layout',{attrs:{"md-flex":"15","md-flex-medium":"30","md-flex-small":"100","md-flex-xsmall":"100"}},[_c('md-input-container',[_c('label',{attrs:{"for":"periodoSelect"}},[_vm._v(_vm._s(_vm.$t('label.periodo')))]),_vm._v(" "),_c('md-select',{attrs:{"id":"periodoSelect"},model:{value:(_vm.competencia),callback:function ($$v) {_vm.competencia=$$v},expression:"competencia"}},_vm._l((_vm.competenciasPagamento),function(opt,index){return _c('md-option',{key:index,attrs:{"value":opt.valor},on:{"selected":_vm.refreshDashboard}},[_vm._v("\n              "+_vm._s(opt.nome)+"\n            ")])}),1)],1)],1)],1)],1),_vm._v(" "),_c('md-layout',{staticClass:"Consolidados",attrs:{"md-gutter":"8"}},[_c('md-layout',{attrs:{"md-flex":"16","md-flex-medium":"33"}},[_c('md-whiteframe',{attrs:{"md-elevation":"6"}},[_c('div',{staticClass:"ValuesConsolidados",staticStyle:{"background-color":"#03a9f4"}},[_c('div',{staticClass:"Consolidados_Valores"},[_c('span',{staticClass:"Consolidados_Valores_Fonts"},[_vm._v(_vm._s(_vm.$t('label.aguardando_pagamento')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.carregandoBox),expression:"!carregandoBox"}],staticClass:"Consolidados_Valores_Fonts"},[_vm._v("\n              "+_vm._s(_vm.getMoney(_vm.consolidado.aguardandoPagamento, 0))+"\n            ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.carregandoBox),expression:"carregandoBox"}],staticClass:"Consolidados_Valores_Fonts"},[_c('md-spinner',{attrs:{"md-size":30,"md-stroke":2,"md-indeterminate":""}})],1)])])])],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"16","md-flex-medium":"33"}},[_c('md-whiteframe',{attrs:{"md-elevation":"6"}},[_c('div',{staticClass:"ValuesConsolidados",staticStyle:{"background-color":"#4caf50"}},[_c('div',{staticClass:"Consolidados_Valores"},[_c('span',{staticClass:"Consolidados_Valores_Fonts"},[_vm._v(_vm._s(_vm.$t('label.pagamento_efetivado')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.carregandoBox),expression:"!carregandoBox"}],staticClass:"Consolidados_Valores_Fonts"},[_vm._v("\n              "+_vm._s(_vm.getMoney(_vm.consolidado.liquidado, 0))+"\n            ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.carregandoBox),expression:"carregandoBox"}],staticClass:"Consolidados_Valores_Fonts"},[_c('md-spinner',{attrs:{"md-size":30,"md-stroke":2,"md-indeterminate":""}})],1)])])])],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"16","md-flex-medium":"33"}},[_c('md-whiteframe',{attrs:{"md-elevation":"6"}},[_c('div',{staticClass:"ValuesConsolidados",staticStyle:{"background-color":"#fb8c00"}},[_c('div',{staticClass:"Consolidados_Valores"},[_c('span',{staticClass:"Consolidados_Valores_Fonts"},[_vm._v(_vm._s(_vm.$t('label.pagamento_rejeitado')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.carregandoBox),expression:"!carregandoBox"}],staticClass:"Consolidados_Valores_Fonts"},[_vm._v("\n              "+_vm._s(_vm.getMoney(_vm.consolidado.naoEfetuado, 0))+"\n            ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.carregandoBox),expression:"carregandoBox"}],staticClass:"Consolidados_Valores_Fonts"},[_c('md-spinner',{attrs:{"md-size":30,"md-stroke":2,"md-indeterminate":""}})],1)])])])],1)],1),_vm._v(" "),_c('md-layout',{staticClass:"Layout_Tabela"},[_c('negociacoes-aguardando-aprovacao',{ref:"negociacoesAgAprovacao",attrs:{"carregando":_vm.carregandoAgAprovacao,"negociacoes":_vm.negociacoesAgAprovacao,"paginas":_vm.paginasNegociacoesAgAprovacao},on:{"NEGOCIACAO_AG_APROVACAO_TABELA_PAGINA":_vm.requestCarregarNegociacoesAgAprovacao}})],1),_vm._v(" "),_c('md-layout',{staticClass:"Layout_Tabela"},[_c('apuracao-finalizada-tabela',{ref:"apuracoesFinalizadas",attrs:{"carregando":_vm.carregandoFinalizadas,"apuracoes":_vm.apuracoesFinalizadas,"paginas":_vm.paginasApuracoesFinalizadas},on:{"APURACAO_FINALIZADA_TABELA_PAGINA":_vm.requestCarregarApuracoesFinalizadas,"APURACAO_FINALIZADA_TABELA_EVIDENCIA":_vm.exibirSidebar}})],1),_vm._v(" "),_c('md-layout',{staticClass:"Layout_Tabela"},[_c('apuracao-pendentes-tabela',{ref:"apuracoesPendentes",attrs:{"carregando":_vm.carregandoPendentes,"apuracoes":_vm.apuracoesPendentes,"paginas":_vm.paginasApuracoesPendentes},on:{"APURACAO_PENDENTE_TABELA_PAGINA":_vm.requestCarregarApuracoesPendentes,"APURACAO_PENDENTE_TABELA_EVIDENCIA":_vm.exibirSidebar}})],1),_vm._v(" "),_c('md-layout',{staticClass:"Layout_Tabela"},[_c('pagamentos-liquidados-tabela',{ref:"pagamentosLiquidados",attrs:{"periodo":_vm.competencia}})],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ExecucaoModal_vue_vue_type_template_id_17009aea_lang_html___ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ExecucaoModal_vue_vue_type_script_lang_js___ = __webpack_require__(491);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__ExecucaoModal_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__ExecucaoModal_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ExecucaoModal_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__ExecucaoModal_vue_vue_type_template_id_17009aea_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ExecucaoModal_vue_vue_type_template_id_17009aea_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ExecucaoModal_vue_vue_type_template_id_17009aea_lang_html___ = __webpack_require__(1271);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ExecucaoModal_vue_vue_type_template_id_17009aea_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ExecucaoModal_vue_vue_type_template_id_17009aea_lang_html___["b"]; });


/***/ }),
/* 1271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-dialog',{ref:"modal"},[_c('md-dialog-title',[_vm._v("\n    "+_vm._s(_vm.$t('label.evidencias'))+"\n  ")]),_vm._v(" "),_c('md-dialog-content',[_c('md-table',[_c('md-table-body',_vm._l((_vm.evidencias),function(row,index){return _c('md-table-row',{key:index},[_c('md-table-cell',[_vm._v(_vm._s(row.nome_arquivo))]),_vm._v(" "),_c('md-table-cell',[_c('md-button',{staticClass:"md-icon-button",attrs:{"id":("modal-visualizar-evidencia-" + index)},nativeOn:{"click":function($event){return _vm.visualizarArquivo(row)}}},[_c('md-icon',[_vm._v("visibility")])],1)],1)],1)}),1)],1)],1),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-accent",nativeOn:{"click":function($event){return _vm.fechar($event)}}},[_vm._v("\n      "+_vm._s(_vm.$t('label.ok'))+"\n    ")])],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ApuracaoFinalizadaTabela_vue_vue_type_template_id_6e1bb57c_lang_html___ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ApuracaoFinalizadaTabela_vue_vue_type_script_lang_js___ = __webpack_require__(493);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__ApuracaoFinalizadaTabela_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__ApuracaoFinalizadaTabela_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_generico_TabelaGenerica_css_vue_type_style_index_0_lang_css___ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_generico_Pagination_css_vue_type_style_index_1_lang_css___ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_generico_TabelaSizing_css_vue_type_style_index_2_lang_css___ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);








/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_5__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ApuracaoFinalizadaTabela_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__ApuracaoFinalizadaTabela_vue_vue_type_template_id_6e1bb57c_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ApuracaoFinalizadaTabela_vue_vue_type_template_id_6e1bb57c_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ApuracaoFinalizadaTabela_vue_vue_type_template_id_6e1bb57c_lang_html___ = __webpack_require__(1274);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ApuracaoFinalizadaTabela_vue_vue_type_template_id_6e1bb57c_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ApuracaoFinalizadaTabela_vue_vue_type_template_id_6e1bb57c_lang_html___["b"]; });


/***/ }),
/* 1274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-table-card',[_c('md-toolbar',[_c('h1',{staticClass:"md-title"},[_vm._v(_vm._s(_vm.$tc('title.apuracoes_finalizadas')))]),_vm._v(" "),_c('div',[_c('md-input-container',[_c('label',{attrs:{"for":"statusApuracaoSelect"}},[_vm._v(_vm._s(_vm.$t('label.status')))]),_vm._v(" "),_c('md-select',{attrs:{"id":"statusApuracaoSelect"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},_vm._l((_vm.listaStatus),function(opt,index){return _c('md-option',{key:index,attrs:{"value":opt.status},on:{"selected":_vm.filtraRegistros}},[_vm._v("\n            "+_vm._s(opt.descricao)+"\n          ")])}),1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"TabelaGenerica__TableWrapper"},[_c('md-table',{staticClass:"TabelaGenerica__Table"},[_c('md-table-header',[_c('md-table-row',_vm._l((_vm.cabecalho),function(coluna,index){return _c('md-table-head',{key:index,class:_vm.classeCabecalho(index)},[_vm._v("\n            "+_vm._s(coluna)+"\n          ")])}),1)],1),_vm._v(" "),_c('md-table-body',{directives:[{name:"show",rawName:"v-show",value:(_vm.possuiRegistros() && !_vm.carregando),expression:"possuiRegistros() && !carregando"}]},_vm._l((_vm.apuracoes),function(row,rowIndex){return _c('md-table-row',{key:rowIndex},[_c('md-table-cell',[_c('md-menu',{attrs:{"md-direction":"top left","md-size":"4"}},[_c('md-button',{staticClass:"md-icon-button",attrs:{"md-menu-trigger":""}},[_c('md-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('md-menu-content',[_c('md-menu-item',{nativeOn:{"click":function($event){return _vm.detalharAcordo(row)}}},[_c('md-icon',[_vm._v("equalizer")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.mais_detalhes')))])],1),_vm._v(" "),_c('md-menu-item',{nativeOn:{"click":function($event){return _vm.imprimirContrato(row)}}},[_c('md-icon',[_vm._v("print")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.imprimir')))])],1),_vm._v(" "),_c('md-menu-item',{directives:[{name:"show",rawName:"v-show",value:(row.possuiEvidencia),expression:"row.possuiEvidencia"}],nativeOn:{"click":function($event){return _vm.exibirSidebar(row)}}},[_c('md-icon',[_vm._v("info_outline")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.evidencias')))])],1)],1)],1)],1),_vm._v(" "),_c('md-table-cell',[_c('span',{domProps:{"textContent":_vm._s(row.numeroAcordo)}})]),_vm._v(" "),_c('md-table-cell',[_c('span',{domProps:{"textContent":_vm._s(row.cliente)}})]),_vm._v(" "),_c('md-table-cell',[_c('span',{domProps:{"textContent":_vm._s(row.acordo)}})]),_vm._v(" "),_c('md-table-cell',[_c('span',{domProps:{"textContent":_vm._s(row.tipoAcordo)}})]),_vm._v(" "),_c('md-table-cell',[_c('span',{domProps:{"textContent":_vm._s(row.inicioVigencia)}})]),_vm._v(" "),_c('md-table-cell',[_c('span',{domProps:{"textContent":_vm._s(row.fimVigencia)}})]),_vm._v(" "),_c('md-table-cell',[_c('span',{domProps:{"textContent":_vm._s(row.representante)}})]),_vm._v(" "),_c('md-table-cell',[_c('span',[_vm._v(_vm._s(_vm.statusApuracao(row.status)))])]),_vm._v(" "),_c('md-table-cell',[_c('span',{domProps:{"textContent":_vm._s(row.marca)}})]),_vm._v(" "),_c('md-table-cell',[_c('span',{domProps:{"textContent":_vm._s(row.linhaProduto)}})]),_vm._v(" "),_c('md-table-cell',[_c('span',{domProps:{"textContent":_vm._s(row.familia)}})]),_vm._v(" "),_c('md-table-cell',[_c('span',{domProps:{"textContent":_vm._s(row.produto)}})]),_vm._v(" "),_c('md-table-cell',[_c('span',[_vm._v(_vm._s(_vm.getMoney(row.pagamento)))])])],1)}),1)],1),_vm._v(" "),(!_vm.carregando)?_c('paginate',{directives:[{name:"show",rawName:"v-show",value:(_vm.possuiRegistros() && _vm.paginas > 1),expression:"possuiRegistros() && paginas > 1"}],attrs:{"page-count":_vm.paginas,"click-handler":_vm.clickHandler,"initial-page":_vm.indexPagina,"prev-text":_vm.$t('label.anterior'),"next-text":_vm.$tc('label.proximo', 1),"container-class":'pagination'}}):_vm._e(),_vm._v(" "),_c('h4',{directives:[{name:"show",rawName:"v-show",value:(!_vm.possuiRegistros() && !_vm.carregando),expression:"!possuiRegistros() && !carregando"}],staticClass:"TabelaGenerica__NoContent"},[_vm._v("\n        "+_vm._s(_vm.$t('label.tabela_sem_conteudo'))+"\n    ")]),_vm._v(" "),_c('md-spinner',{directives:[{name:"show",rawName:"v-show",value:(_vm.carregando),expression:"carregando"}],staticClass:"TabelaGenerica__InterminateLoader",attrs:{"md-indeterminate":""}})],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ApuracaoPendentesTabela_vue_vue_type_template_id_194015f5_lang_html___ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ApuracaoPendentesTabela_vue_vue_type_script_lang_js___ = __webpack_require__(496);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__ApuracaoPendentesTabela_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__ApuracaoPendentesTabela_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_generico_TabelaGenerica_css_vue_type_style_index_0_lang_css___ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_generico_Pagination_css_vue_type_style_index_1_lang_css___ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_generico_TabelaSizing_css_vue_type_style_index_2_lang_css___ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);








/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_5__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ApuracaoPendentesTabela_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__ApuracaoPendentesTabela_vue_vue_type_template_id_194015f5_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ApuracaoPendentesTabela_vue_vue_type_template_id_194015f5_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ApuracaoPendentesTabela_vue_vue_type_template_id_194015f5_lang_html___ = __webpack_require__(1277);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ApuracaoPendentesTabela_vue_vue_type_template_id_194015f5_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ApuracaoPendentesTabela_vue_vue_type_template_id_194015f5_lang_html___["b"]; });


/***/ }),
/* 1277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-table-card',[_c('md-toolbar',[_c('h1',{staticClass:"md-title"},[_vm._v(_vm._s(_vm.$tc('title.apuracoes_pendentes')))]),_vm._v(" "),_c('div',[_c('md-input-container',[_c('label',{attrs:{"for":"statusApuracaoSelect"}},[_vm._v(_vm._s(_vm.$t('label.status')))]),_vm._v(" "),_c('md-select',{attrs:{"id":"statusApuracaoSelect"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},_vm._l((_vm.listaStatus),function(opt,index){return _c('md-option',{key:index,attrs:{"value":opt.status},on:{"selected":_vm.filtraRegistros}},[_vm._v("\n            "+_vm._s(opt.descricao)+"\n          ")])}),1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"TabelaGenerica__TableWrapper"},[_c('md-table',{staticClass:"TabelaGenerica__Table"},[_c('md-table-header',[_c('md-table-row',_vm._l((_vm.cabecalho),function(coluna,index){return _c('md-table-head',{key:index,class:_vm.classeCabecalho(index)},[_vm._v("\n            "+_vm._s(coluna)+"\n          ")])}),1)],1),_vm._v(" "),_c('md-table-body',{directives:[{name:"show",rawName:"v-show",value:(_vm.possuiRegistros() && !_vm.carregando),expression:"possuiRegistros() && !carregando"}]},_vm._l((_vm.apuracoes),function(row,rowIndex){return _c('md-table-row',{key:rowIndex},[_c('md-table-cell',[_c('md-menu',{attrs:{"md-direction":"top left","md-size":"4"}},[_c('md-button',{staticClass:"md-icon-button",attrs:{"md-menu-trigger":""}},[_c('md-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('md-menu-content',[_c('md-menu-item',{nativeOn:{"click":function($event){return _vm.detalharAcordo(row)}}},[_c('md-icon',[_vm._v("equalizer")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.mais_detalhes')))])],1),_vm._v(" "),_c('md-menu-item',{nativeOn:{"click":function($event){return _vm.imprimirContrato(row)}}},[_c('md-icon',[_vm._v("print")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.imprimir')))])],1),_vm._v(" "),_c('md-menu-item',{directives:[{name:"show",rawName:"v-show",value:(row.possuiEvidencia),expression:"row.possuiEvidencia"}],nativeOn:{"click":function($event){return _vm.exibirSidebar(row)}}},[_c('md-icon',[_vm._v("info_outline")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.evidencias')))])],1)],1)],1)],1),_vm._v(" "),_c('md-table-cell',[_c('span',{domProps:{"textContent":_vm._s(row.numeroAcordo)}})]),_vm._v(" "),_c('md-table-cell',[_c('span',{domProps:{"textContent":_vm._s(row.cliente)}})]),_vm._v(" "),_c('md-table-cell',[_c('span',{domProps:{"textContent":_vm._s(row.acordo)}})]),_vm._v(" "),_c('md-table-cell',[_c('span',{domProps:{"textContent":_vm._s(row.tipoAcordo)}})]),_vm._v(" "),_c('md-table-cell',[_c('span',{domProps:{"textContent":_vm._s(row.inicioVigencia)}})]),_vm._v(" "),_c('md-table-cell',[_c('span',{domProps:{"textContent":_vm._s(row.fimVigencia)}})]),_vm._v(" "),_c('md-table-cell',[_c('span',{domProps:{"textContent":_vm._s(row.representante)}})]),_vm._v(" "),_c('md-table-cell',[_c('span',[_vm._v(_vm._s(_vm.statusApuracao(row.status)))])]),_vm._v(" "),_c('md-table-cell',[_c('span',{domProps:{"textContent":_vm._s(row.marca)}})]),_vm._v(" "),_c('md-table-cell',[_c('span',{domProps:{"textContent":_vm._s(row.linhaProduto)}})]),_vm._v(" "),_c('md-table-cell',[_c('span',{domProps:{"textContent":_vm._s(row.familia)}})]),_vm._v(" "),_c('md-table-cell',[_c('span',{domProps:{"textContent":_vm._s(row.produto)}})])],1)}),1)],1),_vm._v(" "),(!_vm.carregando)?_c('paginate',{directives:[{name:"show",rawName:"v-show",value:(_vm.possuiRegistros() && _vm.paginas > 1),expression:"possuiRegistros() && paginas > 1"}],attrs:{"page-count":_vm.paginas,"click-handler":_vm.clickHandler,"initial-page":_vm.indexPagina,"prev-text":_vm.$t('label.anterior'),"next-text":_vm.$tc('label.proximo', 1),"container-class":'pagination'}}):_vm._e(),_vm._v(" "),_c('h4',{directives:[{name:"show",rawName:"v-show",value:(!_vm.possuiRegistros() && !_vm.carregando),expression:"!possuiRegistros() && !carregando"}],staticClass:"TabelaGenerica__NoContent"},[_vm._v("\n        "+_vm._s(_vm.$t('label.tabela_sem_conteudo'))+"\n    ")]),_vm._v(" "),_c('md-spinner',{directives:[{name:"show",rawName:"v-show",value:(_vm.carregando),expression:"carregando"}],staticClass:"TabelaGenerica__InterminateLoader",attrs:{"md-indeterminate":""}})],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NegociacoesAguardandoAprovacao_vue_vue_type_template_id_4632bb38_lang_html___ = __webpack_require__(1279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NegociacoesAguardandoAprovacao_vue_vue_type_script_lang_js___ = __webpack_require__(498);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__NegociacoesAguardandoAprovacao_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__NegociacoesAguardandoAprovacao_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_generico_TabelaGenerica_css_vue_type_style_index_0_lang_css___ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_generico_Pagination_css_vue_type_style_index_1_lang_css___ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_generico_TabelaSizing_css_vue_type_style_index_2_lang_css___ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NegociacoesAguardandoAprovacao_vue_vue_type_style_index_3_lang_css___ = __webpack_require__(1281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);









/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_6__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__NegociacoesAguardandoAprovacao_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__NegociacoesAguardandoAprovacao_vue_vue_type_template_id_4632bb38_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__NegociacoesAguardandoAprovacao_vue_vue_type_template_id_4632bb38_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_NegociacoesAguardandoAprovacao_vue_vue_type_template_id_4632bb38_lang_html___ = __webpack_require__(1280);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_NegociacoesAguardandoAprovacao_vue_vue_type_template_id_4632bb38_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_NegociacoesAguardandoAprovacao_vue_vue_type_template_id_4632bb38_lang_html___["b"]; });


/***/ }),
/* 1280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-table-card',{staticClass:"TabelaNegociacoes",style:(_vm.styleCard()),attrs:{"id":"dash_op_tabela_negoc"}},[_c('md-toolbar',[_c('h1',{staticClass:"md-title"},[_vm._v(_vm._s(_vm.$tc('title.negociacoes_aguardando_aprovacao')))])]),_vm._v(" "),_c('status-passos',{ref:"modalAcompanhamento",attrs:{"source":_vm.statusPassos}}),_vm._v(" "),_c('md-dialog',{ref:"modalAprovacao",staticClass:"TabelaNegociacoes__ModalAvaliacao"},[_c('md-dialog-title',[_vm._v("\n      "+_vm._s(_vm.$t('label.aprovar'))+"\n    ")]),_vm._v(" "),_c('md-dialog-content',[_c('md-input-container',{ref:"inputJustificativaAprovar"},[_c('label',[_vm._v(_vm._s(_vm.$t('label.justificativa')))]),_vm._v(" "),_c('md-input',{attrs:{"type":"text","maxlength":"50","id":"justificativa_aprovar","name":"justificativa_aprovar"},model:{value:(_vm.justificativaAvaliacao),callback:function ($$v) {_vm.justificativaAvaliacao=$$v},expression:"justificativaAvaliacao"}})],1)],1),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",nativeOn:{"click":function($event){return _vm.cancelarAprovacao($event)}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.cancelar'))+"\n      ")]),_vm._v(" "),_c('md-button',{staticClass:"md-accent",nativeOn:{"click":function($event){return _vm.aprovar($event)}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.salvar'))+"\n      ")])],1)],1),_vm._v(" "),_c('md-dialog',{ref:"modalReprovacao",staticClass:"TabelaNegociacoes__ModalAvaliacao"},[_c('md-dialog-title',[_vm._v("\n      "+_vm._s(_vm.$t('label.reprovar'))+"\n    ")]),_vm._v(" "),_c('md-dialog-content',[_c('md-input-container',{ref:"inputJustificativaReprovar",class:{
            'md-input-invalid': _vm.errors.has('justificativa_reprovar')
          }},[_c('label',[_vm._v(_vm._s(_vm.$t('label.justificativa')))]),_vm._v(" "),_c('md-input',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"type":"text","required":"","maxlength":"50","id":"justificativa_reprovar","name":"justificativa_reprovar","data-vv-rules":"required","data-vv-name":"justificativa_reprovar"},model:{value:(_vm.justificativaAvaliacao),callback:function ($$v) {_vm.justificativaAvaliacao=$$v},expression:"justificativaAvaliacao"}}),_vm._v(" "),_c('span',{staticClass:"md-error"},[_vm._v("\n          "+_vm._s(_vm.errors.first('justificativa_reprovar'))+"\n        ")])],1)],1),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",nativeOn:{"click":function($event){return _vm.cancelarReprovacao($event)}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.cancelar'))+"\n      ")]),_vm._v(" "),_c('md-button',{staticClass:"md-accent",nativeOn:{"click":function($event){return _vm.reprovar($event)}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.salvar'))+"\n      ")])],1)],1),_vm._v(" "),_c('md-dialog',{ref:"modalAnalise",staticClass:"TabelaNegociacoes__ModalAvaliacao"},[_c('md-dialog-title',[_vm._v("\n      "+_vm._s(_vm.$t('label.enviar_analise'))+"\n    ")]),_vm._v(" "),_c('md-dialog-content',[_c('md-input-container',{ref:"inputJustificativaAnalise",class:{
          'md-input-invalid': _vm.errors.has('justificativa_analise')
        }},[_c('label',[_vm._v(_vm._s(_vm.$t('label.justificativa')))]),_vm._v(" "),_c('md-input',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"type":"text","required":"","maxlength":"50","id":"justificativa_analise","name":"justificativa_analise","data-vv-rules":"required","data-vv-name":"justificativa_analise"},model:{value:(_vm.justificativaAvaliacao),callback:function ($$v) {_vm.justificativaAvaliacao=$$v},expression:"justificativaAvaliacao"}}),_vm._v(" "),_c('span',{staticClass:"md-error"},[_vm._v("\n          "+_vm._s(_vm.errors.first('justificativa_analise'))+"\n        ")])],1)],1),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",nativeOn:{"click":function($event){return _vm.cancelarEnvioParaAnalise($event)}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.cancelar'))+"\n      ")]),_vm._v(" "),_c('md-button',{staticClass:"md-accent",nativeOn:{"click":function($event){return _vm.enviarParaAnalise($event)}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.salvar'))+"\n      ")])],1)],1),_vm._v(" "),_c('div',{staticClass:"TabelaGenerica__TableWrapper"},[_c('md-table',{staticClass:"TabelaGenerica__Table"},[_c('md-table-header',[_c('md-table-row',_vm._l((_vm.cabecalho),function(coluna,index){return _c('md-table-head',{key:index,class:_vm.classeCabecalho(index)},[_vm._v("\n            "+_vm._s(coluna)+"\n          ")])}),1)],1),_vm._v(" "),_c('md-table-body',{directives:[{name:"show",rawName:"v-show",value:(_vm.possuiRegistros() && !_vm.carregando),expression:"possuiRegistros() && !carregando"}]},_vm._l((_vm.negociacoes),function(row,rowIndex){return _c('md-table-row',{key:rowIndex},[_c('md-table-cell',[_c('md-menu',{attrs:{"md-direction":"top left","md-size":"4"}},[_c('md-button',{staticClass:"md-icon-button",attrs:{"md-menu-trigger":""}},[_c('md-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('md-menu-content',[_c('md-menu-item',{nativeOn:{"click":function($event){return _vm.detalharAcordo(row)}}},[_c('md-icon',[_vm._v("equalizer")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.mais_detalhes')))])],1),_vm._v(" "),_c('md-menu-item',{nativeOn:{"click":function($event){return _vm.imprimirContrato(row)}}},[_c('md-icon',[_vm._v("print")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.imprimir')))])],1),_vm._v(" "),_c('md-menu-item',{nativeOn:{"click":function($event){return _vm.iniciarEnvioParaAnalise(row)}}},[_c('md-icon',[_vm._v("chat_bubble")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.enviar_analise')))])],1),_vm._v(" "),_c('md-menu-item',{nativeOn:{"click":function($event){return _vm.iniciarReprovacao(row)}}},[_c('md-icon',[_vm._v("thumb_down")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.reprovar')))])],1),_vm._v(" "),_c('md-menu-item',{nativeOn:{"click":function($event){return _vm.iniciarAprovacao(row)}}},[_c('md-icon',[_vm._v("thumb_up")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.aprovar')))])],1)],1)],1)],1),_vm._v(" "),_c('md-table-cell',[_c('span',{domProps:{"textContent":_vm._s(row.numeroAcordo)}})]),_vm._v(" "),_c('md-table-cell',[_c('span',{domProps:{"textContent":_vm._s(row.cliente)}})]),_vm._v(" "),_c('md-table-cell',[_c('span',{domProps:{"textContent":_vm._s(row.acordo)}})]),_vm._v(" "),_c('md-table-cell',[_c('span',{domProps:{"textContent":_vm._s(row.tipoAcordo)}})]),_vm._v(" "),_c('md-table-cell',[_c('span',{domProps:{"textContent":_vm._s(row.inicioVigencia)}})]),_vm._v(" "),_c('md-table-cell',[_c('span',{domProps:{"textContent":_vm._s(row.fimVigencia)}})]),_vm._v(" "),_c('md-table-cell',[_c('span',{domProps:{"textContent":_vm._s(row.representante)}})]),_vm._v(" "),_c('md-table-cell',[_c('span',[_vm._v(_vm._s(_vm.statusApuracao(row.status)))])])],1)}),1)],1),_vm._v(" "),(!_vm.carregando)?_c('paginate',{directives:[{name:"show",rawName:"v-show",value:(_vm.possuiRegistros() && _vm.paginas > 1),expression:"possuiRegistros() && paginas > 1"}],attrs:{"page-count":_vm.paginas,"click-handler":_vm.clickHandler,"initial-page":_vm.indexPagina,"prev-text":_vm.$t('label.anterior'),"next-text":_vm.$tc('label.proximo', 1),"container-class":'pagination'}}):_vm._e(),_vm._v(" "),_c('h4',{directives:[{name:"show",rawName:"v-show",value:(!_vm.possuiRegistros() && !_vm.carregando),expression:"!possuiRegistros() && !carregando"}],staticClass:"TabelaGenerica__NoContent"},[_vm._v("\n        "+_vm._s(_vm.$t('message.nenhum_registro_pendente_aprovacao'))+"\n    ")]),_vm._v(" "),_c('md-spinner',{directives:[{name:"show",rawName:"v-show",value:(_vm.carregando),expression:"carregando"}],staticClass:"TabelaGenerica__InterminateLoader",attrs:{"md-indeterminate":""}})],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_NegociacoesAguardandoAprovacao_vue_vue_type_style_index_3_lang_css___ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_NegociacoesAguardandoAprovacao_vue_vue_type_style_index_3_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_NegociacoesAguardandoAprovacao_vue_vue_type_style_index_3_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_NegociacoesAguardandoAprovacao_vue_vue_type_style_index_3_lang_css____default.a); 

/***/ }),
/* 1282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PagamentosLiquidadosTabela_vue_vue_type_template_id_0ee9ac09_lang_html___ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PagamentosLiquidadosTabela_vue_vue_type_script_lang_js___ = __webpack_require__(501);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__PagamentosLiquidadosTabela_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__PagamentosLiquidadosTabela_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__PagamentosLiquidadosTabela_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__PagamentosLiquidadosTabela_vue_vue_type_template_id_0ee9ac09_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__PagamentosLiquidadosTabela_vue_vue_type_template_id_0ee9ac09_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_PagamentosLiquidadosTabela_vue_vue_type_template_id_0ee9ac09_lang_html___ = __webpack_require__(1284);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_PagamentosLiquidadosTabela_vue_vue_type_template_id_0ee9ac09_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_PagamentosLiquidadosTabela_vue_vue_type_template_id_0ee9ac09_lang_html___["b"]; });


/***/ }),
/* 1284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-table-card',{scopedSlots:_vm._u([{key:"item.dtaLiquidacao",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatDatePattern(_vm.itemdtaLiquidacao, 'DD/MM/YYYY'))+" ")]}},{key:"item.valor",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.getMoney(item.valor))+" ")]}}])},[_c('md-toolbar',[_c('h1',{staticClass:"md-title"},[_vm._v(_vm._s(_vm.$tc('title.pagamentos_liquidados')))])]),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.liquidados,"options":_vm.pagination,"server-items-length":_vm.totalPaginas,"footer-props":{
          itemsPerPageOptions: [5, 10, 25, 50],
        },"no-data-text":_vm.$t('label.tabela_sem_conteudo')},on:{"update:options":function($event){_vm.pagination=$event}}})],1)}
var staticRenderFns = []



/***/ }),
/* 1285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardAcompanhamento_vue_vue_type_style_index_0_id_2950bb69_scoped_true_lang_css___ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardAcompanhamento_vue_vue_type_style_index_0_id_2950bb69_scoped_true_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardAcompanhamento_vue_vue_type_style_index_0_id_2950bb69_scoped_true_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardAcompanhamento_vue_vue_type_style_index_0_id_2950bb69_scoped_true_lang_css____default.a); 

/***/ }),
/* 1286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_node_modules_vue_loader_lib_index_js_vue_loader_options_DashBoard_vue_vue_type_style_index_1_lang_scss___ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_node_modules_vue_loader_lib_index_js_vue_loader_options_DashBoard_vue_vue_type_style_index_1_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_node_modules_vue_loader_lib_index_js_vue_loader_options_DashBoard_vue_vue_type_style_index_1_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_node_modules_vue_loader_lib_index_js_vue_loader_options_DashBoard_vue_vue_type_style_index_1_lang_scss____default.a); 

/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var DashBoardGerencial = function DashBoardGerencial() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1662));
};

exports.default = {
  path: 'dashboard-gerencial',
  name: 'dashboard-gerencial',
  component: DashBoardGerencial
};

/***/ }),
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CadastroDivisao = __webpack_require__(1310);

var _CadastroDivisao2 = _interopRequireDefault(_CadastroDivisao);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  path: 'divisao',
  name: 'divisao',
  component: _CadastroDivisao2.default
};

/***/ }),
/* 1310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CadastroDivisao_vue_vue_type_template_id_e6ac3cae_lang_html___ = __webpack_require__(1311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CadastroDivisao_vue_vue_type_script_lang_js___ = __webpack_require__(519);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__CadastroDivisao_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__CadastroDivisao_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__CadastroDivisao_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__CadastroDivisao_vue_vue_type_template_id_e6ac3cae_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__CadastroDivisao_vue_vue_type_template_id_e6ac3cae_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CadastroDivisao_vue_vue_type_template_id_e6ac3cae_lang_html___ = __webpack_require__(1312);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CadastroDivisao_vue_vue_type_template_id_e6ac3cae_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_CadastroDivisao_vue_vue_type_template_id_e6ac3cae_lang_html___["b"]; });


/***/ }),
/* 1312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canAccessPage)?_c('div',{staticClass:"CRUDGenerico__Wrapper"},[(_vm.carregouMetadados)?_c('v-row',[(!_vm.somenteLeitura)?_c('v-col',{staticClass:"pt-0",attrs:{"cols":"12","sm":"3"}},[_c('divisao-form',{ref:"divisaoForm",attrs:{"configCarteira":_vm.configCarteira},on:{"FORMULARIO_CADASTRO_DIVISAO_SALVAR":_vm.onNovaDivisao,"FORMULARIO_CADASTRO_DIVISAO_CANCELAR":_vm.onCancelar}})],1):_vm._e(),_vm._v(" "),_c('v-col',{staticClass:"pt-0",attrs:{"cols":"12","md":!_vm.somenteLeitura ? 9 : 12}},[_c('divisao-tabela',{ref:"divisaoTabela",staticClass:"CRUDGenerico__ContentTable",attrs:{"title":_vm.$tc('label.divisao', 2),"configCarteira":_vm.configCarteira},on:{"PESQUISA_DIVISAO_EDITAR":_vm.onEditarDivisao}})],1)],1):_vm._e()],1):_vm._e()}
var staticRenderFns = []



/***/ }),
/* 1313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DivisaoForm_vue_vue_type_template_id_dbdbeda4_lang_html___ = __webpack_require__(1314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DivisaoForm_vue_vue_type_script_lang_js___ = __webpack_require__(521);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__DivisaoForm_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__DivisaoForm_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__DivisaoForm_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__DivisaoForm_vue_vue_type_template_id_dbdbeda4_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__DivisaoForm_vue_vue_type_template_id_dbdbeda4_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DivisaoForm_vue_vue_type_template_id_dbdbeda4_lang_html___ = __webpack_require__(1315);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DivisaoForm_vue_vue_type_template_id_dbdbeda4_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DivisaoForm_vue_vue_type_template_id_dbdbeda4_lang_html___["b"]; });


/***/ }),
/* 1315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{ref:"form",attrs:{"lazy-validation":""}},[_c('v-card',{staticClass:"card-size"},[_c('v-card-title',[_c('h2',{staticClass:"mb-0",staticStyle:{"font-size":"18px","width":"100%"}},[_vm._v(_vm._s(_vm.divisao.ehEdicao() ? _vm.$t('title.editar_divisao') : _vm.$t('title.cadastrar_nova_divisao')))])]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-xl":"","fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-text-field',{staticClass:"Form-text__invalid",attrs:{"id":"codDivisao","name":"codDivisao","required":"","label":((_vm.$t('label.cod_divisao')) + " *"),"rules":[_vm.rules.required]},model:{value:(_vm.divisao.idExterno),callback:function ($$v) {_vm.$set(_vm.divisao, "idExterno", $$v)},expression:"divisao.idExterno"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12"}},[_c('v-text-field',{staticClass:"Form-text__invalid",attrs:{"id":"nome","name":"nome","label":((_vm.$t('label.nome')) + " *"),"counter":50,"maxlength":"50","required":"","rules":[_vm.rules.required]},model:{value:(_vm.divisao.nome),callback:function ($$v) {_vm.$set(_vm.divisao, "nome", $$v)},expression:"divisao.nome"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12"}},[_c('v-autocomplete',{attrs:{"id":"estruturaUsuarioDaDivisao","name":"estruturaUsuarioDaDivisao","disabled":_vm.divisao.possuiDivisoesSuperiores(),"items":_vm.listaEstruturaUsuarios,"search-input":_vm.buscaListaEstruturaUsuario,"no-data-text":_vm.$tc('message.nenhum_registro', 1),"item-text":"nomEstruturaUsuario","item-value":"id","rules":[_vm.rules.requiredEstrutura],"label":((_vm.$tc('label.estrutura_usuario', 1)) + " *"),"clearable":"","return-object":""},on:{"update:searchInput":function($event){_vm.buscaListaEstruturaUsuario=$event},"update:search-input":function($event){_vm.buscaListaEstruturaUsuario=$event},"input":_vm.onEstruturaUsuarioSelecionada},model:{value:(_vm.divisao.estruturaUsuario),callback:function ($$v) {_vm.$set(_vm.divisao, "estruturaUsuario", $$v)},expression:"divisao.estruturaUsuario"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12"}},[_c('v-autocomplete',{attrs:{"id":"divisoesSuperiores","name":"divisoesSuperiores","disabled":_vm.isDivisoesSuperioresDisabled(),"items":_vm.listaDivisoes,"search-input":_vm.buscaListaDivisoesSuperiores,"no-data-text":_vm.$tc('message.nenhum_registro', 1),"item-text":"nome","item-value":"id","label":("" + (_vm.$tc('label.divisao_superior', 1))),"multiple":"","return-object":""},on:{"update:searchInput":function($event){_vm.buscaListaDivisoesSuperiores=$event},"update:search-input":function($event){_vm.buscaListaDivisoesSuperiores=$event}},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-chip',{staticClass:"chip--select-multi",attrs:{"input-value":data.selected,"close":""},on:{"click:close":function($event){return _vm.removeChipSelecao(data.item)}}},[_vm._v("\n                "+_vm._s(data.item.nome)+"\n              ")])]}}]),model:{value:(_vm.divisao.divisoesSuperiores),callback:function ($$v) {_vm.$set(_vm.divisao, "divisoesSuperiores", $$v)},expression:"divisao.divisoesSuperiores"}})],1),_vm._v(" "),(_vm.configCarteira === 'EXPLICITA')?_c('v-col',{attrs:{"cols":"12"}},[_c('v-autocomplete',{attrs:{"id":"carteirasCliente","name":"carteirasCliente","items":_vm.listaCarteirasCliente,"search-input":_vm.buscaListaCarteiras,"no-data-text":_vm.$tc('message.nenhum_registro', 1),"item-text":"descricao","item-value":"id","label":("" + (_vm.$tc('label.carteira_cliente', 1))),"multiple":"","return-object":""},on:{"update:searchInput":function($event){_vm.buscaListaCarteiras=$event},"update:search-input":function($event){_vm.buscaListaCarteiras=$event}},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-chip',{staticClass:"chip--select-multi",attrs:{"input-value":data.selected,"close":""}},[_vm._v(" "+_vm._s(data.item.descricao))])]}}],null,false,854502190),model:{value:(_vm.divisao.carteirasCliente),callback:function ($$v) {_vm.$set(_vm.divisao, "carteirasCliente", $$v)},expression:"divisao.carteirasCliente"}})],1):_vm._e()],1),_vm._v(" "),(_vm.metadadosDivisao)?_c('metadados-container-layout',{ref:"container",attrs:{"metadados-entidade":_vm.metadadosDivisao,"objeto":_vm.divisao,"input-layout":_vm.inputLayout,"layout-class":_vm.layoutClass}}):_vm._e(),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-switch',{staticClass:"mt-3",attrs:{"label":_vm.$t('label.diretoria'),"color":"primary"},model:{value:(_vm.divisao.desAtributos.diretoria),callback:function ($$v) {_vm.$set(_vm.divisao.desAtributos, "diretoria", $$v)},expression:"divisao.desAtributos.diretoria"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{nativeOn:{"click":function($event){return _vm.cancel($event)}}},[_vm._v(_vm._s(_vm.$t('label.cancelar')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.openSaveDialog($event)}}},[_vm._v(_vm._s(_vm.$t('label.salvar')))])],1)],1),_vm._v(" "),_c('confirm',{ref:"confirmDialog",attrs:{"message":_vm.dialog.content,"persistent":true},on:{"agree":function($event){return _vm.save()}}})],1)}
var staticRenderFns = []



/***/ }),
/* 1316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MetadadosContainerLayout_vue_vue_type_template_id_49678a0a___ = __webpack_require__(1317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MetadadosContainerLayout_vue_vue_type_script_lang_js___ = __webpack_require__(524);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__MetadadosContainerLayout_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__MetadadosContainerLayout_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__MetadadosContainerLayout_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__MetadadosContainerLayout_vue_vue_type_template_id_49678a0a___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__MetadadosContainerLayout_vue_vue_type_template_id_49678a0a___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosContainerLayout_vue_vue_type_template_id_49678a0a___ = __webpack_require__(1318);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosContainerLayout_vue_vue_type_template_id_49678a0a___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosContainerLayout_vue_vue_type_template_id_49678a0a___["b"]; });


/***/ }),
/* 1318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{class:_vm.layoutClass},[_vm._t("antes"),_vm._v(" "),_vm._l((_vm.relacaoComponentesDinamicos),function(metadados,index){return _c('v-col',{key:index,attrs:{"cols":"12","sm":_vm.smCol,"md":_vm.mdCol}},[_c('metadados-componente-dinamico',{ref:"componentes",refInFor:true,attrs:{"metadados":metadados,"objeto":_vm.objeto,"ignora-obrigatorios":_vm.ignoraObrigatorios,"ignora-filtro-recursivo":_vm.explodeHierarquia,"novo-cadastro":_vm.novoCadastro,"get-valores-dependencias":_vm.getValoresDependenciasRecursivas,"somente-leitura":_vm.somenteLeitura,"filtro-rapido":_vm.filtroRapido,"grupo-ativo":_vm.grupoAtivo,"exibe-loading-overlay":_vm.exibeLoadingOverlay},on:{"MetadadosExtensao_FiltraAmostragemRecursiva":_vm.filtraAmostragemRecursiva,"MetadadosComponenteDinamico_valorAlterado":_vm.valorAlterado,"MetadadosComponenteDinamico_abrirCadastro":_vm.abrirCadastro,"MetadadosComponenteDinamico_GrupoAtivo":function (val) { return _vm.$emit('MetadadosContainerLayout_GrupoAtivo', val); }}})],1)}),_vm._v(" "),(!_vm.explodeHierarquia)?_c('metadados-filtros-recursivos',{ref:"dialogFiltros",attrs:{"metadados-entidade":_vm.metadadosEntidade,"objeto":_vm.objeto,"callback-filtro":_vm.filtroAplicado}}):_vm._e(),_vm._v(" "),_vm._t("depois")],2)}
var staticRenderFns = []



/***/ }),
/* 1319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MetadadosComponenteDinamico_vue_vue_type_template_id_fa90a79e___ = __webpack_require__(1320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MetadadosComponenteDinamico_vue_vue_type_script_lang_js___ = __webpack_require__(526);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__MetadadosComponenteDinamico_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__MetadadosComponenteDinamico_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__MetadadosComponenteDinamico_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__MetadadosComponenteDinamico_vue_vue_type_template_id_fa90a79e___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__MetadadosComponenteDinamico_vue_vue_type_template_id_fa90a79e___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosComponenteDinamico_vue_vue_type_template_id_fa90a79e___ = __webpack_require__(1321);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosComponenteDinamico_vue_vue_type_template_id_fa90a79e___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosComponenteDinamico_vue_vue_type_template_id_fa90a79e___["b"]; });


/***/ }),
/* 1321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.metadados.campoExtensao)?_c('metadados-extensao',{ref:"componente",attrs:{"metadados":_vm.metadados,"objeto-container":_vm.objeto,"somente-leitura":_vm.somenteLeitura,"ignora-obrigatorios":_vm.ignoraObrigatorios,"ignora-filtro-recursivo":_vm.ignoraFiltroRecursivo,"novoCadastro":_vm.novoCadastro,"get-valores-dependencias":_vm.getValoresDependencias,"exibe-loading-overlay":_vm.exibeLoadingOverlay},on:{"MetadadosExtensao_FiltraAmostragemRecursiva":_vm.filtraAmostragemRecursiva,"MetadadosExtensao_ValorSelecionado":_vm.valorAlterado,"MetadadosExtensao_abrirCadastro":_vm.abrirCadastro},model:{value:(_vm.objeto[_vm.metadados.label]),callback:function ($$v) {_vm.$set(_vm.objeto, _vm.metadados.label, $$v)},expression:"objeto[metadados.label]"}}):(_vm.campoAutocomplete)?_c('metadados-campo-dinamico-autocomplete',{ref:"componente",attrs:{"metadados":_vm.metadados,"objeto-container":_vm.objeto,"somente-leitura":_vm.somenteLeitura,"ignora-obrigatorios":_vm.ignoraObrigatorios,"exibe-loading-overlay":_vm.exibeLoadingOverlay},on:{"MetadadosCampoDinamico_valorAlterado":_vm.valorAlterado},model:{value:(_vm.objeto[_vm.metadados.labelCampo]),callback:function ($$v) {_vm.$set(_vm.objeto, _vm.metadados.labelCampo, $$v)},expression:"objeto[metadados.labelCampo]"}}):(_vm.campoTexto)?_c('metadados-campo-dinamico-texto',{ref:"componente",attrs:{"metadados":_vm.metadados,"objeto-container":_vm.objeto,"somente-leitura":_vm.somenteLeitura,"ignora-obrigatorios":_vm.ignoraObrigatorios},on:{"MetadadosCampoDinamico_valorAlterado":_vm.valorAlterado},model:{value:(_vm.objeto[_vm.metadados.labelCampo]),callback:function ($$v) {_vm.$set(_vm.objeto, _vm.metadados.labelCampo, $$v)},expression:"objeto[metadados.labelCampo]"}}):(_vm.campoDinheiro)?_c('metadados-campo-dinamico-dinheiro',{ref:"componente",attrs:{"metadados":_vm.metadados,"objeto-container":_vm.objeto,"somente-leitura":_vm.somenteLeitura,"ignora-obrigatorios":_vm.ignoraObrigatorios},on:{"MetadadosCampoDinamico_valorAlterado":_vm.valorAlterado},model:{value:(_vm.objeto[_vm.metadados.labelCampo]),callback:function ($$v) {_vm.$set(_vm.objeto, _vm.metadados.labelCampo, $$v)},expression:"objeto[metadados.labelCampo]"}}):(_vm.campoBoolean)?_c('metadados-campo-dinamico-boolean',{ref:"componente",attrs:{"metadados":_vm.metadados,"objeto-container":_vm.objeto,"somente-leitura":_vm.somenteLeitura,"ignora-obrigatorios":_vm.ignoraObrigatorios},on:{"MetadadosCampoDinamico_valorAlterado":_vm.valorAlterado},model:{value:(_vm.objeto[_vm.metadados.labelCampo]),callback:function ($$v) {_vm.$set(_vm.objeto, _vm.metadados.labelCampo, $$v)},expression:"objeto[metadados.labelCampo]"}}):(_vm.campoData)?_c('metadados-campo-dinamico-data',{ref:"componente",attrs:{"metadados":_vm.metadados,"objeto-container":_vm.objeto,"somente-leitura":_vm.somenteLeitura,"ignora-obrigatorios":_vm.ignoraObrigatorios},on:{"MetadadosCampoDinamico_valorAlterado":_vm.valorAlterado},model:{value:(_vm.objeto[_vm.metadados.labelCampo]),callback:function ($$v) {_vm.$set(_vm.objeto, _vm.metadados.labelCampo, $$v)},expression:"objeto[metadados.labelCampo]"}}):(_vm.campoHora)?_c('metadados-campo-dinamico-hora',{ref:"componente",attrs:{"metadados":_vm.metadados,"objeto-container":_vm.objeto,"somente-leitura":_vm.somenteLeitura,"ignora-obrigatorios":_vm.ignoraObrigatorios},on:{"MetadadosCampoDinamico_valorAlterado":_vm.valorAlterado},model:{value:(_vm.objeto[_vm.metadados.labelCampo]),callback:function ($$v) {_vm.$set(_vm.objeto, _vm.metadados.labelCampo, $$v)},expression:"objeto[metadados.labelCampo]"}}):(_vm.campoNumerico)?_c('metadados-campo-dinamico-numerico',{ref:"componente",attrs:{"metadados":_vm.metadados,"objeto-container":_vm.objeto,"somente-leitura":_vm.somenteLeitura,"ignora-obrigatorios":_vm.ignoraObrigatorios},on:{"MetadadosCampoDinamico_valorAlterado":_vm.valorAlterado},model:{value:(_vm.objeto[_vm.metadados.labelCampo]),callback:function ($$v) {_vm.$set(_vm.objeto, _vm.metadados.labelCampo, $$v)},expression:"objeto[metadados.labelCampo]"}}):(_vm.campoPercentual)?_c('metadados-campo-dinamico-percentual',{ref:"componente",attrs:{"metadados":_vm.metadados,"objeto-container":_vm.objeto,"somente-leitura":_vm.somenteLeitura,"ignora-obrigatorios":_vm.ignoraObrigatorios},on:{"MetadadosCampoDinamico_valorAlterado":_vm.valorAlterado},model:{value:(_vm.objeto[_vm.metadados.labelCampo]),callback:function ($$v) {_vm.$set(_vm.objeto, _vm.metadados.labelCampo, $$v)},expression:"objeto[metadados.labelCampo]"}}):(_vm.campoMultiplaEscolha)?_c('metadados-campo-dinamico-multipla-escolha',{ref:"componente",attrs:{"metadados":_vm.metadados,"objeto-container":_vm.objeto,"somente-leitura":_vm.somenteLeitura,"ignora-obrigatorios":_vm.ignoraObrigatorios},on:{"MetadadosCampoDinamico_valorAlterado":_vm.valorAlterado},model:{value:(_vm.objeto[_vm.metadados.labelCampo]),callback:function ($$v) {_vm.$set(_vm.objeto, _vm.metadados.labelCampo, $$v)},expression:"objeto[metadados.labelCampo]"}}):(_vm.campoLista)?_c('metadados-campo-dinamico-lista',{ref:"componente",attrs:{"metadados":_vm.metadados,"objeto-container":_vm.objeto,"somente-leitura":_vm.somenteLeitura,"ignora-obrigatorios":_vm.ignoraObrigatorios},on:{"MetadadosCampoDinamico_valorAlterado":_vm.valorAlterado},model:{value:(_vm.objeto[_vm.metadados.labelCampo]),callback:function ($$v) {_vm.$set(_vm.objeto, _vm.metadados.labelCampo, $$v)},expression:"objeto[metadados.labelCampo]"}}):(_vm.campoCheckbox)?_c('metadados-campo-dinamico-checkbox',{ref:"componente",attrs:{"metadados":_vm.metadados,"objeto-container":_vm.objeto,"somente-leitura":_vm.somenteLeitura,"ignora-obrigatorios":_vm.ignoraObrigatorios},on:{"MetadadosCampoDinamico_valorAlterado":_vm.valorAlterado},model:{value:(_vm.objeto[_vm.metadados.labelCampo]),callback:function ($$v) {_vm.$set(_vm.objeto, _vm.metadados.labelCampo, $$v)},expression:"objeto[metadados.labelCampo]"}}):(_vm.campoListaCheckbox)?_c('metadados-campo-dinamico-lista-checkbox',{ref:"componente",attrs:{"metadados":_vm.metadados,"objeto-container":_vm.objeto,"somente-leitura":_vm.somenteLeitura,"ignora-obrigatorios":_vm.ignoraObrigatorios,"grupo-ativo":_vm.grupoAtivo},on:{"MetadadosCampoDinamico_valorAlterado":_vm.valorAlterado,"MetadadosCampoDinamicoListaCheckbox_GrupoAtivo":function (val) { return _vm.$emit('MetadadosComponenteDinamico_GrupoAtivo', val); }},model:{value:(_vm.objeto[_vm.metadados.labelCampo]),callback:function ($$v) {_vm.$set(_vm.objeto, _vm.metadados.labelCampo, $$v)},expression:"objeto[metadados.labelCampo]"}}):_vm._e()}
var staticRenderFns = []



/***/ }),
/* 1322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosExtensao_vue_vue_type_template_id_b2b13a88_lang_html___ = __webpack_require__(1323);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosExtensao_vue_vue_type_template_id_b2b13a88_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosExtensao_vue_vue_type_template_id_b2b13a88_lang_html___["b"]; });


/***/ }),
/* 1323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-autocomplete',{staticClass:"Metadados__Extensao custom-autocomplete",attrs:{"id":_vm.inputId,"name":_vm.metadados.label,"disabled":_vm.somenteLeitura,"chips":_vm.metadados.manyToMany,"multiple":_vm.metadados.manyToMany,"items":_vm.itens,"search-input":_vm.trigger,"no-data-text":_vm.$tc('message.nenhum_registro', 1),"item-text":_vm.identificador,"item-value":"id","rules":[_vm.rules.requiredNome],"label":_vm.label,"required":_vm.campoObrigatorio,"append-icon":_vm.appendIcon,"clearable":!_vm.metadados.manyToMany && !_vm.somenteLeitura,"loading":_vm.exibeBarraLoading,"return-object":""},on:{"update:searchInput":function($event){_vm.trigger=$event},"update:search-input":function($event){_vm.trigger=$event},"click:append":_vm.triggerClick,"input":_vm.valorSelecionado},nativeOn:{"click":function($event){return _vm.buscaExtensoes($event)}},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [(_vm.metadados.manyToMany)?_c('v-chip',{staticClass:"chip--select-multi",attrs:{"input-value":data.selected,"close":""},on:{"click":data.select,"click:close":function($event){return _vm.removeChipSelecao(data.item)}}},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('span',_vm._g({staticClass:"trunc-ellipsis"},on),[_vm._v("\n              "+_vm._s(_vm.identificador(data.item))+"\n            ")])]}}],null,true)},[_vm._v("\n\n          "+_vm._s(_vm.identificador(data.item))+"\n        ")])],1):_vm._e(),_vm._v(" "),(!_vm.metadados.manyToMany)?_c('span',[_vm._v(_vm._s(_vm.identificador(data.item)))]):_vm._e()]}}]),model:{value:(_vm.objetoInterno),callback:function ($$v) {_vm.objetoInterno=$$v},expression:"objetoInterno"}},[(_vm.exibeIconeFiltro)?_c('v-slide-x-reverse-transition',{attrs:{"slot":"append-outer","mode":"out-in"},slot:"append-outer"},[_c('v-icon',{on:{"click":_vm.filtraAmostragem}},[_vm._v("filter_list")])],1):_vm._e()],1),_vm._v(" "),(_vm.novoCadastro && !_vm.somenteLeitura && _vm.permiteCadastro)?_c('div',{staticClass:"mr-2",staticStyle:{"cursor":"pointer"}},[_c('span',{domProps:{"textContent":_vm._s(_vm.$t('label.nao_encontrou_clique_aqui', {text: _vm.metadados.entidadeEstrangeira.toLowerCase()}))},on:{"click":_vm.abrirCadastro}})]):_vm._e()],1)}
var staticRenderFns = []



/***/ }),
/* 1324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosExtensao_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosExtensao_vue_vue_type_style_index_0_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosExtensao_vue_vue_type_style_index_0_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosExtensao_vue_vue_type_style_index_0_lang_css____default.a); 

/***/ }),
/* 1325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MetadadosCampoDinamicoAutocomplete_vue_vue_type_template_id_6c3a709a___ = __webpack_require__(1326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoAutocomplete_vue_vue_type_script_lang_js___ = __webpack_require__(532);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoAutocomplete_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoAutocomplete_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MetadadosCampoDinamicoAutocomplete_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(1328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoAutocomplete_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__MetadadosCampoDinamicoAutocomplete_vue_vue_type_template_id_6c3a709a___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__MetadadosCampoDinamicoAutocomplete_vue_vue_type_template_id_6c3a709a___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoAutocomplete_vue_vue_type_template_id_6c3a709a___ = __webpack_require__(1327);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoAutocomplete_vue_vue_type_template_id_6c3a709a___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoAutocomplete_vue_vue_type_template_id_6c3a709a___["b"]; });


/***/ }),
/* 1327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{staticClass:"Metadados__Autocomplete custom-autocomplete",attrs:{"id":_vm.inputId,"rules":[_vm.rules.requiredNome],"items":_vm.itens,"label":_vm.inputLabel,"no-data-text":_vm.$tc('message.nenhum_registro', 1),"item-text":_vm.metadados.async.itemText,"item-value":_vm.metadados.async.itemValue,"disabled":_vm.somenteLeitura || _vm.campoDesabilitado,"chips":_vm.multiplaEscolha,"multiple":_vm.multiplaEscolha,"clearable":!_vm.campoDesabilitado && !_vm.multiplaEscolha,"loading":_vm.exibeBarraLoading,"menu-props":_vm.menuProps,"deletable-chips":"","return-object":"","search-input":_vm.trigger},on:{"click:append":_vm.triggerSelecao,"input":_vm.emiteValorAlterado,"update:searchInput":function($event){_vm.trigger=$event},"update:search-input":function($event){_vm.trigger=$event}},nativeOn:{"click":function($event){return _vm.buscarItens($event)}},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [(_vm.multiplaEscolha)?_c('v-chip',{staticClass:"chip--select-multi",attrs:{"input-value":data.selected,"close":""},on:{"click:close":function($event){return _vm.removeChipSelecao(data.item)}}},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('span',_vm._g({staticClass:"trunc-ellipsis"},on),[_vm._v("\n            "+_vm._s(data.item[_vm.metadados.async.itemText])+"\n          ")])]}}],null,true)},[_vm._v("\n        "+_vm._s(data.item[_vm.metadados.async.itemText])+"\n      ")])],1):_vm._e(),_vm._v(" "),(!_vm.multiplaEscolha)?_c('span',[_vm._v(_vm._s(data.item[_vm.metadados.async.itemText]))]):_vm._e()]}}]),model:{value:(_vm.objetoInterno),callback:function ($$v) {_vm.objetoInterno=$$v},expression:"objetoInterno"}})}
var staticRenderFns = []



/***/ }),
/* 1328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoAutocomplete_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoAutocomplete_vue_vue_type_style_index_0_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoAutocomplete_vue_vue_type_style_index_0_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoAutocomplete_vue_vue_type_style_index_0_lang_css____default.a); 

/***/ }),
/* 1329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MetadadosCampoDinamicoTexto_vue_vue_type_template_id_74adf081___ = __webpack_require__(1330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoTexto_vue_vue_type_script_lang_js___ = __webpack_require__(535);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoTexto_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoTexto_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoTexto_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__MetadadosCampoDinamicoTexto_vue_vue_type_template_id_74adf081___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__MetadadosCampoDinamicoTexto_vue_vue_type_template_id_74adf081___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoTexto_vue_vue_type_template_id_74adf081___ = __webpack_require__(1331);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoTexto_vue_vue_type_template_id_74adf081___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoTexto_vue_vue_type_template_id_74adf081___["b"]; });


/***/ }),
/* 1331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"id":_vm.inputId,"label":_vm.inputLabel,"disabled":_vm.campoDesabilitado,"required":_vm.campoObrigatorio,"rules":[_vm.rules.requiredTime],"counter":_vm.maxCaracteres,"maxlength":_vm.maxCaracteres},on:{"input":_vm.emiteValorAlterado},model:{value:(_vm.valorInterno),callback:function ($$v) {_vm.valorInterno=$$v},expression:"valorInterno"}})}
var staticRenderFns = []



/***/ }),
/* 1332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MetadadosCampoDinamicoDinheiro_vue_vue_type_template_id_61c7a1bf___ = __webpack_require__(1333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoDinheiro_vue_vue_type_script_lang_js___ = __webpack_require__(537);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoDinheiro_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoDinheiro_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MetadadosCampoDinamicoDinheiro_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(1335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoDinheiro_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__MetadadosCampoDinamicoDinheiro_vue_vue_type_template_id_61c7a1bf___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__MetadadosCampoDinamicoDinheiro_vue_vue_type_template_id_61c7a1bf___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoDinheiro_vue_vue_type_template_id_61c7a1bf___ = __webpack_require__(1334);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoDinheiro_vue_vue_type_template_id_61c7a1bf___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoDinheiro_vue_vue_type_template_id_61c7a1bf___["b"]; });


/***/ }),
/* 1334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-input',{staticClass:"MetadadosCampoDinamico__Dinheiro v-text-field",class:{focused: _vm.focused, dirty: _vm.dirty},attrs:{"label":_vm.inputLabel,"rules":[_vm.rules.requiredNome],"error-messages":_vm.validaCampo,"required":_vm.campoObrigatorio,"disabled":_vm.campoDesabilitado},model:{value:(_vm.valorInterno),callback:function ($$v) {_vm.valorInterno=$$v},expression:"valorInterno"}},[_c('money',_vm._b({attrs:{"id":_vm.inputId,"disabled":_vm.campoDesabilitado},on:{"input":_vm.valorDinheiroAlterado},model:{value:(_vm.valorInterno),callback:function ($$v) {_vm.valorInterno=$$v},expression:"valorInterno"}},'money',_vm.money,false))],1)}
var staticRenderFns = []



/***/ }),
/* 1335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoDinheiro_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoDinheiro_vue_vue_type_style_index_0_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoDinheiro_vue_vue_type_style_index_0_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoDinheiro_vue_vue_type_style_index_0_lang_css____default.a); 

/***/ }),
/* 1336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MetadadosCampoDinamicoBoolean_vue_vue_type_template_id_cae50228___ = __webpack_require__(1337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoBoolean_vue_vue_type_script_lang_js___ = __webpack_require__(540);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoBoolean_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoBoolean_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoBoolean_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__MetadadosCampoDinamicoBoolean_vue_vue_type_template_id_cae50228___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__MetadadosCampoDinamicoBoolean_vue_vue_type_template_id_cae50228___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoBoolean_vue_vue_type_template_id_cae50228___ = __webpack_require__(1338);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoBoolean_vue_vue_type_template_id_cae50228___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoBoolean_vue_vue_type_template_id_cae50228___["b"]; });


/***/ }),
/* 1338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',{attrs:{"id":_vm.inputId,"label":_vm.inputLabel,"disabled":_vm.campoDesabilitado,"color":"primary"},model:{value:(_vm.valorInterno),callback:function ($$v) {_vm.valorInterno=$$v},expression:"valorInterno"}})}
var staticRenderFns = []



/***/ }),
/* 1339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MetadadosCampoDinamicoData_vue_vue_type_template_id_6af0615c___ = __webpack_require__(1340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoData_vue_vue_type_script_lang_js___ = __webpack_require__(542);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoData_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoData_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoData_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__MetadadosCampoDinamicoData_vue_vue_type_template_id_6af0615c___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__MetadadosCampoDinamicoData_vue_vue_type_template_id_6af0615c___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoData_vue_vue_type_template_id_6af0615c___ = __webpack_require__(1341);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoData_vue_vue_type_template_id_6af0615c___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoData_vue_vue_type_template_id_6af0615c___["b"]; });


/***/ }),
/* 1341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px","disabled":_vm.somenteLeitura},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"label":_vm.inputLabel,"id":_vm.inputId,"disabled":_vm.somenteLeitura,"required":_vm.campoObrigatorio,"rules":[_vm.rules.requiredDate],"clearable":"","prepend-icon":"event","readonly":""},on:{"click:clear":_vm.limpaData},model:{value:(_vm.valorApresentavel),callback:function ($$v) {_vm.valorApresentavel=$$v},expression:"valorApresentavel"}},on))]}}]),model:{value:(_vm.pickerData),callback:function ($$v) {_vm.pickerData=$$v},expression:"pickerData"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"pt-br","color":"primary","disabled":_vm.somenteLeitura,"required":_vm.campoObrigatorio},on:{"input":function($event){return _vm.dataAlterada()}},model:{value:(_vm.valorInterno),callback:function ($$v) {_vm.valorInterno=$$v},expression:"valorInterno"}})],1)}
var staticRenderFns = []



/***/ }),
/* 1342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MetadadosCampoDinamicoHora_vue_vue_type_template_id_89ec978a___ = __webpack_require__(1343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoHora_vue_vue_type_script_lang_js___ = __webpack_require__(544);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoHora_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoHora_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoHora_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__MetadadosCampoDinamicoHora_vue_vue_type_template_id_89ec978a___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__MetadadosCampoDinamicoHora_vue_vue_type_template_id_89ec978a___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoHora_vue_vue_type_template_id_89ec978a___ = __webpack_require__(1344);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoHora_vue_vue_type_template_id_89ec978a___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoHora_vue_vue_type_template_id_89ec978a___["b"]; });


/***/ }),
/* 1344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":_vm.time,"transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px","disabled":_vm.somenteLeitura,"required":_vm.campoObrigatorio},on:{"update:returnValue":function($event){_vm.time=$event},"update:return-value":function($event){_vm.time=$event}},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"id":_vm.inputId,"label":_vm.inputLabel,"prepend-icon":"access_time","readonly":"","disabled":_vm.somenteLeitura,"required":_vm.campoObrigatorio,"clearable":"","rules":[_vm.rules.requiredHour]},on:{"click:clear":_vm.limpaHora},model:{value:(_vm.valorInterno),callback:function ($$v) {_vm.valorInterno=$$v},expression:"valorInterno"}},on))]}}]),model:{value:(_vm.pickerHora),callback:function ($$v) {_vm.pickerHora=$$v},expression:"pickerHora"}},[_vm._v(" "),(_vm.pickerHora)?_c('v-time-picker',{attrs:{"full-width":"","format":"24hr","disabled":_vm.somenteLeitura,"required":_vm.campoObrigatorio},on:{"input":function($event){return _vm.horaAlterada()}},model:{value:(_vm.valorInterno),callback:function ($$v) {_vm.valorInterno=$$v},expression:"valorInterno"}}):_vm._e()],1)}
var staticRenderFns = []



/***/ }),
/* 1345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MetadadosCampoDinamicoNumerico_vue_vue_type_template_id_56c10616___ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoNumerico_vue_vue_type_script_lang_js___ = __webpack_require__(546);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoNumerico_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoNumerico_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoNumerico_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__MetadadosCampoDinamicoNumerico_vue_vue_type_template_id_56c10616___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__MetadadosCampoDinamicoNumerico_vue_vue_type_template_id_56c10616___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoNumerico_vue_vue_type_template_id_56c10616___ = __webpack_require__(1347);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoNumerico_vue_vue_type_template_id_56c10616___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoNumerico_vue_vue_type_template_id_56c10616___["b"]; });


/***/ }),
/* 1347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"id":_vm.inputId,"label":_vm.inputLabel,"prepend-icon":"filter_1","disabled":_vm.campoDesabilitado,"required":_vm.campoObrigatorio,"rules":[_vm.rules.requiredNome, _vm.rules.numeroValido, _vm.rules.intervaloValido],"type":"Number"},on:{"input":_vm.numeroAlterado},model:{value:(_vm.valorInterno),callback:function ($$v) {_vm.valorInterno=$$v},expression:"valorInterno"}})}
var staticRenderFns = []



/***/ }),
/* 1348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MetadadosCampoDinamicoPercentual_vue_vue_type_template_id_a1ea6a2a___ = __webpack_require__(1349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoPercentual_vue_vue_type_script_lang_js___ = __webpack_require__(548);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoPercentual_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoPercentual_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoPercentual_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__MetadadosCampoDinamicoPercentual_vue_vue_type_template_id_a1ea6a2a___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__MetadadosCampoDinamicoPercentual_vue_vue_type_template_id_a1ea6a2a___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoPercentual_vue_vue_type_template_id_a1ea6a2a___ = __webpack_require__(1350);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoPercentual_vue_vue_type_template_id_a1ea6a2a___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoPercentual_vue_vue_type_template_id_a1ea6a2a___["b"]; });


/***/ }),
/* 1350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"id":_vm.inputId,"label":_vm.inputLabel,"prefix":"%","disabled":_vm.campoDesabilitado,"required":_vm.campoObrigatorio,"rules":[_vm.rules.requiredNome, _vm.rules.numeroValido, _vm.rules.intervaloValido],"type":"Number"},on:{"input":_vm.numeroAlterado},model:{value:(_vm.valorInterno),callback:function ($$v) {_vm.valorInterno=$$v},expression:"valorInterno"}})}
var staticRenderFns = []



/***/ }),
/* 1351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MetadadosCampoDinamicoMultiplaEscolha_vue_vue_type_template_id_281a2044___ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoMultiplaEscolha_vue_vue_type_script_lang_js___ = __webpack_require__(550);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoMultiplaEscolha_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoMultiplaEscolha_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoMultiplaEscolha_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__MetadadosCampoDinamicoMultiplaEscolha_vue_vue_type_template_id_281a2044___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__MetadadosCampoDinamicoMultiplaEscolha_vue_vue_type_template_id_281a2044___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoMultiplaEscolha_vue_vue_type_template_id_281a2044___ = __webpack_require__(1353);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoMultiplaEscolha_vue_vue_type_template_id_281a2044___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoMultiplaEscolha_vue_vue_type_template_id_281a2044___["b"]; });


/***/ }),
/* 1353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{staticClass:"custom-autocomplete",attrs:{"id":_vm.inputId,"clearable":"","chips":"","multiple":"","deletable-chips":"","no-data-text":_vm.$tc('message.nenhum_registro', 1),"required":_vm.campoObrigatorio,"items":_vm.itens,"label":_vm.inputLabel,"item-text":_vm.textoItem,"item-value":_vm.valorItem,"disabled":_vm.somenteLeitura || _vm.campoDesabilitado,"rules":[_vm.rules.requiredNome]},on:{"input":_vm.emiteValorAlterado},model:{value:(_vm.objetoInterno),callback:function ($$v) {_vm.objetoInterno=$$v},expression:"objetoInterno"}})}
var staticRenderFns = []



/***/ }),
/* 1354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MetadadosCampoDinamicoLista_vue_vue_type_template_id_2bdf1833___ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoLista_vue_vue_type_script_lang_js___ = __webpack_require__(552);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoLista_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoLista_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoLista_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__MetadadosCampoDinamicoLista_vue_vue_type_template_id_2bdf1833___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__MetadadosCampoDinamicoLista_vue_vue_type_template_id_2bdf1833___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoLista_vue_vue_type_template_id_2bdf1833___ = __webpack_require__(1356);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoLista_vue_vue_type_template_id_2bdf1833___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoLista_vue_vue_type_template_id_2bdf1833___["b"]; });


/***/ }),
/* 1356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{staticClass:"custom-autocomplete",attrs:{"id":_vm.inputId,"clearable":"","no-data-text":_vm.$tc('message.nenhum_registro', 1),"required":_vm.campoObrigatorio,"items":_vm.itens,"label":_vm.inputLabel,"item-text":_vm.textoItem,"item-value":_vm.valorItem,"disabled":_vm.somenteLeitura || _vm.campoDesabilitado,"rules":[_vm.rules.requiredNome]},on:{"input":_vm.emiteValorAlterado},model:{value:(_vm.objetoInterno),callback:function ($$v) {_vm.objetoInterno=$$v},expression:"objetoInterno"}})}
var staticRenderFns = []



/***/ }),
/* 1357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MetadadosCampoDinamicoCheckbox_vue_vue_type_template_id_79027340___ = __webpack_require__(1358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoCheckbox_vue_vue_type_script_lang_js___ = __webpack_require__(554);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoCheckbox_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoCheckbox_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoCheckbox_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__MetadadosCampoDinamicoCheckbox_vue_vue_type_template_id_79027340___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__MetadadosCampoDinamicoCheckbox_vue_vue_type_template_id_79027340___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoCheckbox_vue_vue_type_template_id_79027340___ = __webpack_require__(1359);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoCheckbox_vue_vue_type_template_id_79027340___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoCheckbox_vue_vue_type_template_id_79027340___["b"]; });


/***/ }),
/* 1359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-checkbox',{attrs:{"id":_vm.inputId,"label":_vm.inputLabel,"disabled":_vm.campoDesabilitado,"required":_vm.campoObrigatorio,"rules":[_vm.rules.requiredTime]},on:{"input":_vm.emiteValorAlterado},model:{value:(_vm.valorInterno),callback:function ($$v) {_vm.valorInterno=$$v},expression:"valorInterno"}})}
var staticRenderFns = []



/***/ }),
/* 1360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MetadadosCampoDinamicoListaCheckbox_vue_vue_type_template_id_4cd626d2___ = __webpack_require__(1361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoListaCheckbox_vue_vue_type_script_lang_js___ = __webpack_require__(556);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoListaCheckbox_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoListaCheckbox_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MetadadosCampoDinamicoListaCheckbox_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(1363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__MetadadosCampoDinamicoListaCheckbox_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__MetadadosCampoDinamicoListaCheckbox_vue_vue_type_template_id_4cd626d2___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__MetadadosCampoDinamicoListaCheckbox_vue_vue_type_template_id_4cd626d2___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoListaCheckbox_vue_vue_type_template_id_4cd626d2___ = __webpack_require__(1362);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoListaCheckbox_vue_vue_type_template_id_4cd626d2___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoListaCheckbox_vue_vue_type_template_id_4cd626d2___["b"]; });


/***/ }),
/* 1362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',[_c('v-list-group',{staticClass:"MetadadosCampoDinamicoListaCheckbox__list-group",attrs:{"no-action":""},scopedSlots:_vm._u([{key:"activator",fn:function(){return [_c('v-list-item',{staticClass:"MetadadosCampoDinamicoListaCheckbox__list_item"},[_c('v-list-item-content',{staticClass:"mx-0"},[_c('v-list-item-title',[_vm._v(_vm._s(("" + _vm.inputLabel + _vm.quantidadeItens)))])],1)],1)]},proxy:true}]),model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_vm._v(" "),_vm._l((_vm.itens),function(item){return _c('v-list-item',{key:item[_vm.valorItem],staticClass:"MetadadosCampoDinamicoListaCheckbox__list_item",on:{"click":function($event){return _vm.setValue(item[_vm.valorItem])}}},[_c('v-list-item-action',[_c('v-checkbox',{model:{value:(_vm.objetoInternoCheckbox[item[_vm.valorItem]]),callback:function ($$v) {_vm.$set(_vm.objetoInternoCheckbox, item[_vm.valorItem], $$v)},expression:"objetoInternoCheckbox[item[valorItem]]"}})],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(item[_vm.textoItem]))])],1)],1)})],2)],1)}
var staticRenderFns = []



/***/ }),
/* 1363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoListaCheckbox_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoListaCheckbox_vue_vue_type_style_index_0_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoListaCheckbox_vue_vue_type_style_index_0_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosCampoDinamicoListaCheckbox_vue_vue_type_style_index_0_lang_css____default.a); 

/***/ }),
/* 1364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MetadadosFiltrosRecursivos_vue_vue_type_template_id_5f1616a9___ = __webpack_require__(1365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MetadadosFiltrosRecursivos_vue_vue_type_script_lang_js___ = __webpack_require__(559);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__MetadadosFiltrosRecursivos_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__MetadadosFiltrosRecursivos_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__MetadadosFiltrosRecursivos_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__MetadadosFiltrosRecursivos_vue_vue_type_template_id_5f1616a9___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__MetadadosFiltrosRecursivos_vue_vue_type_template_id_5f1616a9___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosFiltrosRecursivos_vue_vue_type_template_id_5f1616a9___ = __webpack_require__(1366);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosFiltrosRecursivos_vue_vue_type_template_id_5f1616a9___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MetadadosFiltrosRecursivos_vue_vue_type_template_id_5f1616a9___["b"]; });


/***/ }),
/* 1366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","max-width":"600"},model:{value:(_vm.dialogRecursao),callback:function ($$v) {_vm.dialogRecursao=$$v},expression:"dialogRecursao"}},[(_vm.entidadeRecursivaEmFiltro)?_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("\n        "+_vm._s(_vm.$t('title.filtros_da_entidade', { entidade: _vm.entidadeRecursivaEmFiltro.entidadeEstrangeira }))+"\n      ")])]),_vm._v(" "),_c('v-card-text',_vm._l((_vm.dependenciasRecursivas),function(metadados,index){return _c('metadados-extensao',{key:index,attrs:{"metadados":metadados,"objeto-container":_vm.objeto,"get-valores-dependencias":_vm.getValoresDependencias,"ignora-filtro-recursivo":true,"ignora-obrigatorios":true},on:{"MetadadosExtensao_ValorSelecionado":_vm.valorSelecionado},model:{value:(_vm.filtroRecursao[metadados.label]),callback:function ($$v) {_vm.$set(_vm.filtroRecursao, metadados.label, $$v)},expression:"filtroRecursao[metadados.label]"}})}),1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","text":""},nativeOn:{"click":function($event){return _vm.cancelarFiltroAmostragem($event)}}},[_vm._v(_vm._s(_vm.$t('label.cancelar')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","disabled":!_vm.campoFiltrado()},nativeOn:{"click":function($event){return _vm.aplicarFiltroAmostragem($event)}}},[_vm._v("\n        "+_vm._s(_vm.$t("label.filtrar"))+"\n        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("filter_list")])],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []



/***/ }),
/* 1367 */,
/* 1368 */,
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNivelExtensao = exports.desabilitadoPorDependencia = exports.formataDependencia = exports.ordenaComponentesDinamicos = undefined;

var _keys = __webpack_require__(11);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = __webpack_require__(9);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ordenacaoSimples = function ordenacaoSimples(todosCampos) {
  return todosCampos.sort(function (a, b) {
    if (!a.campoExtensao) {
      return 1;
    }

    if (a.idNivelExtensao === b.idNivelExtensao) {
      return a.indiceRecursao < b.indiceRecursao ? 1 : -1;
    }

    return a.depObrigatoria ? -1 : 1;
  });
};

var ordenaComponentesDinamicos = exports.ordenaComponentesDinamicos = function ordenaComponentesDinamicos(ordenacao, dependencias, camposDinamicos, camposFixos) {
  var todosCampos = [].concat((0, _toConsumableArray3.default)(camposFixos || []), (0, _toConsumableArray3.default)(dependencias), (0, _toConsumableArray3.default)(camposDinamicos));
  if (!ordenacao || ordenacao.length === 0) {
    return ordenacaoSimples(todosCampos);
  }

  var ordenados = [];
  ordenacao.forEach(function (label) {
    for (var i = 0; i < todosCampos.length; i += 1) {
      var campo = todosCampos[i];
      var labelCampo = campo.labelCampo || campo.label;
      if (labelCampo === label) {
        ordenados.push(campo);
        break;
      }
    }
  });

  return ordenados;
};

var formataDependencia = exports.formataDependencia = function formataDependencia(dependencia, formularioFiltros) {
  var formatada = (0, _extends3.default)({}, dependencia);
  formatada.campoExtensao = true;
  if (formularioFiltros) {
    formatada.manyToMany = true;
  }
  return formatada;
};

var desabilitadoPorDependencia = exports.desabilitadoPorDependencia = function desabilitadoPorDependencia(metadados, objetoContainer) {
  var dependencia = metadados.dependencia;

  if (!dependencia) {
    return false;
  }
  var vlrDependencia = objetoContainer[dependencia];
  return !vlrDependencia || vlrDependencia === '' || (0, _keys2.default)(vlrDependencia).length === 0;
};

var getNivelExtensao = exports.getNivelExtensao = function getNivelExtensao(metadados, label) {
  var mapaEntidades = metadados.mapaEntidades;

  if (!mapaEntidades[label]) return null;

  var _mapaEntidades$label = mapaEntidades[label],
      idNivelExtensao = _mapaEntidades$label.idNivelExtensao,
      indiceRecursao = _mapaEntidades$label.indiceRecursao;

  return { idNivelExtensao: idNivelExtensao, indiceRecursao: indiceRecursao };
};

/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _maxSafeInteger = __webpack_require__(561);

var _maxSafeInteger2 = _interopRequireDefault(_maxSafeInteger);

var _values = __webpack_require__(42);

var _values2 = _interopRequireDefault(_values);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(11);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  methods: {
    getValoresAutocomplete: function getValoresAutocomplete() {
      var padrao = this.getValoresCamposPadrao();
      var valoresPadrao = (0, _keys2.default)(padrao).filter(function (key) {
        return key.startsWith('id');
      }).map(function (key) {
        var valor = {};
        valor[key] = padrao[key];
        return valor;
      }).reduce(function (obj1, obj2) {
        return (0, _extends3.default)({}, obj1, obj2);
      }, {});

      var valores = (0, _extends3.default)({}, this.getValoresDependencias(), valoresPadrao);

      return valores;
    },
    getDependenciasRecursivas: function getDependenciasRecursivas(dependente) {
      var listaDependencias = [];
      var metadados = this.metadadosEntidade,
          dependencias = (0, _values2.default)(metadados.mapaEntidades);
      var referencia = dependente;

      while (referencia !== null) {
        var dependencia = dependencias.filter(function (dependenciaRec) {
          var label = dependenciaRec.label;

          return referencia === label;
        })[0];

        if (dependencia) {
          listaDependencias.push(dependencia);
          referencia = dependencia.dependencias[0];
        } else {
          referencia = null;
        }
      }

      return listaDependencias;
    },
    getValoresDependenciasRecursivas: function getValoresDependenciasRecursivas(dependente) {
      if (!dependente) return [];

      var listaDependencias = this.getDependenciasRecursivas(dependente),
          valores = [],
          objeto = this.objeto;

      listaDependencias.filter(function (entidade) {
        var label = entidade.label;

        return objeto[label] && (0, _keys2.default)(objeto[label]).length !== 0;
      }).forEach(function (entidade) {
        var label = entidade.label,
            idNivelExtensao = entidade.idNivelExtensao,
            indiceRecursao = entidade.indiceRecursao;

        var addVal = function addVal(v) {
          var id = v.id;

          valores.push({ id: id, idNivelExtensao: idNivelExtensao, indiceRecursao: indiceRecursao });
        };

        var val = objeto[label];
        if (Array.isArray(val)) {
          val.forEach(function (v) {
            return addVal(v);
          });
        } else {
          addVal(val);
        }
      });

      if (valores.length === 0) {
        return [];
      }

      var menorIndiceRecursao = _maxSafeInteger2.default;
      var menorDependencia = null;
      valores.forEach(function (valor) {
        if (valor.indiceRecursao < menorIndiceRecursao) {
          menorIndiceRecursao = valor.indiceRecursao;
          menorDependencia = valor;
        }
      });
      return [menorDependencia];
    },
    getQuantidadeFiltrosSelecionados: function getQuantidadeFiltrosSelecionados() {
      var _this = this;

      return this.ordenacaoCampos.map(function (campo) {
        var objeto = _this.objeto[campo] || _this.objeto['id_' + campo];
        if (!objeto) {
          return 0;
        }
        if (Array.isArray(objeto)) {
          return objeto.length;
        }
        return 1;
      }).reduce(function (a, c) {
        return a + c;
      }, 0);
    },
    getNomesDependencias: function getNomesDependencias() {
      return this.dependenciasDiretas().map(function (dependencia) {
        return dependencia.label;
      });
    },
    getValoresDependencias: function getValoresDependencias() {
      var _this2 = this;

      var valores = {},
          objeto = this.objeto;

      this.dependenciasDiretas().filter(function (dependencia) {
        var label = dependencia.label,
            valor = objeto[label];

        return valor != null && (0, _keys2.default)(valor).length !== 0;
      }).filter(function (entidade) {
        var label = entidade.label;

        return _this2.ordenacaoCampos.length === 0 || _this2.ordenacaoCampos.indexOf(label) >= 0;
      }).forEach(function (dependencia) {
        var campo = dependencia.campo,
            label = dependencia.label,
            manyToMany = dependencia.manyToMany;

        valores[campo] = !manyToMany ? objeto[label].id : (0, _values2.default)(objeto[label]).map(function (v) {
          return v.id;
        });
      });
      return valores;
    },
    getValoresCamposDinamicos: function getValoresCamposDinamicos() {
      var _this3 = this;

      var valores = {};
      this.metadadosCamposDinamicos.filter(function (campoDinamico) {
        var labelCampo = campoDinamico.labelCampo;

        return _this3.objeto[labelCampo] != null;
      }).forEach(function (campoDinamico) {
        var labelCampo = campoDinamico.labelCampo,
            valor = _this3.objeto[labelCampo];

        valores[labelCampo] = valor;
      });
      return valores;
    },
    getValoresCamposPadrao: function getValoresCamposPadrao() {
      var _this4 = this;

      var valores = {};
      var campos = this.camposFormulario.padrao;

      campos.filter(function (campo) {
        return campo.async != null;
      }).filter(function (campo) {
        var labelCampo = campo.labelCampo;

        return _this4.objeto[labelCampo] != null;
      }).forEach(function (campo) {
        var itemValue = campo.async.itemValue;
        var nomCampoId = campo.nomCampoId,
            labelCampo = campo.labelCampo;

        var objSelecao = _this4.objeto[labelCampo];

        if (campo.tipoCampo === 'MULTIPLA_ESCOLHA') {
          valores[nomCampoId] = objSelecao.map(function (item) {
            return item[itemValue];
          });
        } else if (campo.tipoCampo === 'LISTA_CHECKBOX') {
          valores[nomCampoId] = objSelecao;
        } else {
          valores[nomCampoId] = objSelecao[itemValue];
        }
      });

      campos.filter(function (campo) {
        return !campo.async;
      }).filter(function (campo) {
        var labelCampo = campo.labelCampo;

        return _this4.objeto[labelCampo] != null;
      }).forEach(function (campo) {
        var labelCampo = campo.labelCampo;

        valores[labelCampo] = _this4.objeto[labelCampo];
      }, this);

      return valores;
    }
  }
};

/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(9);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _set = __webpack_require__(1372);

var _set2 = _interopRequireDefault(_set);

var _from = __webpack_require__(115);

var _from2 = _interopRequireDefault(_from);

var _values = __webpack_require__(42);

var _values2 = _interopRequireDefault(_values);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(11);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  methods: {
    filtraAmostragemRecursiva: function filtraAmostragemRecursiva(metadadosExtensao) {
      this.$refs.dialogFiltros.filtraAmostragemRecursiva(metadadosExtensao);
    },
    filtroAplicado: function filtroAplicado(filtrosRecursao) {
      var objeto = this.objeto;
      (0, _keys2.default)(filtrosRecursao).filter(function (chave) {
        return filtrosRecursao[chave] != null;
      }).forEach(function (chave) {
        objeto[chave] = (0, _extends3.default)({}, filtrosRecursao[chave]);
      });
      this.refresh();
    },
    identificaNiveisRecursivos: function identificaNiveisRecursivos() {
      var metadados = this.metadadosEntidade,
          dependencias = (0, _values2.default)(metadados.mapaEntidades);

      var idNiveisRecursivos = dependencias.filter(function (dependencia) {
        return dependencia.recursiva;
      }).map(function (dependencia) {
        return dependencia.idNivelExtensao;
      });
      idNiveisRecursivos = (0, _from2.default)(new _set2.default(idNiveisRecursivos));

      return idNiveisRecursivos;
    },
    identificaToposHierarquias: function identificaToposHierarquias(idNiveisRecursivos) {
      var metadados = this.metadadosEntidade,
          dependencias = (0, _values2.default)(metadados.mapaEntidades);

      var mapaTopoHierarquia = {};
      idNiveisRecursivos.forEach(function (idNivelExtensao) {
        var maiorIndice = -1;
        dependencias.filter(function (d) {
          return d.idNivelExtensao === idNivelExtensao;
        }).forEach(function (dependencia) {
          var indiceRecursao = dependencia.indiceRecursao;

          if (indiceRecursao > maiorIndice) {
            maiorIndice = indiceRecursao;
            mapaTopoHierarquia[idNivelExtensao] = dependencia;
          }
        });
      });
      return (0, _values2.default)(mapaTopoHierarquia);
    },
    vinculaDependenciasRecursivamente: function vinculaDependenciasRecursivamente(dependencia) {
      var metadados = this.metadadosEntidade;
      var dependenciasHier = (0, _values2.default)(metadados.mapaEntidades).filter(function (d) {
        return d.idNivelExtensao === dependencia.idNivelExtensao;
      });

      var nomesDependencias = [dependencia.label],
          referencia = dependencia;

      while (referencia != null) {
        var dependente = dependenciasHier.filter(function (dependenciaRec) {
          var dependencias = dependenciaRec.dependencias;

          return dependencias.indexOf(referencia.label) >= 0;
        })[0];

        if (dependente != null) {
          dependente.dependencias = nomesDependencias;
          nomesDependencias = [].concat((0, _toConsumableArray3.default)(nomesDependencias), [dependente.label]);
          referencia = dependente;
        } else {
          referencia = null;
        }
      }
    },
    vinculaTopoHierarquiaComDependentesIndiretos: function vinculaTopoHierarquiaComDependentesIndiretos() {
      var _this = this;

      if (!this.containerPossuiMapaEntidades()) {
        return;
      }

      var idNiveisRecursivos = this.identificaNiveisRecursivos();
      var toposHierarquias = this.identificaToposHierarquias(idNiveisRecursivos);

      toposHierarquias.forEach(function (dependencia) {
        return _this.vinculaDependenciasRecursivamente(dependencia);
      });
    },
    vinculaEntidadeComDependenciasIndiretas: function vinculaEntidadeComDependenciasIndiretas() {
      if (!this.containerPossuiMapaEntidades()) {
        return;
      }

      var _metadadosEntidade = this.metadadosEntidade,
          entidade = _metadadosEntidade.entidade,
          mapaEntidades = _metadadosEntidade.mapaEntidades;

      var dependencias = (0, _values2.default)(mapaEntidades);
      dependencias.filter(function (dependencia) {
        return dependencia.dependentes.indexOf(entidade) < 0;
      }).forEach(function (dependencia) {
        return dependencia.dependentes.push(entidade);
      });
    }
  }
};

/***/ }),
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _values = __webpack_require__(42);

var _values2 = _interopRequireDefault(_values);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  methods: {
    montaDependenciaCruzadaCampo: function montaDependenciaCruzadaCampo(campo) {
      var metadadosCampo = campo.metadadosCampo;
      var metadadosEntidade = this.metadadosEntidade;


      var dependenciasRef = (0, _values2.default)(metadadosCampo.mapaEntidades).map(function (dependencia) {
        return dependencia.label;
      });

      var mapaEntidades = metadadosEntidade.mapaEntidades;

      var dependenciasEntidade = (0, _values2.default)(mapaEntidades);

      dependenciasEntidade.filter(function (dependencia) {
        return dependenciasRef.indexOf(dependencia.label) >= 0;
      }).forEach(function (dependencia) {
        dependencia.dependentes.push(metadadosCampo.entidade.toLowerCase());
      });
    },
    montaDependenciasCruzadas: function montaDependenciasCruzadas() {
      var _this = this;

      var relacaoCampos = this.camposFormulario.padrao;

      relacaoCampos.filter(function (campo) {
        return campo.metadadosCampo != null;
      }).forEach(function (campo) {
        return _this.montaDependenciaCruzadaCampo(campo);
      });
    }
  }
};

/***/ }),
/* 1382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DivisaoTabela_vue_vue_type_template_id_082bfbfc_lang_html___ = __webpack_require__(1383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DivisaoTabela_vue_vue_type_script_lang_js___ = __webpack_require__(562);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__DivisaoTabela_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__DivisaoTabela_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__DivisaoTabela_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__DivisaoTabela_vue_vue_type_template_id_082bfbfc_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__DivisaoTabela_vue_vue_type_template_id_082bfbfc_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DivisaoTabela_vue_vue_type_template_id_082bfbfc_lang_html___ = __webpack_require__(1384);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DivisaoTabela_vue_vue_type_template_id_082bfbfc_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_DivisaoTabela_vue_vue_type_template_id_082bfbfc_lang_html___["b"]; });


/***/ }),
/* 1384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[_c('v-card',{staticClass:"card-size",attrs:{"height":"100%"}},[_c('v-card-title',[_c('h3',{staticClass:"headline mb-0",domProps:{"textContent":_vm._s(_vm.title)}})]),_vm._v(" "),_c('v-row',{attrs:{"justify":"start"}},[_c('v-col',{staticClass:"ml-3",attrs:{"cols":"12","sm":"6","md":"3"}},[_c('v-text-field',{attrs:{"append-icon":"search","label":_vm.$t('label.pesquisar'),"single-line":"","clearable":"","hide-details":""},on:{"input":_vm.filtrar},model:{value:(_vm.searchQuery),callback:function ($$v) {_vm.searchQuery=$$v},expression:"searchQuery"}})],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"ml-3",attrs:{"headers":_vm.headersDinamico,"items":_vm.divisoes,"options":_vm.pagination,"server-items-length":_vm.totalPage,"no-data-text":_vm.$t('label.tabela_sem_conteudo'),"footer-props":{
        itemsPerPageOptions: [10, 25, 50],
      }},on:{"update:options":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"body",fn:function(ref){
      var items = ref.items;
return [_c('tbody',_vm._l((items),function(item){return _c('tr',{key:item.id},[(!_vm.somenteLeitura)?_c('td',{staticClass:"justify-center px-0",staticStyle:{"width":"1%","text-align":"center"}},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
      var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.onEditarDivisao(item)}}},on),[_c('v-icon',[_vm._v("edit")])],1)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.editar')))])])],1):_vm._e(),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.idExterno))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.nome))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.estruturaUsuario.nome))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.getNomesSeparadosPorVirgula('divisoesSuperiores', 'nome')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getDiretoria(item.desAtributos) ? _vm.$t('label.sim') : _vm.$t('label.nao')))]),_vm._v(" "),(_vm.configCarteira === 'EXPLICITA')?_c('td',[_vm._v(_vm._s(item.getNomesSeparadosPorVirgula('carteirasCliente', 'descricao')))]):_vm._e(),_vm._v(" "),_vm._l((Object.keys(_vm.metadadosDivisao.mapaEntidades)),function(entidade){return _c('td',[_vm._v("\n              "+_vm._s(item.getNomesSeparadosPorVirgula(entidade, 'nomExtensao'))+"\n            ")])})],2)}),0)]}}])})],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EstruturaCadastro = __webpack_require__(1386);

var _EstruturaCadastro2 = _interopRequireDefault(_EstruturaCadastro);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  path: 'estrutura-usuario',
  name: 'estrutura-usuario',
  component: _EstruturaCadastro2.default
};

/***/ }),
/* 1386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EstruturaCadastro_vue_vue_type_template_id_092f721c_lang_html___ = __webpack_require__(1387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EstruturaCadastro_vue_vue_type_script_lang_js___ = __webpack_require__(564);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__EstruturaCadastro_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__EstruturaCadastro_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__EstruturaCadastro_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__EstruturaCadastro_vue_vue_type_template_id_092f721c_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__EstruturaCadastro_vue_vue_type_template_id_092f721c_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_EstruturaCadastro_vue_vue_type_template_id_092f721c_lang_html___ = __webpack_require__(1388);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_EstruturaCadastro_vue_vue_type_template_id_092f721c_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_EstruturaCadastro_vue_vue_type_template_id_092f721c_lang_html___["b"]; });


/***/ }),
/* 1388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CRUDGenerico__Wrapper"},[_c('md-layout',{staticClass:"md-gutter-16",attrs:{"md-row":""}},[(!_vm.somenteLeitura)?_c('md-layout',{staticClass:"CRUDGenerico__SideMenu md-hide-medium",attrs:{"md-column":""}},[_c('estrutura-form',{ref:"formularioCadastroDeDivisao",attrs:{"prepareResponseData":_vm.prepareResponseData},on:{"FORMULARIO_CADASTRO_ESTRUTURA_SALVAR":_vm.onNovaEstrutura}})],1):_vm._e(),_vm._v(" "),(!_vm.somenteLeitura)?_c('md-dialog',{ref:"dialog1",staticClass:"md-hide-large-and-up",attrs:{"md-open-from":"#fab","md-close-to":"#fab"}},[_c('estrutura-form',{ref:"dialogoFormularioCadastroDeDivisao",attrs:{"prepareResponseData":_vm.prepareResponseData},on:{"FORMULARIO_CADASTRO_ESTRUTURA_SALVAR":_vm.onNovaEstrutura,"FORMULARIO_CADASTRO_ESTRUTURA_CANCELAR":_vm.closeDialog}})],1):_vm._e(),_vm._v(" "),_c('md-layout',{staticClass:"CRUDGenerico__TableWrapper",attrs:{"md-flex":""}},[_c('estrutura-tabela',{ref:"tabelaEstruturaUsuario",on:{"ESTRUTURAUSUARIOTABELA_EDITAR":_vm.onEditarEstrutura}})],1)],1),_vm._v(" "),(!_vm.somenteLeitura)?_c('md-button',{staticClass:"md-fab md-fab-bottom-right md-hide-large-and-up",staticStyle:{"position":"fixed","z-index":"5"},attrs:{"id":"estuturaUsuario-button-fab"},nativeOn:{"click":function($event){return _vm.openDialog('dialog1')}}},[_c('md-icon',[_vm._v("add")])],1):_vm._e()],1)}
var staticRenderFns = []



/***/ }),
/* 1389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EstruturaForm_vue_vue_type_template_id_56462f63_lang_html___ = __webpack_require__(1390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EstruturaForm_vue_vue_type_script_lang_js___ = __webpack_require__(566);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__EstruturaForm_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__EstruturaForm_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__EstruturaForm_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__EstruturaForm_vue_vue_type_template_id_56462f63_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__EstruturaForm_vue_vue_type_template_id_56462f63_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_EstruturaForm_vue_vue_type_template_id_56462f63_lang_html___ = __webpack_require__(1391);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_EstruturaForm_vue_vue_type_template_id_56462f63_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_EstruturaForm_vue_vue_type_template_id_56462f63_lang_html___["b"]; });


/***/ }),
/* 1391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-card',[_c('register-form',{attrs:{"title":_vm.estruturaUsuario.id !== null ? _vm.$t('title.editar_estrutura_usuario') : _vm.$t('title.cadastrar_nova_estrutura_usuario'),"cancel":_vm.cancel,"save":_vm.openSaveDialog}},[_c('v-form',{ref:"form",attrs:{"slot":"content","lazy-validation":""},slot:"content",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('div',[_c('v-text-field',{attrs:{"tabindex":"1","counter":50,"rules":[_vm.required],"label":((_vm.$tc('label.nome')) + "*"),"required":""},model:{value:(_vm.estruturaUsuario.nomEstruturaUsuario),callback:function ($$v) {_vm.$set(_vm.estruturaUsuario, "nomEstruturaUsuario", $$v)},expression:"estruturaUsuario.nomEstruturaUsuario"}}),_vm._v(" "),_c('md-input-container',[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.$tc('label.estrutura_pai')))]),_vm._v(" "),_c('md-autocomplete',{attrs:{"tabindex":"2","name":"estrutura_usuario_pai","fetch":_vm.estruturaUsuarioResources.listarAtivos,"prepareResponseData":_vm.prepareResponseData,"min-chars":2,"printAttribute":"nomEstruturaUsuario","queryParam":"nome"},on:{"selected":_vm.setEstruturaUsuarioPai},nativeOn:{"change":function($event){return _vm.setEstruturaUsuarioPai($event)}},model:{value:(_vm.estruturaUsuario.estruturaUsuarioPai),callback:function ($$v) {_vm.$set(_vm.estruturaUsuario, "estruturaUsuarioPai", $$v)},expression:"estruturaUsuario.estruturaUsuarioPai"}}),_vm._v(" "),_c('md-icon',{staticStyle:{"cursor":"pointer"},attrs:{"md-autocomplete-search":""}},[_vm._v("search")])],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"33","md-flex-medium":"100","md-flex-small":"100","md-flex-xsmall":"100"}},[_c('md-switch',{staticClass:"md-primary",attrs:{"tabindex":"3","id":"estruturaUsuario_indHierarquia","name":"estruturaUsuario_indHierarquia"},model:{value:(_vm.estruturaUsuario.indHierarquia),callback:function ($$v) {_vm.$set(_vm.estruturaUsuario, "indHierarquia", $$v)},expression:"estruturaUsuario.indHierarquia"}},[_vm._v("\n            "+_vm._s(_vm.$tc('label.estrutura_usuario', 2))+"\n          ")])],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"33","md-flex-medium":"100","md-flex-small":"100","md-flex-xsmall":"100"}},[_c('md-switch',{staticClass:"md-primary",attrs:{"tabindex":"4","id":"estruturaUsuario_indExtensao","name":"estruturaUsuario_indExtensao"},model:{value:(_vm.estruturaUsuario.indExtensao),callback:function ($$v) {_vm.$set(_vm.estruturaUsuario, "indExtensao", $$v)},expression:"estruturaUsuario.indExtensao"}},[_vm._v("\n            "+_vm._s(_vm.$tc('label.unidade_negocio', 2))+"\n          ")])],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"33","md-flex-medium":"100","md-flex-small":"100","md-flex-xsmall":"100"}},[_c('md-switch',{staticClass:"md-primary",attrs:{"tabindex":"5","id":"estruturaUsuario_indRepresentante","name":"estruturaUsuario_indRepresentante"},model:{value:(_vm.estruturaUsuario.indRepresentante),callback:function ($$v) {_vm.$set(_vm.estruturaUsuario, "indRepresentante", $$v)},expression:"estruturaUsuario.indRepresentante"}},[_vm._v("\n            "+_vm._s(_vm.$tc('label.representante', 2))+"\n          ")])],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"33","md-flex-medium":"100","md-flex-small":"100","md-flex-xsmall":"100"}},[_c('md-switch',{staticClass:"md-primary",attrs:{"tabindex":"6","id":"estruturaUsuario_indRateio","name":"estruturaUsuario_indRateio"},model:{value:(_vm.estruturaUsuario.indRateio),callback:function ($$v) {_vm.$set(_vm.estruturaUsuario, "indRateio", $$v)},expression:"estruturaUsuario.indRateio"}},[_vm._v("\n            "+_vm._s(_vm.$tc('label.rateio', 2))+"\n          ")])],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"33","md-flex-medium":"100","md-flex-small":"100","md-flex-xsmall":"100"}},[_c('md-switch',{staticClass:"md-primary",attrs:{"tabindex":"7","id":"estruturaUsuario_indAtivo","name":"estruturaUsuario_indAtivo"},model:{value:(_vm.estruturaUsuario.indAtivo),callback:function ($$v) {_vm.$set(_vm.estruturaUsuario, "indAtivo", $$v)},expression:"estruturaUsuario.indAtivo"}},[_vm._v("\n            "+_vm._s(_vm.$tc('label.ativo', 2))+"\n          ")])],1)],1)])],1),_vm._v(" "),_c('md-dialog',{ref:_vm.dialog.ref,attrs:{"md-open-from":("#" + (_vm.dialog.from)),"md-close-to":("#" + (_vm.dialog.from))}},[_c('md-dialog-title',[_vm._v(_vm._s(_vm.dialog.title))]),_vm._v(" "),_c('md-dialog-content',[_vm._v(_vm._s(_vm.dialog.content))]),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",nativeOn:{"click":function($event){return _vm.closeDialog('dialog1')}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.cancelar'))+"\n      ")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary",nativeOn:{"click":function($event){return _vm.closeDialog('dialog1', _vm.dialog.action)}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.sim'))+"\n      ")])],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EstruturaTabela_vue_vue_type_template_id_c145981c_lang_html___ = __webpack_require__(1393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EstruturaTabela_vue_vue_type_script_lang_js___ = __webpack_require__(568);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__EstruturaTabela_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__EstruturaTabela_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EstruturaTabela_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__EstruturaTabela_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__EstruturaTabela_vue_vue_type_template_id_c145981c_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__EstruturaTabela_vue_vue_type_template_id_c145981c_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_EstruturaTabela_vue_vue_type_template_id_c145981c_lang_html___ = __webpack_require__(1394);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_EstruturaTabela_vue_vue_type_template_id_c145981c_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_EstruturaTabela_vue_vue_type_template_id_c145981c_lang_html___["b"]; });


/***/ }),
/* 1394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticStyle:{"width":"100%"}},[_c('v-card-title',[_c('h3',{staticClass:"headline mb-0"},[_vm._v(_vm._s(_vm.$tc('label.estrutura_usuario', 2)))])]),_vm._v(" "),_c('v-row',{attrs:{"justify":"end"}},[_c('v-col',{staticClass:"ml-3",attrs:{"cols":"12","sm":"6","md":"3"}},[_c('md-input-container',[_c('md-select',{on:{"change":_vm.handleStatusFilterChange},model:{value:(_vm.statusFilter),callback:function ($$v) {_vm.statusFilter=$$v},expression:"statusFilter"}},[_c('md-option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.$t('label.todos')))]),_vm._v(" "),_c('md-option',{attrs:{"value":"true"}},[_vm._v(_vm._s(_vm.$t('label.ativos')))]),_vm._v(" "),_c('md-option',{attrs:{"value":"false"}},[_vm._v(_vm._s(_vm.$t('label.inativos')))])],1)],1)],1),_vm._v(" "),_c('v-col',{staticClass:"ml-3",attrs:{"cols":"12","sm":"6","md":"3"}},[_c('v-text-field',{attrs:{"append-icon":"search","label":_vm.$t('label.pesquisar'),"single-line":"","clearable":"","hide-details":""},on:{"input":_vm.filtrar},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.estruturasUsuarios,"options":_vm.pagination,"server-items-length":_vm.totalPage,"no-data-text":_vm.$t('label.tabela_sem_conteudo'),"footer-props":{
      itemsPerPageOptions: [10, 25, 50],
    }},on:{"update:options":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"item.acoes",fn:function(ref){
    var item = ref.item;
return [(_vm.canEdit)?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
    var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();return _vm.edit(item)}}},on),[_c('v-icon',[_vm._v("edit")])],1)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.editar')))])]):_vm._e()]}},{key:"item.nom_estrutura_usuario",fn:function(ref){
    var item = ref.item;
return [_vm._v("\n      "+_vm._s(item.nomEstruturaUsuario)+"\n    ")]}},{key:"item.estrutura_usuario_pai",fn:function(ref){
    var item = ref.item;
return [_vm._v("\n      "+_vm._s(item.estruturaUsuarioPai)+"\n    ")]}},{key:"item.ind_hierarquia",fn:function(ref){
    var item = ref.item;
return [_vm._v("\n      "+_vm._s(item.indHierarquia ? _vm.$t('label.sim') : _vm.$t('label.nao'))+"\n    ")]}},{key:"item.ind_extensao",fn:function(ref){
    var item = ref.item;
return [_vm._v("\n      "+_vm._s(item.indExtensao ? _vm.$t('label.sim') : _vm.$t('label.nao'))+"\n    ")]}},{key:"item.ind_representante",fn:function(ref){
    var item = ref.item;
return [_vm._v("\n      "+_vm._s(item.indRepresentante ? _vm.$t('label.sim') : _vm.$t('label.nao'))+"\n    ")]}},{key:"item.ind_rateio",fn:function(ref){
    var item = ref.item;
return [_vm._v("\n      "+_vm._s(item.indRateio ? _vm.$t('label.sim') : _vm.$t('label.nao'))+"\n    ")]}},{key:"item.ind_ativo",fn:function(ref){
    var item = ref.item;
return [_vm._v("\n      "+_vm._s(item.indAtivo ? _vm.$t('label.sim') : _vm.$t('label.nao'))+"\n    ")]}}])})],1)}
var staticRenderFns = []



/***/ }),
/* 1395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_EstruturaTabela_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_EstruturaTabela_vue_vue_type_style_index_0_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_EstruturaTabela_vue_vue_type_style_index_0_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_EstruturaTabela_vue_vue_type_style_index_0_lang_css____default.a); 

/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _GestaoAprovacao = __webpack_require__(1397);

var _GestaoAprovacao2 = _interopRequireDefault(_GestaoAprovacao);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  path: 'gestao-aprovacao',
  name: 'gestao-aprovacao',
  component: _GestaoAprovacao2.default
};

/***/ }),
/* 1397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GestaoAprovacao_vue_vue_type_template_id_3730f2e7___ = __webpack_require__(1398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GestaoAprovacao_vue_vue_type_script_lang_js___ = __webpack_require__(571);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__GestaoAprovacao_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__GestaoAprovacao_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__GestaoAprovacao_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__GestaoAprovacao_vue_vue_type_template_id_3730f2e7___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__GestaoAprovacao_vue_vue_type_template_id_3730f2e7___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GestaoAprovacao_vue_vue_type_template_id_3730f2e7___ = __webpack_require__(1399);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GestaoAprovacao_vue_vue_type_template_id_3730f2e7___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GestaoAprovacao_vue_vue_type_template_id_3730f2e7___["b"]; });


/***/ }),
/* 1399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.podeAcessarPagina)?_c('v-card',[_c('v-card-text',[_c('div',{staticClass:"ma-3"},[_c('h6',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('title.gestao_aprovacao')))])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('filtros-gestao-aprovacao',{on:{"filtrar":_vm.preencharFiltro,"recarregarUsuarios":_vm.recarregarUsuariosNoModal}}),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('gestao-aprovacao-tabela',{attrs:{"filtros":_vm.filtros},on:{"TransferirPasso":_vm.transferirPasso}}),_vm._v(" "),_c('transferir-modal',{ref:"transgerirModal",attrs:{"passo":_vm.passo,"idPerfilFiltro":_vm.idPerfilParaModal,"filtros":_vm.filtros},on:{"filtrar":_vm.preencharFiltro}})],1)],1):_vm._e()}
var staticRenderFns = []



/***/ }),
/* 1400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FiltrosGestaoAprovacao_vue_vue_type_template_id_f6f69cb0___ = __webpack_require__(1401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FiltrosGestaoAprovacao_vue_vue_type_script_lang_js___ = __webpack_require__(573);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__FiltrosGestaoAprovacao_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__FiltrosGestaoAprovacao_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__FiltrosGestaoAprovacao_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__FiltrosGestaoAprovacao_vue_vue_type_template_id_f6f69cb0___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__FiltrosGestaoAprovacao_vue_vue_type_template_id_f6f69cb0___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosGestaoAprovacao_vue_vue_type_template_id_f6f69cb0___ = __webpack_require__(1402);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosGestaoAprovacao_vue_vue_type_template_id_f6f69cb0___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_FiltrosGestaoAprovacao_vue_vue_type_template_id_f6f69cb0___["b"]; });


/***/ }),
/* 1402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{ref:"form",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-text-field',{attrs:{"label":_vm.$t('label.numero_acordo'),"required":""},model:{value:(_vm.filtros.idAcordo),callback:function ($$v) {_vm.$set(_vm.filtros, "idAcordo", $$v)},expression:"filtros.idAcordo"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-select',{attrs:{"items":_vm.tipos,"item-text":"nome","item-value":"id","return-object":"","rules":[_vm.rules.required],"required":"","label":_vm.$t('label.tipo_de_fluxo')},on:{"change":_vm.buscarTarefas},model:{value:(_vm.filtros.tipo),callback:function ($$v) {_vm.$set(_vm.filtros, "tipo", $$v)},expression:"filtros.tipo"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-select',{attrs:{"items":_vm.passos,"item-text":"descricao","item-value":"descricao","no-data-text":_vm.$t('label.tabela_sem_conteudo'),"rules":[_vm.rules.required],"return-object":"","required":"","label":_vm.$t('label.tarefa_aprovacao')},on:{"change":_vm.preencherFiltroCliente},model:{value:(_vm.filtros.passo),callback:function ($$v) {_vm.$set(_vm.filtros, "passo", $$v)},expression:"filtros.passo"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[(_vm.passoCliente)?_c('v-select',{attrs:{"clearable":"","items":_vm.aprovadores,"item-text":"aprovador","item-value":"id","rules":[_vm.rules.required],"return-object":"","required":"","no-data-text":_vm.$t('label.tabela_sem_conteudo'),"label":_vm.$t('label.usuario_aprovador')},model:{value:(_vm.filtros.aprovador),callback:function ($$v) {_vm.$set(_vm.filtros, "aprovador", $$v)},expression:"filtros.aprovador"}}):_vm._e(),_vm._v(" "),(!_vm.passoCliente)?_c('v-select',{attrs:{"clearable":"","items":_vm.aprovadores,"return-object":"","item-text":"aprovador","item-value":"id","no-data-text":_vm.$t('label.tabela_sem_conteudo'),"label":_vm.$t('label.usuario_aprovador')},model:{value:(_vm.filtros.aprovador),callback:function ($$v) {_vm.$set(_vm.filtros, "aprovador", $$v)},expression:"filtros.aprovador"}}):_vm._e()],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-select',{attrs:{"clearable":"","items":_vm.solicitantes,"item-text":"solicitante","return-object":"","item-value":"id","no-data-text":_vm.$t('label.tabela_sem_conteudo'),"label":_vm.$t('label.solicitante')},model:{value:(_vm.filtros.solicitante),callback:function ($$v) {_vm.$set(_vm.filtros, "solicitante", $$v)},expression:"filtros.solicitante"}})],1)],1),_vm._v(" "),_c('v-row',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"text":"","color":"primary"},on:{"click":_vm.limparFiltros}},[_vm._v(_vm._s(_vm.$t('label.limpar_filtros')))]),_vm._v(" "),_c('v-btn',{attrs:{"text":"","color":"accent"},on:{"click":_vm.filtrar}},[_vm._v(_vm._s(_vm.$t('label.aplicar')))])],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GestaoAprovacaoTabela_vue_vue_type_template_id_2b0d230f_scoped_true___ = __webpack_require__(1404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GestaoAprovacaoTabela_vue_vue_type_script_lang_js___ = __webpack_require__(575);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__GestaoAprovacaoTabela_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__GestaoAprovacaoTabela_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__GestaoAprovacaoTabela_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__GestaoAprovacaoTabela_vue_vue_type_template_id_2b0d230f_scoped_true___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__GestaoAprovacaoTabela_vue_vue_type_template_id_2b0d230f_scoped_true___["b" /* staticRenderFns */],
  false,
  null,
  "2b0d230f",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GestaoAprovacaoTabela_vue_vue_type_template_id_2b0d230f_scoped_true___ = __webpack_require__(1405);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GestaoAprovacaoTabela_vue_vue_type_template_id_2b0d230f_scoped_true___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_GestaoAprovacaoTabela_vue_vue_type_template_id_2b0d230f_scoped_true___["b"]; });


/***/ }),
/* 1405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',{staticClass:"ma-3"},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","disabled":_vm.tipoNaoSelecionado},on:{"click":_vm.transferirTodos}},[_vm._v(_vm._s(_vm.$t('label.transferir_todos')))])],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.passos,"options":_vm.pagination,"server-items-length":_vm.totalPassos,"no-data-text":_vm.$tc('message.nenhum_registro', 1),"loading":_vm.loading,"footer-props":{
      itemsPerPageOptions: [10, 25, 50],
    }},on:{"update:options":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"item",fn:function(ref){
    var item = ref.item;
return [_c('tr',[_c('td',[_vm._v(_vm._s(item.idAcordo ? item.idAcordo : item.tipo))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.solicitante))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.dtaSolicitacao))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.aprovadorAtual))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('v-tooltip',{attrs:{"left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
    var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"text":"","icon":""},on:{"click":function($event){return _vm.transferirPasso(item)}}},on),[_c('v-icon',[_vm._v("swap_horiz")])],1)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.transferir')))])])],1)])]}}])})],1)}
var staticRenderFns = []



/***/ }),
/* 1406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TransferirModal_vue_vue_type_template_id_0cc132a0___ = __webpack_require__(1407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TransferirModal_vue_vue_type_script_lang_js___ = __webpack_require__(577);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__TransferirModal_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__TransferirModal_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__TransferirModal_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__TransferirModal_vue_vue_type_template_id_0cc132a0___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__TransferirModal_vue_vue_type_template_id_0cc132a0___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferirModal_vue_vue_type_template_id_0cc132a0___ = __webpack_require__(1408);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferirModal_vue_vue_type_template_id_0cc132a0___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferirModal_vue_vue_type_template_id_0cc132a0___["b"]; });


/***/ }),
/* 1408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","max-width":"800px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.$t('title.transferir_de')))])]),_vm._v(" "),_c('v-container',{staticClass:"py-0",attrs:{"grid-list-md":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"6"}},[_c('v-text-field',{attrs:{"label":_vm.$t('label.tipo_de_fluxo'),"readonly":true},model:{value:(_vm.passo.tipo),callback:function ($$v) {_vm.$set(_vm.passo, "tipo", $$v)},expression:"passo.tipo"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","sm":"6"}},[_c('v-text-field',{attrs:{"label":_vm.$t('label.tarefa_aprovacao'),"readonly":true},model:{value:(_vm.passo.tarefaAprovacao),callback:function ($$v) {_vm.$set(_vm.passo, "tarefaAprovacao", $$v)},expression:"passo.tarefaAprovacao"}})],1),_vm._v(" "),(_vm.passo.usuarioAprovador)?_c('v-col',{attrs:{"cols":"12","sm":"6"}},[_c('v-text-field',{attrs:{"label":_vm.$t('label.usuario_aprovador'),"readonly":true},model:{value:(_vm.passo.usuarioAprovador),callback:function ($$v) {_vm.$set(_vm.passo, "usuarioAprovador", $$v)},expression:"passo.usuarioAprovador"}})],1):_vm._e(),_vm._v(" "),(_vm.passo.solicitante)?_c('v-col',{attrs:{"cols":"12","sm":"6"}},[_c('v-text-field',{attrs:{"label":_vm.$t('label.solicitante'),"readonly":true},model:{value:(_vm.passo.solicitante),callback:function ($$v) {_vm.$set(_vm.passo, "solicitante", $$v)},expression:"passo.solicitante"}})],1):_vm._e()],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.$t('title.para')))])]),_vm._v(" "),(_vm.ehCliente)?_c('v-container',{staticClass:"py-0",attrs:{"grid-list-md":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"6"}},[_c('v-select',{attrs:{"readonly":true,"items":_vm.tipoAprovadores,"label":_vm.$t('label.selecione_aprovadores'),"item-text":"descricao","item-value":"value"},model:{value:(_vm.tipoAprovador),callback:function ($$v) {_vm.tipoAprovador=$$v},expression:"tipoAprovador"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","sm":"6"}},[_c('v-autocomplete',{attrs:{"items":_vm.usuariosCliente,"required":"","rules":[_vm.rules.required],"clearable":"","label":((_vm.$t('label.workflow_buscar_usuarios')) + "*"),"no-data-text":_vm.$tc('message.nenhum_registro', 1),"item-text":"nome","item-value":"id"},model:{value:(_vm.idUsuarioCliente),callback:function ($$v) {_vm.idUsuarioCliente=$$v},expression:"idUsuarioCliente"}})],1)],1)],1):_c('v-container',{staticClass:"py-0",attrs:{"grid-list-md":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"6"}},[_c('v-select',{attrs:{"items":_vm.tipoAprovadores,"label":_vm.$t('label.selecione_aprovadores'),"item-text":"descricao","item-value":"value"},model:{value:(_vm.tipoAprovador),callback:function ($$v) {_vm.tipoAprovador=$$v},expression:"tipoAprovador"}})],1),_vm._v(" "),(_vm.ehUsuario)?_c('v-col',{attrs:{"cols":"12","sm":"6"}},[_c('v-autocomplete',{attrs:{"items":_vm.usuarios,"multiple":"","required":"","rules":[_vm.rules.requiredArray],"clearable":"","return-object":"","label":((_vm.$t('label.workflow_buscar_usuarios')) + "*"),"no-data-text":_vm.$tc('message.nenhum_registro', 1),"item-text":"nomeSobrenome","item-value":"id"},model:{value:(_vm.usuariosAprovadores),callback:function ($$v) {_vm.usuariosAprovadores=$$v},expression:"usuariosAprovadores"}})],1):_vm._e(),_vm._v(" "),(_vm.ehGrupo)?_c('v-col',{attrs:{"cols":"12","sm":"6"}},[_c('v-autocomplete',{attrs:{"items":_vm.perfis,"multiple":"","required":"","rules":[_vm.rules.requiredArray],"clearable":"","return-object":"","label":((_vm.$t('label.workflow_buscar_grupos')) + "*"),"no-data-text":_vm.$tc('message.nenhum_registro', 1),"item-text":"nomPerfil","item-value":"id"},model:{value:(_vm.grupos),callback:function ($$v) {_vm.grupos=$$v},expression:"grupos"}})],1):_vm._e(),_vm._v(" "),(_vm.ehGrupo)?_c('v-col',{attrs:{"cols":"12","sm":"6"}},[_c('v-autocomplete',{attrs:{"items":_vm.estruturas,"multiple":"","clearable":"","return-object":"","label":_vm.$t('label.workflow_buscar_subgrupos'),"no-data-text":_vm.$tc('message.nenhum_registro', 1),"item-text":"nomEstruturaUsuario","item-value":"id"},model:{value:(_vm.subgrupos),callback:function ($$v) {_vm.subgrupos=$$v},expression:"subgrupos"}})],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{on:{"click":_vm.close}},[_vm._v(_vm._s(_vm.$t('label.cancelar')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent"},on:{"click":_vm.transferir}},[_vm._v(_vm._s(_vm.$t('label.confirmar')))])],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Importacao = __webpack_require__(1410);

var _Importacao2 = _interopRequireDefault(_Importacao);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  path: 'importacoes',
  name: 'importacoes',
  component: _Importacao2.default
};

/***/ }),
/* 1410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Importacao_vue_vue_type_template_id_8121a2bc_lang_html___ = __webpack_require__(1411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Importacao_vue_vue_type_script_lang_js___ = __webpack_require__(579);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__Importacao_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__Importacao_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Importacao_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(1433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Importacao_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__Importacao_vue_vue_type_template_id_8121a2bc_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Importacao_vue_vue_type_template_id_8121a2bc_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Importacao_vue_vue_type_template_id_8121a2bc_lang_html___ = __webpack_require__(1412);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Importacao_vue_vue_type_template_id_8121a2bc_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Importacao_vue_vue_type_template_id_8121a2bc_lang_html___["b"]; });


/***/ }),
/* 1412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canImport)?_c('div',{staticClass:"Importation__Wrapper"},[_c('v-row',[_c('v-col',{attrs:{"md":"3","sm":"12"}},[_c('importacao-lateral',{attrs:{"tipos":_vm.getTiposImportacaoFiltrados},on:{"IMPORTACAO_LATERACAO_UPLOAD":_vm.uploadRealizado}})],1),_vm._v(" "),_c('v-col',{attrs:{"md":"9","sm":"12"}},[_c('v-tabs',{attrs:{"centered":"","color":"accent","background-color":"rgba(0,0,0,0)"},on:{"change":_vm.popularImportacoes},model:{value:(_vm.tabSelecionada),callback:function ($$v) {_vm.tabSelecionada=$$v},expression:"tabSelecionada"}},[_c('v-tab',{attrs:{"href":"#tab-importacoes-andamento"}},[_vm._v("\n          "+_vm._s(_vm.$t('label.em_andamento'))+"\n        ")]),_vm._v(" "),_c('v-tab',{attrs:{"href":"#tab-importacoes-finalizadas"}},[_vm._v("\n          "+_vm._s(_vm.$t('label.finalizados'))+"\n        ")]),_vm._v(" "),_c('v-tab',{staticClass:"white-text",attrs:{"href":"#tab-importacoes-erros"}},[_vm._v("\n          "+_vm._s(_vm.$t('label.com_erros'))+"\n        ")]),_vm._v(" "),_c('v-tabs-items',{model:{value:(_vm.tabSelecionada),callback:function ($$v) {_vm.tabSelecionada=$$v},expression:"tabSelecionada"}},[_c('v-tab-item',{attrs:{"id":"tab-importacoes-andamento"}},[_c('importacao-tabela',{attrs:{"title":_vm.$t('label.importacoes_andamento'),"headers":_vm.cabecalhoImportacoesAndamento,"registros":_vm.importacoesAndamento,"isErros":false}})],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":"tab-importacoes-finalizadas"}},[_c('importacao-tabela',{attrs:{"title":_vm.$t('label.importacoes_finalizadas'),"headers":_vm.cabecalhoImportacoesFinalizados,"registros":_vm.importacoesFinalizadas,"isErros":true},on:{"IMPORTACAOTABELA_OPEN_DIALOG_ERROS":_vm.getImportacoesDetalhesFinalizados}})],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":"tab-importacoes-erros"}},[_c('importacao-tabela',{attrs:{"title":_vm.$t('label.importacoes_erros'),"headers":_vm.cabecalhoImportacoes,"registros":_vm.importacoesErros,"isErros":true},on:{"IMPORTACAOTABELA_OPEN_DIALOG_ERROS":_vm.getImportacoesDetalhesErros}})],1)],1)],1)],1)],1),_vm._v(" "),_c('generic-modal',{ref:"modalErros",attrs:{"title":_vm.$tc('title.erro', 2)}},[(_vm.importacaoDetalheErros)?_c('div',{staticStyle:{"width":"100%"},attrs:{"slot":"body"},slot:"body"},[_c('importacao-dialog-erros',{staticStyle:{"max-height":"400px"},attrs:{"registros":_vm.importacaoDetalheErros,"headers":_vm.tableHeaderDetalheErros,"source":_vm.idErro},on:{"IMPORTACAODIALOGERROS_CLOSE_DIALOG":function($event){return _vm.closeDialog('modalErros')}}})],1):_vm._e(),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"})]),_vm._v(" "),_c('generic-modal',{ref:"modalFinalizada"},[(_vm.importacaoDetalheFinalizados && _vm.importacaoDetalheErros)?_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('importacao-finalizada-dialog',{attrs:{"table-rows-finalizado":_vm.importacaoDetalheFinalizados,"table-header-finalizado":_vm.tableHeaderDetalheFinalizados,"table-rows-erros":_vm.importacaoDetalheErros,"table-header-erros":_vm.tableHeaderDetalheErros},on:{"IMPORTACAO_FINALIZADA_DIALOG_CLOSE":function($event){return _vm.closeDialog('modalFinalizada')}}})],1):_vm._e(),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"})])],1):_vm._e()}
var staticRenderFns = []



/***/ }),
/* 1413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ImportacaoLateral_vue_vue_type_template_id_0cc198d7_lang_html___ = __webpack_require__(1414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ImportacaoLateral_vue_vue_type_script_lang_js___ = __webpack_require__(581);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__ImportacaoLateral_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__ImportacaoLateral_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ImportacaoLateral_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(1416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ImportacaoLateral_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__ImportacaoLateral_vue_vue_type_template_id_0cc198d7_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ImportacaoLateral_vue_vue_type_template_id_0cc198d7_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoLateral_vue_vue_type_template_id_0cc198d7_lang_html___ = __webpack_require__(1415);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoLateral_vue_vue_type_template_id_0cc198d7_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoLateral_vue_vue_type_template_id_0cc198d7_lang_html___["b"]; });


/***/ }),
/* 1415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('register-form',[_c('v-card-title',{attrs:{"slot":"header"},slot:"header"},[_c('h2',{staticClass:"mb-0",staticStyle:{"font-size":"18px","width":"100%"}},[_vm._v(_vm._s(_vm.$t('label.fazer_nova_importacao')))])]),_vm._v(" "),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-select',{staticClass:"Form-text__invalid",attrs:{"id":"periodo","name":"periodo","items":_vm.tipos,"item-value":"id","label":("" + (_vm.$t('label.tipo_importacao')))},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('div',{staticClass:"ImportacaoLateral__TipoImportacao--capitalize"},[_vm._v("\n                "+_vm._s(data.item.nome.replace(/\_/g,' ').replace('importacao', ''))+"\n              ")])]}},{key:"item",fn:function(data){return [_c('div',{staticClass:"ImportacaoLateral__TipoImportacao--capitalize"},[_vm._v("\n                "+_vm._s(data.item.nome.replace(/\_/g,' ').replace('importacao', ''))+"\n              ")])]}}]),model:{value:(_vm.importacaoId),callback:function ($$v) {_vm.importacaoId=$$v},expression:"importacaoId"}})],1),_vm._v(" "),(_vm.importacao.nome === 'importacao_sellin' || _vm.importacao.nome === 'importacao_sellout')?_c('v-col',{attrs:{"cols":"12"}},[_c('input-datepicker',{staticStyle:{"width":"100%"},attrs:{"label":_vm.$t('label.data_inicio'),"format":"DD-MM-YYYY","dateIsClicked":true,"validate:":"false"},on:{"INPUTDATEPICKER_FORMATTED_DATE":_vm.dataInicialFormatada},model:{value:(_vm.dataInicio),callback:function ($$v) {_vm.dataInicio=$$v},expression:"dataInicio"}})],1):_vm._e(),_vm._v(" "),(_vm.importacao.nome === 'importacao_sellin' || _vm.importacao.nome === 'importacao_sellout')?_c('v-col',{attrs:{"cols":"12"}},[_c('input-datepicker',{staticStyle:{"width":"100%"},attrs:{"label":_vm.$t('label.data_fim'),"format":"DD-MM-YYYY","dateIsClicked":true,"validate:":"false"},on:{"INPUTDATEPICKER_FORMATTED_DATE":_vm.dataFimFormatada},model:{value:(_vm.dataFim),callback:function ($$v) {_vm.dataFim=$$v},expression:"dataFim"}})],1):_vm._e()],1),_vm._v(" "),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('div',{staticStyle:{"position":"relative","min-height":"352px"}},[(_vm.hasUploadFileUrl &&
              ((_vm.showImportSellIn || _vm.importacao.nome !== 'importacao_sellin') || (_vm.showImportSellOut || _vm.importacao.nome !== 'importacao_sellout')))?_c('upload-file',{staticClass:"md-hide-medium",attrs:{"id":_vm.uploadFileDropzoneId,"maxFileSizeInMB":50,"url":_vm.uploadFileUrl,"accepted-file-types":_vm.importacao.arquivosSuportados},on:{"UPLOADFILE_SUCCESS":_vm.uploadSuccess,"UPLOADFILE_ERROR":_vm.uploadError,"UPLOADFILE_SENDING":_vm.enviandoArquivo}}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBlockDropzone),expression:"showBlockDropzone"}],staticClass:"ImportacaoLateral__BlockDropzone",class:{
                  'ImportacaoLateral__BlockDropzone--active': !_vm.hasUploadFileUrl,
                  'ImportacaoLateral__BlockDropzone--deactive': _vm.hasUploadFileUrl,
                }},[_c('h4',[_vm._v(_vm._s(_vm.$t('label.escolha_tipo_importacao_acima')))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:((!_vm.showImportSellIn && _vm.importacao.nome === 'importacao_sellin')
                  || (!_vm.showImportSellOut && _vm.importacao.nome === 'importacao_sellout')),expression:"(!showImportSellIn && importacao.nome === 'importacao_sellin')\n                  || (!showImportSellOut && importacao.nome === 'importacao_sellout')"}],staticClass:"ImportacaoLateral__BlockDropzone",class:{
                  'ImportacaoLateral__BlockDropzone--active':!_vm.showImportSellIn,
                  'ImportacaoLateral__BlockDropzone--deactive': _vm.showImportSellIn,
                  'ImportacaoLateral__BlockDropzone--active':!_vm.showImportSellOut,
                  'ImportacaoLateral__BlockDropzone--deactive': _vm.showImportSellOut,
                }},[_c('h4',[_vm._v(_vm._s(_vm.$t('label.escolha_periodo_importacao')))])])],1)])],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"button"},slot:"button"}),_vm._v(" "),(_vm.exibeCancelar)?_c('v-btn',{attrs:{"color":"primary","id":"importacaoLateral-dialog-button-cancel"},nativeOn:{"click":function($event){return _vm.cancelarImportacao()}}},[_vm._v("\n      "+_vm._s(_vm.$t('label.cancelar'))+"\n    ")]):_vm._e()],1),_vm._v(" "),_c('md-dialog',{ref:_vm.dialog.ref,attrs:{"md-open-from":("#" + (_vm.dialog.from)),"md-close-to":("#" + (_vm.dialog.from))}},[_c('md-dialog-title',[_vm._v(_vm._s(_vm.dialog.title))]),_vm._v(" "),_c('md-dialog-content',[_vm._v(_vm._s(_vm.dialog.content))]),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",attrs:{"id":"importacaoLateral-dialog-button-cancel"},nativeOn:{"click":function($event){return _vm.closeDialog('dialog1')}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.cancelar'))+"\n      ")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary",attrs:{"id":"importacaoLateral-dialog-button-save"},nativeOn:{"click":function($event){return _vm.closeDialog('dialog1', _vm.dialog.action)}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.sim'))+"\n      ")])],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoLateral_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoLateral_vue_vue_type_style_index_0_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoLateral_vue_vue_type_style_index_0_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoLateral_vue_vue_type_style_index_0_lang_css____default.a); 

/***/ }),
/* 1417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ImportacaoTabela_vue_vue_type_template_id_299d78d8_lang_html___ = __webpack_require__(1418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ImportacaoTabela_vue_vue_type_script_lang_js___ = __webpack_require__(584);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__ImportacaoTabela_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__ImportacaoTabela_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ImportacaoTabela_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__ImportacaoTabela_vue_vue_type_template_id_299d78d8_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ImportacaoTabela_vue_vue_type_template_id_299d78d8_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoTabela_vue_vue_type_template_id_299d78d8_lang_html___ = __webpack_require__(1419);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoTabela_vue_vue_type_template_id_299d78d8_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoTabela_vue_vue_type_template_id_299d78d8_lang_html___["b"]; });


/***/ }),
/* 1419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"tabindex":"100"}},[_c('v-card',{staticStyle:{"min-height":"83vh"}},[_c('v-card-title',[_c('h1',{staticClass:"md-title",domProps:{"textContent":_vm._s(_vm.title)}})]),_vm._v(" "),_c('v-container',[_c('v-row',{attrs:{"justify-end":""}},[_c('v-col',{staticClass:"mr-3",attrs:{"cols":"12","sm":"6","md":"3"}},[_c('v-text-field',{attrs:{"append-icon":"search","label":_vm.$t('label.pesquisar'),"single-line":"","clearable":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.registros,"search":_vm.search,"items-per-page":5,"no-data-text":_vm.$t('label.tabela_sem_conteudo'),"footer-props":{itemsPerPageText: _vm.$t('label.linhas_por_pagina')}},scopedSlots:_vm._u([{key:"item.desImportacao",fn:function(ref){
var item = ref.item;
return [_vm._v("\n          "+_vm._s(item.desImportacao)+"\n        ")]}},{key:"item.nomArquivoOrigem",fn:function(ref){
var item = ref.item;
return [_vm._v("\n          "+_vm._s(item.nomArquivoOrigem)+"\n        ")]}},{key:"item.dtaCriacao",fn:function(ref){
var item = ref.item;
return [_vm._v("\n          "+_vm._s(item.dtaCriacao)+"\n        ")]}},(_vm.isErros)?{key:"item.desResultado",fn:function(ref){
var item = ref.item;
return [_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.openDialogErros(item)}}},on),[_c('v-icon',[_vm._v("visibility")])],1)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.visualizar_detalhes')))])])]}}:null],null,true)})],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ImportacaoDialogErros_vue_vue_type_template_id_3690c2be_lang_html___ = __webpack_require__(1421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ImportacaoDialogErros_vue_vue_type_script_lang_js___ = __webpack_require__(586);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__ImportacaoDialogErros_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__ImportacaoDialogErros_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ImportacaoDialogErros_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(1423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ImportacaoDialogErros_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__ImportacaoDialogErros_vue_vue_type_template_id_3690c2be_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ImportacaoDialogErros_vue_vue_type_template_id_3690c2be_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoDialogErros_vue_vue_type_template_id_3690c2be_lang_html___ = __webpack_require__(1422);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoDialogErros_vue_vue_type_template_id_3690c2be_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoDialogErros_vue_vue_type_template_id_3690c2be_lang_html___["b"]; });


/***/ }),
/* 1422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.registros,"hide-default-footer":"","no-data-text":_vm.$t('message.nao_ha_conteudo')},scopedSlots:_vm._u([{key:"item.linha",fn:function(ref){
var item = ref.item;
return [_vm._v("\n      "+_vm._s(item.linha)+"\n    ")]}},{key:"item.descricao",fn:function(ref){
var item = ref.item;
return [_vm._v("\n      "+_vm._s(item.descricao)+"\n    ")]}}])}),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":"","id":"importacaoDialog-table-button-cancel"},nativeOn:{"click":function($event){return _vm.closeDialog($event)}}},[_vm._v("\n      "+_vm._s(_vm.$t('label.fechar'))+"\n    ")])],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoDialogErros_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoDialogErros_vue_vue_type_style_index_0_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoDialogErros_vue_vue_type_style_index_0_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoDialogErros_vue_vue_type_style_index_0_lang_css____default.a); 

/***/ }),
/* 1424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ImportacaoFinalizadaDialog_vue_vue_type_template_id_1c652432_lang_html___ = __webpack_require__(1425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ImportacaoFinalizadaDialog_vue_vue_type_script_lang_js___ = __webpack_require__(589);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__ImportacaoFinalizadaDialog_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__ImportacaoFinalizadaDialog_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ImportacaoFinalizadaDialog_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__ImportacaoFinalizadaDialog_vue_vue_type_template_id_1c652432_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ImportacaoFinalizadaDialog_vue_vue_type_template_id_1c652432_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoFinalizadaDialog_vue_vue_type_template_id_1c652432_lang_html___ = __webpack_require__(1426);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoFinalizadaDialog_vue_vue_type_template_id_1c652432_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoFinalizadaDialog_vue_vue_type_template_id_1c652432_lang_html___["b"]; });


/***/ }),
/* 1426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"slot":"body"},slot:"body"},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"6","md":"6"}},[(_vm.tableRowsFinalizado)?_c('importacao-sucesso-tabela',{staticStyle:{"height":"400px","max-height":"400px"},attrs:{"registros":_vm.tableRowsFinalizado,"headers":_vm.tableHeaderFinalizado}}):_vm._e()],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","sm":"6","md":"6"}},[(_vm.tableRowsErros)?_c('importacao-erro-tabela',{staticStyle:{"height":"400px","max-height":"400px"},attrs:{"registros":_vm.tableRowsErros,"headers":_vm.tableHeaderErros,"visible-columns":['linha', 'descricao'],"ignore-columns":[]}}):_vm._e()],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":"","id":"importacaoFinalizadaDialog-button-fechar"},nativeOn:{"click":function($event){return _vm.closeDialog($event)}}},[_vm._v("\n      "+_vm._s(_vm.$t('label.fechar'))+"\n    ")])],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ImportacaoSucessoTabela_vue_vue_type_template_id_a0e27162_lang_html___ = __webpack_require__(1428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ImportacaoSucessoTabela_vue_vue_type_script_lang_js___ = __webpack_require__(591);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__ImportacaoSucessoTabela_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__ImportacaoSucessoTabela_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ImportacaoSucessoTabela_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__ImportacaoSucessoTabela_vue_vue_type_template_id_a0e27162_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ImportacaoSucessoTabela_vue_vue_type_template_id_a0e27162_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoSucessoTabela_vue_vue_type_template_id_a0e27162_lang_html___ = __webpack_require__(1429);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoSucessoTabela_vue_vue_type_template_id_a0e27162_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoSucessoTabela_vue_vue_type_template_id_a0e27162_lang_html___["b"]; });


/***/ }),
/* 1429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"md-title"},[_vm._v("\n    "+_vm._s(_vm.$tc('label.detalhe', 2))+"\n  ")]),_vm._v(" "),_c('v-row',{attrs:{"justify":"end"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.registros,"hide-default-footer":"","no-data-text":_vm.$t('message.nao_ha_conteudo')},scopedSlots:_vm._u([{key:"items",fn:function(props){return [(props.item.label)?_c('td',[_vm._v(_vm._s(_vm.$t(("label." + (props.item.label.toLowerCase())))))]):_vm._e(),_vm._v(" "),(props.item.value)?_c('td',[_vm._v(" "+_vm._s(props.item.value)+" ")]):_vm._e()]}}])})],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ImportacaoErroTabela_vue_vue_type_template_id_2402cfa6_lang_html___ = __webpack_require__(1431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ImportacaoErroTabela_vue_vue_type_script_lang_js___ = __webpack_require__(593);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__ImportacaoErroTabela_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__ImportacaoErroTabela_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__ImportacaoErroTabela_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__ImportacaoErroTabela_vue_vue_type_template_id_2402cfa6_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__ImportacaoErroTabela_vue_vue_type_template_id_2402cfa6_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoErroTabela_vue_vue_type_template_id_2402cfa6_lang_html___ = __webpack_require__(1432);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoErroTabela_vue_vue_type_template_id_2402cfa6_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ImportacaoErroTabela_vue_vue_type_template_id_2402cfa6_lang_html___["b"]; });


/***/ }),
/* 1432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"md-title"},[_vm._v("\n    "+_vm._s(_vm.$tc('label.erro', 2))+"\n  ")]),_vm._v(" "),_c('v-row',{attrs:{"justify":"end"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.registros,"hide-default-footer":"","no-data-text":_vm.$t('message.nao_ha_conteudo')},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v("  teste123 ")]),_vm._v(" "),(props.item.descricao)?_c('td',[_vm._v(" "+_vm._s(_vm.alterandoValor(props))+" ")]):_vm._e()]}}])})],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Importacao_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Importacao_vue_vue_type_style_index_0_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Importacao_vue_vue_type_style_index_0_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Importacao_vue_vue_type_style_index_0_lang_css____default.a); 

/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MargemContribuicao = __webpack_require__(1435);

var _MargemContribuicao2 = _interopRequireDefault(_MargemContribuicao);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  path: 'margem-contribuicao',
  name: 'margem-contribuicao',
  component: _MargemContribuicao2.default
};

/***/ }),
/* 1435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MargemContribuicao_vue_vue_type_template_id_309eb006___ = __webpack_require__(1436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MargemContribuicao_vue_vue_type_script_lang_js___ = __webpack_require__(596);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__MargemContribuicao_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__MargemContribuicao_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__MargemContribuicao_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__MargemContribuicao_vue_vue_type_template_id_309eb006___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__MargemContribuicao_vue_vue_type_template_id_309eb006___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MargemContribuicao_vue_vue_type_template_id_309eb006___ = __webpack_require__(1437);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MargemContribuicao_vue_vue_type_template_id_309eb006___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MargemContribuicao_vue_vue_type_template_id_309eb006___["b"]; });


/***/ }),
/* 1437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canAccessPage)?_c('div',{staticClass:"elevation-2",staticStyle:{"background":"#fff"}},[_c('v-container',{attrs:{"grid-list-xl":"","fluid":""}},[_c('v-row',{attrs:{"justify-end":""}},[_c('v-col',{attrs:{"cols":"12","sm":"6","md":"9"}},[_c('h3',{staticClass:"headline mb-0"},[_vm._v(_vm._s(_vm.$t('title.margemcontribuicao')))])]),_vm._v(" "),(!_vm.openSearchToolbar)?_c('v-col',{attrs:{"cols":"12","sm":"6","md":"1"}},[_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"md-icon-button md-hide-medium",attrs:{"text":"","id":"margem-contribuicao-button-import","disabled":_vm.blockExportButton},on:{"change":function($event){return _vm.$emit('MARGEMTABELA_IMPORTACAO')}},nativeOn:{"click":function($event){return _vm.openSideBar($event)}}},on),[_c('v-icon',[_vm._v("cloud_upload")])],1)]}}],null,false,3006690000)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.importar_conteudo')))])])],1):_vm._e(),_vm._v(" "),(!_vm.openSearchToolbar)?_c('v-col',{attrs:{"cols":"12","sm":"6","md":"1"}},[_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"md-icon-button",attrs:{"text":"","id":"margem-contribuicao-button-export","disabled":_vm.blockExportButton},nativeOn:{"click":function($event){return _vm.requestExportacao($event)}}},on),[_c('v-icon',[_vm._v("get_app")])],1)]}}],null,false,3962091045)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.exportar_conteudo'))+" ")])])],1):_vm._e(),_vm._v(" "),(!_vm.openSearchToolbar)?_c('v-col',{attrs:{"cols":"12","sm":"6","md":"1"}},[_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"md-icon-button",attrs:{"text":"","id":"margem-contribuicao-button-search"},nativeOn:{"click":function($event){return _vm.focusSearchInput('margem-contribuicao-input-search')}}},on),[_c('v-icon',[_vm._v("search")])],1)]}}],null,false,81870219)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.buscar'))+" ")])])],1):_vm._e(),_vm._v(" "),(_vm.openSearchToolbar)?_c('v-col',{attrs:{"cols":"12","sm":"6","md":"3"}},[_c('md-input-container',{staticClass:"TabelaGenerica__SearchInput md-accent"},[_c('label',[_vm._v(_vm._s(_vm.$t('label.buscar')))]),_vm._v(" "),_c('md-input',{attrs:{"autoFocus":"true","id":"margem-contribuicao-input-search","type":"text"},model:{value:(_vm.searchQuery),callback:function ($$v) {_vm.searchQuery=$$v},expression:"searchQuery"}}),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",attrs:{"id":"margem-contribuicao-button-search-close"},nativeOn:{"click":function($event){return _vm.closeSearchHeader($event)}}},[_c('md-icon',[_vm._v("close")])],1)],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.margens,"options":_vm.pagination,"no-data-text":_vm.$t('label.tabela_sem_conteudo'),"server-items-length":_vm.totalPage,"footer-props":{
      itemsPerPageText: _vm.$t('label.linhas_por_pagina'),
      itemsPerPageOptions: [5, 10, 25, 50],
    }},on:{"update:options":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"headerCell",fn:function(props){return [_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
    var on = ref.on;
return [_c('span',_vm._g({},on),[_vm._v("\n            "+_vm._s(props.header.text)+"\n          ")])]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v("\n          "+_vm._s(props.header.text)+"\n        ")])])]}},{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.ano))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.mes))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.codigoProduto))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.nomeProduto))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.codigoCliente))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.nomeCliente))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(_vm.getNumber(props.item.volumeVendido)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(_vm.getMoney(props.item.faturamentoLiquido)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(_vm.getMoney(props.item.custoTotal)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.canal))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.holding))])]}}],null,false,2257805103)}),_vm._v(" "),_c('margem-contribuicao-sidebar',{ref:"sidebar"})],1):_vm._e()}
var staticRenderFns = []



/***/ }),
/* 1438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MargemContribuicaoSidebar_vue_vue_type_template_id_25b793e2___ = __webpack_require__(1439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MargemContribuicaoSidebar_vue_vue_type_script_lang_js___ = __webpack_require__(598);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__MargemContribuicaoSidebar_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__MargemContribuicaoSidebar_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__MargemContribuicaoSidebar_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__MargemContribuicaoSidebar_vue_vue_type_template_id_25b793e2___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__MargemContribuicaoSidebar_vue_vue_type_template_id_25b793e2___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MargemContribuicaoSidebar_vue_vue_type_template_id_25b793e2___ = __webpack_require__(1440);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MargemContribuicaoSidebar_vue_vue_type_template_id_25b793e2___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_MargemContribuicaoSidebar_vue_vue_type_template_id_25b793e2___["b"]; });


/***/ }),
/* 1440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',{attrs:{"absolute":"","temporary":""},model:{value:(_vm.dialogForm),callback:function ($$v) {_vm.dialogForm=$$v},expression:"dialogForm"}},[_c('v-card',{staticClass:"elevation-0"},[_c('v-card-title',{staticClass:"headline grey lighten-2",attrs:{"primary-title":""}},[_vm._v(_vm._s(_vm.$t('title.importar_arquivo'))+"\n    ")]),_vm._v(" "),_c('v-card-text',[(_vm.tipoImportacao)?_c('upload-file',{staticClass:"md-hide-medium",attrs:{"name":"margem-sidebar-upload","subtitle":_vm.subtitle,"id":_vm.uploadFileDropzoneId,"url":_vm.importUrl,"accepted-file-types":_vm.tipoImportacao.arquivosSuportados},on:{"UPLOADFILE_SUCCESS":_vm.uploadSuccess,"UPLOADFILE_ERROR":_vm.uploadError,"UPLOADFILE_SENDING":_vm.enviandoArquivo}}):_vm._e()],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var Negociacao = function Negociacao() {
  return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 1666));
};
var NegociacaoList = function NegociacaoList() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 1667));
};
var DetalhesNegociacao = function DetalhesNegociacao() {
  return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 711));
};

exports.default = {
  path: 'negociacao',
  component: Negociacao,
  children: [{
    path: '',
    name: 'negociacao',
    component: NegociacaoList
  }, {
    path: 'detalhes/fixo',
    name: 'detalhesNegociacaoFixo',
    component: DetalhesNegociacao,
    props: {
      tipoAcordo: 'FIXO',
      somenteLeitura: false,
      edicao: false
    }
  }, {
    path: 'detalhes/fixo/:id',
    name: 'verDetalhesNegociacaoFixo',
    component: DetalhesNegociacao,
    props: {
      tipoAcordo: 'FIXO',
      somenteLeitura: true,
      edicao: false
    }
  }, {
    path: 'detalhes/fixo/:id/fluxo',
    name: 'verDetalhesNegociacaoFixoFluxo',
    component: DetalhesNegociacao,
    props: {
      tipoAcordo: 'FIXO',
      somenteLeitura: true,
      edicao: false,
      fluxo: true
    }
  }, {
    path: 'detalhes/fixo/:id/editar',
    name: 'editarDetalhesNegociacaoFixo',
    component: DetalhesNegociacao,
    props: {
      tipoAcordo: 'FIXO',
      somenteLeitura: false,
      edicao: true
    }
  }, {
    path: 'detalhes/tabloide',
    name: 'detalhesNegociacaoTabloide',
    component: DetalhesNegociacao,
    props: {
      tipoAcordo: 'TABLOIDE',
      somenteLeitura: false,
      edicao: false
    }
  }, {
    path: 'detalhes/tabloide/:id',
    name: 'verDetalhesNegociacaoTabloide',
    component: DetalhesNegociacao,
    props: {
      tipoAcordo: 'TABLOIDE',
      somenteLeitura: true,
      edicao: false
    }
  }, {
    path: 'detalhes/tabloide/:id/fluxo',
    name: 'verDetalhesNegociacaoTabloideFluxo',
    component: DetalhesNegociacao,
    props: {
      tipoAcordo: 'TABLOIDE',
      somenteLeitura: true,
      edicao: false,
      fluxo: true
    }
  }, {
    path: 'detalhes/tabloide/:id/editar',
    name: 'editarDetalhesNegociacaoTabloide',
    component: DetalhesNegociacao,
    props: {
      tipoAcordo: 'TABLOIDE',
      somenteLeitura: false,
      edicao: true
    }
  }, {
    path: 'detalhes/negociacao_preco',
    name: 'detalhesNegociacaoPreco',
    component: DetalhesNegociacao,
    props: {
      tipoAcordo: 'NEGOCIACAO_PRECO',
      somenteLeitura: false,
      edicao: false
    }
  }, {
    path: 'detalhes/negociacao_preco/:id',
    name: 'verDetalhesNegociacaoPreco',
    component: DetalhesNegociacao,
    props: {
      tipoAcordo: 'NEGOCIACAO_PRECO',
      somenteLeitura: true,
      edicao: false
    }
  }, {
    path: 'detalhes/negociacao_preco/:id/fluxo',
    name: 'verDetalhesNegociacaoPrecoFluxo',
    component: DetalhesNegociacao,
    props: {
      tipoAcordo: 'NEGOCIACAO_PRECO',
      somenteLeitura: true,
      edicao: false,
      fluxo: true
    }
  }, {
    path: 'detalhes/negociacao_preco/:id/editar',
    name: 'editarDetalhesNegociacaoPreco',
    component: DetalhesNegociacao,
    props: {
      tipoAcordo: 'NEGOCIACAO_PRECO',
      somenteLeitura: false,
      edicao: true
    }
  }, {
    path: 'detalhes/positivacao',
    name: 'detalhesPositivacao',
    component: DetalhesNegociacao,
    props: {
      tipoAcordo: 'POSITIVACAO',
      somenteLeitura: false,
      edicao: false
    }
  }, {
    path: 'detalhes/positivacao/:id',
    name: 'verDetalhesPositivacao',
    component: DetalhesNegociacao,
    props: {
      tipoAcordo: 'POSITIVACAO',
      somenteLeitura: true,
      edicao: false
    }
  }, {
    path: 'detalhes/positivacao/:id/fluxo',
    name: 'verDetalhesPositivacaoFluxo',
    component: DetalhesNegociacao,
    props: {
      tipoAcordo: 'POSITIVACAO',
      somenteLeitura: true,
      edicao: false,
      fluxo: true
    }
  }, {
    path: 'detalhes/positivacao/:id/editar',
    name: 'editarDetalhesPositivacao',
    component: DetalhesNegociacao,
    props: {
      tipoAcordo: 'POSITIVACAO',
      somenteLeitura: false,
      edicao: true
    }
  }, {
    path: 'detalhes/crescimento',
    name: 'detalhesCrescimento',
    component: DetalhesNegociacao,
    props: {
      tipoAcordo: 'CRESCIMENTO',
      somenteLeitura: false,
      edicao: false
    }
  }, {
    path: 'detalhes/crescimento/:id',
    name: 'verDetalhesCrescimento',
    component: DetalhesNegociacao,
    props: {
      tipoAcordo: 'CRESCIMENTO',
      somenteLeitura: true,
      edicao: false
    }
  }, {
    path: 'detalhes/crescimento/:id/fluxo',
    name: 'verDetalhesCrescimentoFluxo',
    component: DetalhesNegociacao,
    props: {
      tipoAcordo: 'CRESCIMENTO',
      somenteLeitura: true,
      edicao: false,
      fluxo: true
    }
  }, {
    path: 'detalhes/crescimento/:id/editar',
    name: 'editarDetalhesCrescimento',
    component: DetalhesNegociacao,
    props: {
      tipoAcordo: 'CRESCIMENTO',
      somenteLeitura: false,
      edicao: true
    }
  }]
};

/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var Orcamento = function Orcamento() {
  return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 1668));
};
var OrcamentoList = function OrcamentoList() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1669));
};
var OrcamentoForm = function OrcamentoForm() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 1670));
};
var RateioOrcamento = function RateioOrcamento() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1671));
};

exports.default = {
  path: 'orcamento',
  component: Orcamento,
  children: [{
    path: '',
    name: 'orcamento',
    component: OrcamentoList
  }, {
    path: 'novo',
    name: 'novoOrcamento',
    component: OrcamentoForm,
    props: {
      default: false,
      somenteLeitura: false,
      copia: false,
      edicao: false,
      novo: true
    }
  }, {
    path: ':id',
    name: 'verOrcamento',
    component: OrcamentoForm,
    props: {
      default: true,
      somenteLeitura: true,
      copia: false,
      edicao: false,
      novo: false,
      fluxo: false
    }
  }, {
    path: ':id/fluxo',
    name: 'verOrcamentoFluxo',
    component: OrcamentoForm,
    props: {
      default: true,
      somenteLeitura: true,
      copia: false,
      edicao: false,
      novo: false,
      fluxo: true
    }
  }, {
    path: ':id/editar',
    name: 'editarOrcamento',
    component: OrcamentoForm,
    props: {
      default: true,
      somenteLeitura: false,
      copia: false,
      edicao: true,
      novo: false
    }
  }, {
    path: ':id/copiar',
    name: 'copiarOrcamento',
    component: OrcamentoForm,
    props: {
      default: true,
      somenteLeitura: false,
      copia: true,
      edicao: false,
      novo: false
    }
  }, {
    path: ':id/rateio',
    name: 'rateioOrcamento',
    component: RateioOrcamento,
    props: {
      default: true,
      somenteLeitura: false,
      copia: false,
      edicao: true,
      novo: false
    }
  }]
};

/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Produto = __webpack_require__(1444);

var _Produto2 = _interopRequireDefault(_Produto);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProdutoList = function ProdutoList() {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 1672));
};
var ProdutoForm = function ProdutoForm() {
  return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 1673));
};

exports.default = {
  path: 'produto',
  component: _Produto2.default,
  children: [{
    path: '',
    name: 'produto',
    component: ProdutoList
  }, {
    path: 'novo',
    name: 'novoProduto',
    component: ProdutoForm,
    props: {
      default: false,
      somenteLeitura: false,
      copia: false
    }
  }, {
    path: ':id',
    name: 'verProduto',
    component: ProdutoForm,
    props: {
      default: true,
      somenteLeitura: true,
      copia: false
    }
  }, {
    path: ':id/editar',
    name: 'editarProduto',
    component: ProdutoForm,
    props: {
      default: true,
      somenteLeitura: false,
      copia: false
    }
  }]
};

/***/ }),
/* 1444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Produto_vue_vue_type_template_id_71b9c325___ = __webpack_require__(1445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__Produto_vue_vue_type_template_id_71b9c325___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Produto_vue_vue_type_template_id_71b9c325___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Produto_vue_vue_type_template_id_71b9c325___ = __webpack_require__(1446);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Produto_vue_vue_type_template_id_71b9c325___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Produto_vue_vue_type_template_id_71b9c325___["b"]; });


/***/ }),
/* 1446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c('router-view')],1)}
var staticRenderFns = []



/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var Pagamento = function Pagamento() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 1674));
};

exports.default = {
  path: 'pagamento',
  name: 'pagamento',
  component: Pagamento
};

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RegiaoCadastro = __webpack_require__(1449);

var _RegiaoCadastro2 = _interopRequireDefault(_RegiaoCadastro);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  path: 'regiao',
  name: 'regiao',
  component: _RegiaoCadastro2.default
};

/***/ }),
/* 1449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RegiaoCadastro_vue_vue_type_template_id_36c1a100_lang_html___ = __webpack_require__(1450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RegiaoCadastro_vue_vue_type_script_lang_js___ = __webpack_require__(600);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__RegiaoCadastro_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__RegiaoCadastro_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__RegiaoCadastro_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__RegiaoCadastro_vue_vue_type_template_id_36c1a100_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__RegiaoCadastro_vue_vue_type_template_id_36c1a100_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_RegiaoCadastro_vue_vue_type_template_id_36c1a100_lang_html___ = __webpack_require__(1451);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_RegiaoCadastro_vue_vue_type_template_id_36c1a100_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_RegiaoCadastro_vue_vue_type_template_id_36c1a100_lang_html___["b"]; });


/***/ }),
/* 1451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canAccessPage)?_c('div',{staticClass:"CRUDGenerico__Wrapper"},[_c('v-row',[(!_vm.somenteLeitura)?_c('v-col',{attrs:{"cols":"12","sm":"3"}},[_c('regiao-form',{ref:"regiaoForm",on:{"FORMULARIO_CADASTRO_REGIAO_SALVAR":_vm.onNovoRegiao,"FORMULARIO_CADASTRO_REGIAO_CANCELAR":_vm.onCancelar}})],1):_vm._e(),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","md":_vm.somenteLeitura ? 12 : 9}},[_c('regiao-tabela',{ref:"regiaoTabela",staticClass:"CRUDGenerico__ContentTable",attrs:{"title":_vm.$tc('label.regiao', 2)},on:{"TABELA_EXPORTAR_DADOS":_vm.requestExportacao,"PESQUISA_REGIAO_EDITAR":_vm.onEditarRegiao}})],1)],1)],1):_vm._e()}
var staticRenderFns = []



/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _exportacoes = __webpack_require__(39);

var _exportacoes2 = _interopRequireDefault(_exportacoes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function exportarFiltros(filtros, cb, contexto, nomeExportador, limit, timeout) {
  var resource = (0, _exportacoes2.default)(contexto.$http, timeout);
  resource.download(nomeExportador, {
    limit: limit,
    parametrosConsulta: filtros
  }).then(function () {
    if (cb) {
      cb();
    }
    contexto.$toast.create(contexto.$t('message.exportacao_download'), 'snack', 3E3);
  }).catch(function () {
    if (cb) {
      cb();
    }
    contexto.$toast.create('Erro ao exportar. Tente novamente.', 'snack', 3E3);
  });
}

exports.default = {
  exportar: function exportar(cb, nomeExportador, contexto) {
    var parametros = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var limit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 500;
    var timeout = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 120000;

    exportarFiltros(parametros, cb, contexto, nomeExportador, limit, timeout);
  }
};

/***/ }),
/* 1453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RegiaoForm_vue_vue_type_template_id_6a4478ad_lang_html___ = __webpack_require__(1454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RegiaoForm_vue_vue_type_script_lang_js___ = __webpack_require__(602);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__RegiaoForm_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__RegiaoForm_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__RegiaoForm_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__RegiaoForm_vue_vue_type_template_id_6a4478ad_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__RegiaoForm_vue_vue_type_template_id_6a4478ad_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_RegiaoForm_vue_vue_type_template_id_6a4478ad_lang_html___ = __webpack_require__(1455);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_RegiaoForm_vue_vue_type_template_id_6a4478ad_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_RegiaoForm_vue_vue_type_template_id_6a4478ad_lang_html___["b"]; });


/***/ }),
/* 1455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{ref:"form",attrs:{"lazy-validation":""}},[_c('v-card',{staticClass:"card-size"},[_c('v-card-title',[_vm._v(_vm._s(_vm.regiao.ehEdicao() ? _vm.$t('title.editar_regiao') : _vm.$t('title.cadastrar_nova_regiao')))]),_vm._v(" "),_c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-text-field',{staticClass:"Form-text__invalid",attrs:{"id":"regiao_code","name":"regiao_code","label":((_vm.$t('label.cod_regiao')) + " *"),"counter":50,"maxlength":"50","rules":[_vm.rules.required]},model:{value:(_vm.regiao.codRegiao),callback:function ($$v) {_vm.$set(_vm.regiao, "codRegiao", $$v)},expression:"regiao.codRegiao"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12"}},[_c('v-text-field',{staticClass:"Form-text__invalid",attrs:{"id":"regiao_name","name":"regiao_name","label":((_vm.$t('label.nome')) + " *"),"counter":50,"maxlength":"50","rules":[_vm.rules.required]},model:{value:(_vm.regiao.nomRegiao),callback:function ($$v) {_vm.$set(_vm.regiao, "nomRegiao", $$v)},expression:"regiao.nomRegiao"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{nativeOn:{"click":function($event){return _vm.cancel($event)}}},[_vm._v(_vm._s(_vm.$t('label.cancelar')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.openSaveDialog($event)}}},[_vm._v(_vm._s(_vm.$t('label.salvar')))])],1)],1),_vm._v(" "),_c('confirm',{ref:"confirmDialog",attrs:{"message":_vm.dialog.content,"persistent":true},on:{"agree":function($event){return _vm.save()}}})],1)}
var staticRenderFns = []



/***/ }),
/* 1456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RegiaoTabela_vue_vue_type_template_id_322b8d14_lang_html___ = __webpack_require__(1457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RegiaoTabela_vue_vue_type_script_lang_js___ = __webpack_require__(605);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__RegiaoTabela_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__RegiaoTabela_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__RegiaoTabela_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__RegiaoTabela_vue_vue_type_template_id_322b8d14_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__RegiaoTabela_vue_vue_type_template_id_322b8d14_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_RegiaoTabela_vue_vue_type_template_id_322b8d14_lang_html___ = __webpack_require__(1458);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_RegiaoTabela_vue_vue_type_template_id_322b8d14_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_RegiaoTabela_vue_vue_type_template_id_322b8d14_lang_html___["b"]; });


/***/ }),
/* 1458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"card-size"},[_c('v-card-title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('v-container',{staticClass:"py-0",attrs:{"fluid":""}},[_c('v-row',[_c('v-spacer'),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({directives:[{name:"show",rawName:"v-show",value:(_vm.canAccessCRUD && _vm.selected.length > 0),expression:"canAccessCRUD && selected.length > 0"}],staticClass:"mx-0 mt-5",attrs:{"icon":"","id":"tipo-investimento-botao-ativar-inativar"},on:{"click":_vm.ativarInativarRegistros}},on),[_c('v-icon',[_vm._v("block")])],1)]}}])},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.ativar_inativa')))])]),_vm._v(" "),(_vm.canAccessCRUD)?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"mx-0 mt-5",attrs:{"id":"btn_exportar","icon":"","disabled":_vm.bloquearBotaoExportacao},on:{"click":function($event){return _vm.exportar()}}},on),[_c('v-icon',[_vm._v("get_app")])],1)]}}],null,false,518359774)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.exportar')))])]):_vm._e(),_vm._v(" "),_c('v-col',{staticClass:"mr-3 py-0",attrs:{"cols":"12","sm":"6","md":"3"}},[_c('v-text-field',{attrs:{"append-icon":"search","label":_vm.$t('label.pesquisar'),"single-line":"","clearable":"","hide-details":""},on:{"input":_vm.filtrar},model:{value:(_vm.searchQuery),callback:function ($$v) {_vm.searchQuery=$$v},expression:"searchQuery"}})],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.regioes,"show-select":"","item-key":"id","options":_vm.pagination,"server-items-length":_vm.totalPage,"no-data-text":_vm.$t('label.tabela_sem_conteudo'),"footer-props":{
        itemsPerPageOptions: [10, 25, 50],
      }},on:{"update:options":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"item.cod_regiao",fn:function(ref){
      var item = ref.item;
return [_vm._v("\n        "+_vm._s(item.codRegiao)+"\n      ")]}},{key:"item.nom_regiao",fn:function(ref){
      var item = ref.item;
return [_vm._v("\n        "+_vm._s(item.nomRegiao)+"\n      ")]}},{key:"item.ind_ativo",fn:function(ref){
      var item = ref.item;
return [_vm._v("\n        "+_vm._s(item.indAtivo ? _vm.$t('label.sim') : _vm.$t('label.nao'))+"\n      ")]}},{key:"item.acoes",fn:function(ref){
      var item = ref.item;
return [(!_vm.somenteLeitura)?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
      var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();return _vm.onEditarRegiao(item)}}},on),[_c('v-icon',[_vm._v("edit")])],1)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.editar')))])]):_vm._e()]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SSO = __webpack_require__(1460);

var _SSO2 = _interopRequireDefault(_SSO);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GrupoForm = function GrupoForm() {
  return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 1675));
};
var GrupoList = function GrupoList() {
  return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 1676));
};

exports.default = {
  path: 'sso-grupo',
  component: _SSO2.default,
  children: [{
    path: '',
    name: 'sso-grupo',
    component: GrupoList
  }, {
    path: 'novo',
    name: 'novoGrupo',
    component: GrupoForm,
    props: {
      somenteLeitura: false
    }
  }, {
    path: ':id',
    name: 'verGrupo',
    component: GrupoForm,
    props: {
      somenteLeitura: true
    }
  }, {
    path: ':id/editar',
    name: 'editarGrupo',
    component: GrupoForm,
    props: {
      somenteLeitura: false
    }
  }]
};

/***/ }),
/* 1460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SSO_vue_vue_type_template_id_26b354ee___ = __webpack_require__(1461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__SSO_vue_vue_type_template_id_26b354ee___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__SSO_vue_vue_type_template_id_26b354ee___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SSO_vue_vue_type_template_id_26b354ee___ = __webpack_require__(1462);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SSO_vue_vue_type_template_id_26b354ee___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SSO_vue_vue_type_template_id_26b354ee___["b"]; });


/***/ }),
/* 1462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c('router-view')],1)}
var staticRenderFns = []



/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SSO = __webpack_require__(1464);

var _SSO2 = _interopRequireDefault(_SSO);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UsuarioForm = function UsuarioForm() {
  return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 1677));
};
var UsuarioList = function UsuarioList() {
  return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 1678));
};

exports.default = {
  path: 'sso-usuario',
  component: _SSO2.default,
  children: [{
    path: '',
    name: 'sso-usuario',
    component: UsuarioList
  }, {
    path: 'novo',
    name: 'novoUsuarioSSO',
    component: UsuarioForm
  }, {
    path: ':id/editar',
    name: 'editarUsuarioSSO',
    component: UsuarioForm
  }]
};

/***/ }),
/* 1464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SSO_vue_vue_type_template_id_69446e28___ = __webpack_require__(1465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__SSO_vue_vue_type_template_id_69446e28___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__SSO_vue_vue_type_template_id_69446e28___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SSO_vue_vue_type_template_id_69446e28___ = __webpack_require__(1466);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SSO_vue_vue_type_template_id_69446e28___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SSO_vue_vue_type_template_id_69446e28___["b"]; });


/***/ }),
/* 1466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SellIn = __webpack_require__(1468);

var _SellIn2 = _interopRequireDefault(_SellIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  path: 'sellin',
  name: 'sellin',
  component: _SellIn2.default
};

/***/ }),
/* 1468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SellIn_vue_vue_type_template_id_4ba2f2a8_lang_html___ = __webpack_require__(1469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SellIn_vue_vue_type_script_lang_js___ = __webpack_require__(607);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__SellIn_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__SellIn_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SellIn_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(1481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__SellIn_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__SellIn_vue_vue_type_template_id_4ba2f2a8_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__SellIn_vue_vue_type_template_id_4ba2f2a8_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SellIn_vue_vue_type_template_id_4ba2f2a8_lang_html___ = __webpack_require__(1470);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SellIn_vue_vue_type_template_id_4ba2f2a8_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SellIn_vue_vue_type_template_id_4ba2f2a8_lang_html___["b"]; });


/***/ }),
/* 1470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CRUDGenerico__Wrapper elevation-1 md-card"},[(_vm.canAccessPage)?_c('md-layout',{staticClass:"md-gutter-16",attrs:{"md-row":""}},[_c('md-tabs',{staticClass:"md-transparent CRUDGenerico__TableWrapper",attrs:{"md-flex":"","md-fixed":""}},[_c('md-tab',{attrs:{"id":"consolidado","md-label":"Consolidado","md-active":!_vm.tabelaDetalhadoAtiva}},[_c('md-layout',{attrs:{"md-gutter":"16"}},[(_vm.canImport)?_c('md-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.importacaoVisivel),expression:"importacaoVisivel"}],staticClass:"SellIn__SideMenu md-hide-medium",attrs:{"md-column":""}},[_c('importacao-lateral',{attrs:{"exibe-cancelar":true},on:{"IMPORTACAO_LATERACAO_CANCELAR":_vm.toggleImportacao}})],1):_vm._e(),_vm._v(" "),_c('md-layout',{attrs:{"md-column":""}},[_c('conteudo-sell-in-consolidado',{staticClass:"CRUDGenerico__ContentTable",attrs:{"title":"Sell In Consolidado","registros":_vm.tableRowsConsolidado,"paginas":_vm.paginasConsolidado,"table-header":_vm.tableHeaderConsolidado,"carregando":_vm.carregandoConsolidado},on:{"TABELA_BUSCAR_PROXIMA_PAGINA":_vm.requestPopularConsolidado,"TABELAGENERICA_BUSCAR_PROXIMA_PAGINA":_vm.requestPopularConsolidadoFiltro,"TABELAGENERICA_ORDENAR":_vm.organizarConsolidado,"TABELAGENERICA_EXPORTAR_DADOS":_vm.requestExportacao,"SELLINTABELACONSOLIDADO_DETALHAR":_vm.detalharConsolidado,"SELLINTABELACONSOLIDADO_TOGGLE_IMPORTACAO":_vm.toggleImportacao}})],1)],1)],1),_vm._v(" "),_c('md-tab',{attrs:{"id":"detalhado","md-label":"Detalhado","md-disabled":!_vm.tabelaDetalhadoAtiva,"md-active":_vm.tabelaDetalhadoAtiva}},[_c('conteudo-sell-in-detalhado',{staticClass:"CRUDGenerico__ContentTable",attrs:{"title":"Sell In Detalhado","table-rows":_vm.tableRowsDetalhado,"table-header":_vm.tableHeaderDetalhado,"visible-columns":['competencia', 'numeronotafiscal', 'nomecliente', 'seqitem', 'nomeproduto','quantidadeproduto','unidademedida','valorunitario', 'valortotal', 'valorliquido', 'aliquota', 'impostos'],"numeric-columns":['numeronotafiscal', 'quantidadeproduto', 'valorunitario', 'valortotal', 'valorliquido', 'aliquota','impostos'],"mobile-invisible-columns":['id', 'unidademedida', 'quantidadeproduto', 'valorunitario', 'valorliquido', 'aliquota', 'impostos'],"ignore-columns":['id'],"isExportAvailable":false,"isSearchAvailable":true,"isPaginationAvailable":false},on:{"TABELAGENERICA_EXPORTAR_DADOS":_vm.requestExportacao,"TABELAGENERICA_ORDENAR":_vm.organizarDetalhado,"SELLINTABELACONSOLIDADO_EXIBIR":_vm.exibirTabConsolidado,"SELLINTABELADETALHADO_BUSCA":_vm.detalhadoBusca}})],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []



/***/ }),
/* 1471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SellInLateral_vue_vue_type_template_id_0c31f49e_lang_html___ = __webpack_require__(1472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SellInLateral_vue_vue_type_script_lang_js___ = __webpack_require__(609);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__SellInLateral_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__SellInLateral_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SellInLateral_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(1474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__SellInLateral_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__SellInLateral_vue_vue_type_template_id_0c31f49e_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__SellInLateral_vue_vue_type_template_id_0c31f49e_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SellInLateral_vue_vue_type_template_id_0c31f49e_lang_html___ = __webpack_require__(1473);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SellInLateral_vue_vue_type_template_id_0c31f49e_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SellInLateral_vue_vue_type_template_id_0c31f49e_lang_html___["b"]; });


/***/ }),
/* 1473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-card',[_c('md-card-header',[_c('div',{staticClass:"md-title"},[_vm._v(_vm._s(_vm.$t('title.importar_arquivo')))])]),_vm._v(" "),_c('div',{staticClass:"SellInLateral__div"},[_c('md-layout',{staticStyle:{"padding-left":"15px"},attrs:{"md-gutter":"16","md-column":"","md-align":"center"}},[_c('md-layout',{attrs:{"md-flex-xsmall":"95","md-flex-small":"95","md-flex-medium":"40","md-flex-large":"40","md-flex-xlarge":"40"}},[_c('input-datepicker',{staticStyle:{"width":"100%"},attrs:{"label":_vm.$t('label.data_inicio'),"format":"DD-MM-YYYY","dateIsClicked":true,"validate:":"false"},on:{"INPUTDATEPICKER_FORMATTED_DATE":_vm.dataInicialFormatada},model:{value:(_vm.dataInicio),callback:function ($$v) {_vm.dataInicio=$$v},expression:"dataInicio"}})],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"95","md-flex-small":"95","md-flex-medium":"40","md-flex-large":"40","md-flex-xlarge":"40"}},[_c('input-datepicker',{staticStyle:{"width":"100%"},attrs:{"label":_vm.$t('label.data_fim'),"format":"DD-MM-YYYY","dateIsClicked":true,"validate:":"false"},on:{"INPUTDATEPICKER_FORMATTED_DATE":_vm.dataFimFormatada},model:{value:(_vm.dataFim),callback:function ($$v) {_vm.dataFim=$$v},expression:"dataFim"}})],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"position":"relative","min-height":"220px","min-width":"352px"}},[(_vm.showImport)?_c('upload-file',{staticClass:"md-hide-medium",attrs:{"name":"sellin-lateral-upload","accepted-file-types":_vm.tipoImportacao.arquivosSuportados,"id":_vm.uploadFileDropzoneId,"url":_vm.importUrl},on:{"UPLOADFILE_SUCCESS":_vm.uploadSuccess,"UPLOADFILE_ERROR":_vm.uploadError,"UPLOADFILE_SENDING":_vm.enviandoArquivo}}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showImport),expression:"!showImport"}],staticClass:"ImportacaoLateral__BlockDropzone",class:{
        'ImportacaoLateralSellin__BlockDropzone--active':!_vm.showImport,
        'ImportacaoLateralSellin__BlockDropzone--deactive': _vm.showImport,
      }},[_c('h4',[_vm._v(_vm._s(_vm.$t('label.escolha_periodo_importacao')))])])],1),_vm._v(" "),_c('md-card-actions',[(_vm.exibeCancelar)?_c('md-button',{staticClass:"md-accent",attrs:{"id":"importacaoLateral-dialog-button-cancel"},nativeOn:{"click":function($event){return _vm.cancelarImportacao()}}},[_vm._v("\n      "+_vm._s(_vm.$t('label.cancelar'))+"\n    ")]):_vm._e()],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SellInLateral_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SellInLateral_vue_vue_type_style_index_0_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SellInLateral_vue_vue_type_style_index_0_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SellInLateral_vue_vue_type_style_index_0_lang_css____default.a); 

/***/ }),
/* 1475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SellinTabelaConsolidado_vue_vue_type_template_id_470c1742_lang_html___ = __webpack_require__(1476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SellinTabelaConsolidado_vue_vue_type_script_lang_js___ = __webpack_require__(612);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__SellinTabelaConsolidado_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__SellinTabelaConsolidado_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_generico_TabelaGenerica_css_vue_type_style_index_0_lang_css___ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_generico_Pagination_css_vue_type_style_index_1_lang_css___ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_components_generico_TabelaSizing_css_vue_type_style_index_2_lang_css___ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);








/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_5__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__SellinTabelaConsolidado_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__SellinTabelaConsolidado_vue_vue_type_template_id_470c1742_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__SellinTabelaConsolidado_vue_vue_type_template_id_470c1742_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SellinTabelaConsolidado_vue_vue_type_template_id_470c1742_lang_html___ = __webpack_require__(1477);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SellinTabelaConsolidado_vue_vue_type_template_id_470c1742_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SellinTabelaConsolidado_vue_vue_type_template_id_470c1742_lang_html___["b"]; });


/***/ }),
/* 1477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('md-dialog',{ref:"modalExportacao"},[_c('md-dialog-title',[_vm._v("\n      "+_vm._s(_vm.$t('label.exportar_conteudo'))+"\n    ")]),_vm._v(" "),_c('md-dialog-content',[_c('md-input-container',[_c('label',{attrs:{"for":"modalExportaca-competencia"}},[_vm._v(_vm._s(_vm.$t('label.competencia')))]),_vm._v(" "),_c('md-autocomplete',{attrs:{"id":"modalExportaca-competencia","tabindex":"6","maxlength":"7","fetch":_vm.buscarPeriodos,"printAttribute":"mesAno","prepareResponseData":_vm.prepareResponseData,"queryParam":"anoMes"},on:{"selected":_vm.setCompetenciaExportacao},model:{value:(_vm.competenciaExportacao),callback:function ($$v) {_vm.competenciaExportacao=$$v},expression:"competenciaExportacao"}}),_vm._v(" "),_c('md-icon',{staticStyle:{"cursor":"pointer"},attrs:{"md-autocomplete-search":""}},[_vm._v("search")])],1)],1),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",nativeOn:{"click":function($event){return _vm.fechaModalExportacao($event)}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.cancelar'))+"\n      ")]),_vm._v(" "),_c('md-button',{staticClass:"md-accent md-raised",attrs:{"disabled":_vm.competenciaExportacao === null},nativeOn:{"click":function($event){return _vm.exportarSellIn($event)}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.exportar'))+"\n      ")])],1)],1),_vm._v(" "),_c('md-table-card',[_c('md-toolbar',[_c('h1',{staticClass:"md-title",domProps:{"textContent":_vm._s(_vm.title)}}),_vm._v(" "),_c('md-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.canImport),expression:"canImport"}],staticClass:"md-icon-button",attrs:{"id":"sellin-tabelaConsolidado-button-import","disabled":_vm.blockExportButton},nativeOn:{"click":function($event){return _vm.toggleImportacao($event)}}},[_c('md-icon',[_vm._v("file_upload")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"top"}},[_vm._v(_vm._s(_vm.$t('label.importar_conteudo')))])],1),_vm._v(" "),_c('md-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isExportAvailable && _vm.canExport),expression:"isExportAvailable && canExport"}],staticClass:"md-icon-button",attrs:{"id":"sellin-tabelaConsolidado-button-export","disabled":_vm.blockExportButton},nativeOn:{"click":function($event){return _vm.$refs.modalExportacao.open()}}},[_c('md-icon',[_vm._v("get_app")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"top"}},[_vm._v(_vm._s(_vm.$t('label.exportar_conteudo')))])],1),_vm._v(" "),_c('md-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSearchAvailable),expression:"isSearchAvailable"}],staticClass:"md-icon-button",attrs:{"id":"sellin-tabelaConsolidado-button-search"},nativeOn:{"click":function($event){return _vm.focusSearchInput('sellin-tabelaConsolidado-input-search')}}},[_c('md-icon',[_vm._v("search")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"top"}},[_vm._v(_vm._s(_vm.$t('label.buscar')))])],1),_vm._v(" "),(_vm.openSearchToolbar)?_c('div',{staticClass:"TabelaGenerica__SearchWrapper",class:{
          'TabelaGenerica__SearchWrapper--active': _vm.openSearchToolbar,
        }},[_c('md-input-container',{staticClass:"TabelaGenerica__SearchInput md-accent"},[_c('label',[_vm._v(_vm._s(_vm.$t('label.buscar')))]),_vm._v(" "),_c('md-input',{attrs:{"autoFocus":"true","id":"sellin-tabelaConsolidado-input-search","type":"text"},model:{value:(_vm.searchQuery),callback:function ($$v) {_vm.searchQuery=$$v},expression:"searchQuery"}}),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",attrs:{"id":"sellin-tabelaConsolidado-button-search-close"},nativeOn:{"click":function($event){return _vm.closeSearchHeader($event)}}},[_c('md-icon',[_vm._v("close")])],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"TabelaGenerica__TableWrapper"},[_c('md-table',{ref:"myTable",staticClass:"TabelaGenerica__Table",attrs:{"md-sort":_vm.sortData.name,"md-sort-type":_vm.sortData.type},on:{"sort":_vm.onSort}},[_c('md-table-header',[_c('md-table-row',_vm._l((_vm.tableHeader),function(head,index){return _c('md-table-head',{key:index,class:head.classes,attrs:{"id":("sellin-tabelaConsolidado-head-" + index),"md-tooltip":head.tooltip,"md-sort-by":head.sortType}},[_vm._v("\n              "+_vm._s(head.name)+"\n            ")])}),1)],1),_vm._v(" "),_c('md-table-body',_vm._l((_vm.registros),function(row,rowIndex){return _c('md-table-row',{key:rowIndex,nativeOn:{"click":function($event){return _vm.detalharConsolidado(row)}}},[_c('md-table-cell',{key:'competencia'},[_c('span',[_vm._v(_vm._s(row.competencia))])]),_vm._v(" "),_c('md-table-cell',{key:'nomecliente'},[_c('span',[_vm._v(_vm._s(row.nomecliente))])]),_vm._v(" "),_c('md-table-cell',{key:'numeronotafiscal'},[_c('span',[_vm._v(_vm._s(row.numeronotafiscal))])]),_vm._v(" "),_c('md-table-cell',{key:'quantidadeprodutos'},[_c('span',[_vm._v(_vm._s(_vm.formatDecimal(row.quantidadeprodutos)))])]),_vm._v(" "),_c('md-table-cell',{key:'valortotal'},[_c('span',[_vm._v(_vm._s(_vm.getMoney(row.valortotal)))])]),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button"},[_c('md-icon',[_vm._v("arrow_forward")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"top"}},[_vm._v(_vm._s(_vm.$t('title.sellin_detalhado')))])],1)],1)}),1)],1),_vm._v(" "),(!_vm.carregando)?_c('paginate',{directives:[{name:"show",rawName:"v-show",value:(_vm.possuiRegistros && _vm.paginas > 1),expression:"possuiRegistros && paginas > 1"}],attrs:{"page-count":_vm.paginas,"click-handler":_vm.clickHandler,"initial-page":_vm.indexPagina,"prev-text":_vm.$tc('label.anterior', 1),"next-text":_vm.$tc('label.proximo', 1),"container-class":'pagination'}}):_vm._e(),_vm._v(" "),_c('h4',{directives:[{name:"show",rawName:"v-show",value:(!_vm.possuiRegistros && !_vm.carregando),expression:"!possuiRegistros && !carregando"}],staticClass:"TabelaGenerica__NoContent"},[_vm._v("\n          "+_vm._s(_vm.$t('label.tabela_sem_conteudo'))+"\n      ")])],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SellinTabelaDetalhado_vue_vue_type_template_id_1e548a68_lang_html___ = __webpack_require__(1479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SellinTabelaDetalhado_vue_vue_type_script_lang_js___ = __webpack_require__(614);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__SellinTabelaDetalhado_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__SellinTabelaDetalhado_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__SellinTabelaDetalhado_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__SellinTabelaDetalhado_vue_vue_type_template_id_1e548a68_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__SellinTabelaDetalhado_vue_vue_type_template_id_1e548a68_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SellinTabelaDetalhado_vue_vue_type_template_id_1e548a68_lang_html___ = __webpack_require__(1480);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SellinTabelaDetalhado_vue_vue_type_template_id_1e548a68_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SellinTabelaDetalhado_vue_vue_type_template_id_1e548a68_lang_html___["b"]; });


/***/ }),
/* 1480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"tabindex":"100"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.preventDefault();return _vm.onArrowUpPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.preventDefault();return _vm.onArrowDownPress($event)}]}},[_c('md-dialog',{ref:_vm.dialog.ref,attrs:{"md-open-from":("#" + (_vm.dialog.from))}},[_c('md-dialog-title',[_vm._v(_vm._s(_vm.dialog.title))]),_vm._v(" "),_c('md-dialog-content',[_vm._v(_vm._s(_vm.dialog.content))]),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",attrs:{"id":"sellin-tabelaDetalhado-button-cancel"},nativeOn:{"click":function($event){return _vm.closeDialog('dialog1')}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.cancelar'))+"\n      ")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary",attrs:{"id":"sellin-tabelaDetalhado-button-save"},nativeOn:{"click":function($event){return _vm.closeDialog('dialog1', _vm.dialog.action)}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.sim'))+"\n      ")])],1)],1),_vm._v(" "),(_vm.isHeaderAvailable)?_c('md-table-card',[_c('md-toolbar',[_c('md-button',{staticClass:"md-icon-button",attrs:{"id":"sellin-tabelaDetalhado-button-back"},nativeOn:{"click":function($event){return _vm.retornarSellInConsolidado($event)}}},[_c('md-icon',[_vm._v("arrow_back")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"top"}},[_vm._v(_vm._s(_vm.$t('title.sellin_consolidado')))])],1),_vm._v(" "),_c('h1',{staticClass:"md-title",domProps:{"textContent":_vm._s(_vm.title)}}),_vm._v(" "),_c('md-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isExportAvailable && _vm.canExport),expression:"isExportAvailable && canExport"}],staticClass:"md-icon-button",attrs:{"id":"sellin-tabelaDetalhado-button-export","disabled":_vm.blockExportButton},nativeOn:{"click":function($event){return _vm.exportData($event)}}},[_c('md-icon',[_vm._v("get_app")])],1),_vm._v(" "),_c('md-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSearchAvailable),expression:"isSearchAvailable"}],staticClass:"md-icon-button",attrs:{"id":"sellin-tabelaDetalhado-button-search"},nativeOn:{"click":function($event){return _vm.focusSearchInput('sellin-tabelaDetalhado-input-search')}}},[_c('md-icon',[_vm._v("search")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"top"}},[_vm._v(_vm._s(_vm.$t('label.buscar')))])],1),_vm._v(" "),(_vm.isPaginationAvailable)?_c('md-select',{staticClass:"TabelaGenerica__Filters__Select md-hide-medium",attrs:{"md-menu-class":"md-pagination-select","id":"sellin-tabelaDetalhado-button-select"},model:{value:(_vm.paginationSize),callback:function ($$v) {_vm.paginationSize=$$v},expression:"paginationSize"}},[_c('md-option',{attrs:{"value":5}},[_vm._v("Buscar por 05 itens")]),_vm._v(" "),_c('md-option',{attrs:{"value":10}},[_vm._v("Buscar por 10 itens")]),_vm._v(" "),_c('md-option',{attrs:{"value":15}},[_vm._v("Buscar por 15 itens")]),_vm._v(" "),_c('md-option',{attrs:{"value":20}},[_vm._v("Buscar por 20 itens")]),_vm._v(" "),_c('md-option',{attrs:{"value":50}},[_vm._v("Buscar por 50 itens")])],1):_vm._e(),_vm._v(" "),(_vm.openSearchToolbar)?_c('div',{staticClass:"TabelaGenerica__SearchWrapper",class:{
          'TabelaGenerica__SearchWrapper--active': _vm.openSearchToolbar,
        }},[_c('md-input-container',{staticClass:"TabelaGenerica__SearchInput md-accent"},[_c('label',[_vm._v("Buscar")]),_vm._v(" "),_c('md-input',{attrs:{"autoFocus":"true","id":"sellin-tabelaDetalhado-input-search","type":"text"},model:{value:(_vm.searchQuery),callback:function ($$v) {_vm.searchQuery=$$v},expression:"searchQuery"}}),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",attrs:{"id":"sellin-tabelaDetalhado-button-search-close"},nativeOn:{"click":function($event){return _vm.closeSearchHeader($event)}}},[_c('md-icon',[_vm._v("close")])],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"TabelaGenerica__TableWrapper"},[_c('md-table',{ref:"myTable",staticClass:"TabelaGenerica__Table",attrs:{"md-sort":_vm.sortData.name,"md-sort-type":_vm.sortData.type},on:{"select":_vm.onSelect,"sort":_vm.onSort}},[(_vm.isHeaderAvailable)?_c('md-table-header',[_c('md-table-row',_vm._l((_vm.tableHeader),function(head,index){return _c('md-table-head',{key:index,class:head.classes,attrs:{"id":("sellin-tabelaDetalhado-head-" + index),"md-tooltip":head.tooltip,"md-sort-by":head.sortType}},[_vm._v("\n              "+_vm._s(head.name)+"\n            ")])}),1)],1):_vm._e(),_vm._v(" "),(_vm.isContentAvailable)?_c('md-table-body',{attrs:{"tabindex":"110"}},[_vm._l((_vm.tableData),function(row,rowIndex){return _c('md-table-row',{key:rowIndex,class:{
              'TabelaGenerica__TableRow--highlight': _vm.currentEditItem && _vm.currentEditItem === row,
              'TabelaGenerica__TableRow--disabled': false,
            },attrs:{"md-item":row}},[(_vm.isColumnVisible('competencia'))?_c('md-table-cell',{key:'competencia',class:{
                'md-hide-medium': _vm.hideOnMedium('competencia'),
              },attrs:{"md-numeric":_vm.isNumericField('competencia')},nativeOn:{"mouseover":function($event){return _vm.onCelMouseEnter(row, 'competencia')},"mouseleave":function($event){return _vm.onCelMouseLeave($event)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onKeyEscPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateItem(row, rowIndex, 'competencia')}]}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'competencia')),expression:"!(currentEditItem && currentEditItem === row && currentColumn === 'competencia')"}]},[_vm._v("\n                   "+_vm._s(row.competencia)+"\n              ")])]):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('numeronotafiscal'))?_c('md-table-cell',{key:'numeronotafiscal',class:{
                'md-hide-medium': _vm.hideOnMedium('numeronotafiscal'),
              },attrs:{"md-numeric":_vm.isNumericField('numeronotafiscal')},nativeOn:{"mouseover":function($event){return _vm.onCelMouseEnter(row, 'numeronotafiscal')},"mouseleave":function($event){return _vm.onCelMouseLeave($event)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onKeyEscPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateItem(row, rowIndex, 'numeronotafiscal')}]}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'numeronotafiscal')),expression:"!(currentEditItem && currentEditItem === row && currentColumn === 'numeronotafiscal')"}]},[_vm._v("\n                   "+_vm._s(row.numeronotafiscal)+"\n              ")])]):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('nomecliente'))?_c('md-table-cell',{key:'nomecliente',class:{
                'md-hide-medium': _vm.hideOnMedium('nomecliente'),
              },attrs:{"md-numeric":_vm.isNumericField('nomecliente')},nativeOn:{"mouseover":function($event){return _vm.onCelMouseEnter(row, 'nomecliente')},"mouseleave":function($event){return _vm.onCelMouseLeave($event)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onKeyEscPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateItem(row, rowIndex, 'nomecliente')}]}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'nomecliente')),expression:"!(currentEditItem && currentEditItem === row && currentColumn === 'nomecliente')"}]},[_vm._v("\n                   "+_vm._s(row.nomecliente)+"\n              ")])]):_vm._e(),_vm._v(" "),_c('md-table-cell',[_vm._v("\n              "+_vm._s(row.seqitem)+"\n            ")]),_vm._v(" "),(_vm.isColumnVisible('nomeproduto'))?_c('md-table-cell',{key:'nomeproduto',class:{
                'md-hide-medium': _vm.hideOnMedium('nomeproduto'),
              },attrs:{"md-numeric":_vm.isNumericField('nomeproduto')},nativeOn:{"mouseover":function($event){return _vm.onCelMouseEnter(row, 'nomeproduto')},"mouseleave":function($event){return _vm.onCelMouseLeave($event)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onKeyEscPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateItem(row, rowIndex, 'nomeproduto')}]}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'nomeproduto')),expression:"!(currentEditItem && currentEditItem === row && currentColumn === 'nomeproduto')"}]},[_vm._v("\n                   "+_vm._s(row.nomeproduto)+"\n              ")])]):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('unidademedida'))?_c('md-table-cell',{key:'unidademedida',class:{
                'md-hide-medium': _vm.hideOnMedium('unidademedida'),
              },attrs:{"md-numeric":_vm.isNumericField('unidademedida')},nativeOn:{"mouseover":function($event){return _vm.onCelMouseEnter(row, 'unidademedida')},"mouseleave":function($event){return _vm.onCelMouseLeave($event)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onKeyEscPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateItem(row, rowIndex, 'unidademedida')}]}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'unidademedida')),expression:"!(currentEditItem && currentEditItem === row && currentColumn === 'unidademedida')"}]},[_vm._v("\n                   "+_vm._s(row.unidademedida)+"\n              ")])]):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('quantidadeproduto'))?_c('md-table-cell',{key:'quantidadeproduto',class:{
                'md-hide-medium': _vm.hideOnMedium('quantidadeproduto'),
              },attrs:{"md-numeric":_vm.isNumericField('quantidadeproduto')},nativeOn:{"mouseover":function($event){return _vm.onCelMouseEnter(row, 'quantidadeproduto')},"mouseleave":function($event){return _vm.onCelMouseLeave($event)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onKeyEscPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateItem(row, rowIndex, 'quantidadeproduto')}]}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'quantidadeproduto')),expression:"!(currentEditItem && currentEditItem === row && currentColumn === 'quantidadeproduto')"}]},[_vm._v("\n                   "+_vm._s(_vm.formatDecimal(row.quantidadeproduto))+"\n              ")])]):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('valortotal'))?_c('md-table-cell',{key:'valortotal',class:{
                'md-hide-medium': _vm.hideOnMedium('valortotal'),
              },attrs:{"md-numeric":_vm.isNumericField('valortotal')},nativeOn:{"mouseover":function($event){return _vm.onCelMouseEnter(row, 'valortotal')},"mouseleave":function($event){return _vm.onCelMouseLeave($event)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onKeyEscPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateItem(row, rowIndex, 'valortotal')}]}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'valortotal')),expression:"!(currentEditItem && currentEditItem === row && currentColumn === 'valortotal')"}]},[_vm._v("\n                   "+_vm._s(_vm.formatCurrency(row.valortotal))+"\n              ")])]):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('valorliquido'))?_c('md-table-cell',{key:'valorliquido',class:{
                'md-hide-medium': _vm.hideOnMedium('valorliquido'),
              },attrs:{"md-numeric":_vm.isNumericField('valorliquido')},nativeOn:{"mouseover":function($event){return _vm.onCelMouseEnter(row, 'valorliquido')},"mouseleave":function($event){return _vm.onCelMouseLeave($event)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onKeyEscPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateItem(row, rowIndex, 'valorliquido')}]}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'valorliquido')),expression:"!(currentEditItem && currentEditItem === row && currentColumn === 'valorliquido')"}]},[_vm._v("\n                   "+_vm._s(_vm.formatCurrency(row.valorliquido))+"\n              ")])]):_vm._e()],1)}),_vm._v(" "),_c('infinite-loading',{ref:"infiniteLoading",attrs:{"distance":100,"on-infinite":_vm.onInfinite}},[_c('div',{attrs:{"slot":"spinner"},slot:"spinner"})])],2):_vm._e()],1),_vm._v(" "),_c('h4',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isContentAvailable),expression:"!isContentAvailable"}],staticClass:"TabelaGenerica__NoContent"},[_vm._v("\n        "+_vm._s(_vm.$t('label.tabela_sem_conteudo'))+"\n      ")]),_vm._v(" "),_c('md-spinner',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLoading),expression:"showLoading"}],staticClass:"TabelaGenerica__InterminateLoader",attrs:{"slot":"spinner","md-indeterminate":""},slot:"spinner"})],1)],1):_vm._e()],1)}
var staticRenderFns = []



/***/ }),
/* 1481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SellIn_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SellIn_vue_vue_type_style_index_0_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SellIn_vue_vue_type_style_index_0_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SellIn_vue_vue_type_style_index_0_lang_css____default.a); 

/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SellOut = __webpack_require__(1483);

var _SellOut2 = _interopRequireDefault(_SellOut);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  path: 'sellout',
  name: 'sellout',
  component: _SellOut2.default
};

/***/ }),
/* 1483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SellOut_vue_vue_type_template_id_d9fcf016_lang_html___ = __webpack_require__(1484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SellOut_vue_vue_type_script_lang_js___ = __webpack_require__(617);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__SellOut_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__SellOut_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SellOut_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(1496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__SellOut_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__SellOut_vue_vue_type_template_id_d9fcf016_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__SellOut_vue_vue_type_template_id_d9fcf016_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SellOut_vue_vue_type_template_id_d9fcf016_lang_html___ = __webpack_require__(1485);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SellOut_vue_vue_type_template_id_d9fcf016_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SellOut_vue_vue_type_template_id_d9fcf016_lang_html___["b"]; });


/***/ }),
/* 1485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CRUDGenerico__Wrapper"},[(_vm.canAccessPage)?_c('md-layout',{staticClass:"md-gutter-16",attrs:{"md-row":""}},[_c('md-tabs',{staticClass:"md-transparent CRUDGenerico__TableWrapper",attrs:{"md-flex":"","md-fixed":""}},[_c('md-tab',{attrs:{"id":"consolidado","md-label":"Consolidado","md-active":!_vm.tabelaDetalhadoAtiva}},[_c('md-layout',{attrs:{"md-gutter":"16"}},[(_vm.canImport)?_c('md-layout',{staticClass:"SellOut__SideMenu md-hide-medium",attrs:{"md-column":""}},[_c('importacao-lateral')],1):_vm._e(),_vm._v(" "),_c('md-layout',{attrs:{"md-column":""}},[_c('conteudo-sell-out-consolidado',{staticClass:"CRUDGenerico__ContentTable",attrs:{"title":"Sell Out Consolidado","table-rows":_vm.tableRowsConsolidado,"table-header":_vm.tableHeaderConsolidado,"visible-columns":['competencia', 'cnpjcliente', 'nomecliente', 'distribuidor', 'quantidadeprodutos', 'valortotal', 'valorunitario' ],"numeric-columns":['numeronotafiscal','valortotal', 'impostos'],"mobile-invisible-columns":['numeronotafiscal','quantidadeprodutos','impostos','competencia'],"ignore-columns":['idcliente']},on:{"TABELAGENERICA_BUSCAR_PROXIMA_PAGINA":_vm.requestPopularConsolidado,"TABELAGENERICA_ORDENAR":_vm.organizarConsolidado,"TABELAGENERICA_EXPORTAR_DADOS":_vm.requestExportacao,"SELLOUTTABELACONSOLIDADO_DETALHAR":_vm.detalharConsolidado}})],1)],1)],1),_vm._v(" "),_c('md-tab',{attrs:{"id":"detalhado","md-label":"Detalhado","md-disabled":!_vm.tabelaDetalhadoAtiva,"md-active":_vm.tabelaDetalhadoAtiva}},[_c('conteudo-sell-out-detalhado',{staticClass:"CRUDGenerico__ContentTable",attrs:{"title":"Sell Out Detalhado","table-rows":_vm.tableRowsDetalhado,"table-header":_vm.tableHeaderDetalhado,"visible-columns":['competencia', 'numeronotafiscal', 'cnpjloja', 'cnpjcliente', 'nomecliente', 'nomeproduto','quantidadeproduto','unidademedida','valorunitario',
            'valortotal', 'valorliquido', 'cnpjdistribuidor', 'distribuidor', 'ean'],"numeric-columns":['numeronotafiscal', 'quantidadeproduto', 'valorunitario', 'valortotal', 'valorliquido', 'aliquota','impostos'],"mobile-invisible-columns":['id', 'unidademedida', 'quantidadeproduto', 'valorunitario', 'valorliquido', 'aliquota', 'impostos'],"ignore-columns":['id'],"isExportAvailable":false,"isSearchAvailable":true,"isPaginationAvailable":false},on:{"TABELAGENERICA_EXPORTAR_DADOS":_vm.requestExportacao,"TABELAGENERICA_ORDENAR":_vm.organizarDetalhado,"SELLOUTTABELACONSOLIDADO_EXIBIR":_vm.exibirTabConsolidado,"SELLOUTTABELADETALHADO_BUSCA":_vm.detalhadoBusca}})],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []



/***/ }),
/* 1486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SellOutLateral_vue_vue_type_template_id_405637fb_lang_html___ = __webpack_require__(1487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SellOutLateral_vue_vue_type_script_lang_js___ = __webpack_require__(619);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__SellOutLateral_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__SellOutLateral_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SellOutLateral_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(1489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__SellOutLateral_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__SellOutLateral_vue_vue_type_template_id_405637fb_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__SellOutLateral_vue_vue_type_template_id_405637fb_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SellOutLateral_vue_vue_type_template_id_405637fb_lang_html___ = __webpack_require__(1488);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SellOutLateral_vue_vue_type_template_id_405637fb_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SellOutLateral_vue_vue_type_template_id_405637fb_lang_html___["b"]; });


/***/ }),
/* 1488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-card',[_c('md-card-header',[_c('div',{staticClass:"md-title"},[_vm._v(_vm._s(_vm.$t('title.importar_arquivo')))])]),_vm._v(" "),_c('div',{staticClass:"SellOutLateral__div"},[_c('md-layout',{staticStyle:{"padding-left":"15px"},attrs:{"md-gutter":"16","md-column":"","md-align":"center"}},[_c('md-layout',{attrs:{"md-flex-xsmall":"95","md-flex-small":"95","md-flex-medium":"40","md-flex-large":"40","md-flex-xlarge":"40"}},[_c('md-input-container',{class:{
            'md-input-invalid': _vm.errors.has('data_inicio'),
          }},[_c('label',[_vm._v(_vm._s(_vm.$t('label.data_inicio')))]),_vm._v(" "),_c('md-input',{directives:[{name:"validate",rawName:"v-validate"},{name:"datefull",rawName:"v-datefull"}],attrs:{"required":"","tabindex":"1","name":"data_inicio","data-vv-rules":"required|dateformat:{YYYY-MM-DD}","data-vv-name":"data_inicio"},model:{value:(_vm.dataInicio),callback:function ($$v) {_vm.dataInicio=$$v},expression:"dataInicio"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"95","md-flex-small":"95","md-flex-medium":"40","md-flex-large":"40","md-flex-xlarge":"40"}},[_c('md-input-container',{class:{
            'md-input-invalid': _vm.errors.has('data_fim'),
          }},[_c('label',[_vm._v(_vm._s(_vm.$t('label.data_fim')))]),_vm._v(" "),_c('md-input',{directives:[{name:"validate",rawName:"v-validate"},{name:"datefull",rawName:"v-datefull"}],attrs:{"required":"","tabindex":"2","name":"data_fim","data-vv-rules":"required|dateformat:{YYYY-MM-DD}","data-vv-name":"data_fim"},model:{value:(_vm.dataFim),callback:function ($$v) {_vm.dataFim=$$v},expression:"dataFim"}})],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"position":"relative","min-height":"352px","min-width":"352px"}},[(_vm.canImport && _vm.tipoImportacao && _vm.showImport)?_c('upload-file',{staticClass:"md-hide-medium",attrs:{"name":"sellout-lateral-upload","accepted-file-types":_vm.tipoImportacao.arquivosSuportados,"id":_vm.uploadFileDropzoneId,"url":_vm.importUrl},on:{"UPLOADFILE_SUCCESS":_vm.uploadSuccess,"UPLOADFILE_ERROR":_vm.uploadError,"UPLOADFILE_SENDING":_vm.enviandoArquivo}}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showImport),expression:"!showImport"}],staticClass:"ImportacaoLateral__BlockDropzone",class:{
        'ImportacaoLateral__BlockDropzone--active':!_vm.showImport,
        'ImportacaoLateral__BlockDropzone--deactive': _vm.showImport,
      }},[_c('h4',[_vm._v(_vm._s(_vm.$t('label.escolha_periodo_importacao')))])])],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SellOutLateral_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SellOutLateral_vue_vue_type_style_index_0_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SellOutLateral_vue_vue_type_style_index_0_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SellOutLateral_vue_vue_type_style_index_0_lang_css____default.a); 

/***/ }),
/* 1490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SelloutTabelaConsolidado_vue_vue_type_template_id_0f30e9b4_lang_html___ = __webpack_require__(1491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SelloutTabelaConsolidado_vue_vue_type_script_lang_js___ = __webpack_require__(622);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__SelloutTabelaConsolidado_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__SelloutTabelaConsolidado_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__SelloutTabelaConsolidado_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__SelloutTabelaConsolidado_vue_vue_type_template_id_0f30e9b4_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__SelloutTabelaConsolidado_vue_vue_type_template_id_0f30e9b4_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SelloutTabelaConsolidado_vue_vue_type_template_id_0f30e9b4_lang_html___ = __webpack_require__(1492);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SelloutTabelaConsolidado_vue_vue_type_template_id_0f30e9b4_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SelloutTabelaConsolidado_vue_vue_type_template_id_0f30e9b4_lang_html___["b"]; });


/***/ }),
/* 1492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"tabindex":"100"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.preventDefault();return _vm.onArrowUpPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.preventDefault();return _vm.onArrowDownPress($event)}]}},[_c('md-dialog',{ref:_vm.dialog.ref,attrs:{"md-open-from":("#" + (_vm.dialog.from))}},[_c('md-dialog-title',[_vm._v(_vm._s(_vm.dialog.title))]),_vm._v(" "),_c('md-dialog-content',[_vm._v(_vm._s(_vm.dialog.content))]),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",nativeOn:{"click":function($event){return _vm.closeDialog('dialog1')}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.cancelar'))+"\n      ")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary",nativeOn:{"click":function($event){return _vm.closeDialog('dialog1', _vm.dialog.action)}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.sim'))+"\n      ")])],1)],1),_vm._v(" "),(_vm.isHeaderAvailable)?_c('md-table-card',[_c('md-toolbar',[_c('h1',{staticClass:"md-title",domProps:{"textContent":_vm._s(_vm.title)}}),_vm._v(" "),_c('md-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isExportAvailable && _vm.canExport),expression:"isExportAvailable && canExport"}],staticClass:"md-icon-button",attrs:{"id":"sellout-tabelaConsolidado-button-export","disabled":_vm.blockExportButton},nativeOn:{"click":function($event){return _vm.exportData($event)}}},[_c('md-icon',[_vm._v("get_app")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"top"}},[_vm._v(_vm._s(_vm.$t('label.exportar_conteudo')))])],1),_vm._v(" "),_c('md-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSearchAvailable),expression:"isSearchAvailable"}],staticClass:"md-icon-button",attrs:{"id":"sellout-tabelaConsolidado-button-search"},nativeOn:{"click":function($event){return _vm.focusSearchInput('sellout-tabelaConsolidado-input-search')}}},[_c('md-icon',[_vm._v("search")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"top"}},[_vm._v(_vm._s(_vm.$t('label.buscar')))])],1),_vm._v(" "),(_vm.isPaginationAvailable)?_c('md-select',{staticClass:"TabelaGenerica__Filters__Select md-hide-medium",attrs:{"md-menu-class":"md-pagination-select","id":"sellout-tabelaConsolidado-select"},model:{value:(_vm.paginationSize),callback:function ($$v) {_vm.paginationSize=$$v},expression:"paginationSize"}},[_c('md-option',{attrs:{"value":5}},[_vm._v("Buscar por 05 itens")]),_vm._v(" "),_c('md-option',{attrs:{"value":10}},[_vm._v("Buscar por 10 itens")]),_vm._v(" "),_c('md-option',{attrs:{"value":15}},[_vm._v("Buscar por 15 itens")]),_vm._v(" "),_c('md-option',{attrs:{"value":20}},[_vm._v("Buscar por 20 itens")]),_vm._v(" "),_c('md-option',{attrs:{"value":50}},[_vm._v("Buscar por 50 itens")])],1):_vm._e(),_vm._v(" "),(_vm.openSearchToolbar)?_c('div',{staticClass:"TabelaGenerica__SearchWrapper",class:{
          'TabelaGenerica__SearchWrapper--active': _vm.openSearchToolbar,
        }},[_c('md-input-container',{staticClass:"TabelaGenerica__SearchInput md-accent"},[_c('label',[_vm._v(_vm._s(_vm.$t('label.buscar')))]),_vm._v(" "),_c('md-input',{attrs:{"autoFocus":"true","id":"sellout-tabelaConsolidado-input-search","type":"text"},model:{value:(_vm.searchQuery),callback:function ($$v) {_vm.searchQuery=$$v},expression:"searchQuery"}}),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",attrs:{"id":"sellout-tabelaConsolidado-button-search-close"},nativeOn:{"click":function($event){return _vm.closeSearchHeader($event)}}},[_c('md-icon',[_vm._v("close")])],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"TabelaGenerica__TableWrapper"},[_c('md-table',{ref:"myTable",staticClass:"TabelaGenerica__Table",attrs:{"md-sort":_vm.sortData.name,"md-sort-type":_vm.sortData.type},on:{"sort":_vm.onSort}},[(_vm.isHeaderAvailable)?_c('md-table-header',[_c('md-table-row',_vm._l((_vm.tableHeader),function(head,index){return _c('md-table-head',{key:index,class:head.classes,attrs:{"id":("sellout-tabelaConsolidado-head-" + index),"md-tooltip":head.tooltip,"md-sort-by":head.sortType}},[_vm._v("\n              "+_vm._s(head.name)+"\n            ")])}),1)],1):_vm._e(),_vm._v(" "),(_vm.isContentAvailable)?_c('md-table-body',{attrs:{"tabindex":"110"}},[_vm._l((_vm.tableData),function(row,rowIndex){return _c('md-table-row',{key:rowIndex,class:{
              'TabelaGenerica__TableRow--highlight': _vm.currentEditItem && _vm.currentEditItem === row,
              'TabelaGenerica__TableRow--disabled': false,
            },attrs:{"md-item":row},nativeOn:{"click":function($event){return _vm.detalharConsolidado(row)}}},[(_vm.isColumnVisible('competencia'))?_c('md-table-cell',{key:'competencia',class:{
                'md-hide-medium': _vm.hideOnMedium('competencia'),
              },attrs:{"md-numeric":_vm.isNumericField('competencia')},nativeOn:{"mouseover":function($event){return _vm.onCelMouseEnter(row, 'competencia')},"mouseleave":function($event){return _vm.onCelMouseLeave($event)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onKeyEscPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateItem(row, rowIndex, 'competencia')}]}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'competencia')),expression:"!(currentEditItem && currentEditItem === row && currentColumn === 'competencia')"}]},[_vm._v("\n                "+_vm._s(row.competencia)+"\n              ")])]):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('distribuidor'))?_c('md-table-cell',{key:'distribuidor',class:{
                'md-hide-medium': _vm.hideOnMedium('distribuidor'),
              },attrs:{"md-numeric":_vm.isNumericField('distribuidor')},nativeOn:{"mouseover":function($event){return _vm.onCelMouseEnter(row, 'distribuidor')},"mouseleave":function($event){return _vm.onCelMouseLeave($event)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onKeyEscPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateItem(row, rowIndex, 'distribuidor')}]}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'distribuidor')),expression:"!(currentEditItem && currentEditItem === row && currentColumn === 'distribuidor')"}]},[_vm._v("\n                "+_vm._s(row.distribuidor)+"\n              ")])]):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('cnpjcliente'))?_c('md-table-cell',{key:'cnpjcliente',class:{
                'md-hide-medium': _vm.hideOnMedium('cnpjcliente'),
              },attrs:{"md-numeric":_vm.isNumericField('cnpjcliente')},nativeOn:{"mouseover":function($event){return _vm.onCelMouseEnter(row, 'cnpjcliente')},"mouseleave":function($event){return _vm.onCelMouseLeave($event)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onKeyEscPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateItem(row, rowIndex, 'cnpjcliente')}]}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'cnpjcliente')),expression:"!(currentEditItem && currentEditItem === row && currentColumn === 'cnpjcliente')"}]},[_vm._v("\n                "+_vm._s(row.cnpjcliente)+"\n              ")])]):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('nomecliente'))?_c('md-table-cell',{key:'nomecliente',class:{
                'md-hide-medium': _vm.hideOnMedium('nomecliente'),
              },attrs:{"md-numeric":_vm.isNumericField('nomecliente')},nativeOn:{"mouseover":function($event){return _vm.onCelMouseEnter(row, 'nomecliente')},"mouseleave":function($event){return _vm.onCelMouseLeave($event)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onKeyEscPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateItem(row, rowIndex, 'nomecliente')}]}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'nomecliente')),expression:"!(currentEditItem && currentEditItem === row && currentColumn === 'nomecliente')"}]},[_vm._v("\n                "+_vm._s(row.nomecliente)+"\n              ")])]):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('quantidadeprodutos'))?_c('md-table-cell',{key:'quantidadeprodutos',class:{
                'md-hide-medium': _vm.hideOnMedium('quantidadeprodutos'),
              },attrs:{"md-numeric":_vm.isNumericField('quantidadeprodutos')},nativeOn:{"mouseover":function($event){return _vm.onCelMouseEnter(row, 'quantidadeprodutos')},"mouseleave":function($event){return _vm.onCelMouseLeave($event)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onKeyEscPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateItem(row, rowIndex, 'quantidadeprodutos')}]}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'quantidadeprodutos')),expression:"!(currentEditItem && currentEditItem === row && currentColumn === 'quantidadeprodutos')"}]},[_vm._v("\n                "+_vm._s(_vm.formatDecimal(row.quantidadeprodutos))+"\n              ")])]):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('valortotal'))?_c('md-table-cell',{key:'valortotal',class:{
                'md-hide-medium': _vm.hideOnMedium('valortotal'),
              },attrs:{"md-numeric":_vm.isNumericField('valortotal')},nativeOn:{"mouseover":function($event){return _vm.onCelMouseEnter(row, 'valortotal')},"mouseleave":function($event){return _vm.onCelMouseLeave($event)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onKeyEscPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateItem(row, rowIndex, 'valortotal')}]}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'valortotal')),expression:"!(currentEditItem && currentEditItem === row && currentColumn === 'valortotal')"}]},[_vm._v("\n                "+_vm._s(_vm.formatCurrency(row.valortotal))+"\n              ")])]):_vm._e(),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button"},[_c('md-icon',[_vm._v("arrow_forward")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"top"}},[_vm._v(_vm._s(_vm.$t('title.sellout_detalhado')))])],1)],1)}),_vm._v(" "),_c('infinite-loading',{ref:"infiniteLoading",attrs:{"distance":100,"on-infinite":_vm.onInfinite}},[_c('div',{attrs:{"slot":"spinner"},slot:"spinner"})])],2):_vm._e()],1),_vm._v(" "),_c('h4',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isContentAvailable),expression:"!isContentAvailable"}],staticClass:"TabelaGenerica__NoContent"},[_vm._v("\n        "+_vm._s(_vm.$t('label.tabela_sem_conteudo'))+"\n      ")]),_vm._v(" "),_c('md-spinner',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLoading),expression:"showLoading"}],staticClass:"TabelaGenerica__InterminateLoader",attrs:{"slot":"spinner","md-indeterminate":""},slot:"spinner"})],1)],1):_vm._e()],1)}
var staticRenderFns = []



/***/ }),
/* 1493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SelloutTabelaDetalhado_vue_vue_type_template_id_6d3fab1a_lang_html___ = __webpack_require__(1494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SelloutTabelaDetalhado_vue_vue_type_script_lang_js___ = __webpack_require__(624);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__SelloutTabelaDetalhado_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__SelloutTabelaDetalhado_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__SelloutTabelaDetalhado_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__SelloutTabelaDetalhado_vue_vue_type_template_id_6d3fab1a_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__SelloutTabelaDetalhado_vue_vue_type_template_id_6d3fab1a_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SelloutTabelaDetalhado_vue_vue_type_template_id_6d3fab1a_lang_html___ = __webpack_require__(1495);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SelloutTabelaDetalhado_vue_vue_type_template_id_6d3fab1a_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SelloutTabelaDetalhado_vue_vue_type_template_id_6d3fab1a_lang_html___["b"]; });


/***/ }),
/* 1495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"tabindex":"100"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.preventDefault();return _vm.onArrowUpPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.preventDefault();return _vm.onArrowDownPress($event)}]}},[_c('md-dialog',{ref:_vm.dialog.ref,attrs:{"md-open-from":("#" + (_vm.dialog.from))}},[_c('md-dialog-title',[_vm._v(_vm._s(_vm.dialog.title))]),_vm._v(" "),_c('md-dialog-content',[_vm._v(_vm._s(_vm.dialog.content))]),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",attrs:{"id":"sellout-tabelaDetalhado-button-cancel"},nativeOn:{"click":function($event){return _vm.closeDialog('dialog1')}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.cancelar'))+"\n      ")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary",attrs:{"id":"sellout-tabelaDetalhado-button-save"},nativeOn:{"click":function($event){return _vm.closeDialog('dialog1', _vm.dialog.action)}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.sim'))+"\n      ")])],1)],1),_vm._v(" "),(_vm.isHeaderAvailable)?_c('md-table-card',[_c('md-toolbar',[_c('md-button',{staticClass:"md-icon-button",attrs:{"id":"sellout-tabelaDetalhado-button-back"},nativeOn:{"click":function($event){return _vm.retornarSellOutConsolidado($event)}}},[_c('md-icon',[_vm._v("arrow_back")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"top"}},[_vm._v(_vm._s(_vm.$t('title.sellout_consolidado')))])],1),_vm._v(" "),_c('h1',{staticClass:"md-title",domProps:{"textContent":_vm._s(_vm.title)}}),_vm._v(" "),_c('md-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isExportAvailable && _vm.canExport),expression:"isExportAvailable && canExport"}],staticClass:"md-icon-button",attrs:{"id":"sellout-tabelaDetalhado-button-export","disabled":_vm.blockExportButton},nativeOn:{"click":function($event){return _vm.exportData($event)}}},[_c('md-icon',[_vm._v("get_app")])],1),_vm._v(" "),_c('md-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSearchAvailable),expression:"isSearchAvailable"}],staticClass:"md-icon-button",attrs:{"id":"sellout-tabelaDetalhado-button-search"},nativeOn:{"click":function($event){return _vm.focusSearchInput('sellout-tabelaDetalhado-input-search')}}},[_c('md-icon',[_vm._v("search")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"top"}},[_vm._v(_vm._s(_vm.$t('label.buscar')))])],1),_vm._v(" "),(_vm.isPaginationAvailable)?_c('md-select',{staticClass:"TabelaGenerica__Filters__Select md-hide-medium",attrs:{"md-menu-class":"md-pagination-select","id":"sellout-tabelaDetalhado-button-select"},model:{value:(_vm.paginationSize),callback:function ($$v) {_vm.paginationSize=$$v},expression:"paginationSize"}},[_c('md-option',{attrs:{"value":5}},[_vm._v("Buscar por 05 itens")]),_vm._v(" "),_c('md-option',{attrs:{"value":10}},[_vm._v("Buscar por 10 itens")]),_vm._v(" "),_c('md-option',{attrs:{"value":15}},[_vm._v("Buscar por 15 itens")]),_vm._v(" "),_c('md-option',{attrs:{"value":20}},[_vm._v("Buscar por 20 itens")]),_vm._v(" "),_c('md-option',{attrs:{"value":50}},[_vm._v("Buscar por 50 itens")])],1):_vm._e(),_vm._v(" "),(_vm.openSearchToolbar)?_c('div',{staticClass:"TabelaGenerica__SearchWrapper",class:{
          'TabelaGenerica__SearchWrapper--active': _vm.openSearchToolbar,
        }},[_c('md-input-container',{staticClass:"TabelaGenerica__SearchInput md-accent"},[_c('label',[_vm._v("Buscar")]),_vm._v(" "),_c('md-input',{attrs:{"autoFocus":"true","id":"sellout-tabelaDetalhado-input-search","type":"text"},model:{value:(_vm.searchQuery),callback:function ($$v) {_vm.searchQuery=$$v},expression:"searchQuery"}}),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",attrs:{"id":"sellout-tabelaDetalhado-button-search-close"},nativeOn:{"click":function($event){return _vm.closeSearchHeader($event)}}},[_c('md-icon',[_vm._v("close")])],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"TabelaGenerica__TableWrapper"},[_c('md-table',{ref:"myTable",staticClass:"TabelaGenerica__Table",attrs:{"md-sort":_vm.sortData.name,"md-sort-type":_vm.sortData.type},on:{"select":_vm.onSelect,"sort":_vm.onSort}},[(_vm.isHeaderAvailable)?_c('md-table-header',[_c('md-table-row',_vm._l((_vm.tableHeader),function(head,index){return _c('md-table-head',{key:index,class:head.classes,attrs:{"id":("sellout-tabelaDetalhado-head-" + index),"md-tooltip":head.tooltip,"md-sort-by":head.sortType}},[_vm._v("\n              "+_vm._s(head.name)+"\n            ")])}),1)],1):_vm._e(),_vm._v(" "),(_vm.isContentAvailable)?_c('md-table-body',{attrs:{"tabindex":"110"}},[_vm._l((_vm.tableData),function(row,rowIndex){return _c('md-table-row',{key:rowIndex,class:{
              'TabelaGenerica__TableRow--highlight': _vm.currentEditItem && _vm.currentEditItem === row,
              'TabelaGenerica__TableRow--disabled': false,
            },attrs:{"md-item":row}},[(_vm.isColumnVisible('competencia'))?_c('md-table-cell',{key:'competencia',class:{
                'md-hide-medium': _vm.hideOnMedium('competencia'),
              },attrs:{"md-numeric":_vm.isNumericField('competencia')},nativeOn:{"mouseover":function($event){return _vm.onCelMouseEnter(row, 'competencia')},"mouseleave":function($event){return _vm.onCelMouseLeave($event)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onKeyEscPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateItem(row, rowIndex, 'competencia')}]}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'competencia')),expression:"!(currentEditItem && currentEditItem === row && currentColumn === 'competencia')"}]},[_vm._v("\n                "+_vm._s(row.competencia)+"\n              ")])]):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('numeronotafiscal'))?_c('md-table-cell',{key:'numeronotafiscal',class:{
                'md-hide-medium': _vm.hideOnMedium('numeronotafiscal'),
              },attrs:{"md-numeric":_vm.isNumericField('numeronotafiscal')},nativeOn:{"mouseover":function($event){return _vm.onCelMouseEnter(row, 'numeronotafiscal')},"mouseleave":function($event){return _vm.onCelMouseLeave($event)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onKeyEscPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateItem(row, rowIndex, 'numeronotafiscal')}]}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'numeronotafiscal')),expression:"!(currentEditItem && currentEditItem === row && currentColumn === 'numeronotafiscal')"}]},[_vm._v("\n                   "+_vm._s(row.numeronotafiscal)+"\n              ")])]):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('cnpjdistribuidor'))?_c('md-table-cell',{key:'cnpjdistribuidor',class:{
                'md-hide-medium': _vm.hideOnMedium('cnpjdistribuidor'),
              },attrs:{"md-numeric":_vm.isNumericField('cnpjdistribuidor')},nativeOn:{"mouseover":function($event){return _vm.onCelMouseEnter(row, 'cnpjdistribuidor')},"mouseleave":function($event){return _vm.onCelMouseLeave($event)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onKeyEscPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateItem(row, rowIndex, 'cnpjdistribuidor')}]}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'cnpjdistribuidor')),expression:"!(currentEditItem && currentEditItem === row && currentColumn === 'cnpjdistribuidor')"}]},[_vm._v("\n                   "+_vm._s(row.cnpjdistribuidor)+"\n              ")])]):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('distribuidor'))?_c('md-table-cell',{key:'distribuidor',class:{
                'md-hide-medium': _vm.hideOnMedium('distribuidor'),
              },attrs:{"md-numeric":_vm.isNumericField('distribuidor')},nativeOn:{"mouseover":function($event){return _vm.onCelMouseEnter(row, 'distribuidor')},"mouseleave":function($event){return _vm.onCelMouseLeave($event)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onKeyEscPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateItem(row, rowIndex, 'distribuidor')}]}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'distribuidor')),expression:"!(currentEditItem && currentEditItem === row && currentColumn === 'distribuidor')"}]},[_vm._v("\n                   "+_vm._s(row.distribuidor)+"\n              ")])]):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('cnpjloja'))?_c('md-table-cell',{key:'cnpjloja',class:{
                'md-hide-medium': _vm.hideOnMedium('cnpjloja'),
              },attrs:{"md-numeric":_vm.isNumericField('cnpjloja')},nativeOn:{"mouseover":function($event){return _vm.onCelMouseEnter(row, 'cnpjloja')},"mouseleave":function($event){return _vm.onCelMouseLeave($event)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onKeyEscPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateItem(row, rowIndex, 'cnpjloja')}]}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'cnpjloja')),expression:"!(currentEditItem && currentEditItem === row && currentColumn === 'cnpjloja')"}]},[_vm._v("\n                   "+_vm._s(row.cnpjloja)+"\n              ")])]):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('ean'))?_c('md-table-cell',{key:'ean',class:{
                'md-hide-medium': _vm.hideOnMedium('ean'),
              },attrs:{"md-numeric":_vm.isNumericField('ean')},nativeOn:{"mouseover":function($event){return _vm.onCelMouseEnter(row, 'ean')},"mouseleave":function($event){return _vm.onCelMouseLeave($event)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onKeyEscPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateItem(row, rowIndex, 'ean')}]}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'ean')),expression:"!(currentEditItem && currentEditItem === row && currentColumn === 'ean')"}]},[_vm._v("\n                   "+_vm._s(row.ean)+"\n              ")])]):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('nomeproduto'))?_c('md-table-cell',{key:'nomeproduto',class:{
                'md-hide-medium': _vm.hideOnMedium('nomeproduto'),
              },attrs:{"md-numeric":_vm.isNumericField('nomeproduto')},nativeOn:{"mouseover":function($event){return _vm.onCelMouseEnter(row, 'nomeproduto')},"mouseleave":function($event){return _vm.onCelMouseLeave($event)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onKeyEscPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateItem(row, rowIndex, 'nomeproduto')}]}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'nomeproduto')),expression:"!(currentEditItem && currentEditItem === row && currentColumn === 'nomeproduto')"}]},[_vm._v("\n                   "+_vm._s(row.nomeproduto)+"\n              ")])]):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('unidademedida'))?_c('md-table-cell',{key:'unidademedida',class:{
                'md-hide-medium': _vm.hideOnMedium('unidademedida'),
              },attrs:{"md-numeric":_vm.isNumericField('unidademedida')},nativeOn:{"mouseover":function($event){return _vm.onCelMouseEnter(row, 'unidademedida')},"mouseleave":function($event){return _vm.onCelMouseLeave($event)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onKeyEscPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateItem(row, rowIndex, 'unidademedida')}]}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'unidademedida')),expression:"!(currentEditItem && currentEditItem === row && currentColumn === 'unidademedida')"}]},[_vm._v("\n                   "+_vm._s(row.unidademedida)+"\n              ")])]):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('quantidadeproduto'))?_c('md-table-cell',{key:'quantidadeproduto',class:{
                'md-hide-medium': _vm.hideOnMedium('quantidadeproduto'),
              },attrs:{"md-numeric":_vm.isNumericField('quantidadeproduto')},nativeOn:{"mouseover":function($event){return _vm.onCelMouseEnter(row, 'quantidadeproduto')},"mouseleave":function($event){return _vm.onCelMouseLeave($event)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onKeyEscPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateItem(row, rowIndex, 'quantidadeproduto')}]}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'quantidadeproduto')),expression:"!(currentEditItem && currentEditItem === row && currentColumn === 'quantidadeproduto')"}]},[_vm._v("\n                   "+_vm._s(_vm.formatDecimal(row.quantidadeproduto))+"\n              ")])]):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('valorunitario'))?_c('md-table-cell',{key:'valorunitario',class:{
                'md-hide-medium': _vm.hideOnMedium('valorunitario'),
              },attrs:{"md-numeric":_vm.isNumericField('valorunitario')},nativeOn:{"mouseover":function($event){return _vm.onCelMouseEnter(row, 'valorunitario')},"mouseleave":function($event){return _vm.onCelMouseLeave($event)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onKeyEscPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateItem(row, rowIndex, 'valorunitario')}]}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'valorunitario')),expression:"!(currentEditItem && currentEditItem === row && currentColumn === 'valorunitario')"}]},[_vm._v("\n                   "+_vm._s(_vm.formatCurrency(row.valorunitario))+"\n              ")])]):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('valortotal'))?_c('md-table-cell',{key:'valortotal',class:{
                'md-hide-medium': _vm.hideOnMedium('valortotal'),
              },attrs:{"md-numeric":_vm.isNumericField('valortotal')},nativeOn:{"mouseover":function($event){return _vm.onCelMouseEnter(row, 'valortotal')},"mouseleave":function($event){return _vm.onCelMouseLeave($event)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onKeyEscPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateItem(row, rowIndex, 'valortotal')}]}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'valortotal')),expression:"!(currentEditItem && currentEditItem === row && currentColumn === 'valortotal')"}]},[_vm._v("\n                   "+_vm._s(_vm.formatCurrency(row.valortotal))+"\n              ")])]):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('valorliquido'))?_c('md-table-cell',{key:'valorliquido',class:{
                'md-hide-medium': _vm.hideOnMedium('valorliquido'),
              },attrs:{"md-numeric":_vm.isNumericField('valorliquido')},nativeOn:{"mouseover":function($event){return _vm.onCelMouseEnter(row, 'valorliquido')},"mouseleave":function($event){return _vm.onCelMouseLeave($event)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onKeyEscPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateItem(row, rowIndex, 'valorliquido')}]}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'valorliquido')),expression:"!(currentEditItem && currentEditItem === row && currentColumn === 'valorliquido')"}]},[_vm._v("\n                   "+_vm._s(_vm.formatCurrency(row.valorliquido))+"\n              ")])]):_vm._e()],1)}),_vm._v(" "),_c('infinite-loading',{ref:"infiniteLoading",attrs:{"distance":100,"on-infinite":_vm.onInfinite}},[_c('div',{attrs:{"slot":"spinner"},slot:"spinner"})])],2):_vm._e()],1),_vm._v(" "),_c('h4',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isContentAvailable),expression:"!isContentAvailable"}],staticClass:"TabelaGenerica__NoContent"},[_vm._v("\n        "+_vm._s(_vm.$t('label.tabela_sem_conteudo'))+"\n      ")]),_vm._v(" "),_c('md-spinner',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLoading),expression:"showLoading"}],staticClass:"TabelaGenerica__InterminateLoader",attrs:{"slot":"spinner","md-indeterminate":""},slot:"spinner"})],1)],1):_vm._e()],1)}
var staticRenderFns = []



/***/ }),
/* 1496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SellOut_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SellOut_vue_vue_type_style_index_0_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SellOut_vue_vue_type_style_index_0_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_SellOut_vue_vue_type_style_index_0_lang_css____default.a); 

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TermoAceite = __webpack_require__(1498);

var _TermoAceite2 = _interopRequireDefault(_TermoAceite);

var _TermoAceiteLista = __webpack_require__(1501);

var _TermoAceiteLista2 = _interopRequireDefault(_TermoAceiteLista);

var _TermoAceiteForm = __webpack_require__(1504);

var _TermoAceiteForm2 = _interopRequireDefault(_TermoAceiteForm);

var _TermoAceiteRealizado = __webpack_require__(1514);

var _TermoAceiteRealizado2 = _interopRequireDefault(_TermoAceiteRealizado);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  path: 'termo-aceite',
  component: _TermoAceite2.default,
  children: [{
    path: '',
    name: 'termo-aceite',
    component: _TermoAceiteLista2.default
  }, {
    path: 'novo',
    name: 'novoTermoAceite',
    component: _TermoAceiteForm2.default,
    props: {
      criarNovoTermoAceite: true
    }
  }, {
    path: ':id/editar',
    name: 'editarTermoAceite',
    component: _TermoAceiteForm2.default
  }, {
    path: ':id/ver',
    name: 'verTermoAceite',
    component: _TermoAceiteForm2.default,
    props: {
      somenteLeitura: true
    }
  }, {
    path: 'realizado',
    name: 'termoAceiteRealizado',
    component: _TermoAceiteRealizado2.default
  }]
};

/***/ }),
/* 1498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TermoAceite_vue_vue_type_template_id_450a2531___ = __webpack_require__(1499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__TermoAceite_vue_vue_type_template_id_450a2531___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__TermoAceite_vue_vue_type_template_id_450a2531___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TermoAceite_vue_vue_type_template_id_450a2531___ = __webpack_require__(1500);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TermoAceite_vue_vue_type_template_id_450a2531___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TermoAceite_vue_vue_type_template_id_450a2531___["b"]; });


/***/ }),
/* 1500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c('router-view')],1)}
var staticRenderFns = []



/***/ }),
/* 1501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TermoAceiteLista_vue_vue_type_template_id_6813c8ee_lang_html___ = __webpack_require__(1502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TermoAceiteLista_vue_vue_type_script_lang_js___ = __webpack_require__(627);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__TermoAceiteLista_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__TermoAceiteLista_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__TermoAceiteLista_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__TermoAceiteLista_vue_vue_type_template_id_6813c8ee_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__TermoAceiteLista_vue_vue_type_template_id_6813c8ee_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TermoAceiteLista_vue_vue_type_template_id_6813c8ee_lang_html___ = __webpack_require__(1503);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TermoAceiteLista_vue_vue_type_template_id_6813c8ee_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TermoAceiteLista_vue_vue_type_template_id_6813c8ee_lang_html___["b"]; });


/***/ }),
/* 1503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canAccessPage)?_c('v-card',[_c('v-card-title',[_c('h3',{staticClass:"headline mb-0"},[_vm._v(_vm._s(_vm.$tc('label.termo_aceite', 1)))])]),_vm._v(" "),_c('v-card-text',[_c('v-row',{attrs:{"justify":"start"}},[_c('v-col',{attrs:{"cols":"12","sm":"6","md":"4"}},[_c('v-text-field',{attrs:{"append-icon":"search","label":_vm.$t('label.pesquisar'),"single-line":"","clearable":"","hide-details":""},model:{value:(_vm.searchQuery),callback:function ($$v) {_vm.searchQuery=$$v},expression:"searchQuery"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","sm":"6","md":"1"}},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"text":"","icon":""},nativeOn:{"click":function($event){return _vm.requestExportacao($event)}}},on),[_c('v-icon',[_vm._v("get_app")])],1)]}}],null,false,1163599354)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$tc('label.exportar', 1)))])])],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.termos,"options":_vm.pagination,"server-items-length":_vm.totalPage,"items-per-page":5,"no-data-text":_vm.$t('label.tabela_sem_conteudo'),"footer-props":{
        itemsPerPageOptions: [10, 25, 50],
      }},on:{"update:options":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"item.acoes",fn:function(ref){
      var item = ref.item;
return [_c('v-menu',{attrs:{"bottom":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
      var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"grey--text text--darken-1",attrs:{"icon":""}},on),[_c('v-icon',[_vm._v("more_vert")])],1)]}}],null,true)},[_vm._v(" "),_c('v-list',[(!_vm.canCRUD)?_c('v-list-item',{on:{"click":function($event){return _vm.verDetalhes(item)}}},[_c('v-list-item-action',[_c('v-icon',[_vm._v("equalizer")])],1),_vm._v(" "),_c('v-list-item-title',{staticClass:"grey--text text--darken-1"},[_vm._v(_vm._s(_vm.$t('label.mais_detalhes')))])],1):_vm._e(),_vm._v(" "),(_vm.canCRUD)?_c('v-list-item',{on:{"click":function($event){return _vm.editar(item)}}},[_c('v-list-item-action',[_c('v-icon',[_vm._v("edit")])],1),_vm._v(" "),_c('v-list-item-title',{staticClass:"grey--text text--darken-1"},[_vm._v(_vm._s(_vm.$t('label.editar')))])],1):_vm._e(),_vm._v(" "),(_vm.canCRUD)?_c('v-list-item',{on:{"click":function($event){return _vm.ativarInativar(item)}}},[_c('v-list-item-action',[_c('v-icon',[_vm._v("block")])],1),_vm._v(" "),_c('v-list-item-title',{staticClass:"grey--text text--darken-1"},[_vm._v(_vm._s(_vm.$t('label.ativar_inativa')))])],1):_vm._e()],1)],1)]}},(_vm.indModoVarejo)?{key:"item.grupos_fornecedor",fn:function(ref){
      var item = ref.item;
return [_vm._v("\n        "+_vm._s(item.gruposFornecedor)+"\n      ")]}}:{key:"item.unidades",fn:function(ref){
      var item = ref.item;
return [_vm._v("\n        "+_vm._s(item.unidades)+"\n      ")]}},{key:"item.objetivo",fn:function(ref){
      var item = ref.item;
return [_vm._v("\n        "+_vm._s(_vm.$t(("label." + (item.objetivo.toLowerCase()))))+"\n      ")]}},{key:"item.frequencia",fn:function(ref){
      var item = ref.item;
return [_vm._v("\n        "+_vm._s(_vm.$t(("label." + (item.frequencia.toLowerCase()))))+"\n      ")]}},{key:"item.indAtivo",fn:function(ref){
      var item = ref.item;
return [_vm._v("\n        "+_vm._s(item.indAtivo ? _vm.$t('label.sim') : _vm.$t('label.nao'))+"\n      ")]}}],null,true)}),_vm._v(" "),(_vm.canCRUD)?_c('v-btn',{staticClass:"v-btn__fab",attrs:{"color":"primary","dark":"","fixed":"","fab":"","bottom":"","right":""},on:{"click":_vm.abrirForm}},[_c('v-icon',[_vm._v("add")])],1):_vm._e()],1)],1):_vm._e()}
var staticRenderFns = []



/***/ }),
/* 1504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TermoAceiteForm_vue_vue_type_template_id_51ce4880_lang_html___ = __webpack_require__(1505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TermoAceiteForm_vue_vue_type_script_lang_js___ = __webpack_require__(629);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__TermoAceiteForm_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__TermoAceiteForm_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__TermoAceiteForm_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__TermoAceiteForm_vue_vue_type_template_id_51ce4880_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__TermoAceiteForm_vue_vue_type_template_id_51ce4880_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TermoAceiteForm_vue_vue_type_template_id_51ce4880_lang_html___ = __webpack_require__(1506);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TermoAceiteForm_vue_vue_type_template_id_51ce4880_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TermoAceiteForm_vue_vue_type_template_id_51ce4880_lang_html___["b"]; });


/***/ }),
/* 1506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canAccessPage)?_c('div',[_c('v-form',{ref:"form",attrs:{"lazy-validation":""}},[_c('v-card',[_c('v-card-title',[_c('h3',{staticClass:"headline mb-0"},[_vm._v(_vm._s(_vm.$t('label.termo_aceite')))])]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-xl":"","fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"6","md":"4"}},[_c('v-text-field',{staticClass:"CalendarioForm-data__text",attrs:{"id":"termo_aceite_descricao","name":"termo_aceite_descricao","label":((_vm.$t('label.descricao')) + " *"),"counter":100,"rules":[_vm.rules.required],"disabled":_vm.somenteLeitura},model:{value:(_vm.termo.descricao),callback:function ($$v) {_vm.$set(_vm.termo, "descricao", $$v)},expression:"termo.descricao"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","sm":"6","md":"4"}},[(_vm.indModoVarejo)?_c('v-autocomplete',{staticClass:"Form-text__invalid",attrs:{"id":"termo_aceite_grupo_fornecedor","name":"termo_aceite_grupo_fornecedor","items":_vm.gruposFornecedor,"item-text":"nomExtensao","item-value":"id","label":("" + (_vm.$tc('label.grupo_fornecedor', 1))),"return-object":"","multiple":"","no-data-text":_vm.$tc('message.nenhum_registro', 1),"clearable":true,"search-input":_vm.triggerGrupoFornecedor,"disabled":_vm.somenteLeitura},on:{"update:searchInput":function($event){_vm.triggerGrupoFornecedor=$event},"update:search-input":function($event){_vm.triggerGrupoFornecedor=$event},"click:append":function () { return _vm.triggerSelecao('termo_aceite_grupo_fornecedor'); }},nativeOn:{"click":function($event){return (function (i) { return _vm.buscaAutocomplete(i, _vm.buscarGruposFornecedores); })($event)}},model:{value:(_vm.termo.gruposFornecedor),callback:function ($$v) {_vm.$set(_vm.termo, "gruposFornecedor", $$v)},expression:"termo.gruposFornecedor"}}):_c('v-select',{staticClass:"Form-text__invalid",attrs:{"id":"termo_aceite_unidades","name":"termo_aceite_unidades","items":_vm.unidades,"item-text":"nomExtensao","item-value":"id","label":((_vm.$tc('label.unidades_negocio', 2)) + " *"),"return-object":"","multiple":"","no-data-text":_vm.$tc('message.nenhum_registro', 1),"required":"","rules":[function () { return _vm.termo.unidades.length > 0 || this$1.$t('message.campo_obrigatorio'); }],"disabled":_vm.somenteLeitura},model:{value:(_vm.termo.unidades),callback:function ($$v) {_vm.$set(_vm.termo, "unidades", $$v)},expression:"termo.unidades"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","sm":"6","md":"4"}},[(_vm.criarNovoTermoAceite)?_c('v-select',{staticClass:"Form-text__invalid",attrs:{"id":"termo_aceite_objetivo","name":"termo_aceite_objetivo","item-text":"text","item-value":"value","items":_vm.objetivosSemRevalidacao,"rules":[_vm.rules.required],"label":((_vm.$tc('label.objetivo', 1)) + " *"),"required":"","disabled":""},model:{value:(_vm.termo.objetivo),callback:function ($$v) {_vm.$set(_vm.termo, "objetivo", $$v)},expression:"termo.objetivo"}}):_vm._e(),_vm._v(" "),(!_vm.criarNovoTermoAceite)?_c('v-select',{staticClass:"Form-text__invalid",attrs:{"id":"termo_aceite_objetivo","name":"termo_aceite_objetivo","item-text":"text","item-value":"value","items":_vm.objetivos,"rules":[_vm.rules.required],"label":((_vm.$tc('label.objetivo', 1)) + " *"),"required":"","disabled":_vm.somenteLeitura},model:{value:(_vm.termo.objetivo),callback:function ($$v) {_vm.$set(_vm.termo, "objetivo", $$v)},expression:"termo.objetivo"}}):_vm._e()],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","sm":"6","md":"4"}},[_c('v-menu',{ref:"data_inicio",attrs:{"close-on-content-click":false,"id":"data_inicio","name":"data_inicio","nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","max-width":"290px","min-width":"290px","disabled":_vm.somenteLeitura},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({staticClass:"filtro-acesso-usuario__select",attrs:{"return-masked-value":true,"mask":"##-##-####","rules":[_vm.rules.required, _vm.rules.validDate],"label":((_vm.$t('label.data_inicio')) + " *")},model:{value:(_vm.dateInicioFormatada),callback:function ($$v) {_vm.dateInicioFormatada=$$v},expression:"dateInicioFormatada"}},on))]}}],null,false,3222775876),model:{value:(_vm.menuDataInicio),callback:function ($$v) {_vm.menuDataInicio=$$v},expression:"menuDataInicio"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"pt-br","color":"primary"},on:{"input":function($event){_vm.menuDataInicio = false}},model:{value:(_vm.dataInicio),callback:function ($$v) {_vm.dataInicio=$$v},expression:"dataInicio"}})],1)],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","sm":"6","md":"4"}},[_c('v-select',{staticClass:"Form-text__invalid",attrs:{"id":"termo_aceite_frequencia","name":"termo_aceite_frequencia","item-text":"text","item-value":"value","items":_vm.frequencias,"rules":[_vm.rules.required],"label":((_vm.$tc('label.frequencia', 1)) + " *"),"required":"","disabled":_vm.somenteLeitura},model:{value:(_vm.termo.frequencia),callback:function ($$v) {_vm.$set(_vm.termo, "frequencia", $$v)},expression:"termo.frequencia"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","sm":"6","md":"4"}},[_c('v-select',{staticClass:"Form-text__invalid",attrs:{"id":"termo_aceite_tipo_usuario","name":"termo_aceite_tipo_usuario","item-text":"text","item-value":"value","items":_vm.tiposUsuario,"rules":[_vm.rules.required],"label":((_vm.$tc('label.tipo_usuario', 1)) + " *"),"required":"","disabled":""},model:{value:(_vm.termo.tipoUsuario),callback:function ($$v) {_vm.$set(_vm.termo, "tipoUsuario", $$v)},expression:"termo.tipoUsuario"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12"}},[(_vm.indModoVarejo)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('message.variaveis_termo_aceite_varejo'))}}):_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('message.variaveis_termo_aceite_industria'))}}),_vm._v(" "),(!_vm.somenteLeitura)?_c('editor',{ref:"editor"}):_vm._e(),_vm._v(" "),(_vm.somenteLeitura)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.termo.conteudo)}}):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{nativeOn:{"click":function($event){return _vm.cancelar($event)}}},[_vm._v(_vm._s(_vm.somenteLeitura ? _vm.$t('label.voltar') : _vm.$t('label.cancelar')))]),_vm._v(" "),(!_vm.somenteLeitura)?_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.abrirDialogSalvar($event)}}},[_vm._v(_vm._s(_vm.$t('label.salvar')))]):_vm._e()],1)],1),_vm._v(" "),_c('confirm',{ref:"confirmDialog",attrs:{"message":_vm.$t('message.deseja_salvar', {text: _vm.$t('label.termo_aceite')}),"persistent":true},on:{"agree":_vm.salvar}})],1)],1):_vm._e()}
var staticRenderFns = []



/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var buscaAutocomplete = exports.buscaAutocomplete = function buscaAutocomplete(autocomplete, callback) {
  if (typeof autocomplete !== 'string') {
    autocomplete = '';
  }
  return callback(autocomplete);
};

var triggerSelecao = exports.triggerSelecao = function triggerSelecao(id) {
  setTimeout(function () {
    return document.getElementById(id).click();
  });
};

/***/ }),
/* 1508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Editor_vue_vue_type_template_id_04e871d2_lang_html___ = __webpack_require__(1509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Editor_vue_vue_type_script_lang_js___ = __webpack_require__(631);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__Editor_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__Editor_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__spreadsheet_kendoui_kendo_common_min_css_vue_type_style_index_0_lang_css___ = __webpack_require__(1511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__spreadsheet_kendoui_kendo_default_min_css_vue_type_style_index_1_lang_css___ = __webpack_require__(1512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__spreadsheet_kendoui_kendo_default_mobile_min_css_vue_type_style_index_2_lang_css___ = __webpack_require__(1513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);








/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_5__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Editor_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__Editor_vue_vue_type_template_id_04e871d2_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Editor_vue_vue_type_template_id_04e871d2_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Editor_vue_vue_type_template_id_04e871d2_lang_html___ = __webpack_require__(1510);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Editor_vue_vue_type_template_id_04e871d2_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Editor_vue_vue_type_template_id_04e871d2_lang_html___["b"]; });


/***/ }),
/* 1510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('textarea',{staticStyle:{"height":"440px"},attrs:{"id":_vm.id,"name":_vm.id,"rows":"10","cols":"30","aria-label":"editor"}},[_vm._v("      "+_vm._s(_vm.texto)+"\n  ")])])}
var staticRenderFns = []



/***/ }),
/* 1511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_kendo_common_min_css_vue_type_style_index_0_lang_css___ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_kendo_common_min_css_vue_type_style_index_0_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_kendo_common_min_css_vue_type_style_index_0_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_kendo_common_min_css_vue_type_style_index_0_lang_css____default.a); 

/***/ }),
/* 1512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_kendo_default_min_css_vue_type_style_index_1_lang_css___ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_kendo_default_min_css_vue_type_style_index_1_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_kendo_default_min_css_vue_type_style_index_1_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_kendo_default_min_css_vue_type_style_index_1_lang_css____default.a); 

/***/ }),
/* 1513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_kendo_default_mobile_min_css_vue_type_style_index_2_lang_css___ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_kendo_default_mobile_min_css_vue_type_style_index_2_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_kendo_default_mobile_min_css_vue_type_style_index_2_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_kendo_default_mobile_min_css_vue_type_style_index_2_lang_css____default.a); 

/***/ }),
/* 1514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TermoAceiteRealizado_vue_vue_type_template_id_516875d4_scoped_true_lang_html___ = __webpack_require__(1515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TermoAceiteRealizado_vue_vue_type_script_lang_js___ = __webpack_require__(636);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__TermoAceiteRealizado_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__TermoAceiteRealizado_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TermoAceiteRealizado_vue_vue_type_style_index_0_id_516875d4_scoped_true_lang_css___ = __webpack_require__(1517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__TermoAceiteRealizado_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__TermoAceiteRealizado_vue_vue_type_template_id_516875d4_scoped_true_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__TermoAceiteRealizado_vue_vue_type_template_id_516875d4_scoped_true_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  "516875d4",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TermoAceiteRealizado_vue_vue_type_template_id_516875d4_scoped_true_lang_html___ = __webpack_require__(1516);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TermoAceiteRealizado_vue_vue_type_template_id_516875d4_scoped_true_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TermoAceiteRealizado_vue_vue_type_template_id_516875d4_scoped_true_lang_html___["b"]; });


/***/ }),
/* 1516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',[_c('v-card-title',[_c('h3',{staticClass:"headline mb-0"},[_vm._v(_vm._s(_vm.$t('label.aceites_realizados')))])]),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"6"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-text-field',{attrs:{"append-icon":"search","label":_vm.$t('label.pesquisar'),"single-line":"","clearable":"","hide-details":""},model:{value:(_vm.searchQuery),callback:function ($$v) {_vm.searchQuery=$$v},expression:"searchQuery"}}),_vm._v(" "),_c('v-data-iterator',{attrs:{"items":_vm.items,"server-items-length":_vm.totalPage,"options":_vm.pagination,"no-data-text":_vm.$t('label.tabela_sem_conteudo'),"content-tag":"v-row","footer-props":{
                itemsPerPageOptions: [10, 25, 50],
              }},on:{"update:options":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('v-row',{staticClass:"mx-0",attrs:{"justify":"start"}},_vm._l((_vm.items),function(item){return _c('v-col',{key:item.titulo,attrs:{"cols":"12","sm":"6"}},[_c('v-card',{nativeOn:{"click":function($event){return _vm.selecionar(item)}}},[_c('v-card-title',[_vm._v(_vm._s(item.descricao))]),_vm._v(" "),_c('v-card-actions',[_c('span',[_vm._v("\n                          "+_vm._s(((_vm.$tc('label.data')) + ": " + (item.dtaAceite.split(' ', 1)[0])))+"\n                          "),_c('v-spacer'),_vm._v("\n                          "+_vm._s(((_vm.$tc('label.hora')) + ": " + (item.dtaAceite.split(' ', 2)[1])))+"\n                        ")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"details-button",attrs:{"color":"accent"},nativeOn:{"click":function($event){return _vm.selecionar(item)}}},[_vm._v("\n                          "+_vm._s(_vm.$t('label.visualizar_detalhes'))+"\n                        ")])],1)],1)],1)}),1)]}}])})],1)],1),_vm._v(" "),_c('v-col',{staticClass:"details",attrs:{"cols":"12","sm":"6"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.termo.conteudo)}})])],1)],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TermoAceiteRealizado_vue_vue_type_style_index_0_id_516875d4_scoped_true_lang_css___ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TermoAceiteRealizado_vue_vue_type_style_index_0_id_516875d4_scoped_true_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TermoAceiteRealizado_vue_vue_type_style_index_0_id_516875d4_scoped_true_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TermoAceiteRealizado_vue_vue_type_style_index_0_id_516875d4_scoped_true_lang_css____default.a); 

/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TipoAcao = __webpack_require__(1519);

var _TipoAcao2 = _interopRequireDefault(_TipoAcao);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  path: 'tipo-acao',
  name: 'tipo-acao',
  component: _TipoAcao2.default
};

/***/ }),
/* 1519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TipoAcao_vue_vue_type_template_id_ca59e1f6_lang_html___ = __webpack_require__(1520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TipoAcao_vue_vue_type_script_lang_js___ = __webpack_require__(639);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__TipoAcao_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__TipoAcao_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__TipoAcao_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__TipoAcao_vue_vue_type_template_id_ca59e1f6_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__TipoAcao_vue_vue_type_template_id_ca59e1f6_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoAcao_vue_vue_type_template_id_ca59e1f6_lang_html___ = __webpack_require__(1521);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoAcao_vue_vue_type_template_id_ca59e1f6_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoAcao_vue_vue_type_template_id_ca59e1f6_lang_html___["b"]; });


/***/ }),
/* 1521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CRUDGenerico__Wrapper"},[(_vm.canAccessPage)?_c('md-layout',{staticClass:"md-gutter-16",attrs:{"md-row":""}},[(_vm.canAccessCRUD)?_c('md-layout',{staticClass:"CRUDGenerico__SideMenu md-hide-medium",attrs:{"md-column":""}},[_c('tipo-acao-lateral',{on:{"SIDECOLUMN_SAVE_ACTION":_vm.requestAdicionar}})],1):_vm._e(),_vm._v(" "),(_vm.canAccessCRUD)?_c('md-dialog',{ref:"dialog1",attrs:{"md-open-from":"#fab","md-close-to":"#fab"}},[_c('tipo-acao-lateral',{on:{"SIDECOLUMN_CANCEL_ACTION":_vm.closeDialog,"SIDECOLUMN_SAVE_ACTION":_vm.closeDialogSave}})],1):_vm._e(),_vm._v(" "),_c('md-layout',{staticClass:"CRUDGenerico__TableWrapper",attrs:{"md-flex":""}},[_c('tipo-acao-tabela',{ref:"tipoAcaoTabela",staticClass:"CRUDGenerico__ContentTable",attrs:{"title":_vm.$t('label.tipo_acao'),"table-rows":_vm.tableRows,"table-header":_vm.tableHeader,"visible-columns":['idExterno', 'nome', 'tipo'],"mobile-invisible-columns":['idExterno', 'nome', 'tipo'],"ignore-columns":['id', 'indAtivo']},on:{"TABELAGENERICA_ATUALIZAR":_vm.requestAtualizar,"TABELAGENERICA_BLOQUEAR_SELECIONADOS":_vm.ativarInativar,"TABELAGENERICA_BUSCAR_PROXIMA_PAGINA":_vm.requestPopular,"TABELAGENERICA_EXPORTAR_DADOS":_vm.requestExportacao,"TABELAGENERICA_ORDENAR":_vm.organizar,"PAGINACAO_ALTERANDO_TAMANHO_PAGINA":_vm.alterarTamanhoPagina}})],1)],1):_vm._e(),_vm._v(" "),(_vm.canAccessCRUD)?_c('md-button',{staticClass:"md-fab md-fab-bottom-right md-hide-large-and-up",staticStyle:{"position":"fixed","z-index":"5"},attrs:{"id":"fab"},nativeOn:{"click":function($event){return _vm.openDialog('dialog1')}}},[_c('md-icon',[_vm._v("add")])],1):_vm._e()],1)}
var staticRenderFns = []



/***/ }),
/* 1522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TipoAcaoLateral_vue_vue_type_template_id_2373110a_lang_html___ = __webpack_require__(1523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TipoAcaoLateral_vue_vue_type_script_lang_js___ = __webpack_require__(641);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__TipoAcaoLateral_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__TipoAcaoLateral_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__TipoAcaoLateral_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__TipoAcaoLateral_vue_vue_type_template_id_2373110a_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__TipoAcaoLateral_vue_vue_type_template_id_2373110a_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoAcaoLateral_vue_vue_type_template_id_2373110a_lang_html___ = __webpack_require__(1524);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoAcaoLateral_vue_vue_type_template_id_2373110a_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoAcaoLateral_vue_vue_type_template_id_2373110a_lang_html___["b"]; });


/***/ }),
/* 1524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-card',[(_vm.canAccessCRUD)?_c('register-form',{attrs:{"title":_vm.$t('title.cadastrar_novo_tipo_acao'),"cancel":_vm.cancel,"save":_vm.openSaveDialog}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('md-input-container',{class:{
          'md-input-invalid': _vm.errors.has('tipoAcao_code')
        }},[_c('label',[_vm._v(_vm._s(_vm.$t('label.cod_tipo_acao')))]),_vm._v(" "),_c('md-input',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"type":"text","tabindex":"1","name":"tipoAcao_code","required":"","data-vv-name":"tipoAcao_code","data-vv-rules":"required","maxlength":"10"},model:{value:(_vm.tipoAcao.idExterno),callback:function ($$v) {_vm.$set(_vm.tipoAcao, "idExterno", $$v)},expression:"tipoAcao.idExterno"}}),_vm._v(" "),_c('span',{staticClass:"md-error"},[_vm._v("\n          "+_vm._s(_vm.errors.first('tipoAcao_code'))+"\n        ")])],1),_vm._v(" "),_c('md-input-container',{class:{
          'md-input-invalid': _vm.errors.has('tipoAcao_nome')
        }},[_c('label',[_vm._v(_vm._s(_vm.$t('label.nome')))]),_vm._v(" "),_c('md-input',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"type":"text","tabindex":"2","name":"tipoAcao_nome","required":"","data-vv-name":"tipoAcao_nome","data-vv-rules":"required","maxlength":"100"},model:{value:(_vm.tipoAcao.nome),callback:function ($$v) {_vm.$set(_vm.tipoAcao, "nome", $$v)},expression:"tipoAcao.nome"}}),_vm._v(" "),_c('span',{staticClass:"md-error"},[_vm._v("\n          "+_vm._s(_vm.errors.first('tipoAcao_nome'))+"\n        ")])],1),_vm._v(" "),_c('md-input-container',[_c('label',{attrs:{"for":"tipo"}},[_vm._v(_vm._s(_vm.$tc('label.tipo_provisao',1)))]),_vm._v(" "),_c('md-select',{attrs:{"name":"tipo","id":"tipo"},model:{value:(_vm.tipoAcao.tipo),callback:function ($$v) {_vm.$set(_vm.tipoAcao, "tipo", $$v)},expression:"tipoAcao.tipo"}},_vm._l((_vm.tipos),function(opt,index){return _c('md-option',{key:index,attrs:{"value":opt.tipo}},[_vm._v("\n            "+_vm._s(opt.descricao)+"\n          ")])}),1)],1)],1)]):_vm._e(),_vm._v(" "),_c('md-dialog',{ref:_vm.dialog.ref,attrs:{"md-open-from":("#" + (_vm.dialog.from)),"md-close-to":("#" + (_vm.dialog.from))}},[_c('md-dialog-title',[_vm._v(_vm._s(_vm.dialog.title))]),_vm._v(" "),_c('md-dialog-content',[_vm._v(_vm._s(_vm.dialog.content))]),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",attrs:{"disabled":_vm.disableButton},nativeOn:{"click":function($event){return _vm.closeDialog('dialog1')}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.cancelar'))+"\n      ")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary",attrs:{"disabled":_vm.disableButton},nativeOn:{"click":function($event){return _vm.closeDialog('dialog1', _vm.dialog.action)}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.sim'))+"\n      ")])],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TipoAcaoTabela_vue_vue_type_template_id_0615e58f_lang_html___ = __webpack_require__(1526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TipoAcaoTabela_vue_vue_type_script_lang_js___ = __webpack_require__(643);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__TipoAcaoTabela_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__TipoAcaoTabela_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__TipoAcaoTabela_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__TipoAcaoTabela_vue_vue_type_template_id_0615e58f_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__TipoAcaoTabela_vue_vue_type_template_id_0615e58f_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoAcaoTabela_vue_vue_type_template_id_0615e58f_lang_html___ = __webpack_require__(1527);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoAcaoTabela_vue_vue_type_template_id_0615e58f_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoAcaoTabela_vue_vue_type_template_id_0615e58f_lang_html___["b"]; });


/***/ }),
/* 1527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"tabindex":"100"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.preventDefault();return _vm.onArrowUpPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.preventDefault();return _vm.onArrowDownPress($event)}]}},[_c('md-dialog',{ref:_vm.dialog.ref,attrs:{"md-open-from":("#" + (_vm.dialog.from))}},[_c('md-dialog-title',[_vm._v(_vm._s(_vm.dialog.title))]),_vm._v(" "),_c('md-dialog-content',[_vm._v(_vm._s(_vm.dialog.content))]),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",nativeOn:{"click":function($event){return _vm.closeDialog('dialog1')}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.cancelar'))+"\n      ")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary",nativeOn:{"click":function($event){return _vm.closeDialog('dialog1', _vm.dialog.action)}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.sim'))+"\n      ")])],1)],1),_vm._v(" "),(_vm.isHeaderAvailable)?_c('md-table-card',[_c('md-toolbar',[_c('h1',{staticClass:"md-title",domProps:{"textContent":_vm._s(_vm.title)}}),_vm._v(" "),_c('md-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.canAccessCRUD),expression:"canAccessCRUD"}],staticClass:"md-icon-button",attrs:{"disabled":_vm.blockExportButton},nativeOn:{"click":function($event){return _vm.exportData($event)}}},[_c('md-icon',[_vm._v("get_app")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"top"}},[_vm._v(_vm._s(_vm.$t('label.exportar_conteudo')))])],1),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",attrs:{"id":"tipoAcao-table-button-search"},nativeOn:{"click":function($event){return _vm.focusSearchInput('inputSearch')}}},[_c('md-icon',[_vm._v("search")])],1),_vm._v(" "),_c('md-select',{staticClass:"TabelaGenerica__Filters__Select md-hide-medium",attrs:{"md-menu-class":"md-pagination-select","id":"movie"},model:{value:(_vm.paginationSize),callback:function ($$v) {_vm.paginationSize=$$v},expression:"paginationSize"}},[_c('md-option',{attrs:{"value":5}},[_vm._v(_vm._s(_vm.$t('label.buscar_5_itens')))]),_vm._v(" "),_c('md-option',{attrs:{"value":10}},[_vm._v(_vm._s(_vm.$t('label.buscar_10_itens')))]),_vm._v(" "),_c('md-option',{attrs:{"value":15}},[_vm._v(_vm._s(_vm.$t('label.buscar_15_itens')))]),_vm._v(" "),_c('md-option',{attrs:{"value":20}},[_vm._v(_vm._s(_vm.$t('label.buscar_20_itens')))]),_vm._v(" "),_c('md-option',{attrs:{"value":50}},[_vm._v(_vm._s(_vm.$t('label.buscar_50_itens')))])],1),_vm._v(" "),(_vm.openSearchToolbar)?_c('div',{staticClass:"TabelaGenerica__SearchWrapper",class:{
          'TabelaGenerica__SearchWrapper--active': _vm.openSearchToolbar,
        }},[_c('md-input-container',{staticClass:"TabelaGenerica__SearchInput md-accent"},[_c('label',[_vm._v(_vm._s(_vm.$t('label.buscar')))]),_vm._v(" "),_c('md-input',{attrs:{"id":"inputSearch","type":"text","autoFocus":"true"},model:{value:(_vm.searchQuery),callback:function ($$v) {_vm.searchQuery=$$v},expression:"searchQuery"}}),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",nativeOn:{"click":function($event){return _vm.closeSearchHeader($event)}}},[_c('md-icon',[_vm._v("close")])],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('md-table-alternate-header',{attrs:{"md-selected-label":_vm.selecionadoLabel()}},[_c('md-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.canAccessCRUD),expression:"canAccessCRUD"}],staticClass:"md-icon-button",attrs:{"id":"blockbtn"},nativeOn:{"click":function($event){return _vm.openBlockDialog('dialog1', 'blockbtn')}}},[_c('md-icon',[_vm._v("block")])],1)],1),_vm._v(" "),_c('div',{staticClass:"TabelaGenerica__TableWrapper"},[_c('md-table',{ref:"myTable",staticClass:"TabelaGenerica__Table",attrs:{"md-sort":_vm.sortData.name,"md-sort-type":_vm.sortData.type},on:{"select":_vm.onSelect,"sort":_vm.onSort}},[_c('md-table-header',[_c('md-table-row',_vm._l((_vm.tableHeader),function(head,index){return _c('md-table-head',{key:index,class:head.classes,attrs:{"md-tooltip":head.tooltip,"md-sort-by":head.sortType}},[_vm._v("\n              "+_vm._s(head.name)+"\n            ")])}),1)],1),_vm._v(" "),_c('md-table-body',{attrs:{"tabindex":"110"}},_vm._l((_vm.filteredList),function(row,rowIndex){return _c('md-table-row',{key:rowIndex,class:{
              'TabelaGenerica__TableRow--highlight': _vm.currentEditItem && _vm.currentEditItem === row,
              'TabelaGenerica__TableRow--disabled': !row.indAtivo,
            },attrs:{"md-item":row,"md-selection":""}},[(_vm.isColumnVisible('idExterno'))?_c('md-table-cell',{class:{
                'md-hide-medium': _vm.hideOnMedium('idExterno'),
              },attrs:{"md-numeric":_vm.isNumericField('idExterno')},nativeOn:{"mouseover":function($event){return _vm.onCelMouseEnter(row, 'idExterno')},"mouseleave":function($event){return _vm.onCelMouseLeave($event)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onKeyEscPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onKeyEnterPress($event)}]}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'idExterno')),expression:"!(currentEditItem && currentEditItem === row && currentColumn === 'idExterno')"}]},[_vm._v("\n                "+_vm._s(row.idExterno)+"\n              ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.canAccessCRUD && _vm.editItem === row && !_vm.currentEditItem && _vm.currentColumn === 'idExterno'),expression:"canAccessCRUD && editItem === row && !currentEditItem && currentColumn === 'idExterno'"}],staticClass:"TabelaGenerica__ChangeOnHover"},[_c('md-button',{staticClass:"md-icon-button md-dense",nativeOn:{"click":function($event){return _vm.onClickEdit(row, row.idExterno)}}},[_c('md-icon',[_vm._v("edit")])],1)],1),_vm._v(" "),(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'idExterno')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.edition),expression:"edition"}],ref:"currentinput",refInFor:true,staticClass:"TabelaGenerica__EditInput",attrs:{"type":"text","name":"","autofocus":""},domProps:{"value":(_vm.edition)},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }$event.stopPropagation();$event.preventDefault();return _vm.onTabPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateItem(row, 'idExterno')}],"blur":_vm.cleanEdition,"input":function($event){if($event.target.composing){ return; }_vm.edition=$event.target.value}},nativeOn:{"focus":function($event){return _vm.onCelMouseEnter(row.idExterno, 'idExterno')}}}):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('nome'))?_c('md-table-cell',{class:{
                'md-hide-medium': _vm.hideOnMedium('nome'),
              },attrs:{"md-numeric":_vm.isNumericField('nome')},nativeOn:{"mouseover":function($event){return _vm.onCelMouseEnter(row, 'nome')},"mouseleave":function($event){return _vm.onCelMouseLeave($event)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onKeyEscPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onKeyEnterPress($event)}]}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'nome')),expression:"!(currentEditItem && currentEditItem === row && currentColumn === 'nome')"}]},[_vm._v("\n                "+_vm._s(row.nome)+"\n              ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.canAccessCRUD && _vm.editItem === row && !_vm.currentEditItem && _vm.currentColumn === 'nome'),expression:"canAccessCRUD && editItem === row && !currentEditItem && currentColumn === 'nome'"}],staticClass:"TabelaGenerica__ChangeOnHover"},[_c('md-button',{staticClass:"md-icon-button md-dense",nativeOn:{"click":function($event){return _vm.onClickEdit(row, row.nome)}}},[_c('md-icon',[_vm._v("edit")])],1)],1),_vm._v(" "),(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'nome')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.edition),expression:"edition"}],ref:"currentinput",refInFor:true,staticClass:"TabelaGenerica__EditInput",attrs:{"type":"text","name":"","autofocus":""},domProps:{"value":(_vm.edition)},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }$event.stopPropagation();$event.preventDefault();return _vm.onTabPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateItem(row, 'nome')}],"blur":_vm.cleanEdition,"input":function($event){if($event.target.composing){ return; }_vm.edition=$event.target.value}},nativeOn:{"focus":function($event){return _vm.onCelMouseEnter(row.nome, 'nome')}}}):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('tipo'))?_c('md-table-cell',{class:{
                'md-hide-medium': _vm.hideOnMedium('tipo'),
              },attrs:{"md-numeric":_vm.isNumericField('tipo')},nativeOn:{"mouseover":function($event){return _vm.onCelMouseEnter(row, 'tipo')},"mouseleave":function($event){return _vm.onCelMouseLeave($event)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onKeyEscPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onKeyEnterPress($event)}]}},[(!(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'tipo') && row.tipo !== '-')?_c('span',{domProps:{"textContent":_vm._s(_vm.$t(("label." + (row.tipo.toLowerCase()))))}}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.canAccessCRUD && _vm.editItem === row && !_vm.currentEditItem && _vm.currentColumn === 'tipo'),expression:"canAccessCRUD && editItem === row && !currentEditItem && currentColumn === 'tipo'"}],staticClass:"TabelaGenerica__ChangeOnHover"},[_c('md-button',{staticClass:"md-icon-button md-dense",nativeOn:{"click":function($event){return _vm.onClickEdit(row, row.tipo)}}},[_c('md-icon',[_vm._v("edit")])],1)],1),_vm._v(" "),(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'tipo')?_c('md-select',{ref:"currentinput",refInFor:true,attrs:{"name":"tipo","id":"tipo"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateItem(row, 'tipo')}},nativeOn:{"focus":function($event){return _vm.onCelMouseEnter(row.tipo, 'tipo')}},model:{value:(_vm.edition),callback:function ($$v) {_vm.edition=$$v},expression:"edition"}},_vm._l((_vm.tipos),function(opt,index){return _c('md-option',{key:index,attrs:{"value":opt.tipo},on:{"selected":function($event){return _vm.updateItem(row, 'tipo')}}},[_vm._v("\n                  "+_vm._s(opt.descricao)+"\n                ")])}),1):_vm._e()],1):_vm._e()],1)}),1),_vm._v(" "),_c('infinite-loading',{ref:"infiniteLoading",attrs:{"distance":30,"on-infinite":_vm.onInfinite}},[_c('div',{attrs:{"slot":"spinner"},slot:"spinner"})])],1),_vm._v(" "),_c('h4',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isContentAvailable),expression:"!isContentAvailable"}],staticClass:"TabelaGenerica__NoContent"},[_vm._v("\n          "+_vm._s(_vm.$t('label.tabela_sem_conteudo'))+"\n      ")]),_vm._v(" "),_c('md-spinner',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLoading),expression:"showLoading"}],staticClass:"TabelaGenerica__InterminateLoader",attrs:{"slot":"spinner","md-indeterminate":""},slot:"spinner"})],1)],1):_vm._e()],1)}
var staticRenderFns = []



/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TipoInvestimento = __webpack_require__(1529);

var _TipoInvestimento2 = _interopRequireDefault(_TipoInvestimento);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  path: 'tipo-investimento',
  name: 'tipo-investimento',
  component: _TipoInvestimento2.default
};

/***/ }),
/* 1529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TipoInvestimento_vue_vue_type_template_id_88767050_lang_html___ = __webpack_require__(1530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TipoInvestimento_vue_vue_type_script_lang_js___ = __webpack_require__(645);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__TipoInvestimento_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__TipoInvestimento_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__TipoInvestimento_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__TipoInvestimento_vue_vue_type_template_id_88767050_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__TipoInvestimento_vue_vue_type_template_id_88767050_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoInvestimento_vue_vue_type_template_id_88767050_lang_html___ = __webpack_require__(1531);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoInvestimento_vue_vue_type_template_id_88767050_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoInvestimento_vue_vue_type_template_id_88767050_lang_html___["b"]; });


/***/ }),
/* 1531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canAccessPage)?_c('div',[_c('v-row',[(!_vm.somenteLeitura)?_c('v-col',{staticClass:"pt-0",attrs:{"cols":"12","sm":"3"}},[_c('tipo-investimento-form',{ref:"tipoInvestimentoForm",on:{"FORMULARIO_SALVAR":_vm.onNovo,"FORMULARIO_CANCELAR":_vm.onCancelar}})],1):_vm._e(),_vm._v(" "),_c('v-col',{staticClass:"pt-0",attrs:{"cols":"12","md":_vm.somenteLeitura ? 12 : 9}},[_c('tipo-investimento-tabela',{ref:"tipoInvestimentoTabela",staticClass:"CRUDGenerico__ContentTable",attrs:{"title":_vm.$tc('label.tipo_investimento', 2)},on:{"PESQUISA_EDITAR":_vm.onEditar}})],1)],1)],1):_vm._e()}
var staticRenderFns = []



/***/ }),
/* 1532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TipoInvestimentoForm_vue_vue_type_template_id_f6f2e13e_lang_html___ = __webpack_require__(1533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TipoInvestimentoForm_vue_vue_type_script_lang_js___ = __webpack_require__(647);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__TipoInvestimentoForm_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__TipoInvestimentoForm_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__TipoInvestimentoForm_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__TipoInvestimentoForm_vue_vue_type_template_id_f6f2e13e_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__TipoInvestimentoForm_vue_vue_type_template_id_f6f2e13e_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoInvestimentoForm_vue_vue_type_template_id_f6f2e13e_lang_html___ = __webpack_require__(1534);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoInvestimentoForm_vue_vue_type_template_id_f6f2e13e_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoInvestimentoForm_vue_vue_type_template_id_f6f2e13e_lang_html___["b"]; });


/***/ }),
/* 1534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{ref:"form",attrs:{"lazy-validation":""}},[_c('v-card',[_c('v-card-title',[_c('h2',{staticClass:"mb-0",staticStyle:{"font-size":"18px","width":"100%"}},[_vm._v(_vm._s(_vm.ehEdicao ? _vm.$t('title.editar_tipo_investimento') : _vm.$t('title.cadastrar_novo_tipo_investimento')))])]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-xl":"","fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-text-field',{staticClass:"Form-text__invalid",attrs:{"id":"tipo_investimento_codigo","name":"tipo_investimento_codigo","label":((_vm.$t('label.codigo')) + " *"),"counter":10,"maxlength":"10","rules":[_vm.rules.required],"required":""},model:{value:(_vm.tipoInvestimento.idExterno),callback:function ($$v) {_vm.$set(_vm.tipoInvestimento, "idExterno", $$v)},expression:"tipoInvestimento.idExterno"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12"}},[_c('v-text-field',{staticClass:"Form-text__invalid",attrs:{"id":"tipo_investimento_nome","name":"tipo_investimento_nome","label":((_vm.$t('label.nome')) + " *"),"counter":50,"maxlength":"50","rules":[_vm.rules.required],"required":""},model:{value:(_vm.tipoInvestimento.nome),callback:function ($$v) {_vm.$set(_vm.tipoInvestimento, "nome", $$v)},expression:"tipoInvestimento.nome"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"id":"tipo-investimento-btn-cancelar"},nativeOn:{"click":function($event){return _vm.cancel($event)}}},[_vm._v(_vm._s(_vm.$t('label.cancelar')))]),_vm._v(" "),_c('v-btn',{attrs:{"id":"tipo-investimento-btn-salvar","color":"primary"},nativeOn:{"click":function($event){return _vm.openSaveDialog($event)}}},[_vm._v(_vm._s(_vm.$t('label.salvar')))])],1)],1),_vm._v(" "),_c('confirm',{ref:"confirmDialog",attrs:{"message":_vm.dialog.content,"persistent":true},on:{"agree":function($event){return _vm.save()}}})],1)}
var staticRenderFns = []



/***/ }),
/* 1535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TipoInvestimentoTabela_vue_vue_type_template_id_4f1c5906_lang_html___ = __webpack_require__(1536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TipoInvestimentoTabela_vue_vue_type_script_lang_js___ = __webpack_require__(649);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__TipoInvestimentoTabela_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__TipoInvestimentoTabela_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_components_generico_CRUDGenerico_css_vue_type_style_index_0_lang_css___ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__TipoInvestimentoTabela_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__TipoInvestimentoTabela_vue_vue_type_template_id_4f1c5906_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__TipoInvestimentoTabela_vue_vue_type_template_id_4f1c5906_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoInvestimentoTabela_vue_vue_type_template_id_4f1c5906_lang_html___ = __webpack_require__(1537);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoInvestimentoTabela_vue_vue_type_template_id_4f1c5906_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoInvestimentoTabela_vue_vue_type_template_id_4f1c5906_lang_html___["b"]; });


/***/ }),
/* 1537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"card-size"},[_c('v-card-title',[_c('h2',{staticClass:"headline mb-0",domProps:{"textContent":_vm._s(_vm.title)}})]),_vm._v(" "),_c('v-container',{staticClass:"py-0",attrs:{"fluid":""}},[_c('v-row',[_c('v-spacer'),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({directives:[{name:"show",rawName:"v-show",value:(!_vm.somenteLeitura && _vm.selected.length > 0),expression:"!somenteLeitura && selected.length > 0"}],staticClass:"mx-0 mt-5",attrs:{"icon":"","id":"tipo-investimento-botao-ativar-inativar"},on:{"click":_vm.ativarDesativarRegistros}},on),[_c('v-icon',[_vm._v("block")])],1)]}}])},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.ativar_inativa')))])]),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"mx-0 mt-5",attrs:{"icon":"","id":"tipo-investimento-botao-exportar"},on:{"click":_vm.exportar}},on),[_c('v-icon',[_vm._v("get_app")])],1)]}}])},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.exportar')))])]),_vm._v(" "),_c('v-col',{staticClass:"mr-3 py-0",attrs:{"cols":"12","sm":"6","md":"3"}},[_c('v-text-field',{attrs:{"id":"tipo-investimento-campo-pesquisar","append-icon":"search","label":_vm.$t('label.pesquisar'),"single-line":"","clearable":"","hide-details":""},on:{"input":_vm.filtrar},model:{value:(_vm.searchQuery),callback:function ($$v) {_vm.searchQuery=$$v},expression:"searchQuery"}})],1)],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"text-sm-left",attrs:{"headers":_vm.headers,"items":_vm.tipos,"show-select":"","options":_vm.pagination,"server-items-length":_vm.totalPage,"no-data-text":_vm.$t('label.tabela_sem_conteudo'),"footer-props":{
        itemsPerPageOptions: [10, 25, 50],
      }},on:{"update:options":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"item.acoes",fn:function(ref){
      var item = ref.item;
return [(!_vm.somenteLeitura)?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
      var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.onEditar(item)}}},on),[_c('v-icon',[_vm._v("edit")])],1)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.editar')))])]):_vm._e()]}},{key:"item.id_externo",fn:function(ref){
      var item = ref.item;
return [_vm._v("\n        "+_vm._s(item.idExterno)+"\n      ")]}},{key:"item.ind_ativo",fn:function(ref){
      var item = ref.item;
return [_vm._v("\n        "+_vm._s(item.indAtivo ? _vm.$t('label.sim') : _vm.$t('label.nao'))+"\n      ")]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TipoOrcamento = __webpack_require__(1539);

var _TipoOrcamento2 = _interopRequireDefault(_TipoOrcamento);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  path: 'tipo-orcamento',
  name: 'tipo-orcamento',
  component: _TipoOrcamento2.default
};

/***/ }),
/* 1539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TipoOrcamento_vue_vue_type_template_id_fea3aa70_lang_html___ = __webpack_require__(1540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TipoOrcamento_vue_vue_type_script_lang_js___ = __webpack_require__(651);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__TipoOrcamento_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__TipoOrcamento_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__TipoOrcamento_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__TipoOrcamento_vue_vue_type_template_id_fea3aa70_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__TipoOrcamento_vue_vue_type_template_id_fea3aa70_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoOrcamento_vue_vue_type_template_id_fea3aa70_lang_html___ = __webpack_require__(1541);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoOrcamento_vue_vue_type_template_id_fea3aa70_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoOrcamento_vue_vue_type_template_id_fea3aa70_lang_html___["b"]; });


/***/ }),
/* 1541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CRUDGenerico__Wrapper"},[(_vm.canAccessPage)?_c('md-layout',{staticClass:"md-gutter-16",attrs:{"md-row":""}},[(_vm.canAccessCRUD)?_c('md-layout',{staticClass:"CRUDGenerico__SideMenu md-hide-medium",attrs:{"md-column":""}},[_c('side-column',{attrs:{"fetch-function":_vm.tipoInvestimentoResources.listarAtivos,"prepareResponseData":_vm.prepareResponseData},on:{"SIDECOLUMN_SAVE_ACTION":_vm.requestAdicionar}})],1):_vm._e(),_vm._v(" "),(_vm.canAccessCRUD)?_c('md-dialog',{ref:"dialog1",attrs:{"md-open-from":"#fab","md-close-to":"#fab"}},[_c('side-column',{attrs:{"fetch-function":_vm.tipoInvestimentoResources.listarAtivos,"prepareResponseData":_vm.prepareResponseData},on:{"SIDECOLUMN_CANCEL_ACTION":function($event){return _vm.closeDialog('dialog1')},"SIDECOLUMN_SAVE_ACTION":_vm.closeDialogSave}})],1):_vm._e(),_vm._v(" "),_c('md-layout',{staticClass:"CRUDGenerico__TableWrapper",attrs:{"md-flex":""}},[_c('tipo-orcamento-tabela',{staticClass:"CRUDGenerico__ContentTable",attrs:{"title":_vm.$t('label.tipo_orcamento'),"table-rows":_vm.tableRows,"table-header":_vm.tableHeader,"fetch-function":_vm.tipoInvestimentoResources.listarAtivos,"prepareResponseData":_vm.prepareResponseData,"visible-columns":['idExterno', 'descricao', 'tiposInvestimento'],"mobile-invisible-columns":['dependencias'],"ignore-columns":['id', 'idNivelExtensao', 'indAtivo']},on:{"TABELAGENERICA_ATUALIZAR":_vm.requestAtualizar,"TABELAGENERICA_BLOQUEAR_SELECIONADOS":_vm.ativarInativar,"TABELAGENERICA_BUSCAR_PROXIMA_PAGINA":_vm.requestPopular,"TABELAGENERICA_EXPORTAR_DADOS":_vm.requestExportacao,"TABELAGENERICA_ORDENAR":_vm.organizar}})],1)],1):_vm._e(),_vm._v(" "),(_vm.canAccessCRUD)?_c('md-button',{staticClass:"md-fab md-fab-bottom-right md-hide-large-and-up",staticStyle:{"position":"fixed","z-index":"5"},attrs:{"id":"fab"},nativeOn:{"click":function($event){return _vm.openDialog('dialog1')}}},[_c('md-icon',[_vm._v("add")])],1):_vm._e()],1)}
var staticRenderFns = []



/***/ }),
/* 1542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SideColumn_vue_vue_type_template_id_33f9f3b1_lang_html___ = __webpack_require__(1543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SideColumn_vue_vue_type_script_lang_js___ = __webpack_require__(653);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__SideColumn_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__SideColumn_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__SideColumn_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__SideColumn_vue_vue_type_template_id_33f9f3b1_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__SideColumn_vue_vue_type_template_id_33f9f3b1_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SideColumn_vue_vue_type_template_id_33f9f3b1_lang_html___ = __webpack_require__(1544);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SideColumn_vue_vue_type_template_id_33f9f3b1_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_SideColumn_vue_vue_type_template_id_33f9f3b1_lang_html___["b"]; });


/***/ }),
/* 1544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-card',[(_vm.canAccessCRUD)?_c('register-form',{attrs:{"title":_vm.$t('title.cadastrar_novo_tipo_orcamento'),"cancel":_vm.cancel,"save":_vm.openSaveDialog}},[_c('div',{attrs:{"slot":"content"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.openSaveDialog(_vm.dialog.ref, 'saveRegisterFromButton')}},slot:"content"},[_c('md-input-container',{ref:"containerIdExterno",class:{
          'md-input-invalid': _vm.errors.has('tipoOrcamento_code')
        }},[_c('label',[_vm._v(_vm._s(_vm.$t('label.cod_tipo_orcamento')))]),_vm._v(" "),_c('md-input',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"type":"text","required":"","tabindex":"1","name":"tipoOrcamento_code","data-vv-name":"tipoOrcamento_code","data-vv-rules":"required","maxlength":"10"},model:{value:(_vm.tipoOrcamento.idExterno),callback:function ($$v) {_vm.$set(_vm.tipoOrcamento, "idExterno", $$v)},expression:"tipoOrcamento.idExterno"}}),_vm._v(" "),_c('span',{staticClass:"md-error"},[_vm._v("\n          "+_vm._s(_vm.errors.first('tipoOrcamento_code'))+"\n        ")])],1),_vm._v(" "),_c('md-input-container',{ref:"containerOrcamento",class:{
          'md-input-invalid': _vm.errors.has('tipoOrcamento_name')
        }},[_c('label',[_vm._v(_vm._s(_vm.$t('label.nome')))]),_vm._v(" "),_c('md-input',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"type":"text","required":"","tabindex":"2","name":"tipoOrcamento_name","data-vv-name":"tipoOrcamento_name","data-vv-rules":"required","maxlength":"100"},model:{value:(_vm.tipoOrcamento.nome),callback:function ($$v) {_vm.$set(_vm.tipoOrcamento, "nome", $$v)},expression:"tipoOrcamento.nome"}}),_vm._v(" "),_c('span',{staticClass:"md-error"},[_vm._v("\n          "+_vm._s(_vm.errors.first('tipoOrcamento_name'))+"\n        ")])],1),_vm._v(" "),_c('md-input-container',{class:{
          'md-input-invalid': _vm.errors.has('tipoOrcamento_tipoInvestimento')
        }},[_c('md-chips-autocomplete',{directives:[{name:"validate",rawName:"v-validate"}],ref:"tipoLinhaOrcamento",attrs:{"required":"","tabindex":"3","name":"tipoOrcamento_tipoInvestimento","data-vv-name":"tipoOrcamento_tipoInvestimento","data-vv-rules":"required","fetch":_vm.fetchFunction,"min-chars":2,"mdInputPlaceholder":_vm.$tc('label.tipo_investimento', 2),"printAttribute":"nome","prepareResponseData":_vm.prepareResponseData,"query-param":"nome"},on:{"change":_vm.addTipoInvestimentoChip},model:{value:(_vm.source),callback:function ($$v) {_vm.source=$$v},expression:"source"}}),_vm._v(" "),_c('span',{staticClass:"md-error"},[_vm._v("\n          "+_vm._s(_vm.errors.first('tipoOrcamento_tipoInvestimento'))+"\n        ")])],1)],1)]):_vm._e(),_vm._v(" "),_c('md-dialog',{ref:_vm.dialog.ref,attrs:{"md-open-from":("#" + (_vm.dialog.from)),"md-close-to":("#" + (_vm.dialog.from))}},[_c('md-dialog-title',[_vm._v(_vm._s(_vm.dialog.title))]),_vm._v(" "),_c('md-dialog-content',[_vm._v(_vm._s(_vm.dialog.content))]),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",attrs:{"id":"tipoOrcamento-side-dialog-button-cancel","disabled":_vm.disableButton},nativeOn:{"click":function($event){return _vm.closeDialog('dialog1')}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.cancelar'))+"\n      ")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary",attrs:{"id":"tipoOrcamento-side-dialog-button-save","disabled":_vm.disableButton},nativeOn:{"click":function($event){return _vm.closeDialog('dialog1', _vm.dialog.action)}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.sim'))+"\n      ")])],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TipoOrcamentoTabela_vue_vue_type_template_id_20755927_lang_html___ = __webpack_require__(1546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TipoOrcamentoTabela_vue_vue_type_script_lang_js___ = __webpack_require__(655);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__TipoOrcamentoTabela_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__TipoOrcamentoTabela_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TipoOrcamentoTabela_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(1548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__TipoOrcamentoTabela_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__TipoOrcamentoTabela_vue_vue_type_template_id_20755927_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__TipoOrcamentoTabela_vue_vue_type_template_id_20755927_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoOrcamentoTabela_vue_vue_type_template_id_20755927_lang_html___ = __webpack_require__(1547);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoOrcamentoTabela_vue_vue_type_template_id_20755927_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoOrcamentoTabela_vue_vue_type_template_id_20755927_lang_html___["b"]; });


/***/ }),
/* 1547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"tabindex":"100"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.preventDefault();return _vm.onArrowUpPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.preventDefault();return _vm.onArrowDownPress($event)}]}},[_c('md-dialog',{ref:_vm.dialog.ref,attrs:{"md-open-from":("#" + (_vm.dialog.from))}},[_c('md-dialog-title',[_vm._v(_vm._s(_vm.dialog.title))]),_vm._v(" "),_c('md-dialog-content',[_vm._v(_vm._s(_vm.dialog.content))]),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",attrs:{"id":"tipoOrcamento-table-dialog-button-cancel"},nativeOn:{"click":function($event){return _vm.closeDialog('dialog1')}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.cancelar'))+"\n      ")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary",attrs:{"id":"tipoOrcamento-table-dialog-button-save"},nativeOn:{"click":function($event){return _vm.closeDialog('dialog1', _vm.dialog.action)}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.sim'))+"\n      ")])],1)],1),_vm._v(" "),(_vm.isHeaderAvailable)?_c('md-table-card',[_c('md-toolbar',[_c('h1',{staticClass:"md-title",domProps:{"textContent":_vm._s(_vm.title)}}),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",attrs:{"id":"tipoOrcamento-table-button-search"},nativeOn:{"click":function($event){return _vm.focusSearchInput('tipoOrcamento-table-input-search')}}},[_c('md-icon',[_vm._v("search")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"top"}},[_vm._v(_vm._s(_vm.$t('label.buscar')))])],1),_vm._v(" "),(_vm.openSearchToolbar)?_c('div',{staticClass:"TabelaGenerica__SearchWrapper",class:{
          'TabelaGenerica__SearchWrapper--active': _vm.openSearchToolbar,
        }},[_c('md-input-container',{staticClass:"TabelaGenerica__SearchInput md-accent"},[_c('label',[_vm._v(_vm._s(_vm.$t('label.buscar')))]),_vm._v(" "),_c('md-input',{attrs:{"autoFocus":"true","id":"tipoOrcamento-table-input-search","type":"text"},model:{value:(_vm.searchQuery),callback:function ($$v) {_vm.searchQuery=$$v},expression:"searchQuery"}}),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",attrs:{"id":"tipoOrcamento-table-button-search-close"},nativeOn:{"click":function($event){return _vm.closeSearchHeader($event)}}},[_c('md-icon',[_vm._v("close")])],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('md-table-alternate-header',{attrs:{"md-selected-label":_vm.selecionadoLabel()}},[_c('md-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.canAccessCRUD),expression:"canAccessCRUD"}],staticClass:"md-icon-button",attrs:{"id":"blockbtn"},nativeOn:{"click":function($event){return _vm.openBlockDialog('dialog1', 'blockbtn')}}},[_c('md-icon',[_vm._v("block")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"top"}},[_vm._v(_vm._s(_vm.$t('label.ativar_inativa')))])],1)],1),_vm._v(" "),_c('div',{staticClass:"TabelaGenerica__TableWrapper TIPOORCAMENTOTABELA_TABLE"},[_c('md-table',{ref:"myTable",staticClass:"TabelaGenerica__Table ",attrs:{"md-sort":_vm.sortData.name,"md-sort-type":_vm.sortData.type},on:{"select":_vm.onSelect,"sort":_vm.onSort}},[(_vm.isHeaderAvailable)?_c('md-table-header',[_c('md-table-row',_vm._l((_vm.tableHeader),function(head,index){return _c('md-table-head',{key:index,class:head.classes,attrs:{"id":("tipoOrcamento-table-head-" + index),"md-tooltip":head.tooltip,"md-sort-by":head.sortType}},[_vm._v("\n              "+_vm._s(head.name)+"\n            ")])}),1)],1):_vm._e(),_vm._v(" "),(_vm.isContentAvailable)?_c('md-table-body',{attrs:{"tabindex":"110"}},[_vm._l((_vm.tipoOrcamentoFilteredList),function(row,rowIndex){return _c('md-table-row',{key:rowIndex,class:{
              'TabelaGenerica__TableRow--highlight': _vm.currentEditItem && _vm.currentEditItem === row,
              'TabelaGenerica__TableRow--disabled': !row.indAtivo,
            },attrs:{"md-item":row,"md-selection":""}},[(_vm.isColumnVisible('idExterno'))?_c('md-table-cell',{key:'idExterno',class:{
                  'md-hide-medium': _vm.hideOnMedium('idExterno'),
              },attrs:{"md-numeric":_vm.isNumericField('idExterno')},nativeOn:{"mouseover":function($event){return _vm.onCelMouseEnter(row, 'idExterno')},"mouseleave":function($event){return _vm.onCelMouseLeave($event)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onKeyEscPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateItem(row, rowIndex, 'idExterno')}]}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'idExterno')),expression:"!(currentEditItem && currentEditItem === row && currentColumn === 'idExterno')"}]},[_vm._v("\n                "+_vm._s(row.idExterno)+"\n              ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.canAccessCRUD && _vm.editItem === row && !_vm.currentEditItem && _vm.currentColumn === 'idExterno'),expression:"canAccessCRUD && editItem === row && !currentEditItem && currentColumn === 'idExterno'"}],staticClass:"TabelaGenerica__ChangeOnHover"},[_c('md-button',{staticClass:"md-icon-button md-dense",attrs:{"id":("tipoOrcamento-table-button-edit-" + rowIndex)},nativeOn:{"click":function($event){return _vm.onClickEdit(row, row['idExterno'])}}},[_c('md-icon',[_vm._v("edit")])],1)],1),_vm._v(" "),(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'idExterno')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.edition),expression:"edition"}],ref:"currentinput",refInFor:true,staticClass:"TabelaGenerica__EditInput",attrs:{"type":"text","name":("tipoOrcamento-table-button-edit-idExterno-" + rowIndex),"autofocus":""},domProps:{"value":(_vm.edition)},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }$event.stopPropagation();$event.preventDefault();return _vm.onTabPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.stopPropagation();return _vm.updateItem(row, 'idExterno')}],"blur":_vm.cleanEdition,"input":function($event){if($event.target.composing){ return; }_vm.edition=$event.target.value}},nativeOn:{"focus":function($event){return _vm.onCelMouseEnter(row.idExterno, 'idExterno')}}}):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('descricao'))?_c('md-table-cell',{key:'descricao',class:{
                'md-hide-medium': _vm.hideOnMedium('descricao'),
              },attrs:{"md-numeric":_vm.isNumericField('descricao')},nativeOn:{"mouseover":function($event){return _vm.onCelMouseEnter(row, 'descricao')},"mouseleave":function($event){return _vm.onCelMouseLeave($event)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onKeyEscPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateItem(row, rowIndex, 'descricao')}]}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'descricao')),expression:"!(currentEditItem && currentEditItem === row && currentColumn === 'descricao')"}]},[_vm._v("\n                "+_vm._s(row.descricao)+"\n              ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.canAccessCRUD && _vm.editItem === row && !_vm.currentEditItem && _vm.currentColumn === 'descricao'),expression:"canAccessCRUD && editItem === row && !currentEditItem && currentColumn === 'descricao'"}],staticClass:"TabelaGenerica__ChangeOnHover"},[_c('md-button',{staticClass:"md-icon-button md-dense",nativeOn:{"click":function($event){return _vm.onClickEdit(row, row['descricao'])}}},[_c('md-icon',[_vm._v("edit")])],1)],1),_vm._v(" "),(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'descricao')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.edition),expression:"edition"}],ref:"currentinput",refInFor:true,staticClass:"TabelaGenerica__EditInput",attrs:{"type":"text","name":("tipoOrcamento-table-button-edit-descricao-" + rowIndex),"autofocus":""},domProps:{"value":(_vm.edition)},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }$event.stopPropagation();$event.preventDefault();return _vm.onTabPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.stopPropagation();return _vm.updateItem(row, 'descricao')}],"input":function($event){if($event.target.composing){ return; }_vm.edition=$event.target.value}},nativeOn:{"focus":function($event){return _vm.onCelMouseEnter(row.descricao, 'descricao')}}}):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isColumnVisible('tiposInvestimento'))?_c('md-table-cell',{key:'tiposInvestimento',class:{
                'md-hide-medium': _vm.hideOnMedium('tiposInvestimento'),
              },attrs:{"md-numeric":_vm.isNumericField('tiposInvestimento')},nativeOn:{"mouseover":function($event){return _vm.onCelMouseEnter(row, 'tiposInvestimento')},"mouseleave":function($event){return _vm.onCelMouseLeave($event)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onKeyEscPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateItem(row, rowIndex, 'tiposInvestimento')}]}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'tiposInvestimento')),expression:"!(currentEditItem && currentEditItem === row && currentColumn === 'tiposInvestimento')"}]},[_vm._v("\n                "+_vm._s(_vm.extractTipoInvestimentoName(row))+"\n              ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.canAccessCRUD && _vm.editItem === row && !_vm.currentEditItem && _vm.currentColumn === 'tiposInvestimento'),expression:"canAccessCRUD && editItem === row && !currentEditItem && currentColumn === 'tiposInvestimento'"}],staticClass:"TabelaGenerica__ChangeOnHover"},[_c('md-button',{staticClass:"md-icon-button md-dense",nativeOn:{"click":function($event){return _vm.onClickEdit(row, row.listaTiposInvestimento)}}},[_c('md-icon',[_vm._v("edit")])],1)],1),_vm._v(" "),(_vm.currentEditItem && _vm.currentEditItem === row && _vm.currentColumn === 'tiposInvestimento')?_c('md-input-container',[_c('md-chips-autocomplete',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"required":"","tabindex":"3","name":("tipoOrcamento_tipoInvestimento-tiposInvestimento-" + rowIndex),"data-vv-name":"tipoOrcamento_tipoInvestimento","data-vv-rules":"required","fetch":_vm.fetchFunction,"min-chars":2,"mdInputPlaceholder":_vm.$tc('label.tipo_investimento', 2),"printAttribute":"nome","prepareResponseData":_vm.prepareResponseData,"query-param":"nome"},on:{"change":_vm.addTipoInvestimentoChip,"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }$event.stopPropagation();$event.preventDefault();return _vm.onTabPress($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.stopPropagation();return _vm.updateItem(row, 'tiposInvestimento')}]},nativeOn:{"focus":function($event){return _vm.onCelMouseEnter(row.tiposInvestimento, 'tiposInvestimento')}},model:{value:(row.tiposInvestimento),callback:function ($$v) {_vm.$set(row, "tiposInvestimento", $$v)},expression:"row.tiposInvestimento"}})],1):_vm._e()],1):_vm._e()],1)}),_vm._v(" "),_c('infinite-loading',{ref:"infiniteLoading",attrs:{"distance":100,"on-infinite":_vm.onInfinite}},[_c('div',{attrs:{"slot":"spinner"},slot:"spinner"})])],2):_vm._e()],1),_vm._v(" "),_c('h4',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isContentAvailable),expression:"!isContentAvailable"}],staticClass:"TabelaGenerica__NoContent"},[_vm._v("\n        "+_vm._s(_vm.$t('label.tabela_sem_conteudo'))+"\n      ")]),_vm._v(" "),_c('md-spinner',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLoading),expression:"showLoading"}],staticClass:"TabelaGenerica__InterminateLoader",attrs:{"slot":"spinner","md-indeterminate":""},slot:"spinner"})],1)],1):_vm._e()],1)}
var staticRenderFns = []



/***/ }),
/* 1548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoOrcamentoTabela_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoOrcamentoTabela_vue_vue_type_style_index_0_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoOrcamentoTabela_vue_vue_type_style_index_0_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TipoOrcamentoTabela_vue_vue_type_style_index_0_lang_css____default.a); 

/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Transferencia = __webpack_require__(1550);

var _Transferencia2 = _interopRequireDefault(_Transferencia);

var _TransferenciaForm = __webpack_require__(1553);

var _TransferenciaForm2 = _interopRequireDefault(_TransferenciaForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  path: 'transferencia',
  name: 'transferencia',
  component: _Transferencia2.default,
  children: [{
    path: 'nova',
    name: 'novaTransferencia',
    component: _TransferenciaForm2.default,
    props: {
      fluxo: false,
      somenteLeitura: false,
      novo: true
    }
  }, {
    path: ':id',
    name: 'verTransferencia',
    component: _TransferenciaForm2.default,
    props: {
      somenteLeitura: true,
      novo: false,
      fluxo: false
    }
  }, {
    path: ':id/fluxo',
    name: 'verTransferenciaFluxo',
    component: _TransferenciaForm2.default,
    props: {
      somenteLeitura: true,
      novo: false,
      fluxo: true
    }
  }]
};

/***/ }),
/* 1550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Transferencia_vue_vue_type_template_id_10256df0___ = __webpack_require__(1551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__Transferencia_vue_vue_type_template_id_10256df0___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Transferencia_vue_vue_type_template_id_10256df0___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Transferencia_vue_vue_type_template_id_10256df0___ = __webpack_require__(1552);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Transferencia_vue_vue_type_template_id_10256df0___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Transferencia_vue_vue_type_template_id_10256df0___["b"]; });


/***/ }),
/* 1552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c('router-view')],1)}
var staticRenderFns = []



/***/ }),
/* 1553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TransferenciaForm_vue_vue_type_template_id_4d3cdebf_lang_html___ = __webpack_require__(1554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TransferenciaForm_vue_vue_type_script_lang_js___ = __webpack_require__(658);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__TransferenciaForm_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__TransferenciaForm_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__TransferenciaForm_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__TransferenciaForm_vue_vue_type_template_id_4d3cdebf_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__TransferenciaForm_vue_vue_type_template_id_4d3cdebf_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaForm_vue_vue_type_template_id_4d3cdebf_lang_html___ = __webpack_require__(1555);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaForm_vue_vue_type_template_id_4d3cdebf_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaForm_vue_vue_type_template_id_4d3cdebf_lang_html___["b"]; });


/***/ }),
/* 1555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canAccessPage)?_c('section',[_c('register-form',{attrs:{"title":_vm.$t('title.transferencia_verba'),"cancel":_vm.somenteLeitura ? _vm.voltar : _vm.openCancelDialog,"save":_vm.somenteLeitura || !_vm.canPost ? null : _vm.openSaveDialog,"cancelLabel":_vm.$t('label.voltar'),"saveLabel":_vm.$t('label.transferir'),"subtitle":''}},[_c('div',{staticStyle:{"width":"100%"},attrs:{"slot":"content"},slot:"content"},[_c('h3',[_vm._v(_vm._s(_vm.$t('label.origem')))]),_vm._v(" "),(_vm.carregarComponentes)?_c('transferencia-desdobramento',{ref:"desdobramento",attrs:{"somenteLeitura":_vm.somenteLeitura,"idDesdobramento":_vm.transferencia.idDesdobramentoOrigem,"idRepresentante":_vm.transferencia.idControladorOrigem},on:{"TRANSFERENCIAORCAMENTO_SET":_vm.preencherOrcamento,"TRANSFERENCIADESDOBRAMENTO_SET":_vm.preencherDesdobramento,"TRANSFERENCIADESDOBRAMENTO_SET_REPRESENTANTE":_vm.preencherRepresentante,"TRANSFERENCIADESDOBRAMENTO_SET_VALORES":_vm.preencherValores}}):_vm._e(),_vm._v(" "),_c('md-layout',{attrs:{"md-gutter":"16"}},[_c('md-layout',{attrs:{"md-flex":"33","md-flex-medium":"50","md-flex-small":"100","md-flex-xsmall":"100"}},[_c('md-input-container',{class:{
              'md-input-invalid': _vm.errors.has('vlr_transferencia')
            }},[_c('label',[_vm._v(_vm._s(_vm.$t('label.valor_transferencia')))]),_vm._v(" "),_c('InputMoneyOld',{attrs:{"disabled":_vm.somenteLeitura,"tabindex":"6","id":"vlr_transferencia","maxlength":13,"name":"vlr_transferencia","one-way-bind":_vm.transferencia.valor},on:{"change":function (n) { return _vm.transferencia.valor = n; }}}),_vm._v(" "),_c('span',{staticClass:"md-error"},[_vm._v("\n              "+_vm._s(_vm.errors.first('vlr_transferencia'))+"\n            ")])],1)],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-gutter":"16"}},[_c('md-layout',{attrs:{"md-flex-small":"100","md-flex-xsmall":"100"}},[_c('md-input-container',{class:{
              'md-input-invalid': _vm.errors.has('justificativa')
            }},[_c('label',[_vm._v(_vm._s(_vm.$t('label.justificativa')))]),_vm._v(" "),_c('md-textarea',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"id":"justificativa","name":"justificativa","tabindex":"7","maxlength":"250","required":"","data-vv-name":"justificativa","data-vv-rules":"required","disabled":_vm.somenteLeitura},model:{value:(_vm.transferencia.justificativa),callback:function ($$v) {_vm.$set(_vm.transferencia, "justificativa", $$v)},expression:"transferencia.justificativa"}}),_vm._v(" "),_c('span',{staticClass:"md-error"},[_vm._v("\n              "+_vm._s(_vm.errors.first('justificativa'))+"\n            ")])],1)],1),_vm._v(" "),(_vm.transferencia.status === 'REPROVADO')?_c('md-layout',{attrs:{"md-flex-small":"100","md-flex-xsmall":"100"}},[_c('md-input-container',{class:{
              'md-input-invalid': _vm.errors.has('justificativa_reprovacao')
            }},[_c('label',[_vm._v(_vm._s(_vm.$t('label.justificativa_reprovacao')))]),_vm._v(" "),_c('md-textarea',{attrs:{"id":"justificativa_reprovacao","name":"justificativa_reprovacao","tabindex":"-1","disabled":true},model:{value:(_vm.justificativaReprovacao),callback:function ($$v) {_vm.justificativaReprovacao=$$v},expression:"justificativaReprovacao"}}),_vm._v(" "),_c('span',{staticClass:"md-error"},[_vm._v("\n              "+_vm._s(_vm.errors.first('justificativa_reprovacao'))+"\n            ")])],1)],1):_vm._e()],1),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.$t('label.destino')))]),_vm._v(" "),(_vm.carregarComponentes)?_c('transferencia-desdobramento',{ref:"desdobramentoDestino",attrs:{"somenteLeitura":_vm.somenteLeitura || _vm.transferencia.idDesdobramentoOrigem == null,"idDesdobramento":_vm.transferencia.idDesdobramento,"idRepresentante":_vm.transferencia.idControladorDestino,"idDesdobramentoOrigem":_vm.transferencia.idDesdobramentoOrigem,"idOrcamentoOrigem":_vm.transferencia.idOrcamentoOrigem},on:{"TRANSFERENCIADESDOBRAMENTO_SET":_vm.preencherDesdobramentoDestino,"TRANSFERENCIADESDOBRAMENTO_SET_REPRESENTANTE":_vm.preencherRepresentanteDestino,"TRANSFERENCIADESDOBRAMENTO_SET_VALORES":_vm.preencherValoresDestino}}):_vm._e(),_vm._v(" "),_c('md-layout',{attrs:{"md-gutter":"16"}},[_c('md-layout',{attrs:{"md-flex":"33","md-flex-medium":"50","md-flex-small":"100","md-flex-xsmall":"100"}},[_c('md-input-container',[_c('label',[_vm._v(_vm._s(_vm.$t('label.valor_disponivel_pos_transferencia')))]),_vm._v(" "),_c('InputMoneyOld',{attrs:{"disabled":true,"tabindex":"-1","id":"vlr_destino","name":"vlr_destino","one-way-bind":_vm.valorDestino}})],1)],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"button"},slot:"button"},[_c('md-card-actions',{staticClass:"RegisterForm__Boxing"},[_c('md-button',{staticClass:"md-raised",attrs:{"id":"cancelRegisterFromButton"},nativeOn:{"click":function($event){_vm.somenteLeitura ? _vm.voltar() : _vm.openCancelDialog()}}},[_vm._v("\n          "+_vm._s(_vm.$t('label.voltar'))+"\n        ")]),_vm._v(" "),(!_vm.somenteLeitura)?_c('md-button',{staticClass:"md-accent md-raised",attrs:{"id":"saveRegisterFromButton"},nativeOn:{"click":function($event){return _vm.openSaveDialog(_vm.dialog.ref)}}},[_vm._v("\n          "+_vm._s(_vm.$t('label.transferir'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('md-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.podeReprovar),expression:"podeReprovar"}],staticClass:"md-raised md-warn",nativeOn:{"click":function($event){return _vm.openDialogReprovar(_vm.dialog.ref)}}},[_vm._v("\n          "+_vm._s(_vm.$tc('label.reprovar'))+"\n        ")]),_vm._v(" "),_c('md-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.podeAprovar),expression:"podeAprovar"}],staticClass:"md-raised md-accent",nativeOn:{"click":function($event){return _vm.openDialogAprovar(_vm.dialog.ref)}}},[_vm._v("\n          "+_vm._s(_vm.$tc('label.aprovar'))+"\n        ")])],1)],1)]),_vm._v(" "),_c('md-dialog',{ref:"justificarDialog"},[_c('md-dialog-title',[_vm._v("\n      "+_vm._s(_vm.$t('label.justificativa'))+"\n    ")]),_vm._v(" "),_c('md-dialog-content',[_c('div',{staticStyle:{"width":"300px"}},[(_vm.justificarTransferencia.obrigatorio)?_c('md-input-container',{class:{
            'md-input-invalid': _vm.errors.has('justificativa_transferencia'),
          }},[_c('label',[_vm._v("\n            "+_vm._s(_vm.$t('label.motivo'))+"\n          ")]),_vm._v(" "),_c('md-textarea',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"required":"","data-vv-rules":"required","id":"justificativa_transferencia","name":"justificativa_transferencia"},model:{value:(_vm.justificarTransferencia.observacao),callback:function ($$v) {_vm.$set(_vm.justificarTransferencia, "observacao", $$v)},expression:"justificarTransferencia.observacao"}})],1):_vm._e()],1)]),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",nativeOn:{"click":function($event){return _vm.closeDialog('justificarDialog')}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.cancelar'))+"\n      ")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary",nativeOn:{"click":function($event){return _vm.closeDialog('justificarDialog', _vm.justificarTransferencia.action)}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.salvar'))+"\n      ")])],1)],1),_vm._v(" "),_c('md-dialog',{ref:_vm.dialog.ref,attrs:{"md-open-from":("#" + (_vm.dialog.from)),"md-close-to":("#" + (_vm.dialog.from))}},[_c('md-dialog-title',[_vm._v(_vm._s(_vm.dialog.title))]),_vm._v(" "),_c('md-dialog-content',[_vm._v(_vm._s(_vm.dialog.content))]),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{staticClass:"md-primary",attrs:{"disabled":_vm.disableButton},nativeOn:{"click":function($event){return _vm.closeDialog('dialog1')}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.cancelar'))+"\n      ")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary",attrs:{"disabled":_vm.disableButton},nativeOn:{"click":function($event){return _vm.closeDialog('dialog1', _vm.dialog.action)}}},[_vm._v("\n        "+_vm._s(_vm.$t('label.sim'))+"\n      ")])],1)],1),_vm._v(" "),_c('modal-voltar',{ref:"voltarDialog",attrs:{"actionSim":this.openSaveDialogVoltar,"actionNao":this.cancel}})],1):_vm._e()}
var staticRenderFns = []



/***/ }),
/* 1556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TransferenciaDesdobramento_vue_vue_type_template_id_f91906ae_lang_html___ = __webpack_require__(1557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TransferenciaDesdobramento_vue_vue_type_script_lang_js___ = __webpack_require__(660);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__TransferenciaDesdobramento_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__TransferenciaDesdobramento_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__TransferenciaDesdobramento_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__TransferenciaDesdobramento_vue_vue_type_template_id_f91906ae_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__TransferenciaDesdobramento_vue_vue_type_template_id_f91906ae_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaDesdobramento_vue_vue_type_template_id_f91906ae_lang_html___ = __webpack_require__(1558);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaDesdobramento_vue_vue_type_template_id_f91906ae_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaDesdobramento_vue_vue_type_template_id_f91906ae_lang_html___["b"]; });


/***/ }),
/* 1558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-layout',{attrs:{"md-gutter":"16"}},[_c('md-layout',{attrs:{"md-flex":"33","md-flex-medium":"50","md-flex-small":"100","md-flex-xsmall":"100"}},[_c('md-input-container',{class:{
        'md-input-invalid': _vm.errors.has('orcamento')
      }},[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('label.orcamento')))]),_vm._v(" "),_c('md-autocomplete',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"tabindex":"2","id":"orcamento","name":"orcamento","required":true,"maxlength":"50","data-vv-name":"orcamento","data-vv-rules":"required","fetch":_vm.buscarOrcamentos,"min-chars":1,"disabled":_vm.somenteLeitura,"prepareResponseData":_vm.prepareResponseData,"printAttribute":"descricao","queryParam":"descricao"},on:{"selected":_vm.setOrcamento},model:{value:(_vm.desdobramento.descricaoOrcamento),callback:function ($$v) {_vm.$set(_vm.desdobramento, "descricaoOrcamento", $$v)},expression:"desdobramento.descricaoOrcamento"}}),_vm._v(" "),_c('md-icon',{staticStyle:{"cursor":"pointer"},attrs:{"md-autocomplete-search":""}},[_vm._v("search")]),_vm._v(" "),_c('span',{staticClass:"md-error"},[_vm._v("\n        "+_vm._s(_vm.errors.first('orcamento'))+"\n      ")])],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"33","md-flex-medium":"50","md-flex-small":"100","md-flex-xsmall":"100"}},[_c('md-input-container',{class:{
        'md-input-invalid': _vm.errors.has('linha')
      }},[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('label.linha_investimento')))]),_vm._v(" "),_c('md-autocomplete',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"tabindex":"3","id":"linha","name":"linha","maxlength":"50","required":true,"data-vv-name":"linha","data-vv-rules":"required","fetch":_vm.buscarLinha,"min-chars":1,"disabled":_vm.somenteLeitura || _vm.disableLinha,"prepareResponseData":_vm.prepareResponseData,"printAttribute":"descricao","queryParam":"descricao"},on:{"selected":_vm.setLinha},model:{value:(_vm.desdobramento.descricaoLinha),callback:function ($$v) {_vm.$set(_vm.desdobramento, "descricaoLinha", $$v)},expression:"desdobramento.descricaoLinha"}}),_vm._v(" "),_c('md-icon',{staticStyle:{"cursor":"pointer"},attrs:{"md-autocomplete-search":""}},[_vm._v("search")]),_vm._v(" "),_c('span',{staticClass:"md-error"},[_vm._v("\n        "+_vm._s(_vm.errors.first('linha'))+"\n      ")])],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"33","md-flex-medium":"50","md-flex-small":"100","md-flex-xsmall":"100"}},[_c('md-input-container',{class:{
        'md-input-invalid': _vm.errors.has('desdobramento')
      }},[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t('label.competencia')))]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"top"}},[_vm._v(_vm._s(_vm.$t('message.meses_verba_alocada')))]),_vm._v(" "),_c('md-autocomplete',{directives:[{name:"validate",rawName:"v-validate"}],attrs:{"tabindex":"4","id":"desdobramento","name":"desdobramento","maxlength":"7","required":true,"data-vv-name":"desdobramento","data-vv-rules":"required","fetch":_vm.buscarDesdobramento,"min-chars":1,"disabled":_vm.somenteLeitura || _vm.disableDesdobramento,"prepareResponseData":_vm.prepareResponseData,"printAttribute":"anoMes","queryParam":"anoMes"},on:{"selected":_vm.setDesdobramento},model:{value:(_vm.desdobramento.competencia),callback:function ($$v) {_vm.$set(_vm.desdobramento, "competencia", $$v)},expression:"desdobramento.competencia"}}),_vm._v(" "),_c('md-icon',{staticStyle:{"cursor":"pointer"},attrs:{"md-autocomplete-search":""}},[_vm._v("search")]),_vm._v(" "),_c('span',{staticClass:"md-error"},[_vm._v("\n        "+_vm._s(_vm.errors.first('desdobramento'))+"\n      ")])],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"33","md-flex-medium":"50","md-flex-small":"100","md-flex-xsmall":"100"}},[_c('md-input-container',{class:{
        'md-input-invalid': _vm.errors.has('representante')
      }},[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.$tc('label.representante', 1)))]),_vm._v(" "),_c('md-autocomplete',{attrs:{"tabindex":"5","id":"representante","name":"representante","maxlength":"100","data-vv-name":"representante","fetch":_vm.buscarRepresentante,"min-chars":1,"disabled":_vm.somenteLeitura || _vm.disableRepresentante,"prepareResponseData":_vm.prepareResponseData,"printAttribute":"nome","queryParam":"nome"},on:{"selected":_vm.setRepresentante},model:{value:(_vm.desdobramento.representante),callback:function ($$v) {_vm.$set(_vm.desdobramento, "representante", $$v)},expression:"desdobramento.representante"}}),_vm._v(" "),_c('md-icon',{staticStyle:{"cursor":"pointer"},attrs:{"md-autocomplete-search":""}},[_vm._v("search")]),_vm._v(" "),_c('span',{staticClass:"md-error"},[_vm._v("\n        "+_vm._s(_vm.errors.first('representante'))+"\n      ")])],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"33","md-flex-medium":"50","md-flex-small":"100","md-flex-xsmall":"100"}},[_c('md-input-container',[_c('label',[_vm._v(_vm._s(_vm.$t('label.valor_planejado')))]),_vm._v(" "),_c('InputMoneyOld',{attrs:{"disabled":true,"tabindex":"-1","id":"vlr_planejado","name":"vlr_planejado","one-way-bind":_vm.desdobramento.vlrPlanejado}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"33","md-flex-medium":"50","md-flex-small":"100","md-flex-xsmall":"100"}},[_c('md-input-container',[_c('label',[_vm._v(_vm._s(_vm.$t('label.valor_disponivel')))]),_vm._v(" "),_c('InputMoneyOld',{attrs:{"disabled":true,"tabindex":"-1","id":"vlr_disponivel","name":"vlr_disponivel","one-way-bind":_vm.desdobramento.vlrDisponivel}})],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TransferenciaPosse = __webpack_require__(1560);

var _TransferenciaPosse2 = _interopRequireDefault(_TransferenciaPosse);

var _TransferenciaPosseAbas = __webpack_require__(1563);

var _TransferenciaPosseAbas2 = _interopRequireDefault(_TransferenciaPosseAbas);

var _TransferenciaPosseDefinitivaForm = __webpack_require__(1573);

var _TransferenciaPosseDefinitivaForm2 = _interopRequireDefault(_TransferenciaPosseDefinitivaForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  path: 'transferencia-posse',
  component: _TransferenciaPosse2.default,
  children: [{
    path: '',
    name: 'transferencia-posse',
    component: _TransferenciaPosseAbas2.default
  }, {
    path: 'transf-definitiva',
    name: 'novaTransferenciaDefinitiva',
    component: _TransferenciaPosseDefinitivaForm2.default
  }]

};

/***/ }),
/* 1560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TransferenciaPosse_vue_vue_type_template_id_532c4aa8___ = __webpack_require__(1561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__TransferenciaPosse_vue_vue_type_template_id_532c4aa8___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__TransferenciaPosse_vue_vue_type_template_id_532c4aa8___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosse_vue_vue_type_template_id_532c4aa8___ = __webpack_require__(1562);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosse_vue_vue_type_template_id_532c4aa8___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosse_vue_vue_type_template_id_532c4aa8___["b"]; });


/***/ }),
/* 1562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c('router-view')],1)}
var staticRenderFns = []



/***/ }),
/* 1563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TransferenciaPosseAbas_vue_vue_type_template_id_3218fa2c___ = __webpack_require__(1564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TransferenciaPosseAbas_vue_vue_type_script_lang_js___ = __webpack_require__(662);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__TransferenciaPosseAbas_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__TransferenciaPosseAbas_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TransferenciaPosseAbas_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(1572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__TransferenciaPosseAbas_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__TransferenciaPosseAbas_vue_vue_type_template_id_3218fa2c___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__TransferenciaPosseAbas_vue_vue_type_template_id_3218fa2c___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseAbas_vue_vue_type_template_id_3218fa2c___ = __webpack_require__(1565);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseAbas_vue_vue_type_template_id_3218fa2c___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseAbas_vue_vue_type_template_id_3218fa2c___["b"]; });


/***/ }),
/* 1565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-tabs',{attrs:{"centered":"","background-color":"rgba(0,0,0,0)","color":"accent"},model:{value:(_vm.tabSelecionada),callback:function ($$v) {_vm.tabSelecionada=$$v},expression:"tabSelecionada"}},[_c('v-tab',{staticClass:"aba-text",attrs:{"href":"#tab-definitiva"}},[_vm._v(_vm._s(_vm.$t('label.definitiva')))]),_vm._v(" "),_c('v-tab',{staticClass:"aba-text",attrs:{"href":"#tab-temporaria"}},[_vm._v(_vm._s(_vm.$t('label.transferencia_temporaria')))]),_vm._v(" "),_c('v-tab',{staticClass:"aba-text",attrs:{"href":"#tab-historico"}},[_vm._v(_vm._s(_vm.$t('label.historico')))]),_vm._v(" "),_c('v-tabs-items',{model:{value:(_vm.tabSelecionada),callback:function ($$v) {_vm.tabSelecionada=$$v},expression:"tabSelecionada"}},[_c('v-tab-item',{staticClass:"mt-3",attrs:{"id":"tab-definitiva"}},[_c('transferencia-posse-definitiva')],1),_vm._v(" "),_c('v-tab-item',{staticClass:"mt-3",attrs:{"id":"tab-temporaria"}},[_c('v-container',{attrs:{"ml-0":""}},[_c('v-row',{attrs:{"justify-end":""}},[_c('v-col',{attrs:{"cols":"12","sm":"6","md":"4"}},[_c('v-text-field',{attrs:{"append-icon":"search","label":_vm.$t('label.pesquisar'),"single-line":"","clearable":"","hide-details":""},model:{value:(_vm.searchQueryTemporaria),callback:function ($$v) {_vm.searchQueryTemporaria=$$v},expression:"searchQueryTemporaria"}})],1)],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",class:{ 'controls-puller': _vm.possesTemporarias.length > 5 },attrs:{"headers":_vm.headersPossesTemporarias,"items":_vm.possesTemporarias,"options":_vm.paginationTemporaria,"server-items-length":_vm.paginationTemporaria.totalPage,"pl-3":"","pr-3":"","pt-3":"","pb-3":"","footer-props":{
            itemsPerPageText: _vm.$t('label.linhas_por_pagina'),
            itemsPerPageOptions: [10, 25, 50],
          },"no-data-text":_vm.$t('label.tabela_sem_conteudo')},on:{"update:options":function($event){_vm.paginationTemporaria=$event}},scopedSlots:_vm._u([{key:"item.opcao",fn:function(ref){
          var item = ref.item;
return [_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.abrirDialogRemover(item)}}},[_c('v-icon',[_vm._v("delete")])],1)]}}])}),_vm._v(" "),_c('v-btn',{staticClass:"v-btn__fab",attrs:{"color":"accent","dark":"","fixed":"","fab":"","bottom":"","right":""},on:{"click":_vm.abrirForm}},[_c('v-icon',[_vm._v("add")])],1)],1),_vm._v(" "),_c('v-tab-item',{staticClass:"mt-3",attrs:{"id":"tab-historico"}},[_c('v-container',{attrs:{"ml-0":""}},[_c('v-row',{attrs:{"justify-end":""}},[_c('v-col',{attrs:{"cols":"12","sm":"6","md":"4"}},[_c('v-text-field',{attrs:{"append-icon":"search","label":_vm.$t('label.pesquisar'),"single-line":"","clearable":"","hide-details":""},model:{value:(_vm.searchQueryHistorico),callback:function ($$v) {_vm.searchQueryHistorico=$$v},expression:"searchQueryHistorico"}})],1)],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headersHistoricoPosses,"items":_vm.historicoPosses,"options":_vm.paginationHistorico,"server-items-length":_vm.paginationHistorico.totalPage,"pl-3":"","pr-3":"","pt-3":"","pb-3":"","footer-props":{
            itemsPerPageText: _vm.$t('label.linhas_por_pagina'),
            itemsPerPageOptions: [10, 25, 50],
          },"no-data-text":_vm.$t('label.tabela_sem_conteudo')},on:{"update:options":function($event){_vm.paginationHistorico=$event}},scopedSlots:_vm._u([{key:"pageText",fn:function(props){return [_vm._v("\n            "+_vm._s(props.pageStart)+" - "+_vm._s(props.pageStop)+" "+_vm._s(_vm.$tc('label.de', 2))+" "+_vm._s(props.itemsLength)+"\n          ")]}}])})],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"1200"},model:{value:(_vm.dialogForm),callback:function ($$v) {_vm.dialogForm=$$v},expression:"dialogForm"}},[(_vm.dialogForm)?_c('transferencia-posse-form',{attrs:{"somente-leitura":!_vm.canAccessPage},on:{"cancelar":_vm.fecharForm,"atualizarGrid":function($event){return _vm.carregarGrids()}}}):_vm._e()],1),_vm._v(" "),_c('confirm',{ref:"confirmDialog",attrs:{"message":_vm.$t('message.remover_transferencia_posse'),"persistent":true},on:{"agree":_vm.removerTransferenciaTemporaria}})],1)}
var staticRenderFns = []



/***/ }),
/* 1566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TransferenciaPosseForm_vue_vue_type_template_id_332ff4f5___ = __webpack_require__(1567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TransferenciaPosseForm_vue_vue_type_script_lang_js___ = __webpack_require__(664);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__TransferenciaPosseForm_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__TransferenciaPosseForm_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__TransferenciaPosseForm_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__TransferenciaPosseForm_vue_vue_type_template_id_332ff4f5___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__TransferenciaPosseForm_vue_vue_type_template_id_332ff4f5___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseForm_vue_vue_type_template_id_332ff4f5___ = __webpack_require__(1568);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseForm_vue_vue_type_template_id_332ff4f5___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseForm_vue_vue_type_template_id_332ff4f5___["b"]; });


/***/ }),
/* 1568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{ref:"form",attrs:{"lazy-validation":""}},[_c('v-card',[_c('v-card-title',[_c('h3',{staticClass:"headline mb-0"},[_vm._v(_vm._s(_vm.$t('label.transferencia_posse')))])]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-xl":"","fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-radio-group',{attrs:{"row":""},on:{"change":function($event){return _vm.alterarListas()}},model:{value:(_vm.radioGroup),callback:function ($$v) {_vm.radioGroup=$$v},expression:"radioGroup"}},[(_vm.podeTransferenciaFun)?_c('v-radio',{attrs:{"label":("" + (_vm.$tc('label.funcionario'))),"value":'FUNCIONARIO'}}):_vm._e(),_vm._v(" "),(_vm.podeTransferenciaDiv)?_c('v-radio',{attrs:{"label":("" + (_vm.$tc('label.divisao'))),"value":'DIVISAO'}}):_vm._e()],1)],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","sm":"6"}},[_c('v-autocomplete',{attrs:{"id":"posse_de","name":"posse_de","items":_vm.listaDe,"search-input":_vm.buscaListaDe,"no-data-text":_vm.$tc('message.nenhum_registro', 1),"item-text":"nome","item-value":"id","rules":[_vm.rules.requiredDe],"label":((_vm.$tc('label.de', 2)) + " *"),"placeholder":_vm.$tc('label.digite_para_buscar', 1),"clearable":"","return-object":""},on:{"update:searchInput":function($event){_vm.buscaListaDe=$event},"update:search-input":function($event){_vm.buscaListaDe=$event}},nativeOn:{"change":function($event){return _vm.limparPara($event)}},model:{value:(_vm.posse.de),callback:function ($$v) {_vm.$set(_vm.posse, "de", $$v)},expression:"posse.de"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","sm":"6"}},[_c('v-autocomplete',{attrs:{"id":"posse_para","name":"posse_para","items":_vm.listaPara,"search-input":_vm.buscaListaPara,"no-data-text":_vm.$tc('message.nenhum_registro', 1),"item-text":"nome","item-value":"id","rules":[_vm.rules.requiredPara],"label":((_vm.$tc('label.para', 1)) + " *"),"placeholder":_vm.$tc('label.digite_para_buscar', 1),"return-object":"","clearable":"","disabled":!_vm.posse.de},on:{"update:searchInput":function($event){_vm.buscaListaPara=$event},"update:search-input":function($event){_vm.buscaListaPara=$event}},model:{value:(_vm.posse.para),callback:function ($$v) {_vm.$set(_vm.posse, "para", $$v)},expression:"posse.para"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"6"}},[_c('v-text-field',{staticClass:"CalendarioForm-data__text",attrs:{"id":"motivo","name":"motivo","label":((_vm.$t('label.motivo')) + " *"),"counter":50,"rules":[_vm.rules.required, _vm.rules.maxLength50]},model:{value:(_vm.posse.motivo),callback:function ($$v) {_vm.$set(_vm.posse, "motivo", $$v)},expression:"posse.motivo"}})],1),_vm._v(" "),(_vm.podeTransferenciaDefinitiva)?_c('v-col',{attrs:{"cols":"6"}},[_c('v-switch',{staticClass:"mt-3",attrs:{"label":_vm.$t('label.definitiva')},model:{value:(_vm.posse.definitiva),callback:function ($$v) {_vm.$set(_vm.posse, "definitiva", $$v)},expression:"posse.definitiva"}})],1):_vm._e()],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{nativeOn:{"click":function($event){return _vm.cancelar($event)}}},[_vm._v(_vm._s(_vm.$t('label.cancelar')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.abrirDialogSalvar($event)}}},[_vm._v(_vm._s(_vm.$t('label.salvar')))])],1)],1),_vm._v(" "),_c('confirm',{ref:"confirmDialog",attrs:{"message":_vm.$t('message.deseja_salvar', {text: _vm.$t('label.transferencia_posse')}),"persistent":true},on:{"agree":_vm.salvar}})],1)}
var staticRenderFns = []



/***/ }),
/* 1569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TransferenciaPosseDefinitiva_vue_vue_type_template_id_9fbc3060___ = __webpack_require__(1570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TransferenciaPosseDefinitiva_vue_vue_type_script_lang_js___ = __webpack_require__(666);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__TransferenciaPosseDefinitiva_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__TransferenciaPosseDefinitiva_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__TransferenciaPosseDefinitiva_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__TransferenciaPosseDefinitiva_vue_vue_type_template_id_9fbc3060___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__TransferenciaPosseDefinitiva_vue_vue_type_template_id_9fbc3060___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitiva_vue_vue_type_template_id_9fbc3060___ = __webpack_require__(1571);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitiva_vue_vue_type_template_id_9fbc3060___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitiva_vue_vue_type_template_id_9fbc3060___["b"]; });


/***/ }),
/* 1571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{attrs:{"ml-0":""}},[_c('v-row',{attrs:{"justify-end":""}},[_c('v-col',{attrs:{"cols":"12","sm":"6","md":"4"}},[_c('v-text-field',{attrs:{"append-icon":"search","label":_vm.$t('label.pesquisar'),"single-line":"","clearable":"","hide-details":""},model:{value:(_vm.searchQueryDef),callback:function ($$v) {_vm.searchQueryDef=$$v},expression:"searchQueryDef"}})],1)],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",class:{ 'controls-puller': _vm.posses.length > 5 },attrs:{"headers":_vm.headers,"items":_vm.posses,"options":_vm.pagination,"server-items-length":_vm.totalPage,"pl-3":"","pr-3":"","pt-3":"","pb-3":"","footer-props":{
      itemsPerPageText: _vm.$t('label.linhas_por_pagina'),
      itemsPerPageOptions: [10, 25, 50],
    },"no-data-text":_vm.$t('label.tabela_sem_conteudo')},on:{"update:options":function($event){_vm.pagination=$event}}}),_vm._v(" "),_c('v-btn',{staticClass:"v-btn__fab",attrs:{"color":"accent","dark":"","fixed":"","fab":"","bottom":"","right":""},on:{"click":_vm.abrirForm}},[_c('v-icon',[_vm._v("add")])],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseAbas_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseAbas_vue_vue_type_style_index_0_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseAbas_vue_vue_type_style_index_0_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseAbas_vue_vue_type_style_index_0_lang_css____default.a); 

/***/ }),
/* 1573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TransferenciaPosseDefinitivaForm_vue_vue_type_template_id_c3364efe_lang_html___ = __webpack_require__(1574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TransferenciaPosseDefinitivaForm_vue_vue_type_script_lang_js___ = __webpack_require__(669);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__TransferenciaPosseDefinitivaForm_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__TransferenciaPosseDefinitivaForm_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TransferenciaPosseDefinitivaForm_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(1599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__TransferenciaPosseDefinitivaForm_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__TransferenciaPosseDefinitivaForm_vue_vue_type_template_id_c3364efe_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__TransferenciaPosseDefinitivaForm_vue_vue_type_template_id_c3364efe_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaForm_vue_vue_type_template_id_c3364efe_lang_html___ = __webpack_require__(1575);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaForm_vue_vue_type_template_id_c3364efe_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaForm_vue_vue_type_template_id_c3364efe_lang_html___["b"]; });


/***/ }),
/* 1575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-stepper',{staticClass:"TransferenciaPosseDefinitivaForm",model:{value:(_vm.e1),callback:function ($$v) {_vm.e1=$$v},expression:"e1"}},[_c('v-stepper-header',[_c('v-stepper-step',{attrs:{"complete":_vm.e1 > 1,"step":"1"}},[_vm._v(_vm._s(_vm.$t('label.hierarquia_funcionario')))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.e1 > 2,"step":"2"}},[_vm._v(_vm._s(_vm.$tc('label.carteira_cliente', 2)))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.e1 > 3,"step":"3"}},[_vm._v(_vm._s(_vm.$tc('label.responsavel_faturamento', 1)))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.e1 > 4,"step":"4"}},[_vm._v(_vm._s(_vm.$tc('label.orcamento', 2)))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.e1 > 5,"step":"5"}},[_vm._v(_vm._s(_vm.$tc('label.confirmacao', 1)))])],1),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"1"}},[_c('transferencia-posse-definitiva-passo-1',{on:{"TRANSFERENCIA_DEFINITIVA_CANCELAR":_vm.cancelar,"TRANSFERENCIA_DEFINITIVA_CONTINUAR":_vm.continuar}})],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('transferencia-posse-definitiva-passo-2',{ref:"passo2",attrs:{"transferencia":_vm.objeto},on:{"TRANSFERENCIA_DEFINITIVA_CANCELAR":_vm.cancelar,"TRANSFERENCIA_DEFINITIVA_CONTINUAR":_vm.continuar,"TRANSFERENCIA_DEFINITIVA_VOLTAR":_vm.voltar}})],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"3"}},[_c('transferencia-posse-definitiva-passo-3',{ref:"passo3",attrs:{"transferencia":_vm.objeto},on:{"TRANSFERENCIA_DEFINITIVA_CANCELAR":_vm.cancelar,"TRANSFERENCIA_DEFINITIVA_CONTINUAR":_vm.continuar,"TRANSFERENCIA_DEFINITIVA_VOLTAR":_vm.voltar}})],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"4"}},[_c('transferencia-posse-definitiva-passo-4',{ref:"passo4",attrs:{"transferencia":_vm.objeto},on:{"TRANSFERENCIA_DEFINITIVA_CANCELAR":_vm.cancelar,"TRANSFERENCIA_DEFINITIVA_CONTINUAR":_vm.continuar,"TRANSFERENCIA_DEFINITIVA_VOLTAR":_vm.voltar}})],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"5"}},[_c('transferencia-posse-definitiva-passo-5',{ref:"passo5",attrs:{"transferencia":_vm.objeto},on:{"TRANSFERENCIA_DEFINITIVA_CANCELAR":_vm.cancelar,"TRANSFERENCIA_DEFINITIVA_CONCLUIR":_vm.concluir,"TRANSFERENCIA_DEFINITIVA_VOLTAR":_vm.voltar}})],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TransferenciaPosseDefinitivaPasso1_vue_vue_type_template_id_c0981c32_lang_html___ = __webpack_require__(1577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TransferenciaPosseDefinitivaPasso1_vue_vue_type_script_lang_js___ = __webpack_require__(671);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__TransferenciaPosseDefinitivaPasso1_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__TransferenciaPosseDefinitivaPasso1_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TransferenciaPosseDefinitivaPasso1_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(1582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__TransferenciaPosseDefinitivaPasso1_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__TransferenciaPosseDefinitivaPasso1_vue_vue_type_template_id_c0981c32_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__TransferenciaPosseDefinitivaPasso1_vue_vue_type_template_id_c0981c32_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso1_vue_vue_type_template_id_c0981c32_lang_html___ = __webpack_require__(1578);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso1_vue_vue_type_template_id_c0981c32_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso1_vue_vue_type_template_id_c0981c32_lang_html___["b"]; });


/***/ }),
/* 1578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-form',{ref:"form",attrs:{"lazy-validation":""}},[_c('v-card-title',{staticClass:"card-header",attrs:{"primary-title":""}},[_vm._v("\n      "+_vm._s(_vm.$tc('title.orientacao_geral', 2))+"\n    ")]),_vm._v(" "),_c('v-row',{staticClass:"mx-4 mt-4"},[_c('v-col',{staticClass:"mr-3",attrs:{"cols":"12","sm":"6","md":"12"}},[_c('p',[_c('label',[_vm._v(_vm._s(_vm.$t('message.ajuda.transferencia_definitiva.orientacao_geral')))])]),_vm._v(" "),_c('p',[_c('label',[_vm._v(_vm._s(_vm.$t('message.ajuda.transferencia_definitiva.orientacao_geral_premissa')))])]),_vm._v(" "),_c('ol',[_c('li',[_c('label',[_vm._v(_vm._s(_vm.$t('message.ajuda.transferencia_definitiva.orientacao_geral_premissa_1')))])]),_vm._v(" "),_c('li',[_c('label',[_vm._v(_vm._s(_vm.$t('message.ajuda.transferencia_definitiva.orientacao_geral_premissa_2')))])]),_vm._v(" "),_c('li',[_c('label',[_vm._v(_vm._s(_vm.$t('message.ajuda.transferencia_definitiva.orientacao_geral_premissa_3')))])]),_vm._v(" "),_c('li',[_c('label',[_vm._v(_vm._s(_vm.$t('message.ajuda.transferencia_definitiva.orientacao_geral_premissa_4')))])])])])],1),_vm._v(" "),_c('v-card-title',{staticClass:"card-header",attrs:{"primary-title":""}},[_vm._v("\n      "+_vm._s(_vm.$tc('title.motivo', 1))+"\n      "),_c('v-spacer'),_vm._v(" "),_c('tooltip-ajuda',{attrs:{"mensagem":("" + (_vm.$t('message.ajuda.transferencia_definitiva.motivo')))}})],1),_vm._v(" "),_c('v-row',{staticClass:"mx-4 mt-4"},[_c('v-col',{staticClass:"mr-3",attrs:{"cols":"12","sm":"6","md":"6"}},[_c('v-text-field',{attrs:{"id":"transf_def_motivo","label":((_vm.$tc('label.motivo', 1)) + " * "),"rules":[_vm.rules.required],"maxlength":"100","counter":"100","required":""},model:{value:(_vm.transferencia.motivo),callback:function ($$v) {_vm.$set(_vm.transferencia, "motivo", $$v)},expression:"transferencia.motivo"}}),_vm._v(" "),_c('v-spacer')],1)],1),_vm._v(" "),_c('v-card-title',{staticClass:"card-header",attrs:{"primary-title":""}},[_vm._v("\n      "+_vm._s(_vm.$tc('title.cenario', 1))+"\n      "),_c('v-spacer'),_vm._v(" "),_c('tooltip-ajuda',{attrs:{"mensagem":("" + (_vm.$t('message.ajuda.transferencia_definitiva.cenario')))}})],1),_vm._v(" "),_c('v-row',{staticClass:"mx-4 mt-4"},[_c('v-col',{staticClass:"mr-3",attrs:{"cols":"12","sm":"6","md":"12"}},[_c('v-radio-group',{on:{"change":_vm.limparSelecaoUsuario},model:{value:(_vm.transferencia.cenario),callback:function ($$v) {_vm.$set(_vm.transferencia, "cenario", $$v)},expression:"transferencia.cenario"}},[_c('v-radio',{attrs:{"label":_vm.$t('message.transferencia_definitiva_cenario_1'),"value":1}}),_vm._v(" "),_c('v-radio',{attrs:{"label":_vm.$t('message.transferencia_definitiva_cenario_2'),"value":2}}),_vm._v(" "),_c('v-radio',{attrs:{"label":_vm.$t('message.transferencia_definitiva_cenario_3'),"value":3}}),_vm._v(" "),_c('v-radio',{attrs:{"label":_vm.$t('message.transferencia_definitiva_cenario_4'),"value":4}})],1)],1)],1),_vm._v(" "),_c('v-card-title',{staticClass:"card-header",attrs:{"primary-title":""}},[_vm._v("\n      "+_vm._s(_vm.$tc('title.selecao_usuario', 2))+"\n    ")]),_vm._v(" "),_c('v-row',{staticClass:"mx-4 mt-4"},[_c('v-col',{attrs:{"cols":"12","sm":"6","md":"5"}},[_c('v-card-title',[_c('v-spacer'),_vm._v(" "),_c('tooltip-ajuda',{attrs:{"mensagem":("" + (_vm.$t('message.ajuda.transferencia_definitiva.usuario_de'))),"color":'black'}})],1),_vm._v(" "),_c('v-autocomplete',{attrs:{"id":"posse_de","name":"posse_de","items":_vm.listaDe,"search-input":_vm.buscaListaDe,"no-data-text":_vm.$tc('message.nenhum_registro', 1),"item-text":"nome","item-value":"id","rules":[_vm.rules.required],"label":((_vm.labelSelecaoUsuarioDe()) + " *"),"clearable":"","return-object":""},on:{"update:searchInput":function($event){_vm.buscaListaDe=$event},"update:search-input":function($event){_vm.buscaListaDe=$event},"input":function($event){return _vm.limparPara(_vm.transferencia.funcionarioDe)}},nativeOn:{"click":function($event){return _vm.buscarFuncionarioDe($event)}},model:{value:(_vm.transferencia.funcionarioDe),callback:function ($$v) {_vm.$set(_vm.transferencia, "funcionarioDe", $$v)},expression:"transferencia.funcionarioDe"}}),_vm._v(" "),(_vm.transferencia.funcionarioDe)?_c('label',[_vm._v(_vm._s(((_vm.$tc('label.superior_imediato')) + ":  " + (_vm.transferencia.funcionarioDe.superiorImediato)))+" ")]):_vm._e(),_vm._v(" "),(_vm.transferencia.cenario !== 1)?_c('v-checkbox',{attrs:{"label":_vm.$t('label.inativar_usuario_migracao')},model:{value:(_vm.transferencia.inativarUsuario),callback:function ($$v) {_vm.$set(_vm.transferencia, "inativarUsuario", $$v)},expression:"transferencia.inativarUsuario"}}):_vm._e()],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","sm":"6","md":"5"}},[_c('v-card-title',[_c('v-spacer'),_vm._v(" "),_c('tooltip-ajuda',{attrs:{"mensagem":("" + (_vm.$t('message.ajuda.transferencia_definitiva.usuario_para'))),"color":'black'}})],1),_vm._v(" "),_c('v-autocomplete',{attrs:{"id":"posse_para","name":"posse_para","disabled":!_vm.transferencia.funcionarioDe,"items":_vm.listaPara,"search-input":_vm.buscaListaPara,"no-data-text":_vm.$tc('message.nenhum_registro', 1),"item-text":"nome","item-value":"id","rules":[_vm.rules.required],"label":((_vm.labelSelecaoUsuarioPara()) + " *"),"clearable":"","return-object":""},on:{"update:searchInput":function($event){_vm.buscaListaPara=$event},"update:search-input":function($event){_vm.buscaListaPara=$event},"input":function($event){return _vm.selecionaUsuarioPara(_vm.transferencia.funcionarioPara)}},nativeOn:{"click":function($event){return _vm.buscarFuncionarioPara($event)}},model:{value:(_vm.transferencia.funcionarioPara),callback:function ($$v) {_vm.$set(_vm.transferencia, "funcionarioPara", $$v)},expression:"transferencia.funcionarioPara"}}),_vm._v(" "),(_vm.transferencia.cenario !== 1 && _vm.transferencia.funcionarioPara)?_c('label',[_vm._v("\n            "+_vm._s(((_vm.$tc('label.superior_imediato')) + ":  " + (_vm.transferencia.funcionarioPara.superiorImediato)))+"\n          ")]):_vm._e()],1)],1),_vm._v(" "),(_vm.transferencia.cenario === 3)?_c('v-row',{staticClass:"mx-4"},[_c('v-col',{attrs:{"cols":"12","sm":"6","md":"5"}},[(_vm.transferencia.cenario === 3 && _vm.transferencia.funcionarioDe)?_c('v-list',[_c('v-subheader',{attrs:{"inset":""}},[_vm._v(_vm._s(((_vm.$tc('label.vendedores_usuario')) + "  " + (_vm.transferencia.funcionarioDe.nome))))]),_vm._v(" "),_vm._l((_vm.vendedoresDe),function(item){return _c('v-list-item',{key:item.id,on:{"click":function($event){}}},[_c('v-list-item-content',[_c('v-list-item-title',{domProps:{"textContent":_vm._s(item.nome)}})],1)],1)})],2):_vm._e()],1),_vm._v(" "),(_vm.transferencia.funcionarioDe && _vm.transferencia.funcionarioPara)?_c('v-col',{attrs:{"cols":"12","sm":"6","md":"1"}},[_c('v-row',{attrs:{"align":"center","justify":"center","column":"","fill-height":""}},[_c('v-col',{staticClass:"mr-3",attrs:{"cols":"12","sm":"6","md":"1"}},[_c('v-btn',{attrs:{"text":"","icon":""},nativeOn:{"click":function($event){return _vm.enviarDePara()}}},[_c('v-icon',[_vm._v("chevron_right")])],1)],1),_vm._v(" "),_c('v-col',{staticClass:"mr-3",attrs:{"cols":"12","sm":"6","md":"1"}},[_c('v-btn',{attrs:{"text":"","icon":""},nativeOn:{"click":function($event){return _vm.enviarParaDe()}}},[_c('v-icon',[_vm._v("chevron_left")])],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","sm":"6","md":"5"}},[(_vm.transferencia.cenario === 3 && _vm.transferencia.funcionarioPara)?_c('v-list',[_c('v-subheader',{attrs:{"inset":""}},[_vm._v(_vm._s(((_vm.$tc('label.vendedores_usuario')) + "  " + (_vm.transferencia.funcionarioPara.nome))))]),_vm._v(" "),_vm._l((_vm.vendedoresPara),function(item){return _c('v-list-item',{key:item.id,on:{"click":function($event){}}},[_c('v-list-item-content',[_c('v-list-item-title',{domProps:{"textContent":_vm._s(item.nome)}})],1)],1)})],2):_vm._e()],1)],1):_vm._e(),_vm._v(" "),_c('v-row',{staticClass:"mt-4"},[_c('v-col',{staticStyle:{"text-align":"right"},attrs:{"cols":"12"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"mr-3",attrs:{"id":"transf_def_passo1_botao_cancelar"},on:{"click":_vm.cancelar}},[_vm._v(_vm._s(_vm.$t('label.cancelar')))]),_vm._v(" "),_c('v-btn',{attrs:{"id":"transf_def_passo1_botao_proximo","color":"primary"},on:{"click":_vm.proximoPasso}},[_vm._v(_vm._s(_vm.$t('label.proximo_passo')))])],1)],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(29);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TransferenciaDefinitiva = function TransferenciaDefinitiva() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  (0, _classCallCheck3.default)(this, TransferenciaDefinitiva);

  this.motivo = data.motivo;
  this.cenario = data.cenario || 1;
  this.funcionarioDe = data.funcionarioDe;
  this.funcionarioPara = data.funcionarioPara;
  this.usuarios = data.usuarios || [];
  this.inativarUsuario = data.inativarUsuario || false;
  this.transferenciaCarteira = data.transferenciaCarteira || 1;
  this.transferenciaResponsavelFaturamento = data.transferenciaResponsavelFaturamento || 1;
  this.carteiras = data.carteiras || [];
  this.clientes = data.clientes || [];
  this.orcamentos = data.orcamentos || [];
  this.aceito = data.aceito || false;
};

exports.default = TransferenciaDefinitiva;

/***/ }),
/* 1580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TooltipAjuda_vue_vue_type_template_id_2f772edf_lang_html___ = __webpack_require__(1581);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TooltipAjuda_vue_vue_type_template_id_2f772edf_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TooltipAjuda_vue_vue_type_template_id_2f772edf_lang_html___["b"]; });


/***/ }),
/* 1581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mensagem)?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({attrs:{"color":_vm.color,"dark":""}},on),[_vm._v("info")])]}}],null,false,2590703436)},[_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.mensagem)}})]):_vm._e()}
var staticRenderFns = []



/***/ }),
/* 1582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso1_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso1_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso1_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso1_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 1583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TransferenciaPosseDefinitivaPasso2_vue_vue_type_template_id_e82c66ec_lang_html___ = __webpack_require__(1584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TransferenciaPosseDefinitivaPasso2_vue_vue_type_script_lang_js___ = __webpack_require__(676);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__TransferenciaPosseDefinitivaPasso2_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__TransferenciaPosseDefinitivaPasso2_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TransferenciaPosseDefinitivaPasso2_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(1586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__TransferenciaPosseDefinitivaPasso2_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__TransferenciaPosseDefinitivaPasso2_vue_vue_type_template_id_e82c66ec_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__TransferenciaPosseDefinitivaPasso2_vue_vue_type_template_id_e82c66ec_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso2_vue_vue_type_template_id_e82c66ec_lang_html___ = __webpack_require__(1585);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso2_vue_vue_type_template_id_e82c66ec_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso2_vue_vue_type_template_id_e82c66ec_lang_html___["b"]; });


/***/ }),
/* 1585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-form',{ref:"form",attrs:{"lazy-validation":""}},[(_vm.transferencia.funcionarioDe && _vm.transferencia.funcionarioPara)?_c('h3',[_vm._v("\n      "+_vm._s(((_vm.$tc('label.de', 2)) + ": " + (_vm.transferencia.funcionarioDe.nome) + " :: " + (_vm.$tc('label.para')) + ": " + (_vm.transferencia.funcionarioPara.nome)))+"\n    ")]):_vm._e(),_vm._v(" "),_c('v-card-title',{staticClass:"card-header",attrs:{"primary-title":""}},[_vm._v("\n      "+_vm._s(_vm.$tc('title.selecao_carteira', 1))+"\n      "),_c('v-spacer'),_vm._v(" "),_c('tooltip-ajuda',{attrs:{"mensagem":("" + (_vm.$t('message.ajuda.transferencia_definitiva.selecao_carteira')))}})],1),_vm._v(" "),_c('v-row',{staticClass:"mx-4 mt-4"},[_c('v-col',{staticClass:"mr-3",attrs:{"cols":"12","sm":"6","md":"4"}},[_c('v-select',{attrs:{"items":_vm.filtros,"label":_vm.$t('label.filtro_cliente'),"item-text":"nome","item-value":"nomCampoId","no-data-text":_vm.$tc('message.nenhum_registro', 1),"return-object":""},on:{"change":_vm.limparFiltro},model:{value:(_vm.filtroSelecionado),callback:function ($$v) {_vm.filtroSelecionado=$$v},expression:"filtroSelecionado"}})],1),_vm._v(" "),_c('v-col',{staticClass:"mr-3",attrs:{"cols":"12","sm":"6","md":"4"}},[_c('v-autocomplete',{attrs:{"id":"filtro_cliente","name":"filtro_cliente","items":_vm.lista,"search-input":_vm.buscaLista,"no-data-text":_vm.$tc('message.nenhum_registro', 1),"item-text":"nome","item-value":"id","label":_vm.filtroSelecionado.nome,"disabled":!_vm.filtroSelecionado.nome,"clearable":"","multiple":""},on:{"update:searchInput":function($event){_vm.buscaLista=$event},"update:search-input":function($event){_vm.buscaLista=$event}},nativeOn:{"click":function($event){return _vm.buscarLista($event)}},model:{value:(_vm.itensFiltro),callback:function ($$v) {_vm.itensFiltro=$$v},expression:"itensFiltro"}})],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"warn","id":"transf_def_passo2_botao_filtrar"},on:{"click":function($event){return _vm.aplicarFiltro()}}},[_vm._v(_vm._s(_vm.$t('label.aplicar')))])],1),_vm._v(" "),_c('v-card-title',{staticClass:"card-header",attrs:{"primary-title":""}},[_vm._v("\n      "+_vm._s(_vm.$tc('title.carteira_cliente', 2))+"\n      "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.exportar()}}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("get_app")])],1),_vm._v(" "),_c('tooltip-ajuda',{attrs:{"mensagem":("" + (_vm.$t('message.ajuda.transferencia_definitiva.carteira_cliente')))}})],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.carteiras,"options":_vm.pagination,"server-items-length":_vm.totalPage,"items-per-page":5,"footer-props":{
        itemsPerPageOptions: [10, 25, 50],
      },"no-data-text":_vm.$t('label.tabela_sem_conteudo')},on:{"update:options":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"item.transferir",fn:function(ref){
      var item = ref.item;
return [_c('v-checkbox',{nativeOn:{"click":function($event){return _vm.selecionar(item)}},model:{value:(item.transferir),callback:function ($$v) {_vm.$set(item, "transferir", $$v)},expression:"item.transferir"}})]}}])}),_vm._v(" "),_c('v-card-title',{staticClass:"card-header",attrs:{"primary-title":""}},[_vm._v("\n      "+_vm._s(_vm.$tc('title.transferencia_carteira', 1))+"\n      "),_c('v-spacer'),_vm._v(" "),_c('tooltip-ajuda',{attrs:{"mensagem":("" + (_vm.$t('message.ajuda.transferencia_definitiva.transferencia_carteira')))}})],1),_vm._v(" "),_c('v-row',{staticClass:"mx-4 mt-4"},[_c('v-col',{staticClass:"mr-3",attrs:{"cols":"12","sm":"6"}},[_c('v-radio-group',{model:{value:(_vm.transferencia.transferenciaCarteira),callback:function ($$v) {_vm.$set(_vm.transferencia, "transferenciaCarteira", $$v)},expression:"transferencia.transferenciaCarteira"}},[_c('v-radio',{attrs:{"label":_vm.$t('message.transferencia_definitiva_toda_carteira'),"value":1}}),_vm._v(" "),_c('v-radio',{attrs:{"label":_vm.$t('message.transferencia_definitiva_carteira_filtro'),"value":2}}),_vm._v(" "),_c('v-radio',{attrs:{"label":_vm.$t('message.transferencia_definitiva_carteira_selecionada'),"value":3}})],1)],1)],1),_vm._v(" "),_c('v-row',{staticClass:"mt-4"},[_c('v-col',{staticStyle:{"text-align":"right"},attrs:{"cols":"12"}},[_c('v-btn',{staticClass:"mr-3",attrs:{"id":"transf_def_passo2_botao_cancelar"},on:{"click":_vm.cancelar}},[_vm._v(_vm._s(_vm.$t('label.cancelar')))]),_vm._v(" "),_c('v-btn',{staticClass:"mr-3",attrs:{"id":"transf_def_passo2_botao_voltar"},on:{"click":_vm.voltarPasso}},[_vm._v(_vm._s(_vm.$t('label.voltar_passo')))]),_vm._v(" "),_c('v-btn',{attrs:{"id":"transf_def_passo2_botao_proximo","color":"primary"},on:{"click":_vm.proximoPasso}},[_vm._v(_vm._s(_vm.$t('label.proximo_passo')))])],1)],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso2_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso2_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso2_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso2_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 1587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TransferenciaPosseDefinitivaPasso3_vue_vue_type_template_id_bfe37e20_lang_html___ = __webpack_require__(1588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TransferenciaPosseDefinitivaPasso3_vue_vue_type_script_lang_js___ = __webpack_require__(679);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__TransferenciaPosseDefinitivaPasso3_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__TransferenciaPosseDefinitivaPasso3_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TransferenciaPosseDefinitivaPasso3_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(1590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__TransferenciaPosseDefinitivaPasso3_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__TransferenciaPosseDefinitivaPasso3_vue_vue_type_template_id_bfe37e20_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__TransferenciaPosseDefinitivaPasso3_vue_vue_type_template_id_bfe37e20_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso3_vue_vue_type_template_id_bfe37e20_lang_html___ = __webpack_require__(1589);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso3_vue_vue_type_template_id_bfe37e20_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso3_vue_vue_type_template_id_bfe37e20_lang_html___["b"]; });


/***/ }),
/* 1589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-form',{ref:"form",attrs:{"lazy-validation":""}},[(_vm.transferencia.funcionarioDe && _vm.transferencia.funcionarioPara)?_c('h3',[_vm._v("\n      "+_vm._s(((_vm.$tc('label.de', 2)) + ": " + (_vm.transferencia.funcionarioDe.nome) + " :: " + (_vm.$tc('label.para')) + ": " + (_vm.transferencia.funcionarioPara.nome)))+"\n    ")]):_vm._e(),_vm._v(" "),_c('v-card-title',{staticClass:"card-header",attrs:{"primary-title":""}},[_c('h3',[_vm._v(_vm._s(_vm.$tc('title.selecao_cliente', 2)))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('tooltip-ajuda',{attrs:{"mensagem":("" + (_vm.$t('message.ajuda.transferencia_definitiva.selecao_cliente')))}})],1),_vm._v(" "),_c('v-row',{staticClass:"mx-4 mt-4"},[_c('v-col',{staticClass:"mr-3",attrs:{"cols":"12","sm":"6","md":"4"}},[_c('v-select',{attrs:{"items":_vm.filtros,"label":_vm.$t('label.filtro_cliente'),"item-text":"nome","item-value":"nomCampoId","no-data-text":_vm.$tc('message.nenhum_registro', 1),"return-object":""},on:{"change":_vm.limparFiltro},model:{value:(_vm.filtroSelecionado),callback:function ($$v) {_vm.filtroSelecionado=$$v},expression:"filtroSelecionado"}})],1),_vm._v(" "),_c('v-col',{staticClass:"mr-3",attrs:{"cols":"12","sm":"6","md":"4"}},[_c('v-autocomplete',{attrs:{"id":"filtro_cliente","name":"filtro_cliente","items":_vm.lista,"search-input":_vm.buscaLista,"no-data-text":_vm.$tc('message.nenhum_registro', 1),"item-text":"nome","item-value":"id","label":_vm.filtroSelecionado.nome,"disabled":!_vm.filtroSelecionado.nome,"clearable":"","multiple":""},on:{"update:searchInput":function($event){_vm.buscaLista=$event},"update:search-input":function($event){_vm.buscaLista=$event}},nativeOn:{"click":function($event){return _vm.buscarLista($event)}},model:{value:(_vm.itensFiltro),callback:function ($$v) {_vm.itensFiltro=$$v},expression:"itensFiltro"}})],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"warn","id":"transf_def_passo2_botao_filtrar"},on:{"click":function($event){return _vm.aplicarFiltro()}}},[_vm._v(_vm._s(_vm.$t('label.aplicar')))])],1),_vm._v(" "),_c('v-card-title',{staticClass:"card-header",attrs:{"primary-title":""}},[_c('h3',[_vm._v(_vm._s(_vm.$tc('title.cliente', 2)))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.exportar()}}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("get_app")])],1),_vm._v(" "),_c('tooltip-ajuda',{attrs:{"mensagem":("" + (_vm.$t('message.ajuda.transferencia_definitiva.cliente')))}})],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.clientes,"options":_vm.pagination,"server-items-length":_vm.totalPage,"items-per-page":5,"footer-props":{
        itemsPerPageOptions: [10, 25, 50],
      },"no-data-text":_vm.$t('label.tabela_sem_conteudo')},on:{"update:options":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"item.transferir",fn:function(ref){
      var item = ref.item;
return [_c('v-checkbox',{nativeOn:{"click":function($event){return _vm.selecionar(item)}},model:{value:(item.transferir),callback:function ($$v) {_vm.$set(item, "transferir", $$v)},expression:"item.transferir"}})]}}])}),_vm._v(" "),_c('v-card-title',{staticClass:"card-header",attrs:{"primary-title":""}},[_c('h3',[_vm._v(_vm._s(_vm.$tc('title.transferencia_responsabilidade_faturamento', 1)))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('tooltip-ajuda',{attrs:{"mensagem":("" + (_vm.$t('message.ajuda.transferencia_definitiva.transferencia_responsabilidade_faturamento')))}})],1),_vm._v(" "),_c('v-row',{staticClass:"mx-4 mt-4"},[_c('v-col',{staticClass:"mr-3",attrs:{"cols":"12","sm":"6"}},[_c('v-radio-group',{model:{value:(_vm.transferencia.transferenciaResponsavelFaturamento),callback:function ($$v) {_vm.$set(_vm.transferencia, "transferenciaResponsavelFaturamento", $$v)},expression:"transferencia.transferenciaResponsavelFaturamento"}},[_c('v-radio',{attrs:{"label":_vm.$t('message.transferencia_definitiva_toda_responsabilidade'),"value":1}}),_vm._v(" "),_c('v-radio',{attrs:{"label":_vm.$t('message.transferencia_definitiva_cliente_filtro'),"value":2}}),_vm._v(" "),_c('v-radio',{attrs:{"label":_vm.$t('message.transferencia_definitiva_cliente_selecionado'),"value":3}})],1)],1)],1),_vm._v(" "),_c('v-row',{staticClass:"mt-4"},[_c('v-col',{staticStyle:{"text-align":"right"},attrs:{"cols":"12"}},[_c('v-btn',{staticClass:"mr-3",attrs:{"id":"transf_def_passo3_botao_cancelar"},on:{"click":_vm.cancelar}},[_vm._v(_vm._s(_vm.$t('label.cancelar')))]),_vm._v(" "),_c('v-btn',{staticClass:"mr-3",attrs:{"id":"transf_def_passo3_botao_voltar"},on:{"click":_vm.voltarPasso}},[_vm._v(_vm._s(_vm.$t('label.voltar_passo')))]),_vm._v(" "),_c('v-btn',{attrs:{"id":"transf_def_passo3_botao_proximo","color":"primary"},on:{"click":_vm.proximoPasso}},[_vm._v(_vm._s(_vm.$t('label.proximo_passo')))])],1)],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso3_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso3_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso3_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso3_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 1591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TransferenciaPosseDefinitivaPasso4_vue_vue_type_template_id_50eeb4b6_lang_html___ = __webpack_require__(1592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TransferenciaPosseDefinitivaPasso4_vue_vue_type_script_lang_js___ = __webpack_require__(682);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__TransferenciaPosseDefinitivaPasso4_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__TransferenciaPosseDefinitivaPasso4_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TransferenciaPosseDefinitivaPasso4_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(1594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__TransferenciaPosseDefinitivaPasso4_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__TransferenciaPosseDefinitivaPasso4_vue_vue_type_template_id_50eeb4b6_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__TransferenciaPosseDefinitivaPasso4_vue_vue_type_template_id_50eeb4b6_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso4_vue_vue_type_template_id_50eeb4b6_lang_html___ = __webpack_require__(1593);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso4_vue_vue_type_template_id_50eeb4b6_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso4_vue_vue_type_template_id_50eeb4b6_lang_html___["b"]; });


/***/ }),
/* 1593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-form',{ref:"form",attrs:{"lazy-validation":""}},[(_vm.transferencia.funcionarioDe && _vm.transferencia.funcionarioPara)?_c('h3',[_vm._v("\n      "+_vm._s(((_vm.$tc('label.de', 2)) + ": " + (_vm.transferencia.funcionarioDe.nome) + " :: " + (_vm.$tc('label.para')) + ": " + (_vm.transferencia.funcionarioPara.nome)))+"\n    ")]):_vm._e(),_vm._v(" "),_c('v-card-title',{staticClass:"card-header",attrs:{"primary-title":""}},[_vm._v("\n      "+_vm._s(_vm.$tc('title.selecao_orcamento', 2))+"\n    ")]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-xl":"","fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"4","md":"3"}},[_c('v-menu',{ref:"data_inicio",attrs:{"close-on-content-click":false,"id":"data_inicio","name":"data_inicio","nudge-right":40,"lazy":"","readonly":false,"transition":"scale-transition","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({staticClass:"filtros-negociacao__select",attrs:{"return-masked-value":true,"mask":"##-##-####","rules":[_vm.rules.validDate],"label":("" + (_vm.$t('label.data_inicio')))},model:{value:(_vm.dateInicioFormatada),callback:function ($$v) {_vm.dateInicioFormatada=$$v},expression:"dateInicioFormatada"}},on))]}}]),model:{value:(_vm.menuDataInicio),callback:function ($$v) {_vm.menuDataInicio=$$v},expression:"menuDataInicio"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"pt-br","color":"primary"},on:{"input":function($event){_vm.menuDataInicio = false}},model:{value:(_vm.dataInicio),callback:function ($$v) {_vm.dataInicio=$$v},expression:"dataInicio"}})],1)],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","sm":"4","md":"3"}},[_c('v-menu',{ref:"data_fim",attrs:{"close-on-content-click":false,"id":"data_fim","name":"data_fim","nudge-right":40,"lazy":"","readonly":false,"transition":"scale-transition","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({staticClass:"filtros-negociacao__select",attrs:{"return-masked-value":true,"mask":"##-##-####","rules":[_vm.rules.validDate, _vm.rules.dataFimMaiorInicio],"label":("" + (_vm.$t('label.data_fim')))},model:{value:(_vm.dateFimFormatada),callback:function ($$v) {_vm.dateFimFormatada=$$v},expression:"dateFimFormatada"}},on))]}}]),model:{value:(_vm.menuDataFim),callback:function ($$v) {_vm.menuDataFim=$$v},expression:"menuDataFim"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"pt-br","color":"primary","min":_vm.dataInicio},on:{"input":function($event){_vm.menuDataFim = false}},model:{value:(_vm.dataFim),callback:function ($$v) {_vm.dataFim=$$v},expression:"dataFim"}})],1)],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","sm":"4","md":"3"}},[_c('v-autocomplete',{attrs:{"id":"marcas","name":"marcas","items":_vm.marcas,"search-input":_vm.searchMarca,"item-text":"nomExtensao","item-value":"id","label":_vm.$tc('label.marca', 2),"no-data-text":_vm.$tc('message.nenhum_registro', 1),"multiple":"","clearable":""},on:{"update:searchInput":function($event){_vm.searchMarca=$event},"update:search-input":function($event){_vm.searchMarca=$event}},nativeOn:{"click":function($event){return _vm.buscarMarcas($event)}},model:{value:(_vm.filtroMarcas),callback:function ($$v) {_vm.filtroMarcas=$$v},expression:"filtroMarcas"}})],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"warn","id":"transf_def_passo4_botao_filtrar"},on:{"click":function($event){return _vm.aplicarFiltro()}}},[_vm._v(_vm._s(_vm.$t('label.aplicar')))])],1)],1),_vm._v(" "),_c('v-card-title',{staticClass:"card-header",attrs:{"primary-title":""}},[_vm._v("\n      "+_vm._s(_vm.$tc('title.orcamento', 2))+"\n      "),_c('v-spacer'),_vm._v(" "),_c('tooltip-ajuda',{attrs:{"mensagem":("" + (_vm.$t('message.ajuda.transferencia_definitiva.selecao_orcamentos')))}})],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.orcamentos,"options":_vm.pagination,"server-items-length":_vm.totalPage,"footer-props":{
        itemsPerPageOptions: [10, 25, 50],
      },"no-data-text":_vm.$t('label.tabela_sem_conteudo')},on:{"update:options":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"item.transferir",fn:function(ref){
      var item = ref.item;
return [_c('v-checkbox',{staticClass:"transfer-checkbox",nativeOn:{"click":function($event){return _vm.selecionar(item)}},model:{value:(item.transferir),callback:function ($$v) {_vm.$set(item, "transferir", $$v)},expression:"item.transferir"}})]}}])}),_vm._v(" "),_c('v-row',{staticClass:"mt-4"},[_c('v-col',{staticStyle:{"text-align":"right"},attrs:{"cols":"12"}},[_c('v-btn',{staticClass:"mr-3",attrs:{"id":"transf_def_passo4_botao_cancelar"},on:{"click":_vm.cancelar}},[_vm._v(_vm._s(_vm.$t('label.cancelar')))]),_vm._v(" "),_c('v-btn',{staticClass:"mr-3",attrs:{"id":"transf_def_passo4_botao_voltar"},on:{"click":_vm.voltarPasso}},[_vm._v(_vm._s(_vm.$t('label.voltar_passo')))]),_vm._v(" "),_c('v-btn',{attrs:{"id":"transf_def_passo4_botao_proximo","color":"primary"},on:{"click":_vm.proximoPasso}},[_vm._v(_vm._s(_vm.$t('label.proximo_passo')))])],1)],1)],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso4_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso4_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso4_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso4_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 1595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TransferenciaPosseDefinitivaPasso5_vue_vue_type_template_id_385822ff_lang_html___ = __webpack_require__(1596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TransferenciaPosseDefinitivaPasso5_vue_vue_type_script_lang_js___ = __webpack_require__(685);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__TransferenciaPosseDefinitivaPasso5_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__TransferenciaPosseDefinitivaPasso5_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TransferenciaPosseDefinitivaPasso5_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(1598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__TransferenciaPosseDefinitivaPasso5_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__TransferenciaPosseDefinitivaPasso5_vue_vue_type_template_id_385822ff_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__TransferenciaPosseDefinitivaPasso5_vue_vue_type_template_id_385822ff_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso5_vue_vue_type_template_id_385822ff_lang_html___ = __webpack_require__(1597);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso5_vue_vue_type_template_id_385822ff_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso5_vue_vue_type_template_id_385822ff_lang_html___["b"]; });


/***/ }),
/* 1597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.transferencia && _vm.transferencia.funcionarioDe && _vm.transferencia.funcionarioPara)?_c('v-form',{ref:"form",attrs:{"lazy-validation":""}},[_c('v-card-title',{staticClass:"card-header",attrs:{"primary-title":""}},[_c('h3',[_vm._v(_vm._s(_vm.$t('title.termos_condicoes')))])]),_vm._v(" "),_c('v-row',{staticClass:"mx-4 mt-4"},[_c('ul',[_c('li',[_vm._v(_vm._s(((_vm.$tc('label.de', 2)) + ": " + (_vm.transferencia.funcionarioDe.nome))))]),_vm._v(" "),(_vm.transferencia.cenario !== 1)?_c('li',[_vm._v(_vm._s(((_vm.$tc('label.para', 2)) + ": " + (_vm.transferencia.funcionarioPara.nome))))]):_vm._e(),_vm._v(" "),(_vm.transferencia.cenario === 1)?_c('li',[_vm._v(_vm._s(((_vm.$t('label.superior_imediato_atual')) + ": " + (_vm.transferencia.funcionarioDe.superiorImediato))))]):_vm._e(),_vm._v(" "),(_vm.transferencia.cenario === 1)?_c('li',[_vm._v(_vm._s(((_vm.$t('label.para_novo_superior_imediato')) + ": " + (_vm.transferencia.funcionarioPara.nome))))]):_vm._e()])]),_vm._v(" "),_c('v-row',{staticClass:"mx-4 mt-4"},[_c('v-col',{staticClass:"mr-3",attrs:{"cols":"12","sm":"6"}},[_c('p',[_vm._v(_vm._s(_vm.$t('message.ao_concluir_transferencia_operacoes_efetivadas')))]),_vm._v(" "),(_vm.transferencia.cenario === 1)?_c('p',[_c('ol',[_c('li',[_vm._v(_vm._s(_vm.$t('message.alteracoes_aplicadas_orcamentos_vendedor_de', { de: _vm.transferencia.funcionarioDe.nome, para: _vm.transferencia.funcionarioPara.nome })))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t('message.novo_superior_imediato_de_sera', { de: _vm.transferencia.funcionarioDe.nome, para: _vm.transferencia.funcionarioPara.nome })))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t('message.verba_gestores_de_para_sera_alterada', { superiorDe: _vm.transferencia.funcionarioDe.superiorImediato, de: _vm.transferencia.funcionarioDe.nome, superiorPara: _vm.transferencia.funcionarioPara.nome })))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t('message.historico_orcamento_investimento_faturamento_serao_alterados')))])])]):_vm._e(),_vm._v(" "),(_vm.transferencia.cenario === 2)?_c('p',[_c('ol',[_c('li',[_vm._v(_vm._s(_vm.$t('message.alteracoes_aplicadas_orcamentos_vendedor_de', { de: _vm.transferencia.funcionarioDe.nome, para: _vm.transferencia.funcionarioPara.nome })))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t('message.acoes_saldo_de_para', { de: _vm.transferencia.funcionarioDe.nome, para: _vm.transferencia.funcionarioPara.nome })))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t('message.verba_gestores_de_para_sera_alterada', { superiorDe: _vm.transferencia.funcionarioDe.superiorImediato, de: _vm.transferencia.funcionarioDe.nome, para: _vm.transferencia.funcionarioPara.superiorImediato })))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t('message.carteira_cliente_responsavel_serao_ajustadas')))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t('message.historico_orcamento_investimento_faturamento_serao_alterados')))])])]):_vm._e(),_vm._v(" "),(_vm.transferencia.cenario === 3)?_c('p',[_c('ol',[_c('li',[_vm._v(_vm._s(_vm.$t('message.alteracoes_aplicadas_orcamentos_vendedor_de', { de: _vm.transferencia.funcionarioDe.nome, para: _vm.transferencia.funcionarioPara.nome })))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t('message.acoes_saldo_de_para', { de: _vm.transferencia.funcionarioDe.nome, para: _vm.transferencia.funcionarioPara.nome })))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t('message.time_vendedores_serao_transferidos', { de: _vm.transferencia.funcionarioDe.nome, para: _vm.transferencia.funcionarioPara.nome })))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t('message.verba_gestores_de_para_sera_alterada', { superiorDe: _vm.transferencia.funcionarioDe.superiorImediato, de: _vm.transferencia.funcionarioDe.nome, superiorPara: _vm.transferencia.funcionarioPara.superiorImediato })))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t('message.carteira_cliente_responsavel_serao_ajustadas')))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t('message.historico_orcamento_investimento_faturamento_serao_alterados')))])])]):_vm._e(),_vm._v(" "),(_vm.transferencia.cenario === 4)?_c('p',[_c('ol',[_c('li',[_vm._v(_vm._s(_vm.$t('message.alteracoes_aplicadas_orcamentos_vendedor_de', { de: _vm.transferencia.funcionarioDe.nome, para: _vm.transferencia.funcionarioPara.nome })))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t('message.historico_orcamento_investimento_faturamento_serao_alterados')))])])]):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('message.apos_efetivacao_transferencia_nao_desfeita')))])])],1),_vm._v(" "),_c('v-row',{staticClass:"mt-4",attrs:{"justify-end":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-checkbox',{attrs:{"label":_vm.$t('label.li_aceito_termos_condicoes'),"rules":[_vm.rules.required],"required":""},model:{value:(_vm.transferencia.aceito),callback:function ($$v) {_vm.$set(_vm.transferencia, "aceito", $$v)},expression:"transferencia.aceito"}})],1)],1),_vm._v(" "),_c('v-row',{staticClass:"mt-4"},[_c('v-col',{staticStyle:{"text-align":"right"},attrs:{"cols":"12"}},[_c('v-btn',{staticClass:"mr-3",attrs:{"id":"transf_def_passo4_botao_cancelar"},on:{"click":_vm.cancelar}},[_vm._v(_vm._s(_vm.$t('label.cancelar')))]),_vm._v(" "),_c('v-btn',{staticClass:"mr-3",attrs:{"id":"transf_def_passo4_botao_voltar"},on:{"click":_vm.voltarPasso}},[_vm._v(_vm._s(_vm.$t('label.voltar_passo')))]),_vm._v(" "),_c('v-btn',{attrs:{"id":"transf_def_passo4_botao_concluir","color":"primary"},on:{"click":_vm.confirmarConclusao}},[_vm._v(_vm._s(_vm.$t('label.confirmar')))])],1)],1),_vm._v(" "),_c('confirm',{ref:"confirmDialog",attrs:{"message":_vm.$t('message.operacao_irreversivel_deseja_continuar'),"persistent":true},on:{"agree":_vm.concluir}})],1):_vm._e()],1)}
var staticRenderFns = []



/***/ }),
/* 1598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso5_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso5_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso5_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_10_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_lib_loader_js_sourceMap_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaPasso5_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 1599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaForm_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaForm_vue_vue_type_style_index_0_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaForm_vue_vue_type_style_index_0_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_TransferenciaPosseDefinitivaForm_vue_vue_type_style_index_0_lang_css____default.a); 

/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _UnidadeMedidaCadastro = __webpack_require__(1601);

var _UnidadeMedidaCadastro2 = _interopRequireDefault(_UnidadeMedidaCadastro);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  path: 'unidade-medida',
  name: 'unidade-medida',
  component: _UnidadeMedidaCadastro2.default
};

/***/ }),
/* 1601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UnidadeMedidaCadastro_vue_vue_type_template_id_5b14cd21_scoped_true_lang_html___ = __webpack_require__(1602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UnidadeMedidaCadastro_vue_vue_type_script_lang_js___ = __webpack_require__(689);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__UnidadeMedidaCadastro_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__UnidadeMedidaCadastro_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UnidadeMedidaCadastro_vue_vue_type_style_index_0_id_5b14cd21_scoped_true_lang_css___ = __webpack_require__(1610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__UnidadeMedidaCadastro_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__UnidadeMedidaCadastro_vue_vue_type_template_id_5b14cd21_scoped_true_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__UnidadeMedidaCadastro_vue_vue_type_template_id_5b14cd21_scoped_true_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  "5b14cd21",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_UnidadeMedidaCadastro_vue_vue_type_template_id_5b14cd21_scoped_true_lang_html___ = __webpack_require__(1603);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_UnidadeMedidaCadastro_vue_vue_type_template_id_5b14cd21_scoped_true_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_UnidadeMedidaCadastro_vue_vue_type_template_id_5b14cd21_scoped_true_lang_html___["b"]; });


/***/ }),
/* 1603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canAccessPage)?_c('div',{staticClass:"CRUDGenerico__Wrapper"},[_c('v-row',[(!_vm.somenteLeitura)?_c('v-col',{attrs:{"cols":"12","sm":"3"}},[_c('unidade-medida-form',{ref:"unidadeMedidaForm",on:{"FORMULARIO_CADASTRO_UNIDADE_SALVAR":_vm.onUnidadeSalva}})],1):_vm._e(),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","sm":_vm.somenteLeitura ? 12 : 9}},[_c('unidade-medida-lista',{ref:"unidadeTabela",staticClass:"CRUDGenerico__ContentTable",attrs:{"title":_vm.$tc('label.unidade_medida', 2)},on:{"PESQUISA_UNIDADE_EDITAR":_vm.onEditarUnidade}})],1)],1)],1):_vm._e()}
var staticRenderFns = []



/***/ }),
/* 1604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UnidadeMedidaForm_vue_vue_type_template_id_730bc1e6_lang_html___ = __webpack_require__(1605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UnidadeMedidaForm_vue_vue_type_script_lang_js___ = __webpack_require__(691);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__UnidadeMedidaForm_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__UnidadeMedidaForm_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__UnidadeMedidaForm_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__UnidadeMedidaForm_vue_vue_type_template_id_730bc1e6_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__UnidadeMedidaForm_vue_vue_type_template_id_730bc1e6_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_UnidadeMedidaForm_vue_vue_type_template_id_730bc1e6_lang_html___ = __webpack_require__(1606);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_UnidadeMedidaForm_vue_vue_type_template_id_730bc1e6_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_UnidadeMedidaForm_vue_vue_type_template_id_730bc1e6_lang_html___["b"]; });


/***/ }),
/* 1606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{ref:"form",attrs:{"lazy-validation":""}},[_c('v-card',{staticClass:"card-size"},[_c('v-card-title',[_c('h2',{staticClass:"mb-0",staticStyle:{"font-size":"18px","width":"100%"}},[_vm._v(_vm._s(_vm.ehEdicao ? _vm.$t('title.editar_unidade_medida') : _vm.$t('title.cadastrar_nova_unidade_medida')))])]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-xl":"","fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-text-field',{staticClass:"Form-text__invalid",attrs:{"id":"unidade_sigla","name":"unidade_sigla","label":((_vm.$tc('label.sigla', 1)) + " *"),"counter":20,"maxlength":"20","rules":[_vm.rules.required]},model:{value:(_vm.unidade.sigla),callback:function ($$v) {_vm.$set(_vm.unidade, "sigla", $$v)},expression:"unidade.sigla"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12"}},[_c('v-text-field',{staticClass:"Form-text__invalid",attrs:{"id":"unidade_nome","name":"unidade_nome","label":((_vm.$tc('label.nome', 1)) + " *"),"counter":80,"maxlength":"80","rules":[_vm.rules.required]},model:{value:(_vm.unidade.nomUnidade),callback:function ($$v) {_vm.$set(_vm.unidade, "nomUnidade", $$v)},expression:"unidade.nomUnidade"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{nativeOn:{"click":function($event){return _vm.cancel($event)}}},[_vm._v(_vm._s(_vm.$t('label.cancelar')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.openSaveDialog($event)}}},[_vm._v(_vm._s(_vm.$t('label.salvar')))])],1)],1),_vm._v(" "),_c('confirm',{ref:"confirmDialog",attrs:{"message":_vm.dialog.content,"persistent":true},on:{"agree":function($event){return _vm.save()}}})],1)}
var staticRenderFns = []



/***/ }),
/* 1607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UnidadeMedidaLista_vue_vue_type_template_id_3959cc9c_lang_html___ = __webpack_require__(1608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UnidadeMedidaLista_vue_vue_type_script_lang_js___ = __webpack_require__(693);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__UnidadeMedidaLista_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__UnidadeMedidaLista_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__UnidadeMedidaLista_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__UnidadeMedidaLista_vue_vue_type_template_id_3959cc9c_lang_html___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__UnidadeMedidaLista_vue_vue_type_template_id_3959cc9c_lang_html___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_UnidadeMedidaLista_vue_vue_type_template_id_3959cc9c_lang_html___ = __webpack_require__(1609);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_UnidadeMedidaLista_vue_vue_type_template_id_3959cc9c_lang_html___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_UnidadeMedidaLista_vue_vue_type_template_id_3959cc9c_lang_html___["b"]; });


/***/ }),
/* 1609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"card-size"},[_c('v-card-title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('v-container',{staticClass:"py-0",attrs:{"fluid":""}},[_c('v-row',[_c('v-spacer'),_vm._v(" "),_c('v-col',{staticClass:"mr-3 py-0",attrs:{"cols":"12","sm":"6","md":"3"}},[_c('v-text-field',{attrs:{"append-icon":"search","label":_vm.$t('label.pesquisar'),"single-line":"","clearable":"","hide-details":""},on:{"input":_vm.filtrar},model:{value:(_vm.searchQuery),callback:function ($$v) {_vm.searchQuery=$$v},expression:"searchQuery"}})],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.lista,"options":_vm.pagination,"server-items-length":_vm.totalPage,"no-data-text":_vm.$t('label.tabela_sem_conteudo'),"footer-props":{
        itemsPerPageOptions: [10, 25, 50],
      }},on:{"update:options":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"item.nome",fn:function(ref){
      var item = ref.item;
return [_vm._v("\n        "+_vm._s(item.nomUnidade)+"\n      ")]}},{key:"item.acoes",fn:function(ref){
      var item = ref.item;
return [(!_vm.somenteLeitura)?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
      var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();return _vm.onEditar(item)}}},on),[_c('v-icon',[_vm._v("edit")])],1)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('label.editar')))])]):_vm._e()]}}])})],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_UnidadeMedidaCadastro_vue_vue_type_style_index_0_id_5b14cd21_scoped_true_lang_css___ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_UnidadeMedidaCadastro_vue_vue_type_style_index_0_id_5b14cd21_scoped_true_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_UnidadeMedidaCadastro_vue_vue_type_style_index_0_id_5b14cd21_scoped_true_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_UnidadeMedidaCadastro_vue_vue_type_style_index_0_id_5b14cd21_scoped_true_lang_css____default.a); 

/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Usuario = __webpack_require__(1612);

var _Usuario2 = _interopRequireDefault(_Usuario);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UsuarioForm = function UsuarioForm() {
  return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 1679));
};
var UsuarioList = function UsuarioList() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 1680));
};

exports.default = {
  path: 'usuario',
  component: _Usuario2.default,
  children: [{
    path: '',
    name: 'usuario',
    component: UsuarioList
  }, {
    path: ':id/editar',
    name: 'editarUsuario',
    component: UsuarioForm,
    props: {
      somenteLeitura: false
    }
  }, {
    path: 'novo',
    name: 'novoUsuario',
    component: UsuarioForm
  }, {
    path: ':id',
    name: 'verUsuario',
    component: UsuarioForm,
    props: {
      somenteLeitura: true
    }
  }]
};

/***/ }),
/* 1612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Usuario_vue_vue_type_template_id_5eb45c81___ = __webpack_require__(1613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Usuario_vue_vue_type_script_lang_js___ = __webpack_require__(696);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__Usuario_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__Usuario_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__Usuario_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__Usuario_vue_vue_type_template_id_5eb45c81___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__Usuario_vue_vue_type_template_id_5eb45c81___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Usuario_vue_vue_type_template_id_5eb45c81___ = __webpack_require__(1614);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Usuario_vue_vue_type_template_id_5eb45c81___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_Usuario_vue_vue_type_template_id_5eb45c81___["b"]; });


/***/ }),
/* 1614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c('router-view')],1)}
var staticRenderFns = []



/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var Workflow = function Workflow() {
  return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 1681));
};
var WorkflowList = function WorkflowList() {
  return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 1682));
};
var WorkflowView = function WorkflowView() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 1683));
};

exports.default = {
  path: 'workflow',
  component: Workflow,
  children: [{
    path: '',
    name: 'workflow',
    component: WorkflowList
  }, {
    path: 'novo',
    name: 'novoWorkflow',
    component: WorkflowView,
    props: {
      default: false,
      somenteLeitura: false,
      copia: false
    }
  }, {
    path: ':id',
    name: 'verWorkflow',
    component: WorkflowView,
    props: {
      default: true,
      somenteLeitura: true,
      copia: false
    }
  }, {
    path: ':id/editar',
    name: 'editarWorkflow',
    component: WorkflowView,
    props: {
      default: true,
      somenteLeitura: false,
      copia: false
    }
  }]
};

/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var Acordo = function Acordo() {
  return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 1684));
};
var TelaAcordo = function TelaAcordo() {
  return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 1685));
};

exports.default = {
  path: 'acordo',
  component: TelaAcordo,
  children: [{
    path: '',
    name: 'acordo',
    component: Acordo
  }]
};

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueI18n = __webpack_require__(1618);

var _vueI18n2 = _interopRequireDefault(_vueI18n);

var _i18n = __webpack_require__(253);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function interpolarDicionario(resDicionario) {
  var lang = _i18n2.default.messages['pt-br'];
  resDicionario.forEach(function (e) {
    var label = e.label.split('.');
    var valor = void 0;
    for (var i = 0; i < label.length - 1; i += 1) {
      if (i === 0) {
        if (!lang[label[i]]) lang[label[i]] = {};
        valor = lang[label[i]];
      } else {
        if (!valor[label[i]]) valor[label[i]] = {};
        valor = valor[label[i]];
      }
    }
    valor[label[label.length - 1]] = e.depara;
  });
  _i18n2.default.messages['pt-br'] = lang;
  return _i18n2.default;
}

exports.default = function (Vue, resDicionario) {
  Vue.use(_vueI18n2.default);
  return new _vueI18n2.default(interpolarDicionario(resDicionario));
};

/***/ }),
/* 1618 */,
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(38);

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

var _apiResource = __webpack_require__(1);

var _apiResource2 = _interopRequireDefault(_apiResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dicionario = {};
var basePath = (0, _apiResource2.default)('api', 'dicionario');

var setDicionario = function setDicionario(el) {
  dicionario[el.label] = el.depara;
};

exports.default = {
  mapa: function mapa() {
    return localStorage.dicionario ? JSON.parse(localStorage.dicionario) : {};
  },
  carregar: function carregar() {
    return new _promise2.default(function (resolve, reject) {
      var xhttp = new XMLHttpRequest();
      xhttp.open('GET', '' + basePath, true);
      xhttp.setRequestHeader('Authorization', 'Bearer ' + sessionStorage.token);
      xhttp.send();
      xhttp.onreadystatechange = function () {
        if (this.readyState === 4) {
          if (this.status === 200) {
            var response = JSON.parse(xhttp.response);
            resolve(response);
          }
        } else if (this.status && this.status === 403) {
          reject({ status: this.status, message: 'Usuário sem permissão para acessar o sistema!' });
        }
      };
    });
  },
  carrega: function carrega($http) {
    var ultimaData = localStorage.dicionarioData ? new Date(localStorage.dicionarioData) : new Date();

    return new _promise2.default(function (resolve, reject) {
      if (!localStorage.dicionarioData || Math.abs(ultimaData - new Date()) > 60000) {
        $http.get(basePath).then(function (resp) {
          var response = JSON.parse(resp.bodyText);
          response.forEach(setDicionario);
          localStorage.setItem('dicionario', (0, _stringify2.default)(dicionario));
          localStorage.setItem('dicionarioData', new Date());
          resolve();
        }).catch(reject);
      } else {
        dicionario = localStorage.dicionario ? JSON.parse(localStorage.dicionario) : {};
        resolve();
      }
    });
  }
};

/***/ }),
/* 1620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App_vue_vue_type_template_id_286536cf___ = __webpack_require__(1621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue_vue_type_script_lang_js___ = __webpack_require__(698);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__App_vue_vue_type_script_lang_js___) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__App_vue_vue_type_script_lang_js___[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(1623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__App_vue_vue_type_script_lang_js___["default"],
  __WEBPACK_IMPORTED_MODULE_0__App_vue_vue_type_template_id_286536cf___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__App_vue_vue_type_template_id_286536cf___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 1621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_template_id_286536cf___ = __webpack_require__(1622);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_template_id_286536cf___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_template_id_286536cf___["b"]; });


/***/ }),
/* 1622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"light":""}},[_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c('router-view')],1)],1)}
var staticRenderFns = []



/***/ }),
/* 1623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_style_index_0_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_style_index_0_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_dist_loader_js_ref_6_0_node_modules_vue_style_loader_index_js_node_modules_css_loader_index_js_sourceMap_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_style_index_0_lang_css____default.a); 

/***/ }),
/* 1624 */,
/* 1625 */,
/* 1626 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAIcCAYAAAD2RY5JAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAShJREFUeNrs2EkKAkEQBEDHBUVcEBFR3JcZ///B8RMp1iHqAXGqpjK76ft+kJwGCAQCgUAgEAgEAoFAIBAIBAKBQCAQCAQCgUAgEAgEAoFAIBAIBAKBQCAQCAQCgUAgEAgEAoFAIBAIBAKBQCAQ+EewSYPDNDhOg5M0OE2DszQ4T4PLNLhOg5s0uE2DuzS4T4PHNHhKg5c0eEuDjzT4TIPv8mCbBrs0+CkPduXBtvwevsq/5XsavKbBc/mbcih/l+PJIZ5t4ulrlQYX5TN2vAXEe0q8SY3Kt9F4X/aJAQQCgUAgEAgEAoFAIBAIBAKBQCAQCAQCgUAgEAgEAoFAIBAIBAKBQCAQCAQCgUAgEAgEAoFAIBAIBAKBQCAQCAQCgUAg8JfgV4ABANLCVFQtVP42AAAAAElFTkSuQmCC"

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/WebComponentsIcons.b45bf89.eot";

/***/ }),
/* 1628 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAIAAAD8GO2jAAAACXBIWXMAABcSAAAXOQER7y87AAAAB3RJTUUH3AsbChsyNZaItwAAABl0RVh0Q29tbWVudABDcmVhdGVkIHdpdGggR0lNUFeBDhcAAABFSURBVEjHY0xLS2PABoyNjbGKnz17liT1TAw0BqMWjFpAOWChVnrHpX40DkYtGAr5gFrpfbQ+GLVgtD4YrQ9GLRjSFgAAbfUXEVeGAdQAAAAASUVORK5CYII="

/***/ }),
/* 1629 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/WebComponentsIcons.595e8d5.ttf";

/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/WebComponentsIcons.c287b98.woff";

/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/WebComponentsIcons.a45f0eb.svg";

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/DejaVuSans.49c0f03.ttf";

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/DejaVuSans-Bold.21546d8.ttf";

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/DejaVuSans-Oblique.8723fc1.ttf";

/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/DejaVuSans-BoldOblique.e5947ee.ttf";

/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/DejaVuSerif.a4108b7.ttf";

/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/DejaVuSerif-Bold.25670b4.ttf";

/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/DejaVuSerif-Italic.08f58f7.ttf";

/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/DejaVuSerif-BoldItalic.42a9a4e.ttf";

/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/DejaVuSansMono.f7435b1.ttf";

/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/DejaVuSansMono-Bold.fb4ec87.ttf";

/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/DejaVuSansMono-Oblique.a6927e4.ttf";

/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/DejaVuSansMono-BoldOblique.ca84e57.ttf";

/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sprite.48c19f3.png";

/***/ }),
/* 1646 */
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,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"

/***/ }),
/* 1647 */
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,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"

/***/ }),
/* 1648 */
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,R0lGODlhFgAWAJECAPDw8OTk5AAAAAAAACH/C05FVFNDQVBFMi4wAwEAAAAh+QQFBAACACwAAAAAFgAWAAACL4yPAcsNmZyESDp6bMNGM654DyeOWAmipJiyqweGWuy+Fg23s37zk38BboQf4qIAACH5BAUEAAIALAAAAAAWABYAAAIwBIKpYe231ntRTlfTxZlt03lf+IFdCWUoWbLj2cKvGstXKN6ubk94Tdv8ZkFe0VEAACH5BAUEAAIALAAAAAAWABYAAAIwhBGpG+fH4nuRTVfXhTltnn1G14ikiHToaapt+Far+7E1vZFlbl96LLvhJj8hzFEAACH5BAUEAAIALAAAAAAWABYAAAIwhB+pG+fI2HtRTljTxXmbrHgAqImkOILoaapt91ar67E1vdk5fpHNzaPoJr6Y7FAAACH5BAUEAAIALAAAAAAWABYAAAIvhG+hy4EPmoRINnosw0krHnkOJ45YCaKpB4ZaK8Ls+tKWXJOznp+736OogMGHqgAAIfkEBQQAAgAsAAAAABYAFgAAAi+Ej6HLgQ+ahEkyeuzFUSveeaD3caRjkqOaiqsGhlbMtvN72xO+6w3t8m2EC6CnAAAh+QQFBAACACwAAAAAFgAWAAACMAyOCcHtCp1kME1Z0X15bdp9YCYaodh5X1qy6LnCW6pe9CtPd5xj7vyzBXVDX69RAAAh+QQFBAACACwAAAAAFgAWAAACMIyBqWDtseJ7cU1X1cWZ7dN9YCZCodh5X1qy6LnCmxuTrzyl6qXf9kzjBXNDSjFQAAAh+QQFBAACACwAAAAAFgAWAAACLowNqQvnx+J7kU1X14U5bdQ1XxCOZGeWo/qxm3vBk0yhq93iL83pMw/y1YQYWAEAIfkEBQQAAgAsAAAAABYAFgAAAjCMH6DLgJ9ag0hOaizDWSseeaD3caQziqkGhlZLwqo5Y/H64pLM6hddg5x8P8rQUAAAIfkEBQQAAgAsAAAAABYAFgAAAjCMf6DLgB+ahEg2muzCRm/uKVwUjqEDlqk3klqrrhbMmrU82a8+8zl+8QWBQ8opUAAAOw=="

/***/ }),
/* 1649 */
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,R0lGODlhAQC0ALMMAN/f34yMjNTU1JGRkcPDw9ra2peXl7q6urGxsaioqJ+fn8zMzAAAAAAAAAAAAAAAACH5BAEAAAwALAAAAAABALQAAAQvEBSxyEFJmcG678FgKAlyEItQSJSFadwnz3RNh2N5pgV9ZbUcwib7KYjIpExIiwAAOw=="

/***/ }),
/* 1650 */
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,R0lGODlhtAABALMMAN/f34yMjNTU1JGRkcPDw9ra2peXl7q6urGxsaioqJ+fn8zMzAAAAAAAAAAAAAAAACH5BAEAAAwALAAAAAC0AAEAAAQvEBSxyEFJmcG678FgKAlyEItQSJSFadwnz3RNh2N5pgV9ZbUcwib7KYjIpExIiwAAOw=="

/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/kendoui.2d27c2b.woff";

/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/kendoui.29409af.ttf";

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kendoui.9d6320a.svg";

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wp8_icons.7c946ef.png";

/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wp8_inverseicons.cd3081f.png";

/***/ }),
/* 1656 */,
/* 1657 */,
/* 1658 */,
/* 1659 */,
/* 1660 */,
/* 1661 */,
/* 1662 */,
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/roboto-light-webfont.66efa98.woff2";

/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/roboto-regular-webfont.166faf4.woff2";

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/roboto-medium-webfont.d8ab400.woff2";

/***/ })
],[713]);


// WEBPACK FOOTER //
// static/js/app.d207872893be02b99d1e.js